/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1018);
	module.exports = __webpack_require__(817);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(101);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(214);
	
	module.exports = factory(React.isValidElement);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(68);
	var hide = __webpack_require__(53);
	var redefine = __webpack_require__(54);
	var ctx = __webpack_require__(69);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1687);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(671);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1688);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(710);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1771);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1770);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1769);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(709);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(711);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var intent_1 = __webpack_require__(432);
	// modifiers
	exports.DARK = "pt-dark";
	exports.ACTIVE = "pt-active";
	exports.MINIMAL = "pt-minimal";
	exports.DISABLED = "pt-disabled";
	exports.SMALL = "pt-small";
	exports.LARGE = "pt-large";
	exports.LOADING = "pt-loading";
	exports.INTERACTIVE = "pt-interactive";
	exports.ALIGN_LEFT = "pt-align-left";
	exports.ALIGN_RIGHT = "pt-align-right";
	exports.INLINE = "pt-inline";
	exports.FILL = "pt-fill";
	exports.FIXED = "pt-fixed";
	exports.FIXED_TOP = "pt-fixed-top";
	exports.VERTICAL = "pt-vertical";
	exports.ROUND = "pt-round";
	// text utilities
	exports.TEXT_MUTED = "pt-text-muted";
	exports.TEXT_OVERFLOW_ELLIPSIS = "pt-text-overflow-ellipsis";
	exports.UI_TEXT_LARGE = "pt-ui-text-large";
	// components
	exports.ALERT = "pt-alert";
	exports.ALERT_BODY = "pt-alert-body";
	exports.ALERT_CONTENTS = "pt-alert-contents";
	exports.ALERT_FOOTER = "pt-alert-footer";
	exports.BREADCRUMB = "pt-breadcrumb";
	exports.BREADCRUMB_CURRENT = "pt-breadcrumb-current";
	exports.BREADCRUMBS = "pt-breadcrumbs";
	exports.BREADCRUMBS_COLLAPSED = "pt-breadcrumbs-collapsed";
	exports.BUTTON = "pt-button";
	exports.BUTTON_GROUP = "pt-button-group";
	exports.CALLOUT = "pt-callout";
	exports.CARD = "pt-card";
	exports.COLLAPSE = "pt-collapse";
	exports.COLLAPSIBLE_LIST = "pt-collapse-list";
	exports.CONTEXT_MENU = "pt-context-menu";
	exports.CONTEXT_MENU_POPOVER_TARGET = "pt-context-menu-popover-target";
	exports.CONTROL = "pt-control";
	exports.CONTROL_GROUP = "pt-control-group";
	exports.CONTROL_INDICATOR = "pt-control-indicator";
	exports.DIALOG = "pt-dialog";
	exports.DIALOG_CONTAINER = "pt-dialog-container";
	exports.DIALOG_BODY = "pt-dialog-body";
	exports.DIALOG_CLOSE_BUTTON = "pt-dialog-close-button";
	exports.DIALOG_FOOTER = "pt-dialog-footer";
	exports.DIALOG_FOOTER_ACTIONS = "pt-dialog-footer-actions";
	exports.DIALOG_HEADER = "pt-dialog-header";
	exports.EDITABLE_TEXT = "pt-editable-text";
	exports.ELEVATION_0 = "pt-elevation-0";
	exports.ELEVATION_1 = "pt-elevation-1";
	exports.ELEVATION_2 = "pt-elevation-2";
	exports.ELEVATION_3 = "pt-elevation-3";
	exports.ELEVATION_4 = "pt-elevation-4";
	exports.INPUT = "pt-input";
	exports.INPUT_GROUP = "pt-input-group";
	exports.CHECKBOX = "pt-checkbox";
	exports.RADIO = "pt-radio";
	exports.SWITCH = "pt-switch";
	exports.FILE_UPLOAD = "pt-file-upload";
	exports.FILE_UPLOAD_INPUT = "pt-file-upload-input";
	exports.INTENT_PRIMARY = "pt-intent-primary";
	exports.INTENT_SUCCESS = "pt-intent-success";
	exports.INTENT_WARNING = "pt-intent-warning";
	exports.INTENT_DANGER = "pt-intent-danger";
	exports.LABEL = "pt-label";
	exports.FORM_GROUP = "pt-form-group";
	exports.FORM_CONTENT = "pt-form-content";
	exports.FORM_HELPER_TEXT = "pt-form-helper-text";
	exports.MENU = "pt-menu";
	exports.MENU_ITEM = "pt-menu-item";
	exports.MENU_ITEM_LABEL = "pt-menu-item-label";
	exports.MENU_SUBMENU = "pt-submenu";
	exports.MENU_DIVIDER = "pt-menu-divider";
	exports.MENU_HEADER = "pt-menu-header";
	exports.NAVBAR = "pt-navbar";
	exports.NAVBAR_GROUP = "pt-navbar-group";
	exports.NAVBAR_HEADING = "pt-navbar-heading";
	exports.NAVBAR_DIVIDER = "pt-navbar-divider";
	exports.NON_IDEAL_STATE = "pt-non-ideal-state";
	exports.NON_IDEAL_STATE_ACTION = "pt-non-ideal-state-action";
	exports.NON_IDEAL_STATE_DESCRIPTION = "pt-non-ideal-state-description";
	exports.NON_IDEAL_STATE_ICON = "pt-non-ideal-state-icon";
	exports.NON_IDEAL_STATE_TITLE = "pt-non-ideal-state-title";
	exports.NON_IDEAL_STATE_VISUAL = "pt-non-ideal-state-visual";
	exports.NUMERIC_INPUT = "pt-numeric-input";
	exports.OVERLAY = "pt-overlay";
	exports.OVERLAY_BACKDROP = "pt-overlay-backdrop";
	exports.OVERLAY_CONTENT = "pt-overlay-content";
	exports.OVERLAY_INLINE = "pt-overlay-inline";
	exports.OVERLAY_OPEN = "pt-overlay-open";
	exports.OVERLAY_SCROLL_CONTAINER = "pt-overlay-scroll-container";
	exports.POPOVER = "pt-popover";
	exports.POPOVER_ARROW = "pt-popover-arrow";
	exports.POPOVER_BACKDROP = "pt-popover-backdrop";
	exports.POPOVER_CONTENT = "pt-popover-content";
	exports.POPOVER_DISMISS = "pt-popover-dismiss";
	exports.POPOVER_DISMISS_OVERRIDE = "pt-popover-dismiss-override";
	exports.POPOVER_OPEN = "pt-popover-open";
	exports.POPOVER_TARGET = "pt-popover-target";
	exports.TRANSITION_CONTAINER = "pt-transition-container";
	exports.PROGRESS_BAR = "pt-progress-bar";
	exports.PROGRESS_METER = "pt-progress-meter";
	exports.PROGRESS_NO_STRIPES = "pt-no-stripes";
	exports.PROGRESS_NO_ANIMATION = "pt-no-animation";
	exports.PORTAL = "pt-portal";
	exports.SELECT = "pt-select";
	exports.SKELETON = "pt-skeleton";
	exports.SLIDER = "pt-slider";
	exports.SLIDER_HANDLE = exports.SLIDER + "-handle";
	exports.SLIDER_LABEL = exports.SLIDER + "-label";
	exports.RANGE_SLIDER = "pt-range-slider";
	exports.SPINNER = "pt-spinner";
	exports.SVG_SPINNER = "pt-svg-spinner";
	exports.TAB = "pt-tab";
	exports.TAB_LIST = "pt-tab-list";
	exports.TAB_PANEL = "pt-tab-panel";
	exports.TABS = "pt-tabs";
	exports.TABLE = "pt-table";
	exports.TABLE_CONDENSED = "pt-condensed";
	exports.TABLE_STRIPED = "pt-striped";
	exports.TABLE_BORDERED = "pt-bordered";
	exports.TAG = "pt-tag";
	exports.TAG_REMOVABLE = "pt-tag-removable";
	exports.TAG_REMOVE = "pt-tag-remove";
	exports.TOAST = "pt-toast";
	exports.TOAST_CONTAINER = "pt-toast-container";
	exports.TOAST_MESSAGE = "pt-toast-message";
	exports.TOOLTIP = "pt-tooltip";
	exports.TREE = "pt-tree";
	exports.TREE_NODE = "pt-tree-node";
	exports.TREE_NODE_CARET = "pt-tree-node-caret";
	exports.TREE_NODE_CARET_CLOSED = "pt-tree-node-caret-closed";
	exports.TREE_NODE_CARET_NONE = "pt-tree-node-caret-none";
	exports.TREE_NODE_CARET_OPEN = "pt-tree-node-caret-open";
	exports.TREE_NODE_CONTENT = "pt-tree-node-content";
	exports.TREE_NODE_EXPANDED = "pt-tree-node-expanded";
	exports.TREE_NODE_ICON = "pt-tree-node-icon";
	exports.TREE_NODE_LABEL = "pt-tree-node-label";
	exports.TREE_NODE_LIST = "pt-tree-node-list";
	exports.TREE_NODE_SECONDARY_LABEL = "pt-tree-node-secondary-label";
	exports.TREE_NODE_SELECTED = "pt-tree-node-selected";
	exports.TREE_ROOT = "pt-tree-root";
	exports.ICON = "pt-icon";
	exports.ICON_STANDARD = "pt-icon-standard";
	exports.ICON_LARGE = "pt-icon-large";
	/** Return CSS class for icon, whether or not 'pt-icon-' prefix is included */
	function iconClass(iconName) {
	    if (iconName == null) {
	        return undefined;
	    }
	    return iconName.indexOf("pt-icon-") === 0 ? iconName : "pt-icon-" + iconName;
	}
	exports.iconClass = iconClass;
	function intentClass(intent) {
	    if (intent === void 0) { intent = intent_1.Intent.NONE; }
	    if (intent === intent_1.Intent.NONE || intent_1.Intent[intent] == null) {
	        return undefined;
	    }
	    return "pt-intent-" + intent_1.Intent[intent].toLowerCase();
	}
	exports.intentClass = intentClass;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(116);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(420);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(174);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1705);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(676);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1699);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1718);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1700);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1701);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(677);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1703);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1698);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1702);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(1704);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(1717);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(295);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(1706);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(1715);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(682);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1708);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1709);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1713);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(679);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1247);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/prop-types: 0 */
	
	function Loading(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'loading-container' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'loading-content' },
	        props.children
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'loading' },
	        _react2.default.createElement('div', { className: 'loading-dot' }),
	        _react2.default.createElement('div', { className: 'loading-dot' }),
	        _react2.default.createElement('div', { className: 'loading-dot' }),
	        _react2.default.createElement('div', { className: 'loading-dot' }),
	        _react2.default.createElement('div', { className: 'loading-dot' })
	      )
	    )
	  );
	}
	
	exports.default = Loading;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(56);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 4.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash -d -o ./foo/lodash.js`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.6.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	  /** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsQuoteRange = '\\u2018\\u2019\\u201c\\u201d',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+',
	    rsUpper + '+',
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_',
	    'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[mapTag] = cloneableTags[numberTag] =
	  cloneableTags[objectTag] = cloneableTags[regexpTag] =
	  cloneableTags[setTag] = cloneableTags[stringTag] =
	  cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
	  cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
	  cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	    ? exports
	    : undefined;
	
	  /** Detect free variable `module`. */
	  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	    ? module
	    : undefined;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = (freeModule && freeModule.exports === freeExports)
	    ? freeExports
	    : undefined;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	  /** Detect free variable `window`. */
	  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal ||
	    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	      freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {...*} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * Creates a new array concatenating `array` with `other`.
	   *
	   * @private
	   * @param {Array} array The first array to concatenate.
	   * @param {Array} other The second array to concatenate.
	   * @returns {Array} Returns the new concatenated array.
	   */
	  function arrayConcat(array, other) {
	    var index = -1,
	        length = array.length,
	        othIndex = -1,
	        othLength = other.length,
	        result = Array(length + othLength);
	
	    while (++index < length) {
	      result[index] = array[index];
	    }
	    while (++othIndex < othLength) {
	      result[index++] = other[othIndex];
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    return !!array.length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.max` and `_.min` which accepts a
	   * `comparator` to determine the extremum value.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The iteratee invoked per iteration.
	   * @param {Function} comparator The comparator used to compare values.
	   * @returns {*} Returns the extremum value.
	   */
	  function baseExtremum(array, iteratee, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index],
	          current = iteratee(value);
	
	      if (current != null && (computed === undefined
	            ? current === current
	            : comparator(current, computed)
	          )) {
	        var computed = current,
	            result = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of methods like `_.find` and `_.findKey`, without
	   * support for iteratee shorthands, which iterates over `collection` using
	   * `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @param {boolean} [retKey] Specify returning the key of the found element instead of the element itself.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFind(collection, predicate, eachFunc, retKey) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = retKey ? key : value;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` without support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the new array of key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Compares values to sort them in ascending order.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function compareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * Used by `_.orderBy` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	   * specify an order of "desc" for descending or "asc" for ascending sort order
	   * of corresponding values.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]|string[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = compareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * (order == 'desc' ? -1 : 1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return value > -1 && value % 1 == 0 && value < length;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to an array.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to mock `Date#getTime` use in `_.now`.
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        clearTimeout = context.clearTimeout,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getPrototypeOf = Object.getPrototypeOf,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var Map = getNative(context, 'Map'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var mapCtorString = Map ? funcToString.call(Map) : '',
	        setCtorString = Set ? funcToString.call(Set) : '',
	        weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chaining. Methods that operate on and return arrays, collections, and
	     * functions can be chained together. Methods that retrieve a single value or
	     * may return a primitive value will automatically end the chain sequence and
	     * return the unwrapped value. Otherwise, the value must be unwrapped with
	     * `_#value`.
	     *
	     * Explicit chaining, which must be unwrapped with `_#value` in all cases,
	     * may be enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization to merge iteratee calls; this avoids the creation
	     * of intermediate arrays and can greatly reduce the number of iteratee executions.
	     * Sections of a chain sequence qualify for shortcut fusion if the section is
	     * applied to an array of at least two hundred elements and any iteratees
	     * accept only one argument. The heuristic for whether a section qualifies
	     * for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatten`, `flattenDeep`, `flattenDepth`, `flip`, `flow`, `flowRight`,
	     * `fromPairs`, `functions`, `functionsIn`, `groupBy`, `initial`, `intersection`,
	     * `intersectionBy`, `intersectionWith`, `invert`, `invertBy`, `invokeMap`,
	     * `iteratee`, `keyBy`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`,
	     * `matches`, `matchesProperty`, `memoize`, `merge`, `mergeWith`, `method`,
	     * `methodOf`, `mixin`, `negate`, `nthArg`, `omit`, `omitBy`, `once`, `orderBy`,
	     * `over`, `overArgs`, `overEvery`, `overSome`, `partial`, `partialRight`,
	     * `partition`, `pick`, `pickBy`, `plant`, `property`, `propertyOf`, `pull`,
	     * `pullAll`, `pullAllBy`, `pullAllWith`, `pullAt`, `push`, `range`,
	     * `rangeRight`, `rearg`, `reject`, `remove`, `rest`, `reverse`, `sampleSize`,
	     * `set`, `setWith`, `shuffle`, `slice`, `sort`, `sortBy`, `splice`, `spread`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`, `throttle`,
	     * `thru`, `toArray`, `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`,
	     * `transform`, `unary`, `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`,
	     * `uniqWith`, `unset`, `unshift`, `unzip`, `unzipWith`, `update`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`, `zipObject`,
	     * `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `each`, `eachRight`,
	     * `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`, `floor`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`, `includes`,
	     * `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`, `isArrayBuffer`,
	     * `isArrayLike`, `isArrayLikeObject`, `isBoolean`, `isBuffer`, `isDate`,
	     * `isElement`, `isEmpty`, `isEqual`, `isEqualWith`, `isError`, `isFinite`,
	     * `isFunction`, `isInteger`, `isLength`, `isMap`, `isMatch`, `isMatchWith`,
	     * `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`, `isObject`, `isObjectLike`,
	     * `isPlainObject`, `isRegExp`, `isSafeInteger`, `isSet`, `isString`,
	     * `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`,
	     * `maxBy`, `mean`, `min`, `minBy`, `noConflict`, `noop`, `now`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toInteger`, `toJSON`, `toLength`, `toLower`,
	     * `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`, `trimEnd`,
	     * `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`, `upperFirst`,
	     * `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an hash object.
	     *
	     * @private
	     * @constructor
	     * @returns {Object} Returns the new hash object.
	     */
	    function Hash() {}
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(hash, key) {
	      return hashHas(hash, key) && delete hash[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(hash, key) {
	      if (nativeCreate) {
	        var result = hash[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(hash, key) {
	      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function hashSet(hash, key, value) {
	      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function MapCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': Map ? new Map : [],
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapDelete(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapGet(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.get(key) : assocGet(data.map, key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.has(key) : assocHas(data.map, key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache object.
	     */
	    function mapSet(key, value) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	      } else if (Map) {
	        data.map.set(key, value);
	      } else {
	        assocSet(data.map, key, value);
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a set cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.push(values[index]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache`.
	     *
	     * @private
	     * @param {Object} cache The set cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function cacheHas(cache, value) {
	      var map = cache.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        return hash[value] === HASH_UNDEFINED;
	      }
	      return map.has(value);
	    }
	
	    /**
	     * Adds `value` to the set cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var map = this.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        hash[value] = HASH_UNDEFINED;
	      }
	      else {
	        map.set(value, HASH_UNDEFINED);
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function Stack(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = { 'array': [], 'map': null };
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocDelete(array, key) : data.map['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocGet(array, key) : data.map.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocHas(array, key) : data.map.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache object.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__,
	          array = data.array;
	
	      if (array) {
	        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	          assocSet(array, key, value);
	        } else {
	          data.array = null;
	          data.map = new MapCache(array);
	        }
	      }
	      var map = data.map;
	      if (map) {
	        map.set(key, value);
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Removes `key` and its value from the associative array.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function assocDelete(array, key) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = array.length - 1;
	      if (index == lastIndex) {
	        array.pop();
	      } else {
	        splice.call(array, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the associative array value for `key`.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function assocGet(array, key) {
	      var index = assocIndexOf(array, key);
	      return index < 0 ? undefined : array[index][1];
	    }
	
	    /**
	     * Checks if an associative array value for `key` exists.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function assocHas(array, key) {
	      return assocIndexOf(array, key) > -1;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `key` is found in `array`
	     * of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Sets the associative array `key` to `value`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function assocSet(array, key, value) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        array.push([key, value]);
	      } else {
	        array[index][1] = value;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the array-like object.
	     */
	    function baseCastArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the array-like object.
	     */
	    function baseCastFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function baseCastPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            result = baseAssign(result, value);
	            return isFull ? copySymbols(value, result) : result;
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return (isFull && !isArr) ? copySymbols(value, result) : result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined && !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support for
	     * excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && isArrayLikeObject(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return object == null ? object : baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return hasOwnProperty.call(object, key) ||
	        (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = baseCastPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          stack || (stack = new Stack);
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack,
	              result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;
	
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      var type = typeof value;
	      if (type == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value &&
	            (value !== undefined || (key in Object(object)));
	        };
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      var props = (isArray(source) || isTypedArray(source))
	        ? undefined
	        : keysIn(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, !customizer);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, !customizer);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : Array(1), getIteratee());
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property names.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key) {
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (lastIndex == length || index != previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = baseCastPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[last(path)];
	            }
	          }
	          else {
	            delete array[index];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the new array of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq`.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array) {
	      return baseSortedUniqBy(array);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniqBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniqBy(array, iteratee) {
	      var index = 0,
	          length = array.length,
	          value = array[0],
	          computed = iteratee ? iteratee(value) : value,
	          seen = computed,
	          resIndex = 1,
	          result = [value];
	
	      while (++index < length) {
	        value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	        if (!eq(computed, seen)) {
	          seen = computed;
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	      object = parent(object, path);
	      var key = last(path);
	      return (object != null && has(object, key)) ? delete object[key] : true;
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property names.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        assignFunc(result, props[index], index < valsLength ? values[index] : undefined);
	      }
	      return result;
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map) {
	      return arrayReduce(mapToArray(map), addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set) {
	      return arrayReduce(setToArray(set), addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object) {
	      return copyObjectWith(source, props, object);
	    }
	
	    /**
	     * This function is like `copyObject` except that it accepts a function to
	     * customize copied values.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObjectWith(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = typeof customizer == 'function'
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols ? strSymbols[0] : string.charAt(0),
	            trailing = strSymbols ? strSymbols.slice(1).join('') : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string)), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getPlaceholder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getPlaceholder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new invoker function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = arrayMap(baseFlatten(iteratees, 1), getIteratee());
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(string, length, chars) {
	      length = toInteger(length);
	
	      var strLength = stringSize(string);
	      if (!length || strLength >= length) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars === undefined ? ' ' : (chars + '');
	
	      var result = repeat(chars, nativeCeil(padLength / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? stringToArray(result).slice(0, padLength).join('')
	        : result.slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newArgPos = argPos ? copyArray(argPos) : undefined,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, newArgPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = toInteger(precision);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var index = -1,
	          isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isUnordered) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask | UNORDERED_COMPARE_FLAG, stack.set(object, other));
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If the `_.iteratee` method is
	     * customized this function returns the custom method, otherwise it returns
	     * `baseIteratee`. If arguments are provided the chosen function is invoked
	     * with them and its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = toPairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getPlaceholder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Creates an array of the own symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = getOwnPropertySymbols || function() {
	      return [];
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
	    if ((Map && getTag(new Map) != mapTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : null,
	            ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case mapCtorString: return mapTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasFunc(object, path);
	      if (!result && !isKey(path)) {
	        path = baseCastPath(path);
	        object = parent(object, path);
	        if (object != null) {
	          path = last(path);
	          result = hasFunc(object, path);
	        }
	      }
	      var length = object ? object.length : undefined;
	      return result || (
	        !!length && isLength(length) && isIndex(path, length) &&
	        (isArray(object) || isString(object) || isArguments(object))
	      );
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototypeOf(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (typeof value == 'number') {
	        return true;
	      }
	      return !isArray(value) &&
	        (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	          (object != null && value in Object(object)));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return type == 'number' || type == 'boolean' ||
	        (type == 'string' && value != '__proto__') || value == null;
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * modify function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * combined case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = copyArray(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    function stringToPath(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=0] The length of each chunk.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size) {
	      size = nativeMax(toInteger(size), 0);
	
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var concat = rest(function(array, values) {
	      if (!isArray(array)) {
	        array = array == null ? [] : [Object(array)];
	      }
	      values = baseFlatten(values, 1);
	      return arrayConcat(array, values);
	    });
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * given arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([3, 2, 1], [4, 2]);
	     * // => [3, 1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
	     * // => [3.1, 1.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3))
	        : -1;
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3), true)
	        : -1;
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	     * from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      fromIndex = toInteger(fromIndex);
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return baseIndexOf(array, value, fromIndex);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [4, 2], [1, 2]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, baseCastArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1)) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pullAll(array, [2, 3]);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = arrayMap(baseFlatten(indexes, 1), String);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(compareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of [`Array#slice`](https://mdn.io/Array/slice)
	     * to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 5], 4);
	     * // => 0
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
	     *
	     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([1, 1, 2, 2], 2);
	     * // => 2
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5], 4);
	     * // => 1
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniqBy(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with three
	     * arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2, 1], [4, 2], [1, 2]);
	     * // => [2, 1, 4]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1, 1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([2, 1], [4, 2]);
	     * // => [1, 4]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by which
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property names and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} [props=[]] The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} [props=[]] The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method chaining enabled.
	     * The result of such method chaining must be unwrapped with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     *
	     * _(['a', 'b', 'c']).at(0, 2).value();
	     * // => ['a', 'c']
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * This method is the wrapper version of `_.flatMap`.
	     *
	     * @name flatMap
	     * @memberOf _
	     * @category Seq
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _([1, 2]).flatMap(duplicate).value();
	     * // => [1, 1, 2, 2]
	     */
	    function wrapperFlatMap(iteratee) {
	      return this.map(iteratee).flatten();
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    function find(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEach);
	    }
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    function findLast(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate, true);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEachRight);
	    }
	
	    /**
	     * Creates an array of flattened values by running each element in `collection`
	     * through `iteratee` and concating its result to the other mapped values.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior use `_.forIn` or `_.forOwn`
	     * for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => logs `1` then `2`
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' then 'b' (iteration order is not guaranteed)
	     */
	    function forEach(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEach(collection, iteratee)
	        : baseEach(collection, baseCastFunction(iteratee));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => logs `2` then `1`
	     */
	    function forEachRight(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEachRight(collection, iteratee)
	        : baseEachRight(collection, baseCastFunction(iteratee));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of elements responsible for generating the key.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string it's checked
	     * for a substring of `value`, otherwise [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it's
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
	     * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
	     * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
	     * and `words`
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} [iteratees=[_.identity]] The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=0] The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = baseClamp(toInteger(n), 0, length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by, specified individually or in arrays.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees.length = 1;
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @type {Function}
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = Date.now;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it's invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          leading = false,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        args = maxTimeoutId = thisArg = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function flush() {
	        if ((timeoutId && trailingCall) || (maxTimeoutId && trailing)) {
	          result = func.apply(thisArg, args);
	        }
	        cancel();
	        return result;
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!lastCalled && !maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled);
	
	          var isCalled = (remaining <= 0 || remaining > maxWait) &&
	            (leading || maxTimeoutId);
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => logs 'deferred' after one or more milliseconds
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = arrayMap(baseFlatten(transforms, 1), getIteratee());
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = args.slice(0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? constant(false) : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty collection or object. A value is considered
	     * empty if it's an `arguments` object, array, string, or jQuery-like collection
	     * with a length of `0` or has no own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) ||
	            isFunction(value.splice) || isArguments(value))) {
	        return !value.length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined` comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MAX_VALUE);
	     * // => true
	     *
	     * _.isFinite(3.14);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined` comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(funcToString.call(value));
	      }
	      return isObjectLike(value) &&
	        (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototypeOf(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3');
	     * // => 3
	     */
	    function toInteger(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      var remainder = value % 1;
	      return value === value ? (remainder ? value - remainder : value) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3);
	     * // => 3
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3');
	     * // => 3
	     */
	    function toNumber(value) {
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string if it's not one. An empty string is returned
	     * for `null` and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (value == null) {
	        return '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable properties of source objects to the destination
	     * object. Source objects are applied from left to right. Subsequent sources
	     * overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer` which
	     * is invoked to produce the assigned values. If `customizer` returns `undefined`
	     * assignment is handled by the method instead. The `customizer` is invoked
	     * with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer` which
	     * is invoked to produce the assigned values. If `customizer` returns `undefined`
	     * assignment is handled by the method instead. The `customizer` is invoked
	     * with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     *
	     * _.at(['a', 'b', 'c'], 0, 2);
	     * // => ['a', 'c']
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a `properties`
	     * object is given its own enumerable properties are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable properties of source objects to the
	     * destination object for all destination properties that resolve to `undefined`.
	     * Source objects are applied from left to right. Once a property is set,
	     * additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The iteratee is invoked with three arguments:
	     * (value, key, object). Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', then 'c' (iteration order is not guaranteed)
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, baseCastFunction(iteratee), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, baseCastFunction(iteratee), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The iteratee is invoked with three arguments:
	     * (value, key, object). Iteratee functions may exit iteration early by
	     * explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' then 'b' (iteration order is not guaranteed)
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, baseCastFunction(iteratee));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, baseCastFunction(iteratee));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     * var other = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b.c');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b', 'c']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` through `iteratee`.
	     * The corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`. The iteratee is invoked with
	     * three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee is invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable properties of source objects into the destination
	     * object. Source properties that resolve to `undefined` are skipped if a
	     * destination value exists. Array and plain object properties are merged
	     * recursively.Other objects and value types are overridden by assignment.
	     * Source objects are applied from left to right. Subsequent sources
	     * overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined` merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property names to omit, specified
	     *  individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), String);
	      return basePick(object, baseDifference(keysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable properties of `object` that `predicate`
	     * doesn't return truthy for. The predicate is invoked with two arguments:
	     * (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property names to pick, specified
	     *  individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, baseFlatten(props, 1));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it's invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      if (!isKey(path, object)) {
	        path = baseCastPath(path);
	        var result = get(object, path);
	        object = parent(object, path);
	      } else {
	        result = object == null ? undefined : object[path];
	      }
	      if (result === undefined) {
	        result = defaultValue;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable key-value pairs for `object` which
	     * can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    function toPairs(object) {
	      return baseToPairs(object, keys(object));
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable key-value pairs for
	     * `object` which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
	     */
	    function toPairsIn(object) {
	      return baseToPairs(object, keysIn(object));
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The iteratee is invoked with four arguments:
	     * (accumulator, value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototypeOf(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, baseCastFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, baseCastFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are floats,
	     * a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = typeof target == 'string' ? target : (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = stringSize(string);
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      return createPadding('', leftLength, chars) + string + createPadding('', rightLength, chars);
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      return string + createPadding(string, length, chars);
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      return createPadding(string, length, chars) + string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#x15.1.2.2)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      string = toString(string);
	      n = toInteger(n);
	
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the new array of string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      return toString(string).split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + capitalize(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar');
	     * // => '--foo-bar'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar');
	     * // => '--FOO-BAR'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrim, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars);
	
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimEnd, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimStart, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, stringToArray(chars)))
	        .join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options=({})] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? toString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? strSymbols.slice(0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, 'onClick');
	     * jQuery(element).on('click', view.onClick);
	     * // => logs 'clicked docs' when clicked
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` invoking the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name the created callback returns the
	     * property value for a given element. If `func` is an object the created
	     * callback returns `true` for elements that contain the equivalent object
	     * properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(callback, func) {
	     *   var p = /^(\S+)\s*([<>])\s*(\S+)$/.exec(func);
	     *   return !p ? callback(func) : function(object) {
	     *     return (p[2] == '>' ? object[p[1]] > p[3] : object[p[1]] < p[3]);
	     *   };
	     * });
	     *
	     * _.filter(users, 'age > 36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invokeMap(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = (isObject(options) && 'chain' in options) ? options.chain : true,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns its nth argument.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     *
	     * func('a', 'b', 'c');
	     * // => 'b'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return function() {
	        return arguments[n];
	      };
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments provided
	     * to the created function and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} iteratees The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over(Math.max, Math.min);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments provided to the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments provided to the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(true));
	     * // => [true, true, true, true]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = baseCastFunction(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     *
	     * var path = ['a', 'b', 'c'],
	     *     newPath = _.toPath(path);
	     *
	     * console.log(newPath);
	     * // => ['a', 'b', 'c']
	     *
	     * console.log(path === newPath);
	     * // => false
	     */
	    function toPath(value) {
	      return isArray(value) ? arrayMap(value, String) : stringToPath(value);
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      var result;
	      if (augend === undefined && addend === undefined) {
	        return 0;
	      }
	      if (augend !== undefined) {
	        result = augend;
	      }
	      if (addend !== undefined) {
	        result = result === undefined ? addend : (result + addend);
	      }
	      return result;
	    }
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey
	     * `undefined` is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, gt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), gt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return sum(array) / (array ? array.length : 0);
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey
	     * `undefined` is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, lt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), lt)
	        : undefined;
	    }
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    function subtract(minuend, subtrahend) {
	      var result;
	      if (minuend === undefined && subtrahend === undefined) {
	        return 0;
	      }
	      if (minuend !== undefined) {
	        result = minuend;
	      }
	      if (subtrahend !== undefined) {
	        result = result === undefined ? subtrahend : (result - subtrahend);
	      }
	      return result;
	    }
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Avoid inheriting from `Object.prototype` when possible.
	    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	    // Add functions to the `MapCache`.
	    MapCache.prototype.clear = mapClear;
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `SetCache`.
	    SetCache.prototype.push = cachePush;
	
	    // Add functions to the `Stack` cache.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.flatMap = wrapperFlatMap;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose lodash on the free variable `window` or `self` when available. This
	  // prevents errors in cases where lodash is loaded by a script tag in the presence
	  // of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch for more details.
	  (freeWindow || freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module), (function() { return this; }())))

/***/ },
/* 15 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @author Félix Girault <felix.girault@gmail.com>
	 * @license MIT
	 */
	'use strict';
	
	var warning = __webpack_require__(13);
	var shallowEqual = __webpack_require__(256);
	
	
	
	/**
	 * Tells if a component should update given it's next props
	 * and state.
	 *
	 * @param object nextProps Next props.
	 * @param object nextState Next state.
	 */
	function shouldComponentUpdate(nextProps, nextState) {
	  return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	}
	
	/**
	 * Returns a text description of the component that can be
	 * used to identify it in error messages.
	 *
	 * @see https://github.com/facebook/react/blob/v15.4.0-rc.3/src/renderers/shared/stack/reconciler/ReactCompositeComponent.js#L1143
	 * @param {function} component The component.
	 * @return {string} The name of the component.
	 */
	function getComponentName(component) {
	  var constructor = component.prototype && component.prototype.constructor;
	
	  return (
	    component.displayName
	    || (constructor && constructor.displayName)
	    || component.name
	    || (constructor && constructor.name)
	    || 'a component'
	  );
	}
	
	/**
	 * Makes the given component "pure".
	 *
	 * @param object component Component.
	 */
	function pureRenderDecorator(component) {
	  if (component.prototype.shouldComponentUpdate !== undefined) {
	    // We're not using the condition mecanism of warning()
	    // here to avoid useless calls to getComponentName().
	    warning(
	      false,
	      'Cannot decorate `%s` with @pureRenderDecorator, '
	      + 'because it already implements `shouldComponentUpdate().',
	      getComponentName(component)
	    )
	  }
	
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	  return component;
	}
	
	
	
	module.exports = pureRenderDecorator;


/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(588);
	
	var _qs = __webpack_require__(1600);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _uuid = __webpack_require__(715);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _authDataHelper = __webpack_require__(234);
	
	var _authDataHelper2 = _interopRequireDefault(_authDataHelper);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getHeader() {
	  var header = {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json',
	    'X-APPLICATION': 'dashboard.bindo.com',
	    'X-USER-DEVICE-TYPE': 'pos',
	    'X-Request-ID': (0, _uuid2.default)()
	  };
	  var user = _authDataHelper2.default.get();
	
	  if (user) {
	    Object.assign(header, {
	      'Authorization': "OAuth " + user.access_token,
	      'X-USER-ACCESS-TOKEN': user.access_token // bindo.com, gateway, analytics are using this one
	    });
	  }
	  return header;
	}
	
	function decodeJsonWithMeta(json, link) {
	  if (link) {
	    var _JSON$parse = JSON.parse(link),
	        current_page = _JSON$parse.current_page,
	        per_page = _JSON$parse.per_page,
	        total_entries = _JSON$parse.total_entries,
	        total_pages = _JSON$parse.total_pages;
	
	    var jsonWithMeta = {
	      page: current_page,
	      count: per_page,
	      totalCount: total_entries,
	      totalPages: total_pages,
	      data: json
	    };
	    return jsonWithMeta;
	  }
	  return json;
	}
	
	function getHeaderForUploadFile() {
	  var user = _authDataHelper2.default.get();
	  return {
	    'Authorization': "OAuth " + user.access_token,
	    'X-USER-ACCESS-TOKEN': user.access_token, // bindo.com, gateway, analytics are using this one
	    'X-APPLICATION': 'dashboard.bindo.com',
	    'X-USER-DEVICE-TYPE': 'pos',
	    'X-Request-ID': (0, _uuid2.default)(),
	    'Accept': 'application/json'
	  };
	}
	
	var ApiService = function () {
	  function ApiService() {
	    _classCallCheck(this, ApiService);
	  }
	
	  _createClass(ApiService, [{
	    key: 'postFile',
	    value: function postFile(path, data) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	
	
	      var url = server + '/' + path;
	
	      var result = fetch(url, {
	        method: 'post',
	        headers: getHeaderForUploadFile(),
	        body: data
	      }).then(function (response) {
	        if (response.status < 399) {
	          return response.json();
	        } else if (response.status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw new Error(response.message);
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'putFile',
	    value: function putFile(path, data) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	
	
	      var url = server + '/' + path;
	
	      var result = fetch(url, {
	        method: 'put',
	        headers: getHeaderForUploadFile(),
	        body: data
	      }).then(function (response) {
	        if (response.status < 399) {
	          return response.json();
	        } else if (response.status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw new Error(response.message);
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'postFileWProgress',
	    value: function postFileWProgress(path, data, progress) {
	      var server = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config2.default.bindo;
	
	      return new Promise(function (resolve, reject) {
	        var xhr = new XMLHttpRequest();
	        var url = server + '/' + path;
	        xhr.open("POST", url, true);
	        xhr.upload.onprogress = progress;
	        xhr.onload = function () {
	          if (xhr.status >= 200 && xhr.status < 300) {
	            if (xhr.response === "") {
	              resolve("success");
	            } else {
	              resolve(JSON.parse(xhr.response));
	            }
	          } else if (xhr.status == 401) {
	            _authDataHelper2.default.clear();
	            location.href = '/login';
	          } else {
	            reject({
	              status: xhr.status,
	              // statusText: JSON.parse(xhr.response)
	              statusText: xhr.response
	            });
	          }
	        };
	        xhr.onerror = function (evt) {
	          var err_msg = void 0;
	          if (xhr.response === "") {
	            err_msg = "Some unknow error from server or timeout";
	          } else {
	            err_msg = xhr.response;
	          }
	          reject({
	            status: "ERROR",
	            statusText: err_msg
	          });
	        };
	
	        var headers = getHeaderForUploadFile();
	        Object.keys(headers).forEach(function (name) {
	          xhr.setRequestHeader(name, headers[name]);
	        });
	
	        xhr.send(data);
	      });
	    }
	  }, {
	    key: 'postFileWithProgress',
	    value: function postFileWithProgress(path, data, progress) {
	      var server = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config2.default.bindo;
	
	
	      return new Promise(function (resolve, reject) {
	        var url = path;
	        var xhr = new XMLHttpRequest();
	
	        xhr.open("PUT", url, true);
	
	        xhr.upload.addEventListener("progress", progress, false);
	
	        xhr.addEventListener("load", function () {
	
	          if (xhr.status >= 200 && xhr.status < 300) {
	            if (xhr.response === "") {
	              resolve("success");
	            } else {
	              resolve(JSON.parse(xhr.response));
	            }
	          } else if (xhr.status == 401) {
	            _authDataHelper2.default.clear();
	            _routeHelper2.default.goLogin();
	          } else {
	            reject({
	              status: xhr.status,
	              statusText: JSON.parse(xhr.response)
	            });
	          }
	        });
	
	        xhr.addEventListener("error", function (evt) {
	
	          var err_msg = void 0;
	
	          if (xhr.response === "") {
	            err_msg = "Some unknow error from server or timeout";
	          } else {
	            err_msg = xhr.response;
	          }
	          reject({
	            status: "ERROR",
	            statusText: err_msg
	          });
	        });
	
	        xhr.send(data);
	      });
	    }
	  }, {
	    key: 'post',
	    value: function post(path, data) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	
	      var link = void 0,
	          status = void 0;
	      var url = server + '/' + path;
	      var result = fetch(url, {
	        method: 'post',
	        headers: getHeader(),
	        body: JSON.stringify(data)
	      }).then(function (response) {
	        status = response.status;
	        link = response.headers.get('link');
	        return response.json();
	      }).then(function (json) {
	        if (status < 400) {
	          return decodeJsonWithMeta(json, link);
	        } else if (status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw json;
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: 'get',
	    value: function get(path, query) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	      var customHeader = arguments[3];
	
	      var url = server + '/' + path;
	      var header = getHeader();
	
	      if (query) {
	        url = url + '?' + _qs2.default.stringify(query, { arrayFormat: 'brackets' });
	      }
	
	      if (customHeader) {
	        Object.assign(header, customHeader);
	      }
	
	      var link = void 0,
	          status = void 0;
	      var result = fetch(url, {
	        method: 'GET',
	        headers: header
	      }).then(function (response) {
	        status = response.status;
	        link = response.headers.get('link');
	        return response.json();
	      }).then(function (json) {
	        if (status < 400) {
	          return decodeJsonWithMeta(json, link);
	        } else if (status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw json;
	        }
	      }).catch(function (error) {
	        if (error) {
	          throw error;
	        } else {
	          throw Error(status);
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: 'put',
	    value: function put(path, data) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	
	      var url = server + '/' + path;
	
	      var status = void 0;
	
	      var result = fetch(url, {
	        method: 'PUT',
	        headers: getHeader(),
	        body: JSON.stringify(data)
	      }).then(function (response) {
	        status = response.status;
	        return response.json();
	      }).then(function (json) {
	        if (status < 399) {
	          return json;
	        } else if (status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw json;
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(path, query) {
	      var server = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.bindo;
	
	      var url = server + '/' + path;
	
	      if (query) {
	        url = url + '?' + _qs2.default.stringify(query, { arrayFormat: 'brackets' });
	      }
	
	      var status = void 0;
	
	      var result = fetch(url, {
	        method: 'DELETE',
	        headers: getHeader()
	      }).then(function (response) {
	        status = response.status;
	        return response.json();
	      }).then(function (json) {
	        if (status < 399) {
	          return json;
	        } else if (status == 401) {
	          _authDataHelper2.default.clear();
	          _routeHelper2.default.goLogin();
	        } else {
	          throw json;
	        }
	      });
	
	      return result;
	    }
	  }]);
	
	  return ApiService;
	}();
	
	exports.default = ApiService;

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var errors_1 = __webpack_require__(48);
	tslib_1.__exportStar(__webpack_require__(721), exports);
	/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
	function isNodeEnv(env) {
	    return typeof process !== "undefined" && process.env && ("production") === env;
	}
	exports.isNodeEnv = isNodeEnv;
	/** Returns whether the value is a function. Acts as a type guard. */
	// tslint:disable-next-line:ban-types
	function isFunction(value) {
	    return typeof value === "function";
	}
	exports.isFunction = isFunction;
	// tslint:disable-next-line:ban-types
	function safeInvoke(func) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    if (isFunction(func)) {
	        return func.apply(void 0, args);
	    }
	}
	exports.safeInvoke = safeInvoke;
	// tslint:disable-next-line:ban-types
	function safeInvokeOrValue(funcOrValue) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    return isFunction(funcOrValue) ? funcOrValue.apply(void 0, args) : funcOrValue;
	}
	exports.safeInvokeOrValue = safeInvokeOrValue;
	function elementIsOrContains(element, testElement) {
	    return element === testElement || element.contains(testElement);
	}
	exports.elementIsOrContains = elementIsOrContains;
	/**
	 * Returns the difference in length between two arrays. A `null` argument is
	 * considered an empty list. The return value will be positive if `a` is longer
	 * than `b`, negative if the opposite is true, and zero if their lengths are
	 * equal.
	 */
	function arrayLengthCompare(a, b) {
	    if (a === void 0) { a = []; }
	    if (b === void 0) { b = []; }
	    return a.length - b.length;
	}
	exports.arrayLengthCompare = arrayLengthCompare;
	/**
	 * Returns true if the two numbers are within the given tolerance of each other.
	 * This is useful to correct for floating point precision issues, less useful
	 * for integers.
	 */
	function approxEqual(a, b, tolerance) {
	    if (tolerance === void 0) { tolerance = 0.00001; }
	    return Math.abs(a - b) <= tolerance;
	}
	exports.approxEqual = approxEqual;
	/**
	 * Clamps the given number between min and max values. Returns value if within
	 * range, or closest bound.
	 */
	function clamp(val, min, max) {
	    if (val == null) {
	        return val;
	    }
	    if (max < min) {
	        throw new Error(errors_1.CLAMP_MIN_MAX);
	    }
	    return Math.min(Math.max(val, min), max);
	}
	exports.clamp = clamp;
	/** Returns the number of decimal places in the given number. */
	function countDecimalPlaces(num) {
	    if (typeof num !== "number" || Math.floor(num) === num) {
	        return 0;
	    }
	    return num.toString().split(".")[1].length;
	}
	exports.countDecimalPlaces = countDecimalPlaces;
	/**
	 * Throttle an event on an EventTarget by wrapping it in a
	 * `requestAnimationFrame` call. Returns the event handler that was bound to
	 * given eventName so you can clean up after yourself.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events/scroll
	 */
	function throttleEvent(target, eventName, newEventName) {
	    var throttledFunc = _throttleHelper(undefined, undefined, function (event) {
	        target.dispatchEvent(new CustomEvent(newEventName, event));
	    });
	    target.addEventListener(eventName, throttledFunc);
	    return throttledFunc;
	}
	exports.throttleEvent = throttleEvent;
	/**
	 * Throttle a callback by wrapping it in a `requestAnimationFrame` call. Returns
	 * the throttled function.
	 * @see https://www.html5rocks.com/en/tutorials/speed/animations/
	 */
	function throttleReactEventCallback(callback, options) {
	    if (options === void 0) { options = {}; }
	    var throttledFunc = _throttleHelper(function (event2) {
	        if (options.preventDefault) {
	            event2.preventDefault();
	        }
	    }, function (event2) {
	        // prevent React from reclaiming the event object before we
	        // reference it
	        event2.persist();
	    }, function (event2) {
	        var otherArgs2 = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            otherArgs2[_i - 1] = arguments[_i];
	        }
	        callback.apply(void 0, [event2].concat(otherArgs2));
	    });
	    return throttledFunc;
	}
	exports.throttleReactEventCallback = throttleReactEventCallback;
	function _throttleHelper(onBeforeIsRunningCheck, onAfterIsRunningCheck, onAnimationFrameRequested) {
	    var isRunning = false;
	    var func = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        // don't use safeInvoke, because we might have more than its max number
	        // of typed params
	        if (isFunction(onBeforeIsRunningCheck)) {
	            onBeforeIsRunningCheck.apply(void 0, args);
	        }
	        if (isRunning) {
	            return;
	        }
	        isRunning = true;
	        if (isFunction(onAfterIsRunningCheck)) {
	            onAfterIsRunningCheck.apply(void 0, args);
	        }
	        requestAnimationFrame(function () {
	            if (isFunction(onAnimationFrameRequested)) {
	                onAnimationFrameRequested.apply(void 0, args);
	            }
	            isRunning = false;
	        });
	    };
	    return func;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(252)('wks');
	var uid = __webpack_require__(132);
	var Symbol = __webpack_require__(15).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(71);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168),
	    baseIteratee = __webpack_require__(72),
	    baseMap = __webpack_require__(619),
	    isArray = __webpack_require__(32);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
	 * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
	 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
	 * and `words`
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _createAll2 = __webpack_require__(1743);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes;
	var addArrayValue = _createAll.addArrayValue;
	var autofill = _createAll.autofill;
	var autofillWithKey = _createAll.autofillWithKey;
	var blur = _createAll.blur;
	var change = _createAll.change;
	var changeWithKey = _createAll.changeWithKey;
	var destroy = _createAll.destroy;
	var focus = _createAll.focus;
	var reducer = _createAll.reducer;
	var reduxForm = _createAll.reduxForm;
	var removeArrayValue = _createAll.removeArrayValue;
	var getValues = _createAll.getValues;
	var initialize = _createAll.initialize;
	var initializeWithKey = _createAll.initializeWithKey;
	var propTypes = _createAll.propTypes;
	var reset = _createAll.reset;
	var startAsyncValidation = _createAll.startAsyncValidation;
	var startSubmit = _createAll.startSubmit;
	var stopAsyncValidation = _createAll.stopAsyncValidation;
	var stopSubmit = _createAll.stopSubmit;
	var swapArrayValues = _createAll.swapArrayValues;
	var touch = _createAll.touch;
	var touchWithKey = _createAll.touchWithKey;
	var untouch = _createAll.untouch;
	var untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(810);
	
	Object.defineProperty(exports, 'ROUTE', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _inventoryVariance = __webpack_require__(808);
	
	Object.defineProperty(exports, 'INVENTORY_VARIANCE', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inventoryVariance).default;
	  }
	});
	
	var _promoCode = __webpack_require__(809);
	
	Object.defineProperty(exports, 'PROMO_CODE', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_promoCode).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DECIMAL_POINTS_ZERO_DP = exports.DECIMAL_POINTS_ZERO_DP = 0;
	var DECIMAL_POINTS_ONE_DP = exports.DECIMAL_POINTS_ONE_DP = 1;
	var DECIMAL_POINTS_TWO_DP = exports.DECIMAL_POINTS_TWO_DP = 2;
	var DECIMAL_POINTS_FOUR_DP = exports.DECIMAL_POINTS_FOUR_DP = 4;
	
	var ROUNDING_TYPE_NORMAL = exports.ROUNDING_TYPE_NORMAL = 0;
	var ROUNDING_TYPE_ROUND_DOWN = exports.ROUNDING_TYPE_ROUND_DOWN = 2;
	var ROUNDING_TYPE_ROUND_UP = exports.ROUNDING_TYPE_ROUND_UP = 1;
	var ROUNDING_TYPE_ROUND_TO_NEAREST_FIVE = exports.ROUNDING_TYPE_ROUND_TO_NEAREST_FIVE = 3;
	
	var QUANTITY_ALLOW_DECIMAL_NO = exports.QUANTITY_ALLOW_DECIMAL_NO = 0;
	var QUANTITY_ALLOW_DECIMAL_ALLOW_PARTIALLY = exports.QUANTITY_ALLOW_DECIMAL_ALLOW_PARTIALLY = 1;
	var QUANTITY_ALLOW_DECIMAL_ALLOW_ALL = exports.QUANTITY_ALLOW_DECIMAL_ALLOW_ALL = 2;
	
	var QUANTITY_DECIMAL_POINTS_ZERO_DP = exports.QUANTITY_DECIMAL_POINTS_ZERO_DP = 0;
	var QUANTITY_DECIMAL_POINTS_ONE_DP = exports.QUANTITY_DECIMAL_POINTS_ONE_DP = 1;
	var QUANTITY_DECIMAL_POINTS_TWO_DP = exports.QUANTITY_DECIMAL_POINTS_TWO_DP = 2;
	var QUANTITY_DECIMAL_POINTS_THREE_DP = exports.QUANTITY_DECIMAL_POINTS_THREE_DP = 3;
	var QUANTITY_DECIMAL_POINTS_FOUR_DP = exports.QUANTITY_DECIMAL_POINTS_FOUR_DP = 4;
	
	var PURCHASABLE_TYPE_LISTING = exports.PURCHASABLE_TYPE_LISTING = "Listing";
	var PURCHASABLE_TYPE_VOUCHER_DISCOUNT = exports.PURCHASABLE_TYPE_VOUCHER_DISCOUNT = "VoucherDiscount";
	var PURCHASABLE_TYPE_TAX = exports.PURCHASABLE_TYPE_TAX = "Tax";
	var PURCHASABLE_TYPE_DELIVERY = exports.PURCHASABLE_TYPE_DELIVERY = "Delivery";
	var PURCHASABLE_TYPE_CHARGE = exports.PURCHASABLE_TYPE_CHARGE = "Charge";
	var PURCHASABLE_TYPE_STORE_CREDIT = exports.PURCHASABLE_TYPE_STORE_CREDIT = "StoreCredit";
	var PURCHASABLE_TYPE_LOYALTY_REDEEM = exports.PURCHASABLE_TYPE_LOYALTY_REDEEM = "LoyaltyRedeem";
	var PURCHASABLE_TYPE_GIFT_CARD = exports.PURCHASABLE_TYPE_GIFT_CARD = "GiftCard";
	var PURCHASABLE_TYPE_OCTOPUS = exports.PURCHASABLE_TYPE_OCTOPUS = "OctopusValue";
	var PURCHASABLE_TYPE_SERVICE_FEE = exports.PURCHASABLE_TYPE_SERVICE_FEE = "ServiceFee";
	var PURCHASABLE_TYPE_TIPS = exports.PURCHASABLE_TYPE_TIPS = "Tips";
	var PURCHASABLE_TYPE_ROUNDING = exports.PURCHASABLE_TYPE_ROUNDING = "Rounding";
	var PURCHASABLE_TYPE_DEPOSIT = exports.PURCHASABLE_TYPE_DEPOSIT = "Deposit";
	var PURCHASABLE_TYPE_DEPOSIT_REDEEM = exports.PURCHASABLE_TYPE_DEPOSIT_REDEEM = "DepositRedeem";
	var PURCHASABLE_TYPE_DEPOSIT_FORFEIT = exports.PURCHASABLE_TYPE_DEPOSIT_FORFEIT = "DepositForfeit";
	
	var PAYMENT_METHOD_CASH = exports.PAYMENT_METHOD_CASH = 1;
	var PAYMENT_METHOD_CHECK = exports.PAYMENT_METHOD_CHECK = 2;
	var PAYMENT_METHOD_OCTOPUS = exports.PAYMENT_METHOD_OCTOPUS = 3;
	var PAYMENT_METHOD_CP = exports.PAYMENT_METHOD_CP = 4;
	var PAYMENT_METHOD_CNP = exports.PAYMENT_METHOD_CNP = 8;
	
	var PAYMENT_METHOD_STORE_CREDIT = exports.PAYMENT_METHOD_STORE_CREDIT = 16;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(16)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(508);
	var toPrimitive = __webpack_require__(80);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (false) {
	  module.exports = require('./config.prod');
	} else if (true) {
	  module.exports = __webpack_require__(807);
	} else if (process.env.NODE_ENV === 'test' || process.env.API_ENV === 'test') {
	  module.exports = require('./config.test');
	} else {
	  module.exports = require('./config.dev');
	}

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createReducer = createReducer;
	function createReducer(initialState, handlers) {
	  return function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (handlers.hasOwnProperty(action.type)) {
	      return handlers[action.type](state, action);
	    } else {
	      return state;
	    }
	  };
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _reactRouter = __webpack_require__(9);
	
	var _constants = __webpack_require__(26);
	
	var _bindHelper = __webpack_require__(235);
	
	var _concat = __webpack_require__(281);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _menu = __webpack_require__(303);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _lodash = __webpack_require__(14);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function join() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return '/' + args.join('/');
	}
	
	function go(target) {
	  var keys = void 0;
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    keys = Reflect.ownKeys(target.prototype);
	  } else {
	    keys = Object.getOwnPropertyNames(target.prototype);
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
	    }
	  }
	
	  keys.forEach(function (key) {
	    if (key === 'constructor') {
	      return;
	    }
	    var func = (target.prototype || {})[key];
	    if (typeof func === 'function') {
	      var newKey = 'go' + key.charAt(0).toUpperCase() + key.slice(1);
	      target.prototype[newKey] = function () {
	        return _reactRouter.browserHistory.push(func.apply(undefined, arguments));
	      };
	    }
	  });
	
	  return target;
	}
	
	function routeAccessor(prefix, subRoutes) {
	  return function wrapped() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var params = (0, _concat2.default)(args[0], subRoutes);
	    if (args.length > 1) {
	      args.shift();
	      params = (0, _concat2.default)(params, args);
	    }
	    if (prefix) params = (0, _concat2.default)([prefix], params);
	    return join.apply(undefined, _toConsumableArray(params));
	  };
	}
	
	function configured(target) {
	  _lodash2.default.forEach(_menu2.default.DEFAULT, function (item) {
	    var type = item.type,
	        route1 = item.subRoute,
	        children = item.children,
	        route = item.route,
	        prefix = item.prefix;
	
	    if (type === 'link') {
	      (0, _bindHelper.bindPublicMethod)(target, _lodash2.default.camelCase(route), routeAccessor(prefix, [route]));
	    }
	    if (type === 'menu') {
	      children.forEach(function (child) {
	        var subRoute = child.subRoute,
	            subChildren = child.children;
	
	        var subRoutes = [route1];
	        if (subRoute) subRoutes.push(subRoute);
	        subChildren.forEach(function (c) {
	          if (c.subRoute) {
	            (0, _bindHelper.bindPublicMethod)(target, _lodash2.default.camelCase(c.subRoute), routeAccessor(c.prefix, (0, _concat2.default)(subRoutes, [c.subRoute])));
	          }
	        });
	      });
	    }
	  });
	
	  return target;
	}
	
	var RouteHelper = go(_class = configured(_class = function () {
	  function RouteHelper() {
	    _classCallCheck(this, RouteHelper);
	  }
	
	  _createClass(RouteHelper, [{
	    key: 'siteIndex',
	    value: function siteIndex() {
	      return '/' + _constants.ROUTE.SITE_PREFIX;
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      return join(_constants.ROUTE.SITE_PREFIX, _constants.ROUTE.LOGIN);
	    }
	  }]);
	
	  return RouteHelper;
	}()) || _class) || _class;
	
	exports.default = new RouteHelper();

/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMProperty = __webpack_require__(172);
	var ReactDOMComponentFlags = __webpack_require__(651);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startFetch = startFetch;
	exports.stopFetch = stopFetch;
	exports.setPathState = setPathState;
	var START_FETCH = exports.START_FETCH = 'START_FETCH';
	var STOP_FETCH = exports.STOP_FETCH = 'STOP_FETCH';
	var SET_PATH_STATE = exports.SET_PATH_STATE = 'SET_PATH_STATE';
	
	function startFetch() {
	  return {
	    type: START_FETCH
	  };
	}
	
	function stopFetch() {
	  return {
	    type: STOP_FETCH
	  };
	}
	
	function setPathState(path, stateName, result) {
	  return {
	    type: SET_PATH_STATE,
	    path: path,
	    stateName: stateName,
	    result: result
	  };
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateTimeFormatter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.dateTime = dateTime;
	exports.date = date;
	exports.dateTz = dateTz;
	exports.dateToIso = dateToIso;
	exports.decodeNumberMask = decodeNumberMask;
	exports.formatNumber = formatNumber;
	exports.currencySymbol = currencySymbol;
	exports.formatCurrency = formatCurrency;
	exports.decimal = decimal;
	exports.lowercase = lowercase;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _currencyFormatter = __webpack_require__(1222);
	
	var _momentTimezone = __webpack_require__(400);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	__webpack_require__(399);
	
	var _bindHelper = __webpack_require__(235);
	
	var _lodash = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function dateTime(datetime) {
	  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Hong_Kong';
	
	  var d = (0, _momentTimezone2.default)(datetime);
	  if (d.isValid()) {
	    return d.tz(timezone).format('M/D/YYYY, h:mm A');
	  }
	  return '';
	}
	
	/**
	 * Format date without timezone, it is useful when you want to
	 * format a date string to M/D/YYYY format.
	 *
	 * @param {string|Date|Moment} date
	 * @returns {string}
	 *
	 * @example
	 * date('2016-05-31') // 5/31/2016
	 */
	function date(date, asIsoValue) {
	  var d = (0, _momentTimezone2.default)(date);
	  if (d.isValid()) {
	    if (asIsoValue) {
	      return (0, _momentTimezone2.default)(date).format('M/D/YYYY');
	    } else {
	      return (0, _momentTimezone2.default)(date).format('YYYY-MM-DD');
	    }
	  }
	  return '';
	}
	
	/**
	 * Format date with timezone, it is useful when you want to
	 * format a ISO datetime string to a local date with M/D/YYYY format.
	 *
	 * @param {string|Date|Moment} date
	 * @param {string} [timezone="Asia/Hong_Kong"]
	 * @returns {string}
	 *
	 * @example
	 * dateTz('2016-05-31T18:00:00.000Z', 'Asia/Hong_Kong') // 6/1/2016
	 */
	function dateTz(date) {
	  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Hong_Kong';
	  var asIsoValue = arguments[2];
	
	  var d = (0, _momentTimezone2.default)(date);
	  if (d.isValid()) {
	    if (asIsoValue) {
	      return d.tz(timezone).format('M/D/YYYY');
	    } else {
	      return d.tz(timezone).format('YYYY-MM-DD');
	    }
	  }
	  return '';
	}
	
	/**
	 * Format date string to ISO date string
	 * @param {string} date
	 * @param {string} [timezone="Asia/Hong_Kong"]
	 * @returns {string}
	 *
	 * @example
	 * dateToIso('2016-05-31', 'America/new_york') // 2016-05-31T00:00:00-04:00
	 */
	function dateToIso(date) {
	  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Hong_Kong';
	
	  var d = _momentTimezone2.default.tz(date, timezone);
	  return d.isValid() ? d.format() : '';
	}
	
	var dateTimeFormatter = exports.dateTimeFormatter = function dateTimeFormatter(WrappedComponent) {
	  function formatter(data) {
	    var timezone = this.context.currentStore && this.context.currentStore.timezone;
	    return dateTime(data, timezone);
	  }
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'dateTime', formatter);
	};
	
	/**
	 * @typedef {object} NumberMaskDecoded
	 *
	 * @property {boolean} valid     Given string is a valid format number or not
	 * @property {object}  match     Matching components of the format
	 * @property {string}  mask      The given mask
	 * @property {string}  formatted Formatted number string
	 * @property {Big}     value     The number value
	 */
	
	/**
	 * Decode number string in specific format
	 *
	 * @param {string}  mask
	 * @param {object}  [format]                 The number format config
	 * @param {number}  [format.dp]              The decimal points
	 * @param {string}  [format.prefix]          The prefix string
	 * @param {string}  [format.suffix]          The suffix string
	 * @param {boolean} [format.signAfterPrefix] The sign should place after prefix
	 *
	 * @return {NumberMaskDecoded}
	 */
	function decodeNumberMask(mask) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _format$dp = format.dp,
	      dp = _format$dp === undefined ? 2 : _format$dp,
	      _format$prefix = format.prefix,
	      prefix = _format$prefix === undefined ? '' : _format$prefix,
	      _format$suffix = format.suffix,
	      suffix = _format$suffix === undefined ? '' : _format$suffix,
	      _format$signAfterPref = format.signAfterPrefix,
	      signAfterPrefix = _format$signAfterPref === undefined ? false : _format$signAfterPref;
	
	  var prefixRegexp = prefix.replace(/(\W)/g, '\\$1');
	  var suffixRegexp = suffix.replace(/(\W)/g, '\\$1');
	  var regexp = RegExp('^(-)?(' + prefixRegexp + ')?(-)?(\\d+(,\\d+)*)?(\\.)?(\\d*)(' + suffixRegexp + ')?$');
	
	  var _ref = mask.match(regexp) || [],
	      _ref2 = _slicedToArray(_ref, 9),
	      matchStr = _ref2[0],
	      _ref2$ = _ref2[1],
	      matchNe1 = _ref2$ === undefined ? '' : _ref2$,
	      _ref2$2 = _ref2[2],
	      matchPrefix = _ref2$2 === undefined ? '' : _ref2$2,
	      _ref2$3 = _ref2[3],
	      matchNe2 = _ref2$3 === undefined ? '' : _ref2$3,
	      _ref2$4 = _ref2[4],
	      matchDigit = _ref2$4 === undefined ? '' : _ref2$4,
	      matchIgnore = _ref2[5],
	      _ref2$5 = _ref2[6],
	      matchDot = _ref2$5 === undefined ? '' : _ref2$5,
	      _ref2$6 = _ref2[7],
	      matchDecimal = _ref2$6 === undefined ? '' : _ref2$6,
	      _ref2$7 = _ref2[8],
	      matchSuffix = _ref2$7 === undefined ? '' : _ref2$7;
	
	  var valid = !!matchStr;
	
	  if (valid) {
	    var matchDecimalFormatted = Array(dp).fill('0').join('');
	    if (matchDecimal !== '') {
	      matchSuffix = suffix;
	      matchDigit = matchDigit || '0';
	      matchDecimal = matchDecimal.substr(0, dp);
	      matchDecimalFormatted = (matchDecimal + matchDecimalFormatted).substr(0, dp);
	    }
	
	    if (matchDigit !== '') {
	      matchPrefix = prefix;
	      matchDigit = matchDigit.replace(/,/g, '').replace(/^0*/, '');
	      matchDigit = (matchDigit || '0').split('').reverse().reduce(function (ret, d, i, ary) {
	        if (i !== 0 && i % 3 == 0) {
	          ret.push(',');
	        }
	        ret.push(d);
	        return ret;
	      }, []).reverse().join('');
	    }
	    var match = {
	      matchStr: matchStr,
	      matchNe1: matchNe1,
	      matchPrefix: matchPrefix,
	      matchNe2: matchNe2,
	      matchDigit: matchDigit,
	      matchIgnore: matchIgnore,
	      matchDot: matchDot,
	      matchDecimal: matchDecimal,
	      matchDecimalFormatted: matchDecimalFormatted,
	      matchSuffix: matchSuffix
	    };
	    var newMask = matchNe1 + matchPrefix + matchNe2 + matchDigit + matchDot + matchDecimal + matchSuffix;
	    var newMaskFormatted = (signAfterPrefix ? '' : matchNe1 + matchNe2) + prefix + (signAfterPrefix ? matchNe1 + matchNe2 : '') + matchDigit + (dp > 0 ? '.' + matchDecimalFormatted : '') + suffix;
	    var newValue = (0, _big2.default)(matchNe1 + matchNe2 + (matchDigit.split(',').join('') || '0') + (matchDot || '.') + matchDecimal || '0');
	    return {
	      valid: valid,
	      match: match,
	      mask: newMask,
	      formatted: newMaskFormatted,
	      value: newValue
	    };
	  } else {
	    return { valid: valid };
	  }
	}
	
	/**
	 * Format number in given format
	 *
	 * @param {number|string|Big} number                   The given number
	 * @param {object}            [format]                 The number format config
	 * @param {number}            [format.dp]              The decimal points
	 * @param {string}            [format.prefix]          The prefix string
	 * @param {string}            [format.suffix]          The suffix string
	 * @param {boolean}           [format.signAfterPrefix] The sign should place after prefix
	 *
	 * @return {string}
	 */
	function formatNumber(number) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var decoded = decodeNumberMask((0, _big2.default)(number || 0).toString(), format);
	  return decoded.valid ? decoded.formatted : '';
	}
	
	function currencySymbol() {
	  var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HKD';
	
	  return currency === 'HKD' ? '$' : (0, _currencyFormatter.findCurrency)(currency).symbol;
	}
	
	/**
	 * Format number in given format
	 *
	 * @param {number|string|Big} number                   The given number
	 * @param {object}            [format]                 The number format config
	 * @param {number}            [format.dp]              The decimal points
	 * @param {string}            [format.currency]        The currency code, eg. HKD, USD
	 * @param {boolean}           [format.signAfterPrefix] The sign should place after prefix
	 *
	 * @return {string}
	 */
	function formatCurrency(number) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _format$currency = format.currency,
	      currency = _format$currency === undefined ? 'HKD' : _format$currency,
	      cfg = _objectWithoutProperties(format, ['currency']);
	
	  var prefix = currencySymbol(currency);
	  return formatNumber(number, _extends({ prefix: prefix }, cfg));
	}
	
	function decimal(value) {
	  return (0, _lodash.isNumber)(value) ? new Intl.NumberFormat().format(value) : '';
	}
	
	/**
	 * Format string to lower case
	 *
	 * @param {string} string The given string
	 *
	 * @return {string}
	 */
	function lowercase(string) {
	  var str = string || '';
	  return str.toLowerCase();
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(78);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouter = __webpack_require__(9);
	
	var _lodash = __webpack_require__(14);
	
	var _humps = __webpack_require__(44);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilterHelper = function () {
	  function FilterHelper() {
	    var _this = this;
	
	    _classCallCheck(this, FilterHelper);
	
	    this.getFilterSettings = function () {
	      var columnMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      return columnMeta.filter(function (d) {
	        return d.filterConditions;
	      }).map(function (d) {
	        return (0, _lodash.pick)(d, 'columnName', 'displayName', 'filterConditions');
	      });
	    };
	
	    this.onSearchFactory = function (basePath, perPage) {
	      return function (filters) {
	        return _this.search(basePath, 1, perPage, filters);
	      };
	    };
	
	    this.goToPageFactory = function (basePath, perPage, filters) {
	      return function (page) {
	        return _this.search(basePath, page, perPage, filters);
	      };
	    };
	
	    this.updateRowsPerPageFactory = function (basePath, filters) {
	      return function (perPage) {
	        return _this.search(basePath, 1, perPage, filters);
	      };
	    };
	  }
	
	  _createClass(FilterHelper, [{
	    key: 'filtersToString',
	    value: function filtersToString(filters) {
	      var queryList = this.filtersToQueryString(filters);
	
	      return queryList.join('____');
	    }
	  }, {
	    key: 'filtersToQueryString',
	    value: function filtersToQueryString(filters) {
	      var queryList = [];
	
	      for (var filterKey in filters) {
	        if (filters.hasOwnProperty(filterKey)) {
	          var filter = filters[filterKey];
	
	          switch (filter.condition) {
	            case 'between':
	            case 'date_between':
	              {
	                if (!filter.conditionFrom && !filter.conditionTo) {
	                  continue;
	                }
	
	                var query = filter.column + '__' + filter.condition + '__' + filter.conditionFrom + '__' + filter.conditionTo;
	
	                queryList.push(query);
	                break;
	              }
	            default:
	              {
	                if (filter.conditionValue == null || filter.conditionValue === '') {
	                  continue;
	                }
	                var value = typeof filter.conditionValue === 'boolean' ? filter.conditionValue ? 1 : 0 : filter.conditionValue;
	                var _query = filter.column + '__' + filter.condition + '__' + value;
	
	                queryList.push(_query);
	                break;
	              }
	          }
	        }
	      }
	
	      return queryList;
	    }
	  }, {
	    key: 'stringToFilters',
	    value: function stringToFilters(query) {
	      var filters = [];
	      if (!query) {
	        return filters;
	      }
	
	      var queryList = query.split('____');
	      for (var i = 0; i < queryList.length; i++) {
	        var rowData = queryList[i].split('__');
	        var condition = rowData[1];
	
	        switch (condition) {
	          case 'between':
	          case 'date_between':
	            {
	              var filter = {
	                column: rowData[0],
	                condition: rowData[1],
	                conditionFrom: rowData[2],
	                conditionTo: rowData[3]
	              };
	
	              filters.push(filter);
	              break;
	            }
	          default:
	            {
	              var _filter = {
	                column: rowData[0],
	                condition: rowData[1],
	                conditionValue: rowData[2]
	              };
	
	              filters.push(_filter);
	              break;
	            }
	        }
	      }
	
	      return filters;
	    }
	  }, {
	    key: 'searchParamToFilters',
	    value: function searchParamToFilters(searchParam) {
	      var filters = [];
	      if (searchParam) {
	        var _decamelizeKeys = (0, _humps.decamelizeKeys)(searchParam),
	            filter = _decamelizeKeys.filter,
	            wildcard = _decamelizeKeys.wildcard,
	            range = _decamelizeKeys.range;
	
	        (0, _lodash.each)(filter, function (v, key) {
	          if (v) {
	            var column = key;
	            var condition = 'equal';
	            var conditionValue = v;
	            filters.push({ column: column, condition: condition, conditionValue: conditionValue });
	          }
	        });
	        (0, _lodash.each)(wildcard, function (v, key) {
	          if (v) {
	            var column = key;
	            var condition = 'contain';
	            var conditionValue = v.replace(/\*/g, '');
	            filters.push({ column: column, condition: condition, conditionValue: conditionValue });
	          }
	        });
	        (0, _lodash.each)(range, function (v, key) {
	          if (v) {
	            var column = key;
	            var condition = 'between';
	            var conditionFrom = v.gte || v.gt;
	            var conditionTo = v.lte || v.lt;
	            filters.push({ column: column, condition: condition, conditionFrom: conditionFrom, conditionTo: conditionTo });
	          }
	        });
	      }
	      return filters;
	    }
	  }, {
	    key: 'search',
	    value: function search(basePath, page, perPage, filters) {
	      filters = this.filtersToQueryString(filters);
	      _reactRouter.browserHistory.push({
	        pathname: basePath,
	        query: { page: page, per_page: perPage, filters: filters }
	      });
	    }
	  }]);
	
	  return FilterHelper;
	}();
	
	exports.default = new FilterHelper();

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(650);


/***/ },
/* 40 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alertActions = __webpack_require__(90);
	
	Object.keys(_alertActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _alertActions[key];
	    }
	  });
	});
	
	var _associateActions = __webpack_require__(760);
	
	Object.keys(_associateActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _associateActions[key];
	    }
	  });
	});
	
	var _baseActions = __webpack_require__(34);
	
	Object.keys(_baseActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _baseActions[key];
	    }
	  });
	});
	
	var _deliveryOrderActions = __webpack_require__(458);
	
	Object.keys(_deliveryOrderActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _deliveryOrderActions[key];
	    }
	  });
	});
	
	var _departmentActions = __webpack_require__(149);
	
	Object.keys(_departmentActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _departmentActions[key];
	    }
	  });
	});
	
	var _emailTemplateActions = __webpack_require__(308);
	
	Object.keys(_emailTemplateActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _emailTemplateActions[key];
	    }
	  });
	});
	
	var _entityActions = __webpack_require__(58);
	
	Object.keys(_entityActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _entityActions[key];
	    }
	  });
	});
	
	var _formActions = __webpack_require__(762);
	
	Object.keys(_formActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _formActions[key];
	    }
	  });
	});
	
	var _inventoryActions = __webpack_require__(105);
	
	Object.keys(_inventoryActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _inventoryActions[key];
	    }
	  });
	});
	
	var _invoiceActions = __webpack_require__(226);
	
	Object.keys(_invoiceActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _invoiceActions[key];
	    }
	  });
	});
	
	var _kdsActions = __webpack_require__(182);
	
	Object.keys(_kdsActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _kdsActions[key];
	    }
	  });
	});
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	Object.keys(_lineItemStatusAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _lineItemStatusAction[key];
	    }
	  });
	});
	
	var _membershipLevelActions = __webpack_require__(183);
	
	Object.keys(_membershipLevelActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _membershipLevelActions[key];
	    }
	  });
	});
	
	var _otherPaymentInstrumentActions = __webpack_require__(763);
	
	Object.keys(_otherPaymentInstrumentActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _otherPaymentInstrumentActions[key];
	    }
	  });
	});
	
	var _savedFiltersActions = __webpack_require__(227);
	
	Object.keys(_savedFiltersActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _savedFiltersActions[key];
	    }
	  });
	});
	
	var _storeActions = __webpack_require__(228);
	
	Object.keys(_storeActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _storeActions[key];
	    }
	  });
	});
	
	var _supplierActions = __webpack_require__(468);
	
	Object.keys(_supplierActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _supplierActions[key];
	    }
	  });
	});
	
	var _userActions = __webpack_require__(470);
	
	Object.keys(_userActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _userActions[key];
	    }
	  });
	});
	
	var _voucherActions = __webpack_require__(59);
	
	Object.keys(_voucherActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _voucherActions[key];
	    }
	  });
	});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormGroup = (_temp = _class = function (_Component) {
	  _inherits(FormGroup, _Component);
	
	  function FormGroup(props) {
	    _classCallCheck(this, FormGroup);
	
	    return _possibleConstructorReturn(this, (FormGroup.__proto__ || Object.getPrototypeOf(FormGroup)).call(this, props));
	  }
	
	  _createClass(FormGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          state = _props.state,
	          autoHideHelpText = _props.autoHideHelpText,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          label = _props.label,
	          display = _props.display;
	
	      state = state || {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('form-group', className, { 'has-danger': state.touched && state.invalid }) },
	        label ? _react2.default.createElement(
	          'label',
	          null,
	          label
	        ) : null,
	        display != null && display !== '' ? _react2.default.createElement(
	          'span',
	          { className: 'form-control', readOnly: true },
	          display
	        ) : this.props.children,
	        !autoHideHelpText || state.touched || state.error ? _react2.default.createElement(
	          'div',
	          { className: 'text-help' },
	          state.touched && state.error,
	          '\xA0'
	        ) : null
	      );
	    }
	  }]);
	
	  return FormGroup;
	}(_react.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  state: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  label: _propTypes2.default.string,
	  display: _propTypes2.default.string,
	  autoHideHelpText: _propTypes2.default.bool
	}, _temp);
	exports.default = FormGroup;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* big.js v3.1.3 https://github.com/MikeMcl/big.js/LICENCE */
	;(function (global) {
	    'use strict';
	
	/*
	  big.js v3.1.3
	  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
	  https://github.com/MikeMcl/big.js/
	  Copyright (c) 2014 Michael Mclaughlin <M8ch88l@gmail.com>
	  MIT Expat Licence
	*/
	
	/***************************** EDITABLE DEFAULTS ******************************/
	
	    // The default values below must be integers within the stated ranges.
	
	    /*
	     * The maximum number of decimal places of the results of operations
	     * involving division: div and sqrt, and pow with negative exponents.
	     */
	    var DP = 20,                           // 0 to MAX_DP
	
	        /*
	         * The rounding mode used when rounding to the above decimal places.
	         *
	         * 0 Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
	         * 1 To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
	         * 2 To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
	         * 3 Away from zero.                                  (ROUND_UP)
	         */
	        RM = 1,                            // 0, 1, 2 or 3
	
	        // The maximum value of DP and Big.DP.
	        MAX_DP = 1E6,                      // 0 to 1000000
	
	        // The maximum magnitude of the exponent argument to the pow method.
	        MAX_POWER = 1E6,                   // 1 to 1000000
	
	        /*
	         * The exponent value at and beneath which toString returns exponential
	         * notation.
	         * JavaScript's Number type: -7
	         * -1000000 is the minimum recommended exponent value of a Big.
	         */
	        E_NEG = -7,                   // 0 to -1000000
	
	        /*
	         * The exponent value at and above which toString returns exponential
	         * notation.
	         * JavaScript's Number type: 21
	         * 1000000 is the maximum recommended exponent value of a Big.
	         * (This limit is not enforced or checked.)
	         */
	        E_POS = 21,                   // 0 to 1000000
	
	/******************************************************************************/
	
	        // The shared prototype object.
	        P = {},
	        isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	        Big;
	
	
	    /*
	     * Create and return a Big constructor.
	     *
	     */
	    function bigFactory() {
	
	        /*
	         * The Big constructor and exported function.
	         * Create and return a new instance of a Big number object.
	         *
	         * n {number|string|Big} A numeric value.
	         */
	        function Big(n) {
	            var x = this;
	
	            // Enable constructor usage without new.
	            if (!(x instanceof Big)) {
	                return n === void 0 ? bigFactory() : new Big(n);
	            }
	
	            // Duplicate.
	            if (n instanceof Big) {
	                x.s = n.s;
	                x.e = n.e;
	                x.c = n.c.slice();
	            } else {
	                parse(x, n);
	            }
	
	            /*
	             * Retain a reference to this Big constructor, and shadow
	             * Big.prototype.constructor which points to Object.
	             */
	            x.constructor = Big;
	        }
	
	        Big.prototype = P;
	        Big.DP = DP;
	        Big.RM = RM;
	        Big.E_NEG = E_NEG;
	        Big.E_POS = E_POS;
	
	        return Big;
	    }
	
	
	    // Private functions
	
	
	    /*
	     * Return a string representing the value of Big x in normal or exponential
	     * notation to dp fixed decimal places or significant digits.
	     *
	     * x {Big} The Big to format.
	     * dp {number} Integer, 0 to MAX_DP inclusive.
	     * toE {number} 1 (toExponential), 2 (toPrecision) or undefined (toFixed).
	     */
	    function format(x, dp, toE) {
	        var Big = x.constructor,
	
	            // The index (normal notation) of the digit that may be rounded up.
	            i = dp - (x = new Big(x)).e,
	            c = x.c;
	
	        // Round?
	        if (c.length > ++dp) {
	            rnd(x, i, Big.RM);
	        }
	
	        if (!c[0]) {
	            ++i;
	        } else if (toE) {
	            i = dp;
	
	        // toFixed
	        } else {
	            c = x.c;
	
	            // Recalculate i as x.e may have changed if value rounded up.
	            i = x.e + i + 1;
	        }
	
	        // Append zeros?
	        for (; c.length < i; c.push(0)) {
	        }
	        i = x.e;
	
	        /*
	         * toPrecision returns exponential notation if the number of
	         * significant digits specified is less than the number of digits
	         * necessary to represent the integer part of the value in normal
	         * notation.
	         */
	        return toE === 1 || toE && (dp <= i || i <= Big.E_NEG) ?
	
	          // Exponential notation.
	          (x.s < 0 && c[0] ? '-' : '') +
	            (c.length > 1 ? c[0] + '.' + c.join('').slice(1) : c[0]) +
	              (i < 0 ? 'e' : 'e+') + i
	
	          // Normal notation.
	          : x.toString();
	    }
	
	
	    /*
	     * Parse the number or string value passed to a Big constructor.
	     *
	     * x {Big} A Big number instance.
	     * n {number|string} A numeric value.
	     */
	    function parse(x, n) {
	        var e, i, nL;
	
	        // Minus zero?
	        if (n === 0 && 1 / n < 0) {
	            n = '-0';
	
	        // Ensure n is string and check validity.
	        } else if (!isValid.test(n += '')) {
	            throwErr(NaN);
	        }
	
	        // Determine sign.
	        x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
	
	        // Decimal point?
	        if ((e = n.indexOf('.')) > -1) {
	            n = n.replace('.', '');
	        }
	
	        // Exponential form?
	        if ((i = n.search(/e/i)) > 0) {
	
	            // Determine exponent.
	            if (e < 0) {
	                e = i;
	            }
	            e += +n.slice(i + 1);
	            n = n.substring(0, i);
	
	        } else if (e < 0) {
	
	            // Integer.
	            e = n.length;
	        }
	
	        // Determine leading zeros.
	        for (i = 0; n.charAt(i) == '0'; i++) {
	        }
	
	        if (i == (nL = n.length)) {
	
	            // Zero.
	            x.c = [ x.e = 0 ];
	        } else {
	
	            // Determine trailing zeros.
	            for (; n.charAt(--nL) == '0';) {
	            }
	
	            x.e = e - i - 1;
	            x.c = [];
	
	            // Convert string to array of digits without leading/trailing zeros.
	            for (e = 0; i <= nL; x.c[e++] = +n.charAt(i++)) {
	            }
	        }
	
	        return x;
	    }
	
	
	    /*
	     * Round Big x to a maximum of dp decimal places using rounding mode rm.
	     * Called by div, sqrt and round.
	     *
	     * x {Big} The Big to round.
	     * dp {number} Integer, 0 to MAX_DP inclusive.
	     * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
	     * [more] {boolean} Whether the result of division was truncated.
	     */
	    function rnd(x, dp, rm, more) {
	        var u,
	            xc = x.c,
	            i = x.e + dp + 1;
	
	        if (rm === 1) {
	
	            // xc[i] is the digit after the digit that may be rounded up.
	            more = xc[i] >= 5;
	        } else if (rm === 2) {
	            more = xc[i] > 5 || xc[i] == 5 &&
	              (more || i < 0 || xc[i + 1] !== u || xc[i - 1] & 1);
	        } else if (rm === 3) {
	            more = more || xc[i] !== u || i < 0;
	        } else {
	            more = false;
	
	            if (rm !== 0) {
	                throwErr('!Big.RM!');
	            }
	        }
	
	        if (i < 1 || !xc[0]) {
	
	            if (more) {
	
	                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	                x.e = -dp;
	                x.c = [1];
	            } else {
	
	                // Zero.
	                x.c = [x.e = 0];
	            }
	        } else {
	
	            // Remove any digits after the required decimal places.
	            xc.length = i--;
	
	            // Round up?
	            if (more) {
	
	                // Rounding up may mean the previous digit has to be rounded up.
	                for (; ++xc[i] > 9;) {
	                    xc[i] = 0;
	
	                    if (!i--) {
	                        ++x.e;
	                        xc.unshift(1);
	                    }
	                }
	            }
	
	            // Remove trailing zeros.
	            for (i = xc.length; !xc[--i]; xc.pop()) {
	            }
	        }
	
	        return x;
	    }
	
	
	    /*
	     * Throw a BigError.
	     *
	     * message {string} The error message.
	     */
	    function throwErr(message) {
	        var err = new Error(message);
	        err.name = 'BigError';
	
	        throw err;
	    }
	
	
	    // Prototype/instance methods
	
	
	    /*
	     * Return a new Big whose value is the absolute value of this Big.
	     */
	    P.abs = function () {
	        var x = new this.constructor(this);
	        x.s = 1;
	
	        return x;
	    };
	
	
	    /*
	     * Return
	     * 1 if the value of this Big is greater than the value of Big y,
	     * -1 if the value of this Big is less than the value of Big y, or
	     * 0 if they have the same value.
	    */
	    P.cmp = function (y) {
	        var xNeg,
	            x = this,
	            xc = x.c,
	            yc = (y = new x.constructor(y)).c,
	            i = x.s,
	            j = y.s,
	            k = x.e,
	            l = y.e;
	
	        // Either zero?
	        if (!xc[0] || !yc[0]) {
	            return !xc[0] ? !yc[0] ? 0 : -j : i;
	        }
	
	        // Signs differ?
	        if (i != j) {
	            return i;
	        }
	        xNeg = i < 0;
	
	        // Compare exponents.
	        if (k != l) {
	            return k > l ^ xNeg ? 1 : -1;
	        }
	
	        i = -1;
	        j = (k = xc.length) < (l = yc.length) ? k : l;
	
	        // Compare digit by digit.
	        for (; ++i < j;) {
	
	            if (xc[i] != yc[i]) {
	                return xc[i] > yc[i] ^ xNeg ? 1 : -1;
	            }
	        }
	
	        // Compare lengths.
	        return k == l ? 0 : k > l ^ xNeg ? 1 : -1;
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big divided by the
	     * value of Big y, rounded, if necessary, to a maximum of Big.DP decimal
	     * places using rounding mode Big.RM.
	     */
	    P.div = function (y) {
	        var x = this,
	            Big = x.constructor,
	            // dividend
	            dvd = x.c,
	            //divisor
	            dvs = (y = new Big(y)).c,
	            s = x.s == y.s ? 1 : -1,
	            dp = Big.DP;
	
	        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	            throwErr('!Big.DP!');
	        }
	
	        // Either 0?
	        if (!dvd[0] || !dvs[0]) {
	
	            // If both are 0, throw NaN
	            if (dvd[0] == dvs[0]) {
	                throwErr(NaN);
	            }
	
	            // If dvs is 0, throw +-Infinity.
	            if (!dvs[0]) {
	                throwErr(s / 0);
	            }
	
	            // dvd is 0, return +-0.
	            return new Big(s * 0);
	        }
	
	        var dvsL, dvsT, next, cmp, remI, u,
	            dvsZ = dvs.slice(),
	            dvdI = dvsL = dvs.length,
	            dvdL = dvd.length,
	            // remainder
	            rem = dvd.slice(0, dvsL),
	            remL = rem.length,
	            // quotient
	            q = y,
	            qc = q.c = [],
	            qi = 0,
	            digits = dp + (q.e = x.e - y.e) + 1;
	
	        q.s = s;
	        s = digits < 0 ? 0 : digits;
	
	        // Create version of divisor with leading zero.
	        dvsZ.unshift(0);
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL++ < dvsL; rem.push(0)) {
	        }
	
	        do {
	
	            // 'next' is how many times the divisor goes into current remainder.
	            for (next = 0; next < 10; next++) {
	
	                // Compare divisor and remainder.
	                if (dvsL != (remL = rem.length)) {
	                    cmp = dvsL > remL ? 1 : -1;
	                } else {
	
	                    for (remI = -1, cmp = 0; ++remI < dvsL;) {
	
	                        if (dvs[remI] != rem[remI]) {
	                            cmp = dvs[remI] > rem[remI] ? 1 : -1;
	                            break;
	                        }
	                    }
	                }
	
	                // If divisor < remainder, subtract divisor from remainder.
	                if (cmp < 0) {
	
	                    // Remainder can't be more than 1 digit longer than divisor.
	                    // Equalise lengths using divisor with extra leading zero?
	                    for (dvsT = remL == dvsL ? dvs : dvsZ; remL;) {
	
	                        if (rem[--remL] < dvsT[remL]) {
	                            remI = remL;
	
	                            for (; remI && !rem[--remI]; rem[remI] = 9) {
	                            }
	                            --rem[remI];
	                            rem[remL] += 10;
	                        }
	                        rem[remL] -= dvsT[remL];
	                    }
	                    for (; !rem[0]; rem.shift()) {
	                    }
	                } else {
	                    break;
	                }
	            }
	
	            // Add the 'next' digit to the result array.
	            qc[qi++] = cmp ? next : ++next;
	
	            // Update the remainder.
	            if (rem[0] && cmp) {
	                rem[remL] = dvd[dvdI] || 0;
	            } else {
	                rem = [ dvd[dvdI] ];
	            }
	
	        } while ((dvdI++ < dvdL || rem[0] !== u) && s--);
	
	        // Leading zero? Do not remove if result is simply zero (qi == 1).
	        if (!qc[0] && qi != 1) {
	
	            // There can't be more than one zero.
	            qc.shift();
	            q.e--;
	        }
	
	        // Round?
	        if (qi > digits) {
	            rnd(q, dp, Big.RM, rem[0] !== u);
	        }
	
	        return q;
	    };
	
	
	    /*
	     * Return true if the value of this Big is equal to the value of Big y,
	     * otherwise returns false.
	     */
	    P.eq = function (y) {
	        return !this.cmp(y);
	    };
	
	
	    /*
	     * Return true if the value of this Big is greater than the value of Big y,
	     * otherwise returns false.
	     */
	    P.gt = function (y) {
	        return this.cmp(y) > 0;
	    };
	
	
	    /*
	     * Return true if the value of this Big is greater than or equal to the
	     * value of Big y, otherwise returns false.
	     */
	    P.gte = function (y) {
	        return this.cmp(y) > -1;
	    };
	
	
	    /*
	     * Return true if the value of this Big is less than the value of Big y,
	     * otherwise returns false.
	     */
	    P.lt = function (y) {
	        return this.cmp(y) < 0;
	    };
	
	
	    /*
	     * Return true if the value of this Big is less than or equal to the value
	     * of Big y, otherwise returns false.
	     */
	    P.lte = function (y) {
	         return this.cmp(y) < 1;
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big minus the value
	     * of Big y.
	     */
	    P.sub = P.minus = function (y) {
	        var i, j, t, xLTy,
	            x = this,
	            Big = x.constructor,
	            a = x.s,
	            b = (y = new Big(y)).s;
	
	        // Signs differ?
	        if (a != b) {
	            y.s = -b;
	            return x.plus(y);
	        }
	
	        var xc = x.c.slice(),
	            xe = x.e,
	            yc = y.c,
	            ye = y.e;
	
	        // Either zero?
	        if (!xc[0] || !yc[0]) {
	
	            // y is non-zero? x is non-zero? Or both are zero.
	            return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
	        }
	
	        // Determine which is the bigger number.
	        // Prepend zeros to equalise exponents.
	        if (a = xe - ye) {
	
	            if (xLTy = a < 0) {
	                a = -a;
	                t = xc;
	            } else {
	                ye = xe;
	                t = yc;
	            }
	
	            t.reverse();
	            for (b = a; b--; t.push(0)) {
	            }
	            t.reverse();
	        } else {
	
	            // Exponents equal. Check digit by digit.
	            j = ((xLTy = xc.length < yc.length) ? xc : yc).length;
	
	            for (a = b = 0; b < j; b++) {
	
	                if (xc[b] != yc[b]) {
	                    xLTy = xc[b] < yc[b];
	                    break;
	                }
	            }
	        }
	
	        // x < y? Point xc to the array of the bigger number.
	        if (xLTy) {
	            t = xc;
	            xc = yc;
	            yc = t;
	            y.s = -y.s;
	        }
	
	        /*
	         * Append zeros to xc if shorter. No need to add zeros to yc if shorter
	         * as subtraction only needs to start at yc.length.
	         */
	        if (( b = (j = yc.length) - (i = xc.length) ) > 0) {
	
	            for (; b--; xc[i++] = 0) {
	            }
	        }
	
	        // Subtract yc from xc.
	        for (b = i; j > a;){
	
	            if (xc[--j] < yc[j]) {
	
	                for (i = j; i && !xc[--i]; xc[i] = 9) {
	                }
	                --xc[i];
	                xc[j] += 10;
	            }
	            xc[j] -= yc[j];
	        }
	
	        // Remove trailing zeros.
	        for (; xc[--b] === 0; xc.pop()) {
	        }
	
	        // Remove leading zeros and adjust exponent accordingly.
	        for (; xc[0] === 0;) {
	            xc.shift();
	            --ye;
	        }
	
	        if (!xc[0]) {
	
	            // n - n = +0
	            y.s = 1;
	
	            // Result must be zero.
	            xc = [ye = 0];
	        }
	
	        y.c = xc;
	        y.e = ye;
	
	        return y;
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big modulo the
	     * value of Big y.
	     */
	    P.mod = function (y) {
	        var yGTx,
	            x = this,
	            Big = x.constructor,
	            a = x.s,
	            b = (y = new Big(y)).s;
	
	        if (!y.c[0]) {
	            throwErr(NaN);
	        }
	
	        x.s = y.s = 1;
	        yGTx = y.cmp(x) == 1;
	        x.s = a;
	        y.s = b;
	
	        if (yGTx) {
	            return new Big(x);
	        }
	
	        a = Big.DP;
	        b = Big.RM;
	        Big.DP = Big.RM = 0;
	        x = x.div(y);
	        Big.DP = a;
	        Big.RM = b;
	
	        return this.minus( x.times(y) );
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big plus the value
	     * of Big y.
	     */
	    P.add = P.plus = function (y) {
	        var t,
	            x = this,
	            Big = x.constructor,
	            a = x.s,
	            b = (y = new Big(y)).s;
	
	        // Signs differ?
	        if (a != b) {
	            y.s = -b;
	            return x.minus(y);
	        }
	
	        var xe = x.e,
	            xc = x.c,
	            ye = y.e,
	            yc = y.c;
	
	        // Either zero?
	        if (!xc[0] || !yc[0]) {
	
	            // y is non-zero? x is non-zero? Or both are zero.
	            return yc[0] ? y : new Big(xc[0] ? x : a * 0);
	        }
	        xc = xc.slice();
	
	        // Prepend zeros to equalise exponents.
	        // Note: Faster to use reverse then do unshifts.
	        if (a = xe - ye) {
	
	            if (a > 0) {
	                ye = xe;
	                t = yc;
	            } else {
	                a = -a;
	                t = xc;
	            }
	
	            t.reverse();
	            for (; a--; t.push(0)) {
	            }
	            t.reverse();
	        }
	
	        // Point xc to the longer array.
	        if (xc.length - yc.length < 0) {
	            t = yc;
	            yc = xc;
	            xc = t;
	        }
	        a = yc.length;
	
	        /*
	         * Only start adding at yc.length - 1 as the further digits of xc can be
	         * left as they are.
	         */
	        for (b = 0; a;) {
	            b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
	            xc[a] %= 10;
	        }
	
	        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	
	        if (b) {
	            xc.unshift(b);
	            ++ye;
	        }
	
	         // Remove trailing zeros.
	        for (a = xc.length; xc[--a] === 0; xc.pop()) {
	        }
	
	        y.c = xc;
	        y.e = ye;
	
	        return y;
	    };
	
	
	    /*
	     * Return a Big whose value is the value of this Big raised to the power n.
	     * If n is negative, round, if necessary, to a maximum of Big.DP decimal
	     * places using rounding mode Big.RM.
	     *
	     * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
	     */
	    P.pow = function (n) {
	        var x = this,
	            one = new x.constructor(1),
	            y = one,
	            isNeg = n < 0;
	
	        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
	            throwErr('!pow!');
	        }
	
	        n = isNeg ? -n : n;
	
	        for (;;) {
	
	            if (n & 1) {
	                y = y.times(x);
	            }
	            n >>= 1;
	
	            if (!n) {
	                break;
	            }
	            x = x.times(x);
	        }
	
	        return isNeg ? one.div(y) : y;
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big rounded to a
	     * maximum of dp decimal places using rounding mode rm.
	     * If dp is not specified, round to 0 decimal places.
	     * If rm is not specified, use Big.RM.
	     *
	     * [dp] {number} Integer, 0 to MAX_DP inclusive.
	     * [rm] 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
	     */
	    P.round = function (dp, rm) {
	        var x = this,
	            Big = x.constructor;
	
	        if (dp == null) {
	            dp = 0;
	        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	            throwErr('!round!');
	        }
	        rnd(x = new Big(x), dp, rm == null ? Big.RM : rm);
	
	        return x;
	    };
	
	
	    /*
	     * Return a new Big whose value is the square root of the value of this Big,
	     * rounded, if necessary, to a maximum of Big.DP decimal places using
	     * rounding mode Big.RM.
	     */
	    P.sqrt = function () {
	        var estimate, r, approx,
	            x = this,
	            Big = x.constructor,
	            xc = x.c,
	            i = x.s,
	            e = x.e,
	            half = new Big('0.5');
	
	        // Zero?
	        if (!xc[0]) {
	            return new Big(x);
	        }
	
	        // If negative, throw NaN.
	        if (i < 0) {
	            throwErr(NaN);
	        }
	
	        // Estimate.
	        i = Math.sqrt(x.toString());
	
	        // Math.sqrt underflow/overflow?
	        // Pass x to Math.sqrt as integer, then adjust the result exponent.
	        if (i === 0 || i === 1 / 0) {
	            estimate = xc.join('');
	
	            if (!(estimate.length + e & 1)) {
	                estimate += '0';
	            }
	
	            r = new Big( Math.sqrt(estimate).toString() );
	            r.e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
	        } else {
	            r = new Big(i.toString());
	        }
	
	        i = r.e + (Big.DP += 4);
	
	        // Newton-Raphson iteration.
	        do {
	            approx = r;
	            r = half.times( approx.plus( x.div(approx) ) );
	        } while ( approx.c.slice(0, i).join('') !==
	                       r.c.slice(0, i).join('') );
	
	        rnd(r, Big.DP -= 4, Big.RM);
	
	        return r;
	    };
	
	
	    /*
	     * Return a new Big whose value is the value of this Big times the value of
	     * Big y.
	     */
	    P.mul = P.times = function (y) {
	        var c,
	            x = this,
	            Big = x.constructor,
	            xc = x.c,
	            yc = (y = new Big(y)).c,
	            a = xc.length,
	            b = yc.length,
	            i = x.e,
	            j = y.e;
	
	        // Determine sign of result.
	        y.s = x.s == y.s ? 1 : -1;
	
	        // Return signed 0 if either 0.
	        if (!xc[0] || !yc[0]) {
	            return new Big(y.s * 0);
	        }
	
	        // Initialise exponent of result as x.e + y.e.
	        y.e = i + j;
	
	        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
	        if (a < b) {
	            c = xc;
	            xc = yc;
	            yc = c;
	            j = a;
	            a = b;
	            b = j;
	        }
	
	        // Initialise coefficient array of result with zeros.
	        for (c = new Array(j = a + b); j--; c[j] = 0) {
	        }
	
	        // Multiply.
	
	        // i is initially xc.length.
	        for (i = b; i--;) {
	            b = 0;
	
	            // a is yc.length.
	            for (j = a + i; j > i;) {
	
	                // Current sum of products at this digit position, plus carry.
	                b = c[j] + yc[i] * xc[j - i - 1] + b;
	                c[j--] = b % 10;
	
	                // carry
	                b = b / 10 | 0;
	            }
	            c[j] = (c[j] + b) % 10;
	        }
	
	        // Increment result exponent if there is a final carry.
	        if (b) {
	            ++y.e;
	        }
	
	        // Remove any leading zero.
	        if (!c[0]) {
	            c.shift();
	        }
	
	        // Remove trailing zeros.
	        for (i = c.length; !c[--i]; c.pop()) {
	        }
	        y.c = c;
	
	        return y;
	    };
	
	
	    /*
	     * Return a string representing the value of this Big.
	     * Return exponential notation if this Big has a positive exponent equal to
	     * or greater than Big.E_POS, or a negative exponent equal to or less than
	     * Big.E_NEG.
	     */
	    P.toString = P.valueOf = P.toJSON = function () {
	        var x = this,
	            Big = x.constructor,
	            e = x.e,
	            str = x.c.join(''),
	            strL = str.length;
	
	        // Exponential notation?
	        if (e <= Big.E_NEG || e >= Big.E_POS) {
	            str = str.charAt(0) + (strL > 1 ? '.' + str.slice(1) : '') +
	              (e < 0 ? 'e' : 'e+') + e;
	
	        // Negative exponent?
	        } else if (e < 0) {
	
	            // Prepend zeros.
	            for (; ++e; str = '0' + str) {
	            }
	            str = '0.' + str;
	
	        // Positive exponent?
	        } else if (e > 0) {
	
	            if (++e > strL) {
	
	                // Append zeros.
	                for (e -= strL; e-- ; str += '0') {
	                }
	            } else if (e < strL) {
	                str = str.slice(0, e) + '.' + str.slice(e);
	            }
	
	        // Exponent zero.
	        } else if (strL > 1) {
	            str = str.charAt(0) + '.' + str.slice(1);
	        }
	
	        // Avoid '-0'
	        return x.s < 0 && x.c[0] ? '-' + str : str;
	    };
	
	
	    /*
	     ***************************************************************************
	     * If toExponential, toFixed, toPrecision and format are not required they
	     * can safely be commented-out or deleted. No redundant code will be left.
	     * format is used only by toExponential, toFixed and toPrecision.
	     ***************************************************************************
	     */
	
	
	    /*
	     * Return a string representing the value of this Big in exponential
	     * notation to dp fixed decimal places and rounded, if necessary, using
	     * Big.RM.
	     *
	     * [dp] {number} Integer, 0 to MAX_DP inclusive.
	     */
	    P.toExponential = function (dp) {
	
	        if (dp == null) {
	            dp = this.c.length - 1;
	        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	            throwErr('!toExp!');
	        }
	
	        return format(this, dp, 1);
	    };
	
	
	    /*
	     * Return a string representing the value of this Big in normal notation
	     * to dp fixed decimal places and rounded, if necessary, using Big.RM.
	     *
	     * [dp] {number} Integer, 0 to MAX_DP inclusive.
	     */
	    P.toFixed = function (dp) {
	        var str,
	            x = this,
	            Big = x.constructor,
	            neg = Big.E_NEG,
	            pos = Big.E_POS;
	
	        // Prevent the possibility of exponential notation.
	        Big.E_NEG = -(Big.E_POS = 1 / 0);
	
	        if (dp == null) {
	            str = x.toString();
	        } else if (dp === ~~dp && dp >= 0 && dp <= MAX_DP) {
	            str = format(x, x.e + dp);
	
	            // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.
	            // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	            if (x.s < 0 && x.c[0] && str.indexOf('-') < 0) {
	        //E.g. -0.5 if rounded to -0 will cause toString to omit the minus sign.
	                str = '-' + str;
	            }
	        }
	        Big.E_NEG = neg;
	        Big.E_POS = pos;
	
	        if (!str) {
	            throwErr('!toFix!');
	        }
	
	        return str;
	    };
	
	
	    /*
	     * Return a string representing the value of this Big rounded to sd
	     * significant digits using Big.RM. Use exponential notation if sd is less
	     * than the number of digits necessary to represent the integer part of the
	     * value in normal notation.
	     *
	     * sd {number} Integer, 1 to MAX_DP inclusive.
	     */
	    P.toPrecision = function (sd) {
	
	        if (sd == null) {
	            return this.toString();
	        } else if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
	            throwErr('!toPre!');
	        }
	
	        return format(this, sd - 1, 2);
	    };
	
	
	    // Export
	
	
	    Big = bigFactory();
	
	    //AMD.
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return Big;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    // Node and other CommonJS-like environments that support module.exports.
	    } else if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Big;
	
	    //Browser.
	    } else {
	        global.Big = Big;
	    }
	})(this);


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
	// = humps =
	// =========
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys
	
	// humps is copyright © 2012+ Dom Christie
	// Released under the MIT license.
	
	
	;(function(global) {
	
	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }
	
	    var output,
	        i = 0,
	        l = 0;
	
	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(obj.hasOwnProperty(key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };
	
	  // String conversion methods
	
	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;
	
	    return string.split(split).join(separator);
	  };
	
	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };
	
	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };
	
	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };
	
	  // Utilities
	  // Taken from Underscore.js
	
	  var toString = Object.prototype.toString;
	
	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };
	
	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };
	
	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;
	
	    if(typeof(callback) !== 'function') {
	      return convert;
	    }
	
	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };
	
	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }
	
	})(this);


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(1785);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var utils_1 = __webpack_require__(21);
	/**
	 * An abstract component that Blueprint components can extend
	 * in order to add some common functionality like runtime props validation.
	 */
	var AbstractComponent = (function (_super) {
	    tslib_1.__extends(AbstractComponent, _super);
	    function AbstractComponent(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
	        _this.timeoutIds = [];
	        /**
	         * Clear all known timeouts.
	         */
	        _this.clearTimeouts = function () {
	            if (_this.timeoutIds.length > 0) {
	                for (var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++) {
	                    var timeoutId = _a[_i];
	                    window.clearTimeout(timeoutId);
	                }
	                _this.timeoutIds = [];
	            }
	        };
	        if (!utils_1.isNodeEnv("production")) {
	            _this.validateProps(_this.props);
	        }
	        return _this;
	    }
	    AbstractComponent.prototype.componentWillReceiveProps = function (nextProps) {
	        if (!utils_1.isNodeEnv("production")) {
	            this.validateProps(nextProps);
	        }
	    };
	    AbstractComponent.prototype.componentWillUnmount = function () {
	        this.clearTimeouts();
	    };
	    /**
	     * Set a timeout and remember its ID.
	     * All stored timeouts will be cleared when component unmounts.
	     * @returns a "cancel" function that will clear timeout when invoked.
	     */
	    AbstractComponent.prototype.setTimeout = function (callback, timeout) {
	        var handle = window.setTimeout(callback, timeout);
	        this.timeoutIds.push(handle);
	        return function () { return window.clearTimeout(handle); };
	    };
	    /**
	     * Ensures that the props specified for a component are valid.
	     * Implementations should check that props are valid and usually throw an Error if they are not.
	     * Implementations should not duplicate checks that the type system already guarantees.
	     *
	     * This method should be used instead of React's
	     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
	     * In contrast to propTypes, these runtime checks are _always_ run, not just in development mode.
	     */
	    AbstractComponent.prototype.validateProps = function (_) {
	        // implement in subclass
	    };
	    return AbstractComponent;
	}(React.Component));
	exports.AbstractComponent = AbstractComponent;


/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ns = "[Blueprint]";
	var deprec = ns + " DEPRECATION:";
	exports.CLAMP_MIN_MAX = ns + " clamp: max cannot be less than min";
	exports.ALERT_WARN_CANCEL_PROPS = ns + " <Alert> cancelButtonText and onCancel should be set together.";
	exports.COLLAPSIBLE_LIST_INVALID_CHILD = ns + " <CollapsibleList> children must be <MenuItem>s";
	exports.CONTEXTMENU_WARN_DECORATOR_NO_METHOD = ns + " @ContextMenuTarget-decorated class should implement renderContextMenu.";
	exports.HOTKEYS_HOTKEY_CHILDREN = ns + " <Hotkeys> only accepts <Hotkey> children.";
	exports.MENU_WARN_CHILDREN_SUBMENU_MUTEX = ns + " <MenuItem> children and submenu props are mutually exclusive, with children taking priority.";
	exports.NUMERIC_INPUT_MIN_MAX = ns + " <NumericInput> requires min to be strictly less than max if both are defined.";
	exports.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires minorStepSize to be strictly less than stepSize.";
	exports.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires majorStepSize to be strictly greater than stepSize.";
	exports.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
	exports.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
	exports.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
	exports.NUMERIC_INPUT_STEP_SIZE_NULL = ns + " <NumericInput> requires stepSize to be defined.";
	exports.POPOVER_REQUIRES_TARGET = ns + " <Popover> requires target prop or at least one child element.";
	exports.POPOVER_MODAL_INTERACTION = ns + " <Popover isModal={true}> requires interactionKind={PopoverInteractionKind.CLICK}.";
	exports.POPOVER_WARN_TOO_MANY_CHILDREN = ns +
	    " <Popover> supports one or two children; additional children are ignored." +
	    " First child is the target, second child is the content. You may instead supply these two as props.";
	exports.POPOVER_WARN_DOUBLE_CONTENT = ns + " <Popover> with two children ignores content prop; use either prop or children.";
	exports.POPOVER_WARN_DOUBLE_TARGET = ns + " <Popover> with children ignores target prop; use either prop or children.";
	exports.POPOVER_WARN_EMPTY_CONTENT = ns + " Disabling <Popover> with empty/whitespace content...";
	exports.POPOVER_WARN_MODAL_INLINE = ns + " <Popover inline={true}> ignores isModal";
	exports.POPOVER_WARN_DEPRECATED_CONSTRAINTS = ns + " <Popover> constraints and useSmartPositioning are deprecated. Use tetherOptions directly.";
	exports.POPOVER_WARN_INLINE_NO_TETHER = ns + " <Popover inline={true}> ignores tetherOptions, constraints, and useSmartPositioning.";
	exports.POPOVER_WARN_UNCONTROLLED_ONINTERACTION = ns + " <Popover> onInteraction is ignored when uncontrolled.";
	exports.PORTAL_CONTEXT_CLASS_NAME_STRING = ns + " <Portal> context blueprintPortalClassName must be string";
	exports.RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX = ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
	exports.SLIDER_ZERO_STEP = ns + " <Slider> stepSize must be greater than zero.";
	exports.SLIDER_ZERO_LABEL_STEP = ns + " <Slider> labelStepSize must be greater than zero.";
	exports.RANGESLIDER_NULL_VALUE = ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
	exports.TABS_FIRST_CHILD = ns + " First child of <Tabs> component must be a <TabList>";
	exports.TABS_MISMATCH = ns + " Number of <Tab> components must equal number of <TabPanel> components";
	exports.TABS_WARN_DEPRECATED = deprec +
	    " <Tabs> is deprecated since v1.11.0; consider upgrading to <Tabs2>." +
	    " https://blueprintjs.com/#components.tabs.js";
	exports.TOASTER_WARN_INLINE = ns + " Toaster.create() ignores inline prop as it always creates a new element.";
	exports.TOASTER_WARN_LEFT_RIGHT = ns + " Toaster does not support LEFT or RIGHT positions.";
	exports.DIALOG_WARN_NO_HEADER_ICON = ns + " <Dialog> iconName is ignored if title is omitted.";
	exports.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON = ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _permissionHelper = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Can = (_temp = _class = function (_Component) {
	  _inherits(Can, _Component);
	
	  function Can(props) {
	    _classCallCheck(this, Can);
	
	    return _possibleConstructorReturn(this, (Can.__proto__ || Object.getPrototypeOf(Can)).call(this, props));
	  }
	
	  _createClass(Can, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          children = _props.children;
	      var currentStore = this.context.currentStore;
	
	
	      if (!currentStore) {
	        return null;
	      }
	
	      return (0, _permissionHelper.permissionAccessor)(action, currentStore) ? children : null;
	    }
	  }]);
	
	  return Can;
	}(_react.Component), _class.propTypes = {
	  action: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),
	  children: _propTypes2.default.node
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Can;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var createDesc = __webpack_require__(128);
	module.exports = __webpack_require__(27) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(53);
	var has = __webpack_require__(60);
	var SRC = __webpack_require__(132)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(68).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var fails = __webpack_require__(16);
	var defined = __webpack_require__(78);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var React = __webpack_require__(1);
	var GridTable = __webpack_require__(1318);
	var GridFilter = __webpack_require__(1313);
	var GridPagination = __webpack_require__(1315);
	var GridSettings = __webpack_require__(1317);
	var GridNoData = __webpack_require__(1314);
	var GridRow = __webpack_require__(1316);
	var GridRowContainer = __webpack_require__(542);
	var CustomRowComponentContainer = __webpack_require__(1312);
	var CustomPaginationContainer = __webpack_require__(1311);
	var CustomFilterContainer = __webpack_require__(1310);
	var ColumnProperties = __webpack_require__(197);
	var RowProperties = __webpack_require__(543);
	var deep = __webpack_require__(541);
	
	var drop = __webpack_require__(1425);
	var dropRight = __webpack_require__(1426);
	var find = __webpack_require__(368);
	var first = __webpack_require__(1446);
	var forEach = __webpack_require__(574);
	var initial = __webpack_require__(1431);
	var isArray = __webpack_require__(38);
	var isEmpty = __webpack_require__(1432);
	var isNull = __webpack_require__(1434);
	var isUndefined = __webpack_require__(1438);
	var omit = __webpack_require__(1441);
	var map = __webpack_require__(578);
	var extend = __webpack_require__(264);
	var _filter = __webpack_require__(573);
	
	var _orderBy = __webpack_require__(1442);
	var _property = __webpack_require__(579);
	var _get = __webpack_require__(575);
	
	var Griddle = React.createClass({
	    displayName: 'Griddle',
	
	    statics: {
	        GridTable: GridTable,
	        GridFilter: GridFilter,
	        GridPagination: GridPagination,
	        GridSettings: GridSettings,
	        GridRow: GridRow
	    },
	    columnSettings: null,
	    rowSettings: null,
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columns": [],
	            "gridMetadata": null,
	            "columnMetadata": [],
	            "rowMetadata": null,
	            "results": [], // Used if all results are already loaded.
	            "initialSort": "",
	            "gridClassName": "",
	            "tableClassName": "",
	            "customRowComponentClassName": "",
	            "settingsText": "Settings",
	            "filterPlaceholderText": "Filter Results",
	            "nextText": "Next",
	            "previousText": "Previous",
	            "maxRowsText": "Rows per page",
	            "enableCustomFormatText": "Enable Custom Formatting",
	            //this column will determine which column holds subgrid data
	            //it will be passed through with the data object but will not be rendered
	            "childrenColumnName": "children",
	            //Any column in this list will be treated as metadata and will be passed through with the data but won't be rendered
	            "metadataColumns": [],
	            "showFilter": false,
	            "showSettings": false,
	            "useCustomRowComponent": false,
	            "useCustomGridComponent": false,
	            "useCustomPagerComponent": false,
	            "useCustomFilterer": false,
	            "useCustomFilterComponent": false,
	            "useGriddleStyles": true,
	            "useGriddleIcons": true,
	            "customRowComponent": null,
	            "customGridComponent": null,
	            "customPagerComponent": {},
	            "customFilterComponent": null,
	            "customFilterer": null,
	            "globalData": null,
	            "enableToggleCustom": false,
	            "noDataMessage": "There is no data to display.",
	            "noDataClassName": "griddle-nodata",
	            "customNoDataComponent": null,
	            "allowEmptyGrid": false,
	            "showTableHeading": true,
	            "showPager": true,
	            "useFixedHeader": false,
	            "useExternal": false,
	            "externalSetPage": null,
	            "externalChangeSort": null,
	            "externalSetFilter": null,
	            "externalSetPageSize": null,
	            "externalMaxPage": null,
	            "externalCurrentPage": null,
	            "externalSortColumn": null,
	            "externalSortAscending": true,
	            "externalLoadingComponent": null,
	            "externalIsLoading": false,
	            "enableInfiniteScroll": false,
	            "bodyHeight": null,
	            "paddingHeight": 5,
	            "rowHeight": 25,
	            "infiniteScrollLoadTreshold": 50,
	            "useFixedLayout": true,
	            "isSubGriddle": false,
	            "enableSort": true,
	            "onRowClick": null,
	            /* css class names */
	            "sortAscendingClassName": "sort-ascending",
	            "sortDescendingClassName": "sort-descending",
	            "parentRowCollapsedClassName": "parent-row",
	            "parentRowExpandedClassName": "parent-row expanded",
	            "settingsToggleClassName": "settings",
	            "nextClassName": "griddle-next",
	            "previousClassName": "griddle-previous",
	            "headerStyles": {},
	            /* icon components */
	            "sortAscendingComponent": " ▲",
	            "sortDescendingComponent": " ▼",
	            "sortDefaultComponent": null,
	            "parentRowCollapsedComponent": "▶",
	            "parentRowExpandedComponent": "▼",
	            "settingsIconComponent": "",
	            "nextIconComponent": "",
	            "previousIconComponent": "",
	            "isMultipleSelection": false, //currently does not support subgrids
	            "selectedRowIds": [],
	            "uniqueIdentifier": "id"
	        };
	    },
	    propTypes: {
	        isMultipleSelection: React.PropTypes.bool,
	        selectedRowIds: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.number), React.PropTypes.arrayOf(React.PropTypes.string)]),
	        uniqueIdentifier: React.PropTypes.string
	    },
	    defaultFilter: function defaultFilter(results, filter) {
	        return _filter(results, function (item) {
	            var arr = deep.keys(item);
	            for (var i = 0; i < arr.length; i++) {
	                if ((deep.getAt(item, arr[i]) || "").toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
	                    return true;
	                }
	            }
	            return false;
	        });
	    },
	
	    filterByColumnFilters: function filterByColumnFilters(columnFilters) {
	        var filteredResults = Object.keys(columnFilters).reduce(function (previous, current) {
	            return _filter(previous, function (item) {
	                if (deep.getAt(item, current || "").toString().toLowerCase().indexOf(columnFilters[current].toLowerCase()) >= 0) {
	                    return true;
	                }
	
	                return false;
	            });
	        }, this.props.results);
	
	        var newState = {
	            columnFilters: columnFilters
	        };
	
	        if (columnFilters) {
	            newState.filteredResults = filteredResults;
	            newState.maxPage = this.getMaxPage(newState.filteredResults);
	        } else if (this.state.filter) {
	            newState.filteredResults = this.props.useCustomFilterer ? this.props.customFilterer(this.props.results, filter) : this.defaultFilter(this.props.results, filter);
	        } else {
	            newState.filteredResults = null;
	        }
	
	        this.setState(newState);
	    },
	
	    filterByColumn: function filterByColumn(filter, column) {
	        var columnFilters = this.state.columnFilters;
	
	        //if filter is "" remove it from the columnFilters object
	        if (columnFilters.hasOwnProperty(column) && !filter) {
	            columnFilters = omit(columnFilters, column);
	        } else {
	            var newObject = {};
	            newObject[column] = filter;
	            columnFilters = extend({}, columnFilters, newObject);
	        }
	
	        this.filterByColumnFilters(columnFilters);
	    },
	
	    /* if we have a filter display the max page and results accordingly */
	    setFilter: function setFilter(filter) {
	        if (this.props.useExternal) {
	            this.props.externalSetFilter(filter);
	            return;
	        }
	
	        var that = this,
	            updatedState = {
	            page: 0,
	            filter: filter
	        };
	
	        // Obtain the state results.
	        updatedState.filteredResults = this.props.useCustomFilterer ? this.props.customFilterer(this.props.results, filter) : this.defaultFilter(this.props.results, filter);
	
	        // Update the max page.
	        updatedState.maxPage = that.getMaxPage(updatedState.filteredResults);
	
	        //if filter is null or undefined reset the filter.
	        if (isUndefined(filter) || isNull(filter) || isEmpty(filter)) {
	            updatedState.filter = filter;
	            updatedState.filteredResults = null;
	        }
	
	        // Set the state.
	        that.setState(updatedState);
	
	        this._resetSelectedRows();
	    },
	    setPageSize: function setPageSize(size) {
	        if (this.props.useExternal) {
	            this.props.externalSetPageSize(size);
	            return;
	        }
	
	        //make this better.
	        this.state.resultsPerPage = size;
	        this.setMaxPage();
	    },
	    toggleColumnChooser: function toggleColumnChooser() {
	        this.setState({
	            showColumnChooser: !this.state.showColumnChooser
	        });
	    },
	    isNullOrUndefined: function isNullOrUndefined(value) {
	        return value === undefined || value === null;
	    },
	    shouldUseCustomRowComponent: function shouldUseCustomRowComponent() {
	        return this.isNullOrUndefined(this.state.useCustomRowComponent) ? this.props.useCustomRowComponent : this.state.useCustomRowComponent;
	    },
	    shouldUseCustomGridComponent: function shouldUseCustomGridComponent() {
	        return this.isNullOrUndefined(this.state.useCustomGridComponent) ? this.props.useCustomGridComponent : this.state.useCustomGridComponent;
	    },
	    toggleCustomComponent: function toggleCustomComponent() {
	        if (this.state.customComponentType === "grid") {
	            this.setState({
	                useCustomGridComponent: !this.shouldUseCustomGridComponent()
	            });
	        } else if (this.state.customComponentType === "row") {
	            this.setState({
	                useCustomRowComponent: !this.shouldUseCustomRowComponent()
	            });
	        }
	    },
	    getMaxPage: function getMaxPage(results, totalResults) {
	        if (this.props.useExternal) {
	            return this.props.externalMaxPage;
	        }
	
	        if (!totalResults) {
	            totalResults = (results || this.getCurrentResults()).length;
	        }
	        var maxPage = Math.ceil(totalResults / this.state.resultsPerPage);
	        return maxPage;
	    },
	    setMaxPage: function setMaxPage(results) {
	        var maxPage = this.getMaxPage(results);
	        //re-render if we have new max page value
	        if (this.state.maxPage !== maxPage) {
	            this.setState({ page: 0, maxPage: maxPage, filteredColumns: this.columnSettings.filteredColumns });
	        }
	    },
	    setPage: function setPage(number) {
	        if (this.props.useExternal) {
	            this.props.externalSetPage(number);
	            return;
	        }
	
	        //check page size and move the filteredResults to pageSize * pageNumber
	        if (number * this.state.resultsPerPage <= this.state.resultsPerPage * this.state.maxPage) {
	            var that = this,
	                state = {
	                page: number
	            };
	
	            that.setState(state);
	        }
	
	        //When infinite scrolling is enabled, uncheck the "select all" checkbox, since more unchecked rows will be appended at the end
	        if (this.props.enableInfiniteScroll) {
	            this.setState({
	                isSelectAllChecked: false
	            });
	        } else {
	            //When the paging is done on the server, the previously selected rows on a certain page might not
	            // coincide with the new rows on that exact page page, if moving back and forth. Better reset the selection
	            this._resetSelectedRows();
	        }
	    },
	    setColumns: function setColumns(columns) {
	        this.columnSettings.filteredColumns = isArray(columns) ? columns : [columns];
	
	        this.setState({
	            filteredColumns: this.columnSettings.filteredColumns
	        });
	    },
	    nextPage: function nextPage() {
	        var currentPage = this.getCurrentPage();
	        if (currentPage < this.getCurrentMaxPage() - 1) {
	            this.setPage(currentPage + 1);
	        }
	    },
	    previousPage: function previousPage() {
	        var currentPage = this.getCurrentPage();
	        if (currentPage > 0) {
	            this.setPage(currentPage - 1);
	        }
	    },
	    changeSort: function changeSort(column) {
	        if (this.props.enableSort === false) {
	            return;
	        }
	
	        if (this.props.useExternal) {
	            this.props.externalChangeSort(column, this.props.externalSortColumn === column ? !this.props.externalSortAscending : true);
	            return;
	        }
	        var columnMeta = find(this.props.columnMetadata, { columnName: column }) || {};
	        var sortDirectionCycle = columnMeta.sortDirectionCycle ? columnMeta.sortDirectionCycle : [null, 'asc', 'desc'];
	        var sortDirection = null;
	        // Find the current position in the cycle (or -1).
	        var i = sortDirectionCycle.indexOf(this.state.sortDirection ? this.state.sortDirection : null);
	        // Proceed to the next position in the cycle (or start at the beginning).
	        i = (i + 1) % sortDirectionCycle.length;
	
	        if (sortDirectionCycle[i]) {
	            sortDirection = sortDirectionCycle[i];
	        } else {
	            sortDirection = null;
	        }
	
	        var state = {
	            page: 0,
	            sortColumn: column,
	            sortDirection: sortDirection
	        };
	
	        this.setState(state);
	
	        //When the sorting is done on the server, the previously selected rows might not correspond with the new ones.
	        //Better reset the selection
	        this._resetSelectedRows();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setMaxPage(nextProps.results);
	        if (nextProps.resultsPerPage !== this.props.resultsPerPage) {
	            this.setPageSize(nextProps.resultsPerPage);
	        }
	        //This will updaet the column Metadata
	        this.columnSettings.columnMetadata = nextProps.columnMetadata;
	        if (nextProps.results.length > 0) {
	            var deepKeys = deep.keys(nextProps.results[0]);
	
	            var is_same = this.columnSettings.allColumns.length == deepKeys.length && this.columnSettings.allColumns.every(function (element, index) {
	                return element === deepKeys[index];
	            });
	
	            if (!is_same) {
	                this.columnSettings.allColumns = deepKeys;
	            }
	        } else if (this.columnSettings.allColumns.length > 0) {
	            this.columnSettings.allColumns = [];
	        }
	
	        if (nextProps.columns !== this.columnSettings.filteredColumns) {
	            this.columnSettings.filteredColumns = nextProps.columns;
	        }
	
	        if (nextProps.selectedRowIds) {
	            var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true);
	
	            this.setState({
	                isSelectAllChecked: this._getAreAllRowsChecked(nextProps.selectedRowIds, map(visibleRows, this.props.uniqueIdentifier)),
	                selectedRowIds: nextProps.selectedRowIds
	            });
	        }
	    },
	    getInitialState: function getInitialState() {
	        var state = {
	            maxPage: 0,
	            page: 0,
	            filteredResults: null,
	            filteredColumns: [],
	            filter: "",
	            //this sets the individual column filters
	            columnFilters: {},
	            resultsPerPage: this.props.resultsPerPage || 5,
	            showColumnChooser: false,
	            isSelectAllChecked: false,
	            selectedRowIds: this.props.selectedRowIds
	        };
	        return state;
	    },
	    componentWillMount: function componentWillMount() {
	        this.verifyExternal();
	        this.verifyCustom();
	
	        this.columnSettings = new ColumnProperties(this.props.results.length > 0 ? deep.keys(this.props.results[0]) : [], this.props.columns, this.props.childrenColumnName, this.props.columnMetadata, this.props.metadataColumns);
	
	        this.rowSettings = new RowProperties(this.props.rowMetadata, this.props.useCustomTableRowComponent && this.props.customTableRowComponent ? this.props.customTableRowComponent : GridRow, this.props.useCustomTableRowComponent);
	
	        if (this.props.initialSort) {
	            this.changeSort(this.props.initialSort);
	        }
	        this.setMaxPage();
	
	        //don't like the magic strings
	        if (this.shouldUseCustomGridComponent()) {
	            this.setState({
	                customComponentType: "grid"
	            });
	        } else if (this.shouldUseCustomRowComponent()) {
	            this.setState({
	                customComponentType: "row"
	            });
	        } else {
	            this.setState({
	                filteredColumns: this.columnSettings.filteredColumns
	            });
	        }
	    },
	    //todo: clean these verify methods up
	    verifyExternal: function verifyExternal() {
	        if (this.props.useExternal === true) {
	            //hooray for big ugly nested if
	            if (this.props.externalSetPage === null) {
	                console.error("useExternal is set to true but there is no externalSetPage function specified.");
	            }
	
	            if (this.props.externalChangeSort === null) {
	                console.error("useExternal is set to true but there is no externalChangeSort function specified.");
	            }
	
	            if (this.props.externalSetFilter === null) {
	                console.error("useExternal is set to true but there is no externalSetFilter function specified.");
	            }
	
	            if (this.props.externalSetPageSize === null) {
	                console.error("useExternal is set to true but there is no externalSetPageSize function specified.");
	            }
	
	            if (this.props.externalMaxPage === null) {
	                console.error("useExternal is set to true but externalMaxPage is not set.");
	            }
	
	            if (this.props.externalCurrentPage === null) {
	                console.error("useExternal is set to true but externalCurrentPage is not set. Griddle will not page correctly without that property when using external data.");
	            }
	        }
	    },
	    //TODO: Do this with propTypes
	    verifyCustom: function verifyCustom() {
	        if (this.props.useCustomGridComponent === true && this.props.customGridComponent === null) {
	            console.error("useCustomGridComponent is set to true but no custom component was specified.");
	        }
	        if (this.props.useCustomRowComponent === true && this.props.customRowComponent === null) {
	            console.error("useCustomRowComponent is set to true but no custom component was specified.");
	        }
	        if (this.props.useCustomGridComponent === true && this.props.useCustomRowComponent === true) {
	            console.error("Cannot currently use both customGridComponent and customRowComponent.");
	        }
	        if (this.props.useCustomFilterer === true && this.props.customFilterer === null) {
	            console.error("useCustomFilterer is set to true but no custom filter function was specified.");
	        }
	        if (this.props.useCustomFilterComponent === true && this.props.customFilterComponent === null) {
	            console.error("useCustomFilterComponent is set to true but no customFilterComponent was specified.");
	        }
	    },
	    getDataForRender: function getDataForRender(data, cols, pageList) {
	        var _this = this;
	
	        var that = this;
	
	        // get the correct page size
	        if (this.state.sortColumn !== "") {
	            var column = this.state.sortColumn;
	            var sortColumn = _filter(this.props.columnMetadata, { columnName: column });
	            var customCompareFn;
	            var multiSort = {
	                columns: [],
	                orders: []
	            };
	
	            if (sortColumn.length > 0) {
	                customCompareFn = sortColumn[0].hasOwnProperty("customCompareFn") && sortColumn[0]["customCompareFn"];
	                if (sortColumn[0]["multiSort"]) {
	                    multiSort = sortColumn[0]["multiSort"];
	                }
	            }
	
	            if (this.state.sortDirection) {
	                if (typeof customCompareFn === 'function') {
	                    if (customCompareFn.length === 2) {
	                        data = data.sort(function (a, b) {
	                            return customCompareFn(_get(a, column), _get(b, column));
	                        });
	
	                        if (sortDirection === 'desc') {
	                            data.reverse();
	                        }
	                    } else if (customCompareFn.length === 1) {
	                        data = _orderBy(data, function (item) {
	                            return customCompareFn(_get(item, column));
	                        }, [this.state.sortDirection]);
	                    }
	                } else {
	                    var iteratees = [_property(column)];
	                    var orders = [this.state.sortDirection];
	                    multiSort.columns.forEach(function (col, i) {
	                        iteratees.push(_property(col));
	                        if (multiSort.orders[i] === 'asc' || multiSort.orders[i] === 'desc') {
	                            orders.push(multiSort.orders[i]);
	                        } else {
	                            orders.push(_this.state.sortDirection);
	                        }
	                    });
	
	                    data = _orderBy(data, iteratees, orders);
	                }
	            }
	        }
	
	        var currentPage = this.getCurrentPage();
	
	        if (!this.props.useExternal && pageList && this.state.resultsPerPage * (currentPage + 1) <= this.state.resultsPerPage * this.state.maxPage && currentPage >= 0) {
	            if (this.isInfiniteScrollEnabled()) {
	                // If we're doing infinite scroll, grab all results up to the current page.
	                data = first(data, (currentPage + 1) * this.state.resultsPerPage);
	            } else {
	                //the 'rest' is grabbing the whole array from index on and the 'initial' is getting the first n results
	                var rest = drop(data, currentPage * this.state.resultsPerPage);
	                data = (dropRight || initial)(rest, rest.length - this.state.resultsPerPage);
	            }
	        }
	
	        var meta = this.columnSettings.getMetadataColumns;
	
	        var transformedData = [];
	
	        for (var i = 0; i < data.length; i++) {
	            var mappedData = data[i];
	
	            if (typeof mappedData[that.props.childrenColumnName] !== "undefined" && mappedData[that.props.childrenColumnName].length > 0) {
	                //internally we're going to use children instead of whatever it is so we don't have to pass the custom name around
	                mappedData["children"] = that.getDataForRender(mappedData[that.props.childrenColumnName], cols, false);
	
	                if (that.props.childrenColumnName !== "children") {
	                    delete mappedData[that.props.childrenColumnName];
	                }
	            }
	
	            transformedData.push(mappedData);
	        }
	        return transformedData;
	    },
	    //this is the current results
	    getCurrentResults: function getCurrentResults() {
	        return this.state.filteredResults || this.props.results;
	    },
	    getCurrentPage: function getCurrentPage() {
	        return this.props.externalCurrentPage || this.state.page;
	    },
	    getCurrentSort: function getCurrentSort() {
	        return this.props.useExternal ? this.props.externalSortColumn : this.state.sortColumn;
	    },
	    getCurrentSortAscending: function getCurrentSortAscending() {
	        return this.props.useExternal ? this.props.externalSortAscending : this.state.sortDirection === 'asc';
	    },
	    getCurrentMaxPage: function getCurrentMaxPage() {
	        return this.props.useExternal ? this.props.externalMaxPage : this.state.maxPage;
	    },
	    //This takes the props relating to sort and puts them in one object
	    getSortObject: function getSortObject() {
	        return {
	            enableSort: this.props.enableSort,
	            changeSort: this.changeSort,
	            sortColumn: this.getCurrentSort(),
	            sortAscending: this.getCurrentSortAscending(),
	            sortDirection: this.state.sortDirection,
	            sortAscendingClassName: this.props.sortAscendingClassName,
	            sortDescendingClassName: this.props.sortDescendingClassName,
	            sortAscendingComponent: this.props.sortAscendingComponent,
	            sortDescendingComponent: this.props.sortDescendingComponent,
	            sortDefaultComponent: this.props.sortDefaultComponent
	        };
	    },
	    _toggleSelectAll: function _toggleSelectAll() {
	        var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true),
	            newIsSelectAllChecked = !this.state.isSelectAllChecked,
	            newSelectedRowIds = JSON.parse(JSON.stringify(this.state.selectedRowIds));
	
	        var self = this;
	        forEach(visibleRows, function (row) {
	            self._updateSelectedRowIds(row[self.props.uniqueIdentifier], newSelectedRowIds, newIsSelectAllChecked);
	        }, this);
	
	        this.setState({
	            isSelectAllChecked: newIsSelectAllChecked,
	            selectedRowIds: newSelectedRowIds
	        });
	    },
	    _toggleSelectRow: function _toggleSelectRow(row, isChecked) {
	
	        var visibleRows = this.getDataForRender(this.getCurrentResults(), this.columnSettings.getColumns(), true),
	            newSelectedRowIds = JSON.parse(JSON.stringify(this.state.selectedRowIds));
	
	        this._updateSelectedRowIds(row[this.props.uniqueIdentifier], newSelectedRowIds, isChecked);
	
	        this.setState({
	            isSelectAllChecked: this._getAreAllRowsChecked(newSelectedRowIds, map(visibleRows, this.props.uniqueIdentifier)),
	            selectedRowIds: newSelectedRowIds
	        });
	    },
	    _updateSelectedRowIds: function _updateSelectedRowIds(id, selectedRowIds, isChecked) {
	
	        var isFound;
	
	        if (isChecked) {
	            isFound = find(selectedRowIds, function (item) {
	                return id === item;
	            });
	
	            if (isFound === undefined) {
	                selectedRowIds.push(id);
	            }
	        } else {
	            selectedRowIds.splice(selectedRowIds.indexOf(id), 1);
	        }
	    },
	    _getIsSelectAllChecked: function _getIsSelectAllChecked() {
	
	        return this.state.isSelectAllChecked;
	    },
	    _getAreAllRowsChecked: function _getAreAllRowsChecked(selectedRowIds, visibleRowIds) {
	
	        var i, isFound;
	
	        if (selectedRowIds.length !== visibleRowIds.length) {
	            return false;
	        }
	
	        for (i = 0; i < selectedRowIds.length; i++) {
	            isFound = find(visibleRowIds, function (visibleRowId) {
	                return selectedRowIds[i] === visibleRowId;
	            });
	
	            if (isFound === undefined) {
	                return false;
	            }
	        }
	
	        return true;
	    },
	    _getIsRowChecked: function _getIsRowChecked(row) {
	
	        return this.state.selectedRowIds.indexOf(row[this.props.uniqueIdentifier]) > -1 ? true : false;
	    },
	    getSelectedRowIds: function getSelectedRowIds() {
	
	        return this.state.selectedRowIds;
	    },
	    _resetSelectedRows: function _resetSelectedRows() {
	
	        this.setState({
	            isSelectAllChecked: false,
	            selectedRowIds: []
	        });
	    },
	    //This takes the props relating to multiple selection and puts them in one object
	    getMultipleSelectionObject: function getMultipleSelectionObject() {
	
	        return {
	            isMultipleSelection: find(this.props.results, function (result) {
	                return 'children' in result;
	            }) ? false : this.props.isMultipleSelection, //does not support subgrids
	            toggleSelectAll: this._toggleSelectAll,
	            getIsSelectAllChecked: this._getIsSelectAllChecked,
	
	            toggleSelectRow: this._toggleSelectRow,
	            getSelectedRowIds: this.getSelectedRowIds,
	            getIsRowChecked: this._getIsRowChecked
	        };
	    },
	    isInfiniteScrollEnabled: function isInfiniteScrollEnabled() {
	        // If a custom pager is included, don't allow for infinite scrolling.
	        if (this.props.useCustomPagerComponent) {
	            return false;
	        }
	
	        // Otherwise, send back the property.
	        return this.props.enableInfiniteScroll;
	    },
	    getClearFixStyles: function getClearFixStyles() {
	        return {
	            clear: "both",
	            display: "table",
	            width: "100%"
	        };
	    },
	    getSettingsStyles: function getSettingsStyles() {
	        return {
	            "float": "left",
	            width: "50%",
	            textAlign: "right"
	        };
	    },
	    getFilterStyles: function getFilterStyles() {
	        return {
	            "float": "left",
	            width: "50%",
	            textAlign: "left",
	            color: "#222",
	            minHeight: "1px"
	        };
	    },
	    getFilter: function getFilter() {
	        return this.props.showFilter && this.shouldUseCustomGridComponent() === false ? this.props.useCustomFilterComponent ? React.createElement(CustomFilterContainer, { changeFilter: this.setFilter, placeholderText: this.props.filterPlaceholderText, customFilterComponent: this.props.customFilterComponent, results: this.props.results, currentResults: this.getCurrentResults() }) : React.createElement(GridFilter, { changeFilter: this.setFilter, placeholderText: this.props.filterPlaceholderText }) : "";
	    },
	    getSettings: function getSettings() {
	        return this.props.showSettings ? React.createElement('button', { type: 'button', className: this.props.settingsToggleClassName, onClick: this.toggleColumnChooser,
	            style: this.props.useGriddleStyles ? { background: "none", border: "none", padding: 0, margin: 0, fontSize: 14 } : null }, this.props.settingsText, this.props.settingsIconComponent) : "";
	    },
	    getTopSection: function getTopSection(filter, settings) {
	        if (this.props.showFilter === false && this.props.showSettings === false) {
	            return "";
	        }
	
	        var filterStyles = null,
	            settingsStyles = null,
	            topContainerStyles = null;
	
	        if (this.props.useGriddleStyles) {
	            filterStyles = this.getFilterStyles();
	            settingsStyles = this.getSettingsStyles();
	
	            topContainerStyles = this.getClearFixStyles();
	        }
	
	        return React.createElement('div', { className: 'top-section', style: topContainerStyles }, React.createElement('div', { className: 'griddle-filter', style: filterStyles }, filter), React.createElement('div', { className: 'griddle-settings-toggle', style: settingsStyles }, settings));
	    },
	    getPagingSection: function getPagingSection(currentPage, maxPage) {
	        if ((this.props.showPager && !this.isInfiniteScrollEnabled() && !this.shouldUseCustomGridComponent()) === false) {
	            return undefined;
	        }
	
	        return React.createElement('div', { className: 'griddle-footer' }, this.props.useCustomPagerComponent ? React.createElement(CustomPaginationContainer, { next: this.nextPage, previous: this.previousPage, currentPage: currentPage, maxPage: maxPage, setPage: this.setPage, nextText: this.props.nextText, previousText: this.props.previousText, customPagerComponent: this.props.customPagerComponent }) : React.createElement(GridPagination, { useGriddleStyles: this.props.useGriddleStyles, next: this.nextPage, previous: this.previousPage, nextClassName: this.props.nextClassName, nextIconComponent: this.props.nextIconComponent, previousClassName: this.props.previousClassName, previousIconComponent: this.props.previousIconComponent, currentPage: currentPage, maxPage: maxPage, setPage: this.setPage, nextText: this.props.nextText, previousText: this.props.previousText }));
	    },
	    getColumnSelectorSection: function getColumnSelectorSection(keys, cols) {
	        return this.state.showColumnChooser ? React.createElement(GridSettings, { columns: keys, selectedColumns: cols, setColumns: this.setColumns, settingsText: this.props.settingsText,
	            settingsIconComponent: this.props.settingsIconComponent, maxRowsText: this.props.maxRowsText, setPageSize: this.setPageSize,
	            showSetPageSize: !this.shouldUseCustomGridComponent(), resultsPerPage: this.state.resultsPerPage, enableToggleCustom: this.props.enableToggleCustom,
	            toggleCustomComponent: this.toggleCustomComponent, useCustomComponent: this.shouldUseCustomRowComponent() || this.shouldUseCustomGridComponent(),
	            useGriddleStyles: this.props.useGriddleStyles, enableCustomFormatText: this.props.enableCustomFormatText, columnMetadata: this.props.columnMetadata }) : "";
	    },
	    getCustomGridSection: function getCustomGridSection() {
	        return React.createElement(this.props.customGridComponent, _extends({ data: this.props.results, className: this.props.customGridComponentClassName }, this.props.gridMetadata));
	    },
	    getCustomRowSection: function getCustomRowSection(data, cols, meta, pagingContent, globalData) {
	        return React.createElement('div', null, React.createElement(CustomRowComponentContainer, { data: data, columns: cols, metadataColumns: meta, globalData: globalData,
	            className: this.props.customRowComponentClassName, customComponent: this.props.customRowComponent,
	            style: this.props.useGriddleStyles ? this.getClearFixStyles() : null }), this.props.showPager && pagingContent);
	    },
	    getStandardGridSection: function getStandardGridSection(data, cols, meta, pagingContent, hasMorePages) {
	        var sortProperties = this.getSortObject();
	        var multipleSelectionProperties = this.getMultipleSelectionObject();
	
	        // no data section
	        var showNoData = this.shouldShowNoDataSection(data);
	        var noDataSection = this.getNoDataSection();
	
	        return React.createElement('div', { className: 'griddle-body' }, React.createElement(GridTable, { useGriddleStyles: this.props.useGriddleStyles,
	            noDataSection: noDataSection,
	            showNoData: showNoData,
	            columnSettings: this.columnSettings,
	            rowSettings: this.rowSettings,
	            sortSettings: sortProperties,
	            multipleSelectionSettings: multipleSelectionProperties,
	            filterByColumn: this.filterByColumn,
	            isSubGriddle: this.props.isSubGriddle,
	            useGriddleIcons: this.props.useGriddleIcons,
	            useFixedLayout: this.props.useFixedLayout,
	            showPager: this.props.showPager,
	            pagingContent: pagingContent,
	            data: data,
	            className: this.props.tableClassName,
	            enableInfiniteScroll: this.isInfiniteScrollEnabled(),
	            nextPage: this.nextPage,
	            showTableHeading: this.props.showTableHeading,
	            useFixedHeader: this.props.useFixedHeader,
	            parentRowCollapsedClassName: this.props.parentRowCollapsedClassName,
	            parentRowExpandedClassName: this.props.parentRowExpandedClassName,
	            parentRowCollapsedComponent: this.props.parentRowCollapsedComponent,
	            parentRowExpandedComponent: this.props.parentRowExpandedComponent,
	            bodyHeight: this.props.bodyHeight,
	            paddingHeight: this.props.paddingHeight,
	            rowHeight: this.props.rowHeight,
	            infiniteScrollLoadTreshold: this.props.infiniteScrollLoadTreshold,
	            externalLoadingComponent: this.props.externalLoadingComponent,
	            externalIsLoading: this.props.externalIsLoading,
	            hasMorePages: hasMorePages,
	            onRowClick: this.props.onRowClick }));
	    },
	    getContentSection: function getContentSection(data, cols, meta, pagingContent, hasMorePages, globalData) {
	        if (this.shouldUseCustomGridComponent() && this.props.customGridComponent !== null) {
	            return this.getCustomGridSection();
	        } else if (this.shouldUseCustomRowComponent()) {
	            return this.getCustomRowSection(data, cols, meta, pagingContent, globalData);
	        } else {
	            return this.getStandardGridSection(data, cols, meta, pagingContent, hasMorePages);
	        }
	    },
	    getNoDataSection: function getNoDataSection() {
	        if (this.props.customNoDataComponent != null) {
	            return React.createElement('div', { className: this.props.noDataClassName }, React.createElement(this.props.customNoDataComponent, null));
	        }
	        return React.createElement(GridNoData, { noDataMessage: this.props.noDataMessage });
	    },
	    shouldShowNoDataSection: function shouldShowNoDataSection(results) {
	        if (this.props.allowEmptyGrid) {
	            return false;
	        }
	
	        return this.props.useExternal === false && (typeof results === 'undefined' || results.length === 0) || this.props.useExternal === true && this.props.externalIsLoading === false && results.length === 0;
	    },
	    render: function render() {
	        var that = this,
	            results = this.getCurrentResults(); // Attempt to assign to the filtered results, if we have any.
	
	        var headerTableClassName = this.props.tableClassName + " table-header";
	
	        //figure out if we want to show the filter section
	        var filter = this.getFilter();
	        var settings = this.getSettings();
	
	        //if we have neither filter or settings don't need to render this stuff
	        var topSection = this.getTopSection(filter, settings);
	
	        var keys = [];
	        var cols = this.columnSettings.getColumns();
	        //figure out which columns are displayed and show only those
	        var data = this.getDataForRender(results, cols, true);
	
	        var meta = this.columnSettings.getMetadataColumns();
	
	        // Grab the column keys from the first results
	        keys = deep.keys(omit(results[0], meta));
	
	        // sort keys by order
	        keys = this.columnSettings.orderColumns(keys);
	
	        // Grab the current and max page values.
	        var currentPage = this.getCurrentPage();
	        var maxPage = this.getCurrentMaxPage();
	
	        // Determine if we need to enable infinite scrolling on the table.
	        var hasMorePages = currentPage + 1 < maxPage;
	
	        // Grab the paging content if it's to be displayed
	        var pagingContent = this.getPagingSection(currentPage, maxPage);
	
	        var resultContent = this.getContentSection(data, cols, meta, pagingContent, hasMorePages, this.props.globalData);
	
	        var columnSelector = this.getColumnSelectorSection(keys, cols);
	
	        var gridClassName = this.props.gridClassName.length > 0 ? "griddle " + this.props.gridClassName : "griddle";
	        //add custom to the class name so we can style it differently
	        gridClassName += this.shouldUseCustomRowComponent() ? " griddle-custom" : "";
	
	        return React.createElement('div', { className: gridClassName }, topSection, columnSelector, React.createElement('div', { className: 'griddle-container', style: this.props.useGriddleStyles && !this.props.isSubGriddle ? { border: "1px solid #DDD" } : null }, resultContent));
	    }
	});
	
	GridRowContainer.Griddle = module.exports = Griddle;


/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ENTITIES_LISTINGS = exports.SET_ENTITIES_LISTINGS = 'SET_ENTITIES_LISTINGS';
	var ADD_ENTITY_LISTING_GRAPHIC = exports.ADD_ENTITY_LISTING_GRAPHIC = 'ADD_ENTITY_LISTING_GRAPHIC';
	var REMOVE_ENTITY_LISTING_GRAPHIC = exports.REMOVE_ENTITY_LISTING_GRAPHIC = 'REMOVE_ENTITY_LISTING_GRAPHIC';
	var SET_ENTITIES_SUPPLIERS = exports.SET_ENTITIES_SUPPLIERS = 'SET_ENTITIES_SUPPLIERS';
	var UPDATE_ENTITY = exports.UPDATE_ENTITY = 'UPDATE_ENTITY';
	var SET_ENTITIES = exports.SET_ENTITIES = 'SET_ENTITIES';
	var ADD_ENTITY_LISTING_CUSTOM_ITEM = exports.ADD_ENTITY_LISTING_CUSTOM_ITEM = 'ADD_ENTITY_LISTING_CUSTOM_ITEM';
	var REMOVE_ENTITY = exports.REMOVE_ENTITY = 'REMOVE_ENTITY';
	var ADD_ENTITY = exports.ADD_ENTITY = 'ADD_ENTITY';
	var SET_PRIVATE_ENTITIES_LISTINGS = exports.SET_PRIVATE_ENTITIES_LISTINGS = "SET_PRIVATE_ENTITIES_LISTINGS";
	var ADD_PRIVATE_ENTITIES_LISTINGS = exports.ADD_PRIVATE_ENTITIES_LISTINGS = "ADD_PRIVATE_ENTITIES_LISTINGS";
	var ADD_PRIVATE_ENTITY = exports.ADD_PRIVATE_ENTITY = "ADD_PRIVATE_ENTITY";
	var UPDATE_PRIVATE_ENTITY = exports.UPDATE_PRIVATE_ENTITY = "UPDATE_PRIVATE_ENTITY";
	var CLEAR_PRIVATE_ENTITIES_LISTINGS = exports.CLEAR_PRIVATE_ENTITIES_LISTINGS = "CLEAR_PRIVATE_ENTITIES_LISTINGS";

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.importVoucher = exports.SET_VOUCHER_COUPONS = exports.SET_VOUCHERS_FILTERS = exports.REMOVE_ASSOCIATED_PRODUCTS = exports.SET_ASSOCIATED_PRODUCTS = exports.SET_VOUCHERS = exports.REMOVE_VOUCHER = undefined;
	exports.getVouchers = getVouchers;
	exports.getAssociateProducts = getAssociateProducts;
	exports.removeAssociateProduct = removeAssociateProduct;
	exports.getVoucher = getVoucher;
	exports.updateVoucher = updateVoucher;
	exports.createVoucher = createVoucher;
	exports.removeVoucher = removeVoucher;
	exports.updateVoucherFilters = updateVoucherFilters;
	exports.getVoucherCoupons = getVoucherCoupons;
	exports.createVoucherCoupons = createVoucherCoupons;
	exports.cancelVoucherCoupons = cancelVoucherCoupons;
	exports.deleteVoucherCoupon = deleteVoucherCoupon;
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _voucherService = __webpack_require__(497);
	
	var _voucherService2 = _interopRequireDefault(_voucherService);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var REMOVE_VOUCHER = exports.REMOVE_VOUCHER = 'REMOVE_VOUCHER';
	var SET_VOUCHERS = exports.SET_VOUCHERS = 'SET_VOUCHERS';
	var SET_ASSOCIATED_PRODUCTS = exports.SET_ASSOCIATED_PRODUCTS = 'SET_ASSOCIATED_PRODUCTS';
	var REMOVE_ASSOCIATED_PRODUCTS = exports.REMOVE_ASSOCIATED_PRODUCTS = 'REMOVE_ASSOCIATED_PRODUCTS';
	
	var SET_VOUCHERS_FILTERS = exports.SET_VOUCHERS_FILTERS = 'SET_VOUCHERS_FILTERS';
	var SET_VOUCHER_COUPONS = exports.SET_VOUCHER_COUPONS = 'SET_VOUCHER_COUPONS';
	
	function getVouchers(storeId, page, count, orderBy) {
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.getList(storeId, page, count, orderBy, filters),
	    actions: {
	      type: 'SET_VOUCHERS'
	    }
	  });
	}
	
	function getAssociateProducts(storeId, productsId) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.getAssociateProducts(storeId, productsId),
	    actions: {
	      type: SET_ASSOCIATED_PRODUCTS
	    }
	  });
	}
	
	function removeAssociateProduct(productId) {
	  return {
	    type: REMOVE_ASSOCIATED_PRODUCTS,
	    id: productId
	  };
	}
	
	function getVoucher(storeId, discountId) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.getItem(storeId, discountId),
	    actions: [{
	      type: 'SET_VOUCHERS'
	    }, {
	      type: SET_ASSOCIATED_PRODUCTS
	    }]
	  });
	}
	
	function updateVoucher(storeId, discountId, voucher) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.updateItem(storeId, discountId, voucher),
	    actions: [{
	      type: 'SET_VOUCHERS'
	    }]
	  });
	}
	
	function createVoucher(storeId, voucher) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.createItem(storeId, voucher),
	    actions: {
	      type: 'SET_VOUCHERS'
	    }
	  });
	}
	
	function removeVoucher(storeId, discountId) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.removeItem(storeId, discountId),
	    actions: [{
	      type: REMOVE_VOUCHER,
	      id: discountId
	    }, {
	      type: _entityActions.REMOVE_ENTITY,
	      collection: 'vouchers',
	      id: discountId
	
	    }]
	  });
	}
	
	function updateVoucherFilters() {
	  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return {
	    type: SET_VOUCHERS_FILTERS,
	    data: filters
	  };
	}
	
	function getVoucherCoupons(storeId, discountId, page, perPage) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.getCoupons(storeId, discountId, page, perPage),
	    actions: {
	      type: 'SET_VOUCHER_COUPONS'
	    }
	  });
	}
	
	function createVoucherCoupons(storeId, discountId, data) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.putCoupons(storeId, discountId, data),
	    actions: {
	      type: 'SET_ENTITIES',
	      collection: 'vouchers'
	    }
	  });
	}
	
	function cancelVoucherCoupons(storeId, discountId, id) {
	  var coupon = { id: id, canceled: true };
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.putCoupons(storeId, discountId, coupon),
	    actions: {
	      type: 'SET_ENTITIES',
	      collection: 'vouchers'
	    }
	  });
	}
	
	function deleteVoucherCoupon(storeId, discountId, id) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _voucherService2.default.deleteCoupon(storeId, discountId, id),
	    actions: {
	      type: 'SET_ENTITIES',
	      collection: 'vouchers'
	    }
	  });
	}
	
	var importVoucher = exports.importVoucher = function importVoucher(storeId, discountId, csv) {
	  return function (dispatch) {
	    dispatch(_voucherService2.default.importCoupons(storeId, discountId, csv)).then(function (resp) {
	      var coupon_import = resp.data.coupon_import;
	
	      if (!coupon_import) {
	        return { error: new Error('Invalid response') };
	      } else {
	        return { data: coupon_import };
	      }
	    }).catch(function (e) {
	      return { error: e };
	    });
	  };
	};

/***/ },
/* 60 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(193);
	var createDesc = __webpack_require__(128);
	var toIObject = __webpack_require__(63);
	var toPrimitive = __webpack_require__(80);
	var has = __webpack_require__(60);
	var IE8_DOM_DEFINE = __webpack_require__(508);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(60);
	var toObject = __webpack_require__(36);
	var IE_PROTO = __webpack_require__(346)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(192);
	var defined = __webpack_require__(78);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.arrayOf = arrayOf;
	exports.valuesOf = valuesOf;
	exports.unionOf = unionOf;
	exports.normalize = normalize;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EntitySchema = __webpack_require__(1582);
	
	var _EntitySchema2 = _interopRequireDefault(_EntitySchema);
	
	var _IterableSchema = __webpack_require__(1583);
	
	var _IterableSchema2 = _interopRequireDefault(_IterableSchema);
	
	var _UnionSchema = __webpack_require__(639);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	var _lodashIsObject = __webpack_require__(51);
	
	var _lodashIsObject2 = _interopRequireDefault(_lodashIsObject);
	
	var _lodashIsEqual = __webpack_require__(1566);
	
	var _lodashIsEqual2 = _interopRequireDefault(_lodashIsEqual);
	
	var _lodashMapValues = __webpack_require__(1570);
	
	var _lodashMapValues2 = _interopRequireDefault(_lodashMapValues);
	
	function defaultAssignEntity(normalized, key, entity) {
	  normalized[key] = entity;
	}
	
	function visitObject(obj, schema, bag, options) {
	  var _options$assignEntity = options.assignEntity;
	  var assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;
	
	  var normalized = {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      var entity = visit(obj[key], schema[key], bag, options);
	      assignEntity.call(null, normalized, key, entity);
	    }
	  }
	  return normalized;
	}
	
	function defaultMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj) {
	    return visit(obj, itemSchema, bag, options);
	  };
	}
	
	function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj) {
	    var schemaKey = iterableSchema.getSchemaKey(obj);
	    var result = visit(obj, itemSchema[schemaKey], bag, options);
	    return { id: result, schema: schemaKey };
	  };
	}
	
	function visitIterable(obj, iterableSchema, bag, options) {
	  var itemSchema = iterableSchema.getItemSchema();
	  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);
	
	  if (Array.isArray(obj)) {
	    return obj.map(curriedItemMapper);
	  } else {
	    return _lodashMapValues2['default'](obj, curriedItemMapper);
	  }
	}
	
	function visitUnion(obj, unionSchema, bag, options) {
	  var itemSchema = unionSchema.getItemSchema();
	  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
	}
	
	function defaultMergeIntoEntity(entityA, entityB, entityKey) {
	  for (var key in entityB) {
	    if (!entityB.hasOwnProperty(key)) {
	      continue;
	    }
	
	    if (!entityA.hasOwnProperty(key) || _lodashIsEqual2['default'](entityA[key], entityB[key])) {
	      entityA[key] = entityB[key];
	      continue;
	    }
	
	    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
	  }
	}
	
	function visitEntity(entity, entitySchema, bag, options) {
	  var _options$mergeIntoEntity = options.mergeIntoEntity;
	  var mergeIntoEntity = _options$mergeIntoEntity === undefined ? defaultMergeIntoEntity : _options$mergeIntoEntity;
	
	  var entityKey = entitySchema.getKey();
	  var id = entitySchema.getId(entity);
	
	  if (!bag.hasOwnProperty(entityKey)) {
	    bag[entityKey] = {};
	  }
	
	  if (!bag[entityKey].hasOwnProperty(id)) {
	    bag[entityKey][id] = {};
	  }
	
	  var stored = bag[entityKey][id];
	  var normalized = visitObject(entity, entitySchema, bag, options);
	  mergeIntoEntity(stored, normalized, entityKey);
	
	  return id;
	}
	
	function visit(obj, schema, bag, options) {
	  if (!_lodashIsObject2['default'](obj) || !_lodashIsObject2['default'](schema)) {
	    return obj;
	  }
	
	  if (schema instanceof _EntitySchema2['default']) {
	    return visitEntity(obj, schema, bag, options);
	  } else if (schema instanceof _IterableSchema2['default']) {
	    return visitIterable(obj, schema, bag, options);
	  } else if (schema instanceof _UnionSchema2['default']) {
	    return visitUnion(obj, schema, bag, options);
	  } else {
	    return visitObject(obj, schema, bag, options);
	  }
	}
	
	function arrayOf(schema, options) {
	  return new _IterableSchema2['default'](schema, options);
	}
	
	function valuesOf(schema, options) {
	  return new _IterableSchema2['default'](schema, options);
	}
	
	function unionOf(schema, options) {
	  return new _UnionSchema2['default'](schema, options);
	}
	
	exports.Schema = _EntitySchema2['default'];
	
	function normalize(obj, schema) {
	  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  if (!_lodashIsObject2['default'](obj) && !Array.isArray(obj)) {
	    throw new Error('Normalize accepts an object or an array as its input.');
	  }
	
	  if (!_lodashIsObject2['default'](schema) || Array.isArray(schema)) {
	    throw new Error('Normalize accepts an object for schema.');
	  }
	
	  var bag = {};
	  var result = visit(obj, schema, bag, options);
	
	  return {
	    entities: bag,
	    result: result
	  };
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1675);
	


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GridFooter = exports.GridBody = exports.Grid = undefined;
	
	var _grid = __webpack_require__(783);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_grid).default;
	  }
	});
	
	var _gridBody = __webpack_require__(473);
	
	Object.defineProperty(exports, 'GridBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gridBody).default;
	  }
	});
	
	var _gridFooter = __webpack_require__(315);
	
	Object.defineProperty(exports, 'GridFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gridFooter).default;
	  }
	});
	
	__webpack_require__(1239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 67 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(49);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(16);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 71 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1504),
	    baseMatchesProperty = __webpack_require__(1505),
	    identity = __webpack_require__(636),
	    isArray = __webpack_require__(32),
	    property = __webpack_require__(1574);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  var type = typeof value;
	  if (type == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 73 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	tslib_1.__exportStar(__webpack_require__(47), exports);
	tslib_1.__exportStar(__webpack_require__(719), exports);
	tslib_1.__exportStar(__webpack_require__(432), exports);
	tslib_1.__exportStar(__webpack_require__(88), exports);
	tslib_1.__exportStar(__webpack_require__(147), exports);
	tslib_1.__exportStar(__webpack_require__(433), exports);
	var classes = __webpack_require__(8);
	var keys = __webpack_require__(103);
	var utils = __webpack_require__(21);
	exports.Classes = classes;
	exports.Keys = keys;
	exports.Utils = utils;
	// NOTE: Errors is not exported in public API
	var iconClasses_1 = __webpack_require__(755);
	exports.IconClasses = iconClasses_1.IconClasses;
	var iconStrings_1 = __webpack_require__(756);
	exports.IconContents = iconStrings_1.IconContents;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputBox = (_temp = _class = function (_Component) {
	  _inherits(InputBox, _Component);
	
	  function InputBox() {
	    _classCallCheck(this, InputBox);
	
	    return _possibleConstructorReturn(this, (InputBox.__proto__ || Object.getPrototypeOf(InputBox)).apply(this, arguments));
	  }
	
	  _createClass(InputBox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          failure = _props.failure,
	          success = _props.success,
	          containerClass = _props.containerClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-box ' + containerClass },
	        title != false && _react2.default.createElement(
	          'p',
	          { className: 'input-box__title' },
	          title
	        ),
	        _react2.default.createElement('input', _extends({ className: (0, _classnames2.default)('input-box__input', { '_failure': failure }) }, this.props)),
	        success && _react2.default.createElement('i', { className: 'fa fa-check input-box__status _success' }),
	        failure && _react2.default.createElement(
	          'span',
	          { className: 'input-box__status _failure' },
	          'failed'
	        )
	      );
	    }
	  }]);
	
	  return InputBox;
	}(_react.Component), _class.propTypes = {
	  title: _propTypes2.default.string,
	  containerClass: _propTypes2.default.string,
	  success: _propTypes2.default.bool,
	  failure: _propTypes2.default.bool
	}, _class.defaultProps = {
	  onChange: function onChange() {},
	  containerClass: ''
	}, _temp);
	exports.default = InputBox;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(69);
	var IObject = __webpack_require__(192);
	var toObject = __webpack_require__(36);
	var toLength = __webpack_require__(23);
	var asc = __webpack_require__(330);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3);
	var core = __webpack_require__(68);
	var fails = __webpack_require__(16);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(18);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(562);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(267),
	    isLength = __webpack_require__(369);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 84 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(207);
	var compressions = __webpack_require__(378);
	var nodeBuffer = __webpack_require__(379);
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer, mimeType) {
	    exports.checkSupport("blob");
		mimeType = mimeType || 'application/zip';
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: mimeType
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob(mimeType);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(648);
	var PooledClass = __webpack_require__(144);
	var ReactFeatureFlags = __webpack_require__(654);
	var ReactReconciler = __webpack_require__(173);
	var Transaction = __webpack_require__(291);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Position;
	(function (Position) {
	    Position[Position["TOP_LEFT"] = 0] = "TOP_LEFT";
	    Position[Position["TOP"] = 1] = "TOP";
	    Position[Position["TOP_RIGHT"] = 2] = "TOP_RIGHT";
	    Position[Position["RIGHT_TOP"] = 3] = "RIGHT_TOP";
	    Position[Position["RIGHT"] = 4] = "RIGHT";
	    Position[Position["RIGHT_BOTTOM"] = 5] = "RIGHT_BOTTOM";
	    Position[Position["BOTTOM_RIGHT"] = 6] = "BOTTOM_RIGHT";
	    Position[Position["BOTTOM"] = 7] = "BOTTOM";
	    Position[Position["BOTTOM_LEFT"] = 8] = "BOTTOM_LEFT";
	    Position[Position["LEFT_BOTTOM"] = 9] = "LEFT_BOTTOM";
	    Position[Position["LEFT"] = 10] = "LEFT";
	    Position[Position["LEFT_TOP"] = 11] = "LEFT_TOP";
	})(Position = exports.Position || (exports.Position = {}));
	function isPositionHorizontal(position) {
	    /* istanbul ignore next */
	    return (position === Position.TOP ||
	        position === Position.TOP_LEFT ||
	        position === Position.TOP_RIGHT ||
	        position === Position.BOTTOM ||
	        position === Position.BOTTOM_LEFT ||
	        position === Position.BOTTOM_RIGHT);
	}
	exports.isPositionHorizontal = isPositionHorizontal;
	function isPositionVertical(position) {
	    /* istanbul ignore next */
	    return (position === Position.LEFT ||
	        position === Position.LEFT_TOP ||
	        position === Position.LEFT_BOTTOM ||
	        position === Position.RIGHT ||
	        position === Position.RIGHT_TOP ||
	        position === Position.RIGHT_BOTTOM);
	}
	exports.isPositionVertical = isPositionVertical;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	tslib_1.__exportStar(__webpack_require__(718), exports);
	tslib_1.__exportStar(__webpack_require__(75), exports);
	tslib_1.__exportStar(__webpack_require__(443), exports);


/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alert = alert;
	exports.removeAlert = removeAlert;
	exports.truncateAlert = truncateAlert;
	var ADD_ALERT = exports.ADD_ALERT = 'ADD_ALERT';
	var REMOVE_ALERT = exports.REMOVE_ALERT = 'REMOVE_ALERT';
	var TRUNCATE_ALERT = exports.TRUNCATE_ALERT = 'TRUNCATE_ALERT';
	
	function alert(style, message) {
	  return {
	    type: ADD_ALERT,
	    style: style,
	    message: message
	  };
	}
	
	function removeAlert(message) {
	  return {
	    type: REMOVE_ALERT,
	    message: message
	  };
	}
	
	function truncateAlert() {
	  return {
	    type: TRUNCATE_ALERT
	  };
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalContainer = exports.Modal = exports.ModalBottom = exports.ModalContent = exports.ModalHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp5;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	__webpack_require__(1248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    padding: '0px',
	    border: '0px',
	    transform: 'translate(-50%, -50%)'
	
	  },
	  overlay: {
	    zIndex: 1000,
	    background: 'rgba(0,0,0,.2)',
	    cursor: 'default'
	  }
	};
	
	var ModalHeader = exports.ModalHeader = (_temp = _class = function (_Component) {
	  _inherits(ModalHeader, _Component);
	
	  function ModalHeader() {
	    _classCallCheck(this, ModalHeader);
	
	    return _possibleConstructorReturn(this, (ModalHeader.__proto__ || Object.getPrototypeOf(ModalHeader)).apply(this, arguments));
	  }
	
	  _createClass(ModalHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          onRequestClose = _props.onRequestClose;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal__header' },
	        this.props.children,
	        _react2.default.createElement(
	          'h5',
	          { className: 'modal__title' },
	          title
	        ),
	        onRequestClose && _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'close', onClick: onRequestClose },
	          _react2.default.createElement(
	            'span',
	            null,
	            '\xD7'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalHeader;
	}(_react.Component), _class.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  onRequestClose: _propTypes2.default.func,
	  children: _propTypes2.default.node
	}, _temp);
	var ModalContent = exports.ModalContent = (_temp2 = _class2 = function (_Component2) {
	  _inherits(ModalContent, _Component2);
	
	  function ModalContent() {
	    _classCallCheck(this, ModalContent);
	
	    return _possibleConstructorReturn(this, (ModalContent.__proto__ || Object.getPrototypeOf(ModalContent)).apply(this, arguments));
	  }
	
	  _createClass(ModalContent, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal__content' },
	        children
	      );
	    }
	  }]);
	
	  return ModalContent;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.node.isRequired
	}, _temp2);
	var ModalBottom = exports.ModalBottom = (_temp3 = _class3 = function (_Component3) {
	  _inherits(ModalBottom, _Component3);
	
	  function ModalBottom() {
	    _classCallCheck(this, ModalBottom);
	
	    return _possibleConstructorReturn(this, (ModalBottom.__proto__ || Object.getPrototypeOf(ModalBottom)).apply(this, arguments));
	  }
	
	  _createClass(ModalBottom, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal__bottom' },
	        children
	      );
	    }
	  }]);
	
	  return ModalBottom;
	}(_react.Component), _class3.propTypes = {
	  children: _propTypes2.default.node.isRequired
	}, _temp3);
	var Modal = exports.Modal = (_temp4 = _class4 = function (_Component4) {
	  _inherits(Modal, _Component4);
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	  }
	
	  _createClass(Modal, [{
	    key: 'renderChildren',
	    value: function renderChildren() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          isOpen = _props2.isOpen,
	          _onRequestClose = _props2.onRequestClose,
	          _onAfterOpen = _props2.onAfterOpen;
	
	      var style = this.props.style || {};
	      var contentStyle = Object.assign({}, defaultStyles.content, style.content || {});
	      var overlayStyle = Object.assign({}, defaultStyles.overlay, style.overlay || {});
	      var computedStyle = { content: contentStyle, overlay: overlayStyle };
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        { isOpen: isOpen,
	          onAfterOpen: function onAfterOpen() {
	            return _onAfterOpen ? _onAfterOpen() : null;
	          },
	          onRequestClose: function onRequestClose() {
	            return _onRequestClose ? _onRequestClose() : null;
	          },
	          style: computedStyle },
	        this.renderChildren()
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component), _class4.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  style: _propTypes2.default.object
	}, _temp4);
	var ModalContainer = exports.ModalContainer = (_temp5 = _class5 = function (_Component5) {
	  _inherits(ModalContainer, _Component5);
	
	  function ModalContainer() {
	    _classCallCheck(this, ModalContainer);
	
	    return _possibleConstructorReturn(this, (ModalContainer.__proto__ || Object.getPrototypeOf(ModalContainer)).apply(this, arguments));
	  }
	
	  _createClass(ModalContainer, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: '_modal' },
	        children
	      );
	    }
	  }]);
	
	  return ModalContainer;
	}(_react.Component), _class5.propTypes = {
	  children: _propTypes2.default.node.isRequired
	}, _temp5);

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.permissionAccessor = permissionAccessor;
	exports.getCurrentPermission = getCurrentPermission;
	
	var _bindHelper = __webpack_require__(235);
	
	var _lodash = __webpack_require__(14);
	
	/**
	 * Test whether a ROLE can do ACTION base on the STORE_PERMISSIONS
	 *
	 * @param {string|RegExp} action                            The action want to perform
	 * @param {string|object} store                             The store object or association type string
	 * @param {string}        [store.associate_type]            The association type string
	 * @param {object[]}      [store.store_permissions]         The array of store permission object
	 * @param {boolean}       [store.module.permission_enabled] The indicator of store permission module
	 * @param {object[]}      [storePermissions]                The array of store permission object
	 * @param {boolean}       [permissionEnabled]               The indicator of store permission module
	 *
	 * @return {boolean}
	 *
	 * @example Call with params (action, store)
	 * var canEditInvoice = permissionAccessor('invoice:edit', currentStore);
	 *
	 * @example Call with params (action, associateType, storePermissions, permissionEnabled)
	 * var canEditInvoice = permissionAccessor('invoice:edit', store.associate_type, store.store_permissions, true);
	 *
	 * @example Call with RegExp
	 * // return true for 'invoice:view_only', 'invoice:edit', 'invoice:edit_button', etc.
	 * var canViewInvoice = permissionAccessor(/^invoice:/, currentStore);
	 *
	 * @example Store permission module is disabled
	 * var canEditInvoice = permissionAccessor('invoice:edit', currentStore); // Always true
	 */
	function permissionAccessor(action, associateType, storePermissions, permissionEnabled) {
	  var needCheck = permissionEnabled;
	  var permissions = null;
	
	  // Get role's permission
	  if (typeof associateType === 'string') {
	    permissions = (0, _lodash.find)(storePermissions, { store_role_name: associateType });
	  } else {
	    var store = associateType || {};
	    var r = store.associate_type || store.associateType;
	    var p = store.store_permissions || store.storePermissions || [];
	    var m = store.module || {};
	    var e = m.permission_enabled || m.permissionEnabled;
	    needCheck = e;
	    permissions = p.find(function (d) {
	      return d.store_role_name === r || d.storeRoleName === r;
	    });
	  }
	
	  if (!needCheck) return true;
	
	  if (!permissions) {
	    console.warn('user\'s role not in store permissions');
	    return false;
	  }
	
	  // Exect match with permission object
	  if (typeof action === 'string') {
	    if (typeof permissions.permissions[action] === 'boolean') {
	      return permissions.permissions[action];
	    } else {
	      // Permission not found, assume for super-module prefix search
	      action = RegExp('^' + action + ':');
	    }
	  }
	
	  // RegExp match with permission object
	  if (action instanceof RegExp) {
	    for (var key in permissions.permissions) {
	      if (action.test(key) && permissions.permissions[key]) {
	        return true;
	      }
	    }
	    return false;
	
	    // Unknow permission checking
	  } else {
	    console.warn('unknow data type for permission checking');
	    return false;
	  }
	}
	
	function getCurrentPermission(WrappedComponent) {
	  function accessor(key) {
	    var currentStore = this.context.currentStore;
	
	    return permissionAccessor(key, currentStore);
	  }
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'getCurrentPermission', accessor);
	}

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainContentSection = exports.MainContentFilter = exports.MainContentTabs = exports.MainContentHeaderButtons = exports.MainContentHeader = exports.MainContent = undefined;
	
	var _mainContent = __webpack_require__(190);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _mainContentHeader = __webpack_require__(188);
	
	var _mainContentHeader2 = _interopRequireDefault(_mainContentHeader);
	
	var _mainContentHeaderButtons = __webpack_require__(487);
	
	var _mainContentHeaderButtons2 = _interopRequireDefault(_mainContentHeaderButtons);
	
	var _mainContentTabs = __webpack_require__(238);
	
	var _mainContentTabs2 = _interopRequireDefault(_mainContentTabs);
	
	var _mainContentFilter = __webpack_require__(868);
	
	var _mainContentFilter2 = _interopRequireDefault(_mainContentFilter);
	
	var _mainContentSection = __webpack_require__(189);
	
	var _mainContentSection2 = _interopRequireDefault(_mainContentSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MainContent = _mainContent2.default;
	exports.MainContentHeader = _mainContentHeader2.default;
	exports.MainContentHeaderButtons = _mainContentHeaderButtons2.default;
	exports.MainContentTabs = _mainContentTabs2.default;
	exports.MainContentFilter = _mainContentFilter2.default;
	exports.MainContentSection = _mainContentSection2.default;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HANDLE_PROMISE = undefined;
	
	var _isObject = __webpack_require__(51);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(212);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isArray = __webpack_require__(32);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _promiseHandlers = __webpack_require__(975);
	
	var handlers = _interopRequireWildcard(_promiseHandlers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HANDLE_PROMISE = exports.HANDLE_PROMISE = "HANDLE_PROMISE";
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      // Check if need to handle promise
	      var handlePromise = action && action[HANDLE_PROMISE];
	
	      if (typeof handlePromise === 'undefined') {
	        return next(action);
	      }
	
	      if (!(0, _isObject2.default)(handlePromise) || !(0, _isObject2.default)(handlePromise.promise) || !(0, _isFunction2.default)(handlePromise.promise.then)) {
	        return next(action);
	      }
	
	      // Wrap action
	
	      var promise = handlePromise.promise,
	          actions = handlePromise.actions,
	          settings = _objectWithoutProperties(handlePromise, ['promise', 'actions']);
	
	      var wrappedAction = function wrappedAction(dispatch) {
	        // Register promise handlers
	        var promiseHandlers = [];
	        for (var handler in handlers) {
	          if (handlers.hasOwnProperty(handler)) {
	            promiseHandlers.push(new handlers[handler](dispatch, settings));
	          }
	        }
	
	        promiseHandlers.map(function (handler) {
	          return handler.onBeforePromise();
	        });
	
	        // Handle promise
	        return promise.then(function (data) {
	          //have to update entities first.
	          var state = typeof data.state !== "undefined" ? data.state : null;
	
	          dispatch({ type: 'SET_HANDLE_PROMISE_ENTITIES', data: data.entities });
	
	          // Dispatch actions if specified
	          if (actions) {
	            if ((0, _isArray2.default)(actions)) {
	              for (var i in actions) {
	                var props = _objectWithoutProperties(actions[i], []);
	
	                var opts = Object.assign({}, { data: state }, props, data);
	                dispatch(opts);
	              }
	            } else if ((0, _isObject2.default)(actions)) {
	              var props = _objectWithoutProperties(actions, []);
	
	              var _opts = Object.assign({}, { data: state }, props, data);
	              dispatch(_opts);
	            }
	          }
	
	          promiseHandlers.map(function (handler) {
	            return handler.onAfterPromise();
	          });
	          return data;
	        }).catch(function (err) {
	          promiseHandlers.forEach(function (handler) {
	            return handler.onCatchPromise(err);
	          });
	        });
	      };
	
	      return next(wrappedAction);
	    };
	  };
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(530);
	var $export = __webpack_require__(3);
	var shared = __webpack_require__(252)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(534))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(27)) {
	  var LIBRARY = __webpack_require__(111);
	  var global = __webpack_require__(15);
	  var fails = __webpack_require__(16);
	  var $export = __webpack_require__(3);
	  var $typed = __webpack_require__(254);
	  var $buffer = __webpack_require__(351);
	  var ctx = __webpack_require__(69);
	  var anInstance = __webpack_require__(123);
	  var propertyDesc = __webpack_require__(128);
	  var hide = __webpack_require__(53);
	  var redefineAll = __webpack_require__(129);
	  var toInteger = __webpack_require__(71);
	  var toLength = __webpack_require__(23);
	  var toIndex = __webpack_require__(528);
	  var toAbsoluteIndex = __webpack_require__(131);
	  var toPrimitive = __webpack_require__(80);
	  var has = __webpack_require__(60);
	  var classof = __webpack_require__(156);
	  var isObject = __webpack_require__(18);
	  var toObject = __webpack_require__(36);
	  var isArrayIter = __webpack_require__(337);
	  var create = __webpack_require__(125);
	  var getPrototypeOf = __webpack_require__(62);
	  var gOPN = __webpack_require__(126).f;
	  var getIterFn = __webpack_require__(353);
	  var uid = __webpack_require__(132);
	  var wks = __webpack_require__(22);
	  var createArrayMethod = __webpack_require__(77);
	  var createArrayIncludes = __webpack_require__(241);
	  var speciesConstructor = __webpack_require__(194);
	  var ArrayIterators = __webpack_require__(354);
	  var Iterators = __webpack_require__(157);
	  var $iterDetect = __webpack_require__(246);
	  var setSpecies = __webpack_require__(130);
	  var arrayFill = __webpack_require__(329);
	  var arrayCopyWithin = __webpack_require__(500);
	  var $DP = __webpack_require__(28);
	  var $GOPD = __webpack_require__(61);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(548),
	    baseKeys = __webpack_require__(555),
	    isArrayLike = __webpack_require__(82);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(208),
	    baseFind = __webpack_require__(614),
	    baseFindIndex = __webpack_require__(1497),
	    baseIteratee = __webpack_require__(72),
	    isArray = __webpack_require__(32);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	function find(collection, predicate) {
	  predicate = baseIteratee(predicate, 3);
	  if (isArray(collection)) {
	    var index = baseFindIndex(collection, predicate);
	    return index > -1 ? collection[index] : undefined;
	  }
	  return baseFind(collection, predicate, baseEach);
	}
	
	module.exports = find;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1518),
	    keys = __webpack_require__(141);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(144);
	
	var emptyFunction = __webpack_require__(56);
	var warning = __webpack_require__(13);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	var ReactChildren = __webpack_require__(1729);
	var ReactComponent = __webpack_require__(423);
	var ReactPureComponent = __webpack_require__(1734);
	var ReactClass = __webpack_require__(1730);
	var ReactDOMFactories = __webpack_require__(1731);
	var ReactElement = __webpack_require__(176);
	var ReactPropTypes = __webpack_require__(1733);
	var ReactVersion = __webpack_require__(1738);
	
	var onlyChild = __webpack_require__(692);
	var warning = __webpack_require__(13);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 103 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BACKSPACE = 8;
	exports.TAB = 9;
	exports.ENTER = 13;
	exports.SHIFT = 16;
	exports.ESCAPE = 27;
	exports.SPACE = 32;
	exports.ARROW_LEFT = 37;
	exports.ARROW_UP = 38;
	exports.ARROW_RIGHT = 39;
	exports.ARROW_DOWN = 40;
	exports.DELETE = 46;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var Icon = (function (_super) {
	    tslib_1.__extends(Icon, _super);
	    function Icon() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Icon_1 = Icon;
	    Icon.prototype.render = function () {
	        if (this.props.iconName == null) {
	            return null;
	        }
	        var _a = this.props, className = _a.className, iconName = _a.iconName, intent = _a.intent, _b = _a.iconSize, iconSize = _b === void 0 ? Icon_1.SIZE_STANDARD : _b, restProps = tslib_1.__rest(_a, ["className", "iconName", "intent", "iconSize"]);
	        var classes = classNames(getSizeClass(iconSize), common_1.Classes.iconClass(iconName), common_1.Classes.intentClass(intent), className);
	        return React.createElement("span", tslib_1.__assign({ className: classes }, restProps));
	    };
	    Icon.displayName = "Blueprint.Icon";
	    Icon.SIZE_STANDARD = 16;
	    Icon.SIZE_LARGE = 20;
	    Icon.SIZE_INHERIT = "inherit";
	    Icon = Icon_1 = tslib_1.__decorate([
	        PureRender
	    ], Icon);
	    return Icon;
	    var Icon_1;
	}(React.Component));
	exports.Icon = Icon;
	// NOTE: not using a type alias here so the full union will appear in the interface docs
	function getSizeClass(size) {
	    switch (size) {
	        case Icon.SIZE_STANDARD:
	            return common_1.Classes.ICON_STANDARD;
	        case Icon.SIZE_LARGE:
	            return common_1.Classes.ICON_LARGE;
	        default:
	            return common_1.Classes.ICON;
	    }
	}


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getListingItems = exports.ERROR_UPLOAD_IMAGES = exports.FINISH_UPLOAD_IMAGES = exports.UPLOADING_IMAGES = exports.WAIT_SERVER_UPLOAD_IMAGES = exports.REQUEST_UPLOAD_IMAGES = exports.GET_IMPORTER_STATUS = exports.REQUEST_VALIATATED = exports.REMOVE_LISTING = exports.SET_LISTING_QUANTITYHISTORY = exports.SET_LISTINGS_STATUS = exports.SET_LISTINGS = undefined;
	exports.updateFilters = updateFilters;
	exports.validateImportInventory = validateImportInventory;
	exports.postImportInventory = postImportInventory;
	exports.postImagesToS3 = postImagesToS3;
	exports.postCustomItem = postCustomItem;
	exports.postItem = postItem;
	exports.getImportInventory = getImportInventory;
	exports.getListings = getListings;
	exports.getListingsByUPC = getListingsByUPC;
	exports.getProductByUPC = getProductByUPC;
	exports.getListing = getListing;
	exports.deleteListing = deleteListing;
	exports.updateListing = updateListing;
	exports.getQuantityHistory = getQuantityHistory;
	exports.getProductGraphics = getProductGraphics;
	exports.uploadProductGraphics = uploadProductGraphics;
	exports.deleteProductGraphics = deleteProductGraphics;
	exports.setDefaultProductGraphics = setDefaultProductGraphics;
	exports.getTaxOptions = getTaxOptions;
	
	var _lodash = __webpack_require__(14);
	
	var _normalizr = __webpack_require__(64);
	
	var _humps = __webpack_require__(44);
	
	var _schema = __webpack_require__(109);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _taxOptionsService = __webpack_require__(968);
	
	var _taxOptionsService2 = _interopRequireDefault(_taxOptionsService);
	
	var _entityActions = __webpack_require__(58);
	
	var _baseActions = __webpack_require__(34);
	
	var _alertActions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// LIST
	var SET_LISTINGS = exports.SET_LISTINGS = 'SET_LISTINGS';
	var SET_LISTINGS_STATUS = exports.SET_LISTINGS_STATUS = 'SET_LISTINGS_STATUS';
	var SET_LISTING_QUANTITYHISTORY = exports.SET_LISTING_QUANTITYHISTORY = 'SET_LISTING_QUANTITYHISTORY';
	var REMOVE_LISTING = exports.REMOVE_LISTING = 'REMOVE_LISTING';
	
	var REQUEST_VALIATATED = exports.REQUEST_VALIATATED = 'REQUEST_VALIATATED';
	var GET_IMPORTER_STATUS = exports.GET_IMPORTER_STATUS = 'GET_IMPORTER_STATUS';
	var REQUEST_UPLOAD_IMAGES = exports.REQUEST_UPLOAD_IMAGES = 'REQUEST_UPLOAD_IMAGES';
	
	var WAIT_SERVER_UPLOAD_IMAGES = exports.WAIT_SERVER_UPLOAD_IMAGES = 'WAIT_SERVER_UPLOAD_IMAGES';
	var UPLOADING_IMAGES = exports.UPLOADING_IMAGES = 'UPLOADING_IMAGES';
	var FINISH_UPLOAD_IMAGES = exports.FINISH_UPLOAD_IMAGES = 'FINISH_UPLOAD_IMAGES';
	var ERROR_UPLOAD_IMAGES = exports.ERROR_UPLOAD_IMAGES = 'ERROR_UPLOAD_IMAGES';
	
	function updateFilters() {
	  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var listingStatus = {
	    filters: filters
	  };
	
	  return {
	    type: SET_LISTINGS_STATUS,
	    data: listingStatus
	  };
	}
	
	function validateImportInventory(storeId, file) {
	  return function (dispatch) {
	    return _inventoryService2.default.validateImportInventory(storeId, file).then(function (data) {
	      _inventoryService2.default.getImagesUploadURL(storeId, data.id).then(function (uploaded) {
	        dispatch({ type: REQUEST_VALIATATED, data: data, upload_url: uploaded.upload_url });
	      });
	    });
	  };
	}
	
	function postImportInventory(storeId, id) {
	  return function (dispatch) {
	    return _inventoryService2.default.postImportInventory(storeId, id).then(function (data) {
	      dispatch({ type: REQUEST_VALIATATED, data: data });
	    });
	  };
	}
	
	function postImagesToS3(path, file, store_id, import_id) {
	  return function (dispatch) {
	    var isProgressed = false;
	    //if server response time take too long, xhr progress will fire twice, so we need it here.
	    var progress = function progress(evt) {
	      if (!isProgressed) {
	        var percentComplete = Math.round(evt.loaded * 100 / evt.total);
	
	        var data = {
	          percentComplete: percentComplete
	        };
	
	        if (percentComplete === 100) {
	          dispatch({ type: WAIT_SERVER_UPLOAD_IMAGES, data: data });
	          isProgressed = true;
	        } else {
	          dispatch({ type: UPLOADING_IMAGES, data: data });
	        }
	      }
	    };
	    return _inventoryService2.default.postImagesToS3(path, file, progress).then(function (data) {
	      _inventoryService2.default.postImagesToValidate(store_id, import_id).then(function (data) {
	        dispatch({ type: FINISH_UPLOAD_IMAGES, id: import_id });
	      });
	    }).catch(function (e) {
	      dispatch({ type: ERROR_UPLOAD_IMAGES, data: e });
	    });
	  };
	}
	
	function postCustomItem(storeId, listing) {
	  return function (dispatch) {
	    return _inventoryService2.default.postCustomItem(storeId, listing).then(function (data) {
	      dispatch({ type: _entityActions.ADD_ENTITY_LISTING_CUSTOM_ITEM, data: data });
	      return data[0].listing;
	    });
	  };
	}
	
	function postItem(storeId, listing) {
	  return function (dispatch) {
	    return _inventoryService2.default.postItem(storeId, listing).then(function (data) {
	      dispatch({ type: _entityActions.ADD_ENTITY_LISTING_CUSTOM_ITEM, data: data });
	      return data[0].listing;
	    });
	  };
	}
	
	function getImportInventory(storeId, inventory_import_id) {
	  return function (dispatch) {
	    return _inventoryService2.default.getImportInventory(storeId, inventory_import_id).then(function (data) {
	      if (data.validation_progress_rate === "1.0") {
	        _inventoryService2.default.getImagesUploadURL(storeId, data.id).then(function (uploaded) {
	          data.upload_url = uploaded.upload_url;
	          dispatch({ type: GET_IMPORTER_STATUS, data: data, upload_url: uploaded.upload_url });
	        });
	      } else {
	        dispatch({ type: GET_IMPORTER_STATUS, data: data });
	      }
	    });
	  };
	}
	
	function getListings(storeId, page, count, orderBy) {
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	    dispatch({ type: SET_LISTINGS_STATUS, data: { loading: true } });
	
	    return _inventoryService2.default.getList(storeId, page, count, orderBy, filters).then(function (data) {
	      data.data = (0, _lodash.map)(data.data, function (d) {
	        return d.listing;
	      });
	      var listings = (0, _normalizr.normalize)(data, {
	        data: (0, _normalizr.arrayOf)(_schema.ListingSchema)
	      });
	      var listingStatus = {
	        totalCount: data.totalCount,
	        totalPages: data.totalPages,
	        page: data.page,
	        count: data.count,
	        filters: filters,
	        loading: false
	      };
	
	      dispatch({ type: _entityActions.SET_ENTITIES_LISTINGS, data: listings.entities });
	      dispatch({ type: SET_LISTINGS_STATUS, data: listingStatus });
	      dispatch({ type: SET_LISTINGS, data: listings.result.data });
	      dispatch((0, _baseActions.stopFetch)());
	    }).catch(function (ex) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var listingStatus = {
	        loading: false
	      };
	      dispatch({ type: SET_LISTINGS_STATUS, data: listingStatus });
	    });
	  };
	}
	
	function getListingsByUPC(storeId, page, count, orderBy) {
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  return function (dispatch) {
	    return _inventoryService2.default.getList(storeId, page, count, orderBy, filters);
	  };
	}
	
	function getProductByUPC(upc) {
	  return function (dispatch) {
	    return _inventoryService2.default.getProductByUPC(upc);
	  };
	}
	
	function getListing(storeId, listingId) {
	  return function (dispatch) {
	    return _inventoryService2.default.getItem(storeId, listingId).then(function (data) {
	      var listings = (0, _normalizr.normalize)({ data: [data.listing] }, {
	        data: (0, _normalizr.arrayOf)(_schema.ListingSchema)
	      });
	
	      dispatch({ type: _entityActions.SET_ENTITIES_LISTINGS, data: listings.entities });
	    });
	  };
	}
	
	function deleteListing(storeId, listingId) {
	  return function (dispatch) {
	    return _inventoryService2.default.deleteItem(storeId, listingId).then(function (data) {
	
	      dispatch({ type: REMOVE_LISTING, id: listingId });
	    });
	  };
	}
	
	function updateListing(storeId, listingId, data) {
	  return function (dispatch) {
	    return _inventoryService2.default.updateItem(storeId, listingId, data).then(function (res) {
	      dispatch({
	        type: _entityActions.UPDATE_ENTITY,
	        collection: 'listings',
	        id: listingId,
	        data: data
	      });
	    });
	  };
	}
	
	function getQuantityHistory(storeId, listingId) {
	  return function (dispatch) {
	    return _inventoryService2.default.getQuantityHistory(storeId, listingId).then(function (data) {
	      dispatch({
	        type: _entityActions.UPDATE_ENTITY,
	        collection: 'listings',
	        id: listingId,
	        data: { quantity_histories: data }
	      });
	    });
	  };
	}
	
	function getProductGraphics(listingId, productId) {
	  return function (dispatch) {
	    return _inventoryService2.default.getProductGraphics(productId).then(function (data) {
	      var product_graphics = (0, _lodash.map)(data, 'product_graphic');
	      dispatch({
	        type: _entityActions.UPDATE_ENTITY,
	        collection: 'listings',
	        id: listingId,
	        data: { product_graphics: product_graphics }
	      });
	    });
	  };
	}
	
	function uploadProductGraphics(listingId, productId, files) {
	  return function (dispatch) {
	    files.forEach(function (file) {
	      dispatch((0, _alertActions.alert)('warning', 'Uploading file ' + file.name));
	
	      _inventoryService2.default.uploadProductGraphics(productId, file).then(function (data) {
	        dispatch({
	          type: _entityActions.ADD_ENTITY_LISTING_GRAPHIC,
	          listingId: listingId,
	          graphicData: data.product_graphic
	        });
	
	        dispatch((0, _alertActions.removeAlert)('Uploading file ' + file.name));
	      }).catch(function () {
	        dispatch((0, _alertActions.removeAlert)('Uploading file ' + file.name));
	      });
	    });
	  };
	}
	
	function deleteProductGraphics(listingId, productId, graphicIds) {
	  return function (dispatch) {
	    graphicIds.forEach(function (graphicId) {
	      _inventoryService2.default.deleteProductGraphics(productId, graphicId).then(function (data) {
	        dispatch({
	          type: _entityActions.REMOVE_ENTITY_LISTING_GRAPHIC,
	          listingId: listingId,
	          graphicId: graphicId
	        });
	      });
	    });
	  };
	}
	
	function setDefaultProductGraphics(listingId, productId, graphicId) {
	  return function (dispatch) {
	    return _inventoryService2.default.setDefaultProductGraphics(productId, graphicId);
	  };
	}
	
	function getTaxOptions(storeId, listingId) {
	  return function (dispatch) {
	    return _taxOptionsService2.default.getList(storeId).then(function (res) {
	      var taxOptions = (0, _lodash.map)(res.data, function (d) {
	        return d.tax_option;
	      });
	      var normalizedData = (0, _normalizr.normalize)(taxOptions, (0, _normalizr.arrayOf)(_schema.TaxOptionSchema));
	      dispatch({
	        type: _entityActions.SET_ENTITIES,
	        collection: 'taxOptions',
	        data: normalizedData.entities.taxOptions
	      });
	    });
	  };
	}
	
	var getListingItems = exports.getListingItems = function getListingItems(listingIds, storeId) {
	  return function (dispatch) {
	    return _inventoryService2.default.getItems(storeId, listingIds).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.data.listings;
	      if (Array.isArray(data)) {
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        return { error: error };
	      }
	    }).catch(function (error) {
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1230);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ActionButton(props) {
	  var type = props.type,
	      children = props.children;
	
	  var className = 'btn btn-action-' + type;
	  className += props.defaultTextColor ? ' btn-action--default-text' : '';
	  return _react2.default.createElement(
	    'button',
	    _extends({}, props, { className: className, type: 'button' }),
	    children
	  );
	}
	
	ActionButton.propTypes = {
	  type: _propTypes2.default.oneOf(['add', 'delete']),
	  defaultTextColor: _propTypes2.default.bool,
	  children: _propTypes2.default.node
	};
	
	exports.default = ActionButton;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1236);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _cascadeFilter = __webpack_require__(775);
	
	var _cascadeFilter2 = _interopRequireDefault(_cascadeFilter);
	
	var _savedFilter = __webpack_require__(776);
	
	var _savedFilter2 = _interopRequireDefault(_savedFilter);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CascadeFilterCollection = (_temp2 = _class = function (_Component) {
	  _inherits(CascadeFilterCollection, _Component);
	
	  function CascadeFilterCollection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CascadeFilterCollection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CascadeFilterCollection.__proto__ || Object.getPrototypeOf(CascadeFilterCollection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      filters: _this.props.filters || []
	    }, _this.onFilterSelected = function (filters) {
	      _this.setState({ filters: [] });
	      _this.setState({ filters: filters });
	    }, _this.addNewFilter = function () {
	      var filters = _this.state.filters;
	      filters.push({
	        id: (0, _uniqueId2.default)(), // for react render correct
	        column: null,
	        condition: null,
	        conditionValue: null,
	        conditionFrom: null,
	        conditionTo: null
	      });
	      _this.setState({ filters: filters });
	    }, _this.handleFilterChange = function (index, data) {
	      var filters = _this.state.filters;
	
	      filters[index] = data;
	      _this.setState({ filters: filters });
	    }, _this.handleFilterDelete = function (index) {
	      _this.state.filters.splice(index, 1);
	      _this.setState({ filters: _this.state.filters });
	    }, _this.handleSearch = function (e) {
	      _this.props.onSearch(_this.state.filters);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CascadeFilterCollection, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filters = nextProps.filters || [];
	
	      // ensure filters passed in have id
	      filters.forEach(function (filter) {
	        filter.id = filter.id || (0, _uniqueId2.default)();
	      });
	
	      this.setState({
	        filters: filters
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var filters = this.state.filters;
	      // Set a default filter if no filters exist
	
	      if (filters.length === 0) {
	        filters.push({
	          id: (0, _uniqueId2.default)(),
	          column: '',
	          condition: '',
	          conditionValue: '',
	          conditionFrom: '',
	          conditionTo: ''
	        });
	      }
	
	      // Expends filters
	      var cascadeFilter = filters.map(function (filter, index) {
	        var showDelete = !!(filters.length - 1);
	        return _react2.default.createElement(_cascadeFilter2.default, {
	          key: filter.id,
	          settings: _this2.props.settings,
	          filter: filter,
	          onChange: _this2.handleFilterChange.bind(null, index),
	          onDelete: _this2.handleFilterDelete.bind(null, index),
	          showDelete: showDelete
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card cascade-filter-collection' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          cascadeFilter,
	          _react2.default.createElement(
	            _actionButton2.default,
	            { type: 'add', onClick: this.addNewFilter },
	            'Add Filter'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-footer clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            '\xA0 ',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: this.handleSearch },
	              'Search'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            _react2.default.createElement(_savedFilter2.default, {
	              group: this.props.group,
	              currentFilter: this.state.filters,
	              onFilterSelected: this.onFilterSelected })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CascadeFilterCollection;
	}(_react.Component), _class.propTypes = {
	  group: _propTypes2.default.string.isRequired,
	  settings: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  filters: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  onSearch: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = CascadeFilterCollection;

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INVOICE_TYPE = exports.INVOICE_TYPE = 'Invoice';
	
	var QUOTE_TYPE = exports.QUOTE_TYPE = 'Quote';
	
	var VIEW = exports.VIEW = 'view';
	var NEW = exports.NEW = 'new';
	var EDIT = exports.EDIT = 'edit';
	
	var OVERVIEW = exports.OVERVIEW = 'overview';
	var PAYMENT = exports.PAYMENT = 'payment';
	var DELIVERY_NOTE = exports.DELIVERY_NOTE = 'delivery-note';
	var LOG = exports.LOG = 'log';

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PrivateListingSchema = exports.inventoryVarianceSchema = exports.UnitGroupSchema = exports.UnitSchema = exports.PaymentSchema = exports.DeliveryOrderLogsSchema = exports.DeliveryOrderSchema = exports.OrderCorrespondenceSchema = exports.InvoiceSchema = exports.TaxOptionSchema = exports.DepartmentSchema = exports.SupplierSchema = exports.ListingSchema = undefined;
	
	var _normalizr = __webpack_require__(64);
	
	var ListingSchema = new _normalizr.Schema('listings');
	
	var PrivateListingSchema = new _normalizr.Schema('privateListings', { idAttribute: 'listing_id' });
	
	var SupplierSchema = new _normalizr.Schema('suppliers');
	
	var DepartmentSchema = new _normalizr.Schema('departments');
	
	var TaxOptionSchema = new _normalizr.Schema('taxOptions');
	
	var InvoiceSchema = new _normalizr.Schema('invoices');
	
	var OrderCorrespondenceSchema = new _normalizr.Schema('orderCorrespondences');
	
	var DeliveryOrderSchema = new _normalizr.Schema('deliveryOrders');
	
	var DeliveryOrderLogsSchema = new _normalizr.Schema('deliveryOrderHistories');
	
	var PaymentSchema = new _normalizr.Schema('payment_instruments');
	
	var UnitSchema = new _normalizr.Schema('units');
	
	var UnitGroupSchema = new _normalizr.Schema('unitGroups');
	
	var inventoryVarianceSchema = new _normalizr.Schema('inventoryVariance');
	
	inventoryVarianceSchema.define({
	    items: (0, _normalizr.arrayOf)(PrivateListingSchema)
	});
	
	UnitGroupSchema.define({
	    units: (0, _normalizr.arrayOf)(UnitSchema)
	});
	
	exports.ListingSchema = ListingSchema;
	exports.SupplierSchema = SupplierSchema;
	exports.DepartmentSchema = DepartmentSchema;
	exports.TaxOptionSchema = TaxOptionSchema;
	exports.InvoiceSchema = InvoiceSchema;
	exports.OrderCorrespondenceSchema = OrderCorrespondenceSchema;
	exports.DeliveryOrderSchema = DeliveryOrderSchema;
	exports.DeliveryOrderLogsSchema = DeliveryOrderLogsSchema;
	exports.PaymentSchema = PaymentSchema;
	exports.UnitSchema = UnitSchema;
	exports.UnitGroupSchema = UnitGroupSchema;
	exports.inventoryVarianceSchema = inventoryVarianceSchema;
	exports.PrivateListingSchema = PrivateListingSchema;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(22)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(53)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(132)('meta');
	var isObject = __webpack_require__(18);
	var has = __webpack_require__(60);
	var setDesc = __webpack_require__(28).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(16)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 113 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(396);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given the ID is appended to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitDepartmentSelection = exports.toggleDepartmentSelection = exports.toggleDepartmentCollapse = exports.closeDepartmentSelection = exports.toggleAllDepartmentSelection = exports.openDepartmentSelection = exports.TOGGLE_ALL_DEPARTMENT_SELECTION = exports.SAVE_DEPARTMENT_SELECTION = exports.TOGGLE_DEPARTMENT_COLLAPSED = exports.TOGGLE_DEPARTMENT_SELECTION = exports.CLOSE_DEPARTMENT_SELECTION = exports.OPEN_DEPARTMENT_SELECTION = undefined;
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPEN_DEPARTMENT_SELECTION = exports.OPEN_DEPARTMENT_SELECTION = 'OPEN_DEPARTMENT_SELECTION';
	var CLOSE_DEPARTMENT_SELECTION = exports.CLOSE_DEPARTMENT_SELECTION = 'CLOSE_DEPARTMENT_SELECTION';
	var TOGGLE_DEPARTMENT_SELECTION = exports.TOGGLE_DEPARTMENT_SELECTION = 'TOGGLE_DEPARTMENT_SELECTION';
	var TOGGLE_DEPARTMENT_COLLAPSED = exports.TOGGLE_DEPARTMENT_COLLAPSED = 'TOGGLE_DEPARTMENT_COLLAPSED';
	var SAVE_DEPARTMENT_SELECTION = exports.SAVE_DEPARTMENT_SELECTION = 'SAVE_DEPARTMENT_SELECTION';
	var TOGGLE_ALL_DEPARTMENT_SELECTION = exports.TOGGLE_ALL_DEPARTMENT_SELECTION = 'TOGGLE_ALL_DEPARTMENT_SELECTION';
	
	var openDepartmentSelection = exports.openDepartmentSelection = function openDepartmentSelection(storeId, _ref) {
	  var selected = _ref.selected,
	      params = _ref.params;
	
	  return function (dispatch, getState) {
	    var department = getState().entities.departments;
	    dispatch({ type: OPEN_DEPARTMENT_SELECTION, all: (0, _values2.default)(department), selected: selected.slice(), params: params });
	  };
	};
	
	var toggleAllDepartmentSelection = exports.toggleAllDepartmentSelection = function toggleAllDepartmentSelection(empty) {
	  return function (dispatch, getState) {
	    dispatch({ type: TOGGLE_ALL_DEPARTMENT_SELECTION, empty: empty });
	  };
	};
	
	var closeDepartmentSelection = exports.closeDepartmentSelection = function closeDepartmentSelection() {
	  return { type: CLOSE_DEPARTMENT_SELECTION };
	};
	
	var toggleDepartmentCollapse = exports.toggleDepartmentCollapse = function toggleDepartmentCollapse(path, collapsed) {
	  return { type: TOGGLE_DEPARTMENT_COLLAPSED, path: path, collapsed: collapsed };
	};
	
	var toggleDepartmentSelection = exports.toggleDepartmentSelection = function toggleDepartmentSelection(path, checked) {
	  return { type: TOGGLE_DEPARTMENT_SELECTION, path: path, checked: checked };
	};
	
	var submitDepartmentSelection = exports.submitDepartmentSelection = function submitDepartmentSelection(openerSubmitCallback) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$departme = state.forms.departmentSelection,
	        selected = _state$forms$departme.selected,
	        params = _state$forms$departme.params;
	
	    dispatch({ type: SAVE_DEPARTMENT_SELECTION, selected: selected, params: params });
	    if (typeof openerSubmitCallback === 'function') {
	      openerSubmitCallback();
	    }
	  };
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.importInit = exports.changeItemStatus = exports.saveItem = exports.cancelEdit = exports.startEdit = exports.listingGoToPage = exports.updateIvField = exports.updateUnit = exports.updateRemark = exports.updateSerialNumbers = exports.updateCost = exports.updateVarianceQty = exports.updateActualQty = exports.removeListings = exports.addListings = exports.loadInventoryVariance = exports.initInventoryVariance = exports.addListingsByDepartments = exports.searchInventoryVariances = exports.createInventoryVarianceByDepartments = exports.INVENTORY_VARIANCE_IMPORT_INIT = exports.INVENTORY_VARIANCE_UPDATE_UNIT = exports.INVENTORY_VARIANCE_UPDATE_REMARK = exports.INVENTORY_VARIANCE_UPDATE_ITEM = exports.INVENTORY_VARIANCE_LOAD_LISTINGS = exports.INVENTORY_VARIANCE_LOAD_ITEM = exports.INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS = exports.INVENTORY_VARIANCE_LISTING_GO_TO_PAGE = exports.INVENTORY_VARIANCE_UPDATE_IV_FIELD = exports.INVENTORY_VARIANCE_UPDATE_COST = exports.INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY = exports.INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY = exports.INVENTORY_VARIANCE_REMOVE_LISTINGS = exports.INVENTORY_VARIANCE_ADD_LISTINGS = exports.INVENTORY_VARIANCE_SET_FIELDS = exports.INVENTORY_VARIANCE_INIT = exports.GET_INVENTORY_VARIANCES_FAILURE = exports.GET_INVENTORY_VARIANCES_SUCCESS = exports.GET_INVENTORY_VARIANCES_REQUEST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.validateImportIV = validateImportIV;
	exports.postImportIV = postImportIV;
	exports.getImportIV = getImportIV;
	
	var _humps = __webpack_require__(44);
	
	var _lodash = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(9);
	
	var _constants = __webpack_require__(26);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _inventoryVarianceService = __webpack_require__(956);
	
	var _inventoryVarianceService2 = _interopRequireDefault(_inventoryVarianceService);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _apiHelper = __webpack_require__(811);
	
	var _alertActions = __webpack_require__(90);
	
	var _baseActions = __webpack_require__(34);
	
	var _entityActions = __webpack_require__(58);
	
	var _departmentSelection = __webpack_require__(118);
	
	var _inventoryActions = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MODE = _constants.INVENTORY_VARIANCE.MODE,
	    TAB = _constants.INVENTORY_VARIANCE.TAB;
	var GET_INVENTORY_VARIANCES_REQUEST = exports.GET_INVENTORY_VARIANCES_REQUEST = 'GET_INVENTORY_VARIANCES_REQUEST';
	var GET_INVENTORY_VARIANCES_SUCCESS = exports.GET_INVENTORY_VARIANCES_SUCCESS = 'GET_INVENTORY_VARIANCES_SUCCESS';
	var GET_INVENTORY_VARIANCES_FAILURE = exports.GET_INVENTORY_VARIANCES_FAILURE = 'GET_INVENTORY_VARIANCES_FAILURE';
	var INVENTORY_VARIANCE_INIT = exports.INVENTORY_VARIANCE_INIT = 'INVENTORY_VARIANCE_INIT';
	var INVENTORY_VARIANCE_SET_FIELDS = exports.INVENTORY_VARIANCE_SET_FIELDS = 'INVENTORY_VARIANCE_SET_FIELDS';
	var INVENTORY_VARIANCE_ADD_LISTINGS = exports.INVENTORY_VARIANCE_ADD_LISTINGS = 'INVENTORY_VARIANCE_ADD_LISTINGS';
	var INVENTORY_VARIANCE_REMOVE_LISTINGS = exports.INVENTORY_VARIANCE_REMOVE_LISTINGS = 'INVENTORY_VARIANCE_REMOVE_LISTINGS';
	var INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY = exports.INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY = 'INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY';
	var INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY = exports.INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY = 'INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY';
	var INVENTORY_VARIANCE_UPDATE_COST = exports.INVENTORY_VARIANCE_UPDATE_COST = 'INVENTORY_VARIANCE_UPDATE_COST';
	var INVENTORY_VARIANCE_UPDATE_IV_FIELD = exports.INVENTORY_VARIANCE_UPDATE_IV_FIELD = 'INVENTORY_VARIANCE_UPDATE_IV_FIELD';
	var INVENTORY_VARIANCE_LISTING_GO_TO_PAGE = exports.INVENTORY_VARIANCE_LISTING_GO_TO_PAGE = 'INVENTORY_VARIANCE_LISTING_GO_TO_PAGE';
	var INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS = exports.INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS = 'INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS';
	var INVENTORY_VARIANCE_LOAD_ITEM = exports.INVENTORY_VARIANCE_LOAD_ITEM = 'INVENTORY_VARIANCE_LOAD_ITEM';
	var INVENTORY_VARIANCE_LOAD_LISTINGS = exports.INVENTORY_VARIANCE_LOAD_LISTINGS = 'INVENTORY_VARIANCE_LOAD_LISTINGS';
	var INVENTORY_VARIANCE_UPDATE_ITEM = exports.INVENTORY_VARIANCE_UPDATE_ITEM = 'INVENTORY_VARIANCE_UPDATE_ITEM';
	var INVENTORY_VARIANCE_UPDATE_REMARK = exports.INVENTORY_VARIANCE_UPDATE_REMARK = 'INVENTORY_VARIANCE_UPDATE_REMARK';
	var INVENTORY_VARIANCE_UPDATE_UNIT = exports.INVENTORY_VARIANCE_UPDATE_UNIT = 'INVENTORY_VARIANCE_UPDATE_UNIT';
	var INVENTORY_VARIANCE_IMPORT_INIT = exports.INVENTORY_VARIANCE_IMPORT_INIT = 'INVENTORY_VARIANCE_IMPORT_INIT';
	
	var createInventoryVarianceByDepartments = exports.createInventoryVarianceByDepartments = function createInventoryVarianceByDepartments(currentStore) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var departmentIds = (0, _lodash.get)(state, 'forms.departmentSelection.selected', []).map(function (d) {
	      return d.department_id;
	    });
	    var type = (0, _lodash.get)(state, 'pages.inventoryVarianceIndex.type');
	    dispatch(initInventoryVariance(currentStore, null, MODE.NEW, TAB.OVERVIEW, type));
	    dispatch((0, _departmentSelection.closeDepartmentSelection)());
	    dispatch({ type: INVENTORY_VARIANCE_SET_FIELDS, payload: { type: type } });
	    _routeHelper2.default.goInventoryVariance(currentStore.id, 'new');
	    return dispatch(addListingsByDepartments(currentStore.id, departmentIds));
	  };
	};
	
	var searchInventoryVariances = exports.searchInventoryVariances = function searchInventoryVariances(storeId) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	  var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  return function (dispatch) {
	    dispatch({ type: GET_INVENTORY_VARIANCES_REQUEST });
	    return _inventoryVarianceService2.default.getVariances(storeId, page, perPage, orderBy, filters).then(function (resp) {
	      // dispatch(startFetch());
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.data.inventoryVariances;
	      if (data) {
	        var entities = {};
	        data.forEach(function (d) {
	          return entities[d.id] = d;
	        });
	        dispatch({ type: GET_INVENTORY_VARIANCES_SUCCESS, data: data });
	        dispatch({ type: _entityActions.SET_ENTITIES, collection: 'inventoryVariances', data: entities });
	        return resp;
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: GET_INVENTORY_VARIANCES_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      // dispatch(startFetch());
	      dispatch({ type: GET_INVENTORY_VARIANCES_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var addListingsByDepartments = exports.addListingsByDepartments = function addListingsByDepartments(storeId) {
	  var departmentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  return function (dispatch, getState) {
	    var search = {
	      filter: { departmentId: departmentId, trackQuantity: true }
	    };
	    dispatch((0, _baseActions.startFetch)());
	    return (0, _apiHelper.drainAllPages)(function (page) {
	      return _inventoryService2.default.searchEs(storeId, search, page, 200).then(function (res) {
	        res.data = res.data.listings;
	        dispatch(addListings(res.data));
	        return res;
	      });
	    }).then(function (res) {
	      dispatch((0, _baseActions.stopFetch)());
	    }).catch(function (err) {
	      dispatch((0, _baseActions.stopFetch)());
	      dispatch((0, _alertActions.alert)('danger', err.message));
	    });
	  };
	};
	
	var initInventoryVariance = exports.initInventoryVariance = function initInventoryVariance(currentStore, id, mode, tab, type) {
	  return function (dispatch, getState) {
	    dispatch({ type: INVENTORY_VARIANCE_INIT, payload: { currentStore: currentStore, mode: mode, tab: tab, type: type } });
	    if (mode === MODE.VIEW) {
	      return dispatch(loadInventoryVariance(currentStore.id, id));
	    }
	  };
	};
	
	var loadInventoryVariance = exports.loadInventoryVariance = function loadInventoryVariance(storeId, itemId) {
	  return function (dispatch, getState) {
	    if (storeId && itemId) {
	      var state = getState();
	      var _state$inventoryVaria = state.inventoryVariance,
	          inventoryVariance = _state$inventoryVaria === undefined ? {} : _state$inventoryVaria;
	      var _inventoryVariance$pe = inventoryVariance.perPage,
	          perPage = _inventoryVariance$pe === undefined ? 200 : _inventoryVariance$pe,
	          _inventoryVariance$cu = inventoryVariance.currentStore,
	          currentStore = _inventoryVariance$cu === undefined ? {} : _inventoryVariance$cu;
	      var id = currentStore.id;
	
	      dispatch((0, _baseActions.startFetch)());
	      return _inventoryVarianceService2.default.getVariance(itemId, storeId).then(function (res) {
	        dispatch({ type: INVENTORY_VARIANCE_LOAD_ITEM, payload: res });
	      }).then(function () {
	        return (0, _apiHelper.drainAllPages)(function (page) {
	          return _inventoryVarianceService2.default.getVarianceListings(itemId, storeId, page, perPage).then(function (res) {
	            res.data = res.data.inventory_variance_items;
	            var unit_group_ids = res.data.map(function (u) {
	              return u.unit_group_id;
	            });
	            var promises = unit_group_ids.map(function (group_id) {
	              return group_id ? _inventoryService2.default.getUnits(id, group_id).then(function (response) {
	                return response.unit_group.units;
	              }) : null;
	            });
	            if (promises.length) {
	              Promise.all(promises).then(function (resonse) {
	                res.data.map(function (r, i) {
	                  return r.unit_group = resonse[i];
	                });
	                dispatch({ type: INVENTORY_VARIANCE_LOAD_LISTINGS, payload: res.data });
	              });
	            } else {
	              dispatch({ type: INVENTORY_VARIANCE_LOAD_LISTINGS, payload: res.data });
	            }
	            return res;
	          });
	        });
	      }).then(function (res) {
	        dispatch((0, _baseActions.stopFetch)());
	      }).catch(function (err) {
	        dispatch((0, _baseActions.stopFetch)());
	        dispatch((0, _alertActions.alert)('danger', err.message));
	      });
	    }
	  };
	};
	
	var addListings = exports.addListings = function addListings() {
	  var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$inventoryVaria2 = state.inventoryVariance,
	        inventoryVariance = _state$inventoryVaria2 === undefined ? {} : _state$inventoryVaria2;
	    var _inventoryVariance$cu2 = inventoryVariance.currentStore,
	        currentStore = _inventoryVariance$cu2 === undefined ? {} : _inventoryVariance$cu2;
	    var id = currentStore.id;
	
	    var unit_group_ids = listings.map(function (u) {
	      return u.unit_group_id;
	    });
	    var promises = unit_group_ids.map(function (group_id) {
	      return group_id ? _inventoryService2.default.getUnits(id, group_id).then(function (response) {
	        return response.unit_group.units;
	      }) : null;
	    });
	    Promise.all(promises).then(function (resonse) {
	      listings.map(function (r, i) {
	        return r.unit_group = resonse[i];
	      });
	      dispatch({ type: INVENTORY_VARIANCE_ADD_LISTINGS, payload: listings });
	    });
	  };
	};
	
	var removeListings = exports.removeListings = function removeListings() {
	  var listingIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return function (dispatch, getState) {
	    dispatch({ type: INVENTORY_VARIANCE_REMOVE_LISTINGS, payload: listingIds });
	  };
	};
	
	var updateActualQty = exports.updateActualQty = function updateActualQty(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY, payload: payload });
	  };
	};
	
	var updateVarianceQty = exports.updateVarianceQty = function updateVarianceQty(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY, payload: payload });
	  };
	};
	
	var updateCost = exports.updateCost = function updateCost(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_COST, payload: payload });
	  };
	};
	
	var updateSerialNumbers = exports.updateSerialNumbers = function updateSerialNumbers(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS, payload: payload });
	  };
	};
	
	var updateRemark = exports.updateRemark = function updateRemark(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_REMARK, payload: payload });
	  };
	};
	
	var updateUnit = exports.updateUnit = function updateUnit(listingId, value) {
	  return function (dispatch, getState) {
	    var payload = { listingId: listingId, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_UNIT, payload: payload });
	  };
	};
	
	var updateIvField = exports.updateIvField = function updateIvField(field, value) {
	  return function (dispatch, getState) {
	    var payload = { field: field, value: value };
	    dispatch({ type: INVENTORY_VARIANCE_UPDATE_IV_FIELD, payload: payload });
	  };
	};
	
	var listingGoToPage = exports.listingGoToPage = function listingGoToPage(page) {
	  return function (dispatch, getState) {
	    var payload = { page: page };
	    dispatch({ type: INVENTORY_VARIANCE_LISTING_GO_TO_PAGE, payload: payload });
	  };
	};
	
	var startEdit = exports.startEdit = function startEdit() {
	  return function (dispatch, getState) {
	    var payload = { mode: MODE.EDIT };
	    dispatch({ type: INVENTORY_VARIANCE_SET_FIELDS, payload: payload });
	  };
	};
	
	var cancelEdit = exports.cancelEdit = function cancelEdit() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$inventoryVaria3 = state.inventoryVariance,
	        inventoryVariance = _state$inventoryVaria3 === undefined ? {} : _state$inventoryVaria3;
	    var currentStore = inventoryVariance.currentStore,
	        mode = inventoryVariance.mode,
	        tab = inventoryVariance.tab,
	        type = inventoryVariance.type,
	        _inventoryVariance$iv = inventoryVariance.iv,
	        iv = _inventoryVariance$iv === undefined ? {} : _inventoryVariance$iv;
	    var itemId = iv.id;
	
	    if (mode === MODE.EDIT) {
	      return dispatch(initInventoryVariance(currentStore, itemId, MODE.VIEW, tab, type));
	    } else {
	      _reactRouter.browserHistory.goBack();
	    }
	  };
	};
	
	var saveItem = exports.saveItem = function saveItem() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$inventoryVaria4 = state.inventoryVariance,
	        inventoryVariance = _state$inventoryVaria4 === undefined ? {} : _state$inventoryVaria4;
	    var mode = inventoryVariance.mode,
	        type = inventoryVariance.type,
	        _inventoryVariance$iv2 = inventoryVariance.iv,
	        iv = _inventoryVariance$iv2 === undefined ? {} : _inventoryVariance$iv2,
	        _inventoryVariance$en = inventoryVariance.entities,
	        entities = _inventoryVariance$en === undefined ? {} : _inventoryVariance$en,
	        _inventoryVariance$cu3 = inventoryVariance.currentStore,
	        currentStore = _inventoryVariance$cu3 === undefined ? {} : _inventoryVariance$cu3;
	    var storeId = currentStore.id;
	
	    var data = _extends({}, iv);
	    var itemId = data.id;
	    var isEdit = mode === MODE.EDIT && itemId;
	    var items = iv.items.map(function (id) {
	      return entities[id];
	    }).filter(function (item) {
	      return isEdit ? item && (item._destroy || item._modified) : item && !item._destroy;
	    }).map(function (item) {
	      var id = item.id,
	          listingId = item.listingId,
	          actualQty = item.actualQty,
	          quantityInDisplayUnit = item.quantityInDisplayUnit,
	          varianceQty = item.varianceQty,
	          varianceQtyInDisplayUnit = item.varianceQtyInDisplayUnit,
	          cost = item.cost,
	          costInDisplayUnit = item.costInDisplayUnit,
	          lots = item.lots,
	          serialNumbers = item.serialNumbers,
	          _destroy = item._destroy,
	          remark = item.remark,
	          displayUnitId = item.displayUnitId;
	
	      return {
	        id: id,
	        listingId: listingId,
	        // actualQty: actualQty.toString(),
	        actualQty: quantityInDisplayUnit.toString(),
	        quantityInDisplayUnit: quantityInDisplayUnit.toString(),
	        varianceQty: varianceQty.toString(),
	        varianceQtyInDisplayUnit: varianceQtyInDisplayUnit.toString(),
	        cost: cost.toString(),
	        costInDisplayUnit: costInDisplayUnit.toString(),
	        lots: lots,
	        serialNumbers: serialNumbers,
	        remark: remark,
	        displayUnitId: displayUnitId,
	        _destroy: _destroy
	      };
	    });
	    data.typeId = type;
	    data.unitEnable = true;
	    data.inventoryVarianceItemsAttributes = items;
	    if (items && items.length) {
	      items.forEach(function (item) {
	        if (item.id % 1 !== 0) {
	          delete item.id;
	        }
	      });
	    }
	    data = {
	      inventoryVariance: (0, _lodash.pick)(data, ['id', 'typeId', 'name', 'effectiveDate', 'inventoryVarianceItemsAttributes', 'remarks', 'unitEnable'])
	    };
	    data = (0, _humps.decamelizeKeys)(data);
	    dispatch((0, _baseActions.startFetch)());
	    var promise = null;
	    if (isEdit) {
	      promise = _inventoryVarianceService2.default.update(data, itemId, storeId);
	    } else {
	      promise = _inventoryVarianceService2.default.create(data, storeId);
	    }
	    return promise.then(function (res) {
	      var _res$inventory_varian = res.inventory_variance,
	          ret = _res$inventory_varian === undefined ? {} : _res$inventory_varian;
	
	      if (mode === MODE.NEW) {
	        _routeHelper2.default.goInventoryVariance(storeId, ret.id);
	      } else {
	        location.reload();
	      }
	    }).catch(function (err) {
	      dispatch((0, _baseActions.stopFetch)());
	      dispatch((0, _alertActions.alert)('danger', err.message));
	    });
	  };
	};
	
	var changeItemStatus = exports.changeItemStatus = function changeItemStatus(status) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$inventoryVaria5 = state.inventoryVariance,
	        inventoryVariance = _state$inventoryVaria5 === undefined ? {} : _state$inventoryVaria5;
	    var _inventoryVariance$cu4 = inventoryVariance.currentStore,
	        currentStore = _inventoryVariance$cu4 === undefined ? {} : _inventoryVariance$cu4,
	        _inventoryVariance$iv3 = inventoryVariance.iv,
	        iv = _inventoryVariance$iv3 === undefined ? {} : _inventoryVariance$iv3;
	
	    if (currentStore.id && iv.id && status) {
	      dispatch((0, _baseActions.startFetch)());
	      return _inventoryVarianceService2.default.changeVarianceStatus(currentStore.id, iv.id, status).then(function (res) {
	        var statusNeedGoBack = {
	          submit: true,
	          approve: true
	        };
	        dispatch((0, _baseActions.stopFetch)());
	        if (statusNeedGoBack) {
	          _routeHelper2.default.goInventoryVariance(currentStore.id);
	        } else {
	          dispatch({ type: INVENTORY_VARIANCE_UPDATE_ITEM, payload: res });
	        }
	      }).catch(function (err) {
	        dispatch((0, _baseActions.stopFetch)());
	        dispatch((0, _alertActions.alert)('danger', err.message));
	      });
	    }
	  };
	};
	
	var importInit = exports.importInit = function importInit() {
	  return function (dispatch, getState) {
	    dispatch({ type: INVENTORY_VARIANCE_IMPORT_INIT });
	  };
	};
	
	function validateImportIV(storeId, file) {
	  return function (dispatch) {
	    return _inventoryVarianceService2.default.importInit(storeId, file).then(function (data) {
	      dispatch({ type: _inventoryActions.REQUEST_VALIATATED, data: data });
	    });
	  };
	}
	
	function postImportIV(storeId, id) {
	  return function (dispatch) {
	    return _inventoryVarianceService2.default.postImportIV(storeId, id).then(function (data) {
	      dispatch({ type: _inventoryActions.REQUEST_VALIATATED, data: data });
	    });
	  };
	}
	
	function getImportIV(storeId, IV_import_id) {
	  return function (dispatch) {
	    return _inventoryVarianceService2.default.getImportIV(storeId, IV_import_id).then(function (data) {
	      dispatch({ type: _inventoryActions.GET_IMPORTER_STATUS, data: data });
	    });
	  };
	}

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Col = exports.Table = exports.Action = exports.ActionMenu = exports.PopRender = exports.PopContainer = exports.DialogButtonGroup = exports.Callout = undefined;
	
	var _Callout = __webpack_require__(769);
	
	var _Callout2 = _interopRequireDefault(_Callout);
	
	var _DialogButtonGroup = __webpack_require__(770);
	
	var _DialogButtonGroup2 = _interopRequireDefault(_DialogButtonGroup);
	
	var _PopContainer = __webpack_require__(771);
	
	var _PopContainer2 = _interopRequireDefault(_PopContainer);
	
	var _PopRender = __webpack_require__(772);
	
	var _PopRender2 = _interopRequireDefault(_PopRender);
	
	var _ActionMenu = __webpack_require__(768);
	
	var _ActionMenu2 = _interopRequireDefault(_ActionMenu);
	
	var _Action = __webpack_require__(767);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _Table = __webpack_require__(773);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Callout = _Callout2.default;
	exports.DialogButtonGroup = _DialogButtonGroup2.default;
	exports.PopContainer = _PopContainer2.default;
	exports.PopRender = _PopRender2.default;
	exports.ActionMenu = _ActionMenu2.default;
	exports.Action = _Action2.default;
	exports.Table = _Table2.default;
	exports.Col = _Table.Col;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storeComponent = exports.statusComponent = exports.transactionDetailsComponent = exports.transactionTypeComponent = exports.decimalComponent = exports.capitalizeFirstLetterComponent = exports.selectComponent = exports.spanComponent = exports.textInputComponent = exports.numberInputComponent = exports.currencyInputComponent = exports.dateComponent = exports.countSerialNumberComponent = exports.timeComponent = exports.orderStatusComponent = exports.linkComponent = exports.listingComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1240);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSelect = __webpack_require__(422);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRouter = __webpack_require__(9);
	
	var _formatHelper = __webpack_require__(35);
	
	var _statusHelper = __webpack_require__(317);
	
	var statusHelper = _interopRequireWildcard(_statusHelper);
	
	var _bindHelper = __webpack_require__(235);
	
	var _status = __webpack_require__(233);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	var _serialNumber = __webpack_require__(801);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var listingComponent = exports.listingComponent = function listingComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'listingComponent', function () {
	    var additionalFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    return function ListingComponent(props) {
	      var data = props.data,
	          rowData = props.rowData; //eslint-disable-line react/prop-types
	
	      var imgEl = null;
	      var codes = [];
	      if (Array.isArray(additionalFields)) {
	        additionalFields.forEach(function (field) {
	          if (field === 'imageUrl') {
	            imgEl = _react2.default.createElement(
	              'div',
	              { className: 'media-left' },
	              _react2.default.createElement('img', { className: '_thumbnail', src: rowData.imageUrl || __webpack_require__(1297) })
	            );
	          } else if (field === 'listingReferenceCodes') {
	            var refCodes = rowData.listingReferenceCodes || [];
	            var refStr = refCodes.join(', ');
	            codes.push(!refStr ? null : _react2.default.createElement(
	              'div',
	              { className: '_code pull-left w-100', key: field },
	              'Ref Codes: ',
	              refStr
	            ));
	          } else {
	            var label = {
	              bpid: 'BPID',
	              blid: 'BLID',
	              ean13: 'UPC/EAN',
	              listingBarcode: 'PLU/SKU'
	            }[field];
	            var value = rowData[field];
	            codes.push(!value ? null : _react2.default.createElement(
	              'div',
	              { className: '_code pull-left w-50', key: field },
	              label,
	              ': ',
	              value
	            ));
	          }
	        });
	      }
	      codes = codes.filter(function (d) {
	        return d;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('media', { 'listing-name-thumbnail': imgEl }) },
	        !imgEl ? null : imgEl,
	        _react2.default.createElement(
	          'div',
	          { className: 'media-body' },
	          _react2.default.createElement(
	            'div',
	            { className: '_name' },
	            data
	          ),
	          codes
	        )
	      );
	    };
	  });
	};
	
	var linkComponent = exports.linkComponent = function linkComponent(WrappedComponent) {
	  function linkComponent(props) {
	    var data = props.data,
	        rowData = props.rowData; //eslint-disable-line react/prop-types
	
	    var path = location.pathname + '/' + rowData.id;
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      { to: path },
	      data
	    );
	  }
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'linkComponent', linkComponent);
	};
	
	var orderStatusComponent = exports.orderStatusComponent = function orderStatusComponent(WrappedComponent) {
	  var orderStatusComponent = function orderStatusComponent(props) {
	    var data = props.data,
	        metadata = props.metadata; //eslint-disable-line react/prop-types
	
	    var _metadata$customCompo = metadata.customComponentProps,
	        customComponentProps = _metadata$customCompo === undefined ? {} : _metadata$customCompo;
	    var colorTransformer = customComponentProps.colorTransformer,
	        labelTransformer = customComponentProps.labelTransformer;
	
	
	    return _react2.default.createElement(_status2.default, { state: data, label: data, colorTransformer: colorTransformer, labelTransformer: labelTransformer });
	  };
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'orderStatusComponent', orderStatusComponent);
	};
	
	var timeComponent = exports.timeComponent = function timeComponent(WrappedComponent) {
	  function timeComponent(props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    var timezine = this.context.currentStore && this.context.currentStore.timezone;
	    return _react2.default.createElement(
	      'span',
	      null,
	      data && (0, _formatHelper.dateTime)(data, timezine)
	    );
	  }
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'timeComponent', timeComponent);
	};
	
	var countSerialNumberComponent = function countSerialNumberComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'countSerialNumberComponent', function CountSerialNumberComponent(props) {
	    var _props$data = props.data,
	        data = _props$data === undefined ? [] : _props$data,
	        metadata = props.metadata,
	        rowData = props.rowData;
	    var _metadata$customCompo2 = metadata.customComponentProps,
	        customComponentProps = _metadata$customCompo2 === undefined ? {} : _metadata$customCompo2;
	
	    var onConfirm = customComponentProps.onConfirm,
	        readOnly = customComponentProps.readOnly,
	        productName = customComponentProps.productName,
	        hide = customComponentProps.hide,
	        meta = _objectWithoutProperties(customComponentProps, ['onConfirm', 'readOnly', 'productName', 'hide']);
	
	    readOnly = typeof readOnly === 'function' ? readOnly(props) : readOnly;
	    hide = typeof hide === 'function' ? hide(props) : hide;
	    productName = typeof productName === 'function' ? productName(props) : productName;
	    var handleOnConfirm = onConfirm ? function (value) {
	      return onConfirm(value, rowData);
	    } : undefined;
	    return hide ? null : _react2.default.createElement(_serialNumber.CountSerialNumber, _extends({
	      value: data,
	      productName: productName,
	      readOnly: readOnly,
	      onConfirm: handleOnConfirm
	    }, meta));
	  });
	};
	exports.countSerialNumberComponent = countSerialNumberComponent;
	var dateComponent = exports.dateComponent = function dateComponent(WrappedComponent) {
	
	  function dateComponent(props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatHelper.date)(data)
	    );
	  }
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'dateComponent', dateComponent);
	};
	
	var currencyInputComponent = function currencyInputComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'currencyInputComponent', function CurrencyInputComponent(props) {
	    var data = props.data,
	        rowData = props.rowData,
	        metadata = props.metadata; //eslint-disable-line react/prop-types
	
	    var _metadata$customCompo3 = metadata.customComponentProps,
	        customComponentProps = _metadata$customCompo3 === undefined ? {} : _metadata$customCompo3;
	
	    var onChange = customComponentProps.onChange,
	        readOnly = customComponentProps.readOnly,
	        dp = customComponentProps.dp,
	        meta = _objectWithoutProperties(customComponentProps, ['onChange', 'readOnly', 'dp']);
	
	    readOnly = typeof readOnly === 'function' ? readOnly(props) : readOnly;
	    dp = typeof dp === 'function' ? dp(props) : dp;
	    var handleOnChange = onChange ? function (value) {
	      return onChange(value, rowData);
	    } : undefined;
	    return _react2.default.createElement(_inputCurrency2.default, _extends({ value: data, onChange: handleOnChange, readOnly: readOnly, dp: dp }, meta));
	  });
	};
	
	exports.currencyInputComponent = currencyInputComponent;
	var numberInputComponent = function numberInputComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'numberInputComponent', function NumberInputComponent(props) {
	    var data = props.data,
	        rowData = props.rowData,
	        metadata = props.metadata; //eslint-disable-line react/prop-types
	
	    var _metadata$customCompo4 = metadata.customComponentProps,
	        customComponentProps = _metadata$customCompo4 === undefined ? {} : _metadata$customCompo4;
	
	    var onChange = customComponentProps.onChange,
	        readOnly = customComponentProps.readOnly,
	        dp = customComponentProps.dp,
	        meta = _objectWithoutProperties(customComponentProps, ['onChange', 'readOnly', 'dp']);
	
	    readOnly = typeof readOnly === 'function' ? readOnly(props) : readOnly;
	    dp = typeof dp === 'function' ? dp(props) : dp;
	    var handleOnChange = onChange ? function (value) {
	      return onChange(value, rowData);
	    } : undefined;
	    return _react2.default.createElement(_inputNumber2.default, _extends({ value: data, onChange: handleOnChange, readOnly: readOnly, dp: dp }, meta));
	  });
	};
	exports.numberInputComponent = numberInputComponent;
	var textInputComponent = function textInputComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'textInputComponent', function TextInputComponent(props) {
	    var data = props.data,
	        rowData = props.rowData,
	        metadata = props.metadata; //eslint-disable-line react/prop-types
	
	    var _metadata$customCompo5 = metadata.customComponentProps,
	        customComponentProps = _metadata$customCompo5 === undefined ? {} : _metadata$customCompo5;
	
	    var _onChange = customComponentProps.onChange,
	        readOnly = customComponentProps.readOnly,
	        meta = _objectWithoutProperties(customComponentProps, ['onChange', 'readOnly']);
	
	    readOnly = typeof readOnly === 'function' ? readOnly(props) : readOnly;
	    return _react2.default.createElement('input', { value: data, onChange: function onChange(e) {
	        return _onChange(e.target.value, rowData);
	      }, readOnly: readOnly });
	  });
	};
	
	exports.textInputComponent = textInputComponent;
	var spanComponent = exports.spanComponent = function spanComponent(WrappedComponent) {
	  var spanComponent = function spanComponent(props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    return _react2.default.createElement(
	      'span',
	      null,
	      data
	    );
	  };
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'spanComponent', spanComponent);
	};
	
	var selectComponent = exports.selectComponent = function selectComponent(WrappedComponent) {
	  var selectComponent = function selectComponent(props) {
	    var data = props.data,
	        rowData = props.rowData,
	        metadata = props.metadata; //eslint-disable-line react/prop-types
	
	    var customComponentProps = metadata.customComponentProps;
	    var readOnly = customComponentProps.readOnly;
	
	    readOnly = typeof readOnly === 'function' ? readOnly(props) : readOnly;
	    var selectProps = _extends({}, customComponentProps, {
	      value: data,
	      onChange: function onChange(e) {
	        return customComponentProps.onChange(e, rowData);
	      },
	      options: customComponentProps.optionsAccessor(rowData),
	      disabled: readOnly
	    });
	    return _react2.default.createElement(_reactSelect2.default, selectProps);
	  };
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'selectComponent', selectComponent);
	};
	
	var capitalizeFirstLetterComponent = exports.capitalizeFirstLetterComponent = function capitalizeFirstLetterComponent(WrappedComponent) {
	  var capitalizeFirstLetterComponent = function capitalizeFirstLetterComponent(props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    if (typeof data === 'string' && data.length) {
	      var s = data.charAt(0).toUpperCase() + data.slice(1);
	      return _react2.default.createElement(
	        'span',
	        null,
	        s
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'capitalizeFirstLetterComponent', capitalizeFirstLetterComponent);
	};
	
	var decimalComponent = exports.decimalComponent = function decimalComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'decimalComponent', function (props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    return _react2.default.createElement(
	      'span',
	      { style: { width: '50%' } },
	      (0, _formatHelper.decimal)(data)
	    );
	  });
	};
	
	var transactionTypeComponent = exports.transactionTypeComponent = function transactionTypeComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'transactionTypeComponent', function (props) {
	    var data = props.data,
	        rowData = props.rowData; //eslint-disable-line react/prop-types
	
	    var extra = rowData.extra;
	
	    var value = extra ? 'Credit Card' : data;
	    return _react2.default.createElement(
	      'span',
	      { className: 'capitalize' },
	      value
	    );
	  });
	};
	
	var transactionDetailsComponent = exports.transactionDetailsComponent = function transactionDetailsComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'transactionDetailsComponent', function (props) {
	    var rowData = props.rowData; //eslint-disable-line react/prop-types
	
	    var _rowData$approvalCode = rowData.approvalCode,
	        approvalCode = _rowData$approvalCode === undefined ? '' : _rowData$approvalCode,
	        _rowData$entryMode = rowData.entryMode,
	        entryMode = _rowData$entryMode === undefined ? '' : _rowData$entryMode,
	        _rowData$statusMessag = rowData.statusMessage,
	        statusMessage = _rowData$statusMessag === undefined ? '' : _rowData$statusMessag,
	        _rowData$transactionT = rowData.transactionType,
	        transactionType = _rowData$transactionT === undefined ? '' : _rowData$transactionT,
	        extra = rowData.extra;
	
	    if (extra) {
	      var holderName = extra.holderName,
	          last4Digits = extra.last4Digits,
	          creditCardType = extra.creditCardType;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'credit-card-details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Cardholder'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            holderName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Paid via ',
	            creditCardType,
	            ' Card'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            '**** **** **** ',
	            last4Digits
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Transaction Type'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            (0, _formatHelper.lowercase)(transactionType)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Approval Code'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            approvalCode
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Entry Mode'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            (0, _formatHelper.lowercase)(entryMode)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'credit-card-details__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__label' },
	            'Authorised'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'credit-card-details__value' },
	            (0, _formatHelper.lowercase)(statusMessage)
	          )
	        )
	      );
	    } else {
	      return null;
	    }
	  });
	};
	
	var statusComponent = exports.statusComponent = function statusComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'statusComponent', function (statusType) {
	    return function StatusComponent(props) {
	      var data = props.data; //eslint-disable-line react/prop-types
	
	      var defaultState = statusHelper.DEFAULT_STATE[statusType];
	      var labelTransformer = statusHelper[statusType + 'Label'];
	      var colorTransformer = statusHelper[statusType + 'Color'];
	      return _react2.default.createElement(_status2.default, { state: data || defaultState, labelTransformer: labelTransformer, colorTransformer: colorTransformer });
	    };
	  });
	};
	
	// The WrappedComponent must have either appState or stores in props
	var storeComponent = exports.storeComponent = function storeComponent(WrappedComponent) {
	  return (0, _bindHelper.bindPublicMethod)(WrappedComponent, 'storeComponent', function (props) {
	    var storeName = null;
	    var _props = this.props,
	        _props$appState = _props.appState,
	        appState = _props$appState === undefined ? {} : _props$appState,
	        stores = _props.stores;
	
	    var s = stores || appState.stores;
	    if (Array.isArray(s)) {
	      var data = props.data; //eslint-disable-line react/prop-types
	
	      var _target = s.find(function (s) {
	        return s.id === data;
	      }) || {};
	      storeName = _target.title;
	    }
	    return storeName ? _react2.default.createElement(
	      'span',
	      null,
	      storeName
	    ) : null;
	  });
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1020)
	var ieee754 = __webpack_require__(1457)
	var isArray = __webpack_require__(1021)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122).Buffer, (function() { return this; }())))

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var call = __webpack_require__(511);
	var isArrayIter = __webpack_require__(337);
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(23);
	var getIterFn = __webpack_require__(353);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(11);
	var dPs = __webpack_require__(517);
	var enumBugKeys = __webpack_require__(333);
	var IE_PROTO = __webpack_require__(346)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(332)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(335).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(519);
	var hiddenKeys = __webpack_require__(333).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(519);
	var enumBugKeys = __webpack_require__(333);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(54);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var dP = __webpack_require__(28);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(22)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(71);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 132 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 133 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161),
	    getRawTag = __webpack_require__(1381),
	    objectToString = __webpack_require__(1408);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1342),
	    getValue = __webpack_require__(1382);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 137 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {var checkGlobal = __webpack_require__(1520);
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module), (function() { return this; }())))

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(385),
	    baseCastFunction = __webpack_require__(1495),
	    baseEach = __webpack_require__(208),
	    isArray = __webpack_require__(32);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior use `_.forIn` or `_.forOwn`
	 * for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => logs `1` then `2`
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a' then 'b' (iteration order is not guaranteed)
	 */
	function forEach(collection, iteratee) {
	  return (typeof iteratee == 'function' && isArray(collection))
	    ? arrayEach(collection, iteratee)
	    : baseEach(collection, baseCastFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(617),
	    baseKeys = __webpack_require__(1502),
	    indexKeys = __webpack_require__(630),
	    isArrayLike = __webpack_require__(170),
	    isIndex = __webpack_require__(210),
	    isPrototype = __webpack_require__(389);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1490),
	    toInteger = __webpack_require__(395);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 144 */
[1805, 20],
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(195);
	util.inherits = __webpack_require__(137);
	/*</replacement>*/
	
	var Readable = __webpack_require__(713);
	var Writable = __webpack_require__(431);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */
	var INVALID_PROPS = [
	    "active",
	    "containerRef",
	    "elementRef",
	    "iconName",
	    "inputRef",
	    "intent",
	    "inline",
	    "loading",
	    "leftIconName",
	    "onChildrenMount",
	    "onRemove",
	    "popoverProps",
	    "rightElement",
	    "rightIconName",
	    "text",
	];
	/**
	 * Typically applied to HTMLElements to filter out blacklisted props. When applied to a Component,
	 * can filter props from being passed down to the children. Can also filter by a combined list of
	 * supplied prop keys and the blacklist (only appropriate for HTMLElements).
	 * @param props The original props object to filter down.
	 * @param {string[]} invalidProps If supplied, overwrites the default blacklist.
	 * @param {boolean} shouldMerge If true, will merge supplied invalidProps and blacklist together.
	 */
	function removeNonHTMLProps(props, invalidProps, shouldMerge) {
	    if (invalidProps === void 0) { invalidProps = INVALID_PROPS; }
	    if (shouldMerge === void 0) { shouldMerge = false; }
	    if (shouldMerge) {
	        invalidProps = invalidProps.concat(INVALID_PROPS);
	    }
	    return invalidProps.reduce(function (prev, curr) {
	        if (prev.hasOwnProperty(curr)) {
	            delete prev[curr];
	        }
	        return prev;
	    }, tslib_1.__assign({}, props));
	}
	exports.removeNonHTMLProps = removeNonHTMLProps;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var react_dom_1 = __webpack_require__(39);
	var Tether = __webpack_require__(1778);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var PosUtils = __webpack_require__(88);
	var TetherUtils = __webpack_require__(433);
	var Utils = __webpack_require__(21);
	var isDarkTheme_1 = __webpack_require__(434);
	var overlay_1 = __webpack_require__(223);
	var tooltip_1 = __webpack_require__(307);
	var Arrows = __webpack_require__(741);
	var SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378" +
	    "-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
	var SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005" +
	    "c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
	var SMART_POSITIONING = {
	    attachment: "together",
	    to: "scrollParent",
	};
	var PopoverInteractionKind;
	(function (PopoverInteractionKind) {
	    PopoverInteractionKind[PopoverInteractionKind["CLICK"] = 0] = "CLICK";
	    PopoverInteractionKind[PopoverInteractionKind["CLICK_TARGET_ONLY"] = 1] = "CLICK_TARGET_ONLY";
	    PopoverInteractionKind[PopoverInteractionKind["HOVER"] = 2] = "HOVER";
	    PopoverInteractionKind[PopoverInteractionKind["HOVER_TARGET_ONLY"] = 3] = "HOVER_TARGET_ONLY";
	})(PopoverInteractionKind = exports.PopoverInteractionKind || (exports.PopoverInteractionKind = {}));
	var Popover = (function (_super) {
	    tslib_1.__extends(Popover, _super);
	    function Popover(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.hasDarkParent = false;
	        // a flag that is set to true while we are waiting for the underlying Portal to complete rendering
	        _this.isContentMounting = false;
	        _this.refHandlers = {
	            popover: function (ref) {
	                _this.popoverElement = ref;
	                _this.updateTether();
	                _this.updateArrowPosition();
	            },
	            target: function (ref) {
	                _this.targetElement = ref;
	            },
	        };
	        _this.handleContentMount = function () {
	            if (Utils.isFunction(_this.props.popoverDidOpen) && _this.isContentMounting) {
	                _this.props.popoverDidOpen();
	                _this.isContentMounting = false;
	            }
	        };
	        _this.handleTargetFocus = function (e) {
	            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
	                _this.handleMouseEnter(e);
	            }
	        };
	        _this.handleTargetBlur = function (e) {
	            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
	                // if the next element to receive focus is within the popover, we'll want to leave the
	                // popover open. we must do this check *after* the next element focuses, so we use a
	                // timeout of 0 to flush the rest of the event queue before proceeding.
	                requestAnimationFrame(function () {
	                    if (_this.popoverElement == null || !_this.popoverElement.contains(document.activeElement)) {
	                        _this.handleMouseLeave(e);
	                    }
	                });
	            }
	        };
	        _this.handleMouseEnter = function (e) {
	            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
	            // trigger the mouse leave event, as hovering over the popover shouldn't count.
	            if (_this.props.inline &&
	                _this.isElementInPopover(e.target) &&
	                _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY &&
	                !_this.props.openOnTargetFocus) {
	                _this.handleMouseLeave(e);
	            }
	            else if (!_this.props.isDisabled) {
	                // only begin opening popover when it is enabled
	                _this.setOpenStateByPropCallback(true, e, _this.props.hoverOpenDelay);
	            }
	        };
	        _this.handleMouseLeave = function (e) {
	            // user-configurable closing delay is helpful when moving mouse from target to popover
	            _this.setOpenStateByPropCallback(false, e, _this.props.hoverCloseDelay);
	        };
	        _this.handlePopoverClick = function (e) {
	            var eventTarget = e.target;
	            var shouldDismiss = eventTarget.closest("." + Classes.POPOVER_DISMISS) != null;
	            var overrideDismiss = eventTarget.closest("." + Classes.POPOVER_DISMISS_OVERRIDE) != null;
	            if (shouldDismiss && !overrideDismiss) {
	                _this.setOpenStateByPropCallback(false, e);
	            }
	        };
	        _this.handleOverlayClose = function (e) {
	            var eventTarget = e.target;
	            // if click was in target, target event listener will handle things, so don't close
	            if (!Utils.elementIsOrContains(_this.targetElement, eventTarget) || e.nativeEvent instanceof KeyboardEvent) {
	                _this.setOpenStateByPropCallback(false, e);
	            }
	        };
	        _this.handleTargetClick = function (e) {
	            // ensure click did not originate from within inline popover before closing
	            if (!_this.props.isDisabled && !_this.isElementInPopover(e.target)) {
	                if (_this.props.isOpen == null) {
	                    _this.setOpenStateDirectly(function (previousIsOpen) { return !previousIsOpen; });
	                }
	                else {
	                    _this.setOpenStateByPropCallback(!_this.props.isOpen, e);
	                }
	            }
	        };
	        var isOpen = props.defaultIsOpen && !props.isDisabled;
	        if (props.isOpen != null) {
	            isOpen = props.isOpen;
	        }
	        _this.state = {
	            ignoreTargetDimensions: false,
	            isOpen: isOpen,
	            targetHeight: 0,
	            targetWidth: 0,
	        };
	        return _this;
	    }
	    Popover.prototype.render = function () {
	        var className = this.props.className;
	        var isOpen = this.state.isOpen;
	        var targetProps;
	        if (this.isHoverInteractionKind()) {
	            targetProps = {
	                onBlur: this.handleTargetBlur,
	                onFocus: this.handleTargetFocus,
	                onMouseEnter: this.handleMouseEnter,
	                onMouseLeave: this.handleMouseLeave,
	            };
	            // any one of the CLICK* values
	        }
	        else {
	            targetProps = {
	                onClick: this.handleTargetClick,
	            };
	        }
	        targetProps.className = classNames(Classes.POPOVER_TARGET, (_a = {},
	            _a[Classes.POPOVER_OPEN] = isOpen,
	            _a), className);
	        targetProps.ref = this.refHandlers.target;
	        var children = this.understandChildren();
	        var targetTabIndex = this.props.openOnTargetFocus && this.isHoverInteractionKind() ? 0 : undefined;
	        var target = React.cloneElement(children.target, 
	        // force disable single Tooltip child when popover is open (BLUEPRINT-552)
	        isOpen && children.target.type === tooltip_1.Tooltip
	            ? { isDisabled: true, tabIndex: targetTabIndex }
	            : { tabIndex: targetTabIndex });
	        var isContentEmpty = children.content == null;
	        if (isContentEmpty && !this.props.isDisabled && isOpen !== false && !Utils.isNodeEnv("production")) {
	            console.warn(Errors.POPOVER_WARN_EMPTY_CONTENT);
	        }
	        return React.createElement(this.props.rootElementTag, targetProps, target, React.createElement(overlay_1.Overlay, { autoFocus: this.props.autoFocus, backdropClassName: Classes.POPOVER_BACKDROP, backdropProps: this.props.backdropProps, canEscapeKeyClose: this.props.canEscapeKeyClose, canOutsideClickClose: this.props.interactionKind === PopoverInteractionKind.CLICK, className: this.props.portalClassName, didOpen: this.handleContentMount, enforceFocus: this.props.enforceFocus, hasBackdrop: this.props.isModal, inline: this.props.inline, isOpen: isOpen && !isContentEmpty, lazy: this.props.lazy, onClose: this.handleOverlayClose, transitionDuration: this.props.transitionDuration, transitionName: Classes.POPOVER }, this.renderPopover(children.content)));
	        var _a;
	    };
	    Popover.prototype.componentDidMount = function () {
	        this.componentDOMChange();
	    };
	    Popover.prototype.componentWillReceiveProps = function (nextProps) {
	        _super.prototype.componentWillReceiveProps.call(this, nextProps);
	        if (nextProps.isOpen == null && nextProps.isDisabled && !this.props.isDisabled) {
	            // ok to use setOpenState here because isDisabled and isOpen are mutex.
	            this.setOpenStateByPropCallback(false);
	        }
	        else if (nextProps.isOpen !== this.props.isOpen) {
	            // propagate isOpen prop directly to state, circumventing onInteraction callback
	            // (which would be invoked if this went through setOpenState)
	            this.setOpenStateDirectly(nextProps.isOpen);
	        }
	    };
	    Popover.prototype.componentWillUpdate = function (_, nextState) {
	        if (!this.state.isOpen && nextState.isOpen) {
	            this.isContentMounting = true;
	            Utils.safeInvoke(this.props.popoverWillOpen);
	        }
	        else if (this.state.isOpen && !nextState.isOpen) {
	            Utils.safeInvoke(this.props.popoverWillClose);
	        }
	    };
	    Popover.prototype.componentDidUpdate = function () {
	        this.componentDOMChange();
	    };
	    Popover.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	        this.destroyTether();
	    };
	    Popover.prototype.validateProps = function (props) {
	        if (props.useSmartPositioning || props.constraints != null) {
	            console.warn(Errors.POPOVER_WARN_DEPRECATED_CONSTRAINTS);
	        }
	        if (props.isOpen == null && props.onInteraction != null) {
	            console.warn(Errors.POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
	        }
	        if (props.inline && (props.useSmartPositioning || props.constraints != null || props.tetherOptions != null)) {
	            console.warn(Errors.POPOVER_WARN_INLINE_NO_TETHER);
	        }
	        if (props.isModal && props.inline) {
	            console.warn(Errors.POPOVER_WARN_MODAL_INLINE);
	        }
	        if (props.isModal && props.interactionKind !== PopoverInteractionKind.CLICK) {
	            throw new Error(Errors.POPOVER_MODAL_INTERACTION);
	        }
	        var childrenCount = React.Children.count(props.children);
	        var hasContentProp = props.content !== undefined;
	        var hasTargetProp = props.target !== undefined;
	        if (childrenCount === 0 && !hasTargetProp) {
	            throw new Error(Errors.POPOVER_REQUIRES_TARGET);
	        }
	        if (childrenCount > 2) {
	            console.warn(Errors.POPOVER_WARN_TOO_MANY_CHILDREN);
	        }
	        if (childrenCount > 0 && hasTargetProp) {
	            console.warn(Errors.POPOVER_WARN_DOUBLE_TARGET);
	        }
	        if (childrenCount === 2 && hasContentProp) {
	            console.warn(Errors.POPOVER_WARN_DOUBLE_CONTENT);
	        }
	    };
	    Popover.prototype.componentDOMChange = function () {
	        if (this.targetElement == null) {
	            return;
	        }
	        if (this.props.useSmartArrowPositioning) {
	            this.setState({
	                targetHeight: this.targetElement.clientHeight,
	                targetWidth: this.targetElement.clientWidth,
	            });
	        }
	        if (!this.props.inline) {
	            this.updateTether();
	        }
	        if (!this.props.inline && this.state.isOpen) {
	            this.checkDOMForDarkTheme();
	        }
	    };
	    Popover.prototype.renderPopover = function (content) {
	        var _a = this.props, inline = _a.inline, interactionKind = _a.interactionKind;
	        var popoverHandlers = {
	            // always check popover clicks for dismiss class
	            onClick: this.handlePopoverClick,
	        };
	        if (interactionKind === PopoverInteractionKind.HOVER ||
	            (inline && interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY)) {
	            popoverHandlers.onMouseEnter = this.handleMouseEnter;
	            popoverHandlers.onMouseLeave = this.handleMouseLeave;
	        }
	        var positionClasses = TetherUtils.getAttachmentClasses(this.props.position).join(" ");
	        var containerClasses = classNames(Classes.TRANSITION_CONTAINER, (_b = {}, _b[positionClasses] = inline, _b));
	        var popoverClasses = classNames(Classes.POPOVER, (_c = {},
	            _c[Classes.DARK] = this.props.inheritDarkTheme && this.hasDarkParent && !inline,
	            _c), this.props.popoverClassName);
	        var styles = this.getArrowPositionStyles();
	        var transform = { transformOrigin: this.getPopoverTransformOrigin() };
	        return (React.createElement("div", { className: containerClasses, ref: this.refHandlers.popover, style: styles.container },
	            React.createElement("div", tslib_1.__assign({ className: popoverClasses, style: transform }, popoverHandlers),
	                React.createElement("div", { className: Classes.POPOVER_ARROW, style: styles.arrow },
	                    React.createElement("svg", { viewBox: "0 0 30 30" },
	                        React.createElement("path", { className: Classes.POPOVER_ARROW + "-border", d: SVG_SHADOW_PATH }),
	                        React.createElement("path", { className: Classes.POPOVER_ARROW + "-fill", d: SVG_ARROW_PATH }))),
	                React.createElement("div", { className: Classes.POPOVER_CONTENT }, content))));
	        var _b, _c;
	    };
	    // content and target can be specified as props or as children.
	    // this method normalizes the two approaches, preferring child over prop.
	    Popover.prototype.understandChildren = function () {
	        var _a = this.props, children = _a.children, contentProp = _a.content, targetProp = _a.target;
	        // #validateProps asserts that 1 <= children.length <= 2 so content is optional
	        var _b = React.Children.toArray(children), targetChild = _b[0], contentChild = _b[1];
	        return {
	            content: ensureElement(contentChild == null ? contentProp : contentChild),
	            target: ensureElement(targetChild == null ? targetProp : targetChild),
	        };
	    };
	    Popover.prototype.getArrowPositionStyles = function () {
	        if (this.props.useSmartArrowPositioning) {
	            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
	            return Arrows.getArrowPositionStyles(this.props.position, this.props.arrowSize, this.state.ignoreTargetDimensions, dimensions, this.props.inline);
	        }
	        else {
	            return {};
	        }
	    };
	    Popover.prototype.getPopoverTransformOrigin = function () {
	        // if smart positioning is enabled then we must rely on CSS classes to put transform origin
	        // on the correct side and cannot override it in JS. (https://github.com/HubSpot/tether/issues/154)
	        if (this.props.useSmartArrowPositioning && !this.props.useSmartPositioning) {
	            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
	            return Arrows.getPopoverTransformOrigin(this.props.position, this.props.arrowSize, dimensions);
	        }
	        else {
	            return undefined;
	        }
	    };
	    Popover.prototype.updateArrowPosition = function () {
	        if (this.popoverElement != null) {
	            var arrow = this.popoverElement.getElementsByClassName(Classes.POPOVER_ARROW)[0];
	            var centerWidth = (this.state.targetWidth + arrow.clientWidth) / 2;
	            var centerHeight = (this.state.targetHeight + arrow.clientHeight) / 2;
	            var ignoreWidth = centerWidth > this.popoverElement.clientWidth && PosUtils.isPositionHorizontal(this.props.position);
	            var ignoreHeight = centerHeight > this.popoverElement.clientHeight && PosUtils.isPositionVertical(this.props.position);
	            if (!this.state.ignoreTargetDimensions && (ignoreWidth || ignoreHeight)) {
	                this.setState({ ignoreTargetDimensions: true });
	            }
	            else if (this.state.ignoreTargetDimensions && !ignoreWidth && !ignoreHeight) {
	                this.setState({ ignoreTargetDimensions: false });
	            }
	        }
	    };
	    Popover.prototype.updateTether = function () {
	        var _this = this;
	        if (this.state.isOpen && !this.props.inline && this.popoverElement != null) {
	            var _a = this.props, constraints = _a.constraints, position = _a.position, _b = _a.tetherOptions, tetherOptions = _b === void 0 ? {} : _b, useSmartPositioning = _a.useSmartPositioning;
	            // the .pt-popover-target span we wrap the children in won't always be as big as its children
	            // so instead, we'll position tether based off of its first child.
	            // NOTE: use findDOMNode(this) directly because this.targetElement may not exist yet
	            var target = react_dom_1.findDOMNode(this).childNodes[0];
	            // constraints is deprecated but must still be supported through tetherOptions until v2.0
	            var options = constraints == null && !useSmartPositioning
	                ? tetherOptions
	                : tslib_1.__assign({}, tetherOptions, { constraints: useSmartPositioning ? [SMART_POSITIONING] : constraints });
	            var finalTetherOptions = TetherUtils.createTetherOptions(this.popoverElement, target, position, options);
	            if (this.tether == null) {
	                this.tether = new Tether(finalTetherOptions);
	            }
	            else {
	                this.tether.setOptions(finalTetherOptions);
	            }
	            // if props.position has just changed, Tether unfortunately positions the popover based
	            // on the margins from the previous position. delay a frame for styles to catch up.
	            setTimeout(function () { return _this.tether.position(); });
	        }
	        else {
	            this.destroyTether();
	        }
	    };
	    Popover.prototype.destroyTether = function () {
	        if (this.tether != null) {
	            this.tether.destroy();
	        }
	    };
	    // a wrapper around setState({isOpen}) that will call props.onInteraction instead when in controlled mode.
	    // starts a timeout to delay changing the state if a non-zero duration is provided.
	    Popover.prototype.setOpenStateByPropCallback = function (isOpen, e, timeout) {
	        var _this = this;
	        // cancel any existing timeout because we have new state
	        Utils.safeInvoke(this.cancelOpenTimeout);
	        if (timeout > 0) {
	            this.cancelOpenTimeout = this.setTimeout(function () { return _this.setOpenStateByPropCallback(isOpen, e); }, timeout);
	        }
	        else {
	            if (this.props.isOpen == null) {
	                this.setOpenStateDirectly(isOpen);
	            }
	            else {
	                Utils.safeInvoke(this.props.onInteraction, isOpen);
	            }
	            if (!isOpen) {
	                Utils.safeInvoke(this.props.onClose, e);
	            }
	        }
	    };
	    Popover.prototype.setOpenStateDirectly = function (isOpen) {
	        var _this = this;
	        if (Utils.isFunction(isOpen)) {
	            this.setState(function (previousState) {
	                var nextIsOpen = isOpen(previousState.isOpen);
	                if (nextIsOpen) {
	                    _this.checkDOMForDarkTheme();
	                }
	                return { isOpen: nextIsOpen };
	            });
	        }
	        else {
	            if (isOpen) {
	                this.checkDOMForDarkTheme();
	            }
	            this.setState({ isOpen: isOpen });
	        }
	    };
	    Popover.prototype.isElementInPopover = function (element) {
	        return this.popoverElement != null && this.popoverElement.contains(element);
	    };
	    Popover.prototype.isHoverInteractionKind = function () {
	        return (this.props.interactionKind === PopoverInteractionKind.HOVER ||
	            this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY);
	    };
	    // This may cause a preemptive DOM reflow so should be avoided when the tether is not present
	    Popover.prototype.checkDOMForDarkTheme = function () {
	        this.hasDarkParent = isDarkTheme_1.isDarkTheme(this.targetElement);
	    };
	    Popover.defaultProps = {
	        arrowSize: 30,
	        className: "",
	        defaultIsOpen: false,
	        hoverCloseDelay: 300,
	        hoverOpenDelay: 150,
	        inheritDarkTheme: true,
	        inline: false,
	        interactionKind: PopoverInteractionKind.CLICK,
	        isDisabled: false,
	        isModal: false,
	        openOnTargetFocus: true,
	        popoverClassName: "",
	        position: PosUtils.Position.RIGHT,
	        rootElementTag: "span",
	        transitionDuration: 300,
	        useSmartArrowPositioning: true,
	        useSmartPositioning: false,
	    };
	    Popover.displayName = "Blueprint.Popover";
	    Popover = tslib_1.__decorate([
	        PureRender
	    ], Popover);
	    return Popover;
	}(abstractComponent_1.AbstractComponent));
	exports.Popover = Popover;
	/**
	 * Converts a react child to an element: non-empty strings or numbers are wrapped in `<span>`;
	 * empty strings are discarded.
	 */
	function ensureElement(child) {
	    // wrap text in a <span> so children are always elements
	    if (typeof child === "string") {
	        // cull whitespace strings
	        return child.trim().length > 0 ? React.createElement("span", null, child) : undefined;
	    }
	    else if (typeof child === "number") {
	        return React.createElement("span", null, child);
	    }
	    else {
	        return child;
	    }
	}
	exports.PopoverFactory = React.createFactory(Popover);


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDepartments = getDepartments;
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _normalizr = __webpack_require__(64);
	
	var _schema = __webpack_require__(109);
	
	var _departmentService = __webpack_require__(954);
	
	var _departmentService2 = _interopRequireDefault(_departmentService);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDepartments(storeId, page, count, orderBy) {
	  return function (dispatch) {
	    return _departmentService2.default.getList(storeId).then(function (data) {
	      data.data = (0, _map2.default)(data.data, function (d) {
	        return d.department;
	      });
	      var normalizedData = (0, _normalizr.normalize)(data, {
	        data: (0, _normalizr.arrayOf)(_schema.DepartmentSchema)
	      });
	
	      dispatch({ type: _entityActions.SET_ENTITIES, collection: 'departments', data: normalizedData.entities.departments });
	    });
	  };
	}

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitKitchenDepartmentSelection = exports.toggleKitchenDepartmentSelection = exports.closeKitchenDepartmentSelection = exports.toggleAllKitchenDepartmentSelection = exports.openKitchenDepartmentSelection = exports.getAllKitchenDepartments = exports.GET_SELECTED = exports.SAVE_KITCHEN_DEPARTMENT_SELECTION = exports.TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION = exports.TOGGLE_KITCHEN_DEPARTMENT_SELECTION = exports.CLOSE_KITCHEN_DEPARTMENT_SELECTION = exports.OPEN_KITCHEN_DEPARTMENT_SELECTION = exports.GET_ALL_KITCHEN_DEPARTMENTS = undefined;
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_ALL_KITCHEN_DEPARTMENTS = exports.GET_ALL_KITCHEN_DEPARTMENTS = 'GET_ALL_KITCHEN_DEPARTMENTS';
	var OPEN_KITCHEN_DEPARTMENT_SELECTION = exports.OPEN_KITCHEN_DEPARTMENT_SELECTION = 'OPEN_KITCHEN_DEPARTMENT_SELECTION';
	var CLOSE_KITCHEN_DEPARTMENT_SELECTION = exports.CLOSE_KITCHEN_DEPARTMENT_SELECTION = 'CLOSE_KITCHEN_DEPARTMENT_SELECTION';
	var TOGGLE_KITCHEN_DEPARTMENT_SELECTION = exports.TOGGLE_KITCHEN_DEPARTMENT_SELECTION = 'TOGGLE_KITCHEN_DEPARTMENT_SELECTION';
	var TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION = exports.TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION = 'TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION';
	var SAVE_KITCHEN_DEPARTMENT_SELECTION = exports.SAVE_KITCHEN_DEPARTMENT_SELECTION = 'SAVE_KITCHEN_DEPARTMENT_SELECTION';
	var GET_SELECTED = exports.GET_SELECTED = 'GET_SELECTED';
	
	var getAllKitchenDepartments = exports.getAllKitchenDepartments = function getAllKitchenDepartments(payload) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: GET_ALL_KITCHEN_DEPARTMENTS,
	      payload: payload
	    });
	  };
	};
	
	var openKitchenDepartmentSelection = exports.openKitchenDepartmentSelection = function openKitchenDepartmentSelection(storeId, _ref) {
	  var selected = _ref.selected,
	      params = _ref.params;
	
	  return function (dispatch, getState) {
	    var department = getState().forms.kitchenDepartmentSelection.all;
	    dispatch({ type: OPEN_KITCHEN_DEPARTMENT_SELECTION, all: (0, _values2.default)(department), selected: selected.slice(), params: params });
	  };
	};
	
	var toggleAllKitchenDepartmentSelection = exports.toggleAllKitchenDepartmentSelection = function toggleAllKitchenDepartmentSelection(checked) {
	  return function (dispatch, getState) {
	    dispatch({ type: TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION, checked: checked });
	  };
	};
	
	var closeKitchenDepartmentSelection = exports.closeKitchenDepartmentSelection = function closeKitchenDepartmentSelection() {
	  return { type: CLOSE_KITCHEN_DEPARTMENT_SELECTION };
	};
	
	var toggleKitchenDepartmentSelection = exports.toggleKitchenDepartmentSelection = function toggleKitchenDepartmentSelection(id, checked) {
	  return { type: TOGGLE_KITCHEN_DEPARTMENT_SELECTION, id: id, checked: checked };
	};
	
	var submitKitchenDepartmentSelection = exports.submitKitchenDepartmentSelection = function submitKitchenDepartmentSelection(openerSubmitCallback) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$kitchenD = state.forms.kitchenDepartmentSelection,
	        selected = _state$forms$kitchenD.selected,
	        params = _state$forms$kitchenD.params;
	
	    dispatch({ type: SAVE_KITCHEN_DEPARTMENT_SELECTION, selected: selected, params: params });
	    if (typeof openerSubmitCallback === 'function') {
	      openerSubmitCallback();
	    }
	  };
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeLineItemStatus = exports.updateLineItemStatus = undefined;
	exports.createLineItemStatus = createLineItemStatus;
	exports.getLineItemStatuses = getLineItemStatuses;
	
	var _lineItemStatusService = __webpack_require__(958);
	
	var _lineItemStatusService2 = _interopRequireDefault(_lineItemStatusService);
	
	var _baseActions = __webpack_require__(34);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createLineItemStatus(status, color, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _lineItemStatusService2.default.createLineItemStatus(status, color, storeId).then(function (resp) {
	      var data = resp.data,
	          message = resp.message;
	
	      if (data) {
	        var id = data.id;
	
	        dispatch({ type: _entityActions.ADD_ENTITY, collection: 'lineItemStatuses', id: id, data: data });
	        dispatch((0, _baseActions.stopFetch)());
	        return { data: data };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	}
	
	function getLineItemStatuses(storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _lineItemStatusService2.default.getLineItemStatuses(storeId).then(function (resp) {
	      var data = resp.data,
	          message = resp.message;
	
	      if (data) {
	        var entities = {};
	        if (data && data.line_item_statuses) {
	          data.line_item_statuses.forEach(function (s) {
	            var id = s.id;
	
	            entities[id] = s;
	          });
	        }
	        dispatch({ type: _entityActions.SET_ENTITIES, collection: 'lineItemStatuses', data: entities });
	        dispatch((0, _baseActions.stopFetch)());
	        return { data: data };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	}
	
	var updateLineItemStatus = exports.updateLineItemStatus = function updateLineItemStatus(id, status, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _lineItemStatusService2.default.updateLineItemStatus(id, status, storeId).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var message = resp.message;
	
	      if (message === 'success') {
	        dispatch({ type: _entityActions.UPDATE_ENTITY, collection: 'lineItemStatuses', id: id, data: status });
	        return { error: null };
	      } else {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      return { error: e };
	    });
	  };
	};
	
	var removeLineItemStatus = exports.removeLineItemStatus = function removeLineItemStatus(id, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _lineItemStatusService2.default.removeLineItemStatus(id, storeId).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var message = resp.message;
	
	      if (message === 'success') {
	        dispatch({ type: _entityActions.REMOVE_ENTITY, collection: 'lineItemStatuses', id: id });
	      } else {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      return { error: e };
	    });
	  };
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.savePromoCode = exports.updatePromoCodeField = exports.cancelEditPromoCode = exports.loadPromoCodeItem = exports.loadPromoCodeList = exports.MODE_CHANGE = exports.UPDATE_PROMO_CODE_ITEM_FIELD = exports.LOAD_PROMO_CODE_ITEM_SUCCESS = exports.LOAD_PROMO_CODE_LIST_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.modeChange = modeChange;
	
	var _reactRouter = __webpack_require__(9);
	
	var _baseActions = __webpack_require__(34);
	
	var _alertActions = __webpack_require__(90);
	
	var _constants = __webpack_require__(26);
	
	var _promoCodeService = __webpack_require__(963);
	
	var _promoCodeService2 = _interopRequireDefault(_promoCodeService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOAD_PROMO_CODE_LIST_SUCCESS = exports.LOAD_PROMO_CODE_LIST_SUCCESS = 'LOAD_PROMO_CODE_LIST_SUCCESS';
	var LOAD_PROMO_CODE_ITEM_SUCCESS = exports.LOAD_PROMO_CODE_ITEM_SUCCESS = 'LOAD_PROMO_CODE_ITEM_SUCCESS';
	
	var UPDATE_PROMO_CODE_ITEM_FIELD = exports.UPDATE_PROMO_CODE_ITEM_FIELD = 'UPDATE_PROMO_CODE_ITEM_FIELD';
	
	var MODE_CHANGE = exports.MODE_CHANGE = 'MODE_CHANGE';
	
	function loadPromoCodeListSuccess(promoCodes, totalEntries, totalPages) {
	  return {
	    type: LOAD_PROMO_CODE_LIST_SUCCESS,
	    payload: { promoCodes: promoCodes, totalEntries: totalEntries, totalPages: totalPages }
	  };
	}
	
	function modeChange(mode, extra) {
	  return {
	    type: MODE_CHANGE,
	    payload: _extends({
	      mode: mode
	    }, extra)
	  };
	}
	
	var loadPromoCodeList = exports.loadPromoCodeList = function loadPromoCodeList(storeId, page, count, filters) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	    return _promoCodeService2.default.getList(storeId, page, count, filters).then(function (response) {
	      var promoCodes = response.data.map(function (item) {
	        return item.coupon;
	      });
	      return dispatch(loadPromoCodeListSuccess(promoCodes, response.totalCount, response.totalPages));
	    }).catch(function (err) {
	      dispatch((0, _alertActions.alert)('danger', err.message));
	    }).then(function () {
	      return dispatch((0, _baseActions.stopFetch)());
	    });
	  };
	};
	
	var loadPromoCodeItem = exports.loadPromoCodeItem = function loadPromoCodeItem(storeId, promoCodeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	    dispatch(modeChange(_constants.PROMO_CODE.MODE.EDIT, { storeId: storeId, promoCodeId: promoCodeId }));
	    return _promoCodeService2.default.getItem(storeId, promoCodeId).then(function (response) {
	      return dispatch({
	        type: LOAD_PROMO_CODE_ITEM_SUCCESS,
	        promoCode: response.coupon
	      });
	    }).catch(function (err) {
	      return dispatch((0, _alertActions.alert)('danger', err.message));
	    }).then(function () {
	      return dispatch((0, _baseActions.stopFetch)());
	    });
	  };
	};
	
	var cancelEditPromoCode = exports.cancelEditPromoCode = function cancelEditPromoCode(mode, storeId, promoCodeId) {
	  _reactRouter.browserHistory.goBack();
	  return modeChange(_constants.PROMO_CODE.MODE.VIEW);
	};
	
	var updatePromoCodeField = exports.updatePromoCodeField = function updatePromoCodeField(field, value) {
	  return {
	    type: UPDATE_PROMO_CODE_ITEM_FIELD,
	    payload: { field: field, value: value }
	  };
	};
	
	var savePromoCode = exports.savePromoCode = function savePromoCode(storeId, promoCode) {
	  return function (dispatch) {
	    if (!promoCode.code) {
	      return dispatch((0, _alertActions.alert)('warning', 'code is required'));
	    } else if (!promoCode.discount) {
	      return dispatch((0, _alertActions.alert)('warning', 'discount is required'));
	    }
	    dispatch((0, _baseActions.startFetch)());
	    return _promoCodeService2.default.saveItem(storeId, promoCode).then(function () {
	      dispatch((0, _alertActions.alert)('success', 'Promo Code Saved'));
	    }).catch(function (err) {
	      dispatch((0, _alertActions.alert)('danger', err.message));
	    }).then(function () {
	      return dispatch((0, _baseActions.stopFetch)());
	    });
	  };
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _formatHelper = __webpack_require__(35);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function InputCurrency(props, context) {
	    var _context$currentStore = context.currentStore,
	        currentStore = _context$currentStore === undefined ? {} : _context$currentStore;
	    var defaultCurrency = currentStore.currency;
	
	    var currency = props.currency,
	        otherProps = _objectWithoutProperties(props, ['currency']);
	
	    var prefix = (0, _formatHelper.currencySymbol)(currency || defaultCurrency);
	    return _react2.default.createElement(_inputNumber2.default, _extends({ prefix: prefix, dp: 4 }, otherProps));
	}
	
	InputCurrency.contextTypes = {
	    currentStore: _propTypes2.default.object
	};
	
	InputCurrency.propTypes = {
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(_big2.default)]),
	    dp: _propTypes2.default.number,
	    currency: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    readOnly: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool
	};
	
	exports.default = InputCurrency;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputNumber = (_temp2 = _class = function (_Component) {
	  _inherits(InputNumber, _Component);
	
	  function InputNumber() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: _this.getValue(_this.props.value),
	      mask: _this.valueToMask(_this.props.value)
	    }, _this.onFocus = function () {
	      var input = _this.refs.input;
	      input.select();
	    }, _this.onBlur = function () {
	      var value = _this.state.value;
	
	      var mask = _this.valueToMask(value);
	      _this.setState({ value: value, mask: mask });
	      _this.callOnChange(value);
	    }, _this.onKeyPress = function (event) {
	      var validKey = '0123456789-' + (_this.props.dp > 0 ? '.' : '');
	      var key = event.data;
	
	      if (validKey.indexOf(key) < 0) {
	        event.preventDefault();
	      }
	    }, _this.onChange = function (event) {
	      var newMask = event.target.value || '';
	
	      if (newMask === '') {
	        _this.setState({ value: (0, _big2.default)(0), mask: '' });
	      } else {
	        var decode = _this.decodeMask(newMask);
	        if (decode.valid) {
	          _this.setState({ value: decode.value, mask: decode.mask });
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //TODO: calculate state in one method
	
	
	  _createClass(InputNumber, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Update state when input element is not focus
	      if (document.activeElement !== this.refs.input) {
	        this.setState({
	          value: this.getValue(nextProps.value),
	          mask: this.valueToMask(nextProps.value)
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(value) {
	      if (value === null || value === '') {
	        return '';
	      } else {
	        return (0, _big2.default)(value);
	      }
	    }
	  }, {
	    key: 'valueToMask',
	    value: function valueToMask(value) {
	      if (value === null || value === '') return '';
	      return this.decodeMask((0, _big2.default)(value).toString()).formatted;
	    }
	  }, {
	    key: 'decodeMask',
	    value: function decodeMask(mask) {
	      var _props = this.props,
	          dp = _props.dp,
	          _props$prefix = _props.prefix,
	          prefix = _props$prefix === undefined ? '' : _props$prefix,
	          _props$suffix = _props.suffix,
	          suffix = _props$suffix === undefined ? '' : _props$suffix,
	          signAfterPrefix = _props.signAfterPrefix;
	
	      return (0, _formatHelper.decodeNumberMask)(mask, { dp: dp, prefix: prefix, suffix: suffix, signAfterPrefix: signAfterPrefix });
	    }
	  }, {
	    key: 'callOnChange',
	    value: function callOnChange(value) {
	      if (typeof this.props.onChange === 'function') {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          _props2$style = _props2.style,
	          style = _props2$style === undefined ? {} : _props2$style,
	          readOnly = _props2.readOnly,
	          disabled = _props2.disabled,
	          placeholder = _props2.placeholder;
	      var mask = this.state.mask;
	
	      var eventHandler = readOnly ? {} : {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onBeforeInput: this.onKeyPress,
	        onChange: this.onChange
	      };
	      return _react2.default.createElement('input', _extends({
	        ref: 'input',
	        className: 'form-control ' + className,
	        style: Object.assign({ textAlign: 'right' }, style),
	        type: 'text',
	        value: mask,
	        readOnly: readOnly,
	        disabled: disabled
	      }, eventHandler, {
	        placeholder: placeholder
	      }));
	    }
	  }]);
	
	  return InputNumber;
	}(_react.Component), _class.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(_big2.default)]),
	  dp: _propTypes2.default.number,
	  signAfterPrefix: _propTypes2.default.bool,
	  prefix: _propTypes2.default.string,
	  suffix: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  readOnly: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  placeholder: _propTypes2.default.string
	}, _class.defaultProps = {
	  value: 0,
	  dp: 2,
	  signAfterPrefix: false,
	  prefix: '',
	  suffix: '',
	  onChange: function onChange() {},
	  className: '',
	  style: {},
	  readOnly: false,
	  disabled: false,
	  placeholder: ''
	}, _temp2);
	exports.default = InputNumber;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _humps = __webpack_require__(44);
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _lodash = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { normalize, arrayOf } from 'normalizr';
	// import { ListingSchema } from '../store/middlewares/schema';
	
	var InventoryService = function (_BindoService) {
	  _inherits(InventoryService, _BindoService);
	
	  function InventoryService() {
	    _classCallCheck(this, InventoryService);
	
	    return _possibleConstructorReturn(this, (InventoryService.__proto__ || Object.getPrototypeOf(InventoryService)).apply(this, arguments));
	  }
	
	  _createClass(InventoryService, [{
	    key: 'getUnits',
	    value: function getUnits(storeId, unit_group_id) {
	      var path = 'v2/stores/' + storeId + '/unit_groups/' + unit_group_id;
	      return this.get(path);
	    }
	  }, {
	    key: 'validateImportInventory',
	    value: function validateImportInventory(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/';
	      return this.postFile(path, data);
	    }
	  }, {
	    key: 'postImportInventory',
	    value: function postImportInventory(storeId, inventory_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/' + inventory_import_id + '/import';
	      var query = {
	        inventory_import_id: inventory_import_id
	      };
	      return this.post(path, query);
	    }
	  }, {
	    key: 'postImagesToImportInventory',
	    value: function postImagesToImportInventory(storeId, data, inventory_import_id, progress) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/' + inventory_import_id + '/images';
	      return this.postFileWithProgress(path, data, progress);
	    }
	  }, {
	    key: 'postImagesToS3',
	    value: function postImagesToS3(path, data, progress) {
	      return this.postFileWithProgress(path, data, progress);
	    }
	  }, {
	    key: 'postImagesToValidate',
	    value: function postImagesToValidate(storeId, inventory_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/' + inventory_import_id + '/verify_uploaded_images';
	      return this.put(path);
	    }
	  }, {
	    key: 'getImagesUploadURL',
	    value: function getImagesUploadURL(storeId, inventory_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/' + inventory_import_id + '/image_import_url';
	      return this.get(path);
	    }
	  }, {
	    key: 'getImportInventory',
	    value: function getImportInventory(storeId, inventory_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_imports/' + inventory_import_id;
	      return this.get(path);
	    }
	  }, {
	    key: 'postCustomItem',
	    value: function postCustomItem(storeId, listing) {
	      listing.barcode = listing.listing_barcode; // POST .barcode will update .listing_barcode
	
	      var path = 'v2/stores/' + storeId + '/unique_products/';
	      var data = {
	        unique_product: listing
	      };
	      return this.post(path, data);
	    }
	  }, {
	    key: 'postItem',
	    value: function postItem(storeId, listing) {
	      var path = 'v2/stores/' + storeId + '/listings/';
	      var data = {
	        listing: listing
	      };
	      return this.post(path, data);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(storeId, listingId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId;
	
	      return this.get(path);
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems(storeId, listingIds) {
	      var path = 'v2/stores/' + storeId + '/listings/by';
	      var query = {
	        listing_ids: listingIds.join(',')
	      };
	
	      return this.get(path, query);
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(storeId, listingId, data) {
	      data.barcode = data.listing_barcode; // PUT .barcode will update .listing_barcode
	
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId;
	
	      return this.put(path, { listing: data });
	    }
	  }, {
	    key: 'deleteItem',
	    value: function deleteItem(storeId, listingId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId;
	
	      return this.delete(path);
	    }
	  }, {
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/listings';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: 'name',
	        filters: filtersQueryList
	      };
	
	      return this.get(path, query);
	    }
	  }, {
	    key: 'search',
	    value: function search(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/listings';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: 'name',
	        filters: filtersQueryList
	      };
	
	      return this.get(path, query).then(function (res) {
	        res.data = res.data.map(function (d) {
	          return d.listing;
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'getQuantityHistory',
	    value: function getQuantityHistory(storeId, listingId) {
	      var path = 'v3/stores/' + storeId + '/listings/' + listingId + '/quantity_histories';
	
	      return this.get(path, null, _config2.default.analytics);
	    }
	  }, {
	    key: 'getProductGraphics',
	    value: function getProductGraphics(productId) {
	      var path = 'v2/products/' + productId + '/product_graphics';
	
	      return this.get(path);
	    }
	  }, {
	    key: 'uploadProductGraphics',
	    value: function uploadProductGraphics(product_id, file) {
	      var fd = new FormData();
	      fd.append('product_graphic[image]', file);
	      fd.append('product_graphic[default]', false);
	
	      return this.postFile('v2/products/' + product_id + '/product_graphics', fd);
	    }
	  }, {
	    key: 'deleteProductGraphics',
	    value: function deleteProductGraphics(product_id, graphic_id) {
	      var path = 'v2/products/' + product_id + '/product_graphics/' + graphic_id;
	
	      return this.delete(path);
	    }
	  }, {
	    key: 'setDefaultProductGraphics',
	    value: function setDefaultProductGraphics(product_id, graphic_id) {
	      var path = 'v1/products/' + product_id + '/product_graphics/' + graphic_id + '/mark_as_default';
	      return _get(InventoryService.prototype.__proto__ || Object.getPrototypeOf(InventoryService.prototype), 'put', this).call(this, path);
	    }
	  }, {
	    key: 'getProductByUPC',
	    value: function getProductByUPC(upc) {
	      var path = 'v2/products/' + upc + '/name';
	      return _get(InventoryService.prototype.__proto__ || Object.getPrototypeOf(InventoryService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'searchEs',
	    value: function searchEs(storeIds) {
	      var searchParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
	      var fields = arguments[4];
	
	      var search = _extends({}, searchParams);
	      search.filter = _extends({}, search.filter, { storeId: storeIds });
	      search.sort = search.sort || [{ createdAt: 'desc' }]; // Default sroting
	      if (fields) {
	        search.fields = fields;
	      }
	      var data = (0, _humps.decamelizeKeys)({
	        search: search,
	        page: page,
	        perPage: perPage
	      });
	      var path = 'v2/listings/search';
	      return this.post(path, data);
	    }
	  }, {
	    key: 'searchByBarcode',
	    value: function searchByBarcode(storeId, barcode, baseSearch) {
	      var _this2 = this;
	
	      var isExactMatch = false;
	      var bcode = barcode;
	      var typeOfCodeToSearch = ['upc', 'ean13', 'listing_barcode', 'bpid'];
	      if (/^BP-.+/i.test(bcode)) {
	        isExactMatch = true;
	        bcode = bcode.slice(3);
	        typeOfCodeToSearch = ['bpid'];
	      }
	      var promises = typeOfCodeToSearch.map(function (type) {
	        var search = isExactMatch ? { filter: _defineProperty({}, type, bcode) } : { wildcard: _defineProperty({}, type, bcode) };
	        search = (0, _lodash.merge)({}, search, baseSearch);
	        return _this2.searchEs(storeId, search).then(function (res) {
	          // Match the old API data format for "v2/stores/${store_id}/listings"
	          if (res.data && res.data.listings) {
	            res.data = res.data.listings || [];
	          }
	          res.data = (res.data || []).map(function (item) {
	            return { listing: item };
	          });
	          return res;
	        });
	      });
	      return Promise.all(promises).then(function (res) {
	        var data = res.reduce(function (ret, r) {
	          return ret.concat(r.data);
	        }, []);
	        data = (0, _lodash.uniqBy)(data, 'listing.id');
	        return { data: data };
	      });
	    }
	  }]);
	
	  return InventoryService;
	}(_bindoService2.default);
	
	exports.default = new InventoryService();

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(67);
	var TAG = __webpack_require__(22)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(28).f;
	var has = __webpack_require__(60);
	var TAG = __webpack_require__(22)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var defined = __webpack_require__(78);
	var fails = __webpack_require__(16);
	var spaces = __webpack_require__(349);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 161 */
[1790, 81],
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(38),
	    isKey = __webpack_require__(366),
	    stringToPath = __webpack_require__(1421),
	    toString = __webpack_require__(581);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(258),
	    baseAssignValue = __webpack_require__(549);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1320),
	    Map = __webpack_require__(356),
	    Promise = __webpack_require__(1322),
	    Set = __webpack_require__(1323),
	    WeakMap = __webpack_require__(1324),
	    baseGetTag = __webpack_require__(134),
	    toSource = __webpack_require__(572);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(205);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 167 */
[1788, 275, 138],
/* 168 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return type == 'number' || type == 'boolean' ||
	    (type == 'string' && value != '__proto__') || value == null;
	}
	
	module.exports = isKeyable;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(1536),
	    isFunction = __webpack_require__(212),
	    isLength = __webpack_require__(284);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(403);
	var setInnerHTML = __webpack_require__(293);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(411);
	var setTextContent = __webpack_require__(667);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1639);
	var ReactInstrumentation = __webpack_require__(74);
	
	var warning = __webpack_require__(13);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 175 */
[1807, 1723],
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	var ReactCurrentOwner = __webpack_require__(102);
	
	var warning = __webpack_require__(13);
	var canDefineProperty = __webpack_require__(691);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(690);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 177 */
20,
/* 178 */
40,
/* 179 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectDiscount = exports.filterChange = exports.loadDiscountOptions = exports.closeSelectDiscountModal = exports.openSelectDiscountModal = exports.SELECT_DISCOUNT = exports.FILTER_CHANGE = exports.LOAD_DISCOUNT_OPTIONS_FAIL = exports.LOAD_DISCOUNT_OPTIONS_SUCCESS = exports.LOAD_DISCOUNT_OPTIONS = exports.CLOSE_SELECT_DISCOUNT_MODAL = exports.OPEN_SELECT_DISCOUNT_MODAL = undefined;
	
	var _discountService = __webpack_require__(955);
	
	var _discountService2 = _interopRequireDefault(_discountService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPEN_SELECT_DISCOUNT_MODAL = exports.OPEN_SELECT_DISCOUNT_MODAL = 'OPEN_SELECT_DISCOUNT_MODAL';
	var CLOSE_SELECT_DISCOUNT_MODAL = exports.CLOSE_SELECT_DISCOUNT_MODAL = 'CLOSE_SELECT_DISCOUNT_MODAL';
	
	var LOAD_DISCOUNT_OPTIONS = exports.LOAD_DISCOUNT_OPTIONS = 'LOAD_DISCOUNT_OPTIONS';
	var LOAD_DISCOUNT_OPTIONS_SUCCESS = exports.LOAD_DISCOUNT_OPTIONS_SUCCESS = 'LOAD_DISCOUNT_OPTIONS_SUCCESS';
	var LOAD_DISCOUNT_OPTIONS_FAIL = exports.LOAD_DISCOUNT_OPTIONS_FAIL = 'LOAD_DISCOUNT_OPTIONS_FAIL';
	
	var FILTER_CHANGE = exports.FILTER_CHANGE = 'FILTER_CHANGE';
	var SELECT_DISCOUNT = exports.SELECT_DISCOUNT = 'SELECT_DISCOUNT';
	
	var openSelectDiscountModal = exports.openSelectDiscountModal = function openSelectDiscountModal(name, modalInitState) {
	  return {
	    type: OPEN_SELECT_DISCOUNT_MODAL,
	    payload: { name: name, modalInitState: modalInitState }
	  };
	};
	
	var closeSelectDiscountModal = exports.closeSelectDiscountModal = function closeSelectDiscountModal() {
	  return {
	    type: CLOSE_SELECT_DISCOUNT_MODAL
	  };
	};
	
	function loadDiscountOptionsSuccess(discounts) {
	  return {
	    type: LOAD_DISCOUNT_OPTIONS_SUCCESS,
	    discounts: discounts
	  };
	}
	
	var loadDiscountOptions = exports.loadDiscountOptions = function loadDiscountOptions(storeId) {
	  return function (dispatch) {
	    dispatch({ type: LOAD_DISCOUNT_OPTIONS });
	    try {
	      return _discountService2.default.getList(storeId).then(function (response) {
	        return response.data.map(function (item) {
	          return item.discount;
	        });
	      }).then(function (discounts) {
	        return dispatch(loadDiscountOptionsSuccess(discounts));
	      });
	    } catch (err) {
	      console.error(err);
	      dispatch({
	        type: LOAD_DISCOUNT_OPTIONS_FAIL,
	        err: err
	      });
	    }
	  };
	};
	
	var filterChange = exports.filterChange = function filterChange(value) {
	  return {
	    type: FILTER_CHANGE,
	    value: value
	  };
	};
	
	var selectDiscount = exports.selectDiscount = function selectDiscount(_ref) {
	  var id = _ref.id;
	  return {
	    type: SELECT_DISCOUNT,
	    id: id
	  };
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.payInvoice = exports.refundInvoice = exports.changeFields = exports.changeField = exports.changeTenderAmount = exports.changeAmount = exports.changePaymentType = exports.changeRefundTo = exports.closePaymentRefundModal = exports.openPaymentRefundModal = exports.setErrors = exports.addErrors = exports.clearErrors = exports.stopLoading = exports.startLoading = exports.PAYMENT_REFUND_SUCCESS_PAY = exports.PAYMENT_REFUND_SUCCESS_REFUND = exports.PAYMENT_REFUND_SET_ERRORS = exports.PAYMENT_REFUND_ADD_ERRORS = exports.PAYMENT_REFUND_CLEAR_ERRORS = exports.PAYMENT_REFUND_STOP_LOADING = exports.PAYMENT_REFUND_START_LOADING = exports.PAYMENT_REFUND_CHANGE_FIELDS = exports.PAYMENT_REFUND_CHANGE_TENDER_AMOUNT = exports.PAYMENT_REFUND_CHANGE_AMOUNT = exports.PAYMENT_REFUND_CHANGE_PAYMENT_TYPE = exports.PAYMENT_REFUND_CHANGE_REFUND_TO = exports.PAYMENT_REFUND_CLOSE = exports.PAYMENT_REFUND_OPEN = exports.PAYMENT_REFUND_INIT = undefined;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _moment = __webpack_require__(143);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _humps = __webpack_require__(44);
	
	var _invoiceService = __webpack_require__(323);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _otherPaymentInstrumentService = __webpack_require__(325);
	
	var _otherPaymentInstrumentService2 = _interopRequireDefault(_otherPaymentInstrumentService);
	
	var _paymentRefundModal = __webpack_require__(236);
	
	var _paymentRefundModal2 = _interopRequireDefault(_paymentRefundModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPE = _paymentRefundModal2.default.TYPE,
	    DEFAULT_PAYMENT_TYPE = _paymentRefundModal2.default.DEFAULT_PAYMENT_TYPE;
	var PAYMENT_REFUND_INIT = exports.PAYMENT_REFUND_INIT = 'PAYMENT_REFUND_INIT';
	var PAYMENT_REFUND_OPEN = exports.PAYMENT_REFUND_OPEN = 'PAYMENT_REFUND_OPEN';
	var PAYMENT_REFUND_CLOSE = exports.PAYMENT_REFUND_CLOSE = 'PAYMENT_REFUND_CLOSE';
	var PAYMENT_REFUND_CHANGE_REFUND_TO = exports.PAYMENT_REFUND_CHANGE_REFUND_TO = 'PAYMENT_REFUND_CHANGE_REFUND_TO';
	var PAYMENT_REFUND_CHANGE_PAYMENT_TYPE = exports.PAYMENT_REFUND_CHANGE_PAYMENT_TYPE = 'PAYMENT_REFUND_CHANGE_PAYMENT_TYPE';
	var PAYMENT_REFUND_CHANGE_AMOUNT = exports.PAYMENT_REFUND_CHANGE_AMOUNT = 'PAYMENT_REFUND_CHANGE_AMOUNT';
	var PAYMENT_REFUND_CHANGE_TENDER_AMOUNT = exports.PAYMENT_REFUND_CHANGE_TENDER_AMOUNT = 'PAYMENT_REFUND_CHANGE_TENDER_AMOUNT';
	var PAYMENT_REFUND_CHANGE_FIELDS = exports.PAYMENT_REFUND_CHANGE_FIELDS = 'PAYMENT_REFUND_CHANGE_FIELDS';
	var PAYMENT_REFUND_START_LOADING = exports.PAYMENT_REFUND_START_LOADING = 'PAYMENT_REFUND_START_LOADING';
	var PAYMENT_REFUND_STOP_LOADING = exports.PAYMENT_REFUND_STOP_LOADING = 'PAYMENT_REFUND_STOP_LOADING';
	var PAYMENT_REFUND_CLEAR_ERRORS = exports.PAYMENT_REFUND_CLEAR_ERRORS = 'PAYMENT_REFUND_CLEAR_ERRORS';
	var PAYMENT_REFUND_ADD_ERRORS = exports.PAYMENT_REFUND_ADD_ERRORS = 'PAYMENT_REFUND_ADD_ERRORS';
	var PAYMENT_REFUND_SET_ERRORS = exports.PAYMENT_REFUND_SET_ERRORS = 'PAYMENT_REFUND_SET_ERRORS';
	var PAYMENT_REFUND_SUCCESS_REFUND = exports.PAYMENT_REFUND_SUCCESS_REFUND = 'PAYMENT_REFUND_SUCCESS_REFUND';
	var PAYMENT_REFUND_SUCCESS_PAY = exports.PAYMENT_REFUND_SUCCESS_PAY = 'PAYMENT_REFUND_SUCCESS_PAY';
	
	var startLoading = exports.startLoading = function startLoading() {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_START_LOADING });
	  };
	};
	
	var stopLoading = exports.stopLoading = function stopLoading() {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_STOP_LOADING });
	  };
	};
	
	var clearErrors = exports.clearErrors = function clearErrors() {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_CLEAR_ERRORS });
	  };
	};
	
	var addErrors = exports.addErrors = function addErrors(errors) {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_ADD_ERRORS, payload: { errors: errors } });
	  };
	};
	
	var setErrors = exports.setErrors = function setErrors(errors) {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_SET_ERRORS, payload: { errors: errors } });
	  };
	};
	
	var openPaymentRefundModal = exports.openPaymentRefundModal = function openPaymentRefundModal(type, storeId) {
	  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var refundTo = arguments[3];
	  return function (dispatch, getState) {
	    var number = order.number,
	        _order$saleTransactio = order.saleTransactions,
	        saleTransactions = _order$saleTransactio === undefined ? [] : _order$saleTransactio,
	        _order$refundTransact = order.refundTransactions,
	        refundTransactions = _order$refundTransact === undefined ? [] : _order$refundTransact,
	        total = order.total,
	        paidTotal = order.paidTotal,
	        refundTotal = order.refundTotal,
	        amountLefted = order.amountLefted;
	
	    var settled = (0, _big2.default)(paidTotal || 0).minus((0, _big2.default)(refundTotal || 0));
	    var now = (0, _moment2.default)();
	    var payload = {
	      type: type,
	      storeId: storeId,
	      orderNumber: number,
	      amountDue: total,
	      amountSettled: settled,
	      amountBalance: amountLefted,
	      refundTo: refundTo,
	      saleTransactions: saleTransactions,
	      refundTransactions: refundTransactions,
	      expYear: now.format('YY'),
	      expMonth: now.format('MM')
	    };
	    dispatch({ type: PAYMENT_REFUND_INIT });
	    dispatch({ type: PAYMENT_REFUND_OPEN, payload: payload });
	    if (type === TYPE.PAYMENT) {
	      startLoading()(dispatch);
	      changeAmount(amountLefted)(dispatch);
	      return _otherPaymentInstrumentService2.default.getAll(storeId).then(function (res) {
	        var data = (0, _humps.camelizeKeys)(res);
	        var _data$paymentInstrume = data.paymentInstruments,
	            paymentInstruments = _data$paymentInstrume === undefined ? [] : _data$paymentInstrume;
	
	        changeFields({ paymentInstruments: paymentInstruments })(dispatch);
	        stopLoading()(dispatch);
	      }).catch(function (err) {
	        var errors = err && err.message ? [err.message] : ['Fail to get other payment types.'];
	        setErrors(errors)(dispatch);
	        stopLoading()(dispatch);
	      });
	    } else {
	      changeRefundTo(refundTo)(dispatch, getState);
	    }
	  };
	};
	
	var closePaymentRefundModal = exports.closePaymentRefundModal = function closePaymentRefundModal() {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_CLOSE });
	  };
	};
	
	var changeRefundTo = exports.changeRefundTo = function changeRefundTo(refundTo) {
	  return function (dispatch) {
	    dispatch({
	      type: PAYMENT_REFUND_CHANGE_REFUND_TO,
	      payload: {
	        refundTo: refundTo ? Number(refundTo) : null
	      }
	    });
	  };
	};
	
	var changePaymentType = exports.changePaymentType = function changePaymentType(instrumentId) {
	  return function (dispatch, getState) {
	    dispatch({ type: PAYMENT_REFUND_CHANGE_PAYMENT_TYPE, payload: { instrumentId: instrumentId } });
	  };
	};
	
	var changeAmount = exports.changeAmount = function changeAmount(amount) {
	  return function (dispatch, getState) {
	    dispatch({ type: PAYMENT_REFUND_CHANGE_AMOUNT, payload: { amount: amount } });
	  };
	};
	
	var changeTenderAmount = exports.changeTenderAmount = function changeTenderAmount(tenderAmount) {
	  return function (dispatch, getState) {
	    dispatch({ type: PAYMENT_REFUND_CHANGE_TENDER_AMOUNT, payload: { tenderAmount: tenderAmount } });
	  };
	};
	
	var changeField = exports.changeField = function changeField(field, value) {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_CHANGE_FIELDS, payload: _defineProperty({}, field, value) });
	  };
	};
	
	var changeFields = exports.changeFields = function changeFields(fields) {
	  return function (dispatch) {
	    dispatch({ type: PAYMENT_REFUND_CHANGE_FIELDS, payload: fields });
	  };
	};
	
	var refundInvoice = exports.refundInvoice = function refundInvoice() {
	  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (dispatch) {
	    var storeId = order.storeId,
	        orderNumber = order.orderNumber,
	        refundTo = order.refundTo,
	        amount = order.amount,
	        note = order.note;
	
	    if (storeId && orderNumber && refundTo && (0, _big2.default)(amount || 0).gt(0)) {
	      var transactions = [{ transaction_id: refundTo, amount: amount.toString(), note: note }];
	      startLoading()(dispatch);
	      return _invoiceService2.default.returnMoney(storeId, orderNumber, transactions).then(function (res) {
	        var data = (0, _humps.camelizeKeys)(res);
	        var order = data.order;
	
	        dispatch({ type: PAYMENT_REFUND_SUCCESS_REFUND, payload: { order: order, amount: amount } });
	        stopLoading()(dispatch);
	      }).catch(function (err) {
	        var errors = err && err.message ? [err.message] : ['Fail to refund transactions.'];
	        setErrors(errors)(dispatch);
	        stopLoading()(dispatch);
	      });
	    }
	  };
	};
	
	var validateCreditCard = function validateCreditCard() {
	  var payment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var errors = [];
	  var number = payment.number,
	      cvv = payment.cvv;
	
	  if (!number) {
	    errors.push('Card Number is required.');
	  } else if (!/\d{16}/.test(number)) {
	    errors.push('Card Number is not valid');
	  }
	  if (!cvv) {
	    errors.push('CVV/CVC is required.');
	  } else if (!/\d{3,4}/.test(cvv)) {
	    errors.push('CVV/CVC is not valid');
	  }
	  return errors;
	};
	
	var payInvoice = exports.payInvoice = function payInvoice(order) {
	  return function (dispatch) {
	    var storeId = order.storeId,
	        orderNumber = order.orderNumber,
	        instrumentId = order.instrumentId,
	        instrumentName = order.instrumentName,
	        amount = order.amount,
	        tipsAmount = order.tipsAmount,
	        changeAmount = order.changeAmount,
	        showTips = order.showTips,
	        showChange = order.showChange,
	        note = order.note,
	        cardNumber = order.cardNumber,
	        expMonth = order.expMonth,
	        expYear = order.expYear,
	        cvv = order.cvv;
	
	
	    if (storeId && orderNumber && instrumentId && (0, _big2.default)(amount || 0).gt(0)) {
	      var _paymentTypes;
	
	      var errors = [];
	      var payment = {
	        amount: amount.toString(),
	        note: note
	      };
	      if (showChange) {
	        payment.changeAmount = changeAmount.toString();
	      }
	      if (showTips) {
	        payment.tipsAmount = tipsAmount.toString();
	        payment.amount = amount.add(tipsAmount).toString(); // Tips affect pay amount
	      }
	      var paymentTypes = (_paymentTypes = {}, _defineProperty(_paymentTypes, DEFAULT_PAYMENT_TYPE.CASH, 'cashes'), _defineProperty(_paymentTypes, DEFAULT_PAYMENT_TYPE.CHECK, 'checks'), _defineProperty(_paymentTypes, DEFAULT_PAYMENT_TYPE.CREDIT_CARD, 'creditCards'), _defineProperty(_paymentTypes, DEFAULT_PAYMENT_TYPE.STORE_CREDIT, 'storeCredits'), _defineProperty(_paymentTypes, DEFAULT_PAYMENT_TYPE.OCTOPUS, 'octopuses'), _paymentTypes);
	      var otherPaymentType = 'others';
	      var paymentType = paymentTypes[instrumentId] ? paymentTypes[instrumentId] : otherPaymentType;
	      if (paymentType === otherPaymentType) {
	        payment = Object.assign({}, payment, {
	          instrumentId: instrumentId,
	          instrumentName: instrumentName
	        });
	      }
	      if (instrumentId === DEFAULT_PAYMENT_TYPE.CREDIT_CARD) {
	        payment = Object.assign({}, payment, {
	          number: cardNumber,
	          expMonth: expMonth,
	          expYear: expYear,
	          cvv: cvv
	        });
	        errors = validateCreditCard(payment);
	      }
	
	      if (errors.length > 0) {
	        setErrors(errors)(dispatch);
	      } else {
	        var data = _defineProperty({}, paymentType, [payment]);
	        var params = (0, _humps.decamelizeKeys)(data);
	        clearErrors()(dispatch);
	        startLoading()(dispatch);
	        return _invoiceService2.default.payMoney(storeId, orderNumber, params).then(function (res) {
	          var data = (0, _humps.camelizeKeys)(res);
	          var order = data.order;
	
	          dispatch({ type: PAYMENT_REFUND_SUCCESS_PAY, payload: { order: order, amount: amount } });
	          stopLoading()(dispatch);
	        }).catch(function (err) {
	          var errors = err && err.message ? [err.message] : ['Fail to pay transactions.'];
	          setErrors(errors)(dispatch);
	          stopLoading()(dispatch);
	        });
	      }
	    }
	  };
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LINK_STATION_TO_STORE = exports.SET_STATIONS_STATUS = undefined;
	exports.updateStationsFilters = updateStationsFilters;
	exports.updateStationsStatus = updateStationsStatus;
	exports.getStations = getStations;
	exports.updateStation = updateStation;
	exports.removeStation = removeStation;
	exports.linkStationToStore = linkStationToStore;
	exports.getStation = getStation;
	
	var _kdsService = __webpack_require__(957);
	
	var _kdsService2 = _interopRequireDefault(_kdsService);
	
	var _baseActions = __webpack_require__(34);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_STATIONS_STATUS = exports.SET_STATIONS_STATUS = 'SET_STATIONS_STATUS';
	var LINK_STATION_TO_STORE = exports.LINK_STATION_TO_STORE = 'LINK_STATION_TO_STORE';
	
	function updateStationsFilters() {
	  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var status = {
	    filters: filters
	  };
	
	  return {
	    type: SET_STATIONS_STATUS,
	    data: status
	  };
	}
	
	function updateStationsStatus(data) {
	  return {
	    type: SET_STATIONS_STATUS,
	    data: data
	  };
	}
	
	function getStations(storeId, page, count, orderBy) {
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	    dispatch({ type: SET_STATIONS_STATUS, data: { loading: true } });
	
	    return _kdsService2.default.getStations(storeId, page, count, orderBy, filters).then(function (data) {
	      var totalCount = data.totalCount,
	          totalPages = data.totalPages,
	          page = data.page,
	          count = data.count;
	
	
	      var entities = {};
	      if (data.data && data.data.stations) {
	        data.data.stations.forEach(function (station) {
	          var id = station.id;
	
	          entities[id] = station;
	        });
	      }
	      var status = {
	        totalCount: totalCount,
	        totalPages: totalPages,
	        page: page,
	        count: count,
	        filters: filters,
	        loading: false
	      };
	
	      dispatch({ type: SET_STATIONS_STATUS, data: status });
	      dispatch({ type: _entityActions.SET_ENTITIES, collection: 'stations', data: entities });
	      dispatch((0, _baseActions.stopFetch)());
	    }).catch(function (ex) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var listingStatus = {
	        loading: false
	      };
	
	      dispatch({ type: SET_STATIONS_STATUS, data: listingStatus });
	    });
	  };
	}
	
	function updateStation(data, id, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _kdsService2.default.updateStation(data, id, storeId).then(function (data) {
	      dispatch({ type: _entityActions.UPDATE_ENTITY, collection: 'stations', id: id, data: data });
	      dispatch((0, _baseActions.stopFetch)());
	      return { data: data };
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	}
	
	function removeStation(id, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _kdsService2.default.removeStation(id, storeId).then(function (data) {
	      dispatch({ type: _entityActions.REMOVE_ENTITY, collection: 'stations', id: id });
	      dispatch((0, _baseActions.stopFetch)());
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	    });
	  };
	}
	
	function linkStationToStore(stationKey, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _kdsService2.default.linkStationToStore({ station_key: stationKey }, storeId).then(function (data) {
	      var station = data.station,
	          message = data.message;
	
	      if (station) {
	        var id = station.id;
	
	        dispatch({ type: _entityActions.ADD_ENTITY, collection: 'stations', id: id, data: station });
	        dispatch({ type: SET_STATIONS_STATUS, data: { loading: false } });
	        dispatch((0, _baseActions.stopFetch)());
	        return { id: id };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch({ type: SET_STATIONS_STATUS, data: { loading: false } });
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	}
	
	function getStation(stationId, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _kdsService2.default.getStation(stationId, storeId).then(function (result) {
	      var station = result.station;
	
	      if (station) {
	        var id = station.id;
	
	        dispatch({ type: _entityActions.ADD_ENTITY, collection: 'stations', id: id, data: station });
	        dispatch({ type: SET_STATIONS_STATUS, data: { loading: false } });
	        dispatch((0, _baseActions.stopFetch)());
	      }
	      return { station: station };
	    }).catch(function (e) {
	      dispatch({ type: SET_STATIONS_STATUS, data: { loading: false } });
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	}

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMembershipLevels = getMembershipLevels;
	exports.getMembershipLevel = getMembershipLevel;
	exports.createMembershipLevel = createMembershipLevel;
	exports.updateMembershipLevel = updateMembershipLevel;
	exports.removeMembershipLevel = removeMembershipLevel;
	
	var _without = __webpack_require__(398);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _concat = __webpack_require__(281);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _baseActions = __webpack_require__(34);
	
	var _membershipLevelsService = __webpack_require__(960);
	
	var _membershipLevelsService2 = _interopRequireDefault(_membershipLevelsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getMembershipLevels(storeId, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _membershipLevelsService2.default.getList(storeId),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'membership_level',
	      path: path
	    }
	  });
	}
	
	function getMembershipLevel(storeId, id, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _membershipLevelsService2.default.getItem(storeId, id),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'memberships',
	      path: path
	    }
	  });
	}
	
	function createMembershipLevel(storeId, data, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _membershipLevelsService2.default.createItem(storeId, data),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'membership_level',
	      path: path,
	      callback: function callback(state, result) {
	        return (0, _concat2.default)(state, [result]);
	      }
	    }
	  });
	}
	
	function updateMembershipLevel(storeId, id, data, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _membershipLevelsService2.default.updateItem(storeId, id, data),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'membership_level',
	      path: path,
	      callback: function callback(state, result) {
	        return state;
	      }
	    }
	  });
	}
	
	function removeMembershipLevel(storeId, id, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _membershipLevelsService2.default.removeItem(storeId, id),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'membership_level',
	      path: path,
	      callback: function callback(state, result) {
	        return (0, _without2.default)(state, result);
	      }
	    }
	  });
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DateTimeDisplay(props, context) {
	    var value = props.value,
	        formField = props.formField,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        style = props.style;
	
	    var compClassName = (formField ? 'form-control' : '') + ' ' + className;
	    var timezone = props.timezone ? props.timezone : context.currentStore && context.currentStore.timezone;
	    var dateString = value ? (0, _formatHelper.dateTime)(value, timezone) : '\xA0';
	
	    return _react2.default.createElement(
	        'span',
	        { className: compClassName, style: style, readOnly: formField },
	        dateString
	    );
	}
	
	DateTimeDisplay.contextTypes = {
	    currentStore: _propTypes2.default.object.isRequired
	};
	
	DateTimeDisplay.propTypes = {
	    value: _propTypes2.default.string,
	    timezone: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    formField: _propTypes2.default.bool
	};
	
	exports.default = DateTimeDisplay;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildStoreTree = buildStoreTree;
	exports.moduleEnabled = moduleEnabled;
	exports.isAllowStoreTransfer = isAllowStoreTransfer;
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function buildStoreTree(stores) {
	  var rootStores = stores.reduce(function (acc, store, index, stores) {
	    if (!(0, _find2.default)(stores, { id: store.parent_id })) {
	      acc.push(store);
	    }
	    return acc;
	  }, []);
	
	  rootStores.forEach(function (rootStore) {
	    rootStore._children = stores.filter(function (store) {
	      return store.parent_id == rootStore.id;
	    });
	  }, []);
	
	  return rootStores;
	}
	
	function moduleEnabled(name, storeModule) {
	  var m = storeModule || {};
	  var mm = m.module || {};
	  return !!m[name] || !!(mm || {})[name];
	}
	
	function isAllowStoreTransfer(chain_info) {
	  try {
	    return chain_info.allow_store_transfer.current.length > 0;
	    // console.log('chain_info.allow_store_transfer.current.length > 0', chain_info.allow_store_transfer.current.length > 0);
	  } catch (e) {
	    return false;
	  }
	}

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ROOT_ROUTE = exports.ROOT_ROUTE = 'delivery-note';
	var VIEW = exports.VIEW = 'view';
	var NEW = exports.NEW = 'new';
	var EDIT = exports.EDIT = 'edit';
	var OVERVIEW = exports.OVERVIEW = 'overview';
	var REMARKS = exports.REMARKS = 'remarks';
	var LOG = exports.LOG = 'log';

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1264);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Breadcrumb(props) {
	    var _props$links = props.links,
	        links = _props$links === undefined ? [] : _props$links,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'breadcrumb ' + className },
	        links.reduce(function (els, item, i, ary) {
	            var len = ary.length;
	            var className = 'breadcrumb__link ' + (item.active ? 'breadcrumb__link--active' : '');
	            var to = item.link,
	                label = item.label,
	                _onClick = item.onClick;
	
	            var comp = to ? _reactRouter.Link : 'span';
	            var key = els.length;
	            if (typeof _onClick === 'function') {
	                els.push((0, _react.createElement)('a', { className: className, key: key, href: '#', onClick: function onClick(event) {
	                        event.preventDefault();
	                        _onClick(event);
	                    } }, label));
	            } else {
	                els.push((0, _react.createElement)(comp, { className: className, to: to, key: key }, label));
	            }
	            els.push(i < len - 1 ? _react2.default.createElement(
	                'span',
	                { className: 'breadcrumb__separator', key: els.length },
	                '>'
	            ) : null);
	            return els;
	        }, [])
	    );
	}
	
	Breadcrumb.propTypes = {
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        label: _propTypes2.default.string.isRequired,
	        link: _propTypes2.default.string,
	        active: _propTypes2.default.bool,
	        onClick: _propTypes2.default.func
	    })).isRequired,
	    className: _propTypes2.default.string
	};
	
	exports.default = Breadcrumb;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1268);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainContentHeader(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        title = props.title,
	        children = props.children;
	
	    return _react2.default.createElement(
	        'header',
	        { className: 'main-content-header columns ' + className },
	        !title ? null : _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            title
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            children
	        )
	    );
	}
	
	MainContentHeader.propTypes = {
	    className: _propTypes2.default.string,
	    title: _propTypes2.default.node,
	    children: _propTypes2.default.node
	};
	
	exports.default = MainContentHeader;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1269);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainContentSection(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'main-content-section ' + className },
	        props.children
	    );
	}
	
	MainContentSection.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node
	};
	
	exports.default = MainContentSection;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1271);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainContent(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        transparent = props.transparent;
	
	    var style = {};
	    if (transparent) {
	        style.background = 'transparent';
	    }
	    return _react2.default.createElement(
	        'div',
	        { className: 'main-content ' + className, style: style },
	        props.children
	    );
	}
	
	MainContent.propTypes = {
	    className: _propTypes2.default.string,
	    transparent: _propTypes2.default.bool,
	    children: _propTypes2.default.node
	};
	
	exports.default = MainContent;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(11);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(67);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 193 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(49);
	var SPECIES = __webpack_require__(22)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122).Buffer))

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var map = __webpack_require__(578);
	var filter = __webpack_require__(573);
	var find = __webpack_require__(368);
	var sortBy = __webpack_require__(1444);
	var difference = __webpack_require__(1424);
	
	var ColumnProperties = (function () {
	  function ColumnProperties() {
	    var allColumns = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	    var filteredColumns = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	    var childrenColumnName = arguments.length <= 2 || arguments[2] === undefined ? "children" : arguments[2];
	    var columnMetadata = arguments.length <= 3 || arguments[3] === undefined ? [] : arguments[3];
	    var metadataColumns = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	
	    _classCallCheck(this, ColumnProperties);
	
	    this.allColumns = allColumns;
	    this.filteredColumns = filteredColumns;
	    this.childrenColumnName = childrenColumnName;
	    this.columnMetadata = columnMetadata;
	    this.metadataColumns = metadataColumns;
	  }
	
	  _createClass(ColumnProperties, [{
	    key: 'getMetadataColumns',
	    value: function getMetadataColumns() {
	      var meta = map(filter(this.columnMetadata, { visible: false }), function (item) {
	        return item.columnName;
	      });
	      if (meta.indexOf(this.childrenColumnName) < 0) {
	        meta.push(this.childrenColumnName);
	      }
	      return meta.concat(this.metadataColumns);
	    }
	  }, {
	    key: 'getVisibleColumnCount',
	    value: function getVisibleColumnCount() {
	      return this.getColumns().length;
	    }
	  }, {
	    key: 'getColumnMetadataByName',
	    value: function getColumnMetadataByName(name) {
	      return find(this.columnMetadata, { columnName: name });
	    }
	  }, {
	    key: 'hasColumnMetadata',
	    value: function hasColumnMetadata() {
	      return this.columnMetadata !== null && this.columnMetadata.length > 0;
	    }
	  }, {
	    key: 'getMetadataColumnProperty',
	    value: function getMetadataColumnProperty(columnName, propertyName, defaultValue) {
	      var meta = this.getColumnMetadataByName(columnName);
	
	      //send back the default value if meta isn't there
	      if (typeof meta === "undefined" || meta === null) return defaultValue;
	
	      return meta.hasOwnProperty(propertyName) ? meta[propertyName] : defaultValue;
	    }
	  }, {
	    key: 'orderColumns',
	    value: function orderColumns(cols) {
	      var _this = this;
	
	      var ORDER_MAX = 100;
	
	      var orderedColumns = sortBy(cols, function (item) {
	        var metaItem = find(_this.columnMetadata, { columnName: item });
	
	        if (typeof metaItem === 'undefined' || metaItem === null || isNaN(metaItem.order)) {
	          return ORDER_MAX;
	        }
	
	        return metaItem.order;
	      });
	
	      return orderedColumns;
	    }
	  }, {
	    key: 'getColumns',
	    value: function getColumns() {
	      //if we didn't set default or filter
	      var filteredColumns = this.filteredColumns.length === 0 ? this.allColumns : this.filteredColumns;
	
	      filteredColumns = difference(filteredColumns, this.metadataColumns);
	
	      filteredColumns = this.orderColumns(filteredColumns);
	
	      return filteredColumns;
	    }
	  }]);
	
	  return ColumnProperties;
	})();
	
	module.exports = ColumnProperties;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1346),
	    baseMatchesProperty = __webpack_require__(1347),
	    identity = __webpack_require__(204),
	    isArray = __webpack_require__(38),
	    property = __webpack_require__(579);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(204),
	    overRest = __webpack_require__(570),
	    setToString = __webpack_require__(571);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1447);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122).Buffer))

/***/ },
/* 208 */
[1794, 274, 1531],
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1492),
	    isArguments = __webpack_require__(283),
	    isArray = __webpack_require__(32),
	    isArrayLikeObject = __webpack_require__(211);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && isArrayLikeObject(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 210 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(170),
	    isObjectLike = __webpack_require__(140);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(209),
	    basePick = __webpack_require__(621),
	    rest = __webpack_require__(142);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property names to pick, specified
	 *  individually or in arrays.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = rest(function(object, props) {
	  return object == null ? {} : basePick(object, baseFlatten(props, 1));
	});
	
	module.exports = pick;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(56);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var ReactPropTypesSecret = __webpack_require__(645);
	var checkPropTypes = __webpack_require__(1597);
	
	module.exports = function (isValidElement) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  var ReactPropTypes;
	
	  if (false) {
	    // Keep in sync with production version below
	    ReactPropTypes = {
	      array: createPrimitiveTypeChecker('array'),
	      bool: createPrimitiveTypeChecker('boolean'),
	      func: createPrimitiveTypeChecker('function'),
	      number: createPrimitiveTypeChecker('number'),
	      object: createPrimitiveTypeChecker('object'),
	      string: createPrimitiveTypeChecker('string'),
	      symbol: createPrimitiveTypeChecker('symbol'),
	
	      any: createAnyTypeChecker(),
	      arrayOf: createArrayOfTypeChecker,
	      element: createElementTypeChecker(),
	      instanceOf: createInstanceTypeChecker,
	      node: createNodeChecker(),
	      objectOf: createObjectOfTypeChecker,
	      oneOf: createEnumTypeChecker,
	      oneOfType: createUnionTypeChecker,
	      shape: createShapeTypeChecker
	    };
	  } else {
	    var productionTypeChecker = function () {
	      invariant(false, 'React.PropTypes type checking code is stripped in production.');
	    };
	    productionTypeChecker.isRequired = productionTypeChecker;
	    var getProductionTypeChecker = function () {
	      return productionTypeChecker;
	    };
	    // Keep in sync with development version above
	    ReactPropTypes = {
	      array: productionTypeChecker,
	      bool: productionTypeChecker,
	      func: productionTypeChecker,
	      number: productionTypeChecker,
	      object: productionTypeChecker,
	      string: productionTypeChecker,
	      symbol: productionTypeChecker,
	
	      any: productionTypeChecker,
	      arrayOf: getProductionTypeChecker,
	      element: productionTypeChecker,
	      instanceOf: getProductionTypeChecker,
	      node: productionTypeChecker,
	      objectOf: getProductionTypeChecker,
	      oneOf: getProductionTypeChecker,
	      oneOfType: getProductionTypeChecker,
	      shape: getProductionTypeChecker
	    };
	  }
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	      if (false) {
	        if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	          var cacheKey = componentName + ':' + propName;
	          if (!manualPropTypeCallCache[cacheKey]) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	            manualPropTypeCallCache[cacheKey] = true;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var EventPluginRegistry = __webpack_require__(404);
	var EventPluginUtils = __webpack_require__(405);
	var ReactErrorUtils = __webpack_require__(409);
	
	var accumulateInto = __webpack_require__(660);
	var forEachAccumulated = __webpack_require__(661);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(215);
	var EventPluginUtils = __webpack_require__(405);
	
	var accumulateInto = __webpack_require__(660);
	var forEachAccumulated = __webpack_require__(661);
	var warning = __webpack_require__(13);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	var getEventTarget = __webpack_require__(414);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(535).EventEmitter;
	var inherits = __webpack_require__(137);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(1774);
	Stream.Writable = __webpack_require__(1776);
	Stream.Duplex = __webpack_require__(1772);
	Stream.Transform = __webpack_require__(1775);
	Stream.PassThrough = __webpack_require__(1773);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * validate.js 0.9.0
	 *
	 * (c) 2013-2015 Nicklas Ansman, 2013 Wrapp
	 * Validate.js may be freely distributed under the MIT license.
	 * For all details and documentation:
	 * http://validatejs.org/
	 */
	
	(function(exports, module, define) {
	  "use strict";
	
	  // The main function that calls the validators specified by the constraints.
	  // The options are the following:
	  //   - format (string) - An option that controls how the returned value is formatted
	  //     * flat - Returns a flat array of just the error messages
	  //     * grouped - Returns the messages grouped by attribute (default)
	  //     * detailed - Returns an array of the raw validation data
	  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
	  //
	  // Please note that the options are also passed to each validator.
	  var validate = function(attributes, constraints, options) {
	    options = v.extend({}, v.options, options);
	
	    var results = v.runValidations(attributes, constraints, options)
	      , attr
	      , validator;
	
	    for (attr in results) {
	      for (validator in results[attr]) {
	        if (v.isPromise(results[attr][validator])) {
	          throw new Error("Use validate.async if you want support for promises");
	        }
	      }
	    }
	    return validate.processValidationResults(results, options);
	  };
	
	  var v = validate;
	
	  // Copies over attributes from one or more sources to a single destination.
	  // Very much similar to underscore's extend.
	  // The first argument is the target object and the remaining arguments will be
	  // used as sources.
	  v.extend = function(obj) {
	    [].slice.call(arguments, 1).forEach(function(source) {
	      for (var attr in source) {
	        obj[attr] = source[attr];
	      }
	    });
	    return obj;
	  };
	
	  v.extend(validate, {
	    // This is the version of the library as a semver.
	    // The toString function will allow it to be coerced into a string
	    version: {
	      major: 0,
	      minor: 9,
	      patch: 0,
	      metadata: null,
	      toString: function() {
	        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
	        if (!v.isEmpty(v.version.metadata)) {
	          version += "+" + v.version.metadata;
	        }
	        return version;
	      }
	    },
	
	    // Below is the dependencies that are used in validate.js
	
	    // The constructor of the Promise implementation.
	    // If you are using Q.js, RSVP or any other A+ compatible implementation
	    // override this attribute to be the constructor of that promise.
	    // Since jQuery promises aren't A+ compatible they won't work.
	    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,
	
	    EMPTY_STRING_REGEXP: /^\s*$/,
	
	    // Runs the validators specified by the constraints object.
	    // Will return an array of the format:
	    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
	    runValidations: function(attributes, constraints, options) {
	      var results = []
	        , attr
	        , validatorName
	        , value
	        , validators
	        , validator
	        , validatorOptions
	        , error;
	
	      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
	        attributes = v.collectFormValues(attributes);
	      }
	
	      // Loops through each constraints, finds the correct validator and run it.
	      for (attr in constraints) {
	        value = v.getDeepObjectValue(attributes, attr);
	        // This allows the constraints for an attribute to be a function.
	        // The function will be called with the value, attribute name, the complete dict of
	        // attributes as well as the options and constraints passed in.
	        // This is useful when you want to have different
	        // validations depending on the attribute value.
	        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);
	
	        for (validatorName in validators) {
	          validator = v.validators[validatorName];
	
	          if (!validator) {
	            error = v.format("Unknown validator %{name}", {name: validatorName});
	            throw new Error(error);
	          }
	
	          validatorOptions = validators[validatorName];
	          // This allows the options to be a function. The function will be
	          // called with the value, attribute name, the complete dict of
	          // attributes as well as the options and constraints passed in.
	          // This is useful when you want to have different
	          // validations depending on the attribute value.
	          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
	          if (!validatorOptions) {
	            continue;
	          }
	          results.push({
	            attribute: attr,
	            value: value,
	            validator: validatorName,
	            globalOptions: options,
	            attributes: attributes,
	            options: validatorOptions,
	            error: validator.call(validator,
	                value,
	                validatorOptions,
	                attr,
	                attributes,
	                options)
	          });
	        }
	      }
	
	      return results;
	    },
	
	    // Takes the output from runValidations and converts it to the correct
	    // output format.
	    processValidationResults: function(errors, options) {
	      var attr;
	
	      errors = v.pruneEmptyErrors(errors, options);
	      errors = v.expandMultipleErrors(errors, options);
	      errors = v.convertErrorMessages(errors, options);
	
	      switch (options.format || "grouped") {
	        case "detailed":
	          // Do nothing more to the errors
	          break;
	
	        case "flat":
	          errors = v.flattenErrorsToArray(errors);
	          break;
	
	        case "grouped":
	          errors = v.groupErrorsByAttribute(errors);
	          for (attr in errors) {
	            errors[attr] = v.flattenErrorsToArray(errors[attr]);
	          }
	          break;
	
	        default:
	          throw new Error(v.format("Unknown format %{format}", options));
	      }
	
	      return v.isEmpty(errors) ? undefined : errors;
	    },
	
	    // Runs the validations with support for promises.
	    // This function will return a promise that is settled when all the
	    // validation promises have been completed.
	    // It can be called even if no validations returned a promise.
	    async: function(attributes, constraints, options) {
	      options = v.extend({}, v.async.options, options);
	
	      var WrapErrors = options.wrapErrors || function(errors) {
	        return errors;
	      };
	
	      // Removes unknown attributes
	      if (options.cleanAttributes !== false) {
	        attributes = v.cleanAttributes(attributes, constraints);
	      }
	
	      var results = v.runValidations(attributes, constraints, options);
	
	      return new v.Promise(function(resolve, reject) {
	        v.waitForResults(results).then(function() {
	          var errors = v.processValidationResults(results, options);
	          if (errors) {
	            reject(new WrapErrors(errors, options, attributes, constraints));
	          } else {
	            resolve(attributes);
	          }
	        }, function(err) {
	          reject(err);
	        });
	      });
	    },
	
	    single: function(value, constraints, options) {
	      options = v.extend({}, v.single.options, options, {
	        format: "flat",
	        fullMessages: false
	      });
	      return v({single: value}, {single: constraints}, options);
	    },
	
	    // Returns a promise that is resolved when all promises in the results array
	    // are settled. The promise returned from this function is always resolved,
	    // never rejected.
	    // This function modifies the input argument, it replaces the promises
	    // with the value returned from the promise.
	    waitForResults: function(results) {
	      // Create a sequence of all the results starting with a resolved promise.
	      return results.reduce(function(memo, result) {
	        // If this result isn't a promise skip it in the sequence.
	        if (!v.isPromise(result.error)) {
	          return memo;
	        }
	
	        return memo.then(function() {
	          return result.error.then(
	            function(error) {
	              result.error = error || null;
	            },
	            function(error) {
	              if (error instanceof Error) {
	                throw error;
	              }
	              v.error("Rejecting promises with the result is deprecated. Please use the resolve callback instead.");
	              result.error = error;
	            }
	          );
	        });
	      }, new v.Promise(function(r) { r(); })); // A resolved promise
	    },
	
	    // If the given argument is a call: function the and: function return the value
	    // otherwise just return the value. Additional arguments will be passed as
	    // arguments to the function.
	    // Example:
	    // ```
	    // result('foo') // 'foo'
	    // result(Math.max, 1, 2) // 2
	    // ```
	    result: function(value) {
	      var args = [].slice.call(arguments, 1);
	      if (typeof value === 'function') {
	        value = value.apply(null, args);
	      }
	      return value;
	    },
	
	    // Checks if the value is a number. This function does not consider NaN a
	    // number like many other `isNumber` functions do.
	    isNumber: function(value) {
	      return typeof value === 'number' && !isNaN(value);
	    },
	
	    // Returns false if the object is not a function
	    isFunction: function(value) {
	      return typeof value === 'function';
	    },
	
	    // A simple check to verify that the value is an integer. Uses `isNumber`
	    // and a simple modulo check.
	    isInteger: function(value) {
	      return v.isNumber(value) && value % 1 === 0;
	    },
	
	    // Uses the `Object` function to check if the given argument is an object.
	    isObject: function(obj) {
	      return obj === Object(obj);
	    },
	
	    // Simply checks if the object is an instance of a date
	    isDate: function(obj) {
	      return obj instanceof Date;
	    },
	
	    // Returns false if the object is `null` of `undefined`
	    isDefined: function(obj) {
	      return obj !== null && obj !== undefined;
	    },
	
	    // Checks if the given argument is a promise. Anything with a `then`
	    // function is considered a promise.
	    isPromise: function(p) {
	      return !!p && v.isFunction(p.then);
	    },
	
	    isJqueryElement: function(o) {
	      return o && v.isString(o.jquery);
	    },
	
	    isDomElement: function(o) {
	      if (!o) {
	        return false;
	      }
	
	      if (!v.isFunction(o.querySelectorAll) || !v.isFunction(o.querySelector)) {
	        return false;
	      }
	
	      if (v.isObject(document) && o === document) {
	        return true;
	      }
	
	      // http://stackoverflow.com/a/384380/699304
	      /* istanbul ignore else */
	      if (typeof HTMLElement === "object") {
	        return o instanceof HTMLElement;
	      } else {
	        return o &&
	          typeof o === "object" &&
	          o !== null &&
	          o.nodeType === 1 &&
	          typeof o.nodeName === "string";
	      }
	    },
	
	    isEmpty: function(value) {
	      var attr;
	
	      // Null and undefined are empty
	      if (!v.isDefined(value)) {
	        return true;
	      }
	
	      // functions are non empty
	      if (v.isFunction(value)) {
	        return false;
	      }
	
	      // Whitespace only strings are empty
	      if (v.isString(value)) {
	        return v.EMPTY_STRING_REGEXP.test(value);
	      }
	
	      // For arrays we use the length property
	      if (v.isArray(value)) {
	        return value.length === 0;
	      }
	
	      // Dates have no attributes but aren't empty
	      if (v.isDate(value)) {
	        return false;
	      }
	
	      // If we find at least one property we consider it non empty
	      if (v.isObject(value)) {
	        for (attr in value) {
	          return false;
	        }
	        return true;
	      }
	
	      return false;
	    },
	
	    // Formats the specified strings with the given values like so:
	    // ```
	    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
	    // ```
	    // If you want to write %{...} without having it replaced simply
	    // prefix it with % like this `Foo: %%{foo}` and it will be returned
	    // as `"Foo: %{foo}"`
	    format: v.extend(function(str, vals) {
	      if (!v.isString(str)) {
	        return str;
	      }
	      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
	        if (m1 === '%') {
	          return "%{" + m2 + "}";
	        } else {
	          return String(vals[m2]);
	        }
	      });
	    }, {
	      // Finds %{key} style patterns in the given string
	      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
	    }),
	
	    // "Prettifies" the given string.
	    // Prettifying means replacing [.\_-] with spaces as well as splitting
	    // camel case words.
	    prettify: function(str) {
	      if (v.isNumber(str)) {
	        // If there are more than 2 decimals round it to two
	        if ((str * 100) % 1 === 0) {
	          return "" + str;
	        } else {
	          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
	        }
	      }
	
	      if (v.isArray(str)) {
	        return str.map(function(s) { return v.prettify(s); }).join(", ");
	      }
	
	      if (v.isObject(str)) {
	        return str.toString();
	      }
	
	      // Ensure the string is actually a string
	      str = "" + str;
	
	      return str
	        // Splits keys separated by periods
	        .replace(/([^\s])\.([^\s])/g, '$1 $2')
	        // Removes backslashes
	        .replace(/\\+/g, '')
	        // Replaces - and - with space
	        .replace(/[_-]/g, ' ')
	        // Splits camel cased words
	        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
	          return "" + m1 + " " + m2.toLowerCase();
	        })
	        .toLowerCase();
	    },
	
	    stringifyValue: function(value) {
	      return v.prettify(value);
	    },
	
	    isString: function(value) {
	      return typeof value === 'string';
	    },
	
	    isArray: function(value) {
	      return {}.toString.call(value) === '[object Array]';
	    },
	
	    contains: function(obj, value) {
	      if (!v.isDefined(obj)) {
	        return false;
	      }
	      if (v.isArray(obj)) {
	        return obj.indexOf(value) !== -1;
	      }
	      return value in obj;
	    },
	
	    forEachKeyInKeypath: function(object, keypath, callback) {
	      if (!v.isString(keypath)) {
	        return undefined;
	      }
	
	      var key = ""
	        , i
	        , escape = false;
	
	      for (i = 0; i < keypath.length; ++i) {
	        switch (keypath[i]) {
	          case '.':
	            if (escape) {
	              escape = false;
	              key += '.';
	            } else {
	              object = callback(object, key, false);
	              key = "";
	            }
	            break;
	
	          case '\\':
	            if (escape) {
	              escape = false;
	              key += '\\';
	            } else {
	              escape = true;
	            }
	            break;
	
	          default:
	            escape = false;
	            key += keypath[i];
	            break;
	        }
	      }
	
	      return callback(object, key, true);
	    },
	
	    getDeepObjectValue: function(obj, keypath) {
	      if (!v.isObject(obj)) {
	        return undefined;
	      }
	
	      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
	        if (v.isObject(obj)) {
	          return obj[key];
	        }
	      });
	    },
	
	    // This returns an object with all the values of the form.
	    // It uses the input name as key and the value as value
	    // So for example this:
	    // <input type="text" name="email" value="foo@bar.com" />
	    // would return:
	    // {email: "foo@bar.com"}
	    collectFormValues: function(form, options) {
	      var values = {}
	        , i
	        , input
	        , inputs
	        , value;
	
	      if (v.isJqueryElement(form)) {
	        form = form[0];
	      }
	
	      if (!form) {
	        return values;
	      }
	
	      options = options || {};
	
	      inputs = form.querySelectorAll("input[name], textarea[name]");
	      for (i = 0; i < inputs.length; ++i) {
	        input = inputs.item(i);
	
	        if (v.isDefined(input.getAttribute("data-ignored"))) {
	          continue;
	        }
	
	        value = v.sanitizeFormValue(input.value, options);
	        if (input.type === "number") {
	          value = value ? +value : null;
	        } else if (input.type === "checkbox") {
	          if (input.attributes.value) {
	            if (!input.checked) {
	              value = values[input.name] || null;
	            }
	          } else {
	            value = input.checked;
	          }
	        } else if (input.type === "radio") {
	          if (!input.checked) {
	            value = values[input.name] || null;
	          }
	        }
	        values[input.name] = value;
	      }
	
	      inputs = form.querySelectorAll("select[name]");
	      for (i = 0; i < inputs.length; ++i) {
	        input = inputs.item(i);
	        value = v.sanitizeFormValue(input.options[input.selectedIndex].value, options);
	        values[input.name] = value;
	      }
	
	      return values;
	    },
	
	    sanitizeFormValue: function(value, options) {
	      if (options.trim && v.isString(value)) {
	        value = value.trim();
	      }
	
	      if (options.nullify !== false && value === "") {
	        return null;
	      }
	      return value;
	    },
	
	    capitalize: function(str) {
	      if (!v.isString(str)) {
	        return str;
	      }
	      return str[0].toUpperCase() + str.slice(1);
	    },
	
	    // Remove all errors who's error attribute is empty (null or undefined)
	    pruneEmptyErrors: function(errors) {
	      return errors.filter(function(error) {
	        return !v.isEmpty(error.error);
	      });
	    },
	
	    // In
	    // [{error: ["err1", "err2"], ...}]
	    // Out
	    // [{error: "err1", ...}, {error: "err2", ...}]
	    //
	    // All attributes in an error with multiple messages are duplicated
	    // when expanding the errors.
	    expandMultipleErrors: function(errors) {
	      var ret = [];
	      errors.forEach(function(error) {
	        // Removes errors without a message
	        if (v.isArray(error.error)) {
	          error.error.forEach(function(msg) {
	            ret.push(v.extend({}, error, {error: msg}));
	          });
	        } else {
	          ret.push(error);
	        }
	      });
	      return ret;
	    },
	
	    // Converts the error mesages by prepending the attribute name unless the
	    // message is prefixed by ^
	    convertErrorMessages: function(errors, options) {
	      options = options || {};
	
	      var ret = [];
	      errors.forEach(function(errorInfo) {
	        var error = v.result(errorInfo.error,
	            errorInfo.value,
	            errorInfo.attribute,
	            errorInfo.options,
	            errorInfo.attributes,
	            errorInfo.globalOptions);
	
	        if (!v.isString(error)) {
	          ret.push(errorInfo);
	          return;
	        }
	
	        if (error[0] === '^') {
	          error = error.slice(1);
	        } else if (options.fullMessages !== false) {
	          error = v.capitalize(v.prettify(errorInfo.attribute)) + " " + error;
	        }
	        error = error.replace(/\\\^/g, "^");
	        error = v.format(error, {value: v.stringifyValue(errorInfo.value)});
	        ret.push(v.extend({}, errorInfo, {error: error}));
	      });
	      return ret;
	    },
	
	    // In:
	    // [{attribute: "<attributeName>", ...}]
	    // Out:
	    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
	    groupErrorsByAttribute: function(errors) {
	      var ret = {};
	      errors.forEach(function(error) {
	        var list = ret[error.attribute];
	        if (list) {
	          list.push(error);
	        } else {
	          ret[error.attribute] = [error];
	        }
	      });
	      return ret;
	    },
	
	    // In:
	    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
	    // Out:
	    // ["<message 1>", "<message 2>"]
	    flattenErrorsToArray: function(errors) {
	      return errors.map(function(error) { return error.error; });
	    },
	
	    cleanAttributes: function(attributes, whitelist) {
	      function whitelistCreator(obj, key, last) {
	        if (v.isObject(obj[key])) {
	          return obj[key];
	        }
	        return (obj[key] = last ? true : {});
	      }
	
	      function buildObjectWhitelist(whitelist) {
	        var ow = {}
	          , lastObject
	          , attr;
	        for (attr in whitelist) {
	          if (!whitelist[attr]) {
	            continue;
	          }
	          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
	        }
	        return ow;
	      }
	
	      function cleanRecursive(attributes, whitelist) {
	        if (!v.isObject(attributes)) {
	          return attributes;
	        }
	
	        var ret = v.extend({}, attributes)
	          , w
	          , attribute;
	
	        for (attribute in attributes) {
	          w = whitelist[attribute];
	
	          if (v.isObject(w)) {
	            ret[attribute] = cleanRecursive(ret[attribute], w);
	          } else if (!w) {
	            delete ret[attribute];
	          }
	        }
	        return ret;
	      }
	
	      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
	        return {};
	      }
	
	      whitelist = buildObjectWhitelist(whitelist);
	      return cleanRecursive(attributes, whitelist);
	    },
	
	    exposeModule: function(validate, root, exports, module, define) {
	      if (exports) {
	        if (module && module.exports) {
	          exports = module.exports = validate;
	        }
	        exports.validate = validate;
	      } else {
	        root.validate = validate;
	        if (validate.isFunction(define) && define.amd) {
	          define([], function () { return validate; });
	        }
	      }
	    },
	
	    warn: function(msg) {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("[validate.js] " + msg);
	      }
	    },
	
	    error: function(msg) {
	      if (typeof console !== "undefined" && console.error) {
	        console.error("[validate.js] " + msg);
	      }
	    }
	  });
	
	  validate.validators = {
	    // Presence validates that the value isn't empty
	    presence: function(value, options) {
	      options = v.extend({}, this.options, options);
	      if (v.isEmpty(value)) {
	        return options.message || this.message || "can't be blank";
	      }
	    },
	    length: function(value, options, attribute) {
	      // Empty values are allowed
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var is = options.is
	        , maximum = options.maximum
	        , minimum = options.minimum
	        , tokenizer = options.tokenizer || function(val) { return val; }
	        , err
	        , errors = [];
	
	      value = tokenizer(value);
	      var length = value.length;
	      if(!v.isNumber(length)) {
	        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
	        return options.message || this.notValid || "has an incorrect length";
	      }
	
	      // Is checks
	      if (v.isNumber(is) && length !== is) {
	        err = options.wrongLength ||
	          this.wrongLength ||
	          "is the wrong length (should be %{count} characters)";
	        errors.push(v.format(err, {count: is}));
	      }
	
	      if (v.isNumber(minimum) && length < minimum) {
	        err = options.tooShort ||
	          this.tooShort ||
	          "is too short (minimum is %{count} characters)";
	        errors.push(v.format(err, {count: minimum}));
	      }
	
	      if (v.isNumber(maximum) && length > maximum) {
	        err = options.tooLong ||
	          this.tooLong ||
	          "is too long (maximum is %{count} characters)";
	        errors.push(v.format(err, {count: maximum}));
	      }
	
	      if (errors.length > 0) {
	        return options.message || errors;
	      }
	    },
	    numericality: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var errors = []
	        , name
	        , count
	        , checks = {
	            greaterThan:          function(v, c) { return v > c; },
	            greaterThanOrEqualTo: function(v, c) { return v >= c; },
	            equalTo:              function(v, c) { return v === c; },
	            lessThan:             function(v, c) { return v < c; },
	            lessThanOrEqualTo:    function(v, c) { return v <= c; }
	          };
	
	      // Coerce the value to a number unless we're being strict.
	      if (options.noStrings !== true && v.isString(value)) {
	        value = +value;
	      }
	
	      // If it's not a number we shouldn't continue since it will compare it.
	      if (!v.isNumber(value)) {
	        return options.message || options.notValid || this.notValid || "is not a number";
	      }
	
	      // Same logic as above, sort of. Don't bother with comparisons if this
	      // doesn't pass.
	      if (options.onlyInteger && !v.isInteger(value)) {
	        return options.message || options.notInteger || this.notInteger  || "must be an integer";
	      }
	
	      for (name in checks) {
	        count = options[name];
	        if (v.isNumber(count) && !checks[name](value, count)) {
	          // This picks the default message if specified
	          // For example the greaterThan check uses the message from
	          // this.notGreaterThan so we capitalize the name and prepend "not"
	          var key = "not" + v.capitalize(name);
	          var msg = options[key] || this[key] || "must be %{type} %{count}";
	
	          errors.push(v.format(msg, {
	            count: count,
	            type: v.prettify(name)
	          }));
	        }
	      }
	
	      if (options.odd && value % 2 !== 1) {
	        errors.push(options.notOdd || this.notOdd || "must be odd");
	      }
	      if (options.even && value % 2 !== 0) {
	        errors.push(options.notEven || this.notEven || "must be even");
	      }
	
	      if (errors.length) {
	        return options.message || errors;
	      }
	    },
	    datetime: v.extend(function(value, options) {
	      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
	        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
	      }
	
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var err
	        , errors = []
	        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
	        , latest = options.latest ? this.parse(options.latest, options) : NaN;
	
	      value = this.parse(value, options);
	
	      // 86400000 is the number of seconds in a day, this is used to remove
	      // the time from the date
	      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
	        return options.message || this.notValid || "must be a valid date";
	      }
	
	      if (!isNaN(earliest) && value < earliest) {
	        err = this.tooEarly || "must be no earlier than %{date}";
	        err = v.format(err, {date: this.format(earliest, options)});
	        errors.push(err);
	      }
	
	      if (!isNaN(latest) && value > latest) {
	        err = this.tooLate || "must be no later than %{date}";
	        err = v.format(err, {date: this.format(latest, options)});
	        errors.push(err);
	      }
	
	      if (errors.length) {
	        return options.message || errors;
	      }
	    }, {
	      parse: null,
	      format: null
	    }),
	    date: function(value, options) {
	      options = v.extend({}, options, {dateOnly: true});
	      return v.validators.datetime.call(v.validators.datetime, value, options);
	    },
	    format: function(value, options) {
	      if (v.isString(options) || (options instanceof RegExp)) {
	        options = {pattern: options};
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var message = options.message || this.message || "is invalid"
	        , pattern = options.pattern
	        , match;
	
	      // Empty values are allowed
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (!v.isString(value)) {
	        return message;
	      }
	
	      if (v.isString(pattern)) {
	        pattern = new RegExp(options.pattern, options.flags);
	      }
	      match = pattern.exec(value);
	      if (!match || match[0].length != value.length) {
	        return message;
	      }
	    },
	    inclusion: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (v.isArray(options)) {
	        options = {within: options};
	      }
	      options = v.extend({}, this.options, options);
	      if (v.contains(options.within, value)) {
	        return;
	      }
	      var message = options.message ||
	        this.message ||
	        "^%{value} is not included in the list";
	      return v.format(message, {value: value});
	    },
	    exclusion: function(value, options) {
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (v.isArray(options)) {
	        options = {within: options};
	      }
	      options = v.extend({}, this.options, options);
	      if (!v.contains(options.within, value)) {
	        return;
	      }
	      var message = options.message || this.message || "^%{value} is restricted";
	      return v.format(message, {value: value});
	    },
	    email: v.extend(function(value, options) {
	      options = v.extend({}, this.options, options);
	      var message = options.message || this.message || "is not a valid email";
	      // Empty values are fine
	      if (v.isEmpty(value)) {
	        return;
	      }
	      if (!v.isString(value)) {
	        return message;
	      }
	      if (!this.PATTERN.exec(value)) {
	        return message;
	      }
	    }, {
	      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
	    }),
	    equality: function(value, options, attribute, attributes) {
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      if (v.isString(options)) {
	        options = {attribute: options};
	      }
	      options = v.extend({}, this.options, options);
	      var message = options.message ||
	        this.message ||
	        "is not equal to %{attribute}";
	
	      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
	        throw new Error("The attribute must be a non empty string");
	      }
	
	      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
	        , comparator = options.comparator || function(v1, v2) {
	          return v1 === v2;
	        };
	
	      if (!comparator(value, otherValue, options, attribute, attributes)) {
	        return v.format(message, {attribute: v.prettify(options.attribute)});
	      }
	    },
	
	    // A URL validator that is used to validate URLs with the ability to
	    // restrict schemes and some domains.
	    url: function(value, options) {
	      if (v.isEmpty(value)) {
	        return;
	      }
	
	      options = v.extend({}, this.options, options);
	
	      var message = options.message || this.message || "is not a valid url"
	        , schemes = options.schemes || this.schemes || ['http', 'https']
	        , allowLocal = options.allowLocal || this.allowLocal || false;
	
	      if (!v.isString(value)) {
	        return message;
	      }
	
	      // https://gist.github.com/dperini/729294
	      var regex =
	        "^" +
	          // schemes
	          "(?:(?:" + schemes.join("|") + "):\\/\\/)" +
	          // credentials
	          "(?:\\S+(?::\\S*)?@)?";
	
	      regex += "(?:";
	
	      var hostname =
	          "(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)" +
	          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*" +
	          "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))";
	
	      // This ia a special case for the localhost hostname
	      if (allowLocal) {
	        hostname = "(?:localhost|" + hostname + ")";
	      } else {
	          // private & local addresses
	          regex +=
	              "(?!10(?:\\.\\d{1,3}){3})" +
	              "(?!127(?:\\.\\d{1,3}){3})" +
	              "(?!169\\.254(?:\\.\\d{1,3}){2})" +
	              "(?!192\\.168(?:\\.\\d{1,3}){2})" +
	              "(?!172" +
	                "\\.(?:1[6-9]|2\\d|3[0-1])" +
	                "(?:\\.\\d{1,3})" +
	              "{2})";
	      }
	
	      // reserved addresses
	      regex +=
	          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
	          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
	          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
	        "|" +
	          hostname +
	          // port number
	          "(?::\\d{2,5})?" +
	          // path
	          "(?:\\/[^\\s]*)?" +
	        "$";
	
	      var PATTERN = new RegExp(regex, 'i');
	      if (!PATTERN.exec(value)) {
	        return message;
	      }
	    }
	  };
	
	  validate.exposeModule(validate, this, exports, module, __webpack_require__(716));
	}).call(this,
	         true ? /* istanbul ignore next */ exports : null,
	         true ? /* istanbul ignore next */ module : null,
	        __webpack_require__(716));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	// HACKHACK: these components should go in separate files
	// tslint:disable max-classes-per-file
	var React = __webpack_require__(1);
	var props_1 = __webpack_require__(147);
	var abstractButton_1 = __webpack_require__(726);
	var Button = (function (_super) {
	    tslib_1.__extends(Button, _super);
	    function Button() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Button.prototype.render = function () {
	        return (React.createElement("button", tslib_1.__assign({ type: "button" }, props_1.removeNonHTMLProps(this.props), this.getCommonButtonProps()), this.renderChildren()));
	    };
	    Button.displayName = "Blueprint.Button";
	    return Button;
	}(abstractButton_1.AbstractButton));
	exports.Button = Button;
	exports.ButtonFactory = React.createFactory(Button);
	var AnchorButton = (function (_super) {
	    tslib_1.__extends(AnchorButton, _super);
	    function AnchorButton() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnchorButton.prototype.render = function () {
	        var _a = this.props, href = _a.href, _b = _a.tabIndex, tabIndex = _b === void 0 ? 0 : _b;
	        var commonProps = this.getCommonButtonProps();
	        return (React.createElement("a", tslib_1.__assign({ role: "button" }, props_1.removeNonHTMLProps(this.props), commonProps, { href: commonProps.disabled ? undefined : href, tabIndex: commonProps.disabled ? undefined : tabIndex }), this.renderChildren()));
	    };
	    AnchorButton.displayName = "Blueprint.AnchorButton";
	    return AnchorButton;
	}(abstractButton_1.AbstractButton));
	exports.AnchorButton = AnchorButton;
	exports.AnchorButtonFactory = React.createFactory(AnchorButton);


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var keyCombo_1 = __webpack_require__(442);
	var Hotkey = (function (_super) {
	    tslib_1.__extends(Hotkey, _super);
	    function Hotkey() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Hotkey.isInstance = function (element) {
	        return element != null && element.type === Hotkey;
	    };
	    Hotkey.prototype.render = function () {
	        var _a = this.props, label = _a.label, spreadableProps = tslib_1.__rest(_a, ["label"]);
	        return (React.createElement("div", { className: "pt-hotkey" },
	            React.createElement("div", { className: "pt-hotkey-label" }, label),
	            React.createElement(keyCombo_1.KeyCombo, tslib_1.__assign({}, spreadableProps))));
	    };
	    Hotkey.prototype.validateProps = function (props) {
	        if (props.global !== true && props.group == null) {
	            throw new Error("non-global <Hotkey>s must define a group");
	        }
	    };
	    Hotkey.defaultProps = {
	        allowInInput: false,
	        disabled: false,
	        global: false,
	        preventDefault: false,
	        stopPropagation: false,
	    };
	    return Hotkey;
	}(common_1.AbstractComponent));
	exports.Hotkey = Hotkey;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var CSSTransitionGroup = __webpack_require__(1603);
	var Classes = __webpack_require__(8);
	var Keys = __webpack_require__(103);
	var utils_1 = __webpack_require__(21);
	var portal_1 = __webpack_require__(448);
	var Overlay = (function (_super) {
	    tslib_1.__extends(Overlay, _super);
	    function Overlay(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.refHandlers = {
	            container: function (ref) { return (_this.containerElement = ref); },
	        };
	        _this.handleBackdropMouseDown = function (e) {
	            var _a = _this.props, backdropProps = _a.backdropProps, canOutsideClickClose = _a.canOutsideClickClose, enforceFocus = _a.enforceFocus, onClose = _a.onClose;
	            if (canOutsideClickClose) {
	                utils_1.safeInvoke(onClose, e);
	            }
	            if (enforceFocus) {
	                // make sure document.activeElement is updated before bringing the focus back
	                _this.bringFocusInsideOverlay();
	            }
	            utils_1.safeInvoke(backdropProps.onMouseDown, e);
	        };
	        _this.handleDocumentClick = function (e) {
	            var _a = _this.props, isOpen = _a.isOpen, onClose = _a.onClose;
	            var eventTarget = e.target;
	            var isClickInOverlay = _this.containerElement != null && _this.containerElement.contains(eventTarget);
	            if (isOpen && _this.props.canOutsideClickClose && !isClickInOverlay) {
	                // casting to any because this is a native event
	                utils_1.safeInvoke(onClose, e);
	            }
	        };
	        _this.handleContentMount = function () {
	            if (_this.props.isOpen) {
	                utils_1.safeInvoke(_this.props.didOpen);
	            }
	            if (_this.props.autoFocus) {
	                _this.bringFocusInsideOverlay();
	            }
	        };
	        _this.handleDocumentFocus = function (e) {
	            if (_this.props.enforceFocus &&
	                _this.containerElement != null &&
	                !_this.containerElement.contains(e.target)) {
	                // prevent default focus behavior (sometimes auto-scrolls the page)
	                e.preventDefault();
	                e.stopImmediatePropagation();
	                _this.bringFocusInsideOverlay();
	            }
	        };
	        _this.handleKeyDown = function (e) {
	            var _a = _this.props, canEscapeKeyClose = _a.canEscapeKeyClose, onClose = _a.onClose;
	            if (e.which === Keys.ESCAPE && canEscapeKeyClose) {
	                utils_1.safeInvoke(onClose, e);
	                // prevent browser-specific escape key behavior (Safari exits fullscreen)
	                e.preventDefault();
	            }
	        };
	        _this.state = { hasEverOpened: props.isOpen };
	        return _this;
	    }
	    Overlay_1 = Overlay;
	    Overlay.prototype.render = function () {
	        // oh snap! no reason to render anything at all if we're being truly lazy
	        if (this.props.lazy && !this.state.hasEverOpened) {
	            return null;
	        }
	        var _a = this.props, children = _a.children, className = _a.className, inline = _a.inline, isOpen = _a.isOpen, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
	        // add a special class to each child that will automatically set the appropriate
	        // CSS position mode under the hood. also, make the container focusable so we can
	        // trap focus inside it (via `enforceFocus`).
	        var decoratedChildren = React.Children.map(children, function (child) {
	            return React.cloneElement(child, {
	                className: classNames(child.props.className, Classes.OVERLAY_CONTENT),
	                tabIndex: 0,
	            });
	        });
	        var transitionGroup = (React.createElement(CSSTransitionGroup, { transitionAppear: true, transitionAppearTimeout: transitionDuration, transitionEnterTimeout: transitionDuration, transitionLeaveTimeout: transitionDuration, transitionName: transitionName },
	            this.maybeRenderBackdrop(),
	            isOpen ? decoratedChildren : null));
	        var mergedClassName = classNames(Classes.OVERLAY, (_b = {},
	            _b[Classes.OVERLAY_OPEN] = isOpen,
	            _b[Classes.OVERLAY_INLINE] = inline,
	            _b), className);
	        var elementProps = {
	            className: mergedClassName,
	            onKeyDown: this.handleKeyDown,
	        };
	        if (inline) {
	            return (React.createElement("span", tslib_1.__assign({}, elementProps, { ref: this.refHandlers.container }), transitionGroup));
	        }
	        else {
	            return (React.createElement(portal_1.Portal, tslib_1.__assign({}, elementProps, { containerRef: this.refHandlers.container, onChildrenMount: this.handleContentMount }), transitionGroup));
	        }
	        var _b;
	    };
	    Overlay.prototype.componentDidMount = function () {
	        if (this.props.isOpen) {
	            this.overlayWillOpen();
	        }
	    };
	    Overlay.prototype.componentWillReceiveProps = function (nextProps) {
	        this.setState({ hasEverOpened: this.state.hasEverOpened || nextProps.isOpen });
	    };
	    Overlay.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.isOpen && !this.props.isOpen) {
	            this.overlayWillClose();
	        }
	        else if (!prevProps.isOpen && this.props.isOpen) {
	            this.overlayWillOpen();
	        }
	    };
	    Overlay.prototype.componentWillUnmount = function () {
	        this.overlayWillClose();
	    };
	    /**
	     * @public for testing
	     * @internal
	     */
	    Overlay.prototype.bringFocusInsideOverlay = function () {
	        var _this = this;
	        // always delay focus manipulation to just before repaint to prevent scroll jumping
	        return requestAnimationFrame(function () {
	            // container ref may be undefined between component mounting and Portal rendering
	            // activeElement may be undefined in some rare cases in IE
	            if (_this.containerElement == null || document.activeElement == null || !_this.props.isOpen) {
	                return;
	            }
	            var isFocusOutsideModal = !_this.containerElement.contains(document.activeElement);
	            if (isFocusOutsideModal) {
	                // element marked autofocus has higher priority than the other clowns
	                var autofocusElement = _this.containerElement.query("[autofocus]");
	                var wrapperElement = _this.containerElement.query("[tabindex]");
	                if (autofocusElement != null) {
	                    autofocusElement.focus();
	                }
	                else if (wrapperElement != null) {
	                    wrapperElement.focus();
	                }
	            }
	        });
	    };
	    Overlay.prototype.maybeRenderBackdrop = function () {
	        var _a = this.props, backdropClassName = _a.backdropClassName, backdropProps = _a.backdropProps, hasBackdrop = _a.hasBackdrop, isOpen = _a.isOpen;
	        if (hasBackdrop && isOpen) {
	            return (React.createElement("div", tslib_1.__assign({}, backdropProps, { className: classNames(Classes.OVERLAY_BACKDROP, backdropClassName, backdropProps.className), onMouseDown: this.handleBackdropMouseDown, tabIndex: this.props.canOutsideClickClose ? 0 : null })));
	        }
	        else {
	            return undefined;
	        }
	    };
	    Overlay.prototype.overlayWillClose = function () {
	        document.removeEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
	        document.removeEventListener("mousedown", this.handleDocumentClick);
	        var openStack = Overlay_1.openStack;
	        var stackIndex = openStack.indexOf(this);
	        if (stackIndex !== -1) {
	            openStack.splice(stackIndex, 1);
	            if (openStack.length > 0) {
	                var lastOpenedOverlay = Overlay_1.getLastOpened();
	                if (lastOpenedOverlay.props.enforceFocus) {
	                    document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
	                }
	            }
	            if (openStack.filter(function (o) { return !o.props.inline && o.props.hasBackdrop; }).length === 0) {
	                document.body.classList.remove(Classes.OVERLAY_OPEN);
	            }
	        }
	    };
	    Overlay.prototype.overlayWillOpen = function () {
	        var openStack = Overlay_1.openStack;
	        if (openStack.length > 0) {
	            document.removeEventListener("focus", Overlay_1.getLastOpened().handleDocumentFocus, /* useCapture */ true);
	        }
	        openStack.push(this);
	        if (this.props.canOutsideClickClose && !this.props.hasBackdrop) {
	            document.addEventListener("mousedown", this.handleDocumentClick);
	        }
	        if (this.props.enforceFocus) {
	            document.addEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
	        }
	        if (this.props.inline) {
	            utils_1.safeInvoke(this.props.didOpen);
	            if (this.props.autoFocus) {
	                this.bringFocusInsideOverlay();
	            }
	        }
	        else if (this.props.hasBackdrop) {
	            // add a class to the body to prevent scrolling of content below the overlay
	            document.body.classList.add(Classes.OVERLAY_OPEN);
	        }
	    };
	    Overlay.displayName = "Blueprint.Overlay";
	    Overlay.defaultProps = {
	        autoFocus: true,
	        backdropProps: {},
	        canEscapeKeyClose: true,
	        canOutsideClickClose: true,
	        enforceFocus: true,
	        hasBackdrop: true,
	        inline: false,
	        isOpen: false,
	        lazy: true,
	        transitionDuration: 300,
	        transitionName: "pt-overlay",
	    };
	    Overlay.openStack = [];
	    Overlay.getLastOpened = function () { return Overlay_1.openStack[Overlay_1.openStack.length - 1]; };
	    Overlay = Overlay_1 = tslib_1.__decorate([
	        PureRender
	    ], Overlay);
	    return Overlay;
	    var Overlay_1;
	}(React.Component));
	exports.Overlay = Overlay;
	exports.OverlayFactory = React.createFactory(Overlay);


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submit = exports.cancel = exports.approve = exports.discard = exports.addListingItem = exports.removeListingItem = exports.changeUom = exports.changeProcessedQuantity = exports.changePlannedQuantity = exports.changeOrderType = exports.enableEditMode = exports.close = exports.open = exports.actionTypes = undefined;
	
	var _keykey = __webpack_require__(270);
	
	var _keykey2 = _interopRequireDefault(_keykey);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _treeFlatten = __webpack_require__(1780);
	
	var _treeFlatten2 = _interopRequireDefault(_treeFlatten);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _productionOrderAction = __webpack_require__(467);
	
	var _billOfMaterialsActions = __webpack_require__(761);
	
	var _inventoryActions = __webpack_require__(105);
	
	var _uomGroupActions = __webpack_require__(311);
	
	var _baseActions = __webpack_require__(34);
	
	var _lodash = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = (0, _keykey2.default)(['OPEN_PRODUCTION_ORDER_OVERVIEW_REQUEST', 'OPEN_PRODUCTION_ORDER_OVERVIEW_SUCCESS', 'OPEN_PRODUCTION_ORDER_OVERVIEW_FAILURE', 'CLOSE_PRODUCTION_ORDER_OVERVIEW', 'CLOSE_ISSUBMITING_STATE', 'SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST', 'SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS', 'SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE', 'LOAD_LISTINGS_FOR_PRODUCTION_ORDER_REQUEST', 'LOAD_LISTINGS_FOR_PRODUCTION_ORDER_SUCCESS', 'LOAD_LISTINGS_FOR_PRODUCTION_ORDER_FAILURE', 'LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_REQUEST', 'LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_SUCCESS', 'LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_FAILURE', 'LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_REQUEST', 'LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_SUCCESS', 'LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_FAILURE', 'ENABLE_PRODUCTION_ORDER_EDITMODE', 'CHANGE_PRODUCTION_ORDER_TYPE', 'CHANGE_PRODUCTION_ORDER_PLANNED_QUANTITY', 'CHANGE_PRODUCTION_ORDER_PROCESSED_QUANTITIY', 'CHANGE_PRODUCTION_ORDER_UOM', 'REMOVE_PRODUCTION_ORDER_LISTING_ITEM', 'ADD_PRODUCTION_ORDER_LISTING_ITEM', 'DISCARD_PRODUCTION_ORDER_OVERVIEW']);
	
	var open = exports.open = function open(id, storeId) {
	  return function (dispatch) {
	    if (!id) {
	      dispatch(openNew(storeId));
	    } else {
	      dispatch(openExist(id, storeId));
	    }
	  };
	};
	
	var openNew = function openNew(storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_REQUEST, storeId: storeId });
	    return dispatch(enableEditMode());
	  };
	};
	
	var openExist = function openExist(id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_REQUEST, storeId: storeId, id: id });
	    dispatch((0, _baseActions.startFetch)());
	    return dispatch((0, _productionOrderAction.getProductionOrder)(id, storeId)).then(function (resp) {
	      var data = resp.data,
	          error = resp.error;
	
	      if (error) {
	        alert('Cannot load the production order: ' + error.message);
	        dispatch({ type: actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	        dispatch((0, _baseActions.stopFetch)());
	        return { error: error };
	      } else {
	        var productionOrderItems = data.productionOrderItems;
	
	        dispatch({ type: actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_SUCCESS, data: data, id: id, storeId: storeId });
	        if (Array.isArray(productionOrderItems) && productionOrderItems.length > 0) {
	          var listingIds = getListingIdFromNested(productionOrderItems);
	          dispatch({ type: actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_REQUEST });
	          return dispatch((0, _inventoryActions.getListingItems)(listingIds, storeId)).then(function (resp) {
	            var data = resp.data,
	                error = resp.error;
	
	            dispatch((0, _baseActions.stopFetch)());
	            if (!error) {
	              dispatch({ type: actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_SUCCESS, data: data });
	              return {};
	            } else {
	              alert('Cannot load the listing info for production order: ' + error.message);
	              dispatch({ type: actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_FAILURE, error: error });
	              return { error: error };
	            }
	          });
	        } else {
	          dispatch((0, _baseActions.stopFetch)());
	        }
	      }
	    });
	  };
	};
	var loadAllUnitOfMeasure = function loadAllUnitOfMeasure(storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_REQUEST });
	    dispatch((0, _baseActions.startFetch)());
	    return dispatch((0, _uomGroupActions.getGroups)(storeId)).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	      var data = resp.data,
	          error = resp.error;
	
	      if (!error) {
	        dispatch({ type: actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        alert('Cannot load all unit groups: ' + error.message);
	        dispatch({ type: actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    });
	  };
	};
	
	var loadBomForListingItem = function loadBomForListingItem(listingId, storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_REQUEST });
	    dispatch((0, _baseActions.startFetch)());
	    return dispatch((0, _billOfMaterialsActions.getCollection)(listingId, storeId)).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	      var data = resp.data,
	          error = resp.error;
	
	      if (!error) {
	        dispatch({ type: actionTypes.LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        alert('Cannot load the bill of material: ' + error.message);
	        dispatch({ type: actionTypes.LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_FAILURE, error: error });
	        return { error: error };
	      }
	    });
	  };
	};
	
	var close = exports.close = function close() {
	  return { type: actionTypes.CLOSE_PRODUCTION_ORDER_OVERVIEW };
	};
	var enableEditMode = exports.enableEditMode = function enableEditMode() {
	  var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  return function (dispatch, getState) {
	    if (!enable) {
	      return dispatch({ type: actionTypes.ENABLE_PRODUCTION_ORDER_EDITMODE, mode: enable });
	    } else {
	      var state = getState();
	      var storeId = state.forms.productionOrderItem.storeId;
	
	      return dispatch(loadAllUnitOfMeasure(storeId)).then(function (resp) {
	        var error = resp.error;
	
	        if (!error) {
	          dispatch({ type: actionTypes.ENABLE_PRODUCTION_ORDER_EDITMODE, mode: enable });
	          return {};
	        } else {
	          return { error: error };
	        }
	      });
	    }
	  };
	};
	var changeOrderType = exports.changeOrderType = function changeOrderType(value) {
	  return {
	    type: actionTypes.CHANGE_PRODUCTION_ORDER_TYPE,
	    value: value
	  };
	};
	
	var changePlannedQuantity = exports.changePlannedQuantity = function changePlannedQuantity(value, index) {
	  return {
	    type: actionTypes.CHANGE_PRODUCTION_ORDER_PLANNED_QUANTITY,
	    value: value,
	    index: index
	  };
	};
	var changeProcessedQuantity = exports.changeProcessedQuantity = function changeProcessedQuantity(value, index) {
	  return {
	    type: actionTypes.CHANGE_PRODUCTION_ORDER_PROCESSED_QUANTITIY,
	    value: value,
	    index: index
	  };
	};
	var changeUom = exports.changeUom = function changeUom(value, index) {
	  return { type: actionTypes.CHANGE_PRODUCTION_ORDER_UOM, value: value, index: index };
	};
	var removeListingItem = exports.removeListingItem = function removeListingItem(index) {
	  return { type: actionTypes.REMOVE_PRODUCTION_ORDER_LISTING_ITEM, index: index };
	};
	var addListingItem = exports.addListingItem = function addListingItem(listings) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$producti = state.forms.productionOrderItem,
	        storeId = _state$forms$producti.storeId,
	        productionOrderItems = _state$forms$producti.productionOrderItems;
	
	    listings.forEach(function (l) {
	      return l.listingId = l.id;
	    });
	    var diff = (0, _lodash.differenceBy)(listings, productionOrderItems, 'listingId');
	    if (!diff.length) return;
	    var ids = diff.map(function (l) {
	      return l.id;
	    });
	
	    return dispatch(loadBomForListingItem(ids, storeId)).then(function (resp) {
	      var error = resp.error;
	
	      if (!error) {
	        dispatch({ type: actionTypes.ADD_PRODUCTION_ORDER_LISTING_ITEM, data: diff });
	        return {};
	      } else {
	        alert(error.message);
	        return { error: error };
	      }
	    });
	  };
	};
	var discard = exports.discard = function discard() {
	  return function (dispatch, getState) {
	    if (window.confirm("Do you really want to discard you changes?")) {
	      var state = getState();
	      var _state$forms$producti2 = state.forms.productionOrderItem,
	          isCreating = _state$forms$producti2.isCreating,
	          storeId = _state$forms$producti2.storeId;
	
	      if (!isCreating) {
	        dispatch({ type: actionTypes.DISCARD_PRODUCTION_ORDER_OVERVIEW });
	      } else {
	        _routeHelper2.default.goProductionOrders(storeId);
	      }
	    }
	  };
	};
	var createProductionOrder = function createProductionOrder(data, storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	    dispatch((0, _baseActions.startFetch)());
	    var listingIds = data.productionOrderItemsAttributes.map(function (_ref) {
	      var listingId = _ref.listingId;
	      return listingId;
	    });
	    dispatch((0, _billOfMaterialsActions.getCollection)(listingIds, storeId)).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	      var billOfMaterialsData = resp.data;
	      data.productionOrderItemsAttributes.forEach(function (obj) {
	        obj.productionOrderItemMaterialsAttributes = billOfMaterialsData[obj.listingId];
	        obj.productionOrderItemMaterialsAttributes.forEach(function (attributesArray) {
	          attributesArray.quantity = attributesArray.quantityInDisplayUnit * obj.quantity;
	          attributesArray.name = attributesArray.nameOfMaterial;
	          attributesArray.listingId = attributesArray.materialId;
	        });
	      });
	      return dispatch((0, _productionOrderAction.create)(data, storeId)).then(function (resp) {
	        var error = resp.error;
	
	        if (!error) {
	          dispatch(enableEditMode(false));
	          dispatch({ type: actionTypes.CLOSE_ISSUBMITING_STATE });
	          _routeHelper2.default.goProductionOrders(storeId);
	        } else {
	          alert(error.message);
	          dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	        }
	      });
	    });
	  };
	};
	var updateProductionOrder = function updateProductionOrder(data, id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	    dispatch((0, _baseActions.startFetch)());
	    var listingIds = data.productionOrderItemsAttributes.map(function (_ref2) {
	      var listingId = _ref2.listingId;
	      return listingId;
	    });
	    dispatch((0, _billOfMaterialsActions.getCollection)(listingIds, storeId)).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	      var billOfMaterialsData = resp.data;
	      data.productionOrderItemsAttributes.forEach(function (obj) {
	        obj.productionOrderItemMaterials = billOfMaterialsData[obj.listingId];
	      });
	      return dispatch((0, _productionOrderAction.update)(data, id, storeId)).then(function (resp) {
	        var error = resp.error,
	            data = resp.data;
	
	        if (!error) {
	          dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS, data: data });
	        } else {
	          alert(error.message);
	          dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	        }
	      });
	    });
	  };
	};
	
	var fulfillProductionOrder = function fulfillProductionOrder(data, id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	    return dispatch((0, _productionOrderAction.fulfill)(data, id, storeId)).then(function (resp) {
	      var error = resp.error,
	          data = resp.data;
	
	      if (!error) {
	        dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS, data: data });
	      } else {
	        alert(error.message);
	        dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	      }
	    });
	  };
	};
	
	var approve = exports.approve = function approve() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$producti3 = state.forms.productionOrderItem,
	        id = _state$forms$producti3.id,
	        storeId = _state$forms$producti3.storeId;
	
	    dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	    return dispatch((0, _productionOrderAction.approve)(id, storeId)).then(function (resp) {
	      var error = resp.error,
	          data = resp.data;
	
	      if (error) {
	        alert(error.message);
	        dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	      } else {
	        dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS, data: data });
	      }
	    });
	  };
	};
	
	var cancel = exports.cancel = function cancel() {
	  return function (dispatch, getState) {
	    if (window.confirm("Do you really want to cancel this order?")) {
	      var state = getState();
	      var _state$forms$producti4 = state.forms.productionOrderItem,
	          id = _state$forms$producti4.id,
	          storeId = _state$forms$producti4.storeId;
	
	      dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	      return dispatch((0, _productionOrderAction.cancel)(id, storeId)).then(function (resp) {
	        var error = resp.error,
	            data = resp.data;
	
	        if (error) {
	          alert(error.message);
	          dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, error: error });
	        } else {
	          dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS, data: data });
	        }
	      });
	    }
	  };
	};
	
	var submit = exports.submit = function submit() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$producti5 = state.forms.productionOrderItem,
	        isCreating = _state$forms$producti5.isCreating,
	        errors = _state$forms$producti5.errors,
	        storeId = _state$forms$producti5.storeId,
	        id = _state$forms$producti5.id,
	        productionOrderItems = _state$forms$producti5.productionOrderItems,
	        initialValues = _state$forms$producti5.initialValues,
	        typeId = _state$forms$producti5.typeId;
	
	    if (errors.loadBOM.length && errors.loadUOM.length && errors.loadListing.length) {
	      alert('Faild to save, missing data.');
	      return;
	    }
	
	    var error = null;
	    productionOrderItems.forEach(function (i) {
	      if ((0, _big2.default)(i.qtyFulfilled).gt(i.quantity)) {
	        error = 'Processed quantity should not be greater than planned quantity.';
	      }
	      if (typeId === 2 && i.quantityInDisplayUnit > i.listingQuantity / i.ratio) {
	        error = 'Planned quantity should not be greater than Lateset qty on shelf';
	      }
	    });
	    if (error) {
	      alert(error);
	      return;
	    }
	
	    dispatch({ type: actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST });
	
	    var isProcessing = ['approved', 'fulfilling'].indexOf(initialValues.state) > -1;
	
	    var data = { typeId: typeId, productionOrderItemsAttributes: [] };
	
	    if (isCreating) {
	      productionOrderItems.forEach(function (p) {
	        var picked = cleanItem(p);
	        if (Array.isArray(p.productionOrderItemMaterials) && p.productionOrderItemMaterials.length) {
	          p.productionOrderItemMaterials = p.productionOrderItemMaterials.map(function (nested) {
	            return (0, _treeFlatten2.default)(nested, 'children');
	          });
	          p.productionOrderItemMaterials = [].concat.apply([], p.productionOrderItemMaterials);
	          picked.productionOrderItemMaterialsAttributes = p.productionOrderItemMaterials.map(cleanMaterials);
	        }
	        data.productionOrderItemsAttributes.push(picked);
	      });
	    } else {
	      if (isProcessing) {
	        data = { productionOrderItemsAttributes: [] };
	        data.productionOrderItemsAttributes = productionOrderItems.map(function (i) {
	          return (0, _lodash.pick)(i, ['id', 'qtyFulfilled', 'qtyFulfilledInDisplayUnit']);
	        });
	      } else {
	        productionOrderItems.forEach(function (p) {
	          var picked = cleanItem(p);
	          if (Array.isArray(p.productionOrderItemMaterials) && p.productionOrderItemMaterials.length) {
	            p.productionOrderItemMaterials = p.productionOrderItemMaterials.map(function (nested) {
	              return (0, _treeFlatten2.default)(nested, 'children');
	            });
	            p.productionOrderItemMaterials = [].concat.apply([], p.productionOrderItemMaterials);
	            picked.productionOrderItemMaterialsAttributes = p.productionOrderItemMaterials.map(cleanMaterials);
	          }
	        });
	        data.productionOrderItemsAttributes = itemDiff(initialValues.productionOrderItems, productionOrderItems);
	      }
	    }
	
	    dispatch(isCreating ? createProductionOrder(data, storeId) : isProcessing ? fulfillProductionOrder(data, id, storeId) : updateProductionOrder(data, id, storeId));
	  };
	};
	
	var cleanItem = function cleanItem(item) {
	  return (0, _lodash.pick)(item, ['id', '_destroy', 'listingId', 'ean13', "listingBarcode", "quantity", "baseUnitId", "baseUnit", "quantityInDisplayUnit", "displayUnitId", "displayUnit", 'trackQuantity', "productionOrderItemMaterialsAttributes", "qtyFulfilledInDisplayUnit", "qtyFulfilled"]);
	};
	
	var cleanMaterials = function cleanMaterials(item) {
	  return (0, _lodash.pick)(item, ['name', 'baseUnit', 'baseUnitId', 'autoAssembly', 'ean13', 'listingBarcode', 'trackQuantity', 'bomRatio', 'unitRatio', 'listingId', 'parentListingId', 'quantity', 'baseUnitId', 'baseUnit', 'quantityInDisplayUnit', 'displayUnitId', 'displayUnit', 'uuid', 'qtyFulfilled', 'qtyFulfilledInDisplayUnit', 'parentUuid']);
	};
	
	var itemDiff = function itemDiff(prev, next) {
	  var toRemove = (0, _lodash.slice)((0, _lodash.differenceBy)(prev, next, 'id'));
	  var toAdd = (0, _lodash.slice)((0, _lodash.differenceBy)(next, prev, 'id'));
	  var toUpdate = (0, _lodash.slice)((0, _lodash.intersectionBy)(next, prev, 'id'));
	
	  (0, _lodash.forEach)(toRemove, function (item) {
	    return item['_destroy'] = true;
	  });
	  return (0, _lodash.concat)(toRemove, toAdd, toUpdate);
	};
	
	var getListingIdFromNested = function getListingIdFromNested(productionOrderItems) {
	  var itemIds = productionOrderItems.map(function (i) {
	    return i.listingId;
	  });
	  productionOrderItems.forEach(function (i) {
	    if (Array.isArray(i.productionOrderItemMaterials) && i.productionOrderItemMaterials.length) {
	      var materialListingIds = i.productionOrderItemMaterials.map(function (m) {
	        return m.listingId;
	      });
	
	      itemIds = itemIds.concat(materialListingIds);
	    }
	  });
	  return itemIds;
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStatus = exports.toggleStatusSelection = exports.submitStatusSelection = exports.changeStatusInput = exports.closeStatusSelection = exports.openStatusSelection = exports.ADD_STATUS_FAILURE = exports.ADD_STATUS_SUCCESS = exports.ADD_STATUS_REQUEST = exports.SAVE_STATUS_SELECTION = exports.CHANGE_STATUS_INPUT = exports.TOGGLE_STATUS = exports.CLOSE_STATUS_SELECTION = exports.OPEN_STATUS_SELECTION = undefined;
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPEN_STATUS_SELECTION = exports.OPEN_STATUS_SELECTION = 'OPEN_STATUS_SELECTION';
	var CLOSE_STATUS_SELECTION = exports.CLOSE_STATUS_SELECTION = 'CLOSE_STATUS_SELECTION';
	var TOGGLE_STATUS = exports.TOGGLE_STATUS = 'TOGGLE_STATUS';
	var CHANGE_STATUS_INPUT = exports.CHANGE_STATUS_INPUT = 'CHANGE_STATUS_INPUT';
	var SAVE_STATUS_SELECTION = exports.SAVE_STATUS_SELECTION = 'SAVE_STATUS_SELECTION';
	
	var ADD_STATUS_REQUEST = exports.ADD_STATUS_REQUEST = 'ADD_STATUS_REQUEST';
	var ADD_STATUS_SUCCESS = exports.ADD_STATUS_SUCCESS = 'ADD_STATUS_SUCCESS';
	var ADD_STATUS_FAILURE = exports.ADD_STATUS_FAILURE = 'ADD_STATUS_FAILURE';
	
	var openStatusSelection = exports.openStatusSelection = function openStatusSelection(_ref) {
	  var selected = _ref.selected,
	      params = _ref.params;
	  return function (dispatch, getState) {
	    var state = getState();
	    var lineItemStatuses = state.entities.lineItemStatuses;
	
	    var all = (0, _values2.default)(lineItemStatuses);
	    all = all.map(function (s) {
	      return { line_item_status_id: s.id, line_item_status_name: s.status };
	    });
	    dispatch({ type: OPEN_STATUS_SELECTION, all: all, selected: selected.slice(), params: params });
	  };
	};
	
	var closeStatusSelection = exports.closeStatusSelection = function closeStatusSelection() {
	  return { type: CLOSE_STATUS_SELECTION };
	};
	
	var changeStatusInput = exports.changeStatusInput = function changeStatusInput(value) {
	  return { type: CHANGE_STATUS_INPUT, value: value };
	};
	
	var submitStatusSelection = exports.submitStatusSelection = function submitStatusSelection() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$statusSe = state.forms.statusSelection,
	        selected = _state$forms$statusSe.selected,
	        params = _state$forms$statusSe.params;
	
	    dispatch({ type: SAVE_STATUS_SELECTION, selected: selected, params: params });
	  };
	};
	
	var toggleStatusSelection = exports.toggleStatusSelection = function toggleStatusSelection(_ref2) {
	  var item = _ref2.item,
	      checked = _ref2.checked;
	  return { type: TOGGLE_STATUS, item: item, checked: checked };
	};
	
	var createStatus = exports.createStatus = function createStatus(_ref3) {
	  var status = _ref3.status,
	      color = _ref3.color,
	      store_id = _ref3.store_id;
	
	  return function (dispatch) {
	    dispatch({ type: ADD_STATUS_REQUEST });
	    dispatch((0, _lineItemStatusAction.createLineItemStatus)(status, color, store_id)).then(function (result) {
	      var data = result.data;
	
	      if (data) {
	        data.line_item_status_name = data.status;
	        data.line_item_status_id = data.id;
	        dispatch({ type: ADD_STATUS_SUCCESS, data: data });
	        dispatch(changeStatusInput(''));
	      } else {
	        dispatch({ type: ADD_STATUS_FAILURE });
	      }
	    });
	  };
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.voidInvoice = exports.sendInvoice = exports.exportInvoicePdf = exports.getInvoiceDeliveryNote = exports.voidTransaction = exports.confirmVoidTransaction = exports.changeInvoiceListingUnitPrice = exports.refreshInvoice = exports.getInvoiceHistory = exports.LOAD_INVOICE_DELIVERY_ORDER_SUCCESS = exports.LOAD_INVOICE_HISTORY_FAILURE = exports.LOAD_INVOICE_HISTORY_SUCCESS = exports.LOAD_INVOICE_HISTORY_REQUEST = exports.PATCH_INVOICE_LISTING_UNIT_GROUP = exports.PATCH_INVOICE_LISTING_MISSING_INFO = exports.LOAD_INVOICE_TO_FORM = exports.CALCULATE_INVOICE_ORDER_TOTAL = exports.CHANGE_INVOICE_LISTING_UNIT_PRICE = exports.CHANGE_INVOICE_DISCOUNT = exports.CHANGE_INVOICE_LISTING_UNIT = exports.CHANGE_INVOICE_LISTING_QUANTITY = exports.CHANGE_INVOICE_FIELDS = exports.CHANGE_INVOICE_FIELD = exports.REMOVE_LISTINGS_FROM_INVOICE = exports.ADD_LISTINGS_TO_INVOICE = exports.CHANGE_INVOICE_TAB = exports.SET_INVOICE_STATE = exports.INIT_INVOICE_STATE = undefined;
	exports.getInvoice = getInvoice;
	exports.goToInvoiceSearch = goToInvoiceSearch;
	exports.initInvoiceState = initInvoiceState;
	exports.loadInvoiceToForm = loadInvoiceToForm;
	exports.refreshInvoiceLineItemDetails = refreshInvoiceLineItemDetails;
	exports.fetchInvoiceLineItemUnitGroups = fetchInvoiceLineItemUnitGroups;
	exports.changeInvoiceTab = changeInvoiceTab;
	exports.addListingsToInvoice = addListingsToInvoice;
	exports.removeListingsFromInvoice = removeListingsFromInvoice;
	exports.changeInvoiceField = changeInvoiceField;
	exports.changeInvoiceListingQuantity = changeInvoiceListingQuantity;
	exports.changeInvoiceListingUnit = changeInvoiceListingUnit;
	exports.changeInvoiceDiscount = changeInvoiceDiscount;
	exports.saveInvoice = saveInvoice;
	exports.startEditInvoice = startEditInvoice;
	exports.convertQuoteToInvoice = convertQuoteToInvoice;
	exports.cancelInvoice = cancelInvoice;
	
	var _reactRouter = __webpack_require__(9);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _formatHelper = __webpack_require__(35);
	
	var _humps = __webpack_require__(44);
	
	var _normalizr = __webpack_require__(64);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _schema = __webpack_require__(109);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _invoiceService = __webpack_require__(323);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _quoteService = __webpack_require__(965);
	
	var _quoteService2 = _interopRequireDefault(_quoteService);
	
	var _unitGroupsService = __webpack_require__(969);
	
	var _unitGroupsService2 = _interopRequireDefault(_unitGroupsService);
	
	var _deliveryOrderService = __webpack_require__(493);
	
	var _deliveryOrderService2 = _interopRequireDefault(_deliveryOrderService);
	
	var _constants = __webpack_require__(26);
	
	var _alertActions = __webpack_require__(90);
	
	var _baseActions = __webpack_require__(34);
	
	var _emailTemplateActions = __webpack_require__(308);
	
	var _constant = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INIT_INVOICE_STATE = exports.INIT_INVOICE_STATE = 'INIT_INVOICE_STATE';
	var SET_INVOICE_STATE = exports.SET_INVOICE_STATE = 'SET_INVOICE_STATE';
	var CHANGE_INVOICE_TAB = exports.CHANGE_INVOICE_TAB = 'CHANGE_INVOICE_TAB';
	var ADD_LISTINGS_TO_INVOICE = exports.ADD_LISTINGS_TO_INVOICE = 'ADD_LISTINGS_TO_INVOICE';
	var REMOVE_LISTINGS_FROM_INVOICE = exports.REMOVE_LISTINGS_FROM_INVOICE = 'REMOVE_LISTINGS_FROM_INVOICE';
	var CHANGE_INVOICE_FIELD = exports.CHANGE_INVOICE_FIELD = 'CHANGE_INVOICE_FIELD';
	var CHANGE_INVOICE_FIELDS = exports.CHANGE_INVOICE_FIELDS = 'CHANGE_INVOICE_FIELDS';
	var CHANGE_INVOICE_LISTING_QUANTITY = exports.CHANGE_INVOICE_LISTING_QUANTITY = 'CHANGE_INVOICE_LISTING_QUANTITY';
	var CHANGE_INVOICE_LISTING_UNIT = exports.CHANGE_INVOICE_LISTING_UNIT = 'CHANGE_INVOICE_LISTING_UNIT';
	var CHANGE_INVOICE_DISCOUNT = exports.CHANGE_INVOICE_DISCOUNT = 'CHANGE_INVOICE_DISCOUNT';
	var CHANGE_INVOICE_LISTING_UNIT_PRICE = exports.CHANGE_INVOICE_LISTING_UNIT_PRICE = 'CHANGE_INVOICE_LISTING_UNIT_PRICE';
	var CALCULATE_INVOICE_ORDER_TOTAL = exports.CALCULATE_INVOICE_ORDER_TOTAL = 'CALCULATE_INVOICE_ORDER_TOTAL';
	var LOAD_INVOICE_TO_FORM = exports.LOAD_INVOICE_TO_FORM = 'LOAD_INVOICE_TO_FORM';
	var PATCH_INVOICE_LISTING_MISSING_INFO = exports.PATCH_INVOICE_LISTING_MISSING_INFO = 'PATCH_INVOICE_LISTING_MISSING_INFO';
	var PATCH_INVOICE_LISTING_UNIT_GROUP = exports.PATCH_INVOICE_LISTING_UNIT_GROUP = 'PATCH_INVOICE_LISTING_UNIT_GROUP';
	var LOAD_INVOICE_HISTORY_REQUEST = exports.LOAD_INVOICE_HISTORY_REQUEST = 'LOAD_INVOICE_HISTORY_REQUEST';
	var LOAD_INVOICE_HISTORY_SUCCESS = exports.LOAD_INVOICE_HISTORY_SUCCESS = 'LOAD_INVOICE_HISTORY_SUCCESS';
	var LOAD_INVOICE_HISTORY_FAILURE = exports.LOAD_INVOICE_HISTORY_FAILURE = 'LOAD_INVOICE_HISTORY_FAILURE';
	var LOAD_INVOICE_DELIVERY_ORDER_SUCCESS = exports.LOAD_INVOICE_DELIVERY_ORDER_SUCCESS = 'LOAD_INVOICE_DELIVERY_ORDER_SUCCESS';
	
	function getInvoice(storeId, number) {
	    return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	        promise: _invoiceService2.default.getItem(storeId, number).then(function (res) {
	            return (0, _normalizr.normalize)(res.invoice, _schema.InvoiceSchema);
	        })
	    });
	}
	
	var getInvoiceHistory = exports.getInvoiceHistory = function getInvoiceHistory() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var _state$invoice = state.invoice,
	            _state$invoice$curren = _state$invoice.currentStore,
	            currentStore = _state$invoice$curren === undefined ? {} : _state$invoice$curren,
	            _state$invoice$order = _state$invoice.order,
	            order = _state$invoice$order === undefined ? {} : _state$invoice$order;
	        var number = order.number;
	        var storeId = currentStore.id;
	
	        if (!number || !storeId) return;
	        dispatch({ type: LOAD_INVOICE_HISTORY_REQUEST });
	        return _invoiceService2.default.getItemHistory(storeId, number).then(function (resp) {
	            resp = (0, _humps.camelizeKeys)(resp);
	            var data = resp.histories;
	            if (data) {
	                dispatch({ type: LOAD_INVOICE_HISTORY_SUCCESS, data: data });
	                return { data: data };
	            } else {
	                var error = new Error('Invalid response');
	                (0, _alertActions.alert)(error.message);
	                dispatch({ type: LOAD_INVOICE_HISTORY_FAILURE, error: error });
	                return { error: error };
	            }
	        }).catch(function (error) {
	            (0, _alertActions.alert)(error.message);
	            dispatch({ type: LOAD_INVOICE_HISTORY_FAILURE, error: error });
	            return { error: error };
	        });
	    };
	};
	
	/* istanbul ignore next */
	function goToInvoiceSearch(storeId) {
	    window.top.location.replace('/' + storeId + '/invoices');
	}
	
	function initInvoiceState(type, mode, tab, orderNumber, currentStore, multiStore) {
	    return function (dispatch) {
	        var _currentStore$module = currentStore.module,
	            module = _currentStore$module === undefined ? {} : _currentStore$module;
	        var decimal_points = module.decimal_points,
	            rounding_type = module.rounding_type,
	            line_item_decimal_points = module.line_item_decimal_points,
	            line_item_rounding_type = module.line_item_rounding_type,
	            quantity_decimal_points = module.quantity_decimal_points;
	
	
	        dispatch({
	            type: INIT_INVOICE_STATE,
	            data: {
	                type: type,
	                mode: mode,
	                currentTab: tab,
	                multiStore: multiStore,
	                currentStore: currentStore,
	                orderNumber: orderNumber,
	                totalDp: decimal_points,
	                totalRoundType: rounding_type,
	                listingDp: line_item_decimal_points,
	                listingRoundType: line_item_rounding_type,
	                quantityDp: quantity_decimal_points
	            }
	        });
	
	        if (mode === _constant.VIEW) {
	            loadInvoiceToForm(type, currentStore.id, orderNumber)(dispatch);
	        }
	    };
	}
	
	function loadInvoiceToForm(type, storeId, orderNumber) {
	    return function (dispatch) {
	        var order = null;
	        if (type === _constant.INVOICE_TYPE) {
	            order = _invoiceService2.default.getItem(storeId, orderNumber).then(function (res) {
	                return res.invoice;
	            });
	        } else if (type === _constant.QUOTE_TYPE) {
	            order = _quoteService2.default.getItem(storeId, orderNumber).then(function (res) {
	                return res.quote;
	            });
	        }
	        if (order) {
	            dispatch((0, _baseActions.startFetch)());
	            return order.then(function (raw) {
	                var data = (0, _humps.camelizeKeys)(raw);
	                dispatch({ type: LOAD_INVOICE_TO_FORM, data: data });
	                var listingIds = (data.listingLineItems || []).map(function (d) {
	                    return d.purchasableId;
	                });
	                return refreshInvoiceLineItemDetails(storeId, listingIds)(dispatch);
	            }).then(function () {
	                return dispatch(getInvoiceDeliveryNote());
	            }).then(function () {
	                return dispatch((0, _baseActions.stopFetch)());
	            }).catch(function (err) {
	                dispatch((0, _baseActions.stopFetch)());
	                dispatch((0, _alertActions.alert)('danger', err.message));
	            });
	        }
	    };
	}
	
	var refreshInvoice = exports.refreshInvoice = function refreshInvoice() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var _state$invoice2 = state.invoice,
	            invoice = _state$invoice2 === undefined ? {} : _state$invoice2;
	        var type = invoice.type,
	            _invoice$currentStore = invoice.currentStore,
	            currentStore = _invoice$currentStore === undefined ? {} : _invoice$currentStore,
	            _invoice$order = invoice.order,
	            order = _invoice$order === undefined ? {} : _invoice$order;
	        var storeId = currentStore.id;
	        var number = order.number;
	
	        if (type && storeId && number) {
	            return loadInvoiceToForm(type, storeId, number)(dispatch);
	        }
	    };
	};
	
	function refreshInvoiceLineItemDetails(storeId) {
	    var listingIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return function (dispatch) {
	        var ids = Array.isArray(listingIds) ? listingIds : [listingIds];
	        if (ids.length > 0) {
	            dispatch((0, _baseActions.startFetch)());
	            var promise = _inventoryService2.default.getItems(storeId, ids);
	            return promise.then(function (res) {
	                var count = res.count,
	                    _res$data$listings = res.data.listings,
	                    listings = _res$data$listings === undefined ? [] : _res$data$listings;
	
	                var data = (0, _humps.camelizeKeys)(listings);
	                var unitGroupIds = data.reduce(function (ret, item) {
	                    if (item.unitGroupId) {
	                        ret.add(item.unitGroupId);
	                    }
	                    return ret;
	                }, new Set());
	
	                if (count > 0) {
	                    dispatch({ type: PATCH_INVOICE_LISTING_MISSING_INFO, data: data });
	                    return fetchInvoiceLineItemUnitGroups(storeId, unitGroupIds)(dispatch);
	                }
	            }).then(function () {
	                return dispatch((0, _baseActions.stopFetch)());
	            }).catch(function (err) {
	                dispatch((0, _baseActions.stopFetch)());
	                dispatch((0, _alertActions.alert)('danger', err.message));
	            });
	        }
	    };
	}
	
	function fetchInvoiceLineItemUnitGroups(storeId) {
	    var unitGroupIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return function (dispatch) {
	        if (unitGroupIds.size > 0 || unitGroupIds.length > 0) {
	            var promises = [].concat(_toConsumableArray(unitGroupIds)).map(function (id) {
	                return _unitGroupsService2.default.getItem(storeId, id);
	            });
	            dispatch((0, _baseActions.startFetch)());
	            return Promise.all(promises).then(function (result) {
	                var unitGroups = (0, _humps.camelizeKeys)(result).map(function (d) {
	                    return d.unitGroup;
	                });
	
	                var _normalize = (0, _normalizr.normalize)(unitGroups, (0, _normalizr.arrayOf)(_schema.UnitGroupSchema)),
	                    entities = _normalize.entities;
	
	                dispatch({ type: PATCH_INVOICE_LISTING_UNIT_GROUP, data: entities });
	            }).then(function () {
	                return dispatch((0, _baseActions.stopFetch)());
	            }).catch(function (err) {
	                dispatch((0, _baseActions.stopFetch)());
	                dispatch((0, _alertActions.alert)('danger', err.message));
	            });
	        }
	    };
	}
	
	function changeInvoiceTab(tab) {
	    return {
	        type: CHANGE_INVOICE_TAB,
	        data: tab
	    };
	}
	
	function addListingsToInvoice() {
	    var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var storeId = arguments[1];
	    var unitGroupIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var units = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return function (dispatch) {
	        var ls = Array.isArray(listings) ? (0, _humps.camelizeKeys)(listings) : (0, _humps.camelizeKeys)([listings]);
	        if (ls.length > 0) {
	            dispatch({ type: ADD_LISTINGS_TO_INVOICE, data: ls });
	            dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	
	            var missingUnitGroupIds = ls.reduce(function (ids, listing) {
	                if (listing.unitGroupId && !unitGroupIds[listing.unitGroupId]) {
	                    ids.add(listing.unitGroupId);
	                }
	                return ids;
	            }, new Set());
	            fetchInvoiceLineItemUnitGroups(storeId, missingUnitGroupIds)(dispatch);
	        }
	    };
	}
	
	function removeListingsFromInvoice() {
	    var indexes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return function (dispatch) {
	        var idxs = Array.isArray(indexes) ? indexes : [indexes];
	        if (idxs.length > 0) {
	            dispatch({ type: REMOVE_LISTINGS_FROM_INVOICE, data: idxs });
	            dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	        }
	    };
	}
	function changeInvoiceField(field, value) {
	    return function (dispatch) {
	        if (field) {
	            var specialHandling = {
	                billingAddressInfo: function billingAddressInfo(f, v) {
	                    var _data;
	
	                    var address = (0, _humps.camelizeKeys)(v || {});
	                    var data = (_data = {}, _defineProperty(_data, f, address.id ? address : null), _defineProperty(_data, 'billToId', address.id ? address.id : null), _data);
	                    dispatch({ type: CHANGE_INVOICE_FIELDS, data: data });
	                },
	                shippingAddressInfo: function shippingAddressInfo(f, v) {
	                    var _data2;
	
	                    var address = (0, _humps.camelizeKeys)(v || {});
	                    var data = (_data2 = {}, _defineProperty(_data2, f, address.id ? address : null), _defineProperty(_data2, 'shipToId', address.id ? address.id : null), _data2);
	                    dispatch({ type: CHANGE_INVOICE_FIELDS, data: data });
	                }
	            };
	
	            if (specialHandling[field]) {
	                specialHandling[field](field, value);
	            } else {
	                dispatch({
	                    type: CHANGE_INVOICE_FIELD,
	                    data: { field: field, value: value }
	                });
	            }
	        }
	    };
	}
	
	function changeInvoiceListingQuantity(index, value) {
	    return function (dispatch) {
	        dispatch({ type: CHANGE_INVOICE_LISTING_QUANTITY, data: { index: index, value: value } });
	        dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	    };
	}
	
	function changeInvoiceListingUnit(index, value) {
	    return function (dispatch) {
	        dispatch({ type: CHANGE_INVOICE_LISTING_UNIT, data: { index: index, value: value } });
	        dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	    };
	}
	
	function changeInvoiceDiscount(index, discount) {
	    return function (dispatch) {
	        dispatch({ type: CHANGE_INVOICE_DISCOUNT, data: { index: index, discount: discount } });
	        dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	    };
	}
	
	var changeInvoiceListingUnitPrice = exports.changeInvoiceListingUnitPrice = function changeInvoiceListingUnitPrice(index, value) {
	    return function (dispatch) {
	        dispatch({ type: CHANGE_INVOICE_LISTING_UNIT_PRICE, data: { index: index, value: value } });
	        dispatch({ type: CALCULATE_INVOICE_ORDER_TOTAL });
	    };
	};
	
	function saveInvoice() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function (dispatch) {
	        var type = params.type,
	            mode = params.mode,
	            currentTab = params.currentTab,
	            _params$currentStore = params.currentStore,
	            currentStore = _params$currentStore === undefined ? {} : _params$currentStore,
	            multiStore = params.multiStore,
	            order = params.order;
	        var storeId = currentStore.id,
	            timezone = currentStore.timezone;
	        var number = order.number;
	
	        var mappedLineItems = (order.lineItems || []).map(function (item) {
	            var id = item.id,
	                label = item.label,
	                purchasableId = item.purchasableId,
	                purchasableType = item.purchasableType,
	                price = item.price,
	                unitPrice = item.unitPrice,
	                discountEntries = item.discountEntries,
	                quantity = item.quantity,
	                unitQuantity = item.unitQuantity,
	                roundingAmount = item.roundingAmount,
	                baseUnitId = item.baseUnitId,
	                baseUnit = item.baseUnit,
	                displayUnit = item.displayUnit,
	                quantityAllowDecimal = item.quantityAllowDecimal,
	                displayUnitId = item.displayUnitId;
	
	            price = price.toString();
	            unitPrice = unitPrice.toString();
	            quantity = quantity.toString();
	            unitQuantity = unitQuantity.toString();
	            roundingAmount = roundingAmount.toString();
	            var quantityInDisplayUnit = unitQuantity.toString();
	            return {
	                id: id,
	                label: label,
	                purchasableId: purchasableId,
	                purchasableType: purchasableType,
	                price: price,
	                unitPrice: unitPrice,
	                discountEntries: discountEntries,
	                quantity: quantity,
	                unitQuantity: unitQuantity,
	                roundingAmount: roundingAmount,
	                baseUnitId: baseUnitId,
	                baseUnit: baseUnit,
	                displayUnit: displayUnit,
	                quantityAllowDecimal: quantityAllowDecimal,
	                displayUnitId: displayUnitId,
	                quantityInDisplayUnit: quantityInDisplayUnit
	            };
	        });
	        if (!order.rounding.eq(0)) {
	            mappedLineItems.push({
	                id: order.roundingId,
	                purchasableType: _constants.PURCHASABLE_TYPE_ROUNDING,
	                price: order.rounding.toString(),
	                quantity: 1
	            });
	        }
	        if (type && mode && storeId && order && (number || mode === _constant.NEW)) {
	            var data = {
	                order: {
	                    referenceNumber: order.referenceNumber,
	                    effectiveCreatedAt: (0, _formatHelper.dateToIso)(order.effectiveCreatedAt, timezone),
	                    dueDate: order.dueDate,
	                    deliveryDate: order.deliveryDate,
	                    customerId: order.customerId,
	                    billToId: order.billToId,
	                    shipToId: order.shipToId,
	                    note: order.note,
	                    lineItems: mappedLineItems
	                }
	            };
	            data = (0, _humps.decamelizeKeys)(data);
	
	            var promise = null;
	            if (type === _constant.INVOICE_TYPE && mode === _constant.NEW) {
	                dispatch((0, _baseActions.startFetch)());
	                promise = _invoiceService2.default.createItem(storeId, data);
	                promise.then(function (res) {
	                    var _ref2 = res || {},
	                        invoice = _ref2.invoice;
	
	                    _reactRouter.browserHistory.push('/v2' + _routeHelper2.default.invoices(storeId, invoice.number));
	                });
	            } else if (type === _constant.INVOICE_TYPE && mode === _constant.EDIT) {
	                dispatch((0, _baseActions.startFetch)());
	                promise = _invoiceService2.default.updateItem(storeId, number, data);
	                promise.then(function (res) {
	                    initInvoiceState(type, _constant.VIEW, currentTab, number, currentStore, multiStore)(dispatch);
	                });
	            } else if (type === _constant.QUOTE_TYPE && mode === _constant.NEW) {
	                dispatch((0, _baseActions.startFetch)());
	                promise = _quoteService2.default.createItem(storeId, data);
	                promise.then(function (res) {
	                    var _ref3 = res || {},
	                        quote = _ref3.quote;
	
	                    _reactRouter.browserHistory.push('/v2' + _routeHelper2.default.quotes(storeId, quote.number));
	                });
	            } else if (type === _constant.QUOTE_TYPE && mode === _constant.EDIT) {
	                dispatch((0, _baseActions.startFetch)());
	                promise = _quoteService2.default.updateItem(storeId, number, data);
	                promise.then(function (res) {
	                    initInvoiceState(type, _constant.VIEW, currentTab, number, currentStore, multiStore)(dispatch);
	                });
	            }
	            if (promise) {
	                return promise.catch(function (err) {
	                    dispatch((0, _baseActions.stopFetch)());
	                    dispatch((0, _alertActions.alert)('danger', err.message));
	                });
	            }
	        }
	    };
	}
	
	function startEditInvoice() {
	    var currentTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constant.OVERVIEW;
	
	    return function (dispatch) {
	        dispatch({ type: SET_INVOICE_STATE, data: { currentTab: currentTab, mode: _constant.EDIT } });
	    };
	}
	
	function convertQuoteToInvoice(storeId, orderNumber) {
	    return function (dispatch) {
	        dispatch((0, _baseActions.startFetch)());
	        var promise = _quoteService2.default.convertToInvoice(storeId, orderNumber);
	        return promise.then(function (res) {
	            _routeHelper2.default.goInvoices(storeId, orderNumber);
	        }).catch(function (err) {
	            dispatch((0, _baseActions.stopFetch)());
	            dispatch((0, _alertActions.alert)('danger', err.message));
	        });
	    };
	}
	
	function cancelInvoice() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function (dispatch) {
	        var type = params.type,
	            mode = params.mode,
	            currentTab = params.currentTab,
	            _params$currentStore2 = params.currentStore,
	            currentStore = _params$currentStore2 === undefined ? {} : _params$currentStore2,
	            multiStore = params.multiStore,
	            order = params.order;
	        var storeId = currentStore.id;
	        var number = order.number;
	
	        var msg = 'Are you sure to cancel this ' + type.toLowerCase() + '?';
	        if (confirm(msg)) {
	            var promise = null;
	            if (type === _constant.INVOICE_TYPE) {
	                promise = _invoiceService2.default.cancelItem(storeId, number);
	            } else {
	                promise = _quoteService2.default.cancelItem(storeId, number);
	            }
	            if (promise) {
	                dispatch((0, _baseActions.startFetch)());
	                return promise.then(function (res) {
	                    initInvoiceState(type, mode, currentTab, number, currentStore, multiStore)(dispatch);
	                }).catch(function (err) {
	                    dispatch((0, _baseActions.stopFetch)());
	                    dispatch((0, _alertActions.alert)('danger', err.message));
	                });
	            }
	        }
	    };
	}
	
	/* istanbul ignore next */
	var confirmVoidTransaction = exports.confirmVoidTransaction = function confirmVoidTransaction(storeId, orderNumber, transactionId) {
	    return function (dispatch, getState) {
	        if (storeId && orderNumber && transactionId) {
	            var state = getState();
	            var _state$invoice3 = state.invoice,
	                invoice = _state$invoice3 === undefined ? {} : _state$invoice3;
	            var _invoice$order2 = invoice.order,
	                order = _invoice$order2 === undefined ? {} : _invoice$order2;
	            var _order$saleTransactio = order.saleTransactions,
	                saleTransactions = _order$saleTransactio === undefined ? [] : _order$saleTransactio;
	
	            var transaction = saleTransactions.find(function (t) {
	                return t.id === transactionId;
	            });
	
	            if (transaction) {
	                var extra = transaction.extra,
	                    payment = transaction.payment,
	                    amount = transaction.amount,
	                    currency = transaction.currency;
	
	                var paymentType = extra ? 'Credit Card' : payment;
	                var msg = 'Are you sure to void the ' + (0, _formatHelper.formatCurrency)(amount, { currency: currency }) + ' ' + paymentType + ' settlement?';
	                return !!confirm(msg);
	            }
	        }
	        return null;
	    };
	};
	
	var voidTransaction = exports.voidTransaction = function voidTransaction(storeId, orderNumber, transactionId) {
	    return function (dispatch, getState) {
	        dispatch((0, _baseActions.startFetch)());
	        return _invoiceService2.default.voidTransaction(storeId, orderNumber, transactionId).then(function (res) {
	            refreshInvoice()(dispatch, getState);
	        }).catch(function (err) {
	            dispatch((0, _baseActions.stopFetch)());
	            dispatch((0, _alertActions.alert)('danger', err.message));
	        });
	    };
	};
	
	var getInvoiceDeliveryNote = exports.getInvoiceDeliveryNote = function getInvoiceDeliveryNote() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var _state$invoice4 = state.invoice,
	            invoice = _state$invoice4 === undefined ? {} : _state$invoice4;
	        var _invoice$currentStore2 = invoice.currentStore,
	            currentStore = _invoice$currentStore2 === undefined ? {} : _invoice$currentStore2,
	            _invoice$order3 = invoice.order,
	            order = _invoice$order3 === undefined ? {} : _invoice$order3;
	
	        dispatch((0, _baseActions.startFetch)());
	        return _deliveryOrderService2.default.getItems(currentStore.id, { order_id: order.id }, 1, 9999).then(function (res) {
	            var json = (0, _humps.camelizeKeys)(res);
	            dispatch((0, _baseActions.stopFetch)());
	            dispatch({ type: LOAD_INVOICE_DELIVERY_ORDER_SUCCESS, payload: json.data });
	        }).catch(function (err) {
	            dispatch((0, _baseActions.stopFetch)());
	            dispatch((0, _alertActions.alert)('danger', err.message));
	        });
	    };
	};
	
	/* istanbul ignore next */
	var exportInvoicePdf = exports.exportInvoicePdf = function exportInvoicePdf(storeId, number) {
	    return function (dispatch) {
	        dispatch((0, _baseActions.startFetch)());
	        return _invoiceService2.default.exportPdf(storeId, number).then(function (res) {
	            dispatch((0, _baseActions.stopFetch)());
	            if (res.url) {
	                location.assign(res.url);
	            }
	        }).catch(function (err) {
	            dispatch((0, _baseActions.stopFetch)());
	            dispatch((0, _alertActions.alert)('danger', err.message));
	        });
	    };
	};
	
	var sendInvoice = exports.sendInvoice = function sendInvoice(storeId, recipient, number) {
	    return function (dispatch) {
	        return (0, _emailTemplateActions.askRecipientThenSendEmail)({
	            storeId: storeId,
	            templateType: _emailTemplateActions.EMAIL_TEMPLATE_TYPE.EMAIL_RECEIPT,
	            defaultRecipient: recipient,
	            params: {
	                order_number: number
	            }
	        })(dispatch);
	    };
	};
	
	var voidInvoice = exports.voidInvoice = function voidInvoice(params) {
	    return function (dispatch) {
	        var type = params.type,
	            mode = params.mode,
	            currentTab = params.currentTab,
	            _params$currentStore3 = params.currentStore,
	            currentStore = _params$currentStore3 === undefined ? {} : _params$currentStore3,
	            multiStore = params.multiStore,
	            order = params.order;
	        var storeId = currentStore.id;
	        var number = order.number;
	
	        var msg = 'Are you sure to void this invoice?';
	        if (confirm(msg)) {
	            dispatch((0, _baseActions.startFetch)());
	            return _invoiceService2.default.voidItem(storeId, number).then(function (res) {
	                initInvoiceState(type, mode, currentTab, number, currentStore, multiStore)(dispatch);
	            }).catch(function (err) {
	                dispatch((0, _baseActions.stopFetch)());
	                dispatch((0, _alertActions.alert)('danger', err.message));
	            });
	        }
	    };
	};

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveFilter = saveFilter;
	exports.removeFilter = removeFilter;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SAVE_FILTER = exports.SAVE_FILTER = 'SAVE_FILTER';
	var REMOVE_SAVED_FILTER = exports.REMOVE_SAVED_FILTER = 'REMOVE_SAVED_FILTER';
	
	function saveFilter(group, name, filter) {
	  // TODO: handle same name
	  var data = _defineProperty({}, group, _defineProperty({}, name, filter));
	
	  return {
	    type: SAVE_FILTER,
	    data: data
	  };
	}
	
	function removeFilter(group, name) {
	  return {
	    type: REMOVE_SAVED_FILTER,
	    data: {
	      group: group,
	      name: name
	    }
	  };
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLEAR_STORE = exports.SWITCH_STORE = exports.UPDATE_STORE = exports.SET_STORES = undefined;
	exports.switchStore = switchStore;
	exports.clearStore = clearStore;
	exports.getStores = getStores;
	exports.updateStore = updateStore;
	exports.getStoreModule = getStoreModule;
	exports.updateStoreModule = updateStoreModule;
	exports.updateScaleBarcode = updateScaleBarcode;
	exports.getStorePermissions = getStorePermissions;
	exports.getStoreChainInfo = getStoreChainInfo;
	exports.getStorePolicy = getStorePolicy;
	exports.updateStorePolicy = updateStorePolicy;
	exports.getScaleBarcode = getScaleBarcode;
	
	var _storeService = __webpack_require__(496);
	
	var _storeService2 = _interopRequireDefault(_storeService);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_STORES = exports.SET_STORES = 'SET_STORES';
	var UPDATE_STORE = exports.UPDATE_STORE = 'UPDATE_STORE';
	var SWITCH_STORE = exports.SWITCH_STORE = 'SWITCH_STORE';
	var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE';
	
	function switchStore() {
	  return {
	    type: SWITCH_STORE
	  };
	}
	
	function clearStore() {
	  return {
	    type: CLEAR_STORE
	  };
	}
	
	function getStores(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.get(storeId).then(function (data) {
	      dispatch({
	        type: SET_STORES,
	        stores: (0, _map2.default)(data, function (d) {
	          return d.store;
	        })
	      });
	    });
	  };
	}
	
	function updateStore(storeId, data) {
	  return function (dispatch) {
	    return _storeService2.default.update(storeId, data).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}
	
	function getStoreModule(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.getModule(storeId).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	      return { data: data };
	    }).catch(function (error) {
	      return { error: error };
	    });
	  };
	}
	
	function updateStoreModule(storeId, data) {
	  return function (dispatch) {
	    return _storeService2.default.updateModule(storeId, data).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	
	      });
	    });
	  };
	}
	
	function updateScaleBarcode(storeId, data) {
	  return function (dispatch) {
	    return _storeService2.default.updateBarcode(storeId, data).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	
	      });
	    });
	  };
	}
	
	function getStorePermissions(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.getPermissions(storeId).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}
	
	function getStoreChainInfo(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.getChainInfo(storeId).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}
	
	function getStorePolicy(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.getPolicy(storeId).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}
	
	function updateStorePolicy(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.updatePolicy(storeId).then(function (data) {
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}
	
	function getScaleBarcode(storeId) {
	  return function (dispatch) {
	    return _storeService2.default.getBarcode(storeId).then(function (data) {
	      if (data.scale_barcodes === undefined || data.scale_barcodes.length == 0) {
	        data.scale_barcodes = [{
	          decimal: 1,
	          prefix: "",
	          type: 0
	        }, {
	          decimal: 1,
	          prefix: "",
	          type: 1
	        }];
	      }
	      dispatch({
	        type: UPDATE_STORE,
	        data: data,
	        id: storeId
	      });
	    });
	  };
	}

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1232);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _compact = __webpack_require__(280);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _addListingByBarcode = __webpack_require__(766);
	
	var _addListingByBarcode2 = _interopRequireDefault(_addListingByBarcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var filterSettings = [{
	  columnName: "name",
	  displayName: "PRODUCT NAME",
	  filterConditions: ['contain']
	}, {
	  columnName: "brand_name",
	  displayName: "BRAND",
	  filterConditions: ['contain']
	}, {
	  columnName: "department_id",
	  displayName: "DEPARTMENT ID",
	  filterConditions: ['equal']
	}, {
	  columnName: "quantity",
	  displayName: "QTY ON SHELF",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "qty_stockroom",
	  displayName: "STOCKROOM QTY",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "price",
	  displayName: "PRICE",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "gtid",
	  displayName: "UPC/EAN",
	  filterConditions: ['equal', 'contain']
	}, {
	  columnName: "listing_barcode",
	  displayName: "PLU/SKU",
	  filterConditions: ['equal', 'contain']
	}, {
	  columnName: "updated_at",
	  displayName: "Updated At",
	  filterConditions: ['date_between', 'date_equal']
	}];
	
	var AddListingButton = (_temp2 = _class = function (_Component) {
	  _inherits(AddListingButton, _Component);
	
	  function AddListingButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddListingButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddListingButton.__proto__ || Object.getPrototypeOf(AddListingButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchListing: false,
	      listings: null,
	      advanceSearch: false,
	      currentFilters: [],
	      currentPage: 0,
	      totalPages: 1,
	      loading: false
	    }, _this.listingCheckboxs = {}, _this.closeModal = function () {
	      _this.setState({
	        searchListing: false
	      });
	    }, _this.openModal = function () {
	      _this.setState({
	        listings: null,
	        searchListing: true
	      });
	    }, _this.advanceSearch = function () {
	      _this.setState({
	        advanceSearch: true
	      });
	    }, _this.simpleSearch = function () {
	      _this.setState({
	        advanceSearch: false
	      });
	    }, _this.save = function () {
	      var checkedIds = (0, _compact2.default)((0, _map2.default)(_this.listingCheckboxs, function (checkbox, id) {
	        return checkbox && checkbox.checked ? id : null;
	      }));
	      var products = checkedIds.map(function (id) {
	        return _this.state.listings.find(function (listing) {
	          return listing.id == id;
	        });
	      });
	      _this.props.onSave && _this.props.onSave(products);
	      _this.closeModal();
	    }, _this.onAddByBarcode = function (listings) {
	      _this.props.onSave && _this.props.onSave(listings);
	    }, _this.search = function (event) {
	      event.preventDefault();
	      var value = _this.refs.keyword.value;
	
	
	      if (!value.trim()) {
	        return;
	      }
	
	      var filters = [{
	        column: "name",
	        condition: "contain",
	        conditionValue: value
	      }];
	
	      _this.searchByFilter(filters);
	    }, _this.setSearchPage = function (index) {
	      var page = index + 1;
	      _this.searchByFilter(_this.state.currentFilters, page);
	      _this.setState({
	        currentPage: index
	      });
	    }, _this.searchByFilter = function (filters) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var baseSearch = _this.props.baseSearch;
	
	      var baseFilter = _filterHelper2.default.searchParamToFilters(baseSearch);
	      var combinedFilters = [].concat(filters || [], baseFilter || []);
	      _this.setState({ loading: true });
	      var store_id = _this.context.currentStore.id;
	      _inventoryService2.default.search(store_id, page, 50, undefined, combinedFilters).then(function (res) {
	        var unit_group_ids = res.data.map(function (u) {
	          return u.unit_group_id;
	        });
	        var promises = unit_group_ids.map(function (group_id) {
	          return group_id ? _inventoryService2.default.getUnits(store_id, group_id).then(function (response) {
	            return response.unit_group.units.map(function (unit) {
	              return unit.is_base_unit ? unit.name : null;
	            });
	          }) : null;
	        });
	
	        Promise.all(promises).then(function (resonse) {
	          res.data.map(function (r, i) {
	            return r.units = resonse[i];
	          });
	          _this.setState({
	            listings: res.data,
	            currentFilters: filters,
	            currentPage: res.page - 1,
	            totalPages: res.totalPages,
	            loading: false
	          });
	        }).catch(function (e) {
	          _this.setState({ loading: false });
	        });
	      }).catch(function (e) {
	        _this.setState({ loading: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddListingButton, [{
	    key: 'render',
	    value: function render() {
	      var listingCheckboxs = this.listingCheckboxs;
	
	      function noop() {}
	
	      function listingCheckbox(props) {
	        var id = props.rowData.id;
	        return _react2.default.createElement('input', { type: 'checkbox', ref: function ref(c) {
	            return listingCheckboxs[id] = c;
	          } });
	      }
	
	      var columnMetadatas = [{
	        columnName: "name",
	        displayName: "PRODUCT NAME"
	      }, {
	        columnName: "price",
	        displayName: "PRICE"
	      }, {
	        columnName: "quantity",
	        displayName: "QTY ON SHELF"
	      }, {
	        columnName: "units",
	        displayName: "UNIT"
	      }, {
	        columnName: "id",
	        displayName: "SELECT",
	        customComponent: listingCheckbox
	      }];
	      var columns = columnMetadatas.map(function (c) {
	        return c.columnName;
	      });
	
	      var _props = this.props,
	          children = _props.children,
	          withBarcode = _props.withBarcode,
	          baseSearch = _props.baseSearch;
	      var _context$currentStore = this.context.currentStore,
	          currentStore = _context$currentStore === undefined ? {} : _context$currentStore;
	      var storeId = currentStore.id;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _actionButton2.default,
	          { type: 'add', onClick: this.openModal },
	          children
	        ),
	        !withBarcode ? null : _react2.default.createElement(_addListingByBarcode2.default, { storeId: storeId, baseSearch: baseSearch, onAdd: this.onAddByBarcode }),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { className: 'ReactModal__Content--fixed', isOpen: this.state.searchListing, onRequestClose: this.closeModal },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-7' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'modal-title' },
	                    'Select Inventory'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5 align-right' },
	                  this.state.advanceSearch ? _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-link', onClick: this.simpleSearch },
	                    'simple'
	                  ) : _react2.default.createElement(
	                    'form',
	                    { className: 'form-inline align-right', onSubmit: this.search },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Enter inventory name', ref: 'keyword' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'a small', onClick: this.advanceSearch },
	                          'advance'
	                        )
	                      )
	                    ),
	                    '\xA0 ',
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-secondary' },
	                      'Search'
	                    )
	                  )
	                )
	              ),
	              this.state.advanceSearch ? _react2.default.createElement(_cascadeFilterCollection2.default, {
	                settings: filterSettings,
	                filters: this.state.currentFilters,
	                group: 'inventory',
	                onSearch: this.searchByFilter
	              }) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-body' },
	              !this.state.listings ? _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Search for inventory you need.'
	                )
	              ) : _react2.default.createElement(_griddleReact2.default, {
	                useExternal: true,
	                externalSetPage: this.setSearchPage,
	                externalChangeSort: noop,
	                externalSetFilter: noop,
	                externalSetPageSize: noop,
	                externalMaxPage: this.state.totalPages,
	                externalCurrentPage: this.state.currentPage,
	                useGriddleStyles: false,
	                tableClassName: 'table table-bordered data-table',
	                results: this.state.listings,
	                columns: columns,
	                columnMetadata: columnMetadatas,
	                noDataMessage: 'No search result'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2.default.createElement(
	                'span',
	                { className: 'btn btn-sm btn-secondary', onClick: this.closeModal },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary', onClick: this.save },
	                'Save'
	              )
	            ),
	            this.state.loading ? _react2.default.createElement(
	              'div',
	              { className: 'mask' },
	              _react2.default.createElement(_loading2.default, null)
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddListingButton;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  onSave: _propTypes2.default.func,
	  withBarcode: _propTypes2.default.bool,
	  baseSearch: _propTypes2.default.shape({
	    query: _propTypes2.default.object,
	    wildcard: _propTypes2.default.object,
	    range: _propTypes2.default.object,
	    missing: _propTypes2.default.object,
	    fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    sort: _propTypes2.default.arrayOf(_propTypes2.default.object)
	  })
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = AddListingButton;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YearField = exports.MonthField = exports.DateTimeField = exports.TimestampDisplay = exports.DateField = exports.DateTimeDisplay = exports.DateDisplay = undefined;
	
	var _dateDisplay = __webpack_require__(314);
	
	var _dateDisplay2 = _interopRequireDefault(_dateDisplay);
	
	var _dateTimeDisplay = __webpack_require__(184);
	
	var _dateTimeDisplay2 = _interopRequireDefault(_dateTimeDisplay);
	
	var _dateField = __webpack_require__(777);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _timestampDisplay = __webpack_require__(780);
	
	var _timestampDisplay2 = _interopRequireDefault(_timestampDisplay);
	
	var _dateTimeField = __webpack_require__(778);
	
	var _dateTimeField2 = _interopRequireDefault(_dateTimeField);
	
	var _monthField = __webpack_require__(779);
	
	var _monthField2 = _interopRequireDefault(_monthField);
	
	var _yearField = __webpack_require__(781);
	
	var _yearField2 = _interopRequireDefault(_yearField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DateDisplay = _dateDisplay2.default;
	exports.DateTimeDisplay = _dateTimeDisplay2.default;
	exports.DateField = _dateField2.default;
	exports.TimestampDisplay = _timestampDisplay2.default;
	exports.DateTimeField = _dateTimeField2.default;
	exports.MonthField = _monthField2.default;
	exports.YearField = _yearField2.default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1238);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropDown = (_temp2 = _class = function (_Component) {
	  _inherits(DropDown, _Component);
	
	  function DropDown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropDown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.close = function (event) {
	      if (_this.state.open == false) {
	        return;
	      }
	      var dropdown_element = (0, _reactDom.findDOMNode)(_this);
	
	      if (!dropdown_element.contains(event.target)) {
	        _this.setState({
	          open: false
	        });
	      }
	    }, _this.toggle = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DropDown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.addEventListener('click', this.close);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.removeEventListener('click', this.close);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      var className = this.state.open ? "btn-group open" : "btn-group";
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'a',
	          { className: 'dropdown-caret' },
	          _react2.default.createElement('i', { className: (0, _classnames2.default)('fa', { 'fa-chevron-circle-down': !this.state.open, 'fa-chevron-circle-up': this.state.open }, 'fa-lg'), onClick: this.toggle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dropdown-menu dropdown-menu-right' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return DropDown;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node
	}, _temp2);
	exports.default = DropDown;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(422);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(536);
	
	__webpack_require__(1245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSelectBox = (_temp = _class = function (_Component) {
	  _inherits(InputSelectBox, _Component);
	
	  function InputSelectBox() {
	    _classCallCheck(this, InputSelectBox);
	
	    return _possibleConstructorReturn(this, (InputSelectBox.__proto__ || Object.getPrototypeOf(InputSelectBox)).apply(this, arguments));
	  }
	
	  _createClass(InputSelectBox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          containerClass = _props.containerClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-box ' + containerClass },
	        title != false && _react2.default.createElement(
	          'p',
	          { className: 'input-box__title' },
	          title
	        ),
	        _react2.default.createElement(_reactSelect2.default, this.props)
	      );
	    }
	  }]);
	
	  return InputSelectBox;
	}(_react.Component), _class.propTypes = {
	  title: _propTypes2.default.string,
	  containerClass: _propTypes2.default.string
	}, _class.defaultProps = {
	  onChange: function onChange() {},
	  containerClass: ''
	}, _temp);
	exports.default = InputSelectBox;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1254);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(14);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _statusIcon = __webpack_require__(802);
	
	var _statusIcon2 = _interopRequireDefault(_statusIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Status(props) {
	  var state = props.state,
	      label = props.label,
	      colorTransformer = props.colorTransformer,
	      labelTransformer = props.labelTransformer,
	      formControl = props.formControl;
	
	  var stateDisplay = label ? label : state ? state.replace('_', ' ') : null;
	  if ((0, _lodash.isFunction)(labelTransformer)) stateDisplay = labelTransformer(state);
	  var customColor = (0, _lodash.isFunction)(colorTransformer) ? colorTransformer(state) : undefined;
	  var className = (0, _classnames2.default)('status', { 'form-control': formControl });
	  return !state ? null : _react2.default.createElement(
	    'span',
	    { className: className, readOnly: formControl },
	    _react2.default.createElement(_statusIcon2.default, { state: state, customColor: customColor }),
	    _react2.default.createElement(
	      'span',
	      { className: 'status__label' },
	      stateDisplay
	    )
	  );
	}
	
	Status.propTypes = {
	  state: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  colorTransformer: _propTypes2.default.func,
	  labelTransformer: _propTypes2.default.func,
	  formControl: _propTypes2.default.bool
	};
	
	exports.default = Status;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookieHelper = __webpack_require__(813);
	
	var cookieHelper = _interopRequireWildcard(_cookieHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var authDataHelper = function () {
	  function authDataHelper() {
	    _classCallCheck(this, authDataHelper);
	  }
	
	  _createClass(authDataHelper, null, [{
	    key: 'save',
	    value: function save(user) {
	      cookieHelper.setCookie(user);
	    }
	  }, {
	    key: 'get',
	    value: function get() {
	      if (cookieHelper.isAuthencated()) {
	        return cookieHelper.getCookie();
	      }
	      return null;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      cookieHelper.clear();
	
	      // Dashboard 2
	      if (typeof localStorage !== 'undefined') {
	        localStorage.removeItem('auth');
	      }
	    }
	  }]);
	
	  return authDataHelper;
	}();
	
	exports.default = authDataHelper;

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function bindPublicMethod(target, key, value) {
	  Object.defineProperty(target.prototype, key, bindMethod(target, key, {
	    value: value,
	    writable: true,
	    enumerable: true,
	    configurable: true
	  }));
	  return target;
	}
	
	function bindMethod(target, key, descriptor) {
	  var fn = descriptor.value;
	  var definingProperty = false;
	
	  return {
	    configurable: true,
	    get: function get() {
	      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	        return fn;
	      }
	      var boundFn = fn.bind(this);
	      definingProperty = true;
	      Object.defineProperty(this, key, {
	        value: boundFn,
	        configurable: true,
	        writable: true
	      });
	      definingProperty = false;
	      return boundFn;
	    }
	  };
	}
	
	exports.bindPublicMethod = bindPublicMethod;
	exports.bindMethod = bindMethod;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	__webpack_require__(1258);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _paymentRefund = __webpack_require__(181);
	
	var actions = _interopRequireWildcard(_paymentRefund);
	
	var _formatHelper = __webpack_require__(35);
	
	var _can = __webpack_require__(472);
	
	var _modal = __webpack_require__(91);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _date = __webpack_require__(230);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE = {
	  PAYMENT: 'PAYMENT',
	  REFUND: 'REFUND'
	};
	var DEFAULT_PAYMENT_TYPE = {
	  CREDIT_CARD: 1,
	  CASH: 2,
	  CHECK: 3,
	  STORE_CREDIT: 4,
	  OCTOPUS: 5
	};
	var defaultTitle = {
	  PAYMENT: 'Make Payment',
	  REFUND: 'Issue Refund'
	};
	var defaultSuccessString = {
	  PAYMENT: 'Payment is successfully processed.',
	  REFUND: 'Refund is successfully processed.'
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var loading = state.base.loading,
	      entities = state.entities;
	  var _state$forms = state.forms,
	      forms = _state$forms === undefined ? {} : _state$forms;
	  var _forms$paymentRefund = forms.paymentRefund,
	      modal = _forms$paymentRefund === undefined ? {} : _forms$paymentRefund;
	
	  return Object.assign({}, props, { entities: entities, loading: loading, modal: modal });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var PaymentRefundModal = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Modal) {
	  _inherits(PaymentRefundModal, _Modal);
	
	  function PaymentRefundModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PaymentRefundModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentRefundModal.__proto__ || Object.getPrototypeOf(PaymentRefundModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleRefundToChange = function (event) {
	      var value = event.target.value;
	      var actions = _this.props.actions;
	
	      actions.changeRefundTo(value);
	    }, _this.handlePaymentTypeChange = function (event) {
	      var target = event.target;
	      var _target$selectedIndex = target.selectedIndex,
	          selectedIndex = _target$selectedIndex === undefined ? 0 : _target$selectedIndex;
	
	      var value = Number(target.value);
	      var _target$children = target.children,
	          children = _target$children === undefined ? [] : _target$children;
	
	      var selected = children[selectedIndex] || {};
	      var _selected$dataset = selected.dataset,
	          dataset = _selected$dataset === undefined ? {} : _selected$dataset;
	      var instrumentName = dataset.instrumentName;
	      var actions = _this.props.actions;
	
	      actions.changePaymentType(value);
	      if (instrumentName) {
	        _this.changeField('instrumentName', instrumentName);
	      }
	    }, _this.handleAmountChange = function (amount) {
	      var actions = _this.props.actions;
	
	      actions.changeAmount(amount);
	    }, _this.handleTenderAmountChange = function (amount) {
	      var actions = _this.props.actions;
	
	      actions.changeTenderAmount(amount);
	    }, _this.changeField = function (field, value) {
	      var actions = _this.props.actions;
	
	      actions.changeField(field, value);
	    }, _this.handleSubmit = function () {
	      var _this$props = _this.props,
	          actions = _this$props.actions,
	          _this$props$modal = _this$props.modal,
	          modal = _this$props$modal === undefined ? {} : _this$props$modal;
	
	      if (modal.type === TYPE.PAYMENT) {
	        actions.payInvoice(modal);
	      } else {
	        actions.refundInvoice(modal);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PaymentRefundModal, [{
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _this2 = this;
	
	      var _context$currentStore = this.context.currentStore,
	          currentStore = _context$currentStore === undefined ? {} : _context$currentStore;
	      var currency = currentStore.currency;
	      var _props = this.props,
	          onRequestClose = _props.onRequestClose,
	          onSuccessClose = _props.onSuccessClose,
	          _props$modal = _props.modal,
	          modal = _props$modal === undefined ? {} : _props$modal;
	      var loading = modal.loading,
	          type = modal.type,
	          _modal$amountDue = modal.amountDue,
	          amountDue = _modal$amountDue === undefined ? (0, _big2.default)(0) : _modal$amountDue,
	          _modal$amountSettled = modal.amountSettled,
	          amountSettled = _modal$amountSettled === undefined ? (0, _big2.default)(0) : _modal$amountSettled,
	          _modal$amountBalance = modal.amountBalance,
	          amountBalance = _modal$amountBalance === undefined ? (0, _big2.default)(0) : _modal$amountBalance,
	          refundTo = modal.refundTo,
	          amount = modal.amount,
	          tenderAmount = modal.tenderAmount,
	          changeAmount = modal.changeAmount,
	          tipsAmount = modal.tipsAmount,
	          note = modal.note,
	          showTips = modal.showTips,
	          showChange = modal.showChange,
	          instrumentId = modal.instrumentId,
	          _modal$saleTransactio = modal.saleTransactions,
	          saleTransactions = _modal$saleTransactio === undefined ? [] : _modal$saleTransactio,
	          successResponse = modal.successResponse,
	          _modal$paymentInstrum = modal.paymentInstruments,
	          paymentInstruments = _modal$paymentInstrum === undefined ? [] : _modal$paymentInstrum,
	          cardNumber = modal.cardNumber,
	          expMonth = modal.expMonth,
	          expYear = modal.expYear,
	          cvv = modal.cvv,
	          _modal$errors = modal.errors,
	          errors = _modal$errors === undefined ? [] : _modal$errors;
	
	      var isSuccess = !!successResponse;
	      var title = defaultTitle[type];
	      var successString = defaultSuccessString[type];
	      var currencyFormat = { currency: currency, dp: 2 };
	      var formElements = null;
	      if (type === TYPE.REFUND) {
	        var refundableTransactions = saleTransactions.filter(function (t) {
	          return t.amountLefted.gt(0);
	        });
	        formElements = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Refund to'
	            ),
	            _react2.default.createElement(
	              'select',
	              {
	                className: 'form-control',
	                value: refundTo,
	                disabled: loading,
	                onChange: this.handleRefundToChange
	              },
	              refundableTransactions.map(function (t) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: t.id, value: t.id },
	                  t.extra ? t.extra.creditCardType + ' - **** **** **** ' + t.extra.last4Digits : t.payment
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Refund Amount'
	            ),
	            _react2.default.createElement(_inputCurrency2.default, _extends({
	              className: 'form-control',
	              value: amount || (0, _big2.default)(0),
	              disabled: loading,
	              onChange: this.handleAmountChange
	            }, currencyFormat))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Refund Reason'
	            ),
	            _react2.default.createElement('textarea', {
	              className: 'form-control',
	              value: note,
	              disabled: loading,
	              onChange: function onChange(e) {
	                return _this2.changeField('note', e.target.value);
	              } })
	          )
	        );
	      } else {
	        formElements = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Payment Type'
	            ),
	            _react2.default.createElement(
	              'select',
	              {
	                className: 'form-control',
	                value: instrumentId,
	                disabled: loading,
	                onChange: this.handlePaymentTypeChange
	              },
	              _react2.default.createElement(
	                'option',
	                { value: DEFAULT_PAYMENT_TYPE.CASH },
	                'Cash'
	              ),
	              _react2.default.createElement(
	                _can.Module,
	                { module: 'payment_check_enabled' },
	                _react2.default.createElement(
	                  'option',
	                  { value: DEFAULT_PAYMENT_TYPE.CHECK },
	                  'Check'
	                )
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: DEFAULT_PAYMENT_TYPE.CREDIT_CARD },
	                'Credit Card'
	              ),
	              paymentInstruments.map(function (p) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: p.id, key: p.id, 'data-instrument-name': p.name },
	                  'Other - ',
	                  p.name
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Payment Amount'
	            ),
	            _react2.default.createElement(_inputCurrency2.default, _extends({
	              className: 'form-control',
	              value: amount || (0, _big2.default)(0),
	              disabled: loading,
	              onChange: this.handleAmountChange
	            }, currencyFormat))
	          ),
	          !showChange ? null : _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Tender Amount'
	            ),
	            _react2.default.createElement(_inputCurrency2.default, _extends({
	              className: 'form-control',
	              value: tenderAmount || (0, _big2.default)(0),
	              disabled: loading,
	              onChange: this.handleTenderAmountChange
	            }, currencyFormat))
	          ),
	          !showChange ? null : _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Change Amount'
	            ),
	            _react2.default.createElement(_inputCurrency2.default, _extends({
	              className: 'form-control',
	              value: changeAmount || (0, _big2.default)(0),
	              readOnly: true
	            }, currencyFormat))
	          ),
	          !showTips ? null : _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Tips Amount'
	            ),
	            _react2.default.createElement(_inputCurrency2.default, _extends({
	              className: 'form-control',
	              value: tipsAmount || (0, _big2.default)(0),
	              disabled: loading,
	              onChange: function onChange(amount) {
	                return _this2.changeField('tipsAmount', amount);
	              }
	            }, currencyFormat))
	          ),
	          instrumentId !== DEFAULT_PAYMENT_TYPE.CREDIT_CARD ? null : _react2.default.createElement(
	            'div',
	            { className: 'credit-card-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Card Number'
	              ),
	              _react2.default.createElement('input', {
	                className: 'form-control',
	                value: cardNumber,
	                disabled: loading,
	                onChange: function onChange(e) {
	                  return _this2.changeField('cardNumber', e.target.value);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Expiry Date'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'credit-card-form__expire-date' },
	                _react2.default.createElement(_date.MonthField, {
	                  className: 'form-control credit-card-form__expire-month',
	                  value: expMonth,
	                  disabled: loading,
	                  onChange: function onChange(e) {
	                    return _this2.changeField('expMonth', e.target.value);
	                  }
	                }),
	                _react2.default.createElement(_date.YearField, {
	                  className: 'form-control credit-card-form__expire-year',
	                  value: expYear,
	                  disabled: loading,
	                  count: 20,
	                  valueFormat: 'YY',
	                  displayFormat: 'YYYY',
	                  onChange: function onChange(e) {
	                    return _this2.changeField('expYear', e.target.value);
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'CVV/CVC'
	              ),
	              _react2.default.createElement('input', {
	                className: 'form-control',
	                value: cvv,
	                disabled: loading,
	                onChange: function onChange(e) {
	                  return _this2.changeField('cvv', e.target.value);
	                }
	              })
	            )
	          ),
	          errors.length === 0 ? null : _react2.default.createElement(
	            'div',
	            { className: 'alert alert-danger' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              errors.map(function (err, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  err
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Note'
	            ),
	            _react2.default.createElement('textarea', {
	              className: 'form-control',
	              value: note,
	              disabled: loading,
	              onChange: function onChange(e) {
	                return _this2.changeField('note', e.target.value);
	              }
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: title, onRequestClose: onRequestClose }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('payment-refund', { 'payment-refund--success': isSuccess }) },
	            _react2.default.createElement(
	              'div',
	              { className: 'payment-refund__result' },
	              successString
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'balance-form' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'balance-form__item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__label' },
	                    'Amount Due'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__value' },
	                    (0, _formatHelper.formatCurrency)(amountDue, currencyFormat)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'balance-form__item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__label' },
	                    'Amount Settled'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__value' },
	                    (0, _formatHelper.formatCurrency)(amountSettled, currencyFormat)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'balance-form__result' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'balance-form__item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__label' },
	                    'Net Balance'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'balance-form__item__value' },
	                    (0, _formatHelper.formatCurrency)(amountBalance, currencyFormat)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'payment-refund-form' },
	              formElements
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          isSuccess ? null : _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary btn-sm',
	              disabled: loading,
	              onClick: onRequestClose },
	            'Cancel'
	          ),
	          isSuccess ? null : _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              disabled: loading,
	              onClick: this.handleSubmit },
	            title
	          ),
	          !isSuccess ? null : _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              onClick: function onClick() {
	                return onSuccessClose(successResponse);
	              } },
	            'Close'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentRefundModal;
	}(_modal.Modal), _class2.TYPE = TYPE, _class2.DEFAULT_PAYMENT_TYPE = DEFAULT_PAYMENT_TYPE, _class2.defaultTitle = defaultTitle, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object
	}, _class2.propTypes = _extends({
	  type: _propTypes2.default.string.isRequired,
	  amountDue: _propTypes2.default.instanceOf(_big2.default),
	  amountSettled: _propTypes2.default.instanceOf(_big2.default),
	  amountBalance: _propTypes2.default.instanceOf(_big2.default),
	  refundTo: _propTypes2.default.number,
	  saleTransactions: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  refundTransactions: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  onSuccessClose: _propTypes2.default.func
	}, _modal.Modal.propTypes), _temp2)) || _class);
	exports.default = PaymentRefundModal;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _invoiceActions = __webpack_require__(226);
	
	var invoiceActions = _interopRequireWildcard(_invoiceActions);
	
	var _paymentRefund = __webpack_require__(181);
	
	var paymentRefundModalActions = _interopRequireWildcard(_paymentRefund);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _storeHelper = __webpack_require__(185);
	
	var _mainContent = __webpack_require__(190);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _mainContentHeader = __webpack_require__(188);
	
	var _mainContentHeader2 = _interopRequireDefault(_mainContentHeader);
	
	var _mainContentHeaderButtons = __webpack_require__(487);
	
	var _mainContentHeaderButtons2 = _interopRequireDefault(_mainContentHeaderButtons);
	
	var _mainContentTabs = __webpack_require__(238);
	
	var _mainContentTabs2 = _interopRequireDefault(_mainContentTabs);
	
	var _breadcrumb = __webpack_require__(187);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _constant = __webpack_require__(108);
	
	var _overview = __webpack_require__(852);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _payment = __webpack_require__(853);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _deliveryNote = __webpack_require__(850);
	
	var _deliveryNote2 = _interopRequireDefault(_deliveryNote);
	
	var _log = __webpack_require__(851);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _paymentRefundModal = __webpack_require__(236);
	
	var _paymentRefundModal2 = _interopRequireDefault(_paymentRefundModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvoiceLayout = (_temp2 = _class = function (_Component) {
	  _inherits(InvoiceLayout, _Component);
	
	  function InvoiceLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InvoiceLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvoiceLayout.__proto__ || Object.getPrototypeOf(InvoiceLayout)).call.apply(_ref, [this].concat(args))), _this), _this.saveEdit = function () {
	      var props = _this.props;
	      var _props$pathState = props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState,
	          actions = props.actions;
	
	      actions.saveInvoice(pathState);
	    }, _this.cancelEdit = function () {
	      var _this$props = _this.props,
	          storeId = _this$props.storeId,
	          _this$props$pathState = _this$props.pathState,
	          pathState = _this$props$pathState === undefined ? {} : _this$props$pathState,
	          actions = _this$props.actions;
	      var type = pathState.type,
	          mode = pathState.mode,
	          currentTab = pathState.currentTab,
	          orderNumber = pathState.orderNumber,
	          currentStore = pathState.currentStore,
	          multiStore = pathState.multiStore;
	
	      if (mode === _constant.NEW) {
	        actions.goToInvoiceSearch(storeId);
	      } else {
	        actions.initInvoiceState(type, _constant.VIEW, currentTab, orderNumber, currentStore, multiStore);
	      }
	    }, _this.refund = function () {
	      var _this$props2 = _this.props,
	          _this$props2$pathStat = _this$props2.pathState,
	          pathState = _this$props2$pathStat === undefined ? {} : _this$props2$pathStat,
	          actions = _this$props2.actions,
	          storeId = _this$props2.storeId;
	      var _pathState$order = pathState.order,
	          order = _pathState$order === undefined ? {} : _pathState$order;
	
	      actions.openPaymentRefundModal(_paymentRefundModal2.default.TYPE.REFUND, storeId, order);
	    }, _this.payment = function () {
	      var _this$props3 = _this.props,
	          _this$props3$pathStat = _this$props3.pathState,
	          pathState = _this$props3$pathStat === undefined ? {} : _this$props3$pathStat,
	          actions = _this$props3.actions,
	          storeId = _this$props3.storeId;
	      var _pathState$order2 = pathState.order,
	          order = _pathState$order2 === undefined ? {} : _pathState$order2;
	
	      actions.openPaymentRefundModal(_paymentRefundModal2.default.TYPE.PAYMENT, storeId, order);
	    }, _this.sendEmail = function () {
	      var _this$props4 = _this.props,
	          storeId = _this$props4.storeId,
	          _this$props4$pathStat = _this$props4.pathState,
	          pathState = _this$props4$pathStat === undefined ? {} : _this$props4$pathStat,
	          actions = _this$props4.actions;
	      var orderNumber = pathState.orderNumber,
	          _pathState$order3 = pathState.order,
	          order = _pathState$order3 === undefined ? {} : _pathState$order3;
	      var customerEmail = order.customerEmail;
	
	      actions.sendInvoice(storeId, customerEmail, orderNumber);
	    }, _this.exportPdf = function () {
	      var _this$props5 = _this.props,
	          _this$props5$pathStat = _this$props5.pathState,
	          pathState = _this$props5$pathStat === undefined ? {} : _this$props5$pathStat,
	          actions = _this$props5.actions,
	          storeId = _this$props5.storeId;
	      var _pathState$order4 = pathState.order,
	          order = _pathState$order4 === undefined ? {} : _pathState$order4;
	      var number = order.number;
	
	      actions.exportInvoicePdf(storeId, number);
	    }, _this.cancelOrder = function () {
	      var _this$props$pathState2 = _this.props.pathState,
	          pathState = _this$props$pathState2 === undefined ? {} : _this$props$pathState2;
	      var cancelInvoice = _this.props.actions.cancelInvoice;
	
	      cancelInvoice(pathState);
	    }, _this.voidInvoice = function () {
	      var pathState = _this.props.pathState;
	      var voidInvoice = _this.props.actions.voidInvoice;
	
	      voidInvoice(pathState);
	    }, _this.edit = function () {
	      var _this$props6 = _this.props,
	          currentTab = _this$props6.pathState.currentTab,
	          actions = _this$props6.actions;
	
	      actions.startEditInvoice(currentTab);
	    }, _this.convertQuoteToInvoice = function () {
	      var _this$props7 = _this.props,
	          storeId = _this$props7.storeId,
	          orderNumber = _this$props7.orderNumber;
	      var convertQuoteToInvoice = _this.props.actions.convertQuoteToInvoice;
	
	      convertQuoteToInvoice(storeId, orderNumber);
	    }, _this.createDn = function () {
	      var _this$props8 = _this.props,
	          storeId = _this$props8.storeId,
	          orderNumber = _this$props8.orderNumber;
	
	      _routeHelper2.default.goDeliveryNote(storeId, 'new/for/invoice', orderNumber);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InvoiceLayout, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        currentStore: this.context.currentStore
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          type = _props.type,
	          mode = _props.mode,
	          tab = _props.tab,
	          orderNumber = _props.orderNumber;
	      var initInvoiceState = this.props.actions.initInvoiceState;
	      var _context = this.context,
	          _context$currentStore = _context.currentStore,
	          currentStore = _context$currentStore === undefined ? {} : _context$currentStore,
	          multiStore = _context.multiStore;
	
	      initInvoiceState(type, mode, tab, orderNumber, currentStore, multiStore);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var _props$pathState2 = props.pathState,
	          pathState = _props$pathState2 === undefined ? {} : _props$pathState2,
	          actions = props.actions,
	          loading = props.loading,
	          storeId = props.storeId;
	      var type = pathState.type,
	          mode = pathState.mode,
	          currentTab = pathState.currentTab,
	          orderNumber = pathState.orderNumber,
	          _pathState$order5 = pathState.order,
	          order = _pathState$order5 === undefined ? {} : _pathState$order5,
	          _pathState$currentSto = pathState.currentStore,
	          currentStore = _pathState$currentSto === undefined ? {} : _pathState$currentSto,
	          _pathState$deliveryOr = pathState.deliveryOrders,
	          deliveryOrders = _pathState$deliveryOr === undefined ? [] : _pathState$deliveryOr;
	      var state = order.state,
	          inventoryState = order.inventoryState,
	          quoteInvoiceState = order.quoteInvoiceState;
	      var _order$lineItems = order.lineItems,
	          lineItems = _order$lineItems === undefined ? [] : _order$lineItems,
	          _order$saleTransactio = order.saleTransactions,
	          saleTransactions = _order$saleTransactio === undefined ? [] : _order$saleTransactio,
	          _order$refundTransact = order.refundTransactions,
	          refundTransactions = _order$refundTransact === undefined ? [] : _order$refundTransact;
	
	      var isViewMode = mode === _constant.VIEW;
	      var isEditMode = mode === _constant.EDIT;
	      var isNewMode = mode === _constant.NEW;
	      var isInvoice = type === _constant.INVOICE_TYPE;
	      var isQuote = type === _constant.QUOTE_TYPE;
	      var isOverviewTab = currentTab === _constant.OVERVIEW;
	      var isPaymentTab = currentTab === _constant.PAYMENT;
	      var isDnTab = currentTab === _constant.DELIVERY_NOTE;
	      var isVoided = state === 'voided';
	      var isCancelled = state === 'cancelled';
	      var isPaid = quoteInvoiceState === 'paid';
	      var isUnpaid = quoteInvoiceState === 'unpaid';
	      var isUnfulfilled = inventoryState === 'unfulfilled';
	      var isActive = quoteInvoiceState === 'active' /* && moment().isBefore(order.effectiveCreatedAt)*/;
	      var hasDn = deliveryOrders.length > 0;
	      var hasTransaction = saleTransactions.length > 0;
	      var hasRefund = refundTransactions.length > 0;
	      var hasLineItem = lineItems.length > 0;
	      var noFulfillRefundItem = lineItems.every(function (item) {
	        return (0, _big2.default)(item.qtyFulfilled).eq(0) && (0, _big2.default)(item.qtyRefunded).eq(0);
	      });
	      var orderCanConvertToInvoice = !(isPaid || isCancelled || isVoided);
	      var orderCanEdit = !(isPaid || isActive || isCancelled || isVoided);
	      var orderCanCancel = !(isPaid || isActive || isCancelled || isVoided) && isUnfulfilled && isUnpaid;
	      var orderCanPay = !(isPaid || isCancelled || isVoided || hasRefund);
	      var orderCanRefund = !(isUnpaid || isCancelled || isVoided);
	      var orderCanVoid = !(isCancelled || isVoided || hasTransaction || hasDn) && noFulfillRefundItem && false;
	      var orderCanCreateDn = !(isCancelled || isVoided);
	      var orderCanSaveEdit = hasLineItem;
	      var pageTitle = mode === _constant.NEW ? 'New ' + type : type + ' #' + orderNumber;
	
	      var pageButtons = [{
	        show: isViewMode && isOverviewTab,
	        disabled: loading,
	        onClick: this.sendEmail,
	        content: 'Send Email Receipt'
	      }, {
	        show: isViewMode && isOverviewTab,
	        disabled: loading,
	        onClick: this.exportPdf,
	        content: 'Export to PDF'
	      }, {
	        show: isViewMode && isOverviewTab && isQuote && orderCanConvertToInvoice,
	        disabled: loading,
	        onClick: this.convertQuoteToInvoice,
	        btnType: 'primary',
	        content: 'Convert to Invoice',
	        permission: 'invoice:edit'
	      }, {
	        show: isViewMode && isOverviewTab && orderCanCancel,
	        disabled: loading,
	        onClick: this.cancelOrder,
	        btnType: 'primary',
	        content: 'Void Invoice',
	        permission: 'invoice:cancel'
	      }, {
	        show: isViewMode && isOverviewTab && isInvoice && orderCanVoid,
	        disabled: loading,
	        onClick: this.voidInvoice,
	        btnType: 'primary',
	        content: 'Void Invoice',
	        permission: 'invoice:void_invoice'
	      }, {
	        show: isViewMode && isOverviewTab && orderCanEdit,
	        disabled: loading,
	        onClick: this.edit,
	        btnType: 'primary',
	        content: 'Edit',
	        permission: 'invoice:edit_button'
	      }, {
	        show: isViewMode && isPaymentTab && isInvoice && orderCanRefund,
	        disabled: loading,
	        onClick: this.refund,
	        btnType: 'primary',
	        content: 'Issue Refund',
	        permission: 'invoice:refund'
	      }, {
	        show: isViewMode && isPaymentTab && isInvoice && orderCanPay,
	        disabled: loading,
	        onClick: this.payment,
	        btnType: 'primary',
	        content: 'Make Payment',
	        permission: 'invoice:edit'
	      }, {
	        show: isViewMode && isDnTab && isInvoice && orderCanCreateDn,
	        disabled: loading,
	        onClick: this.createDn,
	        btnType: 'primary',
	        content: 'New Delivery Note',
	        permission: 'invoice:edit'
	      }, {
	        show: isEditMode || isNewMode,
	        disabled: loading,
	        onClick: this.cancelEdit,
	        content: 'Cancel'
	      }, {
	        show: isEditMode || isNewMode,
	        btnType: 'primary',
	        disabled: loading || !orderCanSaveEdit,
	        onClick: this.saveEdit,
	        content: 'Save'
	      }];
	
	      var pageTabs = [{
	        label: 'Overview',
	        value: _constant.OVERVIEW
	      }, {
	        label: 'Settlements',
	        value: _constant.PAYMENT,
	        show: isInvoice && !isNewMode
	      }, {
	        label: 'Delivery Notes',
	        value: _constant.DELIVERY_NOTE,
	        show: isInvoice && !isNewMode && (0, _storeHelper.moduleEnabled)('warehouse_management_enabled', currentStore)
	      }, {
	        label: 'Log',
	        value: _constant.LOG,
	        show: !isNewMode
	      }];
	
	      var main = null;
	      if (currentTab === _constant.OVERVIEW) {
	        main = _react2.default.createElement(_overview2.default, null);
	      } else if (currentTab === _constant.PAYMENT) {
	        main = _react2.default.createElement(_payment2.default, null);
	      } else if (currentTab === _constant.DELIVERY_NOTE) {
	        main = _react2.default.createElement(_deliveryNote2.default, null);
	      } else if (currentTab === _constant.LOG) {
	        main = _react2.default.createElement(_log2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          _mainContent2.default,
	          null,
	          _react2.default.createElement(
	            _mainContentHeader2.default,
	            { title: pageTitle },
	            _react2.default.createElement(_mainContentHeaderButtons2.default, { config: pageButtons })
	          ),
	          _react2.default.createElement(_breadcrumb2.default, { links: [{ label: 'Sales Management' }, { label: type + 's', onClick: function onClick() {
	                return actions.goToInvoiceSearch(storeId);
	              } }, { label: mode === _constant.NEW ? 'New' : orderNumber || '' }] }),
	          _react2.default.createElement(_mainContentTabs2.default, { tabs: pageTabs, currentTab: currentTab, onChange: function onChange(newTab) {
	              return actions.changeInvoiceTab(newTab);
	            } }),
	          main
	        )
	      );
	    }
	  }]);
	
	  return InvoiceLayout;
	}(_react.Component), _class.childContextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	InvoiceLayout.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired,
	  currentStores: _propTypes2.default.array.isRequired,
	  multiStore: _propTypes2.default.bool.isRequired
	};
	
	InvoiceLayout.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  orderNumber: _propTypes2.default.string,
	  actions: _propTypes2.default.object.isRequired,
	  pathState: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var appState = state;
	  var _state$invoice = state.invoice,
	      pathState = _state$invoice === undefined ? {} : _state$invoice;
	  var loading = state.base.loading,
	      entities = state.entities;
	
	  var ret = Object.assign({}, props, { appState: appState, pathState: pathState, entities: entities, loading: loading });
	  return ret;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(_extends({}, invoiceActions, paymentRefundModalActions), dispatch) };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InvoiceLayout);

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1270);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainContentTabs(props) {
	    var _props$children = props.children,
	        children = _props$children === undefined ? [] : _props$children,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className;
	    var _props$tabs = props.tabs,
	        tabs = _props$tabs === undefined ? [] : _props$tabs,
	        currentTab = props.currentTab,
	        onChange = props.onChange;
	
	    var childrenTabs = [].concat(children);
	
	    // If tabs didn't pass by `children`, we can use `tabs`, `currentTab`, `onChange` shortcut
	    if (childrenTabs.length === 0 && tabs.length > 0 && typeof onChange === 'function') {
	        childrenTabs = tabs.filter(function (tab) {
	            return tab.show !== false;
	        }).map(function (tab, i) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#',
	                    key: i,
	                    className: 'nav-link ' + (currentTab === tab.value ? 'active' : ''),
	                    onClick: function onClick(event) {
	                        event.preventDefault();
	                        onChange(tab.value);
	                    }
	                },
	                tab.label
	            );
	        });
	    }
	
	    return childrenTabs.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: 'main-content-tab ' + className },
	        _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            childrenTabs.map(function (item, i) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: i, className: 'nav-item' },
	                    item
	                );
	            })
	        )
	    ) : null;
	}
	
	MainContentTabs.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        label: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.string.isRequired,
	        show: _propTypes2.default.bool
	    })),
	    currentTab: _propTypes2.default.string,
	    onChange: _propTypes2.default.func
	};
	
	exports.default = MainContentTabs;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var apiRequest = function () {
	  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	      method: 'GET'
	    };
	    var response;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            options.headers = headers;
	            _context.next = 3;
	            return fetch('' + tableauApi + path, options);
	
	          case 3:
	            response = _context.sent;
	
	            if (!response.ok) {
	              _context.next = 8;
	              break;
	            }
	
	            _context.next = 7;
	            return response.json();
	
	          case 7:
	            return _context.abrupt('return', _context.sent);
	
	          case 8:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function apiRequest(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(29);
	
	__webpack_require__(1280);
	
	var _Menu = __webpack_require__(927);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _JSReport = __webpack_require__(926);
	
	var _JSReport2 = _interopRequireDefault(_JSReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var tableauApi = _config.tableau + '/api/2.5';
	
	var headers = new Headers();
	headers.append('Accept', 'application/json');
	headers.append('Content-Type', 'application/json');
	
	var credentials = {
	  "credentials": {
	    "name": "dashboard",
	    "password": "bindorocks!!!",
	    "site": {
	      "contentUrl": ""
	    }
	  }
	};
	
	function seq(view) {
	  var main = 999,
	      sub = 999;
	
	  var found = view.match(/^(\d+)\.(\d+)/);
	  if (found) {
	    main = parseInt(found[1]);
	    sub = parseInt(found[2]);
	  }
	  return {
	    main: main,
	    sub: sub
	  };
	}
	
	var Tableau = function (_React$Component) {
	  _inherits(Tableau, _React$Component);
	
	  function Tableau(props) {
	    _classCallCheck(this, Tableau);
	
	    var _this = _possibleConstructorReturn(this, (Tableau.__proto__ || Object.getPrototypeOf(Tableau)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	    _this.resize = _this.resize.bind(_this);
	    _this.state = {
	      error: null,
	      projects: [],
	      view: null,
	      width: null,
	      menuWidth: null,
	      height: null
	    };
	    return _this;
	  }
	
	  _createClass(Tableau, [{
	    key: 'componentWillMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var _this2 = this;
	
	        var workbooks, views, site, projects, defaultView, langType, chineseArry, englishArray;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                window.addEventListener("resize", this.resize);
	                workbooks = void 0, views = void 0;
	                _context2.prev = 2;
	                _context2.next = 5;
	                return this.signin();
	
	              case 5:
	                site = _context2.sent;
	                _context2.next = 8;
	                return this.queryWorkbooks(site);
	
	              case 8:
	                workbooks = _context2.sent;
	                _context2.next = 11;
	                return this.queryViews(site);
	
	              case 11:
	                views = _context2.sent;
	                _context2.next = 19;
	                break;
	
	              case 14:
	                _context2.prev = 14;
	                _context2.t0 = _context2['catch'](2);
	
	                console.error(_context2.t0);
	                this.setState({ error: _context2.t0 });
	                return _context2.abrupt('return');
	
	              case 19:
	                projects = {};
	                defaultView = null;
	
	
	                workbooks.map(function (workbook) {
	                  workbook.views = [];
	                  var _iteratorNormalCompletion = true;
	                  var _didIteratorError = false;
	                  var _iteratorError = undefined;
	
	                  try {
	                    for (var _iterator = views[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                      var view = _step.value;
	
	                      if (view.workbook.id === workbook.id) {
	                        view.seq = seq(view.name);
	                        if (view.seq.main === 1 && view.seq.sub === 1) defaultView = view;
	                        if (_this2.props.filter(view.seq)) workbook.views.push(view);
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	                    } finally {
	                      if (_didIteratorError) {
	                        throw _iteratorError;
	                      }
	                    }
	                  }
	
	                  return workbook;
	                }).forEach(function (_ref3) {
	                  var id = _ref3.id,
	                      project = _ref3.project,
	                      views = _ref3.views;
	
	                  if (projects[project.id]) {
	                    projects[project.id].views = projects[project.id].views.concat(views);
	                  } else if (views.length > 0) {
	                    projects[project.id] = project;
	                    project.views = views;
	                  }
	                });
	
	                projects = Object.keys(projects).map(function (key) {
	                  var project = projects[key];
	                  project.views = project.views.sort(function (a, b) {
	                    return a.seq.sub - b.seq.sub;
	                  });
	                  var seqView = project.views.find(function (view) {
	                    return view.seq.main < 999;
	                  });
	                  project.seq = seqView ? seqView.seq.main : 999;
	
	                  return project;
	                }).sort(function (a, b) {
	                  return a.seq - b.seq;
	                });
	
	                /**
	                 * @description: 对projects进行过滤
	                 * @param {type} 
	                 * @return: 
	                 */
	                langType = this.props.langType || '';
	
	                if (langType === 'chinese' && projects) {
	                  chineseArry = [];
	
	                  projects.map(function (project) {
	                    var tempObj = {};
	                    var tempArry = project.views.filter(function (view) {
	                      return (/.*[\u4e00-\u9fa5]+.*$/.test(view.name)
	                      );
	                    });
	                    tempObj.name = project.name;
	                    tempObj.views = tempArry;
	                    if (tempObj.views.length > 0) {
	                      chineseArry.push(tempObj);
	                    }
	                  });
	                  this.setState({ projects: chineseArry }, function () {
	                    return _this2.handleClick(defaultView);
	                  });
	                } else {
	                  englishArray = [];
	
	                  projects.map(function (project) {
	                    var tempObj = {};
	                    var tempArry = project.views.filter(function (view) {
	                      return !/.*[\u4e00-\u9fa5]+.*$/.test(view.name);
	                    });
	                    tempObj.name = project.name;
	                    tempObj.views = tempArry;
	                    if (tempObj.views.length > 0) {
	                      englishArray.push(tempObj);
	                    }
	                  });
	                  this.setState({ projects: englishArray }, function () {
	                    return _this2.handleClick(defaultView);
	                  });
	                }
	
	              case 25:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[2, 14]]);
	      }));
	
	      function componentWillMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.resize);
	    }
	  }, {
	    key: 'signin',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var _ref5, info;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                credentials.credentials.site.contentUrl = this.props.site;
	                _context3.next = 3;
	                return apiRequest('/auth/signin', {
	                  method: 'POST',
	                  body: JSON.stringify(credentials)
	                });
	
	              case 3:
	                _ref5 = _context3.sent;
	                info = _ref5.credentials;
	
	                headers.set('X-Tableau-Auth', info.token);
	                return _context3.abrupt('return', info.site);
	
	              case 7:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function signin() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return signin;
	    }()
	  }, {
	    key: 'queryWorkbooks',
	    value: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(site) {
	        var _ref7, workbooks;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return apiRequest('/sites/' + site.id + '/workbooks?pageSize=1000');
	
	              case 2:
	                _ref7 = _context4.sent;
	                workbooks = _ref7.workbooks;
	                return _context4.abrupt('return', workbooks.workbook);
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function queryWorkbooks(_x3) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return queryWorkbooks;
	    }()
	  }, {
	    key: 'queryViews',
	    value: function () {
	      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(site) {
	        var _ref9, views;
	
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return apiRequest('/sites/' + site.id + '/views?pageSize=1000');
	
	              case 2:
	                _ref9 = _context5.sent;
	                views = _ref9.views;
	                return _context5.abrupt('return', views.view);
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function queryViews(_x4) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return queryViews;
	    }()
	  }, {
	    key: 'handleClick',
	    value: function handleClick(view) {
	      this.setState({ view: view });
	    }
	  }, {
	    key: 'handleToggleMenu',
	    value: function handleToggleMenu(menuWidth) {
	      this.setState({ menuWidth: menuWidth });
	    }
	  }, {
	    key: 'resize',
	    value: function resize() {
	      if (this.tableau) {
	        var _tableau = this.tableau,
	            width = _tableau.offsetWidth,
	            height = _tableau.offsetHeight;
	
	        this.setState({ width: width, height: height });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          projects = _state.projects,
	          error = _state.error,
	          view = _state.view,
	          dimensions = _objectWithoutProperties(_state, ['projects', 'error', 'view']);
	
	      if (error) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          error.message
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'tableau', ref: function ref(t) {
	            return _this3.tableau = t;
	          } },
	        _react2.default.createElement(_Menu2.default, { projects: projects, view: view, onClick: this.handleClick, onToggle: this.handleToggleMenu }),
	        _react2.default.createElement(_JSReport2.default, _extends({
	          view: view,
	          ref: function ref(report) {
	            return _this3.report = report;
	          }
	        }, dimensions, {
	          site: this.props.site,
	          storeIds: this.props.storeIds
	        }))
	      );
	    }
	  }]);
	
	  return Tableau;
	}(_react2.default.Component);
	
	Tableau.propTypes = {
	  filter: _propTypes2.default.func,
	  site: _propTypes2.default.string,
	  storeIds: _propTypes2.default.string,
	  langType: _propTypes2.default.string
	};
	
	Tableau.defaultProps = {
	  site: '',
	  filter: function filter() {
	    return true;
	  }
	};
	
	exports.default = Tableau;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStoreIdFromParams = exports.getParams = exports.getLoading = undefined;
	
	var _reselect = __webpack_require__(301);
	
	var _lodash = __webpack_require__(14);
	
	var getLoading = exports.getLoading = function getLoading(state) {
	  return (0, _lodash.get)(state, 'base.loading');
	};
	
	var getParams = exports.getParams = function getParams(state, props) {
	  return (0, _lodash.get)(props, 'params');
	};
	
	var getStoreIdFromParams = exports.getStoreIdFromParams = (0, _reselect.createSelector)([getParams], function (params) {
	  return (0, _lodash.get)(params, 'store_id');
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(63);
	var toLength = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(131);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(54);
	var redefineAll = __webpack_require__(129);
	var meta = __webpack_require__(112);
	var forOf = __webpack_require__(124);
	var anInstance = __webpack_require__(123);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(16);
	var $iterDetect = __webpack_require__(246);
	var setToStringTag = __webpack_require__(158);
	var inheritIfRequired = __webpack_require__(336);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(531);
	var redefine = __webpack_require__(54);
	var hide = __webpack_require__(53);
	var fails = __webpack_require__(16);
	var defined = __webpack_require__(78);
	var wks = __webpack_require__(22);
	var regexpExec = __webpack_require__(344);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(67);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(18);
	var cof = __webpack_require__(67);
	var MATCH = __webpack_require__(22)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(22)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(111) || !__webpack_require__(16)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(15)[K];
	});


/***/ },
/* 248 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(156);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(49);
	var ctx = __webpack_require__(69);
	var forOf = __webpack_require__(124);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(68);
	var global = __webpack_require__(15);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(111) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(71);
	var defined = __webpack_require__(78);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(53);
	var uid = __webpack_require__(132);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1395),
	    listCacheDelete = __webpack_require__(1396),
	    listCacheGet = __webpack_require__(1397),
	    listCacheHas = __webpack_require__(1398),
	    listCacheSet = __webpack_require__(1399);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(549),
	    eq = __webpack_require__(203);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(203);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(162),
	    toKey = __webpack_require__(165);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1393);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 262 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 263 */
[1804, 135],
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(258),
	    copyObject = __webpack_require__(163),
	    createAssigner = __webpack_require__(1372),
	    isArrayLike = __webpack_require__(82),
	    isPrototype = __webpack_require__(202),
	    keys = __webpack_require__(97);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1337),
	    isObjectLike = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(81),
	    stubFalse = __webpack_require__(1445);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObject = __webpack_require__(83);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1456);
	
	var _runTransitionHook = __webpack_require__(374);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(136);
	
	var _deprecate = __webpack_require__(373);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1472)


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var stackClear = __webpack_require__(1554),
	    stackDelete = __webpack_require__(1555),
	    stackGet = __webpack_require__(1556),
	    stackHas = __webpack_require__(1557),
	    stackSet = __webpack_require__(1558);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function Stack(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add functions to the `Stack` cache.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 272 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(282);
	
	/**
	 * Gets the index at which the first occurrence of `key` is found in `array`
	 * of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 274 */
[1796, 615, 141],
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(1567);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 276 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(32);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (typeof value == 'number') {
	    return true;
	  }
	  return !isArray(value) &&
	    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	      (object != null && value in Object(object)));
	}
	
	module.exports = isKey;


/***/ },
/* 278 */
[1804, 275],
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(611);
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 280 */
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var arrayConcat = __webpack_require__(1491),
	    baseFlatten = __webpack_require__(209),
	    isArray = __webpack_require__(32),
	    rest = __webpack_require__(142);
	
	/**
	 * Creates a new array concatenating `array` with any additional arrays
	 * and/or values.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to concatenate.
	 * @param {...*} [values] The values to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 * @example
	 *
	 * var array = [1];
	 * var other = _.concat(array, 2, [3], [[4]]);
	 *
	 * console.log(other);
	 * // => [1, 2, 3, [4]]
	 *
	 * console.log(array);
	 * // => [1]
	 */
	var concat = rest(function(array, values) {
	  if (!isArray(array)) {
	    array = array == null ? [] : [Object(array)];
	  }
	  values = baseFlatten(values, 1);
	  return arrayConcat(array, values);
	});
	
	module.exports = concat;


/***/ },
/* 282 */
/***/ function(module, exports) {

	/**
	 * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(211);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 284 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var isHostObject = __webpack_require__(276),
	    isObjectLike = __webpack_require__(140);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototypeOf(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(1503),
	    indexKeys = __webpack_require__(630),
	    isIndex = __webpack_require__(210),
	    isPrototype = __webpack_require__(389);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(620),
	    createAssigner = __webpack_require__(626);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable properties of source objects into the destination
	 * object. Source properties that resolve to `undefined` are skipped if a
	 * destination value exists. Array and plain object properties are merged
	 * recursively.Other objects and value types are overridden by assignment.
	 * Source objects are applied from left to right. Subsequent sources
	 * overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(272),
	    baseEach = __webpack_require__(208),
	    baseIteratee = __webpack_require__(72),
	    baseReduce = __webpack_require__(1511),
	    isArray = __webpack_require__(32);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` through `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventPluginRegistry = __webpack_require__(404);
	var ReactEventEmitterMixin = __webpack_require__(1631);
	var ViewportMetrics = __webpack_require__(659);
	
	var getVendorPrefixedEventName = __webpack_require__(664);
	var isEventSupported = __webpack_require__(415);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(218);
	var ViewportMetrics = __webpack_require__(659);
	
	var getEventModifierState = __webpack_require__(413);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 292 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var DOMNamespaces = __webpack_require__(403);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(411);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 294 */
[1807, 1685],
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(296);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1712);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(1669);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(298);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _defaultArrowRenderer = __webpack_require__(1721);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultFilterOptions = __webpack_require__(686);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(687);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultClearRenderer = __webpack_require__(1722);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _Option = __webpack_require__(1720);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(685);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	
	var instanceId = 1;
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				if (nextState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(nextState.isOpen);
					var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
					var menuNode = _reactDom2.default.findDOMNode(this.menu);
					menuNode.scrollTop = focusedOptionNode.offsetTop;
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
					var menuDOM = _reactDom2.default.findDOMNode(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					return;
				}
	
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				if (!this.state.isOpen) {
					return;
				}
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: this.handleInputValueChange('')
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
				var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
				this.setState({
					isFocused: true,
					isOpen: isOpen
				});
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					isOpen: true,
					isPseudoFocused: false,
					inputValue: newInputValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							return;
						}
						this.selectFocusedOption();
						return;
					case 13:
						// enter
						if (!this.state.isOpen) return;
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 27:
						// escape
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 38:
						// up
						this.focusPreviousOption();
						break;
					case 40:
						// down
						this.focusNextOption();
						break;
					case 33:
						// page up
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							return;
						}
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							return;
						}
						this.focusStartOption();
						break;
					case 46:
						// backspace
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					default:
						return;
				}
				event.preventDefault();
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'handleRequired',
			value: function handleRequired(value, multi) {
				if (!value) return true;
				return multi ? value.length === 0 : Object.keys(value).length === 0;
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param	{String|Number|Array}	value		- the value of the select input
	   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value, nextProps) {
				var _this2 = this;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') value = value.split(props.delimiter);
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this2.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
	
			/**
	   * Retrieve a value from the given options and valueKey
	   * @param	{String|Number|Array}	value	- the selected value(s)
	   * @param	{Object}		props	- the Select component's props (or nextProps)
	   */
	
		}, {
			key: 'expandValue',
			value: function expandValue(value, props) {
				var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var options = props.options,
				    valueKey = props.valueKey;
	
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (options[i][valueKey] === value) return options[i];
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this3 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = this.handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.onChange) {
					if (this.props.simpleValue && value) {
						value = this.props.multi ? value.map(function (i) {
							return i[_this3.props.valueKey];
						}).join(this.props.delimiter) : value[this.props.valueKey];
					}
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this4 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				if (this.props.multi) {
					var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						_this4.addValue(value);
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this4.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i !== value;
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
				this.setValue(this.getResetValue());
				this.setState({
					isOpen: false,
					inputValue: this.handleInputValueChange('')
				}, this.focus);
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						inputValue: '',
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
					});
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var potentialIndex = focusedIndex + this.props.pageSize;
					if (potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'getInputValue',
			value: function getInputValue() {
				return this.state.inputValue;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					return !this.state.inputValue ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								disabled: _this5.props.disabled || value.clearableValue === false,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (!this.state.inputValue) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							id: this._instancePrefix + '-value-item',
							disabled: this.props.disabled,
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps,
					    inputClassName = _props$inputProps.inputClassName,
					    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
	
					return _react2.default.createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						'aria-readonly': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement('input', inputProps)
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						onMouseDown: this.clearValue,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEndClearValue
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey,
						onOptionRef: this.onOptionRef
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						type: 'hidden',
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						name: this.props.name,
						value: value,
						disabled: this.props.disabled });
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', { key: 'hidden.' + index,
						type: 'hidden',
						ref: 'value' + index,
						name: _this7.props.name,
						value: stringifyValue(item[_this7.props.valueKey]),
						disabled: _this7.props.disabled });
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'Select--multi': this.props.multi,
					'Select--single': !this.props.multi,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'has-value': valueArray.length
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							style: this.props.style,
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchStart: this.handleTouchStart,
							onTouchMove: this.handleTouchMove
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	;
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
		addLabelText: _propTypes2.default.string, // placeholder displayed when you want to add a label on a multi-value input
		arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autofocus: _propTypes2.default.bool, // autofocus the component on mount
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: _propTypes2.default.string, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		addLabelText: 'Add "{label}"?',
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onSelectResetsInput: true,
		onCloseResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		required: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  keyPrefix: 'reduxPersist:',
	  REHYDRATE: 'persist/REHYDRATE'
	};

/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(1779).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(302).setImmediate, __webpack_require__(302).clearImmediate))

/***/ },
/* 303 */
/***/ function(module, exports) {

	const DEFAULT = [
	  { name: 'Summary', type: 'group' },
	  { name: 'Overview', route: 'summary', type: 'link', multiStore: true },
	
	  { name: 'Inventory Management', type: 'group' },
	  { name: 'Inventory', route: 'inventory', indexRedirect: 'index', type: 'link', permission: 'inventory:view_only' },
	  // { name: 'Inventory', route: 'inventory', type: 'link', permission: 'inventory:view_only', prefix: 'v2', label: 'Alpha', internal: true },
	  { name: 'Modifiers', route: 'modifiers', indexRedirect: 'index', type: 'link', permission: 'modifier_set:view_only' },
	  { name: 'Modifiers', route: '/inventory/modifiers', type: 'link', permission: 'modifier_set:view_only', prefix: 'embed', icon: 'modifiers', label: 'Alpha', internal: true },
	  { name: 'Departments', route: 'departments', type: 'link', permission: 'inventory:view_only' },
	  { name: 'Kitchen Departments', route: 'kitchen-departments', type: 'link', prefix: 'v2', permission: 'inventory:view_only'},
	  { name: 'Lot Inquiry', route:'lot-inquiry', type: 'link' },
	  { name: 'Restaurant Menu', route: 'menus', indexRedirect: 'index', type: 'link', permission: 'menu_setup:view_only', module: 'restaurant_features_enabled' },
	  { name: 'Multi Lang Menu', type: 'link', route: '/restaurant-menu', prefix: 'embed', permission: 'menu_setup:view_only', module: 'restaurant_features_enabled', label: 'Alpha', internal: true },
	  { name: 'Stock Transfers', route: 'stock-transfers', indexRedirect: 'index', type: 'link' },
	
	  { name: 'Stock Take Management', type: 'group' },
	  { name: 'Inventory Variance', route: 'inventory-variance', type: 'link', prefix: 'v2', module: 'inventory_variance_enabled' },
	
	  { name: 'Production Management', type: 'group' },
	  { name: 'Production orders', route: 'production-orders', type: 'link', permission: 'production_order:view', module: 'bill_of_material_enabled', prefix: 'v2' },
	
	  { name: 'Promotion', type: 'group' },
	  { name: 'Discounts', route: 'discounts', indexRedirect: 'index', type: 'link', permission: 'discount:view_only' },
	  { name: 'Promotion Codes', type: 'link', route: 'promo-codes', prefix: 'v2' },
	
	  { name: 'CRM', type: 'group' },
	  { name: 'Customers', route: 'customers', indexRedirect: 'index', type: 'link', permission: 'customer:view_only' },
	  { name: 'Membership Levels', route: 'membership', indexRedirect: 'index', type: 'link' },
	  { name: 'Gift Cards', route: 'gift-cards', indexRedirect: 'index', type: 'link', permission: 'gift_card:view_only', module: 'gift_card_enabled' },
	  { name: 'Vouchers', route: 'vouchers', type: 'link', permission: 'voucher:view', module: 'voucher_feature_enabled', prefix: 'v2' },
	
	  { name: 'Sales Management', type: 'group' },
	  { name: 'Register Sales', route: 'sales', indexRedirect: 'index', type: 'link', permission: 'sales:view_only' },
	  { name: 'Invoices', route: 'invoices', indexRedirect: 'index', type: 'link', permission: 'invoice:view_only', multiStore: true },
	  { name: 'Delivery Note', route: 'delivery-note', type: 'link', prefix: 'v2' },
	  { name: 'Line Item Status', route: 'line-items', indexRedirect: 'index', type: 'link' },
	  { name: 'Line Item Status Set Up', route: 'line-item-status-set-up', type: 'link', prefix: 'v2' },
	  { name: 'Workflow Set Up', route: 'workflow-set-up', type: 'link', prefix: 'v2' },
	
	  { name: 'Supplier Management', type: 'group' },
	  { name: 'Suppliers', route: 'suppliers', indexRedirect: 'index', type: 'link', permission: 'supplier:view_only' },
	  { name: 'Purchase Orders', route: 'purchase-orders', indexRedirect: 'index', type: 'link', permission: 'purchase_order:view_only', multiStore: true },
	  { name: 'Goods Received Note', route: 'goods', indexRedirect: 'index', type:'link', permission: 'purchase_order:view_only', module: 'warehouse_management_enabled' },
	  { name: 'Return Note', route: 'returnnote', indexRedirect: 'index', type:'link', permission: 'purchase_order:view_only', module: 'warehouse_management_enabled' },
	  { name: 'Return Note', route: '/purchase/return', type:'link', permission: 'purchase_order:view_only', module: 'warehouse_management_enabled', prefix: 'embed', icon: 'returnnote', label: 'Alpha', internal: true },
	
	  { name: 'Advanced Management', type: 'group' },
	  { name: 'Event & Devices', route: 'event-devices', type: 'link', permission: 'settings:view_only', module: 'device_whitelist_enabled' },
	
	  { name: 'Reports', type: 'group' },
	  { name: 'Reports', route: 'reports', indexRedirect: 'index', type: 'link', permission: 'report', multiStore: true },
	  { name: 'Advanced Reports', route: 'advanced-report', type: 'link', multiStore: true, prefix: 'v2' },
	  { name: 'Tableau', route: 'tableau', type: 'link', multiStore: true, label: 'Alpha', internal: true, prefix: 'v2'},
	  { name: 'Admin', route: 'bindo-admin', type: 'link', multiStore: true, label: 'Admin', internal: true, prefix: 'v2'},
	  { name: 'Chinese Reports', route: 'chinese-report', type: 'link', multiStore: true, prefix: 'v2' },
	
	  { name: 'Settings', type: 'group' },
	  { name: 'Settings', route: 'settings', subRoute: 'settings', type: 'menu', permission: 'settings', children: [
	    {
	      name: 'Business',
	      permission: 'settings:business',
	      subRoute: 'business',
	      children: [
	        { name: 'Policies', route: 'settings/business/policies', subRoute: 'policies', state: 'settings.policy', prefix: 'v2' },
	        { name: 'Storefront', route: 'settings/iframe', state: 'settings.iframe', indexRedirect: 'index' },
	        { name: 'Tax Options', route: 'settings/tax', state: 'settings.tax', indexRedirect: 'index' },
	        { name: 'Associates', route: 'settings/business/associates', subRoute: 'associates', state: 'settings.business.associates' },
	        { name: 'Rounding Behavior', route: 'settings/business/rounding-behavior', subRoute: 'rounding-behavior', prefix: 'v2', state: 'settings.rounding' },
	        { name: 'Opening Hours', route: 'settings/time/opening-hours', state: 'settings.time.opening-hours' },
	        { name: 'Time Segments', route: 'settings/time/segments', state: 'settings.time.segments' },
	        { name: 'Additional Fees', route: 'settings/additionalfee', indexRedirect: 'index', state: 'settings.additionalfee' },
	        { name: 'Email Template', route: 'settings/email-template', indexRedirect: 'index', state: 'settings.email-template' },
	        { name: 'Currencies', route: 'settings/currency', indexRedirect: 'index', state: 'settings.currency' },
	        { name: 'Languages', route: 'settings/languages', state: 'settings.languages' },
	        { name: 'Custom Attributes', route: 'settings/custom-attributes', state: 'settings.custom-attributes' },
	        { name: 'Stations', route: 'settings/business/stations', subRoute: 'stations', prefix: 'v2', state: 'settings.business.stations' },
	        { name: 'Embedded Barcodes', route: 'settings/business/barcode', subRoute: 'barcode', prefix: 'v2', state: 'settings.business.barcode' },
	        { name: 'Tables', route: 'settings/business/table', subRoute: 'table', prefix: 'v2', state: 'settings.business.table' },
	        { name: 'Table Size Segmentations', route: 'settings/business/table-size-segmentation', subRoute: 'table-size-segmentation', prefix: 'v2', state: 'settings.business.table-size-segmentation' },
	        { name: 'UOM Groups', route: 'settings/business/uom-groups', subRoute: 'uom-groups', prefix: 'v2', state: 'settings.business.uom-group' },
	      ]
	    },
	    {
	      name: 'Permissions',
	      permission: 'dashboard:permission',
	      subRoute: 'permissions',
	      children: [
	        { name: 'Permissions', route: 'settings/permissions', indexRedirect: 'index', state: 'settings.permissions'},
	      ]
	    },
	    { name: 'Payments',
	      permission: 'settings:payment',
	      subRoute: 'payments',
	      children: [
	        { name: 'Store Credit', route: 'settings/payments/store-credit', subRoute: 'store-credit', prefix: 'v2', state: 'settings.payments.store-credit' },
	        { name: 'Signature', route: 'settings/payments/signature', subRoute: 'signature', prefix: 'v2', state: 'settings.payments.signature' },
	        { name: 'Payment Types', route: 'settings/payments/payment-type', subRoute: 'payment-type', prefix: 'v2', state: 'settings.payments.payment-type' },
	      ]
	    },
	    { name: 'Add-ons',
	      permission: 'settings:add_ons',
	      children: [
	        { name: 'Add-ons', route: 'settings/add-ons', subRoute: 'add-ons', prefix: 'v2', state: 'settings.add-ons' },
	      ]
	    },
	    {
	      name: 'PMS',
	      module: 'oracle_pms_enable',
	      children: [
	        { name: 'PMS', route: 'settings/pms', subRoute: 'pms', prefix: 'v2', state: 'settings.pms'}
	      ]
	    },
	    {
	      name: 'Reference Number Format',
	      children: [
	        { name: 'Reference Number Format', route: 'settings/reference-number', prefix: 'v2', state: 'settings.reference-number'}
	      ]
	    }
	  ]
	  }
	];
	
	const CHAIN_MASTER_MENUS = [
	  { name: 'Item Master', route: 'item-master', type: 'link', indexRedirect: 'index', multiStore: true },
	  { name: 'Discounts', route: 'discounts', type: 'link', indexRedirect: 'index' },
	  { name: 'Suppliers', route: 'suppliers', indexRedirect: 'index', type: 'link' },
	  { name: 'Purchase Orders', route: 'purchase-orders', indexRedirect: 'index', type: 'link', multiStore: true },
	  { name: 'Goods Received Note', route: 'goods', indexRedirect: 'index', type:'link' },
	  { name: 'Return Note', route: 'returnnote', indexRedirect: 'index', type:'link' },
	];
	
	module.exports = {
	  DEFAULT: DEFAULT,
	  CHAIN_MASTER_MENUS: CHAIN_MASTER_MENUS,
	};


/***/ },
/* 304 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.KeyCodes = {
	    8: "backspace",
	    9: "tab",
	    13: "enter",
	    20: "capslock",
	    27: "esc",
	    32: "space",
	    33: "pageup",
	    34: "pagedown",
	    35: "end",
	    36: "home",
	    37: "left",
	    38: "up",
	    39: "right",
	    40: "down",
	    45: "ins",
	    46: "del",
	    // number keys
	    48: "0",
	    49: "1",
	    50: "2",
	    51: "3",
	    52: "4",
	    53: "5",
	    54: "6",
	    55: "7",
	    56: "8",
	    57: "9",
	    // alphabet
	    65: "a",
	    66: "b",
	    67: "c",
	    68: "d",
	    69: "e",
	    70: "f",
	    71: "g",
	    72: "h",
	    73: "i",
	    74: "j",
	    75: "k",
	    76: "l",
	    77: "m",
	    78: "n",
	    79: "o",
	    80: "p",
	    81: "q",
	    82: "r",
	    83: "s",
	    84: "t",
	    85: "u",
	    86: "v",
	    87: "w",
	    88: "x",
	    89: "y",
	    90: "z",
	    // punctuation
	    106: "*",
	    107: "+",
	    109: "-",
	    110: ".",
	    111: "/",
	    186: ";",
	    187: "=",
	    188: ",",
	    189: "-",
	    190: ".",
	    191: "/",
	    192: "`",
	    219: "[",
	    220: "\\",
	    221: "]",
	    222: "'",
	};
	exports.Modifiers = {
	    16: "shift",
	    17: "ctrl",
	    18: "alt",
	    91: "meta",
	    93: "meta",
	    224: "meta",
	};
	exports.ModifierBitMasks = {
	    alt: 1,
	    ctrl: 2,
	    meta: 4,
	    shift: 8,
	};
	exports.Aliases = {
	    cmd: "meta",
	    command: "meta",
	    escape: "esc",
	    minus: "-",
	    mod: isMac() ? "meta" : "ctrl",
	    option: "alt",
	    plus: "+",
	    return: "enter",
	    win: "meta",
	};
	// alph sorting is unintuitive here
	// tslint:disable object-literal-sort-keys
	exports.ShiftKeys = {
	    "~": "`",
	    "!": "1",
	    "@": "2",
	    "#": "3",
	    $: "4",
	    "%": "5",
	    "^": "6",
	    "&": "7",
	    "*": "8",
	    "(": "9",
	    ")": "0",
	    _: "-",
	    "+": "=",
	    "{": "[",
	    "}": "]",
	    "|": "\\",
	    ":": ";",
	    '"': "'",
	    "<": ",",
	    ">": ".",
	    "?": "/",
	};
	// tslint:enable object-literal-sort-keys
	// Function keys
	for (var i = 1; i <= 12; ++i) {
	    exports.KeyCodes[111 + i] = "f" + i;
	}
	// Numpad
	for (var i = 0; i <= 9; ++i) {
	    exports.KeyCodes[96 + i] = "num" + i.toString();
	}
	function comboMatches(a, b) {
	    return a.modifiers === b.modifiers && a.key === b.key;
	}
	exports.comboMatches = comboMatches;
	/**
	 * Converts a key combo string into a key combo object. Key combos include
	 * zero or more modifier keys, such as `shift` or `alt`, and exactly one
	 * action key, such as `A`, `enter`, or `left`.
	 *
	 * For action keys that require a shift, e.g. `@` or `|`, we inlude the
	 * necessary `shift` modifier and automatically convert the action key to the
	 * unshifted version. For example, `@` is equivalent to `shift+2`.
	 */
	exports.parseKeyCombo = function (combo) {
	    var pieces = combo
	        .replace(/\s/g, "")
	        .toLowerCase()
	        .split("+");
	    var modifiers = 0;
	    var key = null;
	    for (var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++) {
	        var piece = pieces_1[_i];
	        if (piece === "") {
	            throw new Error("Failed to parse key combo \"" + combo + "\".\n                Valid key combos look like \"cmd + plus\", \"shift+p\", or \"!\"");
	        }
	        if (exports.Aliases[piece] != null) {
	            piece = exports.Aliases[piece];
	        }
	        if (exports.ModifierBitMasks[piece] != null) {
	            modifiers += exports.ModifierBitMasks[piece];
	        }
	        else if (exports.ShiftKeys[piece] != null) {
	            // tslint:disable-next-line no-string-literal
	            modifiers += exports.ModifierBitMasks["shift"];
	            key = exports.ShiftKeys[piece];
	        }
	        else {
	            key = piece.toLowerCase();
	        }
	    }
	    return { modifiers: modifiers, key: key };
	};
	/**
	 * PhantomJS's webkit totally messes up keyboard events, so we have do this
	 * fancy little dance with the event data to determine which key was pressed
	 * for unit tests.
	 */
	var normalizeKeyCode = function (e) {
	    return e.which === 0 && e.key != null ? e.key.charCodeAt(0) : e.which;
	};
	/**
	 * Converts a keyboard event into a valid combo prop string
	 */
	exports.getKeyComboString = function (e) {
	    var keys = [];
	    // modifiers first
	    if (e.ctrlKey) {
	        keys.push("ctrl");
	    }
	    if (e.altKey) {
	        keys.push("alt");
	    }
	    if (e.shiftKey) {
	        keys.push("shift");
	    }
	    if (e.metaKey) {
	        keys.push("meta");
	    }
	    var which = normalizeKeyCode(e);
	    if (exports.Modifiers[which] != null) {
	        // no action key
	    }
	    else if (exports.KeyCodes[which] != null) {
	        keys.push(exports.KeyCodes[which]);
	    }
	    else {
	        keys.push(String.fromCharCode(which).toLowerCase());
	    }
	    // join keys with plusses
	    return keys.join(" + ");
	};
	/**
	 * Determines the key combo object from the given keyboard event. Again, a key
	 * combo includes zero or more modifiers (represented by a bitmask) and one
	 * action key, which we determine from the `e.which` property of the keyboard
	 * event.
	 */
	exports.getKeyCombo = function (e) {
	    var key = null;
	    var which = normalizeKeyCode(e);
	    if (exports.Modifiers[which] != null) {
	        // keep key null
	    }
	    else if (exports.KeyCodes[which] != null) {
	        key = exports.KeyCodes[which];
	    }
	    else {
	        key = String.fromCharCode(which).toLowerCase();
	    }
	    var modifiers = 0;
	    // tslint:disable no-string-literal
	    if (e.altKey) {
	        modifiers += exports.ModifierBitMasks["alt"];
	    }
	    if (e.ctrlKey) {
	        modifiers += exports.ModifierBitMasks["ctrl"];
	    }
	    if (e.metaKey) {
	        modifiers += exports.ModifierBitMasks["meta"];
	    }
	    if (e.shiftKey) {
	        modifiers += exports.ModifierBitMasks["shift"];
	    }
	    // tslint:enable
	    return { modifiers: modifiers, key: key };
	};
	/**
	 * Splits a key combo string into its constituent key values and looks up
	 * aliases, such as `return` -> `enter`.
	 *
	 * Unlike the parseKeyCombo method, this method does NOT convert shifted
	 * action keys. So `"@"` will NOT be converted to `["shift", "2"]`).
	 */
	exports.normalizeKeyCombo = function (combo, platformOverride) {
	    var keys = combo.replace(/\s/g, "").split("+");
	    return keys.map(function (key) {
	        var keyName = exports.Aliases[key] != null ? exports.Aliases[key] : key;
	        return keyName === "meta" ? (isMac(platformOverride) ? "cmd" : "ctrl") : keyName;
	    });
	};
	/* tslint:enable:no-string-literal */
	function isMac(platformOverride) {
	    var platform = platformOverride != null ? platformOverride : typeof navigator !== "undefined" ? navigator.platform : undefined;
	    return platform == null ? false : /Mac|iPod|iPhone|iPad/.test(platform);
	}


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Menu = (function (_super) {
	    tslib_1.__extends(Menu, _super);
	    function Menu() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Menu.prototype.render = function () {
	        return (React.createElement("ul", { className: classNames(Classes.MENU, this.props.className), ref: this.props.ulRef }, this.props.children));
	    };
	    Menu.displayName = "Blueprint.Menu";
	    return Menu;
	}(React.Component));
	exports.Menu = Menu;
	exports.MenuFactory = React.createFactory(Menu);


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
	var SPINNER_TRACK = "M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89";
	// unitless total length of SVG path, to which stroke-dash* properties are relative.
	// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
	// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
	var PATH_LENGTH = 280;
	var Spinner = (function (_super) {
	    tslib_1.__extends(Spinner, _super);
	    function Spinner() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Spinner.prototype.render = function () {
	        var _a = this.props, className = _a.className, intent = _a.intent, value = _a.value;
	        var classes = classNames(Classes.SPINNER, Classes.intentClass(intent), {
	            "pt-no-spin": value != null,
	        }, className);
	        var style = {
	            strokeDasharray: PATH_LENGTH + " " + PATH_LENGTH,
	            // default to quarter-circle when indeterminate
	            // IE11: CSS transitions on SVG elements are Not Supported :(
	            strokeDashoffset: PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : utils_1.clamp(value, 0, 1)),
	        };
	        // HACKHACK to squash error regarding React.SVGProps missing prop pathLength
	        var svgPathAttributes = {
	            className: "pt-spinner-head",
	            d: SPINNER_TRACK,
	            pathLength: PATH_LENGTH,
	            style: style,
	        };
	        return this.renderContainer(classes, React.createElement("svg", { viewBox: classes.indexOf(Classes.SMALL) >= 0 ? "-15 -15 130 130" : "0 0 100 100" },
	            React.createElement("path", { className: "pt-spinner-track", d: SPINNER_TRACK }),
	            React.createElement("path", tslib_1.__assign({}, svgPathAttributes))));
	    };
	    // abstract away the container elements so SVGSpinner can do its own thing
	    Spinner.prototype.renderContainer = function (classes, content) {
	        return (React.createElement("div", { className: classes },
	            React.createElement("div", { className: "pt-spinner-svg-container" }, content)));
	    };
	    Spinner.displayName = "Blueprint.Spinner";
	    Spinner = tslib_1.__decorate([
	        PureRender
	    ], Spinner);
	    return Spinner;
	}(React.Component));
	exports.Spinner = Spinner;
	exports.SpinnerFactory = React.createFactory(Spinner);


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var position_1 = __webpack_require__(88);
	var popover_1 = __webpack_require__(148);
	var Tooltip = (function (_super) {
	    tslib_1.__extends(Tooltip, _super);
	    function Tooltip() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Tooltip.prototype.render = function () {
	        var _a = this.props, children = _a.children, intent = _a.intent, openOnTargetFocus = _a.openOnTargetFocus, tooltipClassName = _a.tooltipClassName;
	        var classes = classNames(Classes.TOOLTIP, Classes.intentClass(intent), tooltipClassName);
	        return (React.createElement(popover_1.Popover, tslib_1.__assign({}, this.props, { arrowSize: 22, autoFocus: false, canEscapeKeyClose: false, enforceFocus: false, interactionKind: popover_1.PopoverInteractionKind.HOVER_TARGET_ONLY, lazy: true, openOnTargetFocus: openOnTargetFocus, popoverClassName: classes }), children));
	    };
	    Tooltip.defaultProps = {
	        hoverCloseDelay: 0,
	        hoverOpenDelay: 100,
	        isDisabled: false,
	        openOnTargetFocus: true,
	        position: position_1.Position.TOP,
	        rootElementTag: "span",
	        transitionDuration: 100,
	        useSmartArrowPositioning: true,
	        useSmartPositioning: false,
	    };
	    Tooltip.displayName = "Blueprint.Tooltip";
	    Tooltip = tslib_1.__decorate([
	        PureRender
	    ], Tooltip);
	    return Tooltip;
	}(React.Component));
	exports.Tooltip = Tooltip;
	exports.TooltipFactory = React.createFactory(Tooltip);


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.askRecipientThenSendEmail = exports.sendEmail = exports.EMAIL_TEMPLATE_TYPE = exports.EMAIL_PATTERN = undefined;
	
	var _emailTemplateService = __webpack_require__(494);
	
	var _emailTemplateService2 = _interopRequireDefault(_emailTemplateService);
	
	var _alertActions = __webpack_require__(90);
	
	var alertActions = _interopRequireWildcard(_alertActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
	
	var EMAIL_TEMPLATE_TYPE = _emailTemplateService2.default.TYPE;
	
	var sendEmail = function sendEmail(storeId, template_type, recipient) {
	  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  return function (dispatch) {
	    return _emailTemplateService2.default.send(storeId, template_type, recipient, params).then(function (res) {
	      return dispatch(alertActions.alert('success', 'Send Email Template Success'));
	    }).catch(function (err) {
	      return dispatch(alertActions.alert('danger', err.message));
	    });
	  };
	};
	
	/* istanbul ignore next */
	var askRecipientThenSendEmail = function askRecipientThenSendEmail(_ref) {
	  var storeId = _ref.storeId,
	      templateType = _ref.templateType,
	      defaultRecipient = _ref.defaultRecipient,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params;
	  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter customer\'s email';
	  return function (dispatch) {
	    var askEmail = function askEmail(prevRecipient) {
	      var errorMsg = prevRecipient ? '"' + prevRecipient + '" is not a valid email address.\n' : "";
	      var promptMsg = errorMsg + msg;
	      var recipient = window.prompt(promptMsg, defaultRecipient || '');
	      // Press cancel
	      if (recipient == null) {
	        return;
	      }
	      // Validate recipient email address
	      recipient = (recipient || '').trim();
	      if (EMAIL_PATTERN.test(recipient)) {
	        return sendEmail(storeId, templateType, recipient, params)(dispatch);
	      } else {
	        return askEmail(recipient);
	      }
	    };
	    return askEmail();
	  };
	};
	
	exports.EMAIL_PATTERN = EMAIL_PATTERN;
	exports.EMAIL_TEMPLATE_TYPE = EMAIL_TEMPLATE_TYPE;
	exports.sendEmail = sendEmail;
	exports.askRecipientThenSendEmail = askRecipientThenSendEmail;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitFile = exports.uploadFile = exports.closeFileImporter = exports.showFileImporter = exports.UPDATE_VALIDATION_PROGRESS = exports.UPDATE_IMPORT_PROGRESS = exports.POST_VALIDATED_COUPON_IMPORT_FAILURE = exports.POST_VALIDATED_COUPON_IMPORT_SUCCESS = exports.POST_VALIDATED_COUPON_IMPORT_REQUEST = exports.GET_IMPORT_VALIDATION_PROGRESS_FAILURE = exports.GET_IMPORT_VALIDATION_PROGRESS_SUCCESS = exports.GET_IMPORT_VALIDATION_PROGRESS_REQUEST = exports.SUBMIT_UPLOAD_FILE_FAILURE = exports.SUBMIT_UPLOAD_FILE_SUCCESS = exports.SUBMIT_UPLOAD_FILE_REQUEST = exports.UPLOAD_FILE = exports.CLOSE_FILE_IMPORTER = exports.SHOW_FILE_IMPORTER = undefined;
	
	var _lodash = __webpack_require__(14);
	
	var _voucherService = __webpack_require__(497);
	
	var _voucherService2 = _interopRequireDefault(_voucherService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHOW_FILE_IMPORTER = exports.SHOW_FILE_IMPORTER = 'SHOW_FILE_IMPORTER';
	var CLOSE_FILE_IMPORTER = exports.CLOSE_FILE_IMPORTER = 'CLOSE_FILE_IMPORTER';
	var UPLOAD_FILE = exports.UPLOAD_FILE = 'UPLOAD_FILE';
	var SUBMIT_UPLOAD_FILE_REQUEST = exports.SUBMIT_UPLOAD_FILE_REQUEST = 'SUBMIT_UPLOAD_FILE_REQUEST';
	var SUBMIT_UPLOAD_FILE_SUCCESS = exports.SUBMIT_UPLOAD_FILE_SUCCESS = 'SUBMIT_UPLOAD_FILE_SUCCESS';
	var SUBMIT_UPLOAD_FILE_FAILURE = exports.SUBMIT_UPLOAD_FILE_FAILURE = 'SUBMIT_UPLOAD_FILE_FAILURE';
	var GET_IMPORT_VALIDATION_PROGRESS_REQUEST = exports.GET_IMPORT_VALIDATION_PROGRESS_REQUEST = 'GET_IMPORT_VALIDATION_PROGRESS_REQUEST';
	var GET_IMPORT_VALIDATION_PROGRESS_SUCCESS = exports.GET_IMPORT_VALIDATION_PROGRESS_SUCCESS = 'GET_IMPORT_VALIDATION_PROGRESS_SUCCESS';
	var GET_IMPORT_VALIDATION_PROGRESS_FAILURE = exports.GET_IMPORT_VALIDATION_PROGRESS_FAILURE = 'GET_IMPORT_VALIDATION_PROGRESS_FAILURE';
	var POST_VALIDATED_COUPON_IMPORT_REQUEST = exports.POST_VALIDATED_COUPON_IMPORT_REQUEST = 'POST_VALIDATED_COUPON_IMPORT_REQUEST';
	var POST_VALIDATED_COUPON_IMPORT_SUCCESS = exports.POST_VALIDATED_COUPON_IMPORT_SUCCESS = 'POST_VALIDATED_COUPON_IMPORT_SUCCESS';
	var POST_VALIDATED_COUPON_IMPORT_FAILURE = exports.POST_VALIDATED_COUPON_IMPORT_FAILURE = 'POST_VALIDATED_COUPON_IMPORT_FAILURE';
	var UPDATE_IMPORT_PROGRESS = exports.UPDATE_IMPORT_PROGRESS = 'UPDATE_IMPORT_PROGRESS';
	var UPDATE_VALIDATION_PROGRESS = exports.UPDATE_VALIDATION_PROGRESS = 'UPDATE_VALIDATION_PROGRESS';
	
	var updateImportProgress = function updateImportProgress(value) {
	  return { type: UPDATE_IMPORT_PROGRESS, value: value };
	};
	// const updateValidationProgress = (value) => ({ type: UPDATE_VALIDATION_PROGRESS, value });
	var showFileImporter = exports.showFileImporter = function showFileImporter(storeId, discountId) {
	  return { type: SHOW_FILE_IMPORTER, storeId: storeId, discountId: discountId };
	};
	var closeFileImporter = exports.closeFileImporter = function closeFileImporter() {
	  return { type: CLOSE_FILE_IMPORTER };
	};
	var uploadFile = exports.uploadFile = function uploadFile(fileString, fileBlob, fileType) {
	  return { type: UPLOAD_FILE, fileString: fileString, fileBlob: fileBlob, fileType: fileType };
	};
	var submitFile = exports.submitFile = function submitFile() {
	  return function (dispatch, getState) {
	    dispatch({ type: SUBMIT_UPLOAD_FILE_REQUEST });
	    var state = getState();
	    var store = state.forms.fileImporter;
	    //TODO: use parmas array to store the ids, then 'func.apply(null, params.concat([fileData]))', use a promise to wrap it
	    var storeId = store.storeId,
	        discountId = store.discountId,
	        fileBlob = store.fileBlob;
	
	    var importProgressHandler = function importProgressHandler(e) {
	      return dispatch(updateImportProgress(e.lengthComputable ? e.loaded / e.total : 0));
	    };
	    return _voucherService2.default.createCouponImport(storeId, discountId, fileBlob, importProgressHandler).then(function (resp) {
	      var coupon_import = resp.coupon_import;
	
	      dispatch({ type: SUBMIT_UPLOAD_FILE_SUCCESS, data: coupon_import }); //TODO: use data accessor
	      dispatch(getValidateProgress(storeId, coupon_import.id)); //TODO: use import id accessor
	    }).catch(function (error) {
	      dispatch({ type: SUBMIT_UPLOAD_FILE_FAILURE, error: error });
	    });
	  };
	};
	var getValidateProgress = function getValidateProgress(storeId, importId) {
	  return function (dispatch) {
	    dispatch({ type: GET_IMPORT_VALIDATION_PROGRESS_REQUEST });
	    return _voucherService2.default.getCouponImport(storeId, importId) //TODO: use abstruct validation api caller
	    .then(function (resp) {
	      var coupon_import = resp.coupon_import;
	
	      dispatch({ type: GET_IMPORT_VALIDATION_PROGRESS_SUCCESS, data: coupon_import });
	      dispatch({ type: UPDATE_VALIDATION_PROGRESS, value: parseFloat(coupon_import.validation_progress_rate) });
	      if (coupon_import.status === 'validated') {
	        if (!(0, _lodash.size)((0, _lodash.keys)((0, _lodash.get)(coupon_import, 'humanize_validation_errors'))) && !(0, _lodash.size)((0, _lodash.keys)((0, _lodash.get)(coupon_import, 'humanize_validation_warnings')))) {
	          dispatch(postValidatedImport(storeId, importId));
	        }
	      } else {
	        dispatch(getValidateProgress(storeId, importId));
	      }
	    }).catch(function (error) {
	      dispatch({ type: GET_IMPORT_VALIDATION_PROGRESS_FAILURE, error: error });
	    });
	  };
	};
	var postValidatedImport = function postValidatedImport(storeId, importId) {
	  return function (dispatch) {
	    dispatch({ type: POST_VALIDATED_COUPON_IMPORT_REQUEST });
	    return _voucherService2.default.importValidatedCoupon(storeId, importId) //TODO: use abstruct validation api caller
	    .then(function (resp) {
	      var data = resp.data,
	          error = resp.error;
	
	      if (error) {
	        dispatch({ type: POST_VALIDATED_COUPON_IMPORT_FAILURE, error: error });
	      } else {
	        dispatch({ type: POST_VALIDATED_COUPON_IMPORT_SUCCESS, data: data.coupon_import }); //TODO: use data accessor
	      }
	    }).catch(function (error) {
	      dispatch({ type: POST_VALIDATED_COUPON_IMPORT_FAILURE, error: error });
	    });
	  };
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.save = exports.changeMatchingCriteria = exports.changeAggregationTime = exports.toggleAggregation = exports.changePriority = exports.addMatchingCriteria = exports.selectDisplayView = exports.changeShowInProgressState = exports.changeStationName = exports.showStationOverview = exports.SUBMIT_STATION_OVERVIEW_FAILURE = exports.SUBMIT_STATION_OVERVIEW_SUCCESS = exports.SUBMIT_STATION_OVERVIEW_REQUEST = exports.CHANGE_MATCHING_CRITERIA = exports.CHANGE_AGGREGATION_TIME = exports.TOGGLE_AGGREGATION = exports.CHANGE_PRIORITY = exports.ADD_MATCHING_CRITERIA = exports.SELECT_DISPLAY_VIEW = exports.CHANGE_SHOW_IN_PROGRESS_STATE = exports.CHANE_STATION_NAME = exports.DISCARD_STATION_OVERVIEW = exports.SHOW_STATION_OVERVIEW = undefined;
	
	var _kdsActions = __webpack_require__(182);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SHOW_STATION_OVERVIEW = exports.SHOW_STATION_OVERVIEW = 'SHOW_STATION_OVERVIEW';
	var DISCARD_STATION_OVERVIEW = exports.DISCARD_STATION_OVERVIEW = 'DISCARD_STATION_OVERVIEW';
	var CHANE_STATION_NAME = exports.CHANE_STATION_NAME = 'CHANE_STATION_NAME';
	var CHANGE_SHOW_IN_PROGRESS_STATE = exports.CHANGE_SHOW_IN_PROGRESS_STATE = 'CHANGE_SHOW_IN_PROGRESS_STATE';
	var SELECT_DISPLAY_VIEW = exports.SELECT_DISPLAY_VIEW = 'SELECT_DISPLAY_VIEW';
	var ADD_MATCHING_CRITERIA = exports.ADD_MATCHING_CRITERIA = 'ADD_MATCHING_CRITERIA';
	var CHANGE_PRIORITY = exports.CHANGE_PRIORITY = 'CHANGE_PRIORITY';
	var TOGGLE_AGGREGATION = exports.TOGGLE_AGGREGATION = 'TOGGLE_AGGREGATION';
	var CHANGE_AGGREGATION_TIME = exports.CHANGE_AGGREGATION_TIME = 'CHANGE_AGGREGATION_TIME';
	var CHANGE_MATCHING_CRITERIA = exports.CHANGE_MATCHING_CRITERIA = 'CHANGE_MATCHING_CRITERIA';
	
	var SUBMIT_STATION_OVERVIEW_REQUEST = exports.SUBMIT_STATION_OVERVIEW_REQUEST = 'SUBMIT_STATION_OVERVIEW_REQUEST';
	var SUBMIT_STATION_OVERVIEW_SUCCESS = exports.SUBMIT_STATION_OVERVIEW_SUCCESS = 'SUBMIT_STATION_OVERVIEW_SUCCESS';
	var SUBMIT_STATION_OVERVIEW_FAILURE = exports.SUBMIT_STATION_OVERVIEW_FAILURE = 'SUBMIT_STATION_OVERVIEW_FAILURE';
	
	var showStationOverview = exports.showStationOverview = function showStationOverview(station) {
	  return { type: SHOW_STATION_OVERVIEW, station: station };
	};
	
	var changeStationName = exports.changeStationName = function changeStationName(value) {
	  return { type: CHANE_STATION_NAME, value: value };
	};
	
	var changeShowInProgressState = exports.changeShowInProgressState = function changeShowInProgressState(value) {
	  return { type: CHANGE_SHOW_IN_PROGRESS_STATE, value: value };
	};
	
	var selectDisplayView = exports.selectDisplayView = function selectDisplayView(view) {
	  return { type: SELECT_DISPLAY_VIEW, view: view };
	};
	
	var addMatchingCriteria = exports.addMatchingCriteria = function addMatchingCriteria() {
	  return { type: ADD_MATCHING_CRITERIA };
	};
	
	var changePriority = exports.changePriority = function changePriority(priority) {
	  return { type: CHANGE_PRIORITY, priority: priority };
	};
	
	var toggleAggregation = exports.toggleAggregation = function toggleAggregation(value) {
	  return { type: TOGGLE_AGGREGATION, value: value };
	};
	
	var changeAggregationTime = exports.changeAggregationTime = function changeAggregationTime(value) {
	  return { type: CHANGE_AGGREGATION_TIME, value: value };
	};
	
	var changeMatchingCriteria = exports.changeMatchingCriteria = function changeMatchingCriteria(_ref) {
	  var number = _ref.number,
	      departments = _ref.departments,
	      status = _ref.status,
	      showPrematureItems = _ref.showPrematureItems,
	      kitchenDepartments = _ref.kitchenDepartments;
	  return { type: CHANGE_MATCHING_CRITERIA, number: number, departments: departments, status: status, showPrematureItems: showPrematureItems, kitchenDepartments: kitchenDepartments };
	};
	
	var save = exports.save = function save() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$forms$stationO = state.forms.stationOverview,
	        initialValues = _state$forms$stationO.initialValues,
	        name = _state$forms$stationO.name,
	        need_aggregation = _state$forms$stationO.need_aggregation,
	        aggregation_minutes = _state$forms$stationO.aggregation_minutes,
	        station_priorities = _state$forms$stationO.station_priorities,
	        matchCriteria = _state$forms$stationO.matchCriteria;
	
	
	    var data = {};
	    data.name = name;
	    data.need_aggregation = need_aggregation;
	    data.aggregation_minutes = aggregation_minutes;
	    data.station_priorities_attributes = prioritiesDiff(initialValues.station_priorities, station_priorities);
	    data.station_departments_attributes = departmentDiff(initialValues.station_departments, matchCriteria);
	    data.station_kitchen_departments_attributes = departmentDiff(initialValues.station_kitchen_departments, matchCriteria, "kitchenDepartments", "kitchen_department_id", "station_kitchen_department_statuses_attributes", "station_kitchen_department_statuses");
	
	    dispatch({ type: SUBMIT_STATION_OVERVIEW_REQUEST });
	    dispatch((0, _kdsActions.updateStation)(data, initialValues.id, initialValues.store_id)).then(function (result) {
	      var data = result.data,
	          error = result.error;
	
	      if (!error) {
	        var station = data.station;
	
	        dispatch({ type: SUBMIT_STATION_OVERVIEW_SUCCESS, station: station });
	        alert('Update station successfully.');
	      } else {
	        dispatch({ type: SUBMIT_STATION_OVERVIEW_FAILURE });
	        alert('Update station failed.');
	      }
	    });
	  };
	};
	
	function prioritiesDiff(prev, next) {
	  var prevPriority = {};
	  var newPriority = [];
	  prev.forEach(function (d) {
	    var id = d.id;
	
	    prevPriority[id] = d;
	  });
	
	  next.forEach(function (p) {
	    if (prevPriority[p.id]) {
	      prevPriority[p.id] = Object.assign({}, prevPriority[p.id], p);
	    } else {
	      newPriority.push({
	        // id: p.id,
	        id: "",
	        name: p.name,
	        minutes: p.minutes,
	        color: p.color
	      });
	    }
	  });
	
	  var nextPriorityIDs = next.map(function (d) {
	    return d.id;
	  }).filter(function (d) {
	    return d != false;
	  });
	  var removePriorityIDs = Object.keys(prevPriority).filter(function (i) {
	    return nextPriorityIDs.indexOf(parseInt(i)) === -1;
	  });
	  if (removePriorityIDs.length) {
	    removePriorityIDs.forEach(function (i) {
	      return prevPriority[i]['_destroy'] = true;
	    });
	  }
	
	  return Object.keys(prevPriority).map(function (id) {
	    return prevPriority[id];
	  }).concat(newPriority);
	}
	
	function departmentDiff(prev, groups) {
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "departments";
	  var idKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "department_id";
	  var statusKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "station_department_statuses_attributes";
	  var statusesKey = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "station_department_statuses";
	
	
	  var out = [];
	
	  groups.forEach(function (match) {
	    var prevDepartment = {};
	    prev.forEach(function (d) {
	      if (match.match_group_number === d.match_group_number) prevDepartment[d[idKey]] = d;
	    });
	    var newDepartment = {};
	
	    var status = match.status;
	
	    var departments = match[key];
	
	    departments.forEach(function (d) {
	      var id = d[idKey];
	      if (prevDepartment[id]) {
	        var _prevDepartment$id;
	
	        prevDepartment[id] = (_prevDepartment$id = {
	          id: prevDepartment[id].id
	        }, _defineProperty(_prevDepartment$id, idKey, id), _defineProperty(_prevDepartment$id, 'match_group_number', match.match_group_number), _defineProperty(_prevDepartment$id, 'show_premature_items', match.show_premature_items), _defineProperty(_prevDepartment$id, statusKey, statusDiff(prevDepartment[id][statusesKey] || [], status)), _prevDepartment$id);
	      } else {
	        var _newDepartment$id;
	
	        newDepartment[id] = (_newDepartment$id = {
	          id: ''
	        }, _defineProperty(_newDepartment$id, idKey, id), _defineProperty(_newDepartment$id, 'match_group_number', match.match_group_number), _defineProperty(_newDepartment$id, 'show_premature_items', match.show_premature_items), _defineProperty(_newDepartment$id, statusKey, statusDiff([], status)), _newDepartment$id);
	      }
	    });
	
	    var nextDepartmentIDs = departments.map(function (d) {
	      return d[idKey];
	    }).filter(function (d) {
	      return d != false;
	    });
	    var removeDepartmentIDs = Object.keys(prevDepartment).filter(function (i) {
	      return nextDepartmentIDs.indexOf(parseInt(i)) === -1;
	    });
	    if (removeDepartmentIDs.length) {
	      removeDepartmentIDs.forEach(function (i) {
	        return prevDepartment[i]['_destroy'] = true;
	      });
	    }
	
	    out = out.concat(Object.keys(prevDepartment).map(function (id) {
	      return prevDepartment[id];
	    }));
	    out = out.concat(Object.keys(newDepartment).map(function (id) {
	      return newDepartment[id];
	    }));
	  });
	
	  return out;
	}
	
	function statusDiff(prev, next) {
	  var prevStatus = {};
	  var newStatus = [];
	  prev.forEach(function (d) {
	    return prevStatus[d.line_item_status_id] = d;
	  });
	
	  next.forEach(function (status) {
	    if (!prevStatus[status.line_item_status_id]) {
	      newStatus.push({ id: '', line_item_status_id: status.line_item_status_id });
	    }
	  });
	
	  var nextStatusIDs = next.map(function (d) {
	    return d.line_item_status_id;
	  }).filter(function (d) {
	    return d != false;
	  });
	  var removeStatusIDs = Object.keys(prevStatus).filter(function (i) {
	    return nextStatusIDs.indexOf(parseInt(i)) === -1;
	  });
	  if (removeStatusIDs.length) {
	    removeStatusIDs.forEach(function (i) {
	      return prevStatus[i]['_destroy'] = true;
	    });
	  }
	
	  return Object.keys(prevStatus).map(function (id) {
	    return prevStatus[id];
	  }).concat(newStatus);
	}

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.remove = exports.update = exports.create = exports.getGroup = exports.getGroups = exports.REMOVE_UOM_GROUP_FAILURE = exports.REMOVE_UOM_GROUP_SUCCESS = exports.REMOVE_UOM_GROUP_REQUEST = exports.UPDATE_UOM_GROUP_FAILURE = exports.UPDATE_UOM_GROUP_SUCCESS = exports.UPDATE_UOM_GROUP_REQUEST = exports.GET_UOM_GROUPS_FAILURE = exports.GET_UOM_GROUPS_SUCCESS = exports.GET_UOM_GROUPS_REQUEST = exports.GET_UOM_GROUP_FAILURE = exports.GET_UOM_GROUP_SUCCESS = exports.GET_UOM_GROUP_REQUEST = exports.CREATE_UOM_GROUP_FAILURE = exports.CREATE_UOM_GROUP_SUCCESS = exports.CREATE_UOM_GROUP_REQUEST = undefined;
	
	var _humps = __webpack_require__(44);
	
	var _uomGroupService = __webpack_require__(970);
	
	var _uomGroupService2 = _interopRequireDefault(_uomGroupService);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CREATE_UOM_GROUP_REQUEST = exports.CREATE_UOM_GROUP_REQUEST = 'CREATE_UOM_GROUP_REQUEST';
	var CREATE_UOM_GROUP_SUCCESS = exports.CREATE_UOM_GROUP_SUCCESS = 'CREATE_UOM_GROUP_SUCCESS';
	var CREATE_UOM_GROUP_FAILURE = exports.CREATE_UOM_GROUP_FAILURE = 'CREATE_UOM_GROUP_FAILURE';
	var GET_UOM_GROUP_REQUEST = exports.GET_UOM_GROUP_REQUEST = 'GET_UOM_GROUP_REQUEST';
	var GET_UOM_GROUP_SUCCESS = exports.GET_UOM_GROUP_SUCCESS = 'GET_UOM_GROUP_SUCCESS';
	var GET_UOM_GROUP_FAILURE = exports.GET_UOM_GROUP_FAILURE = 'GET_UOM_GROUP_FAILURE';
	var GET_UOM_GROUPS_REQUEST = exports.GET_UOM_GROUPS_REQUEST = 'GET_UOM_GROUPS_REQUEST';
	var GET_UOM_GROUPS_SUCCESS = exports.GET_UOM_GROUPS_SUCCESS = 'GET_UOM_GROUPS_SUCCESS';
	var GET_UOM_GROUPS_FAILURE = exports.GET_UOM_GROUPS_FAILURE = 'GET_UOM_GROUPS_FAILURE';
	var UPDATE_UOM_GROUP_REQUEST = exports.UPDATE_UOM_GROUP_REQUEST = 'UPDATE_UOM_GROUP_REQUEST';
	var UPDATE_UOM_GROUP_SUCCESS = exports.UPDATE_UOM_GROUP_SUCCESS = 'UPDATE_UOM_GROUP_SUCCESS';
	var UPDATE_UOM_GROUP_FAILURE = exports.UPDATE_UOM_GROUP_FAILURE = 'UPDATE_UOM_GROUP_FAILURE';
	var REMOVE_UOM_GROUP_REQUEST = exports.REMOVE_UOM_GROUP_REQUEST = 'REMOVE_UOM_GROUP_REQUEST';
	var REMOVE_UOM_GROUP_SUCCESS = exports.REMOVE_UOM_GROUP_SUCCESS = 'REMOVE_UOM_GROUP_SUCCESS';
	var REMOVE_UOM_GROUP_FAILURE = exports.REMOVE_UOM_GROUP_FAILURE = 'REMOVE_UOM_GROUP_FAILURE';
	
	var getGroups = exports.getGroups = function getGroups(storeId) {
	  return function (dispatch) {
	    dispatch({ type: GET_UOM_GROUPS_REQUEST });
	    return _uomGroupService2.default.getGroups(storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.data.unitGroups;
	      if (data) {
	        var entities = {};
	        data.forEach(function (item) {
	          var id = item.id;
	
	          entities[id] = item;
	        });
	        dispatch({ type: GET_UOM_GROUPS_SUCCESS, data: data });
	        dispatch({ type: _entityActions.SET_ENTITIES, collection: 'uomGroups', data: entities });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: GET_UOM_GROUPS_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: GET_UOM_GROUPS_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var getGroup = exports.getGroup = function getGroup(storeId, id) {
	  return function (dispatch) {
	    dispatch({ type: GET_UOM_GROUP_REQUEST });
	    return _uomGroupService2.default.getGroup(storeId, id).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.unitGroup;
	      if (data) {
	        dispatch({ type: GET_UOM_GROUP_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: GET_UOM_GROUP_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: GET_UOM_GROUP_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var create = exports.create = function create(data, storeId) {
	  return function (dispatch) {
	    dispatch({ type: CREATE_UOM_GROUP_REQUEST });
	    return _uomGroupService2.default.create((0, _humps.decamelizeKeys)(data), storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.unitGroup;
	      if (data) {
	        dispatch({ type: CREATE_UOM_GROUP_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: CREATE_UOM_GROUP_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: CREATE_UOM_GROUP_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var update = exports.update = function update(data, id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: UPDATE_UOM_GROUP_REQUEST });
	    return _uomGroupService2.default.update((0, _humps.decamelizeKeys)(data), id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.unitGroup;
	      if (data) {
	        dispatch({ type: UPDATE_UOM_GROUP_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: UPDATE_UOM_GROUP_FAILURE, error: error });
	      }
	    }).catch(function (error) {
	      dispatch({ type: UPDATE_UOM_GROUP_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var remove = exports.remove = function remove(id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: REMOVE_UOM_GROUP_REQUEST });
	    return _uomGroupService2.default.remove(id, storeId).then(function (resp) {
	      var message = resp.message;
	
	      if (message === 'success') {
	        dispatch({ type: REMOVE_UOM_GROUP_SUCCESS });
	        dispatch({ type: _entityActions.REMOVE_ENTITY, collection: 'uomGroups', id: id });
	        return {};
	      } else {
	        var error = new Error(message);
	        dispatch({ type: REMOVE_UOM_GROUP_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: REMOVE_UOM_GROUP_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeWorkflow = exports.updateWorkflow = exports.getWorkflow = exports.getWorkflows = exports.createWorkflow = undefined;
	
	var _workflowService = __webpack_require__(498);
	
	var _workflowService2 = _interopRequireDefault(_workflowService);
	
	var _baseActions = __webpack_require__(34);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createWorkflow = exports.createWorkflow = function createWorkflow(workflow, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _workflowService2.default.createWorkflow(workflow, storeId).then(function (resp) {
	      var workflow = resp.workflow,
	          message = resp.message;
	
	      if (workflow) {
	        var id = workflow.id;
	
	        dispatch({ type: _entityActions.ADD_ENTITY, collection: 'workflows', id: id, data: workflow });
	        dispatch((0, _baseActions.stopFetch)());
	        return { workflow: workflow };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	};
	
	var getWorkflows = exports.getWorkflows = function getWorkflows(storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _workflowService2.default.getWorkflows(storeId).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	      var data = resp.data,
	          message = resp.message;
	      var workflows = data.workflows;
	
	      if (workflows) {
	        var entities = {};
	        workflows.forEach(function (s) {
	          var id = s.id;
	
	          entities[id] = s;
	        });
	
	        dispatch({ type: _entityActions.SET_ENTITIES, collection: 'workflows', data: entities });
	        return { workflows: workflows };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	};
	
	var getWorkflow = exports.getWorkflow = function getWorkflow(id, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _workflowService2.default.getWorkflow(id, storeId).then(function (resp) {
	      var workflow = resp.workflow,
	          message = resp.message;
	
	      if (workflow) {
	        var _id = workflow.id;
	
	        dispatch({ type: _entityActions.ADD_ENTITY, collection: 'workflows', id: _id, data: workflow });
	        dispatch((0, _baseActions.stopFetch)());
	        return { workflow: workflow };
	      }
	      if (message) {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	      return { error: e };
	    });
	  };
	};
	
	var updateWorkflow = exports.updateWorkflow = function updateWorkflow(id, workflow, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _workflowService2.default.updateWorkflow(id, workflow, storeId).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var workflow = resp.workflow;
	
	      if (workflow) {
	        dispatch({ type: _entityActions.UPDATE_ENTITY, collection: 'workflows', id: id, workflow: workflow });
	        return { workflow: workflow };
	      } else {
	        return { error: new Error() };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      return { error: e };
	    });
	  };
	};
	
	var removeWorkflow = exports.removeWorkflow = function removeWorkflow(id, storeId) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _workflowService2.default.removeWorkflow(id, storeId).then(function (resp) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      var message = resp.message;
	
	      if (message === 'success') {
	        dispatch({ type: _entityActions.REMOVE_ENTITY, collection: 'workflows', id: id });
	      } else {
	        return { error: new Error(message) };
	      }
	    }).catch(function (e) {
	      dispatch((0, _baseActions.stopFetch)());
	
	      return { error: e };
	    });
	  };
	};

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Alert(props) {
	  var style = props.style,
	      children = props.children;
	
	  var className = 'alert alert-' + style;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    children
	  );
	}
	
	Alert.propTypes = {
	  style: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger']),
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Alert;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DateDisplay(props, context) {
	    var value = props.value,
	        formField = props.formField,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        style = props.style;
	
	    var compClassName = (formField ? 'form-control' : '') + ' ' + className;
	    var timezone = props.timezone ? props.timezone : context.currentStore && context.currentStore.timezone;
	    var dateString = value ? (0, _formatHelper.date)(value, timezone) : '\xA0';
	
	    return _react2.default.createElement(
	        'span',
	        { className: compClassName, style: style, readOnly: formField },
	        dateString
	    );
	}
	
	DateDisplay.contextTypes = {
	    currentStore: _propTypes2.default.object.isRequired
	};
	
	DateDisplay.propTypes = {
	    value: _propTypes2.default.string,
	    timezone: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    formField: _propTypes2.default.bool
	};
	
	exports.default = DateDisplay;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridPagination = exports.GridRowsPerPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2, _class3, _temp3;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultRowCounts = [25, 50, 100, 200];
	
	var GridRowsPerPage = exports.GridRowsPerPage = (_temp = _class = function (_Component) {
	  _inherits(GridRowsPerPage, _Component);
	
	  function GridRowsPerPage() {
	    _classCallCheck(this, GridRowsPerPage);
	
	    return _possibleConstructorReturn(this, (GridRowsPerPage.__proto__ || Object.getPrototypeOf(GridRowsPerPage)).apply(this, arguments));
	  }
	
	  _createClass(GridRowsPerPage, [{
	    key: 'renderSwitch',
	    value: function renderSwitch() {
	      var _props = this.props,
	          totalEntries = _props.totalEntries,
	          disableAll = _props.disableAll,
	          rowsPerPage = _props.rowsPerPage,
	          updateRowsPerPage = _props.updateRowsPerPage,
	          returnAll = _props.returnAll;
	
	
	      var switches = defaultRowCounts.map(function (number, i) {
	        var showLink = returnAll || rowsPerPage !== number;
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'row-count__switch',
	            key: '' + number },
	          showLink && _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return updateRowsPerPage(number);
	              } },
	            number
	          ),
	          !showLink && _react2.default.createElement(
	            'span',
	            null,
	            number
	          ),
	          i !== defaultRowCounts.length - 1 && ' / '
	        );
	      });
	      if (!disableAll) {
	        var allSwitch = _react2.default.createElement(
	          'span',
	          { className: 'row-count__switch',
	            key: 'all' },
	          ' / ',
	          !returnAll && _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return updateRowsPerPage(totalEntries);
	              } },
	            'All'
	          ),
	          returnAll && _react2.default.createElement(
	            'span',
	            null,
	            'All'
	          )
	        );
	        switches.push(allSwitch);
	      }
	
	      return switches;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          totalEntries = _props2.totalEntries,
	          currentPage = _props2.currentPage,
	          rowsPerPage = _props2.rowsPerPage,
	          returnAll = _props2.returnAll;
	
	
	      var gridIsEmpty = totalEntries < 1;
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid__row-count' },
	        returnAll && _react2.default.createElement(
	          'span',
	          null,
	          'Showing ' + (gridIsEmpty ? 0 : 1) + '-' + totalEntries + ' of ' + totalEntries + ' results.'
	        ),
	        !returnAll && _react2.default.createElement(
	          'span',
	          null,
	          'Showing ' + (gridIsEmpty ? 0 : (currentPage - 1) * rowsPerPage + 1) + '-' + Math.min(currentPage * rowsPerPage, totalEntries) + ' of ' + totalEntries + ' results.'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Show ',
	          this.renderSwitch()
	        )
	      );
	    }
	  }]);
	
	  return GridRowsPerPage;
	}(_react.Component), _class.propTypes = {
	  disableAll: _propTypes2.default.bool,
	  returnAll: _propTypes2.default.bool,
	  totalEntries: _propTypes2.default.number.isRequired,
	  rowsPerPage: _propTypes2.default.number.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  updateRowsPerPage: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	  disableAll: true,
	  returnAll: false
	}, _temp);
	var GridPagination = exports.GridPagination = (_temp2 = _class2 = function (_Component2) {
	  _inherits(GridPagination, _Component2);
	
	  function GridPagination() {
	    _classCallCheck(this, GridPagination);
	
	    return _possibleConstructorReturn(this, (GridPagination.__proto__ || Object.getPrototypeOf(GridPagination)).apply(this, arguments));
	  }
	
	  _createClass(GridPagination, [{
	    key: 'renderLinks',
	    value: function renderLinks() {
	      var _props3 = this.props,
	          paginationLinks = _props3.paginationLinks,
	          goToPage = _props3.goToPage,
	          currentPage = _props3.currentPage;
	
	
	      return paginationLinks.map(function (number, i) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'pagination__link',
	            key: number },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return goToPage(number);
	              },
	              className: (0, _classnames2.default)({ _current: number === currentPage }) },
	            number
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          currentPage = _props4.currentPage,
	          totalPages = _props4.totalPages,
	          goToPage = _props4.goToPage;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid__pagination' },
	        currentPage !== 1 && _react2.default.createElement(
	          'span',
	          { className: 'pagination__link' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return goToPage(1);
	              } },
	            '\xAB'
	          )
	        ),
	        currentPage !== 1 && _react2.default.createElement(
	          'span',
	          { className: 'pagination__link' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return goToPage(currentPage - 1);
	              } },
	            '\u2039'
	          )
	        ),
	        this.renderLinks(),
	        currentPage !== totalPages && _react2.default.createElement(
	          'span',
	          { className: 'pagination__link' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return goToPage(currentPage + 1);
	              } },
	            '\u203A'
	          )
	        ),
	        currentPage !== totalPages && _react2.default.createElement(
	          'span',
	          { className: 'pagination__link' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return goToPage(totalPages);
	              } },
	            '\xBB'
	          )
	        )
	      );
	    }
	  }]);
	
	  return GridPagination;
	}(_react.Component), _class2.propTypes = {
	  currentPage: _propTypes2.default.number.isRequired,
	  totalPages: _propTypes2.default.number.isRequired,
	  goToPage: _propTypes2.default.func.isRequired,
	  paginationLinks: _propTypes2.default.array.isRequired
	}, _temp2);
	
	
	function paginationLinks(currentPage, totalPages) {
	  var min = void 0;
	  var max = void 0;
	  var links = [];
	
	  if (currentPage > 4) {
	    max = Math.min(totalPages, currentPage + 5);
	    min = Math.max(1, max - 9);
	  } else {
	    min = 1;
	    max = Math.min(totalPages, 10);
	  }
	
	  for (var i = min; i < max + 1; i++) {
	    links.push(i);
	  }
	
	  return links;
	}
	
	var GirdFooter = (_temp3 = _class3 = function (_Component3) {
	  _inherits(GirdFooter, _Component3);
	
	  function GirdFooter() {
	    _classCallCheck(this, GirdFooter);
	
	    return _possibleConstructorReturn(this, (GirdFooter.__proto__ || Object.getPrototypeOf(GirdFooter)).apply(this, arguments));
	  }
	
	  _createClass(GirdFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          totalEntries = _props5.totalEntries,
	          rowsPerPage = _props5.rowsPerPage,
	          currentPage = _props5.currentPage,
	          totalPages = _props5.totalPages,
	          goToPage = _props5.goToPage,
	          updateRowsPerPage = _props5.updateRowsPerPage,
	          hidePaginate = _props5.hidePaginate,
	          hideRowPerPage = _props5.hideRowPerPage;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid__footer' },
	        hidePaginate ? null : _react2.default.createElement(GridPagination, { currentPage: currentPage,
	          totalPages: totalPages,
	          goToPage: goToPage,
	          paginationLinks: paginationLinks(currentPage, totalPages) }),
	        hideRowPerPage ? null : _react2.default.createElement(GridRowsPerPage, { currentPage: currentPage,
	          totalEntries: totalEntries,
	          rowsPerPage: rowsPerPage,
	          updateRowsPerPage: updateRowsPerPage })
	      );
	    }
	  }]);
	
	  return GirdFooter;
	}(_react.Component), _class3.propTypes = {
	  totalEntries: _propTypes2.default.number,
	  rowsPerPage: _propTypes2.default.number,
	  currentPage: _propTypes2.default.number,
	  totalPages: _propTypes2.default.number,
	  goToPage: _propTypes2.default.func,
	  updateRowsPerPage: _propTypes2.default.func,
	  hidePaginate: _propTypes2.default.bool,
	  hideRowPerPage: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  rowsPerPage: 25
	}, _temp3);
	exports.default = GirdFooter;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sortAndTreeDepartment = undefined;
	
	var _cloneDeep = __webpack_require__(279);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _sortBy = __webpack_require__(1576);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// copied from old dashboard and need to rewrite to known what it is doing
	
	/**
	 * Seems Verbose but there seems to be no other way to sort this data
	 */
	function TreeNode(data) {
	    this.data = data;
	    this.parent = null;
	    this.children = [];
	}
	
	TreeNode.prototype.walk = function (f, recursive) {
	    for (var i = 0, l = this.children.length; i < l; i++) {
	        var child = this.children[i];
	        f.apply(child, Array.prototype.slice.call(arguments, 2));
	        if (recursive) {
	            child.walk.apply(child, arguments);
	        }
	    }
	};
	
	function toTree(data) {
	    var parent = new TreeNode(),
	        i = 0,
	        l = data.length,
	        node = void 0;
	    var nodeById = {};
	    for (i = 0; i < l; i++) {
	        var newNode = new TreeNode(data[i]);
	        nodeById[data[i].id] = newNode;
	        if (data[i].parent_id === null) {
	            parent.children.push(newNode);
	            newNode.parent = parent;
	        }
	    }
	    for (i = 0; i < l; i++) {
	        node = nodeById[data[i].id];
	        if (node.data.parent_id && nodeById[node.data.parent_id]) {
	            node.parent = nodeById[node.data.parent_id];
	            node.parent.children.push(node);
	        }
	    }
	    return parent;
	}
	var htmlDecode = function htmlDecode(input) {
	    var e = document.createElement('div');
	    e.innerHTML = input;
	    return e.childNodes[0].nodeValue;
	};
	
	var sortAndTreeDepartment = function sortAndTreeDepartment(departments) {
	    var departmentsSorted = (0, _cloneDeep2.default)(departments);
	
	    // Sorting
	    departmentsSorted = (0, _sortBy2.default)(departmentsSorted, 'name');
	
	    // Treenoding the department array
	    var departmentsTree = toTree(departmentsSorted);
	    var departmentsTreeSort = [];
	
	    // Formatting the Display Values
	    departmentsTree.walk(function () {
	        this.data.display = '';
	        this.data.stackdisplay = null;
	        var current = this;
	        do {
	
	            if (current) {
	                if (!this.data.stackdisplay) {
	                    this.data.stackdisplay = current.data.name;
	                } else {
	                    this.data.stackdisplay = current.data.name + '->' + this.data.stackdisplay;
	                }
	            }
	
	            current = current.parent;
	        } while (current.parent !== null);
	
	        for (var i = 0; i < this.data.depth; i++) {
	            this.data.display += '——';
	        }
	        this.data.display += this.data.name;
	        this.data.display = htmlDecode(this.data.display);
	        departmentsTreeSort.push(this.data);
	    }, true);
	    return departmentsTreeSort;
	};
	
	exports.sortAndTreeDepartment = sortAndTreeDepartment;

/***/ },
/* 317 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_STATE = exports.DEFAULT_STATE = {
	  deliveryOrder: 'created',
	  order: 'created',
	  inventoryVariance: 'new'
	};
	
	var deliveryOrderLabel = exports.deliveryOrderLabel = function deliveryOrderLabel(status) {
	  return {
	    created: 'Created',
	    pending: 'Pending',
	    sent: 'Delivered',
	    partially_sent: 'Partially Delivered',
	    canceled: 'Cancelled'
	  }[status];
	};
	
	var orderColor = exports.orderColor = function orderColor(state) {
	  var colorMap = {
	    'created': '#ffc91e',
	    'approved': '#8cd678',
	    'fulfilled': '#49bbeb',
	    'canceled': '#aaaaaa',
	    'fulfilling': '#ff7700'
	  };
	  return colorMap[state];
	};
	
	var orderLabel = exports.orderLabel = function orderLabel(state) {
	  var labelMap = {
	    'created': 'Created',
	    'approved': 'Approved',
	    'fulfilled': 'Finished',
	    'canceled': 'Cancalled',
	    'fulfilling': 'Processing'
	  };
	  return labelMap[state];
	};
	
	var inventoryVarianceLabel = exports.inventoryVarianceLabel = function inventoryVarianceLabel(state) {
	  var labelMap = {
	    submitting: 'Submitting',
	    pending_for_approval: 'Pending For Approval',
	    processing: 'Processing',
	    opened: 'Open',
	    completed: 'Completed',
	    voided: 'Voided',
	    new: 'New'
	  };
	  return labelMap[state] || labelMap[DEFAULT_STATE.inventoryVariance];
	};
	
	var inventoryVarianceColor = exports.inventoryVarianceColor = function inventoryVarianceColor(state) {
	  var colorMap = {
	    submitting: '#ca5ce0',
	    pending_for_approval: '#ff7d09',
	    processing: '#3cd5e8',
	    opened: '#ffc91e',
	    completed: '#8cd678',
	    voided: '#d0d0d0',
	    new: ''
	  };
	  return colorMap[state] || colorMap[DEFAULT_STATE.inventoryVariance];
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = typeToPermission;
	
	var _permissionHelper = __webpack_require__(92);
	
	function typeToPermission(type, operation, store) {
	    var typeNumber = Number(type);
	    switch (typeNumber) {
	        case 1:
	            return (0, _permissionHelper.permissionAccessor)('inventory_variance_opening:' + operation, store);
	        case 2:
	            return (0, _permissionHelper.permissionAccessor)('inventory_variance_adjust_by_qty:' + operation, store);
	        case 3:
	            return (0, _permissionHelper.permissionAccessor)('inventory_variance_adjust_by_variance:' + operation, store);
	        case 4:
	            return (0, _permissionHelper.permissionAccessor)('inventory_variance_cost_adjustment:' + operation, store);
	    }
	}

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _status = __webpack_require__(233);
	
	var _status2 = _interopRequireDefault(_status);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexStatus(props) {
	    var data = props.data;
	
	    var state = data || 'created';
	    return _react2.default.createElement(_status2.default, { state: data || 'created', label: IndexStatus.STATUS_FOR_DISPLAY[state] });
	}
	
	IndexStatus.propTypes = {
	    data: _propTypes2.default.string
	};
	
	IndexStatus.STATUS_FOR_DISPLAY = {
	    created: 'Created',
	    pending: 'Pending',
	    sent: 'Delivered',
	    partially_sent: 'Partially Delivered',
	    canceled: 'Cancelled'
	};
	
	exports.default = IndexStatus;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = exports.REVENUE = exports.EXPIRATION_TYPE = exports.perDaySecons = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _validate = __webpack_require__(220);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _dayCalculator = __webpack_require__(936);
	
	var _dayCalculator2 = _interopRequireDefault(_dayCalculator);
	
	var _removeButton = __webpack_require__(476);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var perDaySecons = exports.perDaySecons = 86400;
	
	var EXPIRATION_TYPE = exports.EXPIRATION_TYPE = {
	  DATE: 'date',
	  NEVER: 'never',
	  DURATION: 'duration'
	};
	
	var REVENUE = exports.REVENUE = {
	  SALES: 0,
	  REDEMPTION: 1
	};
	
	var fields = exports.fields = ['name', 'notes', 'amount', 'price', 'revenue_recognition', 'expiration_type', 'expiration_date', 'expiration_duration', 'date_ranges[].start_from', 'date_ranges[].end_at'];
	
	function validator(values) {
	  var constraints = {
	    name: { presence: true },
	    amount: { presence: true },
	    price: { presence: true },
	    date_ranges: { //validate.js not work well with array
	      length: {
	        minimum: 0,
	        maximum: 999
	      }
	    }
	  };
	  return (0, _validate2.default)(values, constraints) || {};
	}
	
	var VoucherOverviewForm = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherOverviewForm, _Component);
	
	  function VoucherOverviewForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherOverviewForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherOverviewForm.__proto__ || Object.getPrototypeOf(VoucherOverviewForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showDayCalculator: false
	    }, _this.toogleDayCalculator = function () {
	      _this.setState({
	        showDayCalculator: !_this.state.showDayCalculator
	      });
	    }, _this.setExpirationDay = function (data) {
	      var days = (0, _dayCalculator.sumDays)(data.day, data.week, data.month, data.year);
	      _this.props.fields.expiration_duration.onChange(days);
	
	      _this.setState({
	        showDayCalculator: false
	      });
	    }, _this.submitSetExpirationDay = function () {
	      _this.refs.DayCalForm.submit();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherOverviewForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          voucherId = _props.voucherId,
	          _props$fields = _props.fields,
	          name = _props$fields.name,
	          notes = _props$fields.notes,
	          price = _props$fields.price,
	          amount = _props$fields.amount,
	          revenue_recognition = _props$fields.revenue_recognition,
	          expiration_type = _props$fields.expiration_type,
	          expiration_date = _props$fields.expiration_date,
	          expiration_duration = _props$fields.expiration_duration,
	          date_ranges = _props$fields.date_ranges,
	          handleSubmit = _props.handleSubmit;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'voucher-overview-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { state: name },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'TITLE'
	                ),
	                _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, name))
	              )
	            ),
	            voucherId ? _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { label: 'VOUCHER TYPE ID' },
	                _react2.default.createElement('input', { type: 'text', className: 'form-control', value: voucherId, disabled: true })
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { label: 'Description', state: notes },
	                _react2.default.createElement('textarea', _extends({ className: 'form-control', rows: 4 }, notes))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { state: amount },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'FACE VALUE'
	                ),
	                _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, amount))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { state: price },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'PRICE'
	                ),
	                _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, price))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { state: revenue_recognition },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'REVENUE RECOGNITION'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata-value' },
	                  _react2.default.createElement(
	                    'select',
	                    _extends({ className: 'form-control' }, revenue_recognition),
	                    _react2.default.createElement(
	                      'option',
	                      { key: '0', value: REVENUE.SALES },
	                      'Sales'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { key: '1', value: REVENUE.REDEMPTION },
	                      'Redemption'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6' },
	              _react2.default.createElement(
	                _formGroup2.default,
	                { state: expiration_type },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'EXPIRATION DATE'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  _extends({ defaultValue: EXPIRATION_TYPE.NEVER, className: 'form-control _expiration_select' }, expiration_type),
	                  _react2.default.createElement(
	                    'option',
	                    { key: '0', value: EXPIRATION_TYPE.NEVER },
	                    'Never'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { key: '1', value: EXPIRATION_TYPE.DATE },
	                    'Specific Date'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { key: '2', value: EXPIRATION_TYPE.DURATION },
	                    'Days From Activation'
	                  )
	                ),
	                expiration_type.value === EXPIRATION_TYPE.DATE ? _react2.default.createElement('input', _extends({ type: 'date', className: 'form-control' }, expiration_date)) : null,
	                expiration_type.value === EXPIRATION_TYPE.DURATION ? _react2.default.createElement(
	                  'div',
	                  { className: 'input-group' },
	                  _react2.default.createElement('input', _extends({ ref: 'expiration_date', type: 'text', className: 'form-control col-md-3', placeholder: 'ENTER DAYS' }, expiration_duration)),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'input-group-addon' },
	                    'Days \xA0\xA0',
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'small a', onClick: this.toogleDayCalculator },
	                      'calculator...'
	                    )
	                  )
	                ) : null
	              ),
	              _react2.default.createElement(
	                _reactModal2.default,
	                { className: 'ReactModal__Content', isOpen: this.state.showDayCalculator, onRequestClose: this.toogleDayCalculator },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal-dialog' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'modal-content' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'modal-header' },
	                      _react2.default.createElement(
	                        'h4',
	                        { className: 'modal-title' },
	                        'Expiration Days Calculator'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'modal-body' },
	                      _react2.default.createElement(_dayCalculator2.default, { ref: 'DayCalForm', onSubmit: this.setExpirationDay })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'modal-footer' },
	                      _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-secondary', onClick: this.toogleDayCalculator },
	                        'Cancel'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary', onClick: this.submitSetExpirationDay },
	                        'Set Expiration Days'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Blackout Date'
	          ),
	          date_ranges.map(function (range, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    '#',
	                    i + 1
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Start Date'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    _react2.default.createElement('input', _extends({ ref: 'blackout_start_date', type: 'date', className: 'form-control' }, range.start_from))
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'End Date'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    _react2.default.createElement('input', _extends({ ref: 'blackout_start_date', type: 'date', className: 'form-control' }, range.end_at))
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-1' },
	                  _react2.default.createElement(_removeButton2.default, { onClick: function onClick() {
	                      return date_ranges.removeField(i);
	                    } })
	                )
	              ),
	              _react2.default.createElement('br', null)
	            );
	          }),
	          _react2.default.createElement(
	            'a',
	            { className: '_add', onClick: function onClick() {
	                return date_ranges.addField({ start_from: '', end_at: '' });
	              } },
	            _react2.default.createElement('i', { className: 'fa fa-plus-circle' }),
	            ' ',
	            date_ranges.length ? 'Add Another Date Range' : 'Add Date Range'
	          )
	        )
	      );
	    }
	  }]);
	
	  return VoucherOverviewForm;
	}(_react.Component), _class.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  fields: _propTypes2.default.object.isRequired,
	  voucherId: _propTypes2.default.number
	}, _temp2);
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'voucherOverview',
	  fields: fields,
	  validate: validator
	})(VoucherOverviewForm);

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatUpdateVoucher = exports.formatVoucher = undefined;
	
	var _overviewForm = __webpack_require__(320);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var perDaySecons = 86400;
	
	function formatVoucher(voucher) {
	  var _REVENUE_RECOGNITION;
	
	  var REVENUE_RECOGNITION = (_REVENUE_RECOGNITION = {}, _defineProperty(_REVENUE_RECOGNITION, _overviewForm.REVENUE.REDEMPTION, "REDEMPTION"), _defineProperty(_REVENUE_RECOGNITION, _overviewForm.REVENUE.SALES, "SALES"), _REVENUE_RECOGNITION);
	
	  switch (voucher.expiration_setting.type) {
	    case _overviewForm.EXPIRATION_TYPE.DATE:
	      {
	        voucher.expiration_setting_text = 'Expire on ' + voucher.expiration_setting.value;
	
	        break;
	      }
	
	    case _overviewForm.EXPIRATION_TYPE.DURATION:
	      {
	        voucher.expiration_setting_text = 'Expire on ' + parseInt(voucher.expiration_setting.value) / perDaySecons + ' days after activation';
	
	        break;
	      }
	
	    case _overviewForm.EXPIRATION_TYPE.NEVER:
	      {
	        voucher.expiration_setting_text = 'Never Expires';
	
	        break;
	      }
	  }
	  voucher.revenue_recognition_text = REVENUE_RECOGNITION[voucher.revenue_recognition];
	
	  return voucher;
	}
	
	function formatUpdateVoucher(voucherData, store_id) {
	  var expiration_setting = {
	    "type": voucherData.expiration_type
	  };
	
	  if (voucherData.expiration_type === "date") {
	    expiration_setting.value = voucherData.expiration_date;
	  } else if (voucherData.expiration_type === "duration") {
	    expiration_setting.value = String(Number(voucherData.expiration_duration) * perDaySecons);
	  }
	
	  var date_ranges = voucherData.date_ranges.slice();
	  date_ranges.forEach(function (range) {
	    range.exclude = true;
	  });
	
	  var voucher = {
	    "store_id": store_id,
	    "name": voucherData.name,
	    "notes": voucherData.notes,
	    "price": voucherData.price,
	    "amount": voucherData.amount,
	    "revenue_recognition": voucherData.revenue_recognition,
	    "expiration_setting": expiration_setting,
	    "date_ranges": date_ranges
	  };
	
	  return voucher;
	}
	
	exports.formatVoucher = formatVoucher;
	exports.formatUpdateVoucher = formatUpdateVoucher;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getButtonShowConfig = exports.getReadOnlyConfig = exports.getDiscountDetail = exports.getItem = exports.getPathInfo = exports.getBreadcrumbTitle = exports.getPageTitle = exports.getPathState = exports.getErrMsg = exports.getPromoCodes = exports.getGridMeta = exports.getTotalPages = exports.getTotalEntries = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(301);
	
	var _lodash = __webpack_require__(14);
	
	var _constants = __webpack_require__(26);
	
	var getTotalEntries = exports.getTotalEntries = function getTotalEntries(state, props) {
	  return (0, _lodash.get)(state, 'promoCode.totalEntries', 0);
	};
	
	var getTotalPages = exports.getTotalPages = function getTotalPages(state, props) {
	  return (0, _lodash.get)(state, 'promoCode.totalPages', 0);
	};
	
	var getGridMeta = exports.getGridMeta = (0, _reselect.createSelector)([getTotalEntries, getTotalPages], function (totalEntries, totalPages) {
	  return { totalEntries: totalEntries, totalPages: totalPages };
	});
	
	var getPromoCodes = exports.getPromoCodes = function getPromoCodes(state) {
	  return (0, _lodash.get)(state, 'promoCode.promoCodes', []);
	};
	
	var getErrMsg = exports.getErrMsg = function getErrMsg(state) {
	  return (0, _lodash.get)(state, 'promoCode.errMsg');
	};
	
	var getPathState = exports.getPathState = function getPathState(state) {
	  return (0, _lodash.get)(state, 'promoCode', {});
	};
	
	var getPageTitle = exports.getPageTitle = (0, _reselect.createSelector)([getPathState], function (s) {
	  return s.mode === _constants.PROMO_CODE.MODE.NEW ? 'New Promotion Code' : 'Promotion Code #' + s.coupon.code;
	});
	
	var getBreadcrumbTitle = exports.getBreadcrumbTitle = (0, _reselect.createSelector)([getPathState], function (s) {
	  return s.mode === _constants.PROMO_CODE.MODE.NEW ? 'New Promotion Code' : s.coupon.code;
	});
	
	var getPathInfo = exports.getPathInfo = (0, _reselect.createSelector)([getPathState], function (s) {
	  return (0, _lodash.pick)(s, ['mode', 'storeId', 'promoCodeId', 'tab']);
	});
	
	var getItem = exports.getItem = (0, _reselect.createSelector)([getPathState], function (s) {
	  var discount = (0, _lodash.get)(s, 'discount', {});
	  var coupon = (0, _lodash.get)(s, 'coupon', {});
	  return _extends({
	    discount: discount
	  }, coupon);
	});
	
	var getDiscountDetail = exports.getDiscountDetail = (0, _reselect.createSelector)([getPathState], function (s) {
	  var discount = (0, _lodash.get)(s, 'discount', {});
	  var ret = (0, _lodash.pick)(discount, ['id', 'name', 'code', 'discountType', 'amount', 'percentage', 'startFrom', 'endAt']);
	  ret.discountTypeDisplay = ret.amoun > 0 ? 'Amount Off' : 'Percentage Off';
	  return ret;
	});
	
	var getReadOnlyConfig = exports.getReadOnlyConfig = (0, _reselect.createSelector)([getPathInfo], function (info) {
	  // const isView = info.mode === PROMO_CODE.MODE.VIEW;
	  var isNew = info.mode === _constants.PROMO_CODE.MODE.NEW;
	  // const isEdit = info.mode === PROMO_CODE.MODE.EDIT;
	  return {
	    code: !isNew,
	    discount: !isNew,
	    userQuota: false,
	    totalQuota: false,
	    usedQuota: true
	  };
	});
	
	var getButtonShowConfig = exports.getButtonShowConfig = (0, _reselect.createSelector)([getPathInfo], function (info) {
	  // const isOverview = info.tab === PROMO_CODE.TAB.OVERVIEW;
	  var isView = info.mode === _constants.PROMO_CODE.MODE.VIEW;
	  // const isNew = info.mode === PROMO_CODE.MODE.NEW;
	  // const isEdit = info.mode === PROMO_CODE.MODE.EDIT;
	  return {
	    edit: isView,
	    cancelEdit: !isView,
	    saveEdit: !isView
	  };
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvoiceService = function (_BindoService) {
	  _inherits(InvoiceService, _BindoService);
	
	  function InvoiceService() {
	    _classCallCheck(this, InvoiceService);
	
	    return _possibleConstructorReturn(this, (InvoiceService.__proto__ || Object.getPrototypeOf(InvoiceService)).apply(this, arguments));
	  }
	
	  _createClass(InvoiceService, [{
	    key: 'getItem',
	    value: function getItem(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number;
	      return this.get(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'createItem',
	    value: function createItem(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/invoices';
	      data.order.unit_enable = true;
	      return this.post(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(storeId, number, data) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number;
	      data.order.unit_enable = true;
	      return this.put(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'cancelItem',
	    value: function cancelItem(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number + '/void';
	      return this.post(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'returnMoney',
	    value: function returnMoney(storeId, number) {
	      var transactions_to_be_refunded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      var path = 'v2/stores/' + storeId + '/invoices/' + number + '/returns';
	      var data = {
	        return: { transactions_to_be_refunded: transactions_to_be_refunded }
	      };
	      return this.post(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'payMoney',
	    value: function payMoney(storeId, number, payment) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number + '/pay';
	      var data = {
	        order: { payment: payment }
	      };
	      return this.post(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'getItemHistory',
	    value: function getItemHistory(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/quotes_and_invoices/' + number + '/history';
	      return this.get(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'voidTransaction',
	    value: function voidTransaction(storeId, number, transactionId) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number + '/transactions/' + transactionId + '/void';
	      return this.put(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'exportPdf',
	    value: function exportPdf(storeId, number) {
	      var path = '/v2/stores/' + storeId + '/invoices/' + number + '/download';
	      var data = {
	        template_type: 'airprint_invoice'
	      };
	      return this.get(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'voidItem',
	    value: function voidItem(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/invoices/' + number + '/void';
	      return this.post(path, undefined, _config2.default.gateway);
	    }
	  }]);
	
	  return InvoiceService;
	}(_bindoService2.default);
	
	exports.default = new InvoiceService();

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function printerAssigned(printer, departmentId) {
	  var kitchen_department_ids = printer.details.send_to_kitchen.kitchen_department_ids;
	  // return kitchen_department_ids && kitchen_department_ids.includes(departmentId)
	
	  return kitchen_department_ids && kitchen_department_ids.indexOf(departmentId) >= 0;
	}
	
	var KitchenDepartmentService = function (_BindoService) {
	  _inherits(KitchenDepartmentService, _BindoService);
	
	  function KitchenDepartmentService() {
	    _classCallCheck(this, KitchenDepartmentService);
	
	    return _possibleConstructorReturn(this, (KitchenDepartmentService.__proto__ || Object.getPrototypeOf(KitchenDepartmentService)).apply(this, arguments));
	  }
	
	  _createClass(KitchenDepartmentService, [{
	    key: 'getAll',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(storeId) {
	        var kdPath, response;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                kdPath = 'v2/stores/' + storeId + '/kitchen_departments';
	                _context.next = 3;
	                return _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'get', this).call(this, kdPath, { per_page: 999999 });
	
	              case 3:
	                response = _context.sent;
	                return _context.abrupt('return', response.data.map(function (_ref2) {
	                  var kitchen_department = _ref2.kitchen_department;
	                  return kitchen_department;
	                }));
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getAll(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getAll;
	    }()
	  }, {
	    key: 'getPrinters',
	    value: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(storeId) {
	        var path, response;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/hardwares';
	                _context2.next = 3;
	                return _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'get', this).call(this, path, { hardware_type: 'receipt_printer' });
	
	              case 3:
	                response = _context2.sent;
	                return _context2.abrupt('return', response.hardwares);
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getPrinters(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getPrinters;
	    }()
	  }, {
	    key: 'getAllWithPrinter',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(storeId) {
	        var _ref5, _ref6, departments, printers;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return Promise.all([this.getAll(storeId), this.getPrinters(storeId)]);
	
	              case 2:
	                _ref5 = _context3.sent;
	                _ref6 = _slicedToArray(_ref5, 2);
	                departments = _ref6[0];
	                printers = _ref6[1];
	
	                departments = departments.map(function (kd) {
	                  kd.printers = printers.filter(function (printer) {
	                    return printerAssigned(printer, kd.id);
	                  });
	                  return kd;
	                });
	                return _context3.abrupt('return', {
	                  departments: departments,
	                  printers: printers
	                });
	
	              case 8:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getAllWithPrinter(_x3) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getAllWithPrinter;
	    }()
	  }, {
	    key: 'create',
	    value: function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(storeId, department) {
	        var path, res;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/kitchen_departments';
	                _context4.next = 3;
	                return _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'post', this).call(this, path, { kitchen_department: department });
	
	              case 3:
	                res = _context4.sent;
	                return _context4.abrupt('return', res.kitchen_department);
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function create(_x4, _x5) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return create;
	    }()
	  }, {
	    key: 'update',
	    value: function () {
	      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(storeId, department) {
	        var path;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/kitchen_departments/' + department.id;
	                _context5.next = 3;
	                return _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'put', this).call(this, path, { kitchen_department: department });
	
	              case 3:
	                return _context5.abrupt('return', _context5.sent);
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function update(_x6, _x7) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return update;
	    }()
	  }, {
	    key: 'assignPrinter',
	    value: function assignPrinter(storeId, department) {
	      var promises = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = department.printers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var printer = _step.value;
	
	          if (!printerAssigned(printer, department.id)) {
	            var path = 'v2/stores/' + storeId + '/hardwares/' + printer.id;
	            var send_to_kitchen = printer.details.send_to_kitchen;
	
	            if (!send_to_kitchen.kitchen_department_ids) {
	              send_to_kitchen.kitchen_department_ids = [];
	            }
	            send_to_kitchen.kitchen_department_ids.push(department.id);
	            var p = _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'put', this).call(this, path, { hardware: printer });
	            promises.push(p);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return Promise.all(promises);
	    }
	  }, {
	    key: 'delete',
	    value: function () {
	      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(storeId, departmentId) {
	        var path;
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/kitchen_departments/' + departmentId;
	                _context6.next = 3;
	                return _get(KitchenDepartmentService.prototype.__proto__ || Object.getPrototypeOf(KitchenDepartmentService.prototype), 'delete', this).call(this, path);
	
	              case 3:
	                return _context6.abrupt('return', _context6.sent);
	
	              case 4:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function _delete(_x8, _x9) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return _delete;
	    }()
	  }]);
	
	  return KitchenDepartmentService;
	}(_bindoService2.default);
	
	exports.default = new KitchenDepartmentService();

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var otherPaymentInstrumentService = function (_BindoService) {
	  _inherits(otherPaymentInstrumentService, _BindoService);
	
	  function otherPaymentInstrumentService() {
	    _classCallCheck(this, otherPaymentInstrumentService);
	
	    return _possibleConstructorReturn(this, (otherPaymentInstrumentService.__proto__ || Object.getPrototypeOf(otherPaymentInstrumentService)).apply(this, arguments));
	  }
	
	  _createClass(otherPaymentInstrumentService, [{
	    key: 'getAll',
	    value: function getAll(storeId) {
	      var path = 'v2/stores/' + storeId + '/other_payment_instruments';
	      return this.get(path, null, _config2.default.goGatewayApi);
	    }
	  }, {
	    key: 'updateAll',
	    value: function updateAll(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/other_payment_instruments/update_all';
	      return this.post(path, data, _config2.default.goGatewayApi);
	    }
	  }, {
	    key: 'modifyAll',
	    value: function modifyAll(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/other_payment_instruments/modify_all';
	      return this.post(path, data, _config2.default.goGatewayApi);
	    }
	  }, {
	    key: 'getAllWithDefalut',
	    value: function getAllWithDefalut(storeId) {
	      var path = 'v2/stores/' + storeId + '/other_payment_instruments';
	      return this.get(path, { all: 1 }, _config2.default.goGatewayApi);
	    }
	  }, {
	    key: 'modifyAllWithDefault',
	    value: function modifyAllWithDefault(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/other_payment_instruments/modify_all?all=1';
	      return this.post(path, data, _config2.default.goGatewayApi);
	    }
	  }]);
	
	  return otherPaymentInstrumentService;
	}(_bindoService2.default);
	
	exports.default = new otherPaymentInstrumentService();

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alertActions = __webpack_require__(90);
	
	var alertMiddleware = function alertMiddleware(store) {
	  return function (next) {
	    return function (action) {
	
	      var result = next(action);
	
	      setTimeout(function () {
	        next({
	          type: _alertActions.REMOVE_ALERT,
	          message: action.message
	        });
	      }, 3000);
	
	      return result;
	    };
	  };
	};
	
	exports.default = alertMiddleware;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(25);
	
	var _baseReducer = __webpack_require__(978);
	
	var _baseReducer2 = _interopRequireDefault(_baseReducer);
	
	var _alertReducer = __webpack_require__(977);
	
	var _alertReducer2 = _interopRequireDefault(_alertReducer);
	
	var _storeReducer = __webpack_require__(1010);
	
	var _storeReducer2 = _interopRequireDefault(_storeReducer);
	
	var _userReducer = __webpack_require__(1013);
	
	var _userReducer2 = _interopRequireDefault(_userReducer);
	
	var _pathReducer = __webpack_require__(1007);
	
	var _pathReducer2 = _interopRequireDefault(_pathReducer);
	
	var _listingReducer = __webpack_require__(1002);
	
	var _listingStatusReducer = __webpack_require__(1003);
	
	var _listingStatusReducer2 = _interopRequireDefault(_listingStatusReducer);
	
	var _entityReducer = __webpack_require__(982);
	
	var _entityReducer2 = _interopRequireDefault(_entityReducer);
	
	var _voucherReducer = __webpack_require__(1015);
	
	var _voucherReducer2 = _interopRequireDefault(_voucherReducer);
	
	var _voucherCouponReducer = __webpack_require__(1014);
	
	var _voucherCouponReducer2 = _interopRequireDefault(_voucherCouponReducer);
	
	var _kdsReducer = __webpack_require__(1000);
	
	var _kdsReducer2 = _interopRequireDefault(_kdsReducer);
	
	var _kdsStatusReducer = __webpack_require__(1001);
	
	var _kdsStatusReducer2 = _interopRequireDefault(_kdsStatusReducer);
	
	var _importerReducer = __webpack_require__(997);
	
	var _savedFiltersReducer = __webpack_require__(1009);
	
	var _savedFiltersReducer2 = _interopRequireDefault(_savedFiltersReducer);
	
	var _storeSuppliersReducer = __webpack_require__(1011);
	
	var _storeSuppliersReducer2 = _interopRequireDefault(_storeSuppliersReducer);
	
	var _deliveryOrderReducer = __webpack_require__(981);
	
	var _deliveryOrderReducer2 = _interopRequireDefault(_deliveryOrderReducer);
	
	var _inventoryVarianceReducer = __webpack_require__(998);
	
	var _inventoryVarianceReducer2 = _interopRequireDefault(_inventoryVarianceReducer);
	
	var _invoiceReducer = __webpack_require__(999);
	
	var _invoiceReducer2 = _interopRequireDefault(_invoiceReducer);
	
	var _tableReducer = __webpack_require__(1012);
	
	var _tableReducer2 = _interopRequireDefault(_tableReducer);
	
	var _promoCodesReducer = __webpack_require__(1008);
	
	var _promoCodesReducer2 = _interopRequireDefault(_promoCodesReducer);
	
	var _formsReducer = __webpack_require__(988);
	
	var _formsReducer2 = _interopRequireDefault(_formsReducer);
	
	var _pagesReducer = __webpack_require__(1004);
	
	var _pagesReducer2 = _interopRequireDefault(_pagesReducer);
	
	var _componentReducer = __webpack_require__(979);
	
	var _componentReducer2 = _interopRequireDefault(_componentReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	  base: _baseReducer2.default,
	  alerts: _alertReducer2.default,
	  form: _reduxForm.reducer,
	  user: _userReducer2.default,
	  path: _pathReducer2.default,
	  stores: _storeReducer2.default,
	  storeSuppliers: _storeSuppliersReducer2.default,
	  savedFilters: _savedFiltersReducer2.default,
	  listings: _listingReducer.listingsReducer,
	  currentListing: _listingReducer.listingReducer,
	  listingStatus: _listingStatusReducer2.default,
	  entities: _entityReducer2.default,
	  importerStatus: _importerReducer.importerReducer,
	  voucher: _voucherReducer2.default,
	  voucherCoupon: _voucherCouponReducer2.default,
	  deliveryOrder: _deliveryOrderReducer2.default,
	  invoice: _invoiceReducer2.default,
	  inventoryVariance: _inventoryVarianceReducer2.default,
	  promoCode: _promoCodesReducer2.default,
	  kds: _kdsReducer2.default,
	  kdsStatus: _kdsStatusReducer2.default,
	  table: _tableReducer2.default,
	  forms: _formsReducer2.default,
	  pages: _pagesReducer2.default,
	  components: _componentReducer2.default
	});
	
	exports.default = rootReducer;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(253)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(36);
	var toAbsoluteIndex = __webpack_require__(131);
	var toLength = __webpack_require__(23);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1023);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(28);
	var createDesc = __webpack_require__(128);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var document = __webpack_require__(15).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 333 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(22)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(15).document;
	module.exports = document && document.documentElement;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var setPrototypeOf = __webpack_require__(345).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(157);
	var ITERATOR = __webpack_require__(22)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(125);
	var descriptor = __webpack_require__(128);
	var setToStringTag = __webpack_require__(158);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(53)(IteratorPrototype, __webpack_require__(22)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(111);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(54);
	var hide = __webpack_require__(53);
	var Iterators = __webpack_require__(157);
	var $iterCreate = __webpack_require__(338);
	var setToStringTag = __webpack_require__(158);
	var getPrototypeOf = __webpack_require__(62);
	var ITERATOR = __webpack_require__(22)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 340 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 341 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var macrotask = __webpack_require__(350).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(67)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(49);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(191);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(11);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(69)(Function.call, __webpack_require__(61).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(252)('keys');
	var uid = __webpack_require__(132);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(245);
	var defined = __webpack_require__(78);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(71);
	var defined = __webpack_require__(78);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 349 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var invoke = __webpack_require__(509);
	var html = __webpack_require__(335);
	var cel = __webpack_require__(332);
	var global = __webpack_require__(15);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(67)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var DESCRIPTORS = __webpack_require__(27);
	var LIBRARY = __webpack_require__(111);
	var $typed = __webpack_require__(254);
	var hide = __webpack_require__(53);
	var redefineAll = __webpack_require__(129);
	var fails = __webpack_require__(16);
	var anInstance = __webpack_require__(123);
	var toInteger = __webpack_require__(71);
	var toLength = __webpack_require__(23);
	var toIndex = __webpack_require__(528);
	var gOPN = __webpack_require__(126).f;
	var dP = __webpack_require__(28).f;
	var arrayFill = __webpack_require__(329);
	var setToStringTag = __webpack_require__(158);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(68);
	var LIBRARY = __webpack_require__(111);
	var wksExt = __webpack_require__(529);
	var defineProperty = __webpack_require__(28).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(156);
	var ITERATOR = __webpack_require__(22)('iterator');
	var Iterators = __webpack_require__(157);
	module.exports = __webpack_require__(68).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(110);
	var step = __webpack_require__(512);
	var Iterators = __webpack_require__(157);
	var toIObject = __webpack_require__(63);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(339)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1225);
	var isArguments = __webpack_require__(1224);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 356 */
[1788, 135, 81],
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1400),
	    mapCacheDelete = __webpack_require__(1401),
	    mapCacheGet = __webpack_require__(1402),
	    mapCacheHas = __webpack_require__(1403),
	    mapCacheSet = __webpack_require__(1404);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(257),
	    stackClear = __webpack_require__(1415),
	    stackDelete = __webpack_require__(1416),
	    stackGet = __webpack_require__(1417),
	    stackHas = __webpack_require__(1418),
	    stackSet = __webpack_require__(1419);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 359 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 360 */
[1794, 1335, 1373],
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(359),
	    isFlattenable = __webpack_require__(1392);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 362 */
[1799, 545],
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(569);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(547),
	    stubArray = __webpack_require__(580);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(203),
	    isArrayLike = __webpack_require__(82),
	    isIndex = __webpack_require__(262),
	    isObject = __webpack_require__(83);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(38),
	    isSymbol = __webpack_require__(205);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(562);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1375),
	    findIndex = __webpack_require__(1427);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 369 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1344),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(367);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(548),
	    baseKeysIn = __webpack_require__(1345),
	    isArrayLike = __webpack_require__(82);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 372 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 376 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content, compressionOptions) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = __webpack_require__(1463);


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122).Buffer))

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(207);
	var utils = __webpack_require__(86);
	var crc32 = __webpack_require__(1461);
	var signature = __webpack_require__(592);
	var defaults = __webpack_require__(591);
	var base64 = __webpack_require__(377);
	var compressions = __webpack_require__(378);
	var CompressedObject = __webpack_require__(589);
	var nodeBuffer = __webpack_require__(379);
	var utf8 = __webpack_require__(1469);
	var StringWriter = __webpack_require__(1467);
	var Uint8ArrayWriter = __webpack_require__(1468);
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	        dataType = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) != "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression, compressionOptions) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	
	
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {
	
	    // the dir flag is already set for compatibility
	
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset, platform) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    decToHex(versionMadeBy, 2) +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    decToHex(extFileAttr, 4) +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            compressionOptions : null,
	            type: "base64",
	            platform: "DOS",
	            comment: null,
	            mimeType: 'application/zip'
	        });
	
	        utils.checkSupport(options.type);
	
	        // accept nodejs `process.platform`
	        if(
	          options.platform === 'darwin' ||
	          options.platform === 'freebsd' ||
	          options.platform === 'linux' ||
	          options.platform === 'sunos'
	        ) {
	          options.platform = "UNIX";
	        }
	        if (options.platform === 'win32') {
	          options.platform = "DOS";
	        }
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression, compressionOptions);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength, options.platform);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip), options.mimeType);
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;


/***/ },
/* 381 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 382 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(1480),
	    isArguments = __webpack_require__(381),
	    isArray = __webpack_require__(382);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 384 */
[1790, 138],
/* 385 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(32),
	    stringToPath = __webpack_require__(1561);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function baseCastPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = baseCastPath;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1500),
	    isObject = __webpack_require__(51),
	    isObjectLike = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var copyObjectWith = __webpack_require__(1529);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object) {
	  return copyObjectWith(source, props, object);
	}
	
	module.exports = copyObject;


/***/ },
/* 389 */
202,
/* 390 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(32),
	    isObjectLike = __webpack_require__(140);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(284),
	    isObjectLike = __webpack_require__(140);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(72),
	    basePullAt = __webpack_require__(1510);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1577);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3');
	 * // => 3
	 */
	function toInteger(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  var remainder = value % 1;
	  return value === value ? (remainder ? value - remainder : value) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(384),
	    isSymbol = __webpack_require__(1569);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (value == null) {
	    return '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toString;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(209),
	    baseIteratee = __webpack_require__(72),
	    baseUniq = __webpack_require__(1517),
	    isArrayLikeObject = __webpack_require__(211),
	    last = __webpack_require__(393),
	    rest = __webpack_require__(142);
	
	/**
	 * This method is like `_.union` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	 * // => [2.1, 1.2, 4.3]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	var unionBy = rest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseUniq(baseFlatten(arrays, 1, true), baseIteratee(iteratee));
	});
	
	module.exports = unionBy;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(612),
	    isArrayLikeObject = __webpack_require__(211),
	    rest = __webpack_require__(142);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = rest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.4
	//! author : Tim Wood
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(143)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.5.4",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		loadData({
			"version": "2016d",
			"zones": [
				"Africa/Abidjan|GMT|0|0||48e5",
				"Africa/Khartoum|EAT|-30|0||51e5",
				"Africa/Algiers|CET|-10|0||26e5",
				"Africa/Lagos|WAT|-10|0||17e6",
				"Africa/Maputo|CAT|-20|0||26e5",
				"Africa/Cairo|EET EEST|-20 -30|010101010|1Cby0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
				"Africa/Casablanca|WET WEST|0 -10|01010101010101010101010101010101010101010|1Cco0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0|32e5",
				"Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
				"Africa/Johannesburg|SAST|-20|0||84e5",
				"Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5",
				"Africa/Windhoek|WAST WAT|-20 -10|01010101010101010101010|1C1c0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0|32e4",
				"America/Adak|HST HDT|a0 90|01010101010101010101010|1BR00 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
				"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1BQX0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
				"America/Santo_Domingo|AST|40|0||29e5",
				"America/Araguaina|BRT BRST|30 20|010|1IdD0 Lz0|14e4",
				"America/Argentina/Buenos_Aires|ART|30|0|",
				"America/Asuncion|PYST PYT|30 40|01010101010101010101010|1C430 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
				"America/Panama|EST|50|0||15e5",
				"America/Bahia|BRT BRST|30 20|010|1FJf0 Rb0|27e5",
				"America/Bahia_Banderas|MST CDT CST|70 50 60|01212121212121212121212|1C1l0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
				"America/Fortaleza|BRT|30|0||34e5",
				"America/Managua|CST|60|0||22e5",
				"America/Manaus|AMT|40|0||19e5",
				"America/Bogota|COT|50|0||90e5",
				"America/Denver|MST MDT|70 60|01010101010101010101010|1BQV0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
				"America/Campo_Grande|AMST AMT|30 40|01010101010101010101010|1BIr0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10|77e4",
				"America/Cancun|CST CDT EST|60 50 50|010101010102|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
				"America/Caracas|VET VET|4u 40|01|1QMT0|29e5",
				"America/Cayenne|GFT|30|0||58e3",
				"America/Chicago|CST CDT|60 50|01010101010101010101010|1BQU0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
				"America/Chihuahua|MST MDT|70 60|01010101010101010101010|1C1l0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
				"America/Phoenix|MST|70|0||42e5",
				"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
				"America/New_York|EST EDT|50 40|01010101010101010101010|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
				"America/Rio_Branco|AMT ACT|40 50|01|1KLE0|31e4",
				"America/Fort_Nelson|PST PDT MST|80 70 70|010101010102|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
				"America/Halifax|AST ADT|40 30|01010101010101010101010|1BQS0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
				"America/Godthab|WGT WGST|30 20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
				"America/Goose_Bay|AST ADT|40 30|01010101010101010101010|1BQQ1 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
				"America/Grand_Turk|EST EDT AST|50 40 40|0101010101012|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
				"America/Guayaquil|ECT|50|0||27e5",
				"America/Guyana|GYT|40|0||80e4",
				"America/Havana|CST CDT|50 40|01010101010101010101010|1BQR0 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
				"America/La_Paz|BOT|40|0||19e5",
				"America/Lima|PET|50|0||11e6",
				"America/Mexico_City|CST CDT|60 50|01010101010101010101010|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
				"America/Metlakatla|PST AKST AKDT|80 90 80|012121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
				"America/Miquelon|PMST PMDT|30 20|01010101010101010101010|1BQR0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
				"America/Montevideo|UYST UYT|20 30|010101010101|1BQQ0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
				"America/Noronha|FNT|20|0||30e2",
				"America/North_Dakota/Beulah|MST MDT CST CDT|70 60 60 50|01232323232323232323232|1BQV0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
				"America/Paramaribo|SRT|30|0||24e4",
				"America/Port-au-Prince|EST EDT|50 40|010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
				"America/Santiago|CLST CLT|30 40|010101010101010101010|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
				"America/Sao_Paulo|BRST BRT|20 30|01010101010101010101010|1BIq0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10|20e6",
				"America/Scoresbysund|EGT EGST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
				"America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1BQPv 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
				"Antarctica/Casey|CAST AWST|-b0 -80|0101|1BN30 40P0 KL0|10",
				"Antarctica/Davis|DAVT DAVT|-50 -70|0101|1BPw0 3Wn0 KN0|70",
				"Antarctica/DumontDUrville|DDUT|-a0|0||80",
				"Antarctica/Macquarie|AEDT MIST|-b0 -b0|01|1C140|1",
				"Antarctica/Mawson|MAWT|-50|0||60",
				"Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
				"Antarctica/Rothera|ROTT|30|0||130",
				"Antarctica/Syowa|SYOT|-30|0||20",
				"Antarctica/Troll|UTC CEST|0 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
				"Antarctica/Vostok|VOST|-60|0||25",
				"Asia/Baghdad|AST|-30|0||66e5",
				"Asia/Almaty|+06|-60|0||15e5",
				"Asia/Amman|EET EEST|-20 -30|010101010101010101010|1BVy0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0|25e5",
				"Asia/Anadyr|ANAT ANAST ANAT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0|13e3",
				"Asia/Aqtobe|+05|-50|0||27e4",
				"Asia/Ashgabat|TMT|-50|0||41e4",
				"Asia/Baku|AZT AZST|-40 -50|0101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
				"Asia/Bangkok|ICT|-70|0||15e6",
				"Asia/Barnaul|+06 +07|-60 -70|010101|1BWk0 1qM0 WM0 8Hz0 3rd0",
				"Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1BWm0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
				"Asia/Bishkek|KGT|-60|0||87e4",
				"Asia/Brunei|BNT|-80|0||42e4",
				"Asia/Kolkata|IST|-5u|0||15e6",
				"Asia/Chita|YAKT YAKST YAKT IRKT|-90 -a0 -a0 -80|010230|1BWh0 1qM0 WM0 8Hz0 3re0|33e4",
				"Asia/Choibalsan|CHOT CHOST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3",
				"Asia/Shanghai|CST|-80|0||23e6",
				"Asia/Dhaka|BDT|-60|0||16e6",
				"Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1C0m0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0|26e5",
				"Asia/Dili|TLT|-90|0||19e4",
				"Asia/Dubai|GST|-40|0||39e5",
				"Asia/Dushanbe|TJT|-50|0||76e4",
				"Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1BVW1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|18e5",
				"Asia/Hebron|EET EEST|-20 -30|0101010101010101010101010|1BVy0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|25e4",
				"Asia/Hong_Kong|HKT|-80|0||73e5",
				"Asia/Hovd|HOVT HOVST|-70 -80|0101010101010|1O8H0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3",
				"Asia/Irkutsk|IRKT IRKST IRKT|-80 -90 -90|01020|1BWi0 1qM0 WM0 8Hz0|60e4",
				"Europe/Istanbul|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e6",
				"Asia/Jakarta|WIB|-70|0||31e6",
				"Asia/Jayapura|WIT|-90|0||26e4",
				"Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1BVA0 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
				"Asia/Kabul|AFT|-4u|0||46e5",
				"Asia/Kamchatka|PETT PETST PETT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0|18e4",
				"Asia/Karachi|PKT|-50|0||24e6",
				"Asia/Urumqi|XJT|-60|0||32e5",
				"Asia/Kathmandu|NPT|-5J|0||12e5",
				"Asia/Khandyga|VLAT VLAST VLAT YAKT YAKT|-a0 -b0 -b0 -a0 -90|010234|1BWg0 1qM0 WM0 17V0 7zD0|66e2",
				"Asia/Krasnoyarsk|KRAT KRAST KRAT|-70 -80 -80|01020|1BWj0 1qM0 WM0 8Hz0|10e5",
				"Asia/Kuala_Lumpur|MYT|-80|0||71e5",
				"Asia/Magadan|MAGT MAGST MAGT MAGT|-b0 -c0 -c0 -a0|010230|1BWf0 1qM0 WM0 8Hz0 3Cq0|95e3",
				"Asia/Makassar|WITA|-80|0||15e5",
				"Asia/Manila|PHT|-80|0||24e6",
				"Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
				"Asia/Novokuznetsk|KRAT NOVST NOVT NOVT|-70 -70 -60 -70|01230|1BWj0 1qN0 WM0 8Hz0|55e4",
				"Asia/Novosibirsk|NOVT NOVST NOVT|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0|15e5",
				"Asia/Omsk|OMST OMSST OMST|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0|12e5",
				"Asia/Pyongyang|KST KST|-90 -8u|01|1P4D0|29e5",
				"Asia/Rangoon|MMT|-6u|0||48e5",
				"Asia/Sakhalin|SAKT SAKST SAKT|-a0 -b0 -b0|010202|1BWg0 1qM0 WM0 8Hz0 3rd0|58e4",
				"Asia/Tashkent|UZT|-50|0||23e5",
				"Asia/Seoul|KST|-90|0||23e6",
				"Asia/Singapore|SGT|-80|0||56e5",
				"Asia/Srednekolymsk|MAGT MAGST MAGT SRET|-b0 -c0 -c0 -b0|01023|1BWf0 1qM0 WM0 8Hz0|35e2",
				"Asia/Tbilisi|GET|-40|0||11e5",
				"Asia/Tehran|IRST IRDT|-3u -4u|01010101010101010101010|1BTUu 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
				"Asia/Thimphu|BTT|-60|0||79e3",
				"Asia/Tokyo|JST|-90|0||38e6",
				"Asia/Tomsk|+06 +07|-60 -70|010101|1BWk0 1qM0 WM0 8Hz0 3Qp0|10e5",
				"Asia/Ulaanbaatar|ULAT ULAST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5",
				"Asia/Ust-Nera|MAGT MAGST MAGT VLAT VLAT|-b0 -c0 -c0 -b0 -a0|010234|1BWf0 1qM0 WM0 17V0 7zD0|65e2",
				"Asia/Vladivostok|VLAT VLAST VLAT|-a0 -b0 -b0|01020|1BWg0 1qM0 WM0 8Hz0|60e4",
				"Asia/Yakutsk|YAKT YAKST YAKT|-90 -a0 -a0|01020|1BWh0 1qM0 WM0 8Hz0|28e4",
				"Asia/Yekaterinburg|YEKT YEKST YEKT|-50 -60 -60|01020|1BWl0 1qM0 WM0 8Hz0|14e5",
				"Asia/Yerevan|AMT AMST|-40 -50|01010|1BWm0 1qM0 WM0 1qM0|13e5",
				"Atlantic/Azores|AZOT AZOST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
				"Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
				"Atlantic/Cape_Verde|CVT|10|0||50e4",
				"Atlantic/South_Georgia|GST|20|0||30",
				"Atlantic/Stanley|FKST FKT|30 40|010|1C6R0 U10|21e2",
				"Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1C140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
				"Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1C14u 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
				"Australia/Brisbane|AEST|-a0|0||20e5",
				"Australia/Darwin|ACST|-9u|0||12e4",
				"Australia/Eucla|ACWST|-8J|0||368",
				"Australia/Lord_Howe|LHDT LHST|-b0 -au|01010101010101010101010|1C130 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
				"Australia/Perth|AWST|-80|0||18e5",
				"Pacific/Easter|EASST EAST|50 60|010101010101010101010|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
				"Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
				"Etc/GMT+1|GMT+1|10|0|",
				"Etc/GMT+10|GMT+10|a0|0|",
				"Etc/GMT+11|GMT+11|b0|0|",
				"Etc/GMT+12|GMT+12|c0|0|",
				"Etc/GMT+2|GMT+2|20|0|",
				"Etc/GMT+3|GMT+3|30|0|",
				"Etc/GMT+4|GMT+4|40|0|",
				"Etc/GMT+5|GMT+5|50|0|",
				"Etc/GMT+6|GMT+6|60|0|",
				"Etc/GMT+7|GMT+7|70|0|",
				"Etc/GMT+8|GMT+8|80|0|",
				"Etc/GMT+9|GMT+9|90|0|",
				"Etc/GMT-1|GMT-1|-10|0|",
				"Etc/GMT-10|GMT-10|-a0|0|",
				"Etc/GMT-11|GMT-11|-b0|0|",
				"Etc/GMT-12|GMT-12|-c0|0|",
				"Etc/GMT-13|GMT-13|-d0|0|",
				"Etc/GMT-14|GMT-14|-e0|0|",
				"Etc/GMT-2|GMT-2|-20|0|",
				"Etc/GMT-3|GMT-3|-30|0|",
				"Etc/GMT-4|GMT-4|-40|0|",
				"Etc/GMT-5|GMT-5|-50|0|",
				"Etc/GMT-6|GMT-6|-60|0|",
				"Etc/GMT-7|GMT-7|-70|0|",
				"Etc/GMT-8|GMT-8|-80|0|",
				"Etc/GMT-9|GMT-9|-90|0|",
				"Etc/UCT|UCT|0|0|",
				"Etc/UTC|UTC|0|0|",
				"Europe/Astrakhan|+03 +04|-30 -40|010101|1BWn0 1qM0 WM0 8Hz0 3rd0",
				"Europe/London|GMT BST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
				"Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
				"Europe/Kaliningrad|EET EEST FET|-20 -30 -30|01020|1BWo0 1qM0 WM0 8Hz0|44e4",
				"Europe/Kirov|+03 +04|-30 -40|01010|1BWn0 1qM0 WM0 8Hz0|48e4",
				"Europe/Minsk|EET EEST FET MSK|-20 -30 -30 -30|01023|1BWo0 1qM0 WM0 8Hy0|19e5",
				"Europe/Moscow|MSK MSD MSK|-30 -40 -40|01020|1BWn0 1qM0 WM0 8Hz0|16e6",
				"Europe/Samara|SAMT SAMST SAMT|-40 -40 -30|0120|1BWm0 1qN0 WM0|12e5",
				"Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|01010101023|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
				"Pacific/Honolulu|HST|a0|0||37e4",
				"Indian/Chagos|IOT|-60|0||30e2",
				"Indian/Christmas|CXT|-70|0||21e2",
				"Indian/Cocos|CCT|-6u|0||596",
				"Indian/Kerguelen|TFT|-50|0||130",
				"Indian/Mahe|SCT|-40|0||79e3",
				"Indian/Maldives|MVT|-50|0||35e4",
				"Indian/Mauritius|MUT|-40|0||15e4",
				"Indian/Reunion|RET|-40|0||84e4",
				"Pacific/Majuro|MHT|-c0|0||28e3",
				"MET|MET MEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
				"Pacific/Chatham|CHADT CHAST|-dJ -cJ|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
				"Pacific/Apia|SST SDT WSDT WSST|b0 a0 -e0 -d0|01012323232323232323232|1Dbn0 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
				"Pacific/Bougainville|PGT BST|-a0 -b0|01|1NwE0|18e4",
				"Pacific/Chuuk|CHUT|-a0|0||49e3",
				"Pacific/Efate|VUT|-b0|0||66e3",
				"Pacific/Enderbury|PHOT|-d0|0||1",
				"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483",
				"Pacific/Fiji|FJST FJT|-d0 -c0|01010101010101010101010|1BWe0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0|88e4",
				"Pacific/Funafuti|TVT|-c0|0||45e2",
				"Pacific/Galapagos|GALT|60|0||25e3",
				"Pacific/Gambier|GAMT|90|0||125",
				"Pacific/Guadalcanal|SBT|-b0|0||11e4",
				"Pacific/Guam|ChST|-a0|0||17e4",
				"Pacific/Kiritimati|LINT|-e0|0||51e2",
				"Pacific/Kosrae|KOST|-b0|0||66e2",
				"Pacific/Marquesas|MART|9u|0||86e2",
				"Pacific/Pago_Pago|SST|b0|0||37e2",
				"Pacific/Nauru|NRT|-c0|0||10e3",
				"Pacific/Niue|NUT|b0|0||12e2",
				"Pacific/Norfolk|NFT NFT|-bu -b0|01|1PoCu|25e4",
				"Pacific/Noumea|NCT|-b0|0||98e3",
				"Pacific/Palau|PWT|-90|0||21e3",
				"Pacific/Pitcairn|PST|80|0||56",
				"Pacific/Pohnpei|PONT|-b0|0||34e3",
				"Pacific/Port_Moresby|PGT|-a0|0||25e4",
				"Pacific/Rarotonga|CKT|a0|0||13e3",
				"Pacific/Tahiti|TAHT|a0|0||18e4",
				"Pacific/Tarawa|GILT|-c0|0||29e3",
				"Pacific/Tongatapu|TOT|-d0|0||75e3",
				"Pacific/Wake|WAKT|-c0|0||16e3",
				"Pacific/Wallis|WFT|-c0|0||94"
			],
			"links": [
				"Africa/Abidjan|Africa/Accra",
				"Africa/Abidjan|Africa/Bamako",
				"Africa/Abidjan|Africa/Banjul",
				"Africa/Abidjan|Africa/Bissau",
				"Africa/Abidjan|Africa/Conakry",
				"Africa/Abidjan|Africa/Dakar",
				"Africa/Abidjan|Africa/Freetown",
				"Africa/Abidjan|Africa/Lome",
				"Africa/Abidjan|Africa/Monrovia",
				"Africa/Abidjan|Africa/Nouakchott",
				"Africa/Abidjan|Africa/Ouagadougou",
				"Africa/Abidjan|Africa/Sao_Tome",
				"Africa/Abidjan|Africa/Timbuktu",
				"Africa/Abidjan|America/Danmarkshavn",
				"Africa/Abidjan|Atlantic/Reykjavik",
				"Africa/Abidjan|Atlantic/St_Helena",
				"Africa/Abidjan|Etc/GMT",
				"Africa/Abidjan|Etc/GMT+0",
				"Africa/Abidjan|Etc/GMT-0",
				"Africa/Abidjan|Etc/GMT0",
				"Africa/Abidjan|Etc/Greenwich",
				"Africa/Abidjan|GMT",
				"Africa/Abidjan|GMT+0",
				"Africa/Abidjan|GMT-0",
				"Africa/Abidjan|GMT0",
				"Africa/Abidjan|Greenwich",
				"Africa/Abidjan|Iceland",
				"Africa/Algiers|Africa/Tunis",
				"Africa/Cairo|Egypt",
				"Africa/Casablanca|Africa/El_Aaiun",
				"Africa/Johannesburg|Africa/Maseru",
				"Africa/Johannesburg|Africa/Mbabane",
				"Africa/Khartoum|Africa/Addis_Ababa",
				"Africa/Khartoum|Africa/Asmara",
				"Africa/Khartoum|Africa/Asmera",
				"Africa/Khartoum|Africa/Dar_es_Salaam",
				"Africa/Khartoum|Africa/Djibouti",
				"Africa/Khartoum|Africa/Juba",
				"Africa/Khartoum|Africa/Kampala",
				"Africa/Khartoum|Africa/Mogadishu",
				"Africa/Khartoum|Africa/Nairobi",
				"Africa/Khartoum|Indian/Antananarivo",
				"Africa/Khartoum|Indian/Comoro",
				"Africa/Khartoum|Indian/Mayotte",
				"Africa/Lagos|Africa/Bangui",
				"Africa/Lagos|Africa/Brazzaville",
				"Africa/Lagos|Africa/Douala",
				"Africa/Lagos|Africa/Kinshasa",
				"Africa/Lagos|Africa/Libreville",
				"Africa/Lagos|Africa/Luanda",
				"Africa/Lagos|Africa/Malabo",
				"Africa/Lagos|Africa/Ndjamena",
				"Africa/Lagos|Africa/Niamey",
				"Africa/Lagos|Africa/Porto-Novo",
				"Africa/Maputo|Africa/Blantyre",
				"Africa/Maputo|Africa/Bujumbura",
				"Africa/Maputo|Africa/Gaborone",
				"Africa/Maputo|Africa/Harare",
				"Africa/Maputo|Africa/Kigali",
				"Africa/Maputo|Africa/Lubumbashi",
				"Africa/Maputo|Africa/Lusaka",
				"Africa/Tripoli|Libya",
				"America/Adak|America/Atka",
				"America/Adak|US/Aleutian",
				"America/Anchorage|America/Juneau",
				"America/Anchorage|America/Nome",
				"America/Anchorage|America/Sitka",
				"America/Anchorage|America/Yakutat",
				"America/Anchorage|US/Alaska",
				"America/Argentina/Buenos_Aires|America/Argentina/Catamarca",
				"America/Argentina/Buenos_Aires|America/Argentina/ComodRivadavia",
				"America/Argentina/Buenos_Aires|America/Argentina/Cordoba",
				"America/Argentina/Buenos_Aires|America/Argentina/Jujuy",
				"America/Argentina/Buenos_Aires|America/Argentina/La_Rioja",
				"America/Argentina/Buenos_Aires|America/Argentina/Mendoza",
				"America/Argentina/Buenos_Aires|America/Argentina/Rio_Gallegos",
				"America/Argentina/Buenos_Aires|America/Argentina/Salta",
				"America/Argentina/Buenos_Aires|America/Argentina/San_Juan",
				"America/Argentina/Buenos_Aires|America/Argentina/San_Luis",
				"America/Argentina/Buenos_Aires|America/Argentina/Tucuman",
				"America/Argentina/Buenos_Aires|America/Argentina/Ushuaia",
				"America/Argentina/Buenos_Aires|America/Buenos_Aires",
				"America/Argentina/Buenos_Aires|America/Catamarca",
				"America/Argentina/Buenos_Aires|America/Cordoba",
				"America/Argentina/Buenos_Aires|America/Jujuy",
				"America/Argentina/Buenos_Aires|America/Mendoza",
				"America/Argentina/Buenos_Aires|America/Rosario",
				"America/Campo_Grande|America/Cuiaba",
				"America/Chicago|America/Indiana/Knox",
				"America/Chicago|America/Indiana/Tell_City",
				"America/Chicago|America/Knox_IN",
				"America/Chicago|America/Matamoros",
				"America/Chicago|America/Menominee",
				"America/Chicago|America/North_Dakota/Center",
				"America/Chicago|America/North_Dakota/New_Salem",
				"America/Chicago|America/Rainy_River",
				"America/Chicago|America/Rankin_Inlet",
				"America/Chicago|America/Resolute",
				"America/Chicago|America/Winnipeg",
				"America/Chicago|CST6CDT",
				"America/Chicago|Canada/Central",
				"America/Chicago|US/Central",
				"America/Chicago|US/Indiana-Starke",
				"America/Chihuahua|America/Mazatlan",
				"America/Chihuahua|Mexico/BajaSur",
				"America/Denver|America/Boise",
				"America/Denver|America/Cambridge_Bay",
				"America/Denver|America/Edmonton",
				"America/Denver|America/Inuvik",
				"America/Denver|America/Ojinaga",
				"America/Denver|America/Shiprock",
				"America/Denver|America/Yellowknife",
				"America/Denver|Canada/Mountain",
				"America/Denver|MST7MDT",
				"America/Denver|Navajo",
				"America/Denver|US/Mountain",
				"America/Fortaleza|America/Belem",
				"America/Fortaleza|America/Maceio",
				"America/Fortaleza|America/Recife",
				"America/Fortaleza|America/Santarem",
				"America/Halifax|America/Glace_Bay",
				"America/Halifax|America/Moncton",
				"America/Halifax|America/Thule",
				"America/Halifax|Atlantic/Bermuda",
				"America/Halifax|Canada/Atlantic",
				"America/Havana|Cuba",
				"America/Los_Angeles|America/Dawson",
				"America/Los_Angeles|America/Ensenada",
				"America/Los_Angeles|America/Santa_Isabel",
				"America/Los_Angeles|America/Tijuana",
				"America/Los_Angeles|America/Vancouver",
				"America/Los_Angeles|America/Whitehorse",
				"America/Los_Angeles|Canada/Pacific",
				"America/Los_Angeles|Canada/Yukon",
				"America/Los_Angeles|Mexico/BajaNorte",
				"America/Los_Angeles|PST8PDT",
				"America/Los_Angeles|US/Pacific",
				"America/Los_Angeles|US/Pacific-New",
				"America/Managua|America/Belize",
				"America/Managua|America/Costa_Rica",
				"America/Managua|America/El_Salvador",
				"America/Managua|America/Guatemala",
				"America/Managua|America/Regina",
				"America/Managua|America/Swift_Current",
				"America/Managua|America/Tegucigalpa",
				"America/Managua|Canada/East-Saskatchewan",
				"America/Managua|Canada/Saskatchewan",
				"America/Manaus|America/Boa_Vista",
				"America/Manaus|America/Porto_Velho",
				"America/Manaus|Brazil/West",
				"America/Mexico_City|America/Merida",
				"America/Mexico_City|America/Monterrey",
				"America/Mexico_City|Mexico/General",
				"America/New_York|America/Detroit",
				"America/New_York|America/Fort_Wayne",
				"America/New_York|America/Indiana/Indianapolis",
				"America/New_York|America/Indiana/Marengo",
				"America/New_York|America/Indiana/Petersburg",
				"America/New_York|America/Indiana/Vevay",
				"America/New_York|America/Indiana/Vincennes",
				"America/New_York|America/Indiana/Winamac",
				"America/New_York|America/Indianapolis",
				"America/New_York|America/Iqaluit",
				"America/New_York|America/Kentucky/Louisville",
				"America/New_York|America/Kentucky/Monticello",
				"America/New_York|America/Louisville",
				"America/New_York|America/Montreal",
				"America/New_York|America/Nassau",
				"America/New_York|America/Nipigon",
				"America/New_York|America/Pangnirtung",
				"America/New_York|America/Thunder_Bay",
				"America/New_York|America/Toronto",
				"America/New_York|Canada/Eastern",
				"America/New_York|EST5EDT",
				"America/New_York|US/East-Indiana",
				"America/New_York|US/Eastern",
				"America/New_York|US/Michigan",
				"America/Noronha|Brazil/DeNoronha",
				"America/Panama|America/Atikokan",
				"America/Panama|America/Cayman",
				"America/Panama|America/Coral_Harbour",
				"America/Panama|America/Jamaica",
				"America/Panama|EST",
				"America/Panama|Jamaica",
				"America/Phoenix|America/Creston",
				"America/Phoenix|America/Dawson_Creek",
				"America/Phoenix|America/Hermosillo",
				"America/Phoenix|MST",
				"America/Phoenix|US/Arizona",
				"America/Rio_Branco|America/Eirunepe",
				"America/Rio_Branco|America/Porto_Acre",
				"America/Rio_Branco|Brazil/Acre",
				"America/Santiago|Antarctica/Palmer",
				"America/Santiago|Chile/Continental",
				"America/Santo_Domingo|America/Anguilla",
				"America/Santo_Domingo|America/Antigua",
				"America/Santo_Domingo|America/Aruba",
				"America/Santo_Domingo|America/Barbados",
				"America/Santo_Domingo|America/Blanc-Sablon",
				"America/Santo_Domingo|America/Curacao",
				"America/Santo_Domingo|America/Dominica",
				"America/Santo_Domingo|America/Grenada",
				"America/Santo_Domingo|America/Guadeloupe",
				"America/Santo_Domingo|America/Kralendijk",
				"America/Santo_Domingo|America/Lower_Princes",
				"America/Santo_Domingo|America/Marigot",
				"America/Santo_Domingo|America/Martinique",
				"America/Santo_Domingo|America/Montserrat",
				"America/Santo_Domingo|America/Port_of_Spain",
				"America/Santo_Domingo|America/Puerto_Rico",
				"America/Santo_Domingo|America/St_Barthelemy",
				"America/Santo_Domingo|America/St_Kitts",
				"America/Santo_Domingo|America/St_Lucia",
				"America/Santo_Domingo|America/St_Thomas",
				"America/Santo_Domingo|America/St_Vincent",
				"America/Santo_Domingo|America/Tortola",
				"America/Santo_Domingo|America/Virgin",
				"America/Sao_Paulo|Brazil/East",
				"America/St_Johns|Canada/Newfoundland",
				"Asia/Almaty|Asia/Qyzylorda",
				"Asia/Aqtobe|Asia/Aqtau",
				"Asia/Aqtobe|Asia/Oral",
				"Asia/Ashgabat|Asia/Ashkhabad",
				"Asia/Baghdad|Asia/Aden",
				"Asia/Baghdad|Asia/Bahrain",
				"Asia/Baghdad|Asia/Kuwait",
				"Asia/Baghdad|Asia/Qatar",
				"Asia/Baghdad|Asia/Riyadh",
				"Asia/Bangkok|Asia/Ho_Chi_Minh",
				"Asia/Bangkok|Asia/Phnom_Penh",
				"Asia/Bangkok|Asia/Saigon",
				"Asia/Bangkok|Asia/Vientiane",
				"Asia/Dhaka|Asia/Dacca",
				"Asia/Dubai|Asia/Muscat",
				"Asia/Hong_Kong|Hongkong",
				"Asia/Jakarta|Asia/Pontianak",
				"Asia/Jerusalem|Asia/Tel_Aviv",
				"Asia/Jerusalem|Israel",
				"Asia/Kathmandu|Asia/Katmandu",
				"Asia/Kolkata|Asia/Calcutta",
				"Asia/Kolkata|Asia/Colombo",
				"Asia/Kuala_Lumpur|Asia/Kuching",
				"Asia/Makassar|Asia/Ujung_Pandang",
				"Asia/Seoul|ROK",
				"Asia/Shanghai|Asia/Chongqing",
				"Asia/Shanghai|Asia/Chungking",
				"Asia/Shanghai|Asia/Harbin",
				"Asia/Shanghai|Asia/Macao",
				"Asia/Shanghai|Asia/Macau",
				"Asia/Shanghai|Asia/Taipei",
				"Asia/Shanghai|PRC",
				"Asia/Shanghai|ROC",
				"Asia/Singapore|Singapore",
				"Asia/Tashkent|Asia/Samarkand",
				"Asia/Tehran|Iran",
				"Asia/Thimphu|Asia/Thimbu",
				"Asia/Tokyo|Japan",
				"Asia/Ulaanbaatar|Asia/Ulan_Bator",
				"Asia/Urumqi|Asia/Kashgar",
				"Australia/Adelaide|Australia/Broken_Hill",
				"Australia/Adelaide|Australia/South",
				"Australia/Adelaide|Australia/Yancowinna",
				"Australia/Brisbane|Australia/Lindeman",
				"Australia/Brisbane|Australia/Queensland",
				"Australia/Darwin|Australia/North",
				"Australia/Lord_Howe|Australia/LHI",
				"Australia/Perth|Australia/West",
				"Australia/Sydney|Australia/ACT",
				"Australia/Sydney|Australia/Canberra",
				"Australia/Sydney|Australia/Currie",
				"Australia/Sydney|Australia/Hobart",
				"Australia/Sydney|Australia/Melbourne",
				"Australia/Sydney|Australia/NSW",
				"Australia/Sydney|Australia/Tasmania",
				"Australia/Sydney|Australia/Victoria",
				"Etc/UCT|UCT",
				"Etc/UTC|Etc/Universal",
				"Etc/UTC|Etc/Zulu",
				"Etc/UTC|UTC",
				"Etc/UTC|Universal",
				"Etc/UTC|Zulu",
				"Europe/Astrakhan|Europe/Ulyanovsk",
				"Europe/Athens|Asia/Nicosia",
				"Europe/Athens|EET",
				"Europe/Athens|Europe/Bucharest",
				"Europe/Athens|Europe/Helsinki",
				"Europe/Athens|Europe/Kiev",
				"Europe/Athens|Europe/Mariehamn",
				"Europe/Athens|Europe/Nicosia",
				"Europe/Athens|Europe/Riga",
				"Europe/Athens|Europe/Sofia",
				"Europe/Athens|Europe/Tallinn",
				"Europe/Athens|Europe/Uzhgorod",
				"Europe/Athens|Europe/Vilnius",
				"Europe/Athens|Europe/Zaporozhye",
				"Europe/Chisinau|Europe/Tiraspol",
				"Europe/Dublin|Eire",
				"Europe/Istanbul|Asia/Istanbul",
				"Europe/Istanbul|Turkey",
				"Europe/Lisbon|Atlantic/Canary",
				"Europe/Lisbon|Atlantic/Faeroe",
				"Europe/Lisbon|Atlantic/Faroe",
				"Europe/Lisbon|Atlantic/Madeira",
				"Europe/Lisbon|Portugal",
				"Europe/Lisbon|WET",
				"Europe/London|Europe/Belfast",
				"Europe/London|Europe/Guernsey",
				"Europe/London|Europe/Isle_of_Man",
				"Europe/London|Europe/Jersey",
				"Europe/London|GB",
				"Europe/London|GB-Eire",
				"Europe/Moscow|Europe/Volgograd",
				"Europe/Moscow|W-SU",
				"Europe/Paris|Africa/Ceuta",
				"Europe/Paris|Arctic/Longyearbyen",
				"Europe/Paris|Atlantic/Jan_Mayen",
				"Europe/Paris|CET",
				"Europe/Paris|Europe/Amsterdam",
				"Europe/Paris|Europe/Andorra",
				"Europe/Paris|Europe/Belgrade",
				"Europe/Paris|Europe/Berlin",
				"Europe/Paris|Europe/Bratislava",
				"Europe/Paris|Europe/Brussels",
				"Europe/Paris|Europe/Budapest",
				"Europe/Paris|Europe/Busingen",
				"Europe/Paris|Europe/Copenhagen",
				"Europe/Paris|Europe/Gibraltar",
				"Europe/Paris|Europe/Ljubljana",
				"Europe/Paris|Europe/Luxembourg",
				"Europe/Paris|Europe/Madrid",
				"Europe/Paris|Europe/Malta",
				"Europe/Paris|Europe/Monaco",
				"Europe/Paris|Europe/Oslo",
				"Europe/Paris|Europe/Podgorica",
				"Europe/Paris|Europe/Prague",
				"Europe/Paris|Europe/Rome",
				"Europe/Paris|Europe/San_Marino",
				"Europe/Paris|Europe/Sarajevo",
				"Europe/Paris|Europe/Skopje",
				"Europe/Paris|Europe/Stockholm",
				"Europe/Paris|Europe/Tirane",
				"Europe/Paris|Europe/Vaduz",
				"Europe/Paris|Europe/Vatican",
				"Europe/Paris|Europe/Vienna",
				"Europe/Paris|Europe/Warsaw",
				"Europe/Paris|Europe/Zagreb",
				"Europe/Paris|Europe/Zurich",
				"Europe/Paris|Poland",
				"Pacific/Auckland|Antarctica/McMurdo",
				"Pacific/Auckland|Antarctica/South_Pole",
				"Pacific/Auckland|NZ",
				"Pacific/Chatham|NZ-CHAT",
				"Pacific/Chuuk|Pacific/Truk",
				"Pacific/Chuuk|Pacific/Yap",
				"Pacific/Easter|Chile/EasterIsland",
				"Pacific/Guam|Pacific/Saipan",
				"Pacific/Honolulu|HST",
				"Pacific/Honolulu|Pacific/Johnston",
				"Pacific/Honolulu|US/Hawaii",
				"Pacific/Majuro|Kwajalein",
				"Pacific/Majuro|Pacific/Kwajalein",
				"Pacific/Pago_Pago|Pacific/Midway",
				"Pacific/Pago_Pago|Pacific/Samoa",
				"Pacific/Pago_Pago|US/Samoa",
				"Pacific/Pohnpei|Pacific/Ponape"
			]
		});
	
	
		return moment;
	}));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1581);
	moment.tz.load(__webpack_require__(1460));


/***/ },
/* 401 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(171);
	var Danger = __webpack_require__(1609);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(74);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(411);
	var setInnerHTML = __webpack_require__(293);
	var setTextContent = __webpack_require__(667);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 403 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactErrorUtils = __webpack_require__(409);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 406 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactPropTypesSecret = __webpack_require__(1637);
	var propTypesFactory = __webpack_require__(1666);
	
	var React = __webpack_require__(101);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(102);
	var ReactInstanceMap = __webpack_require__(217);
	var ReactInstrumentation = __webpack_require__(74);
	var ReactUpdates = __webpack_require__(87);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 412 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 413 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var emptyFunction = __webpack_require__(56);
	var warning = __webpack_require__(13);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 419 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(296);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1710);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1707);
	
	var _isActive2 = __webpack_require__(1714);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1711);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1716);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(297);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(683);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1719);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(684);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(685);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(177);
	
	var ReactNoopUpdateQueue = __webpack_require__(425);
	
	var canDefineProperty = __webpack_require__(691);
	var emptyObject = __webpack_require__(196);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(177);
	
	var ReactCurrentOwner = __webpack_require__(102);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(13);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ },
/* 427 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global, process) {'use strict';
	
	exports.__esModule = true;
	var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate : setImmediate;
	var nextTick = process && process.nextTick ? process.nextTick : genericSetImmediate;
	
	var noStorage = process && process.env && ("production") === 'production' ? function () {
	  /* noop */return null;
	} : function () {
	  console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
	  return null;
	};
	
	function hasLocalStorage() {
	  try {
	    return typeof window === 'object' && typeof window.localStorage !== 'undefined';
	  } catch (e) {
	    return false;
	  }
	}
	
	function hasSessionStorage() {
	  try {
	    return typeof window === 'object' && typeof window.sessionStorage !== 'undefined';
	  } catch (e) {
	    return false;
	  }
	}
	
	function getStorage(type) {
	  if (type === 'local') {
	    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	  if (type === 'session') {
	    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	}
	
	exports['default'] = function (type) {
	  var storage = getStorage(type);
	  return {
	    getItem: function getItem(key, cb) {
	      try {
	        var s = storage.getItem(key);
	        nextTick(function () {
	          cb(null, s);
	        });
	      } catch (e) {
	        cb(e);
	      }
	    },
	    setItem: function setItem(key, string, cb) {
	      try {
	        storage.setItem(key, string);
	        nextTick(function () {
	          cb(null);
	        });
	      } catch (e) {
	        cb(e);
	      }
	    },
	    removeItem: function removeItem(key, cb) {
	      try {
	        storage.removeItem(key);
	        nextTick(function () {
	          cb(null);
	        });
	      } catch (e) {
	        cb(e);
	      }
	    },
	    getAllKeys: function getAllKeys(cb) {
	      try {
	        var keys = [];
	        for (var i = 0; i < storage.length; i++) {
	          keys.push(storage.key(i));
	        }
	        nextTick(function () {
	          cb(null, keys);
	        });
	      } catch (e) {
	        cb(e);
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(302).setImmediate, (function() { return this; }()), __webpack_require__(73)))

/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(146);
	
	/*<replacement>*/
	var util = __webpack_require__(195);
	util.inherits = __webpack_require__(137);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(122).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(195);
	util.inherits = __webpack_require__(137);
	/*</replacement>*/
	
	var Stream = __webpack_require__(219);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(146);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(146);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 432 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The four basic intents.
	 */
	var Intent;
	(function (Intent) {
	    Intent[Intent["NONE"] = -1] = "NONE";
	    Intent[Intent["PRIMARY"] = 0] = "PRIMARY";
	    Intent[Intent["SUCCESS"] = 1] = "SUCCESS";
	    Intent[Intent["WARNING"] = 2] = "WARNING";
	    Intent[Intent["DANGER"] = 3] = "DANGER";
	})(Intent = exports.Intent || (exports.Intent = {}));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var position_1 = __webpack_require__(88);
	// per https://github.com/HubSpot/tether/pull/204, Tether now exposes a `bodyElement` option that,
	// when present, gets the tethered element injected into *it* instead of into the document body.
	// but both approaches still cause React to freak out, because it loses its handle on the DOM
	// element. thus, we pass a fake HTML bodyElement to Tether, with a no-op `appendChild` function
	// (the only function the library uses from bodyElement).
	var fakeHtmlElement = {
	    appendChild: function () {
	        /* No-op */
	    },
	};
	/** @internal */
	function createTetherOptions(element, target, position, tetherOptions) {
	    if (tetherOptions === void 0) { tetherOptions = {}; }
	    return tslib_1.__assign({}, tetherOptions, { attachment: getPopoverAttachment(position), bodyElement: fakeHtmlElement, classPrefix: "pt-tether", element: element,
	        target: target, targetAttachment: getTargetAttachment(position) });
	}
	exports.createTetherOptions = createTetherOptions;
	/** @internal */
	function getTargetAttachment(position) {
	    var attachments = (_a = {},
	        _a[position_1.Position.TOP_LEFT] = "top left",
	        _a[position_1.Position.TOP] = "top center",
	        _a[position_1.Position.TOP_RIGHT] = "top right",
	        _a[position_1.Position.RIGHT_TOP] = "top right",
	        _a[position_1.Position.RIGHT] = "middle right",
	        _a[position_1.Position.RIGHT_BOTTOM] = "bottom right",
	        _a[position_1.Position.BOTTOM_RIGHT] = "bottom right",
	        _a[position_1.Position.BOTTOM] = "bottom center",
	        _a[position_1.Position.BOTTOM_LEFT] = "bottom left",
	        _a[position_1.Position.LEFT_BOTTOM] = "bottom left",
	        _a[position_1.Position.LEFT] = "middle left",
	        _a[position_1.Position.LEFT_TOP] = "top left",
	        _a);
	    return attachments[position];
	    var _a;
	}
	exports.getTargetAttachment = getTargetAttachment;
	/** @internal */
	function getPopoverAttachment(position) {
	    var attachments = (_a = {},
	        _a[position_1.Position.TOP_LEFT] = "bottom left",
	        _a[position_1.Position.TOP] = "bottom center",
	        _a[position_1.Position.TOP_RIGHT] = "bottom right",
	        _a[position_1.Position.RIGHT_TOP] = "top left",
	        _a[position_1.Position.RIGHT] = "middle left",
	        _a[position_1.Position.RIGHT_BOTTOM] = "bottom left",
	        _a[position_1.Position.BOTTOM_RIGHT] = "top right",
	        _a[position_1.Position.BOTTOM] = "top center",
	        _a[position_1.Position.BOTTOM_LEFT] = "top left",
	        _a[position_1.Position.LEFT_BOTTOM] = "bottom right",
	        _a[position_1.Position.LEFT] = "middle right",
	        _a[position_1.Position.LEFT_TOP] = "top right",
	        _a);
	    return attachments[position];
	    var _a;
	}
	exports.getPopoverAttachment = getPopoverAttachment;
	/** @internal */
	function getAttachmentClasses(position) {
	    // this essentially reimplements the Tether logic for attachment classes so the same styles
	    // can be reused outside of Tether-based popovers.
	    return expandAttachmentClasses(getPopoverAttachment(position), "pt-tether-element-attached").concat(expandAttachmentClasses(getTargetAttachment(position), "pt-tether-target-attached"));
	}
	exports.getAttachmentClasses = getAttachmentClasses;
	function expandAttachmentClasses(attachments, prefix) {
	    var _a = attachments.split(" "), verticalAlign = _a[0], horizontalAlign = _a[1];
	    return [prefix + "-" + verticalAlign, prefix + "-" + horizontalAlign];
	}


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var _1 = __webpack_require__(75);
	function isDarkTheme(element) {
	    return element.closest("." + _1.Classes.DARK) != null;
	}
	exports.isDarkTheme = isDarkTheme;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var AnimationStates;
	(function (AnimationStates) {
	    AnimationStates[AnimationStates["CLOSED"] = 0] = "CLOSED";
	    AnimationStates[AnimationStates["OPENING"] = 1] = "OPENING";
	    AnimationStates[AnimationStates["OPEN"] = 2] = "OPEN";
	    AnimationStates[AnimationStates["CLOSING_START"] = 3] = "CLOSING_START";
	    AnimationStates[AnimationStates["CLOSING_END"] = 4] = "CLOSING_END";
	})(AnimationStates = exports.AnimationStates || (exports.AnimationStates = {}));
	/*
	 * A collapse can be in one of 5 states:
	 * CLOSED
	 * When in this state, the contents of the collapse is not rendered, the collapse height is 0,
	 * and the body Y is at -height (so that the bottom of the body is at Y=0).
	 *
	 * OPEN
	 * When in this state, the collapse height is set to auto, and the body Y is set to 0 (so the element can be seen
	 * as normal).
	 *
	 * CLOSING_START
	 * When in this state, height has been changed from auto to the measured height of the body to prepare for the
	 * closing animation in CLOSING_END.
	 *
	 * CLOSING_END
	 * When in this state, the height is set to 0 and the body Y is at -height. Both of these properties are transformed,
	 * and then after the animation is complete, the state changes to CLOSED.
	 *
	 * OPENING
	 * When in this state, the body is re-rendered, height is set to the measured body height and the body Y is set to 0.
	 * This is all animated, and on complete, the state changes to OPEN.
	 *
	 * When changing the isOpen prop, the following happens to the states:
	 * isOpen = true : CLOSED -> OPENING -> OPEN
	 * isOpen = false: OPEN -> CLOSING_START -> CLOSING_END -> CLOSED
	 * These are all animated.
	 */
	var Collapse = (function (_super) {
	    tslib_1.__extends(Collapse, _super);
	    function Collapse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            animationState: AnimationStates.OPEN,
	            height: "0px",
	        };
	        // The most recent non-0 height (once a height has been measured - is 0 until then)
	        _this.height = 0;
	        _this.contentsRefHandler = function (el) {
	            _this.contents = el;
	            if (el != null) {
	                _this.height = _this.contents.clientHeight;
	                _this.setState({
	                    animationState: _this.props.isOpen ? AnimationStates.OPEN : AnimationStates.CLOSED,
	                    height: _this.height + "px",
	                });
	            }
	        };
	        return _this;
	    }
	    Collapse.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        if (this.contents != null && this.contents.clientHeight !== 0) {
	            this.height = this.contents.clientHeight;
	        }
	        if (this.props.isOpen !== nextProps.isOpen) {
	            this.clearTimeouts();
	            if (this.state.animationState !== AnimationStates.CLOSED && !nextProps.isOpen) {
	                this.setState({
	                    animationState: AnimationStates.CLOSING_START,
	                    height: this.height + "px",
	                });
	            }
	            else if (this.state.animationState !== AnimationStates.OPEN && nextProps.isOpen) {
	                this.setState({
	                    animationState: AnimationStates.OPENING,
	                    height: this.height + "px",
	                });
	                this.setTimeout(function () { return _this.onDelayedStateChange(); }, this.props.transitionDuration);
	            }
	        }
	    };
	    Collapse.prototype.render = function () {
	        var isContentVisible = this.state.animationState !== AnimationStates.CLOSED;
	        var shouldRenderChildren = isContentVisible || this.props.keepChildrenMounted;
	        var displayWithTransform = isContentVisible && this.state.animationState !== AnimationStates.CLOSING_END;
	        var isAutoHeight = this.state.height === "auto";
	        var containerStyle = {
	            height: isContentVisible ? this.state.height : undefined,
	            overflowY: (isAutoHeight ? "visible" : undefined),
	            transition: isAutoHeight ? "none" : undefined,
	        };
	        var contentsStyle = {
	            transform: displayWithTransform ? "translateY(0)" : "translateY(-" + this.height + "px)",
	            transition: isAutoHeight ? "none" : undefined,
	        };
	        // HACKHACK: type cast because there's no single overload that supports all
	        // three ReactTypes (string | ComponentClass | StatelessComponent)
	        return React.createElement(this.props.component, {
	            className: classNames(Classes.COLLAPSE, this.props.className),
	            style: containerStyle,
	        }, React.createElement("div", { className: "pt-collapse-body", ref: this.contentsRefHandler, style: contentsStyle, "aria-hidden": !isContentVisible && this.props.keepChildrenMounted }, shouldRenderChildren ? this.props.children : null));
	    };
	    Collapse.prototype.componentDidMount = function () {
	        this.forceUpdate();
	        if (this.props.isOpen) {
	            this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
	        }
	        else {
	            this.setState({ animationState: AnimationStates.CLOSED });
	        }
	    };
	    Collapse.prototype.componentDidUpdate = function () {
	        var _this = this;
	        if (this.state.animationState === AnimationStates.CLOSING_START) {
	            this.setTimeout(function () {
	                return _this.setState({
	                    animationState: AnimationStates.CLOSING_END,
	                    height: "0px",
	                });
	            });
	            this.setTimeout(function () { return _this.onDelayedStateChange(); }, this.props.transitionDuration);
	        }
	    };
	    Collapse.prototype.onDelayedStateChange = function () {
	        switch (this.state.animationState) {
	            case AnimationStates.OPENING:
	                this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
	                break;
	            case AnimationStates.CLOSING_END:
	                this.setState({ animationState: AnimationStates.CLOSED });
	                break;
	            default:
	                break;
	        }
	    };
	    Collapse.displayName = "Blueprint.Collapse";
	    Collapse.defaultProps = {
	        component: "div",
	        isOpen: false,
	        keepChildrenMounted: false,
	        transitionDuration: 200,
	    };
	    return Collapse;
	}(abstractComponent_1.AbstractComponent));
	exports.Collapse = Collapse;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var position_1 = __webpack_require__(88);
	var utils_1 = __webpack_require__(21);
	var popover_1 = __webpack_require__(148);
	var TETHER_OPTIONS = {
	    constraints: [{ attachment: "together", pin: true, to: "window" }],
	};
	var TRANSITION_DURATION = 100;
	/* istanbul ignore next */
	var ContextMenu = (function (_super) {
	    tslib_1.__extends(ContextMenu, _super);
	    function ContextMenu() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            isOpen: false,
	        };
	        _this.cancelContextMenu = function (e) { return e.preventDefault(); };
	        _this.handleBackdropContextMenu = function (e) {
	            // React function to remove from the event pool, useful when using a event within a callback
	            e.persist();
	            e.preventDefault();
	            // wait for backdrop to disappear so we can find the "real" element at event coordinates.
	            // timeout duration is equivalent to transition duration so we know it's animated out.
	            _this.setTimeout(function () {
	                // retrigger context menu event at the element beneath the backdrop.
	                // if it has a `contextmenu` event handler then it'll be invoked.
	                // if it doesn't, no native menu will show (at least on OSX) :(
	                var newTarget = document.elementFromPoint(e.clientX, e.clientY);
	                newTarget.dispatchEvent(new MouseEvent("contextmenu", e));
	            }, TRANSITION_DURATION);
	        };
	        _this.handlePopoverInteraction = function (nextOpenState) {
	            if (!nextOpenState) {
	                // delay the actual hiding till the event queue clears
	                // to avoid flicker of opening twice
	                requestAnimationFrame(function () { return _this.hide(); });
	            }
	        };
	        return _this;
	    }
	    ContextMenu.prototype.render = function () {
	        // prevent right-clicking in a context menu
	        var content = React.createElement("div", { onContextMenu: this.cancelContextMenu }, this.state.menu);
	        var popoverClassName = classNames(Classes.MINIMAL, (_a = {}, _a[Classes.DARK] = this.state.isDarkTheme, _a));
	        return (React.createElement(popover_1.Popover, { backdropProps: { onContextMenu: this.handleBackdropContextMenu }, content: content, enforceFocus: false, isModal: true, isOpen: this.state.isOpen, onInteraction: this.handlePopoverInteraction, position: position_1.Position.RIGHT_TOP, popoverClassName: popoverClassName, useSmartArrowPositioning: false, tetherOptions: TETHER_OPTIONS, transitionDuration: TRANSITION_DURATION },
	            React.createElement("div", { className: Classes.CONTEXT_MENU_POPOVER_TARGET, style: this.state.offset })));
	        var _a;
	    };
	    ContextMenu.prototype.show = function (menu, offset, onClose, isDarkTheme) {
	        this.setState({ isOpen: true, menu: menu, offset: offset, onClose: onClose, isDarkTheme: isDarkTheme });
	    };
	    ContextMenu.prototype.hide = function () {
	        utils_1.safeInvoke(this.state.onClose);
	        this.setState({ isOpen: false, onClose: undefined });
	    };
	    return ContextMenu;
	}(abstractComponent_1.AbstractComponent));
	var contextMenu;
	/**
	 * Show the given menu element at the given offset from the top-left corner of the viewport.
	 * The menu will appear below-right of this point and will flip to below-left if there is not enough
	 * room onscreen. The optional callback will be invoked when this menu closes.
	 */
	function show(menu, offset, onClose, isDarkTheme) {
	    if (contextMenu == null) {
	        var contextMenuElement = document.createElement("div");
	        contextMenuElement.classList.add(Classes.CONTEXT_MENU);
	        document.body.appendChild(contextMenuElement);
	        contextMenu = ReactDOM.render(React.createElement(ContextMenu, null), contextMenuElement);
	    }
	    contextMenu.show(menu, offset, onClose, isDarkTheme);
	}
	exports.show = show;
	/** Hide the open context menu. */
	function hide() {
	    if (contextMenu != null) {
	        contextMenu.hide();
	    }
	}
	exports.hide = hide;
	/** Return whether a context menu is currently open. */
	function isOpen() {
	    return contextMenu != null && contextMenu.state.isOpen;
	}
	exports.isOpen = isOpen;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var utils_1 = __webpack_require__(21);
	var icon_1 = __webpack_require__(104);
	var overlay_1 = __webpack_require__(223);
	var Dialog = (function (_super) {
	    tslib_1.__extends(Dialog, _super);
	    function Dialog() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleContainerMouseDown = function (evt) {
	            // quick re-implementation of canOutsideClickClose because .pt-dialog-container covers the backdrop
	            var isClickOutsideDialog = evt.target.closest("." + Classes.DIALOG) == null;
	            if (isClickOutsideDialog && _this.props.canOutsideClickClose) {
	                utils_1.safeInvoke(_this.props.onClose, evt);
	            }
	        };
	        return _this;
	    }
	    Dialog.prototype.render = function () {
	        return (React.createElement(overlay_1.Overlay, tslib_1.__assign({}, this.props, { className: Classes.OVERLAY_SCROLL_CONTAINER, hasBackdrop: true }),
	            React.createElement("div", { className: Classes.DIALOG_CONTAINER, onMouseDown: this.handleContainerMouseDown },
	                React.createElement("div", { className: classNames(Classes.DIALOG, this.props.className), style: this.props.style },
	                    this.maybeRenderHeader(),
	                    this.props.children))));
	    };
	    Dialog.prototype.validateProps = function (props) {
	        if (props.title == null) {
	            if (props.iconName != null) {
	                console.warn(Errors.DIALOG_WARN_NO_HEADER_ICON);
	            }
	            if (props.isCloseButtonShown != null) {
	                console.warn(Errors.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
	            }
	        }
	    };
	    Dialog.prototype.maybeRenderCloseButton = function () {
	        // for now, show close button if prop is undefined or null
	        // this gives us a behavior as if the default value were `true`
	        if (this.props.isCloseButtonShown !== false) {
	            var classes = classNames(Classes.DIALOG_CLOSE_BUTTON, Classes.iconClass("small-cross"));
	            return React.createElement("button", { "aria-label": "Close", className: classes, onClick: this.props.onClose });
	        }
	        else {
	            return undefined;
	        }
	    };
	    Dialog.prototype.maybeRenderHeader = function () {
	        var _a = this.props, iconName = _a.iconName, title = _a.title;
	        if (title == null) {
	            return undefined;
	        }
	        return (React.createElement("div", { className: Classes.DIALOG_HEADER },
	            React.createElement(icon_1.Icon, { iconName: iconName, iconSize: 20 }),
	            React.createElement("h5", null, title),
	            this.maybeRenderCloseButton()));
	    };
	    Dialog.defaultProps = {
	        canOutsideClickClose: true,
	        isOpen: false,
	    };
	    Dialog.displayName = "Blueprint.Dialog";
	    return Dialog;
	}(abstractComponent_1.AbstractComponent));
	exports.Dialog = Dialog;
	exports.DialogFactory = React.createFactory(Dialog);


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	// HACKHACK: these components should go in separate files
	// tslint:disable max-classes-per-file
	// we need some empty interfaces to show up in docs
	// tslint:disable no-empty-interface
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var props_1 = __webpack_require__(147);
	var utils_1 = __webpack_require__(21);
	var INVALID_PROPS = [
	    // we spread props to `<input>` but render `children` as its sibling
	    "children",
	    "defaultIndeterminate",
	    "indeterminate",
	    "labelElement",
	];
	/** Base Component class for all Controls */
	var Control = (function (_super) {
	    tslib_1.__extends(Control, _super);
	    function Control() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // generates control markup for given input type.
	    // optional inputRef in case the component needs reference for itself (don't forget to invoke the prop!).
	    Control.prototype.renderControl = function (type, typeClassName, inputRef) {
	        if (inputRef === void 0) { inputRef = this.props.inputRef; }
	        var className = classNames(Classes.CONTROL, typeClassName, (_a = {},
	            _a[Classes.DISABLED] = this.props.disabled,
	            _a[Classes.INLINE] = this.props.inline,
	            _a), this.props.className);
	        var inputProps = props_1.removeNonHTMLProps(this.props, INVALID_PROPS, true);
	        return (React.createElement("label", { className: className, style: this.props.style },
	            React.createElement("input", tslib_1.__assign({}, inputProps, { ref: inputRef, type: type })),
	            React.createElement("span", { className: Classes.CONTROL_INDICATOR }),
	            this.props.label,
	            this.props.labelElement,
	            this.props.children));
	        var _a;
	    };
	    return Control;
	}(React.Component));
	exports.Control = Control;
	var Checkbox = (function (_super) {
	    tslib_1.__extends(Checkbox, _super);
	    function Checkbox() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleInputRef = function (ref) {
	            _this.input = ref;
	            utils_1.safeInvoke(_this.props.inputRef, ref);
	        };
	        return _this;
	    }
	    Checkbox.prototype.render = function () {
	        return this.renderControl("checkbox", "pt-checkbox", this.handleInputRef);
	    };
	    Checkbox.prototype.componentDidMount = function () {
	        if (this.props.defaultIndeterminate != null) {
	            this.input.indeterminate = this.props.defaultIndeterminate;
	        }
	        this.updateIndeterminate();
	    };
	    Checkbox.prototype.componentDidUpdate = function () {
	        this.updateIndeterminate();
	    };
	    Checkbox.prototype.updateIndeterminate = function () {
	        if (this.props.indeterminate != null) {
	            this.input.indeterminate = this.props.indeterminate;
	        }
	    };
	    Checkbox.displayName = "Blueprint.Checkbox";
	    return Checkbox;
	}(Control));
	exports.Checkbox = Checkbox;
	var Switch = (function (_super) {
	    tslib_1.__extends(Switch, _super);
	    function Switch() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Switch.prototype.render = function () {
	        return this.renderControl("checkbox", "pt-switch");
	    };
	    Switch.displayName = "Blueprint.Switch";
	    return Switch;
	}(Control));
	exports.Switch = Switch;
	var Radio = (function (_super) {
	    tslib_1.__extends(Radio, _super);
	    function Radio() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Radio.prototype.render = function () {
	        return this.renderControl("radio", "pt-radio");
	    };
	    Radio.displayName = "Blueprint.Radio";
	    return Radio;
	}(Control));
	exports.Radio = Radio;
	exports.CheckboxFactory = React.createFactory(Checkbox);
	exports.SwitchFactory = React.createFactory(Switch);
	exports.RadioFactory = React.createFactory(Radio);


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var props_1 = __webpack_require__(147);
	var icon_1 = __webpack_require__(104);
	var InputGroup = (function (_super) {
	    tslib_1.__extends(InputGroup, _super);
	    function InputGroup() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            rightElementWidth: 30,
	        };
	        _this.refHandlers = {
	            rightElement: function (ref) { return (_this.rightElement = ref); },
	        };
	        return _this;
	    }
	    InputGroup.prototype.render = function () {
	        var _a = this.props, className = _a.className, intent = _a.intent, leftIconName = _a.leftIconName;
	        var classes = classNames(Classes.INPUT_GROUP, Classes.intentClass(intent), (_b = {},
	            _b[Classes.DISABLED] = this.props.disabled,
	            _b), className);
	        var style = tslib_1.__assign({}, this.props.style, { paddingRight: this.state.rightElementWidth });
	        return (React.createElement("div", { className: classes },
	            React.createElement(icon_1.Icon, { iconName: leftIconName, iconSize: "inherit" }),
	            React.createElement("input", tslib_1.__assign({ type: "text" }, props_1.removeNonHTMLProps(this.props), { className: Classes.INPUT, ref: this.props.inputRef, style: style })),
	            this.maybeRenderRightElement()));
	        var _b;
	    };
	    InputGroup.prototype.componentDidMount = function () {
	        this.updateInputWidth();
	    };
	    InputGroup.prototype.componentDidUpdate = function () {
	        this.updateInputWidth();
	    };
	    InputGroup.prototype.maybeRenderRightElement = function () {
	        var rightElement = this.props.rightElement;
	        if (rightElement == null) {
	            return undefined;
	        }
	        return (React.createElement("span", { className: "pt-input-action", ref: this.refHandlers.rightElement }, rightElement));
	    };
	    InputGroup.prototype.updateInputWidth = function () {
	        if (this.rightElement != null) {
	            var clientWidth = this.rightElement.clientWidth;
	            // small threshold to prevent infinite loops
	            if (Math.abs(clientWidth - this.state.rightElementWidth) > 2) {
	                this.setState({ rightElementWidth: clientWidth });
	            }
	        }
	        else {
	            this.setState({ rightElementWidth: 0 });
	        }
	    };
	    InputGroup.displayName = "Blueprint.InputGroup";
	    InputGroup = tslib_1.__decorate([
	        PureRender
	    ], InputGroup);
	    return InputGroup;
	}(React.Component));
	exports.InputGroup = InputGroup;
	exports.InputGroupFactory = React.createFactory(InputGroup);


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var errors_1 = __webpack_require__(48);
	var hotkey_1 = __webpack_require__(222);
	var hotkey_2 = __webpack_require__(222);
	exports.Hotkey = hotkey_2.Hotkey;
	var keyCombo_1 = __webpack_require__(442);
	exports.KeyCombo = keyCombo_1.KeyCombo;
	var hotkeysTarget_1 = __webpack_require__(737);
	exports.HotkeysTarget = hotkeysTarget_1.HotkeysTarget;
	var hotkeyParser_1 = __webpack_require__(304);
	exports.comboMatches = hotkeyParser_1.comboMatches;
	exports.getKeyCombo = hotkeyParser_1.getKeyCombo;
	exports.getKeyComboString = hotkeyParser_1.getKeyComboString;
	exports.parseKeyCombo = hotkeyParser_1.parseKeyCombo;
	var hotkeysDialog_1 = __webpack_require__(441);
	exports.hideHotkeysDialog = hotkeysDialog_1.hideHotkeysDialog;
	exports.setHotkeysDialogProps = hotkeysDialog_1.setHotkeysDialogProps;
	var Hotkeys = (function (_super) {
	    tslib_1.__extends(Hotkeys, _super);
	    function Hotkeys() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Hotkeys.prototype.render = function () {
	        var hotkeys = React.Children.map(this.props.children, function (child) { return child.props; });
	        // sort by group label alphabetically, globals first
	        hotkeys.sort(function (a, b) {
	            if (a.global) {
	                return b.global ? 0 : -1;
	            }
	            if (b.global) {
	                return 1;
	            }
	            return a.group.localeCompare(b.group);
	        });
	        var lastGroup = null;
	        var elems = [];
	        for (var _i = 0, hotkeys_1 = hotkeys; _i < hotkeys_1.length; _i++) {
	            var hotkey = hotkeys_1[_i];
	            var groupLabel = hotkey.group;
	            if (groupLabel !== lastGroup) {
	                elems.push(React.createElement("h4", { key: "group-" + elems.length, className: "pt-hotkey-group" }, groupLabel));
	                lastGroup = groupLabel;
	            }
	            elems.push(React.createElement(hotkey_1.Hotkey, tslib_1.__assign({ key: elems.length }, hotkey)));
	        }
	        return React.createElement("div", { className: "pt-hotkey-column" }, elems);
	    };
	    Hotkeys.prototype.validateProps = function (props) {
	        React.Children.forEach(props.children, function (child) {
	            if (!hotkey_1.Hotkey.isInstance(child)) {
	                throw new Error(errors_1.HOTKEYS_HOTKEY_CHILDREN);
	            }
	        });
	    };
	    Hotkeys.defaultProps = {
	        tabIndex: 0,
	    };
	    return Hotkeys;
	}(common_1.AbstractComponent));
	exports.Hotkeys = Hotkeys;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var common_1 = __webpack_require__(75);
	var components_1 = __webpack_require__(443);
	var hotkey_1 = __webpack_require__(222);
	var hotkeys_1 = __webpack_require__(440);
	/**
	 * The delay before showing or hiding the dialog. Should be long enough to
	 * allow all registered hotkey listeners to execute first.
	 */
	var DELAY_IN_MS = 10;
	var HotkeysDialog = (function () {
	    function HotkeysDialog() {
	        var _this = this;
	        this.componentProps = {
	            globalHotkeysGroup: "Global hotkeys",
	        };
	        this.hotkeysQueue = [];
	        this.isDialogShowing = false;
	        this.show = function () {
	            _this.isDialogShowing = true;
	            _this.render();
	        };
	        this.hide = function () {
	            _this.isDialogShowing = false;
	            _this.render();
	        };
	    }
	    HotkeysDialog.prototype.render = function () {
	        if (this.container == null) {
	            this.container = this.getContainer();
	        }
	        ReactDOM.render(this.renderComponent(), this.container);
	    };
	    HotkeysDialog.prototype.unmount = function () {
	        if (this.container != null) {
	            ReactDOM.unmountComponentAtNode(this.container);
	            this.container.remove();
	            delete this.container;
	        }
	    };
	    /**
	     * Because hotkeys can be registered globally and locally and because
	     * event ordering cannot be guaranteed, we use this debouncing method to
	     * allow all hotkey listeners to fire and add their hotkeys to the dialog.
	     *
	     * 10msec after the last listener adds their hotkeys, we render the dialog
	     * and clear the queue.
	     */
	    HotkeysDialog.prototype.enqueueHotkeysForDisplay = function (hotkeys) {
	        this.hotkeysQueue.push(hotkeys);
	        // reset timeout for debounce
	        window.clearTimeout(this.showTimeoutToken);
	        this.showTimeoutToken = window.setTimeout(this.show, DELAY_IN_MS);
	    };
	    HotkeysDialog.prototype.hideAfterDelay = function () {
	        window.clearTimeout(this.hideTimeoutToken);
	        this.hideTimeoutToken = window.setTimeout(this.hide, DELAY_IN_MS);
	    };
	    HotkeysDialog.prototype.isShowing = function () {
	        return this.isDialogShowing;
	    };
	    HotkeysDialog.prototype.getContainer = function () {
	        if (this.container == null) {
	            this.container = document.createElement("div");
	            this.container.classList.add(common_1.Classes.PORTAL);
	            document.body.appendChild(this.container);
	        }
	        return this.container;
	    };
	    HotkeysDialog.prototype.renderComponent = function () {
	        return (React.createElement(components_1.Dialog, tslib_1.__assign({}, this.componentProps, { className: classNames(this.componentProps.className, "pt-hotkey-dialog"), isOpen: this.isDialogShowing, onClose: this.hide }),
	            React.createElement("div", { className: common_1.Classes.DIALOG_BODY }, this.renderHotkeys())));
	    };
	    HotkeysDialog.prototype.renderHotkeys = function () {
	        var _this = this;
	        var hotkeys = this.emptyHotkeyQueue();
	        var elements = hotkeys.map(function (hotkey, index) {
	            var group = hotkey.global === true && hotkey.group == null ? _this.componentProps.globalHotkeysGroup : hotkey.group;
	            return React.createElement(hotkey_1.Hotkey, tslib_1.__assign({ key: index }, hotkey, { group: group }));
	        });
	        return React.createElement(hotkeys_1.Hotkeys, null, elements);
	    };
	    HotkeysDialog.prototype.emptyHotkeyQueue = function () {
	        // flatten then empty the hotkeys queue
	        var hotkeys = this.hotkeysQueue.reduce(function (arr, queued) { return arr.concat(queued); }, []);
	        this.hotkeysQueue.length = 0;
	        return hotkeys;
	    };
	    return HotkeysDialog;
	}());
	// singleton instance
	var HOTKEYS_DIALOG = new HotkeysDialog();
	function isHotkeysDialogShowing() {
	    return HOTKEYS_DIALOG.isShowing();
	}
	exports.isHotkeysDialogShowing = isHotkeysDialogShowing;
	function setHotkeysDialogProps(props) {
	    for (var key in props) {
	        if (props.hasOwnProperty(key)) {
	            HOTKEYS_DIALOG.componentProps[key] = props[key];
	        }
	    }
	}
	exports.setHotkeysDialogProps = setHotkeysDialogProps;
	function showHotkeysDialog(hotkeys) {
	    HOTKEYS_DIALOG.enqueueHotkeysForDisplay(hotkeys);
	}
	exports.showHotkeysDialog = showHotkeysDialog;
	function hideHotkeysDialog() {
	    HOTKEYS_DIALOG.hide();
	}
	exports.hideHotkeysDialog = hideHotkeysDialog;
	/**
	 * Use this function instead of `hideHotkeysDialog` if you need to ensure that all hotkey listeners
	 * have time to execute with the dialog in a consistent open state. This can avoid flickering the
	 * dialog between open and closed states as successive listeners fire.
	 */
	function hideHotkeysDialogAfterDelay() {
	    HOTKEYS_DIALOG.hideAfterDelay();
	}
	exports.hideHotkeysDialogAfterDelay = hideHotkeysDialogAfterDelay;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var hotkeyParser_1 = __webpack_require__(304);
	var KeyIcons = {
	    alt: "pt-icon-key-option",
	    cmd: "pt-icon-key-command",
	    ctrl: "pt-icon-key-control",
	    delete: "pt-icon-key-delete",
	    down: "pt-icon-arrow-down",
	    enter: "pt-icon-key-enter",
	    left: "pt-icon-arrow-left",
	    meta: "pt-icon-key-command",
	    right: "pt-icon-arrow-right",
	    shift: "pt-icon-key-shift",
	    up: "pt-icon-arrow-up",
	};
	var KeyCombo = (function (_super) {
	    tslib_1.__extends(KeyCombo, _super);
	    function KeyCombo() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    KeyCombo.prototype.render = function () {
	        var keys = hotkeyParser_1.normalizeKeyCombo(this.props.combo);
	        var components = [];
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var icon = KeyIcons[key];
	            if (icon != null) {
	                components.push(React.createElement("kbd", { className: "pt-key pt-modifier-key", key: "key-" + i },
	                    React.createElement("span", { className: "pt-icon-standard " + icon }),
	                    key));
	            }
	            else {
	                if (key.length === 1) {
	                    key = key.toUpperCase();
	                }
	                components.push(React.createElement("kbd", { className: "pt-key", key: "key-" + i }, key));
	            }
	        }
	        return React.createElement("span", { className: "pt-key-combo" }, components);
	    };
	    return KeyCombo;
	}(React.Component));
	exports.KeyCombo = KeyCombo;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	if (typeof window !== "undefined" && typeof document !== "undefined") {
	    // we're in browser
	    // tslint:disable-next-line:no-var-requires
	    __webpack_require__(1226); // only import actual dom4 if we're in the browser (not server-compatible)
	    // we'll still need dom4 types for the TypeScript to compile, these are included in package.json
	}
	var contextMenu = __webpack_require__(436);
	exports.ContextMenu = contextMenu;
	tslib_1.__exportStar(__webpack_require__(724), exports);
	tslib_1.__exportStar(__webpack_require__(725), exports);
	tslib_1.__exportStar(__webpack_require__(221), exports);
	tslib_1.__exportStar(__webpack_require__(727), exports);
	tslib_1.__exportStar(__webpack_require__(728), exports);
	tslib_1.__exportStar(__webpack_require__(729), exports);
	tslib_1.__exportStar(__webpack_require__(435), exports);
	tslib_1.__exportStar(__webpack_require__(730), exports);
	tslib_1.__exportStar(__webpack_require__(731), exports);
	tslib_1.__exportStar(__webpack_require__(437), exports);
	tslib_1.__exportStar(__webpack_require__(732), exports);
	tslib_1.__exportStar(__webpack_require__(438), exports);
	tslib_1.__exportStar(__webpack_require__(733), exports);
	tslib_1.__exportStar(__webpack_require__(439), exports);
	tslib_1.__exportStar(__webpack_require__(734), exports);
	tslib_1.__exportStar(__webpack_require__(735), exports);
	tslib_1.__exportStar(__webpack_require__(440), exports);
	tslib_1.__exportStar(__webpack_require__(104), exports);
	tslib_1.__exportStar(__webpack_require__(305), exports);
	tslib_1.__exportStar(__webpack_require__(738), exports);
	tslib_1.__exportStar(__webpack_require__(444), exports);
	tslib_1.__exportStar(__webpack_require__(739), exports);
	tslib_1.__exportStar(__webpack_require__(445), exports);
	tslib_1.__exportStar(__webpack_require__(446), exports);
	tslib_1.__exportStar(__webpack_require__(447), exports);
	tslib_1.__exportStar(__webpack_require__(740), exports);
	tslib_1.__exportStar(__webpack_require__(223), exports);
	tslib_1.__exportStar(__webpack_require__(751), exports);
	tslib_1.__exportStar(__webpack_require__(148), exports);
	tslib_1.__exportStar(__webpack_require__(742), exports);
	tslib_1.__exportStar(__webpack_require__(448), exports);
	tslib_1.__exportStar(__webpack_require__(743), exports);
	tslib_1.__exportStar(__webpack_require__(753), exports);
	tslib_1.__exportStar(__webpack_require__(744), exports);
	tslib_1.__exportStar(__webpack_require__(745), exports);
	tslib_1.__exportStar(__webpack_require__(306), exports);
	tslib_1.__exportStar(__webpack_require__(746), exports);
	tslib_1.__exportStar(__webpack_require__(451), exports);
	tslib_1.__exportStar(__webpack_require__(747), exports);
	tslib_1.__exportStar(__webpack_require__(452), exports);
	tslib_1.__exportStar(__webpack_require__(453), exports);
	tslib_1.__exportStar(__webpack_require__(454), exports);
	tslib_1.__exportStar(__webpack_require__(749), exports);
	tslib_1.__exportStar(__webpack_require__(750), exports);
	tslib_1.__exportStar(__webpack_require__(455), exports);
	tslib_1.__exportStar(__webpack_require__(752), exports);
	tslib_1.__exportStar(__webpack_require__(307), exports);
	tslib_1.__exportStar(__webpack_require__(754), exports);
	tslib_1.__exportStar(__webpack_require__(456), exports);


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var position_1 = __webpack_require__(88);
	var popover_1 = __webpack_require__(148);
	var menu_1 = __webpack_require__(305);
	var REACT_CONTEXT_TYPES = {
	    alignLeft: function (obj, key) {
	        if (obj[key] != null && typeof obj[key] !== "boolean") {
	            return new Error("[Blueprint] MenuItem context alignLeft must be boolean");
	        }
	        return undefined;
	    },
	};
	var MenuItem = (function (_super) {
	    tslib_1.__extends(MenuItem, _super);
	    function MenuItem() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            alignLeft: false,
	        };
	        _this.liRefHandler = function (r) { return (_this.liElement = r); };
	        _this.measureSubmenu = function (el) {
	            if (el != null) {
	                var submenuRect = ReactDOM.findDOMNode(el).getBoundingClientRect();
	                var parentWidth = _this.liElement.parentElement.getBoundingClientRect().width;
	                var adjustmentWidth = submenuRect.width + parentWidth;
	                // this ensures that the left and right measurements represent a submenu opened to the right
	                var submenuLeft = submenuRect.left;
	                var submenuRight = submenuRect.right;
	                if (_this.state.alignLeft) {
	                    submenuLeft += adjustmentWidth;
	                    submenuRight += adjustmentWidth;
	                }
	                var _a = _this.props.submenuViewportMargin.left, left = _a === void 0 ? 0 : _a;
	                var _b = _this.props.submenuViewportMargin.right, right = _b === void 0 ? 0 : _b;
	                if (typeof document !== "undefined" &&
	                    typeof document.documentElement !== "undefined" &&
	                    Number(document.documentElement.clientWidth)) {
	                    // we're in a browser context and the clientWidth is available,
	                    // use it to set calculate 'right'
	                    right = document.documentElement.clientWidth - right;
	                }
	                // uses context to prioritize the previous positioning
	                var alignLeft = _this.context.alignLeft || false;
	                if (alignLeft) {
	                    if (submenuLeft - adjustmentWidth <= left) {
	                        alignLeft = false;
	                    }
	                }
	                else {
	                    if (submenuRight >= right) {
	                        alignLeft = true;
	                    }
	                }
	                _this.setState({ alignLeft: alignLeft });
	            }
	        };
	        _this.renderChildren = function () {
	            var _a = _this.props, children = _a.children, submenu = _a.submenu;
	            if (children != null) {
	                var childProps_1 = _this.cascadeProps();
	                if (Object.keys(childProps_1).length === 0) {
	                    return children;
	                }
	                else {
	                    return React.Children.map(children, function (child) {
	                        return React.cloneElement(child, childProps_1);
	                    });
	                }
	            }
	            else if (submenu != null) {
	                return submenu.map(_this.cascadeProps).map(renderMenuItem);
	            }
	            else {
	                return undefined;
	            }
	        };
	        /**
	         * Evalutes this.props and cascades prop values into new props when:
	         * - submenuViewportMargin is defined, but is undefined for the supplied input.
	         * - useSmartPositioning is false, but is undefined for the supplied input.
	         * @param {IMenuItemProps} newProps If supplied, object will be modified, otherwise, defaults to an empty object.
	         * @returns An object to be used as child props.
	         */
	        _this.cascadeProps = function (newProps) {
	            if (newProps === void 0) { newProps = {}; }
	            var _a = _this.props, submenuViewportMargin = _a.submenuViewportMargin, useSmartPositioning = _a.useSmartPositioning;
	            if (submenuViewportMargin != null && newProps.submenuViewportMargin == null) {
	                newProps.submenuViewportMargin = submenuViewportMargin;
	            }
	            if (useSmartPositioning === false && newProps.useSmartPositioning == null) {
	                newProps.useSmartPositioning = useSmartPositioning;
	            }
	            return newProps;
	        };
	        return _this;
	    }
	    MenuItem.prototype.render = function () {
	        var _a = this.props, children = _a.children, disabled = _a.disabled, label = _a.label, submenu = _a.submenu, popoverProps = _a.popoverProps;
	        var hasSubmenu = children != null || submenu != null;
	        var liClasses = classNames((_b = {},
	            _b[Classes.MENU_SUBMENU] = hasSubmenu,
	            _b));
	        var anchorClasses = classNames(Classes.MENU_ITEM, Classes.intentClass(this.props.intent), (_c = {},
	            _c[Classes.DISABLED] = disabled,
	            // prevent popover from closing when clicking on submenu trigger or disabled item
	            _c[Classes.POPOVER_DISMISS] = this.props.shouldDismissPopover && !disabled && !hasSubmenu,
	            _c), Classes.iconClass(this.props.iconName), this.props.className);
	        var labelElement;
	        if (label != null) {
	            labelElement = React.createElement("span", { className: "pt-menu-item-label" }, label);
	        }
	        var content = (React.createElement("a", { className: anchorClasses, href: disabled ? undefined : this.props.href, onClick: disabled ? undefined : this.props.onClick, tabIndex: disabled ? undefined : 0, target: this.props.target },
	            labelElement,
	            this.props.text));
	        if (hasSubmenu) {
	            var measureSubmenu = this.props.useSmartPositioning ? this.measureSubmenu : null;
	            var submenuElement = React.createElement(menu_1.Menu, { ref: measureSubmenu }, this.renderChildren());
	            var popoverClasses = classNames(Classes.MINIMAL, Classes.MENU_SUBMENU, popoverProps.popoverClassName, (_d = {},
	                _d[Classes.ALIGN_LEFT] = this.state.alignLeft,
	                _d));
	            content = (React.createElement(popover_1.Popover, tslib_1.__assign({ isDisabled: disabled, enforceFocus: false, hoverCloseDelay: 0, inline: true, interactionKind: popover_1.PopoverInteractionKind.HOVER, position: this.state.alignLeft ? position_1.Position.LEFT_TOP : position_1.Position.RIGHT_TOP, useSmartArrowPositioning: false }, popoverProps, { content: submenuElement, popoverClassName: popoverClasses }), content));
	        }
	        return (React.createElement("li", { className: liClasses, ref: this.liRefHandler }, content));
	        var _b, _c, _d;
	    };
	    MenuItem.prototype.getChildContext = function () {
	        return { alignLeft: this.state.alignLeft };
	    };
	    MenuItem.prototype.validateProps = function (props) {
	        if (props.children != null && props.submenu != null) {
	            console.warn(Errors.MENU_WARN_CHILDREN_SUBMENU_MUTEX);
	        }
	    };
	    MenuItem.defaultProps = {
	        disabled: false,
	        popoverProps: {},
	        shouldDismissPopover: true,
	        submenuViewportMargin: {},
	        text: "",
	        useSmartPositioning: true,
	    };
	    MenuItem.displayName = "Blueprint.MenuItem";
	    MenuItem.contextTypes = REACT_CONTEXT_TYPES;
	    MenuItem.childContextTypes = REACT_CONTEXT_TYPES;
	    return MenuItem;
	}(abstractComponent_1.AbstractComponent));
	exports.MenuItem = MenuItem;
	function renderMenuItem(props, key) {
	    return React.createElement(MenuItem, tslib_1.__assign({ key: key }, props));
	}
	exports.renderMenuItem = renderMenuItem;
	exports.MenuItemFactory = React.createFactory(MenuItem);


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	// this component is simple enough that tests would be purely tautological.
	/* istanbul ignore next */
	var NavbarDivider = (function (_super) {
	    tslib_1.__extends(NavbarDivider, _super);
	    function NavbarDivider() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NavbarDivider.prototype.render = function () {
	        var _a = this.props, className = _a.className, htmlProps = tslib_1.__rest(_a, ["className"]);
	        return React.createElement("div", tslib_1.__assign({ className: classNames(Classes.NAVBAR_DIVIDER, className) }, htmlProps));
	    };
	    NavbarDivider.displayName = "Blueprint.NavbarDivider";
	    NavbarDivider = tslib_1.__decorate([
	        PureRender
	    ], NavbarDivider);
	    return NavbarDivider;
	}(React.Component));
	exports.NavbarDivider = NavbarDivider;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	// this component is simple enough that tests would be purely tautological.
	/* istanbul ignore next */
	var NavbarGroup = (function (_super) {
	    tslib_1.__extends(NavbarGroup, _super);
	    function NavbarGroup() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NavbarGroup.prototype.render = function () {
	        var _a = this.props, align = _a.align, children = _a.children, propsClassName = _a.className, htmlProps = tslib_1.__rest(_a, ["align", "children", "className"]);
	        var className = classNames(Classes.NAVBAR_GROUP, (_b = {},
	            _b[Classes.ALIGN_LEFT] = align === "left",
	            _b[Classes.ALIGN_RIGHT] = align === "right",
	            _b), propsClassName);
	        return (React.createElement("div", tslib_1.__assign({ className: className }, htmlProps), children));
	        var _b;
	    };
	    NavbarGroup.displayName = "Blueprint.NavbarGroup";
	    NavbarGroup.defaultProps = {
	        align: "left",
	    };
	    NavbarGroup = tslib_1.__decorate([
	        PureRender
	    ], NavbarGroup);
	    return NavbarGroup;
	}(React.Component));
	exports.NavbarGroup = NavbarGroup;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	// this component is simple enough that tests would be purely tautological.
	/* istanbul ignore next */
	var NavbarHeading = (function (_super) {
	    tslib_1.__extends(NavbarHeading, _super);
	    function NavbarHeading() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NavbarHeading.prototype.render = function () {
	        var _a = this.props, children = _a.children, className = _a.className, htmlProps = tslib_1.__rest(_a, ["children", "className"]);
	        return (React.createElement("div", tslib_1.__assign({ className: classNames(Classes.NAVBAR_HEADING, className) }, htmlProps), children));
	    };
	    NavbarHeading.displayName = "Blueprint.NavbarHeading";
	    NavbarHeading = tslib_1.__decorate([
	        PureRender
	    ], NavbarHeading);
	    return NavbarHeading;
	}(React.Component));
	exports.NavbarHeading = NavbarHeading;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var props_1 = __webpack_require__(147);
	var utils_1 = __webpack_require__(21);
	var REACT_CONTEXT_TYPES = {
	    blueprintPortalClassName: function (obj, key) {
	        if (obj[key] != null && typeof obj[key] !== "string") {
	            return new Error(Errors.PORTAL_CONTEXT_CLASS_NAME_STRING);
	        }
	        return undefined;
	    },
	};
	/**
	 * This component detaches its contents and re-attaches them to document.body.
	 * Use it when you need to circumvent DOM z-stacking (for dialogs, popovers, etc.).
	 * Any class names passed to this element will be propagated to the new container element on document.body.
	 */
	var Portal = (function (_super) {
	    tslib_1.__extends(Portal, _super);
	    function Portal() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Portal.prototype.render = function () {
	        return null;
	    };
	    Portal.prototype.componentDidMount = function () {
	        var targetElement = document.createElement("div");
	        targetElement.classList.add(Classes.PORTAL);
	        if (this.context.blueprintPortalClassName != null) {
	            targetElement.classList.add(this.context.blueprintPortalClassName);
	        }
	        document.body.appendChild(targetElement);
	        this.targetElement = targetElement;
	        this.componentDidUpdate();
	    };
	    Portal.prototype.componentDidUpdate = function () {
	        var _this = this;
	        // use special render function to preserve React context, in case children need it
	        ReactDOM.unstable_renderSubtreeIntoContainer(
	        /* parentComponent */ this, React.createElement("div", tslib_1.__assign({}, props_1.removeNonHTMLProps(this.props), { ref: this.props.containerRef }), this.props.children), this.targetElement, function () { return utils_1.safeInvoke(_this.props.onChildrenMount); });
	    };
	    Portal.prototype.componentWillUnmount = function () {
	        ReactDOM.unmountComponentAtNode(this.targetElement);
	        this.targetElement.remove();
	    };
	    Portal.displayName = "Blueprint.Portal";
	    Portal.contextTypes = REACT_CONTEXT_TYPES;
	    return Portal;
	}(React.Component));
	exports.Portal = Portal;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var utils_1 = __webpack_require__(21);
	var CoreSlider = (function (_super) {
	    tslib_1.__extends(CoreSlider, _super);
	    function CoreSlider(props) {
	        var _this = _super.call(this, props) || this;
	        _this.className = Classes.SLIDER;
	        _this.refHandlers = {
	            track: function (el) { return (_this.trackElement = el); },
	        };
	        _this.maybeHandleTrackClick = function (event) {
	            if (_this.canHandleTrackEvent(event)) {
	                _this.handleTrackClick(event);
	            }
	        };
	        _this.maybeHandleTrackTouch = function (event) {
	            if (_this.canHandleTrackEvent(event)) {
	                _this.handleTrackTouch(event);
	            }
	        };
	        _this.canHandleTrackEvent = function (event) {
	            var target = event.target;
	            // ensure event does not come from inside the handle
	            return !_this.props.disabled && target.closest("." + Classes.SLIDER_HANDLE) == null;
	        };
	        _this.state = {
	            labelPrecision: _this.getLabelPrecision(props),
	            tickSize: 0,
	        };
	        return _this;
	    }
	    CoreSlider.prototype.render = function () {
	        var classes = classNames(this.className, (_a = {},
	            _a[Classes.DISABLED] = this.props.disabled,
	            _a[Classes.SLIDER + "-unlabeled"] = this.props.renderLabel === false,
	            _a[Classes.VERTICAL] = this.props.vertical,
	            _a), this.props.className);
	        return (React.createElement("div", { className: classes, onMouseDown: this.maybeHandleTrackClick, onTouchStart: this.maybeHandleTrackTouch },
	            React.createElement("div", { className: Classes.SLIDER + "-track", ref: this.refHandlers.track }),
	            this.maybeRenderFill(),
	            this.maybeRenderAxis(),
	            this.renderHandles()));
	        var _a;
	    };
	    CoreSlider.prototype.componentDidMount = function () {
	        this.updateTickSize();
	    };
	    CoreSlider.prototype.componentDidUpdate = function () {
	        this.updateTickSize();
	    };
	    CoreSlider.prototype.componentWillReceiveProps = function (props) {
	        _super.prototype.componentWillReceiveProps.call(this, props);
	        this.setState({ labelPrecision: this.getLabelPrecision(props) });
	    };
	    CoreSlider.prototype.formatLabel = function (value) {
	        var renderLabel = this.props.renderLabel;
	        if (renderLabel === false) {
	            return undefined;
	        }
	        else if (utils_1.isFunction(renderLabel)) {
	            return renderLabel(value);
	        }
	        else {
	            return value.toFixed(this.state.labelPrecision);
	        }
	    };
	    CoreSlider.prototype.validateProps = function (props) {
	        if (props.stepSize <= 0) {
	            throw new Error(Errors.SLIDER_ZERO_STEP);
	        }
	        if (props.labelStepSize <= 0) {
	            throw new Error(Errors.SLIDER_ZERO_LABEL_STEP);
	        }
	    };
	    CoreSlider.prototype.getTrackInitialPixel = function () {
	        if (this.trackElement == null) {
	            return undefined;
	        }
	        var trackRect = this.trackElement.getBoundingClientRect();
	        // for vertical tracks, the initial (lowest-`value`) pixel is on the bottom.
	        return this.props.vertical ? trackRect.top + trackRect.height : trackRect.left;
	    };
	    CoreSlider.prototype.maybeRenderAxis = function () {
	        // explicit typedefs are required because tsc (rightly) assumes that props might be overriden with different
	        // types in subclasses
	        var max = this.props.max;
	        var min = this.props.min;
	        var labelStepSize = this.props.labelStepSize;
	        if (this.props.renderLabel === false) {
	            return undefined;
	        }
	        var stepSize = Math.round(this.state.tickSize * labelStepSize);
	        var labels = [];
	        // tslint:disable-next-line:one-variable-per-declaration ban-comma-operator
	        for (var i = min, offset = 0; i < max || utils_1.approxEqual(i, max); i += labelStepSize, offset += stepSize) {
	            var style = this.props.vertical ? { bottom: offset } : { left: offset };
	            labels.push(React.createElement("div", { className: Classes.SLIDER + "-label", key: i, style: style }, this.formatLabel(i)));
	        }
	        return React.createElement("div", { className: Classes.SLIDER + "-axis" }, labels);
	    };
	    CoreSlider.prototype.maybeRenderFill = function () {
	        if (this.props.showTrackFill && this.trackElement != null) {
	            return this.renderFill();
	        }
	        return undefined;
	    };
	    CoreSlider.prototype.getLabelPrecision = function (_a) {
	        var labelPrecision = _a.labelPrecision, stepSize = _a.stepSize;
	        // infer default label precision from stepSize because that's how much the handle moves.
	        return labelPrecision == null ? utils_1.countDecimalPlaces(stepSize) : labelPrecision;
	    };
	    CoreSlider.prototype.updateTickSize = function () {
	        if (this.trackElement != null) {
	            var trackSize = this.props.vertical ? this.trackElement.clientHeight : this.trackElement.clientWidth;
	            var tickSize = trackSize / (this.props.max - this.props.min);
	            this.setState({ tickSize: tickSize });
	        }
	    };
	    CoreSlider = tslib_1.__decorate([
	        PureRender
	    ], CoreSlider);
	    return CoreSlider;
	}(abstractComponent_1.AbstractComponent));
	exports.CoreSlider = CoreSlider;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Keys = __webpack_require__(103);
	var utils_1 = __webpack_require__(21);
	// props that require number values, for validation
	var NUMBER_PROPS = ["max", "min", "stepSize", "tickSize", "value"];
	var Handle = (function (_super) {
	    tslib_1.__extends(Handle, _super);
	    function Handle() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            isMoving: false,
	        };
	        _this.refHandlers = {
	            handle: function (el) { return (_this.handleElement = el); },
	        };
	        _this.beginHandleMovement = function (event) {
	            document.addEventListener("mousemove", _this.handleHandleMovement);
	            document.addEventListener("mouseup", _this.endHandleMovement);
	            _this.setState({ isMoving: true });
	            _this.changeValue(_this.clientToValue(_this.mouseEventClientOffset(event)));
	        };
	        _this.beginHandleTouchMovement = function (event) {
	            document.addEventListener("touchmove", _this.handleHandleTouchMovement);
	            document.addEventListener("touchend", _this.endHandleTouchMovement);
	            document.addEventListener("touchcancel", _this.endHandleTouchMovement);
	            _this.setState({ isMoving: true });
	            _this.changeValue(_this.clientToValue(_this.touchEventClientOffset(event)));
	        };
	        _this.endHandleMovement = function (event) {
	            _this.handleMoveEndedAt(_this.mouseEventClientOffset(event));
	        };
	        _this.endHandleTouchMovement = function (event) {
	            _this.handleMoveEndedAt(_this.touchEventClientOffset(event));
	        };
	        _this.handleMoveEndedAt = function (clientPixel) {
	            _this.removeDocumentEventListeners();
	            _this.setState({ isMoving: false });
	            // not using changeValue because we want to invoke the handler regardless of current prop value
	            var onRelease = _this.props.onRelease;
	            var finalValue = _this.clamp(_this.clientToValue(clientPixel));
	            utils_1.safeInvoke(onRelease, finalValue);
	        };
	        _this.handleHandleMovement = function (event) {
	            _this.handleMovedTo(_this.mouseEventClientOffset(event));
	        };
	        _this.handleHandleTouchMovement = function (event) {
	            _this.handleMovedTo(_this.touchEventClientOffset(event));
	        };
	        _this.handleMovedTo = function (clientPixel) {
	            if (_this.state.isMoving && !_this.props.disabled) {
	                _this.changeValue(_this.clientToValue(clientPixel));
	            }
	        };
	        _this.handleKeyDown = function (event) {
	            var _a = _this.props, stepSize = _a.stepSize, value = _a.value;
	            var which = event.which;
	            if (which === Keys.ARROW_DOWN || which === Keys.ARROW_LEFT) {
	                _this.changeValue(value - stepSize);
	                // this key event has been handled! prevent browser scroll on up/down
	                event.preventDefault();
	            }
	            else if (which === Keys.ARROW_UP || which === Keys.ARROW_RIGHT) {
	                _this.changeValue(value + stepSize);
	                event.preventDefault();
	            }
	        };
	        _this.handleKeyUp = function (event) {
	            if ([Keys.ARROW_UP, Keys.ARROW_DOWN, Keys.ARROW_LEFT, Keys.ARROW_RIGHT].indexOf(event.which) >= 0) {
	                utils_1.safeInvoke(_this.props.onRelease, _this.props.value);
	            }
	        };
	        return _this;
	    }
	    Handle.prototype.render = function () {
	        var _a = this.props, className = _a.className, disabled = _a.disabled, label = _a.label, min = _a.min, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
	        var isMoving = this.state.isMoving;
	        var handleMidpoint = this.getHandleMidpointAndOffset(this.handleElement, true).handleMidpoint;
	        var offset = Math.round((value - min) * tickSize - handleMidpoint);
	        var style = vertical ? { bottom: offset } : { left: offset };
	        return (React.createElement("span", { className: classNames(Classes.SLIDER_HANDLE, (_b = {}, _b[Classes.ACTIVE] = isMoving, _b), className), onKeyDown: disabled ? null : this.handleKeyDown, onKeyUp: disabled ? null : this.handleKeyUp, onMouseDown: disabled ? null : this.beginHandleMovement, onTouchStart: disabled ? null : this.beginHandleTouchMovement, ref: this.refHandlers.handle, style: style, tabIndex: 0 }, label == null ? null : React.createElement("span", { className: Classes.SLIDER_LABEL }, label)));
	        var _b;
	    };
	    Handle.prototype.componentWillUnmount = function () {
	        this.removeDocumentEventListeners();
	    };
	    /** Convert client pixel to value between min and max. */
	    Handle.prototype.clientToValue = function (clientPixel) {
	        var _a = this.props, stepSize = _a.stepSize, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
	        if (this.handleElement == null) {
	            return value;
	        }
	        // #1769: this logic doesn't work perfectly when the tick size is
	        // smaller than the handle size; it may be off by a tick or two.
	        var clientPixelNormalized = vertical ? window.innerHeight - clientPixel : clientPixel;
	        var handleCenterPixel = this.getHandleElementCenterPixel(this.handleElement);
	        var pixelDelta = clientPixelNormalized - handleCenterPixel;
	        // convert pixels to range value in increments of `stepSize`
	        var valueDelta = Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
	        return value + valueDelta;
	    };
	    Handle.prototype.mouseEventClientOffset = function (event) {
	        return this.props.vertical ? event.clientY : event.clientX;
	    };
	    Handle.prototype.touchEventClientOffset = function (event) {
	        var touch = event.changedTouches[0];
	        return this.props.vertical ? touch.clientY : touch.clientX;
	    };
	    Handle.prototype.validateProps = function (props) {
	        for (var _i = 0, NUMBER_PROPS_1 = NUMBER_PROPS; _i < NUMBER_PROPS_1.length; _i++) {
	            var prop = NUMBER_PROPS_1[_i];
	            if (typeof props[prop] !== "number") {
	                throw new Error("[Blueprint] <Handle> requires number value for " + prop + " prop");
	            }
	        }
	    };
	    /** Clamp value and invoke callback if it differs from current value */
	    Handle.prototype.changeValue = function (newValue, callback) {
	        if (callback === void 0) { callback = this.props.onChange; }
	        newValue = this.clamp(newValue);
	        if (!isNaN(newValue) && this.props.value !== newValue) {
	            utils_1.safeInvoke(callback, newValue);
	        }
	    };
	    /** Clamp value between min and max props */
	    Handle.prototype.clamp = function (value) {
	        return utils_1.clamp(value, this.props.min, this.props.max);
	    };
	    Handle.prototype.getHandleElementCenterPixel = function (handleElement) {
	        var _a = this.getHandleMidpointAndOffset(handleElement), handleMidpoint = _a.handleMidpoint, handleOffset = _a.handleOffset;
	        return handleOffset + handleMidpoint;
	    };
	    Handle.prototype.getHandleMidpointAndOffset = function (handleElement, useOppositeDimension) {
	        if (useOppositeDimension === void 0) { useOppositeDimension = false; }
	        if (handleElement == null) {
	            return { handleMidpoint: 0, handleOffset: 0 };
	        }
	        var vertical = this.props.vertical;
	        // getBoundingClientRect().height includes border size; clientHeight does not.
	        var handleRect = handleElement.getBoundingClientRect();
	        var sizeKey = vertical
	            ? useOppositeDimension ? "width" : "height"
	            : useOppositeDimension ? "height" : "width";
	        // "bottom" value seems to be consistently incorrect, so explicitly
	        // calculate it using the window offset instead.
	        var handleOffset = vertical ? window.innerHeight - (handleRect.top + handleRect[sizeKey]) : handleRect.left;
	        return { handleMidpoint: handleRect[sizeKey] / 2, handleOffset: handleOffset };
	    };
	    Handle.prototype.removeDocumentEventListeners = function () {
	        document.removeEventListener("mousemove", this.handleHandleMovement);
	        document.removeEventListener("mouseup", this.endHandleMovement);
	        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
	        document.removeEventListener("touchend", this.endHandleTouchMovement);
	        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
	    };
	    Handle.displayName = "Blueprint.SliderHandle";
	    Handle = tslib_1.__decorate([
	        PureRender
	    ], Handle);
	    return Handle;
	}(abstractComponent_1.AbstractComponent));
	exports.Handle = Handle;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Tab = (function (_super) {
	    tslib_1.__extends(Tab, _super);
	    function Tab() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Tab.prototype.render = function () {
	        return (React.createElement("li", { "aria-controls": this.props.panelId, "aria-disabled": this.props.isDisabled, "aria-expanded": this.props.isSelected, "aria-selected": this.props.isSelected, className: classNames(Classes.TAB, this.props.className), id: this.props.id, role: "tab", tabIndex: this.props.isDisabled ? null : 0 }, this.props.children));
	    };
	    Tab.defaultProps = {
	        isDisabled: false,
	        isSelected: false,
	    };
	    Tab.displayName = "Blueprint.Tab";
	    Tab = tslib_1.__decorate([
	        PureRender
	    ], Tab);
	    return Tab;
	}(React.Component));
	exports.Tab = Tab;
	exports.TabFactory = React.createFactory(Tab);


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var TabList = (function (_super) {
	    tslib_1.__extends(TabList, _super);
	    function TabList() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            shouldAnimate: false,
	        };
	        return _this;
	    }
	    TabList.prototype.render = function () {
	        return (React.createElement("ul", { className: classNames(Classes.TAB_LIST, this.props.className), role: "tablist" },
	            React.createElement("div", { className: classNames("pt-tab-indicator-wrapper", { "pt-no-animation": !this.state.shouldAnimate }), style: this.props.indicatorWrapperStyle },
	                React.createElement("div", { className: "pt-tab-indicator" })),
	            this.props.children));
	    };
	    TabList.prototype.componentDidUpdate = function (prevProps) {
	        var _this = this;
	        if (prevProps.indicatorWrapperStyle == null) {
	            this.setTimeout(function () { return _this.setState({ shouldAnimate: true }); });
	        }
	    };
	    TabList.displayName = "Blueprint.TabList";
	    TabList = tslib_1.__decorate([
	        PureRender
	    ], TabList);
	    return TabList;
	}(abstractComponent_1.AbstractComponent));
	exports.TabList = TabList;
	exports.TabListFactory = React.createFactory(TabList);


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var TabPanel = (function (_super) {
	    tslib_1.__extends(TabPanel, _super);
	    function TabPanel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TabPanel.prototype.render = function () {
	        return (React.createElement("div", { "aria-labelledby": this.props._tabId, className: classNames(Classes.TAB_PANEL, this.props.className), id: this.props._id, role: "tabpanel" }, this.props.children));
	    };
	    TabPanel.displayName = "Blueprint.TabPanel";
	    TabPanel = tslib_1.__decorate([
	        PureRender
	    ], TabPanel);
	    return TabPanel;
	}(React.Component));
	exports.TabPanel = TabPanel;
	exports.TabPanelFactory = React.createFactory(TabPanel);


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Tab2 = (function (_super) {
	    tslib_1.__extends(Tab2, _super);
	    function Tab2() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // this component is never rendered directly; see Tabs2#renderTabPanel()
	    /* istanbul ignore next */
	    Tab2.prototype.render = function () {
	        var _a = this.props, className = _a.className, panel = _a.panel;
	        return (React.createElement("div", { className: classNames(Classes.TAB_PANEL, className), role: "tablist" }, panel));
	    };
	    Tab2.defaultProps = {
	        disabled: false,
	        id: undefined,
	    };
	    Tab2.displayName = "Blueprint.Tab2";
	    Tab2 = tslib_1.__decorate([
	        PureRender
	    ], Tab2);
	    return Tab2;
	}(React.Component));
	exports.Tab2 = Tab2;
	exports.Tab2Factory = React.createFactory(Tab2);


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	var buttons_1 = __webpack_require__(221);
	var icon_1 = __webpack_require__(104);
	var Toast = (function (_super) {
	    tslib_1.__extends(Toast, _super);
	    function Toast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleActionClick = function (e) {
	            utils_1.safeInvoke(_this.props.action.onClick, e);
	            _this.triggerDismiss(false);
	        };
	        _this.handleCloseClick = function () { return _this.triggerDismiss(false); };
	        _this.startTimeout = function () {
	            if (_this.props.timeout > 0) {
	                _this.setTimeout(function () { return _this.triggerDismiss(true); }, _this.props.timeout);
	            }
	        };
	        return _this;
	    }
	    Toast.prototype.render = function () {
	        var _a = this.props, className = _a.className, iconName = _a.iconName, intent = _a.intent, message = _a.message;
	        return (React.createElement("div", { className: classNames(Classes.TOAST, Classes.intentClass(intent), className), onBlur: this.startTimeout, onFocus: this.clearTimeouts, onMouseEnter: this.clearTimeouts, onMouseLeave: this.startTimeout, tabIndex: 0 },
	            React.createElement(icon_1.Icon, { iconName: iconName }),
	            React.createElement("span", { className: Classes.TOAST_MESSAGE }, message),
	            React.createElement("div", { className: classNames(Classes.BUTTON_GROUP, Classes.MINIMAL) },
	                this.maybeRenderActionButton(),
	                React.createElement(buttons_1.Button, { iconName: "cross", onClick: this.handleCloseClick }))));
	    };
	    Toast.prototype.componentDidMount = function () {
	        this.startTimeout();
	    };
	    Toast.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.timeout <= 0 && this.props.timeout > 0) {
	            this.startTimeout();
	        }
	        else if (prevProps.timeout > 0 && this.props.timeout <= 0) {
	            this.clearTimeouts();
	        }
	    };
	    Toast.prototype.componentWillUnmount = function () {
	        this.clearTimeouts();
	    };
	    Toast.prototype.maybeRenderActionButton = function () {
	        var action = this.props.action;
	        if (action == null) {
	            return undefined;
	        }
	        else {
	            return React.createElement(buttons_1.AnchorButton, tslib_1.__assign({}, action, { intent: undefined, onClick: this.handleActionClick }));
	        }
	    };
	    Toast.prototype.triggerDismiss = function (didTimeoutExpire) {
	        utils_1.safeInvoke(this.props.onDismiss, didTimeoutExpire);
	        this.clearTimeouts();
	    };
	    Toast.defaultProps = {
	        className: "",
	        message: "",
	        timeout: 5000,
	    };
	    Toast.displayName = "Blueprint.Toast";
	    Toast = tslib_1.__decorate([
	        PureRender
	    ], Toast);
	    return Toast;
	}(abstractComponent_1.AbstractComponent));
	exports.Toast = Toast;
	exports.ToastFactory = React.createFactory(Toast);


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	var collapse_1 = __webpack_require__(435);
	var icon_1 = __webpack_require__(104);
	var TreeNode = (function (_super) {
	    tslib_1.__extends(TreeNode, _super);
	    function TreeNode() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleCaretClick = function (e) {
	            e.stopPropagation();
	            var _a = _this.props, isExpanded = _a.isExpanded, onCollapse = _a.onCollapse, onExpand = _a.onExpand;
	            utils_1.safeInvoke(isExpanded ? onCollapse : onExpand, _this, e);
	        };
	        _this.handleClick = function (e) {
	            utils_1.safeInvoke(_this.props.onClick, _this, e);
	        };
	        _this.handleContentRef = function (element) {
	            utils_1.safeInvoke(_this.props.contentRef, _this, element);
	        };
	        _this.handleContextMenu = function (e) {
	            utils_1.safeInvoke(_this.props.onContextMenu, _this, e);
	        };
	        _this.handleDoubleClick = function (e) {
	            utils_1.safeInvoke(_this.props.onDoubleClick, _this, e);
	        };
	        return _this;
	    }
	    TreeNode.prototype.render = function () {
	        var _a = this.props, children = _a.children, className = _a.className, hasCaret = _a.hasCaret, iconName = _a.iconName, isExpanded = _a.isExpanded, isSelected = _a.isSelected, label = _a.label;
	        var showCaret = hasCaret == null ? React.Children.count(children) > 0 : hasCaret;
	        var caretClass = showCaret ? Classes.TREE_NODE_CARET : Classes.TREE_NODE_CARET_NONE;
	        var caretStateClass = isExpanded ? Classes.TREE_NODE_CARET_OPEN : Classes.TREE_NODE_CARET_CLOSED;
	        var caretClasses = classNames(caretClass, Classes.ICON_STANDARD, (_b = {},
	            _b[caretStateClass] = showCaret,
	            _b));
	        var classes = classNames(Classes.TREE_NODE, (_c = {},
	            _c[Classes.TREE_NODE_SELECTED] = isSelected,
	            _c[Classes.TREE_NODE_EXPANDED] = isExpanded,
	            _c), className);
	        var contentClasses = classNames(Classes.TREE_NODE_CONTENT, "pt-tree-node-content-" + this.props.depth);
	        return (React.createElement("li", { className: classes },
	            React.createElement("div", { className: contentClasses, onClick: this.handleClick, onContextMenu: this.handleContextMenu, onDoubleClick: this.handleDoubleClick, ref: this.handleContentRef },
	                React.createElement("span", { className: caretClasses, onClick: showCaret ? this.handleCaretClick : null }),
	                React.createElement(icon_1.Icon, { className: Classes.TREE_NODE_ICON, iconName: iconName }),
	                React.createElement("span", { className: Classes.TREE_NODE_LABEL }, label),
	                this.maybeRenderSecondaryLabel()),
	            React.createElement(collapse_1.Collapse, { isOpen: isExpanded }, children)));
	        var _b, _c;
	    };
	    TreeNode.prototype.maybeRenderSecondaryLabel = function () {
	        if (this.props.secondaryLabel != null) {
	            return React.createElement("span", { className: Classes.TREE_NODE_SECONDARY_LABEL }, this.props.secondaryLabel);
	        }
	        else {
	            return undefined;
	        }
	    };
	    return TreeNode;
	}(React.Component));
	exports.TreeNode = TreeNode;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(759);
	var assign = __webpack_require__(758);
	
	var createTree = function(array, rootNodes, customID) {
	  var tree = [];
	
	  for (var rootNode in rootNodes) {
	    var node = rootNodes[rootNode];
	    var childNode = array[node[customID]];
	
	    if (!node && !rootNodes.hasOwnProperty(rootNode)) {
	      continue ;
	    }
	
	    if (childNode) {
	      node.children = createTree(array, childNode, customID);
	    }
	
	    tree.push(node);
	  }
	
	  return tree;
	};
	
	var groupByParents = function(array, options) {
	  return array.reduce(function(prev, item) {
	    var parentID = item[options.parentProperty] || options.rootID;
	
	    if (parentID && prev.hasOwnProperty(parentID)) {
	      prev[parentID].push(item);
	      return prev;
	    }
	
	    prev[parentID] = [item];
	    return prev;
	  }, {});
	};
	
	/**
	 * arrayToTree
	 * Convert a plain array of nodes (with pointers to parent nodes) to a nested
	 * data structure
	 *
	 * @name arrayToTree
	 * @function
	 *
	 * @param {Array} data An array of data
	 * @param {Object} options An object containing the following fields:
	 *
	 *  - `parentProperty` (String): A name of a property where a link to
	 *     a parent node could be found. Default: 'parent_id'
	 *  - `customID` (String): An unique node identifier. Default: 'id'
	 *
	 * @return {Array} Result of transformation
	 */
	
	module.exports = function arrayToTree(data, options) {
	  options = assign({
	    parentProperty: 'parent_id',
	    customID: 'id',
	    rootID: '0'
	  }, options);
	
	  if (!isArray(data)) {
	    throw new TypeError('Expected an object but got an invalid argument');
	  }
	
	  var grouped = groupByParents(data, options);
	  return createTree(grouped, grouped[options.rootID], options.customID);
	};


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendEmailTemplate = exports.viewDeliveryOrderLogs = exports.fulfillDeliveryOrder = exports.cancelDeliveryOrder = exports.updateDeliveryOrder = exports.createDeliveryOrder = exports.startEditDeliveryOrder = exports.refreshDeliveryOrderOverview = exports.initDeliveryOrderOverview = exports.removeInvoiceFromDeliveryOrder = exports.addInvoiceToDeliveryOrder = exports.initDeliveryOrderForInvoice = exports.changeDeliveryOrderTab = exports.getDeliveryOrders = exports.REFRESH_DELIVERY_ORDER_CUSTOMER = exports.REFRESH_DELIVERY_ORDER_HISTORIES = exports.REFRESH_DELIVERY_ORDER_OVERVIEW = exports.REMOVE_INVOICE_FROM_DELIVERY_ORDER = exports.REFRESH_DELIVERY_ORDER_ITEMS = exports.ADD_INVOICE_TO_DELIVERY_ORDER = exports.CLEANUP_DELIVERY_ORDER_FORM = exports.SET_DELIVERY_ORDER_STATE = undefined;
	
	var _normalizr = __webpack_require__(64);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _schema = __webpack_require__(109);
	
	var _baseActions = __webpack_require__(34);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _invoiceService = __webpack_require__(323);
	
	var _invoiceService2 = _interopRequireDefault(_invoiceService);
	
	var _deliveryOrderService = __webpack_require__(493);
	
	var _deliveryOrderService2 = _interopRequireDefault(_deliveryOrderService);
	
	var _emailTemplateService = __webpack_require__(494);
	
	var _emailTemplateService2 = _interopRequireDefault(_emailTemplateService);
	
	var _customerService = __webpack_require__(492);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _emailTemplateActions = __webpack_require__(308);
	
	var emailTemplateActions = _interopRequireWildcard(_emailTemplateActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SET_DELIVERY_ORDER_STATE = exports.SET_DELIVERY_ORDER_STATE = 'SET_DELIVERY_ORDER_STATE';
	var CLEANUP_DELIVERY_ORDER_FORM = exports.CLEANUP_DELIVERY_ORDER_FORM = 'CLEANUP_DELIVERY_ORDER_FORM';
	var ADD_INVOICE_TO_DELIVERY_ORDER = exports.ADD_INVOICE_TO_DELIVERY_ORDER = 'ADD_INVOICE_TO_DELIVERY_ORDER';
	var REFRESH_DELIVERY_ORDER_ITEMS = exports.REFRESH_DELIVERY_ORDER_ITEMS = 'REFRESH_DELIVERY_ORDER_ITEMS';
	var REMOVE_INVOICE_FROM_DELIVERY_ORDER = exports.REMOVE_INVOICE_FROM_DELIVERY_ORDER = 'REMOVE_INVOICE_FROM_DELIVERY_ORDER';
	var REFRESH_DELIVERY_ORDER_OVERVIEW = exports.REFRESH_DELIVERY_ORDER_OVERVIEW = 'REFRESH_DELIVERY_ORDER_OVERVIEW';
	var REFRESH_DELIVERY_ORDER_HISTORIES = exports.REFRESH_DELIVERY_ORDER_HISTORIES = 'REFRESH_DELIVERY_ORDER_HISTORIES';
	var REFRESH_DELIVERY_ORDER_CUSTOMER = exports.REFRESH_DELIVERY_ORDER_CUSTOMER = 'REFRESH_DELIVERY_ORDER_CUSTOMER';
	
	function getDeliveryOrders(storeId, page, count, orderBy) {
	    var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	    var path = arguments[5];
	
	    return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	        promise: _deliveryOrderService2.default.getList(storeId, page, count, orderBy, filters),
	        actions: {
	            type: _baseActions.SET_PATH_STATE,
	            stateName: 'delivery_orders',
	            path: path
	        }
	    });
	}
	
	function changeDeliveryOrderTab(currentTab) {
	    return function (dispatch) {
	        dispatch({ type: SET_DELIVERY_ORDER_STATE, data: { currentTab: currentTab } });
	    };
	}
	
	function initDeliveryOrderForInvoice(storeId, number) {
	    return function (dispatch) {
	        dispatch({
	            type: SET_DELIVERY_ORDER_STATE,
	            data: {
	                storeId: storeId,
	                page: 'new',
	                type: 'invoice',
	                refId: number,
	                currentTab: 'overview'
	            }
	        });
	        dispatch({ type: CLEANUP_DELIVERY_ORDER_FORM });
	
	        addInvoiceToDeliveryOrder(storeId, [number])(dispatch);
	    };
	}
	
	function addInvoiceToDeliveryOrder(storeId, numbers) {
	    return function (dispatch) {
	        var numbersAry = numbers ? Array.isArray(numbers) ? numbers : [numbers] : [];
	
	        // Get invoices info
	        var invoices = numbersAry.map(function (number) {
	            return _invoiceService2.default.getItem(storeId, number).then(function (res) {
	                return (0, _normalizr.normalize)(res.invoice, _schema.InvoiceSchema);
	            });
	        });
	        invoices.forEach(function (invoice) {
	            dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: invoice }));
	            invoice.then(function (data) {
	                return dispatch({ type: ADD_INVOICE_TO_DELIVERY_ORDER, data: data });
	            });
	        });
	
	        // Get missing fields for listings
	        Promise.all(invoices).then(function (invoiceResults) {
	            var listingIds = invoiceResults.reduce(function (ids, invoiceNormalized) {
	                var result = invoiceNormalized.result,
	                    invoices = invoiceNormalized.entities.invoices;
	
	                var invoice = invoices[result];
	                return ids.concat((invoice.listing_line_items || []).map(function (d) {
	                    return d.purchasable_id;
	                }));
	            }, []);
	            refreshDeliveryOrderItems(storeId, listingIds)(dispatch);
	        });
	    };
	}
	
	function refreshDeliveryOrderItems(storeId, listingIds) {
	    return function (dispatch) {
	        var listings = _inventoryService2.default.getItems(storeId, listingIds).then(function (res) {
	            var data = res.data,
	                meta = _objectWithoutProperties(res, ['data']);
	
	            var obj = (0, _normalizr.normalize)(data.listings, (0, _normalizr.arrayOf)(_schema.ListingSchema));
	            obj.meta = meta;
	            return obj;
	        });
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: listings }));
	        listings.then(function (data) {
	            return dispatch({ type: REFRESH_DELIVERY_ORDER_ITEMS, data: data });
	        });
	    };
	}
	
	function removeInvoiceFromDeliveryOrder(numbers) {
	    return function (dispatch) {
	        var data = numbers != null ? Array.isArray(numbers) ? numbers : [numbers] : [];
	        if (data.length > 0) {
	            dispatch({ type: REMOVE_INVOICE_FROM_DELIVERY_ORDER, data: data });
	        }
	    };
	}
	
	function initDeliveryOrderOverview(storeId, deliveryId) {
	    return function (dispatch) {
	        dispatch({
	            type: SET_DELIVERY_ORDER_STATE,
	            data: {
	                storeId: storeId,
	                deliveryId: deliveryId,
	                page: 'view',
	                currentTab: 'overview'
	            }
	        });
	        dispatch({ type: CLEANUP_DELIVERY_ORDER_FORM });
	
	        var promise = _deliveryOrderService2.default.getItem(storeId, deliveryId);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (data) {
	            var deliveryOrder = data.entities.deliveryOrders[data.result];
	            refreshDeliveryOrderOverview(storeId, deliveryOrder)(dispatch);
	        });
	    };
	}
	
	// Refresh Delivery Order Overview page then refresh Delivery Order Items
	function refreshDeliveryOrderOverview(storeId, deliveryOrderObject) {
	    return function (dispatch) {
	        dispatch({ type: REFRESH_DELIVERY_ORDER_OVERVIEW, data: deliveryOrderObject });
	        var _deliveryOrderObject$ = deliveryOrderObject.orders,
	            orders = _deliveryOrderObject$ === undefined ? [] : _deliveryOrderObject$;
	
	        // Query additional info, eg. billing customer, listings' details
	
	        orders.map(function (order) {
	            return order.number;
	        }).forEach(function (id) {
	            return addInvoiceToDeliveryOrder(storeId, id)(dispatch);
	        });
	
	        // Query customer info
	        var promise = _customerService2.default.get(storeId, deliveryOrderObject.customer_id);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (data) {
	            dispatch({ type: REFRESH_DELIVERY_ORDER_CUSTOMER, data: data });
	        });
	    };
	}
	
	function startEditDeliveryOrder(currentTab) {
	    return function (dispatch) {
	        dispatch({ type: SET_DELIVERY_ORDER_STATE, data: { page: 'edit' } });
	        if (currentTab === 'log') {
	            changeDeliveryOrderTab('overview')(dispatch);
	        }
	    };
	}
	
	function createDeliveryOrder(storeId, data) {
	    return function (dispatch) {
	        var promise = _deliveryOrderService2.default.createItem(storeId, data);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (res) {
	            _routeHelper2.default.goDeliveryNote(storeId, res.result);
	        });
	    };
	}
	
	function updateDeliveryOrder(storeId, deliveryId, data) {
	    return function (dispatch) {
	        var promise = _deliveryOrderService2.default.updateItem(storeId, deliveryId, data);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (res) {
	            initDeliveryOrderOverview(storeId, deliveryId)(dispatch);
	        });
	    };
	}
	
	function cancelDeliveryOrder(storeId, deliveryId) {
	    return function (dispatch) {
	        var promise = _deliveryOrderService2.default.cancelItem(storeId, deliveryId);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (res) {
	            initDeliveryOrderOverview(storeId, deliveryId)(dispatch);
	        });
	    };
	}
	
	function fulfillDeliveryOrder(storeId, deliveryId, data) {
	    return function (dispatch) {
	        var promise = _deliveryOrderService2.default.fulfillItem(storeId, deliveryId, data);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (res) {
	            initDeliveryOrderOverview(storeId, deliveryId)(dispatch);
	        });
	    };
	}
	
	function viewDeliveryOrderLogs(storeId, deliveryId) {
	    return function (dispatch) {
	        changeDeliveryOrderTab('log')(dispatch);
	
	        var promise = _deliveryOrderService2.default.getItemLogs(storeId, deliveryId);
	        dispatch(_defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, { promise: promise }));
	        promise.then(function (data) {
	            return dispatch({ type: REFRESH_DELIVERY_ORDER_HISTORIES, data: data });
	        });
	    };
	}
	
	function sendEmailTemplate(storeId, recipient, deliveryOrderId, orderId) {
	    return function (dispatch) {
	        return emailTemplateActions.askRecipientThenSendEmail({
	            storeId: storeId,
	            templateType: _emailTemplateService2.default.TYPE.DELIVERY_ORDER,
	            defaultRecipient: recipient,
	            params: {
	                delivery_order_id: deliveryOrderId,
	                order_id: orderId
	            }
	        })(dispatch);
	    };
	}
	
	exports.getDeliveryOrders = getDeliveryOrders;
	exports.changeDeliveryOrderTab = changeDeliveryOrderTab;
	exports.initDeliveryOrderForInvoice = initDeliveryOrderForInvoice;
	exports.addInvoiceToDeliveryOrder = addInvoiceToDeliveryOrder;
	exports.removeInvoiceFromDeliveryOrder = removeInvoiceFromDeliveryOrder;
	exports.initDeliveryOrderOverview = initDeliveryOrderOverview;
	exports.refreshDeliveryOrderOverview = refreshDeliveryOrderOverview;
	exports.startEditDeliveryOrder = startEditDeliveryOrder;
	exports.createDeliveryOrder = createDeliveryOrder;
	exports.updateDeliveryOrder = updateDeliveryOrder;
	exports.cancelDeliveryOrder = cancelDeliveryOrder;
	exports.fulfillDeliveryOrder = fulfillDeliveryOrder;
	exports.viewDeliveryOrderLogs = viewDeliveryOrderLogs;
	exports.sendEmailTemplate = sendEmailTemplate;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveLineItemStatus = exports.changeLineItemStatusInput = exports.closeAddLineItemStatus = exports.openAddLineItemStatus = exports.SAVE_LINE_ITEM_STATUS_FAILURE = exports.SAVE_LINE_ITEM_STATUS_SUCCESS = exports.SAVE_LINE_ITEM_STATUS_REQUEST = exports.CHANGE_LINE_ITEM_STATUS_INPUT = exports.CLOSE_ADD_LINE_ITEM_STATUS = exports.OPEN_ADD_LINE_ITEM_STATUS = undefined;
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	var OPEN_ADD_LINE_ITEM_STATUS = exports.OPEN_ADD_LINE_ITEM_STATUS = 'OPEN_ADD_LINE_ITEM_STATUS';
	var CLOSE_ADD_LINE_ITEM_STATUS = exports.CLOSE_ADD_LINE_ITEM_STATUS = 'CLOSE_ADD_LINE_ITEM_STATUS';
	var CHANGE_LINE_ITEM_STATUS_INPUT = exports.CHANGE_LINE_ITEM_STATUS_INPUT = 'CHANGE_LINE_ITEM_STATUS_INPUT';
	
	var SAVE_LINE_ITEM_STATUS_REQUEST = exports.SAVE_LINE_ITEM_STATUS_REQUEST = 'SAVE_LINE_ITEM_STATUS_REQUEST';
	var SAVE_LINE_ITEM_STATUS_SUCCESS = exports.SAVE_LINE_ITEM_STATUS_SUCCESS = 'SAVE_LINE_ITEM_STATUS_SUCCESS';
	var SAVE_LINE_ITEM_STATUS_FAILURE = exports.SAVE_LINE_ITEM_STATUS_FAILURE = 'SAVE_LINE_ITEM_STATUS_FAILURE';
	
	var openAddLineItemStatus = exports.openAddLineItemStatus = function openAddLineItemStatus(_ref) {
	  var storeId = _ref.storeId,
	      initialValues = _ref.initialValues,
	      isCreating = _ref.isCreating;
	  return { type: OPEN_ADD_LINE_ITEM_STATUS, initialValues: initialValues, storeId: storeId, isCreating: isCreating };
	};
	
	var closeAddLineItemStatus = exports.closeAddLineItemStatus = function closeAddLineItemStatus() {
	  return { type: CLOSE_ADD_LINE_ITEM_STATUS };
	};
	
	var changeLineItemStatusInput = exports.changeLineItemStatusInput = function changeLineItemStatusInput(value) {
	  return { type: CHANGE_LINE_ITEM_STATUS_INPUT, value: value };
	};
	
	var saveLineItemStatus = exports.saveLineItemStatus = function saveLineItemStatus() {
	  return function (dispatch, getState) {
	    dispatch({ type: SAVE_LINE_ITEM_STATUS_REQUEST });
	
	    var state = getState();
	    var _state$forms$addLineI = state.forms.addLineItemStatus,
	        input = _state$forms$addLineI.input,
	        storeId = _state$forms$addLineI.storeId,
	        isCreating = _state$forms$addLineI.isCreating,
	        initialValues = _state$forms$addLineI.initialValues;
	
	    var nextAction = isCreating ? (0, _lineItemStatusAction.createLineItemStatus)(input.value, '#FFFFFF', storeId) : (0, _lineItemStatusAction.updateLineItemStatus)(initialValues.id, { status: input.value }, storeId);
	    dispatch(nextAction).then(function (response) {
	      var error = response.error;
	
	      if (!error) {
	        dispatch({ type: SAVE_LINE_ITEM_STATUS_SUCCESS });
	      } else {
	        dispatch({ type: SAVE_LINE_ITEM_STATUS_FAILURE });
	      }
	    });
	  };
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submit = exports.changeInput = exports.actionTypes = undefined;
	
	var _keykey = __webpack_require__(270);
	
	var _keykey2 = _interopRequireDefault(_keykey);
	
	var _humps = __webpack_require__(44);
	
	var _inventoryService = __webpack_require__(155);
	
	var _inventoryService2 = _interopRequireDefault(_inventoryService);
	
	var _baseActions = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = (0, _keykey2.default)(['ADD_LISTING_BY_BARCODE_CHANGE_INPUT', 'ADD_LISTING_BY_BARCODE_SUBMIT_REQUEST', 'ADD_LISTING_BY_BARCODE_SUBMIT_SUCCESS', 'ADD_LISTING_BY_BARCODE_SUBMIT_FAILURE']);
	
	var changeInput = exports.changeInput = function changeInput(value) {
	  return { type: actionTypes['ADD_LISTING_BY_BARCODE_CHANGE_INPUT'], value: value };
	};
	var submit = exports.submit = function submit(value, storeId, baseSearch) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_REQUEST'] });
	    dispatch((0, _baseActions.startFetch)());
	    return _inventoryService2.default.searchByBarcode(storeId, value, baseSearch).then(function (res) {
	      var data = res.data;
	
	      if (data.length) {
	        var items = (0, _humps.camelizeKeys)(data);
	        var listings = items.map(function (d) {
	          return d.listing;
	        });
	        var payload = { data: listings };
	        dispatch((0, _baseActions.stopFetch)());
	        dispatch({ type: actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_SUCCESS'], data: payload });
	        return payload;
	      } else {
	        throw new Error('Barcode not exist');
	      }
	    }).catch(function (error) {
	      dispatch((0, _baseActions.stopFetch)());
	      alert(error.message);
	      dispatch({ type: actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_FAILURE'], error: error });
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitScaleBarcodeSetting = exports.submitEmbeddedBarcodeSetting = exports.discardEmbeddedBarcodeSetting = exports.editEmbeddedBarcodeSetting = exports.ValidationScalePrefix = exports.changeScaleBarcodesDeciamlPoints = exports.editScaleBarcode = exports.showScaleBarcodeNumber = exports.changeEmbeddedBarcodeDeciamlPoints = exports.changeEmbeddedBarcodeType = exports.changeEmbeddedBarcodeEnabled = exports.showEmbeddedBarcodeSetting = exports.VALID_SCALEPREFIX = exports.EDIT_SCALE_BARCODE_DECIMAL = exports.EDIT_SCALE_BARCODE = exports.SHOW_SCALE_BARCODE_NUMBER = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST = exports.DISCARD_EMBEDDED_BARCODE_SETTING = exports.EDIT_EMBEDDED_BARCODE_SETTING = exports.CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS = exports.CHANGE_EMBEDDED_BARCODE_TYPE = exports.CHANGE_EMBEDDED_BARCODE_ENABLED = exports.SHOW_EMBEDDED_BARCODE_SETTING = undefined;
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _storeActions = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHOW_EMBEDDED_BARCODE_SETTING = exports.SHOW_EMBEDDED_BARCODE_SETTING = 'SHOW_EMBEDDED_BARCODE_SETTING';
	var CHANGE_EMBEDDED_BARCODE_ENABLED = exports.CHANGE_EMBEDDED_BARCODE_ENABLED = 'CHANGE_EMBEDDED_BARCODE_ENABLED';
	var CHANGE_EMBEDDED_BARCODE_TYPE = exports.CHANGE_EMBEDDED_BARCODE_TYPE = 'CHANGE_EMBEDDED_BARCODE_TYPE';
	var CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS = exports.CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS = 'CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS';
	var EDIT_EMBEDDED_BARCODE_SETTING = exports.EDIT_EMBEDDED_BARCODE_SETTING = 'EDIT_EMBEDDED_BARCODE_SETTING';
	var DISCARD_EMBEDDED_BARCODE_SETTING = exports.DISCARD_EMBEDDED_BARCODE_SETTING = 'DISCARD_EMBEDDED_BARCODE_SETTING';
	var SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST = 'SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST';
	var SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS = 'SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS';
	var SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE = exports.SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE = 'SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE';
	var SHOW_SCALE_BARCODE_NUMBER = exports.SHOW_SCALE_BARCODE_NUMBER = 'SHOW_SCALE_BARCODE_NUMBER';
	var EDIT_SCALE_BARCODE = exports.EDIT_SCALE_BARCODE = 'EDIT_SCALE_BARCODE';
	var EDIT_SCALE_BARCODE_DECIMAL = exports.EDIT_SCALE_BARCODE_DECIMAL = 'EDIT_SCALE_BARCODE_DECIMAL';
	var VALID_SCALEPREFIX = exports.VALID_SCALEPREFIX = 'VALID_SCALEPREFIX';
	
	var showEmbeddedBarcodeSetting = exports.showEmbeddedBarcodeSetting = function showEmbeddedBarcodeSetting(storeId) {
	  return function (dispatch, getState) {
	    dispatch((0, _storeActions.getStoreModule)(storeId)).then(function () {
	      var state = getState();
	      var targetStore = (0, _find2.default)(state.stores, { id: storeId });
	      if (targetStore) {
	        dispatch({ type: SHOW_EMBEDDED_BARCODE_SETTING, store: targetStore.module, scale_barcodes: targetStore.scale_barcodes });
	      } else {
	        alert('Cannot find target store module');
	      }
	    });
	  };
	};
	var changeEmbeddedBarcodeEnabled = exports.changeEmbeddedBarcodeEnabled = function changeEmbeddedBarcodeEnabled(value) {
	  return { type: CHANGE_EMBEDDED_BARCODE_ENABLED, value: value };
	};
	var changeEmbeddedBarcodeType = exports.changeEmbeddedBarcodeType = function changeEmbeddedBarcodeType(value) {
	  return { type: CHANGE_EMBEDDED_BARCODE_TYPE, value: value };
	};
	var changeEmbeddedBarcodeDeciamlPoints = exports.changeEmbeddedBarcodeDeciamlPoints = function changeEmbeddedBarcodeDeciamlPoints(value, order) {
	  return { type: CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS, value: value, order: order };
	};
	var showScaleBarcodeNumber = exports.showScaleBarcodeNumber = function showScaleBarcodeNumber(storeId) {
	  return function (dispatch, getState) {
	    dispatch((0, _storeActions.getScaleBarcode)(storeId)).then(function () {
	      var state = getState();
	      var targetStore = (0, _find2.default)(state.stores, { id: storeId });
	      if (targetStore) {
	        dispatch({ type: SHOW_SCALE_BARCODE_NUMBER, scale_barcodes: targetStore.scale_barcodes });
	      }
	    });
	  };
	};
	var editScaleBarcode = exports.editScaleBarcode = function editScaleBarcode(value, order) {
	  return { type: EDIT_SCALE_BARCODE, value: value, order: order };
	};
	//add with decimalpoints
	var changeScaleBarcodesDeciamlPoints = exports.changeScaleBarcodesDeciamlPoints = function changeScaleBarcodesDeciamlPoints(value, order) {
	  return { type: EDIT_SCALE_BARCODE_DECIMAL, value: value, order: order };
	};
	
	//ValidationScalePrefix
	var ValidationScalePrefix = exports.ValidationScalePrefix = function ValidationScalePrefix() {
	  return { type: VALID_SCALEPREFIX };
	};
	var editEmbeddedBarcodeSetting = exports.editEmbeddedBarcodeSetting = function editEmbeddedBarcodeSetting() {
	  return { type: EDIT_EMBEDDED_BARCODE_SETTING };
	};
	var discardEmbeddedBarcodeSetting = exports.discardEmbeddedBarcodeSetting = function discardEmbeddedBarcodeSetting() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var pageState = state.forms.embeddedBarcode;
	    var type = pageState.type,
	        enabled = pageState.enabled,
	        decimalPoints = pageState.decimalPoints,
	        initialValues = pageState.initialValues;
	
	    if (type !== initialValues.embedded_barcode_type && enabled !== initialValues.embedded_barcode_enabled && decimalPoints !== initialValues.embedded_barcode_decimal_points) {
	      if (confirm('Do you want to discard your changes?')) {
	        dispatch({ type: DISCARD_EMBEDDED_BARCODE_SETTING });
	      }
	    } else {
	      dispatch({ type: DISCARD_EMBEDDED_BARCODE_SETTING });
	    }
	  };
	};
	var submitEmbeddedBarcodeSetting = exports.submitEmbeddedBarcodeSetting = function submitEmbeddedBarcodeSetting() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var pageState = state.forms.embeddedBarcode;
	    var type = pageState.type,
	        enabled = pageState.enabled,
	        decimalPoints = pageState.decimalPoints,
	        initialValues = pageState.initialValues;
	
	    var data = {};
	    data.embedded_barcode_enabled = enabled;
	    data.embedded_barcode_type = enabled ? type : null;
	    data.embedded_barcode_decimal_points = enabled ? decimalPoints : null;
	    dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST });
	    dispatch((0, _storeActions.updateStoreModule)(initialValues.store_id, { 'module': data })).then(function () {
	      dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS });
	    }).catch(function (e) {
	      dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE });
	      alert('Failed to update settings.');
	    });
	  };
	};
	var submitScaleBarcodeSetting = exports.submitScaleBarcodeSetting = function submitScaleBarcodeSetting() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var pageState = state.forms.embeddedBarcode;
	    var type = pageState.type,
	        enabled = pageState.enabled,
	        decimalPoints = pageState.decimalPoints,
	        initialValues = pageState.initialValues,
	        scale_barcodes = pageState.scale_barcodes;
	
	    // let data = Array.from(scale_barcodes)
	    // scale_barcodes.embedded_barcode_enabled = enabled;
	    // scale_barcodes.embedded_barcode_type = enabled ? type : null;
	    // scale_barcodes.embedded_barcode_decimal_points = enabled ? decimalPoints : null;
	    // dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST });
	
	    dispatch((0, _storeActions.updateScaleBarcode)(initialValues.store_id, { 'scale_barcodes': scale_barcodes })).then(function () {
	      dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS });
	    }).catch(function (e) {
	      dispatch({ type: SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE });
	      alert('Failed to update settings.');
	    });
	  };
	};

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitLinkUp = exports.closeLinkUpQueueDisplayModal = exports.openLinkUpQueueDisplayModal = exports.open = exports.submit = exports.refreshNow = exports.removeTableType = exports.addTableType = exports.changeRestartEnable = exports.changeTableSize = exports.changeTypeName = exports.changeTableSizeSegmentationEditMode = exports.close = exports.CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL = exports.OPEN_LINK_UP_QUEUE_DISPLAY_MODAL = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST = exports.CLOSE_TABLE_SIZE_SEGMENTATION = exports.OPEN_TABLE_SIZE_SEGMENTATION_FAILURE = exports.OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.OPEN_TABLE_SIZE_SEGMENTATION_REQUEST = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST = exports.REFRESH_TABLE_SIZING_NOW_FAILURE = exports.REFRESH_TABLE_SIZING_NOW_SUCCESS = exports.REFRESH_TABLE_SIZING_NOW_REQUEST = exports.REMOVE_TABLE_TYPE = exports.ADD_TABLE_TYPE = exports.CHANGE_RESTART_ENABLE = exports.CHANGE_TABLE_SIZE = exports.CHANGE_TYPE_NAME = exports.CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _tableSizeSegmentationActions = __webpack_require__(765);
	
	var _queueingDisplayActions = __webpack_require__(764);
	
	var _lodash = __webpack_require__(14);
	
	var _baseActions = __webpack_require__(34);
	
	var CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE = exports.CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE = 'CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE';
	var CHANGE_TYPE_NAME = exports.CHANGE_TYPE_NAME = 'CHANGE_TYPE_NAME';
	var CHANGE_TABLE_SIZE = exports.CHANGE_TABLE_SIZE = 'CHANGE_TABLE_SIZE';
	var CHANGE_RESTART_ENABLE = exports.CHANGE_RESTART_ENABLE = 'CHANGE_RESTART_ENABLE';
	var ADD_TABLE_TYPE = exports.ADD_TABLE_TYPE = 'ADD_TABLE_TYPE';
	var REMOVE_TABLE_TYPE = exports.REMOVE_TABLE_TYPE = 'REMOVE_TABLE_TYPE';
	var REFRESH_TABLE_SIZING_NOW_REQUEST = exports.REFRESH_TABLE_SIZING_NOW_REQUEST = 'REFRESH_TABLE_SIZING_NOW_REQUEST';
	var REFRESH_TABLE_SIZING_NOW_SUCCESS = exports.REFRESH_TABLE_SIZING_NOW_SUCCESS = 'REFRESH_TABLE_SIZING_NOW_SUCCESS';
	var REFRESH_TABLE_SIZING_NOW_FAILURE = exports.REFRESH_TABLE_SIZING_NOW_FAILURE = 'REFRESH_TABLE_SIZING_NOW_FAILURE';
	var SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST = 'SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST';
	var SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS = 'SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE = exports.SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE = 'SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE';
	var OPEN_TABLE_SIZE_SEGMENTATION_REQUEST = exports.OPEN_TABLE_SIZE_SEGMENTATION_REQUEST = 'OPEN_TABLE_SIZE_SEGMENTATION_REQUEST';
	var OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS = 'OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var OPEN_TABLE_SIZE_SEGMENTATION_FAILURE = exports.OPEN_TABLE_SIZE_SEGMENTATION_FAILURE = 'OPEN_TABLE_SIZE_SEGMENTATION_FAILURE';
	
	var CLOSE_TABLE_SIZE_SEGMENTATION = exports.CLOSE_TABLE_SIZE_SEGMENTATION = 'CLOSE_TABLE_SIZE_SEGMENTATION';
	
	var SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST = 'SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST';
	var SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS = 'SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS';
	var SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE = exports.SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE = 'SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE';
	
	var OPEN_LINK_UP_QUEUE_DISPLAY_MODAL = exports.OPEN_LINK_UP_QUEUE_DISPLAY_MODAL = 'OPEN_LINK_UP_QUEUE_DISPLAY_MODAL';
	var CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL = exports.CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL = 'CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL';
	
	var close = exports.close = function close() {
	  return { type: CLOSE_TABLE_SIZE_SEGMENTATION };
	};
	var changeTableSizeSegmentationEditMode = exports.changeTableSizeSegmentationEditMode = function changeTableSizeSegmentationEditMode(value) {
	  return {
	    type: CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE,
	    value: value
	  };
	};
	var changeTypeName = exports.changeTypeName = function changeTypeName(value, index) {
	  return { type: CHANGE_TYPE_NAME, value: value, index: index };
	};
	var changeTableSize = exports.changeTableSize = function changeTableSize(value, index) {
	  return { type: CHANGE_TABLE_SIZE, value: value, index: index };
	};
	var changeRestartEnable = exports.changeRestartEnable = function changeRestartEnable(value) {
	  return { type: CHANGE_RESTART_ENABLE, value: value };
	};
	var addTableType = exports.addTableType = function addTableType() {
	  return { type: ADD_TABLE_TYPE };
	};
	var removeTableType = exports.removeTableType = function removeTableType(index) {
	  return { type: REMOVE_TABLE_TYPE, index: index };
	};
	var refreshNow = exports.refreshNow = function refreshNow(storeId) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var data = state.forms.tableSizeSegmentation;
	    dispatch({ type: REFRESH_TABLE_SIZING_NOW_REQUEST });
	    dispatch((0, _tableSizeSegmentationActions.refresh)(data.storeId)).then(function (_ref) {
	      var error = _ref.error;
	
	      if (!error) {
	        dispatch({ type: REFRESH_TABLE_SIZING_NOW_SUCCESS });
	      } else {
	        dispatch({ type: REFRESH_TABLE_SIZING_NOW_FAILURE, error: error });
	      }
	    });
	  };
	};
	var submit = exports.submit = function submit() {
	  return function (dispatch, getState) {
	    dispatch({ type: SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST });
	    var state = getState();
	    var data = state.forms.tableSizeSegmentation;
	    var handler = void 0;
	    var body = { dailyCountRestart: data.enableDailyRestart };
	
	    if (!data.isCreating) {
	      body.partySizeSegmentItemsAttributes = typeDiff(data.initialValues.partySizeSegmentItems, data.items);
	      handler = _tableSizeSegmentationActions.update;
	    } else {
	      body.partySizeSegmentItemsAttributes = data.items.slice();
	      handler = _tableSizeSegmentationActions.create;
	    }
	
	    var len = body.partySizeSegmentItemsAttributes.length;
	
	    if (len > 0) {
	      //validate name input
	      var invalidNames = [];
	      body.partySizeSegmentItemsAttributes.forEach(function (d, i) {
	        if (!d.label || !d.label.length) {
	          invalidNames.push(d);
	        }
	      });
	      if (invalidNames.length) {
	        alert('Please set name for all types.');
	        return;
	      }
	
	      //validate name value
	      var duplicated = [];
	      var names = body.partySizeSegmentItemsAttributes.map(function (d) {
	        return d.label;
	      });
	      body.partySizeSegmentItemsAttributes.forEach(function (d, i) {
	        if (names.indexOf(d.label) !== i) {
	          duplicated.push(d.label);
	        }
	      });
	      if (duplicated.length) {
	        alert('Duplicated name: ' + duplicated.join(', '));
	        return;
	      }
	      //validate size input
	      var invalidSize = [];
	      body.partySizeSegmentItemsAttributes.forEach(function (d, i) {
	        if (!d.minimumPartySize) {
	          invalidSize.push(d);
	        }
	      });
	      if (invalidSize.length) {
	        alert('Please set table size for all types.');
	        return;
	      }
	    }
	
	    body.partySizeSegmentItemsAttributes.sort(function (a, b) {
	      return a.minimumPartySize - b.minimumPartySize;
	    });
	    if (len > 1) {
	      for (var i = 1; i < len; i++) {
	        body.partySizeSegmentItemsAttributes[i - 1].maximumPartySize = body.partySizeSegmentItemsAttributes[i].minimumPartySize - 1;
	      }
	    }
	
	    var temp = [];
	    body.partySizeSegmentItemsAttributes.forEach(function (d) {
	      temp.push((0, _lodash.pick)(d, ['id', 'maximumPartySize', 'minimumPartySize', 'label', '_destroy']));
	    });
	    body.partySizeSegmentItemsAttributes = temp;
	    dispatch((0, _baseActions.startFetch)());
	    dispatch(handler(body, data.storeId)).then(function (_ref2) {
	      var data = _ref2.data,
	          error = _ref2.error;
	
	      dispatch((0, _baseActions.stopFetch)());
	      if (!error) {
	        dispatch({ type: SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS, data: data });
	      } else {
	        alert(error.message);
	        dispatch({ type: SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      }
	    });
	  };
	};
	var open = exports.open = function open(storeId) {
	  return function (dispatch) {
	    dispatch({ type: OPEN_TABLE_SIZE_SEGMENTATION_REQUEST });
	    dispatch((0, _tableSizeSegmentationActions.get)(storeId)).then(function (_ref3) {
	      var data = _ref3.data,
	          error = _ref3.error;
	
	      if (!error) {
	        dispatch({ type: OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS, data: data, storeId: storeId });
	      } else {
	        if (error.message === '404') {
	          dispatch({ type: OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS, data: {}, isCreating: true, storeId: storeId });
	        } else {
	          alert("Failed to fetch data.");
	          dispatch({ type: OPEN_TABLE_SIZE_SEGMENTATION_FAILURE, error: error, storeId: storeId });
	        }
	      }
	    });
	  };
	};
	var openLinkUpQueueDisplayModal = exports.openLinkUpQueueDisplayModal = function openLinkUpQueueDisplayModal() {
	  return { type: OPEN_LINK_UP_QUEUE_DISPLAY_MODAL };
	};
	var closeLinkUpQueueDisplayModal = exports.closeLinkUpQueueDisplayModal = function closeLinkUpQueueDisplayModal() {
	  return { type: CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL };
	};
	var submitLinkUp = exports.submitLinkUp = function submitLinkUp(key) {
	  return function (dispatch, getState) {
	    dispatch((0, _baseActions.startFetch)());
	    dispatch({ type: SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST });
	    var state = getState();
	    var data = state.forms.tableSizeSegmentation;
	    dispatch((0, _queueingDisplayActions.linkUpDisplay)(key, data.storeId)).then(function (_ref4) {
	      var error = _ref4.error;
	
	      dispatch((0, _baseActions.stopFetch)());
	      if (!error) {
	        dispatch({ type: SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS });
	      } else {
	        alert(error.message);
	        dispatch({ type: SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE, error: error });
	      }
	    });
	  };
	};
	
	function typeDiff(prev, next) {
	  var prevTypes = {};
	  var newTypes = [];
	  prev.forEach(function (type) {
	    return prevTypes[type.id] = type;
	  });
	  next.forEach(function (type) {
	    var id = type.id;
	
	    if (!id || !prevTypes[id]) {
	      var temp = _extends({}, type);
	      temp.id = undefined;
	      newTypes.push(temp);
	    }
	  });
	  var nextIds = next.map(function (d) {
	    return d.id;
	  }).filter(function (d) {
	    return d != false;
	  });
	  prev.forEach(function (type) {
	    if (nextIds.indexOf(type.id) === -1) {
	      prevTypes[type.id]['_destroy'] = true;
	    }
	  });
	  return Object.keys(prevTypes).map(function (id) {
	    return prevTypes[id];
	  }).concat(newTypes);
	}

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submit = exports.removeUnit = exports.addUomUnit = exports.changeUnitRatio = exports.changeUnitName = exports.changeGroupName = exports.enableEditMode = exports.close = exports.open = exports.SUBMIT_UOM_GROUP_FAILURE = exports.SUBMIT_UOM_GROUP_SUCCESS = exports.SUBMIT_UOM_GROUP_REQUEST = exports.ENABLE_UOM_OVERVIEW_EDITMODE = exports.REMOVE_UOM_UNIT = exports.ADD_UOM_UNIT = exports.CHANGE_UOM_UNIT_RATIO = exports.CHANGE_UOM_UNIT_NAME = exports.CHANGE_UOM_GROUP_NAME = exports.CLOSE_WORKFLOW_OVERVIEW = exports.OPEN_WORKFLOW_OVERVIEW_FAILURE = exports.OPEN_WORKFLOW_OVERVIEW_SUCCESS = exports.OPEN_WORKFLOW_OVERVIEW_REQUEST = undefined;
	
	var _uomGroupActions = __webpack_require__(311);
	
	var _lodash = __webpack_require__(14);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPEN_WORKFLOW_OVERVIEW_REQUEST = exports.OPEN_WORKFLOW_OVERVIEW_REQUEST = 'OPEN_WORKFLOW_OVERVIEW_REQUEST';
	var OPEN_WORKFLOW_OVERVIEW_SUCCESS = exports.OPEN_WORKFLOW_OVERVIEW_SUCCESS = 'OPEN_WORKFLOW_OVERVIEW_SUCCESS';
	var OPEN_WORKFLOW_OVERVIEW_FAILURE = exports.OPEN_WORKFLOW_OVERVIEW_FAILURE = 'OPEN_WORKFLOW_OVERVIEW_FAILURE';
	var CLOSE_WORKFLOW_OVERVIEW = exports.CLOSE_WORKFLOW_OVERVIEW = 'CLOSE_WORKFLOW_OVERVIEW';
	var CHANGE_UOM_GROUP_NAME = exports.CHANGE_UOM_GROUP_NAME = 'CHANGE_UOM_GROUP_NAME';
	var CHANGE_UOM_UNIT_NAME = exports.CHANGE_UOM_UNIT_NAME = 'CHANGE_UOM_UNIT_NAME';
	var CHANGE_UOM_UNIT_RATIO = exports.CHANGE_UOM_UNIT_RATIO = 'CHANGE_UOM_UNIT_RATIO';
	var ADD_UOM_UNIT = exports.ADD_UOM_UNIT = 'ADD_UOM_UNIT';
	var REMOVE_UOM_UNIT = exports.REMOVE_UOM_UNIT = 'REMOVE_ROM_UNIT';
	var ENABLE_UOM_OVERVIEW_EDITMODE = exports.ENABLE_UOM_OVERVIEW_EDITMODE = 'ENABLE_UOM_OVERVIEW_EDITMODE';
	var SUBMIT_UOM_GROUP_REQUEST = exports.SUBMIT_UOM_GROUP_REQUEST = 'SUBMIT_UOM_GROUP_REQUEST';
	var SUBMIT_UOM_GROUP_SUCCESS = exports.SUBMIT_UOM_GROUP_SUCCESS = 'SUBMIT_UOM_GROUP_SUCCESS';
	var SUBMIT_UOM_GROUP_FAILURE = exports.SUBMIT_UOM_GROUP_FAILURE = 'SUBMIT_UOM_GROUP_FAILURE';
	
	var open = exports.open = function open(storeId, unitGroupId) {
	  return function (dispatch) {
	    dispatch({ type: OPEN_WORKFLOW_OVERVIEW_REQUEST, unitGroupId: unitGroupId, storeId: storeId });
	    if (unitGroupId) {
	      dispatch((0, _uomGroupActions.getGroup)(unitGroupId, storeId)).then(function (resp) {
	        var data = resp.data,
	            error = resp.error;
	
	        if (!error) {
	          dispatch({ type: OPEN_WORKFLOW_OVERVIEW_SUCCESS, data: data });
	          return { groupData: data };
	        } else {
	          alert(error.message);
	          dispatch({ type: OPEN_WORKFLOW_OVERVIEW_FAILURE, error: error });
	          return { error: error };
	        }
	      });
	    }
	  };
	};
	var close = exports.close = function close() {
	  return { type: CLOSE_WORKFLOW_OVERVIEW };
	};
	var enableEditMode = exports.enableEditMode = function enableEditMode() {
	  return { type: ENABLE_UOM_OVERVIEW_EDITMODE };
	};
	var changeGroupName = exports.changeGroupName = function changeGroupName(value) {
	  return { type: CHANGE_UOM_GROUP_NAME, value: value };
	};
	var changeUnitName = exports.changeUnitName = function changeUnitName(value, index) {
	  return { type: CHANGE_UOM_UNIT_NAME, value: value, index: index };
	};
	var changeUnitRatio = exports.changeUnitRatio = function changeUnitRatio(value, index) {
	  return { type: CHANGE_UOM_UNIT_RATIO, value: value, index: index };
	};
	var addUomUnit = exports.addUomUnit = function addUomUnit() {
	  return { type: ADD_UOM_UNIT };
	};
	var removeUnit = exports.removeUnit = function removeUnit(index) {
	  return { type: REMOVE_UOM_UNIT, index: index };
	};
	var submit = exports.submit = function submit() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var data = state.forms.uomOverview;
	    var units = data.units,
	        groupName = data.groupName,
	        isCreating = data.isCreating,
	        storeId = data.storeId,
	        initialValues = data.initialValues,
	        referenceUnit = data.referenceUnit;
	
	    if (!groupName) {
	      alert('Please enter group name.');
	      return;
	    }
	    if (!referenceUnit.name) {
	      alert('Please enter reference unit.');
	      return;
	    }
	    var noName = units.map(function (group, i) {
	      return group.name ? null : i;
	    }).filter(function (i) {
	      return !!i;
	    });
	    if (noName.length) {
	      alert('Please enter unit name.');
	      return;
	    }
	    var noRatio = units.map(function (group, i) {
	      return group.ratio !== null && group.ratio !== undefined ? null : i;
	    }).filter(function (i) {
	      return !!i;
	    });
	    if (noRatio.length) {
	      alert('Please enter unit ratio.');
	      return;
	    }
	
	    var allName = units.map(function (u) {
	      return u.name;
	    }).concat([referenceUnit.name]);
	
	    var deplicatedName = allName.filter(function (n, i) {
	      return allName.indexOf(n) !== i;
	    });
	    if (deplicatedName.length) {
	      alert('Please check duplicated name: ' + deplicatedName.join(', ') + '.');
	      return;
	    }
	
	    var groupData = {
	      units_attributes: []
	    };
	    dispatch({ type: SUBMIT_UOM_GROUP_REQUEST });
	    if (isCreating) {
	      groupData.name = groupName;
	      groupData.units_attributes = units.map(cleanUnitData).concat([cleanUnitData(referenceUnit)]);
	      dispatch((0, _uomGroupActions.create)(groupData, storeId)).then(function (resp) {
	        var data = resp.data,
	            error = resp.error;
	
	        if (!error) {
	          var id = data.id;
	
	          _routeHelper2.default.goUomGroups(storeId, id);
	        } else {
	          alert(error.message);
	          dispatch({ type: SUBMIT_UOM_GROUP_FAILURE, error: error });
	        }
	      }).catch(function (error) {
	        alert(error.message);
	        dispatch({ type: SUBMIT_UOM_GROUP_FAILURE, error: error });
	      });
	    } else {
	      if (groupName !== initialValues.name) groupData.name = groupName;
	      var initialUnits = initialValues.units || [];
	      initialUnits = initialUnits.filter(function (u) {
	        return u.isBaseUnit === false;
	      });
	      var toRemove = (0, _lodash.differenceBy)(initialUnits, units, 'id');
	      var toAdd = (0, _lodash.differenceBy)(units, initialUnits, 'id');
	      var toUpdate = (0, _lodash.intersectionBy)(units, initialUnits, 'id');
	      toRemove.forEach(function (i) {
	        return i['_destroy'] = true;
	      });
	      groupData.units_attributes = groupData.units_attributes.concat(toAdd.map(cleanUnitData)).concat(toRemove.map(cleanUnitData)).concat(toUpdate.map(cleanUnitData));
	      dispatch((0, _uomGroupActions.update)(groupData, initialValues.id, storeId)).then(function (resp) {
	        var data = resp.data,
	            error = resp.error;
	
	        if (!error) {
	          dispatch({ type: SUBMIT_UOM_GROUP_SUCCESS });
	          dispatch({ type: OPEN_WORKFLOW_OVERVIEW_SUCCESS, data: data });
	        } else {
	          alert(error.message);
	          dispatch({ type: SUBMIT_UOM_GROUP_FAILURE, error: error });
	        }
	      });
	    }
	  };
	};
	
	function cleanUnitData(data) {
	  return (0, _lodash.pick)(data, ['id', 'name', 'unitGroupId', 'ratio', 'isBaseUnit', '_destroy']);
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveWorkflowSetting = exports.addWorkflowNextStep = exports.selectWorkflowTitle = exports.changeWorkflowTitle = exports.showWorkflowOverview = exports.SAVE_WORKFLOW_SETTING_FAILURE = exports.SAVE_WORKFLOW_SETTING_SUCCESS = exports.SAVE_WORKFLOW_SETTING_REQUEST = exports.ADD_WORKFLOW_NEXT_STEP = exports.SELECT_WORKFLOW_STEP_STATUS = exports.CHANGE_WORKFLOW_TITLE = exports.SHOW_WORKFLOW_OVERVIEW = undefined;
	
	var _unionBy = __webpack_require__(397);
	
	var _unionBy2 = _interopRequireDefault(_unionBy);
	
	var _workflowActions = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHOW_WORKFLOW_OVERVIEW = exports.SHOW_WORKFLOW_OVERVIEW = 'SHOW_WORKFLOW_OVERVIEW';
	var CHANGE_WORKFLOW_TITLE = exports.CHANGE_WORKFLOW_TITLE = 'CHANGE_WORKFLOW_TITLE';
	var SELECT_WORKFLOW_STEP_STATUS = exports.SELECT_WORKFLOW_STEP_STATUS = 'SELECT_WORKFLOW_STEP_STATUS';
	var ADD_WORKFLOW_NEXT_STEP = exports.ADD_WORKFLOW_NEXT_STEP = 'ADD_WORKFLOW_NEXT_STEP';
	
	var SAVE_WORKFLOW_SETTING_REQUEST = exports.SAVE_WORKFLOW_SETTING_REQUEST = 'SAVE_WORKFLOW_SETTING_REQUEST';
	var SAVE_WORKFLOW_SETTING_SUCCESS = exports.SAVE_WORKFLOW_SETTING_SUCCESS = 'SAVE_WORKFLOW_SETTING_SUCCESS';
	var SAVE_WORKFLOW_SETTING_FAILURE = exports.SAVE_WORKFLOW_SETTING_FAILURE = 'SAVE_WORKFLOW_SETTING_FAILURE';
	
	var showWorkflowOverview = exports.showWorkflowOverview = function showWorkflowOverview(_ref) {
	  var initialValues = _ref.initialValues,
	      isCreating = _ref.isCreating;
	  return { type: SHOW_WORKFLOW_OVERVIEW, initialValues: initialValues, isCreating: isCreating };
	};
	
	var changeWorkflowTitle = exports.changeWorkflowTitle = function changeWorkflowTitle(value) {
	  return { type: CHANGE_WORKFLOW_TITLE, value: value };
	};
	
	var selectWorkflowTitle = exports.selectWorkflowTitle = function selectWorkflowTitle(_ref2) {
	  var stepNumber = _ref2.stepNumber,
	      lineItemStatus = _ref2.lineItemStatus;
	  return { type: SELECT_WORKFLOW_STEP_STATUS, stepNumber: stepNumber, lineItemStatus: lineItemStatus };
	};
	
	var addWorkflowNextStep = exports.addWorkflowNextStep = function addWorkflowNextStep() {
	  return { type: ADD_WORKFLOW_NEXT_STEP };
	};
	
	var saveWorkflowSetting = exports.saveWorkflowSetting = function saveWorkflowSetting(storeId) {
	  return function (dispatch, getState) {
	    var state = getState();
	
	    var _state$forms$workflow = state.forms.workflowOverview,
	        initialValues = _state$forms$workflow.initialValues,
	        name = _state$forms$workflow.title,
	        steps = _state$forms$workflow.steps,
	        isCreating = _state$forms$workflow.isCreating;
	
	
	    if (steps.length === 1) {
	      alert('Please select 0 or more than 1 steps');
	      return;
	    }
	
	    var badInput = validateFalseSteps(steps);
	    if (badInput.length) {
	      alert('Please select status for step ' + badInput.map(function (i) {
	        return i + 1;
	      }).join(', '));
	      return;
	    }
	
	    var hasComplete = -1;
	    steps.forEach(function (s, i) {
	      if (s.id === -3) hasComplete = i;
	    });
	    if (hasComplete > 0 && steps[steps.length - 1].id !== -3) {
	      alert('\'Completed\' should be the last status.');
	      return;
	    }
	
	    var duplicatedInput = validateDuplicatedSteps(steps);
	    if (duplicatedInput.length) {
	      alert('Please check the duplicated status: ' + duplicatedInput.map(function (s) {
	        return s.status;
	      }).join(', '));
	      return;
	    }
	    var nextAction = isCreating ? (0, _workflowActions.createWorkflow)(makeNewWorkflow(name, steps), storeId) : (0, _workflowActions.updateWorkflow)(initialValues.id, { name: name, workflow_statuses_attributes: actionDiff(initialValues.workflow_statuses, steps) }, storeId);
	
	    dispatch({ type: SAVE_WORKFLOW_SETTING_REQUEST });
	    dispatch(nextAction).then(function (resp) {
	      var error = resp.error;
	
	      if (!error) {
	        dispatch({ type: SAVE_WORKFLOW_SETTING_SUCCESS });
	        alert('Update workflow successfully.');
	      } else {
	        dispatch({ type: SAVE_WORKFLOW_SETTING_FAILURE, error: error });
	        alert('Update workflow failed.');
	      }
	    }).catch(function (error) {
	      dispatch({ type: SAVE_WORKFLOW_SETTING_FAILURE, error: error });
	      alert('Update workflow failed.');
	    });
	  };
	};
	
	function makeNewWorkflow(title, statuses) {
	  var workflow = { name: title };
	  var trans = [];
	  for (var i = 1; i < statuses.length; i++) {
	    var from = statuses[i - 1];
	    var to = statuses[i];
	    trans.push({
	      id: '',
	      action: 'from ' + from.status + ' to ' + to.status,
	      from_status_id: from.id,
	      to_status_id: to.id
	    });
	  }
	  workflow.workflow_statuses_attributes = trans;
	  return workflow;
	}
	
	function actionDiff(prev, steps) {
	  var nextActions = [];
	
	  for (var i = 1; i < steps.length; i++) {
	    var from = steps[i - 1];
	    var to = steps[i];
	    nextActions.push({
	      id: '',
	      action: 'from ' + from.status + ' to ' + to.status,
	      from_status_id: from.id,
	      to_status_id: to.id
	    });
	  }
	  if (nextActions.length >= prev.length) {
	    for (var _i = 0; _i < prev.length; _i++) {
	      nextActions[_i].id = prev[_i].id;
	    }
	  } else if (nextActions.length < prev.length) {
	    for (var _i2 = 0; _i2 < nextActions.length; _i2++) {
	      nextActions[_i2].id = prev[_i2].id;
	    }
	    for (var _i3 = nextActions.length; _i3 < prev.length; _i3++) {
	      var action = prev[_i3];
	      nextActions.push({
	        id: action.id,
	        action: action.action,
	        from_status_id: action.from_status.id,
	        to_status_id: action.to_status.id,
	        '_destroy': true
	      });
	    }
	  }
	  return nextActions;
	}
	
	function validateFalseSteps(steps) {
	  return steps.map(function (s, i) {
	    return s == null ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	}
	
	function validateDuplicatedSteps(steps) {
	  var ids = {};
	  steps.forEach(function (s) {
	    if (ids[s.id] === undefined) {
	      ids[s.id] = 1;
	    } else {
	      ids[s.id] = ids[s.id] + 1;
	    }
	  });
	  return (0, _unionBy2.default)(steps.filter(function (s) {
	    return ids[s.id] !== undefined && ids[s.id] > 1;
	  }), 'id');
	}

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearIvType = exports.changeIVType = exports.changeFilters = exports.changePage = exports.changeRowsPerPage = exports.load = exports.actionTypes = undefined;
	
	var _keykey = __webpack_require__(270);
	
	var _keykey2 = _interopRequireDefault(_keykey);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var _typeToPermissionHelper = __webpack_require__(318);
	
	var _typeToPermissionHelper2 = _interopRequireDefault(_typeToPermissionHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = (0, _keykey2.default)(['LOAD_INVENTORY_VARIANCE_INDEX_REQUEST', 'LOAD_INVENTORY_VARIANCE_INDEX_SUCCESS', 'LOAD_INVENTORY_VARIANCE_INDEX_FAILURE', 'CHANGE_INVENTORY_VARIANCE_INDEX_ROWS_PER_PAGE', 'CHANGE_INVENTORY_VARIANCE_INDEX_PAGE_NUMBER', 'CHANGE_INVENTORY_VARIANCE_INDEX_FILTERS', 'CHANGE_INVENTORY_VARIANCE_TYPE', 'CLEAR_IV_TYPE']);
	
	var load = exports.load = function load(storeId, currentPage, rowsPerPage, filters) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_REQUEST, storeId: storeId });
	    dispatch((0, _inventoryVarianceActions.searchInventoryVariances)(storeId, currentPage, rowsPerPage, undefined, filters)).then(function (resp) {
	      var page = resp.page,
	          count = resp.count,
	          totalCount = resp.totalCount,
	          totalPages = resp.totalPages,
	          error = resp.error,
	          data = resp.data;
	
	      if (error) {
	        // alert(error.message);
	        dispatch({ type: actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_FAILURE, error: error });
	      } else {
	        dispatch({
	          type: actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_SUCCESS,
	          data: data.inventoryVariances,
	          totalEntries: totalCount,
	          currentPage: page,
	          rowsPerPage: count,
	          totalPages: totalPages
	        });
	      }
	    });
	  };
	};
	
	var changeRowsPerPage = exports.changeRowsPerPage = function changeRowsPerPage(value) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_ROWS_PER_PAGE, value: value });
	    var state = getState();
	    var _state$pages$inventor = state.pages.inventoryVarianceIndex,
	        currentPage = _state$pages$inventor.currentPage,
	        filters = _state$pages$inventor.filters,
	        storeId = _state$pages$inventor.storeId;
	
	    dispatch(load(storeId, 1, value, filters));
	  };
	};
	
	var changePage = exports.changePage = function changePage(value) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_PAGE_NUMBER, value: value });
	    var state = getState();
	    var _state$pages$inventor2 = state.pages.inventoryVarianceIndex,
	        rowsPerPage = _state$pages$inventor2.rowsPerPage,
	        filters = _state$pages$inventor2.filters,
	        storeId = _state$pages$inventor2.storeId;
	
	    dispatch(load(storeId, value, rowsPerPage, filters));
	  };
	};
	
	var changeFilters = exports.changeFilters = function changeFilters(filters) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_FILTERS, filters: filters });
	    var state = getState();
	    var _state$pages$inventor3 = state.pages.inventoryVarianceIndex,
	        rowsPerPage = _state$pages$inventor3.rowsPerPage,
	        currentPage = _state$pages$inventor3.currentPage,
	        storeId = _state$pages$inventor3.storeId;
	
	    dispatch(load(storeId, currentPage, rowsPerPage, filters));
	  };
	};
	
	var changeIVType = exports.changeIVType = function changeIVType(type) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_INVENTORY_VARIANCE_TYPE, ivType: type });
	  };
	};
	
	var clearIvType = exports.clearIvType = function clearIvType(currentStore) {
	  return function (dispatch, getState) {
	    for (var index = 1; index < 5; index++) {
	      if ((0, _typeToPermissionHelper2.default)(index, "add", currentStore)) {
	        return dispatch({ type: actionTypes.CLEAR_IV_TYPE, initType: index });
	      }
	    }
	  };
	};

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeFilters = exports.changePage = exports.changeRowsPerPage = exports.cancel = exports.approve = exports.load = exports.actionTypes = undefined;
	
	var _keykey = __webpack_require__(270);
	
	var _keykey2 = _interopRequireDefault(_keykey);
	
	var _productionOrderAction = __webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = (0, _keykey2.default)(['LOAD_PRODUCTION_ORDER_INDEX_REQUEST', 'LOAD_PRODUCTION_ORDER_INDEX_SUCCESS', 'LOAD_PRODUCTION_ORDER_INDEX_FAILURE', 'CHANGE_PRODUCTION_ORDER_INDEX_ROWS_PER_PAGE', 'CHANGE_PRODUCTION_ORDER_INDEX_PAGE_NUMBER', 'CHANGE_PRODUCTION_ORDER_INDEX_FILTERS']);
	
	var load = exports.load = function load(storeId, currentPage, rowsPerPage, filters) {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.LOAD_PRODUCTION_ORDER_INDEX_REQUEST, storeId: storeId });
	    dispatch((0, _productionOrderAction.getProductionOrders)(storeId, currentPage, rowsPerPage, undefined, filters)).then(function (resp) {
	      var page = resp.page,
	          count = resp.count,
	          totalCount = resp.totalCount,
	          totalPages = resp.totalPages,
	          error = resp.error,
	          data = resp.data;
	
	      if (error) {
	        // alert(error.message);
	        dispatch({ type: actionTypes.LOAD_PRODUCTION_ORDER_INDEX_FAILURE, error: error });
	      } else {
	        dispatch({
	          type: actionTypes.LOAD_PRODUCTION_ORDER_INDEX_SUCCESS,
	          data: data.productionOrders,
	          totalEntries: totalCount,
	          currentPage: page,
	          rowsPerPage: count,
	          totalPages: totalPages
	        });
	      }
	    });
	  };
	};
	
	var approve = exports.approve = function approve(id) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var _state$pages$producti = state.pages.productionOrderIndex,
	        currentPage = _state$pages$producti.currentPage,
	        filters = _state$pages$producti.filters,
	        storeId = _state$pages$producti.storeId,
	        rowsPerPage = _state$pages$producti.rowsPerPage;
	
	    return dispatch((0, _productionOrderAction.approve)(id, storeId)).then(function (resp) {
	      dispatch(load(storeId, currentPage, rowsPerPage, filters));
	    });
	  };
	};
	
	var cancel = exports.cancel = function cancel(id) {
	  return function (dispatch, getState) {
	    if (window.confirm("Do you really want to cancel this order?")) {
	      var state = getState();
	      var _state$pages$producti2 = state.pages.productionOrderIndex,
	          currentPage = _state$pages$producti2.currentPage,
	          filters = _state$pages$producti2.filters,
	          storeId = _state$pages$producti2.storeId,
	          rowsPerPage = _state$pages$producti2.rowsPerPage;
	
	      return dispatch((0, _productionOrderAction.cancel)(id, storeId)).then(function (resp) {
	        dispatch(load(storeId, currentPage, rowsPerPage, filters));
	      });
	    }
	  };
	};
	
	var changeRowsPerPage = exports.changeRowsPerPage = function changeRowsPerPage(value) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_ROWS_PER_PAGE, value: value });
	    var state = getState();
	    var _state$pages$producti3 = state.pages.productionOrderIndex,
	        currentPage = _state$pages$producti3.currentPage,
	        filters = _state$pages$producti3.filters,
	        storeId = _state$pages$producti3.storeId;
	
	    dispatch(load(storeId, currentPage, value, filters));
	  };
	};
	
	var changePage = exports.changePage = function changePage(value) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_PAGE_NUMBER, value: value });
	    var state = getState();
	    var _state$pages$producti4 = state.pages.productionOrderIndex,
	        rowsPerPage = _state$pages$producti4.rowsPerPage,
	        filters = _state$pages$producti4.filters,
	        storeId = _state$pages$producti4.storeId;
	
	    dispatch(load(storeId, value, rowsPerPage, filters));
	  };
	};
	
	var changeFilters = exports.changeFilters = function changeFilters(filters) {
	  return function (dispatch, getState) {
	    dispatch({ type: actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_FILTERS, filters: filters });
	    var state = getState();
	    var _state$pages$producti5 = state.pages.productionOrderIndex,
	        rowsPerPage = _state$pages$producti5.rowsPerPage,
	        currentPage = _state$pages$producti5.currentPage,
	        storeId = _state$pages$producti5.storeId;
	
	    dispatch(load(storeId, currentPage, rowsPerPage, filters));
	  };
	};

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cancel = exports.fulfill = exports.approve = exports.update = exports.create = exports.getProductionOrder = exports.getProductionOrders = exports.CANCEL_PRODUCTION_ORDER_FAILURE = exports.CANCEL_PRODUCTION_ORDER_SUCCESS = exports.CANCEL_PRODUCTION_ORDER_REQUEST = exports.FULFILL_PRODUCTION_ORDER_FAILURE = exports.FULFILL_PRODUCTION_ORDER_SUCCESS = exports.FULFILL_PRODUCTION_ORDER_REQUEST = exports.APPROVE_PRODUCTION_ORDER_FAILURE = exports.APPROVE_PRODUCTION_ORDER_SUCCESS = exports.APPROVE_PRODUCTION_ORDER_REQUEST = exports.UPDATE_PRODUCTION_ORDER_FAILURE = exports.UPDATE_PRODUCTION_ORDER_SUCCESS = exports.UPDATE_PRODUCTION_ORDER_REQUEST = exports.CREATE_PRODUCTION_ORDER_FAILURE = exports.CREATE_PRODUCTION_ORDER_SUCCESS = exports.CREATE_PRODUCTION_ORDER_REQUEST = exports.GET_PRODUCTION_ORDER_FAILURE = exports.GET_PRODUCTION_ORDER_SUCCESS = exports.GET_PRODUCTION_ORDER_REQUEST = exports.GET_PRODUCTION_ORDERS_FAILURE = exports.GET_PRODUCTION_ORDERS_SUCCESS = exports.GET_PRODUCTION_ORDERS_REQUEST = undefined;
	
	var _humps = __webpack_require__(44);
	
	var _productionOrderService = __webpack_require__(962);
	
	var _productionOrderService2 = _interopRequireDefault(_productionOrderService);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { startFetch, stopFetch } from './baseActions';
	
	var GET_PRODUCTION_ORDERS_REQUEST = exports.GET_PRODUCTION_ORDERS_REQUEST = 'GET_PRODUCTION_ORDERS_REQUEST';
	var GET_PRODUCTION_ORDERS_SUCCESS = exports.GET_PRODUCTION_ORDERS_SUCCESS = 'GET_PRODUCTION_ORDERS_SUCCESS';
	var GET_PRODUCTION_ORDERS_FAILURE = exports.GET_PRODUCTION_ORDERS_FAILURE = 'GET_PRODUCTION_ORDERS_FAILURE';
	var GET_PRODUCTION_ORDER_REQUEST = exports.GET_PRODUCTION_ORDER_REQUEST = 'GET_PRODUCTION_ORDER_REQUEST';
	var GET_PRODUCTION_ORDER_SUCCESS = exports.GET_PRODUCTION_ORDER_SUCCESS = 'GET_PRODUCTION_ORDER_SUCCESS';
	var GET_PRODUCTION_ORDER_FAILURE = exports.GET_PRODUCTION_ORDER_FAILURE = 'GET_PRODUCTION_ORDER_FAILURE';
	var CREATE_PRODUCTION_ORDER_REQUEST = exports.CREATE_PRODUCTION_ORDER_REQUEST = 'CREATE_PRODUCTION_ORDER_REQUEST';
	var CREATE_PRODUCTION_ORDER_SUCCESS = exports.CREATE_PRODUCTION_ORDER_SUCCESS = 'CREATE_PRODUCTION_ORDER_SUCCESS';
	var CREATE_PRODUCTION_ORDER_FAILURE = exports.CREATE_PRODUCTION_ORDER_FAILURE = 'CREATE_PRODUCTION_ORDER_FAILURE';
	var UPDATE_PRODUCTION_ORDER_REQUEST = exports.UPDATE_PRODUCTION_ORDER_REQUEST = 'UPDATE_PRODUCTION_ORDER_REQUEST';
	var UPDATE_PRODUCTION_ORDER_SUCCESS = exports.UPDATE_PRODUCTION_ORDER_SUCCESS = 'UPDATE_PRODUCTION_ORDER_SUCCESS';
	var UPDATE_PRODUCTION_ORDER_FAILURE = exports.UPDATE_PRODUCTION_ORDER_FAILURE = 'UPDATE_PRODUCTION_ORDER_FAILURE';
	// export const REMOVE_PRODUCTION_ORDER_REQUEST = 'REMOVE_PRODUCTION_ORDER_REQUEST';
	// export const REMOVE_PRODUCTION_ORDER_SUCCESS = 'REMOVE_PRODUCTION_ORDER_SUCCESS';
	// export const REMOVE_PRODUCTION_ORDER_FAILURE = 'REMOVE_PRODUCTION_ORDER_FAILURE';
	var APPROVE_PRODUCTION_ORDER_REQUEST = exports.APPROVE_PRODUCTION_ORDER_REQUEST = 'APPROVE_PRODUCTION_ORDER_REQUEST';
	var APPROVE_PRODUCTION_ORDER_SUCCESS = exports.APPROVE_PRODUCTION_ORDER_SUCCESS = 'APPROVE_PRODUCTION_ORDER_SUCCESS';
	var APPROVE_PRODUCTION_ORDER_FAILURE = exports.APPROVE_PRODUCTION_ORDER_FAILURE = 'APPROVE_PRODUCTION_ORDER_FAILURE';
	var FULFILL_PRODUCTION_ORDER_REQUEST = exports.FULFILL_PRODUCTION_ORDER_REQUEST = 'FULFILL_PRODUCTION_ORDER_REQUEST';
	var FULFILL_PRODUCTION_ORDER_SUCCESS = exports.FULFILL_PRODUCTION_ORDER_SUCCESS = 'FULFILL_PRODUCTION_ORDER_SUCCESS';
	var FULFILL_PRODUCTION_ORDER_FAILURE = exports.FULFILL_PRODUCTION_ORDER_FAILURE = 'FULFILL_PRODUCTION_ORDER_FAILURE';
	var CANCEL_PRODUCTION_ORDER_REQUEST = exports.CANCEL_PRODUCTION_ORDER_REQUEST = 'CANCEL_PRODUCTION_ORDER_REQUEST';
	var CANCEL_PRODUCTION_ORDER_SUCCESS = exports.CANCEL_PRODUCTION_ORDER_SUCCESS = 'CANCEL_PRODUCTION_ORDER_SUCCESS';
	var CANCEL_PRODUCTION_ORDER_FAILURE = exports.CANCEL_PRODUCTION_ORDER_FAILURE = 'CANCEL_PRODUCTION_ORDER_FAILURE';
	
	var getProductionOrders = exports.getProductionOrders = function getProductionOrders(storeId) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	  var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  return function (dispatch) {
	    dispatch({ type: GET_PRODUCTION_ORDERS_REQUEST });
	    // dispatch(startFetch());
	    return _productionOrderService2.default.getOrders(storeId, page, perPage, orderBy, filters).then(function (resp) {
	      // dispatch(startFetch());
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.data.productionOrders;
	      if (data) {
	        var entities = {};
	        data.forEach(function (d) {
	          return entities[d.id] = d;
	        });
	        dispatch({ type: GET_PRODUCTION_ORDERS_SUCCESS, data: data });
	        dispatch({ type: _entityActions.SET_ENTITIES, collection: 'productionOrders', data: entities });
	        return resp;
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: GET_PRODUCTION_ORDERS_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      // dispatch(startFetch());
	      dispatch({ type: GET_PRODUCTION_ORDERS_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var getProductionOrder = exports.getProductionOrder = function getProductionOrder(id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: GET_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.getOrder(id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: GET_PRODUCTION_ORDER_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: GET_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: GET_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var create = exports.create = function create(productionOrder, storeId) {
	  return function (dispatch) {
	    dispatch({ type: CREATE_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.create((0, _humps.decamelizeKeys)({ productionOrder: productionOrder }), storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: CREATE_PRODUCTION_ORDER_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: CREATE_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: CREATE_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var update = exports.update = function update(productionOrder, id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: UPDATE_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.update((0, _humps.decamelizeKeys)({ productionOrder: productionOrder }), id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: UPDATE_PRODUCTION_ORDER_SUCCESS, data: data });
	        // dispatch({ type: UPDATE_ENTITY, collection: 'productionOrders', id: data.id, data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: UPDATE_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: UPDATE_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	// export const remove = (id, storeId) => (dispatch) => {
	//   dispatch({ type: REMOVE_PRODUCTION_ORDER_REQUEST });
	//   return productionOrderService.remove(id, storeId)
	//     .then(resp => {
	//       let { message } = resp;
	//       if (message === 'success') {
	//         dispatch({ type: REMOVE_PRODUCTION_ORDER_SUCCESS });
	//         return { };
	//       } else {
	//         let error = new Error(message || 'Invalid response.');
	//         dispatch({ type: REMOVE_PRODUCTION_ORDER_FAILURE, error });
	//         return { error };
	//       }
	//     })
	//     .catch(error => {
	//       dispatch({ type: UPDATE_PRODUCTION_ORDER_FAILURE, error });
	//     });
	// };
	
	var approve = exports.approve = function approve(id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: APPROVE_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.approve(id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: APPROVE_PRODUCTION_ORDER_SUCCESS, data: data });
	        // dispatch({ type: UPDATE_ENTITY, collection: 'productionOrders', id: data.id, data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: APPROVE_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: APPROVE_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var fulfill = exports.fulfill = function fulfill(productionOrder, id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: FULFILL_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.fulfill((0, _humps.decamelizeKeys)({ productionOrder: productionOrder }), id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: FULFILL_PRODUCTION_ORDER_SUCCESS, data: data });
	        // dispatch({ type: UPDATE_ENTITY, collection: 'productionOrders', id: data.id, data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: FULFILL_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: FULFILL_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	
	var cancel = exports.cancel = function cancel(id, storeId) {
	  return function (dispatch) {
	    dispatch({ type: CANCEL_PRODUCTION_ORDER_REQUEST });
	    return _productionOrderService2.default.cancel(id, storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.productionOrder;
	      if (data) {
	        dispatch({ type: CANCEL_PRODUCTION_ORDER_SUCCESS, data: data });
	        // dispatch({ type: UPDATE_ENTITY, collection: 'productionOrders', id: data.id, data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response.');
	        dispatch({ type: CANCEL_PRODUCTION_ORDER_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: CANCEL_PRODUCTION_ORDER_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SET_SUPPLIER = exports.SET_SUPPLIERS_STATUS = exports.SET_SUPPLIERS = undefined;
	exports.getSuppliers = getSuppliers;
	exports.getSupplier = getSupplier;
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _normalizr = __webpack_require__(64);
	
	var _schema = __webpack_require__(109);
	
	var _supplierService = __webpack_require__(966);
	
	var _supplierService2 = _interopRequireDefault(_supplierService);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// LIST
	var SET_SUPPLIERS = exports.SET_SUPPLIERS = 'SET_SUPPLIERS';
	var SET_SUPPLIERS_STATUS = exports.SET_SUPPLIERS_STATUS = 'SET_SUPPLIERS_STATUS';
	
	// ITEM
	var SET_SUPPLIER = exports.SET_SUPPLIER = 'SET_SUPPLIER';
	
	function getSuppliers(storeId, page, count, orderBy) {
	  return function (dispatch) {
	    return _supplierService2.default.getList(storeId, page, count, orderBy).then(function (data) {
	      data.data = (0, _map2.default)(data.data, function (d) {
	        return d.supplier;
	      });
	      var suppliers = (0, _normalizr.normalize)(data, {
	        data: (0, _normalizr.arrayOf)(_schema.SupplierSchema)
	      });
	
	      dispatch({ type: _entityActions.SET_ENTITIES_SUPPLIERS, data: suppliers.entities });
	      dispatch({ type: SET_SUPPLIERS, data: { storeId: storeId, supplierIds: suppliers.result.data } });
	    });
	  };
	}
	
	function getSupplier(storeId, supplierId) {
	  return function (dispatch) {
	    return _supplierService2.default.getItem(storeId, supplierId).then(function (data) {
	      var suppliers = (0, _normalizr.normalize)({ data: [data.supplier] }, {
	        data: (0, _normalizr.arrayOf)(_schema.SupplierSchema)
	      });
	
	      dispatch({ type: _entityActions.SET_ENTITIES_SUPPLIERS, data: suppliers.entities });
	      dispatch({ type: SET_SUPPLIERS, data: { storeId: storeId, supplierIds: suppliers.result.data } });
	    });
	  };
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.save = exports.updateField = exports.init = exports.UPDATE_SETTINGS_BUSINESS_TABLE_FIELD = exports.INIT_SETTINGS_BUSINESS_TABLE = undefined;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _humps = __webpack_require__(44);
	
	var _storeService = __webpack_require__(496);
	
	var _storeService2 = _interopRequireDefault(_storeService);
	
	var _baseActions = __webpack_require__(34);
	
	var _alertActions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INIT_SETTINGS_BUSINESS_TABLE = exports.INIT_SETTINGS_BUSINESS_TABLE = 'INIT_SETTINGS_BUSINESS_TABLE';
	
	// import { UPDATE_STORE } from './storeActions';
	var UPDATE_SETTINGS_BUSINESS_TABLE_FIELD = exports.UPDATE_SETTINGS_BUSINESS_TABLE_FIELD = 'UPDATE_SETTINGS_BUSINESS_TABLE_FIELD';
	
	var init = exports.init = function init(storeId) {
	  return function (dispatch) {
	    return dispatch({ type: INIT_SETTINGS_BUSINESS_TABLE, data: { storeId: storeId } });
	  };
	};
	
	var updateField = exports.updateField = function updateField(field, value) {
	  return function (dispatch) {
	    return dispatch({ type: UPDATE_SETTINGS_BUSINESS_TABLE_FIELD, data: { field: field, value: value } });
	  };
	};
	
	var save = exports.save = function save(storeId, oldValue, newValue) {
	  return function (dispatch) {
	    var initDefaultTableTurnTime = (0, _big2.default)(oldValue);
	    if (storeId && oldValue && newValue && !initDefaultTableTurnTime.eq(newValue)) {
	      if (newValue.lt(initDefaultTableTurnTime)) {
	        if (!confirm('This change will update all current table seat time, are you sure to update it?\n改動會更新現有的座檯限時，確認更改？')) {
	          return;
	        }
	      }
	
	      var defaultTableTurnTime = parseInt(newValue.toString());
	      var data = { module: { defaultTableTurnTime: defaultTableTurnTime } };
	      dispatch((0, _baseActions.startFetch)());
	
	      return _storeService2.default.updateModule(storeId, (0, _humps.decamelizeKeys)(data)).then(function (res) {
	        // HACK: since it will update store module, require refresht the angular container
	        dispatch(_baseActions.stopFetch);
	        window.top.location.reload();
	      }).catch(function (err) {
	        var msg = err && err.message ? err.message : 'Error occur during save';
	        dispatch((0, _alertActions.alert)('danger', msg));
	        dispatch(_baseActions.stopFetch);
	      });
	    }
	  };
	};

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOGIN_FAILURE = exports.LOGIN_SUCCESS = undefined;
	exports.requestLoginSuccess = requestLoginSuccess;
	exports.login = login;
	
	var _loginService = __webpack_require__(959);
	
	var _loginService2 = _interopRequireDefault(_loginService);
	
	var _authDataHelper = __webpack_require__(234);
	
	var _authDataHelper2 = _interopRequireDefault(_authDataHelper);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _baseActions = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
	
	function requestLoginSuccess(user) {
	  return {
	    type: LOGIN_SUCCESS,
	    user: user
	  };
	}
	
	function requestLoginFailure() {
	  _authDataHelper2.default.clear();
	
	  return {
	    type: LOGIN_FAILURE
	  };
	}
	
	function login(username, password) {
	  return function (dispatch) {
	    dispatch((0, _baseActions.startFetch)());
	
	    return _loginService2.default.login(username, password).then(function (_ref) {
	      var user = _ref.user;
	
	      _authDataHelper2.default.save(user);
	      dispatch(requestLoginSuccess(user));
	      dispatch((0, _baseActions.stopFetch)());
	      _routeHelper2.default.goSiteIndex();
	    }).catch(function (ex) {
	      dispatch(requestLoginFailure());
	      dispatch((0, _baseActions.stopFetch)());
	    });
	  };
	}

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1231);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _compact = __webpack_require__(280);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	var _orderCorrespondenceService = __webpack_require__(961);
	
	var _orderCorrespondenceService2 = _interopRequireDefault(_orderCorrespondenceService);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RAND = function RAND() {
	  return new Date().getTime();
	};
	
	function noop() {}
	
	function listingCheckboxFactory(scope, name, singleSelect, refsMap) {
	  var listingCheckbox = function listingCheckbox(props) {
	    var id = props.rowData.id;
	    return _react2.default.createElement('input', { type: singleSelect ? 'radio' : 'checkbox',
	      name: name,
	      'data-orderid': id,
	      ref: function ref(c) {
	        return refsMap[id] = c;
	      } });
	  };
	  listingCheckbox.propTypes = {
	    rowData: _propTypes2.default.object
	  };
	  return listingCheckbox;
	}
	
	var AddInvoiceButton = (_temp2 = _class = function (_Component) {
	  _inherits(AddInvoiceButton, _Component);
	
	  function AddInvoiceButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddInvoiceButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddInvoiceButton.__proto__ || Object.getPrototypeOf(AddInvoiceButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpen: false,
	      listings: null,
	      currentFilters: [],
	      currentPage: 0,
	      totalPages: 1,
	      loading: false
	    }, _this.listingCheckboxs = {}, _this.closeModal = function () {
	      _this.setState({
	        isOpen: false
	      });
	    }, _this.openModal = function () {
	      _this.setState({
	        listings: null,
	        isOpen: true
	      });
	    }, _this.advanceSearch = function () {
	      _this.setState({
	        advanceSearch: true
	      });
	    }, _this.simpleSearch = function () {
	      _this.setState({
	        advanceSearch: false
	      });
	    }, _this.confirm = function () {
	      var checkedIds = (0, _compact2.default)((0, _map2.default)(_this.listingCheckboxs, function (checkbox, id) {
	        return checkbox && checkbox.checked ? id : null;
	      }));
	      var invoices = checkedIds.map(function (id) {
	        return _this.state.listings.find(function (listing) {
	          return listing.id == id;
	        });
	      });
	      _this.props.onConfirm && _this.props.onConfirm(invoices);
	      _this.closeModal();
	    }, _this.search = function (event) {
	      event.preventDefault();
	
	      var number = _this.refs.keyword.value;
	      var correspondence_state = _this.refs.status.value;
	      var _this$props$filters = _this.props.filters,
	          filters = _this$props$filters === undefined ? {} : _this$props$filters;
	      var inventory_status = filters.inventory_status,
	          customer_id = filters.customer_id;
	
	      var filtersObj = { number: number, correspondence_state: correspondence_state, inventory_status: inventory_status, customer_id: customer_id };
	      filtersObj = Object.keys(filtersObj).reduce(function (ret, key) {
	        var value = filtersObj[key];
	        if (value != null && value !== '' && (!Array.isArray(value) || value.length > 0)) {
	          ret[key] = value;
	        }
	        return ret;
	      }, {});
	
	      _this.searchByFilter(filtersObj);
	    }, _this.setPage = function (index) {
	      var page = index + 1;
	      _this.searchByFilter(_this.state.currentFilters, page);
	      _this.setState({
	        currentPage: index
	      });
	    }, _this.searchByFilter = function (filters) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	      _this.setState({ loading: true });
	
	      var store_id = _this.context.currentStore.id;
	      var _this$props$excludeIn = _this.props.excludeInvoices,
	          excludeInvoices = _this$props$excludeIn === undefined ? [] : _this$props$excludeIn;
	
	      _orderCorrespondenceService2.default.getList(store_id, page, 50, undefined, [], filters).then(function (res) {
	        var _res$result = res.result,
	            result = _res$result === undefined ? [] : _res$result,
	            _res$meta = res.meta,
	            meta = _res$meta === undefined ? {} : _res$meta,
	            _res$entities$orderCo = res.entities.orderCorrespondences,
	            orderCorrespondences = _res$entities$orderCo === undefined ? {} : _res$entities$orderCo;
	        var page = meta.page,
	            totalPages = meta.totalPages;
	
	        var gridData = result.map(function (id) {
	          return orderCorrespondences[id];
	        }).filter(function (d) {
	          return !!d;
	        }).filter(function (d) {
	          return excludeInvoices.indexOf(d.id) < 0;
	        });
	        _this.setState({
	          listings: gridData,
	          currentFilters: filters,
	          currentPage: page - 1,
	          totalPages: totalPages,
	          loading: false
	        });
	      }).catch(function (e) {
	        console.error(Error(e));
	        _this.setState({ loading: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddInvoiceButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          _props$singleSelect = _props.singleSelect,
	          singleSelect = _props$singleSelect === undefined ? false : _props$singleSelect,
	          className = _props.className;
	
	
	      var columnMetadatas = [{
	        columnName: "customer_name",
	        displayName: "CUSTOMER"
	      }, {
	        columnName: "number",
	        displayName: "ORDER NUMBER"
	      }, {
	        columnName: "id",
	        displayName: "REFERENCE NUMBER"
	      }, {
	        columnName: "billed_total",
	        displayName: "AMOUNT"
	      }, {
	        columnName: " ",
	        displayName: "",
	        customComponent: listingCheckboxFactory(this, 'add-invoice__checkbox--' + RAND(), singleSelect, this.listingCheckboxs)
	      }];
	      var columns = columnMetadatas.map(function (c) {
	        return c.columnName;
	      });
	      return _react2.default.createElement(
	        'span',
	        null,
	        className && className !== '' ? _react2.default.createElement(
	          'a',
	          { className: className, onClick: this.openModal },
	          children
	        ) : _react2.default.createElement(
	          _actionButton2.default,
	          { type: 'add', onClick: this.openModal },
	          children
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { className: 'ReactModal__Content--fixed', isOpen: this.state.isOpen, onRequestClose: this.closeModal },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-7' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'modal-title' },
	                    'Select Invoice'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5 align-right' },
	                  _react2.default.createElement(
	                    'form',
	                    { className: 'form-inline align-right', onSubmit: this.search },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Enter invoice number', ref: 'keyword' })
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-secondary' },
	                      'Search'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-3' },
	                  _react2.default.createElement(
	                    'form',
	                    { className: 'form-group align-left' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement(
	                        'select',
	                        { ref: 'status', className: 'form-control' },
	                        _react2.default.createElement(
	                          'option',
	                          { key: '0', value: '' },
	                          'All Status'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { key: '1', value: 'partial_paid' },
	                          'Partial Paid'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { key: '2', value: 'unpaid' },
	                          'Unpaid'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { key: '3', value: 'paid' },
	                          'Paid'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-body' },
	              !this.state.listings ? _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Search for invoice you need.'
	                )
	              ) : _react2.default.createElement(_griddleReact2.default, {
	                useExternal: true,
	                useGriddleStyles: false,
	                tableClassName: 'table table-bordered data-table',
	                externalSetPage: this.setPage,
	                externalChangeSort: noop,
	                externalSetFilter: noop,
	                externalSetPageSize: noop,
	                externalMaxPage: this.state.totalPages,
	                externalCurrentPage: this.state.currentPage,
	                resultsPerPage: this.state.count,
	                results: this.state.listings,
	                noDataMessage: 'No search result',
	                columns: columns,
	                columnMetadata: columnMetadatas
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2.default.createElement(
	                'span',
	                { className: 'btn btn-sm btn-secondary', onClick: this.closeModal },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary', onClick: this.confirm },
	                'Done'
	              )
	            ),
	            this.state.loading ? _react2.default.createElement(
	              'div',
	              { className: 'mask' },
	              _react2.default.createElement(_loading2.default, null)
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddInvoiceButton;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  onConfirm: _propTypes2.default.func,
	  singleSelect: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  filters: _propTypes2.default.shape({
	    inventory_status: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['in_transit', 'unfulfilled', 'fulfilled', 'cancel', 'return'])),
	    customer_id: _propTypes2.default.number
	  }),
	  excludeInvoices: _propTypes2.default.arrayOf(_propTypes2.default.number)
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = AddInvoiceButton;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Module = exports.Can = undefined;
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _module = __webpack_require__(774);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Can = _can2.default;
	exports.Module = _module2.default;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2, _class3, _temp3;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _dropDown = __webpack_require__(231);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionDropDown = (_temp = _class = function (_Component) {
	  _inherits(ActionDropDown, _Component);
	
	  function ActionDropDown() {
	    _classCallCheck(this, ActionDropDown);
	
	    return _possibleConstructorReturn(this, (ActionDropDown.__proto__ || Object.getPrototypeOf(ActionDropDown)).apply(this, arguments));
	  }
	
	  _createClass(ActionDropDown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowData = _props.rowData,
	          metadata = _props.metadata;
	      var _metadata$actions = metadata.actions,
	          actions = _metadata$actions === undefined ? [] : _metadata$actions;
	
	      var actionButtons = actions.map(function (act, i) {
	        var name = act.name,
	            hide = act.hide,
	            _onClick = act.onClick;
	
	        if (hide || typeof hide === 'function' ? hide(rowData) : false) return null;
	        return _react2.default.createElement(
	          'a',
	          { key: i, className: 'dropdown-item a', onClick: function onClick() {
	              return _onClick(rowData);
	            } },
	          name
	        );
	      });
	      var hasActionButtons = actionButtons.some(function (el) {
	        return el;
	      });
	      return hasActionButtons ? _react2.default.createElement(
	        _dropDown2.default,
	        null,
	        actionButtons
	      ) : null;
	    }
	  }]);
	
	  return ActionDropDown;
	}(_react.Component), _class.propTypes = {
	  rowData: _propTypes2.default.object,
	  metadata: _propTypes2.default.object
	}, _temp);
	var RemoveButton = (_temp2 = _class2 = function (_Component2) {
	  _inherits(RemoveButton, _Component2);
	
	  function RemoveButton() {
	    _classCallCheck(this, RemoveButton);
	
	    return _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).apply(this, arguments));
	  }
	
	  _createClass(RemoveButton, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          rowData = _props2.rowData,
	          metadata = _props2.metadata;
	      var _onClick2 = metadata.onClick;
	
	
	      return _react2.default.createElement('button', { type: 'button', className: '_remove', onClick: function onClick() {
	          return _onClick2(rowData);
	        } });
	    }
	  }]);
	
	  return RemoveButton;
	}(_react.Component), _class2.propTypes = {
	  rowData: _propTypes2.default.object,
	  metadata: _propTypes2.default.object
	}, _temp2);
	var GridBody = (_temp3 = _class3 = function (_Component3) {
	  _inherits(GridBody, _Component3);
	
	  function GridBody() {
	    _classCallCheck(this, GridBody);
	
	    return _possibleConstructorReturn(this, (GridBody.__proto__ || Object.getPrototypeOf(GridBody)).apply(this, arguments));
	  }
	
	  _createClass(GridBody, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          data = _props3.data,
	          metadatas = _props3.columns,
	          actions = _props3.actions,
	          onRemove = _props3.onRemove,
	          border = _props3.border,
	          noOutline = _props3.noOutline,
	          props = _objectWithoutProperties(_props3, ['data', 'columns', 'actions', 'onRemove', 'border', 'noOutline']);
	
	      var rows = data.slice();
	      var columnMetadatas = metadatas.slice();
	      if (Array.isArray(actions)) {
	        columnMetadatas.push({
	          columnName: "gridActions",
	          displayName: "",
	          customComponent: ActionDropDown,
	          actions: actions
	        });
	      }
	      if (typeof onRemove === 'function') {
	        columnMetadatas.push({
	          columnName: "  ",
	          displayName: "",
	          customComponent: RemoveButton,
	          onClick: onRemove
	        });
	      }
	      var columnNames = columnMetadatas.filter(function (i) {
	        return !i.hide;
	      }).map(function (i) {
	        return i.columnName;
	      });
	      rows.forEach(function (datum) {
	        columnNames.forEach(function (col) {
	          if (!datum.hasOwnProperty(col)) datum[col] = " ";
	        });
	      });
	      var tableClassName = (0, _classnames2.default)('table data-table', {
	        'table-bordered': !noOutline,
	        'data-table--h-border': border === 'h',
	        'data-table--v-border': border === 'v',
	        'data-table--all-border': border === true,
	        'data-table--no-border': border === false
	      });
	
	      return _react2.default.createElement(_griddleReact2.default, _extends({
	        useGriddleStyles: false,
	        tableClassName: tableClassName,
	        resultsPerPage: 200,
	        results: rows,
	        rowMetadata: { key: 'id' },
	        columns: columnNames,
	        columnMetadata: columnMetadatas
	      }, props));
	    }
	  }]);
	
	  return GridBody;
	}(_react.Component), _class3.propTypes = {
	  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    hide: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
	  })),
	  columns: _propTypes2.default.array,
	  data: _propTypes2.default.array,
	  onRemove: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
	  border: _propTypes2.default.oneOf([true, false, 'v', 'h']),
	  noOutline: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  loadingGrid: false,
	  actions: undefined,
	  columns: [],
	  data: [],
	  showRemoveButton: false,
	  onRemove: undefined,
	  border: 'v',
	  noOutline: false
	}, _temp3);
	exports.default = GridBody;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSelect = (_temp = _class = function (_Component) {
	  _inherits(InputSelect, _Component);
	
	  function InputSelect() {
	    _classCallCheck(this, InputSelect);
	
	    return _possibleConstructorReturn(this, (InputSelect.__proto__ || Object.getPrototypeOf(InputSelect)).apply(this, arguments));
	  }
	
	  _createClass(InputSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          readOnly = _props.readOnly,
	          onClick = _props.onClick,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          wrapperClassName = _props.wrapperClassName,
	          inputClassName = _props.inputClassName;
	
	      var cls = (0, _classnames2.default)('input-select', wrapperClassName || '', {
	        'input-select--readonly': readOnly,
	        'input-select--disabled': disabled
	      });
	      var editable = !disabled && !readOnly;
	      var onClickHandle = editable ? onClick : null;
	      return _react2.default.createElement(
	        'div',
	        { className: cls, onClick: onClickHandle },
	        !editable ? null : _react2.default.createElement('i', { className: 'fa fa-ellipsis-h' }),
	        _react2.default.createElement('input', { disabled: disabled,
	          readOnly: readOnly,
	          type: 'text',
	          className: inputClassName,
	          value: value,
	          placeholder: placeholder,
	          onChange: function onChange() {}
	        })
	      );
	    }
	  }]);
	
	  return InputSelect;
	}(_react.Component), _class.propTypes = {
	  onClick: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  value: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  wrapperClassName: _propTypes2.default.string,
	  inputClassName: _propTypes2.default.string
	}, _class.defaultProps = {
	  onClick: function onClick() {},
	  disabled: false,
	  readOnly: false,
	  value: '',
	  placeholder: '',
	  wrapperClassName: '',
	  inputClassName: ''
	}, _temp);
	exports.default = InputSelect;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalToggle = function (_Component) {
	    _inherits(ModalToggle, _Component);
	
	    function ModalToggle(props) {
	        _classCallCheck(this, ModalToggle);
	
	        var _this = _possibleConstructorReturn(this, (ModalToggle.__proto__ || Object.getPrototypeOf(ModalToggle)).call(this, props));
	
	        _this.state = {
	            isOpen: false
	        };
	        return _this;
	    }
	
	    _createClass(ModalToggle, [{
	        key: 'open',
	        value: function open() {
	            var _state = this.state,
	                isOpen = _state.isOpen,
	                other = _objectWithoutProperties(_state, ['isOpen']);
	
	            isOpen = true;
	            this.setState(_extends({ isOpen: isOpen }, other));
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            var _state2 = this.state,
	                isOpen = _state2.isOpen,
	                other = _objectWithoutProperties(_state2, ['isOpen']);
	
	            isOpen = false;
	            this.setState(_extends({ isOpen: isOpen }, other));
	            this.props.onClose && this.props.onClose();
	        }
	    }, {
	        key: 'confirm',
	        value: function confirm() {
	            var ret = this.props.onConfirm();
	
	            var _state3 = this.state,
	                isOpen = _state3.isOpen,
	                other = _objectWithoutProperties(_state3, ['isOpen']);
	
	            isOpen = ret;
	            this.setState(_extends({ isOpen: isOpen }, other));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var open = this.open.bind(this);
	            var close = this.close.bind(this);
	            var confirm = this.confirm.bind(this);
	            var _props = this.props,
	                togglerLabel = _props.togglerLabel,
	                _props$togglerClassNa = _props.togglerClassName,
	                togglerClassName = _props$togglerClassNa === undefined ? 'btn btn-sm btn-primary' : _props$togglerClassNa,
	                togglerStyle = _props.togglerStyle,
	                header = _props.header,
	                children = _props.children,
	                footer = _props.footer;
	            var isOpen = this.state.isOpen;
	
	            var hasToggler = !!(togglerLabel || togglerClassName || togglerStyle);
	
	            return _react2.default.createElement(
	                'span',
	                null,
	                !hasToggler ? null : typeof togglerLabel !== 'string' ? _react2.default.createElement(
	                    'span',
	                    { onClick: open },
	                    togglerLabel
	                ) : _react2.default.createElement(
	                    'span',
	                    { className: togglerClassName, style: togglerStyle, onClick: open },
	                    togglerLabel
	                ),
	                _react2.default.createElement(
	                    _reactModal2.default,
	                    { className: 'ReactModal__Content--fixed', isOpen: isOpen, onRequestClose: close },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-header' },
	                            header
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-body' },
	                            children
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal-footer' },
	                            footer ? footer : _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'btn btn-sm btn-secondary', onClick: close },
	                                    'Cancel'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'btn btn-sm btn-primary', onClick: confirm },
	                                    'Done'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalToggle;
	}(_react.Component);
	
	ModalToggle.propTypes = {
	    header: _propTypes2.default.node.isRequired,
	    children: _propTypes2.default.node.isRequired,
	    footer: _propTypes2.default.node,
	    onConfirm: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func,
	    togglerLabel: _propTypes2.default.node,
	    togglerClassName: _propTypes2.default.string,
	    togglerStyle: _propTypes2.default.object
	};
	
	exports.default = ModalToggle;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RemoveButton = (_temp = _class = function (_Component) {
	  _inherits(RemoveButton, _Component);
	
	  function RemoveButton() {
	    _classCallCheck(this, RemoveButton);
	
	    return _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).apply(this, arguments));
	  }
	
	  _createClass(RemoveButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'remove-btn __has-title' },
	        _react2.default.createElement(
	          'div',
	          { className: 'outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement('button', { type: 'button', className: '_remove', onClick: this.props.onClick })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RemoveButton;
	}(_react.Component), _class.propTypes = {
	  onClick: _propTypes2.default.func
	}, _class.defaultProps = {
	  onClick: function onClick() {}
	}, _temp);
	exports.default = RemoveButton;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	__webpack_require__(1251);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _treeMenu = __webpack_require__(806);
	
	var _treeMenu2 = _interopRequireDefault(_treeMenu);
	
	var _modal = __webpack_require__(91);
	
	var _departmentActions = __webpack_require__(149);
	
	var _departmentSelection = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapDispatchToProp(dispatch) {
	  return {
	    getDepartments: (0, _redux.bindActionCreators)(_departmentActions.getDepartments, dispatch),
	    toggleAllDepartmentSelection: (0, _redux.bindActionCreators)(_departmentSelection.toggleAllDepartmentSelection, dispatch)
	  };
	}
	
	var SelectDepartment = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Modal) {
	  _inherits(SelectDepartment, _Modal);
	
	  function SelectDepartment(props) {
	    _classCallCheck(this, SelectDepartment);
	
	    var _this = _possibleConstructorReturn(this, (SelectDepartment.__proto__ || Object.getPrototypeOf(SelectDepartment)).call(this, props));
	
	    _this.toggleAll = _this.toggleAll.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectDepartment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getDepartments(this.context.currentStore.id);
	    }
	  }, {
	    key: 'toggleAll',
	    value: function toggleAll(event) {
	      this.props.all.map(function (data) {
	        data.checked = event.target.checked;
	      });
	      this.props.toggleAllDepartmentSelection(!event.target.checked);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          all = _props.all,
	          closeDepartmentSelection = _props.closeDepartmentSelection,
	          toggleDepartmentCollapse = _props.toggleDepartmentCollapse,
	          toggleDepartmentSelection = _props.toggleDepartmentSelection,
	          submitDepartmentSelection = _props.submitDepartmentSelection;
	
	      var customerHeader = this.props.customerHeader ? this.props.customerHeader() : null;
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(
	          _modal.ModalHeader,
	          { title: 'Select Departments' },
	          customerHeader,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: this.toggleAll }),
	            _react2.default.createElement(
	              'span',
	              { className: 'all-nodes-label' },
	              'All Departments'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_treeMenu2.default, {
	              onChange: toggleDepartmentSelection,
	              toggleCollapse: toggleDepartmentCollapse,
	              data: all })
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary',
	              onClick: closeDepartmentSelection },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary',
	              onClick: submitDepartmentSelection },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectDepartment;
	}(_modal.Modal), _class2.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  all: _propTypes2.default.array.isRequired,
	  closeDepartmentSelection: _propTypes2.default.func.isRequired,
	  submitDepartmentSelection: _propTypes2.default.func.isRequired,
	  toggleDepartmentCollapse: _propTypes2.default.func.isRequired,
	  toggleDepartmentSelection: _propTypes2.default.func.isRequired,
	  getDepartments: _propTypes2.default.func.isRequired,
	  toggleAllDepartmentSelection: _propTypes2.default.func.isRequired
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = SelectDepartment;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSerialNumber = (_temp = _class = function (_Component) {
	  _inherits(InputSerialNumber, _Component);
	
	  function InputSerialNumber(props) {
	    _classCallCheck(this, InputSerialNumber);
	
	    var _this = _possibleConstructorReturn(this, (InputSerialNumber.__proto__ || Object.getPrototypeOf(InputSerialNumber)).call(this, props));
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      if (InputSerialNumber.diffSn(_this.state.value, nextProps.value)) {
	        _this.setState(_this.getByValue(InputSerialNumber.trimSn(nextProps.value)));
	      }
	    };
	
	    _this.getByValue = function (value) {
	      var v = (value !== undefined ? value : _this.state.value) || [];
	      var mask = v.join('\n');
	      return { value: v, mask: mask };
	    };
	
	    _this.getStateMask = function (mask) {
	      var m = (mask !== undefined ? mask : _this.state.mask) || '';
	      var value = InputSerialNumber.trimSn(m.split('\n'));
	      return { value: value, mask: m };
	    };
	
	    _this.handleOnChange = function (event) {
	      var value = event.target.value;
	      var s = _this.getStateMask(value);
	      _this.setState(s);
	      _this.props.onChange && _this.props.onChange(s.value);
	    };
	
	    _this.state = _this.getByValue(props.value);
	    return _this;
	  }
	
	  _createClass(InputSerialNumber, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange,
	          _props$style = _props.style,
	          style = _props$style === undefined ? {} : _props$style,
	          rest = _objectWithoutProperties(_props, ['value', 'onChange', 'style']);
	
	      var combineStyle = Object.assign({}, { minHeight: 200 }, style);
	      var mask = this.state.mask;
	
	      return _react2.default.createElement('textarea', _extends({}, rest, { style: combineStyle, value: mask, onChange: this.handleOnChange }));
	    }
	  }]);
	
	  return InputSerialNumber;
	}(_react.Component), _class.propTypes = {
	  value: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  onChange: _propTypes2.default.func,
	  style: _propTypes2.default.object
	}, _class.trimSn = function (sns) {
	  return (0, _lodash.uniq)((sns || []).map(function (sn) {
	    return (sn || '').trim();
	  }).filter(function (sn) {
	    return sn;
	  }));
	}, _class.diffSn = function (perv, next) {
	  var prevSn = InputSerialNumber.trimSn(perv);
	  var nextSn = InputSerialNumber.trimSn(next);
	  var snDiff = prevSn.length !== nextSn.length || (0, _lodash.union)(prevSn, nextSn).length !== prevSn.length;
	  return snDiff;
	}, _temp);
	exports.default = InputSerialNumber;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transformPromoCode = transformPromoCode;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getQuota(quota) {
	  return quota === null ? null : (0, _big2.default)(quota);
	}
	
	function transformPromoCode() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      id = _ref.id,
	      image_url = _ref.image_url,
	      _ref$code = _ref.code,
	      code = _ref$code === undefined ? '' : _ref$code,
	      _ref$description = _ref.description,
	      description = _ref$description === undefined ? '' : _ref$description,
	      _ref$expired_at = _ref.expired_at,
	      expired_at = _ref$expired_at === undefined ? '' : _ref$expired_at,
	      _ref$individual_user_ = _ref.individual_user_quota,
	      individual_user_quota = _ref$individual_user_ === undefined ? null : _ref$individual_user_,
	      _ref$total_quota = _ref.total_quota,
	      total_quota = _ref$total_quota === undefined ? null : _ref$total_quota,
	      _ref$used_quota = _ref.used_quota,
	      used_quota = _ref$used_quota === undefined ? 0 : _ref$used_quota,
	      _ref$discount = _ref.discount,
	      discount = _ref$discount === undefined ? null : _ref$discount;
	
	  return {
	    id: id,
	    code: code,
	    description: description,
	    expired_at: expired_at,
	    image_url: image_url,
	    userQuota: getQuota(individual_user_quota),
	    totalQuota: getQuota(total_quota),
	    usedQuota: used_quota,
	    discount: discount
	  };
	}

/***/ },
/* 480 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getName = getName;
	exports.getMargin = getMargin;
	function getName(suppliers, supplierId) {
	  try {
	    return suppliers[supplierId].name;
	  } catch (e) {
	    return "Supplier data not exist";
	  }
	}
	
	function getMargin(cost, price) {
	  if (!cost || !price) {
	    return '';
	  }
	
	  return ((1 - cost / price) * 100).toFixed(2);
	}

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _redux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(9);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _validate = __webpack_require__(220);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _mainContent = __webpack_require__(93);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _addInvoice = __webpack_require__(471);
	
	var _addInvoice2 = _interopRequireDefault(_addInvoice);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	var _dateTimeDisplay = __webpack_require__(184);
	
	var _dateTimeDisplay2 = _interopRequireDefault(_dateTimeDisplay);
	
	var _indexStatus = __webpack_require__(319);
	
	var _indexStatus2 = _interopRequireDefault(_indexStatus);
	
	var _serialNumberInput = __webpack_require__(824);
	
	var _serialNumberInput2 = _interopRequireDefault(_serialNumberInput);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['delivery_order.number', 'delivery_order.reference_number', 'delivery_order.expected_ship_date', 'delivery_order.ship_date', 'delivery_order.order_ids[]', // required
	'delivery_order.order_ids_included', // required
	'delivery_order.stock_transfer_ids[]', // required
	'delivery_order.stock_transfer_ids_included', // required
	'delivery_order.billing.customer_id', 'delivery_order.billing.customer_name', 'delivery_order.delivery_note.customer_id', 'delivery_order.delivery_note.customer_name', 'delivery_order.delivery_note.address', 'delivery_order.delivery_note.phone', 'delivery_order.delivery_note.email', 'delivery_order.remarks', 'delivery_order.signature_data', 'delivery_order.tracking_number', 'delivery_order.courier', 'delivery_order.state', 'delivery_order.created_at', 'delivery_order.created_by', 'delivery_order_items[].id', 'delivery_order_items[].purchasable_id', 'delivery_order_items[].invoice_id', 'delivery_order_items[].invoice_number', 'delivery_order_items[].pallet_number', 'delivery_order_items[].carton_number', 'delivery_order_items[].product_id', 'delivery_order_items[].line_item_id', // required
	'delivery_order_items[].stock_transfer_item_id', // required
	'delivery_order_items[].product_code', 'delivery_order_items[].description', 'delivery_order_items[].uom', 'delivery_order_items[].total_quantity', 'delivery_order_items[].quantity', // required
	'delivery_order_items[].quantity_in_display_unit', // required
	'delivery_order_items[].qty_sent', 'delivery_order_items[].qty_remaining', // required
	'delivery_order_items[].qty_fulfilled', // For UI
	'delivery_order_items[].gross_weight', 'delivery_order_items[].net_weight', 'delivery_order_items[].weight_unit', 'delivery_order_items[].serial_numbers[]', 'delivery_order_items[].fulfilment_note', 'delivery_order_items[].upc', 'delivery_order_items[].ean13', 'delivery_order_items[].listing_barcode', 'delivery_order_items[].serial_number_enabled', 'delivery_order_items[].expiration_date_enabled', 'delivery_order_items[].unit_group_id', 'delivery_order_items[].display_unit_id', 'delivery_order_items[].display_unit'];
	
	var SummaryRow = function SummaryRow(props) {
	    var _props$children = props.children,
	        children = _props$children === undefined ? [] : _props$children,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row ' + className },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            children[0]
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            children[1]
	        )
	    );
	};
	SummaryRow.propTypes = {
	    children: _propTypes2.default.node.isRequired,
	    className: _propTypes2.default.string
	};
	
	var DeliveryOverviewForm = function (_Component) {
	    _inherits(DeliveryOverviewForm, _Component);
	
	    function DeliveryOverviewForm() {
	        _classCallCheck(this, DeliveryOverviewForm);
	
	        return _possibleConstructorReturn(this, (DeliveryOverviewForm.__proto__ || Object.getPrototypeOf(DeliveryOverviewForm)).apply(this, arguments));
	    }
	
	    _createClass(DeliveryOverviewForm, [{
	        key: 'addInvoice',
	        value: function addInvoice(invoices) {
	            var _props = this.props,
	                storeId = _props.pathState.storeId,
	                actions = _props.actions;
	
	            var invoiceIds = invoices.map(function (invoice) {
	                return invoice.number;
	            });
	            actions.addInvoiceToDeliveryOrder(storeId, invoiceIds);
	        }
	    }, {
	        key: 'setDeliveryQuantity',
	        value: function setDeliveryQuantity(field, value) {
	            field.quantity.onChange(value);
	            field.quantity_in_display_unit.onChange(value);
	            field.qty_remaining.onChange(field.total_quantity.value - field.qty_fulfilled.value - value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props;
	            var _props$pathState = props.pathState,
	                storeId = _props$pathState.storeId,
	                page = _props$pathState.page,
	                actions = props.actions,
	                viewMode = props.viewMode;
	            var className = props.className,
	                style = props.style;
	            var _props$fields = props.fields,
	                _props$fields$deliver = _props$fields.delivery_order,
	                number = _props$fields$deliver.number,
	                reference_number = _props$fields$deliver.reference_number,
	                expected_ship_date = _props$fields$deliver.expected_ship_date,
	                ship_date = _props$fields$deliver.ship_date,
	                _props$fields$deliver2 = _props$fields$deliver.order_ids,
	                order_ids = _props$fields$deliver2 === undefined ? [] : _props$fields$deliver2,
	                _props$fields$deliver3 = _props$fields$deliver.billing,
	                billing_customer_id = _props$fields$deliver3.customer_id,
	                billing_customer_name = _props$fields$deliver3.customer_name,
	                _props$fields$deliver4 = _props$fields$deliver.delivery_note,
	                customer_id = _props$fields$deliver4.customer_id,
	                customer_name = _props$fields$deliver4.customer_name,
	                address = _props$fields$deliver4.address,
	                phone = _props$fields$deliver4.phone,
	                tracking_number = _props$fields$deliver.tracking_number,
	                courier = _props$fields$deliver.courier,
	                state = _props$fields$deliver.state,
	                created_at = _props$fields$deliver.created_at,
	                created_by = _props$fields$deliver.created_by,
	                _props$fields$deliver5 = _props$fields.delivery_order_items,
	                delivery_order_items = _props$fields$deliver5 === undefined ? [] : _props$fields$deliver5;
	            var handleSubmit = props.handleSubmit;
	
	
	            var deliveryOrderItemsCount = 0;
	            var deliveryOrderInvoiceNumberToInvoiceId = {};
	            var deliveryOrderTable = delivery_order_items.reduce(function (map, item) {
	                if (item.invoice_number.value) {
	                    map[item.invoice_number.value] = map[item.invoice_number.value] || [];
	                    map[item.invoice_number.value].push(item);
	                    deliveryOrderItemsCount += item.quantity.value;
	                    deliveryOrderInvoiceNumberToInvoiceId[item.invoice_number.value] = item.invoice_id.value;
	                }
	                return map;
	            }, {});
	            return _react2.default.createElement(
	                'form',
	                { className: className, style: style, onSubmit: handleSubmit },
	                _react2.default.createElement(
	                    _mainContent.MainContentSection,
	                    null,
	                    _react2.default.createElement(
	                        SummaryRow,
	                        null,
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'BILL TO', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: billing_customer_name.name, value: billing_customer_name.value, readOnly: true })
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'SHIP TO', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: customer_name.name, value: customer_name.value, readOnly: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryRow,
	                        { className: 'form-inline' },
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'PHONE', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: phone.name, value: phone.value, readOnly: true })
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'D.N. NUMBER', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: number.name, value: number.value, readOnly: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryRow,
	                        { className: 'form-inline' },
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'ADDRESS', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: address.name, value: address.value, readOnly: true })
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'CREATED AT', autoHideHelpText: true },
	                            _react2.default.createElement(_dateTimeDisplay2.default, { value: created_at.value, formField: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryRow,
	                        { className: 'form-inline' },
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'STATUS', autoHideHelpText: true },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-control', readOnly: true },
	                                _react2.default.createElement(_indexStatus2.default, { data: page === 'new' ? 'new' : state.value })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'CREATED BY', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: created_by.name, value: created_by.value, readOnly: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryRow,
	                        null,
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'REFERENCE NUMBER', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: reference_number.name, value: reference_number.value, onChange: reference_number.onChange, readOnly: viewMode })
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'DELIVERY DATE', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', type: 'date', name: expected_ship_date.name,
	                                value: state.value === 'sent' ? ship_date.value : expected_ship_date.value,
	                                onChange: expected_ship_date.onChange,
	                                readOnly: viewMode })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        SummaryRow,
	                        null,
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'COURIER', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: courier.name, value: courier.value, onChange: courier.onChange, readOnly: viewMode })
	                        ),
	                        _react2.default.createElement(
	                            _formGroup2.default,
	                            { label: 'TRACKING NO.', autoHideHelpText: true },
	                            _react2.default.createElement('input', { className: 'form-control', name: tracking_number.name, value: tracking_number.value, onChange: tracking_number.onChange, readOnly: viewMode })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _mainContent.MainContentSection,
	                    null,
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        'Invoices'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        Object.keys(deliveryOrderTable).map(function (invoice_number) {
	                            return _react2.default.createElement(
	                                'span',
	                                { key: invoice_number },
	                                order_ids.length > 1 && !viewMode ? _react2.default.createElement(
	                                    _actionButton2.default,
	                                    {
	                                        type: 'delete',
	                                        defaultTextColor: true,
	                                        onClick: function onClick() {
	                                            return actions.removeInvoiceFromDeliveryOrder(deliveryOrderInvoiceNumberToInvoiceId[invoice_number]);
	                                        }
	                                    },
	                                    invoice_number
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    { style: { padding: 5, display: 'inline-block' } },
	                                    invoice_number
	                                )
	                            );
	                        })
	                    )
	                ),
	                Object.keys(deliveryOrderTable).map(function (key, keyIdx, keys) {
	                    return _react2.default.createElement(
	                        'table',
	                        { key: key, className: 'table data-table data-table--h-border data-table--primary-link' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '40%' } },
	                                    'Invoice: ',
	                                    key
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '15%' } },
	                                    'ORDERED'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '15%' } },
	                                    'DELIVER QTY'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '15%' } },
	                                    'REMAINING'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            deliveryOrderTable[key].map(function (item, i) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: item.id.value || i },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'container' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        _reactRouter.Link,
	                                                        { className: 'block-a', to: '/v2/' + storeId + '/inventory/' + item.purchasable_id.value },
	                                                        item.description.value
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-xs-6' },
	                                                    'UPC/EAN: ',
	                                                    item.upc.value || item.ean13.value
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-xs-6' },
	                                                    'PLU/SKU: ',
	                                                    item.listing_barcode.value
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-xs-12' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { style: { display: viewMode ? 'none' : 'block' } },
	                                                        item.serial_number_enabled.value ? _react2.default.createElement(_serialNumberInput2.default, {
	                                                            productName: item.description.value,
	                                                            serialNumbers: item.serial_numbers,
	                                                            max: item.total_quantity.value || -1,
	                                                            onConfirm: function onConfirm(sn) {
	                                                                return _this2.setDeliveryQuantity(item, sn.length);
	                                                            }
	                                                        }) : null
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { style: { display: viewMode ? 'block' : 'none' } },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            item.serial_number_enabled.value ? item.serial_numbers.map(function (sn, i) {
	                                                                return _react2.default.createElement(
	                                                                    'div',
	                                                                    { key: i, className: 'col-xs-6' },
	                                                                    'S/N: ',
	                                                                    sn.value
	                                                                );
	                                                            }) : null
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', {
	                                            type: 'number',
	                                            className: 'form-control',
	                                            name: item.total_quantity.name,
	                                            value: item.total_quantity.value,
	                                            readOnly: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', {
	                                            type: 'number',
	                                            className: 'form-control',
	                                            name: item.quantity_in_display_unit.name,
	                                            value: item.quantity_in_display_unit.value,
	                                            onChange: function onChange(event) {
	                                                var value = event.target.value || '0';
	                                                var qty = parseFloat(value);
	                                                _this2.setDeliveryQuantity(item, qty);
	                                            },
	                                            min: 0,
	                                            max: item.total_quantity.value - item.qty_fulfilled.value,
	                                            readOnly: viewMode || item.serial_number_enabled.value || item.expiration_date_enabled.value
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement('input', {
	                                            type: 'number',
	                                            className: 'form-control',
	                                            name: item.qty_remaining.name,
	                                            value: item.qty_remaining.value,
	                                            readOnly: true
	                                        })
	                                    )
	                                );
	                            }),
	                            keyIdx < keys.length - 1 ? null : _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    viewMode ? null : _react2.default.createElement(
	                                        _addInvoice2.default,
	                                        {
	                                            filters: {
	                                                inventory_status: ['unfulfilled', 'in_transit'],
	                                                customer_id: customer_id.value || billing_customer_id.value
	                                            },
	                                            excludeInvoices: order_ids.map(function (d) {
	                                                return d.value;
	                                            }),
	                                            onConfirm: _this2.addInvoice.bind(_this2)
	                                        },
	                                        'Add Another Invoice'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        'Total Items: '
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement('input', { className: 'form-control', type: 'number', value: deliveryOrderItemsCount, readOnly: true })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return DeliveryOverviewForm;
	}(_react.Component);
	
	DeliveryOverviewForm.propTypes = {
	    fields: _propTypes2.default.object.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    submitting: _propTypes2.default.bool.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    appState: _propTypes2.default.object.isRequired,
	    pathState: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var appState = state;
	    var loading = state.base.loading,
	        entities = state.entities,
	        pathState = state.deliveryOrder;
	
	    return { appState: appState, pathState: pathState, entities: entities, loading: loading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var constraints = {
	    'delivery_order.reference_number': {
	        format: {
	            pattern: /^[\w\d]*$/
	        }
	    }
	};
	
	var validator = function validator(values) {
	    var result = (0, _validate2.default)(values, constraints) || {};
	    var _values$delivery_orde = values.delivery_order_items,
	        delivery_order_items = _values$delivery_orde === undefined ? [] : _values$delivery_orde;
	
	    delivery_order_items.forEach(function (item, i) {
	        var error = (0, _validate2.default)(item, {
	            'quantity': {
	                presence: true,
	                numericality: {
	                    greaterThanOrEqualTo: 0
	                }
	            },
	            'qty_remaining': {
	                presence: true,
	                numericality: {
	                    greaterThanOrEqualTo: 0
	                }
	            }
	        });
	        if (error) {
	            Object.keys(error).forEach(function (key) {
	                result['delivery_order_items[' + i + '].' + key] = error[key];
	            });
	        }
	    });
	    var total_quantity = delivery_order_items.reduce(function (sum, item) {
	        return sum + item.quantity;
	    }, 0);
	    if (total_quantity <= 0) {
	        result.total_quantity = ['Total quantity cannot be zero'];
	    }
	
	    return result;
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'deliveryOverviewForm',
	    fields: fields,
	    destroyOnUnmount: false,
	    validate: validator
	}, mapStateToProps, mapDispatchToProps)(DeliveryOverviewForm);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _redux = __webpack_require__(5);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _mainContent = __webpack_require__(93);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _constant = __webpack_require__(186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['delivery_order.remarks'];
	
	var Remarks = function (_Component) {
	    _inherits(Remarks, _Component);
	
	    function Remarks() {
	        _classCallCheck(this, Remarks);
	
	        return _possibleConstructorReturn(this, (Remarks.__proto__ || Object.getPrototypeOf(Remarks)).apply(this, arguments));
	    }
	
	    _createClass(Remarks, [{
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var className = props.className,
	                style = props.style,
	                _props$pathState = props.pathState,
	                pathState = _props$pathState === undefined ? {} : _props$pathState;
	            var page = pathState.page;
	            var remarks = props.fields.delivery_order.remarks;
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, style: style },
	                _react2.default.createElement(
	                    _mainContent.MainContentSection,
	                    null,
	                    _react2.default.createElement(
	                        _formGroup2.default,
	                        { label: 'NOTE', autoHideHelpText: true },
	                        _react2.default.createElement('textarea', { className: 'form-control', value: remarks.value, readOnly: page === _constant.VIEW, onChange: remarks.onChange })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Remarks;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var appState = state;
	    var loading = state.base.loading,
	        entities = state.entities,
	        pathState = state.deliveryOrder;
	
	    return { appState: appState, pathState: pathState, entities: entities, loading: loading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	Remarks.propTypes = {
	    remarks: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'deliveryOverviewForm',
	    fields: fields,
	    destroyOnUnmount: false
	}, mapStateToProps, mapDispatchToProps)(Remarks);

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //*
	
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _constants = __webpack_require__(26);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var ivActions = _interopRequireWildcard(_inventoryVarianceActions);
	
	var _typeToPermissionHelper = __webpack_require__(318);
	
	var _typeToPermissionHelper2 = _interopRequireDefault(_typeToPermissionHelper);
	
	var _mainContent = __webpack_require__(93);
	
	var _breadcrumb = __webpack_require__(187);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _overview = __webpack_require__(830);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MODE = _constants.INVENTORY_VARIANCE.MODE,
	    TAB = _constants.INVENTORY_VARIANCE.TAB,
	    STATUS = _constants.INVENTORY_VARIANCE.STATUS;
	
	
	function mapStateToProp(state) {
	  var _state$base = state.base,
	      base = _state$base === undefined ? {} : _state$base,
	      _state$inventoryVaria = state.inventoryVariance,
	      pathState = _state$inventoryVaria === undefined ? {} : _state$inventoryVaria;
	  var loading = base.loading;
	
	  return { loading: loading, pathState: pathState };
	}
	
	function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, ivActions);
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	}
	
	var ItemTemplate = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ItemTemplate, _Component);
	
	  function ItemTemplate(props) {
	    _classCallCheck(this, ItemTemplate);
	
	    var _this = _possibleConstructorReturn(this, (ItemTemplate.__proto__ || Object.getPrototypeOf(ItemTemplate)).call(this, props));
	
	    _this.edit = function () {
	      _this.props.actions.startEdit();
	    };
	
	    _this.save = function () {
	      _this.props.actions.saveItem();
	    };
	
	    _this.cancelEdit = function () {
	      _this.props.actions.cancelEdit();
	    };
	
	    _this.changeTab = function (tab) {};
	
	    _this.void = function () {
	      _this.props.actions.changeItemStatus('void');
	    };
	
	    _this.submit = function () {
	      _this.props.actions.changeItemStatus('submit');
	    };
	
	    _this.cancel = function () {
	      _this.props.actions.changeItemStatus('cancel');
	    };
	
	    _this.reject = function () {
	      _this.props.actions.changeItemStatus('reject');
	    };
	
	    _this.approve = function () {
	      _this.props.actions.changeItemStatus('approve');
	    };
	
	    _this.print = _this.print.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemTemplate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          mode = _props.mode,
	          tab = _props.tab,
	          type = _props.type,
	          id = _props.id,
	          actions = _props.actions,
	          _props$pathState = _props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState;
	
	      if (mode !== MODE.NEW || !(0, _lodash.get)(pathState, 'currentStore.id')) {
	        actions.initInventoryVariance(this.context.currentStore, id, mode, tab, type);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return true;
	    }
	  }, {
	    key: 'print',
	    value: function print() {
	      var _props$pathState2 = this.props.pathState,
	          currentStore = _props$pathState2.currentStore,
	          iv = _props$pathState2.iv,
	          activeItems = _props$pathState2.activeItems,
	          varianceCostTotal = _props$pathState2.varianceCostTotal;
	
	      var storeInfo = ['logo_url', 'title', 'address1', 'address2', 'city'];
	      var ivInfo = ['number', 'name', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'humanizedType', 'status', 'canceledBy', 'approvedBy', 'rejectedBy', 'voidedBy', 'effectiveDate'];
	      var itemInfo = ['listingBarcode', 'ean13', 'blid', 'bpid', 'productName', 'costBefore', 'cost', 'varianceCost', 'actualQty', 'totalCost', 'varianceQty', 'serialNumbers', 'qtyBefore'];
	      var payload = {
	        store: (0, _lodash.pick)(currentStore, storeInfo),
	        iv: (0, _lodash.pick)(iv, ivInfo),
	        items: activeItems.map(function (item) {
	          return (0, _lodash.pick)(item, itemInfo);
	        }),
	        varianceCostTotal: varianceCostTotal
	      };
	
	      var fetchUrl = void 0;
	      var pdfName = void 0;
	      var domain = 'https://ssr.stg.bindolabs.com/pdf/';
	      switch (payload.iv.humanizedType) {
	        case "Opening":
	          fetchUrl = domain + '2';
	          pdfName = "Inventory_opening.pdf";
	          break;
	        case "Adjustment by actual quantity":
	          fetchUrl = domain + '3';
	          pdfName = "Inventory_qty_adjustment.pdf";
	          break;
	        case "Adjustment by variance quantity":
	          fetchUrl = domain + '4';
	          pdfName = "Inventory_Variance_qty_adjustment.pdf";
	          break;
	        case "Cost adjustment":
	          fetchUrl = domain + '5';
	          pdfName = "Inventory_cost_adjustment.pdf";
	          break;
	      }
	
	      function downloadFile(fileName, content) {
	        var aLink = document.createElement('a');
	        aLink.download = fileName;
	        aLink.href = URL.createObjectURL(content);
	        aLink.click();
	      }
	
	      fetch(fetchUrl, {
	        method: 'post',
	        body: JSON.stringify(payload)
	      }).then(function (r) {
	        return r.blob();
	      }).then(function (content) {
	        downloadFile(pdfName, content);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          loading = _props2.loading,
	          _props2$pathState = _props2.pathState,
	          pathState = _props2$pathState === undefined ? {} : _props2$pathState;
	      var mode = pathState.mode,
	          tab = pathState.tab,
	          _pathState$iv = pathState.iv,
	          iv = _pathState$iv === undefined ? {} : _pathState$iv,
	          type = pathState.type;
	      var _pathState$currentSto = pathState.currentStore,
	          currentStore = _pathState$currentSto === undefined ? {} : _pathState$currentSto;
	      var status = iv.status,
	          itemId = iv.id;
	
	      var isView = mode === MODE.VIEW;
	      var isEdit = mode === MODE.EDIT;
	      var isNew = mode === MODE.NEW;
	      var storeId = (0, _lodash.get)(pathState, 'currentStore.id');
	      var title = isNew ? 'New Inventory Variance' : 'Inventory Variance #' + (iv.number || '');
	
	      var tabsConfig = [{ label: 'Overview', value: TAB.OVERVIEW }];
	
	      var mainContent = null;
	      if (tab === TAB.OVERVIEW) {
	        mainContent = _react2.default.createElement(_overview2.default, null);
	      }
	
	      var btnConfig = [{
	        content: 'Export PDF',
	        permission: '',
	        show: isView,
	        btnType: 'secondary',
	        onClick: this.print
	      }, {
	        content: 'Void',
	        permission: '',
	        show: isView && (status === STATUS.OPENED || status === STATUS.PENDING_FOR_APPROVAL) && (0, _typeToPermissionHelper2.default)(type, "void", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.void
	      }, {
	        content: 'Submit for Approval',
	        permission: '',
	        show: isView && status === STATUS.OPENED && (0, _typeToPermissionHelper2.default)(type, "submit", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.submit
	      }, {
	        content: 'Cancel Submission',
	        permission: '',
	        show: isView && status === STATUS.PENDING_FOR_APPROVAL && (0, _typeToPermissionHelper2.default)(type, "cancel_submission", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.cancel
	      }, {
	        content: 'Reject',
	        permission: '',
	        show: isView && status === STATUS.PENDING_FOR_APPROVAL && (0, _typeToPermissionHelper2.default)(type, "approval", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.reject
	      }, {
	        content: 'Approve',
	        permission: '',
	        show: isView && status === STATUS.PENDING_FOR_APPROVAL && (0, _typeToPermissionHelper2.default)(type, "approval", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.approve
	      }, {
	        content: 'Edit',
	        permission: '',
	        show: isView && status === STATUS.OPENED && (0, _typeToPermissionHelper2.default)(type, "edit", currentStore),
	        disabled: !itemId,
	        btnType: 'primary',
	        onClick: this.edit
	      }, {
	        content: 'Cancel',
	        permission: '',
	        show: isEdit || isNew,
	        disabled: loading,
	        btnType: '',
	        onClick: this.cancelEdit
	      }, {
	        content: 'Save',
	        permission: '',
	        show: isEdit || isNew && (0, _typeToPermissionHelper2.default)(type, "add", currentStore),
	        disabled: loading,
	        btnType: 'primary',
	        onClick: this.save
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          _mainContent.MainContent,
	          null,
	          _react2.default.createElement(
	            _mainContent.MainContentHeader,
	            { title: title },
	            _react2.default.createElement(_mainContent.MainContentHeaderButtons, { config: btnConfig })
	          ),
	          _react2.default.createElement(_breadcrumb2.default, { links: [{ label: 'Stock Take Management' }, { label: 'Inventory Variance', link: '/v2/' + storeId + '/' + _constants.ROUTE.INVENTORY_VARIANCE }, { label: mode === MODE.NEW ? 'New Inventory Variance' : iv.name || '#' + (iv.number || ''), active: true }] }),
	          _react2.default.createElement(_mainContent.MainContentTabs, { tabs: tabsConfig, currentTab: tab, onChange: this.changeTab }),
	          mainContent
	        )
	      );
	    }
	  }]);
	
	  return ItemTemplate;
	}(_react.Component), _class2.contextTypes = {
	  currentStore: _propTypes2.default.object
	}, _class2.propTypes = {
	  actions: _propTypes2.default.object.isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  pathState: _propTypes2.default.object
	}, _temp)) || _class);
	exports.default = ItemTemplate;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListingOverviewFormComponent = (_temp2 = _class = function (_Component) {
	  _inherits(ListingOverviewFormComponent, _Component);
	
	  function ListingOverviewFormComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListingOverviewFormComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListingOverviewFormComponent.__proto__ || Object.getPrototypeOf(ListingOverviewFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      uploadImages: []
	    }, _this.previewFiles = function (event) {
	      (0, _forEach2.default)(event.target.files, function (file) {
	        // event.target.files is not a array
	        var reader = new FileReader();
	        reader.readAsDataURL(file);
	        reader.onloadend = function () {
	          _this.state.uploadImages.push({
	            id: (0, _uniqueId2.default)(),
	            src: reader.result,
	            file: file
	          });
	          _this.setState({ uploadImages: _this.state.uploadImages });
	
	          _this.props.fields.upload_images.onChange(_this.state.uploadImages);
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListingOverviewFormComponent, [{
	    key: 'cancelUpload',
	    value: function cancelUpload(index) {
	      this.state.uploadImages.splice(index, 1);
	      this.setState({ uploadImages: this.state.uploadImages });
	      this.props.fields.upload_images.onChange(this.state.uploadImages);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          fields = _props.fields,
	          handleSubmit = _props.handleSubmit,
	          departments = _props.departments,
	          isCustomMode = _props.isCustomMode,
	          isInventoryManager = _props.isInventoryManager;
	
	      var enabledEdit = true;
	      if (!isCustomMode) {
	        var isManager = isInventoryManager === "NO" ? true : false;
	        var isGtid = fields.gtid.defaultValue === null ? true : false;
	        enabledEdit = isManager && isGtid;
	      }
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'row', id: 'listing-form', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Title', state: fields.name },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.name, { disabled: !enabledEdit }))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Description', state: fields.name },
	            _react2.default.createElement('textarea', _extends({ className: 'form-control', rows: 4 }, fields.description, { disabled: !isCustomMode && !enabledEdit }))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'UPC/EAN', state: fields.gtid },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.gtid, { disabled: true }))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'QTY on shelf', state: fields.quantity },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.quantity))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'QTY stockroom', state: fields.qty_stockroom },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.qty_stockroom))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'PLU/SKU', state: fields.listing_barcode },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.listing_barcode))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Price', state: fields.price },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.price))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Brand', state: fields.brand_name },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text' }, fields.brand_name, { disabled: !isCustomMode && !enabledEdit }))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Department', state: fields.department_id },
	            _react2.default.createElement(
	              'select',
	              fields.department_id,
	              _react2.default.createElement(
	                'option',
	                { key: '0', value: '' },
	                '(no department)'
	              ),
	              departments.map(function (d) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: d.id, value: d.id },
	                  d.stackdisplay
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: fields.in_store_only.onChange, checked: fields.in_store_only.checked }),
	            ' In Store Only'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: fields.discontinued.onChange, checked: fields.discontinued.checked }),
	            ' Discontinued'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: fields.exempt_loyalty.onChange, checked: fields.exempt_loyalty.checked }),
	            ' Exempt item from loyalty program'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: fields.exempt_discount.onChange, checked: fields.exempt_discount.checked }),
	            ' Exclude from all discount'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: fields.storefront_allow_negative_quantity.onChange, checked: fields.storefront_allow_negative_quantity.checked }),
	            ' Store front allow negative quantity'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement('br', null)
	        ),
	        fields.product_graphics.map(function (graphic) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-2', key: graphic.value.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'small text-danger' },
	              _react2.default.createElement(
	                'label',
	                null,
	                _react2.default.createElement('input', { type: 'checkbox', onChange: graphic.delete.onChange }),
	                ' Remove image'
	              )
	            ),
	            _react2.default.createElement('img', { src: graphic.value.small_image_url })
	          );
	        }),
	        this.state.uploadImages.map(function (image, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'col-sm-2', key: image.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'small text-danger' },
	              _react2.default.createElement(
	                'span',
	                { className: 'a', onClick: _this2.cancelUpload.bind(_this2, index) },
	                '\xD7 cancel'
	              )
	            ),
	            _react2.default.createElement('img', { className: 'upload-preview', src: image.src })
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('hr', { className: 'clear' }),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Upload new product image'
	          ),
	          _react2.default.createElement('input', { type: 'file', multiple: true, onChange: this.previewFiles, disabled: !isCustomMode && !enabledEdit })
	        )
	      );
	    }
	  }]);
	
	  return ListingOverviewFormComponent;
	}(_react.Component), _class.defaultProps = {
	  isCustomMode: false,
	  isInventoryManager: "YES"
	}, _class.propTypes = {
	  fields: _propTypes2.default.object.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired,
	  departments: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  isCustomMode: _propTypes2.default.bool.isRequired,
	  isInventoryManager: _propTypes2.default.string.isRequired
	}, _temp2);
	exports.default = ListingOverviewFormComponent;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Slip(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        style = props.style,
	        _props$details = props.details,
	        details = _props$details === undefined ? [] : _props$details,
	        _props$totals = props.totals,
	        totals = _props$totals === undefined ? [] : _props$totals;
	
	    return _react2.default.createElement(
	        'table',
	        { className: 'slip ' + className, style: style },
	        _react2.default.createElement(
	            'tbody',
	            null,
	            details.filter(function (item) {
	                return typeof item.hide === 'function' ? !item.hide(item) : !item.hide;
	            }).map(function (item, i, filteredDetails) {
	                var isLastRow = i === filteredDetails.length - 1;
	                var className = 'slip__detail ' + (isLastRow ? 'slip__detail--last-row' : '') + ' ' + (item.className || '');
	                return item.title ? _react2.default.createElement(
	                    'tr',
	                    { key: 'detail-' + i, className: className, style: item.style },
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__title', colSpan: '3' },
	                        item.title
	                    )
	                ) : _react2.default.createElement(
	                    'tr',
	                    { key: 'detail-' + i, className: className, style: item.style },
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__field' },
	                        item.field
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__value' },
	                        item.value
	                    ),
	                    _react2.default.createElement('td', null)
	                );
	            }),
	            totals.filter(function (item) {
	                return typeof item.hide === 'function' ? !item.hide(item) : !item.hide;
	            }).map(function (item, i) {
	                return item.title ? _react2.default.createElement(
	                    'tr',
	                    { key: 'total-' + i, className: 'slip__total', style: item.style },
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__title', colSpan: '3' },
	                        item.title
	                    )
	                ) : _react2.default.createElement(
	                    'tr',
	                    { key: 'total-' + i, className: 'slip__total', style: item.style },
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__field' },
	                        item.field
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'slip__value' },
	                        item.value
	                    ),
	                    _react2.default.createElement('td', null)
	                );
	            })
	        )
	    );
	}
	
	Slip.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    details: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        field: _propTypes2.default.string,
	        value: _propTypes2.default.node,
	        style: _propTypes2.default.object,
	        hide: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
	    })),
	    totals: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        field: _propTypes2.default.string,
	        value: _propTypes2.default.node,
	        style: _propTypes2.default.object,
	        hide: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
	    }))
	};
	
	exports.default = Slip;

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EDIT_MODE = exports.EDIT_MODE = {
	  ADD: 'ADD',
	  EDIT: 'EDIT',
	  ASSIGN_PRINTER: 'ASSIGN_PRINTER',
	  SET_WORKFLOW: 'SET_WORKFLOW',
	  REMOVE: 'REMOVE'
	};

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1267);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function MainContentHeaderButtons(props) {
	  var _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className,
	      _props$config = props.config,
	      config = _props$config === undefined ? [] : _props$config;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    config.filter(function (cfg) {
	      return cfg.show !== false;
	    }).map(function (cfg, i) {
	      var content = cfg.content,
	          className = cfg.className,
	          btnType = cfg.btnType,
	          permission = cfg.permission,
	          link = cfg.link,
	          otherCfg = _objectWithoutProperties(cfg, ['content', 'className', 'btnType', 'permission', 'link']);
	
	      var cl = className ? className : 'btn btn-sm btn-' + (btnType || 'secondary');
	      var btn = link ? _react2.default.createElement(
	        _reactRouter.Link,
	        _extends({ key: i, className: cl, to: link }, otherCfg),
	        content
	      ) : _react2.default.createElement(
	        'button',
	        _extends({ key: i, className: cl }, otherCfg),
	        content
	      );
	      var ret = btn;
	      if (permission) {
	        ret = _react2.default.createElement(
	          _can2.default,
	          { key: i, action: permission },
	          btn
	        );
	      }
	      return ret;
	    })
	  );
	}
	
	MainContentHeaderButtons.propTypes = {
	  className: _propTypes2.default.string,
	  config: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    content: _propTypes2.default.node.isRequired,
	    link: _propTypes2.default.string,
	    permission: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),
	    show: _propTypes2.default.bool,
	    btnType: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    onClick: _propTypes2.default.func
	  })).isRequired
	};
	
	exports.default = MainContentHeaderButtons;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = exports.fields = ['title', 'note'];
	
	var MembershipForm = (_temp = _class = function (_Component) {
	  _inherits(MembershipForm, _Component);
	
	  function MembershipForm() {
	    _classCallCheck(this, MembershipForm);
	
	    return _possibleConstructorReturn(this, (MembershipForm.__proto__ || Object.getPrototypeOf(MembershipForm)).apply(this, arguments));
	  }
	
	  _createClass(MembershipForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$fields = _props.fields,
	          title = _props$fields.title,
	          note = _props$fields.note,
	          handleSubmit = _props.handleSubmit;
	
	
	      return _react2.default.createElement(
	        'form',
	        { id: 'MembershipForm', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          _formGroup2.default,
	          { state: title },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Title'
	          ),
	          _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: title.onChange, value: title.value })
	        ),
	        _react2.default.createElement(
	          _formGroup2.default,
	          { state: note },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Note'
	          ),
	          _react2.default.createElement('textarea', { type: 'text', className: 'form-control', onChange: note.onChange, value: note.value })
	        )
	      );
	    }
	  }]);
	
	  return MembershipForm;
	}(_react.Component), _class.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  fields: _propTypes2.default.object.isRequired,
	  voucher: _propTypes2.default.object
	}, _temp);
	
	
	var formOptions = {
	  form: 'membership',
	  fields: fields
	  // validate
	};
	
	exports.default = (0, _reduxForm.reduxForm)(formOptions)(MembershipForm);

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import AddListingByBarcode from '~/components/add-listing-by-barcode';
	
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _inputSelectBox = __webpack_require__(232);
	
	var _inputSelectBox2 = _interopRequireDefault(_inputSelectBox);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _productionOrderItem = __webpack_require__(224);
	
	var actions = _interopRequireWildcard(_productionOrderItem);
	
	var _formatHelper = __webpack_require__(35);
	
	var _reactSelect = __webpack_require__(422);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _listingName = __webpack_require__(792);
	
	var _listingName2 = _interopRequireDefault(_listingName);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _permissionHelper = __webpack_require__(92);
	
	var _addListing = __webpack_require__(229);
	
	var _addListing2 = _interopRequireDefault(_addListing);
	
	var _humps = __webpack_require__(44);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var options = [{ value: 1, label: 'Assembly' }, { value: 2, label: 'Disassembly' }];
	
	var labelMap = {
	  'created': 'Created',
	  'approved': 'Approved',
	  'fulfilled': 'Finished',
	  'canceled': 'Cancalled',
	  'fulfilling': 'Processing'
	};
	
	function mapStateToProp(state) {
	  var formState = state.forms.productionOrderItem;
	  return _extends({}, formState);
	}
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var ProductionOrderItemOverview = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (0, _formatHelper.dateTimeFormatter)(_class = (0, _griddleComponents.capitalizeFirstLetterComponent)(_class = (0, _permissionHelper.getCurrentPermission)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ProductionOrderItemOverview, _Component);
	
	  function ProductionOrderItemOverview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProductionOrderItemOverview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductionOrderItemOverview.__proto__ || Object.getPrototypeOf(ProductionOrderItemOverview)).call.apply(_ref, [this].concat(args))), _this), _this.handleAdd = function (d) {
	      if (d.length) {
	        _this.props.actions.addListingItem((0, _humps.camelizeKeys)(d));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProductionOrderItemOverview, [{
	    key: 'renderRows',
	    value: function renderRows() {
	      var _props = this.props,
	          editMode = _props.editMode,
	          productionOrderItems = _props.productionOrderItems,
	          actions = _props.actions,
	          initialValues = _props.initialValues,
	          isCreating = _props.isCreating;
	
	
	      if (!productionOrderItems.length) return null;
	      var plannedEditable = editMode && (isCreating || initialValues.state === 'created');
	      var processedEditable = editMode && ['approved', 'fulfilling'].indexOf(initialValues.state) > -1;
	      var removeable = editMode && (isCreating || initialValues.state === 'created');
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        productionOrderItems.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(_listingName2.default, item)
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              plannedEditable ? _react2.default.createElement('input', { disabled: !editMode,
	                value: item.quantityInDisplayUnit,
	                type: 'number',
	                onChange: function onChange(e) {
	                  return actions.changePlannedQuantity(e.target.value, index);
	                } }) : _react2.default.createElement(
	                'span',
	                null,
	                item.quantityInDisplayUnit
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              processedEditable ? _react2.default.createElement('input', { disabled: !editMode,
	                value: item.qtyFulfilledInDisplayUnit,
	                type: 'number',
	                onChange: function onChange(e) {
	                  return actions.changeProcessedQuantity(e.target.value, index);
	                } }) : _react2.default.createElement(
	                'span',
	                null,
	                item.qtyFulfilledInDisplayUnit
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              plannedEditable && item.hasUnitGroup ? _react2.default.createElement(_reactSelect2.default, { value: item.displayUnitId,
	                options: item.units,
	                disabled: !editMode,
	                clearable: false,
	                labelKey: 'name',
	                valueKey: 'id',
	                onChange: function onChange(opt) {
	                  return actions.changeUom(opt, index);
	                } }) : _react2.default.createElement(
	                'span',
	                null,
	                item.displayUnit
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.listingQuantity / (item.ratio || 1)
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              item.quantityInDisplayUnit - item.qtyFulfilledInDisplayUnit
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              editMode ? _react2.default.createElement(
	                'button',
	                { type: 'button',
	                  className: 'btn btn-primary btn-sm',
	                  disabled: !removeable,
	                  onClick: function onClick() {
	                    return actions.removeListingItem(index);
	                  } },
	                'Remove'
	              ) : null
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props2 = this.props,
	          isSubmitting = _props2.isSubmitting,
	          isCreating = _props2.isCreating,
	          editMode = _props2.editMode,
	          initialValues = _props2.initialValues,
	          typeId = _props2.typeId,
	          actions = _props2.actions;
	      var currentStore = this.context.currentStore;
	
	
	      var cancalPermission = this.getCurrentPermission('production_order:cancel');
	      var approvePermission = this.getCurrentPermission('production_order:approval');
	
	      var approveable = approvePermission && initialValues.state === 'created';
	      var processable = approvePermission && initialValues.state === 'approved';
	      var processing = approvePermission && initialValues.state === 'fulfilling';
	      var cancelable = cancalPermission && ['canceled', 'fulfilled'].indexOf(initialValues.state) === -1;
	      var addable = editMode && (isCreating || initialValues.state === 'created');
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            !editMode && cancelable && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', disabled: isSubmitting, onClick: actions.cancel },
	              'Cancel Order'
	            ),
	            !editMode && approveable && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', disabled: isSubmitting, onClick: actions.approve },
	              'Approve Order'
	            ),
	            editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm', disabled: isSubmitting, onClick: actions.discard },
	              'Cancel'
	            ),
	            editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', disabled: isSubmitting, onClick: actions.submit },
	              'Save'
	            ),
	            !editMode && approveable ? _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm', onClick: actions.enableEditMode },
	              'Edit'
	            ) : null,
	            !editMode && (processable || processing) ? _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm', onClick: actions.enableEditMode },
	              'Process'
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                currentStore.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'w-50' },
	                _react2.default.createElement(_inputSelectBox2.default, { title: 'PRODUCTION ORDER TYPE',
	                  value: typeId,
	                  disabled: !editMode,
	                  resetValue: undefined,
	                  clearable: false,
	                  onChange: function onChange(e) {
	                    return actions.changeOrderType(e.value);
	                  },
	                  options: options })
	              )
	            ),
	            !isCreating && _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'ORDER NUMBER:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      initialValues.number
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'CREATED AT:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      this.dateTime(initialValues.createdAt)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'CREATED BY:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      initialValues.userFullName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'STATUS:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      this.capitalizeFirstLetterComponent({ data: labelMap[initialValues.state] || initialValues.state })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'ITEMS'
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'table data-table data-table--no-border data-table--primary-link' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'PLANNED QTY'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'PROCESSED QTY'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'UOM'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'LATEST QTY ON SHELF'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  typeId === 1 ? 'LATEST QTY PENDING TO ASSEMBLE' : 'LATEST QTY PENDING TO DISASSEMBLE'
	                ),
	                _react2.default.createElement('th', null)
	              )
	            ),
	            this.renderRows()
	          ),
	          addable && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _addListing2.default,
	              {
	                withBarcode: true,
	                onSave: this.handleAdd
	              },
	              'Add New Items'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLoading',
	    value: function renderLoading() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading ...'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isLoading = this.props.isLoading;
	
	      return isLoading ? this.renderLoading() : this.renderContent();
	    }
	  }]);
	
	  return ProductionOrderItemOverview;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  editMode: _propTypes2.default.bool.isRequired,
	  isSubmitting: _propTypes2.default.bool.isRequired,
	  initialValues: _propTypes2.default.object.isRequired,
	  productionOrderItems: _propTypes2.default.array.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  isCreating: _propTypes2.default.bool.isRequired,
	  typeId: _propTypes2.default.string.isRequired
	}, _temp2)) || _class) || _class) || _class) || _class);
	exports.default = ProductionOrderItemOverview;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constants = __webpack_require__(26);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _baseSelectors = __webpack_require__(240);
	
	var baseSelectors = _interopRequireWildcard(_baseSelectors);
	
	var _promoCodeSelectors = __webpack_require__(322);
	
	var promoCodeSelectors = _interopRequireWildcard(_promoCodeSelectors);
	
	var _promoCodeActions = __webpack_require__(152);
	
	var promoCodeActions = _interopRequireWildcard(_promoCodeActions);
	
	var _mainContent = __webpack_require__(93);
	
	var _breadcrumb = __webpack_require__(187);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _overview = __webpack_require__(889);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  return {
	    loading: baseSelectors.getLoading(state),
	    pageTitle: promoCodeSelectors.getPageTitle(state),
	    breadcrumbTitle: promoCodeSelectors.getBreadcrumbTitle(state),
	    pathInfo: promoCodeSelectors.getPathInfo(state),
	    btnShowConfig: promoCodeSelectors.getButtonShowConfig(state),
	    data: promoCodeSelectors.getItem(state),
	    errMsg: promoCodeSelectors.getErrMsg(state),
	    storeId: props.storeId
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, promoCodeActions);
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	};
	
	var PromoCodeLayout = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PromoCodeLayout, _Component);
	
	  function PromoCodeLayout() {
	    _classCallCheck(this, PromoCodeLayout);
	
	    return _possibleConstructorReturn(this, (PromoCodeLayout.__proto__ || Object.getPrototypeOf(PromoCodeLayout)).apply(this, arguments));
	  }
	
	  _createClass(PromoCodeLayout, [{
	    key: 'render',
	
	
	    // componentDidMount(){
	    //   const props = this.props || {};
	    //   const { mode, storeId, promoCodeId } = props;
	    //   props.initPromoCode(mode, storeId, promoCodeId);
	    // }
	
	    value: function render() {
	      var props = this.props;
	      var loading = props.loading,
	          pageTitle = props.pageTitle,
	          breadcrumbTitle = props.breadcrumbTitle,
	          storeId = props.storeId,
	          _props$pathInfo = props.pathInfo,
	          pathInfo = _props$pathInfo === undefined ? {} : _props$pathInfo,
	          _props$btnShowConfig = props.btnShowConfig,
	          btnShowConfig = _props$btnShowConfig === undefined ? {} : _props$btnShowConfig,
	          _props$data = props.data,
	          data = _props$data === undefined ? {} : _props$data;
	      var mode = pathInfo.mode,
	          promoCodeId = pathInfo.promoCodeId,
	          tab = pathInfo.tab;
	
	      var btnConfig = [{
	        content: 'Cancel',
	        disabled: loading,
	        show: btnShowConfig.cancelEdit,
	        onClick: function onClick() {
	          return props.cancelEditPromoCode(mode, storeId, promoCodeId);
	        }
	      }, {
	        content: 'Save',
	        disabled: loading,
	        show: btnShowConfig.saveEdit,
	        btnType: 'primary',
	        onClick: function onClick() {
	          return props.savePromoCode(storeId, data);
	        }
	      }];
	      var mainContent = null;
	      if (tab === _constants.PROMO_CODE.TAB.OVERVIEW) {
	        mainContent = _react2.default.createElement(_overview2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          _mainContent.MainContent,
	          null,
	          _react2.default.createElement(
	            _mainContent.MainContentHeader,
	            { title: pageTitle },
	            _react2.default.createElement(_mainContent.MainContentHeaderButtons, { config: btnConfig })
	          ),
	          _react2.default.createElement(_breadcrumb2.default, { links: [{ label: 'Promotion' }, { label: 'Promotion Codes', link: _routeHelper2.default.promoCodes(storeId) }, { label: breadcrumbTitle }] }),
	          _react2.default.createElement(_mainContent.MainContentTabs, {
	            tabs: [{ label: 'Overview', value: _constants.PROMO_CODE.TAB.OVERVIEW }],
	            currentTab: tab
	          }),
	          mainContent
	        )
	      );
	    }
	  }]);
	
	  return PromoCodeLayout;
	}(_react.Component), _class2.propTypes = {}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = PromoCodeLayout;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLoading = exports.getIsOpen = exports.getComponentState = exports.getSelectedDiscount = exports.getSelected = exports.getFilteredDiscountOptions = undefined;
	
	var _reselect = __webpack_require__(301);
	
	var _lodash = __webpack_require__(14);
	
	var getDiscountOptions = function getDiscountOptions(state) {
	  return state.components.selectDiscount.discounts;
	};
	
	var getFilterValue = function getFilterValue(state) {
	  return state.components.selectDiscount.filter;
	};
	
	var getFilteredDiscountOptions = exports.getFilteredDiscountOptions = (0, _reselect.createSelector)([getDiscountOptions, getFilterValue], function (options, filter) {
	  return options.filter(function (opt) {
	    return opt.name.indexOf(filter) > -1;
	  });
	});
	
	var getSelected = exports.getSelected = function getSelected(state) {
	  return state.components.selectDiscount.selected;
	};
	
	var getSelectedDiscount = exports.getSelectedDiscount = (0, _reselect.createSelector)([getDiscountOptions, getSelected], function (options, selectedId) {
	  return options.find(function (discount) {
	    return discount.id === selectedId;
	  });
	});
	
	var getComponentState = exports.getComponentState = function getComponentState(state) {
	  return (0, _lodash.get)(state, 'components.selectDiscount', {});
	};
	
	var getIsOpen = exports.getIsOpen = (0, _reselect.createSelector)([function (state, props) {
	  return (0, _lodash.get)(props, 'name', 'discount');
	}, getComponentState], function (componentName, state) {
	  return componentName === state.name && state.isOpen;
	});
	
	var getLoading = exports.getLoading = (0, _reselect.createSelector)([getIsOpen, getComponentState], function (isOpen, state) {
	  return isOpen && state.loading;
	});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomerService = function (_BindoService) {
	  _inherits(CustomerService, _BindoService);
	
	  function CustomerService() {
	    _classCallCheck(this, CustomerService);
	
	    return _possibleConstructorReturn(this, (CustomerService.__proto__ || Object.getPrototypeOf(CustomerService)).apply(this, arguments));
	  }
	
	  _createClass(CustomerService, [{
	    key: 'search',
	    value: function search(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/customers';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: 'name',
	        filters: filtersQueryList
	      };
	
	      return _get(CustomerService.prototype.__proto__ || Object.getPrototypeOf(CustomerService.prototype), 'get', this).call(this, path, query).then(function (res) {
	        res.data = res.data.map(function (d) {
	          return d.customer;
	        });
	        return res;
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(storeId, id) {
	      var path = 'v2/stores/' + storeId + '/customers/' + id;
	      return _get(CustomerService.prototype.__proto__ || Object.getPrototypeOf(CustomerService.prototype), 'get', this).call(this, path).then(function (res) {
	        var customer = res.customer;
	
	        return customer;
	      });
	    }
	  }]);
	
	  return CustomerService;
	}(_bindoService2.default);
	
	exports.default = new CustomerService();

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _lodash = __webpack_require__(14);
	
	var _normalizr = __webpack_require__(64);
	
	var _schema = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryOrderService = function (_BindoService) {
	    _inherits(DeliveryOrderService, _BindoService);
	
	    function DeliveryOrderService() {
	        _classCallCheck(this, DeliveryOrderService);
	
	        return _possibleConstructorReturn(this, (DeliveryOrderService.__proto__ || Object.getPrototypeOf(DeliveryOrderService)).apply(this, arguments));
	    }
	
	    _createClass(DeliveryOrderService, [{
	        key: 'getList',
	        value: function getList(storeId) {
	            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	            var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	            var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'created_at';
	            var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	            var path = 'v2/stores/' + storeId + '/delivery_orders';
	
	            var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	            var query = {
	                page: page,
	                per_page: perPage,
	                order_by: orderBy,
	                filters: filtersQueryList
	            };
	
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'get', this).call(this, path, query, _config2.default.gateway).then(function (res) {
	                // res.delivery_orders for mock server
	                var deliveryOrders = res.delivery_orders || res.data.delivery_orders;
	
	                var deliveryMeta = (0, _lodash.omit)(res, 'data');
	
	                //normalize
	                var normalized = (0, _normalizr.normalize)(deliveryOrders, (0, _normalizr.arrayOf)(_schema.DeliveryOrderSchema));
	
	                normalized.meta = deliveryMeta;
	                return normalized;
	            });
	        }
	    }, {
	        key: 'getItem',
	        value: function getItem(storeId, deliveryId) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders/' + deliveryId;
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'get', this).call(this, path, null, _config2.default.gateway).then(function (res) {
	                return (0, _normalizr.normalize)(res.delivery_order, _schema.DeliveryOrderSchema);
	            });
	        }
	    }, {
	        key: 'getItems',
	        value: function getItems(storeId) {
	            var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	            var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
	            var orderBy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'created_at';
	
	            var path = 'v2/stores/' + storeId + '/delivery_orders';
	            var params = _extends({}, filters, {
	                per_page: perPage,
	                page: page,
	                order_by: orderBy
	            });
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'get', this).call(this, path, params, _config2.default.gateway);
	        }
	    }, {
	        key: 'createItem',
	        value: function createItem(storeId, data) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders';
	            data.delivery_order.unit_enable = true;
	            data.delivery_order_items = data.delivery_order_items.map(function (d) {
	                return Object.assign({}, d, { quantity_in_display_unit: d.quantity });
	            });
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'post', this).call(this, path, data, _config2.default.gateway).then(function (res) {
	                var deliveryOrder = res.delivery_order;
	
	                //normalize
	                return (0, _normalizr.normalize)(deliveryOrder, _schema.DeliveryOrderSchema);
	            });
	        }
	    }, {
	        key: 'updateItem',
	        value: function updateItem(storeId, orderId, data) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders/' + orderId;
	            var delivery_order = data.delivery_order,
	                delivery_order_items = data.delivery_order_items;
	            var _delivery_order = delivery_order,
	                _delivery_order$order = _delivery_order.order_ids,
	                order_ids = _delivery_order$order === undefined ? [] : _delivery_order$order,
	                _delivery_order$stock = _delivery_order.stock_transfer_ids,
	                stock_transfer_ids = _delivery_order$stock === undefined ? [] : _delivery_order$stock;
	
	            delivery_order.unit_enable = true;
	            delivery_order_items = delivery_order_items.map(function (d) {
	                return Object.assign({}, d, { quantity_in_display_unit: d.quantity });
	            });
	            if (order_ids.length === 0) {
	                delivery_order = Object.assign({}, delivery_order);
	                delete delivery_order.order_ids;
	            }
	            if (stock_transfer_ids.length === 0) {
	                delivery_order = Object.assign({}, delivery_order);
	                delete delivery_order.stock_transfer_ids;
	            }
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'put', this).call(this, path, { delivery_order: delivery_order, delivery_order_items: delivery_order_items }, _config2.default.gateway).then(function (res) {
	                var deliveryOrder = res.delivery_order;
	                //normalize
	                return (0, _normalizr.normalize)(deliveryOrder, _schema.DeliveryOrderSchema);
	            });
	        }
	    }, {
	        key: 'cancelItem',
	        value: function cancelItem(storeId, orderId) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders/' + orderId + '/cancel';
	
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'put', this).call(this, path, undefined, _config2.default.gateway).then(function (res) {
	                var deliveryOrder = res.delivery_order;
	
	                //normalize
	                return (0, _normalizr.normalize)(deliveryOrder, _schema.DeliveryOrderSchema);
	            });
	        }
	    }, {
	        key: 'fulfillItem',
	        value: function fulfillItem(storeId, orderId, data) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders/' + orderId + '/receive';
	
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'put', this).call(this, path, data, _config2.default.gateway).then(function (res) {
	                var deliveryOrder = res.delivery_order;
	
	                //normalize
	                return (0, _normalizr.normalize)(deliveryOrder, _schema.DeliveryOrderSchema);
	            });
	        }
	    }, {
	        key: 'getItemLogs',
	        value: function getItemLogs(storeId, orderId) {
	            var path = 'v2/stores/' + storeId + '/delivery_orders/' + orderId + '/histories';
	
	            return _get(DeliveryOrderService.prototype.__proto__ || Object.getPrototypeOf(DeliveryOrderService.prototype), 'get', this).call(this, path, null, _config2.default.gateway).then(function (res) {
	                var histories = res.histories,
	                    meta = _objectWithoutProperties(res, ['histories']);
	
	                var normalized = (0, _normalizr.normalize)(histories, (0, _normalizr.arrayOf)(_schema.DeliveryOrderLogsSchema));
	                normalized.meta = meta;
	                return normalized;
	            });
	        }
	    }]);
	
	    return DeliveryOrderService;
	}(_bindoService2.default);
	
	exports.default = new DeliveryOrderService();

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE = {
	    EMAIL_RECEIPT: 'email_receipt',
	    WELCOME: 'welcome',
	    PASSWORD_RESET_INSTRUCTION: 'password_reset_instruction',
	    PASSWORD_RESET_SUCCESS: 'password_reset_success',
	    PARTY_CONFIRMATION: 'party_confirmation',
	    AIRPRINT_INVOICE: 'airprint_invoice',
	    ORDER_CONFIRMATION: 'order_confirmation',
	    DELIVERY_ORDER: 'delivery_order'
	};
	
	var EmailTemplateService = function (_BindoService) {
	    _inherits(EmailTemplateService, _BindoService);
	
	    function EmailTemplateService() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EmailTemplateService);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailTemplateService.__proto__ || Object.getPrototypeOf(EmailTemplateService)).call.apply(_ref, [this].concat(args))), _this), _this.TYPE = TYPE, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EmailTemplateService, [{
	        key: 'send',
	
	
	        /**
	         * Send email template
	         *
	         * @param {string} storeId
	         * @param {string} template_type
	         * @param {string} recipient
	         * @param {object} [params]
	         * @param {number} [params.order_id]
	         * @param {number} [params.order_number]
	         * @param {number} [params.delivery_order_id]
	         * @param {number} [params.party_id]
	         * @param {number} [params.user_id]
	         * @param {number} [params.customer_id]
	         *
	         * @memberOf EmailTemplateService
	         */
	        value: function send(storeId, template_type, email) {
	            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            var path = 'v2/stores/' + storeId + '/email_template/send';
	
	            var query = _extends({
	                template_type: template_type,
	                email: email,
	                store_id: storeId
	            }, params);
	
	            return _get(EmailTemplateService.prototype.__proto__ || Object.getPrototypeOf(EmailTemplateService.prototype), 'post', this).call(this, path, query, _config2.default.goGatewayApi).then(function (res) {
	                if (res.success) {
	                    return true;
	                } else {
	                    throw res;
	                }
	            });
	        }
	    }]);
	
	    return EmailTemplateService;
	}(_bindoService2.default);
	
	exports.default = new EmailTemplateService();

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceFormatService = function (_BindoService) {
	  _inherits(ReferenceFormatService, _BindoService);
	
	  function ReferenceFormatService() {
	    _classCallCheck(this, ReferenceFormatService);
	
	    return _possibleConstructorReturn(this, (ReferenceFormatService.__proto__ || Object.getPrototypeOf(ReferenceFormatService)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceFormatService, [{
	    key: 'create',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(storeId, data) {
	        var path;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/reference_numbers';
	                return _context.abrupt('return', this.post(path, data, _config2.default.goApi));
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function create(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return create;
	    }()
	  }, {
	    key: 'getAll',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(storeId) {
	        var path, _ref3, reference_numbers;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/reference_numbers';
	                _context2.next = 3;
	                return this.get(path, null, _config2.default.goApi);
	
	              case 3:
	                _ref3 = _context2.sent;
	                reference_numbers = _ref3.reference_numbers;
	                return _context2.abrupt('return', reference_numbers);
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getAll(_x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getAll;
	    }()
	  }, {
	    key: 'update',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(storeId, data) {
	        var id, path;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                id = data.id;
	                path = 'v2/stores/' + storeId + '/reference_numbers/' + id;
	                _context3.next = 4;
	                return this.put(path, data, _config2.default.goApi);
	
	              case 4:
	                return _context3.abrupt('return', _context3.sent);
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function update(_x4, _x5) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return update;
	    }()
	  }, {
	    key: 'delete',
	    value: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(storeId, id) {
	        var path;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/reference_numbers/' + id;
	                _context4.next = 3;
	                return _get(ReferenceFormatService.prototype.__proto__ || Object.getPrototypeOf(ReferenceFormatService.prototype), 'delete', this).call(this, path, null, _config2.default.goApi);
	
	              case 3:
	                return _context4.abrupt('return', _context4.sent);
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _delete(_x6, _x7) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return _delete;
	    }()
	  }, {
	    key: 'getDict',
	    value: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(storeId) {
	        var path, _ref7, reference_number_related;
	
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                path = 'v2/stores/' + storeId + '/reference_numbers/related';
	                _context5.next = 3;
	                return this.get(path, null, _config2.default.goApi);
	
	              case 3:
	                _ref7 = _context5.sent;
	                reference_number_related = _ref7.reference_number_related;
	                return _context5.abrupt('return', reference_number_related);
	
	              case 6:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function getDict(_x8) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getDict;
	    }()
	  }]);
	
	  return ReferenceFormatService;
	}(_bindoService2.default);
	
	exports.default = new ReferenceFormatService();

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreService = function (_BindoService) {
	  _inherits(StoreService, _BindoService);
	
	  function StoreService() {
	    _classCallCheck(this, StoreService);
	
	    return _possibleConstructorReturn(this, (StoreService.__proto__ || Object.getPrototypeOf(StoreService)).apply(this, arguments));
	  }
	
	  _createClass(StoreService, [{
	    key: 'get',
	    value: function get(id) {
	      var path = 'v2/stores';
	
	      if (id) {
	        path = path + '/' + id;
	      }
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path, { per_page: 999999 });
	    }
	  }, {
	    key: 'update',
	    value: function update(id, data) {
	      var path = 'v2/stores/' + id;
	
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'put', this).call(this, path, data);
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(id) {
	      var path = 'v2/stores/' + id + '/module';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'updateModule',
	    value: function updateModule(id, data) {
	      var path = 'v2/stores/' + id + '/module';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'put', this).call(this, path, data);
	    }
	  }, {
	    key: 'getPermissions',
	    value: function getPermissions(id) {
	      var path = 'v2/stores/' + id + '/store_permissions';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getChainInfo',
	    value: function getChainInfo(id) {
	      var path = 'v2/stores/' + id + '/chain_info';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getOtherPaymentInstrument',
	    value: function getOtherPaymentInstrument(id) {
	      var path = 'v2/stores/' + id + '/other_payment_instruments';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path, null, _config2.default.gateway);
	    }
	  }, {
	    key: 'getPolicy',
	    value: function getPolicy(id) {
	      var path = 'v2/stores/' + id + '/policy';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'updatePolicy',
	    value: function updatePolicy(id, data) {
	      var path = 'v2/stores/' + id + '/policy';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'put', this).call(this, path, data);
	    }
	  }, {
	    key: 'getBarcode',
	    value: function getBarcode(id) {
	      var path = 'v5/stores/' + id + '/scale_barcodes';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'get', this).call(this, path, null, _config2.default.goApi);
	    }
	  }, {
	    key: 'updateBarcode',
	    value: function updateBarcode(id, data) {
	      var path = 'v5/stores/' + id + '/scale_barcodes/modify_all';
	      return _get(StoreService.prototype.__proto__ || Object.getPrototypeOf(StoreService.prototype), 'post', this).call(this, path, data, _config2.default.goApi);
	    }
	  }]);
	
	  return StoreService;
	}(_bindoService2.default);
	
	exports.default = new StoreService();

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoucherSchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _pick = __webpack_require__(213);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _normalizr = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VoucherSchema = exports.VoucherSchema = new _normalizr.Schema('vouchers');
	var ListingSchema = new _normalizr.Schema('listings');
	
	var VoucherService = function (_BindoService) {
	  _inherits(VoucherService, _BindoService);
	
	  function VoucherService() {
	    _classCallCheck(this, VoucherService);
	
	    return _possibleConstructorReturn(this, (VoucherService.__proto__ || Object.getPrototypeOf(VoucherService)).apply(this, arguments));
	  }
	
	  _createClass(VoucherService, [{
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/voucher_discounts';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	      var query = {
	        page: page,
	        per_page: perPage,
	        order_by: 'name',
	        filters: filtersQueryList
	      };
	
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'get', this).call(this, path, query, _config2.default.gateway).then(function (res) {
	        var voucher_discounts = res.data.voucher_discounts;
	
	        var data = voucher_discounts.map(function (voucher, i) {
	          var fix = {
	            revenue_recognition: voucher.revenue_recognition % 2 == 0 ? 'AT SALES' : 'AT REDEMPTION',
	            face_value: voucher.amount
	            // sold_qty: i,
	            // redeemed_qty: i,
	            // pending_qty: i
	          };
	
	          return Object.assign(voucher, fix);
	        });
	
	        var result = {
	          page: page,
	          count: perPage,
	          perPage: perPage,
	          totalCount: res.totalCount,
	          totalPages: res.totalPages,
	          filters: filters
	
	        };
	        //normalize
	        var vouchers = (0, _normalizr.normalize)(data, (0, _normalizr.arrayOf)(VoucherSchema));
	
	        return {
	          state: {
	            criteria: result,
	            currentVouchers: vouchers.result
	          },
	          entities: vouchers.entities
	        };
	      });
	    }
	  }, {
	    key: 'getAssociateProducts',
	    value: function getAssociateProducts(storeId, productsIds) {
	
	      var promisese = [];
	
	      for (var i in productsIds) {
	        var query = {
	          order_by: 'name',
	          "filters[]": 'product_id__equal__' + String(productsIds[i])
	        };
	
	        var path = 'v2/stores/' + storeId + '/listings';
	
	        promisese.push(_get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'get', this).call(this, path, query));
	      }
	
	      return Promise.all(promisese).then(function (res) {
	        var data = [];
	        (0, _forEach2.default)(res, function (item) {
	          if (item.data[0]) {
	            data.push(item.data[0].listing);
	          }
	        });
	        var listing = (0, _normalizr.normalize)(data, (0, _normalizr.arrayOf)(ListingSchema));
	
	        var result = {
	          state: {
	            products: listing.entities.listings
	          }
	        };
	
	        return result;
	      });
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(storeId, discountId) {
	      var _this2 = this;
	
	      var path = 'v2/stores/' + storeId + '/voucher_discounts/' + discountId;
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'get', this).call(this, path, null, _config2.default.gateway).then(function (res) {
	        var voucherDiscount = res.voucher_discount;
	        voucherDiscount.discountable_items = (0, _map2.default)(voucherDiscount.discountable_items, function (item) {
	          return (0, _pick2.default)(item, ['item_type', 'item_id']);
	        });
	
	        var voucher = (0, _normalizr.normalize)(voucherDiscount, VoucherSchema);
	
	        var productIds = [];
	        (0, _forEach2.default)(voucherDiscount.discountable_items, function (item) {
	          productIds.push(item.item_id);
	        });
	
	        return _this2.getAssociateProducts(storeId, productIds).then(function (res) {
	          var result = {
	            state: res.state,
	            entities: voucher.entities
	          };
	
	          return result;
	        });
	      });
	    }
	  }, {
	    key: 'createItem',
	    value: function createItem(storeId, voucher) {
	      var path = 'v2/stores/' + storeId + '/voucher_discounts';
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'post', this).call(this, path, voucher, _config2.default.gateway).then(function (res) {
	
	        var voucher = (0, _normalizr.normalize)(res.voucher_discount, VoucherSchema);
	
	        var result = {
	          state: {},
	          entities: voucher.entities
	        };
	
	        return result;
	      }).catch(function (err) {
	        throw err;
	        // return err;
	      });
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(storeId, discountId, data) {
	      var path = 'v2/stores/' + storeId + '/voucher_discounts/' + discountId;
	
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'put', this).call(this, path, data, _config2.default.gateway).then(function (res) {
	        var voucher = (0, _normalizr.normalize)(res.voucher_discount, VoucherSchema);
	
	        var result = {
	          state: {},
	          entities: voucher.entities
	        };
	
	        return result;
	      });
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(storeId, discountId) {
	
	      var path = 'v2/stores/' + storeId + '/voucher_discounts/' + discountId;
	
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'delete', this).call(this, path, null, _config2.default.gateway).then(function (res) {
	        var voucher = (0, _normalizr.normalize)(res.voucher_discount, VoucherSchema);
	
	        var result = {
	          state: {},
	          entities: voucher.entities
	        };
	
	        return result;
	      });
	    }
	  }, {
	    key: 'getCoupons',
	    value: function getCoupons(storeId, discountId, page, perPage) {
	      var path = 'v2/stores/' + storeId + '/discounts/' + discountId + '/coupons';
	
	      var query = {
	        page: page,
	        per_page: perPage
	      };
	
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'get', this).call(this, path, query, _config2.default.gateway).then(function (res) {
	
	        var criteria = {
	          page: res.page,
	          count: res.count,
	          totalCount: res.totalCount,
	          totalPages: res.totalPages
	        };
	        //normalize
	        res.data.id = parseInt(discountId);
	        var vouchers = (0, _normalizr.normalize)(res.data, VoucherSchema);
	
	        return {
	          state: {
	            criteria: criteria
	          },
	          entities: vouchers.entities
	        };
	      });
	    }
	  }, {
	    key: 'putCoupons',
	    value: function putCoupons(storeId, discountId, coupons) {
	      var path = 'v2/stores/' + storeId + '/discounts/' + discountId + '/coupons';
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'put', this).call(this, path, { coupons: [coupons] }, _config2.default.gateway);
	    }
	  }, {
	    key: 'deleteCoupon',
	    value: function deleteCoupon(storeId, discountId, id) {
	      var path = 'v2/stores/' + storeId + '/discounts/' + discountId + '/coupons/' + id;
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'delete', this).call(this, path, null, _config2.default.gateway);
	    }
	  }, {
	    key: 'createCouponImport',
	    value: function createCouponImport(storeId, discountId, csv) {
	      var progress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
	
	      var path = 'v2/stores/' + storeId + '/coupon_imports';
	      var data = new FormData();
	      data.append('coupon_import[discount_id]', discountId);
	      data.append('coupon_import[csv]', csv);
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'postFileWProgress', this).call(this, path, data, progress, _config2.default.gateway);
	    }
	  }, {
	    key: 'importValidatedCoupon',
	    value: function importValidatedCoupon(storeId, couponImportId) {
	      var path = 'v2/stores/' + storeId + '/coupon_imports/' + couponImportId + '/import';
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'post', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'getCouponImport',
	    value: function getCouponImport(storeId, couponImportId) {
	      var path = 'v2/stores/' + storeId + '/coupon_imports/' + couponImportId;
	      return _get(VoucherService.prototype.__proto__ || Object.getPrototypeOf(VoucherService.prototype), 'get', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }]);
	
	  return VoucherService;
	}(_bindoService2.default);
	
	exports.default = new VoucherService();

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkflowService = function (_BindoService) {
	  _inherits(WorkflowService, _BindoService);
	
	  function WorkflowService() {
	    _classCallCheck(this, WorkflowService);
	
	    return _possibleConstructorReturn(this, (WorkflowService.__proto__ || Object.getPrototypeOf(WorkflowService)).apply(this, arguments));
	  }
	
	  _createClass(WorkflowService, [{
	    key: 'createWorkflow',
	    value: function createWorkflow(workflow, storeId) {
	      var path = 'v2/stores/' + storeId + '/workflows';
	
	      return _get(WorkflowService.prototype.__proto__ || Object.getPrototypeOf(WorkflowService.prototype), 'post', this).call(this, path, { workflow: workflow });
	    }
	  }, {
	    key: 'getWorkflows',
	    value: function getWorkflows(storeId) {
	      var path = 'v2/stores/' + storeId + '/workflows';
	
	      return _get(WorkflowService.prototype.__proto__ || Object.getPrototypeOf(WorkflowService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getWorkflow',
	    value: function getWorkflow(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/workflows/' + id;
	
	      return _get(WorkflowService.prototype.__proto__ || Object.getPrototypeOf(WorkflowService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'updateWorkflow',
	    value: function updateWorkflow(id, workflow, storeId) {
	      var path = 'v2/stores/' + storeId + '/workflows/' + id;
	
	      return _get(WorkflowService.prototype.__proto__ || Object.getPrototypeOf(WorkflowService.prototype), 'put', this).call(this, path, { workflow: workflow });
	    }
	  }, {
	    key: 'removeWorkflow',
	    value: function removeWorkflow(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/workflows/' + id;
	
	      return _get(WorkflowService.prototype.__proto__ || Object.getPrototypeOf(WorkflowService.prototype), 'delete', this).call(this, path);
	    }
	  }]);
	
	  return WorkflowService;
	}(_bindoService2.default);
	
	exports.default = new WorkflowService();

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(67);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(36);
	var toAbsoluteIndex = __webpack_require__(131);
	var toLength = __webpack_require__(23);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(124);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(36);
	var IObject = __webpack_require__(192);
	var toLength = __webpack_require__(23);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(49);
	var isObject = __webpack_require__(18);
	var invoke = __webpack_require__(509);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(28).f;
	var create = __webpack_require__(125);
	var redefineAll = __webpack_require__(129);
	var ctx = __webpack_require__(69);
	var anInstance = __webpack_require__(123);
	var forOf = __webpack_require__(124);
	var $iterDefine = __webpack_require__(339);
	var step = __webpack_require__(512);
	var setSpecies = __webpack_require__(130);
	var DESCRIPTORS = __webpack_require__(27);
	var fastKey = __webpack_require__(112).fastKey;
	var validate = __webpack_require__(160);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(156);
	var from = __webpack_require__(501);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(129);
	var getWeak = __webpack_require__(112).getWeak;
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var anInstance = __webpack_require__(123);
	var forOf = __webpack_require__(124);
	var createArrayMethod = __webpack_require__(77);
	var $has = __webpack_require__(60);
	var validate = __webpack_require__(160);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(244);
	var isObject = __webpack_require__(18);
	var toLength = __webpack_require__(23);
	var ctx = __webpack_require__(69);
	var IS_CONCAT_SPREADABLE = __webpack_require__(22)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(27) && !__webpack_require__(16)(function () {
	  return Object.defineProperty(__webpack_require__(332)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 509 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(18);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(11);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(341);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 514 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 515 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(127);
	var gOPS = __webpack_require__(248);
	var pIE = __webpack_require__(193);
	var toObject = __webpack_require__(36);
	var IObject = __webpack_require__(192);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(16)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var anObject = __webpack_require__(11);
	var getKeys = __webpack_require__(127);
	
	module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(63);
	var gOPN = __webpack_require__(126).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(60);
	var toIObject = __webpack_require__(63);
	var arrayIndexOf = __webpack_require__(241)(false);
	var IE_PROTO = __webpack_require__(346)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(127);
	var toIObject = __webpack_require__(63);
	var isEnum = __webpack_require__(193).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(126);
	var gOPS = __webpack_require__(248);
	var anObject = __webpack_require__(11);
	var Reflect = __webpack_require__(15).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(15).parseFloat;
	var $trim = __webpack_require__(159).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(349) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(15).parseInt;
	var $trim = __webpack_require__(159).trim;
	var ws = __webpack_require__(349);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var newPromiseCapability = __webpack_require__(343);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 526 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(23);
	var repeat = __webpack_require__(348);
	var defined = __webpack_require__(78);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(71);
	var toLength = __webpack_require__(23);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(22);


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(504);
	var validate = __webpack_require__(160);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(242)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(344);
	__webpack_require__(3)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(27) && /./g.flags != 'g') __webpack_require__(28).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(191)
	});


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(504);
	var validate = __webpack_require__(160);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(242)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(77)(0);
	var redefine = __webpack_require__(54);
	var meta = __webpack_require__(112);
	var assign = __webpack_require__(516);
	var weak = __webpack_require__(506);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(16);
	var validate = __webpack_require__(160);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(242)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 535 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 536 */
113,
/* 537 */
113,
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(56);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 539 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 540 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(574);
	var isObject = __webpack_require__(83);
	var isArray = __webpack_require__(38);
	var isFunction = __webpack_require__(267);
	
	// Credits: https://github.com/documentcloud/underscore-contrib
	// Sub module: underscore.object.selectors
	// License: MIT (https://github.com/documentcloud/underscore-contrib/blob/master/LICENSE)
	// https://github.com/documentcloud/underscore-contrib/blob/master/underscore.object.selectors.js
	
	// Will take a path like 'element[0][1].subElement["Hey!.What?"]["[hey]"]'
	// and return ["element", "0", "1", "subElement", "Hey!.What?", "[hey]"]
	function keysFromPath(path) {
	  // from http://codereview.stackexchange.com/a/63010/8176
	  /**
	   * Repeatedly capture either:
	   * - a bracketed expression, discarding optional matching quotes inside, or
	   * - an unbracketed expression, delimited by a dot or a bracket.
	   */
	  var re = /\[("|')(.+)\1\]|([^.\[\]]+)/g;
	
	  var elements = [];
	  var result;
	  while ((result = re.exec(path)) !== null) {
	    elements.push(result[2] || result[3]);
	  }
	  return elements;
	}
	
	// Gets the value at any depth in a nested object based on the
	// path described by the keys given. Keys may be given as an array
	// or as a dot-separated string.
	function getPath(obj, ks) {
	  if (typeof ks == "string") {
	    if (obj[ks] !== undefined) {
	      return obj[ks];
	    }
	    ks = keysFromPath(ks);
	  }
	
	  var i = -1,
	      length = ks.length;
	
	  // If the obj is null or undefined we have to break as
	  // a TypeError will result trying to access any property
	  // Otherwise keep incrementally access the next property in
	  // ks until complete
	  while (++i < length && obj != null) {
	    obj = obj[ks[i]];
	  }
	  return i === length ? obj : void 0;
	}
	
	// Based on the origin underscore _.pick function
	// Credit: https://github.com/jashkenas/underscore/blob/master/underscore.js
	function powerPick(object, keys) {
	  var result = {},
	      obj = object,
	      iteratee;
	  iteratee = function (key, obj) {
	    return key in obj;
	  };
	
	  obj = Object(obj);
	
	  for (var i = 0, length = keys.length; i < length; i++) {
	    var key = keys[i];
	    if (iteratee(key, obj)) result[key] = getPath(obj, key);
	  }
	
	  return result;
	}
	
	// Gets all the keys for a flattened object structure.
	// Doesn't flatten arrays.
	// Input:
	// {
	//  a: {
	//    x: 1,
	//    y: 2
	//  },
	//  b: [3, 4],
	//  c: 5
	// }
	// Output:
	// [
	//  "a.x",
	//  "a.y",
	//  "b",
	//  "c"
	// ]
	function getKeys(obj, prefix) {
	  var keys = [];
	
	  forEach(obj, function (value, key) {
	    var fullKey = prefix ? prefix + "." + key : key;
	    if (isObject(value) && !isArray(value) && !isFunction(value)) {
	      keys = keys.concat(getKeys(value, fullKey));
	    } else {
	      keys.push(fullKey);
	    }
	  });
	
	  return keys;
	}
	
	module.exports = {
	  pick: powerPick,
	  getAt: getPath,
	  keys: getKeys
	};


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(1);
	var ColumnProperties = __webpack_require__(197);
	var pick = __webpack_require__(1443);
	
	var GridRowContainer = React.createClass({
	  displayName: 'GridRowContainer',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "columnSettings": null,
	      "rowSettings": null,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "onRowClick": null,
	      "multipleSelectionSettings": null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      "data": {},
	      "showChildren": false
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setShowChildren(false);
	  },
	  toggleChildren: function toggleChildren() {
	    this.setShowChildren(this.state.showChildren === false);
	  },
	  setShowChildren: function setShowChildren(visible) {
	    this.setState({
	      showChildren: visible
	    });
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridRowContainer: The columnSettings prop is null and it shouldn't be");
	    }
	  },
	  render: function render() {
	    this.verifyProps();
	    var that = this;
	    if (typeof this.props.data === "undefined") {
	      return React.createElement('tbody', null);
	    }
	    var arr = [];
	
	    var columns = this.props.columnSettings.getColumns();
	
	    arr.push(React.createElement(this.props.rowSettings.rowComponent, {
	      useGriddleStyles: this.props.useGriddleStyles,
	      isSubGriddle: this.props.isSubGriddle,
	      data: this.props.rowSettings.isCustom ? pick(this.props.data, columns) : this.props.data,
	      rowData: this.props.rowSettings.isCustom ? this.props.data : null,
	      columnSettings: this.props.columnSettings,
	      rowSettings: this.props.rowSettings,
	      hasChildren: that.props.hasChildren,
	      toggleChildren: that.toggleChildren,
	      showChildren: that.state.showChildren,
	      key: that.props.uniqueId + '_base_row',
	      useGriddleIcons: that.props.useGriddleIcons,
	      parentRowExpandedClassName: this.props.parentRowExpandedClassName,
	      parentRowCollapsedClassName: this.props.parentRowCollapsedClassName,
	      parentRowExpandedComponent: this.props.parentRowExpandedComponent,
	      parentRowCollapsedComponent: this.props.parentRowCollapsedComponent,
	      paddingHeight: that.props.paddingHeight,
	      rowHeight: that.props.rowHeight,
	      onRowClick: that.props.onRowClick,
	      multipleSelectionSettings: this.props.multipleSelectionSettings }));
	
	    var children = null;
	
	    if (that.state.showChildren) {
	      children = that.props.hasChildren && this.props.data["children"].map(function (row, index) {
	        var key = that.props.rowSettings.getRowKey(row, index);
	
	        if (typeof row["children"] !== "undefined") {
	          var Griddle = that.constructor.Griddle;
	          return React.createElement('tr', { key: key, style: { paddingLeft: 5 } }, React.createElement('td', { colSpan: that.props.columnSettings.getVisibleColumnCount(), className: 'griddle-parent', style: that.props.useGriddleStyles ? { border: "none", "padding": "0 0 0 5px" } : null }, React.createElement(Griddle, {
	            rowMetadata: { key: 'id' },
	            isSubGriddle: true,
	            results: [row],
	            columns: that.props.columnSettings.getColumns(),
	            tableClassName: that.props.tableClassName,
	            parentRowExpandedClassName: that.props.parentRowExpandedClassName,
	            parentRowCollapsedClassName: that.props.parentRowCollapsedClassName,
	            showTableHeading: false,
	            showPager: false,
	            columnMetadata: that.props.columnSettings.columnMetadata,
	            parentRowExpandedComponent: that.props.parentRowExpandedComponent,
	            parentRowCollapsedComponent: that.props.parentRowCollapsedComponent,
	            paddingHeight: that.props.paddingHeight,
	            rowHeight: that.props.rowHeight
	          })));
	        }
	
	        return React.createElement(that.props.rowSettings.rowComponent, {
	          useGriddleStyles: that.props.useGriddleStyles,
	          isSubGriddle: that.props.isSubGriddle,
	          data: row,
	          columnSettings: that.props.columnSettings,
	          isChildRow: true,
	          columnMetadata: that.props.columnSettings.columnMetadata,
	          key: key
	        });
	      });
	    }
	
	    return that.props.hasChildren === false ? arr[0] : React.createElement('tbody', null, that.state.showChildren ? arr.concat(children) : arr);
	  }
	});
	
	module.exports = GridRowContainer;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _uniqueId = __webpack_require__(1450);
	
	var RowProperties = (function () {
	  function RowProperties() {
	    var rowMetadata = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var rowComponent = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	    var isCustom = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    _classCallCheck(this, RowProperties);
	
	    this.rowMetadata = rowMetadata;
	    this.rowComponent = rowComponent;
	    this.isCustom = isCustom;
	    // assign unique Id to each griddle instance
	  }
	
	  _createClass(RowProperties, [{
	    key: 'getRowKey',
	    value: function getRowKey(row, key) {
	      var uniqueId;
	
	      if (this.hasRowMetadataKey()) {
	        uniqueId = row[this.rowMetadata.key];
	      } else {
	        uniqueId = _uniqueId("grid_row");
	      }
	
	      //todo: add error handling
	
	      return uniqueId;
	    }
	  }, {
	    key: 'hasRowMetadataKey',
	    value: function hasRowMetadataKey() {
	      return this.hasRowMetadata() && this.rowMetadata.key !== null && this.rowMetadata.key !== undefined;
	    }
	  }, {
	    key: 'getBodyRowMetadataClass',
	    value: function getBodyRowMetadataClass(rowData) {
	      if (this.hasRowMetadata() && this.rowMetadata.bodyCssClassName !== null && this.rowMetadata.bodyCssClassName !== undefined) {
	        if (typeof this.rowMetadata.bodyCssClassName === 'function') {
	          return this.rowMetadata.bodyCssClassName(rowData);
	        } else {
	          return this.rowMetadata.bodyCssClassName;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getHeaderRowMetadataClass',
	    value: function getHeaderRowMetadataClass() {
	      return this.hasRowMetadata() && this.rowMetadata.headerCssClassName !== null && this.rowMetadata.headerCssClassName !== undefined ? this.rowMetadata.headerCssClassName : null;
	    }
	  }, {
	    key: 'hasRowMetadata',
	    value: function hasRowMetadata() {
	      return this.rowMetadata !== null;
	    }
	  }]);
	
	  return RowProperties;
	})();
	
	module.exports = RowProperties;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(357),
	    setCacheAdd = __webpack_require__(1410),
	    setCacheHas = __webpack_require__(1411);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 545 */
[1791, 81],
/* 546 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 547 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1355),
	    isArguments = __webpack_require__(265),
	    isArray = __webpack_require__(38),
	    isBuffer = __webpack_require__(266),
	    isIndex = __webpack_require__(262),
	    isTypedArray = __webpack_require__(370);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(559);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(544),
	    arrayIncludes = __webpack_require__(1326),
	    arrayIncludesWith = __webpack_require__(1327),
	    arrayMap = __webpack_require__(133),
	    baseUnary = __webpack_require__(201),
	    cacheHas = __webpack_require__(558);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 551 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(359),
	    isArray = __webpack_require__(38);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(551),
	    baseIsNaN = __webpack_require__(1341),
	    strictIndexOf = __webpack_require__(1420);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1338),
	    isObjectLike = __webpack_require__(84);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(202),
	    nativeKeys = __webpack_require__(1406);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 556 */
[1797, 360, 82],
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(133),
	    baseIteratee = __webpack_require__(198),
	    baseMap = __webpack_require__(556),
	    baseSortBy = __webpack_require__(1354),
	    baseUnary = __webpack_require__(201),
	    compareMultiple = __webpack_require__(1367),
	    identity = __webpack_require__(204);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(544),
	    arraySome = __webpack_require__(1328),
	    cacheHas = __webpack_require__(558);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1428),
	    overRest = __webpack_require__(570),
	    setToString = __webpack_require__(571);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 562 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(552),
	    getSymbols = __webpack_require__(364),
	    keys = __webpack_require__(97);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(552),
	    getSymbolsIn = __webpack_require__(565),
	    keysIn = __webpack_require__(371);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(359),
	    getPrototype = __webpack_require__(363),
	    getSymbols = __webpack_require__(364),
	    stubArray = __webpack_require__(580);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 566 */
[1803, 83],
/* 567 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 568 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 569 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1325);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1353),
	    shortOut = __webpack_require__(1414);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 572 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(547),
	    baseFilter = __webpack_require__(1333),
	    baseIteratee = __webpack_require__(198),
	    isArray = __webpack_require__(38);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(546),
	    baseEach = __webpack_require__(360),
	    castFunction = __webpack_require__(1360),
	    isArray = __webpack_require__(38);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(260);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1336),
	    hasPath = __webpack_require__(1383);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(82),
	    isObjectLike = __webpack_require__(84);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(133),
	    baseIteratee = __webpack_require__(198),
	    baseMap = __webpack_require__(556),
	    isArray = __webpack_require__(38);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1350),
	    basePropertyDeep = __webpack_require__(1351),
	    isKey = __webpack_require__(366),
	    toKey = __webpack_require__(165);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 580 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1357);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(550),
	    baseRest = __webpack_require__(199),
	    isArrayLikeObject = __webpack_require__(577);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(268);
	
	var _DOMUtils = __webpack_require__(372);
	
	var _createHistory = __webpack_require__(586);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(166);
	
	var _PathUtils = __webpack_require__(136);
	
	var _ExecutionEnvironment = __webpack_require__(268);
	
	var _DOMUtils = __webpack_require__(372);
	
	var _DOMStateStorage = __webpack_require__(583);
	
	var _createDOMHistory = __webpack_require__(584);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(355);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(136);
	
	var _AsyncUtils = __webpack_require__(1452);
	
	var _Actions = __webpack_require__(166);
	
	var _createLocation2 = __webpack_require__(1454);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(374);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(373);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(268);
	
	var _PathUtils = __webpack_require__(136);
	
	var _runTransitionHook = __webpack_require__(374);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(373);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1786);
	module.exports = self.fetch.bind(self);


/***/ },
/* 589 */
/***/ function(module, exports) {

	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(86);
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;


/***/ },
/* 591 */
/***/ function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ },
/* 592 */
/***/ function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(590);
	var utils = __webpack_require__(86);
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(590);
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ },
/* 595 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(1475),
	    createAssigner = __webpack_require__(1479),
	    keys = __webpack_require__(383);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var arrayEach = __webpack_require__(1474),
	    baseEach = __webpack_require__(1477),
	    bindCallback = __webpack_require__(595),
	    isArray = __webpack_require__(382);
	
	/**
	 * Creates a function for `_.forEach` or `_.forEachRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createForEach(arrayFunc, eachFunc) {
	  return function(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee)
	      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	  };
	}
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection). Iteratee functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	var forEach = createForEach(arrayEach, baseEach);
	
	module.exports = forEach;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var mapClear = __webpack_require__(1549),
	    mapDelete = __webpack_require__(1550),
	    mapGet = __webpack_require__(1551),
	    mapHas = __webpack_require__(1552),
	    mapSet = __webpack_require__(1553);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function MapCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add functions to the `MapCache`.
	MapCache.prototype.clear = mapClear;
	MapCache.prototype['delete'] = mapDelete;
	MapCache.prototype.get = mapGet;
	MapCache.prototype.has = mapHas;
	MapCache.prototype.set = mapSet;
	
	module.exports = MapCache;


/***/ },
/* 599 */
[1789, 275, 138],
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(598),
	    cachePush = __webpack_require__(1519);
	
	/**
	 *
	 * Creates a set cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.push(values[index]);
	  }
	}
	
	// Add functions to the `SetCache`.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;


/***/ },
/* 601 */
[1791, 138],
/* 602 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(618);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  return !!array.length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 604 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(282);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(282);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(273);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the associative array.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function assocDelete(array, key) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = array.length - 1;
	  if (index == lastIndex) {
	    array.pop();
	  } else {
	    splice.call(array, index, 1);
	  }
	  return true;
	}
	
	module.exports = assocDelete;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(273);
	
	/**
	 * Gets the associative array value for `key`.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function assocGet(array, key) {
	  var index = assocIndexOf(array, key);
	  return index < 0 ? undefined : array[index][1];
	}
	
	module.exports = assocGet;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(273);
	
	/**
	 * Checks if an associative array value for `key` exists.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function assocHas(array, key) {
	  return assocIndexOf(array, key) > -1;
	}
	
	module.exports = assocHas;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(273);
	
	/**
	 * Sets the associative array `key` to `value`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function assocSet(array, key, value) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    array.push([key, value]);
	  } else {
	    array[index][1] = value;
	  }
	}
	
	module.exports = assocSet;


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(271),
	    arrayEach = __webpack_require__(385),
	    assignValue = __webpack_require__(606),
	    baseAssign = __webpack_require__(1494),
	    baseForOwn = __webpack_require__(274),
	    cloneBuffer = __webpack_require__(1521),
	    copyArray = __webpack_require__(625),
	    copySymbols = __webpack_require__(1530),
	    getTag = __webpack_require__(628),
	    initCloneArray = __webpack_require__(1544),
	    initCloneByTag = __webpack_require__(1545),
	    initCloneObject = __webpack_require__(1546),
	    isArray = __webpack_require__(32),
	    isBuffer = __webpack_require__(1565),
	    isHostObject = __webpack_require__(276),
	    isObject = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[mapTag] = cloneableTags[numberTag] =
	cloneableTags[objectTag] = cloneableTags[regexpTag] =
	cloneableTags[setTag] = cloneableTags[stringTag] =
	cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
	cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
	cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        result = baseAssign(result, value);
	        return isFull ? copySymbols(value, result) : result;
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return (isFull && !isArr) ? copySymbols(value, result) : result;
	}
	
	module.exports = baseClone;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(600),
	    arrayIncludes = __webpack_require__(603),
	    arrayIncludesWith = __webpack_require__(604),
	    arrayMap = __webpack_require__(168),
	    baseUnary = __webpack_require__(1516),
	    cacheHas = __webpack_require__(623);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support for
	 * excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 613 */
[1795, 208],
/* 614 */
/***/ function(module, exports) {

	/**
	 * The base implementation of methods like `_.find` and `_.findKey`, without
	 * support for iteratee shorthands, which iterates over `collection` using
	 * `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1532);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(386),
	    isKey = __webpack_require__(277);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 617 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return hasOwnProperty.call(object, key) ||
	    (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
	}
	
	module.exports = baseHas;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(1543);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 619 */
[1797, 208, 170],
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(271),
	    arrayEach = __webpack_require__(385),
	    assignMergeValue = __webpack_require__(605),
	    baseMergeDeep = __webpack_require__(1506),
	    isArray = __webpack_require__(32),
	    isObject = __webpack_require__(51),
	    isTypedArray = __webpack_require__(392),
	    keysIn = __webpack_require__(286);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  var props = (isArray(source) || isTypedArray(source))
	    ? undefined
	    : keysIn(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	module.exports = baseMerge;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(272);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property names.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return arrayReduce(props, function(result, key) {
	    if (key in object) {
	      result[key] = object[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = basePick;


/***/ },
/* 622 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(169);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Checks if `value` is in `cache`.
	 *
	 * @private
	 * @param {Object} cache The set cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function cacheHas(cache, value) {
	  var map = cache.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    return hash[value] === HASH_UNDEFINED;
	  }
	  return map.has(value);
	}
	
	module.exports = cacheHas;


/***/ },
/* 624 */
[1799, 601],
/* 625 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var isIterateeCall = __webpack_require__(631),
	    rest = __webpack_require__(142);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = typeof customizer == 'function'
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(1493);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var index = -1,
	      isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isUnordered) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(167),
	    Set = __webpack_require__(599),
	    WeakMap = __webpack_require__(1487);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var mapCtorString = Map ? funcToString.call(Map) : '',
	    setCtorString = Set ? funcToString.call(Set) : '',
	    weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
	if ((Map && getTag(new Map) != mapTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : null,
	        ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case mapCtorString: return mapTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(278);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(hash, key) {
	  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1514),
	    isArguments = __webpack_require__(283),
	    isArray = __webpack_require__(32),
	    isLength = __webpack_require__(284),
	    isString = __webpack_require__(391);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(282),
	    isArrayLike = __webpack_require__(170),
	    isIndex = __webpack_require__(210),
	    isObject = __webpack_require__(51);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to an array.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1512),
	    get = __webpack_require__(635);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(602),
	    baseFilter = __webpack_require__(613),
	    baseIteratee = __webpack_require__(72),
	    isArray = __webpack_require__(32);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(616);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined` the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 636 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(618),
	    isArrayLike = __webpack_require__(170),
	    isString = __webpack_require__(391),
	    toInteger = __webpack_require__(395),
	    values = __webpack_require__(99);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string it's checked
	 * for a substring of `value`, otherwise [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	 * // => true
	 *
	 * _.includes('pebbles', 'eb');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168),
	    baseDifference = __webpack_require__(612),
	    baseFlatten = __webpack_require__(209),
	    basePick = __webpack_require__(621),
	    keysIn = __webpack_require__(286),
	    rest = __webpack_require__(142);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property names to omit, specified
	 *  individually or in arrays.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = rest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), String);
	  return basePick(object, baseDifference(keysIn(object), props));
	});
	
	module.exports = omit;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashIsObject = __webpack_require__(51);
	
	var _lodashIsObject2 = _interopRequireDefault(_lodashIsObject);
	
	var UnionSchema = (function () {
	  function UnionSchema(itemSchema, options) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!_lodashIsObject2['default'](itemSchema)) {
	      throw new Error('UnionSchema requires item schema to be an object.');
	    }
	
	    if (!options || !options.schemaAttribute) {
	      throw new Error('UnionSchema requires schemaAttribute option.');
	    }
	
	    this._itemSchema = itemSchema;
	
	    var schemaAttribute = options.schemaAttribute;
	    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
	      return x[schemaAttribute];
	    };
	  }
	
	  UnionSchema.prototype.getItemSchema = function getItemSchema() {
	    return this._itemSchema;
	  };
	
	  UnionSchema.prototype.getSchemaKey = function getSchemaKey(item) {
	    return this._getSchema(item);
	  };
	
	  return UnionSchema;
	})();
	
	exports['default'] = UnionSchema;
	module.exports = exports['default'];

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(115);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ },
/* 641 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },
/* 643 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },
/* 644 */
/***/ function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },
/* 645 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	const ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 646 */
/***/ function(module, exports) {

	'use strict';
	
	var hexTable = (function () {
	    var array = new Array(256);
	    for (var i = 0; i < 256; ++i) {
	        array[i] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            target[source] = true;
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
		return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
			return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += (hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (var j = 0; j < keys.length; ++j) {
	        var key = keys[j];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 647 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(144);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(172);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(74);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1663);
	var warning = __webpack_require__(13);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDefaultInjection = __webpack_require__(1629);
	var ReactMount = __webpack_require__(657);
	var ReactReconciler = __webpack_require__(173);
	var ReactUpdates = __webpack_require__(87);
	var ReactVersion = __webpack_require__(1642);
	
	var findDOMNode = __webpack_require__(1658);
	var getHostComponentFromComposite = __webpack_require__(662);
	var renderSubtreeIntoContainer = __webpack_require__(1664);
	var warning = __webpack_require__(13);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 651 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(87);
	
	var warning = __webpack_require__(13);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 653 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 654 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1624);
	
	var containsNode = __webpack_require__(1287);
	var focusNode = __webpack_require__(539);
	var getActiveElement = __webpack_require__(540);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMLazyTree = __webpack_require__(171);
	var DOMProperty = __webpack_require__(172);
	var React = __webpack_require__(101);
	var ReactBrowserEventEmitter = __webpack_require__(289);
	var ReactCurrentOwner = __webpack_require__(102);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMContainerInfo = __webpack_require__(1618);
	var ReactDOMFeatureFlags = __webpack_require__(1620);
	var ReactFeatureFlags = __webpack_require__(654);
	var ReactInstanceMap = __webpack_require__(217);
	var ReactInstrumentation = __webpack_require__(74);
	var ReactMarkupChecksum = __webpack_require__(1634);
	var ReactReconciler = __webpack_require__(173);
	var ReactUpdateQueue = __webpack_require__(410);
	var ReactUpdates = __webpack_require__(87);
	
	var emptyObject = __webpack_require__(196);
	var instantiateReactComponent = __webpack_require__(665);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(293);
	var shouldUpdateReactComponent = __webpack_require__(416);
	var warning = __webpack_require__(13);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var React = __webpack_require__(101);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 659 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 661 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(658);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var ReactCompositeComponent = __webpack_require__(1616);
	var ReactEmptyComponent = __webpack_require__(653);
	var ReactHostComponent = __webpack_require__(655);
	
	var getNextDebugID = __webpack_require__(1741);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 666 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	var escapeTextContentForBrowser = __webpack_require__(292);
	var setInnerHTML = __webpack_require__(293);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(102);
	var REACT_ELEMENT_TYPE = __webpack_require__(1630);
	
	var getIteratorFn = __webpack_require__(1661);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(406);
	var warning = __webpack_require__(13);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 669 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;
	
	var _Manager2 = __webpack_require__(1682);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _Target2 = __webpack_require__(1684);
	
	var _Target3 = _interopRequireDefault(_Target2);
	
	var _Popper2 = __webpack_require__(1683);
	
	var _Popper3 = _interopRequireDefault(_Popper2);
	
	var _Arrow2 = __webpack_require__(1681);
	
	var _Arrow3 = _interopRequireDefault(_Arrow2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Manager = _Manager3.default;
	exports.Target = _Target3.default;
	exports.Popper = _Popper3.default;
	exports.Arrow = _Arrow3.default;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(375);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1694);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(674);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(675);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(285);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(418);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 675 */
[1807, 1696],
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _PatternUtils = __webpack_require__(174);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(296);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(269);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(587);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1455);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(682);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(296);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(269);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(587);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(297);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(688);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var transformedInputValue = inputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				if (onInputChange) {
					onInputChange(transformedInputValue);
				}
	
				this.setState({ inputValue: inputValue });
				this.loadOptions(transformedInputValue);
	
				// Return the original input value to avoid modifying the user's view of the input while typing.
				return inputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    multi = _props3.multi,
				    onChange = _props3.onChange,
				    placeholder = _props3.placeholder,
				    value = _props3.value;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	}

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(297);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _defaultFilterOptions = __webpack_require__(686);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(687);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options,
				    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    options = _props2.options,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.select.filterOptions();
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
	
				if (onInputChange) {
					onInputChange(input);
				}
	
				// This value may be needed in between Select mounts (when this.select is null)
				this.inputValue = input;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option, event) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    newOptionCreator = _props4.newOptionCreator,
				    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
				    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(298);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	;
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(688);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	exports.default = filterOptions;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(298);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    instancePrefix = _ref.instancePrefix,
		    labelKey = _ref.labelKey,
		    onFocus = _ref.onFocus,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey,
		    onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	exports.default = menuRenderer;

/***/ },
/* 688 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stripDiacritics;
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 689 */
406,
/* 690 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(177);
	
	var ReactElement = __webpack_require__(176);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(177);
	
	var ReactCurrentOwner = __webpack_require__(102);
	var REACT_ELEMENT_TYPE = __webpack_require__(690);
	
	var getIteratorFn = __webpack_require__(1740);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(689);
	var warning = __webpack_require__(13);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(426);
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(427);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ },
/* 696 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(698);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target;
	    var type = _event$target.type;
	    var value = _event$target.value;
	    var checked = _event$target.checked;
	    var files = _event$target.files;
	    var dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (type === 'number' || type === 'range') {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ },
/* 698 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(698);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 700 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ },
/* 701 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value;
	  var initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    (function () {
	      // array field
	      var key = field.substring(0, openIndex);
	      var rest = field.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      var array = state && state[key] || [];
	      if (rest) {
	        if (!dest[key]) {
	          dest[key] = [];
	        }
	        array.forEach(function (item, index) {
	          if (!dest[key][index]) {
	            dest[key][index] = {};
	          }
	          getValue(rest, item, dest[key][index]);
	        });
	      } else {
	        dest[key] = array.map(itemToValue);
	      }
	    })();
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(179);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ },
/* 703 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(426);
	
	var _mapValues = __webpack_require__(427);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(704);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(706);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(702);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(1754);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(1760);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(1761);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(179);
	
	var _normalizeFields = __webpack_require__(1756);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path;
	  var index = _ref.index;
	  var value = _ref.value;
	  var fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field;
	  var value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true });
	
	    var asyncError = _previous$value$autof.asyncError;
	    var submitError = _previous$value$autof.submitError;
	
	    var result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field;
	  var value = _ref3.value;
	  var touch = _ref3.touch;
	  var _active = state._active;
	
	  var stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field;
	  var value = _ref4.value;
	  var touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value });
	
	    var asyncError = _previous$value.asyncError;
	    var submitError = _previous$value.submitError;
	    var autofilled = _previous$value.autofilled;
	
	    var result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var _extends2;
	
	  var data = _ref6.data;
	  var fields = _ref6.fields;
	  var overwriteValues = _ref6.overwriteValues;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = true, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path;
	  var index = _ref7.index;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends3;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends3 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = undefined, _extends3._initialized = state._initialized, _extends3._submitting = false, _extends3._submitFailed = false, _extends3));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends4;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends4 = {
	    _asyncValidating: false
	  }, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends5;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends5 = {}, _extends5[globalErrorKey] = errors && errors[globalErrorKey], _extends5._submitting = false, _extends5._submitFailed = !!(errors && Object.keys(errors).length), _extends5));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path;
	  var indexA = _ref11.indexA;
	  var indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched;
	
	        var rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends11;
	
	  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var form = action.form;
	  var key = action.key;
	
	  var rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends8, _extends9;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends7;
	
	      return _extends({}, state, (_extends7 = {}, _extends7[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends6;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends6 = {}, _extends6[stateKey] = state[form][stateKey], _extends6));
	      }, {}), _extends7));
	    }
	    return _extends({}, state, (_extends9 = {}, _extends9[form] = _extends({}, state[form], (_extends8 = {}, _extends8[key] = reducer((state[form] || {})[key], rest), _extends8)), _extends9));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends10;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends10 = {}, _extends10[formName] = state[formName], _extends10));
	    }, {});
	  }
	  return _extends({}, state, (_extends11 = {}, _extends11[form] = reducer(state[form], rest), _extends11));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends12;
	
	          return _extends({}, result[form], (_extends12 = {}, _extends12[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends12));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      var _extends6;
	
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found [ but no ]');
	      }
	      var key = path.substring(0, openIndex);
	      var index = path.substring(openIndex + 1, closeIndex);
	      var array = object[key] || [];
	      var rest = path.substring(closeIndex + 1);
	      if (index) {
	        var _extends4;
	
	        // indexed array
	        if (rest.length) {
	          var _extends3;
	
	          // need to keep recursing
	          var dest = array[index] || {};
	          var arrayCopy = [].concat(array);
	          arrayCopy[index] = write(rest, value, dest);
	          return {
	            v: _extends({}, object || {}, (_extends3 = {}, _extends3[key] = arrayCopy, _extends3))
	          };
	        }
	        var copy = [].concat(array);
	        copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	        return {
	          v: _extends({}, object || {}, (_extends4 = {}, _extends4[key] = copy, _extends4))
	        };
	      }
	      // indexless array
	      if (rest.length) {
	        var _extends5;
	
	        // need to keep recursing
	        if ((!array || !array.length) && typeof value === 'function') {
	          return {
	            v: object
	          }; // don't even set a value under [key]
	        }
	        var _arrayCopy = array.map(function (dest) {
	          return write(rest, value, dest);
	        });
	        return {
	          v: _extends({}, object || {}, (_extends5 = {}, _extends5[key] = _arrayCopy, _extends5))
	        };
	      }
	      var result = void 0;
	      if (Array.isArray(value)) {
	        result = value;
	      } else if (object[key]) {
	        result = array.map(function (dest) {
	          return typeof value === 'function' ? value(dest) : value;
	        });
	      } else if (typeof value === 'function') {
	        return {
	          v: object
	        }; // don't even set a value under [key]
	      } else {
	          result = value;
	        }
	      return {
	        v: _extends({}, object || {}, (_extends6 = {}, _extends6[key] = result, _extends6))
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getStoredState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashForeach = __webpack_require__(597);
	
	var _lodashForeach2 = _interopRequireDefault(_lodashForeach);
	
	var _constants = __webpack_require__(300);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _defaultsAsyncLocalStorage = __webpack_require__(428);
	
	var _defaultsAsyncLocalStorage2 = _interopRequireDefault(_defaultsAsyncLocalStorage);
	
	function getStoredState(config, onComplete) {
	  var storage = config.storage || _defaultsAsyncLocalStorage2['default']('local');
	  var deserialize = config.deserialize || defaultDeserialize;
	  var transforms = config.transforms || [];
	  var purgeMode = config.purgeMode || false;
	
	  var restoredState = {};
	  var completionCount = 0;
	
	  storage.getAllKeys(function (err, allKeys) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error in storage.getAllKeys');
	    }
	    var persistKeys = allKeys.filter(function (key) {
	      return key.indexOf(_constants2['default'].keyPrefix) === 0;
	    }).map(function (key) {
	      return key.slice(_constants2['default'].keyPrefix.length);
	    });
	    var keysToRestore = Array.isArray(purgeMode) ? persistKeys.filter(function (key) {
	      return purgeMode.indexOf(key) === -1;
	    }) : purgeMode === '*' ? [] : persistKeys;
	
	    var restoreCount = keysToRestore.length;
	    if (restoreCount === 0) complete(null, restoredState);
	    _lodashForeach2['default'](keysToRestore, function (key) {
	      storage.getItem(createStorageKey(key), function (err, serialized) {
	        if (err && ("production") !== 'production') console.warn('Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
	        completionCount += 1;
	        if (completionCount === restoreCount) complete(null, restoredState);
	      });
	    });
	  });
	
	  function rehydrate(key, serialized) {
	    var state = null;
	
	    try {
	      var data = deserialize(serialized);
	      state = transforms.reduceRight(function (subState, transformer) {
	        return transformer.out(subState);
	      }, data);
	    } catch (err) {
	      if (false) console.warn('Error restoring data for key:', key, err);
	    }
	
	    return state;
	  }
	
	  function complete(err, restoredState) {
	    onComplete(err, restoredState);
	  }
	}
	
	function defaultDeserialize(serial) {
	  return JSON.parse(serial);
	}
	
	function createStorageKey(key) {
	  return _constants2['default'].keyPrefix + key;
	}
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createAsyncLocalStorage = __webpack_require__(428);
	
	module.exports.persistStore = __webpack_require__(1768);
	module.exports.autoRehydrate = __webpack_require__(1766);
	module.exports.getStoredState = __webpack_require__(707);
	module.exports.storages = {
	  asyncLocalStorage: createAsyncLocalStorage('local'),
	  asyncSessionStorage: createAsyncLocalStorage('session')
	};

/***/ },
/* 709 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing functions from right to
	 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function () {
	    if (funcs.length === 0) {
	      return arguments.length <= 0 ? undefined : arguments[0];
	    }
	
	    var last = funcs[funcs.length - 1];
	    var rest = funcs.slice(0, -1);
	
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(285);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all states changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ },
/* 711 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(430);
	
	/*<replacement>*/
	var util = __webpack_require__(195);
	util.inherits = __webpack_require__(137);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1458);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(122).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(535).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(219);
	
	/*<replacement>*/
	var util = __webpack_require__(195);
	util.inherits = __webpack_require__(137);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(1787);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(146);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(714).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(146);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(714).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(122).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var _rng = __webpack_require__(1784);
	
	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i = 0; i < 256; ++i) {
	  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i]] = i;
	}
	
	function buff_to_string(buf, offset) {
	  var i = offset || 0;
	  var bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = _rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : buff_to_string(b);
	}
	
	// **`v4()` - Generate random UUID**
	
	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || buff_to_string(rnds);
	}
	
	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 716 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var interactionMode_1 = __webpack_require__(720);
	exports.FOCUS_DISABLED_CLASS = "pt-focus-disabled";
	var fakeFocusEngine = {
	    isActive: function () { return true; },
	    start: function () { return true; },
	    stop: function () { return true; },
	};
	var focusEngine = typeof document !== "undefined"
	    ? new interactionMode_1.InteractionModeEngine(document.documentElement, exports.FOCUS_DISABLED_CLASS)
	    : fakeFocusEngine;
	exports.FocusStyleManager = {
	    alwaysShowFocus: function () { return focusEngine.stop(); },
	    isActive: function () { return focusEngine.isActive(); },
	    onlyShowFocusOnTabs: function () { return focusEngine.start(); },
	};


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	tslib_1.__exportStar(__webpack_require__(717), exports);


/***/ },
/* 719 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Colors = {
	    BLACK: "#10161A",
	    BLUE1: "#0E5A8A",
	    BLUE2: "#106BA3",
	    BLUE3: "#137CBD",
	    BLUE4: "#2B95D6",
	    BLUE5: "#48AFF0",
	    COBALT1: "#1F4B99",
	    COBALT2: "#2458B3",
	    COBALT3: "#2965CC",
	    COBALT4: "#4580E6",
	    COBALT5: "#669EFF",
	    DARK_GRAY1: "#182026",
	    DARK_GRAY2: "#202B33",
	    DARK_GRAY3: "#293742",
	    DARK_GRAY4: "#30404D",
	    DARK_GRAY5: "#394B59",
	    FOREST1: "#1D7324",
	    FOREST2: "#238C2C",
	    FOREST3: "#29A634",
	    FOREST4: "#43BF4D",
	    FOREST5: "#62D96B",
	    GOLD1: "#A67908",
	    GOLD2: "#BF8C0A",
	    GOLD3: "#D99E0B",
	    GOLD4: "#F2B824",
	    GOLD5: "#FFC940",
	    GRAY1: "#5C7080",
	    GRAY2: "#738694",
	    GRAY3: "#8A9BA8",
	    GRAY4: "#A7B6C2",
	    GRAY5: "#BFCCD6",
	    GREEN1: "#0A6640",
	    GREEN2: "#0D8050",
	    GREEN3: "#0F9960",
	    GREEN4: "#15B371",
	    GREEN5: "#3DCC91",
	    INDIGO1: "#5642A6",
	    INDIGO2: "#634DBF",
	    INDIGO3: "#7157D9",
	    INDIGO4: "#9179F2",
	    INDIGO5: "#AD99FF",
	    LIGHT_GRAY1: "#CED9E0",
	    LIGHT_GRAY2: "#D8E1E8",
	    LIGHT_GRAY3: "#E1E8ED",
	    LIGHT_GRAY4: "#EBF1F5",
	    LIGHT_GRAY5: "#F5F8FA",
	    LIME1: "#728C23",
	    LIME2: "#87A629",
	    LIME3: "#9BBF30",
	    LIME4: "#B6D94C",
	    LIME5: "#D1F26D",
	    ORANGE1: "#A66321",
	    ORANGE2: "#BF7326",
	    ORANGE3: "#D9822B",
	    ORANGE4: "#F29D49",
	    ORANGE5: "#FFB366",
	    RED1: "#A82A2A",
	    RED2: "#C23030",
	    RED3: "#DB3737",
	    RED4: "#F55656",
	    RED5: "#FF7373",
	    ROSE1: "#A82255",
	    ROSE2: "#C22762",
	    ROSE3: "#DB2C6F",
	    ROSE4: "#F5498B",
	    ROSE5: "#FF66A1",
	    SEPIA1: "#63411E",
	    SEPIA2: "#7D5125",
	    SEPIA3: "#96622D",
	    SEPIA4: "#B07B46",
	    SEPIA5: "#C99765",
	    TURQUOISE1: "#008075",
	    TURQUOISE2: "#00998C",
	    TURQUOISE3: "#00B3A4",
	    TURQUOISE4: "#14CCBD",
	    TURQUOISE5: "#2EE6D6",
	    VERMILION1: "#9E2B0E",
	    VERMILION2: "#B83211",
	    VERMILION3: "#D13913",
	    VERMILION4: "#EB532D",
	    VERMILION5: "#FF6E4A",
	    VIOLET1: "#5C255C",
	    VIOLET2: "#752F75",
	    VIOLET3: "#8F398F",
	    VIOLET4: "#A854A8",
	    VIOLET5: "#C274C2",
	    WHITE: "#FFFFFF",
	};


/***/ },
/* 720 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var TAB_KEY_CODE = 9;
	/* istanbul ignore next */
	/**
	 * A nifty little class that maintains event handlers to add a class to the container element
	 * when entering "mouse mode" (on a `mousedown` event) and remove it when entering "keyboard mode"
	 * (on a `tab` key `keydown` event).
	 */
	var InteractionModeEngine = (function () {
	    // tslint:disable-next-line:no-constructor-vars
	    function InteractionModeEngine(container, className) {
	        var _this = this;
	        this.container = container;
	        this.className = className;
	        this.isRunning = false;
	        this.handleKeyDown = function (e) {
	            if (e.which === TAB_KEY_CODE) {
	                _this.reset();
	                _this.container.addEventListener("mousedown", _this.handleMouseDown);
	            }
	        };
	        this.handleMouseDown = function () {
	            _this.reset();
	            _this.container.classList.add(_this.className);
	            _this.container.addEventListener("keydown", _this.handleKeyDown);
	        };
	    }
	    /** Returns whether the engine is currently running. */
	    InteractionModeEngine.prototype.isActive = function () {
	        return this.isRunning;
	    };
	    /** Enable behavior which applies the given className when in mouse mode. */
	    InteractionModeEngine.prototype.start = function () {
	        this.container.addEventListener("mousedown", this.handleMouseDown);
	        this.isRunning = true;
	    };
	    /** Disable interaction mode behavior and remove className from container. */
	    InteractionModeEngine.prototype.stop = function () {
	        this.reset();
	        this.isRunning = false;
	    };
	    InteractionModeEngine.prototype.reset = function () {
	        this.container.classList.remove(this.className);
	        this.container.removeEventListener("keydown", this.handleKeyDown);
	        this.container.removeEventListener("mousedown", this.handleMouseDown);
	    };
	    return InteractionModeEngine;
	}());
	exports.InteractionModeEngine = InteractionModeEngine;


/***/ },
/* 721 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true if the arrays are equal. Elements will be shallowly compared by
	 * default, or they will be compared using the custom `compare` function if one
	 * is provided.
	 */
	function arraysEqual(arrA, arrB, compare) {
	    if (compare === void 0) { compare = function (a, b) { return a === b; }; }
	    // treat `null` and `undefined` as the same
	    if (arrA == null && arrB == null) {
	        return true;
	    }
	    else if (arrA == null || arrB == null || arrA.length !== arrB.length) {
	        return false;
	    }
	    else {
	        return arrA.every(function (a, i) { return compare(a, arrB[i]); });
	    }
	}
	exports.arraysEqual = arraysEqual;
	/**
	 * Shallow comparison between objects. If `keys` is provided, just that subset
	 * of keys will be compared; otherwise, all keys will be compared.
	 */
	function shallowCompareKeys(objA, objB, keys) {
	    // treat `null` and `undefined` as the same
	    if (objA == null && objB == null) {
	        return true;
	    }
	    else if (objA == null || objB == null) {
	        return false;
	    }
	    else if (Array.isArray(objA) || Array.isArray(objB)) {
	        return false;
	    }
	    else if (keys != null) {
	        return _shallowCompareKeys(objA, objB, keys);
	    }
	    else {
	        // shallowly compare all keys from both objects
	        var keysA = Object.keys(objA);
	        var keysB = Object.keys(objB);
	        return (_shallowCompareKeys(objA, objB, { include: keysA }) && _shallowCompareKeys(objA, objB, { include: keysB }));
	    }
	}
	exports.shallowCompareKeys = shallowCompareKeys;
	/**
	 * Deep comparison between objects. If `keys` is provided, just that subset of
	 * keys will be compared; otherwise, all keys will be compared.
	 */
	function deepCompareKeys(objA, objB, keys) {
	    if (objA === objB) {
	        return true;
	    }
	    else if (objA == null && objB == null) {
	        // treat `null` and `undefined` as the same
	        return true;
	    }
	    else if (objA == null || objB == null) {
	        return false;
	    }
	    else if (Array.isArray(objA) || Array.isArray(objB)) {
	        return arraysEqual(objA, objB, deepCompareKeys);
	    }
	    else if (_isSimplePrimitiveType(objA) || _isSimplePrimitiveType(objB)) {
	        return objA === objB;
	    }
	    else if (keys != null) {
	        return _deepCompareKeys(objA, objB, keys);
	    }
	    else if (objA.constructor !== objB.constructor) {
	        return false;
	    }
	    else {
	        var keysA = Object.keys(objA);
	        var keysB = Object.keys(objB);
	        if (keysA == null || keysB == null) {
	            return false;
	        }
	        if (keysA.length === 0 && keysB.length === 0) {
	            return true;
	        }
	        return arraysEqual(keysA, keysB) && _deepCompareKeys(objA, objB, keysA);
	    }
	}
	exports.deepCompareKeys = deepCompareKeys;
	/**
	 * Returns a descriptive object for each key whose values are shallowly unequal
	 * between two provided objects. Useful for debugging shouldComponentUpdate.
	 */
	function getShallowUnequalKeyValues(objA, objB, keys) {
	    // default param values let null values pass through, so we have to take
	    // this more thorough approach
	    var definedObjA = objA == null ? {} : objA;
	    var definedObjB = objB == null ? {} : objB;
	    var filteredKeys = _filterKeys(definedObjA, definedObjB, keys == null ? { exclude: [] } : keys);
	    return _getUnequalKeyValues(definedObjA, definedObjB, filteredKeys, function (a, b, key) {
	        return shallowCompareKeys(a, b, { include: [key] });
	    });
	}
	exports.getShallowUnequalKeyValues = getShallowUnequalKeyValues;
	/**
	 * Returns a descriptive object for each key whose values are deeply unequal
	 * between two provided objects. Useful for debugging shouldComponentUpdate.
	 */
	function getDeepUnequalKeyValues(objA, objB, keys) {
	    if (objA === void 0) { objA = {}; }
	    if (objB === void 0) { objB = {}; }
	    var filteredKeys = keys == null ? _unionKeys(objA, objB) : keys;
	    return _getUnequalKeyValues(objA, objB, filteredKeys, function (a, b, key) {
	        return deepCompareKeys(a, b, [key]);
	    });
	}
	exports.getDeepUnequalKeyValues = getDeepUnequalKeyValues;
	// Private helpers
	// ===============
	/**
	 * Partial shallow comparison between objects using the given list of keys.
	 */
	function _shallowCompareKeys(objA, objB, keys) {
	    return _filterKeys(objA, objB, keys).every(function (key) {
	        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
	    });
	}
	/**
	 * Partial deep comparison between objects using the given list of keys.
	 */
	function _deepCompareKeys(objA, objB, keys) {
	    return keys.every(function (key) {
	        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && deepCompareKeys(objA[key], objB[key]);
	    });
	}
	function _isSimplePrimitiveType(value) {
	    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
	}
	function _filterKeys(objA, objB, keys) {
	    if (_isWhitelist(keys)) {
	        return keys.include;
	    }
	    else {
	        var keysA = Object.keys(objA);
	        var keysB = Object.keys(objB);
	        // merge keys from both objects into a big set for quick access
	        var keySet_1 = _arrayToObject(keysA.concat(keysB));
	        // delete blacklisted keys from the key set
	        keys.exclude.forEach(function (key) { return delete keySet_1[key]; });
	        // return the remaining keys as an array
	        return Object.keys(keySet_1);
	    }
	}
	function _isWhitelist(keys) {
	    return keys != null && keys.include != null;
	}
	function _arrayToObject(arr) {
	    return arr.reduce(function (obj, element) {
	        obj[element] = true;
	        return obj;
	    }, {});
	}
	function _getUnequalKeyValues(objA, objB, keys, compareFn) {
	    var unequalKeys = keys.filter(function (key) { return !compareFn(objA, objB, key); });
	    var unequalKeyValues = unequalKeys.map(function (key) { return ({
	        key: key,
	        valueA: objA[key],
	        valueB: objB[key],
	    }); });
	    return unequalKeyValues;
	}
	function _unionKeys(objA, objB) {
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    var concatKeys = keysA.concat(keysB);
	    var keySet = _arrayToObject(concatKeys);
	    return Object.keys(keySet);
	}


/***/ },
/* 722 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
	var browser = {
	    isEdge: !!userAgent.match(/Edge/),
	    isInternetExplorer: !!userAgent.match(/Trident/) || !!userAgent.match(/rv:11/),
	    isWebkit: !!userAgent.match(/AppleWebKit/),
	};
	exports.Browser = {
	    isEdge: function () { return browser.isEdge; },
	    isInternetExplorer: function () { return browser.isInternetExplorer; },
	    isWebkit: function () { return browser.isWebkit; },
	};


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	tslib_1.__exportStar(__webpack_require__(722), exports);


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var errors_1 = __webpack_require__(48);
	var buttons_1 = __webpack_require__(221);
	var dialog_1 = __webpack_require__(437);
	var icon_1 = __webpack_require__(104);
	var Alert = (function (_super) {
	    tslib_1.__extends(Alert, _super);
	    function Alert() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Alert.prototype.render = function () {
	        var _a = this.props, children = _a.children, className = _a.className, iconName = _a.iconName, intent = _a.intent, isOpen = _a.isOpen, confirmButtonText = _a.confirmButtonText, onConfirm = _a.onConfirm, style = _a.style;
	        return (React.createElement(dialog_1.Dialog, { className: classNames(common_1.Classes.ALERT, className), isOpen: isOpen, style: style },
	            React.createElement("div", { className: common_1.Classes.ALERT_BODY },
	                React.createElement(icon_1.Icon, { iconName: iconName, iconSize: "inherit", intent: common_1.Intent.DANGER }),
	                React.createElement("div", { className: common_1.Classes.ALERT_CONTENTS }, children)),
	            React.createElement("div", { className: common_1.Classes.ALERT_FOOTER },
	                React.createElement(buttons_1.Button, { intent: intent, text: confirmButtonText, onClick: onConfirm }),
	                this.maybeRenderSecondaryAction())));
	    };
	    Alert.prototype.validateProps = function (props) {
	        if ((props.cancelButtonText != null && props.onCancel == null) ||
	            (props.cancelButtonText == null && props.onCancel != null)) {
	            console.warn(errors_1.ALERT_WARN_CANCEL_PROPS);
	        }
	    };
	    Alert.prototype.maybeRenderSecondaryAction = function () {
	        if (this.props.cancelButtonText != null) {
	            return React.createElement(buttons_1.Button, { text: this.props.cancelButtonText, onClick: this.props.onCancel });
	        }
	        return undefined;
	    };
	    Alert.defaultProps = {
	        confirmButtonText: "OK",
	        isOpen: false,
	        onConfirm: null,
	    };
	    Alert.displayName = "Blueprint.Alert";
	    return Alert;
	}(common_1.AbstractComponent));
	exports.Alert = Alert;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	exports.Breadcrumb = function (breadcrumbProps) {
	    var classes = classNames(Classes.BREADCRUMB, (_a = {},
	        _a[Classes.DISABLED] = breadcrumbProps.disabled,
	        _a), breadcrumbProps.className);
	    return (React.createElement("a", { className: classes, href: breadcrumbProps.href, onClick: breadcrumbProps.disabled ? null : breadcrumbProps.onClick, tabIndex: breadcrumbProps.disabled ? null : 0, target: breadcrumbProps.target }, breadcrumbProps.text));
	    var _a;
	};


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Keys = __webpack_require__(103);
	var utils_1 = __webpack_require__(21);
	var icon_1 = __webpack_require__(104);
	var spinner_1 = __webpack_require__(306);
	var AbstractButton = (function (_super) {
	    tslib_1.__extends(AbstractButton, _super);
	    function AbstractButton() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            isActive: false,
	        };
	        _this.refHandlers = {
	            button: function (ref) {
	                _this.buttonRef = ref;
	                utils_1.safeInvoke(_this.props.elementRef, ref);
	            },
	        };
	        _this.currentKeyDown = null;
	        // we're casting as `any` to get around a somewhat opaque safeInvoke error
	        // that "Type argument candidate 'KeyboardEvent<T>' is not a valid type
	        // argument because it is not a supertype of candidate
	        // 'KeyboardEvent<HTMLElement>'."
	        _this.handleKeyDown = function (e) {
	            if (isKeyboardClick(e.which)) {
	                e.preventDefault();
	                if (e.which !== _this.currentKeyDown) {
	                    _this.setState({ isActive: true });
	                }
	            }
	            _this.currentKeyDown = e.which;
	            utils_1.safeInvoke(_this.props.onKeyDown, e);
	        };
	        _this.handleKeyUp = function (e) {
	            if (isKeyboardClick(e.which)) {
	                _this.setState({ isActive: false });
	                _this.buttonRef.click();
	            }
	            _this.currentKeyDown = null;
	            utils_1.safeInvoke(_this.props.onKeyUp, e);
	        };
	        return _this;
	    }
	    AbstractButton.prototype.getCommonButtonProps = function () {
	        var disabled = this.props.disabled || this.props.loading;
	        var className = classNames(Classes.BUTTON, (_a = {},
	            _a[Classes.ACTIVE] = this.state.isActive || this.props.active,
	            _a[Classes.DISABLED] = disabled,
	            _a[Classes.LOADING] = this.props.loading,
	            _a), Classes.iconClass(this.props.iconName), Classes.intentClass(this.props.intent), this.props.className);
	        return {
	            className: className,
	            disabled: disabled,
	            onClick: disabled ? undefined : this.props.onClick,
	            onKeyDown: this.handleKeyDown,
	            onKeyUp: this.handleKeyUp,
	            ref: this.refHandlers.button,
	        };
	        var _a;
	    };
	    AbstractButton.prototype.renderChildren = function () {
	        var _a = this.props, loading = _a.loading, rightIconName = _a.rightIconName, text = _a.text;
	        var children = React.Children.map(this.props.children, function (child, index) {
	            if (child === "") {
	                // render as undefined to avoid extra space after icon
	                return undefined;
	            }
	            else if (typeof child === "string") {
	                // must wrap string children in spans so loading prop can hide them
	                return React.createElement("span", { key: "text-" + index }, child);
	            }
	            return child;
	        });
	        return [
	            loading ? React.createElement(spinner_1.Spinner, { className: "pt-small pt-button-spinner", key: "spinner" }) : undefined,
	            text != null ? React.createElement("span", { key: "text" }, text) : undefined
	        ].concat(children, [
	            React.createElement(icon_1.Icon, { className: Classes.ALIGN_RIGHT, iconName: rightIconName, key: "icon" }),
	        ]);
	    };
	    return AbstractButton;
	}(React.Component));
	exports.AbstractButton = AbstractButton;
	function isKeyboardClick(keyCode) {
	    return keyCode === Keys.ENTER || keyCode === Keys.SPACE;
	}


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	// this component is simple enough that tests would be purely tautological.
	/* istanbul ignore next */
	var ButtonGroup = (function (_super) {
	    tslib_1.__extends(ButtonGroup, _super);
	    function ButtonGroup() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ButtonGroup.prototype.render = function () {
	        var _a = this.props, className = _a.className, fill = _a.fill, minimal = _a.minimal, large = _a.large, vertical = _a.vertical, htmlProps = tslib_1.__rest(_a, ["className", "fill", "minimal", "large", "vertical"]);
	        var buttonGroupClasses = classNames(Classes.BUTTON_GROUP, (_b = {},
	            _b[Classes.FILL] = fill,
	            _b[Classes.MINIMAL] = minimal,
	            _b[Classes.LARGE] = large,
	            _b[Classes.VERTICAL] = vertical,
	            _b), className);
	        return (React.createElement("div", tslib_1.__assign({}, htmlProps, { className: buttonGroupClasses }), this.props.children));
	        var _b;
	    };
	    ButtonGroup.displayName = "Blueprint.ButtonGroup";
	    ButtonGroup = tslib_1.__decorate([
	        PureRender
	    ], ButtonGroup);
	    return ButtonGroup;
	}(React.Component));
	exports.ButtonGroup = ButtonGroup;


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var Callout = (function (_super) {
	    tslib_1.__extends(Callout, _super);
	    function Callout() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Callout.prototype.render = function () {
	        var _a = this.props, className = _a.className, children = _a.children, iconName = _a.iconName, intent = _a.intent, title = _a.title, htmlProps = tslib_1.__rest(_a, ["className", "children", "iconName", "intent", "title"]);
	        var classes = classNames(common_1.Classes.CALLOUT, common_1.Classes.intentClass(intent), common_1.Classes.iconClass(iconName), className);
	        return (React.createElement("div", tslib_1.__assign({ className: classes }, htmlProps),
	            title && React.createElement("h5", null, title),
	            children));
	    };
	    Callout = tslib_1.__decorate([
	        PureRender
	    ], Callout);
	    return Callout;
	}(React.Component));
	exports.Callout = Callout;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Elevation;
	(function (Elevation) {
	    Elevation[Elevation["ZERO"] = 0] = "ZERO";
	    Elevation[Elevation["ONE"] = 1] = "ONE";
	    Elevation[Elevation["TWO"] = 2] = "TWO";
	    Elevation[Elevation["THREE"] = 3] = "THREE";
	    Elevation[Elevation["FOUR"] = 4] = "FOUR";
	})(Elevation = exports.Elevation || (exports.Elevation = {}));
	var ELEVATION_CLASSES = [
	    Classes.ELEVATION_0,
	    Classes.ELEVATION_1,
	    Classes.ELEVATION_2,
	    Classes.ELEVATION_3,
	    Classes.ELEVATION_4,
	];
	var Card = (function (_super) {
	    tslib_1.__extends(Card, _super);
	    function Card() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Card.prototype.render = function () {
	        return (React.createElement("div", { className: this.getClassName(), onClick: this.props.onClick }, this.props.children));
	    };
	    Card.prototype.getClassName = function () {
	        var _a = this.props, elevation = _a.elevation, interactive = _a.interactive, className = _a.className;
	        return classNames(Classes.CARD, (_b = {}, _b[Classes.INTERACTIVE] = interactive, _b), ELEVATION_CLASSES[elevation], className);
	        var _b;
	    };
	    Card.displayName = "Blueprint.Card";
	    Card.defaultProps = {
	        elevation: Elevation.ZERO,
	        interactive: false,
	    };
	    Card = tslib_1.__decorate([
	        PureRender
	    ], Card);
	    return Card;
	}(React.Component));
	exports.Card = Card;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var position_1 = __webpack_require__(88);
	var menu_1 = __webpack_require__(305);
	var menuItem_1 = __webpack_require__(444);
	var popover_1 = __webpack_require__(148);
	var CollapseFrom;
	(function (CollapseFrom) {
	    CollapseFrom[CollapseFrom["START"] = 0] = "START";
	    CollapseFrom[CollapseFrom["END"] = 1] = "END";
	})(CollapseFrom = exports.CollapseFrom || (exports.CollapseFrom = {}));
	var CollapsibleList = (function (_super) {
	    tslib_1.__extends(CollapsibleList, _super);
	    function CollapsibleList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CollapsibleList.prototype.render = function () {
	        var _this = this;
	        var collapseFrom = this.props.collapseFrom;
	        var childrenLength = React.Children.count(this.props.children);
	        var _a = this.partitionChildren(), visibleChildren = _a[0], collapsedChildren = _a[1];
	        var visibleItems = visibleChildren.map(function (child, index) {
	            var absoluteIndex = collapseFrom === CollapseFrom.START ? childrenLength - 1 - index : index;
	            return (React.createElement("li", { className: _this.props.visibleItemClassName, key: absoluteIndex }, _this.props.renderVisibleItem(child.props, absoluteIndex)));
	        });
	        if (collapseFrom === CollapseFrom.START) {
	            // reverse START list so separators appear before items
	            visibleItems.reverse();
	        }
	        // construct dropdown menu for collapsed items
	        var collapsedPopover;
	        if (collapsedChildren.length > 0) {
	            var position = collapseFrom === CollapseFrom.END ? position_1.Position.BOTTOM_RIGHT : position_1.Position.BOTTOM_LEFT;
	            collapsedPopover = (React.createElement("li", { className: this.props.visibleItemClassName },
	                React.createElement(popover_1.Popover, tslib_1.__assign({ content: React.createElement(menu_1.Menu, null, collapsedChildren), position: position }, this.props.dropdownProps), this.props.dropdownTarget)));
	        }
	        return (React.createElement("ul", { className: classNames(Classes.COLLAPSIBLE_LIST, this.props.className) },
	            collapseFrom === CollapseFrom.START ? collapsedPopover : null,
	            visibleItems,
	            collapseFrom === CollapseFrom.END ? collapsedPopover : null));
	    };
	    // splits the list of children into two arrays: visible and collapsed
	    CollapsibleList.prototype.partitionChildren = function () {
	        if (this.props.children == null) {
	            return [[], []];
	        }
	        var childrenArray = React.Children.map(this.props.children, function (child, index) {
	            if (child.type !== menuItem_1.MenuItem) {
	                throw new Error(Errors.COLLAPSIBLE_LIST_INVALID_CHILD);
	            }
	            return React.cloneElement(child, { key: "visible-" + index });
	        });
	        if (this.props.collapseFrom === CollapseFrom.START) {
	            // reverse START list so we can always slice visible items from the front of the list
	            childrenArray.reverse();
	        }
	        var visibleItemCount = this.props.visibleItemCount;
	        return [childrenArray.slice(0, visibleItemCount), childrenArray.slice(visibleItemCount)];
	    };
	    CollapsibleList.displayName = "Blueprint.CollapsibleList";
	    CollapsibleList.defaultProps = {
	        collapseFrom: CollapseFrom.START,
	        dropdownTarget: null,
	        renderVisibleItem: null,
	        visibleItemCount: 3,
	    };
	    return CollapsibleList;
	}(React.Component));
	exports.CollapsibleList = CollapsibleList;
	exports.CollapsibleListFactory = React.createFactory(CollapsibleList);


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var errors_1 = __webpack_require__(48);
	var utils_1 = __webpack_require__(21);
	var isDarkTheme_1 = __webpack_require__(434);
	var ContextMenu = __webpack_require__(436);
	function ContextMenuTarget(constructor) {
	    var _a = constructor.prototype, render = _a.render, renderContextMenu = _a.renderContextMenu, onContextMenuClose = _a.onContextMenuClose;
	    if (!utils_1.isFunction(renderContextMenu)) {
	        console.warn(errors_1.CONTEXTMENU_WARN_DECORATOR_NO_METHOD);
	    }
	    // patching classes like this requires preserving function context
	    // tslint:disable-next-line only-arrow-functions
	    constructor.prototype.render = function () {
	        var _this = this;
	        /* tslint:disable:no-invalid-this */
	        var element = render.call(this);
	        if (element == null) {
	            // always return `element` in case caller is distinguishing between `null` and `undefined`
	            return element;
	        }
	        var oldOnContextMenu = element.props.onContextMenu;
	        var onContextMenu = function (e) {
	            // support nested menus (inner menu target would have called preventDefault())
	            if (e.defaultPrevented) {
	                return;
	            }
	            if (utils_1.isFunction(_this.renderContextMenu)) {
	                var menu = _this.renderContextMenu(e);
	                if (menu != null) {
	                    var htmlElement = ReactDOM.findDOMNode(_this);
	                    var darkTheme = htmlElement != null && isDarkTheme_1.isDarkTheme(htmlElement);
	                    e.preventDefault();
	                    ContextMenu.show(menu, { left: e.clientX, top: e.clientY }, onContextMenuClose, darkTheme);
	                }
	            }
	            utils_1.safeInvoke(oldOnContextMenu, e);
	        };
	        return React.cloneElement(element, { onContextMenu: onContextMenu });
	        /* tslint:enable:no-invalid-this */
	    };
	}
	exports.ContextMenuTarget = ContextMenuTarget;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Keys = __webpack_require__(103);
	var utils_1 = __webpack_require__(21);
	var compatibility_1 = __webpack_require__(723);
	var BUFFER_WIDTH_EDGE = 5;
	var BUFFER_WIDTH_IE = 30;
	var EditableText = (function (_super) {
	    tslib_1.__extends(EditableText, _super);
	    function EditableText(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.refHandlers = {
	            content: function (spanElement) {
	                _this.valueElement = spanElement;
	            },
	            input: function (input) {
	                if (input != null) {
	                    input.focus();
	                    var length_1 = input.value.length;
	                    input.setSelectionRange(_this.props.selectAllOnFocus ? 0 : length_1, length_1);
	                    if (!_this.props.selectAllOnFocus) {
	                        input.scrollLeft = input.scrollWidth;
	                    }
	                }
	            },
	        };
	        _this.cancelEditing = function () {
	            var _a = _this.state, lastValue = _a.lastValue, value = _a.value;
	            _this.setState({ isEditing: false, value: lastValue });
	            if (value !== lastValue) {
	                utils_1.safeInvoke(_this.props.onChange, lastValue);
	            }
	            utils_1.safeInvoke(_this.props.onCancel, lastValue);
	        };
	        _this.toggleEditing = function () {
	            if (_this.state.isEditing) {
	                var value = _this.state.value;
	                _this.setState({ isEditing: false, lastValue: value });
	                utils_1.safeInvoke(_this.props.onConfirm, value);
	            }
	            else if (!_this.props.disabled) {
	                _this.setState({ isEditing: true });
	            }
	        };
	        _this.handleFocus = function () {
	            if (!_this.props.disabled) {
	                _this.setState({ isEditing: true });
	            }
	        };
	        _this.handleTextChange = function (event) {
	            var value = event.target.value;
	            // state value should be updated only when uncontrolled
	            if (_this.props.value == null) {
	                _this.setState({ value: value });
	            }
	            utils_1.safeInvoke(_this.props.onChange, value);
	        };
	        _this.handleKeyEvent = function (event) {
	            var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, which = event.which;
	            if (which === Keys.ESCAPE) {
	                _this.cancelEditing();
	                return;
	            }
	            var hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
	            if (which === Keys.ENTER) {
	                // prevent IE11 from full screening with alt + enter
	                // shift + enter adds a newline by default
	                if (altKey || shiftKey) {
	                    event.preventDefault();
	                }
	                if (_this.props.confirmOnEnterKey && _this.props.multiline) {
	                    if (event.target != null && hasModifierKey) {
	                        insertAtCaret(event.target, "\n");
	                        _this.handleTextChange(event);
	                    }
	                    else {
	                        _this.toggleEditing();
	                    }
	                }
	                else if (!_this.props.multiline || hasModifierKey) {
	                    _this.toggleEditing();
	                }
	            }
	        };
	        var value = props.value == null ? props.defaultValue : props.value;
	        _this.state = {
	            inputHeight: 0,
	            inputWidth: 0,
	            isEditing: props.isEditing === true && props.disabled === false,
	            lastValue: value,
	            value: value,
	        };
	        return _this;
	    }
	    EditableText.prototype.render = function () {
	        var _a = this.props, disabled = _a.disabled, multiline = _a.multiline;
	        var value = this.props.value == null ? this.state.value : this.props.value;
	        var hasValue = value != null && value !== "";
	        var classes = classNames(Classes.EDITABLE_TEXT, Classes.intentClass(this.props.intent), (_b = {},
	            _b[Classes.DISABLED] = disabled,
	            _b["pt-editable-editing"] = this.state.isEditing,
	            _b["pt-editable-placeholder"] = !hasValue,
	            _b["pt-multiline"] = multiline,
	            _b), this.props.className);
	        var contentStyle;
	        if (multiline) {
	            // set height only in multiline mode when not editing
	            // otherwise we're measuring this element to determine appropriate height of text
	            contentStyle = { height: !this.state.isEditing ? this.state.inputHeight : null };
	        }
	        else {
	            // minWidth only applies in single line mode (multiline == width 100%)
	            contentStyle = {
	                height: this.state.inputHeight,
	                lineHeight: this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
	                minWidth: this.props.minWidth,
	            };
	        }
	        // make enclosing div focusable when not editing, so it can still be tabbed to focus
	        // (when editing, input itself is focusable so div doesn't need to be)
	        var tabIndex = this.state.isEditing || disabled ? null : 0;
	        return (React.createElement("div", { className: classes, onFocus: this.handleFocus, tabIndex: tabIndex },
	            this.maybeRenderInput(value),
	            React.createElement("span", { className: "pt-editable-content", ref: this.refHandlers.content, style: contentStyle }, hasValue ? value : this.props.placeholder)));
	        var _b;
	    };
	    EditableText.prototype.componentDidMount = function () {
	        this.updateInputDimensions();
	    };
	    EditableText.prototype.componentDidUpdate = function (_, prevState) {
	        if (this.state.isEditing && !prevState.isEditing) {
	            utils_1.safeInvoke(this.props.onEdit);
	        }
	        this.updateInputDimensions();
	    };
	    EditableText.prototype.componentWillReceiveProps = function (nextProps) {
	        var state = {};
	        if (nextProps.value != null) {
	            state.value = nextProps.value;
	        }
	        if (nextProps.isEditing != null) {
	            state.isEditing = nextProps.isEditing;
	        }
	        if (nextProps.disabled || (nextProps.disabled == null && this.props.disabled)) {
	            state.isEditing = false;
	        }
	        this.setState(state);
	    };
	    EditableText.prototype.maybeRenderInput = function (value) {
	        var _a = this.props, maxLength = _a.maxLength, multiline = _a.multiline;
	        if (!this.state.isEditing) {
	            return undefined;
	        }
	        var props = {
	            className: "pt-editable-input",
	            maxLength: maxLength,
	            onBlur: this.toggleEditing,
	            onChange: this.handleTextChange,
	            onKeyDown: this.handleKeyEvent,
	            ref: this.refHandlers.input,
	            style: {
	                height: this.state.inputHeight,
	                lineHeight: !multiline && this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
	                width: multiline ? "100%" : this.state.inputWidth,
	            },
	            value: value,
	        };
	        return multiline ? React.createElement("textarea", tslib_1.__assign({}, props)) : React.createElement("input", tslib_1.__assign({ type: "text" }, props));
	    };
	    EditableText.prototype.updateInputDimensions = function () {
	        if (this.valueElement != null) {
	            var _a = this.props, maxLines = _a.maxLines, minLines = _a.minLines, minWidth = _a.minWidth, multiline = _a.multiline;
	            var _b = this.valueElement, parentElement_1 = _b.parentElement, textContent = _b.textContent;
	            var _c = this.valueElement, scrollHeight_1 = _c.scrollHeight, scrollWidth = _c.scrollWidth;
	            var lineHeight = getLineHeight(this.valueElement);
	            // add one line to computed <span> height if text ends in newline
	            // because <span> collapses that trailing whitespace but <textarea> shows it
	            if (multiline && this.state.isEditing && /\n$/.test(textContent)) {
	                scrollHeight_1 += lineHeight;
	            }
	            if (lineHeight > 0) {
	                // line height could be 0 if the isNaN block from getLineHeight kicks in
	                scrollHeight_1 = utils_1.clamp(scrollHeight_1, minLines * lineHeight, maxLines * lineHeight);
	            }
	            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
	            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
	            scrollHeight_1 = Math.max(scrollHeight_1, getFontSize(this.valueElement) + 1, getLineHeight(parentElement_1));
	            // IE11 & Edge needs a small buffer so text does not shift prior to resizing
	            if (compatibility_1.Browser.isEdge()) {
	                scrollWidth += BUFFER_WIDTH_EDGE;
	            }
	            else if (compatibility_1.Browser.isInternetExplorer()) {
	                scrollWidth += BUFFER_WIDTH_IE;
	            }
	            this.setState({
	                inputHeight: scrollHeight_1,
	                inputWidth: Math.max(scrollWidth, minWidth),
	            });
	            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
	            if (multiline && this.state.isEditing) {
	                this.setTimeout(function () { return (parentElement_1.style.height = scrollHeight_1 + "px"); });
	            }
	        }
	    };
	    EditableText.defaultProps = {
	        confirmOnEnterKey: false,
	        defaultValue: "",
	        disabled: false,
	        maxLines: Infinity,
	        minLines: 1,
	        minWidth: 80,
	        multiline: false,
	        placeholder: "Click to Edit",
	    };
	    EditableText = tslib_1.__decorate([
	        PureRender
	    ], EditableText);
	    return EditableText;
	}(abstractComponent_1.AbstractComponent));
	exports.EditableText = EditableText;
	function getFontSize(element) {
	    var fontSize = getComputedStyle(element).fontSize;
	    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
	}
	function getLineHeight(element) {
	    // getComputedStyle() => 18.0001px => 18
	    var lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
	    // this check will be true if line-height is a keyword like "normal"
	    if (isNaN(lineHeight)) {
	        // @see http://stackoverflow.com/a/18430767/6342931
	        var line = document.createElement("span");
	        line.innerHTML = "<br>";
	        element.appendChild(line);
	        var singleLineHeight = element.offsetHeight;
	        line.innerHTML = "<br><br>";
	        var doubleLineHeight = element.offsetHeight;
	        element.removeChild(line);
	        // this can return 0 in edge cases
	        lineHeight = doubleLineHeight - singleLineHeight;
	    }
	    return lineHeight;
	}
	function insertAtCaret(el, text) {
	    var selectionEnd = el.selectionEnd, selectionStart = el.selectionStart, value = el.value;
	    if (selectionStart >= 0) {
	        var before_1 = value.substring(0, selectionStart);
	        var after_1 = value.substring(selectionEnd, value.length);
	        var len = text.length;
	        el.value = "" + before_1 + text + after_1;
	        el.selectionStart = selectionStart + len;
	        el.selectionEnd = selectionStart + len;
	    }
	}
	exports.EditableTextFactory = React.createFactory(EditableText);


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var FormGroup = (function (_super) {
	    tslib_1.__extends(FormGroup, _super);
	    function FormGroup() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FormGroup_1 = FormGroup;
	    FormGroup.prototype.render = function () {
	        var _a = this.props, children = _a.children, label = _a.label, labelFor = _a.labelFor;
	        return (React.createElement("div", { className: this.getClassName() },
	            React.createElement("label", { className: Classes.LABEL, htmlFor: labelFor },
	                label,
	                this.maybeRenderRequiredLabel()),
	            React.createElement("div", { className: Classes.FORM_CONTENT },
	                children,
	                this.maybeRenderHelperText())));
	    };
	    FormGroup.prototype.getClassName = function () {
	        var _a = this.props, className = _a.className, disabled = _a.disabled, inline = _a.inline, intent = _a.intent;
	        return classNames(Classes.FORM_GROUP, Classes.intentClass(intent), (_b = {},
	            _b[Classes.DISABLED] = disabled,
	            _b[Classes.INLINE] = inline,
	            _b), className);
	        var _b;
	    };
	    FormGroup.prototype.maybeRenderRequiredLabel = function () {
	        var requiredLabel = this.props.requiredLabel;
	        return requiredLabel === true ? FormGroup_1.DEFAULT_REQUIRED_CONTENT : requiredLabel;
	    };
	    FormGroup.prototype.maybeRenderHelperText = function () {
	        var helperText = this.props.helperText;
	        if (!helperText) {
	            return null;
	        }
	        return React.createElement("div", { className: Classes.FORM_HELPER_TEXT }, helperText);
	    };
	    /**
	     * Element used to render `required` message when a boolean value is provided for that prop.
	     * Modifying the value of this property will change the default globally in your app.
	     *
	     * Defaults to `<span class="pt-text-muted">(required)</span>`.
	     */
	    FormGroup.DEFAULT_REQUIRED_CONTENT = React.createElement("span", { className: Classes.TEXT_MUTED }, "(required)");
	    FormGroup = FormGroup_1 = tslib_1.__decorate([
	        PureRender
	    ], FormGroup);
	    return FormGroup;
	    var FormGroup_1;
	}(React.Component));
	exports.FormGroup = FormGroup;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var Errors = __webpack_require__(48);
	var buttons_1 = __webpack_require__(221);
	var inputGroup_1 = __webpack_require__(439);
	var IncrementDirection;
	(function (IncrementDirection) {
	    IncrementDirection[IncrementDirection["DOWN"] = -1] = "DOWN";
	    IncrementDirection[IncrementDirection["UP"] = 1] = "UP";
	})(IncrementDirection || (IncrementDirection = {}));
	var NumericInput = (function (_super) {
	    tslib_1.__extends(NumericInput, _super);
	    function NumericInput(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        // updating these flags need not trigger re-renders, so don't include them in this.state.
	        _this.didPasteEventJustOccur = false;
	        _this.shouldSelectAfterUpdate = false;
	        _this.inputRef = function (input) {
	            _this.inputElement = input;
	        };
	        // Callbacks - Buttons
	        // ===================
	        _this.handleDecrementButtonClick = function (e) {
	            var delta = _this.getIncrementDelta(IncrementDirection.DOWN, e.shiftKey, e.altKey);
	            var nextValue = _this.incrementValue(delta);
	            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
	        };
	        _this.handleIncrementButtonClick = function (e) {
	            var delta = _this.getIncrementDelta(IncrementDirection.UP, e.shiftKey, e.altKey);
	            var nextValue = _this.incrementValue(delta);
	            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
	        };
	        _this.handleButtonFocus = function () {
	            _this.setState({ isButtonGroupFocused: true });
	        };
	        _this.handleButtonBlur = function () {
	            _this.setState({ isButtonGroupFocused: false });
	        };
	        _this.handleButtonKeyUp = function (e, onClick) {
	            if (e.keyCode === common_1.Keys.SPACE || e.keyCode === common_1.Keys.ENTER) {
	                // prevent the page from scrolling (this is the default browser
	                // behavior for shift + space or alt + space).
	                e.preventDefault();
	                // trigger a click event to update the input value appropriately,
	                // based on the active modifier keys.
	                var fakeClickEvent = {
	                    altKey: e.altKey,
	                    currentTarget: e.currentTarget,
	                    shiftKey: e.shiftKey,
	                    target: e.target,
	                };
	                onClick(fakeClickEvent);
	            }
	        };
	        // Callbacks - Input
	        // =================
	        _this.handleInputFocus = function (e) {
	            _this.shouldSelectAfterUpdate = _this.props.selectAllOnFocus;
	            _this.setState({ isInputGroupFocused: true });
	            common_1.Utils.safeInvoke(_this.props.onFocus, e);
	        };
	        _this.handleInputBlur = function (e) {
	            // explicitly set `shouldSelectAfterUpdate` to `false` to prevent focus
	            // hoarding on IE11 (#704)
	            _this.shouldSelectAfterUpdate = false;
	            var baseStateChange = { isInputGroupFocused: false };
	            if (_this.props.clampValueOnBlur) {
	                var value = e.target.value;
	                var sanitizedValue = _this.getSanitizedValue(value);
	                _this.setState(tslib_1.__assign({}, baseStateChange, { value: sanitizedValue }));
	                if (value !== sanitizedValue) {
	                    _this.invokeValueCallback(sanitizedValue, _this.props.onValueChange);
	                }
	            }
	            else {
	                _this.setState(baseStateChange);
	            }
	            common_1.Utils.safeInvoke(_this.props.onBlur, e);
	        };
	        _this.handleInputKeyDown = function (e) {
	            if (_this.props.disabled || _this.props.readOnly) {
	                return;
	            }
	            var keyCode = e.keyCode;
	            var direction;
	            if (keyCode === common_1.Keys.ARROW_UP) {
	                direction = IncrementDirection.UP;
	            }
	            else if (keyCode === common_1.Keys.ARROW_DOWN) {
	                direction = IncrementDirection.DOWN;
	            }
	            if (direction != null) {
	                // when the input field has focus, some key combinations will modify
	                // the field's selection range. we'll actually want to select all
	                // text in the field after we modify the value on the following
	                // lines. preventing the default selection behavior lets us do that
	                // without interference.
	                e.preventDefault();
	                var delta = _this.getIncrementDelta(direction, e.shiftKey, e.altKey);
	                _this.incrementValue(delta);
	            }
	            common_1.Utils.safeInvoke(_this.props.onKeyDown, e);
	        };
	        _this.handleInputKeyPress = function (e) {
	            // we prohibit keystrokes in onKeyPress instead of onKeyDown, because
	            // e.key is not trustworthy in onKeyDown in all browsers.
	            if (_this.props.allowNumericCharactersOnly && _this.isKeyboardEventDisabledForBasicNumericEntry(e)) {
	                e.preventDefault();
	            }
	            common_1.Utils.safeInvoke(_this.props.onKeyPress, e);
	        };
	        _this.handleInputPaste = function (e) {
	            _this.didPasteEventJustOccur = true;
	            common_1.Utils.safeInvoke(_this.props.onPaste, e);
	        };
	        _this.handleInputChange = function (e) {
	            var value = e.target.value;
	            var nextValue;
	            if (_this.props.allowNumericCharactersOnly && _this.didPasteEventJustOccur) {
	                _this.didPasteEventJustOccur = false;
	                var valueChars = value.split("");
	                var sanitizedValueChars = valueChars.filter(_this.isFloatingPointNumericCharacter);
	                var sanitizedValue = sanitizedValueChars.join("");
	                nextValue = sanitizedValue;
	            }
	            else {
	                nextValue = value;
	            }
	            _this.shouldSelectAfterUpdate = false;
	            _this.setState({ value: nextValue });
	            _this.invokeValueCallback(nextValue, _this.props.onValueChange);
	        };
	        _this.state = {
	            stepMaxPrecision: _this.getStepMaxPrecision(props),
	            value: _this.getValueOrEmptyValue(props.value),
	        };
	        return _this;
	    }
	    NumericInput_1 = NumericInput;
	    NumericInput.prototype.componentWillReceiveProps = function (nextProps) {
	        _super.prototype.componentWillReceiveProps.call(this, nextProps);
	        var value = this.getValueOrEmptyValue(nextProps.value);
	        var didMinChange = nextProps.min !== this.props.min;
	        var didMaxChange = nextProps.max !== this.props.max;
	        var didBoundsChange = didMinChange || didMaxChange;
	        var sanitizedValue = value !== NumericInput_1.VALUE_EMPTY
	            ? this.getSanitizedValue(value, /* delta */ 0, nextProps.min, nextProps.max)
	            : NumericInput_1.VALUE_EMPTY;
	        var stepMaxPrecision = this.getStepMaxPrecision(nextProps);
	        // if a new min and max were provided that cause the existing value to fall
	        // outside of the new bounds, then clamp the value to the new valid range.
	        if (didBoundsChange && sanitizedValue !== this.state.value) {
	            this.setState({ stepMaxPrecision: stepMaxPrecision, value: sanitizedValue });
	            this.invokeValueCallback(sanitizedValue, this.props.onValueChange);
	        }
	        else {
	            this.setState({ stepMaxPrecision: stepMaxPrecision, value: value });
	        }
	    };
	    NumericInput.prototype.render = function () {
	        var _a = this.props, buttonPosition = _a.buttonPosition, className = _a.className, large = _a.large;
	        var inputGroupHtmlProps = common_1.removeNonHTMLProps(this.props, [
	            "allowNumericCharactersOnly",
	            "buttonPosition",
	            "clampValueOnBlur",
	            "className",
	            "large",
	            "majorStepSize",
	            "minorStepSize",
	            "onButtonClick",
	            "onValueChange",
	            "selectAllOnFocus",
	            "selectAllOnIncrement",
	            "stepSize",
	        ], true);
	        var inputGroup = (React.createElement(inputGroup_1.InputGroup, tslib_1.__assign({ autoComplete: "off" }, inputGroupHtmlProps, { className: classNames((_b = {}, _b[common_1.Classes.LARGE] = large, _b)), intent: this.props.intent, inputRef: this.inputRef, key: "input-group", leftIconName: this.props.leftIconName, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, onKeyPress: this.handleInputKeyPress, onPaste: this.handleInputPaste, value: this.state.value })));
	        // the strict null check here is intentional; an undefined value should
	        // fall back to the default button position on the right side.
	        if (buttonPosition === "none" || buttonPosition === null) {
	            // If there are no buttons, then the control group will render the
	            // text field with squared border-radii on the left side, causing it
	            // to look weird. This problem goes away if we simply don't nest within
	            // a control group.
	            return React.createElement("div", { className: className }, inputGroup);
	        }
	        else {
	            var incrementButton = this.renderButton(NumericInput_1.INCREMENT_KEY, NumericInput_1.INCREMENT_ICON_NAME, this.handleIncrementButtonClick);
	            var decrementButton = this.renderButton(NumericInput_1.DECREMENT_KEY, NumericInput_1.DECREMENT_ICON_NAME, this.handleDecrementButtonClick);
	            var buttonGroup = (React.createElement("div", { key: "button-group", className: classNames(common_1.Classes.BUTTON_GROUP, common_1.Classes.VERTICAL, common_1.Classes.FIXED) },
	                incrementButton,
	                decrementButton));
	            var inputElems = buttonPosition === common_1.Position.LEFT ? [buttonGroup, inputGroup] : [inputGroup, buttonGroup];
	            var classes = classNames(common_1.Classes.NUMERIC_INPUT, common_1.Classes.CONTROL_GROUP, (_c = {},
	                _c[common_1.Classes.LARGE] = large,
	                _c), className);
	            return React.createElement("div", { className: classes }, inputElems);
	        }
	        var _b, _c;
	    };
	    NumericInput.prototype.componentDidUpdate = function () {
	        if (this.shouldSelectAfterUpdate) {
	            this.inputElement.setSelectionRange(0, this.state.value.length);
	        }
	    };
	    NumericInput.prototype.validateProps = function (nextProps) {
	        var majorStepSize = nextProps.majorStepSize, max = nextProps.max, min = nextProps.min, minorStepSize = nextProps.minorStepSize, stepSize = nextProps.stepSize;
	        if (min != null && max != null && min >= max) {
	            throw new Error(Errors.NUMERIC_INPUT_MIN_MAX);
	        }
	        if (stepSize == null) {
	            throw new Error(Errors.NUMERIC_INPUT_STEP_SIZE_NULL);
	        }
	        if (stepSize <= 0) {
	            throw new Error(Errors.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE);
	        }
	        if (minorStepSize && minorStepSize <= 0) {
	            throw new Error(Errors.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE);
	        }
	        if (majorStepSize && majorStepSize <= 0) {
	            throw new Error(Errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE);
	        }
	        if (minorStepSize && minorStepSize > stepSize) {
	            throw new Error(Errors.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND);
	        }
	        if (majorStepSize && majorStepSize < stepSize) {
	            throw new Error(Errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND);
	        }
	    };
	    // Render Helpers
	    // ==============
	    NumericInput.prototype.renderButton = function (key, iconName, onClick) {
	        var _this = this;
	        // respond explicitly on key *up*, because onKeyDown triggers multiple
	        // times and doesn't always receive modifier-key flags, leading to an
	        // unintuitive/out-of-control incrementing experience.
	        var onKeyUp = function (e) {
	            _this.handleButtonKeyUp(e, onClick);
	        };
	        return (React.createElement(buttons_1.Button, { disabled: this.props.disabled || this.props.readOnly, iconName: iconName, intent: this.props.intent, key: key, onBlur: this.handleButtonBlur, onClick: onClick, onFocus: this.handleButtonFocus, onKeyUp: onKeyUp }));
	    };
	    NumericInput.prototype.invokeValueCallback = function (value, callback) {
	        common_1.Utils.safeInvoke(callback, +value, value);
	    };
	    // Value Helpers
	    // =============
	    NumericInput.prototype.incrementValue = function (delta) {
	        // pretend we're incrementing from 0 if currValue is empty
	        var currValue = this.state.value || NumericInput_1.VALUE_ZERO;
	        var nextValue = this.getSanitizedValue(currValue, delta);
	        this.shouldSelectAfterUpdate = this.props.selectAllOnIncrement;
	        this.setState({ value: nextValue });
	        this.invokeValueCallback(nextValue, this.props.onValueChange);
	        return nextValue;
	    };
	    NumericInput.prototype.getIncrementDelta = function (direction, isShiftKeyPressed, isAltKeyPressed) {
	        var _a = this.props, majorStepSize = _a.majorStepSize, minorStepSize = _a.minorStepSize, stepSize = _a.stepSize;
	        if (isShiftKeyPressed && majorStepSize != null) {
	            return direction * majorStepSize;
	        }
	        else if (isAltKeyPressed && minorStepSize != null) {
	            return direction * minorStepSize;
	        }
	        else {
	            return direction * stepSize;
	        }
	    };
	    NumericInput.prototype.getSanitizedValue = function (value, delta, min, max) {
	        if (delta === void 0) { delta = 0; }
	        if (min === void 0) { min = this.props.min; }
	        if (max === void 0) { max = this.props.max; }
	        if (!this.isValueNumeric(value)) {
	            return NumericInput_1.VALUE_EMPTY;
	        }
	        var nextValue = this.toMaxPrecision(parseFloat(value) + delta);
	        // defaultProps won't work if the user passes in null, so just default
	        // to +/- infinity here instead, as a catch-all.
	        var adjustedMin = min != null ? min : -Infinity;
	        var adjustedMax = max != null ? max : Infinity;
	        nextValue = common_1.Utils.clamp(nextValue, adjustedMin, adjustedMax);
	        return nextValue.toString();
	    };
	    NumericInput.prototype.getValueOrEmptyValue = function (value) {
	        return value != null ? value.toString() : NumericInput_1.VALUE_EMPTY;
	    };
	    NumericInput.prototype.isValueNumeric = function (value) {
	        // checking if a string is numeric in Typescript is a big pain, because
	        // we can't simply toss a string parameter to isFinite. below is the
	        // essential approach that jQuery uses, which involves subtracting a
	        // parsed numeric value from the string representation of the value. we
	        // need to cast the value to the `any` type to allow this operation
	        // between dissimilar types.
	        return value != null && value - parseFloat(value) + 1 >= 0;
	    };
	    NumericInput.prototype.isKeyboardEventDisabledForBasicNumericEntry = function (e) {
	        // unit tests may not include e.key. don't bother disabling those events.
	        if (e.key == null) {
	            return false;
	        }
	        // allow modified key strokes that may involve letters and other
	        // non-numeric/invalid characters (Cmd + A, Cmd + C, Cmd + V, Cmd + X).
	        if (e.ctrlKey || e.altKey || e.metaKey) {
	            return false;
	        }
	        // keys that print a single character when pressed have a `key` name of
	        // length 1. every other key has a longer `key` name (e.g. "Backspace",
	        // "ArrowUp", "Shift"). since none of those keys can print a character
	        // to the field--and since they may have important native behaviors
	        // beyond printing a character--we don't want to disable their effects.
	        var isSingleCharKey = e.key.length === 1;
	        if (!isSingleCharKey) {
	            return false;
	        }
	        // now we can simply check that the single character that wants to be printed
	        // is a floating-point number character that we're allowed to print.
	        return !this.isFloatingPointNumericCharacter(e.key);
	    };
	    NumericInput.prototype.isFloatingPointNumericCharacter = function (character) {
	        return NumericInput_1.FLOATING_POINT_NUMBER_CHARACTER_REGEX.test(character);
	    };
	    NumericInput.prototype.getStepMaxPrecision = function (props) {
	        if (props.minorStepSize != null) {
	            return common_1.Utils.countDecimalPlaces(props.minorStepSize);
	        }
	        else {
	            return common_1.Utils.countDecimalPlaces(props.stepSize);
	        }
	    };
	    NumericInput.prototype.toMaxPrecision = function (value) {
	        // round the value to have the specified maximum precision (toFixed is the wrong choice,
	        // because it would show trailing zeros in the decimal part out to the specified precision)
	        // source: http://stackoverflow.com/a/18358056/5199574
	        var scaleFactor = Math.pow(10, this.state.stepMaxPrecision);
	        return Math.round(value * scaleFactor) / scaleFactor;
	    };
	    NumericInput.displayName = "Blueprint.NumericInput";
	    NumericInput.VALUE_EMPTY = "";
	    NumericInput.VALUE_ZERO = "0";
	    NumericInput.defaultProps = {
	        allowNumericCharactersOnly: true,
	        buttonPosition: common_1.Position.RIGHT,
	        clampValueOnBlur: false,
	        large: false,
	        majorStepSize: 10,
	        minorStepSize: 0.1,
	        selectAllOnFocus: false,
	        selectAllOnIncrement: false,
	        stepSize: 1,
	        value: NumericInput_1.VALUE_EMPTY,
	    };
	    NumericInput.DECREMENT_KEY = "decrement";
	    NumericInput.INCREMENT_KEY = "increment";
	    NumericInput.DECREMENT_ICON_NAME = "chevron-down";
	    NumericInput.INCREMENT_ICON_NAME = "chevron-up";
	    /**
	     * A regex that matches a string of length 1 (i.e. a standalone character)
	     * if and only if it is a floating-point number character as defined by W3C:
	     * https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
	     *
	     * Floating-point number characters are the only characters that can be
	     * printed within a default input[type="number"]. This component should
	     * behave the same way when this.props.allowNumericCharactersOnly = true.
	     * See here for the input[type="number"].value spec:
	     * https://www.w3.org/TR/2012/WD-html-markup-20120329/input.number.html#input.number.attrs.value
	     */
	    NumericInput.FLOATING_POINT_NUMBER_CHARACTER_REGEX = /^[Ee0-9\+\-\.]$/;
	    NumericInput = NumericInput_1 = tslib_1.__decorate([
	        PureRender
	    ], NumericInput);
	    return NumericInput;
	    var NumericInput_1;
	}(common_1.AbstractComponent));
	exports.NumericInput = NumericInput;
	exports.NumericInputFactory = React.createFactory(NumericInput);


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var controls_1 = __webpack_require__(438);
	var counter = 0;
	function nextName() {
	    return RadioGroup.displayName + "-" + counter++;
	}
	var RadioGroup = (function (_super) {
	    tslib_1.__extends(RadioGroup, _super);
	    function RadioGroup() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // a unique name for this group, which can be overridden by `name` prop.
	        _this.autoGroupName = nextName();
	        return _this;
	    }
	    RadioGroup.prototype.render = function () {
	        var label = this.props.label;
	        return (React.createElement("div", { className: this.props.className },
	            label == null ? null : React.createElement("label", { className: Classes.LABEL }, label),
	            Array.isArray(this.props.options) ? this.renderOptions() : this.renderChildren()));
	    };
	    RadioGroup.prototype.validateProps = function () {
	        if (this.props.children != null && this.props.options != null) {
	            console.warn(Errors.RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX);
	        }
	    };
	    RadioGroup.prototype.renderChildren = function () {
	        var _this = this;
	        return React.Children.map(this.props.children, function (child) {
	            if (isRadio(child)) {
	                return React.cloneElement(child, _this.getRadioProps(child.props));
	            }
	            else {
	                return child;
	            }
	        });
	    };
	    RadioGroup.prototype.renderOptions = function () {
	        var _this = this;
	        return this.props.options.map(function (option) { return (React.createElement(controls_1.Radio, tslib_1.__assign({}, option, _this.getRadioProps(option), { key: option.value }))); });
	    };
	    RadioGroup.prototype.getRadioProps = function (optionProps) {
	        var name = this.props.name;
	        var value = optionProps.value, disabled = optionProps.disabled;
	        return {
	            checked: value === this.props.selectedValue,
	            disabled: disabled || this.props.disabled,
	            inline: this.props.inline,
	            name: name == null ? this.autoGroupName : name,
	            onChange: this.props.onChange,
	        };
	    };
	    RadioGroup.displayName = "Blueprint.RadioGroup";
	    return RadioGroup;
	}(abstractComponent_1.AbstractComponent));
	exports.RadioGroup = RadioGroup;
	function isRadio(child) {
	    return child != null && child.type === controls_1.Radio;
	}


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __webpack_require__(1);
	var utils_1 = __webpack_require__(21);
	var hotkey_1 = __webpack_require__(222);
	var hotkeyParser_1 = __webpack_require__(304);
	var hotkeysDialog_1 = __webpack_require__(441);
	var SHOW_DIALOG_KEY = "?";
	var HotkeyScope;
	(function (HotkeyScope) {
	    HotkeyScope[HotkeyScope["LOCAL"] = 0] = "LOCAL";
	    HotkeyScope[HotkeyScope["GLOBAL"] = 1] = "GLOBAL";
	})(HotkeyScope = exports.HotkeyScope || (exports.HotkeyScope = {}));
	var HotkeysEvents = (function () {
	    function HotkeysEvents(scope) {
	        var _this = this;
	        this.scope = scope;
	        this.actions = [];
	        this.handleKeyDown = function (e) {
	            var combo = hotkeyParser_1.getKeyCombo(e);
	            var isTextInput = _this.isTextInput(e);
	            if (!isTextInput && hotkeyParser_1.comboMatches(hotkeyParser_1.parseKeyCombo(SHOW_DIALOG_KEY), combo)) {
	                if (hotkeysDialog_1.isHotkeysDialogShowing()) {
	                    hotkeysDialog_1.hideHotkeysDialogAfterDelay();
	                }
	                else {
	                    hotkeysDialog_1.showHotkeysDialog(_this.actions.map(function (action) { return action.props; }));
	                }
	                return;
	            }
	            else if (hotkeysDialog_1.isHotkeysDialogShowing()) {
	                return;
	            }
	            _this.invokeNamedCallbackIfComboRecognized(combo, "onKeyDown", e);
	        };
	        this.handleKeyUp = function (e) {
	            if (hotkeysDialog_1.isHotkeysDialogShowing()) {
	                return;
	            }
	            _this.invokeNamedCallbackIfComboRecognized(hotkeyParser_1.getKeyCombo(e), "onKeyUp", e);
	        };
	    }
	    HotkeysEvents.prototype.count = function () {
	        return this.actions.length;
	    };
	    HotkeysEvents.prototype.clear = function () {
	        this.actions = [];
	    };
	    HotkeysEvents.prototype.setHotkeys = function (props) {
	        var _this = this;
	        var actions = [];
	        react_1.Children.forEach(props.children, function (child) {
	            if (hotkey_1.Hotkey.isInstance(child) && _this.isScope(child.props)) {
	                actions.push({
	                    combo: hotkeyParser_1.parseKeyCombo(child.props.combo),
	                    props: child.props,
	                });
	            }
	        });
	        this.actions = actions;
	    };
	    HotkeysEvents.prototype.invokeNamedCallbackIfComboRecognized = function (combo, callbackName, e) {
	        var isTextInput = this.isTextInput(e);
	        for (var _i = 0, _a = this.actions; _i < _a.length; _i++) {
	            var action = _a[_i];
	            var shouldIgnore = (isTextInput && !action.props.allowInInput) || action.props.disabled;
	            if (!shouldIgnore && hotkeyParser_1.comboMatches(action.combo, combo)) {
	                if (action.props.preventDefault) {
	                    e.preventDefault();
	                }
	                if (action.props.stopPropagation) {
	                    // set a flag just for unit testing. not meant to be referenced in feature work.
	                    e.isPropagationStopped = true;
	                    e.stopPropagation();
	                }
	                utils_1.safeInvoke(action.props[callbackName], e);
	            }
	        }
	    };
	    HotkeysEvents.prototype.isScope = function (props) {
	        return (props.global ? HotkeyScope.GLOBAL : HotkeyScope.LOCAL) === this.scope;
	    };
	    HotkeysEvents.prototype.isTextInput = function (e) {
	        var elem = e.target;
	        // we check these cases for unit testing, but this should not happen
	        // during normal operation
	        if (elem == null || elem.closest == null) {
	            return false;
	        }
	        var editable = elem.closest("input, textarea, [contenteditable=true]");
	        if (editable == null) {
	            return false;
	        }
	        // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
	        if (editable.tagName.toLowerCase() === "input") {
	            var inputType = editable.type;
	            if (inputType === "checkbox" || inputType === "radio") {
	                return false;
	            }
	        }
	        // don't let read-only fields prevent hotkey behavior
	        if (editable.readOnly) {
	            return false;
	        }
	        return true;
	    };
	    return HotkeysEvents;
	}());
	exports.HotkeysEvents = HotkeysEvents;


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var utils_1 = __webpack_require__(21);
	var hotkeysEvents_1 = __webpack_require__(736);
	function HotkeysTarget(constructor) {
	    var _a = constructor.prototype, componentWillMount = _a.componentWillMount, componentDidMount = _a.componentDidMount, componentWillUnmount = _a.componentWillUnmount, render = _a.render, renderHotkeys = _a.renderHotkeys;
	    if (!utils_1.isFunction(renderHotkeys)) {
	        throw new Error("@HotkeysTarget-decorated class must implement `renderHotkeys`. " + constructor);
	    }
	    // tslint:disable no-invalid-this only-arrow-functions
	    constructor.prototype.componentWillMount = function () {
	        this.localHotkeysEvents = new hotkeysEvents_1.HotkeysEvents(hotkeysEvents_1.HotkeyScope.LOCAL);
	        this.globalHotkeysEvents = new hotkeysEvents_1.HotkeysEvents(hotkeysEvents_1.HotkeyScope.GLOBAL);
	        if (componentWillMount != null) {
	            componentWillMount.call(this);
	        }
	    };
	    constructor.prototype.componentDidMount = function () {
	        // attach global key event listeners
	        document.addEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
	        document.addEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
	        if (componentDidMount != null) {
	            componentDidMount.call(this);
	        }
	    };
	    constructor.prototype.componentWillUnmount = function () {
	        // detach global key event listeners
	        document.removeEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
	        document.removeEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
	        this.globalHotkeysEvents.clear();
	        this.localHotkeysEvents.clear();
	        if (componentWillUnmount != null) {
	            componentWillUnmount.call(this);
	        }
	    };
	    constructor.prototype.render = function () {
	        var _this = this;
	        var element = render.call(this);
	        var hotkeys = renderHotkeys.call(this);
	        this.localHotkeysEvents.setHotkeys(hotkeys.props);
	        this.globalHotkeysEvents.setHotkeys(hotkeys.props);
	        // attach local key event listeners
	        if (element != null && this.localHotkeysEvents.count() > 0) {
	            var tabIndex = hotkeys.props.tabIndex === undefined ? 0 : hotkeys.props.tabIndex;
	            var existingKeyDown_1 = element.props.onKeyDown;
	            var onKeyDown = function (e) {
	                _this.localHotkeysEvents.handleKeyDown(e.nativeEvent);
	                utils_1.safeInvoke(existingKeyDown_1, e);
	            };
	            var existingKeyUp_1 = element.props.onKeyUp;
	            var onKeyUp = function (e) {
	                _this.localHotkeysEvents.handleKeyUp(e.nativeEvent);
	                utils_1.safeInvoke(existingKeyUp_1, e);
	            };
	            return React.cloneElement(element, { tabIndex: tabIndex, onKeyDown: onKeyDown, onKeyUp: onKeyUp });
	        }
	        else {
	            return element;
	        }
	    };
	    // tslint:enable
	}
	exports.HotkeysTarget = HotkeysTarget;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var MenuDivider = (function (_super) {
	    tslib_1.__extends(MenuDivider, _super);
	    function MenuDivider() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MenuDivider.prototype.render = function () {
	        var _a = this.props, className = _a.className, title = _a.title;
	        if (title == null) {
	            // simple divider
	            return React.createElement("li", { className: classNames(Classes.MENU_DIVIDER, className) });
	        }
	        else {
	            // section header with title
	            return (React.createElement("li", { className: classNames(Classes.MENU_HEADER, className) },
	                React.createElement("h6", null, title)));
	        }
	    };
	    MenuDivider.displayName = "Blueprint.MenuDivider";
	    return MenuDivider;
	}(React.Component));
	exports.MenuDivider = MenuDivider;
	exports.MenuDividerFactory = React.createFactory(MenuDivider);


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var navbarDivider_1 = __webpack_require__(445);
	var navbarGroup_1 = __webpack_require__(446);
	var navbarHeading_1 = __webpack_require__(447);
	// this component is simple enough that tests would be purely tautological.
	/* istanbul ignore next */
	var Navbar = (function (_super) {
	    tslib_1.__extends(Navbar, _super);
	    function Navbar() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Navbar.prototype.render = function () {
	        var _a = this.props, children = _a.children, className = _a.className, htmlProps = tslib_1.__rest(_a, ["children", "className"]);
	        return (React.createElement("div", tslib_1.__assign({ className: classNames(Classes.NAVBAR, className) }, htmlProps), children));
	    };
	    Navbar.displayName = "Blueprint.Navbar";
	    Navbar.Divider = navbarDivider_1.NavbarDivider;
	    Navbar.Group = navbarGroup_1.NavbarGroup;
	    Navbar.Heading = navbarHeading_1.NavbarHeading;
	    Navbar = tslib_1.__decorate([
	        PureRender
	    ], Navbar);
	    return Navbar;
	}(React.Component));
	exports.Navbar = Navbar;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var icon_1 = __webpack_require__(104);
	var NonIdealState = (function (_super) {
	    tslib_1.__extends(NonIdealState, _super);
	    function NonIdealState() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NonIdealState.prototype.render = function () {
	        return (React.createElement("div", { className: classNames(Classes.NON_IDEAL_STATE, this.props.className) },
	            this.maybeRenderVisual(),
	            this.maybeRenderTitle(),
	            this.maybeRenderDescription(),
	            this.maybeRenderAction()));
	    };
	    NonIdealState.prototype.maybeRenderAction = function () {
	        if (this.props.action == null) {
	            return undefined;
	        }
	        return React.createElement("div", { className: Classes.NON_IDEAL_STATE_ACTION }, this.props.action);
	    };
	    NonIdealState.prototype.maybeRenderDescription = function () {
	        if (this.props.description == null) {
	            return undefined;
	        }
	        return React.createElement("div", { className: Classes.NON_IDEAL_STATE_DESCRIPTION }, this.props.description);
	    };
	    NonIdealState.prototype.maybeRenderTitle = function () {
	        if (this.props.title == null) {
	            return undefined;
	        }
	        return React.createElement("h4", { className: Classes.NON_IDEAL_STATE_TITLE }, this.props.title);
	    };
	    NonIdealState.prototype.maybeRenderVisual = function () {
	        var visual = this.props.visual;
	        if (visual == null) {
	            return undefined;
	        }
	        else if (typeof visual === "string") {
	            return (React.createElement("div", { className: classNames(Classes.NON_IDEAL_STATE_VISUAL, Classes.NON_IDEAL_STATE_ICON) },
	                React.createElement(icon_1.Icon, { iconName: visual, iconSize: "inherit" })));
	        }
	        else {
	            return React.createElement("div", { className: Classes.NON_IDEAL_STATE_VISUAL }, visual);
	        }
	    };
	    NonIdealState = tslib_1.__decorate([
	        PureRender
	    ], NonIdealState);
	    return NonIdealState;
	}(React.Component));
	exports.NonIdealState = NonIdealState;
	exports.NonIdealStateFactory = React.createFactory(NonIdealState);


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var position_1 = __webpack_require__(88);
	// this value causes popover and target edges to line up on 50px targets
	exports.MIN_ARROW_SPACING = 18;
	function computeArrowOffset(sideLength, arrowSize, minimum) {
	    if (minimum === void 0) { minimum = exports.MIN_ARROW_SPACING; }
	    return Math.max(Math.round((sideLength - arrowSize) / 2), minimum);
	}
	exports.computeArrowOffset = computeArrowOffset;
	function getPopoverTransformOrigin(position, arrowSize, targetDimensions) {
	    var offsetX = computeArrowOffset(targetDimensions.width, arrowSize);
	    var offsetY = computeArrowOffset(targetDimensions.height, arrowSize);
	    switch (position) {
	        case position_1.Position.TOP_LEFT:
	            return offsetX + "px bottom";
	        case position_1.Position.TOP_RIGHT:
	            return "calc(100% - " + offsetX + "px) bottom";
	        case position_1.Position.BOTTOM_LEFT:
	            return offsetX + "px top";
	        case position_1.Position.BOTTOM_RIGHT:
	            return "calc(100% - " + offsetX + "px) top";
	        case position_1.Position.LEFT_TOP:
	            return "right " + offsetY + "px";
	        case position_1.Position.LEFT_BOTTOM:
	            return "right calc(100% - " + offsetY + "px)";
	        case position_1.Position.RIGHT_TOP:
	            return "left " + offsetY + "px";
	        case position_1.Position.RIGHT_BOTTOM:
	            return "left calc(100% - " + offsetY + "px)";
	        default:
	            return undefined;
	    }
	}
	exports.getPopoverTransformOrigin = getPopoverTransformOrigin;
	function getArrowPositionStyles(position, arrowSize, ignoreTargetDimensions, targetDimensions, inline) {
	    // compute the offset to center an arrow with given hypotenuse in a side of the given length
	    var popoverOffset = function (sideLength) {
	        var offset = computeArrowOffset(sideLength, arrowSize, 0);
	        return offset < exports.MIN_ARROW_SPACING ? exports.MIN_ARROW_SPACING - offset : 0;
	    };
	    var popoverOffsetX = popoverOffset(targetDimensions.width);
	    var popoverOffsetY = popoverOffset(targetDimensions.height);
	    // TOP, RIGHT, BOTTOM, LEFT are handled purely in CSS because of centering transforms
	    switch (position) {
	        case position_1.Position.TOP_LEFT:
	        case position_1.Position.BOTTOM_LEFT:
	            return {
	                arrow: ignoreTargetDimensions ? {} : { left: computeArrowOffset(targetDimensions.width, arrowSize) },
	                container: { marginLeft: -popoverOffsetX },
	            };
	        case position_1.Position.TOP_RIGHT:
	        case position_1.Position.BOTTOM_RIGHT:
	            return {
	                arrow: ignoreTargetDimensions ? {} : { right: computeArrowOffset(targetDimensions.width, arrowSize) },
	                container: { marginLeft: popoverOffsetX },
	            };
	        case position_1.Position.RIGHT_TOP:
	        case position_1.Position.LEFT_TOP:
	            return {
	                arrow: ignoreTargetDimensions ? {} : { top: computeArrowOffset(targetDimensions.height, arrowSize) },
	                container: inline ? { top: -popoverOffsetY } : { marginTop: -popoverOffsetY },
	            };
	        case position_1.Position.RIGHT_BOTTOM:
	        case position_1.Position.LEFT_BOTTOM:
	            return {
	                arrow: ignoreTargetDimensions ? {} : { bottom: computeArrowOffset(targetDimensions.height, arrowSize) },
	                container: inline ? { bottom: -popoverOffsetY } : { marginTop: popoverOffsetY },
	            };
	        default:
	            return {};
	    }
	}
	exports.getArrowPositionStyles = getArrowPositionStyles;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var popover_1 = __webpack_require__(148);
	var SVGPopover = (function (_super) {
	    tslib_1.__extends(SVGPopover, _super);
	    function SVGPopover() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SVGPopover.prototype.render = function () {
	        return (React.createElement(popover_1.Popover, tslib_1.__assign({ rootElementTag: "g" }, this.props), this.props.children));
	    };
	    return SVGPopover;
	}(React.Component));
	exports.SVGPopover = SVGPopover;
	exports.SVGPopoverFactory = React.createFactory(SVGPopover);


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	var ProgressBar = (function (_super) {
	    tslib_1.__extends(ProgressBar, _super);
	    function ProgressBar() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ProgressBar.prototype.render = function () {
	        var _a = this.props, className = _a.className, intent = _a.intent, value = _a.value;
	        var classes = classNames("pt-progress-bar", Classes.intentClass(intent), className);
	        // don't set width if value is null (rely on default CSS value)
	        var width = value == null ? null : 100 * utils_1.clamp(value, 0, 1) + "%";
	        return (React.createElement("div", { className: classes },
	            React.createElement("div", { className: "pt-progress-meter", style: { width: width } })));
	    };
	    ProgressBar.displayName = "Blueprint.ProgressBar";
	    ProgressBar = tslib_1.__decorate([
	        PureRender
	    ], ProgressBar);
	    return ProgressBar;
	}(React.Component));
	exports.ProgressBar = ProgressBar;
	exports.ProgressBarFactory = React.createFactory(ProgressBar);


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var utils_1 = __webpack_require__(21);
	var coreSlider_1 = __webpack_require__(449);
	var handle_1 = __webpack_require__(450);
	var RangeIndex;
	(function (RangeIndex) {
	    RangeIndex[RangeIndex["START"] = 0] = "START";
	    RangeIndex[RangeIndex["END"] = 1] = "END";
	})(RangeIndex || (RangeIndex = {}));
	var RangeSlider = (function (_super) {
	    tslib_1.__extends(RangeSlider, _super);
	    function RangeSlider() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.className = classNames(Classes.SLIDER, Classes.RANGE_SLIDER);
	        _this.handles = [];
	        _this.addHandleRef = function (ref) {
	            if (ref != null) {
	                _this.handles.push(ref);
	            }
	        };
	        _this.getHandlerForIndex = function (index, callback) { return function (newValue) {
	            if (utils_1.isFunction(callback)) {
	                var _a = _this.props.value, startValue = _a[0], endValue = _a[1];
	                if (index === RangeIndex.START) {
	                    callback([Math.min(newValue, endValue), endValue]);
	                }
	                else {
	                    callback([startValue, Math.max(newValue, startValue)]);
	                }
	            }
	        }; };
	        _this.handleChange = function (newValue) {
	            var _a = _this.props.value, startValue = _a[0], endValue = _a[1];
	            var newStartValue = newValue[0], newEndValue = newValue[1];
	            if ((startValue !== newStartValue || endValue !== newEndValue) && utils_1.isFunction(_this.props.onChange)) {
	                _this.props.onChange(newValue);
	            }
	        };
	        return _this;
	    }
	    RangeSlider.prototype.renderFill = function () {
	        var tickSize = this.state.tickSize;
	        var _a = this.props.value, startValue = _a[0], endValue = _a[1];
	        if (startValue === endValue) {
	            return undefined;
	        }
	        // expand by 1px in each direction so it sits under the handle border
	        var offset = Math.round((startValue - this.props.min) * tickSize) - 1;
	        var size = Math.round((endValue - startValue) * tickSize) + 2;
	        if (size < 0) {
	            offset += size;
	            size = Math.abs(size);
	        }
	        var style = this.props.vertical
	            ? { bottom: offset, height: size }
	            : { left: offset, width: size };
	        return React.createElement("div", { className: Classes.SLIDER + "-progress", style: style });
	    };
	    RangeSlider.prototype.renderHandles = function () {
	        var _this = this;
	        var _a = this.props, disabled = _a.disabled, max = _a.max, min = _a.min, onRelease = _a.onRelease, stepSize = _a.stepSize, value = _a.value, vertical = _a.vertical;
	        return value.map(function (val, index) { return (React.createElement(handle_1.Handle, { disabled: disabled, key: index, label: _this.formatLabel(val), max: max, min: min, onChange: _this.getHandlerForIndex(index, _this.handleChange), onRelease: _this.getHandlerForIndex(index, onRelease), ref: _this.addHandleRef, stepSize: stepSize, tickSize: _this.state.tickSize, value: val, vertical: vertical })); });
	    };
	    RangeSlider.prototype.handleTrackClick = function (event) {
	        var _this = this;
	        this.handles
	            .reduce(function (min, handle) {
	            // find closest handle to the mouse position
	            var offset = handle.mouseEventClientOffset(event);
	            var value = handle.clientToValue(offset);
	            return _this.nearestHandleForValue(value, min, handle);
	        })
	            .beginHandleMovement(event);
	    };
	    RangeSlider.prototype.handleTrackTouch = function (event) {
	        var _this = this;
	        this.handles
	            .reduce(function (min, handle) {
	            // find closest handle to the touch position
	            var value = handle.clientToValue(handle.touchEventClientOffset(event));
	            return _this.nearestHandleForValue(value, min, handle);
	        })
	            .beginHandleTouchMovement(event);
	    };
	    RangeSlider.prototype.nearestHandleForValue = function (value, firstHandle, secondHandle) {
	        var firstHandleValue = firstHandle.props.value;
	        var firstDistance = Math.abs(value - firstHandleValue);
	        var secondDistance = Math.abs(value - secondHandle.props.value);
	        if (firstDistance < secondDistance) {
	            return firstHandle;
	        }
	        else if (secondDistance < firstDistance) {
	            return secondHandle;
	        }
	        else {
	            // if the values are equal, return the handle that is *able* to move
	            // in the necessary direction.
	            return value < firstHandleValue ? firstHandle : secondHandle;
	        }
	    };
	    RangeSlider.prototype.validateProps = function (props) {
	        var value = props.value;
	        if (value == null || value[RangeIndex.START] == null || value[RangeIndex.END] == null) {
	            throw new Error(Errors.RANGESLIDER_NULL_VALUE);
	        }
	    };
	    RangeSlider.defaultProps = {
	        disabled: false,
	        labelStepSize: 1,
	        max: 10,
	        min: 0,
	        showTrackFill: true,
	        stepSize: 1,
	        value: [0, 10],
	        vertical: false,
	    };
	    RangeSlider.displayName = "Blueprint.RangeSlider";
	    return RangeSlider;
	}(coreSlider_1.CoreSlider));
	exports.RangeSlider = RangeSlider;
	exports.RangeSliderFactory = React.createFactory(RangeSlider);


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	var coreSlider_1 = __webpack_require__(449);
	var handle_1 = __webpack_require__(450);
	var Slider = (function (_super) {
	    tslib_1.__extends(Slider, _super);
	    function Slider() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // tslint:enable member-ordering
	        _this.handleHandleRef = function (ref) {
	            _this.handle = ref;
	        };
	        return _this;
	    }
	    Slider.prototype.renderFill = function () {
	        var tickSize = this.state.tickSize;
	        var initialValue = utils_1.clamp(this.props.initialValue, this.props.min, this.props.max);
	        var offset = Math.round((initialValue - this.props.min) * tickSize);
	        var size = Math.round((this.props.value - initialValue) * tickSize);
	        if (size < 0) {
	            offset += size;
	            size = Math.abs(size);
	        }
	        var style = this.props.vertical
	            ? { bottom: offset, height: size }
	            : { left: offset, width: size };
	        return React.createElement("div", { className: Classes.SLIDER + "-progress", style: style });
	    };
	    Slider.prototype.renderHandles = function () {
	        // make sure to *not* pass this.props.className to handle
	        return (React.createElement(handle_1.Handle, tslib_1.__assign({}, this.props, this.state, { className: "", label: this.formatLabel(this.props.value), ref: this.handleHandleRef })));
	    };
	    Slider.prototype.handleTrackClick = function (event) {
	        if (this.handle != null) {
	            this.handle.beginHandleMovement(event);
	        }
	    };
	    Slider.prototype.handleTrackTouch = function (event) {
	        if (this.handle != null) {
	            this.handle.beginHandleTouchMovement(event);
	        }
	    };
	    Slider.defaultProps = {
	        disabled: false,
	        initialValue: 0,
	        labelStepSize: 1,
	        max: 10,
	        min: 0,
	        showTrackFill: true,
	        stepSize: 1,
	        value: 0,
	        vertical: false,
	    };
	    return Slider;
	}(coreSlider_1.CoreSlider));
	exports.Slider = Slider;
	exports.SliderFactory = React.createFactory(Slider);


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	// import * to avoid "cannot be named" error on factory
	var spinner = __webpack_require__(306);
	var SVGSpinner = (function (_super) {
	    tslib_1.__extends(SVGSpinner, _super);
	    function SVGSpinner() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SVGSpinner.prototype.renderContainer = function (classes, content) {
	        return (React.createElement("g", { className: classNames(Classes.SVG_SPINNER, classes) },
	            React.createElement("g", { className: "pt-svg-spinner-transform-group" }, content)));
	    };
	    return SVGSpinner;
	}(spinner.Spinner));
	exports.SVGSpinner = SVGSpinner;
	exports.SVGSpinnerFactory = React.createFactory(SVGSpinner);


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var react_dom_1 = __webpack_require__(39);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Errors = __webpack_require__(48);
	var Keys = __webpack_require__(103);
	var Utils = __webpack_require__(21);
	var tab_1 = __webpack_require__(451);
	var tabList_1 = __webpack_require__(452);
	var tabPanel_1 = __webpack_require__(453);
	var TAB_CSS_SELECTOR = "li[role=tab]";
	var Tabs = (function (_super) {
	    tslib_1.__extends(Tabs, _super);
	    function Tabs(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        // state is initialized in the constructor but getStateFromProps needs state defined
	        _this.state = {};
	        _this.panelIds = [];
	        _this.tabIds = [];
	        _this.handleClick = function (e) {
	            _this.handleTabSelectingEvent(e);
	        };
	        _this.handleKeyPress = function (e) {
	            var insideTab = e.target.closest("." + Classes.TAB) != null;
	            if (insideTab && (e.which === Keys.SPACE || e.which === Keys.ENTER)) {
	                e.preventDefault();
	                _this.handleTabSelectingEvent(e);
	            }
	        };
	        _this.handleKeyDown = function (e) {
	            // don't want to handle keyDown events inside a tab panel
	            var insideTabList = e.target.closest("." + Classes.TAB_LIST) != null;
	            if (!insideTabList) {
	                return;
	            }
	            var focusedTabIndex = _this.getFocusedTabIndex();
	            if (focusedTabIndex === -1) {
	                return;
	            }
	            if (e.which === Keys.ARROW_LEFT) {
	                e.preventDefault();
	                // find previous tab that isn't disabled
	                var newTabIndex = focusedTabIndex - 1;
	                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
	                while (tabIsDisabled && newTabIndex !== -1) {
	                    newTabIndex--;
	                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
	                }
	                if (newTabIndex !== -1) {
	                    _this.focusTab(newTabIndex);
	                }
	            }
	            else if (e.which === Keys.ARROW_RIGHT) {
	                e.preventDefault();
	                // find next tab that isn't disabled
	                var tabsCount = _this.getTabsCount();
	                var newTabIndex = focusedTabIndex + 1;
	                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
	                while (tabIsDisabled && newTabIndex !== tabsCount) {
	                    newTabIndex++;
	                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
	                }
	                if (newTabIndex !== tabsCount) {
	                    _this.focusTab(newTabIndex);
	                }
	            }
	        };
	        _this.handleTabSelectingEvent = function (e) {
	            var tabElement = e.target.closest(TAB_CSS_SELECTOR);
	            // select only if Tab is one of us and is enabled
	            if (tabElement != null &&
	                _this.tabIds.indexOf(tabElement.id) >= 0 &&
	                tabElement.getAttribute("aria-disabled") !== "true") {
	                var index = tabElement.parentElement.queryAll(TAB_CSS_SELECTOR).indexOf(tabElement);
	                _this.setSelectedTabIndex(index);
	            }
	        };
	        _this.state = _this.getStateFromProps(_this.props);
	        if (!Utils.isNodeEnv("production")) {
	            console.warn(Errors.TABS_WARN_DEPRECATED);
	        }
	        return _this;
	    }
	    Tabs.prototype.render = function () {
	        return (React.createElement("div", { className: classNames(Classes.TABS, this.props.className), onClick: this.handleClick, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown }, this.getChildren()));
	    };
	    Tabs.prototype.componentWillReceiveProps = function (newProps) {
	        var newState = this.getStateFromProps(newProps);
	        this.setState(newState);
	    };
	    Tabs.prototype.componentDidMount = function () {
	        var _this = this;
	        var selectedTab = react_dom_1.findDOMNode(this.refs["tabs-" + this.state.selectedTabIndex]);
	        this.setTimeout(function () { return _this.moveIndicator(selectedTab); });
	    };
	    Tabs.prototype.componentDidUpdate = function (_, prevState) {
	        var _this = this;
	        var newIndex = this.state.selectedTabIndex;
	        if (newIndex !== prevState.selectedTabIndex) {
	            var tabElement_1 = react_dom_1.findDOMNode(this.refs["tabs-" + newIndex]);
	            // need to measure on the next frame in case the Tab children simultaneously change
	            this.setTimeout(function () { return _this.moveIndicator(tabElement_1); });
	        }
	    };
	    Tabs.prototype.validateProps = function (props) {
	        if (React.Children.count(props.children) > 0) {
	            var child = React.Children.toArray(props.children)[0];
	            if (child != null && child.type !== tabList_1.TabList) {
	                throw new Error(Errors.TABS_FIRST_CHILD);
	            }
	            if (this.getTabsCount() !== this.getPanelsCount()) {
	                throw new Error(Errors.TABS_MISMATCH);
	            }
	        }
	    };
	    /**
	     * Calculate the new height, width, and position of the tab indicator.
	     * Store the CSS values so the transition animation can start.
	     */
	    Tabs.prototype.moveIndicator = function (_a) {
	        var clientHeight = _a.clientHeight, clientWidth = _a.clientWidth, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop;
	        var indicatorWrapperStyle = {
	            height: clientHeight,
	            transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
	            width: clientWidth,
	        };
	        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
	    };
	    /**
	     * Most of the component logic lives here. We clone the children provided by the user to set up refs,
	     * accessibility attributes, and selection props correctly.
	     */
	    Tabs.prototype.getChildren = function () {
	        var _this = this;
	        for (var unassignedTabs = this.getTabsCount() - this.tabIds.length; unassignedTabs > 0; unassignedTabs--) {
	            this.tabIds.push(generateTabId());
	            this.panelIds.push(generatePanelId());
	        }
	        var childIndex = 0;
	        return React.Children.map(this.props.children, function (child) {
	            var result;
	            // can be null if conditionally rendering TabList / TabPanel
	            if (child == null) {
	                return null;
	            }
	            if (childIndex === 0) {
	                // clone TabList / Tab elements
	                result = _this.cloneTabList(child);
	            }
	            else {
	                var tabPanelIndex = childIndex - 1;
	                var shouldRenderTabPanel = _this.state.selectedTabIndex === tabPanelIndex;
	                result = shouldRenderTabPanel ? _this.cloneTabPanel(child, tabPanelIndex) : null;
	            }
	            childIndex++;
	            return result;
	        });
	    };
	    Tabs.prototype.cloneTabList = function (child) {
	        var _this = this;
	        var tabIndex = 0;
	        var tabs = React.Children.map(child.props.children, function (tab) {
	            // can be null if conditionally rendering Tab
	            if (tab == null) {
	                return null;
	            }
	            var clonedTab = React.cloneElement(tab, {
	                id: _this.tabIds[tabIndex],
	                isSelected: _this.state.selectedTabIndex === tabIndex,
	                panelId: _this.panelIds[tabIndex],
	                ref: "tabs-" + tabIndex,
	            });
	            tabIndex++;
	            return clonedTab;
	        });
	        // tslint:disable-next-line no-object-literal-type-assertion
	        return React.cloneElement(child, {
	            children: tabs,
	            indicatorWrapperStyle: this.state.indicatorWrapperStyle,
	            ref: "tablist",
	        });
	    };
	    Tabs.prototype.cloneTabPanel = function (child, tabIndex) {
	        return React.cloneElement(child, {
	            id: this.panelIds[tabIndex],
	            isSelected: this.state.selectedTabIndex === tabIndex,
	            ref: "panels-" + tabIndex,
	            tabId: this.tabIds[tabIndex],
	        });
	    };
	    Tabs.prototype.focusTab = function (index) {
	        var ref = "tabs-" + index;
	        var tab = react_dom_1.findDOMNode(this.refs[ref]);
	        tab.focus();
	    };
	    Tabs.prototype.getFocusedTabIndex = function () {
	        var focusedElement = document.activeElement;
	        if (focusedElement != null && focusedElement.classList.contains(Classes.TAB)) {
	            var tabId = focusedElement.id;
	            return this.tabIds.indexOf(tabId);
	        }
	        return -1;
	    };
	    Tabs.prototype.getTabs = function () {
	        if (this.props.children == null) {
	            return [];
	        }
	        var tabs = [];
	        if (React.Children.count(this.props.children) > 0) {
	            var firstChild = React.Children.toArray(this.props.children)[0];
	            if (firstChild != null) {
	                React.Children.forEach(firstChild.props.children, function (tabListChild) {
	                    if (tabListChild.type === tab_1.Tab) {
	                        tabs.push(tabListChild);
	                    }
	                });
	            }
	        }
	        return tabs;
	    };
	    Tabs.prototype.getTabsCount = function () {
	        return this.getTabs().length;
	    };
	    Tabs.prototype.getPanelsCount = function () {
	        if (this.props.children == null) {
	            return 0;
	        }
	        var index = 0;
	        var panelCount = 0;
	        React.Children.forEach(this.props.children, function (child) {
	            if (child.type === tabPanel_1.TabPanel) {
	                panelCount++;
	            }
	            index++;
	        });
	        return panelCount;
	    };
	    Tabs.prototype.getStateFromProps = function (props) {
	        var selectedTabIndex = props.selectedTabIndex, initialSelectedTabIndex = props.initialSelectedTabIndex;
	        if (this.isValidTabIndex(selectedTabIndex)) {
	            return { selectedTabIndex: selectedTabIndex };
	        }
	        else if (this.isValidTabIndex(initialSelectedTabIndex) && this.state.selectedTabIndex == null) {
	            return { selectedTabIndex: initialSelectedTabIndex };
	        }
	        else {
	            return this.state;
	        }
	    };
	    Tabs.prototype.isTabDisabled = function (index) {
	        var tab = this.getTabs()[index];
	        return tab != null && tab.props.isDisabled;
	    };
	    Tabs.prototype.isValidTabIndex = function (index) {
	        return index != null && index >= 0 && index < this.getTabsCount();
	    };
	    /**
	     * Updates the component's state if uncontrolled and calls onChange.
	     */
	    Tabs.prototype.setSelectedTabIndex = function (index) {
	        if (index === this.state.selectedTabIndex || !this.isValidTabIndex(index)) {
	            return;
	        }
	        var prevSelectedIndex = this.state.selectedTabIndex;
	        if (this.props.selectedTabIndex == null) {
	            this.setState({
	                selectedTabIndex: index,
	            });
	        }
	        if (Utils.isFunction(this.props.onChange)) {
	            this.props.onChange(index, prevSelectedIndex);
	        }
	    };
	    Tabs.defaultProps = {
	        initialSelectedTabIndex: 0,
	    };
	    Tabs.displayName = "Blueprint.Tabs";
	    Tabs = tslib_1.__decorate([
	        PureRender
	    ], Tabs);
	    return Tabs;
	}(abstractComponent_1.AbstractComponent));
	exports.Tabs = Tabs;
	var globalTabCount = 0;
	function generateTabId() {
	    return "pt-tab-" + globalTabCount++;
	}
	var globalPanelCount = 0;
	function generatePanelId() {
	    return "pt-tab-panel-" + globalPanelCount++;
	}
	exports.TabsFactory = React.createFactory(Tabs);


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var TabTitle = (function (_super) {
	    tslib_1.__extends(TabTitle, _super);
	    function TabTitle() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleClick = function (e) { return _this.props.onClick(_this.props.id, e); };
	        return _this;
	    }
	    TabTitle.prototype.render = function () {
	        var _a = this.props, disabled = _a.disabled, id = _a.id, parentId = _a.parentId, selected = _a.selected;
	        return (React.createElement("div", { "aria-controls": generateTabPanelId(parentId, id), "aria-disabled": disabled, "aria-expanded": selected, "aria-selected": selected, className: classNames(Classes.TAB, this.props.className), "data-tab-id": id, id: generateTabTitleId(parentId, id), onClick: disabled ? undefined : this.handleClick, role: "tab", tabIndex: disabled ? undefined : 0 },
	            this.props.title,
	            this.props.children));
	    };
	    TabTitle.displayName = "Blueprint.TabTitle";
	    TabTitle = tslib_1.__decorate([
	        PureRender
	    ], TabTitle);
	    return TabTitle;
	}(React.Component));
	exports.TabTitle = TabTitle;
	function generateTabPanelId(parentId, tabId) {
	    return Classes.TAB_PANEL + "_" + parentId + "_" + tabId;
	}
	exports.generateTabPanelId = generateTabPanelId;
	function generateTabTitleId(parentId, tabId) {
	    return Classes.TAB + "-title_" + parentId + "_" + tabId;
	}
	exports.generateTabTitleId = generateTabTitleId;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var Keys = __webpack_require__(103);
	var Utils = __webpack_require__(21);
	var tab2_1 = __webpack_require__(454);
	var tabTitle_1 = __webpack_require__(748);
	exports.Expander = function () { return React.createElement("div", { className: "pt-flex-expander" }); };
	var TAB_SELECTOR = "." + Classes.TAB;
	var Tabs2 = (function (_super) {
	    tslib_1.__extends(Tabs2, _super);
	    function Tabs2(props) {
	        var _this = _super.call(this, props) || this;
	        _this.refHandlers = {
	            tablist: function (tabElement) { return (_this.tablistElement = tabElement); },
	        };
	        _this.handleKeyDown = function (e) {
	            var focusedElement = document.activeElement.closest(TAB_SELECTOR);
	            // rest of this is potentially expensive and futile, so bail if no tab is focused
	            if (focusedElement == null) {
	                return;
	            }
	            // must rely on DOM state because we have no way of mapping `focusedElement` to a JSX.Element
	            var enabledTabElements = _this.getTabElements().filter(function (el) { return el.getAttribute("aria-disabled") === "false"; });
	            var focusedIndex = enabledTabElements.indexOf(focusedElement);
	            var direction = _this.getKeyCodeDirection(e);
	            if (focusedIndex >= 0 && direction !== undefined) {
	                e.preventDefault();
	                var length_1 = enabledTabElements.length;
	                // auto-wrapping at 0 and `length`
	                var nextFocusedIndex = (focusedIndex + direction + length_1) % length_1;
	                enabledTabElements[nextFocusedIndex].focus();
	            }
	        };
	        _this.handleKeyPress = function (e) {
	            var targetTabElement = e.target.closest(TAB_SELECTOR);
	            if (targetTabElement != null && isEventKeyCode(e, Keys.SPACE, Keys.ENTER)) {
	                e.preventDefault();
	                targetTabElement.click();
	            }
	        };
	        _this.handleTabClick = function (newTabId, event) {
	            Utils.safeInvoke(_this.props.onChange, newTabId, _this.state.selectedTabId, event);
	            if (_this.props.selectedTabId === undefined) {
	                _this.setState({ selectedTabId: newTabId });
	            }
	        };
	        _this.renderTabPanel = function (tab) {
	            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id;
	            if (panel === undefined) {
	                return undefined;
	            }
	            return (React.createElement("div", { "aria-labelledby": tabTitle_1.generateTabTitleId(_this.props.id, id), "aria-hidden": id !== _this.state.selectedTabId, className: classNames(Classes.TAB_PANEL, className), id: tabTitle_1.generateTabPanelId(_this.props.id, id), key: id, role: "tabpanel" }, panel));
	        };
	        _this.renderTabTitle = function (tab) {
	            var id = tab.props.id;
	            return (React.createElement(tabTitle_1.TabTitle, tslib_1.__assign({}, tab.props, { parentId: _this.props.id, onClick: _this.handleTabClick, selected: id === _this.state.selectedTabId })));
	        };
	        var selectedTabId = _this.getInitialSelectedTabId();
	        _this.state = { selectedTabId: selectedTabId };
	        return _this;
	    }
	    Tabs2.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, indicatorWrapperStyle = _a.indicatorWrapperStyle, selectedTabId = _a.selectedTabId;
	        var tabTitles = React.Children.map(this.props.children, function (child) { return (isTab(child) ? _this.renderTabTitle(child) : child); });
	        var tabPanels = this.getTabChildren()
	            .filter(this.props.renderActiveTabPanelOnly ? function (tab) { return tab.props.id === selectedTabId; } : function () { return true; })
	            .map(this.renderTabPanel);
	        var tabIndicator = this.props.animate ? (React.createElement("div", { className: "pt-tab-indicator-wrapper", style: indicatorWrapperStyle },
	            React.createElement("div", { className: "pt-tab-indicator" }))) : (undefined);
	        var classes = classNames(Classes.TABS, (_b = {}, _b[Classes.VERTICAL] = this.props.vertical, _b), this.props.className);
	        var tabListClasses = classNames(Classes.TAB_LIST, (_c = {},
	            _c[Classes.LARGE] = this.props.large,
	            _c));
	        return (React.createElement("div", { className: classes },
	            React.createElement("div", { className: tabListClasses, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, ref: this.refHandlers.tablist, role: "tablist" },
	                tabIndicator,
	                tabTitles),
	            tabPanels));
	        var _b, _c;
	    };
	    Tabs2.prototype.componentDidMount = function () {
	        this.moveSelectionIndicator();
	    };
	    Tabs2.prototype.componentWillReceiveProps = function (_a) {
	        var selectedTabId = _a.selectedTabId;
	        if (selectedTabId !== undefined) {
	            // keep state in sync with controlled prop, so state is canonical source of truth
	            this.setState({ selectedTabId: selectedTabId });
	        }
	    };
	    Tabs2.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (this.state.selectedTabId !== prevState.selectedTabId) {
	            this.moveSelectionIndicator();
	        }
	        else if (prevState.selectedTabId != null) {
	            // comparing React nodes is difficult to do with simple logic, so
	            // shallowly compare just their props as a workaround.
	            var didChildrenChange = !Utils.arraysEqual(this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), Utils.shallowCompareKeys);
	            if (didChildrenChange) {
	                this.moveSelectionIndicator();
	            }
	        }
	    };
	    Tabs2.prototype.getInitialSelectedTabId = function () {
	        // NOTE: providing an unknown ID will hide the selection
	        var _a = this.props, defaultSelectedTabId = _a.defaultSelectedTabId, selectedTabId = _a.selectedTabId;
	        if (selectedTabId !== undefined) {
	            return selectedTabId;
	        }
	        else if (defaultSelectedTabId !== undefined) {
	            return defaultSelectedTabId;
	        }
	        else {
	            // select first tab in absence of user input
	            var tabs = this.getTabChildren();
	            return tabs.length === 0 ? undefined : tabs[0].props.id;
	        }
	    };
	    Tabs2.prototype.getKeyCodeDirection = function (e) {
	        if (isEventKeyCode(e, Keys.ARROW_LEFT, Keys.ARROW_UP)) {
	            return -1;
	        }
	        else if (isEventKeyCode(e, Keys.ARROW_RIGHT, Keys.ARROW_DOWN)) {
	            return 1;
	        }
	        return undefined;
	    };
	    Tabs2.prototype.getTabChildrenProps = function (props) {
	        if (props === void 0) { props = this.props; }
	        return this.getTabChildren(props).map(function (child) { return child.props; });
	    };
	    /** Filters children to only `<Tab>`s */
	    Tabs2.prototype.getTabChildren = function (props) {
	        if (props === void 0) { props = this.props; }
	        return React.Children.toArray(props.children).filter(isTab);
	    };
	    /** Queries root HTML element for all `.pt-tab`s with optional filter selector */
	    Tabs2.prototype.getTabElements = function (subselector) {
	        if (subselector === void 0) { subselector = ""; }
	        if (this.tablistElement == null) {
	            return [];
	        }
	        return this.tablistElement.queryAll(TAB_SELECTOR + subselector);
	    };
	    /**
	     * Calculate the new height, width, and position of the tab indicator.
	     * Store the CSS values so the transition animation can start.
	     */
	    Tabs2.prototype.moveSelectionIndicator = function () {
	        if (this.tablistElement === undefined || !this.props.animate) {
	            return;
	        }
	        var tabIdSelector = TAB_SELECTOR + "[data-tab-id=\"" + this.state.selectedTabId + "\"]";
	        var selectedTabElement = this.tablistElement.query(tabIdSelector);
	        var indicatorWrapperStyle = { display: "none" };
	        if (selectedTabElement != null) {
	            var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
	            indicatorWrapperStyle = {
	                height: clientHeight,
	                transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
	                width: clientWidth,
	            };
	        }
	        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
	    };
	    /** Insert a `Tabs2.Expander` between any two children to right-align all subsequent children. */
	    Tabs2.Expander = exports.Expander;
	    Tabs2.Tab = tab2_1.Tab2;
	    Tabs2.defaultProps = {
	        animate: true,
	        large: false,
	        renderActiveTabPanelOnly: false,
	        vertical: false,
	    };
	    Tabs2.displayName = "Blueprint.Tabs2";
	    Tabs2 = tslib_1.__decorate([
	        PureRender
	    ], Tabs2);
	    return Tabs2;
	}(abstractComponent_1.AbstractComponent));
	exports.Tabs2 = Tabs2;
	exports.Tabs2Factory = React.createFactory(Tabs2);
	function isEventKeyCode(e) {
	    var codes = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        codes[_i - 1] = arguments[_i];
	    }
	    return codes.indexOf(e.which) >= 0;
	}
	function isTab(child) {
	    return child != null && child.type === tab2_1.Tab2;
	}


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var common_1 = __webpack_require__(75);
	var props_1 = __webpack_require__(147);
	var Classes = __webpack_require__(8);
	var Tag = (function (_super) {
	    tslib_1.__extends(Tag, _super);
	    function Tag() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onRemoveClick = function (e) {
	            common_1.Utils.safeInvoke(_this.props.onRemove, e, _this.props);
	        };
	        return _this;
	    }
	    Tag.prototype.render = function () {
	        var _a = this.props, active = _a.active, className = _a.className, intent = _a.intent, onRemove = _a.onRemove;
	        var tagClasses = classNames(Classes.TAG, Classes.intentClass(intent), (_b = {},
	            _b[Classes.TAG_REMOVABLE] = onRemove != null,
	            _b[Classes.ACTIVE] = active,
	            _b), className);
	        var button = common_1.Utils.isFunction(onRemove) ? (React.createElement("button", { type: "button", className: Classes.TAG_REMOVE, onClick: this.onRemoveClick })) : (undefined);
	        return (React.createElement("span", tslib_1.__assign({}, props_1.removeNonHTMLProps(this.props), { className: tagClasses }),
	            this.props.children,
	            button));
	        var _b;
	    };
	    Tag.displayName = "Blueprint.Tag";
	    Tag = tslib_1.__decorate([
	        PureRender
	    ], Tag);
	    return Tag;
	}(React.Component));
	exports.Tag = Tag;
	exports.TagFactory = React.createFactory(Tag);


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var Text = (function (_super) {
	    tslib_1.__extends(Text, _super);
	    function Text() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            isContentOverflowing: false,
	            textContent: "",
	        };
	        _this.refHandlers = {
	            text: function (overflowElement) { return (_this.textRef = overflowElement); },
	        };
	        return _this;
	    }
	    Text.prototype.componentDidMount = function () {
	        this.update();
	    };
	    Text.prototype.componentDidUpdate = function () {
	        this.update();
	    };
	    Text.prototype.render = function () {
	        var classes = classNames((_a = {},
	            _a[Classes.TEXT_OVERFLOW_ELLIPSIS] = this.props.ellipsize,
	            _a), this.props.className);
	        return (React.createElement("div", { className: classes, ref: this.refHandlers.text, title: this.state.isContentOverflowing ? this.state.textContent : undefined }, this.props.children));
	        var _a;
	    };
	    Text.prototype.update = function () {
	        var newState = {
	            isContentOverflowing: this.props.ellipsize && this.textRef.scrollWidth > this.textRef.clientWidth,
	            textContent: this.textRef.textContent,
	        };
	        this.setState(newState);
	    };
	    Text = tslib_1.__decorate([
	        PureRender
	    ], Text);
	    return Text;
	}(React.Component));
	exports.Text = Text;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var PureRender = __webpack_require__(17);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var abstractComponent_1 = __webpack_require__(47);
	var Classes = __webpack_require__(8);
	var errors_1 = __webpack_require__(48);
	var keys_1 = __webpack_require__(103);
	var position_1 = __webpack_require__(88);
	var utils_1 = __webpack_require__(21);
	var overlay_1 = __webpack_require__(223);
	var toast_1 = __webpack_require__(455);
	var Toaster = (function (_super) {
	    tslib_1.__extends(Toaster, _super);
	    function Toaster() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            toasts: [],
	        };
	        // auto-incrementing identifier for un-keyed toasts
	        _this.toastId = 0;
	        _this.getDismissHandler = function (toast) { return function (timeoutExpired) {
	            _this.dismiss(toast.key, timeoutExpired);
	        }; };
	        _this.handleClose = function (e) {
	            // NOTE that `e` isn't always a KeyboardEvent but that's the only type we care about
	            if (e.which === keys_1.ESCAPE) {
	                _this.clear();
	            }
	        };
	        return _this;
	    }
	    Toaster_1 = Toaster;
	    /**
	     * Create a new `Toaster` instance that can be shared around your application.
	     * The `Toaster` will be rendered into a new element appended to the given container.
	     */
	    Toaster.create = function (props, container) {
	        if (container === void 0) { container = document.body; }
	        if (props != null && props.inline != null && !utils_1.isNodeEnv("production")) {
	            console.warn(errors_1.TOASTER_WARN_INLINE);
	        }
	        var containerElement = document.createElement("div");
	        container.appendChild(containerElement);
	        return ReactDOM.render(React.createElement(Toaster_1, tslib_1.__assign({}, props, { inline: true })), containerElement);
	    };
	    Toaster.prototype.show = function (props) {
	        var options = this.createToastOptions(props);
	        this.setState(function (prevState) { return ({
	            toasts: [options].concat(prevState.toasts),
	        }); });
	        return options.key;
	    };
	    Toaster.prototype.update = function (key, props) {
	        var options = this.createToastOptions(props, key);
	        this.setState(function (prevState) { return ({
	            toasts: prevState.toasts.map(function (t) { return (t.key === key ? options : t); }),
	        }); });
	    };
	    Toaster.prototype.dismiss = function (key, timeoutExpired) {
	        if (timeoutExpired === void 0) { timeoutExpired = false; }
	        this.setState(function (_a) {
	            var toasts = _a.toasts;
	            return ({
	                toasts: toasts.filter(function (t) {
	                    var matchesKey = t.key === key;
	                    if (matchesKey) {
	                        utils_1.safeInvoke(t.onDismiss, timeoutExpired);
	                    }
	                    return !matchesKey;
	                }),
	            });
	        });
	    };
	    Toaster.prototype.clear = function () {
	        this.state.toasts.map(function (t) { return utils_1.safeInvoke(t.onDismiss, false); });
	        this.setState({ toasts: [] });
	    };
	    Toaster.prototype.getToasts = function () {
	        return this.state.toasts;
	    };
	    Toaster.prototype.render = function () {
	        // $pt-transition-duration * 3 + $pt-transition-duration / 2
	        var classes = classNames(Classes.TOAST_CONTAINER, this.getPositionClasses(), this.props.className);
	        return (React.createElement(overlay_1.Overlay, { autoFocus: this.props.autoFocus, canEscapeKeyClose: this.props.canEscapeKeyClear, canOutsideClickClose: false, className: classes, enforceFocus: false, hasBackdrop: false, inline: this.props.inline, isOpen: this.state.toasts.length > 0, onClose: this.handleClose, transitionDuration: 350, transitionName: "pt-toast" }, this.state.toasts.map(this.renderToast, this)));
	    };
	    Toaster.prototype.validateProps = function (props) {
	        if (props.position === position_1.Position.LEFT || props.position === position_1.Position.RIGHT) {
	            console.warn(errors_1.TOASTER_WARN_LEFT_RIGHT);
	        }
	    };
	    Toaster.prototype.renderToast = function (toast) {
	        return React.createElement(toast_1.Toast, tslib_1.__assign({}, toast, { onDismiss: this.getDismissHandler(toast) }));
	    };
	    Toaster.prototype.createToastOptions = function (props, key) {
	        if (key === void 0) { key = "toast-" + this.toastId++; }
	        // clone the object before adding the key prop to avoid leaking the mutation
	        return tslib_1.__assign({}, props, { key: key });
	    };
	    Toaster.prototype.getPositionClasses = function () {
	        var positions = position_1.Position[this.props.position].split("_");
	        // NOTE that there is no -center class because that's the default style
	        return positions.map(function (p) { return Classes.TOAST_CONTAINER + "-" + p.toLowerCase(); });
	    };
	    Toaster.defaultProps = {
	        autoFocus: false,
	        canEscapeKeyClear: true,
	        inline: false,
	        position: position_1.Position.TOP,
	    };
	    Toaster = Toaster_1 = tslib_1.__decorate([
	        PureRender
	    ], Toaster);
	    return Toaster;
	    var Toaster_1;
	}(abstractComponent_1.AbstractComponent));
	exports.Toaster = Toaster;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var tooltip_1 = __webpack_require__(307);
	var SVGTooltip = (function (_super) {
	    tslib_1.__extends(SVGTooltip, _super);
	    function SVGTooltip() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SVGTooltip.prototype.render = function () {
	        return (React.createElement(tooltip_1.Tooltip, tslib_1.__assign({ rootElementTag: "g" }, this.props), this.props.children));
	    };
	    return SVGTooltip;
	}(React.Component));
	exports.SVGTooltip = SVGTooltip;
	exports.SVGTooltipFactory = React.createFactory(SVGTooltip);


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
	 *
	 * Licensed under the terms of the LICENSE file distributed with this project.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(7);
	var classNames = __webpack_require__(6);
	var React = __webpack_require__(1);
	var Classes = __webpack_require__(8);
	var utils_1 = __webpack_require__(21);
	var treeNode_1 = __webpack_require__(456);
	var Tree = (function (_super) {
	    tslib_1.__extends(Tree, _super);
	    function Tree() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.nodeRefs = {};
	        _this.handleNodeCollapse = function (node, e) {
	            _this.handlerHelper(_this.props.onNodeCollapse, node, e);
	        };
	        _this.handleNodeClick = function (node, e) {
	            _this.handlerHelper(_this.props.onNodeClick, node, e);
	        };
	        _this.handleContentRef = function (node, element) {
	            if (element != null) {
	                _this.nodeRefs[node.props.id] = element;
	            }
	            else {
	                // don't want our object to get bloated with old keys
	                delete _this.nodeRefs[node.props.id];
	            }
	        };
	        _this.handleNodeContextMenu = function (node, e) {
	            _this.handlerHelper(_this.props.onNodeContextMenu, node, e);
	        };
	        _this.handleNodeDoubleClick = function (node, e) {
	            _this.handlerHelper(_this.props.onNodeDoubleClick, node, e);
	        };
	        _this.handleNodeExpand = function (node, e) {
	            _this.handlerHelper(_this.props.onNodeExpand, node, e);
	        };
	        return _this;
	    }
	    Tree.nodeFromPath = function (path, treeNodes) {
	        if (path.length === 1) {
	            return treeNodes[path[0]];
	        }
	        else {
	            return Tree.nodeFromPath(path.slice(1), treeNodes[path[0]].childNodes);
	        }
	    };
	    Tree.prototype.render = function () {
	        return (React.createElement("div", { className: classNames(Classes.TREE, this.props.className) }, this.renderNodes(this.props.contents, [], Classes.TREE_ROOT)));
	    };
	    /**
	     * Returns the underlying HTML element of the `Tree` node with an id of `nodeId`.
	     * This element does not contain the children of the node, only its label and controls.
	     * If the node is not currently mounted, `undefined` is returned.
	     */
	    Tree.prototype.getNodeContentElement = function (nodeId) {
	        return this.nodeRefs[nodeId];
	    };
	    Tree.prototype.renderNodes = function (treeNodes, currentPath, className) {
	        var _this = this;
	        if (treeNodes == null) {
	            return null;
	        }
	        var nodeItems = treeNodes.map(function (node, i) {
	            var elementPath = currentPath.concat(i);
	            return (React.createElement(treeNode_1.TreeNode, tslib_1.__assign({}, node, { key: node.id, contentRef: _this.handleContentRef, depth: elementPath.length - 1, onClick: _this.handleNodeClick, onContextMenu: _this.handleNodeContextMenu, onCollapse: _this.handleNodeCollapse, onDoubleClick: _this.handleNodeDoubleClick, onExpand: _this.handleNodeExpand, path: elementPath }), _this.renderNodes(node.childNodes, elementPath)));
	        });
	        return React.createElement("ul", { className: classNames(Classes.TREE_NODE_LIST, className) }, nodeItems);
	    };
	    Tree.prototype.handlerHelper = function (handlerFromProps, node, e) {
	        if (utils_1.isFunction(handlerFromProps)) {
	            var nodeData = Tree.nodeFromPath(node.props.path, this.props.contents);
	            handlerFromProps(nodeData, node.props.path, e);
	        }
	    };
	    return Tree;
	}(React.Component));
	exports.Tree = Tree;
	exports.TreeFactory = React.createFactory(Tree);


/***/ },
/* 755 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:object-literal-sort-keys
	exports.IconClasses = {
	    BLANK: "pt-icon-blank",
	    STYLE: "pt-icon-style",
	    ALIGN_LEFT: "pt-icon-align-left",
	    ALIGN_CENTER: "pt-icon-align-center",
	    ALIGN_RIGHT: "pt-icon-align-right",
	    ALIGN_JUSTIFY: "pt-icon-align-justify",
	    BOLD: "pt-icon-bold",
	    ITALIC: "pt-icon-italic",
	    UNDERLINE: "pt-icon-underline",
	    SEARCH_AROUND: "pt-icon-search-around",
	    GRAPH_REMOVE: "pt-icon-graph-remove",
	    GROUP_OBJECTS: "pt-icon-group-objects",
	    MERGE_LINKS: "pt-icon-merge-links",
	    LAYOUT: "pt-icon-layout",
	    LAYOUT_AUTO: "pt-icon-layout-auto",
	    LAYOUT_CIRCLE: "pt-icon-layout-circle",
	    LAYOUT_HIERARCHY: "pt-icon-layout-hierarchy",
	    LAYOUT_GRID: "pt-icon-layout-grid",
	    LAYOUT_GROUP_BY: "pt-icon-layout-group-by",
	    LAYOUT_SKEW_GRID: "pt-icon-layout-skew-grid",
	    GEOSEARCH: "pt-icon-geosearch",
	    HEATMAP: "pt-icon-heatmap",
	    DRIVE_TIME: "pt-icon-drive-time",
	    SELECT: "pt-icon-select",
	    PREDICTIVE_ANALYSIS: "pt-icon-predictive-analysis",
	    LAYERS: "pt-icon-layers",
	    LOCATE: "pt-icon-locate",
	    BOOKMARK: "pt-icon-bookmark",
	    CITATION: "pt-icon-citation",
	    TAG: "pt-icon-tag",
	    CLIPBOARD: "pt-icon-clipboard",
	    SELECTION: "pt-icon-selection",
	    TIMELINE_EVENTS: "pt-icon-timeline-events",
	    TIMELINE_LINE_CHART: "pt-icon-timeline-line-chart",
	    TIMELINE_BAR_CHART: "pt-icon-timeline-bar-chart",
	    APPLICATIONS: "pt-icon-applications",
	    PROJECTS: "pt-icon-projects",
	    CHANGES: "pt-icon-changes",
	    NOTIFICATIONS: "pt-icon-notifications",
	    LOCK: "pt-icon-lock",
	    UNLOCK: "pt-icon-unlock",
	    USER: "pt-icon-user",
	    SEARCH_TEMPLATE: "pt-icon-search-template",
	    INBOX: "pt-icon-inbox",
	    MORE: "pt-icon-more",
	    HELP: "pt-icon-help",
	    CALENDAR: "pt-icon-calendar",
	    MEDIA: "pt-icon-media",
	    LINK: "pt-icon-link",
	    SHARE: "pt-icon-share",
	    DOWNLOAD: "pt-icon-download",
	    DOCUMENT: "pt-icon-document",
	    PROPERTIES: "pt-icon-properties",
	    IMPORT: "pt-icon-import",
	    EXPORT: "pt-icon-export",
	    MINIMIZE: "pt-icon-minimize",
	    MAXIMIZE: "pt-icon-maximize",
	    TICK: "pt-icon-tick",
	    CROSS: "pt-icon-cross",
	    PLUS: "pt-icon-plus",
	    MINUS: "pt-icon-minus",
	    ARROW_LEFT: "pt-icon-arrow-left",
	    ARROW_RIGHT: "pt-icon-arrow-right",
	    EXCHANGE: "pt-icon-exchange",
	    COMPARISON: "pt-icon-comparison",
	    LIST: "pt-icon-list",
	    FILTER: "pt-icon-filter",
	    CONFIRM: "pt-icon-confirm",
	    FORK: "pt-icon-fork",
	    TRASH: "pt-icon-trash",
	    PERSON: "pt-icon-person",
	    PEOPLE: "pt-icon-people",
	    ADD: "pt-icon-add",
	    REMOVE: "pt-icon-remove",
	    GEOLOCATION: "pt-icon-geolocation",
	    ZOOM_IN: "pt-icon-zoom-in",
	    ZOOM_OUT: "pt-icon-zoom-out",
	    REFRESH: "pt-icon-refresh",
	    DELETE: "pt-icon-delete",
	    COG: "pt-icon-cog",
	    FLAG: "pt-icon-flag",
	    PIN: "pt-icon-pin",
	    WARNING_SIGN: "pt-icon-warning-sign",
	    ERROR: "pt-icon-error",
	    INFO_SIGN: "pt-icon-info-sign",
	    CREDIT_CARD: "pt-icon-credit-card",
	    EDIT: "pt-icon-edit",
	    HISTORY: "pt-icon-history",
	    SEARCH: "pt-icon-search",
	    LOG_OUT: "pt-icon-log-out",
	    STAR: "pt-icon-star",
	    STAR_EMPTY: "pt-icon-star-empty",
	    SORT_ALPHABETICAL: "pt-icon-sort-alphabetical",
	    SORT_NUMERICAL: "pt-icon-sort-numerical",
	    SORT: "pt-icon-sort",
	    FOLDER_OPEN: "pt-icon-folder-open",
	    FOLDER_CLOSE: "pt-icon-folder-close",
	    FOLDER_SHARED: "pt-icon-folder-shared",
	    CARET_UP: "pt-icon-caret-up",
	    CARET_RIGHT: "pt-icon-caret-right",
	    CARET_DOWN: "pt-icon-caret-down",
	    CARET_LEFT: "pt-icon-caret-left",
	    MENU_OPEN: "pt-icon-menu-open",
	    MENU_CLOSED: "pt-icon-menu-closed",
	    FEED: "pt-icon-feed",
	    TWO_COLUMNS: "pt-icon-two-columns",
	    ONE_COLUMN: "pt-icon-one-column",
	    DOT: "pt-icon-dot",
	    PROPERTY: "pt-icon-property",
	    TIME: "pt-icon-time",
	    DISABLE: "pt-icon-disable",
	    UNPIN: "pt-icon-unpin",
	    FLOWS: "pt-icon-flows",
	    NEW_TEXT_BOX: "pt-icon-new-text-box",
	    NEW_LINK: "pt-icon-new-link",
	    NEW_OBJECT: "pt-icon-new-object",
	    PATH_SEARCH: "pt-icon-path-search",
	    AUTOMATIC_UPDATES: "pt-icon-automatic-updates",
	    PAGE_LAYOUT: "pt-icon-page-layout",
	    CODE: "pt-icon-code",
	    MAP: "pt-icon-map",
	    SEARCH_TEXT: "pt-icon-search-text",
	    ENVELOPE: "pt-icon-envelope",
	    PAPERCLIP: "pt-icon-paperclip",
	    LABEL: "pt-icon-label",
	    GLOBE: "pt-icon-globe",
	    HOME: "pt-icon-home",
	    TH: "pt-icon-th",
	    TH_LIST: "pt-icon-th-list",
	    TH_DERIVED: "pt-icon-th-derived",
	    CIRCLE: "pt-icon-circle",
	    DRAW: "pt-icon-draw",
	    INSERT: "pt-icon-insert",
	    HELPER_MANAGEMENT: "pt-icon-helper-management",
	    SEND_TO: "pt-icon-send-to",
	    EYE_OPEN: "pt-icon-eye-open",
	    FOLDER_SHARED_OPEN: "pt-icon-folder-shared-open",
	    SOCIAL_MEDIA: "pt-icon-social-media",
	    ARROW_UP: "pt-icon-arrow-up",
	    ARROW_DOWN: "pt-icon-arrow-down",
	    ARROWS_HORIZONTAL: "pt-icon-arrows-horizontal",
	    ARROWS_VERTICAL: "pt-icon-arrows-vertical",
	    RESOLVE: "pt-icon-resolve",
	    GRAPH: "pt-icon-graph",
	    BRIEFCASE: "pt-icon-briefcase",
	    DOLLAR: "pt-icon-dollar",
	    NINJA: "pt-icon-ninja",
	    DELTA: "pt-icon-delta",
	    BARCODE: "pt-icon-barcode",
	    TORCH: "pt-icon-torch",
	    WIDGET: "pt-icon-widget",
	    UNRESOLVE: "pt-icon-unresolve",
	    OFFLINE: "pt-icon-offline",
	    ZOOM_TO_FIT: "pt-icon-zoom-to-fit",
	    ADD_TO_ARTIFACT: "pt-icon-add-to-artifact",
	    MAP_MARKER: "pt-icon-map-marker",
	    CHART: "pt-icon-chart",
	    CONTROL: "pt-icon-control",
	    MULTI_SELECT: "pt-icon-multi-select",
	    DIRECTION_LEFT: "pt-icon-direction-left",
	    DIRECTION_RIGHT: "pt-icon-direction-right",
	    DATABASE: "pt-icon-database",
	    PIE_CHART: "pt-icon-pie-chart",
	    FULL_CIRCLE: "pt-icon-full-circle",
	    SQUARE: "pt-icon-square",
	    PRINT: "pt-icon-print",
	    PRESENTATION: "pt-icon-presentation",
	    UNGROUP_OBJECTS: "pt-icon-ungroup-objects",
	    CHAT: "pt-icon-chat",
	    COMMENT: "pt-icon-comment",
	    CIRCLE_ARROW_RIGHT: "pt-icon-circle-arrow-right",
	    CIRCLE_ARROW_LEFT: "pt-icon-circle-arrow-left",
	    CIRCLE_ARROW_UP: "pt-icon-circle-arrow-up",
	    CIRCLE_ARROW_DOWN: "pt-icon-circle-arrow-down",
	    UPLOAD: "pt-icon-upload",
	    ASTERISK: "pt-icon-asterisk",
	    CLOUD: "pt-icon-cloud",
	    CLOUD_DOWNLOAD: "pt-icon-cloud-download",
	    CLOUD_UPLOAD: "pt-icon-cloud-upload",
	    REPEAT: "pt-icon-repeat",
	    MOVE: "pt-icon-move",
	    CHEVRON_LEFT: "pt-icon-chevron-left",
	    CHEVRON_RIGHT: "pt-icon-chevron-right",
	    CHEVRON_UP: "pt-icon-chevron-up",
	    CHEVRON_DOWN: "pt-icon-chevron-down",
	    RANDOM: "pt-icon-random",
	    FULLSCREEN: "pt-icon-fullscreen",
	    LOG_IN: "pt-icon-log-in",
	    HEART: "pt-icon-heart",
	    OFFICE: "pt-icon-office",
	    DUPLICATE: "pt-icon-duplicate",
	    BAN_CIRCLE: "pt-icon-ban-circle",
	    CAMERA: "pt-icon-camera",
	    MOBILE_VIDEO: "pt-icon-mobile-video",
	    VIDEO: "pt-icon-video",
	    FILM: "pt-icon-film",
	    SETTINGS: "pt-icon-settings",
	    VOLUME_OFF: "pt-icon-volume-off",
	    VOLUME_DOWN: "pt-icon-volume-down",
	    VOLUME_UP: "pt-icon-volume-up",
	    MUSIC: "pt-icon-music",
	    STEP_BACKWARD: "pt-icon-step-backward",
	    FAST_BACKWARD: "pt-icon-fast-backward",
	    PAUSE: "pt-icon-pause",
	    STOP: "pt-icon-stop",
	    PLAY: "pt-icon-play",
	    FAST_FORWARD: "pt-icon-fast-forward",
	    STEP_FORWARD: "pt-icon-step-forward",
	    EJECT: "pt-icon-eject",
	    RECORD: "pt-icon-record",
	    DESKTOP: "pt-icon-desktop",
	    PHONE: "pt-icon-phone",
	    LIGHTBULB: "pt-icon-lightbulb",
	    GLASS: "pt-icon-glass",
	    TINT: "pt-icon-tint",
	    FLASH: "pt-icon-flash",
	    FONT: "pt-icon-font",
	    HEADER: "pt-icon-header",
	    SAVED: "pt-icon-saved",
	    FLOPPY_DISK: "pt-icon-floppy-disk",
	    BOOK: "pt-icon-book",
	    HAND_RIGHT: "pt-icon-hand-right",
	    HAND_UP: "pt-icon-hand-up",
	    HAND_DOWN: "pt-icon-hand-down",
	    HAND_LEFT: "pt-icon-hand-left",
	    THUMBS_UP: "pt-icon-thumbs-up",
	    THUMBS_DOWN: "pt-icon-thumbs-down",
	    BOX: "pt-icon-box",
	    COMPRESSED: "pt-icon-compressed",
	    SHOPPING_CART: "pt-icon-shopping-cart",
	    SHOP: "pt-icon-shop",
	    LAYOUT_LINEAR: "pt-icon-layout-linear",
	    UNDO: "pt-icon-undo",
	    REDO: "pt-icon-redo",
	    CODE_BLOCK: "pt-icon-code-block",
	    DOUBLE_CARET_VERTICAL: "pt-icon-double-caret-vertical",
	    DOUBLE_CARET_HORIZONTAL: "pt-icon-double-caret-horizontal",
	    SORT_ALPHABETICAL_DESC: "pt-icon-sort-alphabetical-desc",
	    SORT_NUMERICAL_DESC: "pt-icon-sort-numerical-desc",
	    TAKE_ACTION: "pt-icon-take-action",
	    CONTRAST: "pt-icon-contrast",
	    EYE_OFF: "pt-icon-eye-off",
	    TIMELINE_AREA_CHART: "pt-icon-timeline-area-chart",
	    DOUGHNUT_CHART: "pt-icon-doughnut-chart",
	    LAYER: "pt-icon-layer",
	    GRID: "pt-icon-grid",
	    POLYGON_FILTER: "pt-icon-polygon-filter",
	    ADD_TO_FOLDER: "pt-icon-add-to-folder",
	    LAYOUT_BALLOON: "pt-icon-layout-balloon",
	    LAYOUT_SORTED_CLUSTERS: "pt-icon-layout-sorted-clusters",
	    SORT_ASC: "pt-icon-sort-asc",
	    SORT_DESC: "pt-icon-sort-desc",
	    SMALL_CROSS: "pt-icon-small-cross",
	    SMALL_TICK: "pt-icon-small-tick",
	    POWER: "pt-icon-power",
	    COLUMN_LAYOUT: "pt-icon-column-layout",
	    ARROW_TOP_LEFT: "pt-icon-arrow-top-left",
	    ARROW_TOP_RIGHT: "pt-icon-arrow-top-right",
	    ARROW_BOTTOM_RIGHT: "pt-icon-arrow-bottom-right",
	    ARROW_BOTTOM_LEFT: "pt-icon-arrow-bottom-left",
	    MUGSHOT: "pt-icon-mugshot",
	    HEADSET: "pt-icon-headset",
	    TEXT_HIGHLIGHT: "pt-icon-text-highlight",
	    HAND: "pt-icon-hand",
	    CHEVRON_BACKWARD: "pt-icon-chevron-backward",
	    CHEVRON_FORWARD: "pt-icon-chevron-forward",
	    ROTATE_DOCUMENT: "pt-icon-rotate-document",
	    ROTATE_PAGE: "pt-icon-rotate-page",
	    BADGE: "pt-icon-badge",
	    GRID_VIEW: "pt-icon-grid-view",
	    FUNCTION: "pt-icon-function",
	    WATERFALL_CHART: "pt-icon-waterfall-chart",
	    STACKED_CHART: "pt-icon-stacked-chart",
	    PULSE: "pt-icon-pulse",
	    NEW_PERSON: "pt-icon-new-person",
	    EXCLUDE_ROW: "pt-icon-exclude-row",
	    PIVOT_TABLE: "pt-icon-pivot-table",
	    SEGMENTED_CONTROL: "pt-icon-segmented-control",
	    HIGHLIGHT: "pt-icon-highlight",
	    FILTER_LIST: "pt-icon-filter-list",
	    CUT: "pt-icon-cut",
	    ANNOTATION: "pt-icon-annotation",
	    PIVOT: "pt-icon-pivot",
	    RING: "pt-icon-ring",
	    HEAT_GRID: "pt-icon-heat-grid",
	    GANTT_CHART: "pt-icon-gantt-chart",
	    VARIABLE: "pt-icon-variable",
	    MANUAL: "pt-icon-manual",
	    ADD_ROW_TOP: "pt-icon-add-row-top",
	    ADD_ROW_BOTTOM: "pt-icon-add-row-bottom",
	    ADD_COLUMN_LEFT: "pt-icon-add-column-left",
	    ADD_COLUMN_RIGHT: "pt-icon-add-column-right",
	    REMOVE_ROW_TOP: "pt-icon-remove-row-top",
	    REMOVE_ROW_BOTTOM: "pt-icon-remove-row-bottom",
	    REMOVE_COLUMN_LEFT: "pt-icon-remove-column-left",
	    REMOVE_COLUMN_RIGHT: "pt-icon-remove-column-right",
	    DOUBLE_CHEVRON_LEFT: "pt-icon-double-chevron-left",
	    DOUBLE_CHEVRON_RIGHT: "pt-icon-double-chevron-right",
	    DOUBLE_CHEVRON_UP: "pt-icon-double-chevron-up",
	    DOUBLE_CHEVRON_DOWN: "pt-icon-double-chevron-down",
	    KEY_CONTROL: "pt-icon-key-control",
	    KEY_COMMAND: "pt-icon-key-command",
	    KEY_SHIFT: "pt-icon-key-shift",
	    KEY_BACKSPACE: "pt-icon-key-backspace",
	    KEY_DELETE: "pt-icon-key-delete",
	    KEY_ESCAPE: "pt-icon-key-escape",
	    KEY_ENTER: "pt-icon-key-enter",
	    CALCULATOR: "pt-icon-calculator",
	    HORIZONTAL_BAR_CHART: "pt-icon-horizontal-bar-chart",
	    SMALL_PLUS: "pt-icon-small-plus",
	    SMALL_MINUS: "pt-icon-small-minus",
	    STEP_CHART: "pt-icon-step-chart",
	    EURO: "pt-icon-euro",
	    DRAG_HANDLE_VERTICAL: "pt-icon-drag-handle-vertical",
	    DRAG_HANDLE_HORIZONTAL: "pt-icon-drag-handle-horizontal",
	    MOBILE_PHONE: "pt-icon-mobile-phone",
	    SIM_CARD: "pt-icon-sim-card",
	    TRENDING_UP: "pt-icon-trending-up",
	    TRENDING_DOWN: "pt-icon-trending-down",
	    CURVED_RANGE_CHART: "pt-icon-curved-range-chart",
	    VERTICAL_BAR_CHART_DESC: "pt-icon-vertical-bar-chart-desc",
	    HORIZONTAL_BAR_CHART_DESC: "pt-icon-horizontal-bar-chart-desc",
	    DOCUMENT_OPEN: "pt-icon-document-open",
	    DOCUMENT_SHARE: "pt-icon-document-share",
	    HORIZONTAL_DISTRIBUTION: "pt-icon-horizontal-distribution",
	    VERTICAL_DISTRIBUTION: "pt-icon-vertical-distribution",
	    ALIGNMENT_LEFT: "pt-icon-alignment-left",
	    ALIGNMENT_VERTICAL_CENTER: "pt-icon-alignment-vertical-center",
	    ALIGNMENT_RIGHT: "pt-icon-alignment-right",
	    ALIGNMENT_TOP: "pt-icon-alignment-top",
	    ALIGNMENT_HORIZONTAL_CENTER: "pt-icon-alignment-horizontal-center",
	    ALIGNMENT_BOTTOM: "pt-icon-alignment-bottom",
	    GIT_PULL: "pt-icon-git-pull",
	    GIT_MERGE: "pt-icon-git-merge",
	    GIT_BRANCH: "pt-icon-git-branch",
	    GIT_COMMIT: "pt-icon-git-commit",
	    GIT_PUSH: "pt-icon-git-push",
	    BUILD: "pt-icon-build",
	    SYMBOL_CIRCLE: "pt-icon-symbol-circle",
	    SYMBOL_SQUARE: "pt-icon-symbol-square",
	    SYMBOL_DIAMOND: "pt-icon-symbol-diamond",
	    SYMBOL_CROSS: "pt-icon-symbol-cross",
	    SYMBOL_TRIANGLE_UP: "pt-icon-symbol-triangle-up",
	    SYMBOL_TRIANGLE_DOWN: "pt-icon-symbol-triangle-down",
	    WRENCH: "pt-icon-wrench",
	    APPLICATION: "pt-icon-application",
	    SEND_TO_GRAPH: "pt-icon-send-to-graph",
	    SEND_TO_MAP: "pt-icon-send-to-map",
	    JOIN_TABLE: "pt-icon-join-table",
	    DERIVE_COLUMN: "pt-icon-derive-column",
	    IMAGE_ROTATE_LEFT: "pt-icon-image-rotate-left",
	    IMAGE_ROTATE_RIGHT: "pt-icon-image-rotate-right",
	    KNOWN_VEHICLE: "pt-icon-known-vehicle",
	    UNKNOWN_VEHICLE: "pt-icon-unknown-vehicle",
	    SCATTER_PLOT: "pt-icon-scatter-plot",
	    OIL_FIELD: "pt-icon-oil-field",
	    RIG: "pt-icon-rig",
	    MAP_CREATE: "pt-icon-map-create",
	    KEY_OPTION: "pt-icon-key-option",
	    LIST_DETAIL_VIEW: "pt-icon-list-detail-view",
	    SWAP_VERTICAL: "pt-icon-swap-vertical",
	    SWAP_HORIZONTAL: "pt-icon-swap-horizontal",
	    NUMBERED_LIST: "pt-icon-numbered-list",
	    NEW_GRID_ITEM: "pt-icon-new-grid-item",
	    GIT_REPO: "pt-icon-git-repo",
	    GIT_NEW_BRANCH: "pt-icon-git-new-branch",
	    MANUALLY_ENTERED_DATA: "pt-icon-manually-entered-data",
	    AIRPLANE: "pt-icon-airplane",
	    MERGE_COLUMNS: "pt-icon-merge-columns",
	    SPLIT_COLUMNS: "pt-icon-split-columns",
	    DASHBOARD: "pt-icon-dashboard",
	    PUBLISH_FUNCTION: "pt-icon-publish-function",
	    PATH: "pt-icon-path",
	    MOON: "pt-icon-moon",
	    REMOVE_COLUMN: "pt-icon-remove-column",
	    NUMERICAL: "pt-icon-numerical",
	    KEY_TAB: "pt-icon-key-tab",
	    REGRESSION_CHART: "pt-icon-regression-chart",
	    TRANSLATE: "pt-icon-translate",
	    EYE_ON: "pt-icon-eye-on",
	    VERTICAL_BAR_CHART_ASC: "pt-icon-vertical-bar-chart-asc",
	    HORIZONTAL_BAR_CHART_ASC: "pt-icon-horizontal-bar-chart-asc",
	    GROUPED_BAR_CHART: "pt-icon-grouped-bar-chart",
	    FULL_STACKED_CHART: "pt-icon-full-stacked-chart",
	    ENDORSED: "pt-icon-endorsed",
	    FOLLOWER: "pt-icon-follower",
	    FOLLOWING: "pt-icon-following",
	    MENU: "pt-icon-menu",
	    COLLAPSE_ALL: "pt-icon-collapse-all",
	    EXPAND_ALL: "pt-icon-expand-all",
	    INTERSECTION: "pt-icon-intersection",
	    BLOCKED_PERSON: "pt-icon-blocked-person",
	    SLASH: "pt-icon-slash",
	    PERCENTAGE: "pt-icon-percentage",
	    SATELLITE: "pt-icon-satellite",
	    PARAGRAPH: "pt-icon-paragraph",
	    BANK_ACCOUNT: "pt-icon-bank-account",
	    CELL_TOWER: "pt-icon-cell-tower",
	    ID_NUMBER: "pt-icon-id-number",
	    IP_ADDRESS: "pt-icon-ip-address",
	    ERASER: "pt-icon-eraser",
	    ISSUE: "pt-icon-issue",
	    ISSUE_NEW: "pt-icon-issue-new",
	    ISSUE_CLOSED: "pt-icon-issue-closed",
	    PANEL_STATS: "pt-icon-panel-stats",
	    PANEL_TABLE: "pt-icon-panel-table",
	    TICK_CIRCLE: "pt-icon-tick-circle",
	    PRESCRIPTION: "pt-icon-prescription",
	    NEW_PRESCRIPTION: "pt-icon-new-prescription",
	    FILTER_KEEP: "pt-icon-filter-keep",
	    FILTER_REMOVE: "pt-icon-filter-remove",
	    KEY: "pt-icon-key",
	    FEED_SUBSCRIBED: "pt-icon-feed-subscribed",
	    WIDGET_BUTTON: "pt-icon-widget-button",
	    WIDGET_HEADER: "pt-icon-widget-header",
	    WIDGET_FOOTER: "pt-icon-widget-footer",
	    HEADER_ONE: "pt-icon-header-one",
	    HEADER_TWO: "pt-icon-header-two",
	    FORM: "pt-icon-form",
	    SERIES_ADD: "pt-icon-series-add",
	    SERIES_SEARCH: "pt-icon-series-search",
	    SERIES_FILTERED: "pt-icon-series-filtered",
	    SERIES_DERIVED: "pt-icon-series-derived",
	    SERIES_CONFIGURATION: "pt-icon-series-configuration",
	    CONSOLE: "pt-icon-console",
	    COMPASS: "pt-icon-compass",
	    WALK: "pt-icon-walk",
	    TAXI: "pt-icon-taxi",
	    TRAIN: "pt-icon-train",
	    HEART_BROKEN: "pt-icon-heart-broken",
	};


/***/ },
/* 756 */
/***/ function(module, exports) {

	"use strict";
	/*
	 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable:object-literal-sort-keys
	exports.IconContents = {
	    BLANK: "\ue900",
	    STYLE: "\ue601",
	    ALIGN_LEFT: "\ue602",
	    ALIGN_CENTER: "\ue603",
	    ALIGN_RIGHT: "\ue604",
	    ALIGN_JUSTIFY: "\ue605",
	    BOLD: "\ue606",
	    ITALIC: "\ue607",
	    UNDERLINE: "\u2381",
	    SEARCH_AROUND: "\ue608",
	    GRAPH_REMOVE: "\ue609",
	    GROUP_OBJECTS: "\ue60a",
	    MERGE_LINKS: "\ue60b",
	    LAYOUT: "\ue60c",
	    LAYOUT_AUTO: "\ue60d",
	    LAYOUT_CIRCLE: "\ue60e",
	    LAYOUT_HIERARCHY: "\ue60f",
	    LAYOUT_GRID: "\ue610",
	    LAYOUT_GROUP_BY: "\ue611",
	    LAYOUT_SKEW_GRID: "\ue612",
	    GEOSEARCH: "\ue613",
	    HEATMAP: "\ue614",
	    DRIVE_TIME: "\ue615",
	    SELECT: "\ue616",
	    PREDICTIVE_ANALYSIS: "\ue617",
	    LAYERS: "\ue618",
	    LOCATE: "\ue619",
	    BOOKMARK: "\ue61a",
	    CITATION: "\ue61b",
	    TAG: "\ue61c",
	    CLIPBOARD: "\ue61d",
	    SELECTION: "\u29bf",
	    TIMELINE_EVENTS: "\ue61e",
	    TIMELINE_LINE_CHART: "\ue61f",
	    TIMELINE_BAR_CHART: "\ue620",
	    APPLICATIONS: "\ue621",
	    PROJECTS: "\ue622",
	    CHANGES: "\ue623",
	    NOTIFICATIONS: "\ue624",
	    LOCK: "\ue625",
	    UNLOCK: "\ue626",
	    USER: "\ue627",
	    SEARCH_TEMPLATE: "\ue628",
	    INBOX: "\ue629",
	    MORE: "\ue62a",
	    HELP: "\u003F",
	    CALENDAR: "\ue62b",
	    MEDIA: "\ue62c",
	    LINK: "\ue62d",
	    SHARE: "\ue62e",
	    DOWNLOAD: "\ue62f",
	    DOCUMENT: "\ue630",
	    PROPERTIES: "\ue631",
	    IMPORT: "\ue632",
	    EXPORT: "\ue633",
	    MINIMIZE: "\ue634",
	    MAXIMIZE: "\ue635",
	    TICK: "\u2713",
	    CROSS: "\u2717",
	    PLUS: "\u002b",
	    MINUS: "\u2212",
	    ARROW_LEFT: "\u2190",
	    ARROW_RIGHT: "\u2192",
	    EXCHANGE: "\ue636",
	    COMPARISON: "\ue637",
	    LIST: "\u2630",
	    FILTER: "\ue638",
	    CONFIRM: "\ue639",
	    FORK: "\ue63a",
	    TRASH: "\ue63b",
	    PERSON: "\ue63c",
	    PEOPLE: "\ue63d",
	    ADD: "\ue63e",
	    REMOVE: "\ue63f",
	    GEOLOCATION: "\ue640",
	    ZOOM_IN: "\ue641",
	    ZOOM_OUT: "\ue642",
	    REFRESH: "\ue643",
	    DELETE: "\ue644",
	    COG: "\ue645",
	    FLAG: "\u2691",
	    PIN: "\ue646",
	    WARNING_SIGN: "\ue647",
	    ERROR: "\ue648",
	    INFO_SIGN: "\u2139",
	    CREDIT_CARD: "\ue649",
	    EDIT: "\u270E",
	    HISTORY: "\ue64a",
	    SEARCH: "\ue64b",
	    LOG_OUT: "\ue64c",
	    STAR: "\u2605",
	    STAR_EMPTY: "\u2606",
	    SORT_ALPHABETICAL: "\ue64d",
	    SORT_NUMERICAL: "\ue64e",
	    SORT: "\ue64f",
	    FOLDER_OPEN: "\ue651",
	    FOLDER_CLOSE: "\ue652",
	    FOLDER_SHARED: "\ue653",
	    CARET_UP: "\u2303",
	    CARET_RIGHT: "\u232A",
	    CARET_DOWN: "\u2304",
	    CARET_LEFT: "\u2329",
	    MENU_OPEN: "\ue654",
	    MENU_CLOSED: "\ue655",
	    FEED: "\ue656",
	    TWO_COLUMNS: "\ue657",
	    ONE_COLUMN: "\ue658",
	    DOT: "\u2022",
	    PROPERTY: "\ue65a",
	    TIME: "\u23F2",
	    DISABLE: "\ue600",
	    UNPIN: "\ue650",
	    FLOWS: "\ue659",
	    NEW_TEXT_BOX: "\ue65b",
	    NEW_LINK: "\ue65c",
	    NEW_OBJECT: "\ue65d",
	    PATH_SEARCH: "\ue65e",
	    AUTOMATIC_UPDATES: "\ue65f",
	    PAGE_LAYOUT: "\ue660",
	    CODE: "\ue661",
	    MAP: "\ue662",
	    SEARCH_TEXT: "\ue663",
	    ENVELOPE: "\u2709",
	    PAPERCLIP: "\ue664",
	    LABEL: "\ue665",
	    GLOBE: "\ue666",
	    HOME: "\u2302",
	    TH: "\ue667",
	    TH_LIST: "\ue668",
	    TH_DERIVED: "\ue669",
	    CIRCLE: "\ue66a",
	    DRAW: "\ue66b",
	    INSERT: "\ue66c",
	    HELPER_MANAGEMENT: "\ue66d",
	    SEND_TO: "\ue66e",
	    EYE_OPEN: "\ue66f",
	    FOLDER_SHARED_OPEN: "\ue670",
	    SOCIAL_MEDIA: "\ue671",
	    ARROW_UP: "\u2191 ",
	    ARROW_DOWN: "\u2193 ",
	    ARROWS_HORIZONTAL: "\u2194 ",
	    ARROWS_VERTICAL: "\u2195 ",
	    RESOLVE: "\ue672",
	    GRAPH: "\ue673",
	    BRIEFCASE: "\ue674",
	    DOLLAR: "\u0024",
	    NINJA: "\ue675",
	    DELTA: "\u0394",
	    BARCODE: "\ue676",
	    TORCH: "\ue677",
	    WIDGET: "\ue678",
	    UNRESOLVE: "\ue679",
	    OFFLINE: "\ue67a",
	    ZOOM_TO_FIT: "\ue67b",
	    ADD_TO_ARTIFACT: "\ue67c",
	    MAP_MARKER: "\ue67d",
	    CHART: "\ue67e",
	    CONTROL: "\ue67f",
	    MULTI_SELECT: "\ue680",
	    DIRECTION_LEFT: "\ue681",
	    DIRECTION_RIGHT: "\ue682",
	    DATABASE: "\ue683",
	    PIE_CHART: "\ue684",
	    FULL_CIRCLE: "\ue685",
	    SQUARE: "\ue686",
	    PRINT: "\u2399",
	    PRESENTATION: "\ue687",
	    UNGROUP_OBJECTS: "\ue688",
	    CHAT: "\ue689",
	    COMMENT: "\ue68a",
	    CIRCLE_ARROW_RIGHT: "\ue68b",
	    CIRCLE_ARROW_LEFT: "\ue68c",
	    CIRCLE_ARROW_UP: "\ue68d",
	    CIRCLE_ARROW_DOWN: "\ue68e",
	    UPLOAD: "\ue68f",
	    ASTERISK: "\u002a",
	    CLOUD: "\u2601",
	    CLOUD_DOWNLOAD: "\ue690",
	    CLOUD_UPLOAD: "\ue691",
	    REPEAT: "\ue692",
	    MOVE: "\ue693",
	    CHEVRON_LEFT: "\ue694",
	    CHEVRON_RIGHT: "\ue695",
	    CHEVRON_UP: "\ue696",
	    CHEVRON_DOWN: "\ue697",
	    RANDOM: "\ue698",
	    FULLSCREEN: "\ue699",
	    LOG_IN: "\ue69a",
	    HEART: "\u2665",
	    OFFICE: "\ue69b",
	    DUPLICATE: "\ue69c",
	    BAN_CIRCLE: "\ue69d",
	    CAMERA: "\ue69e",
	    MOBILE_VIDEO: "\ue69f",
	    VIDEO: "\ue6a0",
	    FILM: "\ue6a1",
	    SETTINGS: "\ue6a2",
	    VOLUME_OFF: "\ue6a3",
	    VOLUME_DOWN: "\ue6a4",
	    VOLUME_UP: "\ue6a5",
	    MUSIC: "\ue6a6",
	    STEP_BACKWARD: "\ue6a7",
	    FAST_BACKWARD: "\ue6a8",
	    PAUSE: "\ue6a9",
	    STOP: "\ue6aa",
	    PLAY: "\ue6ab",
	    FAST_FORWARD: "\ue6ac",
	    STEP_FORWARD: "\ue6ad",
	    EJECT: "\u23cf",
	    RECORD: "\ue6ae",
	    DESKTOP: "\ue6af",
	    PHONE: "\u260e",
	    LIGHTBULB: "\ue6b0",
	    GLASS: "\ue6b1",
	    TINT: "\ue6b2",
	    FLASH: "\ue6b3",
	    FONT: "\ue6b4",
	    HEADER: "\ue6b5",
	    SAVED: "\ue6b6",
	    FLOPPY_DISK: "\ue6b7",
	    BOOK: "\ue6b8",
	    HAND_RIGHT: "\ue6b9",
	    HAND_UP: "\ue6ba",
	    HAND_DOWN: "\ue6bb",
	    HAND_LEFT: "\ue6bc",
	    THUMBS_UP: "\ue6bd",
	    THUMBS_DOWN: "\ue6be",
	    BOX: "\ue6bf",
	    COMPRESSED: "\ue6c0",
	    SHOPPING_CART: "\ue6c1",
	    SHOP: "\ue6c2",
	    LAYOUT_LINEAR: "\ue6c3",
	    UNDO: "\u238c",
	    REDO: "\ue6c4",
	    CODE_BLOCK: "\ue6c5",
	    DOUBLE_CARET_VERTICAL: "\ue6c6",
	    DOUBLE_CARET_HORIZONTAL: "\ue6c7",
	    SORT_ALPHABETICAL_DESC: "\ue6c8",
	    SORT_NUMERICAL_DESC: "\ue6c9",
	    TAKE_ACTION: "\ue6ca",
	    CONTRAST: "\ue6cb",
	    EYE_OFF: "\ue6cc",
	    TIMELINE_AREA_CHART: "\ue6cd",
	    DOUGHNUT_CHART: "\ue6ce",
	    LAYER: "\ue6cf",
	    GRID: "\ue6d0",
	    POLYGON_FILTER: "\ue6d1",
	    ADD_TO_FOLDER: "\ue6d2",
	    LAYOUT_BALLOON: "\ue6d3",
	    LAYOUT_SORTED_CLUSTERS: "\ue6d4",
	    SORT_ASC: "\ue6d5",
	    SORT_DESC: "\ue6d6",
	    SMALL_CROSS: "\ue6d7",
	    SMALL_TICK: "\ue6d8",
	    POWER: "\ue6d9",
	    COLUMN_LAYOUT: "\ue6da",
	    ARROW_TOP_LEFT: "\u2196",
	    ARROW_TOP_RIGHT: "\u2197",
	    ARROW_BOTTOM_RIGHT: "\u2198",
	    ARROW_BOTTOM_LEFT: "\u2199",
	    MUGSHOT: "\ue6db",
	    HEADSET: "\ue6dc",
	    TEXT_HIGHLIGHT: "\ue6dd",
	    HAND: "\ue6de",
	    CHEVRON_BACKWARD: "\ue6df",
	    CHEVRON_FORWARD: "\ue6e0",
	    ROTATE_DOCUMENT: "\ue6e1",
	    ROTATE_PAGE: "\ue6e2",
	    BADGE: "\ue6e3",
	    GRID_VIEW: "\ue6e4",
	    FUNCTION: "\ue6e5",
	    WATERFALL_CHART: "\ue6e6",
	    STACKED_CHART: "\ue6e7",
	    PULSE: "\ue6e8",
	    NEW_PERSON: "\ue6e9",
	    EXCLUDE_ROW: "\ue6ea",
	    PIVOT_TABLE: "\ue6eb",
	    SEGMENTED_CONTROL: "\ue6ec",
	    HIGHLIGHT: "\ue6ed",
	    FILTER_LIST: "\ue6ee",
	    CUT: "\ue6ef",
	    ANNOTATION: "\ue6f0",
	    PIVOT: "\ue6f1",
	    RING: "\ue6f2",
	    HEAT_GRID: "\ue6f3",
	    GANTT_CHART: "\ue6f4",
	    VARIABLE: "\ue6f5",
	    MANUAL: "\ue6f6",
	    ADD_ROW_TOP: "\ue6f7",
	    ADD_ROW_BOTTOM: "\ue6f8",
	    ADD_COLUMN_LEFT: "\ue6f9",
	    ADD_COLUMN_RIGHT: "\ue6fa",
	    REMOVE_ROW_TOP: "\ue6fb",
	    REMOVE_ROW_BOTTOM: "\ue6fc",
	    REMOVE_COLUMN_LEFT: "\ue6fd",
	    REMOVE_COLUMN_RIGHT: "\ue6fe",
	    DOUBLE_CHEVRON_LEFT: "\ue6ff",
	    DOUBLE_CHEVRON_RIGHT: "\ue701",
	    DOUBLE_CHEVRON_UP: "\ue702",
	    DOUBLE_CHEVRON_DOWN: "\ue703",
	    KEY_CONTROL: "\ue704",
	    KEY_COMMAND: "\ue705",
	    KEY_SHIFT: "\ue706",
	    KEY_BACKSPACE: "\ue707",
	    KEY_DELETE: "\ue708",
	    KEY_ESCAPE: "\ue709",
	    KEY_ENTER: "\ue70a",
	    CALCULATOR: "\ue70b",
	    HORIZONTAL_BAR_CHART: "\ue70c",
	    SMALL_PLUS: "\ue70d",
	    SMALL_MINUS: "\ue70e",
	    STEP_CHART: "\ue70f",
	    EURO: "\u20ac",
	    DRAG_HANDLE_VERTICAL: "\ue715",
	    DRAG_HANDLE_HORIZONTAL: "\ue716",
	    MOBILE_PHONE: "\ue717",
	    SIM_CARD: "\ue718",
	    TRENDING_UP: "\ue719",
	    TRENDING_DOWN: "\ue71a",
	    CURVED_RANGE_CHART: "\ue71b",
	    VERTICAL_BAR_CHART_DESC: "\ue71c",
	    HORIZONTAL_BAR_CHART_DESC: "\ue71d",
	    DOCUMENT_OPEN: "\ue71e",
	    DOCUMENT_SHARE: "\ue71f",
	    HORIZONTAL_DISTRIBUTION: "\ue720",
	    VERTICAL_DISTRIBUTION: "\ue721",
	    ALIGNMENT_LEFT: "\ue722",
	    ALIGNMENT_VERTICAL_CENTER: "\ue723",
	    ALIGNMENT_RIGHT: "\ue724",
	    ALIGNMENT_TOP: "\ue725",
	    ALIGNMENT_HORIZONTAL_CENTER: "\ue726",
	    ALIGNMENT_BOTTOM: "\ue727",
	    GIT_PULL: "\ue728",
	    GIT_MERGE: "\ue729",
	    GIT_BRANCH: "\ue72a",
	    GIT_COMMIT: "\ue72b",
	    GIT_PUSH: "\ue72c",
	    BUILD: "\ue72d",
	    SYMBOL_CIRCLE: "\ue72e",
	    SYMBOL_SQUARE: "\ue72f",
	    SYMBOL_DIAMOND: "\ue730",
	    SYMBOL_CROSS: "\ue731",
	    SYMBOL_TRIANGLE_UP: "\ue732",
	    SYMBOL_TRIANGLE_DOWN: "\ue733",
	    WRENCH: "\ue734",
	    APPLICATION: "\ue735",
	    SEND_TO_GRAPH: "\ue736",
	    SEND_TO_MAP: "\ue737",
	    JOIN_TABLE: "\ue738",
	    DERIVE_COLUMN: "\ue739",
	    IMAGE_ROTATE_LEFT: "\ue73a",
	    IMAGE_ROTATE_RIGHT: "\ue73b",
	    KNOWN_VEHICLE: "\ue73c",
	    UNKNOWN_VEHICLE: "\ue73d",
	    SCATTER_PLOT: "\ue73e",
	    OIL_FIELD: "\ue73f",
	    RIG: "\ue740",
	    MAP_CREATE: "\ue741",
	    KEY_OPTION: "\ue742",
	    LIST_DETAIL_VIEW: "\ue743",
	    SWAP_VERTICAL: "\ue744",
	    SWAP_HORIZONTAL: "\ue745",
	    NUMBERED_LIST: "\ue746",
	    NEW_GRID_ITEM: "\ue747",
	    GIT_REPO: "\ue748",
	    GIT_NEW_BRANCH: "\ue749",
	    MANUALLY_ENTERED_DATA: "\ue74a",
	    AIRPLANE: "\ue74b",
	    MERGE_COLUMNS: "\ue74f",
	    SPLIT_COLUMNS: "\ue750",
	    DASHBOARD: "\ue751",
	    PUBLISH_FUNCTION: "\ue752",
	    PATH: "\ue753",
	    MOON: "\ue754",
	    REMOVE_COLUMN: "\ue755",
	    NUMERICAL: "\ue756",
	    KEY_TAB: "\ue757",
	    REGRESSION_CHART: "\ue758",
	    TRANSLATE: "\ue759",
	    EYE_ON: "\ue75a",
	    VERTICAL_BAR_CHART_ASC: "\ue75b",
	    HORIZONTAL_BAR_CHART_ASC: "\ue75c",
	    GROUPED_BAR_CHART: "\ue75d",
	    FULL_STACKED_CHART: "\ue75e",
	    ENDORSED: "\ue75f",
	    FOLLOWER: "\ue760",
	    FOLLOWING: "\ue761",
	    MENU: "\ue762",
	    COLLAPSE_ALL: "\ue763",
	    EXPAND_ALL: "\ue764",
	    INTERSECTION: "\ue765",
	    BLOCKED_PERSON: "\ue768",
	    SLASH: "\ue769",
	    PERCENTAGE: "\ue76a",
	    SATELLITE: "\ue76b",
	    PARAGRAPH: "\ue76c",
	    BANK_ACCOUNT: "\ue76f",
	    CELL_TOWER: "\ue770",
	    ID_NUMBER: "\ue771",
	    IP_ADDRESS: "\ue772",
	    ERASER: "\ue773",
	    ISSUE: "\ue774",
	    ISSUE_NEW: "\ue775",
	    ISSUE_CLOSED: "\ue776",
	    PANEL_STATS: "\ue777",
	    PANEL_TABLE: "\ue778",
	    TICK_CIRCLE: "\ue779",
	    PRESCRIPTION: "\ue78a",
	    NEW_PRESCRIPTION: "\ue78b",
	    FILTER_KEEP: "\ue78c",
	    FILTER_REMOVE: "\ue78d",
	    KEY: "\ue78e",
	    FEED_SUBSCRIBED: "\ue78f",
	    WIDGET_BUTTON: "\ue790",
	    WIDGET_HEADER: "\ue791",
	    WIDGET_FOOTER: "\ue792",
	    HEADER_ONE: "\ue793",
	    HEADER_TWO: "\ue794",
	    FORM: "\ue795",
	    SERIES_ADD: "\ue796",
	    SERIES_SEARCH: "\ue797",
	    SERIES_FILTERED: "\ue798",
	    SERIES_DERIVED: "\ue799",
	    SERIES_CONFIGURATION: "\ue79a",
	    CONSOLE: "\ue79b",
	    COMPASS: "\ue79c",
	    WALK: "\ue79d",
	    TAXI: "\ue79e",
	    TRAIN: "\ue79f",
	    HEART_BROKEN: "\ue7a2",
	};


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 758 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ },
/* 759 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAssociate = getAssociate;
	exports.addAssociate = addAssociate;
	exports.createNewAssociate = createNewAssociate;
	exports.promoteAssociate = promoteAssociate;
	exports.removeAssociate = removeAssociate;
	
	var _without = __webpack_require__(398);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _concat = __webpack_require__(281);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _baseActions = __webpack_require__(34);
	
	var _associateService = __webpack_require__(952);
	
	var _associateService2 = _interopRequireDefault(_associateService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getAssociate(storeId, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _associateService2.default.get(storeId),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'associates',
	      path: path
	    }
	  });
	}
	
	function addAssociate(storeId, data, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _associateService2.default.add(storeId, data),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'associates',
	      path: path,
	      callback: function callback(state, result) {
	        return (0, _concat2.default)(state, [result]);
	      }
	    }
	  });
	}
	
	function createNewAssociate(storeId, data, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _associateService2.default.create(storeId, data),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'associates',
	      path: path,
	      callback: function callback(state, result) {
	        return (0, _concat2.default)(state, [result]);
	      }
	    }
	  });
	}
	
	function promoteAssociate(storeId, id, role_id, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _associateService2.default.promote(storeId, id, role_id),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'associates',
	      path: path,
	      callback: function callback(state, result) {
	        return state;
	      }
	    }
	  });
	}
	
	function removeAssociate(storeId, id, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _associateService2.default.remove(storeId, id),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'associates',
	      path: path,
	      callback: function callback(state, result) {
	        return (0, _without2.default)(state, result);
	      }
	    }
	  });
	}

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCollection = exports.GET_BILL_OF_MATERIALS_COLLECTION_FAILURE = exports.GET_BILL_OF_MATERIALS_COLLECTION_SUCCESS = exports.GET_BILL_OF_MATERIALS_COLLECTION_REQUEST = undefined;
	
	var _humps = __webpack_require__(44);
	
	var _billOfMaterialsService = __webpack_require__(953);
	
	var _billOfMaterialsService2 = _interopRequireDefault(_billOfMaterialsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_BILL_OF_MATERIALS_COLLECTION_REQUEST = exports.GET_BILL_OF_MATERIALS_COLLECTION_REQUEST = 'GET_BILL_OF_MATERIALS_COLLECTION_REQUEST';
	var GET_BILL_OF_MATERIALS_COLLECTION_SUCCESS = exports.GET_BILL_OF_MATERIALS_COLLECTION_SUCCESS = 'GET_BILL_OF_MATERIALS_COLLECTION_SUCCESS';
	var GET_BILL_OF_MATERIALS_COLLECTION_FAILURE = exports.GET_BILL_OF_MATERIALS_COLLECTION_FAILURE = 'GET_BILL_OF_MATERIALS_COLLECTION_FAILURE';
	
	var getCollection = exports.getCollection = function getCollection(listingId, storeId) {
	  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  return function (dispatch) {
	    if (Array.isArray(listingId)) {
	      var promises = listingId.map(function (id) {
	        return _billOfMaterialsService2.default.getCollections(id, storeId, deep).then(function (resp) {
	          resp = (0, _humps.camelizeKeys)(resp);
	          var data = resp.billOfMaterials;
	          if (data) {
	            return { id: id, data: data };
	          } else {
	            var error = new Error('Invalid response.');
	            return { id: id, error: error };
	          }
	        });
	      });
	      return Promise.all(promises).then(function (resp) {
	        var bomMap = {};
	        var hasError = void 0;
	        resp.forEach(function (d) {
	          var id = d.id,
	              data = d.data,
	              error = d.error;
	
	          bomMap[id] = data;
	          hasError = hasError || error;
	        });
	        return { data: bomMap, error: hasError };
	      }).catch(function (error) {
	        return { error: error };
	      });
	    } else {
	      return _billOfMaterialsService2.default.getCollections(listingId, storeId, deep).then(function (resp) {
	        resp = (0, _humps.camelizeKeys)(resp);
	        var data = resp.billOfMaterials;
	        if (data) {
	          return { data: data };
	        } else {
	          var error = new Error('Invalid response.');
	          return { error: error };
	        }
	      }).catch(function (error) {
	        return { error: error };
	      });
	    }
	  };
	};

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paymentRefund = exports.fileImporter = exports.stationOverview = exports.statusSelection = exports.kitchenDepartmentSelection = exports.departmentSelection = undefined;
	
	var _departmentSelection = __webpack_require__(118);
	
	var departmentSelection = _interopRequireWildcard(_departmentSelection);
	
	var _kitchenDepartmentSelection = __webpack_require__(150);
	
	var kitchenDepartmentSelection = _interopRequireWildcard(_kitchenDepartmentSelection);
	
	var _statusSelection = __webpack_require__(225);
	
	var statusSelection = _interopRequireWildcard(_statusSelection);
	
	var _stationOverview = __webpack_require__(310);
	
	var stationOverview = _interopRequireWildcard(_stationOverview);
	
	var _fileImporter = __webpack_require__(309);
	
	var fileImporter = _interopRequireWildcard(_fileImporter);
	
	var _paymentRefund = __webpack_require__(181);
	
	var paymentRefund = _interopRequireWildcard(_paymentRefund);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.departmentSelection = departmentSelection;
	exports.kitchenDepartmentSelection = kitchenDepartmentSelection;
	exports.statusSelection = statusSelection;
	exports.stationOverview = stationOverview;
	exports.fileImporter = fileImporter;
	exports.paymentRefund = paymentRefund;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOtherPaymentInstrument = getOtherPaymentInstrument;
	exports.updateOtherPaymentInstrument = updateOtherPaymentInstrument;
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _baseActions = __webpack_require__(34);
	
	var _otherPaymentInstrumentService = __webpack_require__(325);
	
	var _otherPaymentInstrumentService2 = _interopRequireDefault(_otherPaymentInstrumentService);
	
	var _normalizr = __webpack_require__(64);
	
	var _schema = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getOtherPaymentInstrument(storeId, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _otherPaymentInstrumentService2.default.getAll(storeId).then(function (res) {
	      return (0, _normalizr.normalize)(res.payment_instruments, (0, _normalizr.arrayOf)(_schema.PaymentSchema));
	    }),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'payment_instruments',
	      path: path
	    }
	  });
	}
	
	function updateOtherPaymentInstrument(storeId, data, path) {
	  return _defineProperty({}, _handlePromiseMiddleware.HANDLE_PROMISE, {
	    promise: _otherPaymentInstrumentService2.default.updateAll(storeId, data).then(function (res) {
	      return (0, _normalizr.normalize)(res.payment_instruments, (0, _normalizr.arrayOf)(_schema.PaymentSchema));
	    }),
	    actions: {
	      type: _baseActions.SET_PATH_STATE,
	      stateName: 'payment_instruments',
	      path: path
	    }
	  });
	}

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkUpDisplay = exports.LINK_UP_QUEUEING_DISPLAY_FAILURE = exports.LINK_UP_QUEUEING_DISPLAY_SUCCESS = exports.LINK_UP_QUEUEING_DISPLAY_REQUEST = undefined;
	
	var _humps = __webpack_require__(44);
	
	var _queueingDisplayService = __webpack_require__(964);
	
	var _queueingDisplayService2 = _interopRequireDefault(_queueingDisplayService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LINK_UP_QUEUEING_DISPLAY_REQUEST = exports.LINK_UP_QUEUEING_DISPLAY_REQUEST = 'LINK_UP_QUEUEING_DISPLAY_REQUEST';
	var LINK_UP_QUEUEING_DISPLAY_SUCCESS = exports.LINK_UP_QUEUEING_DISPLAY_SUCCESS = 'LINK_UP_QUEUEING_DISPLAY_SUCCESS';
	var LINK_UP_QUEUEING_DISPLAY_FAILURE = exports.LINK_UP_QUEUEING_DISPLAY_FAILURE = 'LINK_UP_QUEUEING_DISPLAY_FAILURE';
	
	var linkUpDisplay = exports.linkUpDisplay = function linkUpDisplay(key, storeId) {
	  return function (dispatch) {
	    dispatch({ type: LINK_UP_QUEUEING_DISPLAY_REQUEST });
	    return _queueingDisplayService2.default.linkUpDisplay(key, storeId).then(function (resp) {
	      var station = resp.station;
	
	      if (station) {
	        var data = (0, _humps.camelizeKeys)(station);
	        dispatch({ type: LINK_UP_QUEUEING_DISPLAY_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error(resp.message);
	        dispatch({ type: LINK_UP_QUEUEING_DISPLAY_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: LINK_UP_QUEUEING_DISPLAY_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.refresh = exports.remove = exports.update = exports.create = exports.get = exports.REFRESH_QUEUEING_DISPLAY_FAILURE = exports.REFRESH_QUEUEING_DISPLAY_SUCCESS = exports.REFRESH_QUEUEING_DISPLAY_REQUEST = exports.REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.REMOVE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.REMOVE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.UPDATE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.UPDATE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.CREATE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.CREATE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.CREATE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.GET_TABLE_SIZE_SEGMENTATION_FAILURE = exports.GET_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.GET_TABLE_SIZE_SEGMENTATION_REQUEST = undefined;
	
	var _humps = __webpack_require__(44);
	
	var _tableSizeSegmentationService = __webpack_require__(967);
	
	var _tableSizeSegmentationService2 = _interopRequireDefault(_tableSizeSegmentationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_TABLE_SIZE_SEGMENTATION_REQUEST = exports.GET_TABLE_SIZE_SEGMENTATION_REQUEST = 'GET_TABLE_SIZE_SEGMENTATION_REQUEST';
	var GET_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.GET_TABLE_SIZE_SEGMENTATION_SUCCESS = 'GET_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var GET_TABLE_SIZE_SEGMENTATION_FAILURE = exports.GET_TABLE_SIZE_SEGMENTATION_FAILURE = 'GET_TABLE_SIZE_SEGMENTATION_FAILURE';
	var CREATE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.CREATE_TABLE_SIZE_SEGMENTATION_REQUEST = 'CREATE_TABLE_SIZE_SEGMENTATION_REQUEST';
	var CREATE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.CREATE_TABLE_SIZE_SEGMENTATION_SUCCESS = 'CREATE_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var CREATE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.CREATE_TABLE_SIZE_SEGMENTATION_FAILURE = 'CREATE_TABLE_SIZE_SEGMENTATION_FAILURE';
	var UPDATE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.UPDATE_TABLE_SIZE_SEGMENTATION_REQUEST = 'UPDATE_TABLE_SIZE_SEGMENTATION_REQUEST';
	var UPDATE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.UPDATE_TABLE_SIZE_SEGMENTATION_SUCCESS = 'UPDATE_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE = 'UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE';
	var REMOVE_TABLE_SIZE_SEGMENTATION_REQUEST = exports.REMOVE_TABLE_SIZE_SEGMENTATION_REQUEST = 'REMOVE_TABLE_SIZE_SEGMENTATION_REQUEST';
	var REMOVE_TABLE_SIZE_SEGMENTATION_SUCCESS = exports.REMOVE_TABLE_SIZE_SEGMENTATION_SUCCESS = 'REMOVE_TABLE_SIZE_SEGMENTATION_SUCCESS';
	var REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE = exports.REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE = 'REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE';
	var REFRESH_QUEUEING_DISPLAY_REQUEST = exports.REFRESH_QUEUEING_DISPLAY_REQUEST = 'REFRESH_QUEUEING_DISPLAY_REQUEST';
	var REFRESH_QUEUEING_DISPLAY_SUCCESS = exports.REFRESH_QUEUEING_DISPLAY_SUCCESS = 'REFRESH_QUEUEING_DISPLAY_SUCCESS';
	var REFRESH_QUEUEING_DISPLAY_FAILURE = exports.REFRESH_QUEUEING_DISPLAY_FAILURE = 'REFRESH_QUEUEING_DISPLAY_FAILURE';
	var get = exports.get = function get(storeId) {
	  return function (dispatch) {
	    dispatch({ type: GET_TABLE_SIZE_SEGMENTATION_REQUEST });
	    return _tableSizeSegmentationService2.default.get(storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.partySizeSegment;
	      if (data) {
	        dispatch({ type: GET_TABLE_SIZE_SEGMENTATION_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: GET_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: GET_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	var create = exports.create = function create(data, storeId) {
	  return function (dispatch) {
	    dispatch({ type: CREATE_TABLE_SIZE_SEGMENTATION_REQUEST });
	    return _tableSizeSegmentationService2.default.create((0, _humps.decamelizeKeys)(data), storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.partySizeSegment;
	      if (data) {
	        dispatch({ type: CREATE_TABLE_SIZE_SEGMENTATION_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: CREATE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: CREATE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	var update = exports.update = function update(data, storeId) {
	  return function (dispatch) {
	    dispatch({ type: UPDATE_TABLE_SIZE_SEGMENTATION_REQUEST });
	    return _tableSizeSegmentationService2.default.update((0, _humps.decamelizeKeys)(data), storeId).then(function (resp) {
	      resp = (0, _humps.camelizeKeys)(resp);
	      var data = resp.partySizeSegment;
	      if (data) {
	        dispatch({ type: UPDATE_TABLE_SIZE_SEGMENTATION_SUCCESS, data: data });
	        return { data: data };
	      } else {
	        var error = new Error('Invalid response');
	        dispatch({ type: UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      }
	    }).catch(function (error) {
	      dispatch({ type: UPDATE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	var remove = exports.remove = function remove(storeId) {
	  return function (dispatch) {
	    dispatch({ type: REMOVE_TABLE_SIZE_SEGMENTATION_REQUEST });
	    return _tableSizeSegmentationService2.default.remove(storeId).then(function (resp) {
	      var message = resp.message;
	
	      if (message === 'success') {
	        dispatch({ type: REMOVE_TABLE_SIZE_SEGMENTATION_SUCCESS });
	        return {};
	      } else {
	        var error = new Error(message);
	        dispatch({ type: REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	        return { error: error };
	      }
	    }).catch(function (error) {
	      dispatch({ type: REMOVE_TABLE_SIZE_SEGMENTATION_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};
	var refresh = exports.refresh = function refresh(storeId) {
	  return function (dispatch) {
	    dispatch({ type: REFRESH_QUEUEING_DISPLAY_REQUEST });
	    return _tableSizeSegmentationService2.default.refresh(storeId).then(function (resp) {
	      dispatch({ type: REFRESH_QUEUEING_DISPLAY_SUCCESS });
	      return {};
	    }).catch(function (error) {
	      dispatch({ type: REFRESH_QUEUEING_DISPLAY_FAILURE, error: error });
	      return { error: error };
	    });
	  };
	};

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _addListingByBarcode = __webpack_require__(460);
	
	var actions = _interopRequireWildcard(_addListingByBarcode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProp(state, ownProps) {
	  var thisState = state.forms.addListingByBarcode;
	  return _extends({}, thisState, ownProps);
	}
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var AddListingByBarcode = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(AddListingByBarcode, _Component);
	
	  function AddListingByBarcode() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddListingByBarcode);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddListingByBarcode.__proto__ || Object.getPrototypeOf(AddListingByBarcode)).call.apply(_ref, [this].concat(args))), _this), _this.handleSearch = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var _this$props = _this.props,
	          value = _this$props.value,
	          storeId = _this$props.storeId,
	          baseSearch = _this$props.baseSearch,
	          onAdd = _this$props.onAdd;
	
	      _this.props.actions.submit(value, storeId, baseSearch).then(function (resp) {
	        var data = resp.data,
	            error = resp.error;
	
	        if (!error) onAdd(data.slice());
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddListingByBarcode, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          value = _props.value,
	          disabled = _props.disabled,
	          isSearching = _props.isSearching;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-block' } },
	        _react2.default.createElement(
	          'form',
	          { className: 'form-inline', onSubmit: this.handleSearch },
	          _react2.default.createElement('input', { onChange: function onChange(e) {
	              return actions.changeInput(e.target.value);
	            },
	            type: 'text',
	            value: value,
	            placeholder: 'UPC/EAN/PLU/SKU',
	            disabled: disabled || isSearching }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              type: 'button',
	              onClick: this.handleSearch,
	              disabled: disabled || isSearching },
	            'Enter'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddListingByBarcode;
	}(_react.Component), _class2.propTypes = {
	  storeId: _propTypes2.default.string.isRequired,
	  onAdd: _propTypes2.default.func.isRequired,
	  disabled: _propTypes2.default.bool,
	  isSearching: _propTypes2.default.bool.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  baseSearch: _propTypes2.default.shape({
	    query: _propTypes2.default.object,
	    wildcard: _propTypes2.default.object,
	    range: _propTypes2.default.object,
	    missing: _propTypes2.default.object,
	    fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    sort: _propTypes2.default.arrayOf(_propTypes2.default.object)
	  })
	}, _class2.defaultProps = {
	  disabled: false
	}, _temp2)) || _class);
	exports.default = AddListingByBarcode;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Action(_ref) {
	  var text = _ref.text,
	      _onClick = _ref.onClick,
	      action = _ref.action;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'action',
	      onClick: function onClick() {
	        _onClick(action);
	      } },
	    text
	  );
	}
	
	Action.propTypes = {
	  text: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  action: _propTypes2.default.string
	};
	
	exports.default = Action;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPopper = __webpack_require__(670);
	
	__webpack_require__(1233);
	
	var _core = __webpack_require__(89);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ActionMenu(_ref) {
	  var active = _ref.active,
	      onToggle = _ref.onToggle,
	      onActionClick = _ref.onActionClick,
	      children = _ref.children,
	      target = _ref.target;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'action-menu' },
	    _react2.default.createElement(
	      _reactPopper.Manager,
	      { className: 'wrapper' },
	      _react2.default.createElement(
	        _reactPopper.Target,
	        null,
	        _react2.default.createElement(_core.Button, { text: 'Action', rightIconName: 'caret-down', onClick: function onClick() {
	            return onToggle(target);
	          } })
	      ),
	      active === target ? _react2.default.createElement(
	        _reactPopper.Popper,
	        { placement: 'bottom', className: 'popper' },
	        _react2.default.Children.toArray(children).map(function (child, idx) {
	          return _react2.default.createElement(child.type, _extends({ key: idx }, child.props, { onClick: function onClick(action) {
	              return onActionClick(target, action);
	            } }));
	        }),
	        _react2.default.createElement(
	          _reactPopper.Arrow,
	          { className: 'popper__arrow' },
	          _react2.default.createElement(_core.Icon, { iconName: 'caret-up' })
	        )
	      ) : null
	    ),
	    active ? _react2.default.createElement('div', { className: (0, _classnames2.default)('screen', { active: active }), onClick: function onClick() {
	        return onToggle(null);
	      } }) : null
	  );
	}
	
	ActionMenu.propTypes = {
	  active: _propTypes2.default.object,
	  onToggle: _propTypes2.default.func,
	  onActionClick: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  target: _propTypes2.default.object
	};
	
	exports.default = ActionMenu;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Callout(_ref) {
	  var error = _ref.error;
	
	  return error ? _react2.default.createElement(
	    "div",
	    { className: "pt-callout pt-intent-danger" },
	    "Error: ",
	    error.message
	  ) : null;
	}
	
	exports.default = Callout;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DialogButtonGroup(_ref) {
	  var onSave = _ref.onSave,
	      onCancel = _ref.onCancel;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'align-right', style: { paddingTop: 10 } },
	    _react2.default.createElement(_core.Button, { text: 'Cancel', onClick: onCancel, style: { marginRight: 10, width: 65 } }),
	    _react2.default.createElement(_core.Button, { text: 'Save', intent: _core.Intent.PRIMARY, onClick: onSave, style: { width: 65 } })
	  );
	}
	
	DialogButtonGroup.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	};
	
	exports.default = DialogButtonGroup;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopContainer = function (_React$Component) {
	  _inherits(PopContainer, _React$Component);
	
	  function PopContainer(props) {
	    _classCallCheck(this, PopContainer);
	
	    var _this = _possibleConstructorReturn(this, (PopContainer.__proto__ || Object.getPrototypeOf(PopContainer)).call(this, props));
	
	    _this.open = _this.open.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.state = {
	      content: null
	    };
	    return _this;
	  }
	
	  _createClass(PopContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        open: this.open,
	        close: this.close
	      };
	    }
	  }, {
	    key: 'open',
	    value: function open(state) {
	      this.setState(state);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({ content: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	      var _state = this.state,
	          content = _state.content,
	          props = _objectWithoutProperties(_state, ['content']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        children,
	        _react2.default.createElement(
	          _core.Dialog,
	          _extends({
	            isOpen: this.state.content !== null
	          }, props),
	          content
	        )
	      );
	    }
	  }]);
	
	  return PopContainer;
	}(_react2.default.Component);
	
	PopContainer.childContextTypes = {
	  open: _propTypes2.default.func,
	  close: _propTypes2.default.func
	};
	
	PopContainer.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired
	};
	
	exports.default = PopContainer;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopRender = function (_React$Component) {
	  _inherits(PopRender, _React$Component);
	
	  function PopRender(props) {
	    _classCallCheck(this, PopRender);
	
	    var _this = _possibleConstructorReturn(this, (PopRender.__proto__ || Object.getPrototypeOf(PopRender)).call(this, props));
	
	    _this.getState = _this.getState.bind(_this);
	    return _this;
	  }
	
	  _createClass(PopRender, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isOpen) this.context.open(this.getState(this.props));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isOpen && !this.props.isOpen) {
	        this.context.open(this.getState(nextProps));
	      } else if (!nextProps.isOpen && this.props.isOpen) {
	        this.context.close();
	      } else if (nextProps.isOpen && this.props.isOpen && nextProps.children !== this.props.children) {
	        this.context.open(this.getState(nextProps));
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.close();
	    }
	  }, {
	    key: 'getState',
	    value: function getState(props) {
	      return {
	        onClose: props.onClose,
	        content: props.children,
	        className: props.className,
	        title: props.title,
	        style: props.style
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PopRender;
	}(_react2.default.Component);
	
	PopRender.contextTypes = {
	  open: _propTypes2.default.func,
	  close: _propTypes2.default.func
	};
	
	PopRender.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  children: _propTypes2.default.element.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = PopRender;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Col = Col;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(89);
	
	__webpack_require__(1234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeRenders = {
	  value: function value(_value) {
	    return _value;
	  },
	  tick: function tick(value) {
	    return value ? _react2.default.createElement(_core.Icon, { iconName: 'tick' }) : null;
	  }
	};
	
	function Table(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  var cols = _react2.default.Children.toArray(children);
	  var headers = cols.map(function (col) {
	    return col.props.title;
	  });
	  var cells = cols.map(function (_ref2) {
	    var props = _ref2.props;
	    var type = props.type,
	        field = props.field;
	
	    type = type || 'value';
	    return _extends({
	      empty: null,
	      render: function render(d) {
	        return typeRenders[type](d[field]);
	      }
	    }, props);
	  });
	  return _react2.default.createElement(
	    'table',
	    { className: 'pt-table pt-striped pt-interactive', width: '100%' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      headers.map(function (header, idx) {
	        return _react2.default.createElement(
	          'th',
	          { key: idx },
	          header
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data.map(function (d, idx) {
	        return _react2.default.createElement(
	          'tr',
	          { key: idx },
	          cells.map(function (_ref3, idx) {
	            var render = _ref3.render,
	                empty = _ref3.empty;
	            return _react2.default.createElement(
	              'td',
	              { key: idx },
	              render(d) || empty
	            );
	          })
	        );
	      })
	    )
	  );
	}
	
	Table.propTypes = {
	  children: _propTypes2.default.node,
	  data: _propTypes2.default.array,
	  type: _propTypes2.default.string,
	  field: _propTypes2.default.string
	};
	
	function Col() {
	  return null;
	}
	
	exports.default = Table;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _storeHelper = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Module = (_temp = _class = function (_Component) {
	  _inherits(Module, _Component);
	
	  function Module(props) {
	    _classCallCheck(this, Module);
	
	    return _possibleConstructorReturn(this, (Module.__proto__ || Object.getPrototypeOf(Module)).call(this, props));
	  }
	
	  _createClass(Module, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          module = _props.module,
	          store = _props.store,
	          children = _props.children;
	      var currentStore = this.context.currentStore;
	
	      var assertStore = store || currentStore;
	
	      if (!assertStore) {
	        return null;
	      }
	
	      return (0, _storeHelper.moduleEnabled)(module, assertStore) ? children : null;
	    }
	  }]);
	
	  return Module;
	}(_react.Component), _class.propTypes = {
	  module: _propTypes2.default.string.isRequired,
	  store: _propTypes2.default.object,
	  children: _propTypes2.default.node
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Module;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1283);
	
	__webpack_require__(1235);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactPikadayComponent = __webpack_require__(1680);
	
	var _reactPikadayComponent2 = _interopRequireDefault(_reactPikadayComponent);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var conditions = {
	  contain: 'contains',
	  equal: 'is',
	  between: 'is between',
	  date_equal: 'is on',
	  date_between: 'is from',
	  options: 'is'
	};
	
	var CascadeFilter = (_temp2 = _class = function (_Component) {
	  _inherits(CascadeFilter, _Component);
	
	  function CascadeFilter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CascadeFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CascadeFilter.__proto__ || Object.getPrototypeOf(CascadeFilter)).call.apply(_ref, [this].concat(args))), _this), _this.handleColumnChange = function (e) {
	      var selectedColumn = e.target.value;
	      var selectedColumnConditions = (0, _find2.default)(_this.state.settings, ['columnName', selectedColumn]).conditions;
	
	      _this.setState({
	        selectedColumn: selectedColumn,
	        selectedColumnConditions: selectedColumnConditions
	      });
	
	      _this.props.onChange({
	        column: selectedColumn,
	        condition: selectedColumnConditions[0].value,
	        conditionValue: undefined
	      });
	    }, _this.handleChange = function (e) {
	      var selectedCondition = (0, _reactDom.findDOMNode)(_this.refs.conditionOptions).value;
	      var filter = {
	        column: _this.state.selectedColumn,
	        condition: selectedCondition,
	        conditionValue: (0, _reactDom.findDOMNode)(_this.refs.conditionValue) ? (0, _reactDom.findDOMNode)(_this.refs.conditionValue).value : undefined,
	        conditionFrom: (0, _reactDom.findDOMNode)(_this.refs.conditionValueFrom) ? (0, _reactDom.findDOMNode)(_this.refs.conditionValueFrom).value : undefined,
	        conditionTo: (0, _reactDom.findDOMNode)(_this.refs.conditionValueTo) ? (0, _reactDom.findDOMNode)(_this.refs.conditionValueTo).value : undefined
	      };
	
	      _this.props.onChange(Object.assign(_this.props.filter, filter));
	    }, _this.handleDelete = function (e) {
	      _this.props.onDelete();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CascadeFilter, [{
	    key: 'render',
	    value: function render() {
	
	      var settings = this.props.settings.map(function (setting) {
	        setting.conditions = setting.filterConditions.map(function (filterCondition) {
	          return {
	            value: filterCondition,
	            displayName: conditions[filterCondition]
	          };
	        });
	
	        return setting;
	      });
	
	      var selectedColumn = this.props.filter.column || settings[0].columnName;
	      var selectedColumnConditions = (0, _find2.default)(settings, ['columnName', selectedColumn]).conditions;
	      this.state = {
	        settings: settings,
	        selectedColumn: selectedColumn,
	        selectedColumnConditions: selectedColumnConditions
	      };
	
	      // Get columns for choice
	      var columnOptions = this.state.settings.map(function (optionSetting, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: optionSetting.columnName },
	          optionSetting.displayName
	        );
	      });
	
	      // Get column's condition
	      var conditionOptions = this.state.selectedColumnConditions.map(function (condition, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: index, value: condition.value },
	          condition.displayName
	        );
	      });
	      var _props = this.props,
	          filter = _props.filter,
	          showDelete = _props.showDelete;
	
	
	      var conditionValueInput = void 0;
	      var condition = filter.condition || this.state.selectedColumnConditions[0].value;
	      switch (condition) {
	        case 'between':
	          conditionValueInput = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', { type: 'text',
	              ref: 'conditionValueFrom',
	              className: 'form-control form-control-sm',
	              value: filter.conditionFrom ? filter.conditionFrom : '',
	              onChange: this.handleChange }),
	            'and',
	            _react2.default.createElement('input', { type: 'text',
	              ref: 'conditionValueTo',
	              className: 'form-control form-control-sm',
	              value: filter.conditionTo ? filter.conditionTo : '',
	              onChange: this.handleChange })
	          );
	          break;
	        case 'date_equal':
	          conditionValueInput = _react2.default.createElement(_reactPikadayComponent2.default, {
	            ref: 'conditionValue',
	            value: new Date(filter.conditionValue),
	            placeholder: 'Select Date',
	            format: 'YYYY-MM-DD',
	            onChange: this.handleChange
	          });
	          break;
	        case 'date_between':
	          conditionValueInput = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactPikadayComponent2.default, {
	              ref: 'conditionValueFrom',
	              placeholder: 'Starting Date',
	              format: 'YYYY-MM-DD',
	              className: 'form-control form-control-sm',
	              value: new Date(filter.conditionFrom),
	              onChange: this.handleChange
	            }),
	            'To',
	            _react2.default.createElement(_reactPikadayComponent2.default, {
	              ref: 'conditionValueTo',
	              placeholder: 'Ending Date',
	              format: 'YYYY-MM-DD',
	              className: 'form-control form-control-sm',
	              value: new Date(filter.conditionTo),
	              onChange: this.handleChange
	            })
	          );
	          break;
	        default:
	          conditionValueInput = _react2.default.createElement('input', { type: 'text',
	            ref: 'conditionValue',
	            className: 'form-control form-control-sm',
	            value: filter.conditionValue ? filter.conditionValue : '',
	            onChange: this.handleChange });
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cascade-filter form-group row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3' },
	          _react2.default.createElement(
	            'select',
	            { ref: 'columnOptions',
	              className: 'form-control form-control-sm',
	              value: filter.column,
	              onChange: this.handleColumnChange },
	            columnOptions
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-2' },
	          _react2.default.createElement(
	            'select',
	            { ref: 'conditionOptions',
	              className: 'form-control form-control-sm',
	              value: filter.condition,
	              onChange: this.handleChange },
	            conditionOptions
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3' },
	          conditionValueInput
	        ),
	        showDelete ? _react2.default.createElement(
	          'div',
	          { className: 'col-sm-1' },
	          _react2.default.createElement(
	            'a',
	            { className: 'text-danger a small', onClick: this.handleDelete },
	            'remove'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return CascadeFilter;
	}(_react.Component), _class.propTypes = {
	  settings: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  filter: _propTypes2.default.object,
	  onChange: _propTypes2.default.func.isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  showDelete: _propTypes2.default.bool
	}, _temp2);
	exports.default = CascadeFilter;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _savedFiltersActions = __webpack_require__(227);
	
	var _inputDialog = __webpack_require__(782);
	
	var _inputDialog2 = _interopRequireDefault(_inputDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  return {
	    savedFilters: state.savedFilters[ownProps.group]
	  };
	}
	
	function mapDispatchToProps(dispatch, ownProps) {
	  var actions = {
	    saveFilter: _savedFiltersActions.saveFilter.bind(null, ownProps.group),
	    removeFilter: _savedFiltersActions.removeFilter.bind(null, ownProps.group)
	  };
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	}
	
	var SavedFilter = (_temp2 = _class = function (_Component) {
	  _inherits(SavedFilter, _Component);
	
	  function SavedFilter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SavedFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SavedFilter.__proto__ || Object.getPrototypeOf(SavedFilter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openInputDialog: false,
	      openSaved: false
	    }, _this.toggleSaved = function (e) {
	      _this.setState({ openSaved: !_this.state.openSaved });
	    }, _this.handleInputDialogOpen = function (e) {
	      _this.setState({
	        openInputDialog: true
	      });
	    }, _this.handleInputDialogCancel = function (e) {
	      _this.setState({
	        openInputDialog: false
	      });
	    }, _this.handleSave = function (name) {
	      var filter = [].concat(_toConsumableArray(_this.props.currentFilter));
	      _this.props.saveFilter(name, filter);
	
	      _this.setState({
	        openInputDialog: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SavedFilter, [{
	    key: 'handleRemove',
	    value: function handleRemove(name, event) {
	      event.stopPropagation();
	      if (confirm('Are you sure you want to delete the filter?')) {
	        this.props.removeFilter(name);
	      }
	    }
	  }, {
	    key: 'selectFilter',
	    value: function selectFilter(filter) {
	      this.props.onFilterSelected(filter);
	
	      this.setState({ openSaved: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var counter = 0;
	      for (var savedFilter in this.props.savedFilters) {
	        if (this.props.savedFilters.hasOwnProperty(savedFilter)) {
	          counter++;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-inline' },
	        _react2.default.createElement(
	          'div',
	          { className: this.state.openSaved ? 'btn-group open' : 'btn-group' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary btn-sm dropdown-toggle', onClick: this.toggleSaved },
	            'Saved Filters'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'dropdown-menu dropdown-menu-right' },
	            counter > 0 ? (0, _map2.default)(this.props.savedFilters, function (filter, name) {
	              return _react2.default.createElement(
	                'li',
	                { key: (0, _uniqueId2.default)(), className: 'dropdown-item a', onClick: _this2.selectFilter.bind(_this2, filter) },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'right a text-danger', onClick: _this2.handleRemove.bind(_this2, name) },
	                  '\xD7'
	                ),
	                ' ',
	                name
	              );
	            }) : _react2.default.createElement(
	              'li',
	              { className: 'dropdown-item text-muted small' },
	              'No Saved Filter'
	            ),
	            _react2.default.createElement('li', { className: 'dropdown-divider' }),
	            _react2.default.createElement(
	              'li',
	              { className: 'dropdown-item a', onClick: this.handleInputDialogOpen },
	              _react2.default.createElement(
	                'b',
	                { className: 'text-success' },
	                '+'
	              ),
	              ' Save current filter'
	            )
	          )
	        ),
	        _react2.default.createElement(_inputDialog2.default, { isOpen: this.state.openInputDialog,
	          onSave: this.handleSave,
	          onCancel: this.handleInputDialogCancel })
	      );
	    }
	  }]);
	
	  return SavedFilter;
	}(_react.Component), _class.propTypes = {
	  savedFilters: _propTypes2.default.object,
	  currentFilter: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  saveFilter: _propTypes2.default.func.isRequired,
	  removeFilter: _propTypes2.default.func.isRequired,
	  onFilterSelected: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SavedFilter);
	
	// TODO : close dropdown menu when click body

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(400);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	__webpack_require__(399);
	
	var _dateDisplay = __webpack_require__(314);
	
	var _dateDisplay2 = _interopRequireDefault(_dateDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DateField(props, context) {
	    var name = props.name,
	        value = props.value,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        _props$style = props.style,
	        style = _props$style === undefined ? {} : _props$style,
	        readOnly = props.readOnly,
	        disabled = props.disabled,
	        onChange = props.onChange,
	        offsetTips = props.offsetTips;
	
	    var timezone = props.timezone ? props.timezone : context.currentStore && context.currentStore.timezone;
	    var offsetStr = '';
	    if (value && offsetTips) {
	        var _ref = value.match(/^(\d{4})-(\d{2})-(\d{2})$/) || [],
	            _ref2 = _slicedToArray(_ref, 4),
	            match = _ref2[0],
	            year = _ref2[1],
	            month = _ref2[2],
	            date = _ref2[3];
	
	        var d1 = match ? (0, _momentTimezone2.default)().tz(timezone).set({ year: year, month: month - 1, date: date }).startOf('day') : (0, _momentTimezone2.default)(value).tz(timezone).startOf('day');
	        var d2 = (0, _momentTimezone2.default)().tz(timezone).startOf('day');
	        if (d1.isValid()) {
	            var diff = Math.floor(_momentTimezone2.default.duration(d1.diff(d2)).asDays());
	            if (diff === 0) {
	                offsetStr = 'Today';
	            } else if (diff > 0) {
	                offsetStr = diff + ' Day' + (diff > 1 ? 's' : '') + ' Later';
	            } else {
	                offsetStr = -diff + ' Day' + (diff < -1 ? 's' : '') + ' Before';
	            }
	        }
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        readOnly ? _react2.default.createElement(_dateDisplay2.default, {
	            value: value,
	            timezone: timezone,
	            className: className,
	            style: style,
	            formField: true
	        }) : _react2.default.createElement('input', { type: 'date',
	            className: 'form-control ' + className,
	            style: style,
	            name: name,
	            value: value,
	            readOnly: readOnly,
	            disabled: disabled,
	            onChange: onChange }),
	        _react2.default.createElement(
	            'span',
	            null,
	            offsetStr
	        )
	    );
	}
	
	DateField.contextTypes = {
	    currentStore: _propTypes2.default.object.isRequired
	};
	
	DateField.propTypes = {
	    name: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    timezone: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    readOnly: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    offsetTips: _propTypes2.default.bool
	};
	
	exports.default = DateField;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(400);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	__webpack_require__(399);
	
	__webpack_require__(1237);
	
	var _dateTimeDisplay = __webpack_require__(184);
	
	var _dateTimeDisplay2 = _interopRequireDefault(_dateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DateTimeField(props, context) {
	  var name = props.name,
	      value = props.value,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className,
	      _props$style = props.style,
	      style = _props$style === undefined ? {} : _props$style,
	      readOnly = props.readOnly,
	      disabled = props.disabled,
	      onChange = props.onChange,
	      offsetTips = props.offsetTips;
	
	  var timezone = props.timezone ? props.timezone : context.currentStore && context.currentStore.timezone;
	  var handleChange = function handleChange(field, event) {
	    var newValue = event.target.value;
	    if (!newValue) {
	      onChange(null);
	    } else {
	      var old = (0, _momentTimezone2.default)(value).isValid() ? (0, _momentTimezone2.default)(value) : (0, _momentTimezone2.default)();
	      var date = field === 'date' ? newValue : old.format('YYYY-MM-DD');
	      var time = field === 'time' ? newValue : old.format('HH:mm:ss');
	      var ret = _momentTimezone2.default.tz(date + ' ' + time, timezone).format('YYYY-MM-DDTHH:mm:ssZ');
	      onChange(ret);
	    }
	  };
	  var offsetStr = '';
	  var dateStr = '';
	  var timeStr = '';
	  if (value && (0, _momentTimezone2.default)(value).isValid()) {
	    var d1 = (0, _momentTimezone2.default)(value).tz(timezone);
	    dateStr = d1.format('YYYY-MM-DD');
	    timeStr = d1.format('HH:mm:ss');
	    if (offsetTips) {
	      var d2 = (0, _momentTimezone2.default)().tz(timezone).startOf('day');
	      var diff = Math.floor(_momentTimezone2.default.duration(d1.diff(d2)).asDays());
	      if (diff === 0) {
	        offsetStr = 'Today';
	      } else if (diff > 0) {
	        offsetStr = diff + ' Day' + (diff > 1 ? 's' : '') + ' Later';
	      } else {
	        offsetStr = -diff + ' Day' + (diff < -1 ? 's' : '') + ' Before';
	      }
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'datetime-field' },
	    !readOnly ? null : _react2.default.createElement(_dateTimeDisplay2.default, {
	      value: value,
	      timezone: timezone,
	      className: className,
	      style: style,
	      formField: true
	    }),
	    readOnly ? null : _react2.default.createElement('input', { type: 'date',
	      className: 'form-control datetime-field__date ' + className,
	      style: style,
	      name: name + '-date',
	      value: dateStr,
	      readOnly: readOnly,
	      disabled: disabled,
	      onChange: function onChange(event) {
	        return handleChange('date', event);
	      } }),
	    readOnly ? null : _react2.default.createElement('input', { type: 'time',
	      className: 'form-control datetime-field__time ' + className,
	      style: style,
	      name: name + '-time',
	      value: timeStr,
	      readOnly: readOnly,
	      disabled: disabled,
	      onChange: function onChange(event) {
	        return handleChange('time', event);
	      } }),
	    _react2.default.createElement(
	      'span',
	      null,
	      offsetStr
	    )
	  );
	}
	
	DateTimeField.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	};
	
	DateTimeField.propTypes = {
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  timezone: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  readOnly: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  offsetTips: _propTypes2.default.bool
	};
	
	exports.default = DateTimeField;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(143);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function MonthField(props) {
	  var value = props.value,
	      _props$displayFormat = props.displayFormat,
	      displayFormat = _props$displayFormat === undefined ? 'MMM' : _props$displayFormat,
	      _props$valueFormat = props.valueFormat,
	      valueFormat = _props$valueFormat === undefined ? 'MM' : _props$valueFormat,
	      className = props.className,
	      style = props.style,
	      otherProps = _objectWithoutProperties(props, ['value', 'displayFormat', 'valueFormat', 'className', 'style']);
	
	  var monthKeys = Array(12).fill(0).map(function (v, i) {
	    return i + 1;
	  }).map(function (v) {
	    return ('0' + v).substr(-2);
	  });
	  var monthValues = monthKeys.map(function (v) {
	    return (0, _moment2.default)(v, 'MM').format(valueFormat);
	  });
	  var monthDisplays = monthKeys.map(function (v) {
	    return (0, _moment2.default)(v, 'MM').format(displayFormat);
	  });
	
	  return _react2.default.createElement(
	    'select',
	    _extends({ className: className, style: style }, otherProps),
	    monthKeys.map(function (m, i) {
	      return _react2.default.createElement(
	        'option',
	        { key: m, value: monthValues[i] },
	        monthDisplays[i]
	      );
	    })
	  );
	}
	
	MonthField.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	};
	
	MonthField.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  displayFormat: _propTypes2.default.string,
	  valueFormat: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = MonthField;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimestampDisplay(props, context) {
	  var at = props.at,
	      by = props.by,
	      formField = props.formField,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className,
	      style = props.style;
	
	  var cl = (0, _classnames2.default)(className, { 'form-control': formField });
	  var timezone = props.timezone ? props.timezone : context.currentStore && context.currentStore.timezone;
	  var dateString = at ? (0, _formatHelper.dateTime)(at, timezone) : '';
	
	  return _react2.default.createElement(
	    'span',
	    { className: cl, style: style, readOnly: formField },
	    _react2.default.createElement(
	      'div',
	      null,
	      by
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      dateString
	    )
	  );
	}
	
	TimestampDisplay.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	};
	
	TimestampDisplay.propTypes = {
	  at: _propTypes2.default.string,
	  by: _propTypes2.default.string,
	  timezone: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  formField: _propTypes2.default.bool
	};
	
	exports.default = TimestampDisplay;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(143);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function YearField(props) {
	  var keyFormat = 'YYYY';
	  var now = (0, _moment2.default)().format(keyFormat);
	
	  var value = props.value,
	      _props$displayFormat = props.displayFormat,
	      displayFormat = _props$displayFormat === undefined ? 'YYYY' : _props$displayFormat,
	      _props$valueFormat = props.valueFormat,
	      valueFormat = _props$valueFormat === undefined ? 'YYYY' : _props$valueFormat,
	      _props$min = props.min,
	      min = _props$min === undefined ? now : _props$min,
	      _props$max = props.max,
	      max = _props$max === undefined ? now : _props$max,
	      count = props.count,
	      className = props.className,
	      style = props.style,
	      otherProps = _objectWithoutProperties(props, ['value', 'displayFormat', 'valueFormat', 'min', 'max', 'count', 'className', 'style']);
	
	  count = count != null ? count : min - max;
	  var optionKeys = Array(count + 1).fill(0).map(function (_, i) {
	    return parseInt(min) + i;
	  });
	  var optionValues = optionKeys.map(function (v) {
	    return (0, _moment2.default)(v, keyFormat).format(valueFormat);
	  });
	  var optionDisplays = optionKeys.map(function (v) {
	    return (0, _moment2.default)(v, keyFormat).format(displayFormat);
	  });
	
	  return _react2.default.createElement(
	    'select',
	    _extends({ className: className, style: style }, otherProps),
	    optionKeys.map(function (m, i) {
	      return _react2.default.createElement(
	        'option',
	        { key: m, value: optionValues[i] },
	        optionDisplays[i]
	      );
	    })
	  );
	}
	
	YearField.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	};
	
	YearField.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  displayFormat: _propTypes2.default.string,
	  valueFormat: _propTypes2.default.string,
	  min: _propTypes2.default.string,
	  max: _propTypes2.default.string,
	  count: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = YearField;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  },
	  overlay: {
	    zIndex: 9999
	  }
	};
	
	var InputDialog = (_temp2 = _class = function (_Component) {
	  _inherits(InputDialog, _Component);
	
	  function InputDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputDialog.__proto__ || Object.getPrototypeOf(InputDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function (e) {
	      var input = (0, _reactDom.findDOMNode)(_this.refs.input);
	
	      _this.props.onSave(input.value);
	    }, _this.handleCancel = function (e) {
	      _this.props.onCancel();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InputDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        { isOpen: this.props.isOpen,
	          style: customStyles },
	        _react2.default.createElement(
	          'h1',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'text', ref: 'input' }),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleSave },
	            'Save'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleCancel },
	            'Cancel'
	          )
	        )
	      );
	    }
	  }]);
	
	  return InputDialog;
	}(_react.Component), _class.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  title: _propTypes2.default.string,
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = InputDialog;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridBody = __webpack_require__(473);
	
	var _gridBody2 = _interopRequireDefault(_gridBody);
	
	var _gridFooter = __webpack_require__(315);
	
	var _gridFooter2 = _interopRequireDefault(_gridFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Grid(props) {
	  var bodyConfig = props.bodyConfig,
	      footerConfig = props.footerConfig,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className,
	      style = props.style;
	
	  var cl = 'grid ' + className;
	  return _react2.default.createElement(
	    'div',
	    { className: cl, style: style },
	    _react2.default.createElement(_gridBody2.default, bodyConfig),
	    !footerConfig ? null : _react2.default.createElement(_gridFooter2.default, footerConfig)
	  );
	}
	
	Grid.propTypes = {
	  bodyConfig: _propTypes2.default.object.isRequired,
	  footerConfig: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = Grid;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HouseNumber(props) {
	  var count = (props.value || []).length;
	  return _react2.default.createElement(
	    'span',
	    { className: 'house-number' },
	    _react2.default.createElement(
	      'span',
	      { className: 'house-number__number' },
	      count
	    ),
	    _react2.default.createElement('i', { className: 'fa fa-chevron-right house-number__icon' })
	  );
	}
	
	HouseNumber.propTypes = {
	  value: _propTypes2.default.array
	};
	
	exports.default = HouseNumber;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _coupons = __webpack_require__(1298);
	
	var _coupons2 = _interopRequireDefault(_coupons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Status = (_temp = _class = function (_Component) {
	  _inherits(Status, _Component);
	
	  function Status(props) {
	    _classCallCheck(this, Status);
	
	    var _this = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));
	
	    _this.handleFile = function () {
	      var reader = new FileReader();
	      var fileBlob = _this.refs.file.files[0];
	      reader.onload = function (evt) {
	        var resultText = evt.target.result;
	        _this.props.onUpload(resultText, fileBlob, 'csv');
	      };
	      reader.readAsText(fileBlob);
	    };
	
	    _this.state = {
	      value: '' //hack, if the uploaded file with the same name, the handleFile function will not be called.
	    };
	    return _this;
	  }
	
	  _createClass(Status, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fileUpload btn btn-primary btn-sm' },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-upload' }),
	            ' Choose CSV File'
	          ),
	          _react2.default.createElement('input', { type: 'file',
	            ref: 'file',
	            name: 'file',
	            value: this.state.value,
	            onChange: this.handleFile,
	            accept: '.csv' })
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: _coupons2.default, target: '_blank' },
	            '   ( Sample CSV )'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Status;
	}(_react.Component), _class.propTypes = {
	  onUpload: _propTypes2.default.string.isRequired
	}, _class.defaultProps = {
	  sample: 'javascript:void(0);',
	  fullSample: ''
	}, _temp);
	exports.default = Status;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Preview = (_temp = _class = function (_Component) {
	  _inherits(Preview, _Component);
	
	  function Preview() {
	    _classCallCheck(this, Preview);
	
	    return _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).apply(this, arguments));
	  }
	
	  _createClass(Preview, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      // if (!data.length) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'importer_preview' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'importer_preview-title' },
	          'Preview'
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'importer_preview-table table listing-table' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            data.map(function (row, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  i > 0 ? i : ''
	                ),
	                row.map(function (col, j) {
	                  return _react2.default.createElement(
	                    'td',
	                    { key: i + '-' + j },
	                    col
	                  );
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Preview;
	}(_react.Component), _class.propTypes = {
	  data: _propTypes2.default.array.isRequired
	}, _temp);
	exports.default = Preview;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Result = (_temp = _class = function (_Component) {
	  _inherits(Result, _Component);
	
	  function Result(props) {
	    _classCallCheck(this, Result);
	
	    var _this = _possibleConstructorReturn(this, (Result.__proto__ || Object.getPrototypeOf(Result)).call(this, props));
	
	    _this.state = {
	      shownDetail: false
	    };
	    return _this;
	  }
	
	  _createClass(Result, [{
	    key: 'renderTable',
	    value: function renderTable() {
	      var _props = this.props,
	          errors = _props.errors,
	          warnings = _props.warnings;
	
	      return _react2.default.createElement(
	        'ul',
	        null,
	        errors.map(function (issue, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: 'error' + i },
	            _react2.default.createElement('i', { className: 'fa fa-times-circle' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              ' Row ',
	              issue.row,
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '- ',
	              issue.value
	            )
	          );
	        }),
	        warnings.map(function (issue, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: 'warning' + i },
	            _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle text-warning' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              ' Row ',
	              issue.row,
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '- ',
	              issue.value
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          errors = _props2.errors,
	          warnings = _props2.warnings;
	      var shownDetail = this.state.shownDetail;
	
	      var noOfErrors = errors.length;
	      var noOfWarnings = warnings.length;
	      var issues = errors.concat(warnings);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Result '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('alert importer_result', {
	              'alert-success': issues.length === 0,
	              'alert-error': errors.length > 0,
	              'alert-warnings': errors.length === 0 && warnings.length > 0
	            }) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)({
	                'importer_response--error': noOfErrors > 0,
	                'importer_response--success': noOfErrors === 0
	              }) },
	            noOfWarnings > 0 && noOfErrors === 0 && _react2.default.createElement(
	              'span',
	              { className: 'importer_response-text' },
	              'Import is successful but there are some warnings - '
	            ),
	            noOfErrors > 0 && _react2.default.createElement(
	              'span',
	              { className: 'importer_response-text' },
	              'Import is unsuccessful due to errors - '
	            ),
	            issues.length === 0 && _react2.default.createElement(
	              'span',
	              { className: 'importer_response-text' },
	              'Import is successful - '
	            ),
	            noOfErrors === 0 && _react2.default.createElement(
	              'span',
	              null,
	              '1 Success'
	            ),
	            noOfErrors > 0 && _react2.default.createElement(
	              'span',
	              null,
	              ' ' + noOfErrors + ' Error'
	            ),
	            noOfWarnings > 0 && _react2.default.createElement(
	              'span',
	              null,
	              ' ' + noOfWarnings + ' Warning'
	            ),
	            issues.length > 0 && !shownDetail && _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this2.setState({ shownDetail: true });
	                } },
	              ' ',
	              _react2.default.createElement('i', { className: 'fa fa-caret-down fa-lg' })
	            ),
	            issues.length > 0 && shownDetail && _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this2.setState({ shownDetail: false });
	                } },
	              ' ',
	              _react2.default.createElement('i', { className: 'fa fa-caret-up fa-lg' })
	            )
	          ),
	          shownDetail && this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return Result;
	}(_react.Component), _class.propTypes = {
	  errors: _propTypes2.default.array.isRequired,
	  warnings: _propTypes2.default.array.isRequired
	}, _temp);
	exports.default = Result;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Status = (_temp = _class = function (_Component) {
	  _inherits(Status, _Component);
	
	  function Status() {
	    _classCallCheck(this, Status);
	
	    return _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).apply(this, arguments));
	  }
	
	  _createClass(Status, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          status = _props.status,
	          rate = _props.rate,
	          showProgress = _props.showProgress;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Status'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            status
	          )
	        ),
	        showProgress && _react2.default.createElement(
	          'div',
	          { className: 'progress' },
	          _react2.default.createElement('div', { className: 'progress-bar', style: { width: rate * 100 + '%' } })
	        )
	      );
	    }
	  }]);
	
	  return Status;
	}(_react.Component), _class.propTypes = {
	  status: _propTypes2.default.string.isRequired,
	  showProgress: _propTypes2.default.bool.isRequired,
	  rate: _propTypes2.default.number
	}, _temp);
	exports.default = Status;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(91);
	
	__webpack_require__(1242);
	
	var _Preview = __webpack_require__(786);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _Status = __webpack_require__(788);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _CsvFile = __webpack_require__(785);
	
	var _CsvFile2 = _interopRequireDefault(_CsvFile);
	
	var _Result = __webpack_require__(787);
	
	var _Result2 = _interopRequireDefault(_Result);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Importer = (_temp = _class = function (_Modal) {
	  _inherits(Importer, _Modal);
	
	  function Importer() {
	    _classCallCheck(this, Importer);
	
	    return _possibleConstructorReturn(this, (Importer.__proto__ || Object.getPrototypeOf(Importer)).apply(this, arguments));
	  }
	
	  _createClass(Importer, [{
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          title = _props.title,
	          isDone = _props.isDone,
	          isDoing = _props.isDoing,
	          style = _props.style,
	          onClose = _props.onClose,
	          isUploaded = _props.isUploaded,
	          onUpload = _props.onUpload,
	          previewData = _props.previewData,
	          onSubmit = _props.onSubmit,
	          status = _props.status,
	          step = _props.step,
	          importProgress = _props.importProgress,
	          validatateProgress = _props.validatateProgress,
	          errors = _props.errors,
	          warnings = _props.warnings;
	
	
	      var rates = [undefined, importProgress, validatateProgress];
	
	      var rate = rates[step];
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        { style: style },
	        _react2.default.createElement(_modal.ModalHeader, { title: title, onRequestClose: onClose }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(_CsvFile2.default, { onUpload: onUpload })
	            )
	          ),
	          _react2.default.createElement('br', null),
	          isDoing && _react2.default.createElement(_Status2.default, { status: status, rate: rate, showProgress: step === 1 || step === 2 }),
	          isDone && _react2.default.createElement(_Result2.default, { errors: errors, warnings: warnings }),
	          isUploaded && _react2.default.createElement(_Preview2.default, { data: previewData })
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              type: 'submit',
	              onClick: onSubmit,
	              disabled: !isUploaded },
	            'Submit'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Importer;
	}(_modal.Modal), _class.propTypes = {
	  title: _propTypes2.default.string,
	  status: _propTypes2.default.string,
	  previewData: _propTypes2.default.array.isRequired,
	  errors: _propTypes2.default.array.isRequired,
	  warnings: _propTypes2.default.array.isRequired,
	  isSubmitting: _propTypes2.default.bool.isRequired,
	  isSubmitted: _propTypes2.default.bool.isRequired,
	  isValidating: _propTypes2.default.bool.isRequired,
	  isValidated: _propTypes2.default.bool.isRequired,
	  isUploaded: _propTypes2.default.bool.isRequired,
	  isPosting: _propTypes2.default.bool.isRequired,
	  isPosted: _propTypes2.default.bool.isRequired,
	  isDone: _propTypes2.default.bool.isRequired,
	  isDoing: _propTypes2.default.bool.isRequired,
	  isOpen: _propTypes2.default.bool.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onUpload: _propTypes2.default.func.isRequired,
	  importProgress: _propTypes2.default.number.isRequired,
	  validatateProgress: _propTypes2.default.number.isRequired,
	  step: _propTypes2.default.number.isRequired,
	  style: _propTypes2.default.object //should not set this value
	}, _class.defaultProps = {
	  style: {
	    content: {
	      left: '6%',
	      top: '6%',
	      right: '6%',
	      bottom: '6%',
	      transform: 'none',
	      margin: '0px'
	    }
	  }
	}, _temp);
	exports.default = Importer;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	__webpack_require__(1243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputAdd = (_temp = _class = function (_Component) {
	  _inherits(InputAdd, _Component);
	
	  function InputAdd() {
	    _classCallCheck(this, InputAdd);
	
	    return _possibleConstructorReturn(this, (InputAdd.__proto__ || Object.getPrototypeOf(InputAdd)).apply(this, arguments));
	  }
	
	  _createClass(InputAdd, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _onChange = _props.onChange,
	          onAdd = _props.onAdd,
	          value = _props.value,
	          failure = _props.failure;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-add' },
	        _react2.default.createElement(
	          'a',
	          { className: 'input-add__btn', onClick: onAdd },
	          _react2.default.createElement('i', { className: 'fa fa-plus' })
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'input-add__form', onSubmit: onAdd },
	          _react2.default.createElement(_inputBox2.default, { type: 'input-add__input',
	            value: value,
	            failure: failure,
	            placeholder: '',
	            onChange: function onChange(e) {
	              return _onChange(e.target.value);
	            } })
	        )
	      );
	    }
	  }]);
	
	  return InputAdd;
	}(_react.Component), _class.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  onAdd: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  failure: _propTypes2.default.bool.isRequired
	}, _temp);
	exports.default = InputAdd;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1244);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox(props) {
	    _classCallCheck(this, Checkbox);
	
	    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
	    _this.test = function () {
	      return _this.refs.input;
	    };
	
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var label = 'test';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-checkbox ' + this.props.wrapperClassName },
	        _react2.default.createElement(
	          'label',
	          { onClick: this.test },
	          _react2.default.createElement('input', _extends({ id: label, type: 'checkbox' }, this.props, { ref: 'input', readOnly: true })),
	          _react2.default.createElement('div', { className: 'input-checkbox-check' })
	        )
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	exports.default = Checkbox;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListingName;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListingName(_ref) {
	  var name = _ref.name,
	      gtid = _ref.gtid,
	      listingBarcode = _ref.listingBarcode,
	      imageUrl = _ref.imageUrl;
	  // eslint-disable-line react/prop-types
	  return _react2.default.createElement(
	    "div",
	    { className: "media listing-name-thumbnail" },
	    _react2.default.createElement(
	      "div",
	      { className: "media-left" },
	      _react2.default.createElement("img", {
	        className: "_thumbnail",
	        src: imageUrl || __webpack_require__(1299),
	        alt: "" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "media-body" },
	      _react2.default.createElement(
	        "p",
	        { className: "_name" },
	        name
	      ),
	      gtid && _react2.default.createElement(
	        "p",
	        { className: "_code" },
	        "UPC/EAN: ",
	        gtid
	      ),
	      listingBarcode && _react2.default.createElement(
	        "p",
	        { className: "_code" },
	        "PLU/SKU: ",
	        listingBarcode
	      )
	    )
	  );
	}

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(1250);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _findKey = __webpack_require__(1563);
	
	var _findKey2 = _interopRequireDefault(_findKey);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _humps = __webpack_require__(44);
	
	var _customerService = __webpack_require__(492);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var filterSettings = [{
	  columnName: "name",
	  displayName: "CUSTOMER NAME",
	  filterConditions: ['contain']
	}, {
	  columnName: "phone",
	  displayName: "PHONE",
	  filterConditions: ['contain']
	}, {
	  columnName: "address",
	  displayName: "ADDRESS",
	  filterConditions: ['equal']
	}, {
	  columnName: "customer_code",
	  displayName: "CUSTOMER CODE",
	  filterConditions: ['equal']
	}];
	
	var SelectCustomer = (_temp2 = _class = function (_Component) {
	  _inherits(SelectCustomer, _Component);
	
	  function SelectCustomer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectCustomer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectCustomer.__proto__ || Object.getPrototypeOf(SelectCustomer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchListing: false,
	      customers: null,
	      selectedCustomer: null,
	      advanceSearch: false,
	      currentFilters: [],
	      currentPage: 0,
	      totalPages: 1,
	      loading: false
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      var oldCust = _this.props.customer || {};
	      var newCust = (0, _humps.decamelizeKeys)(nextProps.customer || {});
	      if (oldCust.id != newCust.id) {
	        _this.setState({ selectedCustomer: newCust });
	      }
	    }, _this.listingCheckboxs = {}, _this.closeModal = function () {
	      _this.setState({
	        searchListing: false
	      });
	    }, _this.openModal = function () {
	      _this.setState({
	        customers: null,
	        searchListing: true
	      });
	    }, _this.advanceSearch = function () {
	      _this.setState({
	        advanceSearch: true
	      });
	    }, _this.simpleSearch = function () {
	      _this.setState({
	        advanceSearch: false
	      });
	    }, _this.resetCustomer = function () {
	      _this.setState({
	        selectedCustomer: {}
	      });
	      _this.props.onChange && _this.props.onChange(null);
	    }, _this.save = function () {
	      var checkedId = (0, _findKey2.default)(_this.listingCheckboxs, function (checkbox, id) {
	        return checkbox && checkbox.checked;
	      });
	      var customer = _this.state.customers.find(function (listing) {
	        return listing.id == checkedId;
	      });
	      _this.setState({
	        selectedCustomer: { customer_name: customer.name }
	      });
	      _this.props.onSave && _this.props.onSave(customer);
	      _this.props.onChange && _this.props.onChange(customer);
	      _this.props.onBlur && _this.props.onBlur(customer);
	      _this.closeModal();
	    }, _this.search = function (event) {
	      event.preventDefault();
	
	      var value = _this.refs.keyword.value;
	
	
	      if (!value.trim()) {
	        return;
	      }
	
	      var filters = [{
	        column: "name",
	        condition: "contain",
	        conditionValue: value
	      }];
	
	      _this.searchByFilter(filters);
	    }, _this.setSearchPage = function (index) {
	      var page = index + 1;
	      _this.searchByFilter(_this.state.currentFilters, page);
	      _this.setState({
	        currentPage: index
	      });
	    }, _this.searchByFilter = function (filters) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	      _this.setState({ loading: true });
	      var store_id = _this.context.currentStore.id;
	      _customerService2.default.search(store_id, page, 50, undefined, filters).then(function (res) {
	        _this.setState({
	          customers: res.data,
	          currentFilters: filters,
	          currentPage: res.page - 1,
	          totalPages: res.totalPages,
	          loading: false
	        });
	      }).catch(function (e) {
	        _this.setState({ loading: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectCustomer, [{
	    key: 'render',
	    value: function render() {
	      var listingCheckboxs = this.listingCheckboxs;
	
	      function noop() {}
	
	      function listingCheckbox(props) {
	        var id = props.data;
	        return _react2.default.createElement('input', { type: 'radio', name: 'input-radio', ref: function ref(c) {
	            return listingCheckboxs[id] = c;
	          } });
	      }
	
	      var columnMetadatas = [{
	        columnName: "name",
	        displayName: "PRODUCT NAME"
	      }, {
	        columnName: "address",
	        displayName: "ADDRESS"
	      }, {
	        columnName: "phone",
	        displayName: "PHONE"
	      }, {
	        columnName: "id",
	        displayName: "SELECT",
	        customComponent: listingCheckbox
	      }];
	      var columns = columnMetadatas.map(function (c) {
	        return c.columnName;
	      });
	      var selectedCustomer = this.state.selectedCustomer || this.props.customer || {};
	      var readOnly = this.props.readOnly;
	
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            'div',
	            { className: 'input-group' },
	            _react2.default.createElement('input', { type: 'text', className: 'form-control',
	              value: selectedCustomer.customer_name || selectedCustomer.name || '',
	              onClick: readOnly ? noop : this.openModal,
	              onChange: noop,
	              readOnly: readOnly }),
	            readOnly ? null : _react2.default.createElement(
	              'div',
	              { className: 'input-group-addon a', onClick: this.resetCustomer },
	              '\xD7'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { className: 'ReactModal__Content--fixed', isOpen: this.state.searchListing, onRequestClose: this.closeModal },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-7' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'modal-title' },
	                    'Select customer'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5 align-right' },
	                  this.state.advanceSearch ? _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-link', onClick: this.simpleSearch },
	                    'simple'
	                  ) : _react2.default.createElement(
	                    'form',
	                    { className: 'form-inline align-right', onSubmit: this.search },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group' },
	                      _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Enter customer name', ref: 'keyword' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group-addon' },
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'a small', onClick: this.advanceSearch },
	                          'advance'
	                        )
	                      )
	                    ),
	                    '\xA0 ',
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-secondary btn-sm' },
	                      'Search'
	                    )
	                  )
	                )
	              ),
	              this.state.advanceSearch ? _react2.default.createElement(_cascadeFilterCollection2.default, {
	                settings: filterSettings,
	                filters: this.state.currentFilters,
	                group: 'customer',
	                onSearch: this.searchByFilter
	              }) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-body' },
	              !this.state.customers ? _react2.default.createElement(
	                'div',
	                { className: 'card-block' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Search for customer you need.'
	                )
	              ) : _react2.default.createElement(_griddleReact2.default, {
	                useExternal: true,
	                externalSetPage: this.setSearchPage,
	                externalChangeSort: noop,
	                externalSetFilter: noop,
	                externalSetPageSize: noop,
	                externalMaxPage: this.state.totalPages,
	                externalCurrentPage: this.state.currentPage,
	
	                useGriddleStyles: false,
	                tableClassName: 'table table-bordered data-table',
	                results: this.state.customers,
	                columns: columns,
	                columnMetadata: columnMetadatas,
	                noDataMessage: 'No search result'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2.default.createElement(
	                'span',
	                { className: 'btn btn-sm btn-secondary', onClick: this.closeModal },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-primary', onClick: this.save },
	                'Save'
	              )
	            ),
	            this.state.loading ? _react2.default.createElement(
	              'div',
	              { className: 'mask' },
	              _react2.default.createElement(_loading2.default, null)
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectCustomer;
	}(_react.Component), _class.propTypes = {
	  customer: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  onSave: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  readOnly: _propTypes2.default.bool
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = SelectCustomer;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Discount(_ref) {
	  var discount = _ref.discount,
	      onSelect = _ref.onSelect,
	      active = _ref.active;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)("discount", { active: active }), onClick: onSelect.bind(this, discount) },
	    discount.name,
	    active ? _react2.default.createElement('i', { className: 'fa fa-check-circle pull-right' }) : null
	  );
	}
	
	exports.default = Discount;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _selectDiscountActions = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterInput = function (_React$Component) {
	  _inherits(FilterInput, _React$Component);
	
	  function FilterInput(props) {
	    _classCallCheck(this, FilterInput);
	
	    var _this = _possibleConstructorReturn(this, (FilterInput.__proto__ || Object.getPrototypeOf(FilterInput)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(FilterInput, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.props.onChange(event.target.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'discount-filter' },
	        _react2.default.createElement('input', {
	          className: 'form-control',
	          value: value,
	          onChange: this.handleChange,
	          placeholder: 'filter by discount name'
	        })
	      );
	    }
	  }]);
	
	  return FilterInput;
	}(_react2.default.Component);
	
	FilterInput.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProp(state) {
	  return {
	    value: state.components.selectDiscount.filter
	  };
	}
	
	function mapDispatchToProp(dispatch) {
	  return {
	    onChange: function onChange(value) {
	      return dispatch((0, _selectDiscountActions.filterChange)(value));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp)(FilterInput);

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectDiscount = __webpack_require__(798);
	
	var _selectDiscount2 = _interopRequireDefault(_selectDiscount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _selectDiscount2.default;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _FilterInput = __webpack_require__(795);
	
	var _FilterInput2 = _interopRequireDefault(_FilterInput);
	
	var _Discount = __webpack_require__(794);
	
	var _Discount2 = _interopRequireDefault(_Discount);
	
	var _selectDiscountSelectors = __webpack_require__(491);
	
	var selectDiscountSelectors = _interopRequireWildcard(_selectDiscountSelectors);
	
	var _selectDiscountActions = __webpack_require__(180);
	
	var selectDiscountActions = _interopRequireWildcard(_selectDiscountActions);
	
	var _modal = __webpack_require__(91);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  return {
	    isOpen: selectDiscountSelectors.getIsOpen(state, props),
	    loading: selectDiscountSelectors.getLoading(state, props),
	    pathState: selectDiscountSelectors.getComponentState(state, props),
	    discounts: selectDiscountSelectors.getFilteredDiscountOptions(state, props),
	    selected: selectDiscountSelectors.getSelected(state)
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, selectDiscountActions);
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	};
	
	var SelectDiscountModal = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp2 = _class2 = function (_Modal) {
	  _inherits(SelectDiscountModal, _Modal);
	
	  function SelectDiscountModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectDiscountModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectDiscountModal.__proto__ || Object.getPrototypeOf(SelectDiscountModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnCancel = function () {
	      var _this$props = _this.props,
	          onCancel = _this$props.onCancel,
	          pathState = _this$props.pathState,
	          closeSelectDiscountModal = _this$props.closeSelectDiscountModal;
	
	      closeSelectDiscountModal();
	      if (typeof onCancel === 'function') {
	        onCancel(pathState);
	      }
	    }, _this.handleOnConfirm = function () {
	      var _this$props2 = _this.props,
	          onConfirm = _this$props2.onConfirm,
	          selected = _this$props2.selected,
	          pathState = _this$props2.pathState,
	          closeSelectDiscountModal = _this$props2.closeSelectDiscountModal;
	
	      closeSelectDiscountModal();
	      if (typeof onConfirm === 'function') {
	        onConfirm(selected, pathState);
	      }
	    }, _this.handleSelect = function (discount) {
	      _this.props.selectDiscount(discount);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectDiscountModal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextIsOpen = nextProps.isOpen;
	      var isOpen = this.props.isOpen;
	      if (nextIsOpen && !isOpen) {
	        this.props.loadDiscountOptions(this.context.currentStore.id);
	      }
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loading = _props.loading,
	          discounts = _props.discounts,
	          isOpen = _props.isOpen,
	          selected = _props.selected;
	
	
	      if (!isOpen) return null;
	
	      // let customerHeader = this.props.customerHeader ? this.props.customerHeader() : null;
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: 'Select Discount' }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	            'div',
	            { className: 'select-discount-modal' },
	            _react2.default.createElement(_FilterInput2.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'discount-options' },
	              discounts.map(function (discount) {
	                return _react2.default.createElement(_Discount2.default, { key: discount.id, discount: discount, onSelect: _this2.handleSelect, active: discount.id === selected });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary', onClick: this.handleOnCancel },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: this.handleOnConfirm },
	            'Confirm'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectDiscountModal;
	}(_modal.Modal), _class2.propTypes = {
	  name: _propTypes2.default.string,
	  isOpen: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  pathState: _propTypes2.default.object
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2)) || _class);
	exports.default = SelectDiscountModal;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1252);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _selectDiscountSelectors = __webpack_require__(491);
	
	var selectDiscountSelectors = _interopRequireWildcard(_selectDiscountSelectors);
	
	var _selectDiscountActions = __webpack_require__(180);
	
	var selectDiscountActions = _interopRequireWildcard(_selectDiscountActions);
	
	var _inputSelect = __webpack_require__(474);
	
	var _inputSelect2 = _interopRequireDefault(_inputSelect);
	
	var _selectDiscountModal = __webpack_require__(797);
	
	var _selectDiscountModal2 = _interopRequireDefault(_selectDiscountModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  return {
	    selected: selectDiscountSelectors.getSelectedDiscount(state, props),
	    value: props.value
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, selectDiscountActions);
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	};
	
	var SelectDiscount = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(SelectDiscount, _Component);
	
	  function SelectDiscount() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectDiscount);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectDiscount.__proto__ || Object.getPrototypeOf(SelectDiscount)).call.apply(_ref, [this].concat(args))), _this), _this.openModal = function () {
	      var _this$props = _this.props,
	          name = _this$props.name,
	          modalState = _this$props.modalState,
	          openSelectDiscountModal = _this$props.openSelectDiscountModal;
	
	      openSelectDiscountModal(name, modalState);
	    }, _this.handleOnConfirm = function (event, modalState) {
	      var _this$props2 = _this.props,
	          onConfirm = _this$props2.onConfirm,
	          selected = _this$props2.selected;
	
	      onConfirm(selected);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectDiscount, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          readOnly = _props.readOnly;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_inputSelect2.default, {
	          inputClassName: 'form-control',
	          placeholder: placeholder,
	          value: value ? value.name : '',
	          onClick: this.openModal,
	          readOnly: readOnly
	        }),
	        _react2.default.createElement(_selectDiscountModal2.default, {
	          name: name,
	          onConfirm: this.handleOnConfirm
	        })
	      );
	    }
	  }]);
	
	  return SelectDiscount;
	}(_react.Component), _class2.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	  placeholder: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  modalState: _propTypes2.default.object,
	  onConfirm: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  openSelectDiscountModal: _propTypes2.default.func,
	  valueDisplay: _propTypes2.default.object,
	  selected: _propTypes2.default.number,
	  readOnly: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  placeholder: 'Select a discount...',
	  name: 'discount'
	}, _temp2)) || _class);
	exports.default = SelectDiscount;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _modal = __webpack_require__(91);
	
	var _kitchenDepartmentService = __webpack_require__(324);
	
	var _kitchenDepartmentService2 = _interopRequireDefault(_kitchenDepartmentService);
	
	var _kitchenDepartmentSelection = __webpack_require__(150);
	
	var KitchenDepartmentsAction = _interopRequireWildcard(_kitchenDepartmentSelection);
	
	var _kitchenDepartmentSelection2 = __webpack_require__(150);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(Object.assign({}, KitchenDepartmentsAction), dispatch),
	    toggleAllKitchenDepartmentSelection: (0, _redux.bindActionCreators)(_kitchenDepartmentSelection2.toggleAllKitchenDepartmentSelection, dispatch)
	  };
	}
	
	function mapStateToProps(state, props) {
	  var kitchenDepartmentSelection = state.forms.kitchenDepartmentSelection;
	
	  return { kitchenDepartmentSelection: kitchenDepartmentSelection };
	}
	
	var SelectDepartment = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Modal) {
	  _inherits(SelectDepartment, _Modal);
	
	  function SelectDepartment(props) {
	    _classCallCheck(this, SelectDepartment);
	
	    var _this = _possibleConstructorReturn(this, (SelectDepartment.__proto__ || Object.getPrototypeOf(SelectDepartment)).call(this, props));
	
	    _this.toggleAll = _this.toggleAll.bind(_this);
	    _this.state = {
	      departments: []
	    };
	    return _this;
	  }
	
	  _createClass(SelectDepartment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAll();
	    }
	  }, {
	    key: 'getAll',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var kdPath, response, kitchen_department;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                kdPath = 'v2/stores/' + this.context.currentStore.id + '/kitchen_departments';
	                _context.next = 3;
	                return _kitchenDepartmentService2.default.get(kdPath, { per_page: 999999 });
	
	              case 3:
	                response = _context.sent;
	                kitchen_department = response.data.map(function (_ref2) {
	                  var kitchen_department = _ref2.kitchen_department;
	                  return kitchen_department;
	                });
	
	                this.props.actions.getAllKitchenDepartments(kitchen_department);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getAll() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getAll;
	    }()
	
	    // async fetchDepartments(){
	    //   let { departments }= await service.getAllWithPrinter(this.context.currentStore.id)
	    //   this.props.actions.getAllKitchenDepartments(departments)
	    // }
	
	  }, {
	    key: 'toggleAll',
	    value: function toggleAll(event) {
	      this.props.all.map(function (data) {
	        data.checked = event.target.checked;
	      });
	      this.props.toggleAllKitchenDepartmentSelection(!event.target.checked);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          closeKitchenDepartmentSelection = _props.closeKitchenDepartmentSelection,
	          toggleKitchenDepartmentSelection = _props.toggleKitchenDepartmentSelection,
	          submitKitchenDepartmentSelection = _props.submitKitchenDepartmentSelection,
	          kitchenDepartmentSelection = _props.kitchenDepartmentSelection;
	
	      var customerHeader = this.props.customerHeader ? this.props.customerHeader() : null;
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(
	          _modal.ModalHeader,
	          { title: 'Select Kitchen Departments' },
	          customerHeader,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', onChange: this.toggleAll }),
	            _react2.default.createElement(
	              'span',
	              { className: 'all-nodes-label' },
	              'All Kitchen Departments'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement('th', { style: { width: '20%' } }),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { width: '80%' } },
	                    'KitchenDepartments'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                kitchenDepartmentSelection.all.map(function (v) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: v.kitchen_department_id },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        checked: v.checked,
	                        onChange: function onChange(e) {
	                          toggleKitchenDepartmentSelection(v.kitchen_department_id, e.target.checked);
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      v.kitchen_department_name
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary',
	              onClick: closeKitchenDepartmentSelection },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary',
	              onClick: submitKitchenDepartmentSelection },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectDepartment;
	}(_modal.Modal), _class2.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  all: _propTypes2.default.array.isRequired,
	  closeKitchenDepartmentSelection: _propTypes2.default.func.isRequired,
	  toggleKitchenDepartmentSelection: _propTypes2.default.func.isRequired,
	  toggleAllKitchenDepartmentSelection: _propTypes2.default.func.isRequired,
	  submitKitchenDepartmentSelection: _propTypes2.default.func.isRequired
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = SelectDepartment;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modalToggle = __webpack_require__(475);
	
	var _modalToggle2 = _interopRequireDefault(_modalToggle);
	
	var _houseNumber = __webpack_require__(784);
	
	var _houseNumber2 = _interopRequireDefault(_houseNumber);
	
	var _inputSerialNumber = __webpack_require__(478);
	
	var _inputSerialNumber2 = _interopRequireDefault(_inputSerialNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountSerialNumber = (_temp = _class = function (_Component) {
	  _inherits(CountSerialNumber, _Component);
	
	  function CountSerialNumber(props) {
	    _classCallCheck(this, CountSerialNumber);
	
	    var _this = _possibleConstructorReturn(this, (CountSerialNumber.__proto__ || Object.getPrototypeOf(CountSerialNumber)).call(this, props));
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var prevSn = _this.state.value;
	      var nextSn = _this.getByValue(nextProps.value).value;
	      if ((0, _inputSerialNumber.diffSn)(prevSn, nextSn)) {
	        _this.setState({ value: nextSn });
	      }
	    };
	
	    _this.getByValue = function (value) {
	      var sn = (value || _this.state.value || []).map(function (v) {
	        return typeof v === 'string' ? v : v.number ? v.number : '';
	      }).filter(function (v) {
	        return v;
	      });
	      return { value: sn };
	    };
	
	    _this.handleOnChange = function (value) {
	      _this.setState({ value: value });
	    };
	
	    _this.handleOnClose = function () {
	      _this.setState(_this.getByValue(_this.props.value));
	    };
	
	    _this.handleOnConfirm = function () {
	      return _this.props.onConfirm ? _this.props.onConfirm(_this.state.value) : undefined;
	    };
	
	    _this.state = _this.getByValue(props.value);
	    return _this;
	  }
	
	  _createClass(CountSerialNumber, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          propValue = _props.value,
	          _props$productName = _props.productName,
	          productName = _props$productName === undefined ? '' : _props$productName,
	          onConfirm = _props.onConfirm,
	          readOnly = _props.readOnly,
	          rest = _objectWithoutProperties(_props, ['value', 'productName', 'onConfirm', 'readOnly']);
	
	      var value = this.state.value;
	
	      return _react2.default.createElement(
	        _modalToggle2.default,
	        _extends({}, rest, {
	          onConfirm: this.handleOnConfirm,
	          onClose: this.handleOnClose,
	          togglerLabel: _react2.default.createElement(_houseNumber2.default, { value: value }),
	          header: productName
	        }),
	        _react2.default.createElement(_inputSerialNumber2.default, {
	          value: value,
	          className: 'form-control',
	          style: {
	            position: 'absolute',
	            top: 0,
	            bottom: 0,
	            left: 0,
	            right: 0
	          },
	          readOnly: readOnly,
	          onChange: this.handleOnChange
	        })
	      );
	    }
	  }]);
	
	  return CountSerialNumber;
	}(_react.Component), _class.propTypes = {
	  value: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])),
	  productName: _propTypes2.default.string,
	  onConfirm: _propTypes2.default.func.isRequired,
	  readOnly: _propTypes2.default.bool
	}, _temp);
	exports.default = CountSerialNumber;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputSerialNumber = exports.CountSerialNumber = undefined;
	
	var _countSerialNumber = __webpack_require__(800);
	
	var _countSerialNumber2 = _interopRequireDefault(_countSerialNumber);
	
	var _inputSerialNumber = __webpack_require__(478);
	
	var _inputSerialNumber2 = _interopRequireDefault(_inputSerialNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CountSerialNumber = _countSerialNumber2.default;
	exports.InputSerialNumber = _inputSerialNumber2.default;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1253);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StatusIcon(props) {
	  var state = props.state,
	      customColor = props.customColor;
	
	  var className = 'status-icon ' + state;
	  var style = {};
	  if (customColor) {
	    style.backgroundColor = customColor;
	  }
	
	  return state ? _react2.default.createElement('i', { className: className, style: style }) : null;
	}
	
	StatusIcon.propTypes = {
	  state: _propTypes2.default.string,
	  customColor: _propTypes2.default.string
	};
	
	exports.default = StatusIcon;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */
	
	__webpack_require__(1255);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store_placeholder = __webpack_require__(1300);
	
	var _store_placeholder2 = _interopRequireDefault(_store_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StoreThumbnail(props) {
	  var image_path = props.src || _store_placeholder2.default;
	  var className = 'store-thumbnail ' + props.className;
	
	  return _react2.default.createElement('img', _extends({}, props, { className: className, src: image_path }));
	}
	
	exports.default = StoreThumbnail;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = (_temp = _class = function (_Component) {
	  _inherits(Tag, _Component);
	
	  function Tag() {
	    _classCallCheck(this, Tag);
	
	    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
	  }
	
	  _createClass(Tag, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          onClick = _props.onClick;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'tag' },
	        _react2.default.createElement(
	          'span',
	          { className: 'tag__label' },
	          label
	        ),
	        this.props.onClick && _react2.default.createElement(
	          'a',
	          { className: 'tag__times', onClick: onClick },
	          _react2.default.createElement('i', { className: 'fa fa-times' })
	        )
	      );
	    }
	  }]);
	
	  return Tag;
	}(_react.Component), _class.propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	}, _temp);
	exports.default = Tag;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TreeNode(props) {
	  var path = props.path,
	      _props$data = props.data,
	      data = _props$data === undefined ? {} : _props$data,
	      _onChange = props.onChange,
	      toggleCollapse = props.toggleCollapse;
	  var label = data.label,
	      checkbox = data.checkbox,
	      checked = data.checked,
	      collapsed = data.collapsed,
	      children = data.children;
	
	  var hasChildren = (children || []).length > 0;
	  return _react2.default.createElement(
	    'div',
	    { className: 'tree-view-node' },
	    _react2.default.createElement('span', {
	      className: (0, _classnames2.default)({
	        'tree-view-node-collapse-toggle': true,
	        'collapse-spacer': !hasChildren,
	        'fa': hasChildren,
	        'fa-chevron-down': hasChildren && !collapsed,
	        'fa-chevron-right': hasChildren && collapsed
	      }),
	      onClick: function onClick() {
	        return toggleCollapse(path, !collapsed);
	      }
	    }),
	    _react2.default.createElement(
	      'span',
	      null,
	      !checkbox ? null : _react2.default.createElement('input', {
	        type: 'checkbox',
	        className: 'tree-view-node-checkbox',
	        checked: !!checked,
	        onChange: function onChange(event) {
	          return _onChange(path, event.target.checked);
	        }
	      }),
	      _react2.default.createElement(
	        'label',
	        { className: 'tree-view-node-label' },
	        label
	      )
	    ),
	    !hasChildren ? null : _react2.default.createElement(
	      'div',
	      {
	        className: 'tree-view-node-children',
	        style: { display: collapsed ? 'none' : 'block' }
	      },
	      children.map(function (d, i) {
	        return _react2.default.createElement(TreeNode, {
	          key: path + '.' + i,
	          path: path + '.' + i,
	          data: d,
	          onChange: _onChange,
	          toggleCollapse: toggleCollapse
	        });
	      })
	    )
	  );
	}
	
	TreeNode.propTypes = {
	  path: _propTypes2.default.string.isRequired,
	  data: _propTypes2.default.shape({
	    label: _propTypes2.default.string.isRequired,
	    checkbox: _propTypes2.default.bool,
	    checked: _propTypes2.default.bool,
	    collapsed: _propTypes2.default.bool,
	    children: _propTypes2.default.arrayOf(_propTypes2.default.object)
	  }).isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  toggleCollapse: _propTypes2.default.func.isRequired
	};
	
	function TreeMenu(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'tree-view' },
	    (props.data || []).map(function (d, i) {
	      return _react2.default.createElement(TreeNode, {
	        key: '' + i,
	        path: '' + i,
	        data: d,
	        onChange: props.onChange,
	        toggleCollapse: props.toggleCollapse
	      });
	    })
	  );
	}
	
	TreeMenu.propTypes = {
	  data: _propTypes2.default.arrayOf(TreeNode.propTypes.data).isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  toggleCollapse: _propTypes2.default.func.isRequired
	};
	
	exports.default = TreeMenu;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TreeMenu = __webpack_require__(805);
	
	var _TreeMenu2 = _interopRequireDefault(_TreeMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TreeMenu2.default;

/***/ },
/* 807 */
/***/ function(module, exports) {

	'use strict';
	
	// API domains https://docs.trybindo.com/
	
	module.exports = {
	  bindo: 'https://trybindo.com/api',
	  api: 'https://api.trybindo.com',
	  analytics: 'https://analytics.trybindo.com',
	  gateway: 'https://gateway.trybindo.com',
	  tableau: 'https://dashboard.trybindo.com/tableau',
	  clientId: '1clvjqb9fmv5bkjoq2akbc1h4',
	  clientSecret: '1tfcglxmnjv4t263dji05wmjr',
	  goApi: 'https://try-main.bindo.io/api',
	  goGatewayApi: 'https://try-main.bindo.io/gateway'
	};

/***/ },
/* 808 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TYPE_LABEL;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPE = {
	  OPENING: 1,
	  ACTUAL_QTY_ADJ: 2,
	  VARIANCE_QTY_ADJ: 3,
	  COST_ADJ: 4
	};
	
	var TYPE_LABEL = (_TYPE_LABEL = {}, _defineProperty(_TYPE_LABEL, TYPE.OPENING, 'Opening'), _defineProperty(_TYPE_LABEL, TYPE.ACTUAL_QTY_ADJ, 'Adjustment by Actual Qty'), _defineProperty(_TYPE_LABEL, TYPE.VARIANCE_QTY_ADJ, 'Adjustment by Variance Qty'), _defineProperty(_TYPE_LABEL, TYPE.COST_ADJ, 'Cost Adjustment'), _TYPE_LABEL);
	
	var MODE = {
	  VIEW: 'view',
	  EDIT: 'edit',
	  NEW: 'new'
	};
	
	var TAB = {
	  OVERVIEW: 'overview'
	};
	
	var STATUS = {
	  OPENED: 'opened',
	  SUBMITTING: 'submitting',
	  PENDING_FOR_APPROVAL: 'pending_for_approval',
	  PROCESSING: 'PROCESSING',
	  COMPLETED: 'completed',
	  VOID: 'voided'
	};
	
	var INVENTORY_VARIANCE = {
	  TYPE: TYPE,
	  TYPE_LABEL: TYPE_LABEL,
	  MODE: MODE,
	  TAB: TAB,
	  STATUS: STATUS
	};
	
	exports.default = INVENTORY_VARIANCE;

/***/ },
/* 809 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODE = {
	  NEW: 'new',
	  VIEW: 'view',
	  EDIT: 'edit'
	};
	
	var TAB = {
	  OVERVIEW: 'overview'
	};
	
	var PROMO_CODE = {
	  MODE: MODE,
	  TAB: TAB
	};
	
	exports.default = PROMO_CODE;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menu = __webpack_require__(303);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _lodash = __webpack_require__(14);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeKey = _lodash2.default.flow([_lodash2.default.snakeCase, _lodash2.default.toUpper]);
	
	var ROUTE = {
	  SITE_PREFIX: 'v2',
	  LOGIN: 'login',
	  INVOICES: 'invoices',
	  QUOTES: 'quotes',
	  DELIVERY_NOTE: 'delivery-note',
	  PRODUCTION_ORDERS: 'production-orders',
	  PROMO_CODES: 'promo-codes',
	  INVENTORY_VARIANCE: 'inventory-variance',
	  LINE_ITEM_STATUS_SET_UP: 'line-item-status-set-up',
	  WORK_FLOW_SET_UP: 'workflow-set-up'
	};
	
	_lodash2.default.forEach(_menu2.default.DEFAULT, function (item) {
	  var type = item.type,
	      subRoute = item.subRoute,
	      children = item.children,
	      route = item.route;
	
	  if (type === 'link' || type === 'menu') {
	    var partial = subRoute || route;
	    _lodash2.default.set(ROUTE, makeKey(partial), partial);
	  }
	  if (Array.isArray(children)) {
	    children.forEach(function (child) {
	      var subRoute = child.subRoute,
	          subChildren = child.children;
	
	      if (subRoute) _lodash2.default.set(ROUTE, makeKey(subRoute), subRoute);
	      subChildren.forEach(function (c) {
	        if (c.subRoute) _lodash2.default.set(ROUTE, makeKey(c.subRoute), c.subRoute);
	      });
	    });
	  }
	});
	
	exports.default = ROUTE;

/***/ },
/* 811 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var setDelay = function setDelay() {
	  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return new Promise(function (resolve, reject) {
	      setTimeout(function () {
	        return resolve.apply(undefined, args);
	      }, delay);
	    });
	  };
	};
	
	/**
	 * Get all data from API, even it has paginagion
	 *
	 * @param {function} apiCall The function to call API
	 * @param {number}   [delay] Each API call delay time
	 * @return {PaginateMeta}
	 *
	 * type PaginateData = any;
	 * interface PaginateMeta {
	 *   totalPages: number;
	 *   data: PaginateData[];
	 * }
	 * type apiCall = (page: number) => Promise<PaginateMeta>
	 */
	var drainAllPages = exports.drainAllPages = function drainAllPages(apiCall, delay) {
	  return apiCall(1).then(function (res) {
	    var _res$totalPages = res.totalPages,
	        totalPages = _res$totalPages === undefined ? 1 : _res$totalPages;
	
	    var promise = Promise.resolve(res);
	    for (var i = 2; i <= totalPages; i++) {
	      promise = function (j) {
	        return promise.then(setDelay(delay)).then(function (meta) {
	          return apiCall(j).then(function (r) {
	            var data = meta.data.concat(r.data);
	            var count = data.length;
	            return _extends({}, r, { data: data, count: count });
	          });
	        });
	      }(i);
	    }
	    return promise;
	  });
	};

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wrapConnect = wrapConnect;
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	function wrapConnect(element, actions) {
	  var mapStateToProps = function mapStateToProps(state) {
	    return {
	      appState: state
	    };
	  };
	
	  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	      actions: (0, _redux.bindActionCreators)(actions, dispatch)
	    };
	  };
	
	  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(element);
	}

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAuthencated = exports.clear = exports.getCookie = exports.setCookie = undefined;
	
	var _jsCookie = __webpack_require__(1459);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entries = [{ key: 'access_token' }, { key: 'user_id', field: 'id', type: 'number' }, { key: 'user_name', field: 'name' }, { key: 'email' }, {
	  key: 'user_type',
	  value: function value(_ref) {
	    var belongs_to_internal = _ref.belongs_to_internal,
	        belongs_to_courier = _ref.belongs_to_courier;
	    return belongs_to_internal ? 'ADMIN' : belongs_to_courier ? 'COURIER' : 'USER';
	  }
	}, { key: 'user_image', field: 'avatar', value: function value(_ref2) {
	    var avatar = _ref2.avatar;
	    return avatar || 'images/user_placeholder.png';
	  } }, { key: 'inventory_manager', field: 'is_inventory_manager', type: 'bool' }, { key: 'belongs_to_internal', type: 'bool' }, { key: 'belongs_to_courier', type: 'bool' }, { key: 'belongs_to_reseller', type: 'bool' }];
	
	function defaultValueResolver(auth, _ref3) {
	  var key = _ref3.key,
	      field = _ref3.field,
	      type = _ref3.type;
	
	  var value = auth[field || key];
	  switch (type) {
	    case 'number':
	      return value.toString();
	    case 'bool':
	      return value ? 'YES' : 'NO';
	    default:
	      return value;
	  }
	}
	
	function setCookie(auth) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var entry = _step.value;
	
	      var value = entry.value ? entry.value(auth) : defaultValueResolver(auth, entry);
	      _jsCookie2.default.set(entry.key, value);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function isAuthencated() {
	  return _jsCookie2.default.get('access_token') !== undefined;
	}
	
	function getCookie() {
	  var auth = {};
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var entry = _step2.value;
	
	      var value = _jsCookie2.default.get(entry.key);
	      switch (entry.type) {
	        case 'number':
	          value = Number(value);
	          break;
	        case 'bool':
	          value = value === 'YES' ? true : false;
	      }
	
	      var field = entry.field || entry.key;
	      auth[field] = value;
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return auth;
	}
	
	function clear() {
	  entries.forEach(function (_ref4) {
	    var key = _ref4.key;
	    return _jsCookie2.default.remove(key);
	  });
	}
	
	exports.setCookie = setCookie;
	exports.getCookie = getCookie;
	exports.clear = clear;
	exports.isAuthencated = isAuthencated;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterMenu = filterMenu;
	
	var _filter = __webpack_require__(634);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _storeHelper = __webpack_require__(185);
	
	var _permissionHelper = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// example menu = [
	//   { name: 'Summary', route: 'summary'},
	//   { name: 'Inventory', route: 'inventory'},
	//   { name: 'Customer', route: 'customer', permission: 'customer:view_only'},
	//   { name: 'Gift Card', route: 'gift-card', module: 'gift_card_enabled'},
	// ];
	//
	// example store_module = {
	//   "id": 100,
	//   "store_id": 100,
	//   "restaurant_features_enabled": false,
	//   "gift_card_enabled": true,
	// };
	//
	// exampler store_permissions = [
	//   {
	//     "store_id": 9999,
	//     "store_role_id": 1,
	//     "store_role_name": "MANAGER",
	//     "permissions": {
	//       "inventory:view_only": true,
	//       "customer:view_only": true,
	//       "gift_card:view_only": true,
	//       "discount:view_only": true,
	//       "sales:view_only": true,
	//     }
	//   },
	//   {
	//     "store_id": 4497,
	//     "store_role_id": 2,
	//     "store_role_name": "EMPLOYEE",
	//     "permissions": {
	//       "inventory:view_only": true,
	//       "customer:view_only": true,
	//       "gift_card:view_only": false,
	//       "discount:view_only": false,
	//       "sales:view_only": false,
	//     }
	//   },
	// ];
	
	// filter MENU for ROLE base on store_module and store_permissions
	function filterMenu(menu, role, store_module, store_permissions) {
	  var filteredByModule = (0, _filter2.default)(menu, function (m) {
	    return m.module ? (0, _storeHelper.moduleEnabled)(m.module, store_module) : true;
	  });
	
	  if (store_module && store_module.permission_enabled) {
	    var filteredByPermission = (0, _filter2.default)(filteredByModule, function (m) {
	      return m.permission ? (0, _permissionHelper.permissionAccessor)(m.permission, role, store_permissions, true) : true;
	    });
	
	    // Recursive filter sub-menu
	    filteredByPermission = filteredByPermission.map(function (m) {
	      if (m.child && m.child.length > 0) {
	        m.child = filterMenu(m.child, role, store_module, store_permissions);
	      }
	      return m;
	    });
	
	    return filteredByPermission;
	  } else {
	    return filteredByModule;
	  }
	}

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.requireAuth = requireAuth;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _authDataHelper = __webpack_require__(234);
	
	var _authDataHelper2 = _interopRequireDefault(_authDataHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function requireAuth(Component) {
	  var _class, _temp;
	
	  var AuthenticatedComponent = (_temp = _class = function (_React$Component) {
	    _inherits(AuthenticatedComponent, _React$Component);
	
	    function AuthenticatedComponent() {
	      _classCallCheck(this, AuthenticatedComponent);
	
	      return _possibleConstructorReturn(this, (AuthenticatedComponent.__proto__ || Object.getPrototypeOf(AuthenticatedComponent)).apply(this, arguments));
	    }
	
	    _createClass(AuthenticatedComponent, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.checkAuth();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.location.pathname !== nextProps.location.pathname || this.props.location.search !== nextProps.location.search) {
	          this.checkAuth();
	        }
	      }
	    }, {
	      key: 'checkAuth',
	      value: function checkAuth() {
	        var auth = _authDataHelper2.default.get();
	        var _props = this.props,
	            actions = _props.actions,
	            location = _props.location;
	
	
	        if (auth) {
	          actions.requestLoginSuccess(auth);
	        } else {
	          var redirectAfterLogin = location.pathname;
	
	          this.context.router.push({
	            pathname: '/v2/login/index',
	            query: { next: redirectAfterLogin }
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var auth = _authDataHelper2.default.get();
	        if (!auth) {
	          return null;
	        }
	
	        return _react2.default.createElement(Component, this.props);
	      }
	    }]);
	
	    return AuthenticatedComponent;
	  }(_react2.default.Component), _class.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	  }, _class.propTypes = {
	    appState: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    params: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	  }, _temp);
	
	
	  return AuthenticatedComponent;
	}

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BIGJS_ROUND_UP = exports.BIGJS_ROUND_HALF_EVEN = exports.BIGJS_ROUND_HALF_UP = exports.BIGJS_ROUND_DOWN = undefined;
	exports.round = round;
	exports.roundAsBig = roundAsBig;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _constants = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BIGJS_ROUND_DOWN = exports.BIGJS_ROUND_DOWN = 0;
	var BIGJS_ROUND_HALF_UP = exports.BIGJS_ROUND_HALF_UP = 1;
	var BIGJS_ROUND_HALF_EVEN = exports.BIGJS_ROUND_HALF_EVEN = 2;
	var BIGJS_ROUND_UP = exports.BIGJS_ROUND_UP = 3;
	
	function round(num, dp, type) {
	    var n = (0, _big2.default)(num);
	    if (type === _constants.ROUNDING_TYPE_ROUND_TO_NEAREST_FIVE) {
	        if (dp === 0) {
	            return n.toFixed(0);
	        } else {
	            return (0, _big2.default)(n.times(2).toFixed(dp - 1)).div(2).toFixed(dp);
	        }
	    } else if (type === _constants.ROUNDING_TYPE_ROUND_DOWN) {
	        return n.round(dp, BIGJS_ROUND_DOWN).toFixed(dp);
	    } else if (type === _constants.ROUNDING_TYPE_ROUND_UP) {
	        return n.round(dp, BIGJS_ROUND_UP).toFixed(dp);
	    } else {
	        return n.toFixed(dp);
	    }
	}
	
	function roundAsBig(num, dp, type) {
	    return (0, _big2.default)(round(num, dp, type));
	}

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(9);
	
	__webpack_require__(1281);
	
	__webpack_require__(1229);
	
	var _routes = __webpack_require__(950);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(972);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	__webpack_require__(1282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _configureStore2.default)();
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.browserHistory, routes: _routes2.default })
	), document.getElementById('dashboard'));

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateTimeDisplay = __webpack_require__(184);
	
	var _dateTimeDisplay2 = _interopRequireDefault(_dateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexDate(props, context) {
	  var timezone = context.currentStore && context.currentStore.timezone;
	  var data = props.data;
	
	  return _react2.default.createElement(_dateTimeDisplay2.default, { value: data, timezone: timezone });
	}
	
	IndexDate.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexDate;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _constant = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexName(props) {
	  var _props$rowData = props.rowData,
	      id = _props$rowData.id,
	      store_id = _props$rowData.store_id,
	      number = _props$rowData.number;
	
	  var path = '/v2/' + store_id + '/' + _constant.ROOT_ROUTE + '/' + id;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { className: 'block-a', to: path },
	    number
	  );
	}
	
	IndexName.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexName;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexQuantity(props) {
	    var _props$data = props.data,
	        data = _props$data === undefined ? [] : _props$data;
	
	    var qty = data.reduce(function (total, item) {
	        return total + parseFloat(item.delivery_order_item.quantity);
	    }, 0);
	    return _react2.default.createElement(
	        'div',
	        null,
	        qty
	    );
	}
	
	IndexQuantity.propTypes = {
	    data: _propTypes2.default.array.isRequired
	};
	
	exports.default = IndexQuantity;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateDisplay = __webpack_require__(314);
	
	var _dateDisplay2 = _interopRequireDefault(_dateDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexShipDate(props, context) {
	    var _props$rowData = props.rowData,
	        rowData = _props$rowData === undefined ? {} : _props$rowData;
	    var ship_date = rowData.ship_date,
	        expected_ship_date = rowData.expected_ship_date;
	
	    var timezone = context.currentStore && context.currentStore.timezone;
	    var date = ship_date || expected_ship_date || null;
	    return _react2.default.createElement(_dateDisplay2.default, { value: date, timezone: timezone });
	}
	
	IndexShipDate.propTypes = {
	    rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexShipDate;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexType(props) {
	    var _props$rowData = props.rowData,
	        _props$rowData$order_ = _props$rowData.order_ids,
	        order_ids = _props$rowData$order_ === undefined ? [] : _props$rowData$order_,
	        _props$rowData$stock_ = _props$rowData.stock_transfer_ids,
	        stock_transfer_ids = _props$rowData$stock_ === undefined ? [] : _props$rowData$stock_;
	
	    var type = order_ids.length > 0 ? 'Invoice' : stock_transfer_ids.length > 0 ? 'Stock Transfer' : 'Unknow';
	    return _react2.default.createElement(
	        'div',
	        null,
	        type
	    );
	}
	
	IndexType.propTypes = {
	    rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexType;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainContent = __webpack_require__(93);
	
	var _indexStatus = __webpack_require__(319);
	
	var _indexStatus2 = _interopRequireDefault(_indexStatus);
	
	var _dateTimeDisplay = __webpack_require__(184);
	
	var _dateTimeDisplay2 = _interopRequireDefault(_dateTimeDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logs(props) {
	    var className = props.className,
	        style = props.style;
	    var _props$qtySent = props.qtySent,
	        qtySent = _props$qtySent === undefined ? 0 : _props$qtySent,
	        _props$invoices = props.invoices,
	        invoices = _props$invoices === undefined ? [] : _props$invoices,
	        _props$logs = props.logs,
	        logs = _props$logs === undefined ? [] : _props$logs;
	
	    return _react2.default.createElement(
	        'div',
	        { className: className, style: style },
	        _react2.default.createElement(
	            _mainContent.MainContentSection,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-8' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'INVOICES'
	                    ),
	                    invoices.map(function (id) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: id },
	                            id
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-4', style: { textAlign: 'right' } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'QTY DELIVERED'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        qtySent
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table data-table data-table--no-border' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { style: { width: '60%' } },
	                        'Date'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { style: { width: '20%' } },
	                        'User'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { style: { width: '20%' } },
	                        'Status'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                logs.map(function (log, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_dateTimeDisplay2.default, { value: log.created_at })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            log.cashier_name
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_indexStatus2.default, { data: log.state })
	                        )
	                    );
	                })
	            )
	        )
	    );
	}
	
	Logs.propTypes = {
	    qtySent: _propTypes2.default.number,
	    invoices: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    logs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        cashier_name: _propTypes2.default.string.isRequired,
	        created_at: _propTypes2.default.object.isRequired,
	        state: _propTypes2.default.string
	    })),
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = Logs;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modalToggle = __webpack_require__(475);
	
	var _modalToggle2 = _interopRequireDefault(_modalToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SerialNumberInput = function (_Component) {
	    _inherits(SerialNumberInput, _Component);
	
	    function SerialNumberInput(props) {
	        _classCallCheck(this, SerialNumberInput);
	
	        var _this = _possibleConstructorReturn(this, (SerialNumberInput.__proto__ || Object.getPrototypeOf(SerialNumberInput)).call(this, props));
	
	        _this.state = {
	            serialNumbers: [null]
	        };
	        return _this;
	    }
	
	    _createClass(SerialNumberInput, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var serialNumbers = (nextProps.serialNumbers || []).map(function (d) {
	                return d.value;
	            }).concat(null);
	            this.setState({ serialNumbers: serialNumbers });
	        }
	    }, {
	        key: '_confirm',
	        value: function _confirm() {
	            var serialNumbers = this.props.serialNumbers;
	
	            var data = this.state.serialNumbers || [];
	            data = data.filter(this._filter).map(function (d) {
	                return d.trim();
	            });
	            var ret = this.props.onConfirm(data);
	            if (ret !== false) {
	                for (var i = serialNumbers.length - 1; i >= 0; i--) {
	                    serialNumbers.removeField(i);
	                }
	                data.forEach(function (d) {
	                    return serialNumbers.addField(d);
	                });
	            }
	        }
	    }, {
	        key: '_change',
	        value: function _change(i, value) {
	            var _props$max = this.props.max,
	                max = _props$max === undefined ? -1 : _props$max;
	            var _state$serialNumbers = this.state.serialNumbers,
	                serialNumbers = _state$serialNumbers === undefined ? [] : _state$serialNumbers;
	
	            serialNumbers = serialNumbers.slice(0);
	            serialNumbers[i] = value;
	            if (i === serialNumbers.length - 1 && value != null && value !== '') {
	                serialNumbers.push(null);
	            }
	            this._refresh({ serialNumbers: serialNumbers }, max);
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(i) {
	            var _state$serialNumbers2 = this.state.serialNumbers,
	                serialNumbers = _state$serialNumbers2 === undefined ? [] : _state$serialNumbers2;
	
	            serialNumbers = serialNumbers.slice(0);
	            if (i >= 0 && i < serialNumbers.length) {
	                serialNumbers.splice(i, 1);
	            }
	            this._refresh({ serialNumbers: serialNumbers });
	        }
	    }, {
	        key: '_filter',
	        value: function _filter(d) {
	            return d != null && d !== '';
	        }
	    }, {
	        key: '_refresh',
	        value: function _refresh(state, max) {
	            var _state$serialNumbers3 = state.serialNumbers,
	                serialNumbers = _state$serialNumbers3 === undefined ? [] : _state$serialNumbers3;
	
	            serialNumbers = serialNumbers.slice(0);
	            var lastValue = serialNumbers[serialNumbers.length - 1];
	            if (this._filter(lastValue)) {
	                serialNumbers.push(null);
	            }
	            if (max >= 0) {
	                serialNumbers = serialNumbers.slice(0, max);
	            }
	            this.setState({ serialNumbers: serialNumbers });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _confirm = this._confirm.bind(this);
	            var props = this.props;
	            var _props$productName = props.productName,
	                productName = _props$productName === undefined ? 'Serial Number' : _props$productName;
	
	            var state = this.state;
	            var _state$serialNumbers4 = state.serialNumbers,
	                serialNumbers = _state$serialNumbers4 === undefined ? [] : _state$serialNumbers4;
	
	
	            return _react2.default.createElement(
	                _modalToggle2.default,
	                {
	                    header: productName,
	                    togglerLabel: 'Enter S/N',
	                    togglerStyle: { width: 250 },
	                    onConfirm: _confirm
	                },
	                serialNumbers.map(function (sn, i) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'form-group', key: i },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Serial Number ',
	                            i + 1
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex' } },
	                            _react2.default.createElement('input', { className: 'form-control', style: { flex: 1 },
	                                value: sn, onChange: function onChange(event) {
	                                    return _this2._change(i, event.target.value);
	                                } }),
	                            _react2.default.createElement(
	                                'span',
	                                {
	                                    className: 'btn btn-sm',
	                                    style: {
	                                        marginLeft: 10,
	                                        visibility: i === serialNumbers.length - 1 ? 'hidden' : 'visible'
	                                    },
	                                    onClick: function onClick(event) {
	                                        return _this2._remove(i);
	                                    }
	                                },
	                                'x'
	                            )
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return SerialNumberInput;
	}(_react.Component);
	
	SerialNumberInput.propTypes = {
	    onConfirm: _propTypes2.default.func.isRequired,
	    productName: _propTypes2.default.string,
	    serialNumbers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.string
	    })),
	    max: _propTypes2.default.number
	};
	
	exports.default = SerialNumberInput;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _addInvoice = __webpack_require__(471);
	
	var _addInvoice2 = _interopRequireDefault(_addInvoice);
	
	var _indexName = __webpack_require__(819);
	
	var _indexName2 = _interopRequireDefault(_indexName);
	
	var _indexDate = __webpack_require__(818);
	
	var _indexDate2 = _interopRequireDefault(_indexDate);
	
	var _indexShipDate = __webpack_require__(821);
	
	var _indexShipDate2 = _interopRequireDefault(_indexShipDate);
	
	var _indexType = __webpack_require__(822);
	
	var _indexType2 = _interopRequireDefault(_indexType);
	
	var _indexQuantity = __webpack_require__(820);
	
	var _indexQuantity2 = _interopRequireDefault(_indexQuantity);
	
	var _indexStatus = __webpack_require__(319);
	
	var _indexStatus2 = _interopRequireDefault(_indexStatus);
	
	var _constant = __webpack_require__(186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	var columnMetadatas = [{
	  columnName: 'order_ids',
	  displayName: 'Type',
	  customComponent: _indexType2.default
	  // TODO: filter by Type
	}, {
	  columnName: "number",
	  displayName: "D.N. Number",
	  customComponent: _indexName2.default,
	  filterConditions: ['contain']
	}, {
	  columnName: "customer_name",
	  displayName: "Customer"
	}, {
	  columnName: 'delivery_order_items',
	  displayName: 'Qty',
	  customComponent: _indexQuantity2.default
	}, {
	  columnName: "ship_date",
	  customComponent: _indexShipDate2.default,
	  displayName: "Delivery Date"
	}, {
	  columnName: 'state',
	  displayName: 'Status',
	  customComponent: _indexStatus2.default
	  // TODO: filter by status
	}, {
	  columnName: "created_at",
	  customComponent: _indexDate2.default,
	  displayName: "Created At"
	}];
	
	// Columns for grid display
	var columns = columnMetadatas.map(function (i) {
	  return i.columnName;
	});
	
	// Columns for filter
	var filterSettings = columnMetadatas.filter(function (i) {
	  return i.displayName && i.filterConditions;
	}).map(function (i) {
	  return {
	    columnName: i.columnName,
	    displayName: i.displayName,
	    filterConditions: i.filterConditions
	  };
	});
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var pathKey = props.location.pathname + props.location.search;
	  var pathState = state.path[pathKey];
	  var appState = state;
	  var loading = state.base.loading,
	      entities = state.entities;
	
	  return { appState: appState, pathState: pathState, entities: entities, loading: loading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var DeliveryNoteIndex = (_temp2 = _class = function (_Component) {
	  _inherits(DeliveryNoteIndex, _Component);
	
	  function DeliveryNoteIndex() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeliveryNoteIndex);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryNoteIndex.__proto__ || Object.getPrototypeOf(DeliveryNoteIndex)).call.apply(_ref, [this].concat(args))), _this), _this.setPage = function (index) {
	      var _this$props = _this.props,
	          store_id = _this$props.params.store_id,
	          filters = _this$props.location.query.filters;
	      var _this$props$pathState = _this.props.pathState.delivery_orders_meta,
	          count = _this$props$pathState.count,
	          totalPages = _this$props$pathState.totalPages;
	
	      var page = index >= totalPages ? totalPages : index < 1 ? 1 : index + 1;
	
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/' + _constant.ROOT_ROUTE,
	        query: {
	          page: page,
	          count: count,
	          filters: filters
	        }
	      });
	    }, _this.handleSearch = function (filters) {
	      var store_id = _this.props.params.store_id;
	      var _this$props$pathState2 = _this.props.pathState.delivery_orders_meta,
	          page = _this$props$pathState2.page,
	          count = _this$props$pathState2.count;
	
	      var filterString = _filterHelper2.default.filtersToQueryString(filters);
	
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/' + _constant.ROOT_ROUTE,
	        query: {
	          page: page,
	          count: count,
	          filters: filterString
	        }
	      });
	    }, _this.handleFilterSave = function (name, filter) {
	      _this.props.actions.saveFilter('voucher', name, filter);
	    }, _this.handleFilterRemove = function (name) {
	      _this.props.actions.removeFilter('voucher', name);
	    }, _this.handleFilterSelected = function (selectedFilter) {
	      _this.props.actions.updateVoucherFilters(selectedFilter);
	    }, _this.createByInvoice = function () {
	      var invoices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var _invoices = _slicedToArray(invoices, 1),
	          ref_id = _invoices[0].number;
	
	      var store_id = _this.props.params.store_id;
	
	      var path = '/v2/' + store_id + '/' + _constant.ROOT_ROUTE + '/new/for/invoice/' + ref_id;
	      if (store_id && ref_id) {
	        _this.context.router.push({
	          pathname: path
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeliveryNoteIndex, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateData(this.props);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var pathKey = this.props.location.pathname + this.props.location.search;
	
	      if (prevProps.location.pathname + prevProps.location.search !== pathKey) {
	        this.updateData(this.props);
	      }
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(props) {
	      var store_id = props.params.store_id,
	          _props$location = props.location,
	          pathname = _props$location.pathname,
	          search = _props$location.search,
	          _props$location$query = _props$location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	      var pathKey = pathname + search;
	
	      props.actions.getDeliveryOrders(store_id, page, count, undefined, filtersObject, pathKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var filtersStr = props.location.query.filters;
	      var _props$pathState = props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState,
	          _props$entities = props.entities,
	          entities = _props$entities === undefined ? {} : _props$entities,
	          loading = props.loading;
	      var delivery_orders = pathState.delivery_orders,
	          _pathState$delivery_o = pathState.delivery_orders_meta,
	          delivery_orders_meta = _pathState$delivery_o === undefined ? {} : _pathState$delivery_o;
	      var page = delivery_orders_meta.page,
	          count = delivery_orders_meta.count,
	          totalPages = delivery_orders_meta.totalPages;
	
	      var filters = _filterHelper2.default.stringToFilters(filtersStr);
	      var noDataMessage = filters ? 'No search result' : 'There is no listing data';
	      var gridData = (delivery_orders || []).map(function (id) {
	        var _entities$deliveryOrd = entities.deliveryOrders,
	            deliveryOrders = _entities$deliveryOrd === undefined ? {} : _entities$deliveryOrd;
	
	        var item = deliveryOrders[id];
	        return item;
	      }).filter(function (item) {
	        return !!item;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp', style: { flexDirection: "column" } },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns ' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Delivery note'
	          ),
	          _react2.default.createElement(
	            _addInvoice2.default,
	            {
	              singleSelect: true,
	              onConfirm: this.createByInvoice,
	              filters: { inventory_status: ['unfulfilled', 'in_transit'] },
	              className: 'btn btn-primary btn-sm' },
	            'Create D.N.for Invoice'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content -main-filter' },
	          _react2.default.createElement(_cascadeFilterCollection2.default, {
	            group: 'delivery_orders',
	            settings: filterSettings,
	            filters: filters,
	            onSearch: this.handleSearch
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content', style: { height: "75%" } },
	          !loading && delivery_orders ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_griddleReact2.default, {
	              useExternal: true,
	              useGriddleStyles: false,
	              tableClassName: 'table table-bordered data-table',
	              externalSetPage: this.setPage,
	              externalChangeSort: noop,
	              externalSetFilter: noop,
	              externalSetPageSize: noop,
	              externalMaxPage: totalPages,
	              externalCurrentPage: page - 1,
	              resultsPerPage: count,
	              results: gridData,
	              noDataMessage: noDataMessage,
	              columns: columns,
	              columnMetadata: columnMetadatas })
	          ) : _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading delivery note'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeliveryNoteIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  entities: _propTypes2.default.object,
	  pathState: _propTypes2.default.object,
	  location: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeliveryNoteIndex);

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _overviewForm = __webpack_require__(481);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _remarks = __webpack_require__(482);
	
	var _remarks2 = _interopRequireDefault(_remarks);
	
	var _logs = __webpack_require__(823);
	
	var _logs2 = _interopRequireDefault(_logs);
	
	var _mainContent = __webpack_require__(190);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _mainContentHeader = __webpack_require__(188);
	
	var _mainContentHeader2 = _interopRequireDefault(_mainContentHeader);
	
	var _mainContentTabs = __webpack_require__(238);
	
	var _mainContentTabs2 = _interopRequireDefault(_mainContentTabs);
	
	var _breadcrumb = __webpack_require__(187);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _constant = __webpack_require__(186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryOrderOverview = function (_Component) {
	    _inherits(DeliveryOrderOverview, _Component);
	
	    function DeliveryOrderOverview() {
	        _classCallCheck(this, DeliveryOrderOverview);
	
	        return _possibleConstructorReturn(this, (DeliveryOrderOverview.__proto__ || Object.getPrototypeOf(DeliveryOrderOverview)).apply(this, arguments));
	    }
	
	    _createClass(DeliveryOrderOverview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$params = this.props.params,
	                store_id = _props$params.store_id,
	                delivery_id = _props$params.delivery_id;
	            var initDeliveryOrderOverview = this.props.actions.initDeliveryOrderOverview;
	
	
	            initDeliveryOrderOverview(store_id, delivery_id);
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(data) {
	            var props = this.props;
	            var _props$params2 = props.params,
	                store_id = _props$params2.store_id,
	                delivery_id = _props$params2.delivery_id,
	                actions = props.actions;
	
	            actions.updateDeliveryOrder(store_id, delivery_id, data);
	        }
	    }, {
	        key: 'saveEdit',
	        value: function saveEdit() {
	            this.refs.OverviewForm.submit();
	        }
	    }, {
	        key: 'cancelEdit',
	        value: function cancelEdit() {
	            var _props = this.props,
	                _props$params3 = _props.params,
	                store_id = _props$params3.store_id,
	                delivery_id = _props$params3.delivery_id,
	                actions = _props.actions;
	
	            actions.initDeliveryOrderOverview(store_id, delivery_id);
	        }
	    }, {
	        key: 'sendEmail',
	        value: function sendEmail() {
	            var _props2 = this.props,
	                _props2$params = _props2.params,
	                store_id = _props2$params.store_id,
	                delivery_id = _props2$params.delivery_id,
	                _props2$pathState = _props2.pathState,
	                pathState = _props2$pathState === undefined ? {} : _props2$pathState,
	                actions = _props2.actions;
	            var _pathState$initialVal = pathState.initialValues,
	                initialValues = _pathState$initialVal === undefined ? {} : _pathState$initialVal;
	            var _initialValues$delive = initialValues.delivery_order,
	                _initialValues$delive2 = _initialValues$delive.order_ids,
	                order_ids = _initialValues$delive2 === undefined ? [] : _initialValues$delive2,
	                email = _initialValues$delive.delivery_note.email;
	
	            actions.sendEmailTemplate(store_id, email, delivery_id, order_ids[0]);
	        }
	    }, {
	        key: 'exportPdf',
	        value: function exportPdf() {}
	    }, {
	        key: 'markAsDelivered',
	        value: function markAsDelivered() {
	            var props = this.props;
	            var _props$params4 = props.params,
	                store_id = _props$params4.store_id,
	                delivery_id = _props$params4.delivery_id,
	                appState = props.appState,
	                actions = props.actions;
	
	            var data = (0, _reduxForm.getValues)(appState.form.deliveryOverviewForm);
	            data.delivery_order.ship_date = data.delivery_order.expected_ship_date;
	            actions.fulfillDeliveryOrder(store_id, delivery_id, data);
	        }
	    }, {
	        key: 'cancelDeliveryOrder',
	        value: function cancelDeliveryOrder() {
	            var _props3 = this.props,
	                _props3$params = _props3.params,
	                store_id = _props3$params.store_id,
	                delivery_id = _props3$params.delivery_id,
	                actions = _props3.actions;
	
	            actions.cancelDeliveryOrder(store_id, delivery_id);
	        }
	    }, {
	        key: 'editDeliveryOrder',
	        value: function editDeliveryOrder() {
	            var _props4 = this.props,
	                currentTab = _props4.pathState.currentTab,
	                actions = _props4.actions;
	
	            actions.startEditDeliveryOrder(currentTab);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var actions = props.actions,
	                loading = props.loading;
	            var _props$pathState = props.pathState,
	                pathState = _props$pathState === undefined ? {} : _props$pathState;
	            var storeId = pathState.storeId,
	                deliveryId = pathState.deliveryId,
	                page = pathState.page,
	                currentTab = pathState.currentTab,
	                _pathState$initialVal2 = pathState.initialValues,
	                initialValues = _pathState$initialVal2 === undefined ? {} : _pathState$initialVal2,
	                _pathState$logs = pathState.logs,
	                logs = _pathState$logs === undefined ? [] : _pathState$logs;
	            var _initialValues$delive3 = initialValues.delivery_order,
	                delivery_order = _initialValues$delive3 === undefined ? {} : _initialValues$delive3,
	                _initialValues$delive4 = initialValues.delivery_order_items,
	                delivery_order_items = _initialValues$delive4 === undefined ? [] : _initialValues$delive4;
	
	            var qtySent = delivery_order_items.reduce(function (total, item) {
	                return total + item.qty_sent;
	            }, 0);
	            var state = delivery_order.state,
	                _delivery_order$order = delivery_order.orders,
	                orders = _delivery_order$order === undefined ? [] : _delivery_order$order;
	
	            var invoices = orders.map(function (order) {
	                return order.number;
	            });
	            var editButtons = [_react2.default.createElement(
	                'button',
	                { key: 'cancelEdit', className: 'btn btn-secondary btn-sm', disabled: loading,
	                    onClick: this.cancelEdit.bind(this) },
	                'Cancel'
	            ), _react2.default.createElement(
	                'button',
	                { key: 'editSave', className: 'btn btn-primary btn-sm', disabled: loading,
	                    onClick: this.saveEdit.bind(this) },
	                'Save'
	            )];
	            var viewButtons = [_react2.default.createElement(
	                'button',
	                { key: 'send', className: 'btn btn-secondary btn-sm', disabled: loading,
	                    onClick: this.sendEmail.bind(this) },
	                'Send Email Template'
	            )];
	            // Only can edit the Delivery Note when status is created
	            if (state == null) {
	                viewButtons.push([_react2.default.createElement(
	                    'button',
	                    { key: 'deliver', className: 'btn btn-secondary btn-sm', disabled: loading,
	                        onClick: this.markAsDelivered.bind(this) },
	                    'Mark As Delivered'
	                ), _react2.default.createElement(
	                    'button',
	                    { key: 'cancel', className: 'btn btn-secondary btn-sm', disabled: loading,
	                        onClick: this.cancelDeliveryOrder.bind(this) },
	                    'Cancel'
	                ), _react2.default.createElement(
	                    'button',
	                    { key: 'edit', className: 'btn btn-secondary btn-sm', disabled: loading,
	                        onClick: this.editDeliveryOrder.bind(this) },
	                    'Edit'
	                )]);
	            }
	            var pageButtons = page === _constant.EDIT ? editButtons : viewButtons;
	            var pageTitle = (page === _constant.EDIT ? 'Edit' : 'View') + ' Delivery Note';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'bp' },
	                _react2.default.createElement(
	                    _mainContent2.default,
	                    null,
	                    _react2.default.createElement(
	                        _mainContentHeader2.default,
	                        { title: pageTitle },
	                        pageButtons
	                    ),
	                    _react2.default.createElement(_breadcrumb2.default, { links: [{ label: 'Delivery Note', link: '/v2/' + storeId + '/' + _constant.ROOT_ROUTE }, { label: pageTitle }] }),
	                    _react2.default.createElement(
	                        _mainContentTabs2.default,
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#',
	                                className: 'nav-link ' + (currentTab === _constant.OVERVIEW ? 'active' : ''),
	                                onClick: function onClick(event) {
	                                    return actions.changeDeliveryOrderTab(_constant.OVERVIEW) || event.preventDefault();
	                                }
	                            },
	                            'Overview'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#',
	                                className: 'nav-link ' + (currentTab === _constant.REMARKS ? 'active' : ''),
	                                onClick: function onClick(event) {
	                                    return actions.changeDeliveryOrderTab(_constant.REMARKS) || event.preventDefault();
	                                }
	                            },
	                            'Remarks'
	                        ),
	                        page === _constant.VIEW ? _react2.default.createElement(
	                            'a',
	                            { href: '#',
	                                className: 'nav-link ' + (currentTab === _constant.LOG ? 'active' : ''),
	                                onClick: function onClick(event) {
	                                    return actions.viewDeliveryOrderLogs(storeId, deliveryId) || event.preventDefault();
	                                }
	                            },
	                            'Log'
	                        ) : null
	                    ),
	                    _react2.default.createElement(_overviewForm2.default, { ref: 'OverviewForm',
	                        style: { display: currentTab === _constant.OVERVIEW ? 'block' : 'none' },
	                        initialValues: initialValues, viewMode: page === _constant.VIEW,
	                        onSubmit: this.onSubmit.bind(this) }),
	                    _react2.default.createElement(_remarks2.default, {
	                        style: { display: currentTab === _constant.REMARKS ? 'block' : 'none' },
	                        viewMode: page === _constant.VIEW }),
	                    _react2.default.createElement(_logs2.default, { style: { display: currentTab === _constant.LOG ? 'block' : 'none' },
	                        qtySent: qtySent,
	                        invoices: invoices,
	                        logs: logs })
	                )
	            );
	        }
	    }]);
	
	    return DeliveryOrderOverview;
	}(_react.Component);
	
	DeliveryOrderOverview.contextTypes = {
	    router: _propTypes2.default.object.isRequired,
	    currentStore: _propTypes2.default.object.isRequired
	};
	
	DeliveryOrderOverview.propTypes = {
	    params: _propTypes2.default.shape({
	        store_id: _propTypes2.default.string.isRequired,
	        delivery_id: _propTypes2.default.string.isRequired
	    }).isRequired,
	    pathState: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var _state$deliveryOrder = state.deliveryOrder,
	        pathState = _state$deliveryOrder === undefined ? {} : _state$deliveryOrder;
	
	    var appState = state;
	    var loading = state.base.loading,
	        entities = state.entities;
	
	    return { appState: appState, pathState: pathState, entities: entities, loading: loading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeliveryOrderOverview);

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _overviewForm = __webpack_require__(481);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _remarks = __webpack_require__(482);
	
	var _remarks2 = _interopRequireDefault(_remarks);
	
	var _mainContent = __webpack_require__(190);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _mainContentHeader = __webpack_require__(188);
	
	var _mainContentHeader2 = _interopRequireDefault(_mainContentHeader);
	
	var _mainContentTabs = __webpack_require__(238);
	
	var _mainContentTabs2 = _interopRequireDefault(_mainContentTabs);
	
	var _breadcrumb = __webpack_require__(187);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _constant = __webpack_require__(186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryOrderOverviewNew = function (_Component) {
	    _inherits(DeliveryOrderOverviewNew, _Component);
	
	    function DeliveryOrderOverviewNew() {
	        _classCallCheck(this, DeliveryOrderOverviewNew);
	
	        return _possibleConstructorReturn(this, (DeliveryOrderOverviewNew.__proto__ || Object.getPrototypeOf(DeliveryOrderOverviewNew)).apply(this, arguments));
	    }
	
	    _createClass(DeliveryOrderOverviewNew, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$params = this.props.params,
	                store_id = _props$params.store_id,
	                type = _props$params.type,
	                ref_id = _props$params.ref_id;
	            var initDeliveryOrderForInvoice = this.props.actions.initDeliveryOrderForInvoice;
	
	
	            if (type === 'invoice') {
	                initDeliveryOrderForInvoice(store_id, ref_id);
	            }
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(data) {
	            var props = this.props;
	            var store_id = props.params.store_id,
	                actions = props.actions;
	
	            actions.createDeliveryOrder(store_id, data);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            this.refs.OverviewForm.submit();
	        }
	    }, {
	        key: 'handleCancel',
	        value: function handleCancel() {
	            _reactRouter.browserHistory.goBack();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var actions = props.actions;
	            var _props$pathState = props.pathState,
	                pathState = _props$pathState === undefined ? {} : _props$pathState;
	            var storeId = pathState.storeId,
	                currentTab = pathState.currentTab,
	                initialValues = pathState.initialValues;
	
	
	            return _react2.default.createElement(
	                _mainContent2.default,
	                null,
	                _react2.default.createElement(
	                    _mainContentHeader2.default,
	                    { title: 'New Delivery Note' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-secondary', onClick: this.handleCancel.bind(this) },
	                        'Cancel'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit.bind(this) },
	                        'Save'
	                    )
	                ),
	                _react2.default.createElement(_breadcrumb2.default, { links: [{ label: 'Delivery Note', link: '/' + storeId + '/' + _constant.ROOT_ROUTE }, { label: 'New Delivery Note' }] }),
	                _react2.default.createElement(
	                    _mainContentTabs2.default,
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'nav-link ' + (currentTab === _constant.OVERVIEW ? 'active' : ''),
	                            onClick: function onClick(event) {
	                                return actions.changeDeliveryOrderTab(_constant.OVERVIEW) && event.preventDefault();
	                            }
	                        },
	                        'Overview'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'nav-link ' + (currentTab === _constant.REMARKS ? 'active' : ''),
	                            onClick: function onClick(event) {
	                                return actions.changeDeliveryOrderTab(_constant.REMARKS) && event.preventDefault();
	                            }
	                        },
	                        'Remarks'
	                    )
	                ),
	                _react2.default.createElement(_overviewForm2.default, { ref: 'OverviewForm',
	                    style: { display: currentTab === _constant.OVERVIEW ? 'block' : 'none' },
	                    initialValues: initialValues,
	                    onSubmit: this.onSubmit.bind(this) }),
	                _react2.default.createElement(_remarks2.default, { style: { display: currentTab === _constant.REMARKS ? 'block' : 'none' } })
	            );
	        }
	    }]);
	
	    return DeliveryOrderOverviewNew;
	}(_react.Component);
	
	DeliveryOrderOverviewNew.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	DeliveryOrderOverviewNew.propTypes = {
	    params: _propTypes2.default.shape({
	        store_id: _propTypes2.default.string.isRequired,
	        type: _propTypes2.default.string.isRequired,
	        ref_id: _propTypes2.default.string.isRequired
	    }).isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var _state$deliveryOrder = state.deliveryOrder,
	        pathState = _state$deliveryOrder === undefined ? {} : _state$deliveryOrder;
	
	    var appState = state;
	    var loading = state.base.loading,
	        entities = state.entities;
	
	    return { appState: appState, pathState: pathState, entities: entities, loading: loading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeliveryOrderOverviewNew);

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = (_temp = _class = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.actions.getStores();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.checkStore(nextProps);
	    }
	  }, {
	    key: 'checkStore',
	    value: function checkStore(props) {
	      var stores = props.appState.stores;
	
	      if (stores.length > 0) {
	        if (!props.params.store_id) {
	          this.context.router.push({
	            pathname: '/v2/' + stores[0].id + '/inventory'
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'login-layout' },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-layout-main' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _loading2.default,
	              null,
	              'Loading Stores'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'login-layout-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'copyright' },
	            _react2.default.createElement(
	              'p',
	              null,
	              '2016 Bindo Labs, Inc. All rights reserved.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Bindo is a registered trademark of Bindo Labs, Inc'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react2.default.Component), _class.propTypes = {
	  actions: _propTypes2.default.object.isRequired,
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired
	}, _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Index;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _includes = __webpack_require__(637);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _alert = __webpack_require__(313);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IMPORTED = "imported";
	var PENDING_VALIDATION = "pending_validation";
	var PENDING_IMPORT = "pending_import";
	var IMPORTING = "importing";
	var IMPORT_ERROR = 'import_error';
	var VALIDATED = "validated";
	var VALIDATE_ERROR = "validate_error";
	var VALIDATING = "validating";
	
	var Importer = (_temp = _class = function (_Component) {
	  _inherits(Importer, _Component);
	
	  function Importer(props) {
	    _classCallCheck(this, Importer);
	
	    var _this = _possibleConstructorReturn(this, (Importer.__proto__ || Object.getPrototypeOf(Importer)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    _this.IVTypes = {
	      opening: 1,
	      actual_qty: 2,
	      var_qty: 3,
	      cost_adjust: 4
	    };
	
	    _this.state = {
	      type: _this.IVTypes.opening
	    };
	    return _this;
	  }
	
	  _createClass(Importer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.actions.importInit();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var sourceDate = nextProps.appState.importerStatus.inventory_variance_import ? nextProps.appState.importerStatus.inventory_variance_import : nextProps.appState.importerStatus;
	      var status = sourceDate.status || '';
	      var allow_import = sourceDate.allow_import || '';
	      var inventory_import_id = sourceDate.id || '';
	
	      if (status === VALIDATING || status === PENDING_VALIDATION || status === VALIDATED && allow_import === false) {
	        this.startPoll(inventory_import_id);
	      } else if (status === PENDING_IMPORT || status === IMPORTING) {
	        this.startPoll(inventory_import_id);
	      }
	    }
	  }, {
	    key: 'validateFileName',
	    value: function validateFileName(files) {
	      //validating the file name
	      var isValid = true;
	      (0, _forEach2.default)(files, function (val, key) {
	        if (!val.dir && !(0, _includes2.default)(val.name, 'png') && !(0, _includes2.default)(val.name, 'jpg')) {
	          isValid = false;
	        }
	      });
	      return isValid;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var type = event.target.value;
	      this.setState({ type: type });
	    }
	  }, {
	    key: 'handleFile',
	    value: function handleFile(e) {
	      var self = this;
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	      var type = this.state.type;
	      var store_id = params.store_id;
	
	      var reader = new FileReader();
	
	      var file = self.refs.uploadCSV.files[0];
	
	      reader.onload = function (upload) {
	
	        var data = new FormData();
	        data.append('inventory_variance_import[csv]', file);
	        data.append('type_id', type);
	        actions.validateImportIV(store_id, data);
	      };
	      reader.readAsText(file);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'startPoll',
	    value: function startPoll(inventory_import_id) {
	      var store_id = this.props.params.store_id;
	      var actions = this.props.actions;
	
	      this.timeout = setTimeout(function () {
	        return actions.getImportIV(store_id, inventory_import_id);
	      }, 3000);
	    }
	  }, {
	    key: 'startImport',
	    value: function startImport() {
	      var _this2 = this;
	
	      var store_id = this.props.params.store_id;
	
	      var id = this.props.appState.importerStatus.inventory_variance_import.id;
	      this.props.actions.postImportIV(store_id, id);
	      this.timeint = setTimeout(function () {
	        return _this2.props.actions.getImportIV(store_id, id);
	      }, 3000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	
	      var validate_msg = '';
	      var warning_msg = '';
	      var error_msg = '';
	      var disableImport = true;
	      var isShowUploadCSVForm = true;
	      var progress_rate = 0;
	      var type = this.state.type;
	
	      var sourceDate = appState.importerStatus.inventory_variance_import ? appState.importerStatus.inventory_variance_import : appState.importerStatus;
	
	      var backPath = '/v2/' + params.store_id + '/inventory-variance';
	
	      switch (sourceDate.status) {
	        case IMPORTED:
	          validate_msg = 'Import Success';
	          progress_rate = 100;
	          isShowUploadCSVForm = true;
	          break;
	
	        case VALIDATING:
	        case PENDING_VALIDATION:
	          validate_msg = 'Please wait, we are validating your data';
	          progress_rate = parseFloat(sourceDate.validation_progress_rate || 0) * 100;
	          isShowUploadCSVForm = false;
	          break;
	
	        case IMPORTING:
	        case PENDING_IMPORT:
	          validate_msg = 'Please wait, we are importing your data';
	          progress_rate = parseFloat(sourceDate.import_progress_rate || 0) * 100;
	          isShowUploadCSVForm = false;
	          break;
	
	        case IMPORT_ERROR:
	          warning_msg = (0, _map2.default)(sourceDate.humanize_validation_warnings, function (items, key) {
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'warning message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          error_msg = (0, _map2.default)(sourceDate.humanize_validation_errors, function (items, key) {
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Error message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          if (!error_msg.length && !warning_msg.length) {
	            validate_msg = 'Import Error &  Please check file';
	          }
	          isShowUploadCSVForm = true;
	          disableImport = true;
	          progress_rate = 100;
	          break;
	
	        case VALIDATED:
	        case VALIDATE_ERROR:
	
	          warning_msg = (0, _map2.default)(sourceDate.humanize_validation_warnings, function (items, key) {
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'warning message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          error_msg = (0, _map2.default)(sourceDate.humanize_validation_errors, function (items, key) {
	
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Error message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          if (!error_msg.length && !warning_msg.length) {
	            validate_msg = 'Validate Success & Ready to importing';
	          }
	
	          isShowUploadCSVForm = true;
	
	          disableImport = error_msg.length ? true : false;
	          progress_rate = 100;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Inventory'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: backPath, className: 'btn btn-secondary btn-sm' },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { disabled: disableImport, onClick: this.startImport.bind(this), className: 'btn btn-primary btn-sm' },
	              'Import'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Import Inventory Variance'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              '1.You can download this Inventory Variance templates to get started:'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { listStyle: 'none', margin: "0 0 10px 0", padding: 0 } },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: __webpack_require__(1304) },
	                'Opening CSV'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: __webpack_require__(1301) },
	                'Adjustment by Actual Qty CSV'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: __webpack_require__(1302) },
	                'Adjustment by Variance Qty CSV'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: __webpack_require__(1303) },
	                'Cost Adjustment CSV'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Tips: To make sure you entered the correct Product name or UPC or SKU, you can ',
	            _react2.default.createElement(
	              'a',
	              null,
	              'Export Sliplified Inventory Report'
	            ),
	            ' with the comespodeling columns as your Inventory Variance Template'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Step 1. Select Inventory Variance type'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'select',
	              { selected: type, onChange: this.handleChange },
	              _react2.default.createElement(
	                'option',
	                { value: this.IVTypes.opening },
	                'Opening'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: this.IVTypes.actual_qty },
	                'Adjustment by Actual QTY'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: this.IVTypes.var_qty },
	                'Adjustment by Variance QTY'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: this.IVTypes.cost_adjust },
	                'Cost Adjustment'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Step 2. Select File'
	          ),
	          _react2.default.createElement('progress', { className: 'progress', value: progress_rate, max: '100' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Inventory Variance file'
	          ),
	          isShowUploadCSVForm ? _react2.default.createElement(
	            'form',
	            { ref: 'uploadCSVForm', onSubmit: this.handleSubmit, encType: 'multipart/form-data' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { accept: '.csv,.txt', ref: 'uploadCSV', type: 'file', onChange: this.handleFile.bind(this) })
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            validate_msg ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'info' },
	              ' ',
	              _react2.default.createElement(
	                'p',
	                null,
	                validate_msg
	              ),
	              ' '
	            ) : null,
	            warning_msg && warning_msg.length > 0 ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'warning' },
	              ' ',
	              warning_msg,
	              ' '
	            ) : null,
	            error_msg && error_msg.length > 0 ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'danger' },
	              ' ',
	              error_msg,
	              ' '
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Importer;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Importer;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constants = __webpack_require__(26);
	
	var _statusHelper = __webpack_require__(317);
	
	var _mainContent = __webpack_require__(93);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _status = __webpack_require__(233);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _grid = __webpack_require__(66);
	
	var _addListing = __webpack_require__(229);
	
	var _addListing2 = _interopRequireDefault(_addListing);
	
	var _date = __webpack_require__(230);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var ivActions = _interopRequireWildcard(_inventoryVarianceActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE = _constants.INVENTORY_VARIANCE.TYPE,
	    TYPE_LABEL = _constants.INVENTORY_VARIANCE.TYPE_LABEL,
	    MODE = _constants.INVENTORY_VARIANCE.MODE;
	
	
	function mapStateToProp(state) {
	  var _state$inventoryVaria = state.inventoryVariance,
	      pathState = _state$inventoryVaria === undefined ? {} : _state$inventoryVaria;
	
	  return { pathState: pathState };
	}
	
	function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, ivActions);
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	}
	
	var ItemTemplate = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (0, _griddleComponents.listingComponent)(_class = (0, _griddleComponents.currencyInputComponent)(_class = (0, _griddleComponents.numberInputComponent)(_class = (0, _griddleComponents.textInputComponent)(_class = (0, _griddleComponents.countSerialNumberComponent)(_class = (0, _griddleComponents.selectComponent)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ItemTemplate, _Component);
	
	  function ItemTemplate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ItemTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemTemplate.__proto__ || Object.getPrototypeOf(ItemTemplate)).call.apply(_ref, [this].concat(args))), _this), _this.removeLineItem = function (data) {
	      _this.props.actions.removeListings([data.listingId]);
	    }, _this.goToPage = function (page) {
	      _this.props.actions.listingGoToPage(page);
	    }, _this.addListing = function (data) {
	      _this.props.actions.addListings(data);
	    }, _this.handleRowChangeFactory = function (field) {
	      return function (value, row) {
	        var actions = _this.props.actions;
	
	        var actionMap = {
	          actualQty: actions.updateActualQty,
	          varianceQtyInDisplayUnit: actions.updateVarianceQty,
	          cost: actions.updateCost,
	          serialNumbers: actions.updateSerialNumbers,
	          remark: actions.updateRemark,
	          displayUnitId: actions.updateUnit
	        };
	        var func = actionMap[field];
	        if (func) {
	          func(row.listingId, value);
	        }
	      };
	    }, _this.handleFieldChange = function (field, value) {
	      _this.props.actions.updateIvField(field, value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ItemTemplate, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$pathState = this.props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState;
	      var _pathState$currentSto = pathState.currentStore,
	          currentStore = _pathState$currentSto === undefined ? {} : _pathState$currentSto,
	          mode = pathState.mode,
	          type = pathState.type,
	          currentPage = pathState.currentPage,
	          totalPages = pathState.totalPages,
	          totalEntries = pathState.totalEntries,
	          varianceCostTotal = pathState.varianceCostTotal,
	          _pathState$iv = pathState.iv,
	          iv = _pathState$iv === undefined ? {} : _pathState$iv,
	          _pathState$activeItem = pathState.activeItems,
	          activeItems = _pathState$activeItem === undefined ? [] : _pathState$activeItem;
	      var _currentStore$module = currentStore.module,
	          storeModule = _currentStore$module === undefined ? {} : _currentStore$module;
	      var quantity_allow_decimal = storeModule.quantity_allow_decimal,
	          quantity_decimal_points = storeModule.quantity_decimal_points;
	
	      var qtyAllowDpAll = quantity_allow_decimal === _constants.QUANTITY_ALLOW_DECIMAL_ALLOW_ALL;
	      var qtyAllowDpPartially = quantity_allow_decimal === _constants.QUANTITY_ALLOW_DECIMAL_ALLOW_PARTIALLY;
	      var isNew = mode === MODE.NEW;
	      var isView = mode === MODE.VIEW;
	      var isEdit = mode === MODE.EDIT;
	      var data = activeItems;
	      data.map(function (v, i) {
	        if (!v.id) {
	          v.id = i + Math.random();
	        }
	        // if (!v.displayUnit) {
	        //   v.quantityInDisplayUnit = v.actualQty
	        //   v.varianceQtyInDisplayUnit = v.varianceQty
	        //   v.costInDisplayUnit = v.cost
	        //   v.totalCost = v.actualQty.times(v.cost)
	        // }
	        // if(iv.status == 'completed') v.varianceQtyInDisplayUnit = v.quantityInDisplayUnit
	      });
	      var columns = [{
	        columnName: "productName",
	        displayName: "Product", // BPID, BLID, UPC/EAN, PLU/SKU
	        customComponent: this.listingComponent(['bpid', 'blid', 'ean13', 'listingBarcode', 'listingReferenceCodes'])
	      }, {
	        columnName: "qtyBefore",
	        displayName: "System Count",
	        hide: type == TYPE.OPENING,
	        customComponent: this.numberInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: true,
	          dp: function dp(props) {
	            return qtyAllowDpAll || qtyAllowDpPartially && props.rowData.quantityAllowDecimal ? quantity_decimal_points : 0;
	          }
	        }
	      }, {
	        columnName: "quantityInDisplayUnit",
	        displayName: "Actual Count",
	        hide: type == TYPE.VARIANCE_QTY_ADJ || type == TYPE.COST_ADJ,
	        customComponent: this.numberInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: function readOnly(props) {
	            return isView || type != TYPE.OPENING && type != TYPE.ACTUAL_QTY_ADJ || props.rowData.serialNumberEnabled;
	          },
	          dp: function dp(props) {
	            return qtyAllowDpAll || qtyAllowDpPartially && props.rowData.quantityAllowDecimal ? quantity_decimal_points : 0;
	          },
	          onChange: this.handleRowChangeFactory('actualQty')
	        }
	      }, {
	        columnName: "varianceQtyInDisplayUnit",
	        displayName: "Qty Variance",
	        hide: type == TYPE.OPENING || type == TYPE.COST_ADJ,
	        customComponent: this.numberInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: function readOnly(props) {
	            return isView || type != TYPE.VARIANCE_QTY_ADJ || props.rowData.serialNumberEnabled;
	          },
	          dp: function dp(props) {
	            return qtyAllowDpAll || qtyAllowDpPartially && props.rowData.quantityAllowDecimal ? quantity_decimal_points : 0;
	          },
	          onChange: this.handleRowChangeFactory('varianceQtyInDisplayUnit')
	        }
	      }, {
	        columnName: "costBefore",
	        displayName: "Unit Cost (Before)",
	        hide: type != TYPE.COST_ADJ,
	        customComponent: this.currencyInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: true,
	          dp: 4
	        }
	      },
	      // {
	      //   columnName: "displayUnitId",
	      //   displayName: "Unit",
	      //   customComponent: this.selectComponent,
	      //   customComponentProps: {
	      //     style: { minWidth: 120 },
	      //     readOnly: isView,
	      //     optionsAccessor:(props) => {return props.unitGroup ?
	      //         props.unitGroup.map(unit => ({ value: unit.id, label: unit.name }))
	      //         :
	      //         null
	      //       },
	      //     onChange: this.handleRowChangeFactory('displayUnitId'),
	      //   },
	      // },
	      {
	        columnName: "costInDisplayUnit",
	        displayName: "Unit Cost",
	        customComponent: this.currencyInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: isView || type != TYPE.OPENING && type != TYPE.COST_ADJ,
	          onChange: this.handleRowChangeFactory('cost'),
	          dp: 4
	        }
	      }, {
	        columnName: "varianceCost",
	        displayName: "Cost Variance",
	        hide: type == TYPE.OPENING,
	        customComponent: this.currencyInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: true,
	          dp: 4
	        }
	      }, {
	        columnName: "totalCost",
	        displayName: "Total Cost",
	        hide: type != TYPE.OPENING,
	        customComponent: this.currencyInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: true,
	          dp: 4
	        }
	      }, {
	        columnName: 'lots',
	        displayName: 'Lots',
	        hide: type == TYPE.COST_ADJ || true
	      }, {
	        columnName: "serialNumbers",
	        displayName: "Serial Numbers",
	        hide: type == TYPE.COST_ADJ,
	        customComponent: this.countSerialNumberComponent,
	        customComponentProps: {
	          productName: function productName(props) {
	            return props.rowData.productName;
	          },
	          hide: function hide(props) {
	            return !props.rowData.serialNumberEnabled;
	          },
	          readOnly: isView,
	          onConfirm: function onConfirm(value, rowData) {
	            return _this2.handleRowChangeFactory('serialNumbers')(value, rowData);
	          }
	        }
	      }, {
	        columnName: "remark",
	        displayName: "Remark",
	        customComponent: this.textInputComponent,
	        customComponentProps: {
	          style: { minWidth: 120 },
	          readOnly: function readOnly(props) {
	            return isView;
	          },
	          onChange: this.handleRowChangeFactory('remark')
	        }
	      }, {
	        columnName: "errors",
	        displayName: "Error",
	        hide: isNew,
	        customComponent: this.countSerialNumberComponent,
	        customComponentProps: {
	          productName: 'Errors',
	          hide: function hide(props) {
	            return (props.rowData.errors || []).length <= 0;
	          },
	          readOnly: true
	        }
	      }];
	      var actions = null;
	      var onRemove = isEdit || isNew ? this.removeLineItem : null;
	      var bodyConfig = { data: data, columns: columns, actions: actions, onRemove: onRemove, border: true };
	      var footerConfig = {
	        currentPage: currentPage,
	        totalPages: totalPages,
	        goToPage: this.goToPage,
	        hideRowPerPage: true
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _mainContent.MainContentSection,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_formGroup2.default, {
	              className: 'col-xs-6 col-lg-4 col-xl-3',
	              label: 'Store Name',
	              display: currentStore.title,
	              autoHideHelpText: true
	            }),
	            _react2.default.createElement(_formGroup2.default, {
	              className: 'col-xs-6 col-lg-4 col-xl-3',
	              label: 'Type',
	              display: TYPE_LABEL[type],
	              autoHideHelpText: true
	            }),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                label: 'Status',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_status2.default, { formControl: true, state: iv.status, labelTransformer: _statusHelper.inventoryVarianceLabel, colorTransformer: _statusHelper.inventoryVarianceColor })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Record Name',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement('input', {
	                className: 'form-control',
	                value: iv.name,
	                onChange: function onChange(event) {
	                  return _this2.handleFieldChange('name', event.target.value);
	                },
	                readOnly: isView
	              })
	            ),
	            _react2.default.createElement(_formGroup2.default, {
	              className: 'col-xs-6 col-lg-4 col-xl-3',
	              label: 'Record ID',
	              display: iv.number,
	              autoHideHelpText: true
	            }),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Effective Date',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.DateField, {
	                value: iv.effectiveDate,
	                readOnly: isView || true,
	                onChange: function onChange(event) {
	                  return _this2.handleFieldChange('effective_date', event.target.value);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Created',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.createdAt, by: iv.createdBy, formField: true })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Updated',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.updatedAt, by: iv.updatedBy, formField: true })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Cancelled',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.canceledAt, by: iv.canceledBy, formField: true })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Rejected',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.rejectedAt, by: iv.rejectedBy, formField: true })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Approved',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.approvedAt, by: iv.approvedBy, formField: true })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Voided',
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.TimestampDisplay, { at: iv.voidedAt, by: iv.voidedBy, formField: true })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_formGroup2.default, {
	              className: 'col-xs-6 col-lg-4 col-xl-3',
	              label: 'Total Number of SKU',
	              display: totalEntries,
	              autoHideHelpText: true
	            }),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                className: 'col-xs-6 col-lg-4 col-xl-3',
	                label: type === TYPE.OPENING ? 'Total Cost' : 'Total Cost Variance',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_inputCurrency2.default, { className: 'form-control', style: { textAlign: 'left' }, value: varianceCostTotal, readOnly: true })
	            )
	          )
	        ),
	        _react2.default.createElement(_grid.Grid, { bodyConfig: bodyConfig, footerConfig: footerConfig, style: { paddingBottom: 0 } }),
	        isView ? null : _react2.default.createElement(
	          _addListing2.default,
	          {
	            withBarcode: true,
	            baseSearch: { filter: { trackQuantity: true } },
	            onSave: this.addListing
	          },
	          'Add New Items'
	        ),
	        _react2.default.createElement(
	          _mainContent.MainContentSection,
	          null,
	          _react2.default.createElement(
	            _formGroup2.default,
	            { label: 'Note' },
	            _react2.default.createElement('textarea', {
	              className: 'form-control',
	              style: { height: 200 },
	              value: iv.remarks,
	              readOnly: isView,
	              onChange: function onChange(event) {
	                return _this2.handleFieldChange('remarks', event.target.value);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ItemTemplate;
	}(_react.Component), _class2.contextTypes = {
	  currentStore: _propTypes2.default.object
	}, _class2.propTypes = {
	  actions: _propTypes2.default.object,
	  pathState: _propTypes2.default.object
	}, _temp2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = ItemTemplate;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _constants = __webpack_require__(26);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _statusHelper = __webpack_require__(317);
	
	var _grid = __webpack_require__(66);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _selectDepartment = __webpack_require__(477);
	
	var _selectDepartment2 = _interopRequireDefault(_selectDepartment);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _mainContent = __webpack_require__(93);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var ivActions = _interopRequireWildcard(_inventoryVarianceActions);
	
	var _inventoryVarianceIndex = __webpack_require__(465);
	
	var ivIndexActions = _interopRequireWildcard(_inventoryVarianceIndex);
	
	var _departmentSelection = __webpack_require__(118);
	
	var departmentSelectionActions = _interopRequireWildcard(_departmentSelection);
	
	var _permissionHelper = __webpack_require__(92);
	
	var _typeToPermissionHelper = __webpack_require__(318);
	
	var _typeToPermissionHelper2 = _interopRequireDefault(_typeToPermissionHelper);
	
	var _reactRouter = __webpack_require__(9);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE_LABEL = _constants.INVENTORY_VARIANCE.TYPE_LABEL;
	
	
	function mapStateToProp(state) {
	  var pageState = state.pages.inventoryVarianceIndex;
	  var forms = state.forms;
	
	  return _extends({}, pageState, { departmentSelectionState: forms.departmentSelection });
	}
	
	function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, ivIndexActions, ivActions);
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch),
	    departmentSelectionActions: (0, _redux.bindActionCreators)(departmentSelectionActions, dispatch)
	  };
	}
	
	var InventoryVarianceIndex = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (0, _griddleComponents.capitalizeFirstLetterComponent)(_class = (0, _griddleComponents.orderStatusComponent)(_class = (0, _griddleComponents.timeComponent)(_class = (0, _griddleComponents.linkComponent)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(InventoryVarianceIndex, _Component);
	
	  function InventoryVarianceIndex(props) {
	    _classCallCheck(this, InventoryVarianceIndex);
	
	    var _this = _possibleConstructorReturn(this, (InventoryVarianceIndex.__proto__ || Object.getPrototypeOf(InventoryVarianceIndex)).call(this, props));
	
	    _this.goToPage = function (page) {
	      var rowsPerPage = _this.props.rowsPerPage;
	      var store_id = _this.props.params.store_id;
	      var _this$props$location$ = _this.props.location.query,
	          count = _this$props$location$.count,
	          filters = _this$props$location$.filters;
	
	      var filterString = _filterHelper2.default.filtersToString(filters);
	
	      _this.context.router.push({
	        pathname: _routeHelper2.default.inventoryVariance(store_id),
	        query: {
	          page: page,
	          count: rowsPerPage,
	          filters: filterString
	        }
	      });
	      _this.props.actions.changePage(page);
	    };
	
	    _this.updateRowsPerPage = function (val) {
	      var store_id = _this.props.params.store_id;
	      var filters = _this.props.location.query.filters;
	
	      var filterString = _filterHelper2.default.filtersToString(filters);
	
	      _this.context.router.push({
	        pathname: _routeHelper2.default.inventoryVariance(store_id),
	        query: {
	          page: 1,
	          count: val,
	          filters: filterString
	        }
	      });
	      _this.props.actions.changeRowsPerPage(val);
	    };
	
	    _this.gridActions = [{
	      name: 'View',
	      onClick: function onClick(item) {
	        var id = item.id;
	        var store_id = _this.props.params.store_id;
	
	        _this.props.actions.clearIvType();
	        _routeHelper2.default.goInventoryVariance(store_id, id);
	      },
	      hide: function hide(item) {
	        var currentStore = _this.context.currentStore;
	
	        return !(0, _typeToPermissionHelper2.default)(item.typeId, "view", currentStore);
	      }
	    }];
	    _this.IVTypes = {
	      opening: 'Opening',
	      actual_qty: 'Adjustment by Actual QTY',
	      var_qty: 'Adjustment by Variance QTY',
	      cost_adjust: 'Cost Adjustment'
	    };
	
	    _this.columnMetadatas = [{
	      columnName: "storeTitle",
	      displayName: "STORE NAME"
	    }, {
	      columnName: "createdAt",
	      displayName: "CREATED AT",
	      customComponent: _this.timeComponent
	    }, {
	      columnName: "effectiveDate",
	      displayName: "EFFECTIVE AT",
	      customComponent: _this.timeComponent
	    }, {
	      columnName: "number",
	      displayName: "RECORD ID",
	      customComponent: function customComponent(item) {
	        var location = _this.props.location;
	        var currentStore = _this.context.currentStore;
	
	        var path = location.pathname + '/' + item.rowData.id;
	        if ((0, _typeToPermissionHelper2.default)(item.rowData.typeId, "view", currentStore)) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: path },
	            item.data
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            item.rowData.number
	          );
	        }
	      }
	    }, {
	      columnName: "name",
	      displayName: "RECORD NAME"
	    }, {
	      columnName: "humanizedType",
	      displayName: "ADJUSTMENT TYPE",
	      customComponent: _this.capitalizeFirstLetterComponent
	    }, {
	      columnName: "createdBy",
	      displayName: "CREATED BY"
	    }, {
	      columnName: "updatedAt",
	      displayName: "LAST UPDATED AT",
	      customComponent: _this.timeComponent
	    }, {
	      columnName: "updatedBy",
	      displayName: "LAST UPDATED BY"
	    }, {
	      columnName: "approvedBy",
	      displayName: "APPROVED BY"
	    }, {
	      columnName: "createdBy",
	      displayName: "COMMITTED BY"
	    }, {
	      columnName: "status",
	      displayName: "STATUS",
	      customComponent: _this.orderStatusComponent,
	      customComponentProps: {
	        colorTransformer: _statusHelper.inventoryVarianceColor,
	        labelTransformer: _statusHelper.inventoryVarianceLabel
	      }
	    }];
	
	    _this.filterSettings = _this.columnMetadatas.filter(function (col) {
	      return col.hasOwnProperty('filterConditions');
	    }).map(function (column) {
	      return (0, _lodash.pick)(column, 'columnName', 'displayName', 'filterConditions');
	    });
	    _this.handleTypeChange = _this.handleTypeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(InventoryVarianceIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var _props$location$query = this.props.location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	
	      count = count || 50;
	
	      this.props.actions.load(store_id, page, count, undefined, filters);
	    }
	  }, {
	    key: 'handleTypeChange',
	    value: function handleTypeChange(event) {
	      this.props.actions.changeIVType(event.target.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          totalEntries = _props.totalEntries,
	          isLoading = _props.isLoading,
	          rowsPerPage = _props.rowsPerPage,
	          currentPage = _props.currentPage,
	          totalPages = _props.totalPages,
	          data = _props.data,
	          departmentSelectionState = _props.departmentSelectionState,
	          departmentSelectionActions = _props.departmentSelectionActions,
	          actions = _props.actions,
	          params = _props.params,
	          history = _props.history;
	      var currentStore = this.context.currentStore;
	
	      var ivDepartmentSelectionActions = Object.assign({}, departmentSelectionActions, {
	        submitDepartmentSelection: function submitDepartmentSelection() {
	          actions.createInventoryVarianceByDepartments(currentStore);
	        }
	      });
	      var getCustomerHeader = function getCustomerHeader() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'select',
	            { onChange: _this2.handleTypeChange, className: 'form-control form-control-sm' },
	            Object.keys(TYPE_LABEL).filter(function (key) {
	              return (0, _typeToPermissionHelper2.default)(key, "add", currentStore);
	            }).map(function (key) {
	              return _react2.default.createElement(
	                'option',
	                { value: key, key: key },
	                TYPE_LABEL[key]
	              );
	            })
	          )
	        );
	      };
	
	      var btnConfig = [{
	        content: 'Import Inventory Variance',
	        permission: '',
	        btnType: 'primary',
	        onClick: function onClick() {
	          _this2.props.actions.clearIvType();
	          history.push('/v2/' + params.store_id + '/inventory-variance/importer');
	        }
	      }, {
	        content: 'New Inventory Variance',
	        permission: '',
	        btnType: 'primary',
	        onClick: function onClick() {
	          _this2.props.actions.clearIvType(currentStore);
	          departmentSelectionActions.openDepartmentSelection(_this2.props.params.store_id, { selected: [], params: { 'opener': 'inventoryVariance' } });
	        }
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          _mainContent.MainContent,
	          null,
	          _react2.default.createElement(
	            _mainContent.MainContentHeader,
	            { title: 'Inventory Variance' },
	            (0, _permissionHelper.permissionAccessor)('inventory_variance_opening:add', currentStore) || (0, _permissionHelper.permissionAccessor)('inventory_variance_adjust_by_qty:add', currentStore) || (0, _permissionHelper.permissionAccessor)('inventory_variance_adjust_by_variance:add', currentStore) || (0, _permissionHelper.permissionAccessor)('inventory_variance_cost_adjustment:add', currentStore) ? _react2.default.createElement(_mainContent.MainContentHeaderButtons, { config: btnConfig }) : null
	          ),
	          _react2.default.createElement(_selectDepartment2.default, _extends({ customerHeader: getCustomerHeader }, departmentSelectionState, ivDepartmentSelectionActions)),
	          isLoading ? _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading...'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_grid.GridBody, { data: (0, _lodash.cloneDeep)(data),
	              actions: this.gridActions,
	              columns: this.columnMetadatas,
	              useExternal: true,
	              externalCurrentPage: currentPage - 1,
	              externalMaxPage: totalPages,
	              externalSetPage: function externalSetPage(newPage) {
	                return _this2.goToPage(newPage + 1);
	              }
	            }),
	            _react2.default.createElement(_grid.GridFooter, { totalEntries: totalEntries,
	              rowsPerPage: rowsPerPage,
	              currentPage: currentPage,
	              totalPages: totalPages,
	              goToPage: this.goToPage,
	              updateRowsPerPage: this.updateRowsPerPage })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InventoryVarianceIndex;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  totalEntries: _propTypes2.default.number.isRequired,
	  rowsPerPage: _propTypes2.default.number.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalPages: _propTypes2.default.number.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  filters: _propTypes2.default.array.isRequired,
	  departmentSelectionState: _propTypes2.default.object.isRequired,
	  departmentSelectionActions: _propTypes2.default.object.isRequired
	}, _temp)) || _class) || _class) || _class) || _class) || _class);
	exports.default = InventoryVarianceIndex;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constants = __webpack_require__(26);
	
	var _itemTemplate = __webpack_require__(483);
	
	var _itemTemplate2 = _interopRequireDefault(_itemTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MODE = _constants.INVENTORY_VARIANCE.MODE,
	    TAB = _constants.INVENTORY_VARIANCE.TAB;
	
	
	function InventoryVarianceItem(props) {
	  return _react2.default.createElement(_itemTemplate2.default, props);
	}
	
	InventoryVarianceItem.propTypes = {
	  type: _propTypes2.default.number,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = undefined;
	  var mode = MODE.VIEW;
	  var tab = TAB.OVERVIEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      id = params.inventory_variance_id;
	
	  return { type: type, mode: mode, tab: tab, storeId: storeId, id: id };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InventoryVarianceItem);

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constants = __webpack_require__(26);
	
	var _itemTemplate = __webpack_require__(483);
	
	var _itemTemplate2 = _interopRequireDefault(_itemTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPE = _constants.INVENTORY_VARIANCE.TYPE,
	    MODE = _constants.INVENTORY_VARIANCE.MODE,
	    TAB = _constants.INVENTORY_VARIANCE.TAB;
	
	
	function InventoryVarianceCreate(props) {
	  return _react2.default.createElement(_itemTemplate2.default, props);
	}
	
	InventoryVarianceCreate.propTypes = {
	  type: _propTypes2.default.number,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = TYPE.OPENING;
	  var mode = MODE.NEW;
	  var tab = TAB.OVERVIEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      id = params.inventory_variance_id;
	
	  return { type: type, mode: mode, tab: tab, storeId: storeId, id: id };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InventoryVarianceCreate);

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryBase = (_temp = _class = function (_Component) {
	  _inherits(InventoryBase, _Component);
	
	  function InventoryBase() {
	    _classCallCheck(this, InventoryBase);
	
	    return _possibleConstructorReturn(this, (InventoryBase.__proto__ || Object.getPrototypeOf(InventoryBase)).apply(this, arguments));
	  }
	
	  _createClass(InventoryBase, [{
	    key: 'render',
	    value: function render() {
	      var storeIds = this.props.params.store_id.split(',');
	      if (storeIds.length > 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'multi store not supported in this section'
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        );
	      }
	    }
	  }]);
	
	  return InventoryBase;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object
	}, _temp);
	exports.default = InventoryBase;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(537);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListingDepartmentDisplay = (_temp = _class = function (_Component) {
	  _inherits(ListingDepartmentDisplay, _Component);
	
	  function ListingDepartmentDisplay() {
	    _classCallCheck(this, ListingDepartmentDisplay);
	
	    return _possibleConstructorReturn(this, (ListingDepartmentDisplay.__proto__ || Object.getPrototypeOf(ListingDepartmentDisplay)).apply(this, arguments));
	  }
	
	  _createClass(ListingDepartmentDisplay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          departments = _props.departments,
	          departmentId = _props.departmentId;
	
	      var departmentName = void 0;
	      try {
	        departmentName = departments[departmentId].name;
	      } catch (e) {
	        departmentName = departmentId;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'media listing-name-thumbnail' },
	        departmentName
	      );
	    }
	  }]);
	
	  return ListingDepartmentDisplay;
	}(_react.Component), _class.propTypes = {
	  departments: _propTypes2.default.object.isRequired,
	  departmentId: _propTypes2.default.number.isRequired
	}, _temp);
	
	
	function mapStateToProps(state, ownProps) {
	
	  var departmentId = ownProps.departmentId || ownProps.department_id || ownProps.rowData.department_id;
	
	  return {
	    departments: state.entities.departments,
	    departmentId: departmentId
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ListingDepartmentDisplay);

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(537);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListingNameDisplay = (_temp = _class = function (_Component) {
	  _inherits(ListingNameDisplay, _Component);
	
	  function ListingNameDisplay() {
	    _classCallCheck(this, ListingNameDisplay);
	
	    return _possibleConstructorReturn(this, (ListingNameDisplay.__proto__ || Object.getPrototypeOf(ListingNameDisplay)).apply(this, arguments));
	  }
	
	  _createClass(ListingNameDisplay, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: 'block-a',
	          to: '/v2/' + this.props.rowData.store_id + '/inventory/' + this.props.rowData.id },
	        _react2.default.createElement(
	          'div',
	          { className: 'media listing-name-thumbnail' },
	          _react2.default.createElement(
	            'div',
	            { className: 'media-left' },
	            _react2.default.createElement('img', {
	              className: '_thumbnail',
	              src: this.props.rowData.image_url || __webpack_require__(1305),
	              alt: '' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media-body' },
	            _react2.default.createElement(
	              'p',
	              { className: '_name' },
	              this.props.rowData.name
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: '_code' },
	              'UPC/EAN: ',
	              this.props.rowData.gtid || "N/A"
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: '_code' },
	              'PLU/SKU: ',
	              this.props.rowData.listing_barcode || "N/A"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ListingNameDisplay;
	}(_react.Component), _class.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	}, _temp);
	
	// TODO: image_url is too large
	
	exports.default = ListingNameDisplay;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	/* eslint react/no-multi-comp: 0 */
	
	__webpack_require__(1257);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _supplierHelper = __webpack_require__(480);
	
	var supplierHelper = _interopRequireWildcard(_supplierHelper);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplierForm = (_temp = _class = function (_Component) {
	  _inherits(SupplierForm, _Component);
	
	  function SupplierForm() {
	    _classCallCheck(this, SupplierForm);
	
	    return _possibleConstructorReturn(this, (SupplierForm.__proto__ || Object.getPrototypeOf(SupplierForm)).apply(this, arguments));
	  }
	
	  _createClass(SupplierForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          listing = _props.listing,
	          supplierForm = _props.supplierForm,
	          suppliers = _props.suppliers;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card card-block supplier-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'checkbox' },
	            _react2.default.createElement(
	              'label',
	              null,
	              _react2.default.createElement('input', { type: 'radio', name: 'isDefault', checked: supplierForm.isDefault.value, onChange: this.props.onDefaultSet }),
	              ' Mark as default supplier'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: supplierForm.id },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Supplier Name'
	              ),
	              _react2.default.createElement(SelectSuppliers, _extends({ suppliers: suppliers }, supplierForm.id))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: supplierForm.productId },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Supplier Product ID'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, supplierForm.productId))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: supplierForm.point },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Reorder Trigger Point'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', step: 'any', className: 'form-control' }, supplierForm.point))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: supplierForm.cost },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Cost'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group-addon' },
	                  '$'
	                ),
	                _react2.default.createElement('input', _extends({ type: 'number', step: 'any', className: 'form-control' }, supplierForm.cost))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: supplierForm.amount },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Reorder Amount'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', step: 'any', className: 'form-control' }, supplierForm.amount))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: {} },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Margin'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group' },
	                _react2.default.createElement('input', { className: 'form-control', type: 'text', value: supplierHelper.getMargin(supplierForm.cost.value, listing.price), disabled: true }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group-addon' },
	                  '%'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-secondary btn-sm text-danger', onClick: this.props.onRemove },
	          '- remove this supplier'
	        )
	      );
	    }
	  }]);
	
	  return SupplierForm;
	}(_react.Component), _class.propTypes = {
	  listing: _propTypes2.default.object.isRequired,
	  suppliers: _propTypes2.default.object.isRequired,
	  supplierForm: _propTypes2.default.object.isRequired,
	  onRemove: _propTypes2.default.func.isRequired,
	  onDefaultSet: _propTypes2.default.func.isRequired
	}, _temp);
	
	/* eslint react/prop-types: 0 */
	
	function SelectSuppliers(props) {
	  var suppliers = props.suppliers,
	      value = props.value,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      rest = _objectWithoutProperties(props, ['suppliers', 'value', 'onBlur', 'onChange']);
	
	  var options = [];
	  var counter = 0;
	  for (var supplier in suppliers) {
	    if (suppliers.hasOwnProperty(supplier)) {
	      options.push(_react2.default.createElement(
	        'option',
	        { key: ++counter, value: supplier },
	        suppliers[supplier].name
	      ));
	    }
	  }
	
	  return _react2.default.createElement(
	    'select',
	    _extends({ className: 'form-control',
	      value: value || '',
	      onBlur: onBlur,
	      onChange: onChange
	    }, rest),
	    _react2.default.createElement('option', null),
	    options
	  );
	}
	
	exports.default = SupplierForm;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _compact = __webpack_require__(280);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _validate = __webpack_require__(220);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _supplierForm = __webpack_require__(837);
	
	var _supplierForm2 = _interopRequireDefault(_supplierForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = exports.fields = ['supplierForms[].isDefault', 'supplierForms[].id', 'supplierForms[].productId', 'supplierForms[].point', 'supplierForms[].cost', 'supplierForms[].amount', 'supplierForms[].margin'];
	
	var SupplierFormCollection = (_temp = _class = function (_Component) {
	  _inherits(SupplierFormCollection, _Component);
	
	  function SupplierFormCollection() {
	    _classCallCheck(this, SupplierFormCollection);
	
	    return _possibleConstructorReturn(this, (SupplierFormCollection.__proto__ || Object.getPrototypeOf(SupplierFormCollection)).apply(this, arguments));
	  }
	
	  _createClass(SupplierFormCollection, [{
	    key: 'handleRemove',
	    value: function handleRemove(index) {
	      var supplierForms = this.props.fields.supplierForms;
	
	
	      supplierForms.removeField(index);
	    }
	  }, {
	    key: 'handleDefaultSet',
	    value: function handleDefaultSet(index) {
	      var supplierForms = this.props.fields.supplierForms;
	
	
	      var defaultValue = !!supplierForms[index].isDefault.value;
	      supplierForms.map(function (form) {
	        form.isDefault.onChange(false);
	      });
	      supplierForms[index].isDefault.onChange(!defaultValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          supplierForms = _props.fields.supplierForms,
	          listing = _props.listing,
	          suppliers = _props.suppliers,
	          handleSubmit = _props.handleSubmit,
	          onCancel = _props.onCancel;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Inventory'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm', onClick: onCancel },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary btn-sm' },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          supplierForms.length < 1 ? _react2.default.createElement(
	            'p',
	            null,
	            'No supplier'
	          ) : _react2.default.createElement(
	            'p',
	            null,
	            supplierForms.length,
	            ' suppliers'
	          ),
	          supplierForms.map(function (supplierForm, index) {
	            return _react2.default.createElement(_supplierForm2.default, { key: index,
	              formKey: index.toString(),
	              listing: listing,
	              suppliers: suppliers,
	              supplierForm: supplierForm,
	              onRemove: _this2.handleRemove.bind(_this2, index),
	              onDefaultSet: _this2.handleDefaultSet.bind(_this2, index) });
	          }),
	          _react2.default.createElement(
	            'p',
	            { className: 'align-right' },
	            _react2.default.createElement(
	              'span',
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  supplierForms.addField();
	                } },
	              'Add Supplier'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SupplierFormCollection;
	}(_react.Component), _class.propTypes = {
	  listing: _propTypes2.default.object.isRequired,
	  suppliers: _propTypes2.default.object.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  fields: _propTypes2.default.object.isRequired
	}, _temp);
	
	
	var mapInitialValue = function mapInitialValue(state, props) {
	  var listing = props.listing;
	
	  var suppliers = listing.suppliers.map(function (supplier) {
	    return {
	      isDefault: supplier.default,
	      id: supplier.supplier_id,
	      cost: supplier.cost,
	      point: supplier.reorder_point,
	      amount: supplier.reorder_level,
	      productId: supplier.supplier_product_id
	    };
	  });
	
	  var initialValues = {
	    initialValues: {
	      supplierForms: suppliers
	    }
	  };
	
	  return initialValues;
	};
	
	var constraints = {
	  id: {
	    presence: { message: "^Must select a supplier " }
	  }
	};
	
	function validator(values) {
	  var result = values.supplierForms.map(function (v) {
	    return (0, _validate2.default)(v, constraints);
	  });
	  if ((0, _compact2.default)(result).length < 1) {
	    return {};
	  } else {
	    return { supplierForms: result };
	  }
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'inventoryEditSupplier',
	  fields: fields,
	  validate: validator
	}, mapInitialValue)(SupplierFormCollection);

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	/* eslint react/no-multi-comp: 0 */
	
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reduxForm = __webpack_require__(25);
	
	var _pickBy = __webpack_require__(1573);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _omit = __webpack_require__(638);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _reduce = __webpack_require__(288);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _validate = __webpack_require__(220);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _departmentHelper = __webpack_require__(316);
	
	var _overviewForm = __webpack_require__(484);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryEditOverview = (_temp2 = _class = function (_Component) {
	  _inherits(InventoryEditOverview, _Component);
	
	  function InventoryEditOverview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InventoryEditOverview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InventoryEditOverview.__proto__ || Object.getPrototypeOf(InventoryEditOverview)).call.apply(_ref, [this].concat(args))), _this), _this.deleteItem = function () {
	      var _this$props = _this.props,
	          actions = _this$props.actions,
	          params = _this$props.params,
	          appState = _this$props.appState;
	
	      var listings = appState.entities.listings || {};
	      var listing = listings[parseInt(params.listing_id)];
	
	      if (confirm('Are you sure? Items can be undeleted.')) {
	        actions.deleteListing(listing.store_id, listing.id).then(function () {
	          _this.context.router.push('/' + params.store_id + '/inventory');
	        }, function (error) {
	          alert(error.message);
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InventoryEditOverview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions,
	          appState = _props.appState;
	
	      var listings = appState.entities.listings || {};
	      var listing = listings[parseInt(params.listing_id)];
	
	      actions.getDepartments(params.store_id);
	      actions.getProductGraphics(listing.id, listing.product_id);
	    }
	  }, {
	    key: 'updateOverview',
	    value: function updateOverview(data) {
	      var _this2 = this;
	
	      // Known IE problem: http://caniuse.com/#feat=form-attribute
	      // TODO: bind onClick on button and use data in store to update listing
	
	      var _props2 = this.props,
	          actions = _props2.actions,
	          params = _props2.params,
	          appState = _props2.appState;
	
	      var backPath = '/' + params.store_id + '/inventory/' + params.listing_id + '/overview';
	
	      var listings = appState.entities.listings || {};
	      var listing = listings[parseInt(params.listing_id)];
	      var productGraphics = data.product_graphics;
	      var uploadImages = data.upload_images;
	      var diff = (0, _pickBy2.default)((0, _omit2.default)(data, 'product_graphics', 'upload_images'), function (value, key) {
	        return listing[key] != value;
	      });
	
	      var deleteProductGraphicIds = (0, _reduce2.default)(productGraphics, function (acc, graphic) {
	        if (graphic.delete) {
	          acc.push(graphic.id);
	        }
	        return acc;
	      }, []);
	
	      var uploadFiles = (0, _map2.default)(uploadImages, function (image) {
	        return image.file;
	      });
	
	      actions.deleteProductGraphics(listing.id, listing.product_id, deleteProductGraphicIds);
	      actions.uploadProductGraphics(listing.id, listing.product_id, uploadFiles);
	
	      actions.updateListing(params.store_id, params.listing_id, diff).then(function (res) {
	        _this2.context.router.push(backPath);
	      }, function (error) {
	        alert(error.message);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          appState = _props3.appState,
	          params = _props3.params;
	
	      var listings = appState.entities.listings || {};
	      var departments = appState.entities.departments || {};
	      var listing = listings[parseInt(params.listing_id)];
	      var productGraphics = listing.product_graphics || [];
	      var backPath = '/' + params.store_id + '/inventory/' + params.listing_id + '/overview';
	
	      if (departments) {
	        departments = (0, _map2.default)(departments, function (value) {
	          return value;
	        });
	        departments = (0, _departmentHelper.sortAndTreeDepartment)(departments);
	      }
	
	      if (!(listing && listing.product_graphics && departments)) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Inventory'
	        );
	      } else {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory - ',
	              listing.name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-link btn-sm text-danger', onClick: this.deleteItem },
	                'Delete this item'
	              ),
	              ' \xA0\xA0\xA0',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: backPath, className: 'btn btn-secondary btn-sm' },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', form: 'listing-form', type: 'submit' },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(ListingOverviewForm, {
	              isCustomMode: false,
	              isInventoryManager: this.props.appState.user.inventory_manager,
	              onSubmit: this.updateOverview.bind(this),
	              initialValues: listing,
	              departments: departments,
	              productGraphics: productGraphics
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryEditOverview;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	var constraints = {
	  price: {
	    presence: true,
	    numericality: true
	  }
	};
	
	function validator(values) {
	  return (0, _validate2.default)(values, constraints) || {};
	}
	
	var ListingOverviewForm = (0, _reduxForm.reduxForm)({
	  form: 'listingOverview',
	  validate: validator,
	  fields: ['name', 'description', 'gtid', 'quantity', 'qty_stockroom', 'listing_barcode', 'price', 'brand_name', 'category_name', 'department_id', 'in_store_only', 'discontinued', 'exempt_loyalty', 'exempt_discount', 'storefront_allow_negative_quantity', 'product_graphics[]', 'product_graphics[].delete', 'upload_images']
	})(_overviewForm2.default);
	
	exports.default = InventoryEditOverview;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _supplierFormCollection = __webpack_require__(838);
	
	var _supplierFormCollection2 = _interopRequireDefault(_supplierFormCollection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryEditSupplier = (_temp2 = _class = function (_Component) {
	  _inherits(InventoryEditSupplier, _Component);
	
	  function InventoryEditSupplier() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InventoryEditSupplier);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InventoryEditSupplier.__proto__ || Object.getPrototypeOf(InventoryEditSupplier)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
	      var _this$props = _this.props,
	          _this$props$params = _this$props.params,
	          store_id = _this$props$params.store_id,
	          listing_id = _this$props$params.listing_id,
	          listings = _this$props.appState.entities.listings;
	
	      var listing = listings[listing_id];
	
	      var showPath = '/v2/' + store_id + '/inventory/' + listing_id + '/supplier';
	
	      var suppliers = data.supplierForms.map(function (supplierForm, index) {
	        var originSupplier = listing.suppliers[index] || {};
	        return {
	          id: originSupplier.id,
	          listing_id: listing.id,
	          supplier_id: supplierForm.id,
	          cost: supplierForm.cost,
	          default: supplierForm.isDefault,
	          reorder_point: supplierForm.point,
	          reorder_level: supplierForm.amount,
	          supplier_product_id: supplierForm.productId,
	          created_at: originSupplier.created_at,
	          updated_at: originSupplier.updated_at
	        };
	      });
	
	      _this.props.actions.updateListing(store_id, listing_id, { suppliers: suppliers }).then(function (data) {
	        _this.context.router.push(showPath);
	      });
	    }, _this.handleCancel = function (e) {
	      e.preventDefault();
	
	      var params = _this.props.params;
	
	      var showPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/supplier';
	      _this.context.router.push(showPath);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InventoryEditSupplier, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	      actions.getSuppliers(params.store_id, 1, 200);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	      var _appState$entities = appState.entities,
	          listings = _appState$entities.listings,
	          suppliers = _appState$entities.suppliers;
	
	      var listing = listings[params.listing_id];
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Listing'
	        );
	      }
	
	      if (!suppliers) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Suppliers'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(_supplierFormCollection2.default, { listing: listing,
	            suppliers: suppliers,
	            onSubmit: this.handleSubmit,
	            onCancel: this.handleCancel })
	        );
	      }
	    }
	  }]);
	
	  return InventoryEditSupplier;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = InventoryEditSupplier;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp3;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(288);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reduxForm = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var taxTypes = [{ id: 1, name: "Tax (Default)" }, { id: 2, name: "Service Fee" }, { id: 3, name: "Bottle Deposit" }];
	
	var taxMethods = [{ id: 1, name: "Normal (Default)", detail: "" }, { id: 2, name: "Threshold", detail: "Product price equal or over threshold amount, tax would automatically applied to entire order." }, { id: 3, name: "Exempt", detail: "The Tax above specific amount only extra amount is taxable." }];
	
	var _TaxOptionForm = (_temp = _class = function (_Component) {
	  _inherits(_TaxOptionForm, _Component);
	
	  function _TaxOptionForm() {
	    _classCallCheck(this, _TaxOptionForm);
	
	    return _possibleConstructorReturn(this, (_TaxOptionForm.__proto__ || Object.getPrototypeOf(_TaxOptionForm)).apply(this, arguments));
	  }
	
	  _createClass(_TaxOptionForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          taxOptions = _props.taxOptions,
	          fields = _props.fields,
	          handleSubmit = _props.handleSubmit;
	
	      // fields.taxOptions is [] at start
	
	      if (fields.taxOptions.length < 1) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'form',
	        { id: 'TaxOptionForm', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'table',
	          { className: 'table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Tax Type'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Tax Code'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Tax Rate'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Method'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Threshold'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Included in price'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Priority'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Enable'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            (0, _map2.default)(taxOptions, function (taxOption, index) {
	              return _react2.default.createElement(
	                'tr',
	                { key: taxOption.id },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  texOption.tax_code
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.tax_type_name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.tax_rate_text
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.method_name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.threshold
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.included_in_price ? 'YES' : 'NO'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  taxOption.priority
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('input', {
	                    type: 'checkbox',
	                    defaultChecked: fields.taxOptions[index].active.defaultValue,
	                    onChange: fields.taxOptions[index].active.onChange,
	                    'ng-click': 'validateTaxOptions(taxOptions, taxOption)' })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return _TaxOptionForm;
	}(_react.Component), _class.propTypes = {
	  activeIds: _propTypes2.default.array.isRequired,
	  taxOptions: _propTypes2.default.array.isRequired,
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	}, _temp);
	
	var fields = ['taxOptions[].active', 'taxOptions[].id'];
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var initialValues = {
	    taxOptions: (0, _map2.default)(ownProps.taxOptions, function (taxOption) {
	      return {
	        id: taxOption.id,
	        // active: ownProps.activeIds.includes(taxOption.id)
	        active: ownProps.activeIds.indexOf(taxOption.id) >= 0
	      };
	    })
	  };
	
	  var props = {
	    initialValues: initialValues
	  };
	  return props;
	};
	
	var TaxOptionForm = (0, _reduxForm.reduxForm)({
	  form: 'inventoryEditTaxOption',
	  fields: fields
	  // validate: validator
	}, mapStateToProps)(_TaxOptionForm);
	
	var InventoryShowTax = (_temp3 = _class2 = function (_Component2) {
	  _inherits(InventoryShowTax, _Component2);
	
	  function InventoryShowTax() {
	    var _ref;
	
	    var _temp2, _this2, _ret;
	
	    _classCallCheck(this, InventoryShowTax);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref = InventoryShowTax.__proto__ || Object.getPrototypeOf(InventoryShowTax)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSubmit = function (data) {
	      var _this2$props = _this2.props,
	          actions = _this2$props.actions,
	          params = _this2$props.params;
	
	      var backPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/tax';
	
	      var taxOptionIds = (0, _reduce2.default)(data.taxOptions, function (acc, taxOption) {
	        if (taxOption.active) {
	          acc.push(taxOption.id);
	        }
	        return acc;
	      }, []);
	
	      actions.updateListing(params.store_id, params.listing_id, { tax_option_ids: taxOptionIds }).then(function (res) {
	        _this2.context.router.push(backPath);
	      }).catch(function (res) {
	        alert(res.message);
	      });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(InventoryShowTax, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          params = _props2.params,
	          actions = _props2.actions;
	
	      actions.getTaxOptions(params.store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          appState = _props3.appState,
	          params = _props3.params;
	      var _appState$entities = appState.entities,
	          listings = _appState$entities.listings,
	          taxOptions = _appState$entities.taxOptions;
	
	      var listing = listings[params.listing_id];
	      var backPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/tax';
	
	      var _parser = function _parser(taxOption) {
	        var option = taxOption;
	        if (option.tax_type !== 3) {
	          // If not Bottle Deposit
	          option.tax_rate_text = parseFloat(option.tax_rate * 100).toFixed(4) + '%';
	        } else {
	          option.tax_rate_text = '$' + option.tax_rate;
	        }
	        try {
	          option.tax_type_name = (0, _find2.default)(taxTypes, { id: option.tax_type }).name;
	          option.method_name = (0, _find2.default)(taxMethods, { id: option.method }).name;
	        } catch (e) {
	          // fall back
	          option.tax_type_name = 'not set';
	          option.method_name = 'not set';
	        }
	        return option;
	      };
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Listing'
	        );
	      }
	
	      if (!taxOptions) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading taxOptions'
	        );
	      } else {
	
	        taxOptions = (0, _map2.default)(taxOptions, function (value) {
	          return _parser(value);
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory - ',
	              listing.name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: backPath, className: 'btn btn-secondary btn-sm' },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', form: 'TaxOptionForm' },
	                'Save Tax Options'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(TaxOptionForm, { taxOptions: taxOptions, activeIds: listing.tax_option_ids, onSubmit: this.handleSubmit })
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryShowTax;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp3);
	exports.default = InventoryShowTax;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _jszip = __webpack_require__(1464);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _includes = __webpack_require__(637);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _alert = __webpack_require__(313);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _inventoryActions = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IMPORTED = "imported";
	var PENDING_VALIDATION = "pending_validation";
	var PENDING_IMPORT = "pending_import";
	var IMPORTING = "importing";
	var VALIDATED = "validated";
	var VALIDATING = "validating";
	
	var Importer = (_temp = _class = function (_Component) {
	  _inherits(Importer, _Component);
	
	  function Importer() {
	    _classCallCheck(this, Importer);
	
	    return _possibleConstructorReturn(this, (Importer.__proto__ || Object.getPrototypeOf(Importer)).apply(this, arguments));
	  }
	
	  _createClass(Importer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = nextProps.appState.importerStatus.status || '';
	      var allow_import = nextProps.appState.importerStatus.allow_import || '';
	      var inventory_import_id = nextProps.appState.importerStatus.id || '';
	
	      if (status === VALIDATING || status === PENDING_VALIDATION || status === VALIDATED && allow_import === false) {
	        this.startPoll(inventory_import_id);
	      } else if (status === PENDING_IMPORT || status === IMPORTING) {
	        this.startPoll(inventory_import_id);
	      }
	    }
	  }, {
	    key: 'validateFileName',
	    value: function validateFileName(files) {
	      //validating the file name
	      var isValid = true;
	      (0, _forEach2.default)(files, function (val, key) {
	        if (!val.dir && !(0, _includes2.default)(val.name, 'png') && !(0, _includes2.default)(val.name, 'jpg')) {
	          isValid = false;
	        }
	      });
	      return isValid;
	    }
	  }, {
	    key: 'handleImagesFile',
	    value: function handleImagesFile(e) {
	
	      var self = this;
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions,
	          appState = _props.appState;
	      var store_id = params.store_id;
	
	      var reader = new FileReader();
	      var file = self.refs.uploadImages.files[0];
	      var import_id = appState.importerStatus.id;
	
	      reader.onload = function (onloadFile) {
	
	        var zip = new _jszip2.default(onloadFile.target.result);
	        var isValid = self.validateFileName(zip.files);
	
	        if (!isValid) {
	          alert('You files contain invalid extension name, png/jpg only and please remove all folder in your .zip file');
	        } else {
	          var path = appState.importerStatus.upload_url;
	          actions.postImagesToS3(path, reader.result, store_id, import_id);
	        }
	
	        //self.refs.uploadImagesForm.reset();
	
	      };
	      reader.readAsArrayBuffer(file);
	    }
	  }, {
	    key: 'handleFile',
	    value: function handleFile(e) {
	      var self = this;
	      var _props2 = this.props,
	          params = _props2.params,
	          actions = _props2.actions;
	      var store_id = params.store_id;
	
	      var reader = new FileReader();
	
	      var file = self.refs.uploadCSV.files[0];
	
	      reader.onload = function (upload) {
	
	        var data = new FormData();
	        data.append('inventory_import[csv]', file);
	        actions.validateImportInventory(store_id, data);
	
	        //self.refs.uploadCSVForm.reset();
	
	      };
	      reader.readAsText(file);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'startPoll',
	    value: function startPoll(inventory_import_id) {
	      var store_id = this.props.params.store_id;
	      var actions = this.props.actions;
	
	      this.timeout = setTimeout(function () {
	        return actions.getImportInventory(store_id, inventory_import_id);
	      }, 1000);
	    }
	  }, {
	    key: 'startImport',
	    value: function startImport() {
	      var store_id = this.props.params.store_id;
	
	      var id = this.props.appState.importerStatus.id;
	      this.props.actions.postImportInventory(store_id, id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          appState = _props3.appState,
	          params = _props3.params;
	
	      var validate_msg = '';
	      var warning_msg = '';
	      var error_msg = '';
	      var disableImport = true;
	      var isShowUploadForm = false;
	      var isShowUploadCSVForm = true;
	      var progress_rate = 0;
	
	      var backPath = '/v2/' + params.store_id + '/inventory';
	
	      switch (appState.importerStatus.status) {
	
	        case _inventoryActions.ERROR_UPLOAD_IMAGES:
	          validate_msg = appState.importerStatus.statusText;
	          isShowUploadCSVForm = true;
	          break;
	
	        case _inventoryActions.WAIT_SERVER_UPLOAD_IMAGES:
	          validate_msg = 'Wait for server response';
	          progress_rate = appState.importerStatus.percentComplete;
	          isShowUploadCSVForm = false;
	          break;
	
	        case _inventoryActions.FINISH_UPLOAD_IMAGES:
	          validate_msg = 'Upload Images Success';
	          progress_rate = 100;
	          disableImport = false;
	          isShowUploadCSVForm = true;
	          break;
	
	        case _inventoryActions.UPLOADING_IMAGES:
	          validate_msg = 'Uploading images';
	          progress_rate = appState.importerStatus.percentComplete;
	          isShowUploadCSVForm = false;
	          break;
	
	        case IMPORTED:
	          validate_msg = 'Import Success';
	          progress_rate = 100;
	          isShowUploadCSVForm = true;
	          break;
	
	        case VALIDATING:
	        case PENDING_VALIDATION:
	          validate_msg = 'Please wait, we are validating your data';
	          progress_rate = parseFloat(appState.importerStatus.validation_progress_rate || 0) * 100;
	          isShowUploadCSVForm = false;
	          break;
	
	        case IMPORTING:
	        case PENDING_IMPORT:
	          validate_msg = 'Please wait, we are importing your data';
	          progress_rate = parseFloat(appState.importerStatus.import_progress_rate || 0) * 100;
	          isShowUploadCSVForm = false;
	          break;
	
	        case VALIDATED:
	
	          warning_msg = (0, _map2.default)(appState.importerStatus.humanize_validation_warnings, function (items, key) {
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'warning message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          error_msg = (0, _map2.default)(appState.importerStatus.humanize_validation_errors, function (items, key) {
	
	            return _react2.default.createElement(
	              'table',
	              { key: (0, _uniqueId2.default)(), className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Row'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Error message'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(items, function (item) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: (0, _uniqueId2.default)() },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      parseInt(key)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      ' ',
	                      item
	                    )
	                  );
	                })
	              )
	            );
	          });
	
	          if (!error_msg.length && !warning_msg.length) {
	            validate_msg = 'Validate Success & ready to upload images';
	          }
	
	          isShowUploadCSVForm = true;
	
	          disableImport = error_msg.length ? true : false;
	          progress_rate = 100;
	          isShowUploadForm = disableImport ? false : true;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Inventory'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: backPath, className: 'btn btn-secondary btn-sm' },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { disabled: disableImport, onClick: this.startImport.bind(this), className: 'btn btn-primary btn-sm' },
	              'Import'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Import Inventory'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'How to import:'
	            )
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'You can download a ',
	              _react2.default.createElement(
	                'a',
	                { href: __webpack_require__(1306) },
	                'Simplify Inventory template'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Fill in product details in a template'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Start to import'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Step 1. Select Action'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', { type: 'radio', name: 'import_action', id: 'new-inventory', defaultChecked: true }),
	            ' \xA0',
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'new-inventory' },
	              'Import New Inventory'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Step 2. Select File'
	          ),
	          _react2.default.createElement('progress', { className: 'progress', value: progress_rate, max: '100' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            '1.Inventory file (CSV, TXT only)'
	          ),
	          isShowUploadCSVForm ? _react2.default.createElement(
	            'form',
	            { ref: 'uploadCSVForm', onSubmit: this.handleSubmit, encType: 'multipart/form-data' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { accept: '.csv,.txt', ref: 'uploadCSV', type: 'file', onChange: this.handleFile.bind(this) })
	            )
	          ) : null,
	          isShowUploadForm ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              '2.Inventory images (zip only)'
	            ),
	            _react2.default.createElement(
	              'form',
	              { ref: 'uploadImagesForm', onSubmit: this.handleSubmit, encType: 'multipart/form-data' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('input', { ref: 'uploadImages', accept: '.zip', type: 'file', onChange: this.handleImagesFile.bind(this) })
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            validate_msg ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'info' },
	              ' ',
	              _react2.default.createElement(
	                'p',
	                null,
	                validate_msg
	              ),
	              ' '
	            ) : null,
	            warning_msg && warning_msg.length > 0 ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'warning' },
	              ' ',
	              warning_msg,
	              ' '
	            ) : null,
	            error_msg && error_msg.length > 0 ? _react2.default.createElement(
	              _alert2.default,
	              { style: 'danger' },
	              ' ',
	              error_msg,
	              ' '
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Importer;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = Importer;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _pick = __webpack_require__(213);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _listingNameDisplay = __webpack_require__(836);
	
	var _listingNameDisplay2 = _interopRequireDefault(_listingNameDisplay);
	
	var _listingDepartmentDisplay = __webpack_require__(835);
	
	var _listingDepartmentDisplay2 = _interopRequireDefault(_listingDepartmentDisplay);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var columnMetadatas = [{
	  columnName: "name",
	  displayName: "PRODUCT NAME",
	  customComponent: _listingNameDisplay2.default,
	  filterConditions: ['contain']
	}, {
	  columnName: "brand_name",
	  displayName: "BRAND",
	  filterConditions: ['contain']
	}, {
	  columnName: "department_id",
	  displayName: "DEPARTMENT ID",
	  customComponent: _listingDepartmentDisplay2.default,
	  filterConditions: ['equal']
	}, {
	  columnName: "quantity",
	  displayName: "QTY ON SHELF",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "qty_stockroom",
	  displayName: "STOCKROOM QTY",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "price",
	  displayName: "PRICE",
	  filterConditions: ['equal', 'between']
	}, {
	  columnName: "gtid",
	  displayName: "UPC/EAN",
	  hide: true
	}, {
	  columnName: "listing_barcode",
	  displayName: "PLU/SKU",
	  filterConditions: ['equal', 'contain'],
	  hide: true
	}, {
	  columnName: "updated_at",
	  displayName: "Updated At",
	  filterConditions: ['date_between', 'date_equal'],
	  hide: true
	}];
	
	var columns = columnMetadatas.filter(function (i) {
	  return !i.hide;
	}).map(function (i) {
	  return i.columnName;
	});
	var filterSettings = columnMetadatas.filter(function (column) {
	  return column.displayName && column.filterConditions && column.filterConditions.length > 0;
	}).map(function (column) {
	  return (0, _pick2.default)(column, 'columnName', 'displayName', 'filterConditions');
	});
	
	filterSettings.push({
	  columnName: "upc",
	  displayName: "UPC/EAN",
	  filterConditions: ['equal', 'contain']
	});
	
	var InventoryIndex = (_temp2 = _class = function (_Component) {
	  _inherits(InventoryIndex, _Component);
	
	  function InventoryIndex() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InventoryIndex);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InventoryIndex.__proto__ || Object.getPrototypeOf(InventoryIndex)).call.apply(_ref, [this].concat(args))), _this), _this.setPage = function (index) {
	      var store_id = _this.props.params.store_id;
	      var _this$props$location$ = _this.props.location.query,
	          count = _this$props$location$.count,
	          filters = _this$props$location$.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	      var listingStatus = _this.props.appState.listingStatus;
	
	      var page = index >= listingStatus.totalPages ? listingStatus.totalPages : index < 1 ? 1 : index + 1;
	
	      _this.props.actions.getListings(store_id, page, count, undefined, filtersObject);
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/inventory',
	        query: {
	          page: page,
	          count: count,
	          filters: filters
	        }
	      });
	    }, _this.changeSort = function (sort, sortAscending) {}, _this.setFilter = function (filter) {}, _this.setPageSize = function (size) {}, _this.handleSearch = function (filters) {
	      var _this$props$params = _this.props.params,
	          store_id = _this$props$params.store_id,
	          page = _this$props$params.page,
	          count = _this$props$params.count;
	
	      var filterString = _filterHelper2.default.filtersToString(filters);
	
	      _this.props.actions.updateFilters(filters);
	
	      _this.props.actions.getListings(store_id, page, count, undefined, filters);
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/inventory',
	        query: {
	          page: page,
	          count: count,
	          filters: filterString
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InventoryIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var _props$location$query = this.props.location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	
	      this.props.actions.getDepartments(store_id);
	      this.props.actions.getListings(store_id, page, count, undefined, filtersObject);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.location.pathname !== nextProps.location.pathname || this.props.location.search !== nextProps.location.search) {
	        var store_id = nextProps.params.store_id;
	        var _nextProps$location$q = nextProps.location.query,
	            count = _nextProps$location$q.count,
	            page = _nextProps$location$q.page,
	            filters = _nextProps$location$q.filters;
	
	        var filtersObject = _filterHelper2.default.stringToFilters(filters);
	
	        this.props.actions.getDepartments(store_id);
	        this.props.actions.getListings(store_id, page, count, undefined, filtersObject);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          params = _props.params,
	          location = _props.location,
	          appState = _props.appState;
	      var listings = appState.listings,
	          entities = appState.entities,
	          listingStatus = appState.listingStatus;
	
	      var importerPath = '/v2/' + params.store_id + '/inventory/importer';
	      var newItemPath = '/v2/' + params.store_id + '/inventory/new';
	
	      var data = listings.reduce(function (acc, id) {
	        var listing = entities.listings[id];
	
	        if (listing) {
	          acc.push((0, _pick2.default)(listing, 'id', 'name', 'store_id', 'image_url', 'gtid', 'brand_name', 'category_name', 'department_id', 'quantity', 'qty_stockroom', 'price', 'listing_barcode'));
	        } else {
	          console.warn('listing id', id, 'not found in entities');
	        }
	        return acc;
	      }, []);
	      var noDataMessage = void 0;
	
	      if (location.query.filters) {
	        noDataMessage = 'No search result';
	      } else {
	        noDataMessage = 'There is no listing data';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Inventory'
	          ),
	          _react2.default.createElement(
	            _can2.default,
	            { action: 'inventory:edit' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: importerPath, className: 'btn btn-secondary btn-sm' },
	              'Import'
	            )
	          ),
	          '\xA0',
	          _react2.default.createElement(
	            _can2.default,
	            { action: 'inventory:edit' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: newItemPath, className: 'btn btn-primary btn-sm' },
	              'New Item'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content -main-filter' },
	          _react2.default.createElement(_cascadeFilterCollection2.default, {
	            group: 'inventory',
	            settings: filterSettings,
	            filters: listingStatus.filters,
	            onSearch: this.handleSearch
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            listingStatus.loading ? _react2.default.createElement(
	              _loading2.default,
	              null,
	              'Loading listings...'
	            ) : _react2.default.createElement(_griddleReact2.default, {
	              useExternal: true,
	              useGriddleStyles: false,
	              tableClassName: 'table table-bordered data-table',
	              externalSetPage: this.setPage,
	              externalChangeSort: this.changeSort,
	              externalSetFilter: this.setFilter,
	              externalSetPageSize: this.setPage,
	              externalMaxPage: listingStatus.totalPages,
	              externalCurrentPage: listingStatus.page - 1,
	              resultsPerPage: listingStatus.count,
	              noDataMessage: noDataMessage,
	              results: data,
	              columns: columns,
	              columnMetadata: columnMetadatas })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InventoryIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = InventoryIndex;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _omit = __webpack_require__(638);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reduxForm = __webpack_require__(25);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _departmentHelper = __webpack_require__(316);
	
	var _validate = __webpack_require__(220);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _whichGtin = __webpack_require__(1016);
	
	var _whichGtin2 = _interopRequireDefault(_whichGtin);
	
	var _overviewForm = __webpack_require__(484);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	
	  },
	  overlay: {
	    zIndex: 1111
	  }
	};
	
	function ProductAlreadyExist(_ref) {
	  var isShow = _ref.isShow;
	
	  return isShow ? _react2.default.createElement(
	    'div',
	    { className: 'alert alert-danger' },
	    'Already a prodcut in inventory'
	  ) : _react2.default.createElement('div', null);
	}
	
	var NewItem = (_temp2 = _class = function (_Component) {
	  _inherits(NewItem, _Component);
	
	  function NewItem() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NewItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = NewItem.__proto__ || Object.getPrototypeOf(NewItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      modalIsOpen: true,
	      isProdcutExsit: false,
	      listing: {},
	      isCustomMode: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NewItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	      actions.getDepartments(params.store_id);
	    }
	  }, {
	    key: 'handleNext',
	    value: function handleNext() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          params = _props2.params,
	          actions = _props2.actions;
	
	      var upc = this.refs.input.value + '';
	
	      if ((0, _whichGtin2.default)(upc, true).valid || (0, _whichGtin2.default)(upc).valid) {
	
	        var filtersObject = [{
	          column: 'upc',
	          condition: 'equal',
	          conditionValue: upc
	        }];
	
	        //if length more length 1 display alredy in inventory
	        actions.getListingsByUPC(params.store_id, undefined, undefined, undefined, filtersObject).then(function (res) {
	          if (res.data.length > 0) {
	            _this2.setState({ isProdcutExsit: true });
	          } else {
	            actions.getProductByUPC(upc).then(function (data) {
	              data.gtid = upc;
	              _this2.setState({ modalIsOpen: false, listing: data, isCustomMode: false });
	            });
	          }
	        });
	      } else {
	        alert('invalid barcode');
	      }
	    }
	  }, {
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: 'handleCustomItem',
	    value: function handleCustomItem() {
	      this.setState({ modalIsOpen: false });
	    }
	  }, {
	    key: 'createItem',
	    value: function createItem(data) {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          actions = _props3.actions,
	          params = _props3.params;
	
	      var uploadImages = data.upload_images;
	      var newItemData = (0, _omit2.default)(data, 'product_graphics', 'upload_images');
	      //new custom item
	      if (this.state.isCustomMode) {
	
	        actions.postCustomItem(params.store_id, newItemData).then(function (newListing) {
	          var backPath = '/v2/' + params.store_id + '/inventory/' + newListing.id;
	
	          var uploadFiles = (0, _map2.default)(uploadImages, function (image) {
	            return image.file;
	          });
	          actions.uploadProductGraphics(newListing.id, newListing.product_id, uploadFiles);
	
	          _this3.context.router.push(backPath);
	        }, function (error) {
	          console.error('error', error);
	          alert(error.message);
	        });
	      } else {
	        newItemData = (0, _omit2.default)(newItemData, 'description', 'category_name', 'brand_name');
	        actions.postItem(params.store_id, newItemData).then(function (newListing) {
	
	          var backPath = '/v2/' + params.store_id + '/inventory/' + newListing.id;
	
	          _this3.context.router.push(backPath);
	        }, function (error) {
	          console.error('error', error);
	          alert(error.message);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          params = _props4.params,
	          appState = _props4.appState;
	
	      var departments = appState.entities.departments || {};
	      var listing = this.state.listing || {};
	      if (departments) {
	        departments = (0, _map2.default)(departments, function (value) {
	          return value;
	        });
	        departments = (0, _departmentHelper.sortAndTreeDepartment)(departments);
	      }
	
	      var ProductAlreadyExist = function ProductAlreadyExist(_ref3) {
	        var isShow = _ref3.isShow;
	
	        return isShow ? _react2.default.createElement(
	          'p',
	          null,
	          'Already a prodcut in inventory'
	        ) : _react2.default.createElement('p', null);
	      };
	
	      var backPath = '/v2/' + params.store_id + '/inventory';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Inventory - New Item'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: backPath, className: 'btn btn-secondary btn-sm' },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', form: 'listing-form', type: 'submit' },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(ListingOverviewForm, { onSubmit: this.createItem.bind(this), isCustomMode: this.state.isCustomMode, initialValues: listing, departments: departments })
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { isOpen: this.state.modalIsOpen, style: customStyles },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'New Item'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Enter UPC/EAN/GTIN code if available.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(ProductAlreadyExist, { isShow: this.state.isProdcutExsit }),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { className: 'form-control', type: 'text', ref: 'input', placeholder: 'UPC/EAN/GTIN' })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-block',
	                  onClick: this.handleNext.bind(this) },
	                'Next'
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-block',
	                  onClick: this.handleCancel.bind(this) },
	                'Cancel'
	              )
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-block',
	                  onClick: this.handleCustomItem.bind(this) },
	                'Add Custom Item'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewItem;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	var constraints = {
	  price: {
	    presence: true,
	    numericality: true
	  }
	};
	
	function validator(values) {
	  return (0, _validate2.default)(values, constraints) || {};
	}
	
	var ListingOverviewForm = (0, _reduxForm.reduxForm)({
	  form: 'listingOverview',
	  validate: validator,
	  fields: ['name', 'description', 'gtid', 'quantity', 'qty_stockroom', 'listing_barcode', 'price', 'brand_name', 'category_name', 'department_id', 'in_store_only', 'discontinued', 'exempt_loyalty', 'exempt_discount', 'storefront_allow_negative_quantity', 'product_graphics[]', 'product_graphics[].delete', 'upload_images']
	})(_overviewForm2.default);
	
	exports.default = NewItem;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryShow = (_temp = _class = function (_Component) {
	  _inherits(InventoryShow, _Component);
	
	  function InventoryShow() {
	    _classCallCheck(this, InventoryShow);
	
	    return _possibleConstructorReturn(this, (InventoryShow.__proto__ || Object.getPrototypeOf(InventoryShow)).apply(this, arguments));
	  }
	
	  _createClass(InventoryShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	
	      actions.getListing(params.store_id, params.listing_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	
	      var listings = appState.entities.listings || {};
	      var listing = listings[parseInt(params.listing_id)];
	
	      var basePath = '/v2/' + params.store_id + '/inventory/' + params.listing_id;
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Inventory'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-tab' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'nav nav-tabs' },
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: basePath + '/overview', className: 'nav-link', activeClassName: 'active' },
	                  'Overview'
	                )
	              ),
	              _react2.default.createElement(
	                _can2.default,
	                { action: 'inventory:supplier_tab' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'nav-item' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: basePath + '/supplier', className: 'nav-link', activeClassName: 'active' },
	                    'Supplier'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: basePath + '/tax', className: 'nav-link', activeClassName: 'active' },
	                  'Tax Options'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: basePath + '/log', className: 'nav-link', activeClassName: 'active' },
	                  'Log'
	                )
	              )
	            )
	          ),
	          this.props.children
	        );
	      }
	    }
	  }]);
	
	  return InventoryShow;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = InventoryShow;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(113);
	
	var _moment = __webpack_require__(143);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryShowHistory = (_temp = _class = function (_Component) {
	  _inherits(InventoryShowHistory, _Component);
	
	  function InventoryShowHistory() {
	    _classCallCheck(this, InventoryShowHistory);
	
	    return _possibleConstructorReturn(this, (InventoryShowHistory.__proto__ || Object.getPrototypeOf(InventoryShowHistory)).apply(this, arguments));
	  }
	
	  _createClass(InventoryShowHistory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	      actions.getQuantityHistory(params.store_id, params.listing_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	
	      var listings = appState.entities.listings || {};
	      var listing = listings[parseInt(params.listing_id)];
	
	      var columns = ['datetime', 'delta', 'quantity_after', 'qty_stockroom_after', 'qty_in_transit_from_supplier_after', 'qty_in_transit_from_transfer_after', 'qty_reserved_for_invoice_after', 'qty_reserved_for_transfer_after'];
	
	      /* eslint react/prop-types: 0 */
	      var DeltaColumn = function DeltaColumn(props) {
	        var _props$rowData = props.rowData,
	            quantity_after = _props$rowData.quantity_after,
	            quantity_before = _props$rowData.quantity_before,
	            qty_stockroom_after = _props$rowData.qty_stockroom_after,
	            qty_stockroom_before = _props$rowData.qty_stockroom_before;
	
	
	        var delta = parseFloat(quantity_after) - parseFloat(quantity_before) + parseFloat(qty_stockroom_after) - parseFloat(qty_stockroom_before);
	
	        return _react2.default.createElement(
	          'b',
	          null,
	          delta
	        );
	      };
	
	      var DatetimeColumn = function DatetimeColumn(props) {
	        var _props$rowData2 = props.rowData,
	            created_at = _props$rowData2.created_at,
	            order_number = _props$rowData2.order_number,
	            user_display_name = _props$rowData2.user_display_name;
	
	
	        var subtext = order_number ? order_number : user_display_name ? 'Adjusted by: ' + user_display_name : '';
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'nowrap' },
	            (0, _moment2.default)(created_at).format('M/D/YYYY, h:mm:ss A')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'text-muted small' },
	            subtext
	          )
	        );
	      };
	
	      var columnMetadata = [{
	        "columnName": "datetime",
	        "displayName": "Sales/Purchase Order",
	        "customComponent": DatetimeColumn
	
	      }, {
	        "columnName": "delta",
	        "displayName": "Qty Delta",
	        "customComponent": DeltaColumn
	
	      }, {
	        "columnName": "quantity_after",
	        "displayName": "Latest Qty(On Shelf)"
	      }, {
	        "columnName": "qty_stockroom_after",
	        "displayName": "Latest Qty Stockroom"
	      }, {
	        "columnName": "qty_in_transit_from_supplier_after",
	        "displayName": "In Transit from Supplier"
	      }, {
	        "columnName": "qty_in_transit_from_transfer_after",
	        "displayName": "In Transit from Transfer"
	      }, {
	        "columnName": "qty_reserved_for_invoice_after",
	        "displayName": "Reserved for Invoice"
	      }, {
	        "columnName": "qty_reserved_for_transfer_after",
	        "displayName": "Reserved for Transfer"
	      }];
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Inventory'
	        );
	      } else if (!listing.quantity_histories) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Log'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory - ',
	              listing.name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(_griddleReact2.default, {
	              useGriddleStyles: false,
	              tableClassName: 'table inventory-log-table',
	              columns: columns,
	              columnMetadata: columnMetadata,
	              resultsPerPage: 50,
	              results: listing.quantity_histories
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryShowHistory;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = InventoryShowHistory;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _departmentHelper = __webpack_require__(316);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _inventoryActions = __webpack_require__(105);
	
	var inventoryActions = _interopRequireWildcard(_inventoryActions);
	
	var _departmentActions = __webpack_require__(149);
	
	var departmentActions = _interopRequireWildcard(_departmentActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)',
	    border: 'none',
	    padding: 0,
	    width: '500px'
	
	  },
	  overlay: {
	    zIndex: 1111
	  }
	};
	
	var InventoryShowOverview = (_temp2 = _class = function (_Component) {
	  _inherits(InventoryShowOverview, _Component);
	
	  function InventoryShowOverview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InventoryShowOverview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InventoryShowOverview.__proto__ || Object.getPrototypeOf(InventoryShowOverview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showQuantityDetail: false
	    }, _this.toggleQuantityDetail = function () {
	      _this.setState({ showQuantityDetail: !_this.state.showQuantityDetail });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InventoryShowOverview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions,
	          listing = _props.listing;
	
	
	      actions.getDepartments(params.store_id);
	      actions.getProductGraphics(listing.id, listing.product_id);
	    }
	  }, {
	    key: 'setDefault',
	    value: function setDefault(productId, graphicId) {
	      var _props2 = this.props,
	          params = _props2.params,
	          actions = _props2.actions;
	
	      var listingId = parseInt(params.listing_id);
	
	      actions.setDefaultProductGraphics(listingId, productId, graphicId).then(function () {
	        actions.getProductGraphics(listingId, productId);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          params = _props3.params,
	          listing = _props3.listing,
	          departments = _props3.departments;
	
	      var productGraphics = listing.product_graphics || [];
	      var editPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/overview/edit';
	
	      function departmentName(id) {
	        try {
	          var _departments = (0, _map2.default)(departments, function (value) {
	            return value;
	          });
	          var _department = (0, _find2.default)((0, _departmentHelper.sortAndTreeDepartment)(_departments), function (department) {
	            return department.id == id;
	          });
	          return _department.stackdisplay;
	        } catch (e) {
	          return '';
	        }
	      }
	
	      if (!listing && !departments) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Inventory'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory - ',
	              listing.name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _can2.default,
	                { action: 'inventory:edit' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: editPath, className: 'btn btn-primary btn-sm' },
	                  'Edit'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Title'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'description'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.description
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'UPC/EAN'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.gtid
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'QTY on shelf'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.quantity
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'a', onClick: this.toggleQuantityDetail },
	                      'quantity details...'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'PLU/SKU'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.listing_barcode
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Price'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.price
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Brand'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    listing.brand_name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Department'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    departmentName(listing.department_id)
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: listing.in_store_only, disabled: true }),
	              ' In Store Only'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: listing.discontinued, disabled: true }),
	              ' Discontinued'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: listing.exempt_loyalty, disabled: true }),
	              ' Exempt item from loyalty program'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: listing.exempt_discount, disabled: true }),
	              ' Exclude from all discount'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: listing.storefront_allow_negative_quantity, disabled: true }),
	              ' Store front allow negative quantity'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              productGraphics.length < 1 ? _react2.default.createElement(
	                'p',
	                { className: 'col-sm-12' },
	                'No Related Image.'
	              ) : null,
	              productGraphics.map(function (graphic) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-2 align-center', key: graphic.id },
	                  graphic.default ? _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'label label-success' },
	                      'Default'
	                    )
	                  ) : _react2.default.createElement(
	                    'p',
	                    { className: 'text-mute small a', onClick: _this2.setDefault.bind(_this2, graphic.product_id, graphic.id) },
	                    'set as default'
	                  ),
	                  _react2.default.createElement('img', { src: graphic.small_image_url })
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _reactModal2.default,
	            {
	              isOpen: this.state.showQuantityDetail,
	              style: customStyles,
	              onRequestClose: this.toggleQuantityDetail },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'close', onClick: this.toggleQuantityDetail },
	                  _react2.default.createElement(
	                    'span',
	                    { 'aria-hidden': 'true' },
	                    '\xD7'
	                  )
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'modal-title' },
	                  'Inventory Quantity Preview'
	                )
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Description'
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      'Quantity'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'On Shelf (default)'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.quantity
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'Stock Room'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.qty_stockroom
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'In Transit from Supplier'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.qty_in_transit_from_supplier
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'In Transit from Transfer'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.qty_in_transit_from_transfer
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'Reserved for Invoice'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.qty_reserved_for_invoice
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'Reserved for Transfer'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      listing.qty_reserved_for_transfer
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryShowOverview;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  listing: _propTypes2.default.object.isRequired,
	  departments: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	function mapStateToProps(state, ownProps) {
	
	  var listing = void 0;
	
	  try {
	    listing = state.entities.listings[parseInt(ownProps.params.listing_id)];
	  } catch (e) {
	    listing = {};
	    console.error('lising not found');
	  }
	
	  return {
	    listing: listing,
	    departments: state.entities.departments || {},
	    params: ownProps.params
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(Object.assign(inventoryActions, departmentActions), dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InventoryShowOverview);

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _supplierHelper = __webpack_require__(480);
	
	var supplierHelper = _interopRequireWildcard(_supplierHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryShow = (_temp = _class = function (_Component) {
	  _inherits(InventoryShow, _Component);
	
	  function InventoryShow() {
	    _classCallCheck(this, InventoryShow);
	
	    return _possibleConstructorReturn(this, (InventoryShow.__proto__ || Object.getPrototypeOf(InventoryShow)).apply(this, arguments));
	  }
	
	  _createClass(InventoryShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	      actions.getSuppliers(params.store_id, 1, 200);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	      var suppliers = appState.entities.suppliers;
	
	      var listing = appState.entities.listings[params.listing_id];
	      var listingSuppliers = listing.suppliers;
	      var editPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/supplier/edit-supplier';
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Listing'
	        );
	      }
	
	      if (!suppliers) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Suppliers'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _can2.default,
	                { action: 'inventory:edit' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: editPath, className: 'btn btn-primary btn-sm' },
	                  'Edit Supplier'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            listingSuppliers.length < 1 ? _react2.default.createElement(
	              'p',
	              null,
	              'No supplier'
	            ) : _react2.default.createElement(
	              'p',
	              null,
	              listingSuppliers.length,
	              ' suppliers'
	            ),
	            listingSuppliers.map(function (supplier) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'card card-block', key: supplier.id },
	                supplier.default ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'label label-success' },
	                    'Default supplier'
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Supplier Name'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplierHelper.getName(suppliers, supplier.supplier_id)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Supplier Product ID'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplier.supplier_product_id
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Reorder Trigger Point'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplier.reorder_point
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Cost'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplier.cost
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Reorder Amount'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplier.reorder_level
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'mapdata' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-label' },
	                        'Margin'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mapdata-value' },
	                        supplierHelper.getMargin(supplier.cost, listing.price) + '%'
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryShow;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = InventoryShow;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(113);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(288);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var taxTypes = [{ id: 1, name: "Tax (Default)" }, { id: 2, name: "Service Fee" }, { id: 3, name: "Bottle Deposit" }];
	
	var taxMethods = [{ id: 1, name: "Normal (Default)", detail: "" }, { id: 2, name: "Threshold", detail: "Product price equal or over threshold amount, tax would automatically applied to entire order." }, { id: 3, name: "Exempt", detail: "The Tax above specific amount only extra amount is taxable." }];
	
	var InventoryShowTax = (_temp = _class = function (_Component) {
	  _inherits(InventoryShowTax, _Component);
	
	  function InventoryShowTax() {
	    _classCallCheck(this, InventoryShowTax);
	
	    return _possibleConstructorReturn(this, (InventoryShowTax.__proto__ || Object.getPrototypeOf(InventoryShowTax)).apply(this, arguments));
	  }
	
	  _createClass(InventoryShowTax, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          actions = _props.actions;
	
	      actions.getTaxOptions(params.store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          params = _props2.params;
	      var _appState$entities = appState.entities,
	          listings = _appState$entities.listings,
	          taxOptions = _appState$entities.taxOptions;
	
	      var listing = listings[params.listing_id];
	      var editPath = '/v2/' + params.store_id + '/inventory/' + params.listing_id + '/tax/edit-tax';
	
	      var _parser = function _parser(taxOption) {
	        var option = taxOption;
	        if (option.tax_type !== 3) {
	          // If not Bottle Deposit
	          option.tax_rate_text = (parseFloat(option.tax_rate) * 100).toFixed(4) + '%';
	        } else {
	          option.tax_rate_text = '$' + option.tax_rate;
	        }
	        try {
	          option.tax_type_name = (0, _find2.default)(taxTypes, { id: option.tax_type }).name;
	          option.method_name = (0, _find2.default)(taxMethods, { id: option.method }).name;
	        } catch (e) {
	          // fall back
	          option.tax_type_name = 'not set';
	          option.method_name = 'not set';
	        }
	        return option;
	      };
	
	      if (!listing) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Listing'
	        );
	      }
	
	      if (!taxOptions) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading taxOptions'
	        );
	      } else {
	
	        var activeTaxOptions = (0, _reduce2.default)(listing.tax_option_ids, function (acc, id) {
	          if (taxOptions[id]) {
	            acc.push(_parser(taxOptions[id]));
	          }
	          return acc;
	        }, []);
	
	        var taxOptionsLength = (0, _map2.default)(taxOptions, 'id').length;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Inventory - ',
	              listing.name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _can2.default,
	                { action: 'inventory:edit' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: editPath, className: 'btn btn-primary btn-sm' },
	                  'Edit Tax Options'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'p',
	              null,
	              activeTaxOptions.length,
	              ' of ',
	              taxOptionsLength,
	              ' tax options seleced.'
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Tax Type'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Tax Code'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Tax Rate'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Method'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Threshold'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Included in price'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Priority'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _map2.default)(activeTaxOptions, function (taxOption, index) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: taxOption.id },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      texOption.tax_code
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.tax_type_name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.tax_rate_text
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.method_name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.threshold
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.included_in_price ? 'YES' : 'NO'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      taxOption.priority
	                    )
	                  );
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return InventoryShowTax;
	}(_react.Component), _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = InventoryShowTax;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _invoiceActions = __webpack_require__(226);
	
	var invoiceActions = _interopRequireWildcard(_invoiceActions);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _grid = __webpack_require__(66);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _mainContentSection = __webpack_require__(189);
	
	var _mainContentSection2 = _interopRequireDefault(_mainContentSection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var _state$invoice = state.invoice,
	      pathState = _state$invoice === undefined ? {} : _state$invoice,
	      _state$stores = state.stores,
	      stores = _state$stores === undefined ? [] : _state$stores;
	  var loading = state.base.loading;
	
	  return Object.assign({}, props, { pathState: pathState, loading: loading, stores: stores });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = _extends({}, invoiceActions);
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var InvoiceDeliveryNote = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _griddleComponents.timeComponent)(_class = (0, _griddleComponents.dateComponent)(_class = (0, _griddleComponents.statusComponent)(_class = (0, _griddleComponents.storeComponent)(_class = (0, _griddleComponents.linkComponent)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(InvoiceDeliveryNote, _Component);
	
	  function InvoiceDeliveryNote(props) {
	    _classCallCheck(this, InvoiceDeliveryNote);
	
	    var _this = _possibleConstructorReturn(this, (InvoiceDeliveryNote.__proto__ || Object.getPrototypeOf(InvoiceDeliveryNote)).call(this, props));
	
	    _this.columns = [{ columnName: 'storeId', displayName: 'Stock Store', customComponent: _this.storeComponent }, { columnName: 'number', displayName: 'Number', customComponent: function customComponent(row) {
	        var data = row.data,
	            _row$rowData = row.rowData,
	            id = _row$rowData.id,
	            storeId = _row$rowData.storeId;
	
	        var path = _routeHelper2.default.deliveryNote(storeId, id);
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: path },
	          data
	        );
	      } }, { columnName: 'customerName', displayName: 'Ship To' }, { columnName: 'state', displayName: 'Delivery Status', customComponent: _this.statusComponent('deliveryOrder') }, { columnName: 'shipDate', displayName: 'Delivery Date', customComponent: _this.dateComponent }, { columnName: 'createdAt', displayName: 'Date', customComponent: _this.timeComponent }, { columnName: 'createdBy', displayName: 'Created By' }];
	    return _this;
	  }
	
	  _createClass(InvoiceDeliveryNote, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$pathState = _props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState,
	          loading = _props.loading;
	      var _pathState$deliveryOr = pathState.deliveryOrders,
	          deliveryOrders = _pathState$deliveryOr === undefined ? [] : _pathState$deliveryOr;
	
	
	      return loading ? _react2.default.createElement(
	        _loading2.default,
	        null,
	        'Loading...'
	      ) : _react2.default.createElement(
	        _mainContentSection2.default,
	        null,
	        _react2.default.createElement(_grid.GridBody, { data: deliveryOrders,
	          border: 'h',
	          noOutline: true,
	          columns: this.columns })
	      );
	    }
	  }]);
	
	  return InvoiceDeliveryNote;
	}(_react.Component), _class2.propTypes = {
	  actions: _propTypes2.default.object,
	  pathState: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  stores: _propTypes2.default.arrayOf(_propTypes2.default.object)
	}, _temp)) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = InvoiceDeliveryNote;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _lodash = __webpack_require__(14);
	
	var _grid = __webpack_require__(66);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var _state$invoice = state.invoice,
	      order = _state$invoice.order,
	      data = _state$invoice.history,
	      isLoading = _state$invoice.isLoadingHistory;
	
	  return { order: order, data: data, isLoading: isLoading };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var InvoiceLog = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _griddleComponents.statusComponent)(_class = (0, _griddleComponents.timeComponent)(_class = (0, _griddleComponents.decimalComponent)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(InvoiceLog, _Component);
	
	  function InvoiceLog(props) {
	    _classCallCheck(this, InvoiceLog);
	
	    var _this = _possibleConstructorReturn(this, (InvoiceLog.__proto__ || Object.getPrototypeOf(InvoiceLog)).call(this, props));
	
	    _this.columns = [{ columnName: 'createdAt', displayName: 'DATE', customComponent: _this.timeComponent }, {
	      columnName: 'cashier',
	      displayName: 'USER',
	      customComponent: function customComponent(props) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          (0, _lodash.get)(props, 'data.displayName')
	        );
	      }
	    }, { columnName: 'correspondenceState', displayName: 'PAYMENT STATUS', customComponent: _this.statusComponent() }, { columnName: 'owingAmount', displayName: 'AMOUNT OWED', customComponent: _this.decimalComponent }];
	    return _this;
	  }
	
	  _createClass(InvoiceLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.actions.getInvoiceHistory();
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props$order = this.props.order,
	          total = _props$order.total,
	          paidTotal = _props$order.paidTotal,
	          balance = _props$order.balance;
	
	      var displayTotal = total ? total.toFixed(2) : '';
	      var displayPaidTotal = paidTotal ? paidTotal.toFixed(2) : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 col-md-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-box' },
	              _react2.default.createElement(
	                'p',
	                { className: 'input-box__title' },
	                'Invoice Total'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'input-box__input' },
	                displayTotal
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 col-md-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-box' },
	              _react2.default.createElement(
	                'p',
	                { className: 'input-box__title' },
	                'Paid'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'input-box__input' },
	                displayPaidTotal
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4 col-md-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-box' },
	              _react2.default.createElement(
	                'p',
	                { className: 'input-box__title' },
	                'Owing'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'input-box__input' },
	                balance
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid' },
	          _react2.default.createElement(_grid.GridBody, { data: this.props.data,
	            columns: this.columns })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.isLoading ? _react2.default.createElement(
	        _loading2.default,
	        null,
	        'Loading ...'
	      ) : this.renderContent();
	    }
	  }]);
	
	  return InvoiceLog;
	}(_react.Component), _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  order: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp)) || _class) || _class) || _class) || _class);
	exports.default = InvoiceLog;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _selectDiscountActions = __webpack_require__(180);
	
	var selectDiscountActions = _interopRequireWildcard(_selectDiscountActions);
	
	var _mainContentSection = __webpack_require__(189);
	
	var _mainContentSection2 = _interopRequireDefault(_mainContentSection);
	
	var _selectCustomer = __webpack_require__(793);
	
	var _selectCustomer2 = _interopRequireDefault(_selectCustomer);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _status = __webpack_require__(233);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _date = __webpack_require__(230);
	
	var _addListing = __webpack_require__(229);
	
	var _addListing2 = _interopRequireDefault(_addListing);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _can = __webpack_require__(472);
	
	var _totalSlip = __webpack_require__(855);
	
	var _totalSlip2 = _interopRequireDefault(_totalSlip);
	
	var _paymentSlip = __webpack_require__(854);
	
	var _paymentSlip2 = _interopRequireDefault(_paymentSlip);
	
	var _constant = __webpack_require__(108);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import moment from 'moment';
	
	
	// import { dateToIso } from '~/helpers/formatHelper';
	
	var InvoiceOverview = function (_Component) {
	    _inherits(InvoiceOverview, _Component);
	
	    function InvoiceOverview(props) {
	        _classCallCheck(this, InvoiceOverview);
	
	        var _this = _possibleConstructorReturn(this, (InvoiceOverview.__proto__ || Object.getPrototypeOf(InvoiceOverview)).call(this, props));
	
	        _this.changeDiscount = _this.changeDiscount.bind(_this);
	        _this.renderDiscount = _this.renderDiscount.bind(_this);
	        return _this;
	    }
	
	    _createClass(InvoiceOverview, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.discountActions.loadDiscountOptions(this.props.pathState.currentStore.id);
	        }
	    }, {
	        key: 'changeDiscount',
	        value: function changeDiscount(e, i) {
	            var choosedDiscount = this.props.selectDiscount.discounts.find(function (d) {
	                return d.id === parseInt(e.target.value);
	            });
	            this.props.actions.changeInvoiceDiscount(i, choosedDiscount);
	        }
	    }, {
	        key: 'renderDiscount',
	        value: function renderDiscount(discount) {
	            if (discount) {
	                return '$' + discount.amount;
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props;
	            var _props$pathState = props.pathState,
	                pathState = _props$pathState === undefined ? {} : _props$pathState,
	                _props$actions = props.actions,
	                actions = _props$actions === undefined ? {} : _props$actions;
	            var _pathState$currentSto = pathState.currentStore,
	                currentStore = _pathState$currentSto === undefined ? {} : _pathState$currentSto,
	                mode = pathState.mode,
	                type = pathState.type,
	                _pathState$order = pathState.order,
	                order = _pathState$order === undefined ? {} : _pathState$order,
	                _pathState$unitGroups = pathState.unitGroups,
	                unitGroups = _pathState$unitGroups === undefined ? {} : _pathState$unitGroups,
	                _pathState$units = pathState.units,
	                units = _pathState$units === undefined ? {} : _pathState$units,
	                quantityDp = pathState.quantityDp,
	                listingDp = pathState.listingDp,
	                totalDp = pathState.totalDp;
	
	            var isViewMode = mode === _constant.VIEW;
	            var isNewMode = mode === _constant.NEW;
	            var isQuote = type === _constant.QUOTE_TYPE;
	            var isInvoice = type === _constant.INVOICE_TYPE;
	            var storeId = currentStore.id,
	                storeTitle = currentStore.title,
	                currency = currentStore.currency;
	            var discounts = this.props.selectDiscount.discounts;
	            // const isEffective = !isNewMode && moment().isAfter(dateToIso(order.effectiveCreatedAt, timezone));
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _mainContentSection2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'STORE NAME', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control', value: storeTitle, readOnly: true })
	                            )
	                        ),
	                        isNewMode ? null : _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'ORDER STATUS', autoHideHelpText: true },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-control', readOnly: true },
	                                    _react2.default.createElement(_status2.default, { state: order.state })
	                                )
	                            )
	                        ),
	                        isQuote || isNewMode ? null : _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'FULFILLMENT STATUS', autoHideHelpText: true },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-control', readOnly: true },
	                                    _react2.default.createElement(_status2.default, { state: order.inventoryState })
	                                )
	                            )
	                        ),
	                        isQuote || isNewMode ? null : _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'PAYMENT STATUS', autoHideHelpText: true },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-control', readOnly: true },
	                                    _react2.default.createElement(_status2.default, { state: order.quoteInvoiceState })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'REFERENCE NUMBER', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control',
	                                    value: order.referenceNumber || '',
	                                    onChange: function onChange(event) {
	                                        return actions.changeInvoiceField('referenceNumber', event.target.value);
	                                    },
	                                    readOnly: !isNewMode })
	                            )
	                        ),
	                        isNewMode ? null : _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'CREATED AT', autoHideHelpText: true },
	                                _react2.default.createElement(_date.DateTimeDisplay, { value: order.createdAt, formField: true })
	                            )
	                        ),
	                        isNewMode ? null : _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'CREATED BY', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control', value: order.createdBy, readOnly: true })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'EFFECTIVE DATE', autoHideHelpText: true },
	                                _react2.default.createElement(_date.DateField, {
	                                    value: order.effectiveCreatedAt || '',
	                                    onChange: function onChange(event) {
	                                        return actions.changeInvoiceField('effectiveCreatedAt', event.target.value);
	                                    },
	                                    readOnly: true,
	                                    offsetTips: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'DUE DATE', autoHideHelpText: true },
	                                _react2.default.createElement(_date.DateField, {
	                                    value: order.dueDate || '',
	                                    onChange: function onChange(event) {
	                                        return actions.changeInvoiceField('dueDate', event.target.value);
	                                    },
	                                    readOnly: isViewMode,
	                                    offsetTips: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _can.Module,
	                            { module: 'restaurant_features_enabled', store: currentStore },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-6' },
	                                _react2.default.createElement(
	                                    _formGroup2.default,
	                                    { label: 'DELIVERY DATE', autoHideHelpText: true },
	                                    _react2.default.createElement(_date.DateTimeField, {
	                                        value: order.deliveryDate || '',
	                                        onChange: function onChange(value) {
	                                            return actions.changeInvoiceField('deliveryDate', value);
	                                        },
	                                        readOnly: isViewMode,
	                                        offsetTips: true })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _mainContentSection2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'BILL TO', autoHideHelpText: true },
	                                _react2.default.createElement(_selectCustomer2.default, {
	                                    customer: order.billingAddressInfo,
	                                    readOnly: isViewMode,
	                                    onChange: function onChange(customer) {
	                                        return actions.changeInvoiceField('billingAddressInfo', customer);
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'SHIP TO', autoHideHelpText: true },
	                                _react2.default.createElement(_selectCustomer2.default, {
	                                    customer: order.shippingAddressInfo,
	                                    readOnly: isViewMode,
	                                    onChange: function onChange(customer) {
	                                        return actions.changeInvoiceField('shippingAddressInfo', customer);
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'CUSTOMER PHONE', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control',
	                                    value: order.customerPhone || '',
	                                    readOnly: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-3' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'CUSTOMER EMAIL', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control',
	                                    value: order.customerEmail || '',
	                                    readOnly: true })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'BILLING ADDRESS', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control',
	                                    value: order.billingAddress || order.billingAddressInfo && order.billingAddressInfo.billingAddress || '',
	                                    readOnly: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            _react2.default.createElement(
	                                _formGroup2.default,
	                                { label: 'SHIPPING ADDRESS', autoHideHelpText: true },
	                                _react2.default.createElement('input', { className: 'form-control',
	                                    value: order.shippingAddress || order.shippingAddressInfo && order.shippingAddressInfo.shippingAddress || '',
	                                    readOnly: true })
	                            )
	                        )
	                    ),
	                    !order.lineItems || order.lineItems.length === 0 ? _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center', padding: 30 } },
	                        'There is no item'
	                    ) : _react2.default.createElement(
	                        'table',
	                        { className: 'table data-table data-table--no-border data-table--primary-link' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '25%' } },
	                                    'ITEM'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'ORDER QTY'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'FULFILLED QTY'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'REFUND QTY'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%' } },
	                                    'UNIT'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'UNIT PRICE'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'DISCOUNT'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%', textAlign: 'right' } },
	                                    'AMOUNT'
	                                ),
	                                isQuote ? null : _react2.default.createElement(
	                                    'th',
	                                    { style: { width: '10%' } },
	                                    'FULFILLMENT STATUS'
	                                ),
	                                isViewMode ? null : _react2.default.createElement('th', { style: { width: '5%' } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            order.lineItems.map(function (item, i) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: i },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        item.label,
	                                        item.listing_barcode ? '<br>SKU / PLU: ' + item.listing_barcode : null,
	                                        Array.isArray(item.listing_reference_codes) && item.listing_reference_codes.length ? '<br>' + item.listing_reference_codes.map(function (item) {
	                                            return item.code;
	                                        }).join(', ') : null
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_inputNumber2.default, {
	                                            value: item.unitQuantity,
	                                            dp: item.quantityAllowDecimal ? quantityDp : 0,
	                                            onChange: function onChange(value) {
	                                                return actions.changeInvoiceListingQuantity(i, value);
	                                            },
	                                            readOnly: isViewMode
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_inputNumber2.default, {
	                                            value: item.qtyFulfilledInDisplayUnit,
	                                            dp: item.quantityAllowDecimal ? quantityDp : 0,
	                                            readOnly: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_inputNumber2.default, {
	                                            value: item.qtyRefundedInDisplayUnit,
	                                            dp: item.quantityAllowDecimal ? quantityDp : 0,
	                                            readOnly: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        function () {
	                                            var allowEditUnit = true;
	                                            if (!isViewMode && allowEditUnit && item.unitGroupId) {
	                                                var unitGroup = unitGroups[item.unitGroupId] || {};
	                                                var unitOptions = (unitGroup.units || []).map(function (unitId) {
	                                                    return units[unitId];
	                                                });
	                                                if (unitOptions.length > 0) {
	                                                    return _react2.default.createElement(
	                                                        'select',
	                                                        {
	                                                            value: item.unitId || item.defaultOrderUnitId || item.baseUnitId,
	                                                            onChange: function onChange(event) {
	                                                                actions.changeInvoiceListingUnit(i, event.target.value);
	                                                            }
	                                                        },
	                                                        unitOptions.map(function (unit) {
	                                                            return _react2.default.createElement(
	                                                                'option',
	                                                                { key: unit.id, value: unit.id },
	                                                                unit.name
	                                                            );
	                                                        })
	                                                    );
	                                                }
	                                            }
	                                            return item.unit || null;
	                                        }()
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_inputCurrency2.default, {
	                                            value: item.unitPrice,
	                                            currency: currency,
	                                            onChange: function onChange(value) {
	                                                actions.changeInvoiceListingUnitPrice(i, value);
	                                            },
	                                            readOnly: isViewMode
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'select',
	                                            {
	                                                disabled: isViewMode,
	                                                value: item.discountEntries[0] ? item.discountEntries[0].discountId : "",
	                                                onChange: function onChange(e) {
	                                                    return _this2.changeDiscount(e, i);
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                'option',
	                                                { value: '' },
	                                                'NONE'
	                                            ),
	                                            discounts.map(function (d, i) {
	                                                return _react2.default.createElement(
	                                                    'option',
	                                                    { key: i, value: d.id },
	                                                    d.name
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { style: { textAlign: "right" } },
	                                            _this2.renderDiscount(item.discountEntries[0])
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_inputCurrency2.default, {
	                                            value: item.unitQuantity * item.unitPrice,
	                                            dp: listingDp,
	                                            currency: currency,
	                                            readOnly: true
	                                        })
	                                    ),
	                                    isQuote ? null : _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_status2.default, { state: item.inventoryState })
	                                    ),
	                                    !isViewMode && (isInvoice || !item.id) ? _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_actionButton2.default, { type: 'delete', onClick: function onClick() {
	                                                return actions.removeListingsFromInvoice(i);
	                                            } })
	                                    ) : null
	                                );
	                            })
	                        )
	                    ),
	                    isViewMode ? null : _react2.default.createElement(
	                        _addListing2.default,
	                        {
	                            withBarcode: true,
	                            onSave: function onSave(listings) {
	                                return actions.addListingsToInvoice(listings, storeId, unitGroups, units);
	                            }
	                        },
	                        'Add New Item'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'w-100' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 w-50' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'form-label' },
	                                    'NOTE'
	                                ),
	                                _react2.default.createElement('textarea', { className: 'form-control',
	                                    style: { height: 250 },
	                                    value: order.note || '',
	                                    readOnly: isViewMode,
	                                    onChange: function onChange(event) {
	                                        return actions.changeInvoiceField('note', event.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 w-50' },
	                                _react2.default.createElement(_totalSlip2.default, {
	                                    currency: currency,
	                                    totalDp: totalDp,
	                                    listingDp: listingDp,
	                                    totalItems: order.totalItems,
	                                    subtotal: order.subtotal,
	                                    tax: order.tax,
	                                    discountTotal: order.discountTotal,
	                                    serviceFee: order.serviceFee,
	                                    tips: order.tips,
	                                    rounding: order.rounding,
	                                    total: order.total
	                                }),
	                                isQuote ? null : _react2.default.createElement(_paymentSlip2.default, {
	                                    currency: currency,
	                                    paidTotal: order.paidTotal,
	                                    refundTotal: order.refundTotal,
	                                    remaining: order.amountLefted,
	                                    saleTransactions: order.saleTransactions,
	                                    refundTransactions: order.refundTransactions })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InvoiceOverview;
	}(_react.Component);
	
	InvoiceOverview.contextTypes = {
	    currentStore: _propTypes2.default.object.isRequired
	};
	
	InvoiceOverview.propTypes = {
	    discountActions: _propTypes2.default.object.isRequired,
	    pathState: _propTypes2.default.object.isRequired,
	    selectDiscount: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var appState = state;
	    var _state$invoice = state.invoice,
	        pathState = _state$invoice === undefined ? {} : _state$invoice;
	    var loading = state.base.loading,
	        entities = state.entities;
	    var selectDiscount = state.components.selectDiscount;
	
	    return Object.assign({}, props, { appState: appState, pathState: pathState, entities: entities, loading: loading, selectDiscount: selectDiscount });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(actions, dispatch),
	        discountActions: (0, _redux.bindActionCreators)(selectDiscountActions, dispatch)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InvoiceOverview);

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _formatHelper = __webpack_require__(35);
	
	var _permissionHelper = __webpack_require__(92);
	
	var _paymentRefund = __webpack_require__(181);
	
	var modalActions = _interopRequireWildcard(_paymentRefund);
	
	var _invoiceActions = __webpack_require__(226);
	
	var invoiceActions = _interopRequireWildcard(_invoiceActions);
	
	var _grid = __webpack_require__(66);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _paymentRefundModal = __webpack_require__(236);
	
	var _paymentRefundModal2 = _interopRequireDefault(_paymentRefundModal);
	
	var _mainContentSection = __webpack_require__(189);
	
	var _mainContentSection2 = _interopRequireDefault(_mainContentSection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var appState = state;
	  var _state$invoice = state.invoice,
	      pathState = _state$invoice === undefined ? {} : _state$invoice;
	  var loading = state.base.loading,
	      entities = state.entities;
	  var _state$forms = state.forms,
	      forms = _state$forms === undefined ? {} : _state$forms;
	  var _forms$paymentRefund = forms.paymentRefund,
	      paymentRefund = _forms$paymentRefund === undefined ? {} : _forms$paymentRefund;
	
	  return Object.assign({}, props, { appState: appState, pathState: pathState, entities: entities, loading: loading, paymentRefund: paymentRefund });
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = _extends({}, modalActions, invoiceActions);
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	var InvoicePayment = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _griddleComponents.timeComponent)(_class = (0, _griddleComponents.transactionTypeComponent)(_class = (0, _griddleComponents.transactionDetailsComponent)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(InvoicePayment, _Component);
	
	  function InvoicePayment(props) {
	    _classCallCheck(this, InvoicePayment);
	
	    var _this = _possibleConstructorReturn(this, (InvoicePayment.__proto__ || Object.getPrototypeOf(InvoicePayment)).call(this, props));
	
	    _this.closePaymentRefundModal = function () {
	      var _this$props = _this.props,
	          _this$props$actions = _this$props.actions,
	          actions = _this$props$actions === undefined ? {} : _this$props$actions,
	          _this$props$paymentRe = _this$props.paymentRefund,
	          paymentRefund = _this$props$paymentRe === undefined ? {} : _this$props$paymentRe;
	      var type = paymentRefund.type;
	
	      var msg = type === _paymentRefundModal2.default.TYPE.PAYMENT ? 'Do you confirm to cancel payment?' : 'Do you confirm to cancel refund?';
	      var result = confirm(msg);
	      if (result) {
	        actions.closePaymentRefundModal();
	      }
	    };
	
	    _this.successlyClosePaymentRefundModal = function (order) {
	      var _this$props$actions2 = _this.props.actions,
	          actions = _this$props$actions2 === undefined ? {} : _this$props$actions2;
	
	      actions.closePaymentRefundModal();
	      actions.refreshInvoice();
	    };
	
	    _this.columns = [{ columnName: 'createdAt', displayName: 'Date', customComponent: _this.timeComponent }, { columnName: 'cashierName', displayName: 'Cashier' }, { columnName: 'payment', displayName: 'Type', customComponent: _this.transactionTypeComponent }, { columnName: 'details', displayName: 'Details', customComponent: _this.transactionDetailsComponent }, { columnName: 'note', displayName: 'Note' }, { columnName: 'amount', displayName: 'Amount', cssClassName: 'align-right', customComponent: function customComponent(row) {
	        var data = row.data,
	            rowData = row.rowData;
	        var currency = rowData.currency,
	            amountLefted = rowData.amountLefted;
	
	        var refunded = data.minus(amountLefted);
	        var format = { currency: currency };
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _formatHelper.formatCurrency)(data, format)
	          ),
	          refunded.gt(0) ? _react2.default.createElement(
	            'div',
	            { style: { color: '#8e8e8e' } },
	            'Refunded ',
	            (0, _formatHelper.formatCurrency)(refunded, format)
	          ) : null
	        );
	      }
	    }];
	    return _this;
	  }
	
	  _createClass(InvoicePayment, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$pathState = _props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState,
	          _props$paymentRefund = _props.paymentRefund,
	          paymentRefund = _props$paymentRefund === undefined ? {} : _props$paymentRefund;
	      var _pathState$order = pathState.order,
	          order = _pathState$order === undefined ? {} : _pathState$order,
	          _pathState$currentSto = pathState.currentStore,
	          currentStore = _pathState$currentSto === undefined ? {} : _pathState$currentSto;
	      var _order$saleTransactio = order.saleTransactions,
	          saleTransactions = _order$saleTransactio === undefined ? [] : _order$saleTransactio,
	          _order$refundTransact = order.refundTransactions,
	          refundTransactions = _order$refundTransact === undefined ? [] : _order$refundTransact;
	
	      var rows = [].concat(saleTransactions, refundTransactions).sort(function (a, b) {
	        return new Date(a.createdAt) - new Date(b.createdAt);
	      });
	      var invoiceEdit = (0, _permissionHelper.permissionAccessor)('invoice:edit', currentStore);
	      var gridActions = [{
	        name: 'Void',
	        hide: function hide(item) {
	          return !invoiceEdit || item.amount.lte(0) || !item.allowVoidPayment || !item.amount.eq(item.amountLefted);
	        },
	        onClick: function onClick(item) {
	          var id = item.id,
	              storeId = item.storeId;
	          var _props2 = _this2.props,
	              _props2$pathState = _props2.pathState,
	              pathState = _props2$pathState === undefined ? {} : _props2$pathState,
	              actions = _props2.actions;
	          var orderNumber = pathState.orderNumber;
	
	          var confirmed = actions.confirmVoidTransaction(storeId, orderNumber, id);
	          if (confirmed) {
	            actions.voidTransaction(storeId, orderNumber, id);
	          }
	        }
	      }, {
	        name: 'Refund',
	        hide: function hide(item) {
	          return !invoiceEdit || item.amount.lte(0) || item.amountLefted.lte(0);
	        },
	        onClick: function onClick(item) {
	          var id = item.id,
	              storeId = item.storeId;
	          var _props3 = _this2.props,
	              _props3$pathState = _props3.pathState,
	              pathState = _props3$pathState === undefined ? {} : _props3$pathState,
	              actions = _props3.actions;
	          var _pathState$order2 = pathState.order,
	              order = _pathState$order2 === undefined ? {} : _pathState$order2;
	
	          actions.openPaymentRefundModal(_paymentRefundModal2.default.TYPE.REFUND, storeId, order, id);
	        }
	      }];
	
	      return _react2.default.createElement(
	        _mainContentSection2.default,
	        null,
	        _react2.default.createElement(_grid.GridBody, { data: rows,
	          border: 'h',
	          noOutline: true,
	          actions: gridActions,
	          columns: this.columns }),
	        _react2.default.createElement(_paymentRefundModal2.default, {
	          style: { width: 800, maxWidth: '80vw' },
	          isOpen: paymentRefund.isOpen,
	          onRequestClose: this.closePaymentRefundModal,
	          onSuccessClose: this.successlyClosePaymentRefundModal
	        })
	      );
	    }
	  }]);
	
	  return InvoicePayment;
	}(_react.Component), _class2.propTypes = {
	  actions: _propTypes2.default.object,
	  pathState: _propTypes2.default.object,
	  paymentRefund: _propTypes2.default.object,
	  saleTransactions: _propTypes2.default.array,
	  refundTransactions: _propTypes2.default.array
	}, _temp)) || _class) || _class) || _class) || _class);
	exports.default = InvoicePayment;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _humps = __webpack_require__(44);
	
	var _constants = __webpack_require__(26);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _slip = __webpack_require__(485);
	
	var _slip2 = _interopRequireDefault(_slip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputStyle = {
	  paddingLeft: 0,
	  paddingRight: 0
	};
	
	function createPaymentData(item, i, ary, isRefund, currency) {
	  var len = ary.length;
	  var ret = [];
	  var num = i + 1;
	  var suffix = 'th';
	  if (num < 10 || num > 20) {
	    var remainder = num % 10;
	    if (remainder === 1) {
	      suffix = 'st';
	    } else if (remainder === 2) {
	      suffix = 'nd';
	    } else if (remainder === 3) {
	      suffix = 'rd';
	    }
	  }
	  var count = '' + num + suffix + ' ';
	  var prefix = len === 1 ? '' : count;
	  var paymentTitle = '' + prefix + (isRefund ? 'Refund' : 'Payment');
	  var paymentEl = _react2.default.createElement(_inputCurrency2.default, { value: item.amount, currency: currency, style: inputStyle, readOnly: true });
	  ret.push({ field: paymentTitle, value: paymentEl, className: 'slip__detail--bold' });
	
	  if (item.paymentMethod === constants.PAYMENT_METHOD_CP || item.paymentMethod === constants.PAYMENT_METHOD_CNP) {
	    var _item$extra = item.extra,
	        extra = _item$extra === undefined ? {} : _item$extra;
	
	    var cardType = (0, _humps.pascalize)(extra.creditCardType || 'Credit Card');
	    var holder = extra.holderName;
	    var cardNumber = '**** **** **** ' + extra.last4Digits;
	    ret.push({ field: 'Cardholder', value: holder });
	    ret.push({ field: 'Pay via ' + cardType, value: cardNumber });
	  } else if (item.paymentMethod === constants.PAYMENT_METHOD_OCTOPUS) {
	    ret.push({ field: 'Pay via Octopus', value: item.octopusCardNumber });
	  } else {
	    ret.push({ field: 'Pay via ' + item.payment });
	  }
	  return ret;
	}
	
	function PaymentSlip(props) {
	  var currency = props.currency,
	      paidTotal = props.paidTotal,
	      refundTotal = props.refundTotal,
	      remaining = props.remaining,
	      _props$saleTransactio = props.saleTransactions,
	      saleTransactions = _props$saleTransactio === undefined ? [] : _props$saleTransactio,
	      _props$refundTransact = props.refundTransactions,
	      refundTransactions = _props$refundTransact === undefined ? [] : _props$refundTransact,
	      showDetails = props.showDetails;
	
	  var salesLength = saleTransactions.length;
	  var refundLength = refundTransactions.length;
	  var details = [];
	  var totals = [{
	    field: 'Paid Total',
	    value: _react2.default.createElement(_inputCurrency2.default, { value: (0, _big2.default)(paidTotal || 0).add(refundTotal || 0), currency: currency, style: inputStyle, readOnly: true }),
	    hide: !showDetails
	  }, {
	    field: 'Refund Total',
	    value: _react2.default.createElement(_inputCurrency2.default, { value: refundTotal, currency: currency, style: inputStyle, readOnly: true }),
	    hide: !showDetails
	  }, {
	    field: 'Settled Amount',
	    value: _react2.default.createElement(_inputCurrency2.default, { value: paidTotal, currency: currency, style: inputStyle, readOnly: true }),
	    hide: showDetails
	  }, {
	    field: 'Amount Remaining',
	    value: _react2.default.createElement(_inputCurrency2.default, { value: remaining, currency: currency, style: inputStyle, readOnly: true })
	  }];
	
	  if (salesLength > 0) {
	    details.push({ title: 'Payment Summary' });
	    saleTransactions.forEach(function (item, i, ary) {
	      details = details.concat(createPaymentData(item, i, ary, false, currency));
	    });
	  }
	
	  if (refundLength > 0) {
	    details.push({ title: 'Refund Summary' });
	    refundTransactions.map(function (item) {
	      return Object.assign({}, item, { amount: (0, _big2.default)(-1).times(item.amount || 0) });
	    }).forEach(function (item, i, ary) {
	      details = details.concat(createPaymentData(item, i, ary, true, currency));
	    });
	  }
	
	  return _react2.default.createElement(_slip2.default, { details: showDetails ? details : [], totals: totals, style: { marginTop: 30 } });
	}
	
	PaymentSlip.propTypes = {
	  currency: _propTypes2.default.string,
	  paidTotal: _propTypes2.default.instanceOf(_big2.default),
	  refundTotal: _propTypes2.default.instanceOf(_big2.default),
	  remaining: _propTypes2.default.instanceOf(_big2.default),
	  saleTransactions: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  refundTransactions: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  showDetails: _propTypes2.default.bool
	};
	
	exports.default = PaymentSlip;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _inputCurrency = __webpack_require__(153);
	
	var _inputCurrency2 = _interopRequireDefault(_inputCurrency);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	var _slip = __webpack_require__(485);
	
	var _slip2 = _interopRequireDefault(_slip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TotalSlip(props) {
	  var totalItems = props.totalItems,
	      subtotal = props.subtotal,
	      tax = props.tax,
	      discountTotal = props.discountTotal,
	      serviceFee = props.serviceFee,
	      tips = props.tips,
	      rounding = props.rounding,
	      total = props.total;
	  var currency = props.currency,
	      totalDp = props.totalDp,
	      listingDp = props.listingDp;
	
	  var style = { paddingLeft: 0, paddingRight: 0 };
	  var details = [{
	    field: 'Total Item' + ((0, _big2.default)(totalItems || 0).gt(1) ? 's' : ''),
	    value: _react2.default.createElement(_inputNumber2.default, { value: totalItems, dp: totalDp, readOnly: true, style: style })
	  }, {
	    field: 'Subtotal',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: subtotal, readOnly: true, style: style })
	  }, {
	    field: 'Discount',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: discountTotal, readOnly: true, style: style })
	  }, {
	    field: 'Tax',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: tax, readOnly: true, style: style }),
	    hide: tax.eq(0)
	  }, {
	    field: 'Service Fee',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: serviceFee, readOnly: true, style: style }),
	    hide: serviceFee.eq(0)
	  }, {
	    field: 'Tips',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: tips, readOnly: true, style: style }),
	    hide: tips.eq(0)
	  }, {
	    field: 'Rounding',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: listingDp, value: rounding, readOnly: true, style: style }),
	    hide: rounding.eq(0)
	  }];
	  var totals = [{
	    field: 'Order Total',
	    value: _react2.default.createElement(_inputCurrency2.default, { currency: currency, dp: totalDp, value: total, readOnly: true, style: style }),
	    style: { fontSize: 18 }
	  }];
	  return _react2.default.createElement(_slip2.default, { details: details, totals: totals });
	}
	
	TotalSlip.propTypes = {
	  currency: _propTypes2.default.string,
	  totalDp: _propTypes2.default.number,
	  listingDp: _propTypes2.default.number,
	  totalItems: _propTypes2.default.instanceOf(_big2.default),
	  subtotal: _propTypes2.default.instanceOf(_big2.default),
	  tax: _propTypes2.default.instanceOf(_big2.default),
	  discountTotal: _propTypes2.default.instanceOf(_big2.default),
	  serviceFee: _propTypes2.default.instanceOf(_big2.default),
	  tips: _propTypes2.default.instanceOf(_big2.default),
	  rounding: _propTypes2.default.instanceOf(_big2.default),
	  total: _propTypes2.default.instanceOf(_big2.default)
	};
	
	exports.default = TotalSlip;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constant = __webpack_require__(108);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _layout = __webpack_require__(237);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceCreate = function InvoiceCreate(props) {
	  var type = props.type,
	      mode = props.mode,
	      tab = props.tab,
	      storeId = props.storeId,
	      orderNumber = props.orderNumber;
	
	  return _react2.default.createElement(
	    _can2.default,
	    { action: 'invoice:edit' },
	    _react2.default.createElement(_layout2.default, { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber })
	  );
	};
	
	InvoiceCreate.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  orderNumber: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = _constant.INVOICE_TYPE;
	  var mode = _constant.NEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      orderNumber = params.order_number;
	
	  var tab = _constant.OVERVIEW;
	  return { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InvoiceCreate);

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constant = __webpack_require__(108);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _layout = __webpack_require__(237);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Invoice = function Invoice(props) {
	  var type = props.type,
	      mode = props.mode,
	      tab = props.tab,
	      storeId = props.storeId,
	      orderNumber = props.orderNumber;
	
	  return _react2.default.createElement(
	    _can2.default,
	    { action: /invoice:/ },
	    _react2.default.createElement(_layout2.default, { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber })
	  );
	};
	
	Invoice.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  orderNumber: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = _constant.INVOICE_TYPE;
	  var mode = _constant.VIEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      orderNumber = params.order_number;
	
	  var tab = _constant.OVERVIEW;
	  return { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Invoice);

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constant = __webpack_require__(108);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _layout = __webpack_require__(237);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuoteCreate = function QuoteCreate(props) {
	  var type = props.type,
	      mode = props.mode,
	      tab = props.tab,
	      storeId = props.storeId,
	      orderNumber = props.orderNumber;
	
	  return _react2.default.createElement(
	    _can2.default,
	    { action: 'invoice:edit' },
	    _react2.default.createElement(_layout2.default, { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber })
	  );
	};
	
	QuoteCreate.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  orderNumber: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = _constant.QUOTE_TYPE;
	  var mode = _constant.NEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      orderNumber = params.order_number;
	
	  var tab = _constant.OVERVIEW;
	  return { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuoteCreate);

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _constant = __webpack_require__(108);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _layout = __webpack_require__(237);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(props) {
	  var type = props.type,
	      mode = props.mode,
	      tab = props.tab,
	      storeId = props.storeId,
	      orderNumber = props.orderNumber;
	
	  return _react2.default.createElement(
	    _can2.default,
	    { action: /invoice:/ },
	    _react2.default.createElement(_layout2.default, { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber })
	  );
	};
	
	Quote.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  storeId: _propTypes2.default.string.isRequired,
	  orderNumber: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var type = _constant.QUOTE_TYPE;
	  var mode = _constant.VIEW;
	  var _props$params = props.params,
	      params = _props$params === undefined ? {} : _props$params;
	  var storeId = params.store_id,
	      orderNumber = params.order_number;
	
	  var tab = _constant.OVERVIEW;
	  return { type: type, mode: mode, tab: tab, storeId: storeId, orderNumber: orderNumber };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Quote);

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Action(_ref) {
	  var text = _ref.text,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "kd-action", onClick: onClick },
	    text
	  );
	}
	
	Action.propTypes = {
	  text: _react.PropTypes.string.isRequired,
	  onClick: _react.PropTypes.func
	};
	
	exports.default = Action;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blueprint = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssignPrinter = (_temp = _class = function (_React$Component) {
	  _inherits(AssignPrinter, _React$Component);
	
	  function AssignPrinter(props) {
	    _classCallCheck(this, AssignPrinter);
	
	    var _this = _possibleConstructorReturn(this, (AssignPrinter.__proto__ || Object.getPrototypeOf(AssignPrinter)).call(this, props));
	
	    _this.handleSelectAllChange = _this.handleSelectAllChange.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSave = _this.handleSave.bind(_this);
	    var selectedPrinters = [];
	    Object.assign(selectedPrinters, props.action.target.printers);
	    _this.state = {
	      selected: selectedPrinters.map(function (printer) {
	        return printer.id;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(AssignPrinter, [{
	    key: 'handleSelectAllChange',
	    value: function handleSelectAllChange(event) {
	      var selected = event.target.checked ? this.props.printers.map(function (printer) {
	        return printer.id;
	      }) : [];
	      this.setState({ selected: selected });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(printer, event) {
	      var selected = this.state.selected;
	
	      if (event.target.checked) {
	        selected.push(printer.id);
	      } else {
	        selected = selected.filter(function (id) {
	          return printer.id !== id;
	        });
	      }
	      this.setState({ selected: selected });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      var _this2 = this;
	
	      // let printers = this.props.printers.filter(printer => this.state.selected.includes(printer.id))
	      var printers = this.props.printers.filter(function (printer) {
	        return _this2.state.selected.indexOf(printer.id) >= 0;
	      });
	      var target = this.props.action.target;
	
	      target.printers = printers;
	      this.props.onSave(target);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          printers = _props.printers,
	          onCancel = _props.onCancel,
	          action = _props.action;
	      var selected = this.state.selected;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog-container' },
	        _react2.default.createElement(
	          'table',
	          { className: 'pt-table', width: '100%' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                _react2.default.createElement('input', {
	                  type: 'checkbox'
	                  // checked={printers.every(({id})=>selected.includes(id))}
	                  , checked: printers.every(function (_ref) {
	                    var id = _ref.id;
	                    return selected.indexOf(id) >= 0;
	                  }),
	                  onChange: this.handleSelectAllChange
	                })
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Mac Address'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'IP'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            printers.map(function (printer) {
	              return _react2.default.createElement(
	                'tr',
	                { key: printer.id },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('input', {
	                    type: 'checkbox'
	                    // checked={selected.includes(printer.id)}
	                    , checked: selected.indexOf(printer.id) >= 0,
	                    onChange: function onChange(event) {
	                      return _this3.handleChange(printer, event);
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  printer.name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  printer.mac_address
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  printer.details.printer_ip
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_blueprint.Callout, { error: action.error }),
	        _react2.default.createElement(_blueprint.DialogButtonGroup, { onSave: this.handleSave, onCancel: onCancel })
	      );
	    }
	  }]);
	
	  return AssignPrinter;
	}(_react2.default.Component), _class.propTypes = {
	  action: _react.PropTypes.object.isRequired,
	  printers: _react.PropTypes.array.isRequired,
	  onSave: _react.PropTypes.func.isRequired,
	  onCancel: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = AssignPrinter;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blueprint = __webpack_require__(120);
	
	var _workflowService = __webpack_require__(498);
	
	var _workflowService2 = _interopRequireDefault(_workflowService);
	
	var _kitchenDepartmentService = __webpack_require__(324);
	
	var _kitchenDepartmentService2 = _interopRequireDefault(_kitchenDepartmentService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetWorkflow = (_temp = _class = function (_React$Component) {
	  _inherits(SetWorkflow, _React$Component);
	
	  function SetWorkflow(props) {
	    _classCallCheck(this, SetWorkflow);
	
	    var _this = _possibleConstructorReturn(this, (SetWorkflow.__proto__ || Object.getPrototypeOf(SetWorkflow)).call(this, props));
	
	    _this.fetchWorkflows = _this.fetchWorkflows.bind(_this);
	    _this.handleSave = _this.handleSave.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    var workflow = props.action.target.workflow;
	
	    _this.state = {
	      loading: false,
	      workflows: [],
	      selected: workflow ? workflow.id : null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(SetWorkflow, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchWorkflows();
	    }
	  }, {
	    key: 'fetchWorkflows',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var response, workflows;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ loading: true });
	                _context.next = 3;
	                return _workflowService2.default.getWorkflows(this.props.storeId);
	
	              case 3:
	                response = _context.sent;
	                workflows = response.data.workflows;
	
	                this.setState({ workflows: workflows, loading: false });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function fetchWorkflows() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchWorkflows;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var selected = event.target.value;
	      this.setState({ selected: selected });
	    }
	  }, {
	    key: 'handleSave',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var selected, id;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                selected = this.state.selected;
	                id = this.props.action.target.id;
	                _context2.next = 5;
	                return _kitchenDepartmentService2.default.update(this.props.storeId, { id: id, workflow_id: selected });
	
	              case 5:
	                this.props.onSaved();
	                this.props.onCancel();
	                _context2.next = 12;
	                break;
	
	              case 9:
	                _context2.prev = 9;
	                _context2.t0 = _context2['catch'](0);
	
	                this.setState({ error: _context2.t0 });
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[0, 9]]);
	      }));
	
	      function handleSave() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handleSave;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var onCancel = this.props.onCancel;
	      var _state = this.state,
	          selected = _state.selected,
	          workflows = _state.workflows,
	          error = _state.error;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pt-select pt-fill' },
	          _react2.default.createElement(
	            'select',
	            { selected: selected, onChange: this.handleChange },
	            _react2.default.createElement(
	              'option',
	              { value: null },
	              'Choose a workflow...'
	            ),
	            workflows.map(function (workflow) {
	              return _react2.default.createElement(
	                'option',
	                { key: workflow.id, value: workflow.id },
	                workflow.name
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_blueprint.Callout, { error: error }),
	        _react2.default.createElement(_blueprint.DialogButtonGroup, { onCancel: onCancel, onSave: this.handleSave })
	      );
	    }
	  }]);
	
	  return SetWorkflow;
	}(_react2.default.Component), _class.propTypes = {
	  action: _react.PropTypes.object.isRequired,
	  storeId: _react.PropTypes.string.isRequired,
	  onSaved: _react.PropTypes.func.isRequired,
	  onCancel: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = SetWorkflow;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPopper = __webpack_require__(670);
	
	var _Action = __webpack_require__(860);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _core = __webpack_require__(89);
	
	var _constants = __webpack_require__(486);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function injectAction(_onClick) {
	  function BoundAction(_ref) {
	    var text = _ref.text,
	        mode = _ref.mode;
	
	    return _react2.default.createElement(_Action2.default, { text: text, onClick: function onClick() {
	        return _onClick(mode);
	      } });
	  }
	  BoundAction.propTypes = {
	    text: _react.PropTypes.string.isRequired,
	    mode: _react.PropTypes.string.isRequired
	  };
	  return BoundAction;
	}
	
	var Table = function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.handleActionClick = _this.handleActionClick.bind(_this);
	    _this.state = {
	      active: null
	    };
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'toggle',
	    value: function toggle(active) {
	      this.setState({ active: active });
	    }
	  }, {
	    key: 'handleActionClick',
	    value: function handleActionClick(target, mode) {
	      this.props.setAction({ target: target, mode: mode });
	      this.setState({ active: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          departments = _props.departments,
	          stores = _props.stores,
	          storeId = _props.storeId;
	      var active = this.state.active;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'table',
	          { className: 'pt-table pt-striped pt-interactive', width: '100%' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Printer'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Workflow'
	              ),
	              _react2.default.createElement('th', null)
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            departments.map(function (kd) {
	              var Action = injectAction(_this2.handleActionClick.bind(_this2, kd));
	              var store = stores.find(function (_ref2) {
	                var id = _ref2.id;
	                return id != storeId && id == kd.store_id;
	              });
	              return _react2.default.createElement(
	                'tr',
	                { key: kd.id },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'kd-name-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'kd-name' },
	                      kd.name
	                    ),
	                    store ? _react2.default.createElement(
	                      'div',
	                      { className: 'kd-store-name' },
	                      'Created at: ',
	                      store.title
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  kd.printers.map(function (_ref3) {
	                    var name = _ref3.name;
	                    return name;
	                  }).join(',') || 'Null'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  kd.workflow ? kd.workflow.name : 'Null'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { width: '10%' },
	                  _react2.default.createElement(
	                    _reactPopper.Manager,
	                    { className: 'kd-actions-wrapper' },
	                    _react2.default.createElement(
	                      _reactPopper.Target,
	                      null,
	                      _react2.default.createElement(_core.Button, { text: 'Action', rightIconName: 'caret-down', onClick: function onClick() {
	                          return _this2.toggle(kd);
	                        } })
	                    ),
	                    active === kd ? _react2.default.createElement(
	                      _reactPopper.Popper,
	                      { placement: 'bottom', className: 'popper' },
	                      _react2.default.createElement(Action, { text: 'Edit', mode: _constants.EDIT_MODE.EDIT }),
	                      _react2.default.createElement(Action, { text: 'Assign Printer', mode: _constants.EDIT_MODE.ASSIGN_PRINTER }),
	                      _react2.default.createElement(Action, { text: 'Set Workflow', mode: _constants.EDIT_MODE.SET_WORKFLOW }),
	                      _react2.default.createElement(Action, { text: 'Remove', mode: _constants.EDIT_MODE.REMOVE }),
	                      _react2.default.createElement(
	                        _reactPopper.Arrow,
	                        { className: 'popper__arrow' },
	                        _react2.default.createElement(_core.Icon, { iconName: 'caret-up' })
	                      )
	                    ) : null
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('kd-screen', { active: active }), onClick: function onClick() {
	            return _this2.toggle(null);
	          } })
	      );
	    }
	  }]);
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = {
	  setAction: _react.PropTypes.func.isRequired,
	  departments: _react.PropTypes.array.isRequired,
	  stores: _react.PropTypes.array.isRequired,
	  storeId: _react.PropTypes.string.isRequired
	};
	
	function mapStateToProps(_ref4, props) {
	  var stores = _ref4.stores;
	
	  return _extends({}, props, {
	    stores: stores
	  });
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Table);

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(89);
	
	var _kitchenDepartmentService = __webpack_require__(324);
	
	var _kitchenDepartmentService2 = _interopRequireDefault(_kitchenDepartmentService);
	
	__webpack_require__(1260);
	
	var _Table = __webpack_require__(863);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _constants = __webpack_require__(486);
	
	var _AssignPrinter = __webpack_require__(861);
	
	var _AssignPrinter2 = _interopRequireDefault(_AssignPrinter);
	
	var _SetWorkflow = __webpack_require__(862);
	
	var _SetWorkflow2 = _interopRequireDefault(_SetWorkflow);
	
	var _blueprint = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_core.FocusStyleManager.onlyShowFocusOnTabs();
	
	var KitchenDepartment = function (_React$Component) {
	  _inherits(KitchenDepartment, _React$Component);
	
	  function KitchenDepartment(props) {
	    _classCallCheck(this, KitchenDepartment);
	
	    var _this = _possibleConstructorReturn(this, (KitchenDepartment.__proto__ || Object.getPrototypeOf(KitchenDepartment)).call(this, props));
	
	    _this.fetchDepartments = _this.fetchDepartments.bind(_this);
	    _this.setAction = _this.setAction.bind(_this);
	    _this.cleanAction = _this.cleanAction.bind(_this);
	    _this.add = _this.add.bind(_this);
	    _this.update = _this.update.bind(_this);
	    _this.assignPrinter = _this.assignPrinter.bind(_this);
	    _this.updateTarget = _this.updateTarget.bind(_this);
	    _this.remove = _this.remove.bind(_this);
	    _this.state = {
	      loading: false,
	      departments: [],
	      action: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(KitchenDepartment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchDepartments();
	    }
	  }, {
	    key: 'fetchDepartments',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var _ref2, departments, printers;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ loading: true });
	                _context.prev = 1;
	                _context.next = 4;
	                return _kitchenDepartmentService2.default.getAllWithPrinter(this.props.params.store_id);
	
	              case 4:
	                _ref2 = _context.sent;
	                departments = _ref2.departments;
	                printers = _ref2.printers;
	
	                this.setState({ departments: departments, printers: printers, error: null });
	                _context.next = 13;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	                this.setState({ error: _context.t0 });
	
	              case 13:
	                _context.prev = 13;
	
	                this.setState({ loading: false });
	                return _context.finish(13);
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 10, 13, 16]]);
	      }));
	
	      function fetchDepartments() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchDepartments;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var action;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                action = this.state.action;
	                _context2.prev = 1;
	                _context2.next = 4;
	                return _kitchenDepartmentService2.default.create(this.props.params.store_id, action.target);
	
	              case 4:
	                this.cleanAction();
	                this.fetchDepartments();
	                _context2.next = 12;
	                break;
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2['catch'](1);
	
	                action.error = _context2.t0;
	                this.setState({ action: action });
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[1, 8]]);
	      }));
	
	      function add() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return add;
	    }()
	  }, {
	    key: 'update',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var action;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                action = this.state.action;
	                _context3.prev = 1;
	                _context3.next = 4;
	                return _kitchenDepartmentService2.default.update(this.props.params.store_id, action.target);
	
	              case 4:
	                this.cleanAction();
	                this.fetchDepartments();
	                _context3.next = 12;
	                break;
	
	              case 8:
	                _context3.prev = 8;
	                _context3.t0 = _context3['catch'](1);
	
	                action.error = _context3.t0;
	                this.setState({ action: action });
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[1, 8]]);
	      }));
	
	      function update() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return update;
	    }()
	  }, {
	    key: 'assignPrinter',
	    value: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(department) {
	        var action;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                action = this.state.action;
	                _context4.prev = 1;
	                _context4.next = 4;
	                return _kitchenDepartmentService2.default.assignPrinter(this.props.params.store_id, department);
	
	              case 4:
	                this.cleanAction();
	                this.fetchDepartments();
	                _context4.next = 12;
	                break;
	
	              case 8:
	                _context4.prev = 8;
	                _context4.t0 = _context4['catch'](1);
	
	                action.error = _context4.t0;
	                this.setState({ action: action });
	
	              case 12:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this, [[1, 8]]);
	      }));
	
	      function assignPrinter(_x) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return assignPrinter;
	    }()
	  }, {
	    key: 'remove',
	    value: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	        var action, id;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                action = this.state.action;
	                id = action.target.id;
	                _context5.prev = 2;
	                _context5.next = 5;
	                return _kitchenDepartmentService2.default.delete(this.props.params.store_id, id);
	
	              case 5:
	                this.cleanAction();
	                this.fetchDepartments();
	                _context5.next = 13;
	                break;
	
	              case 9:
	                _context5.prev = 9;
	                _context5.t0 = _context5['catch'](2);
	
	                action.error = _context5.t0;
	                this.setState({ action: action });
	
	              case 13:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this, [[2, 9]]);
	      }));
	
	      function remove() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return remove;
	    }()
	  }, {
	    key: 'setAction',
	    value: function setAction(action) {
	      this.setState({ action: action });
	    }
	  }, {
	    key: 'cleanAction',
	    value: function cleanAction() {
	      this.setState({ action: null });
	    }
	  }, {
	    key: 'updateTarget',
	    value: function updateTarget(event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	      var action = this.state.action;
	
	      action.target[name] = value;
	      this.setState({ action: action });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          departments = _state.departments,
	          printers = _state.printers,
	          action = _state.action,
	          error = _state.error;
	
	      if (loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'kitchen-department main-content state-wrapper' },
	          _react2.default.createElement(_core.Spinner, { className: _core.Classes.LARGE })
	        );
	      }
	      if (error) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'kitchen-department main-content state-wrapper' },
	          _react2.default.createElement(_blueprint.Callout, { error: error })
	        );
	      }
	      return _react2.default.createElement(
	        _blueprint.PopContainer,
	        { className: 'kitchen-department main-content' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'pt-breadcrumbs' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Home' })
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Inventory Management' })
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_core.Breadcrumb, { text: 'Kitchen Department' })
	          )
	        ),
	        _react2.default.createElement(_Table2.default, {
	          departments: departments,
	          setAction: this.setAction,
	          storeId: this.props.params.store_id
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-header' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'Kitchen Department'
	          ),
	          _react2.default.createElement(_core.Button, {
	            text: 'New Kitchen Department',
	            iconName: 'add',
	            intent: _core.Intent.PRIMARY,
	            onClick: function onClick() {
	              return _this2.setAction({ target: {}, mode: _constants.EDIT_MODE.ADD });
	            }
	          })
	        ),
	        action ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _blueprint.PopRender,
	            {
	              title: 'New Kitchen Department',
	              className: 'kd-dialog',
	              isOpen: action.mode === _constants.EDIT_MODE.ADD,
	              onClose: this.cleanAction
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'pt-input pt-fill',
	                placeholder: 'Name',
	                name: 'name',
	                value: action.target.name,
	                onChange: this.updateTarget
	              })
	            ),
	            _react2.default.createElement(_blueprint.Callout, { error: action.error }),
	            _react2.default.createElement(
	              'div',
	              { className: 'line align-right' },
	              _react2.default.createElement(_core.Button, { text: 'Cancel', onClick: this.cleanAction }),
	              _react2.default.createElement(_core.Button, { text: 'Save', intent: _core.Intent.PRIMARY, onClick: this.add })
	            )
	          ),
	          _react2.default.createElement(
	            _blueprint.PopRender,
	            {
	              title: 'Edit Kitchen Department',
	              className: 'kd-dialog',
	              isOpen: action.mode === _constants.EDIT_MODE.EDIT,
	              onClose: this.cleanAction
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'pt-input pt-fill',
	                placeholder: 'Name',
	                name: 'name',
	                value: action.target.name,
	                onChange: this.updateTarget
	              })
	            ),
	            _react2.default.createElement(_blueprint.Callout, { error: action.error }),
	            _react2.default.createElement(
	              'div',
	              { className: 'line align-right' },
	              _react2.default.createElement(_core.Button, { text: 'Cancel', onClick: this.cleanAction }),
	              _react2.default.createElement(_core.Button, { text: 'Save', intent: _core.Intent.PRIMARY, onClick: this.update })
	            )
	          ),
	          _react2.default.createElement(
	            _blueprint.PopRender,
	            {
	              title: 'Select Printer',
	              className: 'kd-dialog',
	              isOpen: action.mode === _constants.EDIT_MODE.ASSIGN_PRINTER,
	              onClose: this.cleanAction
	            },
	            _react2.default.createElement(_AssignPrinter2.default, {
	              printers: printers,
	              action: action,
	              onSave: this.assignPrinter,
	              onCancel: this.cleanAction
	            })
	          ),
	          _react2.default.createElement(
	            _blueprint.PopRender,
	            {
	              title: 'Set Workflow',
	              className: 'kd-dialog',
	              isOpen: action.mode === _constants.EDIT_MODE.SET_WORKFLOW,
	              onClose: this.cleanAction
	            },
	            _react2.default.createElement(_SetWorkflow2.default, {
	              action: action,
	              storeId: this.props.params.store_id,
	              onSaved: this.fetchDepartments,
	              onCancel: this.cleanAction
	            })
	          ),
	          _react2.default.createElement(
	            _core.Alert,
	            {
	              isOpen: action.mode === _constants.EDIT_MODE.REMOVE,
	              cancelButtonText: 'Cancel',
	              confirmButtonText: 'Yes, remove it',
	              onConfirm: this.remove,
	              onCancel: this.cleanAction,
	              iconName: 'warning-sign',
	              intent: _core.Intent.DANGER
	            },
	            'Are you sure to remove it?',
	            _react2.default.createElement(_blueprint.Callout, { error: action.error })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return KitchenDepartment;
	}(_react2.default.Component);
	
	KitchenDepartment.propTypes = {
	  params: _react.PropTypes.object.isRequired
	};
	
	exports.default = KitchenDepartment;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1261);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _alert = __webpack_require__(313);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppAlertComponent(props) {
	  var alerts = props.alerts;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'app-alert' },
	    alerts.map(function (alert) {
	      return _react2.default.createElement(
	        _alert2.default,
	        { key: (0, _uniqueId2.default)(), style: alert.style },
	        ' ',
	        alert.message,
	        ' '
	      );
	    })
	  );
	}
	
	AppAlertComponent.propTypes = {
	  alerts: _propTypes2.default.array.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    alerts: state.alerts
	  };
	};
	
	var AppAlert = (0, _reactRedux.connect)(mapStateToProps)(AppAlertComponent);
	
	exports.default = AppAlert;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(1263);
	
	__webpack_require__(1262);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _mainMenu = __webpack_require__(869);
	
	var _mainMenu2 = _interopRequireDefault(_mainMenu);
	
	var _profileMenu = __webpack_require__(870);
	
	var _profileMenu2 = _interopRequireDefault(_profileMenu);
	
	var _storeMenu = __webpack_require__(871);
	
	var _storeMenu2 = _interopRequireDefault(_storeMenu);
	
	var _loading = __webpack_require__(867);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _alert = __webpack_require__(865);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _loading3 = __webpack_require__(12);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseLayout = (_temp = _class = function (_React$Component) {
	  _inherits(BaseLayout, _React$Component);
	
	  function BaseLayout(props) {
	    _classCallCheck(this, BaseLayout);
	
	    return _possibleConstructorReturn(this, (BaseLayout.__proto__ || Object.getPrototypeOf(BaseLayout)).call(this, props));
	  }
	
	  _createClass(BaseLayout, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var store_id = this.props.params.store_id;
	      var stores = this.props.appState.stores;
	
	
	      var currentStore = (0, _find2.default)(stores, { id: parseInt(store_id) });
	      var storeIds = (store_id || '').split(',').map(function (id) {
	        return parseInt(id);
	      }).filter(function (id) {
	        return !isNaN(id);
	      });
	      var multiStore = storeIds.length > 1;
	      var currentStores = storeIds.map(function (id) {
	        return (0, _find2.default)(stores, { id: id });
	      });
	
	      return { currentStore: currentStore, multiStore: multiStore, currentStores: currentStores };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	
	
	      this.props.actions.getStores();
	      this.props.actions.getStoreModule(parseInt(store_id));
	      this.props.actions.getStorePermissions(parseInt(store_id));
	      this.props.actions.getStoreChainInfo(parseInt(store_id));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var store_id = nextProps.params.store_id;
	
	
	      if (store_id !== this.props.params.store_id) {
	        this.props.actions.getStores();
	        this.props.actions.getStoreModule(parseInt(store_id));
	        this.props.actions.getStorePermissions(parseInt(store_id));
	        this.props.actions.getStoreChainInfo(parseInt(store_id));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var actions = this.props.actions;
	      var store_id = this.props.params.store_id;
	      var stores = this.props.appState.stores;
	
	
	      var currentStore = (0, _find2.default)(stores, { id: parseInt(store_id) });
	
	      if (stores.length < 1) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _loading4.default,
	            null,
	            'Loading Stores'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'app-layout' },
	        _react2.default.createElement(
	          'div',
	          { id: 'menu' },
	          _react2.default.createElement(
	            'div',
	            { id: 'menu-header' },
	            _react2.default.createElement(
	              'a',
	              { href: '/', id: 'header__logo' },
	              _react2.default.createElement('img', { src: __webpack_require__(1307) })
	            )
	          ),
	          _react2.default.createElement(
	            'nav',
	            { id: 'menu-body' },
	            _react2.default.createElement(_mainMenu2.default, { storeId: store_id, store: currentStore, actions: actions })
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'menu-footer' },
	            _react2.default.createElement(
	              'a',
	              { id: 'intercom', href: 'mailto:support@bindo.com' },
	              'Report a problem'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'http://support.bindo.com', target: '_blank' },
	              'Help'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'main' },
	          _react2.default.createElement(
	            'div',
	            { id: 'main-header' },
	            _react2.default.createElement(_storeMenu2.default, this.props),
	            _react2.default.createElement(_profileMenu2.default, this.props)
	          ),
	          _react2.default.createElement(
	            'main',
	            { id: 'main-body' },
	            this.props.children
	          )
	        ),
	        _react2.default.createElement(_loading2.default, null),
	        _react2.default.createElement(_alert2.default, null)
	      );
	    }
	  }]);
	
	  return BaseLayout;
	}(_react2.default.Component), _class.propTypes = {
	  actions: _propTypes2.default.object.isRequired,
	  appState: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired
	}, _class.childContextTypes = {
	  currentStore: _propTypes2.default.object,
	  currentStores: _propTypes2.default.array,
	  multiStore: _propTypes2.default.bool
	}, _temp);
	exports.default = BaseLayout;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1265);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadingCompoenent(props) {
	  var show = props.show,
	      text = props.text;
	
	  if (show) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'loading-spinner-wrapper', 'ng-show': '$root.requestCounter' },
	      _react2.default.createElement(
	        'div',
	        { className: 'loading-spinner-box' },
	        _react2.default.createElement('span', { className: 'loading-spinner' }),
	        ' ',
	        text || 'Loading...'
	      )
	    );
	  } else {
	    return _react2.default.createElement('div', null);
	  }
	}
	loadingCompoenent.propTypes = {
	  show: _propTypes2.default.bool.isRequired,
	  text: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    show: state.base.loading
	  };
	};
	
	var Loading = (0, _reactRedux.connect)(mapStateToProps)(loadingCompoenent);
	
	exports.default = Loading;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1266);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainContentHeader(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        children = props.children;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'main-content -main-filter ' + className },
	        children
	    );
	}
	
	MainContentHeader.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node
	};
	
	exports.default = MainContentHeader;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2, _class2, _temp3;
	
	__webpack_require__(1272);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _remove = __webpack_require__(394);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(9);
	
	var _menuHelper = __webpack_require__(814);
	
	var _storeHelper = __webpack_require__(185);
	
	var _menu = __webpack_require__(303);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHAIN_MASTER = 'CHAIN_MASTER';
	
	var Menuitem = (_temp2 = _class = function (_Component) {
	  _inherits(Menuitem, _Component);
	
	  function Menuitem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menuitem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menuitem.__proto__ || Object.getPrototypeOf(Menuitem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      condition: false
	    }, _this.handleClick = function () {
	      _this.setState({ condition: !_this.state.condition });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menuitem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          m = _props.m,
	          storeId = _props.storeId;
	
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'a',
	          { onClick: this.handleClick },
	          _react2.default.createElement('i', { className: 'main-menu-icon' + ' -' + m.route }),
	          ' ',
	          m.name
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: this.state.condition ? 'menu__submenu' : 'menu__submenu nodisplay' },
	          m.children.map(function (submenu, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'span',
	                { className: 'menu__submenu-title' },
	                submenu.name
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'list-unstyled' },
	                submenu.children.map(function (subitem, idx) {
	                  var prefix = subitem.prefix,
	                      route = subitem.route,
	                      name = subitem.name;
	
	                  var path = '/' + storeId + '/' + route;
	                  if (prefix) path = '/' + prefix + path;
	                  return _react2.default.createElement(
	                    'li',
	                    { key: idx, className: 'menu__submenuitem' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: path },
	                      name
	                    )
	                  );
	                })
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Menuitem;
	}(_react.Component), _class.propTypes = {
	  m: _propTypes2.default.object,
	  storeId: _propTypes2.default.string
	}, _temp2);
	var MainMenu = (_temp3 = _class2 = function (_Component2) {
	  _inherits(MainMenu, _Component2);
	
	  function MainMenu() {
	    _classCallCheck(this, MainMenu);
	
	    return _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).apply(this, arguments));
	  }
	
	  _createClass(MainMenu, [{
	    key: 'handleClick',
	    value: function handleClick(item) {
	      var storeId = this.props.storeId;
	      var type = item.type,
	          route = item.route,
	          prefix = item.prefix;
	
	      if (type === 'link') {
	        var path = '/' + storeId + '/' + route;
	        if (prefix) path = '/' + prefix + path;
	        if (!path.startsWith('/v2')) {
	          window.history.pushState({ url: path }, 'Bindo Dashboard', path);
	          location.reload();
	        }
	      }
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          store = _props2.store,
	          storeId = _props2.storeId;
	
	      var menu = store.associate_type === CHAIN_MASTER ? _menu2.default.CHAIN_MASTER_MENUS : _menu2.default.DEFAULT;
	
	      var filteredMenu = (0, _menuHelper.filterMenu)(menu, store.associate_type, store.module, store.store_permissions);
	      if (!(0, _storeHelper.isAllowStoreTransfer)(store.chain_info)) {
	        (0, _remove2.default)(filteredMenu, function (m) {
	          return m.route == 'stock-transfers';
	        });
	      }
	
	      return filteredMenu.map(function (m, i) {
	        return _react2.default.createElement(
	          'li',
	          { className: (0, _classnames2.default)('main-menu-item', { 'main-menu-group': m.type === 'group' }),
	            onClick: _this3.handleClick.bind(_this3, m),
	            key: i },
	          function () {
	            var type = m.type,
	                route = m.route,
	                prefix = m.prefix,
	                name = m.name,
	                label = m.label;
	
	            if (type === 'link') {
	              var path = '/' + storeId + '/' + m.route;
	              if (prefix) path = '/' + prefix + path;
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path, activeClassName: '-active' },
	                _react2.default.createElement('i', { className: 'main-menu-icon -' + route }),
	                ' ',
	                name,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  label
	                )
	              );
	            } else if (type === 'group') {
	              return _react2.default.createElement(
	                'span',
	                { className: 'menu__group' },
	                name
	              );
	            } else if (type === 'menu') {
	              return _react2.default.createElement(Menuitem, { m: m, storeId: storeId });
	            }
	          }()
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var store = this.props.store;
	
	      if (!store) return null;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'main-menu' },
	        this.renderMenu()
	      );
	    }
	  }]);
	
	  return MainMenu;
	}(_react.Component), _class2.propTypes = {
	  store: _propTypes2.default.object,
	  storeId: _propTypes2.default.string
	}, _temp3);
	exports.default = MainMenu;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(1273);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _authDataHelper = __webpack_require__(234);
	
	var _authDataHelper2 = _interopRequireDefault(_authDataHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileMenu = (_temp = _class = function (_React$Component) {
	  _inherits(ProfileMenu, _React$Component);
	
	  function ProfileMenu(props) {
	    _classCallCheck(this, ProfileMenu);
	
	    var _this = _possibleConstructorReturn(this, (ProfileMenu.__proto__ || Object.getPrototypeOf(ProfileMenu)).call(this, props));
	
	    _this.state = {
	      showMenu: false
	    };
	
	    _this.handleHideMenu = _this.hideMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProfileMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.addEventListener('click', this.handleHideMenu);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.removeEventListener('click', this.handleHideMenu);
	    }
	  }, {
	    key: 'hideMenu',
	    value: function hideMenu(event) {
	      if (this.state.showMenu == false) {
	        return;
	      }
	      var dropdown_element = (0, _reactDom.findDOMNode)(this);
	
	      if (!dropdown_element.contains(event.target)) {
	        this.setState({
	          showMenu: false
	        });
	      }
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      this.setState({
	        showMenu: !this.state.showMenu
	      });
	    }
	  }, {
	    key: 'setLang',
	    value: function setLang() {
	      this.toggleMenu();
	      // TODO
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.toggleMenu();
	
	      _authDataHelper2.default.clear();
	
	      this.context.router.push({
	        pathname: '/login/index'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)('profile-menu', 'dropdown', { open: this.state.showMenu });
	      var user = this.props.appState.user;
	
	      if (!user) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, onClick: this.toggleMenu.bind(this) },
	        _react2.default.createElement(
	          'div',
	          { className: '_profile' },
	          _react2.default.createElement(
	            'div',
	            { className: '_name' },
	            user.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '_role' },
	            'owner'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '_avatar a' },
	          _react2.default.createElement('img', { src: __webpack_require__(1308) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '_menu dropdown-menu dropdown-menu-right' },
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'en') },
	            'English'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'it') },
	            'Italiano'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'es') },
	            'Espa\xF1ol'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'zh_HK') },
	            '\u4E2D\u6587\uFF08\u7E41\uFF09'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'zh_CN') },
	            '\u4E2D\u6587\uFF08\u7C21\uFF09'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.setLang.bind(this, 'ja_JP') },
	            '\u65E5\u672C\u8A9E'
	          ),
	          _react2.default.createElement('div', { className: 'dropdown-divider' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'a dropdown-item', onClick: this.logout.bind(this) },
	            'Logout'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileMenu;
	}(_react2.default.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = ProfileMenu;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(1274);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _compact = __webpack_require__(280);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _storeMenuItem = __webpack_require__(872);
	
	var _storeMenuItem2 = _interopRequireDefault(_storeMenuItem);
	
	var _storeHelper = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoreMenu = (_temp = _class = function (_React$Component) {
	  _inherits(StoreMenu, _React$Component);
	
	  function StoreMenu(props) {
	    _classCallCheck(this, StoreMenu);
	
	    var _this = _possibleConstructorReturn(this, (StoreMenu.__proto__ || Object.getPrototypeOf(StoreMenu)).call(this, props));
	
	    _this.switchStore = function () {
	      var stores = _this.props.appState.stores;
	
	      var storeIds = (0, _compact2.default)((0, _map2.default)(stores, function (store) {
	        return store.selected ? store.id : null;
	      })).join(',');
	
	      //for role: item master, need to redirect here.
	      if ((0, _find2.default)(stores, { 'id': parseInt(storeIds) }).associate_type === "CHAIN_MASTER") {
	        window.location = '/v2/' + storeIds + '/item-master';
	        return;
	      }
	
	      if (storeIds !== _this.props.params.store_id) {
	        _this.context.router.push('/v2/' + storeIds + '/inventory');
	        _this.setState({ showMenu: false });
	        // window.location = `/v2/${storeIds}/summary`;
	      }
	    };
	
	    _this.deselectAllStores = function () {
	      var allStores = _this.props.appState.stores;
	
	      allStores.forEach(function (store) {
	        return store.selected = false;
	      });
	      _this.forceUpdate();
	    };
	
	    _this.selectAllStores = function () {
	      var allStores = _this.props.appState.stores;
	
	      allStores.forEach(function (store) {
	        return store.selected = true;
	      });
	      _this.forceUpdate();
	    };
	
	    _this.state = {
	      showMenu: false
	    };
	
	    _this.handleHideMenu = _this.hideMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(StoreMenu, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateStore(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.addEventListener('click', this.handleHideMenu);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.params.store_id !== this.props.params.store_id) {
	        this.updateStore(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.removeEventListener('click', this.handleHideMenu);
	    }
	  }, {
	    key: 'updateStore',
	    value: function updateStore(nextProps) {
	      var params = nextProps.params,
	          appState = nextProps.appState;
	
	
	      var storeIds = params.store_id.split(',');
	
	      appState.stores.forEach(function (store) {
	        // if (storeIds.includes(store.id.toString())) {
	        if (storeIds.indexOf(store.id.toString()) >= 0) {
	          store.selected = true;
	        }
	      });
	    }
	  }, {
	    key: 'hideMenu',
	    value: function hideMenu(event) {
	      if (this.state.showMenu == false) {
	        return;
	      }
	      var dropdown_element = (0, _reactDom.findDOMNode)(this);
	
	      if (!dropdown_element.contains(event.target)) {
	        this.setState({
	          showMenu: false
	        });
	      }
	    }
	  }, {
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      this.setState({
	        showMenu: !this.state.showMenu
	      });
	    }
	  }, {
	    key: 'selectStore',
	    value: function selectStore(store, e) {
	      store.selected = !store.selected;
	      this.forceUpdate();
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = (0, _classnames2.default)('store-selector', { '-open': this.state.showMenu });
	
	      var allStores = this.props.appState.stores;
	      var currentStore = (0, _find2.default)(allStores, { id: parseInt(this.props.params.store_id) });
	      var storeTree = (0, _storeHelper.buildStoreTree)(allStores);
	
	      if (!(allStores && currentStore)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'current-store', onClick: this.toggleMenu.bind(this) },
	          _react2.default.createElement(_storeMenuItem2.default, { store: currentStore }),
	          _react2.default.createElement(
	            'div',
	            { className: 'selector' },
	            _react2.default.createElement(
	              'div',
	              { className: 'selector__toggle' },
	              _react2.default.createElement('i', { className: 'fa fa-angle-down actions-arrow' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'store-selector__dropdown' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dropdown__stores' },
	            storeTree.map(function (store) {
	              return _react2.default.createElement(
	                'div',
	                { key: store.id },
	                _react2.default.createElement(
	                  'div',
	                  { onClick: _this2.selectStore.bind(_this2, store), className: 'dropdown__store a' },
	                  _react2.default.createElement(_storeMenuItem2.default, _extends({}, _this2.props, { store: store }))
	                ),
	                store._children && store._children.map(function (store) {
	                  return _react2.default.createElement(
	                    'div',
	                    { onClick: _this2.selectStore.bind(_this2, store), className: 'dropdown__store -child a', key: store.id },
	                    _react2.default.createElement(_storeMenuItem2.default, _extends({}, _this2.props, { store: store }))
	                  );
	                })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dropdown__options' },
	            _react2.default.createElement(
	              'span',
	              { className: 'btn btn-sm btn-select', onClick: this.deselectAllStores },
	              'Deselect All'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'btn btn-sm btn-select', onClick: this.selectAllStores },
	              'Select All'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'btn btn-sm btn-apply', onClick: this.switchStore },
	              'Apply'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoreMenu;
	}(_react2.default.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	
	// var selectedMultiStore =
	//  <div className="store-selector__current" ng-click="startUpdatingCurrentStore()" ng-if="currentStores.length > 1">
	//    <img className="current__image" src="images/store_placeholder.png" placeholder-src="store" />
	//    <div className="current__details">
	//      <p className="details__title">{ 'currentStores.length' } Stores/Chains Selected</p>
	//    </div>
	//    <div className="current__selector">
	//      <div className="selector__toggle"><i className="fa fa-angle-down actions-arrow"></i></div>
	//    </div>
	//  </div>
	
	exports.default = StoreMenu;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1275);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _truncate = __webpack_require__(1580);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _storeThumbnail = __webpack_require__(803);
	
	var _storeThumbnail2 = _interopRequireDefault(_storeThumbnail);
	
	var _inputCheckbox = __webpack_require__(791);
	
	var _inputCheckbox2 = _interopRequireDefault(_inputCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StoreMenuItem(props) {
	  var store = props.store;
	
	
	  var hasChildren = store._children && store._children.length > 0;
	  var className = 'store-menu-item ' + props.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(_storeThumbnail2.default, { className: 'image', src: store.logo_url }),
	    _react2.default.createElement(
	      'div',
	      { className: 'details' },
	      _react2.default.createElement(
	        'div',
	        { className: 'left' },
	        _react2.default.createElement(
	          'p',
	          { className: 'details__title' },
	          (0, _truncate2.default)(store.title, { length: 40 })
	        ),
	        hasChildren ? _react2.default.createElement(
	          'p',
	          { className: 'details__address' },
	          'Chain with ',
	          store._children.length,
	          ' Stores'
	        ) : _react2.default.createElement(
	          'p',
	          { className: 'details__address' },
	          (0, _truncate2.default)(store.address1, { length: 40 })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'right' },
	        _react2.default.createElement(_inputCheckbox2.default, { wrapperClassName: 'store-checkbox', checked: store.selected || false })
	      )
	    )
	  );
	} /* eslint react/prop-types: 0 */
	
	exports.default = StoreMenuItem;
	
	// <div className="info__checkbox">
	//   <input-checkbox label="selected-store-{childStore.id }" ng-model="$root.updatedStores[childStore.id]"></input-checkbox>
	// </div>

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(91);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddLineItemStatus = (_temp = _class = function (_Modal) {
	  _inherits(AddLineItemStatus, _Modal);
	
	  function AddLineItemStatus() {
	    _classCallCheck(this, AddLineItemStatus);
	
	    return _possibleConstructorReturn(this, (AddLineItemStatus.__proto__ || Object.getPrototypeOf(AddLineItemStatus)).apply(this, arguments));
	  }
	
	  _createClass(AddLineItemStatus, [{
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          input = _props.input,
	          isCreating = _props.isCreating,
	          closeAddLineItemStatus = _props.closeAddLineItemStatus,
	          changeLineItemStatusInput = _props.changeLineItemStatusInput,
	          saveLineItemStatus = _props.saveLineItemStatus;
	
	
	      var title = isCreating ? 'New Line Item Status' : 'Update Line Item Status';
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: title }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(_inputBox2.default, { type: 'string',
	            value: input.value,
	            success: input.success,
	            failure: input.failure,
	            onChange: function onChange(e) {
	              return changeLineItemStatusInput(e.target.value);
	            } })
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: '_secondary',
	              onClick: closeAddLineItemStatus },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: '_primary',
	              onClick: saveLineItemStatus },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddLineItemStatus;
	}(_modal.Modal), _class.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  isCreating: _propTypes2.default.bool.isRequired,
	  input: _propTypes2.default.object.isRequired,
	  closeAddLineItemStatus: _propTypes2.default.func.isRequired,
	  changeLineItemStatusInput: _propTypes2.default.func.isRequired,
	  saveLineItemStatus: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = AddLineItemStatus;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _addLineItemStatus = __webpack_require__(873);
	
	var _addLineItemStatus2 = _interopRequireDefault(_addLineItemStatus);
	
	var _grid = __webpack_require__(66);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _addLineItemStatus3 = __webpack_require__(459);
	
	var addLineItemStatusActions = _interopRequireWildcard(_addLineItemStatus3);
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var entities = state.entities;
	
	  var lineItemStatuses = [];
	
	  if (entities.lineItemStatuses) {
	    lineItemStatuses = (0, _values2.default)(entities.lineItemStatuses);
	  }
	
	  return {
	    addLineItemStatusState: state.forms.addLineItemStatus,
	    lineItemStatuses: lineItemStatuses
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    addLineItemStatusActions: (0, _redux.bindActionCreators)(addLineItemStatusActions, dispatch),
	    removeLineItemStatus: (0, _redux.bindActionCreators)(_lineItemStatusAction.removeLineItemStatus, dispatch),
	    getLineItemStatuses: (0, _redux.bindActionCreators)(_lineItemStatusAction.getLineItemStatuses, dispatch)
	  };
	}
	
	var LineItemStatusSetUp = (_temp = _class = function (_Component) {
	  _inherits(LineItemStatusSetUp, _Component);
	
	  function LineItemStatusSetUp(props) {
	    _classCallCheck(this, LineItemStatusSetUp);
	
	    var _this = _possibleConstructorReturn(this, (LineItemStatusSetUp.__proto__ || Object.getPrototypeOf(LineItemStatusSetUp)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      loading: true
	    };
	    _this.gridActions = [{ name: 'Edit', onClick: function onClick(item) {
	        var store_id = _this.props.params.store_id;
	
	        _this.props.addLineItemStatusActions.openAddLineItemStatus({ storeId: store_id, initialValues: item, isCreating: false });
	      } }, { name: 'Remove', onClick: function onClick(item) {
	        if (!confirm('Do you really want to remove this item?')) return false;
	        var id = item.id,
	            store_id = item.store_id;
	
	        _this.props.removeLineItemStatus(id, store_id).then(function (resp) {
	          var error = resp.error;
	
	          if (error) {
	            alert('Remove item successfully.');
	          } else {
	            alert('Remove item failed.');
	          }
	        });
	      } }];
	
	    _this.columns = [{ columnName: 'status', displayName: 'TITLE' }, { columnName: 'created_at', displayName: 'CREATED AT', customComponent: _this.timeFormatter }];
	    return _this;
	  }
	
	  _createClass(LineItemStatusSetUp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var store_id = this.props.params.store_id;
	
	      this.props.getLineItemStatuses(store_id).then(function () {
	        _this2.setState({ loading: false }); //eslint-disable-line react/no-did-mount-set-state
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          addLineItemStatusState = _props.addLineItemStatusState,
	          addLineItemStatusActions = _props.addLineItemStatusActions,
	          lineItemStatuses = _props.lineItemStatuses;
	      var loading = this.state.loading;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(_addLineItemStatus2.default, _extends({}, addLineItemStatusState, addLineItemStatusActions)),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-tab' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link active' },
	                'Overview'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm',
	                onClick: function onClick() {},
	                type: 'submit' },
	              'Cancel'
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm',
	                onClick: this.handleCreate,
	                type: 'submit' },
	              'New Line Item Status'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section ' },
	          loading ? _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading...'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_grid.GridBody, { data: lineItemStatuses,
	              selectable: false,
	              actions: this.gridActions,
	              columns: this.columns })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LineItemStatusSetUp;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  lineItemStatuses: _propTypes2.default.array.isRequired,
	  addLineItemStatusState: _propTypes2.default.object.isRequired,
	
	  addLineItemStatusActions: _propTypes2.default.object.isRequired,
	  removeLineItemStatus: _propTypes2.default.func.isRequired,
	  getLineItemStatuses: _propTypes2.default.func.isRequired
	}, _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleCreate = function () {
	    var store_id = _this3.props.params.store_id;
	
	    _this3.props.addLineItemStatusActions.openAddLineItemStatus({ storeId: store_id, isCreating: true });
	  };
	
	  this.timeFormatter = function (props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    var timezine = _this3.context.currentStore && _this3.context.currentStore.timezone;
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatHelper.dateTime)(data, timezine)
	    );
	  };
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LineItemStatusSetUp);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(1277);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = (_temp = _class = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
	  }
	
	  _createClass(Login, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // clear cached store from maybe other account
	      this.props.actions.clearStore();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'login-layout' },
	        _react2.default.createElement(
	          'div',
	          { className: 'login-layout-main' },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'login-layout-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'copyright' },
	            _react2.default.createElement(
	              'p',
	              null,
	              '2016 Bindo Labs, Inc. All rights reserved.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Bindo is a registered trademark of Bindo Labs, Inc'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react2.default.Component), _class.propTypes = {
	  actions: _propTypes2.default.object.isRequired,
	  appState: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.element.isRequired
	}, _temp);
	exports.default = Login;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	__webpack_require__(1276);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginForm = (_temp = _class = function (_Component) {
	  _inherits(LoginForm, _Component);
	
	  function LoginForm() {
	    _classCallCheck(this, LoginForm);
	
	    return _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).apply(this, arguments));
	  }
	
	  _createClass(LoginForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$fields = _props.fields,
	          emailOrId = _props$fields.emailOrId,
	          password = _props$fields.password,
	          rememberMe = _props$fields.rememberMe,
	          handleSubmit = _props.handleSubmit;
	
	      var checkboxId = (0, _uniqueId2.default)();
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'signin-form', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: '_logo' },
	          _react2.default.createElement('img', { src: __webpack_require__(1309), alt: 'Logo' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '_form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'text', placeholder: 'Bindo ID / Email' }, emailOrId))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement('input', _extends({ className: 'form-control', type: 'password', placeholder: 'Password' }, password))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '_remember' },
	            _react2.default.createElement('input', _extends({ id: checkboxId, type: 'checkbox' }, rememberMe)),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: checkboxId, className: '_description' },
	              'Remember me for 7 days'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '_actions' },
	          _react2.default.createElement(
	            'a',
	            { className: '_forgot' },
	            'Forgot Password?'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm' },
	              'Sign Up'
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', type: 'submit' },
	              'Login'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoginForm;
	}(_react.Component), _class.propTypes = {
	  fields: _propTypes2.default.object.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired
	}, _temp);
	
	
	var loginForm = (0, _reduxForm.reduxForm)({
	  form: 'login',
	  fields: ['emailOrId', 'password', 'rememberMe']
	})(LoginForm);
	
	exports.default = loginForm;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint react/prop-types: 0 */
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loginForm = __webpack_require__(876);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginIndex = (_temp = _class = function (_Component) {
	  _inherits(LoginIndex, _Component);
	
	  function LoginIndex() {
	    _classCallCheck(this, LoginIndex);
	
	    return _possibleConstructorReturn(this, (LoginIndex.__proto__ || Object.getPrototypeOf(LoginIndex)).apply(this, arguments));
	  }
	
	  _createClass(LoginIndex, [{
	    key: 'handleLogin',
	    value: function handleLogin(loginData) {
	      this.props.actions.login(loginData.emailOrId, loginData.password);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_loginForm2.default, { onSubmit: this.handleLogin.bind(this) })
	      );
	    }
	  }]);
	
	  return LoginIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = LoginIndex;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexDatetime(props, context) {
	  var timezine = context.currentStore && context.currentStore.timezone;
	  var created_at = props.rowData.created_at;
	
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    (0, _formatHelper.dateTime)(created_at, timezine)
	  );
	}
	
	IndexDatetime.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexDatetime;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexName(props) {
	  var _props$rowData = props.rowData,
	      id = _props$rowData.id,
	      store_id = _props$rowData.store_id,
	      title = _props$rowData.title;
	
	  var path = '/v2/' + store_id + '/membership-levels/' + id;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { className: 'block-a', to: path },
	    title
	  );
	}
	
	IndexName.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexName;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _membershipLevelActions = __webpack_require__(183);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactRouter = __webpack_require__(9);
	
	var _dropDown = __webpack_require__(231);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _indexName = __webpack_require__(879);
	
	var _indexName2 = _interopRequireDefault(_indexName);
	
	var _indexDatetime = __webpack_require__(878);
	
	var _indexDatetime2 = _interopRequireDefault(_indexDatetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var pathname = ownProps.location.pathname;
	  var pathState = state.path[pathname];
	
	  var pageState = {};
	
	  var _loop = function _loop(prop) {
	    pageState[prop] = (0, _map2.default)(pathState[prop], function (key) {
	      return state.entities[prop][key];
	    });
	  };
	
	  for (var prop in pathState) {
	    _loop(prop);
	  }
	
	  return pageState;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  var actions = { getMembershipLevels: _membershipLevelActions.getMembershipLevels, removeMembershipLevel: _membershipLevelActions.removeMembershipLevel };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var MemberShipIndex = (_temp2 = _class = function (_Component) {
	  _inherits(MemberShipIndex, _Component);
	
	  function MemberShipIndex() {
	    var _ref;
	
	    var _temp, _this, _ret2;
	
	    _classCallCheck(this, MemberShipIndex);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret2 = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MemberShipIndex.__proto__ || Object.getPrototypeOf(MemberShipIndex)).call.apply(_ref, [this].concat(args))), _this), _this.deleteMembership = function (id) {
	      var store_id = _this.props.params.store_id;
	      var pathname = _this.props.location.pathname;
	      var removeMembershipLevel = _this.props.actions.removeMembershipLevel;
	
	
	      removeMembershipLevel(store_id, id, pathname);
	    }, _temp), _possibleConstructorReturn(_this, _ret2);
	  }
	
	  _createClass(MemberShipIndex, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var store_id = this.props.params.store_id;
	      var pathname = this.props.location.pathname;
	      var getMembershipLevels = this.props.actions.getMembershipLevels;
	
	
	      getMembershipLevels(store_id, pathname);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var store_id = this.props.params.store_id;
	      var membership_level = this.props.membership_level;
	
	      var path = '/v2/' + store_id + '/membership-levels/new';
	      var deleteMembership = this.deleteMembership;
	      var noDataMessage = 'There is no membership level data';
	
	      var LinkComponent = function LinkComponent(props) {
	        /* eslint-disable react/prop-types */
	        var id = props.rowData.id;
	        /* eslint-enable react/prop-types */
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _dropDown2.default,
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: deleteMembership.bind(null, id), className: 'dropdown-item text-danger a' },
	              'Delete'
	            )
	          )
	        );
	      };
	      LinkComponent.propTypes = {
	        rowData: _propTypes2.default.shape({
	          id: _propTypes2.default.any.isRequired
	        })
	      };
	
	      // Voucher list settings
	      var columnMetadatas = [{
	        columnName: "title",
	        displayName: "Title",
	        customComponent: _indexName2.default
	      }, {
	        columnName: "created_at",
	        displayName: "CREATED AT",
	        customComponent: _indexDatetime2.default
	      }, {
	        columnName: "",
	        displayName: "",
	        customComponent: LinkComponent
	      }];
	
	      // Columns for grid display
	      var columns = columnMetadatas.map(function (i) {
	        return i.columnName;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Membership Level'
	          ),
	          _react2.default.createElement(
	            _can2.default,
	            { action: 'voucher:create' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: path, className: 'btn btn-primary btn-sm' },
	              'New Membership Level'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          !membership_level ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_griddleReact2.default, {
	            useGriddleStyles: false,
	            tableClassName: 'table table-bordered data-table',
	            results: membership_level,
	            noDataMessage: noDataMessage,
	            columns: columns,
	            resultsPerPage: '100',
	            columnMetadata: columnMetadatas })
	        )
	      );
	    }
	  }]);
	
	  return MemberShipIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  membership_level: _propTypes2.default.arrayOf(_propTypes2.default.object)
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MemberShipIndex);

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _membershipLevelActions = __webpack_require__(183);
	
	var _itemForm = __webpack_require__(488);
	
	var _itemForm2 = _interopRequireDefault(_itemForm);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var membership_level = state.entities.membership_level;
	  var membership_id = ownProps.params.membership_id;
	
	
	  var membership = membership_level && membership_level[membership_id];
	
	  return {
	    membership: membership,
	    params: ownProps.params
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getMembershipLevel: _membershipLevelActions.getMembershipLevel, updateMembershipLevel: _membershipLevelActions.updateMembershipLevel };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherOverviewShow = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherOverviewShow, _Component);
	
	  function VoucherOverviewShow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherOverviewShow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherOverviewShow.__proto__ || Object.getPrototypeOf(VoucherOverviewShow)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
	      var _this$props$params = _this.props.params,
	          store_id = _this$props$params.store_id,
	          membership_id = _this$props$params.membership_id;
	      var updateMembershipLevel = _this.props.actions.updateMembershipLevel;
	
	
	      var pathname = '/v2/' + store_id + '/membership-levels';
	
	      updateMembershipLevel(store_id, membership_id, { membership_level: data }, pathname).then(function (data) {
	        var showPath = '/v2/' + store_id + '/membership-levels';
	        _this.context.router.push(showPath);
	      });
	    }, _this.handleSubmit = function () {
	      _this.refs.MembershipForm.submit();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherOverviewShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          membership_id = _props$params.membership_id;
	      var getMembershipLevel = this.props.actions.getMembershipLevel;
	
	
	      getMembershipLevel(store_id, membership_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var membership = this.props.membership || {};
	
	      if (!membership) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Membership'
	        );
	      } else {
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Membership Level'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(_itemForm2.default, { ref: 'MembershipForm', initialValues: membership, onSubmit: this.onSubmit })
	          )
	        );
	      }
	    }
	  }]);
	
	  return VoucherOverviewShow;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    membership_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  membership: _propTypes2.default.object,
	  actions: _propTypes2.default.object
	}, _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherOverviewShow);

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _membershipLevelActions = __webpack_require__(183);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var membership_level = state.entities.membership_level;
	  var membership_id = ownProps.params.membership_id;
	
	
	  var membership = membership_level && membership_level[membership_id];
	
	  return {
	    membership: membership,
	    params: ownProps.params
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getMembershipLevel: _membershipLevelActions.getMembershipLevel };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherOverviewShow = (_temp = _class = function (_Component) {
	  _inherits(VoucherOverviewShow, _Component);
	
	  function VoucherOverviewShow() {
	    _classCallCheck(this, VoucherOverviewShow);
	
	    return _possibleConstructorReturn(this, (VoucherOverviewShow.__proto__ || Object.getPrototypeOf(VoucherOverviewShow)).apply(this, arguments));
	  }
	
	  _createClass(VoucherOverviewShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          membership_id = _props$params.membership_id;
	      var getMembershipLevel = this.props.actions.getMembershipLevel;
	
	
	      getMembershipLevel(store_id, membership_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$params2 = this.props.params,
	          store_id = _props$params2.store_id,
	          membership_id = _props$params2.membership_id;
	
	      var editPath = '/v2/' + store_id + '/membership-levels/' + membership_id + '/overview/edit';
	
	      var membership = this.props.membership || {};
	
	      if (!membership) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Membership'
	        );
	      } else {
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Membership Level'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: editPath, className: 'btn btn-primary btn-sm' },
	                'Edit'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'TITLE'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    membership.title
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'NOTE'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    membership.note
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return VoucherOverviewShow;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    membership_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  membership: _propTypes2.default.object,
	  actions: _propTypes2.default.shape({
	    getMembershipLevel: _propTypes2.default.func.isRequired
	  }).isRequired
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherOverviewShow);

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MembershipItem = (_temp = _class = function (_Component) {
	  _inherits(MembershipItem, _Component);
	
	  function MembershipItem() {
	    _classCallCheck(this, MembershipItem);
	
	    return _possibleConstructorReturn(this, (MembershipItem.__proto__ || Object.getPrototypeOf(MembershipItem)).apply(this, arguments));
	  }
	
	  _createClass(MembershipItem, [{
	    key: 'render',
	    value: function render() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          membership_id = _props$params.membership_id;
	
	      var path = '/v2/' + store_id + '/membership-levels/' + membership_id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-tab' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path + '/overview', className: 'nav-link', activeClassName: 'active' },
	                'Overview'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path + '/customers', className: 'nav-link', activeClassName: 'active' },
	                'Customers'
	              )
	            )
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return MembershipItem;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    membership_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  children: _propTypes2.default.element.isRequired,
	  actions: _propTypes2.default.object
	}, _temp);
	exports.default = MembershipItem;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _membershipLevelActions = __webpack_require__(183);
	
	var _itemForm = __webpack_require__(488);
	
	var _itemForm2 = _interopRequireDefault(_itemForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { createMembershipLevel: _membershipLevelActions.createMembershipLevel };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var MembershipLevelNew = (_temp2 = _class = function (_Component) {
	  _inherits(MembershipLevelNew, _Component);
	
	  function MembershipLevelNew() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MembershipLevelNew);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MembershipLevelNew.__proto__ || Object.getPrototypeOf(MembershipLevelNew)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
	      var store_id = _this.props.params.store_id;
	      var createMembershipLevel = _this.props.actions.createMembershipLevel;
	
	
	      var pathname = '/v2/' + store_id + '/membership-levels';
	
	      createMembershipLevel(store_id, { membership_level: data }, pathname).then(function (data) {
	        var showPath = '/v2/' + store_id + '/membership-levels';
	        _this.context.router.push(showPath);
	      });
	    }, _this.handleSubmit = function () {
	      _this.refs.MembershipForm.submit();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MembershipLevelNew, [{
	    key: 'render',
	    value: function render() {
	      var store_id = this.props.params.store_id;
	
	      var backPath = '/v2/' + store_id + '/membership-levels';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Create New Membership Level'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: backPath, className: 'btn btn-secondary btn-sm' },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(_itemForm2.default, { ref: 'MembershipForm', onSubmit: this.onSubmit })
	        )
	      );
	    }
	  }]);
	
	  return MembershipLevelNew;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MembershipLevelNew);

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _grid = __webpack_require__(66);
	
	var _cloneDeep = __webpack_require__(279);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _lodash = __webpack_require__(14);
	
	var _griddleComponents = __webpack_require__(121);
	
	var _permissionHelper = __webpack_require__(92);
	
	var _productionOrderIndex = __webpack_require__(466);
	
	var actions = _interopRequireWildcard(_productionOrderIndex);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProp(state) {
	  var pageState = state.pages.productionOrderIndex;
	
	  return _extends({}, pageState);
	}
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var ProductionOrderIndex = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (0, _griddleComponents.capitalizeFirstLetterComponent)(_class = (0, _griddleComponents.statusComponent)(_class = (0, _griddleComponents.timeComponent)(_class = (0, _griddleComponents.linkComponent)(_class = (0, _permissionHelper.getCurrentPermission)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProductionOrderIndex, _Component);
	
	  function ProductionOrderIndex(props) {
	    _classCallCheck(this, ProductionOrderIndex);
	
	    var _this = _possibleConstructorReturn(this, (ProductionOrderIndex.__proto__ || Object.getPrototypeOf(ProductionOrderIndex)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var store_id = _this.props.params.store_id;
	
	
	    _this.columnMetadatas = [{
	      columnName: "store",
	      displayName: "STORE",
	      customComponent: function customComponent() {
	        var currentStore = _this.context.currentStore;
	        var title = currentStore.title;
	
	        return _react2.default.createElement(
	          'span',
	          null,
	          title
	        );
	      },
	      customComponentProps: {
	        pathAccessor: function pathAccessor(item) {
	          return _routeHelper2.default.productionOrders(store_id, item.id);
	        }
	      }
	    }, {
	      columnName: "number",
	      displayName: "ORDER NUMBER",
	      filterConditions: ['equal'],
	      customComponent: _this.linkComponent
	    }, {
	      columnName: "humanizedType",
	      displayName: "ORDER TYPE",
	      customComponent: _this.capitalizeFirstLetterComponent
	    }, {
	      columnName: "createdAt",
	      displayName: "CREATED AT",
	      customComponent: _this.timeComponent
	    }, {
	      columnName: "state",
	      displayName: "STATUS",
	      customComponent: _this.statusComponent('order')
	    }];
	
	    _this.filterSettings = _this.columnMetadatas.filter(function (col) {
	      return col.hasOwnProperty('filterConditions');
	    }).map(function (column) {
	      return (0, _lodash.pick)(column, 'columnName', 'displayName', 'filterConditions');
	    });
	    return _this;
	  }
	
	  _createClass(ProductionOrderIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var _props$location$query = this.props.location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	
	      this.props.actions.load(store_id, page, count, undefined, filters);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          totalEntries = _props.totalEntries,
	          isLoading = _props.isLoading,
	          rowsPerPage = _props.rowsPerPage,
	          currentPage = _props.currentPage,
	          totalPages = _props.totalPages;
	
	
	      var createPermission = this.getCurrentPermission('production_order:create');
	      var approvalPermission = this.getCurrentPermission('production_order:approval');
	      var cancelPermission = this.getCurrentPermission('production_order:cancel');
	      var viewPermission = this.getCurrentPermission('production_order:view');
	      var _props2 = this.props,
	          data = _props2.data,
	          filters = _props2.filters;
	
	      var gridActions = [{
	        name: 'View',
	        hide: function hide() {
	          return !viewPermission;
	        },
	        onClick: function onClick(item) {
	          var id = item.id;
	          var store_id = _this2.props.params.store_id;
	
	          _routeHelper2.default.goProductionOrders(store_id, id);
	        }
	      }, {
	        name: 'Approve',
	        hide: function hide(item) {
	          return !(approvalPermission && item.state === 'created');
	        },
	        onClick: function onClick(item) {
	          var id = item.id;
	
	          _this2.props.actions.approve(id);
	        }
	      }, {
	        name: 'Cancel',
	        // hide: (item) => !cancelPermission || ['fulfilled', 'canceled'].includes(item.state),
	        hide: function hide(item) {
	          return !cancelPermission || ['fulfilled', 'canceled'].indexOf(item.state) >= 0;
	        },
	        onClick: function onClick(item) {
	          if (!confirm('Do you really want to cancel this order?')) return false;
	          var id = item.id;
	
	          _this2.props.actions.cancel(id);
	        }
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 1, overflowY: "scroll", height: "100%" } },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	            createPermission && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: this.handleCreate },
	              'New'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content -main-filter' },
	            _react2.default.createElement(_cascadeFilterCollection2.default, {
	              group: 'stations',
	              settings: this.filterSettings,
	              filters: filters,
	              onSearch: this.handleSearch
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content' },
	            _react2.default.createElement(
	              'div',
	              null,
	              isLoading ? _react2.default.createElement(
	                _loading2.default,
	                null,
	                'Loading...'
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'grid' },
	                _react2.default.createElement(_grid.GridBody, { data: (0, _cloneDeep2.default)(data),
	                  actions: gridActions,
	                  columns: this.columnMetadatas }),
	                _react2.default.createElement(_grid.GridFooter, { totalEntries: totalEntries,
	                  rowsPerPage: rowsPerPage,
	                  currentPage: currentPage,
	                  totalPages: totalPages,
	                  goToPage: this.goToPage,
	                  updateRowsPerPage: this.updateRowsPerPage })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductionOrderIndex;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  totalEntries: _propTypes2.default.number.isRequired,
	  rowsPerPage: _propTypes2.default.number.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalPages: _propTypes2.default.number.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  filters: _propTypes2.default.array.isRequired
	}, _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleCreate = function () {
	    var store_id = _this3.props.params.store_id;
	
	    _routeHelper2.default.goProductionOrders(store_id, 'new');
	  };
	
	  this.handleSearch = function (filters) {
	    var store_id = _this3.props.params.store_id;
	    var _props$location$query2 = _this3.props.location.query,
	        count = _props$location$query2.count,
	        page = _props$location$query2.page;
	
	    var filterString = _filterHelper2.default.filtersToString(filters);
	
	    _this3.context.router.push({
	      pathname: _routeHelper2.default.productionOrders(store_id),
	      query: {
	        page: page,
	        count: count,
	        filters: filterString
	      }
	    });
	    _this3.props.actions.changeFilters(filters);
	  };
	
	  this.goToPage = function (page) {
	    var store_id = _this3.props.params.store_id;
	    var _props$location$query3 = _this3.props.location.query,
	        count = _props$location$query3.count,
	        filters = _props$location$query3.filters;
	
	    var filterString = _filterHelper2.default.filtersToString(filters);
	
	    _this3.context.router.push({
	      pathname: _routeHelper2.default.productionOrders(store_id),
	      query: {
	        page: page,
	        count: count,
	        filters: filterString
	      }
	    });
	    _this3.props.actions.changePage(page);
	  };
	
	  this.updateRowsPerPage = function (val) {
	    var store_id = _this3.props.params.store_id;
	    var filters = _this3.props.location.query.filters;
	
	    var filterString = _filterHelper2.default.filtersToString(filters);
	
	    _this3.context.router.push({
	      pathname: _routeHelper2.default.productionOrders(store_id),
	      query: {
	        page: 1,
	        count: val,
	        filters: filterString
	      }
	    });
	    _this3.props.actions.changeRowsPerPage(val);
	  };
	}, _temp)) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = ProductionOrderIndex;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProp(state) {
	  var formState = state.forms.productionOrderItem;
	  return _extends({}, formState);
	}
	
	var ProductionOrderItemMaterialList = (_dec = (0, _reactRedux.connect)(mapStateToProp, function () {
	  return {};
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProductionOrderItemMaterialList, _Component);
	
	  function ProductionOrderItemMaterialList(props) {
	    _classCallCheck(this, ProductionOrderItemMaterialList);
	
	    var _this = _possibleConstructorReturn(this, (ProductionOrderItemMaterialList.__proto__ || Object.getPrototypeOf(ProductionOrderItemMaterialList)).call(this, props));
	
	    _this.toggleItem = function (index) {
	      _this.setState({ collased: (0, _lodash.xor)(_this.state.collased, [index]) });
	    };
	
	    _this.flattenDeep = function (orderItems) {
	      var items = (0, _lodash.cloneDeep)(orderItems);
	      items.forEach(function (i) {
	        i.children = i.productionOrderItemMaterials.slice();
	        i.materialBomType = 0;
	        i.showCaret = Array.isArray(i.children) && i.children.length > 0;
	      });
	      var flattened = _this.flatternMaterials(items, 0);
	      return flattened.map(function (i) {
	        return (0, _lodash.omit)(i, ['productionOrderItemMaterials', 'children']);
	      });
	    };
	
	    _this.flatternMaterials = function (items, level) {
	      var ret = [];
	      items.forEach(function (i) {
	        i.level = level;
	        i.showCaret = Array.isArray(i.children) && i.children.length > 0;
	        var collasped = _this.state.collased.indexOf(i.uuid) > -1;
	        ret.push(i);
	        if (!collasped && i.showCaret) {
	          var flattened = _this.flatternMaterials(i.children, level + 1);
	          ret = ret.concat(flattened);
	        }
	      });
	      return ret;
	    };
	
	    _this.state = {
	      collased: []
	    };
	    return _this;
	  }
	
	  _createClass(ProductionOrderItemMaterialList, [{
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      var _props$productionOrde = this.props.productionOrderItems,
	          productionOrderItems = _props$productionOrde === undefined ? [] : _props$productionOrde;
	      var collased = this.state.collased;
	
	
	      var flattenData = this.flattenDeep(productionOrderItems);
	
	      return _react2.default.createElement(
	        'table',
	        { className: 'table offset-table data-table--no-border data-table--primary-link' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              'MATERIAL'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'PLU/SKU'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'UPC/EAN'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'TYPE'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'PLANNED QTY'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'PROCESSED QTY'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'UNIT'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'CURRENT QTY'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'UNIT COST'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          flattenData.length > 0 && flattenData.map(function (d, i) {
	            var level = d.level,
	                name = d.name,
	                uuid = d.uuid,
	                showCaret = d.showCaret;
	
	
	            var caretDown = collased.indexOf(uuid) == -1;
	            return _react2.default.createElement(
	              'tr',
	              { key: i },
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginLeft: level * 25 } },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    showCaret && _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return _this2.toggleItem(uuid);
	                        } },
	                      _react2.default.createElement('i', { className: (0, _classnames2.default)('fa', {
	                          'fa-caret-down': caretDown,
	                          'fa-caret-up': !caretDown
	                        }) })
	                    ),
	                    name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.ean13
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.listingBarcode
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.trackQuantity === 1 ? 'Non Inventory Item' : 'Inventory Item'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.quantityInDisplayUnit
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.qtyFulfilledInDisplayUnit
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.baseUnit
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                (d.listingQuantity / d.unitRatio).toFixed(4)
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                d.cost && d.cost.length > 0 ? Number(d.cost).toFixed(4) : d.cost
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isLoading = this.props.isLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' })
	        ),
	        isLoading && _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading...'
	          )
	        ),
	        !isLoading && this.renderTable()
	      );
	    }
	  }]);
	
	  return ProductionOrderItemMaterialList;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  productionOrderItems: _propTypes2.default.array.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired
	}, _temp)) || _class);
	exports.default = ProductionOrderItemMaterialList;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(9);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _productionOrderItem = __webpack_require__(224);
	
	var actions = _interopRequireWildcard(_productionOrderItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProp(state) {
	  var isLoading = state.forms.productionOrderItem.isLoading;
	
	  return { isLoading: isLoading };
	}
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var ProductionOrderItem = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProductionOrderItem, _Component);
	
	  function ProductionOrderItem() {
	    _classCallCheck(this, ProductionOrderItem);
	
	    return _possibleConstructorReturn(this, (ProductionOrderItem.__proto__ || Object.getPrototypeOf(ProductionOrderItem)).apply(this, arguments));
	  }
	
	  _createClass(ProductionOrderItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          production_order_id = _props$params.production_order_id;
	
	      this.props.actions.open(production_order_id, store_id);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$params2 = this.props.params,
	          store_id = _props$params2.store_id,
	          production_order_id = _props$params2.production_order_id;
	
	      var path = _routeHelper2.default.productionOrders(store_id, production_order_id);
	
	      var style = {};
	      if (location.pathname.indexOf('material-list') > -1) {
	        // only use transparent bg color in material list, for the table
	        style.backgroundColor = 'transparent';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content', style: style },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-tab' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'nav nav-tabs' },
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: path + '/overview', className: 'nav-link', activeClassName: 'active' },
	                  'Overview'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: path + '/material-list', className: 'nav-link', activeClassName: 'active' },
	                  'Material List'
	                )
	              )
	            )
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ProductionOrderItem;
	}(_react.Component), _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class2.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.element.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = ProductionOrderItem;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _itemOverview = __webpack_require__(489);
	
	var _itemOverview2 = _interopRequireDefault(_itemOverview);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _permissionHelper = __webpack_require__(92);
	
	var _productionOrderItem = __webpack_require__(224);
	
	var actions = _interopRequireWildcard(_productionOrderItem);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapDispatchToProp(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var ProductionOrderNewItem = (_dec = (0, _reactRedux.connect)(function () {
	  return {};
	}, mapDispatchToProp), _dec(_class = (0, _permissionHelper.getCurrentPermission)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProductionOrderNewItem, _Component);
	
	  function ProductionOrderNewItem() {
	    _classCallCheck(this, ProductionOrderNewItem);
	
	    return _possibleConstructorReturn(this, (ProductionOrderNewItem.__proto__ || Object.getPrototypeOf(ProductionOrderNewItem)).apply(this, arguments));
	  }
	
	  _createClass(ProductionOrderNewItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var createPermission = this.getCurrentPermission('production_order:create');
	      var store_id = this.props.params.store_id;
	
	      if (!createPermission) {
	        _routeHelper2.default.goProductionOrders(store_id);
	      } else {
	        this.props.actions.open(undefined, store_id);
	      }
	    }
	  }, {
	    key: 'getChildContextType',
	    value: function getChildContextType() {
	      return {
	        router: this.context.router,
	        currentStore: this.context.currentStore
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(_itemOverview2.default, { params: this.props.params })
	      );
	    }
	  }]);
	
	  return ProductionOrderNewItem;
	}(_react.Component), _class2.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _class2.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class) || _class);
	exports.default = ProductionOrderNewItem;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _baseSelectors = __webpack_require__(240);
	
	var baseSelectors = _interopRequireWildcard(_baseSelectors);
	
	var _promoCodeSelectors = __webpack_require__(322);
	
	var promoCodeSelectors = _interopRequireWildcard(_promoCodeSelectors);
	
	var _promoCodeActions = __webpack_require__(152);
	
	var promoCodeActions = _interopRequireWildcard(_promoCodeActions);
	
	var _mainContent = __webpack_require__(93);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	var _selectDiscount = __webpack_require__(796);
	
	var _selectDiscount2 = _interopRequireDefault(_selectDiscount);
	
	var _date = __webpack_require__(230);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  return {
	    loading: baseSelectors.getLoading(state),
	    pathInfo: promoCodeSelectors.getPathInfo(state),
	    data: promoCodeSelectors.getItem(state),
	    discountDetail: promoCodeSelectors.getDiscountDetail(state),
	    readOnly: promoCodeSelectors.getReadOnlyConfig(state)
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, promoCodeActions);
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	};
	
	var PromoCodeOverview = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PromoCodeOverview, _Component);
	
	  function PromoCodeOverview(props) {
	    _classCallCheck(this, PromoCodeOverview);
	
	    var _this = _possibleConstructorReturn(this, (PromoCodeOverview.__proto__ || Object.getPrototypeOf(PromoCodeOverview)).call(this, props));
	
	    _this.handleFieldChange = function (field, value) {
	      _this.props.updatePromoCodeField(field, value);
	    };
	
	    _this.state = { url: "" };
	    return _this;
	  }
	
	  _createClass(PromoCodeOverview, [{
	    key: 'handleImageChange',
	    value: function handleImageChange(e) {
	      var url = URL.createObjectURL(e.target.files[0]);
	      this.setState({ url: url });
	      this.props.updatePromoCodeField("image", e.target.files[0]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.props;
	      var _props$data = props.data,
	          data = _props$data === undefined ? {} : _props$data,
	          _props$readOnly = props.readOnly,
	          readOnly = _props$readOnly === undefined ? {} : _props$readOnly;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _mainContent.MainContentSection,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Promotion Code',
	                className: 'col-xs-6',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement('input', {
	                className: 'form-control',
	                value: data.code,
	                onChange: function onChange(event) {
	                  return _this2.handleFieldChange('code', event.target.value);
	                },
	                readOnly: readOnly.code
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Description',
	                className: 'col-xs-6',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement('textarea', {
	                className: 'form-control',
	                value: data.description,
	                onChange: function onChange(event) {
	                  return _this2.handleFieldChange('description', event.target.value);
	                },
	                readOnly: readOnly.description
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Individual User Quota',
	                className: 'col-xs-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_inputNumber2.default, {
	                className: 'form-control',
	                value: data.userQuota ? data.userQuota : '',
	                dp: 0,
	                onChange: function onChange(value) {
	                  return _this2.handleFieldChange('userQuota', value);
	                },
	                readOnly: readOnly.userQuota,
	                placeholder: '1'
	              })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Total Quota',
	                className: 'col-xs-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_inputNumber2.default, {
	                className: 'form-control',
	                value: data.totalQuota ? data.totalQuota : '',
	                dp: 0,
	                onChange: function onChange(value) {
	                  return _this2.handleFieldChange('totalQuota', value);
	                },
	                readOnly: readOnly.totalQuota,
	                placeholder: 'Unlimited'
	              })
	            ),
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Used Quota',
	                className: 'col-xs-3',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_inputNumber2.default, {
	                className: 'form-control',
	                value: data.usedQuota ? data.usedQuota : 0,
	                dp: 0,
	                onChange: function onChange(value) {
	                  return _this2.handleFieldChange('usedQuota', value);
	                },
	                readOnly: readOnly.usedQuota
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Expiration Date',
	                className: 'col-xs-6',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_date.DateField, {
	                className: 'form-control',
	                value: data.expired_at,
	                onChange: function onChange(event) {
	                  return _this2.handleFieldChange('expired_at', event.target.value);
	                },
	                readOnly: readOnly.expired_at
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _mainContent.MainContentSection,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Discount',
	                className: 'col-xs-6',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(_selectDiscount2.default, {
	                inputClassName: 'form-control',
	                value: data.discount,
	                onConfirm: function onConfirm(discount) {
	                  return _this2.handleFieldChange('discount', discount);
	                },
	                readOnly: readOnly.discount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              {
	                label: 'Image',
	                className: 'col-xs-6',
	                autoHideHelpText: true
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('input', { type: 'file', onChange: function onChange(e) {
	                    return _this2.handleImageChange(e);
	                  } })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('img', {
	                  src: data.image_url ? data.image_url : this.state.url,
	                  accept: '.jpg, .jpeg, .png',
	                  style: { width: 100, height: 100, paddingTop: 10 }
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PromoCodeOverview;
	}(_react.Component), _class2.propTypes = {
	  updatePromoCodeField: _propTypes2.default.func.isRequired
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = PromoCodeOverview;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _gridSelectors = __webpack_require__(951);
	
	var gridSelectors = _interopRequireWildcard(_gridSelectors);
	
	var _promoCodeSelectors = __webpack_require__(322);
	
	var promoCodeSelectors = _interopRequireWildcard(_promoCodeSelectors);
	
	var _promoCodeActions = __webpack_require__(152);
	
	var promoCodeActions = _interopRequireWildcard(_promoCodeActions);
	
	var _mainContent = __webpack_require__(93);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _grid = __webpack_require__(66);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  var gridMeta = gridSelectors.getMeta(state, props);
	  var gridMeta2 = promoCodeSelectors.getGridMeta(state, props);
	  return _extends({}, gridMeta, gridMeta2, {
	    promoCodes: promoCodeSelectors.getPromoCodes(state)
	  });
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  var actions = _extends({}, promoCodeActions);
	  return (0, _redux.bindActionCreators)(actions, dispatch);
	};
	
	var PromoCodeList = (_dec = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PromoCodeList, _Component);
	
	  function PromoCodeList() {
	    _classCallCheck(this, PromoCodeList);
	
	    return _possibleConstructorReturn(this, (PromoCodeList.__proto__ || Object.getPrototypeOf(PromoCodeList)).apply(this, arguments));
	  }
	
	  _createClass(PromoCodeList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.refreshData(this.props);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevPathKey = prevProps.location.pathname + prevProps.location.search;
	      var pathKey = this.props.location.pathname + this.props.location.search;
	      if (prevPathKey !== pathKey) {
	        this.refreshData(this.props);
	      }
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData(props) {
	      var store_id = props.params.store_id,
	          _props$location$query = props.location.query,
	          per_page = _props$location$query.per_page,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	      this.props.loadPromoCodeList(store_id, page, per_page, filtersObject);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props,
	          context = this.context;
	      var promoCodes = props.promoCodes,
	          currentPage = props.currentPage,
	          rowsPerPage = props.rowsPerPage,
	          filters = props.filters,
	          totalEntries = props.totalEntries,
	          totalPages = props.totalPages;
	
	      var storeId = (0, _lodash.get)(context, 'currentStore.id');
	      var data = promoCodes.map(function (_ref) {
	        var id = _ref.id,
	            code = _ref.code,
	            discount = _ref.discount,
	            userQuota = _ref.individual_user_quota,
	            totalQuota = _ref.total_quota,
	            usedQuota = _ref.used_quota;
	        return {
	          id: id,
	          code: code,
	          discount: discount.name,
	          userQuota: userQuota ? userQuota : 'Unlimited',
	          totalQuota: totalQuota ? totalQuota : 'Unlimited',
	          usedQuota: usedQuota
	        };
	      });
	      var columns = [{
	        columnName: "code",
	        displayName: "Promotion Code",
	        filterConditions: ['contain', 'equal']
	      }, {
	        columnName: "discount",
	        displayName: "Discount",
	        filterConditions: ['equal']
	      }, {
	        columnName: "userQuota",
	        displayName: "Individual User Quota",
	        filterConditions: ['contain', 'equal', 'between']
	      }, {
	        columnName: "totalQuota",
	        displayName: "Total Quota",
	        filterConditions: ['contain', 'equal', 'between']
	      }, {
	        columnName: "usedQuota",
	        displayName: "Used Quota"
	      }];
	      var filterSettings = _filterHelper2.default.getFilterSettings(columns);
	      var basePath = _routeHelper2.default.promoCodes(storeId);
	      var handleSearch = _filterHelper2.default.onSearchFactory(basePath, rowsPerPage);
	      var goToPage = _filterHelper2.default.goToPageFactory(basePath, rowsPerPage, filters);
	      var updateRowsPerPage = _filterHelper2.default.updateRowsPerPageFactory(basePath, filters);
	      var btnConfig = [{
	        content: 'New Promotion Code',
	        link: _routeHelper2.default.promoCodes(storeId, 'new'),
	        permission: null, // TODO: add permission checking
	        btnType: 'primary'
	      }];
	      var actions = [{
	        name: 'Edit',
	        onClick: function onClick(promoCode) {
	          _routeHelper2.default.goPromoCodes(storeId, promoCode.id);
	        }
	      }];
	      var bodyConfig = { data: data, columns: columns, actions: actions };
	      var footerConfig = {
	        currentPage: currentPage,
	        rowsPerPage: rowsPerPage,
	        totalEntries: totalEntries,
	        totalPages: totalPages,
	        goToPage: goToPage,
	        updateRowsPerPage: updateRowsPerPage
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _mainContent.MainContent,
	          { className: '-main-filter' },
	          _react2.default.createElement(_cascadeFilterCollection2.default, {
	            group: 'delivery_orders',
	            settings: filterSettings,
	            filters: filters,
	            onSearch: handleSearch
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bp' },
	          _react2.default.createElement(
	            _mainContent.MainContent,
	            null,
	            _react2.default.createElement(
	              _mainContent.MainContentHeader,
	              { title: 'Promotion Codes' },
	              _react2.default.createElement(_mainContent.MainContentHeaderButtons, { config: btnConfig })
	            ),
	            _react2.default.createElement(_grid.Grid, { bodyConfig: bodyConfig, footerConfig: footerConfig })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PromoCodeList;
	}(_react.Component), _class2.propTypes = {
	  currentPage: _propTypes2.default.number,
	  rowsPerPage: _propTypes2.default.number,
	  filters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    column: _propTypes2.default.string.isRequired,
	    condition: _propTypes2.default.string.isRequired,
	    conditionValue: _propTypes2.default.any,
	    conditionFrom: _propTypes2.default.any,
	    conditionTo: _propTypes2.default.any
	  })),
	  totalEntries: _propTypes2.default.number,
	  totalPages: _propTypes2.default.number,
	  location: _propTypes2.default.object,
	  loadPromoCodeList: _propTypes2.default.func.isRequired
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = PromoCodeList;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _redux = __webpack_require__(5);
	
	var _constants = __webpack_require__(26);
	
	var _baseSelectors = __webpack_require__(240);
	
	var baseSelectors = _interopRequireWildcard(_baseSelectors);
	
	var _layout = __webpack_require__(490);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _promoCodeActions = __webpack_require__(152);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoCodeItem = (_temp = _class = function (_React$Component) {
	  _inherits(PromoCodeItem, _React$Component);
	
	  function PromoCodeItem() {
	    _classCallCheck(this, PromoCodeItem);
	
	    return _possibleConstructorReturn(this, (PromoCodeItem.__proto__ || Object.getPrototypeOf(PromoCodeItem)).apply(this, arguments));
	  }
	
	  _createClass(PromoCodeItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          storeId = _props.storeId,
	          promoCodeId = _props.promoCodeId,
	          loadPromoCodeItem = _props.loadPromoCodeItem;
	
	      loadPromoCodeItem(storeId, promoCodeId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var p = (0, _lodash.pick)(this.props, ['mode', 'storeId', 'promoCodeId']);
	      return _react2.default.createElement(_layout2.default, p);
	    }
	  }]);
	
	  return PromoCodeItem;
	}(_react2.default.Component), _class.propTypes = {
	  storeId: _propTypes2.default.number,
	  promoCodeId: _propTypes2.default.number,
	  loadPromoCodeItem: _propTypes2.default.func
	}, _temp);
	
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  var params = baseSelectors.getParams(state, props);
	  return {
	    mode: _constants.PROMO_CODE.MODE.VIEW,
	    storeId: (0, _lodash.get)(params, 'store_id'),
	    promoCodeId: (0, _lodash.get)(params, 'promo_code_id')
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    loadPromoCodeItem: _promoCodeActions.loadPromoCodeItem
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp)(PromoCodeItem);

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(14);
	
	var _redux = __webpack_require__(5);
	
	var _constants = __webpack_require__(26);
	
	var _baseSelectors = __webpack_require__(240);
	
	var baseSelectors = _interopRequireWildcard(_baseSelectors);
	
	var _layout = __webpack_require__(490);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _promoCodeHelper = __webpack_require__(479);
	
	var _promoCodeActions = __webpack_require__(152);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoCodeNewItem = (_temp = _class = function (_React$Component) {
	  _inherits(PromoCodeNewItem, _React$Component);
	
	  function PromoCodeNewItem() {
	    _classCallCheck(this, PromoCodeNewItem);
	
	    return _possibleConstructorReturn(this, (PromoCodeNewItem.__proto__ || Object.getPrototypeOf(PromoCodeNewItem)).apply(this, arguments));
	  }
	
	  _createClass(PromoCodeNewItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.modeChange(_constants.PROMO_CODE.MODE.NEW, { coupon: (0, _promoCodeHelper.transformPromoCode)() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var p = (0, _lodash.pick)(this.props, ['mode', 'storeId', 'promoCodeId']);
	      return _react2.default.createElement(_layout2.default, p);
	    }
	  }]);
	
	  return PromoCodeNewItem;
	}(_react2.default.Component), _class.propTypes = {
	  modeChange: _propTypes2.default.func
	}, _temp);
	
	
	var mapStateToProp = function mapStateToProp(state, props, context) {
	  var params = baseSelectors.getParams(state, props);
	  return {
	    mode: _constants.PROMO_CODE.MODE.NEW,
	    storeId: (0, _lodash.get)(params, 'store_id')
	  };
	};
	
	var mapDispatchToProp = function mapDispatchToProp(dispatch) {
	  return (0, _redux.bindActionCreators)({ modeChange: _promoCodeActions.modeChange }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProp, mapDispatchToProp)(PromoCodeNewItem);

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _actions = __webpack_require__(41);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var restaurantAddOns = {
	  "qsr_mode_enabled": "QSR mode",
	  "clear_table_after_checkout": "Clear table after checkout",
	  // "": "Show order time for each line item",
	  "auto_lock": "Automatically lock POS when an order is saved"
	};
	
	var permissionAddOns = {
	
	  "permission_enabled": "Enable Store Permission",
	  "overwrite_price_enabled": "Allow manager to overwrite product price at checkout",
	  "time_clock_enabled": "Enable Time Clock",
	  "loyalty_enabled": "Enable Loyalty",
	  // "": "Support Serialized Inventory",
	  "cash_management_enabled": "Cash Management",
	  "bill_of_material_enabled": "Enable Bill of Material",
	  "show_line_item_image_enabled": "Allow to show item image"
	};
	
	var inventoryAddOns = {
	  "quantity_allow_decimal": "Allow decimal inventory quantity",
	  "quantity_decimal_points": "Quantity decimal points",
	  "costing_method": "Costing method"
	};
	
	var otherInventoryAddOns = {
	  "kitchen_alias_enabled": "Kitchen Alias Enabled"
	};
	
	var paymentAddOns = {
	  "payment_check_enabled": "Check Payment"
	};
	
	var miscAddOns = {
	  "gift_receipt_enabled": "Gift Receipt",
	  "allow_change_meal_period_enabled": "Allow Change Meal Period",
	  "po_tax_enabled": "Apply Tax for Purchase Order",
	  "discount_breakdown_line_item_level": "Show discount breakdown on printed receipt",
	  // "": "Allow all",
	  // "": "Allow partially",
	  // "": "Use A5 paper for AirPrint Receipt (default A4)",
	  "always_print_receipt_enabled": "Always print receipt when checkout",
	  // "" : "Double print receipt",
	  // "" : "Double print check",
	  // "" : "Auto popup modufuer when checkout",
	  "track_associate_sales_enabled": "Track sales by associate",
	  // "": "Automatically attribute line-item to cashier",
	  "line_item_code_enabled": "Enable Line Itme Barcode",
	  "round_tax_line_item_level": "Round Tax Line Item Level",
	  "separate_tax_and_service_fee": "Separate Tax and Service Charge",
	  "show_zero_dollar_item_on_printed_receipt_enabled": "Show zero amount line itme on printed receipt",
	  // "": "Display product quantity for menu",
	  "require_cvv_for_card_presence_transactions": "Require CVV For Card Presence Transactions",
	  "lock_table_after_print_check": "Lock Table After Print Check"
	  // "": "Hold an item to the invoice without sending to kitchen",
	};
	
	var quantity_allow_decimal_options = {
	  QUANTITY_ALLOW_DECIMAL_NO: 0,
	  QUANTITY_ALLOW_DECIMAL_ALLOW_PARTIALLY: 1,
	  QUANTITY_ALLOW_DECIMAL_ALLOW_ALL: 2
	};
	
	var quantity_decimal_points_options = {
	  // QUANTITY_DECIMAL_POINTS_ZERO_DP: 0,
	  QUANTITY_DECIMAL_POINTS_ONE_DP: 1,
	  QUANTITY_DECIMAL_POINTS_TWO_DP: 2,
	  QUANTITY_DECIMAL_POINTS_THREE_DP: 3,
	  QUANTITY_DECIMAL_POINTS_FOUR_DP: 4
	};
	
	var listing_costing_methods = {
	  MARKET_TO_MARKET: 0,
	  WEIGHTED_AVERAGE_COST: 1,
	  FIXED_PRICE: 2,
	  FIRST_IN_FIRST_OUT: 4
	};
	
	var allAddOns = Object.assign({}, restaurantAddOns, permissionAddOns, inventoryAddOns, miscAddOns, paymentAddOns, otherInventoryAddOns);
	
	function AddOnInput(props) {
	  var field = props.field,
	      addOn = props.addOn;
	
	  return _react2.default.createElement(
	    'p',
	    null,
	    _react2.default.createElement(
	      'label',
	      null,
	      _react2.default.createElement('input', {
	        type: 'checkbox',
	        onChange: field.onChange,
	        checked: field.checked }),
	      ' ',
	      addOn
	    )
	  );
	}
	AddOnInput.propTypes = {
	  field: _propTypes2.default.object,
	  addOn: _propTypes2.default.string
	};
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit,
	      fields = props.fields,
	      isRestaurant = props.isRestaurant;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    isRestaurant ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Resturant'
	      ),
	      (0, _map2.default)(restaurantAddOns, function (addOn, key) {
	        return _react2.default.createElement(AddOnInput, { field: fields[key], addOn: addOn, key: key });
	      }),
	      _react2.default.createElement('hr', null)
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Inventory'
	      ),
	      _react2.default.createElement(
	        _formGroup2.default,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Allow decimal quantity ?'
	        ),
	        ' \xA0',
	        _react2.default.createElement(
	          'select',
	          { value: fields.quantity_allow_decimal.value, onChange: fields.quantity_allow_decimal.onChange },
	          _react2.default.createElement(
	            'option',
	            { value: quantity_allow_decimal_options.QUANTITY_ALLOW_DECIMAL_NO },
	            'Don\'t allow'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: quantity_allow_decimal_options.QUANTITY_ALLOW_DECIMAL_ALLOW_PARTIALLY },
	            'Allow all'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: quantity_allow_decimal_options.QUANTITY_ALLOW_DECIMAL_ALLOW_ALL },
	            'Allow partially'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _formGroup2.default,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Costing method: '
	        ),
	        ' \xA0',
	        _react2.default.createElement(
	          'select',
	          { value: fields.costing_method.value, onChange: function onChange(e) {
	              return fields.costing_method.onChange(parseInt(e.target.value));
	            } },
	          _react2.default.createElement(
	            'option',
	            { value: listing_costing_methods.MARKET_TO_MARKET },
	            'Market to market'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: listing_costing_methods.WEIGHTED_AVERAGE_COST },
	            'Weighted average cost'
	          )
	        )
	      ),
	      fields.quantity_allow_decimal.value > 0 ? _react2.default.createElement(
	        _formGroup2.default,
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          inventoryAddOns.quantity_decimal_points
	        ),
	        '  \xA0',
	        _react2.default.createElement(
	          'select',
	          { value: fields.quantity_decimal_points.value, onChange: fields.quantity_decimal_points.onChange },
	          (0, _map2.default)(quantity_decimal_points_options, function (option) {
	            return _react2.default.createElement(
	              'option',
	              { value: option },
	              option
	            );
	          })
	        )
	      ) : null,
	      _react2.default.createElement('br', null),
	      (0, _map2.default)(otherInventoryAddOns, function (addOn, key) {
	        return _react2.default.createElement(AddOnInput, { field: fields[key], addOn: addOn, key: key });
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Permission'
	      ),
	      (0, _map2.default)(permissionAddOns, function (addOn, key) {
	        return _react2.default.createElement(AddOnInput, { field: fields[key], addOn: addOn, key: key });
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Payment'
	      ),
	      (0, _map2.default)(paymentAddOns, function (addOn, key) {
	        return _react2.default.createElement(AddOnInput, { field: fields[key], addOn: addOn, key: key });
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Misc'
	      ),
	      (0, _map2.default)(miscAddOns, function (addOn, key) {
	        return _react2.default.createElement(AddOnInput, { field: fields[key], addOn: addOn, key: key });
	      })
	    )
	  );
	}
	
	var fields = (0, _map2.default)(allAddOns, function (addOn, key) {
	  return key;
	});
	
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func,
	  isRestaurant: _propTypes2.default.bool
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'SettingsStorecredits',
	  fields: fields
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStoreModule: _actions.getStoreModule, updateStoreModule: _actions.updateStoreModule, alert: _actions.alert };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var AddOns = (_temp2 = _class = function (_Component) {
	  _inherits(AddOns, _Component);
	
	  function AddOns() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddOns);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddOns.__proto__ || Object.getPrototypeOf(AddOns)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var _this$props$actions = _this.props.actions,
	          updateStoreModule = _this$props$actions.updateStoreModule,
	          alert = _this$props$actions.alert;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStoreModule(store_id, { store_id: store_id, module: data }).then(function () {
	        alert('success', 'Add-Ons setting saved.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddOns, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var getStoreModule = this.props.actions.getStoreModule;
	
	
	      getStoreModule(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$currentStore = this.context.currentStore.module,
	          module = _context$currentStore === undefined ? {} : _context$currentStore;
	
	      var isRestaurant = !!module.restaurant_features_enabled;
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Add-Ons'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', isRestaurant: isRestaurant, initialValues: module, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddOns;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddOns);

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssociateCreate(props) {
	  var handleSubmit = props.handleSubmit,
	      roles = props.roles;
	  var _props$fields = props.fields,
	      user_id = _props$fields.user_id,
	      role_id = _props$fields.role_id;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Bindo ID / Email'
	      ),
	      _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: user_id.onChange, value: user_id.value })
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Role'
	      ),
	      _react2.default.createElement(
	        'select',
	        { onChange: role_id.onChange, value: role_id.value, className: 'form-control' },
	        (0, _map2.default)(roles, function (role, key) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: key },
	            role
	          );
	        })
	      )
	    )
	  );
	}
	AssociateCreate.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func,
	  roles: _propTypes2.default.object
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'paymentType',
	  initialValues: {
	    role_id: 1
	  },
	  fields: ['user_id', 'role_id']
	})(AssociateCreate);

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssociateCreate(props) {
	  var handleSubmit = props.handleSubmit,
	      roles = props.roles;
	  var _props$fields = props.fields,
	      full_name = _props$fields.full_name,
	      user_email = _props$fields.user_email,
	      password = _props$fields.password,
	      role_id = _props$fields.role_id;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Full Name'
	      ),
	      _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: full_name.onChange, value: full_name.value })
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Email'
	      ),
	      _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: user_email.onChange, value: user_email.value })
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Password (at least 6 characters)'
	      ),
	      _react2.default.createElement('input', { type: 'text', className: 'form-control', onChange: password.onChange, value: password.value })
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Role'
	      ),
	      _react2.default.createElement(
	        'select',
	        { onChange: role_id.onChange, value: role_id.value, className: 'form-control' },
	        (0, _map2.default)(roles, function (role_id, key) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: key },
	            role_id
	          );
	        })
	      )
	    )
	  );
	}
	AssociateCreate.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func,
	  roles: _propTypes2.default.object
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'paymentType',
	  initialValues: {
	    role_id: 1
	  },
	  fields: ['full_name', 'user_email', 'password', 'role_id']
	})(AssociateCreate);

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reduce = __webpack_require__(288);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _associateCreate = __webpack_require__(895);
	
	var _associateCreate2 = _interopRequireDefault(_associateCreate);
	
	var _associateAdd = __webpack_require__(894);
	
	var _associateAdd2 = _interopRequireDefault(_associateAdd);
	
	var _actions = __webpack_require__(41);
	
	var _formatHelper = __webpack_require__(35);
	
	var _permissionHelper = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var pathname = ownProps.location.pathname;
	  var pathState = state.path[pathname] || {};
	  var pageState = {};
	
	  try {
	    pageState.associates = (0, _map2.default)(pathState.associates, function (id) {
	      return state.entities.associates[id];
	    });
	  } catch (e) {
	    console.warn('associates not ready');
	    pageState.associates = null;
	  }
	
	  return pageState;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getAssociate: _actions.getAssociate, addAssociate: _actions.addAssociate, createNewAssociate: _actions.createNewAssociate, promoteAssociate: _actions.promoteAssociate, removeAssociate: _actions.removeAssociate, alert: _actions.alert };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var SettingAssociates = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _permissionHelper.getCurrentPermission)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(SettingAssociates, _Component);
	
	  function SettingAssociates() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingAssociates);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingAssociates.__proto__ || Object.getPrototypeOf(SettingAssociates)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      createForm: false,
	      addForm: false
	    }, _this.updateSettings = function (data) {}, _this.openCreateForm = function () {
	      _this.setState({ createForm: true });
	    }, _this.openAddForm = function () {
	      _this.setState({ addForm: true });
	    }, _this.closeCreateForm = function () {
	      _this.setState({ createForm: false });
	    }, _this.closeAddForm = function () {
	      _this.setState({ addForm: false });
	    }, _this.submitCreateForm = function () {
	      _this.refs.CreateForm.submit();
	    }, _this.submitAddForm = function () {
	      _this.refs.AddForm.submit();
	    }, _this.createNewAssociate = function (data) {
	      var store_id = _this.props.params.store_id;
	      var pathname = _this.props.location.pathname;
	      var _this$props$actions = _this.props.actions,
	          createNewAssociate = _this$props$actions.createNewAssociate,
	          alert = _this$props$actions.alert;
	
	
	      createNewAssociate(store_id, { associate: data }, pathname).then(function (data) {
	        alert('success', 'New associate created.');
	        _this.closeCreateForm();
	      }).catch(function (err) {
	        alert('danger', err.message);
	      });
	    }, _this.addAssociate = function (data) {
	      var store_id = _this.props.params.store_id;
	      var pathname = _this.props.location.pathname;
	      var _this$props$actions2 = _this.props.actions,
	          addAssociate = _this$props$actions2.addAssociate,
	          alert = _this$props$actions2.alert;
	
	
	      addAssociate(store_id, { associate: data }, pathname).then(function (data) {
	        alert('success', 'Associate added.');
	        _this.closeAddForm();
	      }).catch(function (err) {
	        alert('danger', err.message);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingAssociates, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var pathname = this.props.location.pathname;
	      var getAssociate = this.props.actions.getAssociate;
	
	
	      getAssociate(store_id, pathname);
	    }
	  }, {
	    key: 'removeAssociate',
	    value: function removeAssociate(id) {
	      var _this2 = this;
	
	      var store_id = this.props.params.store_id;
	      var pathname = this.props.location.pathname;
	      var _props$actions = this.props.actions,
	          removeAssociate = _props$actions.removeAssociate,
	          alert = _props$actions.alert;
	
	
	      if (confirm('Are you sure you want to remove this associate?')) {
	        removeAssociate(store_id, id, pathname).then(function (data) {
	          alert('success', 'Associate removed.');
	          _this2.closeCreateForm();
	        }).catch(function (err) {
	          alert('danger', err.message);
	        });
	      }
	    }
	  }, {
	    key: 'changeRole',
	    value: function changeRole(id, event) {
	      var _this3 = this;
	
	      var store_id = this.props.params.store_id;
	      var pathname = this.props.location.pathname;
	      var _props$actions2 = this.props.actions,
	          promoteAssociate = _props$actions2.promoteAssociate,
	          alert = _props$actions2.alert;
	
	
	      promoteAssociate(store_id, id, parseInt(event.target.value), pathname).then(function (data) {
	        alert('success', 'Role changed.');
	        _this3.closeCreateForm();
	      }).catch(function (err) {
	        alert('danger', err.message);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var associates = this.props.associates;
	
	      var _ref2 = this.context.currentStore || {},
	          _ref2$store_permissio = _ref2.store_permissions,
	          store_permissions = _ref2$store_permissio === undefined ? [] : _ref2$store_permissio;
	
	      var roles = (0, _reduce2.default)(store_permissions, function (acc, storePermission) {
	        acc[storePermission.store_role_id] = storePermission.store_role_name;
	        return acc;
	      }, {});
	
	      /**
	       * 权限判断
	       */
	      var addAssociate = this.getCurrentPermission('dashboard:add_associates');
	      var editAssociate = this.getCurrentPermission('dashboard:edit_role');
	      var addAssociateForBtn = addAssociate ? 'inline-block' : 'none';
	      var editAssociateForTd = editAssociate ? 'table-cell' : 'none';
	
	      var customModalStyle = {
	        content: {
	          top: '80px'
	        },
	        overlay: {
	          overflow: 'auto'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Associates'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-sm', onClick: this.openAddForm, style: { display: addAssociateForBtn } },
	                'Add Exsiting User'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-sm', onClick: this.openCreateForm, style: { display: addAssociateForBtn } },
	                'Create New Associate'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'table',
	              { className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Full Name'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Role'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Added by'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Last Update'
	                  ),
	                  _react2.default.createElement('th', null)
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                associates.map(function (a) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: a.id },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      a.full_name
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'select',
	                        { value: a.role, onChange: _this4.changeRole.bind(_this4, a.id), disabled: !editAssociate },
	                        (0, _map2.default)(roles, function (role, key) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: key, value: key },
	                            role
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      a.added_by
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _formatHelper.dateTime)(a.updated_at)
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { display: editAssociateForTd } },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'a text-danger', onClick: _this4.removeAssociate.bind(_this4, a.id) },
	                        'remove'
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactModal2.default,
	            { className: 'modal-dialog open', style: customModalStyle, isOpen: this.state.createForm, onRequestClose: this.closeCreateForm },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'modal-title' },
	                  'Create New Associate'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-body' },
	                _react2.default.createElement(_associateCreate2.default, { ref: 'CreateForm', onSubmit: this.createNewAssociate, roles: roles })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-footer' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-secondary', onClick: this.closeCreateForm },
	                  'Cancel'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-primary', onClick: this.submitCreateForm },
	                  'Create Bindo Account'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactModal2.default,
	            { className: 'modal-dialog open', style: customModalStyle, isOpen: this.state.addForm, onRequestClose: this.closeAddForm },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'modal-title' },
	                  'Add Existing Associate'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-body' },
	                _react2.default.createElement(_associateAdd2.default, { ref: 'AddForm', onSubmit: this.addAssociate, roles: roles })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-footer' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-secondary', onClick: this.closeAddForm },
	                  'Cancel'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-primary', onClick: this.submitAddForm },
	                  'Add Associate'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingAssociates;
	}(_react.Component), _class2.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  associates: _propTypes2.default.array
	}, _class2.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2)) || _class) || _class);
	exports.default = SettingAssociates;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _actions = __webpack_require__(41);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit;
	  var _props$fields = props.fields,
	      delivery = _props$fields.delivery,
	      delivery_desc = _props$fields.delivery_desc,
	      delivery_fee = _props$fields.delivery_fee,
	      delivery_miles = _props$fields.delivery_miles,
	      delivery_min_amount = _props$fields.delivery_min_amount;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          onChange: delivery.onChange,
	          checked: delivery.checked }),
	        ' Enable local delivery'
	      )
	    ),
	    delivery.value ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _formGroup2.default,
	        { label: 'Maximun distance (in mile)' },
	        _react2.default.createElement('input', {
	          type: 'text',
	          className: 'form-control',
	          onChange: delivery_miles.onChange,
	          value: delivery_miles.value })
	      ),
	      _react2.default.createElement(
	        _formGroup2.default,
	        { label: 'Minimum order ($)' },
	        _react2.default.createElement('input', {
	          type: 'text',
	          className: 'form-control',
	          onChange: delivery_min_amount.onChange,
	          value: delivery_min_amount.value })
	      ),
	      _react2.default.createElement(
	        _formGroup2.default,
	        { label: 'Delivery charge if minimum order is not met ($)' },
	        _react2.default.createElement('input', {
	          type: 'text',
	          className: 'form-control',
	          onChange: delivery_fee.onChange,
	          value: delivery_fee.value })
	      ),
	      _react2.default.createElement(
	        _formGroup2.default,
	        { label: 'Other pick up and delivery information' },
	        _react2.default.createElement('textarea', {
	          className: 'form-control',
	          onChange: delivery_desc.onChange,
	          value: delivery_desc.value })
	      )
	    ) : null
	  );
	}
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'store_policy',
	  fields: ['delivery', 'delivery_desc', 'delivery_fee', 'delivery_miles', 'delivery_min_amount']
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStoreDelivery: _actions.getStoreDelivery, updateStore: _actions.updateStore, alert: _actions.alert };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var Delivery = (_temp2 = _class = function (_Component) {
	  _inherits(Delivery, _Component);
	
	  function Delivery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Delivery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Delivery.__proto__ || Object.getPrototypeOf(Delivery)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var _this$props$actions = _this.props.actions,
	          updateStore = _this$props$actions.updateStore,
	          alert = _this$props$actions.alert;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStore(store_id, { store_attributes: data }).then(function () {
	        alert('success', 'Policies setting saved.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Delivery, [{
	    key: 'render',
	    value: function render() {
	      var currentStore = this.context.currentStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Delivery'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', initialValues: currentStore, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Delivery;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  associates: _propTypes2.default.array
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Delivery);

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _embeddedBarcode = __webpack_require__(461);
	
	var actions = _interopRequireWildcard(_embeddedBarcode);
	
	var _inputSelectBox = __webpack_require__(232);
	
	var _inputSelectBox2 = _interopRequireDefault(_inputSelectBox);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var typeOptions = [{ value: 0, label: 'Embedded Price' }, { value: 1, label: 'Embedded Weight' }];
	
	var pointOptions = {
	  0: [{ value: 0, label: '0' }, { value: 1, label: '1' }, { value: 2, label: '2' }],
	  1: [{ value: 0, label: '0' }, { value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }]
	};
	
	function mapStateToProps(state, ownProps) {
	  return state.forms.embeddedBarcode;
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var SettingsBusinessEmbededBarcode = (_temp = _class = function (_Component) {
	  _inherits(SettingsBusinessEmbededBarcode, _Component);
	
	  function SettingsBusinessEmbededBarcode() {
	    _classCallCheck(this, SettingsBusinessEmbededBarcode);
	
	    return _possibleConstructorReturn(this, (SettingsBusinessEmbededBarcode.__proto__ || Object.getPrototypeOf(SettingsBusinessEmbededBarcode)).apply(this, arguments));
	  }
	
	  _createClass(SettingsBusinessEmbededBarcode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	
	      this.props.actions.showEmbeddedBarcodeSetting(store_id);
	      this.props.actions.showScaleBarcodeNumber(store_id);
	    }
	  }, {
	    key: 'submitAction',
	    value: function submitAction() {
	      this.props.actions.submitScaleBarcodeSetting();
	      this.props.actions.submitEmbeddedBarcodeSetting();
	    }
	  }, {
	    key: 'scalebarcodevali',
	    value: function scalebarcodevali(prefix) {
	      var store_id = this.props.params.store_id;
	
	      var prefixdata = [prefix];
	      if (prefix) {
	        var ArrayPrefix = prefix.split(",");
	        // not need show: 20,21,22,23,24,25,26,27,28
	        var needShow = false;
	        if (ArrayPrefix.length <= 9) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = ArrayPrefix[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var i = _step.value;
	
	              if (i < 20 || i > 29 || String(i).indexOf(".") > -1 || isNaN(i)) {
	                needShow = true;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } else {
	          needShow = true;
	        }
	        if (needShow) {
	          this.props.actions.showScaleBarcodeNumber(store_id);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          type = _props.type,
	          enabled = _props.enabled,
	          decimalPoints = _props.decimalPoints,
	          editMode = _props.editMode,
	          changed = _props.changed,
	          enableSubmit = _props.enableSubmit,
	          actions = _props.actions,
	          scale_barcodes = _props.scale_barcodes;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	            !editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm', onClick: actions.editEmbeddedBarcodeSetting },
	              'Edit'
	            ),
	            editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: function onClick() {
	                  _this2.submitAction();
	                } },
	              'Save'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Embedded Barcode'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('input', { type: 'checkbox',
	                  value: '1',
	                  checked: enabled,
	                  disabled: !editMode,
	                  onChange: function onChange(e) {
	                    return actions.changeEmbeddedBarcodeEnabled(e.target.checked);
	                  } }),
	                'Enable Embedded Barcode for by weight pricing product'
	              )
	            )
	          ),
	          enabled && _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            typeOptions.map(function (typeOption, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'row', key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-3' },
	                  _react2.default.createElement(_inputBox2.default, { value: typeOption.label,
	                    disabled: !editMode,
	                    title: 'Embedded Type' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-3' },
	                  _react2.default.createElement(_inputBox2.default, { value: scale_barcodes[index].prefix,
	                    disabled: !editMode,
	                    title: 'Scale Prefix'
	                    // key={scale_barcodes[index].prefix}
	                    , onBlur: function onBlur() {
	                      return _this2.scalebarcodevali(scale_barcodes[index].prefix);
	                    },
	                    onChange: function onChange(e) {
	                      return actions.editScaleBarcode(e.target.value, typeOption.value);
	                    } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-3' },
	                  _react2.default.createElement(_inputSelectBox2.default, { value: scale_barcodes.length !== 0 ? scale_barcodes[index].decimal : ''
	                    // key={index}
	                    , title: 'Decimal Points',
	                    placeholder: 'Select decimal',
	                    resetValue: undefined,
	                    clearable: false,
	                    disabled: !editMode,
	                    onChange: function onChange(opt) {
	                      return actions.changeEmbeddedBarcodeDeciamlPoints(opt.value, typeOption.value);
	                    },
	                    options: pointOptions[index] || [] })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingsBusinessEmbededBarcode;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  type: _propTypes2.default.number.isRequired,
	  enabled: _propTypes2.default.bool.isRequired,
	  decimalPoints: _propTypes2.default.number.isRequired,
	  editMode: _propTypes2.default.bool.isRequired,
	  changed: _propTypes2.default.bool.isRequired,
	  enableSubmit: _propTypes2.default.bool.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  scale_barcode: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsBusinessEmbededBarcode);

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(91);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkStationModal = (_temp = _class = function (_Modal) {
	  _inherits(LinkStationModal, _Modal);
	
	  function LinkStationModal(props) {
	    _classCallCheck(this, LinkStationModal);
	
	    var _this = _possibleConstructorReturn(this, (LinkStationModal.__proto__ || Object.getPrototypeOf(LinkStationModal)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.state = {
	      stationKey: ''
	    };
	    return _this;
	  }
	
	  _createClass(LinkStationModal, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var onSubmit = this.props.onSubmit;
	
	      onSubmit(this.state.stationKey);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ stationKey: event.target.value });
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          onRequestClose = _props.onRequestClose,
	          failure = _props.failure;
	      var stationKey = this.state.stationKey;
	
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: 'Link Up New KDS', onRequestClose: onRequestClose }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(_inputBox2.default, { title: 'Enter the station key shown on the station device screen',
	            type: 'text',
	            value: stationKey,
	            failure: failure,
	            placeholder: '',
	            containerClass: '_long',
	            onChange: this.handleChange })
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              onClick: this.handleSubmit },
	            'Add'
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkStationModal;
	}(_modal.Modal), _class.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func
	}, _temp);
	exports.default = LinkStationModal;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _inputSelect = __webpack_require__(474);
	
	var _inputSelect2 = _interopRequireDefault(_inputSelect);
	
	var _tag = __webpack_require__(804);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, props) {
	  var _state$forms = state.forms,
	      selectedKitchenDepartments = _state$forms.kitchenDepartmentSelection.selected,
	      selectedDepartments = _state$forms.departmentSelection.selected;
	
	  return { selectedDepartments: selectedDepartments, selectedKitchenDepartments: selectedKitchenDepartments };
	}
	var MatchingCriteria = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(MatchingCriteria, _Component);
	
	  function MatchingCriteria(props) {
	    _classCallCheck(this, MatchingCriteria);
	
	    var _this = _possibleConstructorReturn(this, (MatchingCriteria.__proto__ || Object.getPrototypeOf(MatchingCriteria)).call(this, props));
	
	    _this.handleDepartmentRemove = function (tag) {
	      var _this$props = _this.props,
	          number = _this$props.number,
	          departments = _this$props.departments,
	          changeMatchingCriteria = _this$props.changeMatchingCriteria;
	
	      var list = departments.filter(function (d) {
	        return d.department_id !== tag.department_id;
	      });
	      changeMatchingCriteria({ number: number, departments: list });
	    };
	
	    _this.handleKitchenDepartRemove = function (tag) {
	      var _this$props2 = _this.props,
	          number = _this$props2.number,
	          kitchenDepartments = _this$props2.kitchenDepartments,
	          changeMatchingCriteria = _this$props2.changeMatchingCriteria;
	
	      var list = kitchenDepartments.filter(function (d) {
	        return d.kitchen_department_id !== tag.kitchen_department_id;
	      });
	      changeMatchingCriteria({ number: number, kitchenDepartments: list });
	    };
	
	    _this.handleStatusRemove = function (tag) {
	      var _this$props3 = _this.props,
	          number = _this$props3.number,
	          status = _this$props3.status,
	          changeMatchingCriteria = _this$props3.changeMatchingCriteria;
	
	      var list = status.filter(function (d) {
	        return d.line_item_status_id !== tag.line_item_status_id;
	      });
	      changeMatchingCriteria({ number: number, status: list });
	    };
	
	    _this.handleShowPrematureItemsChange = function (val) {
	      var _this$props4 = _this.props,
	          number = _this$props4.number,
	          changeMatchingCriteria = _this$props4.changeMatchingCriteria;
	
	      changeMatchingCriteria({ number: number, showPrematureItems: val });
	    };
	
	    return _this;
	  }
	
	  _createClass(MatchingCriteria, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          status = _props.status,
	          number = _props.number,
	          showPrematureItems = _props.showPrematureItems,
	          openDepartmentSelection = _props.openDepartmentSelection,
	          openKitchenDepartmentSelection = _props.openKitchenDepartmentSelection,
	          openStatusSelection = _props.openStatusSelection,
	          selectedDepartments = _props.selectedDepartments,
	          selectedKitchenDepartments = _props.selectedKitchenDepartments,
	          departments = _props.departments,
	          kitchenDepartments = _props.kitchenDepartments;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Match #',
	          number
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input-box' },
	          _react2.default.createElement(
	            'p',
	            { className: 'input-box__title' },
	            'Department'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4' },
	              _react2.default.createElement(_inputSelect2.default, { placeholder: 'Select Departments', onClick: function onClick() {
	                  return openDepartmentSelection({ selected: selectedDepartments, params: { number: number, opener: 'settings-kds' } });
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8' },
	              departments && departments.length > 0 && departments.map(function (d, i) {
	                return _react2.default.createElement(_tag2.default, { label: d.department_name,
	                  onClick: function onClick() {
	                    return _this2.handleDepartmentRemove(d);
	                  },
	                  key: i });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input-box' },
	          _react2.default.createElement(
	            'p',
	            { className: 'input-box__title' },
	            'Kitchen Department'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4' },
	              _react2.default.createElement(_inputSelect2.default, { placeholder: 'Select Kitchen Departments', onClick: function onClick() {
	                  return openKitchenDepartmentSelection({ selected: selectedKitchenDepartments, params: { number: number, opener: 'settings-kds' } });
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8' },
	              kitchenDepartments && kitchenDepartments.length > 0 && kitchenDepartments.map(function (d, i) {
	                return _react2.default.createElement(_tag2.default, { label: d.kitchen_department_name,
	                  onClick: function onClick() {
	                    return _this2.handleKitchenDepartRemove(d);
	                  },
	                  key: i });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input-box' },
	          _react2.default.createElement(
	            'p',
	            { className: 'input-box__title' },
	            'Status'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4' },
	              _react2.default.createElement(_inputSelect2.default, { placeholder: 'Select Status', onClick: function onClick() {
	                  return openStatusSelection({ selected: status, params: { number: number } });
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8' },
	              status && status.length > 0 && status.map(function (d, i) {
	                return _react2.default.createElement(_tag2.default, { label: d.line_item_status_name,
	                  onClick: function onClick() {
	                    return _this2.handleStatusRemove(d);
	                  },
	                  key: i });
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('input', { type: 'checkbox',
	            checked: showPrematureItems,
	            onChange: function onChange(e) {
	              return _this2.handleShowPrematureItemsChange(e.target.checked);
	            } }),
	          ' Show Premature Items'
	        )
	      );
	    }
	  }]);
	
	  return MatchingCriteria;
	}(_react.Component), _class2.propTypes = {
	  number: _propTypes2.default.number.isRequired,
	  departments: _propTypes2.default.array.isRequired,
	  status: _propTypes2.default.array.isRequired,
	  kitchenDepartments: _propTypes2.default.array.isRequired,
	  selectedDepartments: _propTypes2.default.array.isRequired,
	  selectedKitchenDepartments: _propTypes2.default.array.isRequired,
	  showPrematureItems: _propTypes2.default.bool.isRequired,
	  changeMatchingCriteria: _propTypes2.default.func.isRequired,
	  openDepartmentSelection: _propTypes2.default.func.isRequired,
	  openKitchenDepartmentSelection: _propTypes2.default.func.isRequired,
	  openStatusSelection: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = MatchingCriteria;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	var _priority = __webpack_require__(902);
	
	var _priority2 = _interopRequireDefault(_priority);
	
	var _matchingCriteria = __webpack_require__(900);
	
	var _matchingCriteria2 = _interopRequireDefault(_matchingCriteria);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATION_TYPES = {
	  0: 'Kitchen Display',
	  1: 'Queueing Display',
	  2: 'Queue Monitor Display'
	};
	
	var OverviewForm = (_temp = _class = function (_Component) {
	  _inherits(OverviewForm, _Component);
	
	  function OverviewForm() {
	    _classCallCheck(this, OverviewForm);
	
	    return _possibleConstructorReturn(this, (OverviewForm.__proto__ || Object.getPrototypeOf(OverviewForm)).apply(this, arguments));
	  }
	
	  _createClass(OverviewForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          initialValues = _props.initialValues,
	          name = _props.name,
	          need_aggregation = _props.need_aggregation,
	          aggregation_minutes = _props.aggregation_minutes,
	          station_priorities = _props.station_priorities,
	          matchCriteria = _props.matchCriteria,
	          show_in_progress = _props.show_in_progress,
	          discard = _props.discard,
	          save = _props.save,
	          openDepartmentSelection = _props.openDepartmentSelection,
	          openKitchenDepartmentSelection = _props.openKitchenDepartmentSelection,
	          openStatusSelection = _props.openStatusSelection,
	          changeStationName = _props.changeStationName,
	          changeShowInProgressState = _props.changeShowInProgressState,
	          addMatchingCriteria = _props.addMatchingCriteria,
	          changePriority = _props.changePriority,
	          toggleAggregation = _props.toggleAggregation,
	          changeAggregationTime = _props.changeAggregationTime,
	          changeMatchingCriteria = _props.changeMatchingCriteria;
	      var station_key = initialValues.station_key,
	          signature_key = initialValues.signature_key,
	          station_type = initialValues.station_type;
	
	
	      var isKds = !station_type;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	          isKds && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm',
	                onClick: discard,
	                type: 'submit' },
	              'Cancel'
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm',
	                onClick: save,
	                type: 'submit' },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Station: ',
	            station_key
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'WAN IP'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-box__input' },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'LAN IP'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-box__input' },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'STATION KEY'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-box__input' },
	                  station_key
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'STATION VIEWER URL'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'input-box__input' },
	                  'kds.bindo.com/' + station_key
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'ACTIVATION CODE'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-box__input' },
	                  signature_key
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-box' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'input-box__title' },
	                  'STATION TYPE'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-box__input' },
	                  STATION_TYPES[station_type || 0]
	                )
	              )
	            )
	          )
	        ),
	        isKds && _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Station Settings'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-6' },
	              _react2.default.createElement(_inputBox2.default, { title: 'Station Name',
	                value: name,
	                onChange: function onChange(e) {
	                  return changeStationName(e.target.value);
	                },
	                type: 'text' })
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox',
	              checked: show_in_progress,
	              value: show_in_progress,
	              onChange: function onChange(e) {
	                return changeShowInProgressState(e.target.checked);
	              } }),
	            ' Show In Progress State'
	          )
	        ),
	        isKds && _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Matching Criteria'
	          ),
	          matchCriteria && matchCriteria.map(function (m, i) {
	            return _react2.default.createElement(_matchingCriteria2.default, { key: i,
	              number: m.match_group_number,
	              status: m.status,
	              showPrematureItems: m.show_premature_items,
	              departments: m.departments,
	              kitchenDepartments: m.kitchenDepartments,
	              changeMatchingCriteria: changeMatchingCriteria,
	              openDepartmentSelection: openDepartmentSelection,
	              openKitchenDepartmentSelection: openKitchenDepartmentSelection,
	              openStatusSelection: openStatusSelection });
	          }),
	          _react2.default.createElement(
	            'a',
	            { className: 'btn', onClick: addMatchingCriteria },
	            _react2.default.createElement('i', { className: 'fa fa-plus-circle' }),
	            ' Add New Matching Criteria'
	          )
	        ),
	        isKds && _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Priority(from order time)'
	          ),
	          station_priorities && station_priorities.length > 0 && station_priorities.map(function (p, i) {
	            var name = p.name,
	                minutes = p.minutes,
	                color = p.color,
	                id = p.id;
	
	            return _react2.default.createElement(_priority2.default, { key: i,
	              color: color,
	              minutes: minutes,
	              onChange: function onChange(val) {
	                return changePriority({ id: id, minutes: val, name: name, color: color });
	              },
	              name: name });
	          })
	        ),
	        isKds && _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Aggragation / Grouping'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-md-2' },
	              'Aggregation Gate'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'col-md-1' },
	              _react2.default.createElement('input', { type: 'radio',
	                checked: need_aggregation === true,
	                onChange: function onChange(e) {
	                  return e.target.checked ? toggleAggregation(true) : null;
	                },
	                value: 'true' }),
	              ' on'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'col-md-1' },
	              _react2.default.createElement('input', { type: 'radio',
	                checked: need_aggregation === false,
	                onChange: function onChange(e) {
	                  return e.target.checked ? toggleAggregation(false) : null;
	                },
	                value: 'false' }),
	              ' off'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-md-4' },
	              'Aggregation Gate All Same Items Within'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-8' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('input', { type: 'number',
	                  value: aggregation_minutes,
	                  onChange: function onChange(e) {
	                    return changeAggregationTime(parseInt(e.target.value));
	                  }
	                }),
	                ' mins'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OverviewForm;
	}(_react.Component), _class.propTypes = {
	  initialValues: _propTypes2.default.object.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  need_aggregation: _propTypes2.default.bool.isRequired,
	  aggregation_minutes: _propTypes2.default.number.isRequired,
	  station_priorities: _propTypes2.default.array.isRequired,
	  matchCriteria: _propTypes2.default.array.isRequired,
	  //pending
	  show_in_progress: _propTypes2.default.bool.isRequired,
	  // display_view: PropTypes.number.isRequired,
	
	  openDepartmentSelection: _propTypes2.default.func,
	  openKitchenDepartmentSelection: _propTypes2.default.func,
	  openStatusSelection: _propTypes2.default.func,
	  changeStationName: _propTypes2.default.func,
	  changeShowInProgressState: _propTypes2.default.func,
	  // selectDisplayView: PropTypes.func,
	  addMatchingCriteria: _propTypes2.default.func,
	  changePriority: _propTypes2.default.func,
	  toggleAggregation: _propTypes2.default.func,
	  changeAggregationTime: _propTypes2.default.func,
	  changeMatchingCriteria: _propTypes2.default.func,
	  save: _propTypes2.default.func,
	  discard: _propTypes2.default.func
	}, _temp);
	exports.default = OverviewForm;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dotStyle = {
	  width: '0px',
	  borderWidth: '4px'
	};
	
	var Priority = (_temp = _class = function (_Component) {
	  _inherits(Priority, _Component);
	
	  function Priority() {
	    _classCallCheck(this, Priority);
	
	    return _possibleConstructorReturn(this, (Priority.__proto__ || Object.getPrototypeOf(Priority)).apply(this, arguments));
	  }
	
	  _createClass(Priority, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          minutes = _props.minutes,
	          color = _props.color,
	          _onChange = _props.onChange;
	
	
	      dotStyle.borderColor = color;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement('span', { className: 'col-md-1', style: dotStyle }),
	        _react2.default.createElement(
	          'span',
	          { className: 'col-md-2' },
	          name,
	          ' Passed'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'col-md-9' },
	          _react2.default.createElement('input', { type: 'number',
	            onChange: function onChange(e) {
	              return _onChange(parseInt(e.target.value));
	            },
	            value: minutes }),
	          ' mins'
	        )
	      );
	    }
	  }]);
	
	  return Priority;
	}(_react.Component), _class.propTypes = {
	  name: _propTypes2.default.string,
	  minutes: _propTypes2.default.number,
	  color: _propTypes2.default.string,
	  onChange: _propTypes2.default.func
	}, _temp);
	exports.default = Priority;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp3;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(91);
	
	var _inputAdd = __webpack_require__(790);
	
	var _inputAdd2 = _interopRequireDefault(_inputAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusItem = (_temp = _class = function (_Component) {
	  _inherits(StatusItem, _Component);
	
	  function StatusItem() {
	    _classCallCheck(this, StatusItem);
	
	    return _possibleConstructorReturn(this, (StatusItem.__proto__ || Object.getPrototypeOf(StatusItem)).apply(this, arguments));
	  }
	
	  _createClass(StatusItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          checked = _props.checked,
	          onClick = _props.onClick;
	
	      return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox',
	          onChange: function onChange() {
	            return onClick(!checked);
	          },
	          checked: checked }),
	        label
	      );
	    }
	  }]);
	
	  return StatusItem;
	}(_react.Component), _class.propTypes = {
	  checked: _propTypes2.default.bool.isRequired,
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	}, _temp);
	var SelectStatus = (_temp3 = _class2 = function (_Modal) {
	  _inherits(SelectStatus, _Modal);
	
	  function SelectStatus() {
	    var _ref;
	
	    var _temp2, _this2, _ret;
	
	    _classCallCheck(this, SelectStatus);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref = SelectStatus.__proto__ || Object.getPrototypeOf(SelectStatus)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleAdd = function () {
	      var _this2$props = _this2.props,
	          input = _this2$props.input,
	          createStatus = _this2$props.createStatus,
	          store_id = _this2$props.store_id;
	
	      var status = input.value;
	      var color = '#FFFFFF';
	      createStatus({ status: status, color: color, store_id: store_id });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(SelectStatus, [{
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props2 = this.props,
	          all = _props2.all,
	          selected = _props2.selected,
	          input = _props2.input,
	          closeStatusSelection = _props2.closeStatusSelection,
	          changeStatusInput = _props2.changeStatusInput,
	          toggleStatusSelection = _props2.toggleStatusSelection,
	          submitStatusSelection = _props2.submitStatusSelection;
	
	
	      var selectedIds = selected.map(function (s) {
	        return s.line_item_status_id;
	      });
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: 'Select Status' }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          all && all.length > 0 && all.map(function (item, i) {
	            var line_item_status_name = item.line_item_status_name,
	                line_item_status_id = item.line_item_status_id;
	
	            return _react2.default.createElement(StatusItem, { key: i,
	              onClick: function onClick(value) {
	                return toggleStatusSelection({ item: item, checked: value });
	              },
	              checked: selectedIds.indexOf(line_item_status_id) > -1,
	              label: line_item_status_name });
	          }),
	          _react2.default.createElement(_inputAdd2.default, { value: input.value,
	            onAdd: this.handleAdd,
	            onChange: changeStatusInput,
	            failure: input.failure })
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: '_secondary',
	              onClick: closeStatusSelection },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: '_primary',
	              onClick: submitStatusSelection },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectStatus;
	}(_modal.Modal), _class2.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  all: _propTypes2.default.array.isRequired,
	  selected: _propTypes2.default.array.isRequired,
	  input: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  store_id: _propTypes2.default.string.isRequired,
	  closeStatusSelection: _propTypes2.default.func.isRequired,
	  changeStatusInput: _propTypes2.default.func.isRequired,
	  toggleStatusSelection: _propTypes2.default.func.isRequired,
	  createStatus: _propTypes2.default.func.isRequired,
	  submitStatusSelection: _propTypes2.default.func.isRequired
	}, _temp3);
	exports.default = SelectStatus;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pick = __webpack_require__(213);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _keys = __webpack_require__(141);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _cloneDeep = __webpack_require__(279);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _linkStation = __webpack_require__(899);
	
	var _linkStation2 = _interopRequireDefault(_linkStation);
	
	var _grid = __webpack_require__(66);
	
	var _gridFooter = __webpack_require__(315);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATION_TYPES = {
	  0: 'Kitchen Display',
	  1: 'Queueing Display',
	  2: 'Queue Monitor Display'
	};
	
	var SettingsBusinessKdsIndex = (_temp = _class = function (_Component) {
	  _inherits(SettingsBusinessKdsIndex, _Component);
	
	  function SettingsBusinessKdsIndex(props) {
	    _classCallCheck(this, SettingsBusinessKdsIndex);
	
	    var _this = _possibleConstructorReturn(this, (SettingsBusinessKdsIndex.__proto__ || Object.getPrototypeOf(SettingsBusinessKdsIndex)).call(this, props));
	
	    _this.handleRowsPerPageChange = function (perPage) {
	      var store_id = _this.props.params.store_id;
	      var filters = _this.props.appState.kdsStatus.filters;
	
	      var filterString = _filterHelper2.default.filtersToString(filters);
	
	      _this.props.actions.updateStationsFilters(filters);
	      // this.props.actions.getStations(store_id, page, count, undefined, filters);
	      _this.context.router.push({
	        pathname: _routeHelper2.default.stations(store_id),
	        query: {
	          page: 1,
	          count: perPage,
	          filters: filterString
	        }
	      });
	    };
	
	    _this.handleSearch = function (filters) {
	      var _this$props$params = _this.props.params,
	          store_id = _this$props$params.store_id,
	          page = _this$props$params.page,
	          count = _this$props$params.count;
	
	      var filterString = _filterHelper2.default.filtersToString(filters);
	      _this.props.actions.updateStationsFilters(filters);
	      _this.props.actions.getStations(store_id, page, count, undefined, filters);
	      _this.context.router.push({
	        pathname: _routeHelper2.default.stations(store_id),
	        query: {
	          page: page,
	          count: count,
	          filters: filterString
	        }
	      });
	    };
	
	    _this.handleLinkStation = function (key) {
	      var store_id = _this.props.params.store_id;
	
	      _this.setState({ linkError: false });
	      _this.props.actions.linkStationToStore(key, store_id).then(function (result) {
	        var id = result.id,
	            error = result.error;
	
	        if (id) {
	          _this.setState({ modalIsOpen: false });
	          _routeHelper2.default.goStations(store_id, id);
	        }
	        if (error) {
	          _this.setState({ linkError: true });
	        }
	      });
	    };
	
	    _this.handleLinkStation = _this.handleLinkStation.bind(_this);
	    _this.state = {
	      modalIsOpen: false,
	      linkError: false
	    };
	
	    _this.gridActions = [{ name: 'Edit', onClick: function onClick(item) {
	        var id = item.id;
	        var store_id = _this.props.params.store_id;
	
	        _routeHelper2.default.goStations(store_id, id);
	      } }, { name: 'View with browser', onClick: function onClick() {} }, { name: 'Remove', onClick: function onClick(item) {
	        if (!confirm('Do you really want to delete this item?')) return false;
	        _this.props.actions.removeStation(item.id, _this.props.params.store_id);
	      } }];
	
	    _this.columnMetadatas = [{
	      columnName: "name",
	      displayName: "STATION NAME",
	      filterConditions: ['contain', 'equal']
	    }, {
	      columnName: "wan_ip",
	      displayName: "WAN IP",
	      filterConditions: ['contain', 'equal']
	    }, {
	      columnName: "lan_ip",
	      displayName: "LAN IP",
	      filterConditions: ['contain', 'equal']
	    }, {
	      columnName: "station_key",
	      displayName: "STATION Key",
	      filterConditions: ['contain', 'equal'],
	      customComponent: function customComponent(props) {
	        var rowData = props.rowData,
	            data = props.data; //eslint-disable-line react/prop-types
	
	        var id = rowData.id;
	        var store_id = _this.props.params.store_id;
	
	        var path = _routeHelper2.default.stations(store_id, id);
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: path },
	          data
	        );
	      }
	    }, {
	      columnName: "station_type",
	      displayName: "STATION TYPE",
	      filterConditions: ['equal'],
	      customComponent: function customComponent(props) {
	        var data = props.data; //eslint-disable-line react/prop-types
	
	        var type = data === " " ? 0 : data;
	        return _react2.default.createElement(
	          'span',
	          null,
	          STATION_TYPES[type]
	        );
	      }
	    }];
	
	    _this.filterSettings = _this.columnMetadatas.map(function (column) {
	      return (0, _pick2.default)(column, 'columnName', 'displayName', 'filterConditions');
	    });
	
	    return _this;
	  }
	
	  _createClass(SettingsBusinessKdsIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var _props$location$query = this.props.location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	
	      var status = {};
	      if (count) status.count = count;
	      if (page) status.page = page;
	      this.props.actions.updateStationsStatus(status);
	      this.props.actions.getStations(store_id, page, count, undefined, filtersObject);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.location.pathname !== nextProps.location.pathname || this.props.location.search !== nextProps.location.search) {
	        var store_id = nextProps.params.store_id;
	        var filters = nextProps.location.query.filters;
	
	        var filtersObject = _filterHelper2.default.stringToFilters(filters);
	
	        this.props.actions.getStations(store_id, filtersObject);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var appState = this.props.appState;
	      var _state = this.state,
	          modalIsOpen = _state.modalIsOpen,
	          linkError = _state.linkError;
	      var entities = appState.entities,
	          kdsStatus = appState.kdsStatus;
	
	
	      var data = [];
	
	      if (entities.stations) {
	        (0, _keys2.default)(entities.stations).forEach(function (key) {
	          data.push(entities.stations[key]);
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 1, overflowY: "scroll", height: "100%" } },
	          _react2.default.createElement(_linkStation2.default, { isOpen: modalIsOpen,
	            failure: linkError,
	            onRequestClose: function onRequestClose() {
	              return _this2.setState({ modalIsOpen: false });
	            },
	            onSubmit: this.handleLinkStation }),
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              ' '
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: function onClick() {
	                  return _this2.setState({ modalIsOpen: true });
	                } },
	              'New'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content -main-filter' },
	            _react2.default.createElement(_cascadeFilterCollection2.default, {
	              group: 'stations',
	              settings: this.filterSettings,
	              filters: kdsStatus.filters,
	              onSearch: this.handleSearch
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content' },
	            _react2.default.createElement(
	              'div',
	              null,
	              kdsStatus.loading ? _react2.default.createElement(
	                _loading2.default,
	                null,
	                'Loading...'
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'grid' },
	                _react2.default.createElement(_grid.GridBody, { data: (0, _cloneDeep2.default)(data),
	                  actions: this.gridActions,
	                  columns: this.columnMetadatas }),
	                _react2.default.createElement(_gridFooter.GridRowsPerPage, { totalEntries: kdsStatus.totalCount,
	                  rowsPerPage: kdsStatus.count,
	                  currentPage: kdsStatus.page,
	                  updateRowsPerPage: this.handleRowsPerPageChange })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingsBusinessKdsIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  appState: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = SettingsBusinessKdsIndex;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _overviewForm = __webpack_require__(901);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _selectDepartment = __webpack_require__(477);
	
	var _selectDepartment2 = _interopRequireDefault(_selectDepartment);
	
	var _selectKitchenDepartment = __webpack_require__(799);
	
	var _selectKitchenDepartment2 = _interopRequireDefault(_selectKitchenDepartment);
	
	var _selectStatus = __webpack_require__(903);
	
	var _selectStatus2 = _interopRequireDefault(_selectStatus);
	
	var _kdsActions = __webpack_require__(182);
	
	var _departmentActions = __webpack_require__(149);
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	var _departmentSelection = __webpack_require__(118);
	
	var departmentSelectionActions = _interopRequireWildcard(_departmentSelection);
	
	var _kitchenDepartmentSelection = __webpack_require__(150);
	
	var kitchenDepartmentSelectionActions = _interopRequireWildcard(_kitchenDepartmentSelection);
	
	var _statusSelection = __webpack_require__(225);
	
	var statusSelectionActions = _interopRequireWildcard(_statusSelection);
	
	var _stationOverview = __webpack_require__(310);
	
	var stationOverviewActions = _interopRequireWildcard(_stationOverview);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var params = ownProps.params;
	  var station_id = params.station_id;
	  var kdsStatus = state.kdsStatus,
	      entities = state.entities,
	      forms = state.forms;
	
	  var departments = [];
	  var station = {};
	
	  if (entities.departments) {
	    departments = (0, _values2.default)(entities.departments);
	  }
	  if (entities.stations) {
	    station = entities.stations[station_id];
	  }
	
	  return {
	    kdsStatus: kdsStatus,
	    departments: departments,
	    station: station,
	    overviewState: forms.stationOverview,
	    departmentSelectionState: forms.departmentSelection,
	    kitchenDepartmentSelectionState: forms.kitchenDepartmentSelection,
	    statusSelectionState: forms.statusSelection
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    getStation: (0, _redux.bindActionCreators)(_kdsActions.getStation, dispatch),
	    getDepartments: (0, _redux.bindActionCreators)(_departmentActions.getDepartments, dispatch),
	    getLineItemStatuses: (0, _redux.bindActionCreators)(_lineItemStatusAction.getLineItemStatuses, dispatch),
	    departmentSelectionActions: (0, _redux.bindActionCreators)(departmentSelectionActions, dispatch),
	    kitchenDepartmentSelectionActions: (0, _redux.bindActionCreators)(kitchenDepartmentSelectionActions, dispatch),
	    statusSelectionActions: (0, _redux.bindActionCreators)(statusSelectionActions, dispatch),
	    stationOverviewActions: (0, _redux.bindActionCreators)(stationOverviewActions, dispatch)
	  };
	}
	
	var SettingsBusinessKdsItem = (_temp2 = _class = function (_Component) {
	  _inherits(SettingsBusinessKdsItem, _Component);
	
	  function SettingsBusinessKdsItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingsBusinessKdsItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsBusinessKdsItem.__proto__ || Object.getPrototypeOf(SettingsBusinessKdsItem)).call.apply(_ref, [this].concat(args))), _this), _this.goBack = function () {
	      var params = _this.props.params;
	      var store_id = params.store_id;
	
	      _routeHelper2.default.goStations(store_id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingsBusinessKdsItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          station = _props.station;
	      var _props2 = this.props,
	          getStation = _props2.getStation,
	          getDepartments = _props2.getDepartments,
	          getLineItemStatuses = _props2.getLineItemStatuses,
	          stationOverviewActions = _props2.stationOverviewActions;
	      var station_type = station.station_type;
	      var store_id = params.store_id,
	          station_id = params.station_id;
	
	
	      var isKds = !station_type;
	
	      if (isKds) {
	        getDepartments(store_id);
	        getLineItemStatuses(store_id);
	      }
	
	      if (!station.station_key) {
	        getStation(station_id, store_id).then(function (result) {
	          var station = result.station,
	              error = result.error;
	
	          if (!error) {
	            stationOverviewActions.showStationOverview(station);
	          }
	        });
	      } else {
	        stationOverviewActions.showStationOverview(station);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          params = _props3.params,
	          kdsStatus = _props3.kdsStatus,
	          overviewState = _props3.overviewState,
	          stationOverviewActions = _props3.stationOverviewActions,
	          departmentSelectionState = _props3.departmentSelectionState,
	          kitchenDepartmentSelectionState = _props3.kitchenDepartmentSelectionState,
	          departmentSelectionActions = _props3.departmentSelectionActions,
	          kitchenDepartmentSelectionActions = _props3.kitchenDepartmentSelectionActions,
	          statusSelectionState = _props3.statusSelectionState,
	          statusSelectionActions = _props3.statusSelectionActions;
	      var store_id = params.store_id;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(_selectDepartment2.default, _extends({}, departmentSelectionState, departmentSelectionActions)),
	          _react2.default.createElement(_selectKitchenDepartment2.default, _extends({}, kitchenDepartmentSelectionState, kitchenDepartmentSelectionActions)),
	          _react2.default.createElement(_selectStatus2.default, _extends({ store_id: store_id }, statusSelectionState, statusSelectionActions)),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-tab' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'nav nav-tabs' },
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'nav-link active' },
	                  'Overview'
	                )
	              )
	            )
	          ),
	          kdsStatus.loading ? _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading...'
	          ) : _react2.default.createElement(_overviewForm2.default, _extends({ openDepartmentSelection: departmentSelectionActions.openDepartmentSelection.bind(this, params.store_id),
	            openKitchenDepartmentSelection: kitchenDepartmentSelectionActions.openKitchenDepartmentSelection.bind(this, params.store_id),
	            openStatusSelection: statusSelectionActions.openStatusSelection,
	            store_id: store_id,
	            discard: this.goBack
	          }, overviewState, stationOverviewActions))
	        )
	      );
	    }
	  }]);
	
	  return SettingsBusinessKdsItem;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  kdsStatus: _propTypes2.default.object.isRequired,
	  departments: _propTypes2.default.array.isRequired,
	  station: _propTypes2.default.object.isRequired,
	  overviewState: _propTypes2.default.object.isRequired,
	  departmentSelectionState: _propTypes2.default.object.isRequired,
	  kitchenDepartmentSelectionState: _propTypes2.default.object.isRequired,
	  statusSelectionState: _propTypes2.default.object.isRequired,
	
	  getStation: _propTypes2.default.func.isRequired,
	  getDepartments: _propTypes2.default.func.isRequired,
	  getLineItemStatuses: _propTypes2.default.func.isRequired,
	  departmentSelectionActions: _propTypes2.default.object.isRequired,
	  kitchenDepartmentSelectionActions: _propTypes2.default.object.isRequired,
	  statusSelectionActions: _propTypes2.default.object.isRequired,
	  stationOverviewActions: _propTypes2.default.object.isRequired
	}, _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsBusinessKdsItem);

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _actions = __webpack_require__(41);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit;
	  var _props$fields = props.fields,
	      highlight = _props$fields.highlight,
	      policy = _props$fields.policy;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      _formGroup2.default,
	      { label: 'Store Highlight' },
	      _react2.default.createElement('textarea', {
	        className: 'form-control',
	        onChange: highlight.onChange,
	        value: highlight.value })
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      { label: 'Return and Exchange Policy' },
	      _react2.default.createElement('textarea', {
	        className: 'form-control',
	        onChange: policy.onChange,
	        value: policy.value })
	    )
	  );
	}
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'store_policy',
	  fields: ['highlight', 'policy']
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStorePolicy: _actions.getStorePolicy, updateStore: _actions.updateStore, alert: _actions.alert };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var Policies = (_temp2 = _class = function (_Component) {
	  _inherits(Policies, _Component);
	
	  function Policies() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Policies);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Policies.__proto__ || Object.getPrototypeOf(Policies)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var _this$props$actions = _this.props.actions,
	          updateStore = _this$props$actions.updateStore,
	          alert = _this$props$actions.alert;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStore(store_id, { store_attributes: data }).then(function () {
	        alert('success', 'Policies setting saved.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Policies, [{
	    key: 'render',
	    value: function render() {
	      var currentStore = this.context.currentStore;
	
	
	      var initialValues = {
	        highlight: currentStore.highlight,
	        policy: currentStore.policy
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Policies'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', initialValues: initialValues, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Policies;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  associates: _propTypes2.default.array
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Policies);

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _actions = __webpack_require__(41);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROUNDING_BEHAVIOR = {
	  1: 'Normal Rounding',
	  2: 'Rounding Up',
	  3: 'Rounding Down',
	  4: 'Round To Nearest Five'
	};
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit;
	  var _props$fields = props.fields,
	      rounding_type = _props$fields.rounding_type,
	      decimal_points = _props$fields.decimal_points;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      _formGroup2.default,
	      { label: 'Behavior' },
	      _react2.default.createElement(
	        'select',
	        {
	          className: 'form-control',
	          onChange: rounding_type.onChange,
	          value: rounding_type.value },
	        (0, _map2.default)(ROUNDING_BEHAVIOR, function (behavior, key) {
	          return _react2.default.createElement(
	            'option',
	            { key: key, value: key },
	            behavior
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _formGroup2.default,
	      { label: 'Demical Points' },
	      _react2.default.createElement('input', { type: 'text',
	        className: 'form-control',
	        onChange: decimal_points.onChange,
	        value: decimal_points.value })
	    )
	  );
	}
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'SettingsStorecredits',
	  fields: ['rounding_type', 'decimal_points']
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStoreModule: _actions.getStoreModule, updateStoreModule: _actions.updateStoreModule, alert: _actions.alert };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var RoundingBehavior = (_temp2 = _class = function (_Component) {
	  _inherits(RoundingBehavior, _Component);
	
	  function RoundingBehavior() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoundingBehavior);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoundingBehavior.__proto__ || Object.getPrototypeOf(RoundingBehavior)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var _this$props$actions = _this.props.actions,
	          updateStoreModule = _this$props$actions.updateStoreModule,
	          alert = _this$props$actions.alert;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStoreModule(store_id, { store_id: store_id, module: data }).then(function () {
	        alert('success', 'Rounding Behavior setting saved.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoundingBehavior, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var getStoreModule = this.props.actions.getStoreModule;
	
	
	      getStoreModule(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var module = this.context.currentStore.module;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Rounding Behavior'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', initialValues: module, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RoundingBehavior;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoundingBehavior);

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tableSizeSegmentation = __webpack_require__(462);
	
	var actions = _interopRequireWildcard(_tableSizeSegmentation);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _tableType = __webpack_require__(910);
	
	var _tableType2 = _interopRequireDefault(_tableType);
	
	var _linkDisplay = __webpack_require__(909);
	
	var _linkDisplay2 = _interopRequireDefault(_linkDisplay);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsBusinessTableSizingSegmentation = (_temp2 = _class = function (_Component) {
	  _inherits(SettingsBusinessTableSizingSegmentation, _Component);
	
	  function SettingsBusinessTableSizingSegmentation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingsBusinessTableSizingSegmentation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsBusinessTableSizingSegmentation.__proto__ || Object.getPrototypeOf(SettingsBusinessTableSizingSegmentation)).call.apply(_ref, [this].concat(args))), _this), _this.timeFormatter = function (value) {
	      var timezine = _this.context.currentStore && _this.context.currentStore.timezone;
	      return (0, _formatHelper.dateTime)(value, timezine);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingsBusinessTableSizingSegmentation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	
	      this.props.actions.open(store_id);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.close();
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _props = this.props,
	          editMode = _props.editMode,
	          items = _props.items,
	          actions = _props.actions;
	
	      var prev = 0;
	      return items.map(function (item, i) {
	        var min = prev;
	        var label = item.label,
	            minimumPartySize = item.minimumPartySize;
	
	        prev = minimumPartySize + 1;
	        return _react2.default.createElement(_tableType2.default, { label: label,
	          key: i,
	          size: minimumPartySize,
	          onNameChange: function onNameChange(name) {
	            return actions.changeTypeName(name, i);
	          },
	          onRemove: function onRemove() {
	            return actions.removeTableType(i);
	          },
	          onSizeChange: function onSizeChange(size) {
	            return actions.changeTableSize(size, i);
	          },
	          disabled: !editMode,
	          min: min });
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props2 = this.props,
	          editMode = _props2.editMode,
	          enableDailyRestart = _props2.enableDailyRestart,
	          actions = _props2.actions,
	          updatedAt = _props2.updatedAt,
	          isModalOpen = _props2.isModalOpen,
	          linkSuccess = _props2.linkSuccess,
	          isLinking = _props2.isLinking,
	          linkError = _props2.linkError,
	          items = _props2.items;
	
	
	      var typeLen = items ? items.length : 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(_linkDisplay2.default, { isOpen: isModalOpen,
	            isSubmitting: isLinking,
	            success: linkSuccess,
	            failure: linkError,
	            onSubmit: actions.submitLinkUp,
	            onRequestClose: actions.closeLinkUpQueueDisplayModal }),
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              !isModalOpen && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-sm', onClick: actions.openLinkUpQueueDisplayModal },
	                'Link Up Bindo Display'
	              ),
	              editMode && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: actions.submit },
	                'Save'
	              ),
	              !editMode && _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: function onClick() {
	                    return actions.changeTableSizeSegmentationEditMode(true);
	                  } },
	                'Edit'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Table Size Segmentation'
	            ),
	            this.renderItems(),
	            typeLen < 4 && _react2.default.createElement(
	              'a',
	              { className: (0, _classnames2.default)('_add', { '__disabled': !editMode }), onClick: editMode ? actions.addTableType : function () {} },
	              _react2.default.createElement('i', { className: 'fa fa-plus-circle' }),
	              ' Add Table Type'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Setting'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('input', { type: 'checkbox',
	                  value: '1',
	                  checked: enableDailyRestart,
	                  disabled: !editMode,
	                  onChange: function onChange(e) {
	                    return actions.changeRestartEnable(e.target.checked);
	                  } }),
	                ' Daily Queue Count Restart'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Last update: ',
	                this.timeFormatter(updatedAt)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isLoading = this.props.isLoading;
	      // let isLoading = true;
	
	      return isLoading ? _react2.default.createElement(
	        _loading2.default,
	        null,
	        'Loading Settings'
	      ) : this.renderContent();
	    }
	  }]);
	
	  return SettingsBusinessTableSizingSegmentation;
	}(_react.Component), _class.propTypes = {
	  editMode: _propTypes2.default.bool.isRequired,
	  items: _propTypes2.default.array.isRequired,
	  enableDailyRestart: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isCreating: _propTypes2.default.bool.isRequired,
	  loadingError: _propTypes2.default.string.isRequired,
	  isSubmitting: _propTypes2.default.bool.isRequired,
	  isRefreshing: _propTypes2.default.bool.isRequired,
	  updatedAt: _propTypes2.default.string.isRequired,
	  isModalOpen: _propTypes2.default.bool.isRequired,
	  isLinking: _propTypes2.default.bool.isRequired,
	  linkSuccess: _propTypes2.default.bool.isRequired,
	  linkError: _propTypes2.default.bool.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	function mapStateToProps(state) {
	  return state.forms.tableSizeSegmentation;
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsBusinessTableSizingSegmentation);

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(91);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkDisplayModal = (_temp = _class = function (_Modal) {
	  _inherits(LinkDisplayModal, _Modal);
	
	  function LinkDisplayModal(props) {
	    _classCallCheck(this, LinkDisplayModal);
	
	    var _this = _possibleConstructorReturn(this, (LinkDisplayModal.__proto__ || Object.getPrototypeOf(LinkDisplayModal)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.state = {
	      stationKey: ''
	    };
	    return _this;
	  }
	
	  _createClass(LinkDisplayModal, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var onSubmit = this.props.onSubmit;
	
	      onSubmit(this.state.stationKey);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ stationKey: event.target.value });
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          onRequestClose = _props.onRequestClose,
	          success = _props.success,
	          failure = _props.failure;
	      var stationKey = this.state.stationKey;
	
	
	      return _react2.default.createElement(
	        _modal.ModalContainer,
	        null,
	        _react2.default.createElement(_modal.ModalHeader, { title: 'LINK UP BINDO DISPLAY', onRequestClose: onRequestClose }),
	        _react2.default.createElement(
	          _modal.ModalContent,
	          null,
	          _react2.default.createElement(_inputBox2.default, { title: 'Enter the Bindo Display key shown on the Bindo Display screen',
	            type: 'text',
	            value: stationKey,
	            failure: failure,
	            success: success,
	            placeholder: '',
	            containerClass: '_long',
	            onChange: this.handleChange })
	        ),
	        _react2.default.createElement(
	          _modal.ModalBottom,
	          null,
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm',
	              onClick: this.handleSubmit },
	            'Add'
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkDisplayModal;
	}(_modal.Modal), _class.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  onRequestClose: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  success: _propTypes2.default.bool.isRequired,
	  failure: _propTypes2.default.bool.isRequired
	}, _temp);
	exports.default = LinkDisplayModal;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	var _inputSelectBox = __webpack_require__(232);
	
	var _inputSelectBox2 = _interopRequireDefault(_inputSelectBox);
	
	__webpack_require__(1278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function optionsFactroy(min) {
	  var options = [];
	  for (var i = 1; i < 21; i++) {
	    options.push({ label: i + '+', value: i, disabled: i < min });
	  }
	  return options;
	}
	
	var TableType = (_temp = _class = function (_Component) {
	  _inherits(TableType, _Component);
	
	  function TableType() {
	    _classCallCheck(this, TableType);
	
	    return _possibleConstructorReturn(this, (TableType.__proto__ || Object.getPrototypeOf(TableType)).apply(this, arguments));
	  }
	
	  _createClass(TableType, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          size = _props.size,
	          disabled = _props.disabled,
	          onNameChange = _props.onNameChange,
	          onSizeChange = _props.onSizeChange,
	          min = _props.min,
	          onRemove = _props.onRemove;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row table-type' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4' },
	          _react2.default.createElement(_inputBox2.default, { title: 'Table Type Name', value: label, disabled: disabled, onChange: function onChange(e) {
	              return onNameChange(e.target.value);
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-2' },
	          _react2.default.createElement(_inputSelectBox2.default, { value: size,
	            valueRenderer: function valueRenderer(opt) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                opt.value,
	                ' + People'
	              );
	            },
	            title: 'Table Size',
	            placeholder: 'Select size',
	            resetValue: undefined,
	            clearable: false,
	            disabled: disabled,
	            onChange: function onChange(opt) {
	              return onSizeChange(opt.value);
	            },
	            options: optionsFactroy(min) })
	        ),
	        !disabled && _react2.default.createElement(
	          'div',
	          { className: 'table-type_remove' },
	          _react2.default.createElement(
	            'a',
	            { className: 'btn btn-primary btn-sm', onClick: onRemove },
	            'Remove'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableType;
	}(_react.Component), _class.propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  size: _propTypes2.default.number.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  onNameChange: _propTypes2.default.func.isRequired,
	  onSizeChange: _propTypes2.default.func.isRequired,
	  onRemove: _propTypes2.default.func.isRequired,
	  min: _propTypes2.default.number.isRequired
	}, _temp);
	exports.default = TableType;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _tableActions = __webpack_require__(469);
	
	var actions = _interopRequireWildcard(_tableActions);
	
	var _mainContent = __webpack_require__(190);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _mainContentHeader = __webpack_require__(188);
	
	var _mainContentHeader2 = _interopRequireDefault(_mainContentHeader);
	
	var _mainContentSection = __webpack_require__(189);
	
	var _mainContentSection2 = _interopRequireDefault(_mainContentSection);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _inputNumber = __webpack_require__(154);
	
	var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsBusinessTable = (_temp2 = _class = function (_Component) {
	  _inherits(SettingsBusinessTable, _Component);
	
	  function SettingsBusinessTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingsBusinessTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsBusinessTable.__proto__ || Object.getPrototypeOf(SettingsBusinessTable)).call.apply(_ref, [this].concat(args))), _this), _this.save = function () {
	      var _this$context$current = _this.context.currentStore,
	          currentStore = _this$context$current === undefined ? {} : _this$context$current;
	      var _currentStore$module = currentStore.module,
	          module = _currentStore$module === undefined ? {} : _currentStore$module;
	      var default_table_turn_time = module.default_table_turn_time;
	      var _this$props = _this.props,
	          _this$props$actions = _this$props.actions,
	          actions = _this$props$actions === undefined ? {} : _this$props$actions,
	          _this$props$pathState = _this$props.pathState,
	          pathState = _this$props$pathState === undefined ? {} : _this$props$pathState;
	      var storeId = pathState.storeId,
	          defaultTableTurnTime = pathState.defaultTableTurnTime;
	
	      actions.save(storeId, default_table_turn_time, defaultTableTurnTime);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingsBusinessTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	
	      this.props.actions.init(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$currentStore = this.context.currentStore,
	          currentStore = _context$currentStore === undefined ? {} : _context$currentStore;
	      var _currentStore$module2 = currentStore.module,
	          module = _currentStore$module2 === undefined ? {} : _currentStore$module2;
	      var initDefaultTableTurnTime = module.default_table_turn_time;
	      var _props = this.props,
	          _props$pathState = _props.pathState,
	          pathState = _props$pathState === undefined ? {} : _props$pathState,
	          _props$actions = _props.actions,
	          actions = _props$actions === undefined ? {} : _props$actions,
	          loading = _props.loading;
	      var defaultTableTurnTime = pathState.defaultTableTurnTime;
	
	      return _react2.default.createElement(
	        _mainContent2.default,
	        null,
	        _react2.default.createElement(
	          _mainContentHeader2.default,
	          { title: 'Table' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary btn-sm',
	              disabled: loading || defaultTableTurnTime == null,
	              onClick: this.save },
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          _mainContentSection2.default,
	          null,
	          _react2.default.createElement(
	            _formGroup2.default,
	            { className: 'w-30', label: 'Default Table Seat Time', autoHideHelpText: true },
	            _react2.default.createElement(_inputNumber2.default, {
	              value: defaultTableTurnTime == null ? initDefaultTableTurnTime : defaultTableTurnTime,
	              dp: 0,
	              suffix: ' min',
	              onChange: function onChange(v) {
	                return actions.updateField('defaultTableTurnTime', v);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingsBusinessTable;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  pathState: _propTypes2.default.object.isRequired,
	  loading: _propTypes2.default.bool.isRequired
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var appState = state;
	  var _state$table = state.table,
	      pathState = _state$table === undefined ? {} : _state$table;
	  var loading = state.base.loading;
	
	  var ret = Object.assign({}, props, { appState: appState, pathState: pathState, loading: loading });
	  return ret;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(actions, dispatch) };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SettingsBusinessTable);

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uom = __webpack_require__(913);
	
	var _uom2 = _interopRequireDefault(_uom);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverviewForm = (_temp = _class = function (_Component) {
	  _inherits(OverviewForm, _Component);
	
	  function OverviewForm() {
	    _classCallCheck(this, OverviewForm);
	
	    return _possibleConstructorReturn(this, (OverviewForm.__proto__ || Object.getPrototypeOf(OverviewForm)).apply(this, arguments));
	  }
	
	  _createClass(OverviewForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          groupName = _props.groupName,
	          editMode = _props.editMode,
	          isCreating = _props.isCreating,
	          actions = _props.actions,
	          referenceUnit = _props.referenceUnit,
	          units = _props.units;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            ' '
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: actions.submit },
	              'Save'
	            ),
	            !editMode && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: actions.enableEditMode },
	              'Edit'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(_inputBox2.default, { title: 'GROUP NAME',
	            value: groupName,
	            disabled: !editMode,
	            onChange: function onChange(e) {
	              return actions.changeGroupName(e.target.value);
	            } }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Reference Unit'
	          ),
	          _react2.default.createElement(_uom2.default, { name: referenceUnit.name,
	            ratio: referenceUnit.ratio,
	            isBaseUnit: true,
	            onNameChange: function onNameChange(val) {
	              return actions.changeUnitName(val, undefined);
	            },
	            onRatioChange: function onRatioChange(val) {
	              return actions.changeUnitRatio(val, undefined);
	            },
	            disabled: !editMode || !isCreating })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Uom Group'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            units.map(function (group, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', key: i },
	                _react2.default.createElement(_uom2.default, { name: group.name,
	                  ratio: group.ratio,
	                  onNameChange: function onNameChange(val) {
	                    return actions.changeUnitName(val, i);
	                  },
	                  onRatioChange: function onRatioChange(val) {
	                    return actions.changeUnitRatio(val, i);
	                  },
	                  onRemove: function onRemove() {
	                    return actions.removeUnit(i);
	                  },
	                  disabled: !editMode })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: (0, _classnames2.default)('_add', { '__disabled': !editMode }), onClick: editMode ? actions.addUomUnit : function () {} },
	            _react2.default.createElement('i', { className: 'fa fa-plus-circle' }),
	            ' Add New Unit'
	          )
	        )
	      );
	    }
	  }]);
	
	  return OverviewForm;
	}(_react.Component), _class.propTypes = {
	  groupName: _propTypes2.default.string.isRequired,
	  units: _propTypes2.default.array.isRequired,
	  referenceUnit: _propTypes2.default.object.isRequired,
	
	  editMode: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isCreating: _propTypes2.default.bool.isRequired,
	  isSubmitting: _propTypes2.default.bool.isRequired,
	
	  actions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = OverviewForm;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _removeButton = __webpack_require__(476);
	
	var _removeButton2 = _interopRequireDefault(_removeButton);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import InputSuggest from '~/components/input-select';
	
	// const UNITS = [
	//   { label: 'cup', value: 'cup' },
	//   { label: 'doz', value: 'doz' },
	//   { label: 'drop(s)', value: 'drop(s)' },
	//   { label: 'ea', value: 'ea' },
	//   { label: 'g', value: 'g' },
	//   { label: 'gal', value: 'gal' },
	//   { label: 'kg', value: 'kg' },
	//   { label: 'L', value: 'L' },
	//   { label: 'lb', value: 'lb' },
	//   { label: 'oz', value: 'oz' },
	//   { label: 'qt dry', value: 'qt dry' },
	//   { label: 'qt liquid', value: 'qt liquid' },
	//   { label: 'pc(s)', value: 'pc(s)' },
	//   { label: 'tsp', value: 'tsp' },
	//   { label: 'ton', value: 'ton' }
	// ];
	
	// const getSuggestions = value => {
	//   const inputValue = value.trim().toLowerCase();
	//   const inputLength = inputValue.length;
	//
	//   return inputLength === 0 ? UNITS : UNITS.filter(unit =>
	//     unit.label.toLowerCase().slice(0, inputLength) === inputValue
	//   );
	// };
	
	var Uom = (_temp = _class = function (_Component) {
	  _inherits(Uom, _Component);
	
	  function Uom() {
	    _classCallCheck(this, Uom);
	
	    return _possibleConstructorReturn(this, (Uom.__proto__ || Object.getPrototypeOf(Uom)).apply(this, arguments));
	  }
	
	  _createClass(Uom, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          ratio = _props.ratio,
	          disabled = _props.disabled,
	          onNameChange = _props.onNameChange,
	          onRatioChange = _props.onRatioChange,
	          onRemove = _props.onRemove,
	          isBaseUnit = _props.isBaseUnit;
	
	
	      var removeable = typeof onRemove === 'function';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row table-type' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3' },
	          _react2.default.createElement(_inputBox2.default, { title: 'UNIT NAME',
	            value: name,
	            disabled: disabled,
	            onChange: function onChange(e) {
	              return onNameChange(e.target.value);
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-2' },
	          _react2.default.createElement(_inputBox2.default, { title: 'RATIO',
	            type: 'number',
	            step: '0.0001',
	            min: '1',
	            value: ratio,
	            disabled: disabled || isBaseUnit,
	            onChange: function onChange(e) {
	              return onRatioChange(e.target.value);
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-1' },
	          !disabled && removeable && _react2.default.createElement(_removeButton2.default, { onClick: onRemove })
	        )
	      );
	    }
	  }]);
	
	  return Uom;
	}(_react.Component), _class.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  ratio: _propTypes2.default.number.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  isBaseUnit: _propTypes2.default.bool,
	
	  onRemove: _propTypes2.default.func,
	  onNameChange: _propTypes2.default.func.isRequired,
	  onRatioChange: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	  isBaseUnit: false
	}, _temp);
	exports.default = Uom;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _pick = __webpack_require__(213);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _keys = __webpack_require__(141);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _cloneDeep = __webpack_require__(279);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _grid = __webpack_require__(66);
	
	var _reactRouter = __webpack_require__(9);
	
	var _uomGroupActions = __webpack_require__(311);
	
	var actions = _interopRequireWildcard(_uomGroupActions);
	
	var _formatHelper = __webpack_require__(35);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UomGroupIndex = (_temp = _class = function (_Component) {
	  _inherits(UomGroupIndex, _Component);
	
	  function UomGroupIndex(props) {
	    _classCallCheck(this, UomGroupIndex);
	
	    var _this = _possibleConstructorReturn(this, (UomGroupIndex.__proto__ || Object.getPrototypeOf(UomGroupIndex)).call(this, props));
	
	    _this.handleCreate = function () {
	      var store_id = _this.props.params.store_id;
	
	      _routeHelper2.default.goUomGroups(store_id, 'new');
	    };
	
	    _this.state = {
	      isLoading: true
	    };
	
	    _this.gridActions = [{
	      name: 'View', onClick: function onClick(item) {
	        var id = item.id;
	        var store_id = _this.props.params.store_id;
	
	        _routeHelper2.default.goUomGroups(store_id, id);
	      }
	    }, {
	      name: 'Delete', onClick: function onClick(item) {
	        if (!confirm('Do you really want to delete this item?')) return false;
	        _this.props.removeGroup(item.id, _this.props.params.store_id).then(function (resp) {
	          var error = resp.error;
	
	          if (error) alert(error.message);
	        });
	      }
	    }];
	
	    _this.columnMetadatas = [{
	      columnName: "name",
	      displayName: "GROUP NAME",
	      filterConditions: ['contain', 'equal'],
	      customComponent: function customComponent(props) {
	        var rowData = props.rowData,
	            data = props.data; //eslint-disable-line react/prop-types
	
	        var id = rowData.id;
	        var store_id = _this.props.params.store_id;
	
	        var path = _routeHelper2.default.uomGroups(store_id, id);
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: path },
	          data
	        );
	      }
	    }, {
	      columnName: "updatedAt",
	      displayName: "LAST UPDATE",
	      filterConditions: ['equal'],
	      customComponent: function customComponent(props) {
	        var data = props.data; //eslint-disable-line react/prop-types
	
	        var timezine = _this.context.currentStore && _this.context.currentStore.timezone;
	        return _react2.default.createElement(
	          'span',
	          null,
	          (0, _formatHelper.dateTime)(data, timezine)
	        );
	      }
	    }];
	
	    _this.filterSettings = _this.columnMetadatas.map(function (column) {
	      return (0, _pick2.default)(column, 'columnName', 'displayName', 'filterConditions');
	    });
	    return _this;
	  }
	
	  _createClass(UomGroupIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var store_id = this.props.params.store_id;
	
	      this.props.getGroups(store_id).then(function (resp) {
	        var error = resp.error;
	
	        if (error) alert(error.message);
	        _this2.setState({ isLoading: false }); // eslint-disable-line react/no-did-mount-set-state
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      var isLoading = this.state.isLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-sm', onClick: this.handleCreate },
	            'New'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            isLoading ? _react2.default.createElement(
	              _loading2.default,
	              null,
	              'Loading ...'
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'grid' },
	              _react2.default.createElement(_grid.GridBody, { data: (0, _cloneDeep2.default)(data),
	                actions: this.gridActions,
	                columns: this.columnMetadatas })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UomGroupIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  getGroups: _propTypes2.default.func.isRequired,
	  removeGroup: _propTypes2.default.func.isRequired
	}, _temp);
	
	
	function mapStateToProps(state) {
	  var data = [];
	  if (state.entities.uomGroups) {
	    (0, _keys2.default)(state.entities.uomGroups).forEach(function (key) {
	      data.push(state.entities.uomGroups[key]);
	    });
	  }
	  return { data: data };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    getGroups: (0, _redux.bindActionCreators)(actions.getGroups, dispatch),
	    removeGroup: (0, _redux.bindActionCreators)(actions.remove, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UomGroupIndex);

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(5);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _overviewForm = __webpack_require__(912);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _uomGroupOverview = __webpack_require__(463);
	
	var actions = _interopRequireWildcard(_uomGroupOverview);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UomGroupItem = (_temp = _class = function (_Component) {
	  _inherits(UomGroupItem, _Component);
	
	  function UomGroupItem() {
	    _classCallCheck(this, UomGroupItem);
	
	    return _possibleConstructorReturn(this, (UomGroupItem.__proto__ || Object.getPrototypeOf(UomGroupItem)).apply(this, arguments));
	  }
	
	  _createClass(UomGroupItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var params = this.props.params;
	      var store_id = params.store_id,
	          uom_group_id = params.uom_group_id;
	
	      this.props.actions.open(store_id, uom_group_id);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.actions.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          params = _props.params,
	          overviewState = _props.overviewState,
	          actions = _props.actions;
	      var store_id = params.store_id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-tab' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'nav nav-tabs' },
	              _react2.default.createElement(
	                'li',
	                { className: 'nav-item' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'nav-link active' },
	                  'Overview'
	                )
	              )
	            )
	          ),
	          overviewState.isLoading ? _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading Settings...'
	          ) : _react2.default.createElement(_overviewForm2.default, _extends({ store_id: store_id,
	            discard: function discard() {},
	            actions: actions
	          }, overviewState))
	        )
	      );
	    }
	  }]);
	
	  return UomGroupItem;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired,
	  overviewState: _propTypes2.default.object.isRequired
	}, _temp);
	
	
	function mapStateToProps(state) {
	  return {
	    overviewState: state.forms.uomOverview
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UomGroupItem);

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _uniqueId = __webpack_require__(114);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentEdit(props) {
	  var handleSubmit = props.handleSubmit;
	  var payment_instruments = props.fields.payment_instruments;
	
	
	  function addPayment() {
	    payment_instruments.addField({ _id: (0, _uniqueId2.default)() });
	  }
	  function removePayment(index) {
	    payment_instruments.removeField(index);
	  }
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      'table',
	      { className: 'table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Payment Type'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Tipping Enabled'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Shortcut in Register Page'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Fixed Payment Amount'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Reference Number Format'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        payment_instruments ? payment_instruments.map(function (p, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: p.id.value || p._id.value },
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement('input', {
	                className: 'form-control',
	                type: 'text',
	                placeholder: 'Enter payment\'s name',
	                value: p.name.value,
	                disabled: p.id.value,
	                onChange: p.name.onChange })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: p.tipping_enabled.checked, onChange: p.tipping_enabled.onChange })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: p.shortcut_enabled.checked, onChange: p.shortcut_enabled.onChange })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement('input', { type: 'checkbox', checked: p.fixed_amount_enabled.checked, onChange: p.fixed_amount_enabled.onChange, style: { marginRight: 10 } }),
	              _react2.default.createElement('input', { type: 'number', value: p.fixed_amount.value, onChange: p.fixed_amount.onChange, disabled: !p.fixed_amount_enabled.checked })
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'select',
	                { value: p.reference_number_id.value, onChange: p.reference_number_id.onChange },
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  'Default'
	                ),
	                props.refFormats.map(function (ref) {
	                  return _react2.default.createElement(
	                    'option',
	                    {
	                      key: ref.id,
	                      value: ref.id },
	                    ref.name,
	                    '(',
	                    ref.format,
	                    ')'
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _actionButton2.default,
	                { type: 'delete', onClick: removePayment.bind(null, index) },
	                'remove'
	              )
	            )
	          );
	        }) : null
	      )
	    ),
	    _react2.default.createElement(
	      _actionButton2.default,
	      { type: 'add', onClick: addPayment },
	      'Create New Payment Type'
	    )
	  );
	}
	PaymentEdit.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func,
	  refFormats: _propTypes2.default.array
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'paymentType',
	  fields: ['payment_instruments[]._id', 'payment_instruments[].id', 'payment_instruments[].name', 'payment_instruments[].tipping_enabled', 'payment_instruments[].fixed_amount_enabled', 'payment_instruments[].fixed_amount', 'payment_instruments[].reference_number_id', 'payment_instruments[].room_number', 'payment_instruments[].shortcut_enabled', 'payment_instruments[].to_pms_enabled']
	})(PaymentEdit);

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentView(props) {
	  var data = props.data,
	      refFormats = props.refFormats;
	
	
	  return _react2.default.createElement(
	    'table',
	    { className: 'table' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Payment Type'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Tipping Enabled'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Shortcut in Register Page'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Fixed Payment Amount'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Reference Number Format'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      data ? data.map(function (payment) {
	        var refFormat = refFormats.find(function (_ref) {
	          var id = _ref.id;
	          return id === payment.reference_number_id;
	        });
	        return _react2.default.createElement(
	          'tr',
	          { key: payment.id },
	          _react2.default.createElement(
	            'td',
	            null,
	            payment.name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            payment.tipping_enabled ? _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              'Enabled'
	            ) : _react2.default.createElement(
	              'span',
	              { className: 'label label-default' },
	              'off'
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            payment.shortcut_enabled ? _react2.default.createElement(
	              'span',
	              { className: 'label label-success' },
	              'Enabled'
	            ) : _react2.default.createElement(
	              'span',
	              { className: 'label label-default' },
	              'off'
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            payment.fixed_amount_enabled ? payment.fixed_amount : _react2.default.createElement(
	              'span',
	              { className: 'label label-default' },
	              'off'
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            refFormat ? refFormat.name + ' (' + refFormat.format + ')' : _react2.default.createElement(
	              'span',
	              { className: 'label label-default' },
	              'Default'
	            )
	          )
	        );
	      }) : null
	    )
	  );
	}
	PaymentView.propTypes = {
	  data: _propTypes2.default.array,
	  refFormats: _propTypes2.default.array
	};
	
	exports.default = PaymentView;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _actions = __webpack_require__(41);
	
	var _paymentTypeEdit = __webpack_require__(916);
	
	var _paymentTypeEdit2 = _interopRequireDefault(_paymentTypeEdit);
	
	var _paymentTypeView = __webpack_require__(917);
	
	var _paymentTypeView2 = _interopRequireDefault(_paymentTypeView);
	
	var _referenceFormatService = __webpack_require__(495);
	
	var _referenceFormatService2 = _interopRequireDefault(_referenceFormatService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var pathname = ownProps.location.pathname;
	  var pathState = state.path[pathname] || {};
	  var pageState = {};
	
	  try {
	    pageState.payment_instruments = (0, _map2.default)(pathState.payment_instruments, function (paymentId) {
	      return state.entities.payment_instruments[paymentId];
	    });
	  } catch (e) {
	    console.warn('payment_instruments not ready');
	    pageState.payment_instruments = null;
	  }
	
	  return pageState;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getOtherPaymentInstrument: _actions.getOtherPaymentInstrument, updateOtherPaymentInstrument: _actions.updateOtherPaymentInstrument };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var PaymentType = (_temp2 = _class = function (_Component) {
	  _inherits(PaymentType, _Component);
	
	  function PaymentType() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PaymentType);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentType.__proto__ || Object.getPrototypeOf(PaymentType)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      editMode: false,
	      refFormats: []
	    }, _this.enterEditMode = function () {
	      _this.setState({ editMode: true });
	    }, _this.exitEditMode = function () {
	      _this.setState({ editMode: false });
	    }, _this.submitForm = function () {
	      _this.refs.paymentForm.submit();
	    }, _this.updatePayment = function (data) {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          location = _this$props.location,
	          actions = _this$props.actions;
	
	      data.payment_instruments.forEach(function (p) {
	        if (typeof p.reference_number_id === 'string') {
	          p.reference_number_id = parseInt(p.reference_number_id);
	        }
	      });
	      actions.updateOtherPaymentInstrument(params.store_id, data, location.pathname).then(function (res) {
	        _this.exitEditMode();
	      });
	    }, _this.updateSettings = function (data) {
	      var updateStoreModule = _this.props.actions.updateStoreModule;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStoreModule(store_id, { store_id: store_id, module: data });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PaymentType, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          location = _props.location,
	          actions = _props.actions;
	
	      actions.getOtherPaymentInstrument(params.store_id, location.pathname);
	      this.fetchRefFormats();
	    }
	  }, {
	    key: 'fetchRefFormats',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var refFormats;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ loading: true });
	                _context.prev = 1;
	                _context.next = 4;
	                return _referenceFormatService2.default.getAll(this.props.params.store_id);
	
	              case 4:
	                refFormats = _context.sent;
	
	                this.setState({ refFormats: refFormats });
	                _context.next = 11;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context['catch'](1);
	
	                this.setState({ error: _context.t0 });
	
	              case 11:
	                _context.prev = 11;
	
	                this.setState({ loading: false });
	                return _context.finish(11);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 8, 11, 14]]);
	      }));
	
	      function fetchRefFormats() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return fetchRefFormats;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var payment_instruments = this.props.payment_instruments;
	      var refFormats = this.state.refFormats;
	
	
	      var formInitialValues = { payment_instruments: payment_instruments };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Payment Type'
	            ),
	            this.state.editMode ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-sm', onClick: this.exitEditMode },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.enterEditMode },
	                'Edit'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            this.state.editMode ? _react2.default.createElement(_paymentTypeEdit2.default, { initialValues: formInitialValues, ref: 'paymentForm', onSubmit: this.updatePayment, refFormats: refFormats }) : _react2.default.createElement(_paymentTypeView2.default, { data: payment_instruments, refFormats: refFormats })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentType;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  payment_instruments: _propTypes2.default.array
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentType);

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _actions = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit;
	  var signature_from_zero_enabled = props.fields.signature_from_zero_enabled;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          onChange: signature_from_zero_enabled.onChange,
	          checked: signature_from_zero_enabled.checked }),
	        ' Require signature for orders below $20.00'
	      )
	    )
	  );
	}
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'SettingsStorecredits',
	  fields: ['signature_from_zero_enabled']
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStoreModule: _actions.getStoreModule, updateStoreModule: _actions.updateStoreModule };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var Signature = (_temp2 = _class = function (_Component) {
	  _inherits(Signature, _Component);
	
	  function Signature() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Signature);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Signature.__proto__ || Object.getPrototypeOf(Signature)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var updateStoreModule = _this.props.actions.updateStoreModule;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStoreModule(store_id, { store_id: store_id, module: data });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Signature, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var getStoreModule = this.props.actions.getStoreModule;
	
	
	      getStoreModule(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var module = this.context.currentStore.module;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Store Credit'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', initialValues: module, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Signature;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Signature);

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(25);
	
	var _actions = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formComponent(props) {
	  var handleSubmit = props.handleSubmit;
	  var _props$fields = props.fields,
	      store_credit_enabled = _props$fields.store_credit_enabled,
	      gift_card_enabled = _props$fields.gift_card_enabled;
	
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', onChange: store_credit_enabled.onChange, checked: store_credit_enabled.checked }),
	        ' Enable Store Credit'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', onChange: gift_card_enabled.onChange, checked: gift_card_enabled.checked }),
	        ' Enable Gift Card'
	      )
	    )
	  );
	}
	formComponent.propTypes = {
	  fields: _propTypes2.default.object,
	  handleSubmit: _propTypes2.default.func
	};
	
	var SettingsForm = (0, _reduxForm.reduxForm)({
	  form: 'SettingsStorecredits',
	  fields: ['store_credit_enabled', 'gift_card_enabled']
	})(formComponent);
	
	function mapStateToProps(state, ownProps) {
	  return state;
	}
	function mapDispatchToProps(dispatch) {
	  var actions = { getStoreModule: _actions.getStoreModule, updateStoreModule: _actions.updateStoreModule };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	}
	
	var StoreCredit = (_temp2 = _class = function (_Component) {
	  _inherits(StoreCredit, _Component);
	
	  function StoreCredit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StoreCredit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoreCredit.__proto__ || Object.getPrototypeOf(StoreCredit)).call.apply(_ref, [this].concat(args))), _this), _this.submitForm = function () {
	      _this.refs.SettingsForm.submit();
	    }, _this.updateSettings = function (data) {
	      var updateStoreModule = _this.props.actions.updateStoreModule;
	      var store_id = _this.props.params.store_id;
	
	
	      updateStoreModule(store_id, { store_id: store_id, module: data });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StoreCredit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var store_id = this.props.params.store_id;
	      var getStoreModule = this.props.actions.getStoreModule;
	
	
	      getStoreModule(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var module = this.context.currentStore.module;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Store Credit'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.submitForm },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(SettingsForm, { ref: 'SettingsForm', initialValues: module, onSubmit: this.updateSettings })
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoreCredit;
	}(_react.Component), _class.propTypes = {
	  actions: _propTypes2.default.object,
	  params: _propTypes2.default.object
	}, _class.contextTypes = {
	  currentStore: _propTypes2.default.object.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StoreCredit);

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _blueprint = __webpack_require__(120);
	
	var _core = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditDialog = function (_React$Component) {
	  _inherits(EditDialog, _React$Component);
	
	  function EditDialog(props) {
	    _classCallCheck(this, EditDialog);
	
	    var _this = _possibleConstructorReturn(this, (EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).call(this, props));
	
	    _this.handleSave = _this.handleSave.bind(_this);
	    _this.togglePms = _this.togglePms.bind(_this);
	    _this.handlePmsMode = _this.handlePmsMode.bind(_this);
	    _this.handleNumberChange = _this.handleNumberChange.bind(_this);
	    var model = JSON.parse(JSON.stringify(props.model));
	    _this.state = {
	      model: model,
	      pmsMode: model.room_number ? 'fixed' : 'manually',
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(EditDialog, [{
	    key: 'handleSave',
	    value: function handleSave() {
	      var _state = this.state,
	          model = _state.model,
	          pmsMode = _state.pmsMode;
	      var room_number = model.room_number;
	
	      if (pmsMode === 'fixed' && room_number === null) {
	        this.setState({
	          error: {
	            message: 'Room number required'
	          }
	        });
	      } else {
	        this.props.onSave(this.state.model);
	      }
	    }
	  }, {
	    key: 'togglePms',
	    value: function togglePms(_ref) {
	      var target = _ref.target;
	      var checked = target.checked;
	
	      this.setState(function (state) {
	        state.model.to_pms_enabled = checked;
	        state.error = null;
	        return state;
	      });
	    }
	  }, {
	    key: 'handlePmsMode',
	    value: function handlePmsMode(_ref2) {
	      var target = _ref2.target;
	
	      this.setState({
	        pmsMode: target.value,
	        error: null
	      });
	    }
	  }, {
	    key: 'handleNumberChange',
	    value: function handleNumberChange(_ref3) {
	      var target = _ref3.target;
	      var value = target.value;
	
	      if (value === '') {
	        this.setState(function (state) {
	          state.model.room_number = null;
	          state.error = null;
	          return state;
	        });
	      } else {
	        this.setState(function (state) {
	          state.model.room_number = value;
	          state.error = null;
	          return state;
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onCancel = this.props.onCancel;
	      var _state2 = this.state,
	          model = _state2.model,
	          pmsMode = _state2.pmsMode,
	          error = _state2.error;
	      var to_pms_enabled = model.to_pms_enabled,
	          room_number = model.room_number;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp-dialog' },
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          'Payment Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          this.props.model.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          _react2.default.createElement(_core.Checkbox, { checked: to_pms_enabled, label: 'Post to Room', name: 'to_pms_enabled', onChange: this.togglePms })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line', style: { paddingLeft: 26 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-select' },
	            _react2.default.createElement(
	              'select',
	              { disabled: !to_pms_enabled, onChange: this.handlePmsMode, value: pmsMode },
	              _react2.default.createElement(
	                'option',
	                { value: 'manually' },
	                'Manually'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'fixed' },
	                'Fixed Room Number'
	              )
	            )
	          )
	        ),
	        pmsMode === 'fixed' ? _react2.default.createElement(
	          'div',
	          { className: 'line', style: { paddingLeft: 26 } },
	          _react2.default.createElement('input', { className: 'pt-input', placeholder: 'N/A', value: room_number === null ? "" : room_number, onChange: this.handleNumberChange })
	        ) : null,
	        error ? _react2.default.createElement(_blueprint.Callout, { error: error }) : null,
	        _react2.default.createElement(_blueprint.DialogButtonGroup, { onSave: this.handleSave, onCancel: onCancel })
	      );
	    }
	  }]);
	
	  return EditDialog;
	}(_react2.default.Component);
	
	EditDialog.propTypes = {
	  model: _propTypes2.default.object,
	  onSave: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func
	};
	
	exports.default = EditDialog;

/***/ },
/* 922 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EDIT_MODE = exports.EDIT_MODE = {
	  EDIT: "EDIT"
	};

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(89);
	
	var _constants = __webpack_require__(922);
	
	var _blueprint = __webpack_require__(120);
	
	var _otherPaymentInstrumentService = __webpack_require__(325);
	
	var _otherPaymentInstrumentService2 = _interopRequireDefault(_otherPaymentInstrumentService);
	
	var _EditDialog = __webpack_require__(921);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	__webpack_require__(1279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PMS = function (_React$Component) {
	  _inherits(PMS, _React$Component);
	
	  function PMS(props) {
	    _classCallCheck(this, PMS);
	
	    var _this = _possibleConstructorReturn(this, (PMS.__proto__ || Object.getPrototypeOf(PMS)).call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.cleanAction = _this.cleanAction.bind(_this);
	    _this.handleActionClick = _this.handleActionClick.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.state = {
	      loading: false,
	      pmsList: [],
	      active: null,
	      action: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(PMS, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchPMS();
	    }
	  }, {
	    key: 'fetchPMS',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var _ref2, pmsList;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ loading: false });
	                _context.prev = 1;
	                _context.next = 4;
	                return _otherPaymentInstrumentService2.default.getAllWithDefalut(this.props.params.store_id);
	
	              case 4:
	                _ref2 = _context.sent;
	                pmsList = _ref2.payment_instruments;
	
	                this.setState({ pmsList: pmsList, error: null });
	                _context.next = 12;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](1);
	
	                this.setState({ error: _context.t0 });
	
	              case 12:
	                _context.prev = 12;
	
	                this.setState({ loading: false });
	                return _context.finish(12);
	
	              case 15:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 9, 12, 15]]);
	      }));
	
	      function fetchPMS() {
	        return _ref.apply(this, arguments);
	      }
	
	      return fetchPMS;
	    }()
	  }, {
	    key: 'toggle',
	    value: function toggle(active) {
	      this.setState({ active: active });
	    }
	  }, {
	    key: 'handleActionClick',
	    value: function handleActionClick(target, mode) {
	      this.setState({
	        action: {
	          target: target,
	          mode: mode
	        }
	      });
	    }
	  }, {
	    key: 'cleanAction',
	    value: function cleanAction() {
	      this.setState({ action: null, active: null });
	    }
	  }, {
	    key: 'submit',
	    value: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _otherPaymentInstrumentService2.default.modifyAllWithDefault(this.props.params.store_id, { payment_instruments: [data] });
	
	              case 2:
	                this.cleanAction();
	                this.fetchPMS();
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function submit(_x) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return submit;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          active = _state.active,
	          action = _state.action,
	          pmsList = _state.pmsList,
	          loading = _state.loading,
	          error = _state.error;
	
	      if (loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bp pms main-content state-wrapper' },
	          _react2.default.createElement(_core.Spinner, { className: _core.Classes.LARGE })
	        );
	      }
	      if (error) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bp pms main-content state-wrapper' },
	          _react2.default.createElement(_blueprint.Callout, { error: error })
	        );
	      }
	      return _react2.default.createElement(
	        _blueprint.PopContainer,
	        { className: 'bp pms' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'pt-breadcrumbs' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Home' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Settings' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { text: 'PMS' })
	            )
	          ),
	          _react2.default.createElement(
	            _blueprint.Table,
	            { data: pmsList },
	            _react2.default.createElement(_blueprint.Col, { field: 'name', title: 'Name' }),
	            _react2.default.createElement(_blueprint.Col, { field: 'tipping_enabled', title: 'Tipping', type: 'tick' }),
	            _react2.default.createElement(_blueprint.Col, { field: 'shortcut_enabled', title: 'Shortcut in Register Page', type: 'tick' }),
	            _react2.default.createElement(_blueprint.Col, { field: 'to_pms_enabled', title: 'PMS - Post to Room', type: 'tick' }),
	            _react2.default.createElement(_blueprint.Col, { field: 'room_number', title: 'Post to Room Number', empty: ' - ' }),
	            _react2.default.createElement(_blueprint.Col, { style: { width: '10%' }, render: function render(pms) {
	                return _react2.default.createElement(
	                  _blueprint.ActionMenu,
	                  {
	                    active: active,
	                    target: pms,
	                    onToggle: _this2.toggle,
	                    onActionClick: _this2.handleActionClick
	                  },
	                  _react2.default.createElement(_blueprint.Action, { text: 'Edit', action: _constants.EDIT_MODE.EDIT })
	                );
	              } })
	          ),
	          action ? _react2.default.createElement(
	            _blueprint.PopRender,
	            {
	              title: 'PMS Configuration',
	              isOpen: action.mode === _constants.EDIT_MODE.EDIT,
	              onClose: this.cleanAction
	            },
	            _react2.default.createElement(_EditDialog2.default, { model: action.target, onSave: this.submit, onCancel: this.cleanAction })
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-header' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'PMS Configuration'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PMS;
	}(_react2.default.Component);
	
	PMS.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = PMS;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _blueprint = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditDialog = function (_React$Component) {
	  _inherits(EditDialog, _React$Component);
	
	  function EditDialog(props) {
	    _classCallCheck(this, EditDialog);
	
	    var _this = _possibleConstructorReturn(this, (EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).call(this, props));
	
	    _this.handleSave = _this.handleSave.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    var model = JSON.parse(JSON.stringify(props.model));
	    _this.state = {
	      model: model,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(EditDialog, [{
	    key: 'handleSave',
	    value: function handleSave() {
	      var model = this.state.model;
	
	      this.props.onSave(model);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(_ref) {
	      var target = _ref.target;
	      var name = target.name,
	          value = target.value;
	
	      this.setState(function (state) {
	        // if (['type', 'reset', 'base'].includes(name)){
	        if (['type', 'reset', 'base'].indexOf(name) >= 0) {
	          value = parseInt(value);
	        }
	        state.model[name] = value;
	        return state;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onCancel = _props.onCancel,
	          types = _props.types,
	          bases = _props.bases,
	          resets = _props.resets;
	      var _state = this.state,
	          model = _state.model,
	          error = _state.error;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'bp-dialog' },
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          'Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'line' },
	          _react2.default.createElement('input', { className: 'pt-input pt-fill', name: 'name', value: model.name, onChange: this.handleChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'justify' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              'Type'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line pt-select pt-fill' },
	              _react2.default.createElement(
	                'select',
	                { name: 'type', value: model.type, onChange: this.handleChange },
	                types.map(function (_ref2) {
	                  var id = _ref2.id,
	                      name = _ref2.name;
	                  return _react2.default.createElement(
	                    'option',
	                    { key: id, value: id },
	                    name
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              'Reset'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line pt-select pt-fill' },
	              _react2.default.createElement(
	                'select',
	                { name: 'reset', value: model.reset, onChange: this.handleChange },
	                resets.map(function (_ref3) {
	                  var id = _ref3.id,
	                      name = _ref3.name;
	                  return _react2.default.createElement(
	                    'option',
	                    { key: id, value: id },
	                    name
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'justify' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              'Base'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line pt-select pt-fill' },
	              _react2.default.createElement(
	                'select',
	                { name: 'base', value: model.base, onChange: this.handleChange },
	                bases.map(function (_ref4) {
	                  var id = _ref4.id,
	                      name = _ref4.name;
	                  return _react2.default.createElement(
	                    'option',
	                    { key: id, value: id },
	                    name
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              'Format (# will be replaced by natural number)'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement('input', { className: 'pt-input pt-fill', placeholder: 'e.g. AB#####', name: 'format', value: model.format, onChange: this.handleChange })
	            )
	          )
	        ),
	        error ? _react2.default.createElement(_blueprint.Callout, { error: error }) : null,
	        _react2.default.createElement(_blueprint.DialogButtonGroup, { onSave: this.handleSave, onCancel: onCancel })
	      );
	    }
	  }]);
	
	  return EditDialog;
	}(_react2.default.Component);
	
	EditDialog.propTypes = {
	  model: _propTypes2.default.object,
	  onSave: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  types: _propTypes2.default.array,
	  resets: _propTypes2.default.array,
	  bases: _propTypes2.default.array
	};
	
	exports.default = EditDialog;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blueprint = __webpack_require__(120);
	
	var _core = __webpack_require__(89);
	
	var _referenceFormatService = __webpack_require__(495);
	
	var _referenceFormatService2 = _interopRequireDefault(_referenceFormatService);
	
	var _EditDialog = __webpack_require__(924);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EDIT_MODE = {
	  ADD: 'ADD',
	  EDIT: 'EDIT',
	  REMOVE: 'REMOVE'
	};
	
	var DEFAULT_TYPE = 1; // NONE
	var DEFAULT_RESET = 5; // WHEN_RUN_OUT
	var DEFAULT_BASE = 10; // 10
	
	var dictFinder = function dictFinder(dict, key) {
	  return function (rf) {
	    var _ref = dict.find(function (_ref2) {
	      var id = _ref2.id;
	      return id === rf[key];
	    }) || {},
	        name = _ref.name;
	
	    return name;
	  };
	};
	
	var ReferenceNumberFormat = function (_React$Component) {
	  _inherits(ReferenceNumberFormat, _React$Component);
	
	  function ReferenceNumberFormat(props) {
	    _classCallCheck(this, ReferenceNumberFormat);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceNumberFormat.__proto__ || Object.getPrototypeOf(ReferenceNumberFormat)).call(this, props));
	
	    _this.setAction = _this.setAction.bind(_this);
	    _this.cleanAction = _this.cleanAction.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.remove = _this.remove.bind(_this);
	    _this.state = {
	      loading: false,
	      list: [],
	      active: null,
	      action: null,
	      error: null,
	      types: [],
	      resets: [],
	      bases: []
	    };
	    return _this;
	  }
	
	  _createClass(ReferenceNumberFormat, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchList();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(active) {
	      this.setState({ active: active });
	    }
	  }, {
	    key: 'fetchList',
	    value: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var list, dict;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ loading: true });
	                _context.prev = 1;
	                _context.next = 4;
	                return _referenceFormatService2.default.getAll(this.props.params.store_id);
	
	              case 4:
	                list = _context.sent;
	                _context.next = 7;
	                return _referenceFormatService2.default.getDict(this.props.params.store_id);
	
	              case 7:
	                dict = _context.sent;
	
	                this.setState(_extends({ list: list }, dict));
	                _context.next = 14;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context['catch'](1);
	
	                this.setState({ error: _context.t0 });
	
	              case 14:
	                _context.prev = 14;
	
	                this.setState({ loading: false });
	                return _context.finish(14);
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 11, 14, 17]]);
	      }));
	
	      function fetchList() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return fetchList;
	    }()
	  }, {
	    key: 'setAction',
	    value: function setAction(target, mode) {
	      this.setState({
	        action: {
	          target: target,
	          mode: mode
	        }
	      });
	    }
	  }, {
	    key: 'cleanAction',
	    value: function cleanAction() {
	      this.setState({ action: null, active: null });
	    }
	  }, {
	    key: 'save',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!data.id) {
	                  _context2.next = 5;
	                  break;
	                }
	
	                _context2.next = 3;
	                return _referenceFormatService2.default.update(this.props.params.store_id, data);
	
	              case 3:
	                _context2.next = 7;
	                break;
	
	              case 5:
	                _context2.next = 7;
	                return _referenceFormatService2.default.create(this.props.params.store_id, data);
	
	              case 7:
	                this.cleanAction();
	                this.fetchList();
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function save(_x) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return save;
	    }()
	  }, {
	    key: 'remove',
	    value: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var action, id;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                action = this.state.action;
	                id = action.target.id;
	                _context3.prev = 2;
	                _context3.next = 5;
	                return _referenceFormatService2.default.delete(this.props.params.store_id, id);
	
	              case 5:
	                this.cleanAction();
	                this.fetchList();
	                _context3.next = 13;
	                break;
	
	              case 9:
	                _context3.prev = 9;
	                _context3.t0 = _context3['catch'](2);
	
	                action.error = _context3.t0;
	                this.setState({ action: action });
	
	              case 13:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[2, 9]]);
	      }));
	
	      function remove() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return remove;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          active = _state.active,
	          action = _state.action,
	          loading = _state.loading,
	          error = _state.error,
	          list = _state.list,
	          types = _state.types,
	          bases = _state.bases,
	          resets = _state.resets;
	
	      if (loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bp pms main-content state-wrapper' },
	          _react2.default.createElement(_core.Spinner, { className: _core.Classes.LARGE })
	        );
	      }
	      if (error) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bp pms main-content state-wrapper' },
	          _react2.default.createElement(_blueprint.Callout, { error: error })
	        );
	      }
	
	      return _react2.default.createElement(
	        _blueprint.PopContainer,
	        { className: 'bp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'pt-breadcrumbs' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Home' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { disabled: true, text: 'Settings' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_core.Breadcrumb, { text: 'Reference Number Format' })
	            )
	          ),
	          _react2.default.createElement(
	            _blueprint.Table,
	            { data: list },
	            _react2.default.createElement(_blueprint.Col, { field: 'name', title: 'Name' }),
	            _react2.default.createElement(_blueprint.Col, { title: 'Type', render: dictFinder(types, 'type') }),
	            _react2.default.createElement(_blueprint.Col, { title: 'Base', render: dictFinder(bases, 'base') }),
	            _react2.default.createElement(_blueprint.Col, { title: 'Reset', render: dictFinder(resets, 'reset') }),
	            _react2.default.createElement(_blueprint.Col, { field: 'format', title: 'Format' }),
	            _react2.default.createElement(_blueprint.Col, { style: { width: '10%' }, render: function render(format) {
	                return _react2.default.createElement(
	                  _blueprint.ActionMenu,
	                  {
	                    active: active,
	                    target: format,
	                    onToggle: _this2.toggle,
	                    onActionClick: _this2.setAction
	                  },
	                  _react2.default.createElement(_blueprint.Action, { text: 'Edit', action: EDIT_MODE.EDIT }),
	                  _react2.default.createElement(_blueprint.Action, { text: 'Remove', action: EDIT_MODE.REMOVE })
	                );
	              } })
	          ),
	          action ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _blueprint.PopRender,
	              {
	                title: 'New Reference Number',
	                isOpen: action.mode === EDIT_MODE.EDIT || action.mode === EDIT_MODE.ADD,
	                onClose: this.cleanAction,
	                style: { width: 700 }
	              },
	              _react2.default.createElement(_EditDialog2.default, {
	                model: action.target,
	                onSave: this.save,
	                onCancel: this.cleanAction,
	                types: types,
	                bases: bases,
	                resets: resets
	              })
	            ),
	            _react2.default.createElement(
	              _core.Alert,
	              {
	                isOpen: action.mode === EDIT_MODE.REMOVE,
	                cancelButtonText: 'No',
	                confirmButtonText: 'Yes',
	                onConfirm: this.remove,
	                onCancel: this.cleanAction,
	                iconName: 'warning-sign',
	                intent: _core.Intent.DANGER
	              },
	              'Are you sure to remove ',
	              action.target.name,
	              ' Reference Number Format?',
	              _react2.default.createElement(_blueprint.Callout, { error: action.error })
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-header' },
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'Reference Number Format'
	          ),
	          _react2.default.createElement(_core.Button, {
	            text: 'New Sequence Number',
	            iconName: 'add',
	            intent: _core.Intent.PRIMARY,
	            onClick: function onClick() {
	              return _this2.setAction({
	                type: DEFAULT_TYPE,
	                reset: DEFAULT_RESET,
	                base: DEFAULT_BASE
	              }, EDIT_MODE.ADD);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReferenceNumberFormat;
	}(_react2.default.Component);
	
	ReferenceNumberFormat.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = ReferenceNumberFormat;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(930);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _dateformat = __webpack_require__(1223);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Report = function (_React$Component) {
	  _inherits(Report, _React$Component);
	
	  function Report() {
	    _classCallCheck(this, Report);
	
	    return _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).apply(this, arguments));
	  }
	
	  _createClass(Report, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var view = _ref.view,
	          width = _ref.width,
	          height = _ref.height,
	          menuWidth = _ref.menuWidth;
	
	      if (view === null) return;
	
	      var props = this.props;
	
	      if (view !== props.view) {
	        if (this.viz) this.viz.dispose();
	        this.init(view);
	      } else if (width !== props.width || height !== props.height || menuWidth !== props.menuWidth) {
	        this.viz.setFrameSize(width - menuWidth, height - this.toolbar.offsetHeight);
	      }
	    }
	  }, {
	    key: 'init',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(view) {
	        var site, ticket, date, params, sitePath, url, _report, offsetWidth, offsetHeight, options;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(view === null)) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                site = this.props.site;
	                _context.next = 5;
	                return (0, _auth2.default)(site);
	
	              case 5:
	                ticket = _context.sent;
	                date = (0, _dateformat2.default)(new Date(), 'yyyy-mm-dd');
	                params = this.props.storeIds.split(',').map(function (id, idx) {
	                  return 'store_id_filter_' + (idx + 1) + '=' + id;
	                });
	
	                params.push('From=' + date);
	                params.push('To=' + date);
	                sitePath = site ? 't/' + site + '/' : '';
	                url = 'https://tableau-new.bindolabs.com/trusted/' + ticket + '/' + sitePath + 'views/' + view.contentUrl.replace('sheets/', '') + '?' + params.join('&');
	                _report = this.report, offsetWidth = _report.offsetWidth, offsetHeight = _report.offsetHeight;
	                options = {
	                  width: offsetWidth,
	                  height: offsetHeight,
	                  hideTabs: true,
	                  hideToolbar: true
	                };
	
	                this.viz = new window.tableau.Viz(this.report, url, options);
	
	              case 15:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function init(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return init;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'report-container', ref: function ref(container) {
	            return _this2.container = container;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'toolbar', ref: function ref(toolbar) {
	              return _this2.toolbar = toolbar;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'btn', onClick: function onClick() {
	                return _this2.viz.refreshDataAsync();
	              }, style: { marginRight: 10 } },
	            'Refresh'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn', onClick: function onClick() {
	                return _this2.viz.showExportCrossTabDialog();
	              }, style: { marginRight: 10 } },
	            'Download Excel'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn', onClick: function onClick() {
	                return _this2.viz.showExportPDFDialog();
	              } },
	            'Download PDF'
	          )
	        ),
	        _react2.default.createElement('div', { ref: function ref(report) {
	            return _this2.report = report;
	          }, className: 'report' })
	      );
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component);
	
	Report.propTypes = {
	  view: _propTypes2.default.object,
	  storeIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  site: _propTypes2.default.string.isRequired
	};
	
	exports.default = Report;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.state = {
	      open: true
	    };
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'handleToggle',
	    value: function handleToggle() {
	      var _this2 = this;
	
	      this.setState(function (_ref) {
	        var open = _ref.open;
	        return { open: !open };
	      }, function () {
	        return _this2.props.onToggle(_this2.root.offsetWidth);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          projects = _props.projects,
	          view = _props.view,
	          _onClick = _props.onClick;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)("menu-wrapper", { open: open }), ref: function ref(root) {
	            return _this3.root = root;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'toggle', onClick: this.handleToggle },
	          _react2.default.createElement('div', { className: 'child top' }),
	          _react2.default.createElement('div', { className: 'child bottom' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'menu' },
	          projects.map(function (project) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'menu-block', key: project.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'menu-header' },
	                project.name
	              ),
	              project.views.map(function (v) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    className: (0, _classnames2.default)("menu-item", { active: v === view }),
	                    onClick: function onClick() {
	                      return _onClick(v);
	                    },
	                    key: v.id
	                  },
	                  v.name
	                );
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react2.default.Component);
	
	Menu.propTypes = {
	  projects: _propTypes2.default.array,
	  view: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onToggle: _propTypes2.default.func
	};
	
	exports.default = Menu;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tableau = __webpack_require__(239);
	
	var _Tableau2 = _interopRequireDefault(_Tableau);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BindoAdmin = function BindoAdmin(_ref) {
	  var params = _ref.params;
	  return _react2.default.createElement(_Tableau2.default, { storeIds: params.store_id, site: 'BindoAdmin' });
	};
	
	BindoAdmin.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};
	
	exports.default = BindoAdmin;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tableau = __webpack_require__(239);
	
	var _Tableau2 = _interopRequireDefault(_Tableau);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedReport = function AdvancedReport(_ref) {
	  var params = _ref.params;
	  return _react2.default.createElement(_Tableau2.default, { storeIds: params.store_id, filter: function filter(seq) {
	      return seq.main !== 999 && seq.sub !== 999;
	    } });
	};
	
	AdvancedReport.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};
	exports.default = AdvancedReport;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var auth = function () {
	  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(site) {
	    var data, res;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            data = new FormData();
	
	            data.append('username', 'dashboard');
	            if (site !== '') {
	              data.append('target_site', site);
	            }
	            _context.next = 5;
	            return fetch(_config.tableau + '/trusted', {
	              method: 'POST',
	              body: data
	            });
	
	          case 5:
	            res = _context.sent;
	
	            if (!res.ok) {
	              _context.next = 10;
	              break;
	            }
	
	            _context.next = 9;
	            return res.text();
	
	          case 9:
	            return _context.abrupt('return', _context.sent);
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function auth(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _config = __webpack_require__(29);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = auth;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tableau = __webpack_require__(239);
	
	var _Tableau2 = _interopRequireDefault(_Tableau);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChineseReport = function ChineseReport(_ref) {
	  var params = _ref.params;
	  return _react2.default.createElement(_Tableau2.default, { storeIds: params.store_id, filter: function filter(seq) {
	      return seq.main !== 999 && seq.sub !== 999;
	    }, langType: 'chinese' });
	}; /**
	    * Auther: Joshua
	    * date: 2018.12.25
	    * for chinese report
	    */
	
	ChineseReport.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};
	exports.default = ChineseReport;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tableau = __webpack_require__(239);
	
	var _Tableau2 = _interopRequireDefault(_Tableau);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Report = function Report(_ref) {
	  var params = _ref.params;
	  return _react2.default.createElement(_Tableau2.default, { storeIds: params.store_id });
	};
	
	Report.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};
	
	exports.default = Report;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _departmentActions = __webpack_require__(149);
	
	var _voucherActions = __webpack_require__(59);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _pick = __webpack_require__(213);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _remove = __webpack_require__(394);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _addListing = __webpack_require__(229);
	
	var _addListing2 = _interopRequireDefault(_addListing);
	
	var _reactRouter = __webpack_require__(9);
	
	var _associatedProductDelete = __webpack_require__(935);
	
	var _associatedProductDelete2 = _interopRequireDefault(_associatedProductDelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var voucher = state.voucher,
	      _state$entities = state.entities,
	      departments = _state$entities.departments,
	      vouchers = _state$entities.vouchers;
	
	
	  var associatedProducts = [];
	  var products = voucher.products;
	  for (var i in products) {
	    var l = products[i];
	    var department = departments === null || typeof departments[l.department_id] === "undefined" ? "" : departments[l.department_id].name;
	
	    associatedProducts.push({
	      id: l.product_id,
	      name: l.name,
	      price: l.price,
	      department: department
	    });
	  }
	
	  return {
	    voucher: vouchers,
	    associatedProducts: associatedProducts
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getDepartments: _departmentActions.getDepartments, getAssociateProducts: _voucherActions.getAssociateProducts, getVoucher: _voucherActions.getVoucher, updateVoucher: _voucherActions.updateVoucher, removeAssociateProduct: _voucherActions.removeAssociateProduct };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherAssociate = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherAssociate, _Component);
	
	  function VoucherAssociate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherAssociate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherAssociate.__proto__ || Object.getPrototypeOf(VoucherAssociate)).call.apply(_ref, [this].concat(args))), _this), _this.addProduct = function (products) {
	      var _this$props$params = _this.props.params,
	          store_id = _this$props$params.store_id,
	          discount_id = _this$props$params.discount_id;
	      var getAssociateProducts = _this.props.actions.getAssociateProducts;
	      var voucher = _this.props.voucher;
	
	
	      (0, _forEach2.default)(products, function (item) {
	        voucher[discount_id].discountable_items.push({
	          item_type: 0,
	          item_id: item.product_id
	        });
	      });
	
	      var changedVoucher = {
	        voucher_discount: (0, _pick2.default)(voucher[discount_id], ['store_id', 'name', 'notes', 'amount', 'price', 'revenue_recognition', 'discountable_items', 'expiration_setting'])
	      };
	
	      var productIds = [];
	      (0, _forEach2.default)(changedVoucher.voucher_discount.discountable_items, function (item) {
	        productIds.push(item.item_id);
	      });
	
	      getAssociateProducts(store_id, productIds);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherAssociate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          discount_id = _props$params.discount_id;
	      var _props$actions = this.props.actions,
	          getDepartments = _props$actions.getDepartments,
	          getVoucher = _props$actions.getVoucher;
	
	
	      getVoucher(store_id, discount_id);
	      getDepartments(store_id);
	    }
	  }, {
	    key: 'deleteProduct',
	    value: function deleteProduct(product_id) {
	      var discount_id = this.props.params.discount_id;
	
	      var vouchers = this.props.voucher;
	      var removeAssociateProduct = this.props.actions.removeAssociateProduct;
	
	
	      var voucher = vouchers[discount_id];
	      voucher.discountable_items = (0, _remove2.default)(voucher.discountable_items, function (item) {
	        return item.item_id !== product_id;
	      });
	
	      removeAssociateProduct(product_id);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _props$params2 = this.props.params,
	          store_id = _props$params2.store_id,
	          discount_id = _props$params2.discount_id;
	
	      var vouchers = this.props.voucher;
	      var voucher = vouchers[discount_id];
	      var associatedProducts = this.props.associatedProducts;
	      var updateVoucher = this.props.actions.updateVoucher;
	
	      voucher.discountable_items = (0, _map2.default)(associatedProducts, function (item) {
	        return {
	          item_type: 0,
	          item_id: item.id
	        };
	      });
	
	      var changedVoucher = {
	        voucher_discount: (0, _pick2.default)(voucher, ['store_id', 'name', 'notes', 'amount', 'price', 'revenue_recognition', 'discountable_items', 'expiration_setting'])
	      };
	
	      updateVoucher(store_id, discount_id, changedVoucher);
	      var showPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/associate';
	      this.context.router.push(showPath);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var associatedProducts = this.props.associatedProducts;
	      var _props$params3 = this.props.params,
	          store_id = _props$params3.store_id,
	          discount_id = _props$params3.discount_id;
	
	      var fetchingData = false;
	
	      // Voucher list settings
	      var columnMetadatas = [{
	        columnName: "name",
	        displayName: "name"
	      }, {
	        columnName: "department",
	        displayName: "department"
	      }, {
	        columnName: "price",
	        displayName: "price"
	      }, {
	        columnName: " ",
	        displayName: "",
	        customComponent: _associatedProductDelete2.default,
	        deleteProduct: this.deleteProduct.bind(this)
	      }];
	
	      // Columns for grid display
	      var columns = columnMetadatas.map(function (i) {
	        return i.columnName;
	      });
	
	      // Show loading if still fetching
	      if (fetchingData) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading vouchers...'
	        );
	      }
	
	      var showPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/associate';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'voucher-associate' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Vouchers'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'btn btn-secondary btn-sm', to: showPath },
	              'Discard'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit.bind(this) },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_griddleReact2.default, {
	            useGriddleStyles: false,
	            tableClassName: 'table table-bordered data-table',
	            results: associatedProducts,
	            columns: columns,
	            columnMetadata: columnMetadatas }),
	          _react2.default.createElement(
	            'div',
	            { className: '_add' },
	            _react2.default.createElement(
	              _addListing2.default,
	              { onSave: this.addProduct },
	              'Add Products'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VoucherAssociate;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  associatedProducts: _propTypes2.default.array.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object,
	  voucher: _propTypes2.default.object,
	  location: _propTypes2.default.object
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherAssociate);

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _departmentActions = __webpack_require__(149);
	
	var _voucherActions = __webpack_require__(59);
	
	var _reactRouter = __webpack_require__(9);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  var voucher = state.voucher,
	      _state$entities = state.entities,
	      departments = _state$entities.departments,
	      vouchers = _state$entities.vouchers;
	
	
	  var associatedProducts = [];
	  var products = voucher.products;
	  for (var i in products) {
	    var l = products[i];
	    var department = departments === null || typeof departments[l.department_id] === "undefined" ? "" : departments[l.department_id].name;
	
	    associatedProducts.push({
	      id: l.product_id,
	      name: l.name,
	      price: l.price,
	      department: department
	    });
	  }
	
	  return {
	    voucher: vouchers,
	    associatedProducts: associatedProducts
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getDepartments: _departmentActions.getDepartments, getAssociateProducts: _voucherActions.getAssociateProducts, getVoucher: _voucherActions.getVoucher, updateVoucher: _voucherActions.updateVoucher, removeAssociateProduct: _voucherActions.removeAssociateProduct };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherAssociateShow = (_temp = _class = function (_Component) {
	  _inherits(VoucherAssociateShow, _Component);
	
	  function VoucherAssociateShow() {
	    _classCallCheck(this, VoucherAssociateShow);
	
	    return _possibleConstructorReturn(this, (VoucherAssociateShow.__proto__ || Object.getPrototypeOf(VoucherAssociateShow)).apply(this, arguments));
	  }
	
	  _createClass(VoucherAssociateShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          discount_id = _props$params.discount_id;
	      var _props$actions = this.props.actions,
	          getDepartments = _props$actions.getDepartments,
	          getVoucher = _props$actions.getVoucher;
	
	
	      getVoucher(store_id, discount_id);
	      getDepartments(store_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$params2 = this.props.params,
	          store_id = _props$params2.store_id,
	          discount_id = _props$params2.discount_id;
	      var associatedProducts = this.props.associatedProducts;
	
	      var fetchingData = false;
	
	      // Voucher list settings
	      var columnMetadatas = [{
	        columnName: "name",
	        displayName: "name"
	      }, {
	        columnName: "department",
	        displayName: "department"
	      }, {
	        columnName: "price",
	        displayName: "price"
	      }];
	
	      // Columns for grid display
	      var columns = columnMetadatas.map(function (i) {
	        return i.columnName;
	      });
	
	      // Show loading if still fetching
	      if (fetchingData) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading vouchers...'
	        );
	      }
	
	      var editPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/associate/edit';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'voucher-associate' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Vouchers'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: editPath, className: 'btn btn-primary btn-sm' },
	            'Edit'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_griddleReact2.default, {
	            useGriddleStyles: false,
	            tableClassName: 'table table-bordered data-table',
	            results: associatedProducts,
	            columns: columns,
	            columnMetadata: columnMetadatas })
	        )
	      );
	    }
	  }]);
	
	  return VoucherAssociateShow;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  associatedProducts: _propTypes2.default.array.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object,
	  voucher: _propTypes2.default.object,
	  location: _propTypes2.default.object
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherAssociateShow);

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssociatedProductDelete(props) {
	  var id = props.rowData.id;
	
	
	  function deleteItem() {
	    props.metadata.deleteProduct(id);
	  }
	
	  return _react2.default.createElement(_actionButton2.default, { className: 'btn btn-primary', type: 'delete', onClick: deleteItem });
	}
	
	AssociatedProductDelete.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = AssociatedProductDelete;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	exports.sumDays = sumDays;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function sumDays(day, week, month, year) {
	  return day * 1 + week * 7 + month * 30 + year * 365;
	}
	
	var fields = ['day', 'week', 'month', 'year'];
	
	var initialValues = {
	  day: 0,
	  week: 0,
	  month: 0,
	  year: 0
	};
	
	var DayCalForm = (_temp = _class = function (_Component) {
	  _inherits(DayCalForm, _Component);
	
	  function DayCalForm() {
	    _classCallCheck(this, DayCalForm);
	
	    return _possibleConstructorReturn(this, (DayCalForm.__proto__ || Object.getPrototypeOf(DayCalForm)).apply(this, arguments));
	  }
	
	  _createClass(DayCalForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$fields = _props.fields,
	          day = _props$fields.day,
	          week = _props$fields.week,
	          month = _props$fields.month,
	          year = _props$fields.year,
	          handleSubmit = _props.handleSubmit;
	
	
	      var days = sumDays(day.value, week.value, month.value, year.value);
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-3' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Days'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', className: 'form-control' }, day))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-3' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Weeks'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', className: 'form-control' }, week))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-3' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Month'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', className: 'form-control' }, month))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-3' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'Years'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'number', className: 'form-control' }, year))
	            )
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            { className: '_align-right' },
	            '= ',
	            _react2.default.createElement(
	              'b',
	              null,
	              days
	            ),
	            ' Days'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DayCalForm;
	}(_react.Component), _class.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  fields: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'dayCalculator',
	  fields: fields,
	  initialValues: initialValues
	})(DayCalForm);

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexName(props) {
	  var _props$rowData = props.rowData,
	      id = _props$rowData.id,
	      store_id = _props$rowData.store_id,
	      name = _props$rowData.name;
	
	  var path = '/v2/' + store_id + '/vouchers/' + id;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { className: 'block-a', to: path },
	    name
	  );
	}
	
	IndexName.propTypes = {
	  rowData: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexName;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fields = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formGroup = __webpack_require__(42);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = exports.fields = ['code_from', 'code_to'];
	
	var NewVoucherForm = (_temp = _class = function (_Component) {
	  _inherits(NewVoucherForm, _Component);
	
	  function NewVoucherForm() {
	    _classCallCheck(this, NewVoucherForm);
	
	    return _possibleConstructorReturn(this, (NewVoucherForm.__proto__ || Object.getPrototypeOf(NewVoucherForm)).apply(this, arguments));
	  }
	
	  _createClass(NewVoucherForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$fields = _props.fields,
	          code_from = _props$fields.code_from,
	          code_to = _props$fields.code_to,
	          handleSubmit = _props.handleSubmit;
	
	
	      return _react2.default.createElement(
	        'form',
	        { id: 'NewVoucherForm', onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: code_from },
	              _react2.default.createElement(
	                'label',
	                null,
	                'START'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, code_from))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6' },
	            _react2.default.createElement(
	              _formGroup2.default,
	              { state: code_to },
	              _react2.default.createElement(
	                'label',
	                null,
	                'END'
	              ),
	              _react2.default.createElement('input', _extends({ type: 'text', className: 'form-control' }, code_to))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewVoucherForm;
	}(_react.Component), _class.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  fields: _propTypes2.default.object.isRequired,
	  voucher: _propTypes2.default.object
	}, _temp);
	
	
	var formOptions = {
	  form: 'voucherOverview',
	  fields: fields
	  // validate
	};
	
	exports.default = (0, _reduxForm.reduxForm)(formOptions)(NewVoucherForm);

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _dropDown = __webpack_require__(231);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _voucherActions = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    criteria: state.voucherCoupon.criteria
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  var _ownProps$rowData = ownProps.rowData,
	      store_id = _ownProps$rowData.store_id,
	      discount_id = _ownProps$rowData.discount_id,
	      id = _ownProps$rowData.id;
	
	
	  var actions = {
	    cancelVoucherCoupon: _voucherActions.cancelVoucherCoupons.bind(null, store_id, discount_id, id),
	    deleteVoucherCoupon: _voucherActions.deleteVoucherCoupon.bind(null, store_id, discount_id, id),
	    getVoucherCoupons: _voucherActions.getVoucherCoupons.bind(null, store_id, discount_id)
	  };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	function vouchersAction(props) {
	  var criteria = props.criteria,
	      actions = props.actions;
	
	
	  var remove = function remove() {
	    actions.deleteVoucherCoupon().then(function () {
	      actions.getVoucherCoupons(criteria.page, criteria.perPage);
	    });
	  };
	
	  var cancel = function cancel() {
	    actions.cancelVoucherCoupon().then(function () {
	      actions.getVoucherCoupons(criteria.page, criteria.perPage);
	    });
	  };
	
	  return _react2.default.createElement(
	    _dropDown2.default,
	    null,
	    _react2.default.createElement(
	      'a',
	      { className: 'dropdown-item a', onClick: cancel },
	      'Cancel'
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'dropdown-item a text-danger', onClick: remove },
	      'Remove'
	    )
	  );
	}
	
	vouchersAction.propTypes = {
	  rowData: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object,
	  criteria: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(vouchersAction);

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _voucherActions = __webpack_require__(59);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var customStyles = {
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  },
	  overlay: {
	    zIndex: 9999
	  }
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var vouchers = state.entities.vouchers;
	
	
	  return {
	    vouchers: vouchers
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { removeVoucher: _voucherActions.removeVoucher };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var DeleteItem = (_temp2 = _class = function (_Component) {
	  _inherits(DeleteItem, _Component);
	
	  function DeleteItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeleteItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeleteItem.__proto__ || Object.getPrototypeOf(DeleteItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openDialog: true
	    }, _this.handleSave = function () {
	      var params = _this.props.params;
	
	      _this.setState({ openDialog: false });
	      var removeVoucher = _this.props.actions.removeVoucher;
	
	      removeVoucher(params.store_id, params.discount_id);
	
	      _this.context.router.goBack();
	    }, _this.handleCancel = function () {
	      _this.setState({ openDialog: false });
	      _this.context.router.goBack();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeleteItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactModal2.default,
	        { isOpen: this.state.openDialog,
	          style: customStyles },
	        _react2.default.createElement(
	          'h2',
	          null,
	          '\u78BA\u5B9A\u522A\u9664?'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleSave.bind(this) },
	            'Save'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleCancel.bind(this) },
	            'Cancel'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeleteItem;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    discount_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  actions: _propTypes2.default.object
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeleteItem);

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _voucherActions = __webpack_require__(59);
	
	var _savedFiltersActions = __webpack_require__(227);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _cascadeFilterCollection = __webpack_require__(107);
	
	var _cascadeFilterCollection2 = _interopRequireDefault(_cascadeFilterCollection);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactRouter = __webpack_require__(9);
	
	var _indexName = __webpack_require__(937);
	
	var _indexName2 = _interopRequireDefault(_indexName);
	
	var _dropDown = __webpack_require__(231);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkComponent = function LinkComponent(props) {
	  var _props$rowData = props.rowData,
	      id = _props$rowData.id,
	      store_id = _props$rowData.store_id;
	
	  var path = '/v2/' + store_id + '/vouchers/delete/' + id;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _dropDown2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { key: id, to: path, className: 'dropdown-item text-danger' },
	        'Delete'
	      )
	    )
	  );
	};
	LinkComponent.propTypes = {
	  rowData: _propTypes2.default.object
	};
	
	// Voucher list settings
	var columnMetadatas = [{
	  columnName: "name",
	  displayName: "VOUCHER NAME",
	  customComponent: _indexName2.default,
	  filterConditions: ['contain']
	}, {
	  columnName: "face_value",
	  displayName: "FACE VALUE"
	}, {
	  columnName: "revenue_recognition",
	  displayName: "REVENUE RECOGNITION"
	}, {
	  columnName: "sold_qty",
	  displayName: "SOLD QTY"
	}, {
	  columnName: "redeemed_qty",
	  displayName: "REDEEMED QTY"
	}, {
	  columnName: "pending_qty",
	  displayName: "PENDING QTY"
	}, {
	  columnName: "",
	  displayName: "",
	  customComponent: LinkComponent
	}];
	
	// Columns for grid display
	var columns = columnMetadatas.filter(function (i) {
	  return !i.hide;
	}).map(function (i) {
	  return i.columnName;
	});
	
	// Columns for filter
	var filterSettings = columnMetadatas.filter(function (i) {
	  return i.displayName && i.filterConditions && i.filterConditions.length > 0;
	}).map(function (i) {
	  return {
	    columnName: i.columnName,
	    displayName: i.displayName,
	    filterConditions: i.filterConditions
	  };
	});
	
	var VoucherIndex = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherIndex, _Component);
	
	  function VoucherIndex() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherIndex);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherIndex.__proto__ || Object.getPrototypeOf(VoucherIndex)).call.apply(_ref, [this].concat(args))), _this), _this.setPage = function (index) {
	      var store_id = _this.props.params.store_id;
	      var _this$props$location$ = _this.props.location.query,
	          count = _this$props$location$.count,
	          filters = _this$props$location$.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	      var criteria = _this.props.voucher.criteria;
	
	      var page = index >= criteria.totalPages ? criteria.totalPages : index < 1 ? 1 : index + 1;
	      var getVouchers = _this.props.actions.getVouchers;
	
	
	      getVouchers(store_id, page, count, undefined, filtersObject);
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/vouchers',
	        query: {
	          page: page,
	          count: count,
	          filters: filters
	        }
	      });
	    }, _this.changeSort = function (sort, sortAscending) {}, _this.setFilter = function (filter) {}, _this.setPageSize = function (size) {}, _this.handleFiltersChange = function (filters) {
	      var updateVoucherFilters = _this.props.actions.updateVoucherFilters;
	
	
	      updateVoucherFilters(filters);
	    }, _this.handleSearch = function () {
	      var store_id = _this.props.params.store_id;
	      var _this$props$location$2 = _this.props.location.query,
	          count = _this$props$location$2.count,
	          page = _this$props$location$2.page;
	      var filters = _this.props.voucher.criteria.filters;
	
	      var filterString = _filterHelper2.default.filtersToQueryString(filters);
	      var getVouchers = _this.props.actions.getVouchers;
	
	
	      getVouchers(store_id, page, count, undefined, filters);
	      _this.context.router.push({
	        pathname: '/v2/' + store_id + '/vouchers',
	        query: {
	          page: page,
	          count: count,
	          filters: filterString
	        }
	      });
	    }, _this.handleFilterSave = function (name, filter) {
	      _this.props.actions.saveFilter('voucher', name, filter);
	    }, _this.handleFilterRemove = function (name) {
	      _this.props.actions.removeFilter('voucher', name);
	    }, _this.handleFilterSelected = function (selectedFilter) {
	      _this.props.actions.updateVoucherFilters(selectedFilter);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherIndex, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var store_id = this.props.params.store_id;
	      var _props$location$query = this.props.location.query,
	          count = _props$location$query.count,
	          page = _props$location$query.page,
	          filters = _props$location$query.filters;
	
	      var filtersObject = _filterHelper2.default.stringToFilters(filters);
	      var getVouchers = this.props.actions.getVouchers;
	
	
	      getVouchers(store_id, page, count, undefined, filtersObject);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var store_id = this.props.params.store_id;
	      var _props = this.props,
	          _props$voucher = _props.voucher,
	          criteria = _props$voucher.criteria,
	          fetchingData = _props$voucher.fetchingData,
	          vouchers = _props.vouchers;
	
	      // Show loading if still fetching
	
	      if (fetchingData) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading vouchers...'
	        );
	      }
	      var path = '/v2/' + store_id + '/vouchers/new';
	
	      var noDataMessage = void 0;
	
	      if (this.props.location.query.filters) {
	        noDataMessage = 'No search result';
	      } else {
	        noDataMessage = 'There is no listing data';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Vouchers'
	          ),
	          _react2.default.createElement(
	            _can2.default,
	            { action: 'voucher:create' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: path, className: 'btn btn-primary btn-sm' },
	              'New Voucher'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content -main-filter' },
	          _react2.default.createElement(_cascadeFilterCollection2.default, {
	            group: 'voucher',
	            settings: filterSettings,
	            filters: criteria.filters,
	            onSearch: this.handleSearch
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_griddleReact2.default, {
	              useExternal: true,
	              useGriddleStyles: false,
	              tableClassName: 'table table-bordered data-table',
	              externalSetPage: this.setPage,
	              externalChangeSort: this.changeSort,
	              externalSetFilter: this.setFilter,
	              externalSetPageSize: this.setPage,
	              externalMaxPage: criteria.totalPages,
	              externalCurrentPage: criteria.page - 1,
	              resultsPerPage: criteria.perPage,
	              results: vouchers,
	              noDataMessage: noDataMessage,
	              columns: columns,
	              columnMetadata: columnMetadatas })
	          )
	        )
	      );
	    }
	  }]);
	
	  return VoucherIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  voucher: _propTypes2.default.object.isRequired,
	  vouchers: _propTypes2.default.array,
	  savedFilters: _propTypes2.default.object,
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  actions: _propTypes2.default.shape({
	    getVouchers: _propTypes2.default.func.isRequired,
	    updateVoucherFilters: _propTypes2.default.func.isRequired,
	    saveFilter: _propTypes2.default.func.isRequired,
	    removeFilter: _propTypes2.default.func.isRequired
	  }).isRequired,
	  location: _propTypes2.default.shape({
	    query: _propTypes2.default.shape({
	      count: _propTypes2.default.string,
	      page: _propTypes2.default.string,
	      filters: _propTypes2.default.string
	    })
	  }).isRequired
	}, _temp2);
	
	
	var cookVouchers = function cookVouchers(currentVouchers, vouchers) {
	  var mappedVouchers = void 0;
	
	  try {
	    mappedVouchers = currentVouchers.map(function (i) {
	      return vouchers[i];
	    });
	  } catch (e) {
	    mappedVouchers = [];
	  }
	
	  return mappedVouchers;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var voucher = state.voucher,
	      savedFilters = state.savedFilters,
	      entities = state.entities;
	
	  return {
	    voucher: voucher,
	    vouchers: cookVouchers(voucher.currentVouchers, entities.vouchers),
	    savedFilters: savedFilters.voucher
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getVouchers: _voucherActions.getVouchers, updateVoucherFilters: _voucherActions.updateVoucherFilters, saveFilter: _savedFiltersActions.saveFilter, removeFilter: _savedFiltersActions.removeFilter };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherIndex);

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(9);
	
	var _importer = __webpack_require__(789);
	
	var _importer2 = _interopRequireDefault(_importer);
	
	var _fileImporter = __webpack_require__(309);
	
	var importerActions = _interopRequireWildcard(_fileImporter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	  var fileImporter = state.forms.fileImporter;
	
	  return {
	    importerState: fileImporter
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    importerActions: (0, _redux.bindActionCreators)(importerActions, dispatch)
	  };
	}
	
	var VoucherItem = (_temp = _class = function (_Component) {
	  _inherits(VoucherItem, _Component);
	
	  function VoucherItem() {
	    _classCallCheck(this, VoucherItem);
	
	    return _possibleConstructorReturn(this, (VoucherItem.__proto__ || Object.getPrototypeOf(VoucherItem)).apply(this, arguments));
	  }
	
	  _createClass(VoucherItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          importerState = _props.importerState,
	          importerActions = _props.importerActions,
	          params = _props.params;
	      var store_id = params.store_id,
	          discount_id = params.discount_id;
	
	      var path = '/v2/' + store_id + '/vouchers/' + discount_id;
	      var importerProps = Object.assign({}, importerState, {
	        title: "Import Voucher",
	        onClose: importerActions.closeFileImporter,
	        onUpload: importerActions.uploadFile,
	        onSubmit: importerActions.submitFile
	      });
	
	      var importerOpener = function importerOpener() {
	        importerActions.showFileImporter(store_id, discount_id);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(_importer2.default, importerProps),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-tab' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path + '/overview', className: 'nav-link', activeClassName: 'active' },
	                'Overview'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path + '/associate', className: 'nav-link', activeClassName: 'active' },
	                'Associated Products'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: path + '/vouchers', className: 'nav-link', activeClassName: 'active' },
	                'Vouchers'
	              )
	            )
	          )
	        ),
	        _react2.default.cloneElement(this.props.children, { importerOpener: importerOpener })
	      );
	    }
	  }]);
	
	  return VoucherItem;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    discount_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  children: _propTypes2.default.element.isRequired,
	  importerState: _propTypes2.default.object.isRequired,
	  importerActions: _propTypes2.default.object.isRequired
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherItem);

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _voucherActions = __webpack_require__(59);
	
	var _overviewForm = __webpack_require__(320);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _formater = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VoucherOverviewNew = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherOverviewNew, _Component);
	
	  function VoucherOverviewNew() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherOverviewNew);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherOverviewNew.__proto__ || Object.getPrototypeOf(VoucherOverviewNew)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
	      var store_id = _this.props.params.store_id;
	      //redux-form v5.3 not support array vilidation message, validate it here
	
	      var error = undefined;
	      for (var i = 0; i < data.date_ranges.length; i++) {
	        data.date_ranges.forEach(function (range, i) {
	          var start_from = range.start_from,
	              end_at = range.end_at;
	
	          if (!start_from.length) {
	            error = 'Blackout date range #' + (i + 1) + ': Start date should not be blank.';
	          } else if (!end_at.length) {
	            error = 'Blackout date range #' + (i + 1) + ': End date should not be blank.';
	          } else if (new Date(start_from) - new Date(end_at) > 0) {
	            error = 'Blackout date range #' + (i + 1) + ': Invalid date range.';
	          }
	          if (error) return;
	        });
	      }
	      if (error) {
	        alert(error);
	        return;
	      }
	      var voucher = (0, _formater.formatUpdateVoucher)(data);
	
	      var createVoucher = _this.props.actions.createVoucher;
	
	
	      createVoucher(store_id, { voucher_discount: voucher }).then(function (data) {
	        var discount_id = Object.keys(data.entities.vouchers)[0];
	        var showPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/overview';
	        _this.context.router.push(showPath);
	      });
	    }, _this.handleSubmit = function () {
	      _this.refs.VoucherOverviewForm.submit();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherOverviewNew, [{
	    key: 'render',
	    value: function render() {
	      var store_id = this.props.params.store_id;
	
	      var backPath = '/v2/' + store_id + '/vouchers';
	
	      var init = {
	        initialValues: {
	          expiration_type: _overviewForm.EXPIRATION_TYPE.NEVER,
	          revenue_recognition: _overviewForm.REVENUE.SALES
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Vouchers'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: backPath, className: 'btn btn-secondary btn-sm' },
	              'Cancel'
	            ),
	            ' \xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(_overviewForm2.default, _extends({ ref: 'VoucherOverviewForm'
	        }, init, {
	          onSubmit: this.onSubmit }))
	      );
	    }
	  }]);
	
	  return VoucherOverviewNew;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  actions: _propTypes2.default.object.isRequired
	}, _temp2);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { createVoucher: _voucherActions.createVoucher };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherOverviewNew);

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _voucherActions = __webpack_require__(59);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _overviewForm = __webpack_require__(320);
	
	var _overviewForm2 = _interopRequireDefault(_overviewForm);
	
	var _formater = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var vouchers = state.entities.vouchers;
	
	
	  var voucher = vouchers && vouchers[ownProps.params.discount_id];
	  if (voucher) {
	    var expiration_duration = void 0,
	        expiration_date = void 0;
	    if (voucher.expiration_setting.type === _overviewForm.EXPIRATION_TYPE.DURATION) {
	      expiration_duration = Math.floor(Number(voucher.expiration_setting.value) / Number(_overviewForm.perDaySecons));
	    } else {
	      expiration_date = voucher.expiration_setting.value;
	    }
	    var date_ranges = voucher.date_ranges || [];
	    date_ranges.forEach(function (range) {
	      range.start_from = range.start_from.substr(0, 10);
	      range.end_at = range.end_at.substr(0, 10);
	    });
	
	    voucher = {
	      id: voucher.id,
	      name: voucher.name,
	      notes: voucher.notes,
	      price: String(voucher.price),
	      amount: String(voucher.amount),
	      expiration_type: voucher.expiration_setting.type,
	      expiration_date: expiration_date,
	      expiration_duration: expiration_duration,
	      revenue_recognition: voucher.revenue_recognition,
	      date_ranges: date_ranges
	    };
	  }
	
	  return {
	    voucher: voucher
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getVoucher: _voucherActions.getVoucher, updateVoucher: _voucherActions.updateVoucher };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherOverviewEdit = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherOverviewEdit, _Component);
	
	  function VoucherOverviewEdit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherOverviewEdit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherOverviewEdit.__proto__ || Object.getPrototypeOf(VoucherOverviewEdit)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
	      var _this$props$params = _this.props.params,
	          store_id = _this$props$params.store_id,
	          discount_id = _this$props$params.discount_id;
	      var updateVoucher = _this.props.actions.updateVoucher;
	
	      var showPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/overview';
	
	      //redux-form v5.3 not support array vilidation message, validate it here
	      var error = undefined;
	      for (var i = 0; i < data.date_ranges.length; i++) {
	        data.date_ranges.forEach(function (range, i) {
	          var start_from = range.start_from,
	              end_at = range.end_at;
	
	          if (!start_from.length) {
	            error = 'Blackout date range #' + (i + 1) + ': Start date should not be blank.';
	          } else if (!end_at.length) {
	            error = 'Blackout date range #' + (i + 1) + ': End date should not be blank.';
	          } else if (new Date(start_from) - new Date(end_at) > 0) {
	            error = 'Blackout date range #' + (i + 1) + ': Invalid date range.';
	          }
	          if (error) return;
	        });
	      }
	      if (error) {
	        alert(error);
	        return;
	      }
	
	      var voucher = (0, _formater.formatUpdateVoucher)(data);
	
	      updateVoucher(store_id, discount_id, { voucher_discount: voucher }).then(function (data) {
	        _this.context.router.push(showPath);
	      });
	    }, _this.handleSubmit = function () {
	      _this.refs.VoucherOverviewForm.submit();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherOverviewEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          discount_id = _props$params.discount_id;
	      var getVoucher = this.props.actions.getVoucher;
	
	
	      getVoucher(store_id, discount_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var voucher = this.props.voucher;
	      var _props$params2 = this.props.params,
	          store_id = _props$params2.store_id,
	          discount_id = _props$params2.discount_id;
	
	      var showPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/overview';
	
	      if (!voucher) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Voucher'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Vouchers'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'btn btn-secondary btn-sm', to: showPath },
	                'Discard'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm', onClick: this.handleSubmit },
	                'Save'
	              )
	            )
	          ),
	          _react2.default.createElement(_overviewForm2.default, { ref: 'VoucherOverviewForm',
	            onSubmit: this.onSubmit,
	            initialValues: voucher,
	            voucherId: voucher.id })
	        );
	      }
	    }
	  }]);
	
	  return VoucherOverviewEdit;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    discount_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  voucher: _propTypes2.default.object,
	  actions: _propTypes2.default.object
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherOverviewEdit);

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _voucherActions = __webpack_require__(59);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _formater = __webpack_require__(321);
	
	var _can = __webpack_require__(52);
	
	var _can2 = _interopRequireDefault(_can);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var vouchers = state.entities.vouchers;
	  var discount_id = ownProps.params.discount_id;
	
	
	  var voucher = vouchers && vouchers[discount_id];
	  if (voucher) {
	    voucher = (0, _formater.formatVoucher)(voucher);
	  }
	
	  return {
	    voucher: voucher,
	    params: ownProps.params
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var actions = { getVoucher: _voucherActions.getVoucher };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	var VoucherOverviewShow = (_temp = _class = function (_Component) {
	  _inherits(VoucherOverviewShow, _Component);
	
	  function VoucherOverviewShow() {
	    _classCallCheck(this, VoucherOverviewShow);
	
	    return _possibleConstructorReturn(this, (VoucherOverviewShow.__proto__ || Object.getPrototypeOf(VoucherOverviewShow)).apply(this, arguments));
	  }
	
	  _createClass(VoucherOverviewShow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$params = this.props.params,
	          store_id = _props$params.store_id,
	          discount_id = _props$params.discount_id;
	      var getVoucher = this.props.actions.getVoucher;
	
	
	      getVoucher(store_id, discount_id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          importerOpener = _props.importerOpener,
	          params = _props.params;
	      var store_id = params.store_id,
	          discount_id = params.discount_id;
	
	      var editPath = '/v2/' + store_id + '/vouchers/' + discount_id + '/overview/edit';
	
	      var voucher = this.props.voucher || {
	        expiration_setting: {
	          value: 0,
	          type: ""
	        },
	        date_ranges: []
	      };
	
	      if (!voucher) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading Voucher'
	        );
	      } else {
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'header',
	            { className: 'main-content-header columns' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'main-content-title columns-main' },
	              'Vouchers'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-secondary btn-sm', onClick: importerOpener },
	                'Import'
	              ),
	              _react2.default.createElement(
	                _can2.default,
	                { action: 'voucher:edit' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: editPath, className: 'btn btn-primary btn-sm' },
	                  'Edit'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'TITLE'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'VOUCHER TYPE ID'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.id
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'DESCRIPTION'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.notes
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'FACE VALUE'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.amount
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'PRICE'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.price
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'REVENUE RECOGNITION'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.revenue_recognition_text
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mapdata' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'EXPIRATION SETTING'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    voucher.expiration_setting_text
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-section' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Blackout Date'
	            ),
	            voucher.hasOwnProperty('date_ranges') && voucher.date_ranges.map(function (range, i) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'row', key: i },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    '#',
	                    i + 1
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'Start Date'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    (0, _formatHelper.date)(range.start_from)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-label' },
	                    'End Date'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mapdata-value' },
	                    (0, _formatHelper.date)(range.end_at)
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return VoucherOverviewShow;
	}(_react.Component), _class.propTypes = {
	  params: _propTypes2.default.shape({
	    store_id: _propTypes2.default.string.isRequired,
	    discount_id: _propTypes2.default.string.isRequired
	  }).isRequired,
	  voucher: _propTypes2.default.object,
	  actions: _propTypes2.default.shape({
	    getVoucher: _propTypes2.default.func.isRequired
	  }).isRequired,
	  importerOpener: _propTypes2.default.func.isRequired
	}, _temp);
	exports.mapStateToProps = mapStateToProps;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherOverviewShow);

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapStateToProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactModal = __webpack_require__(65);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _griddleReact = __webpack_require__(57);
	
	var _griddleReact2 = _interopRequireDefault(_griddleReact);
	
	var _voucherActions = __webpack_require__(59);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _actionButton = __webpack_require__(106);
	
	var _actionButton2 = _interopRequireDefault(_actionButton);
	
	var _vouchersAction = __webpack_require__(939);
	
	var _vouchersAction2 = _interopRequireDefault(_vouchersAction);
	
	var _newVoucherForm = __webpack_require__(938);
	
	var _newVoucherForm2 = _interopRequireDefault(_newVoucherForm);
	
	var _formatHelper = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var _ownProps$params = ownProps.params,
	      discount_id = _ownProps$params.discount_id,
	      store_id = _ownProps$params.store_id;
	  var vouchers = state.entities.vouchers;
	
	  var coupons = void 0,
	      timezone = void 0;
	
	  try {
	    timezone = state.stores.find(function (store) {
	      return store.id == store_id;
	    }).timezone;
	  } catch (e) {
	    timezone = 'Asia/Hong_Kong';
	    console.warn('missing store timezone info, use Asia/Hong_Kong');
	  }
	
	  try {
	    coupons = vouchers[parseInt(discount_id)].coupons || [];
	  } catch (e) {
	    coupons = [];
	  }
	
	  function cookCoupons(coupons) {
	    coupons.forEach(function (coupon) {
	      coupon.created_at_text = (0, _formatHelper.dateTime)(coupon.created_at, timezone);
	      coupon.expired_at_text = (0, _formatHelper.dateTime)(coupon.expired_at, timezone);
	    });
	
	    return coupons;
	  }
	  return {
	    coupons: cookCoupons(coupons),
	    criteria: state.voucherCoupon.criteria
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  var _ownProps$params2 = ownProps.params,
	      store_id = _ownProps$params2.store_id,
	      discount_id = _ownProps$params2.discount_id;
	
	
	  var actions = {
	    getVoucherCoupons: _voucherActions.getVoucherCoupons.bind(null, store_id, discount_id),
	    createVoucherCoupons: _voucherActions.createVoucherCoupons.bind(null, store_id, discount_id)
	  };
	  return {
	    actions: (0, _redux.bindActionCreators)(actions, dispatch)
	  };
	};
	
	// Voucher list settings
	var columnMetadatas = [{
	  columnName: "id",
	  displayName: "Bindo voucher id"
	}, {
	  columnName: "code",
	  displayName: "store voucher id"
	}, {
	  columnName: "expired_at_text",
	  displayName: "expired at"
	}, {
	  columnName: "created_at_text",
	  displayName: "created at"
	}, {
	  columnName: "status",
	  displayName: "status"
	}, {
	  columnName: " ",
	  displayName: "",
	  customComponent: _vouchersAction2.default
	}];
	
	// Columns for grid display
	var columns = columnMetadatas.map(function (i) {
	  return i.columnName;
	});
	
	var VoucherVouchers = (_temp2 = _class = function (_Component) {
	  _inherits(VoucherVouchers, _Component);
	
	  function VoucherVouchers() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VoucherVouchers);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VoucherVouchers.__proto__ || Object.getPrototypeOf(VoucherVouchers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      newVoucher: false
	    }, _this.newVoucher = function () {
	      _this.setState({
	        newVoucher: true
	      });
	    }, _this.closeNewVoucher = function () {
	      _this.setState({
	        newVoucher: false
	      });
	    }, _this.createVoucher = function (data) {
	      _this.props.actions.createVoucherCoupons(data);
	
	      _this.closeNewVoucher();
	    }, _this.setPage = function (index) {
	      var criteria = _this.props.criteria;
	
	
	      var page = index >= criteria.totalPages ? criteria.totalPages : index < 1 ? 1 : index + 1;
	
	      _this.props.actions.getVoucherCoupons(page, criteria.perPage, undefined);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VoucherVouchers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.actions.getVoucherCoupons();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          coupons = _props.coupons,
	          criteria = _props.criteria;
	
	      var fetchingData = false;
	
	      // Show loading if still fetching
	      if (fetchingData) {
	        return _react2.default.createElement(
	          _loading2.default,
	          null,
	          'Loading vouchers...'
	        );
	      }
	
	      var customStyles = {
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          transform: 'translate(-50%, -50%)'
	
	        },
	        overlay: {
	          zIndex: 1111
	        }
	      };
	      var noop = function noop() {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'voucher-vouchers' },
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'main-content-title columns-main' },
	            'Vouchers'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_griddleReact2.default, {
	            useGriddleStyles: false,
	            tableClassName: 'table table-bordered data-table',
	            results: coupons,
	            resultsPerPage: 50,
	            columns: columns,
	            columnMetadata: columnMetadatas,
	
	            useExternal: true,
	            externalSetPage: this.setPage,
	            externalMaxPage: criteria.totalPages,
	            externalChangeSort: noop,
	            externalSetFilter: noop,
	            externalSetPageSize: noop,
	            externalCurrentPage: criteria.page - 1
	
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: '_add' },
	            _react2.default.createElement(
	              _actionButton2.default,
	              { className: 'btn btn-primary', type: 'add', onClick: this.newVoucher },
	              'New Voucher'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { isOpen: this.state.newVoucher, style: customStyles, onRequestClose: this.closeNewVoucher },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-header' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'modal-title' },
	                'Generate New Voucher Coupons'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-body' },
	              _react2.default.createElement(_newVoucherForm2.default, { onSubmit: this.createVoucher })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-footer' },
	              _react2.default.createElement(
	                'span',
	                { className: 'btn btn-secondary', onClick: this.closeNewVoucher },
	                'Cancel'
	              ),
	              ' \xA0',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary', form: 'NewVoucherForm' },
	                'Generate'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VoucherVouchers;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  coupons: _propTypes2.default.array.isRequired,
	  actions: _propTypes2.default.object,
	  criteria: _propTypes2.default.object
	}, _temp2);
	exports.mapStateToProps = mapStateToProps;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VoucherVouchers);

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputSelectBox = __webpack_require__(232);
	
	var _inputSelectBox2 = _interopRequireDefault(_inputSelectBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = (_temp = _class = function (_Component) {
	  _inherits(Step, _Component);
	
	  function Step() {
	    _classCallCheck(this, Step);
	
	    return _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
	  }
	
	  _createClass(Step, [{
	    key: 'render',
	    value: function render() {
	      var stepNumber = this.props.stepNumber;
	
	
	      var title = stepNumber === 0 ? 'WORKFLOW' : 'STEP ' + (stepNumber + 1);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6 col-md-3' },
	          _react2.default.createElement(_inputSelectBox2.default, _extends({ title: title }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return Step;
	}(_react.Component), _class.propTypes = {
	  stepNumber: _propTypes2.default.number.isRequired
	}, _class.defaultProps = {
	  placeholder: ''
	}, _temp);
	exports.default = Step;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _formatHelper = __webpack_require__(35);
	
	var _grid = __webpack_require__(66);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _workflowActions = __webpack_require__(312);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	  var entities = state.entities;
	
	  var workflows = [];
	
	  if (entities.workflows) {
	    workflows = (0, _values2.default)(entities.workflows);
	  }
	
	  return {
	    workflows: workflows
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    removeWorkflow: (0, _redux.bindActionCreators)(_workflowActions.removeWorkflow, dispatch),
	    getWorkflows: (0, _redux.bindActionCreators)(_workflowActions.getWorkflows, dispatch)
	  };
	}
	
	var WorkflowSetUpIndex = (_temp = _class = function (_Component) {
	  _inherits(WorkflowSetUpIndex, _Component);
	
	  function WorkflowSetUpIndex(props) {
	    _classCallCheck(this, WorkflowSetUpIndex);
	
	    var _this = _possibleConstructorReturn(this, (WorkflowSetUpIndex.__proto__ || Object.getPrototypeOf(WorkflowSetUpIndex)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      loading: true
	    };
	
	    _this.gridActions = [{ name: 'Edit', onClick: function onClick(item) {
	        var id = item.id;
	        var store_id = _this.props.params.store_id;
	
	        _routeHelper2.default.goWorkflowSetUp(store_id, id);
	      } }, { name: 'Remove', onClick: function onClick(item) {
	        if (!confirm('Do you really want to remove this item?')) return false;
	        var id = item.id,
	            store_id = item.store_id;
	
	        _this.props.removeWorkflow(id, store_id).then(function (resp) {
	          var error = resp.error;
	
	          if (!error) {
	            alert('Remove item successfully.');
	          } else {
	            alert('Remove item failed.');
	          }
	        });
	      } }];
	
	    _this.columns = [{ columnName: 'name', displayName: 'TITLE' }, { columnName: 'workflow_statuses', displayName: 'WORKFLOW', customComponent: _this.workflowFormatter }, { columnName: 'created_at', displayName: 'CREATED AT', customComponent: _this.timeFormatter }];
	    return _this;
	  }
	
	  _createClass(WorkflowSetUpIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var store_id = this.props.params.store_id;
	
	      this.props.getWorkflows(store_id).then(function () {
	        _this2.setState({ loading: false }); //eslint-disable-line react/no-did-mount-set-state
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var workflows = this.props.workflows;
	      var loading = this.state.loading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-tab' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link active' },
	                'Overview'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm',
	                onClick: this.handleCreate,
	                type: 'submit' },
	              'New Workflow'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section ' },
	          loading ? _react2.default.createElement(
	            _loading2.default,
	            null,
	            'Loading...'
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_grid.GridBody, { data: workflows,
	              selectable: false,
	              actions: this.gridActions,
	              columns: this.columns })
	          )
	        )
	      );
	    }
	  }]);
	
	  return WorkflowSetUpIndex;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  currentStore: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  workflows: _propTypes2.default.array.isRequired,
	
	  removeWorkflow: _propTypes2.default.func.isRequired,
	  getWorkflows: _propTypes2.default.func.isRequired
	}, _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleCreate = function () {
	    var store_id = _this3.props.params.store_id;
	
	    _routeHelper2.default.goWorkflowSetUp(store_id, 'new');
	  };
	
	  this.workflowFormatter = function (props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    if (data && data.length) {
	      var steps = linksToList(data);
	      return _react2.default.createElement(
	        'span',
	        null,
	        steps.map(function (w) {
	          return w.status;
	        }).join(' > ')
	      );
	    } else {
	      return null;
	    }
	  };
	
	  this.timeFormatter = function (props) {
	    var data = props.data; //eslint-disable-line react/prop-types
	
	    var timezine = _this3.context.currentStore && _this3.context.currentStore.timezone;
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatHelper.dateTime)(data, timezine)
	    );
	  };
	}, _temp);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorkflowSetUpIndex);
	
	
	function linksToList(actions) {
	  var links = {};
	  var all = {};
	  var froms = {};
	  var tos = {};
	  actions.forEach(function (_ref) {
	    var from_status = _ref.from_status,
	        to_status = _ref.to_status;
	
	    from_status = from_status || {};
	    to_status = to_status || {};
	    links[from_status.id] = to_status.id;
	    all[from_status.id] = from_status;
	    all[to_status.id] = to_status;
	    froms[from_status.id] = from_status;
	    tos[to_status.id] = to_status;
	  });
	  var start = Object.keys(all).filter(function (i) {
	    return tos[i] === undefined;
	  });
	  if (start.length) {
	    var from = start[0];
	    var list = [];
	    list.push(all[start[0]]);
	    var to = links[from];
	    while (to !== undefined) {
	      list.push(all[to]);
	      to = links[to];
	    }
	    return list;
	  } else {
	    return [];
	  }
	}

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _workflowOverview = __webpack_require__(464);
	
	var workflowOverview = _interopRequireWildcard(_workflowOverview);
	
	var _workflowActions = __webpack_require__(312);
	
	var _lineItemStatusAction = __webpack_require__(151);
	
	var _routeHelper = __webpack_require__(31);
	
	var _routeHelper2 = _interopRequireDefault(_routeHelper);
	
	var _inputBox = __webpack_require__(76);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	var _step = __webpack_require__(947);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var workflowOverview = state.forms.workflowOverview;
	  var entities = state.entities;
	
	  var lineItemStatuses = [];
	  if (entities && entities.lineItemStatuses) {
	    lineItemStatuses = (0, _values2.default)(entities.lineItemStatuses);
	  }
	  return Object.assign({}, workflowOverview, { lineItemStatuses: lineItemStatuses });
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(workflowOverview, dispatch),
	    getWorkflow: (0, _redux.bindActionCreators)(_workflowActions.getWorkflow, dispatch),
	    getLineItemStatuses: (0, _redux.bindActionCreators)(_lineItemStatusAction.getLineItemStatuses, dispatch)
	  };
	}
	
	var WorkflowSetupItem = (_temp2 = _class = function (_Component) {
	  _inherits(WorkflowSetupItem, _Component);
	
	  function WorkflowSetupItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorkflowSetupItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkflowSetupItem.__proto__ || Object.getPrototypeOf(WorkflowSetupItem)).call.apply(_ref, [this].concat(args))), _this), _this.discard = function () {
	      var store_id = _this.props.params.store_id;
	
	      _routeHelper2.default.goWorkflowSetUp(store_id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(WorkflowSetupItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          getLineItemStatuses = _props.getLineItemStatuses,
	          params = _props.params,
	          actions = _props.actions;
	      var workflow_id = params.workflow_id,
	          store_id = params.store_id;
	
	
	      getLineItemStatuses(store_id);
	      if (workflow_id !== undefined) {
	        this.props.getWorkflow(workflow_id, store_id).then(function (resp) {
	          var workflow = resp.workflow,
	              error = resp.error;
	
	          if (!error) {
	            actions.showWorkflowOverview({ initialValues: workflow, isCreating: false });
	          }
	        });
	      } else {
	        actions.showWorkflowOverview({ initial: null, isCreating: true });
	      }
	    }
	  }, {
	    key: 'renderSteps',
	    value: function renderSteps() {
	      var _props2 = this.props,
	          steps = _props2.steps,
	          lineItemStatuses = _props2.lineItemStatuses,
	          actions = _props2.actions;
	
	
	      var options = lineItemStatuses.slice();
	      options.forEach(function (s) {
	        s.value = s.status;
	        s.label = s.status;
	      });
	      if (!steps.length) {
	        steps = [undefined];
	      }
	      return steps.map(function (step, i) {
	        return _react2.default.createElement(_step2.default, { value: step,
	          valueKey: 'status',
	          placeholder: 'Select Status',
	          key: i,
	          resetValue: undefined,
	          onChange: function onChange(lineItemStatus) {
	            return actions.selectWorkflowTitle({ stepNumber: i, lineItemStatus: lineItemStatus });
	          },
	          options: options,
	          stepNumber: i });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          title = _props3.title,
	          params = _props3.params;
	      var store_id = params.store_id;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'main-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-tab' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-link active' },
	                'Overview'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'header',
	          { className: 'main-content-header columns' },
	          _react2.default.createElement('h1', { className: 'main-content-title columns-main' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary btn-sm',
	                onClick: this.discard,
	                type: 'submit' },
	              'Cancel'
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-sm',
	                onClick: function onClick() {
	                  return actions.saveWorkflowSetting(store_id);
	                },
	                type: 'submit' },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-section ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 col-sm-12' },
	              _react2.default.createElement(_inputBox2.default, { title: 'WORKFLOW TITLE',
	                value: title,
	                type: 'text',
	                onChange: function onChange(e) {
	                  return actions.changeWorkflowTitle(e.target.value);
	                } })
	            )
	          ),
	          this.renderSteps(),
	          _react2.default.createElement(
	            'a',
	            { className: 'btn', onClick: actions.addWorkflowNextStep },
	            _react2.default.createElement('i', { className: 'fa fa-plus-circle' }),
	            ' Add Next Step'
	          )
	        )
	      );
	    }
	  }]);
	
	  return WorkflowSetupItem;
	}(_react.Component), _class.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	}, _class.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  steps: _propTypes2.default.array.isRequired,
	  isCreating: _propTypes2.default.bool.isRequired,
	  lineItemStatuses: _propTypes2.default.array.isRequired,
	
	  actions: _propTypes2.default.object.isRequired,
	  getWorkflow: _propTypes2.default.func.isRequired,
	  getLineItemStatuses: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorkflowSetupItem);

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _connectHelper = __webpack_require__(812);
	
	var _requireAuthHelper = __webpack_require__(815);
	
	var _constants = __webpack_require__(26);
	
	var _actions = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var IVactions = _interopRequireWildcard(_inventoryVarianceActions);
	
	var _index = __webpack_require__(828);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _base = __webpack_require__(875);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _index3 = __webpack_require__(877);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _base3 = __webpack_require__(866);
	
	var _base4 = _interopRequireDefault(_base3);
	
	var _base5 = __webpack_require__(834);
	
	var _base6 = _interopRequireDefault(_base5);
	
	var _index5 = __webpack_require__(843);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _show = __webpack_require__(845);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _showOverview = __webpack_require__(847);
	
	var _showOverview2 = _interopRequireDefault(_showOverview);
	
	var _showSupplier = __webpack_require__(848);
	
	var _showSupplier2 = _interopRequireDefault(_showSupplier);
	
	var _showTaxOption = __webpack_require__(849);
	
	var _showTaxOption2 = _interopRequireDefault(_showTaxOption);
	
	var _showLog = __webpack_require__(846);
	
	var _showLog2 = _interopRequireDefault(_showLog);
	
	var _editOverview = __webpack_require__(839);
	
	var _editOverview2 = _interopRequireDefault(_editOverview);
	
	var _editSupplier = __webpack_require__(840);
	
	var _editSupplier2 = _interopRequireDefault(_editSupplier);
	
	var _editTaxOption = __webpack_require__(841);
	
	var _editTaxOption2 = _interopRequireDefault(_editTaxOption);
	
	var _newItem = __webpack_require__(844);
	
	var _newItem2 = _interopRequireDefault(_newItem);
	
	var _importer = __webpack_require__(842);
	
	var _importer2 = _interopRequireDefault(_importer);
	
	var _index7 = __webpack_require__(825);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _newItem3 = __webpack_require__(827);
	
	var _newItem4 = _interopRequireDefault(_newItem3);
	
	var _item = __webpack_require__(826);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _index9 = __webpack_require__(874);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(948);
	
	var _index12 = _interopRequireDefault(_index11);
	
	var _item3 = __webpack_require__(949);
	
	var _item4 = _interopRequireDefault(_item3);
	
	var _index13 = __webpack_require__(880);
	
	var _index14 = _interopRequireDefault(_index13);
	
	var _item5 = __webpack_require__(883);
	
	var _item6 = _interopRequireDefault(_item5);
	
	var _itemOverview = __webpack_require__(882);
	
	var _itemOverview2 = _interopRequireDefault(_itemOverview);
	
	var _itemOverviewEdit = __webpack_require__(881);
	
	var _itemOverviewEdit2 = _interopRequireDefault(_itemOverviewEdit);
	
	var _newItem5 = __webpack_require__(884);
	
	var _newItem6 = _interopRequireDefault(_newItem5);
	
	var _productionOrder = __webpack_require__(885);
	
	var _productionOrder2 = _interopRequireDefault(_productionOrder);
	
	var _newItem7 = __webpack_require__(888);
	
	var _newItem8 = _interopRequireDefault(_newItem7);
	
	var _item7 = __webpack_require__(887);
	
	var _item8 = _interopRequireDefault(_item7);
	
	var _itemOverview3 = __webpack_require__(489);
	
	var _itemOverview4 = _interopRequireDefault(_itemOverview3);
	
	var _itemMaterialList = __webpack_require__(886);
	
	var _itemMaterialList2 = _interopRequireDefault(_itemMaterialList);
	
	var _index15 = __webpack_require__(831);
	
	var _index16 = _interopRequireDefault(_index15);
	
	var _Importer = __webpack_require__(829);
	
	var _Importer2 = _interopRequireDefault(_Importer);
	
	var _newItem9 = __webpack_require__(833);
	
	var _newItem10 = _interopRequireDefault(_newItem9);
	
	var _item9 = __webpack_require__(832);
	
	var _item10 = _interopRequireDefault(_item9);
	
	var _index17 = __webpack_require__(941);
	
	var _index18 = _interopRequireDefault(_index17);
	
	var _item11 = __webpack_require__(942);
	
	var _item12 = _interopRequireDefault(_item11);
	
	var _overviewShow = __webpack_require__(945);
	
	var _overviewShow2 = _interopRequireDefault(_overviewShow);
	
	var _overviewEdit = __webpack_require__(944);
	
	var _overviewEdit2 = _interopRequireDefault(_overviewEdit);
	
	var _newItem11 = __webpack_require__(943);
	
	var _newItem12 = _interopRequireDefault(_newItem11);
	
	var _deleteItem = __webpack_require__(940);
	
	var _deleteItem2 = _interopRequireDefault(_deleteItem);
	
	var _associatedProductsEdit = __webpack_require__(933);
	
	var _associatedProductsEdit2 = _interopRequireDefault(_associatedProductsEdit);
	
	var _associatedProductsShow = __webpack_require__(934);
	
	var _associatedProductsShow2 = _interopRequireDefault(_associatedProductsShow);
	
	var _vouchers = __webpack_require__(946);
	
	var _vouchers2 = _interopRequireDefault(_vouchers);
	
	var _constant = __webpack_require__(108);
	
	var _invoice = __webpack_require__(857);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _invoiceCreate = __webpack_require__(856);
	
	var _invoiceCreate2 = _interopRequireDefault(_invoiceCreate);
	
	var _quote = __webpack_require__(859);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _quoteCreate = __webpack_require__(858);
	
	var _quoteCreate2 = _interopRequireDefault(_quoteCreate);
	
	var _constants2 = __webpack_require__(26);
	
	var _index19 = __webpack_require__(890);
	
	var _index20 = _interopRequireDefault(_index19);
	
	var _item13 = __webpack_require__(891);
	
	var _item14 = _interopRequireDefault(_item13);
	
	var _newItem13 = __webpack_require__(892);
	
	var _newItem14 = _interopRequireDefault(_newItem13);
	
	var _policies = __webpack_require__(906);
	
	var _policies2 = _interopRequireDefault(_policies);
	
	var _delivery = __webpack_require__(897);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _associates = __webpack_require__(896);
	
	var _associates2 = _interopRequireDefault(_associates);
	
	var _roundingBehavior = __webpack_require__(907);
	
	var _roundingBehavior2 = _interopRequireDefault(_roundingBehavior);
	
	var _kds = __webpack_require__(904);
	
	var _kds2 = _interopRequireDefault(_kds);
	
	var _item15 = __webpack_require__(905);
	
	var _item16 = _interopRequireDefault(_item15);
	
	var _embeddedBarcode = __webpack_require__(898);
	
	var _embeddedBarcode2 = _interopRequireDefault(_embeddedBarcode);
	
	var _table = __webpack_require__(911);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _tableSizingSegmentation = __webpack_require__(908);
	
	var _tableSizingSegmentation2 = _interopRequireDefault(_tableSizingSegmentation);
	
	var _uomGroup = __webpack_require__(914);
	
	var _uomGroup2 = _interopRequireDefault(_uomGroup);
	
	var _item17 = __webpack_require__(915);
	
	var _item18 = _interopRequireDefault(_item17);
	
	var _storeCredit = __webpack_require__(920);
	
	var _storeCredit2 = _interopRequireDefault(_storeCredit);
	
	var _signature = __webpack_require__(919);
	
	var _signature2 = _interopRequireDefault(_signature);
	
	var _paymentType = __webpack_require__(918);
	
	var _paymentType2 = _interopRequireDefault(_paymentType);
	
	var _addOns = __webpack_require__(893);
	
	var _addOns2 = _interopRequireDefault(_addOns);
	
	var _tableau = __webpack_require__(932);
	
	var _tableau2 = _interopRequireDefault(_tableau);
	
	var _advanced = __webpack_require__(929);
	
	var _advanced2 = _interopRequireDefault(_advanced);
	
	var _chinese = __webpack_require__(931);
	
	var _chinese2 = _interopRequireDefault(_chinese);
	
	var _admin = __webpack_require__(928);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _pms = __webpack_require__(923);
	
	var _pms2 = _interopRequireDefault(_pms);
	
	var _referenceNumber = __webpack_require__(925);
	
	var _referenceNumber2 = _interopRequireDefault(_referenceNumber);
	
	var _kitchenDepartment = __webpack_require__(864);
	
	var _kitchenDepartment2 = _interopRequireDefault(_kitchenDepartment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/' },
	  _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/' + _constants.ROUTE.SITE_PREFIX }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: _constants.ROUTE.SITE_PREFIX },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _connectHelper.wrapConnect)((0, _requireAuthHelper.requireAuth)(_index2.default), actions) }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: ':store_id', component: (0, _connectHelper.wrapConnect)((0, _requireAuthHelper.requireAuth)(_base4.default), actions) },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'inventory', component: (0, _connectHelper.wrapConnect)(_base6.default, actions) },
	        _react2.default.createElement(_reactRouter.Route, { path: 'importer', component: (0, _connectHelper.wrapConnect)(_importer2.default, actions) }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: (0, _connectHelper.wrapConnect)(_newItem2.default, actions) }),
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _connectHelper.wrapConnect)(_index6.default, actions) }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':listing_id', component: (0, _connectHelper.wrapConnect)(_show2.default, actions) },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'overview' }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'overview' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _showOverview2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: (0, _connectHelper.wrapConnect)(_editOverview2.default, actions) })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'supplier' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _connectHelper.wrapConnect)(_showSupplier2.default, actions) }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit-supplier', component: (0, _connectHelper.wrapConnect)(_editSupplier2.default, actions) })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'tax' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _connectHelper.wrapConnect)(_showTaxOption2.default, actions) }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit-tax', component: (0, _connectHelper.wrapConnect)(_editTaxOption2.default, actions) })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'log', component: (0, _connectHelper.wrapConnect)(_showLog2.default, actions) }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: (0, _connectHelper.wrapConnect)(_editOverview2.default, actions) })
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.PRODUCTION_ORDERS },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _productionOrder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _newItem8.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':production_order_id', component: _item8.default },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'overview' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'overview', component: _itemOverview4.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'material-list', component: _itemMaterialList2.default })
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.INVENTORY_VARIANCE },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index16.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _newItem10.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'importer', component: (0, _connectHelper.wrapConnect)(_Importer2.default, IVactions) }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':inventory_variance_id', component: _item10.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: _constants.ROUTE.LINE_ITEM_STATUS_SET_UP, component: _index10.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.WORKFLOW_SET_UP },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index12.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _item4.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':workflow_id', component: _item4.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'membership-levels' },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index14.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _newItem6.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':membership_id', component: _item6.default },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'overview' }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'overview' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _itemOverview2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: _itemOverviewEdit2.default })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'vouchers' },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index18.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _newItem12.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'delete' },
	          _react2.default.createElement(_reactRouter.Route, { path: ':discount_id', component: _deleteItem2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':discount_id', component: _item12.default },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'overview' }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'overview' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _overviewShow2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: _overviewEdit2.default })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'associate' },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _associatedProductsShow2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: _associatedProductsEdit2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'vouchers', component: _vouchers2.default })
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.PROMO_CODES },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index20.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: _constants2.PROMO_CODE.MODE.NEW, component: _newItem14.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':promo_code_id', component: _item14.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.DELIVERY_NOTE },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _index8.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'new/for/:type/:ref_id', component: _newItem4.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':delivery_id', component: _item2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.INVOICES },
	        _react2.default.createElement(_reactRouter.Route, { path: _constant.NEW, component: _invoiceCreate2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':order_number', component: _invoice2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.QUOTES },
	        _react2.default.createElement(_reactRouter.Route, { path: _constant.NEW, component: _quoteCreate2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':order_number', component: _quote2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: _constants.ROUTE.SETTINGS },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: _constants.ROUTE.BUSINESS },
	          _react2.default.createElement(_reactRouter.Route, { path: 'policies', component: _policies2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'delivery', component: _delivery2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'associates', component: _associates2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'rounding-behavior', component: _roundingBehavior2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: _constants.ROUTE.STATIONS },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _connectHelper.wrapConnect)(_kds2.default, actions) }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':station_id', component: _item16.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'barcode', component: _embeddedBarcode2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'table', component: _table2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'table-size-segmentation', component: _tableSizingSegmentation2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: _constants.ROUTE.UOM_GROUPS },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _uomGroup2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'new', component: _item18.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':uom_group_id', component: _item18.default })
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'payments' },
	          _react2.default.createElement(_reactRouter.Route, { path: 'store-credit', component: _storeCredit2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'signature', component: _signature2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'payment-type', component: _paymentType2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'add-ons' },
	          _react2.default.createElement(_reactRouter.IndexRoute, { component: _addOns2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'pms', component: _pms2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'reference-number', component: _referenceNumber2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'tableau', component: _tableau2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'advanced-report', component: _advanced2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'bindo-admin', component: _admin2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'kitchen-departments', component: _kitchenDepartment2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'chinese-report', component: _chinese2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: _constants.ROUTE.LOGIN, component: (0, _connectHelper.wrapConnect)(_base2.default, actions) },
	      _react2.default.createElement(_reactRouter.Route, { path: 'index', component: (0, _connectHelper.wrapConnect)(_index4.default, actions) }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'forget-password', component: (0, _connectHelper.wrapConnect)(_index4.default, actions) })
	    )
	  )
	);

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMeta = exports.getFilters = exports.getFiltersString = exports.getRowsPerPage = exports.getCurrentPage = exports.getLoading = undefined;
	
	var _reselect = __webpack_require__(301);
	
	var _lodash = __webpack_require__(14);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLoading = exports.getLoading = function getLoading(state) {
	  return (0, _lodash.get)(state, 'base.loading');
	};
	
	var getCurrentPage = exports.getCurrentPage = function getCurrentPage(state, props) {
	  return parseInt((0, _lodash.get)(props, 'location.query.page', 1));
	};
	
	var getRowsPerPage = exports.getRowsPerPage = function getRowsPerPage(state, props) {
	  return parseInt((0, _lodash.get)(props, 'location.query.per_page', 25));
	};
	
	var getFiltersString = exports.getFiltersString = function getFiltersString(state, props) {
	  return (0, _lodash.get)(props, 'location.query.filters');
	};
	
	var getFilters = exports.getFilters = (0, _reselect.createSelector)([getFiltersString], function (filtersString) {
	  return _filterHelper2.default.stringToFilters(filtersString);
	});
	
	var getMeta = exports.getMeta = (0, _reselect.createSelector)([getCurrentPage, getRowsPerPage, getFilters], function (currentPage, rowsPerPage, filters) {
	  return { currentPage: currentPage, rowsPerPage: rowsPerPage, filters: filters };
	});

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _normalizr = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociateSchema = new _normalizr.Schema('associates');
	
	var AssociateService = function (_BindoService) {
	  _inherits(AssociateService, _BindoService);
	
	  function AssociateService() {
	    _classCallCheck(this, AssociateService);
	
	    return _possibleConstructorReturn(this, (AssociateService.__proto__ || Object.getPrototypeOf(AssociateService)).apply(this, arguments));
	  }
	
	  _createClass(AssociateService, [{
	    key: 'get',
	    value: function get(store_id, id) {
	      var path = 'v2/stores/' + store_id + '/associates';
	
	      if (id) {
	        path = path + '/' + id;
	      }
	      return _get(AssociateService.prototype.__proto__ || Object.getPrototypeOf(AssociateService.prototype), 'get', this).call(this, path, { per_page: 999999 }).then(function (res) {
	        var data = res.map(function (r) {
	          return r.user;
	        });
	        return (0, _normalizr.normalize)(data, (0, _normalizr.arrayOf)(AssociateSchema));
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(store_id, data) {
	      var path = 'v2/stores/' + store_id + '/new_associate';
	      return _get(AssociateService.prototype.__proto__ || Object.getPrototypeOf(AssociateService.prototype), 'post', this).call(this, path, data).then(function (res) {
	        return (0, _normalizr.normalize)(res.user, AssociateSchema);
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(store_id, data) {
	      var path = 'v2/stores/' + store_id + '/associates';
	      return _get(AssociateService.prototype.__proto__ || Object.getPrototypeOf(AssociateService.prototype), 'post', this).call(this, path, data).then(function (res) {
	        return (0, _normalizr.normalize)(res.user, AssociateSchema);
	      });
	    }
	  }, {
	    key: 'promote',
	    value: function promote(store_id, id, role_id) {
	      var path = 'v2/stores/' + store_id + '/associates/' + id + '/promote';
	      var params = { associate: { role_id: role_id } };
	      return _get(AssociateService.prototype.__proto__ || Object.getPrototypeOf(AssociateService.prototype), 'put', this).call(this, path, params).then(function (res) {
	        return (0, _normalizr.normalize)(res.user, AssociateSchema);
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(store_id, id) {
	      var path = 'v2/stores/' + store_id + '/associates/' + id;
	      return _get(AssociateService.prototype.__proto__ || Object.getPrototypeOf(AssociateService.prototype), 'delete', this).call(this, path).then(function (res) {
	        return (0, _normalizr.normalize)(res.user, AssociateSchema);
	      });
	    }
	  }]);
	
	  return AssociateService;
	}(_bindoService2.default);
	
	exports.default = new AssociateService();

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillOfMaterialsService = function (_BindoService) {
	  _inherits(BillOfMaterialsService, _BindoService);
	
	  function BillOfMaterialsService() {
	    _classCallCheck(this, BillOfMaterialsService);
	
	    return _possibleConstructorReturn(this, (BillOfMaterialsService.__proto__ || Object.getPrototypeOf(BillOfMaterialsService)).apply(this, arguments));
	  }
	
	  _createClass(BillOfMaterialsService, [{
	    key: 'getCollections',
	    value: function getCollections(listingId, storeId) {
	      var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials';
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getDeepCollections',
	    value: function getDeepCollections(listingId, storeId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials?deep=1';
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(id, listingId, storeId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials/' + id;
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'update',
	    value: function update(data, listingId, storeId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials';
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'put', this).call(this, path, { listing: data });
	    }
	  }, {
	    key: 'create',
	    value: function create(data, listingId, storeId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials';
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'post', this).call(this, path, { listing: data });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id, listingId, storeId) {
	      var path = 'v2/stores/' + storeId + '/listings/' + listingId + '/bill_of_materials/' + id;
	      return _get(BillOfMaterialsService.prototype.__proto__ || Object.getPrototypeOf(BillOfMaterialsService.prototype), 'delete', this).call(this, path);
	    }
	  }]);
	
	  return BillOfMaterialsService;
	}(_bindoService2.default);
	
	exports.default = new BillOfMaterialsService();

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DepartmentService = function (_BindoService) {
	  _inherits(DepartmentService, _BindoService);
	
	  function DepartmentService() {
	    _classCallCheck(this, DepartmentService);
	
	    return _possibleConstructorReturn(this, (DepartmentService.__proto__ || Object.getPrototypeOf(DepartmentService)).apply(this, arguments));
	  }
	
	  _createClass(DepartmentService, [{
	    key: 'getItem',
	    value: function getItem(storeId, departmentId) {
	      var path = 'v2/stores/' + storeId + '/departments/' + departmentId;
	
	      return _get(DepartmentService.prototype.__proto__ || Object.getPrototypeOf(DepartmentService.prototype), 'get', this).call(this, path, departmentId);
	    }
	  }, {
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'updated_at';
	
	      var path = 'v2/stores/' + storeId + '/departments';
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: orderBy
	      };
	
	      return _get(DepartmentService.prototype.__proto__ || Object.getPrototypeOf(DepartmentService.prototype), 'get', this).call(this, path, query);
	    }
	  }]);
	
	  return DepartmentService;
	}(_bindoService2.default);
	
	exports.default = new DepartmentService();

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscountService = function (_BindoService) {
	  _inherits(DiscountService, _BindoService);
	
	  function DiscountService() {
	    _classCallCheck(this, DiscountService);
	
	    return _possibleConstructorReturn(this, (DiscountService.__proto__ || Object.getPrototypeOf(DiscountService)).apply(this, arguments));
	  }
	
	  _createClass(DiscountService, [{
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'updated_at';
	
	      var path = 'v2/stores/' + storeId + '/discounts';
	      var query = {
	        page: page,
	        per_page: count,
	        filters: ["discount_type__equal__1"]
	      };
	
	      return _get(DiscountService.prototype.__proto__ || Object.getPrototypeOf(DiscountService.prototype), 'get', this).call(this, path, query, _config2.default.gateway);
	    }
	  }]);
	
	  return DiscountService;
	}(_bindoService2.default);
	
	exports.default = new DiscountService();

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InventoryVarianceService = function (_BindoService) {
	  _inherits(InventoryVarianceService, _BindoService);
	
	  function InventoryVarianceService() {
	    _classCallCheck(this, InventoryVarianceService);
	
	    return _possibleConstructorReturn(this, (InventoryVarianceService.__proto__ || Object.getPrototypeOf(InventoryVarianceService)).apply(this, arguments));
	  }
	
	  _createClass(InventoryVarianceService, [{
	    key: 'getVariances',
	    value: function getVariances(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'created_at';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/inventory_variances';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: orderBy,
	        order_asc: 'desc',
	        filters: filtersQueryList
	      };
	
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'get', this).call(this, path, query);
	    }
	  }, {
	    key: 'changeVarianceStatus',
	    value: function changeVarianceStatus(storeId, id, changeAction) {
	      var path = 'v2/stores/' + storeId + '/inventory_variances/' + id + '/' + changeAction;
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'post', this).call(this, path, undefined);
	    }
	  }, {
	    key: 'getVariance',
	    value: function getVariance(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/inventory_variances/' + id;
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'get', this).call(this, path, undefined);
	    }
	  }, {
	    key: 'update',
	    value: function update(data, id, storeId) {
	      var path = 'v2/stores/' + storeId + '/inventory_variances/' + id;
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'put', this).call(this, path, data);
	    }
	  }, {
	    key: 'create',
	    value: function create(data, storeId) {
	      var path = 'v2/stores/' + storeId + '/inventory_variances';
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'post', this).call(this, path, data);
	    }
	  }, {
	    key: 'getVarianceListings',
	    value: function getVarianceListings(id, storeId) {
	      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
	
	      var query = {
	        page: page,
	        per_page: count
	      };
	      var path = 'v2/stores/' + storeId + '/inventory_variances/' + id + '/items';
	      return _get(InventoryVarianceService.prototype.__proto__ || Object.getPrototypeOf(InventoryVarianceService.prototype), 'get', this).call(this, path, query);
	    }
	  }, {
	    key: 'importInit',
	    value: function importInit(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/inventory_variance_imports';
	      return this.postFile(path, data, _config2.default.goApi);
	    }
	  }, {
	    key: 'getImportIV',
	    value: function getImportIV(storeId, IV_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_variance_imports/' + IV_import_id;
	      return this.get(path, null, _config2.default.goApi);
	    }
	  }, {
	    key: 'postImportIV',
	    value: function postImportIV(storeId, IV_import_id) {
	      var path = 'v2/stores/' + storeId + '/inventory_variance_imports/' + IV_import_id + '/import';
	      var query = {
	        inventory_variances_id: IV_import_id
	      };
	      return this.post(path, query, _config2.default.goApi);
	    }
	  }]);
	
	  return InventoryVarianceService;
	}(_bindoService2.default);
	
	exports.default = new InventoryVarianceService();

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KdsService = function (_BindoService) {
	  _inherits(KdsService, _BindoService);
	
	  function KdsService() {
	    _classCallCheck(this, KdsService);
	
	    return _possibleConstructorReturn(this, (KdsService.__proto__ || Object.getPrototypeOf(KdsService)).apply(this, arguments));
	  }
	
	  _createClass(KdsService, [{
	    key: 'getStations',
	    value: function getStations(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/stations';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: 'name',
	        filters: filtersQueryList
	      };
	
	      return _get(KdsService.prototype.__proto__ || Object.getPrototypeOf(KdsService.prototype), 'get', this).call(this, path, query);
	    }
	  }, {
	    key: 'linkStationToStore',
	    value: function linkStationToStore(data, storeId) {
	      var path = 'v2/stores/' + storeId + '/stations';
	
	      return _get(KdsService.prototype.__proto__ || Object.getPrototypeOf(KdsService.prototype), 'post', this).call(this, path, { station: data });
	    }
	  }, {
	    key: 'getStation',
	    value: function getStation(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/stations/' + id;
	
	      return _get(KdsService.prototype.__proto__ || Object.getPrototypeOf(KdsService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'updateStation',
	    value: function updateStation(data, id, storeId) {
	      var path = 'v2/stores/' + storeId + '/stations/' + id;
	
	      return _get(KdsService.prototype.__proto__ || Object.getPrototypeOf(KdsService.prototype), 'put', this).call(this, path, { station: data });
	    }
	  }, {
	    key: 'removeStation',
	    value: function removeStation(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/stations/' + id;
	
	      return _get(KdsService.prototype.__proto__ || Object.getPrototypeOf(KdsService.prototype), 'delete', this).call(this, path);
	    }
	  }]);
	
	  return KdsService;
	}(_bindoService2.default);
	
	exports.default = new KdsService();

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineItemStatusService = function (_BindoService) {
	  _inherits(LineItemStatusService, _BindoService);
	
	  function LineItemStatusService() {
	    _classCallCheck(this, LineItemStatusService);
	
	    return _possibleConstructorReturn(this, (LineItemStatusService.__proto__ || Object.getPrototypeOf(LineItemStatusService)).apply(this, arguments));
	  }
	
	  _createClass(LineItemStatusService, [{
	    key: "createLineItemStatus",
	    value: function createLineItemStatus(status, color, storeId) {
	      var path = "v2/stores/" + storeId + "/line_item_statuses";
	
	      return _get(LineItemStatusService.prototype.__proto__ || Object.getPrototypeOf(LineItemStatusService.prototype), "post", this).call(this, path, { "line_item_status": { status: status, color: color } });
	    }
	  }, {
	    key: "getLineItemStatuses",
	    value: function getLineItemStatuses(storeId) {
	      var path = "v2/stores/" + storeId + "/line_item_statuses";
	
	      return _get(LineItemStatusService.prototype.__proto__ || Object.getPrototypeOf(LineItemStatusService.prototype), "get", this).call(this, path);
	    }
	  }, {
	    key: "updateLineItemStatus",
	    value: function updateLineItemStatus(id, status, storeId) {
	      var path = "v2/stores/" + storeId + "/line_item_statuses/" + id;
	
	      return _get(LineItemStatusService.prototype.__proto__ || Object.getPrototypeOf(LineItemStatusService.prototype), "put", this).call(this, path, status);
	    }
	  }, {
	    key: "removeLineItemStatus",
	    value: function removeLineItemStatus(id, storeId) {
	      var path = "v2/stores/" + storeId + "/line_item_statuses/" + id;
	
	      return _get(LineItemStatusService.prototype.__proto__ || Object.getPrototypeOf(LineItemStatusService.prototype), "delete", this).call(this, path);
	    }
	  }]);
	
	  return LineItemStatusService;
	}(_bindoService2.default);
	
	exports.default = new LineItemStatusService();

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isomorphicFetch = __webpack_require__(588);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _config = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginService = function () {
	  function LoginService() {
	    _classCallCheck(this, LoginService);
	  }
	
	  _createClass(LoginService, null, [{
	    key: 'login',
	    value: function login(username, password) {
	      var url = _config.bindo + '/v2/login';
	      var data = {
	        username: username,
	        password: password,
	        client_id: _config.clientId,
	        client_secret: _config.clientSecret
	      };
	
	      var result = (0, _isomorphicFetch2.default)(url, {
	        method: 'post',
	        headers: {
	          'Accept': 'application/json',
	          'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(data)
	      }).then(function (response) {
	        if (response.status === 200) {
	          return response.json();
	        } else {
	          //// TODO: define more specific error
	          throw new Error("Login Failed");
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: 'forgetPassword',
	    value: function forgetPassword(email) {
	      var url = _config.bindo + '/v2/forgot_password';
	      url = url + '?identifier=' + email + '&client_id=' + _config.clientId + '&client_secret=' + _config.clientSecret;
	
	      var result = (0, _isomorphicFetch2.default)(url).then(function (response) {
	        if (response.status === 200) {
	          return response.json();
	        } else {
	          //// TODO: define more specific error
	          throw new Error("Forget password Failed");
	        }
	      });
	
	      return result;
	    }
	  }]);
	
	  return LoginService;
	}();
	
	exports.default = LoginService;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MembershipLevelSchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _normalizr = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MembershipLevelSchema = exports.MembershipLevelSchema = new _normalizr.Schema('membership_level');
	
	var MembershipLevelService = function (_BindoService) {
	  _inherits(MembershipLevelService, _BindoService);
	
	  function MembershipLevelService() {
	    _classCallCheck(this, MembershipLevelService);
	
	    return _possibleConstructorReturn(this, (MembershipLevelService.__proto__ || Object.getPrototypeOf(MembershipLevelService)).apply(this, arguments));
	  }
	
	  _createClass(MembershipLevelService, [{
	    key: 'getList',
	    value: function getList(storeId) {
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var path = 'v2/stores/' + storeId + '/membership_levels';
	
	      return _get(MembershipLevelService.prototype.__proto__ || Object.getPrototypeOf(MembershipLevelService.prototype), 'get', this).call(this, path).then(function (res) {
	        // asume user won't set over 1000 membership_levels
	        var memberships = res.data.membership_levels;
	
	        //normalize
	        return (0, _normalizr.normalize)(memberships, (0, _normalizr.arrayOf)(MembershipLevelSchema));
	      });
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(storeId, membershipId) {
	      var path = 'v2/stores/' + storeId + '/membership_levels/' + membershipId;
	      return _get(MembershipLevelService.prototype.__proto__ || Object.getPrototypeOf(MembershipLevelService.prototype), 'get', this).call(this, path, null).then(function (res) {
	        var membership = res.membership_level;
	
	        //normalize
	        return (0, _normalizr.normalize)(membership, MembershipLevelSchema);
	      });
	    }
	  }, {
	    key: 'createItem',
	    value: function createItem(storeId, membership) {
	      var path = 'v2/stores/' + storeId + '/membership_levels';
	      return _get(MembershipLevelService.prototype.__proto__ || Object.getPrototypeOf(MembershipLevelService.prototype), 'post', this).call(this, path, membership).then(function (res) {
	
	        var membership = res.membership_level;
	
	        //normalize
	        return (0, _normalizr.normalize)(membership, MembershipLevelSchema);
	      });
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(storeId, membershipId, data) {
	      var path = 'v2/stores/' + storeId + '/membership_levels/' + membershipId;
	
	      return _get(MembershipLevelService.prototype.__proto__ || Object.getPrototypeOf(MembershipLevelService.prototype), 'put', this).call(this, path, data).then(function (res) {
	        var membership = res.membership_level;
	
	        //normalize
	        return (0, _normalizr.normalize)(membership, MembershipLevelSchema);
	      });
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(storeId, membershipId) {
	
	      var path = 'v2/stores/' + storeId + '/membership_levels/' + membershipId;
	
	      return _get(MembershipLevelService.prototype.__proto__ || Object.getPrototypeOf(MembershipLevelService.prototype), 'delete', this).call(this, path, null).then(function (res) {
	        var membership = res.membership_level;
	
	        //normalize
	        return (0, _normalizr.normalize)(membership, MembershipLevelSchema);
	      });
	    }
	  }]);
	
	  return MembershipLevelService;
	}(_bindoService2.default);
	
	exports.default = new MembershipLevelService();

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _normalizr = __webpack_require__(64);
	
	var _schema = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderCorrespondenceService = function (_BindoService) {
	  _inherits(OrderCorrespondenceService, _BindoService);
	
	  function OrderCorrespondenceService() {
	    _classCallCheck(this, OrderCorrespondenceService);
	
	    return _possibleConstructorReturn(this, (OrderCorrespondenceService.__proto__ || Object.getPrototypeOf(OrderCorrespondenceService)).apply(this, arguments));
	  }
	
	  _createClass(OrderCorrespondenceService, [{
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	      var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	      var path = 'v2/stores/' + storeId + '/order_correspondences';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	      var query = _extends({
	        page: page,
	        per_page: count,
	        order_by: 'name',
	        filters: filtersQueryList
	      }, params);
	
	      return _get(OrderCorrespondenceService.prototype.__proto__ || Object.getPrototypeOf(OrderCorrespondenceService.prototype), 'get', this).call(this, path, query, _config2.default.gateway).then(function (res) {
	        var data = res.data,
	            meta = _objectWithoutProperties(res, ['data']);
	
	        var ret = Object.assign({}, { meta: meta }, (0, _normalizr.normalize)(data.order_correspondences, (0, _normalizr.arrayOf)(_schema.OrderCorrespondenceSchema)));
	        return ret;
	      });
	    }
	  }]);
	
	  return OrderCorrespondenceService;
	}(_bindoService2.default);
	
	exports.default = new OrderCorrespondenceService();

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductionOrderService = function (_BindoService) {
	  _inherits(ProductionOrderService, _BindoService);
	
	  function ProductionOrderService() {
	    _classCallCheck(this, ProductionOrderService);
	
	    return _possibleConstructorReturn(this, (ProductionOrderService.__proto__ || Object.getPrototypeOf(ProductionOrderService)).apply(this, arguments));
	  }
	
	  _createClass(ProductionOrderService, [{
	    key: 'getOrders',
	    value: function getOrders(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';
	      var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	      var path = 'v2/stores/' + storeId + '/production_orders';
	      var filtersQueryList = _filterHelper2.default.filtersToQueryString(filters);
	
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: orderBy,
	        filters: filtersQueryList
	      };
	
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'get', this).call(this, path, query, _config2.default.gateway);
	    }
	  }, {
	    key: 'getOrder',
	    value: function getOrder(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders/' + id;
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'get', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'update',
	    value: function update(data, id, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders/' + id;
	      data.production_order.unit_enable = true;
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'put', this).call(this, path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'create',
	    value: function create(data, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders';
	      data.production_order.unit_enable = true;
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'post', this).call(this, path, data, _config2.default.gateway);
	    }
	
	    // remove(id, storeId){
	    //   let path = `v2/stores/${storeId}/production_orders/${id}`;
	    //   return super.delete(path, undefined, config.gateway);
	    // }
	
	  }, {
	    key: 'approve',
	    value: function approve(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders/' + id + '/approve';
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'put', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'fulfill',
	    value: function fulfill(data, id, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders/' + id + '/fulfill';
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'put', this).call(this, path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/production_orders/' + id + '/cancel';
	      return _get(ProductionOrderService.prototype.__proto__ || Object.getPrototypeOf(ProductionOrderService.prototype), 'put', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }]);
	
	  return ProductionOrderService;
	}(_bindoService2.default);
	
	exports.default = new ProductionOrderService();

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _filterHelper = __webpack_require__(37);
	
	var _filterHelper2 = _interopRequireDefault(_filterHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoCodeService = function (_BindoService) {
	  _inherits(PromoCodeService, _BindoService);
	
	  function PromoCodeService() {
	    _classCallCheck(this, PromoCodeService);
	
	    return _possibleConstructorReturn(this, (PromoCodeService.__proto__ || Object.getPrototypeOf(PromoCodeService)).apply(this, arguments));
	  }
	
	  _createClass(PromoCodeService, [{
	    key: 'saveItem',
	    value: function saveItem(storeId, promoCode) {
	      var discount = promoCode.discount;
	
	      var path = 'v2/stores/' + storeId + '/discounts/' + discount.id + '/coupons';
	      var userQuota = promoCode.userQuota,
	          totalQuota = promoCode.totalQuota,
	          description = promoCode.description,
	          image = promoCode.image,
	          expired_at = promoCode.expired_at;
	
	      var formData = new FormData();
	      formData.append("coupon[description]", description);
	      formData.append("coupon[image]", image);
	      formData.append("coupon[expired_at]", expired_at);
	      formData.append("coupon[individual_user_quota]", userQuota === "" ? null : parseInt(promoCode.userQuota));
	      formData.append("coupon[total_quota]", totalQuota === "" ? null : parseInt(promoCode.totalQuota));
	      var api = void 0;
	
	      if (promoCode.id) {
	        path += '/' + promoCode.id;
	        api = _get(PromoCodeService.prototype.__proto__ || Object.getPrototypeOf(PromoCodeService.prototype), 'putFile', this);
	      } else {
	        formData.append("coupon[is_promo]", 1);
	        formData.append("coupon[code]", promoCode.code);
	        api = _get(PromoCodeService.prototype.__proto__ || Object.getPrototypeOf(PromoCodeService.prototype), 'postFile', this);
	      }
	      return api(path, formData, _config2.default.gateway);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(storeId, promoCodeId) {
	      var path = 'v2/stores/' + storeId + '/coupons/' + promoCodeId;
	      return _get(PromoCodeService.prototype.__proto__ || Object.getPrototypeOf(PromoCodeService.prototype), 'get', this).call(this, path, null, _config2.default.gateway);
	    }
	  }, {
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var filters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	      var path = 'v2/stores/' + storeId + '/promo_codes';
	      filters = _filterHelper2.default.filtersToQueryString(filters);
	      var query = {
	        page: page,
	        per_page: count,
	        filters: filters
	      };
	
	      return _get(PromoCodeService.prototype.__proto__ || Object.getPrototypeOf(PromoCodeService.prototype), 'get', this).call(this, path, query, _config2.default.gateway);
	    }
	  }]);
	
	  return PromoCodeService;
	}(_bindoService2.default);
	
	exports.default = new PromoCodeService();

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QueueingDisplayService = function (_BindoService) {
	  _inherits(QueueingDisplayService, _BindoService);
	
	  function QueueingDisplayService() {
	    _classCallCheck(this, QueueingDisplayService);
	
	    return _possibleConstructorReturn(this, (QueueingDisplayService.__proto__ || Object.getPrototypeOf(QueueingDisplayService)).apply(this, arguments));
	  }
	
	  _createClass(QueueingDisplayService, [{
	    key: 'linkUpDisplay',
	    value: function linkUpDisplay(key, storeId) {
	      var path = 'v2/stores/' + storeId + '/stations';
	      return _get(QueueingDisplayService.prototype.__proto__ || Object.getPrototypeOf(QueueingDisplayService.prototype), 'post', this).call(this, path, { station: { station_key: key } });
	    }
	  }]);
	
	  return QueueingDisplayService;
	}(_bindoService2.default);
	
	exports.default = new QueueingDisplayService();

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuoteService = function (_BindoService) {
	  _inherits(QuoteService, _BindoService);
	
	  function QuoteService() {
	    _classCallCheck(this, QuoteService);
	
	    return _possibleConstructorReturn(this, (QuoteService.__proto__ || Object.getPrototypeOf(QuoteService)).apply(this, arguments));
	  }
	
	  _createClass(QuoteService, [{
	    key: 'getItem',
	    value: function getItem(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/quotes/' + number;
	      return this.get(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'createItem',
	    value: function createItem(storeId, data) {
	      var path = 'v2/stores/' + storeId + '/quotes';
	      return this.post(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(storeId, number, data) {
	      var path = 'v2/stores/' + storeId + '/quotes/' + number;
	      return this.put(path, data, _config2.default.gateway);
	    }
	  }, {
	    key: 'convertToInvoice',
	    value: function convertToInvoice(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/quotes/' + number + '/convert_to_invoice';
	      return this.post(path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'cancelItem',
	    value: function cancelItem(storeId, number) {
	      var path = 'v2/stores/' + storeId + '/quotes/' + number + '/cancel';
	      return this.post(path, undefined, _config2.default.gateway);
	    }
	  }]);
	
	  return QuoteService;
	}(_bindoService2.default);
	
	exports.default = new QuoteService();

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplierService = function (_BindoService) {
	  _inherits(SupplierService, _BindoService);
	
	  function SupplierService() {
	    _classCallCheck(this, SupplierService);
	
	    return _possibleConstructorReturn(this, (SupplierService.__proto__ || Object.getPrototypeOf(SupplierService)).apply(this, arguments));
	  }
	
	  _createClass(SupplierService, [{
	    key: 'getItem',
	    value: function getItem(storeId, listingId) {
	      var path = 'v2/stores/' + storeId + '/suppliers/' + listingId;
	
	      return _get(SupplierService.prototype.__proto__ || Object.getPrototypeOf(SupplierService.prototype), 'get', this).call(this, path, listingId);
	    }
	  }, {
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'updated_at';
	
	      var path = 'v2/stores/' + storeId + '/suppliers';
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: orderBy
	      };
	
	      return _get(SupplierService.prototype.__proto__ || Object.getPrototypeOf(SupplierService.prototype), 'get', this).call(this, path, query);
	    }
	  }]);
	
	  return SupplierService;
	}(_bindoService2.default);
	
	exports.default = new SupplierService();

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableSizeSegmentationService = function (_BindoService) {
	  _inherits(TableSizeSegmentationService, _BindoService);
	
	  function TableSizeSegmentationService() {
	    _classCallCheck(this, TableSizeSegmentationService);
	
	    return _possibleConstructorReturn(this, (TableSizeSegmentationService.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService)).apply(this, arguments));
	  }
	
	  _createClass(TableSizeSegmentationService, [{
	    key: 'get',
	    value: function get(storeId) {
	      var path = 'v2/stores/' + storeId + '/party_size_segments/current';
	      return _get(TableSizeSegmentationService.prototype.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService.prototype), 'get', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }, {
	    key: 'update',
	    value: function update(data, storeId) {
	      var path = 'v2/stores/' + storeId + '/party_size_segments/current';
	      return _get(TableSizeSegmentationService.prototype.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService.prototype), 'put', this).call(this, path, { party_size_segment: data }, _config2.default.gateway);
	    }
	  }, {
	    key: 'create',
	    value: function create(data, storeId) {
	      var path = 'v2/stores/' + storeId + '/party_size_segments';
	      return _get(TableSizeSegmentationService.prototype.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService.prototype), 'post', this).call(this, path, { party_size_segment: data }, _config2.default.gateway);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(storeId) {
	      var path = 'v2/stores/' + storeId + '/party_size_segments';
	      return _get(TableSizeSegmentationService.prototype.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService.prototype), 'delete', this).call(this, path, _config2.default.gateway);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh(storeId) {
	      var path = 'v2/stores/' + storeId + '/party_size_segments/refresh_now';
	      return _get(TableSizeSegmentationService.prototype.__proto__ || Object.getPrototypeOf(TableSizeSegmentationService.prototype), 'get', this).call(this, path, undefined, _config2.default.gateway);
	    }
	  }]);
	
	  return TableSizeSegmentationService;
	}(_bindoService2.default);
	
	exports.default = new TableSizeSegmentationService();

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaxOptionService = function (_BindoService) {
	  _inherits(TaxOptionService, _BindoService);
	
	  function TaxOptionService() {
	    _classCallCheck(this, TaxOptionService);
	
	    return _possibleConstructorReturn(this, (TaxOptionService.__proto__ || Object.getPrototypeOf(TaxOptionService)).apply(this, arguments));
	  }
	
	  _createClass(TaxOptionService, [{
	    key: 'getItem',
	    value: function getItem(storeId, taxOptionId) {
	      var path = 'v2/stores/' + storeId + '/tax_options/' + taxOptionId;
	
	      return _get(TaxOptionService.prototype.__proto__ || Object.getPrototypeOf(TaxOptionService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getList',
	    value: function getList(storeId) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
	      var orderBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'updated_at';
	
	      var path = 'v2/stores/' + storeId + '/tax_options';
	      var query = {
	        page: page,
	        per_page: count,
	        order_by: orderBy
	      };
	
	      return _get(TaxOptionService.prototype.__proto__ || Object.getPrototypeOf(TaxOptionService.prototype), 'get', this).call(this, path, query);
	    }
	  }]);
	
	  return TaxOptionService;
	}(_bindoService2.default);
	
	exports.default = new TaxOptionService();

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnitGroupsService = function (_BindoService) {
	  _inherits(UnitGroupsService, _BindoService);
	
	  function UnitGroupsService() {
	    _classCallCheck(this, UnitGroupsService);
	
	    return _possibleConstructorReturn(this, (UnitGroupsService.__proto__ || Object.getPrototypeOf(UnitGroupsService)).apply(this, arguments));
	  }
	
	  _createClass(UnitGroupsService, [{
	    key: 'getItem',
	    value: function getItem(storeId, groupId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups/' + groupId;
	      return this.get(path, null, _config2.default.bindo);
	    }
	  }]);
	
	  return UnitGroupsService;
	}(_bindoService2.default);
	
	exports.default = new UnitGroupsService();

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _bindoService = __webpack_require__(19);
	
	var _bindoService2 = _interopRequireDefault(_bindoService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UomGroupService = function (_BindoService) {
	  _inherits(UomGroupService, _BindoService);
	
	  function UomGroupService() {
	    _classCallCheck(this, UomGroupService);
	
	    return _possibleConstructorReturn(this, (UomGroupService.__proto__ || Object.getPrototypeOf(UomGroupService)).apply(this, arguments));
	  }
	
	  _createClass(UomGroupService, [{
	    key: 'create',
	    value: function create(unit_group, storeId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups';
	
	      return _get(UomGroupService.prototype.__proto__ || Object.getPrototypeOf(UomGroupService.prototype), 'post', this).call(this, path, { unit_group: unit_group });
	    }
	  }, {
	    key: 'getGroups',
	    value: function getGroups(storeId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups';
	
	      return _get(UomGroupService.prototype.__proto__ || Object.getPrototypeOf(UomGroupService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'getGroup',
	    value: function getGroup(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups/' + id;
	
	      return _get(UomGroupService.prototype.__proto__ || Object.getPrototypeOf(UomGroupService.prototype), 'get', this).call(this, path);
	    }
	  }, {
	    key: 'update',
	    value: function update(unit_group, id, storeId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups/' + id;
	
	      return _get(UomGroupService.prototype.__proto__ || Object.getPrototypeOf(UomGroupService.prototype), 'put', this).call(this, path, { unit_group: unit_group });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(id, storeId) {
	      var path = 'v2/stores/' + storeId + '/unit_groups/' + id;
	
	      return _get(UomGroupService.prototype.__proto__ || Object.getPrototypeOf(UomGroupService.prototype), 'delete', this).call(this, path);
	    }
	  }]);
	
	  return UomGroupService;
	}(_bindoService2.default);
	
	exports.default = new UomGroupService();

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(5);
	
	var _reduxThunk = __webpack_require__(429);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPersist = __webpack_require__(708);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _handlePromiseMiddleware2 = _interopRequireDefault(_handlePromiseMiddleware);
	
	var _alertMiddleware = __webpack_require__(326);
	
	var _alertMiddleware2 = _interopRequireDefault(_alertMiddleware);
	
	var _reducers = __webpack_require__(327);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var store = void 0,
	      enhancer = void 0;
	
	  if (window.devToolsExtension) {
	    //Enable Redux devtools if the extension is installed in developer's browser
	    enhancer = (0, _redux.compose)((0, _reduxPersist.autoRehydrate)(), (0, _redux.applyMiddleware)(_handlePromiseMiddleware2.default, _alertMiddleware2.default, _reduxThunk2.default), window.devToolsExtension());
	  } else {
	    enhancer = (0, _redux.compose)((0, _reduxPersist.autoRehydrate)(), (0, _redux.applyMiddleware)(_handlePromiseMiddleware2.default, _alertMiddleware2.default, _reduxThunk2.default));
	  }
	  store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
	  (0, _reduxPersist.persistStore)(store, {
	    whitelist: ['savedFilters', 'stores']
	  });
	
	  if (false) {
	    // Enable Webpack hot module replacement for reducers
	    module.hot.accept('./reducers', function () {
	      var nextReducer = require('./reducers/index').default;
	      store.replaceReducer(nextReducer);
	    });
	  }
	
	  return store;
	}

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	switch (("production")) {
	  case 'production':
	  case 'staging':
	    module.exports = __webpack_require__(973);
	    break;
	
	  case 'test':
	    module.exports = __webpack_require__(974);
	    break;
	
	  default:
	    module.exports = __webpack_require__(971);
	    break;
	}

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(5);
	
	var _reduxThunk = __webpack_require__(429);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPersist = __webpack_require__(708);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _handlePromiseMiddleware2 = _interopRequireDefault(_handlePromiseMiddleware);
	
	var _alertMiddleware = __webpack_require__(326);
	
	var _alertMiddleware2 = _interopRequireDefault(_alertMiddleware);
	
	var _reducers = __webpack_require__(327);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var enhancer = (0, _redux.compose)((0, _reduxPersist.autoRehydrate)(), (0, _redux.applyMiddleware)(_handlePromiseMiddleware2.default, _alertMiddleware2.default, _reduxThunk2.default));
	
	  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
	
	  (0, _reduxPersist.persistStore)(store, {
	    whitelist: ['savedFilters', 'stores']
	  });
	
	  return store;
	}

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(5);
	
	var _reduxThunk = __webpack_require__(429);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _handlePromiseMiddleware = __webpack_require__(94);
	
	var _handlePromiseMiddleware2 = _interopRequireDefault(_handlePromiseMiddleware);
	
	var _alertMiddleware = __webpack_require__(326);
	
	var _alertMiddleware2 = _interopRequireDefault(_alertMiddleware);
	
	var _reducers = __webpack_require__(327);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(_handlePromiseMiddleware2.default, _alertMiddleware2.default, _reduxThunk2.default));
	
	  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
	
	  return store;
	}

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadingHandler = undefined;
	
	var _loadingHandler2 = __webpack_require__(976);
	
	var _loadingHandler3 = _interopRequireDefault(_loadingHandler2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.loadingHandler = _loadingHandler3.default;

/***/ },
/* 976 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var loadingHandler = function () {
	  function loadingHandler(dispatch, settings) {
	    _classCallCheck(this, loadingHandler);
	
	    this.dispatch = dispatch;
	    this.settings = Object.assign({
	      showLoading: true
	    }, settings);
	  }
	
	  _createClass(loadingHandler, [{
	    key: 'onBeforePromise',
	    value: function onBeforePromise() {
	      if (this.settings.showLoading) {
	        this.dispatch({ type: 'START_FETCH' });
	      }
	    }
	  }, {
	    key: 'onAfterPromise',
	    value: function onAfterPromise() {
	      if (this.settings.showLoading) {
	        this.dispatch({ type: 'STOP_FETCH' });
	      }
	    }
	  }, {
	    key: 'onCatchPromise',
	    value: function onCatchPromise() {
	      if (this.settings.showLoading) {
	        this.dispatch({ type: 'STOP_FETCH' });
	      }
	    }
	  }]);
	
	  return loadingHandler;
	}();
	
	exports.default = loadingHandler;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _concat = __webpack_require__(281);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _reject = __webpack_require__(1575);
	
	var _reject2 = _interopRequireDefault(_reject);
	
	var _alertActions = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	function alertReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _alertActions.ADD_ALERT:
	      {
	        return (0, _concat2.default)(state, {
	          style: action.style,
	          message: action.message
	        });
	      }
	
	    case _alertActions.REMOVE_ALERT:
	      {
	        var newState = (0, _reject2.default)(state, { message: action.message });
	        return newState;
	      }
	
	    case _alertActions.TRUNCATE_ALERT:
	      {
	        return [];
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	exports.default = alertReducer;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseActions = __webpack_require__(34);
	
	var initialState = {
	  loading: false
	};
	
	function baseReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _baseActions.START_FETCH:
	      return Object.assign({}, state, { loading: true });
	
	    case _baseActions.STOP_FETCH:
	      return Object.assign({}, state, { loading: false });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = baseReducer;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(5);
	
	var _selectDiscountReducer = __webpack_require__(980);
	
	var _selectDiscountReducer2 = _interopRequireDefault(_selectDiscountReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentsReducer = (0, _redux.combineReducers)({
	  selectDiscount: _selectDiscountReducer2.default
	});
	
	exports.default = componentsReducer;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _selectDiscountActions = __webpack_require__(180);
	
	var act = _interopRequireWildcard(_selectDiscountActions);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  name: '',
	  loading: false,
	  isOpen: false,
	  discounts: []
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, act.OPEN_SELECT_DISCOUNT_MODAL, function (state, _ref) {
	  var _ref$payload = _ref.payload,
	      payload = _ref$payload === undefined ? {} : _ref$payload;
	  var name = payload.name,
	      _payload$modalInitSta = payload.modalInitState,
	      modalInitState = _payload$modalInitSta === undefined ? { filter: '', selected: null } : _payload$modalInitSta;
	
	  return _extends({}, initialState, modalInitState, {
	    name: name,
	    isOpen: true
	  });
	}), _defineProperty(_actionHandlers, act.CLOSE_SELECT_DISCOUNT_MODAL, function (state, _ref2) {
	  var _ref2$payload = _ref2.payload,
	      payload = _ref2$payload === undefined ? {} : _ref2$payload;
	
	  return _extends({}, state, {
	    isOpen: false
	  });
	}), _defineProperty(_actionHandlers, act.LOAD_DISCOUNT_OPTIONS, function (state, _ref3) {
	  var _ref3$payload = _ref3.payload,
	      payload = _ref3$payload === undefined ? {} : _ref3$payload;
	
	  return _extends({}, state, {
	    loading: true
	  });
	}), _defineProperty(_actionHandlers, act.LOAD_DISCOUNT_OPTIONS_SUCCESS, function (state, _ref4) {
	  var discounts = _ref4.discounts;
	
	  return _extends({}, state, {
	    loading: false,
	    discounts: discounts
	  });
	}), _defineProperty(_actionHandlers, act.FILTER_CHANGE, function (state, _ref5) {
	  var value = _ref5.value;
	  return _extends({}, state, { filter: value });
	}), _defineProperty(_actionHandlers, act.SELECT_DISCOUNT, function (state, _ref6) {
	  var id = _ref6.id;
	  return _extends({}, state, { selected: id });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = storeReducer;
	
	var _lodash = __webpack_require__(14);
	
	var _deliveryOrderActions = __webpack_require__(458);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var initialState = {
	    page: null,
	    type: 'invoice',
	    refId: null,
	    currentTab: 'overview',
	    initialValues: {},
	    logs: []
	};
	
	function storeReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _deliveryOrderActions.ADD_INVOICE_TO_DELIVERY_ORDER:
	            {
	                var _action$data = action.data,
	                    result = _action$data.result,
	                    _action$data$entities = _action$data.entities.invoices,
	                    invoices = _action$data$entities === undefined ? {} : _action$data$entities;
	
	                var invoice = invoices[result];
	                if (result && invoice) {
	                    var billingCustomerId = invoice.billing_address_info && invoice.billing_address_info.id;
	                    var billingCustomerName = invoice.billing_address_info && invoice.billing_address_info.name;
	                    var billingAddress = invoice.billing_address_info && invoice.billing_address_info.billing_address;
	                    var billingPhone = invoice.billing_address_info && invoice.billing_address_info.phone;
	                    var shippingCustomerId = invoice.shipping_address_info && invoice.shipping_address_info.id || billingCustomerId;
	                    var shippingCustomerName = invoice.shipping_address_info && invoice.shipping_address_info.name || billingCustomerName;
	                    var shippingAddress = invoice.shipping_address || invoice.shipping_address_info && invoice.shipping_address_info.billing_address || billingAddress;
	                    var shippingPhone = invoice.shipping_address_info && invoice.shipping_address_info.phone || billingPhone;
	                    var initialValues = (0, _lodash.defaultsDeep)({}, state.initialValues, {
	                        delivery_order: {
	                            order_ids: [],
	                            billing: {
	                                customer_id: billingCustomerId,
	                                customer_name: billingCustomerName,
	                                address: billingAddress,
	                                phone: billingPhone
	                            },
	                            delivery_note: {
	                                customer_id: shippingCustomerId,
	                                customer_name: shippingCustomerName,
	                                address: shippingAddress,
	                                phone: shippingPhone
	                            }
	                        },
	                        delivery_order_items: []
	                    });
	
	                    if (initialValues.delivery_order.order_ids.indexOf(result) === -1) {
	                        initialValues.delivery_order.order_ids = [].concat(initialValues.delivery_order.order_ids, result);
	                        initialValues.delivery_order_items = initialValues.delivery_order_items.concat(invoice.listing_line_items.map(function (listing) {
	                            var total_quantity = parseFloat(listing.unit_quantity || 0);
	                            var qty_fulfilled = parseFloat(listing.qty_fulfilled || 0);
	                            var qty_remaining = total_quantity - qty_fulfilled;
	                            return {
	                                invoice_id: result,
	                                invoice_number: invoice.number, // UI only field
	                                line_item_id: listing.id,
	                                line_item: listing,
	                                description: listing.label,
	                                total_quantity: total_quantity, // ordered quantity in order
	                                quantity: qty_remaining, // default set to the remaining qty
	                                qty_sent: 0, // sent quantity in DN
	                                qty_fulfilled: qty_fulfilled, // fulfilled quantity in order
	                                qty_remaining: 0, // default set to 0, treat the DN will delivery all the remaining
	                                serial_number_enabled: listing.serial_number_enabled,
	                                serial_numbers: [],
	                                display_unit_id: listing.unit_id
	                            };
	                        }));
	                    } else {
	                        initialValues.delivery_order_items = initialValues.delivery_order_items.map(function (data) {
	                            return _extends({}, data, {
	                                display_unit_id: invoice.listing_line_items.find(function (d) {
	                                    return d.id === data.line_item_id;
	                                }).unit_id
	                            });
	                        });
	                    }
	
	                    var newState = Object.assign({}, state, { initialValues: initialValues });
	                    return newState;
	                } else {
	                    return state;
	                }
	            }
	
	        case _deliveryOrderActions.CLEANUP_DELIVERY_ORDER_FORM:
	            {
	                var _newState = Object.assign({}, state, {
	                    initialValues: {
	                        delivery_order: {
	                            billing: {},
	                            delivery_note: {},
	                            order_ids_included: true
	                        },
	                        delivery_order_items: []
	                    }
	                });
	                return _newState;
	            }
	
	        case _deliveryOrderActions.SET_DELIVERY_ORDER_STATE:
	            {
	                var _action$data2 = action.data,
	                    data = _action$data2 === undefined ? {} : _action$data2;
	
	                var _newState2 = Object.assign({}, state, data);
	                return _newState2;
	            }
	
	        case _deliveryOrderActions.REFRESH_DELIVERY_ORDER_ITEMS:
	            {
	                var _action$data3 = action.data,
	                    _data = _action$data3 === undefined ? {} : _action$data3;
	
	                if (_data.result && _data.result.length > 0) {
	                    var _initialValues = (0, _lodash.defaultsDeep)({
	                        delivery_order_items: []
	                    }, state.initialValues);
	                    var _data$entities$listin = _data.entities.listings,
	                        listings = _data$entities$listin === undefined ? {} : _data$entities$listin;
	
	
	                    _initialValues.delivery_order_items = _initialValues.delivery_order_items.map(function (item) {
	                        var _item$line_item = item.line_item,
	                            line_item = _item$line_item === undefined ? {} : _item$line_item;
	                        var purchasable_id = line_item.purchasable_id;
	
	                        var newItem = item;
	                        if (listings[purchasable_id]) {
	                            var listing = listings[purchasable_id];
	                            newItem = Object.assign({}, item, {
	                                description: listing.name,
	                                upc: listing.upc || listing.upc_e,
	                                ean13: listing.ean13,
	                                listing_barcode: listing.listing_barcode,
	                                serial_number_enabled: listing.serial_number_enabled,
	                                expiration_date_enabled: listing.expiration_date_enabled
	                            });
	                        }
	                        return newItem;
	                    });
	
	                    var _newState3 = Object.assign({}, state, { initialValues: _initialValues });
	                    return _newState3;
	                } else {
	                    return state;
	                }
	            }
	
	        case _deliveryOrderActions.REMOVE_INVOICE_FROM_DELIVERY_ORDER:
	            {
	                var _action$data4 = action.data,
	                    _data2 = _action$data4 === undefined ? [] : _action$data4;
	
	                if (_data2.length > 0) {
	                    var _initialValues2 = (0, _lodash.defaultsDeep)({
	                        delivery_order: { order_ids: [] },
	                        delivery_order_items: []
	                    }, state.initialValues);
	
	                    _initialValues2.delivery_order.order_ids = _initialValues2.delivery_order.order_ids.filter(function (id) {
	                        return _data2.indexOf(id) < 0;
	                    });
	                    _initialValues2.delivery_order_items = _initialValues2.delivery_order_items.filter(function (item) {
	                        return _data2.indexOf(item.invoice_id) < 0;
	                    });
	                    var _newState4 = Object.assign({}, state, { initialValues: _initialValues2 });
	                    return _newState4;
	                } else {
	                    return state;
	                }
	            }
	
	        case _deliveryOrderActions.REFRESH_DELIVERY_ORDER_OVERVIEW:
	            {
	                if (action.data) {
	                    var _action$data5 = action.data,
	                        _action$data5$deliver = _action$data5.delivery_order_items,
	                        delivery_order_items = _action$data5$deliver === undefined ? [] : _action$data5$deliver,
	                        delivery_order = _objectWithoutProperties(_action$data5, ['delivery_order_items']);
	
	                    delivery_order.order_ids_included = (delivery_order.order_ids || []).length > 0;
	                    delivery_order.stock_transfer_ids_included = (delivery_order.stock_transfer_ids || []).length > 0;
	                    delivery_order.delivery_note = {
	                        customer_id: delivery_order.customer_id,
	                        customer_name: delivery_order.customer_name,
	                        address: delivery_order.address,
	                        phone: delivery_order.phone
	                    };
	                    delivery_order_items = delivery_order_items.map(function (item) {
	                        var delivery_order_item = item.delivery_order_item;
	                        var invoice_id = delivery_order_item.line_item.order_id;
	                        var _delivery_order$order = delivery_order.orders,
	                            orders = _delivery_order$order === undefined ? [] : _delivery_order$order;
	
	                        var invoice_number = (orders.filter(function (order) {
	                            return order.id === invoice_id;
	                        })[0] || {}).number;
	                        var total_quantity = delivery_order_item.line_item.qty_requested_in_display_unit,
	                            quantity = delivery_order_item.quantity,
	                            qty_sent = delivery_order_item.qty_sent,
	                            qty_remaining = delivery_order_item.qty_remaining;
	
	                        total_quantity = parseFloat(total_quantity);
	                        quantity = parseFloat(quantity);
	                        qty_sent = parseFloat(qty_sent);
	                        qty_remaining = parseFloat(qty_remaining);
	                        var qty_fulfilled = total_quantity - qty_remaining - quantity;
	                        return Object.assign({}, delivery_order_item, {
	                            invoice_id: invoice_id,
	                            invoice_number: invoice_number,
	                            total_quantity: total_quantity,
	                            quantity: quantity,
	                            qty_sent: qty_sent,
	                            qty_fulfilled: qty_fulfilled,
	                            qty_remaining: qty_remaining
	                        });
	                    });
	
	                    var _initialValues3 = { delivery_order: delivery_order, delivery_order_items: delivery_order_items };
	                    var _newState5 = Object.assign({}, state, { initialValues: _initialValues3 });
	                    return _newState5;
	                } else {
	                    return state;
	                }
	            }
	
	        case _deliveryOrderActions.REFRESH_DELIVERY_ORDER_HISTORIES:
	            {
	                if (action.data) {
	                    var _action$data6 = action.data,
	                        _result = _action$data6.result,
	                        _action$data6$entitie = _action$data6.entities.deliveryOrderHistories,
	                        deliveryOrderHistories = _action$data6$entitie === undefined ? {} : _action$data6$entitie;
	
	                    var logs = _result.map(function (id) {
	                        return deliveryOrderHistories[id];
	                    });
	                    var _newState6 = Object.assign({}, state, { logs: logs });
	                    return _newState6;
	                } else {
	                    return state;
	                }
	            }
	
	        case _deliveryOrderActions.REFRESH_DELIVERY_ORDER_CUSTOMER:
	            {
	                if (action.data) {
	                    var customer = action.data;
	                    var _initialValues4 = Object.assign({}, state.initialValues);
	                    _initialValues4.delivery_order_items = _initialValues4.delivery_order_items || [];
	                    var _delivery_order = _initialValues4.delivery_order = Object.assign({}, _initialValues4.delivery_order);
	                    var delivery_note = _delivery_order.delivery_note = Object.assign({}, _delivery_order.delivery_note);
	                    delivery_note.email = customer.email;
	                    var _newState7 = Object.assign({}, state, { initialValues: _initialValues4 });
	                    return _newState7;
	                } else {
	                    return state;
	                }
	            }
	
	        default:
	            {
	                return state;
	            }
	    }
	}

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = entityReducer;
	
	var _filter = __webpack_require__(634);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _merge = __webpack_require__(287);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _mergeWith = __webpack_require__(1571);
	
	var _mergeWith2 = _interopRequireDefault(_mergeWith);
	
	var _isArray = __webpack_require__(32);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _entityActions = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  listings: null,
	  suppliers: null,
	  departments: null,
	  vouchers: null,
	  stations: null,
	  lineItemStatuses: null,
	  workflows: null,
	  uomGroups: null,
	  productionOrders: null,
	  private_listings: null
	};
	
	function mergeCustomizer(objValue, srcValue) {
	  if ((0, _isArray2.default)(srcValue)) {
	    return srcValue;
	  }
	}
	
	function entityReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _entityActions.ADD_PRIVATE_ENTITIES_LISTINGS:
	      {
	        //merge two objects
	        state.private_listings = state.private_listings || {};
	        (0, _forEach2.default)(action.data.listings, function (listing, key) {
	          // we may modified private listings locally and not committed yet
	          // so need to retain it till committing.
	          if (state.private_listings.hasOwnProperty(key)) {
	            action.data.listings[key] = Object.assign({}, action.data.listings[key], state.private_listings[key]);
	          }
	        });
	        state.private_listings = Object.assign({}, state.private_listings, action.data.listings);
	        return Object.assign({}, state, { private_listings: state.private_listings });
	      }
	    case _entityActions.CLEAR_PRIVATE_ENTITIES_LISTINGS:
	      {
	        return Object.assign({}, state, { private_listings: null });
	      }
	    case _entityActions.SET_PRIVATE_ENTITIES_LISTINGS:
	      {
	        state.private_listings = state.private_listings || {};
	        return Object.assign({}, state, { private_listings: action.data.listings });
	      }
	    case _entityActions.ADD_PRIVATE_ENTITY:
	      {
	        state.private_listings = state.private_listings || {};
	
	        state.private_listings = Object.assign({}, state.private_listings, _defineProperty({}, action.id, action.data));
	        return Object.assign({}, state);
	      }
	    case _entityActions.UPDATE_PRIVATE_ENTITY:
	      {
	        state.private_listings[action.id] = Object.assign({}, state.private_listings[action.id], action.data);
	        return Object.assign({}, state, { private_listings: state.private_listings });
	      }
	    case _entityActions.SET_ENTITIES_LISTINGS:
	      {
	        state.listings = state.listings || {};
	
	        (0, _forEach2.default)(action.data.listings, function (listing, key) {
	          action.data.listings[key] = Object.assign({}, state.listings[key], action.data.listings[key]);
	        });
	
	        var newListings = Object.assign({}, state.listings, action.data.listings);
	
	        return Object.assign({}, state, { listings: newListings });
	      }
	
	    case _entityActions.REMOVE_ENTITY_LISTING_GRAPHIC:
	      {
	        var targetListing = state.listings[action.listingId];
	        if (targetListing) {
	          var removedProductGraphics = (0, _filter2.default)(targetListing.product_graphics, function (g) {
	            return g.id !== action.graphicId;
	          });
	
	          targetListing.product_graphics = removedProductGraphics;
	
	          var newListing = Object.assign({}, targetListing, { product_graphics: removedProductGraphics });
	          var _newListings = Object.assign({}, state.listings, _defineProperty({}, action.listingId, newListing));
	
	          return Object.assign({}, state, { listings: _newListings });
	        } else {
	          return state;
	        }
	      }
	
	    case _entityActions.ADD_ENTITY_LISTING_GRAPHIC:
	      {
	        var _targetListing = state.listings[action.listingId];
	        if (_targetListing) {
	          _targetListing.product_graphics.push(action.graphicData);
	
	          var _newListing = Object.assign({}, _targetListing);
	          var _newListings2 = Object.assign({}, state.listings, _defineProperty({}, action.listingId, _newListing));
	
	          return Object.assign({}, state, { listings: _newListings2 });
	        } else {
	          return state;
	        }
	      }
	
	    case _entityActions.SET_ENTITIES_SUPPLIERS:
	      state.suppliers = Object.assign({}, state.suppliers, action.data.suppliers);
	      return Object.assign({}, state);
	
	    case _entityActions.SET_ENTITIES:
	      state[action.collection] = (0, _merge2.default)({}, state[action.collection], action.data);
	      return Object.assign({}, state);
	
	    case 'SET_HANDLE_PROMISE_ENTITIES':
	      return (0, _mergeWith2.default)({}, state, action.data, mergeCustomizer);
	
	    case _entityActions.UPDATE_ENTITY:
	      state[action.collection][action.id] = Object.assign({}, state[action.collection][action.id], action.data);
	      state[action.collection] = Object.assign({}, state[action.collection]);
	
	      return Object.assign({}, state);
	
	    case _entityActions.ADD_ENTITY_LISTING_CUSTOM_ITEM:
	      {
	        if (typeof state.listings === 'undefined') {
	          state.listings = {};
	        }
	        var listingId = action.data[0].listing.id;
	        state.listings[listingId] = Object.assign({}, action.data[0].listing);
	        return Object.assign({}, state);
	      }
	
	    case _entityActions.REMOVE_ENTITY:
	      delete state[action.collection][action.id];
	      return Object.assign({}, state, action.data);
	
	    case _entityActions.ADD_ENTITY:
	      state[action.collection] = Object.assign({}, state[action.collection], _defineProperty({}, action.id, action.data));
	      return Object.assign({}, state);
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _addLineItemStatus = __webpack_require__(459);
	
	var actions = _interopRequireWildcard(_addLineItemStatus);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  storeId: null,
	  isOpen: false,
	  initialValues: null,
	  isCreating: true,
	  input: {
	    value: '',
	    failure: false,
	    success: false
	  }
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.OPEN_ADD_LINE_ITEM_STATUS, function (state, action) {
	  var storeId = action.storeId,
	      isCreating = action.isCreating,
	      initialValues = action.initialValues;
	  var input = initialState.input;
	
	  if (initialValues && initialValues.status) {
	    input.value = initialValues.status;
	  }
	  return Object.assign({}, state, { isOpen: true, input: input, storeId: storeId, isCreating: isCreating, initialValues: initialValues });
	}), _defineProperty(_actionHandlers, actions.CLOSE_ADD_LINE_ITEM_STATUS, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.CHANGE_LINE_ITEM_STATUS_INPUT, function (state, action) {
	  var input = state.input;
	
	  input.value = action.value;
	  input.failure = false;
	  input.success = false;
	  return Object.assign({}, state, { input: input });
	}), _defineProperty(_actionHandlers, actions.SAVE_LINE_ITEM_STATUS_REQUEST, function (state) {
	  var input = state.input;
	
	  input = Object.assign({}, input, { failure: false, success: false });
	  return Object.assign({}, state, { input: input });
	}), _defineProperty(_actionHandlers, actions.SAVE_LINE_ITEM_STATUS_SUCCESS, function (state) {
	  var input = state.input;
	
	  input = Object.assign({}, input, { failure: false, success: true });
	  return Object.assign({}, state, { input: input });
	}), _defineProperty(_actionHandlers, actions.SAVE_LINE_ITEM_STATUS_FAILURE, function (state) {
	  var input = state.input;
	
	  input = Object.assign({}, input, { failure: true, success: false });
	  return Object.assign({}, state, { input: input });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _addListingByBarcode = __webpack_require__(460);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  value: '',
	  isSearching: false
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, _addListingByBarcode.actionTypes['ADD_LISTING_BY_BARCODE_CHANGE_INPUT'], function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { value: value });
	}), _defineProperty(_actionHandlers, _addListingByBarcode.actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_REQUEST'], function (state) {
	  return Object.assign({}, state, { isSearching: true });
	}), _defineProperty(_actionHandlers, _addListingByBarcode.actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_SUCCESS'], function (state) {
	  return Object.assign({}, state, { isSearching: false, value: '' });
	}), _defineProperty(_actionHandlers, _addListingByBarcode.actionTypes['ADD_LISTING_BY_BARCODE_SUBMIT_FAILURE'], function (state) {
	  return Object.assign({}, state, { isSearching: false });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _arrayToTree = __webpack_require__(457);
	
	var _arrayToTree2 = _interopRequireDefault(_arrayToTree);
	
	var _departmentSelection = __webpack_require__(118);
	
	var actions = _interopRequireWildcard(_departmentSelection);
	
	var _lodash = __webpack_require__(14);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var selectDepartmentDeep = function selectDepartmentDeep(department, checked) {
	  department.checked = checked;
	  (department.children || []).forEach(function (d) {
	    return selectDepartmentDeep(d, checked);
	  });
	};
	
	var findSelectedDeep = function findSelectedDeep() {
	  var departments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var selected = [];
	  (departments || []).forEach(function (d) {
	    if (d.checked) {
	      selected.push(d);
	    }
	    selected = selected.concat(findSelectedDeep(d.children || []));
	  });
	  return selected;
	};
	
	var initialState = {
	  isOpen: false,
	  all: [],
	  selected: [],
	  params: null
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.TOGGLE_ALL_DEPARTMENT_SELECTION, function (state, action) {
	  var selected = void 0;
	  var all = (0, _lodash.cloneDeep)(state.all || []);
	  if (action.empty) {
	    all.forEach(function (d) {
	      return selectDepartmentDeep(d, false);
	    });
	    selected = [];
	  } else {
	    all.forEach(function (d) {
	      return selectDepartmentDeep(d, true);
	    });
	    selected = findSelectedDeep(all);
	  }
	  return Object.assign({}, state, { all: all, selected: selected });
	}), _defineProperty(_actionHandlers, actions.OPEN_DEPARTMENT_SELECTION, function (state, action) {
	  var all = action.all,
	      selected = action.selected,
	      params = action.params;
	
	  var allItems = all.map(function (d) {
	    return {
	      department_id: d.id,
	      label: d.name,
	      department_name: d.name,
	      checkbox: true,
	      parent_id: d.parent_id
	    };
	  });
	  var nested = (0, _arrayToTree2.default)(allItems, { customID: 'department_id' });
	  return Object.assign({}, state, { isOpen: true, all: nested, selected: selected, params: params });
	}), _defineProperty(_actionHandlers, actions.CLOSE_DEPARTMENT_SELECTION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.SAVE_DEPARTMENT_SELECTION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.TOGGLE_DEPARTMENT_COLLAPSED, function (state, action) {
	  var path = action.path,
	      collapsed = action.collapsed;
	
	  var paths = (path || '').split('.');
	  paths = Array.isArray(paths) ? paths : paths ? [] : [paths];
	  if (paths.length > 0) {
	    var all = state.all;
	
	    all = (0, _lodash.cloneDeep)(all);
	    var pathStr = paths.reduce(function (p, c, i) {
	      var prefix = i > 0 ? '.children' : '';
	      return '' + p + prefix + '[' + c + ']';
	    }, '');
	    var target = (0, _lodash.get)(all, pathStr);
	    if (target) {
	      target.collapsed = collapsed;
	      return Object.assign({}, state, { all: all });
	    }
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actions.TOGGLE_DEPARTMENT_SELECTION, function (state, action) {
	  var path = action.path,
	      checked = action.checked;
	
	  var paths = (path || '').split('.');
	  paths = Array.isArray(paths) ? paths : paths ? [] : [paths];
	  if (paths.length > 0) {
	    var all = state.all;
	
	    all = (0, _lodash.cloneDeep)(all);
	    var pathStr = paths.reduce(function (p, c, i) {
	      var prefix = i > 0 ? '.children' : '';
	      return '' + p + prefix + '[' + c + ']';
	    }, '');
	    var target = (0, _lodash.get)(all, pathStr);
	    if (target) {
	      selectDepartmentDeep(target, checked);
	      var selected = findSelectedDeep(all);
	      return Object.assign({}, state, { all: all, selected: selected });
	    }
	  }
	  return state;
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _embeddedBarcode = __webpack_require__(461);
	
	var actions = _interopRequireWildcard(_embeddedBarcode);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  initialValues: null,
	  type: 0,
	  enabled: false,
	  decimalPoints: 0,
	  editMode: false,
	  changed: false,
	  enableSubmit: false
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.SHOW_EMBEDDED_BARCODE_SETTING, function (state, action) {
	  var store = action.store,
	      scale_barcodes = action.scale_barcodes;
	
	  return {
	    initialValues: store,
	    type: store.embedded_barcode_type,
	    enabled: store.embedded_barcode_enabled,
	    decimalPoints: store.embedded_barcode_decimal_points,
	    editMode: false,
	    changed: false,
	    enableSubmit: false,
	    scale_barcodes: scale_barcodes
	  };
	}), _defineProperty(_actionHandlers, actions.SHOW_SCALE_BARCODE_NUMBER, function (state, action) {
	  var scale_barcodes = action.scale_barcodes;
	
	  return Object.assign({}, state, { scale_barcodes: scale_barcodes });
	}), _defineProperty(_actionHandlers, actions.EDIT_SCALE_BARCODE, function (state, action) {
	  var value = action.value,
	      order = action.order;
	  var scale_barcodes = state.scale_barcodes;
	
	  scale_barcodes[order].prefix = value;
	  return Object.assign({}, state, { scale_barcodes: [].concat(_toConsumableArray(scale_barcodes)) });
	}), _defineProperty(_actionHandlers, actions.EDIT_SCALE_BARCODE_DECIMAL, function (state, action) {
	  var value = action.value,
	      order = action.order;
	  var scale_barcodes = state.scale_barcodes;
	
	  scale_barcodes[order].decimal = value;
	  return Object.assign({}, state, { scale_barcodes: [].concat(_toConsumableArray(scale_barcodes)) });
	}), _defineProperty(_actionHandlers, actions.VALID_SCALEPREFIX, function (state, action) {
	  var scale_barcodes = state.scale_barcodes;
	
	  return Object.assign({}, state, { scale_barcodes: [].concat(_toConsumableArray(scale_barcodes)) });
	}), _defineProperty(_actionHandlers, actions.CHANGE_EMBEDDED_BARCODE_ENABLED, function (state, action) {
	  var value = action.value;
	  var type = state.type,
	      decimalPoints = state.decimalPoints,
	      initialValues = state.initialValues,
	      scale_barcodes = state.scale_barcodes;
	  var embedded_barcode_enabled = initialValues.embedded_barcode_enabled,
	      embedded_barcode_decimal_points = initialValues.embedded_barcode_decimal_points,
	      embedded_barcode_type = initialValues.embedded_barcode_type;
	
	  var changed = value !== embedded_barcode_enabled || type !== embedded_barcode_type || decimalPoints !== embedded_barcode_decimal_points;
	  return Object.assign({}, state, { enabled: value, changed: changed });
	}), _defineProperty(_actionHandlers, actions.CHANGE_EMBEDDED_BARCODE_TYPE, function (state, action) {
	  var value = action.value;
	  var enabled = state.enabled,
	      initialValues = state.initialValues,
	      scale_barcodes = state.scale_barcodes;
	  var embedded_barcode_enabled = initialValues.embedded_barcode_enabled,
	      embedded_barcode_decimal_points = initialValues.embedded_barcode_decimal_points,
	      embedded_barcode_type = initialValues.embedded_barcode_type;
	
	  var changed = enabled !== embedded_barcode_enabled || value !== embedded_barcode_type || 0 !== embedded_barcode_decimal_points;
	  return Object.assign({}, state, { type: value, decimalPoints: 0, changed: changed });
	}), _defineProperty(_actionHandlers, actions.CHANGE_EMBEDDED_BARCODE_DECIMAL_POINTS, function (state, action) {
	  var value = action.value,
	      order = action.order;
	  var enabled = state.enabled,
	      type = state.type,
	      initialValues = state.initialValues,
	      scale_barcodes = state.scale_barcodes;
	
	  var obj = Object.assign({}, scale_barcodes[order]);
	  var decimal = obj.decimal;
	
	  scale_barcodes[order].decimal = value;
	  var embedded_barcode_enabled = initialValues.embedded_barcode_enabled,
	      embedded_barcode_decimal_points = initialValues.embedded_barcode_decimal_points,
	      embedded_barcode_type = initialValues.embedded_barcode_type;
	
	  var changed = enabled !== embedded_barcode_enabled || type !== embedded_barcode_type || value !== decimal;
	  return Object.assign({}, state, { decimalPoints: value, changed: changed, scale_barcodes: [].concat(_toConsumableArray(scale_barcodes)) });
	}), _defineProperty(_actionHandlers, actions.EDIT_EMBEDDED_BARCODE_SETTING, function (state, action) {
	  return Object.assign({}, state, { editMode: true, enableSubmit: true });
	}), _defineProperty(_actionHandlers, actions.DISCARD_EMBEDDED_BARCODE_SETTING, function (state, action) {
	  var initialValues = state.initialValues;
	
	  return Object.assign({}, state, {
	    type: initialValues.embedded_barcode_type,
	    enabled: initialValues.embedded_barcode_enabled,
	    decimalPoints: initialValues.embedded_barcode_decimal_points,
	    editMode: false,
	    changed: false,
	    enableSubmit: false
	  });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_EMBEDDED_BARCODE_SETTING_REQUEST, function (state, action) {
	  return Object.assign({}, state, { enableSubmit: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_EMBEDDED_BARCODE_SETTING_SUCCESS, function (state, action) {
	  return Object.assign({}, state, { enableSubmit: true, editMode: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_EMBEDDED_BARCODE_SETTING_FAILURE, function (state, action) {
	  return Object.assign({}, state, { enableSubmit: true, editMode: false });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _papaparse = __webpack_require__(1594);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _fileImporter = __webpack_require__(309);
	
	var actions = _interopRequireWildcard(_fileImporter);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  storeId: '',
	  discountId: '',
	  fileString: null,
	  fileBlob: null,
	  previewData: [],
	  status: '',
	  step: 0,
	  importProgress: 0,
	  validatateProgress: 0,
	  isDoing: false, //all
	  isDone: false,
	  isSubmitting: false, //create new import
	  isSubmitted: false,
	  isValidated: false, //validate import
	  isValidating: false,
	  isPosting: false, // post validated import
	  isPosted: false,
	  isOpen: false,
	  isUploaded: false,
	  errors: [],
	  warnings: []
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.SHOW_FILE_IMPORTER, function (state, action) {
	  var storeId = action.storeId,
	      discountId = action.discountId;
	
	  return Object.assign({}, state, { storeId: storeId, discountId: discountId, isOpen: true });
	}), _defineProperty(_actionHandlers, actions.CLOSE_FILE_IMPORTER, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.UPLOAD_FILE, function (state, action) {
	  var fileString = action.fileString,
	      fileBlob = action.fileBlob,
	      fileType = action.fileType;
	
	  if (fileType.toUpperCase() === 'CSV') {
	    var preview = _papaparse2.default.parse(fileString);
	    return Object.assign({}, state, { previewData: preview.data, isUploaded: true, fileString: fileString, fileBlob: fileBlob, isDone: false });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UPLOAD_FILE_REQUEST, function (state, action) {
	  return Object.assign({}, state, { isDoing: true, isSubmitting: true, status: 'Step 1/3: Uploading CSV', step: 1 });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UPLOAD_FILE_SUCCESS, function (state, action) {
	  return Object.assign({}, state, { isSubmitting: false, isSubmitted: true, status: 'Step 2/3: Validating CSV', step: 2 });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UPLOAD_FILE_FAILURE, function (state, action) {
	  return Object.assign({}, state, { isSubmitting: false, isSubmitted: true });
	}), _defineProperty(_actionHandlers, actions.GET_IMPORT_VALIDATION_PROGRESS_REQUEST, function (state) {
	  return Object.assign({}, state, { isValidating: true });
	}), _defineProperty(_actionHandlers, actions.GET_IMPORT_VALIDATION_PROGRESS_SUCCESS, function (state, action) {
	  var data = action.data;
	
	  var errors = [];
	  var errorNums = Object.keys(data.humanize_validation_errors || {});
	  if (errorNums.length) {
	    errorNums.forEach(function (num) {
	      var array = data.humanize_validation_errors[num];
	      array.forEach(function (value) {
	        errors.push({ row: num, value: value });
	      });
	    });
	  }
	  var warnings = [];
	  var warningNums = Object.keys(data.humanize_validation_warnings || {});
	  if (warningNums.length) {
	    warningNums.forEach(function (num) {
	      var array = data.humanize_validation_warnings[num];
	      array.forEach(function (value) {
	        warnings.push({ row: num, value: value });
	      });
	    });
	  }
	  var stop = false;
	  if (errors.length || warnings.length) {
	    stop = true;
	  }
	  return Object.assign({}, state, { isValidating: true, errors: errors, warnings: warnings, isDoing: !stop, isDone: stop });
	}), _defineProperty(_actionHandlers, actions.UPDATE_IMPORT_PROGRESS, function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { importProgress: value });
	}), _defineProperty(_actionHandlers, actions.UPDATE_VALIDATION_PROGRESS, function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { validatateProgress: value });
	}), _defineProperty(_actionHandlers, actions.POST_VALIDATED_COUPON_IMPORT_REQUEST, function (state) {
	  return Object.assign({}, state, { isPosting: true, status: 'Step 3/3: Finalizing Upload', isValidating: false, isValidated: true, step: 3 });
	}), _defineProperty(_actionHandlers, actions.POST_VALIDATED_COUPON_IMPORT_SUCCESS, function (state, action) {
	  return Object.assign({}, state, { isPosting: false, isPosted: true, isDoing: false, isDone: true, status: 'Step End: Finalized', step: 0 });
	}), _defineProperty(_actionHandlers, actions.POST_VALIDATED_COUPON_IMPORT_FAILURE, function (state) {
	  return Object.assign({}, state, { isPosting: false, isPosted: true, isDoing: false, isDone: true });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(5);
	
	var _addLineItemStatus = __webpack_require__(983);
	
	var _addLineItemStatus2 = _interopRequireDefault(_addLineItemStatus);
	
	var _addListingByBarcode = __webpack_require__(984);
	
	var _addListingByBarcode2 = _interopRequireDefault(_addListingByBarcode);
	
	var _departmentSelectionReducer = __webpack_require__(985);
	
	var _departmentSelectionReducer2 = _interopRequireDefault(_departmentSelectionReducer);
	
	var _kitchenDepartmentSelection = __webpack_require__(989);
	
	var _kitchenDepartmentSelection2 = _interopRequireDefault(_kitchenDepartmentSelection);
	
	var _stationOverviewReducer = __webpack_require__(992);
	
	var _stationOverviewReducer2 = _interopRequireDefault(_stationOverviewReducer);
	
	var _statusSelectionReducer = __webpack_require__(993);
	
	var _statusSelectionReducer2 = _interopRequireDefault(_statusSelectionReducer);
	
	var _workflowOverview = __webpack_require__(996);
	
	var _workflowOverview2 = _interopRequireDefault(_workflowOverview);
	
	var _embeddedBarcodeReducer = __webpack_require__(986);
	
	var _embeddedBarcodeReducer2 = _interopRequireDefault(_embeddedBarcodeReducer);
	
	var _tableSizeSegmentation = __webpack_require__(994);
	
	var _tableSizeSegmentation2 = _interopRequireDefault(_tableSizeSegmentation);
	
	var _uomOverview = __webpack_require__(995);
	
	var _uomOverview2 = _interopRequireDefault(_uomOverview);
	
	var _productionOrderItem = __webpack_require__(991);
	
	var _productionOrderItem2 = _interopRequireDefault(_productionOrderItem);
	
	var _fileImporter = __webpack_require__(987);
	
	var _fileImporter2 = _interopRequireDefault(_fileImporter);
	
	var _paymentRefund = __webpack_require__(990);
	
	var _paymentRefund2 = _interopRequireDefault(_paymentRefund);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formsReducer = (0, _redux.combineReducers)({
	  addLineItemStatus: _addLineItemStatus2.default,
	  addListingByBarcode: _addListingByBarcode2.default,
	  departmentSelection: _departmentSelectionReducer2.default,
	  kitchenDepartmentSelection: _kitchenDepartmentSelection2.default,
	  stationOverview: _stationOverviewReducer2.default,
	  statusSelection: _statusSelectionReducer2.default,
	  workflowOverview: _workflowOverview2.default,
	  embeddedBarcode: _embeddedBarcodeReducer2.default,
	  tableSizeSegmentation: _tableSizeSegmentation2.default,
	  uomOverview: _uomOverview2.default,
	  productionOrderItem: _productionOrderItem2.default,
	  fileImporter: _fileImporter2.default,
	  paymentRefund: _paymentRefund2.default
	});
	
	exports.default = formsReducer;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _kitchenDepartmentSelection = __webpack_require__(150);
	
	var actions = _interopRequireWildcard(_kitchenDepartmentSelection);
	
	var _lodash = __webpack_require__(14);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var selectAllKitchen = function selectAllKitchen(kitchenDepartment, checked) {
	  kitchenDepartment.map(function (d) {
	    return d.checked = !checked;
	  });
	};
	
	var selectKitchen = function selectKitchen(kitchenDepartment, id, checked) {
	  kitchenDepartment.filter(function (d) {
	    return d.id === id;
	  }).map(function (d) {
	    return d.checked = checked;
	  });
	};
	
	var findSelectedDeep = function findSelectedDeep() {
	  var kitchenDepartments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var selected = [];
	  (kitchenDepartments || []).forEach(function (d) {
	    if (d.checked) {
	      selected.push(d);
	    }
	  });
	  return selected;
	};
	
	var initialState = {
	  isOpen: false,
	  all: [],
	  selected: [],
	  params: null,
	  items: []
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.GET_ALL_KITCHEN_DEPARTMENTS, function (state, action) {
	  var payload = action.payload;
	
	  state.all = payload;
	  return Object.assign({}, state);
	}), _defineProperty(_actionHandlers, actions.OPEN_KITCHEN_DEPARTMENT_SELECTION, function (state, action) {
	  var all = action.all,
	      params = action.params;
	
	  var allItems = all.map(function (d) {
	    return {
	      id: d.id,
	      kitchen_department_id: d.id,
	      kitchen_department_name: d.name,
	      checkbox: true,
	      checked: false
	    };
	  });
	  return Object.assign({}, state, { isOpen: true, all: allItems, params: params });
	}), _defineProperty(_actionHandlers, actions.TOGGLE_KITCHEN_DEPARTMENT_SELECTION, function (state, action) {
	  var checked = action.checked,
	      id = action.id;
	  var all = state.all;
	
	  all = (0, _lodash.cloneDeep)(all);
	  selectKitchen(all, id, checked);
	  var selected = findSelectedDeep(all);
	  return Object.assign({}, state, { all: all, selected: selected });
	}), _defineProperty(_actionHandlers, actions.TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION, function (state, action) {
	  var checked = action.checked;
	  var all = state.all;
	
	  all = (0, _lodash.cloneDeep)(all);
	  selectAllKitchen(all, checked);
	  var selected = findSelectedDeep(all);
	  return Object.assign({}, state, { all: all, selected: selected });
	}), _defineProperty(_actionHandlers, actions.CLOSE_KITCHEN_DEPARTMENT_SELECTION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.SAVE_KITCHEN_DEPARTMENT_SELECTION, function () {
	  return initialState;
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _reduxHelper = __webpack_require__(30);
	
	var _paymentRefund = __webpack_require__(181);
	
	var actions = _interopRequireWildcard(_paymentRefund);
	
	var _paymentRefundModal = __webpack_require__(236);
	
	var _paymentRefundModal2 = _interopRequireDefault(_paymentRefundModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPE = _paymentRefundModal2.default.TYPE,
	    DEFAULT_PAYMENT_TYPE = _paymentRefundModal2.default.DEFAULT_PAYMENT_TYPE;
	
	
	var initialState = {
	  loading: false,
	  isOpen: false,
	  type: TYPE.PAYMENT,
	  storeId: '',
	  orderNumber: null,
	  amountDue: (0, _big2.default)(0),
	  amountSettled: (0, _big2.default)(0),
	  amountBalance: (0, _big2.default)(0),
	  refundTo: null,
	  saleTransactions: [],
	  refundTransactions: [],
	  amount: (0, _big2.default)(0),
	  max: null,
	  tenderAmount: (0, _big2.default)(0),
	  changeAmount: (0, _big2.default)(0),
	  tipsAmount: (0, _big2.default)(0),
	  note: '',
	  showTips: false,
	  showChange: true,
	  errors: [],
	  successResponse: null,
	  instrumentId: DEFAULT_PAYMENT_TYPE.CASH,
	  instrumentName: '',
	  paymentInstruments: [],
	  cardNumber: '',
	  expMonth: '',
	  expYear: '',
	  cvv: ''
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_INIT, function (state, _ref) {
	  var payload = _ref.payload;
	
	  return Object.assign({}, initialState);
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_OPEN, function (state, _ref2) {
	  var payload = _ref2.payload;
	
	  if (!payload || !payload.type || !payload.storeId || !payload.orderNumber) return state;
	  var max = payload.type === TYPE.PAYMENT ? payload.amountBalance : null;
	  return Object.assign({}, state, _extends({ isOpen: true, max: max }, payload));
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CLOSE, function (state, _ref3) {
	  var payload = _ref3.payload;
	
	  return Object.assign({}, state, { isOpen: false });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CHANGE_REFUND_TO, function (state, _ref4) {
	  var _ref4$payload = _ref4.payload,
	      payload = _ref4$payload === undefined ? {} : _ref4$payload;
	  var refundTo = payload.refundTo;
	  var oldRefundTo = state.state,
	      _state$saleTransactio = state.saleTransactions,
	      saleTransactions = _state$saleTransactio === undefined ? [] : _state$saleTransactio;
	
	  var refundableTransactions = saleTransactions.filter(function (t) {
	    return t.amountLefted.gt(0);
	  });
	  var refundToTransaction = refundableTransactions.filter(function (t) {
	    return t.id === refundTo;
	  })[0] || refundableTransactions[0];
	  if (refundToTransaction) {
	    var newRefundTo = refundTo || refundToTransaction.id;
	    if (newRefundTo !== oldRefundTo) {
	      return Object.assign({}, state, {
	        refundTo: newRefundTo,
	        amount: refundToTransaction.amountLefted,
	        max: refundToTransaction.amountLefted
	      });
	    }
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CHANGE_PAYMENT_TYPE, function (state, _ref5) {
	  var _ref5$payload = _ref5.payload,
	      payload = _ref5$payload === undefined ? {} : _ref5$payload;
	  var instrumentId = payload.instrumentId;
	  var _state$paymentInstrum = state.paymentInstruments,
	      paymentInstruments = _state$paymentInstrum === undefined ? [] : _state$paymentInstrum;
	
	  var otherPayment = paymentInstruments.find(function (p) {
	    return p.id === instrumentId;
	  }) || {};
	  var showTips = otherPayment.tippingEnabled || instrumentId === DEFAULT_PAYMENT_TYPE.CREDIT_CARD;
	  var showChange = instrumentId === DEFAULT_PAYMENT_TYPE.CASH;
	  return Object.assign({}, state, { instrumentId: instrumentId, showTips: showTips, showChange: showChange });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CHANGE_AMOUNT, function (state, _ref6) {
	  var _ref6$payload = _ref6.payload,
	      payload = _ref6$payload === undefined ? {} : _ref6$payload;
	
	  var zero = (0, _big2.default)(0);
	  var max = state.max,
	      tenderAmount = state.tenderAmount,
	      changeAmount = state.changeAmount;
	  var amount = payload.amount;
	
	  amount = max && amount.gt(max) ? (0, _big2.default)(max) : amount;
	  amount = amount.lt(zero) ? zero : amount;
	  tenderAmount = amount.gt(tenderAmount) ? (0, _big2.default)(amount) : tenderAmount;
	  changeAmount = tenderAmount.minus(amount);
	  return Object.assign({}, state, { amount: amount, tenderAmount: tenderAmount, changeAmount: changeAmount });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CHANGE_TENDER_AMOUNT, function (state, _ref7) {
	  var _ref7$payload = _ref7.payload,
	      payload = _ref7$payload === undefined ? {} : _ref7$payload;
	  var amount = state.amount;
	  var tenderAmount = payload.tenderAmount;
	
	  tenderAmount = (0, _big2.default)(tenderAmount);
	  if (tenderAmount) {
	    tenderAmount = tenderAmount.lt(amount) ? (0, _big2.default)(amount) : tenderAmount;
	    var changeAmount = tenderAmount.minus(amount);
	    return Object.assign({}, state, { tenderAmount: tenderAmount, changeAmount: changeAmount });
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CHANGE_FIELDS, function (state, _ref8) {
	  var payload = _ref8.payload;
	
	  if (!payload) return state;
	  return Object.assign({}, state, payload);
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_START_LOADING, function (state, _ref9) {
	  var payload = _ref9.payload;
	
	  return Object.assign({}, state, { loading: true });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_STOP_LOADING, function (state, _ref10) {
	  var payload = _ref10.payload;
	
	  return Object.assign({}, state, { loading: false });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_CLEAR_ERRORS, function (state, _ref11) {
	  var payload = _ref11.payload;
	
	  return Object.assign({}, state, { errors: [] });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_ADD_ERRORS, function (state, _ref12) {
	  var payload = _ref12.payload;
	
	  if (!payload) return state;
	  var _state$errors = state.errors,
	      errors = _state$errors === undefined ? [] : _state$errors;
	
	  errors = errors.concat(payload.errors || []);
	  return Object.assign({}, state, { errors: errors });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_SET_ERRORS, function (state, _ref13) {
	  var payload = _ref13.payload;
	
	  if (!payload) return state;
	  var _payload$errors = payload.errors,
	      errors = _payload$errors === undefined ? [] : _payload$errors;
	
	  return Object.assign({}, state, { errors: errors });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_SUCCESS_REFUND, function (state, _ref14) {
	  var payload = _ref14.payload;
	
	  if (!payload) return state;
	  var successResponse = payload.order,
	      amount = payload.amount;
	  var amountSettled = state.amountSettled,
	      amountBalance = state.amountBalance;
	
	  amountSettled = (0, _big2.default)(amountSettled).minus(amount);
	  amountBalance = (0, _big2.default)(amountBalance).plus(amount);
	  return Object.assign({}, state, { successResponse: successResponse, amountSettled: amountSettled, amountBalance: amountBalance });
	}), _defineProperty(_actionHandlers, actions.PAYMENT_REFUND_SUCCESS_PAY, function (state, _ref15) {
	  var payload = _ref15.payload;
	
	  if (!payload) return state;
	  var successResponse = payload.order,
	      amount = payload.amount;
	  var amountSettled = state.amountSettled,
	      amountBalance = state.amountBalance;
	
	  amountSettled = (0, _big2.default)(amountSettled).plus(amount);
	  amountBalance = (0, _big2.default)(amountBalance).minus(amount);
	  return Object.assign({}, state, { successResponse: successResponse, amountSettled: amountSettled, amountBalance: amountBalance });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(14);
	
	var _arrayToTree = __webpack_require__(457);
	
	var _arrayToTree2 = _interopRequireDefault(_arrayToTree);
	
	var _uuid = __webpack_require__(715);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _productionOrderItem = __webpack_require__(224);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var QUANTITY_PRICISION = 4;
	
	var initialState = {
	  editMode: false,
	  isCreating: false,
	
	  isLoading: false,
	  isSubmitting: false,
	
	  isLoadingBom: false,
	  isLoadingUom: false,
	  isLoadingListing: false,
	
	  errors: {
	    loadBOM: [],
	    loadUOM: [],
	    loadListing: []
	  },
	
	  initialValues: {},
	  initialProductionOrderItems: [],
	  billOfMaterials: {},
	  uomGroups: {},
	  storeId: null,
	  id: null,
	  status: '',
	  orderType: 1, //assemble
	  typeId: null,
	  productionOrderItems: []
	};
	
	var turnBomToChildren = function turnBomToChildren(items) {
	  items.forEach(function (i) {
	    if (Array.isArray(i.billOfMaterials) && i.billOfMaterials) {
	      i.children = turnBomToChildren(i.billOfMaterials);
	      delete i.billOfMaterials;
	    }
	  });
	  return items;
	};
	
	var patchBomUuid = function patchBomUuid(items) {
	  if (Array.isArray(items) && items.length) {
	    items = items.map(function (c) {
	      return patchChildBomUuid(c, null);
	    });
	  }
	  return items;
	};
	
	var patchChildBomUuid = function patchChildBomUuid(item, parentUuid) {
	  item.parentUuid = parentUuid;
	  item.uuid = _uuid2.default.v4();
	  if (Array.isArray(item.billOfMaterials) && item.billOfMaterials.length) {
	    item.billOfMaterials = item.billOfMaterials.map(function (i) {
	      return patchChildBomUuid(i, item.uuid);
	    });
	  }
	  return item;
	};
	
	var calculateItemQuantity = function calculateItemQuantity(item) {
	  var _item$ratio = item.ratio,
	      ratio = _item$ratio === undefined ? 1 : _item$ratio,
	      _item$productionOrder = item.productionOrderItemMaterials,
	      productionOrderItemMaterials = _item$productionOrder === undefined ? [] : _item$productionOrder,
	      _item$quantityInDispl = item.quantityInDisplayUnit,
	      quantityInDisplayUnit = _item$quantityInDispl === undefined ? 0 : _item$quantityInDispl,
	      _item$qtyFulfilledInD = item.qtyFulfilledInDisplayUnit,
	      qtyFulfilledInDisplayUnit = _item$qtyFulfilledInD === undefined ? 0 : _item$qtyFulfilledInD;
	
	
	  var multiplier = (0, _big2.default)(quantityInDisplayUnit).times(ratio);
	  item.quantity = multiplier.toFixed(QUANTITY_PRICISION);
	  item.qtyFulfilled = (0, _big2.default)(qtyFulfilledInDisplayUnit).times(ratio).toFixed(QUANTITY_PRICISION);
	  var fulfillPercentage = quantityInDisplayUnit > 0 ? (0, _big2.default)(qtyFulfilledInDisplayUnit).div(quantityInDisplayUnit) : (0, _big2.default)(0);
	  if (fulfillPercentage.gt((0, _big2.default)(1))) fulfillPercentage = (0, _big2.default)(1);
	  if (Array.isArray(productionOrderItemMaterials) && productionOrderItemMaterials.length) {
	    var materialQuantityCalculator = calculateMaterialQuantity.bind(null, multiplier, fulfillPercentage);
	    item.productionOrderItemMaterials = productionOrderItemMaterials.map(materialQuantityCalculator);
	  }
	  return item;
	};
	
	var calculateMaterialQuantity = function calculateMaterialQuantity(qtyMultiplier, fulfillPercentage, item) {
	  var thisQuantity = (0, _big2.default)(item.bomRatio || 0).times(item.unitRatio || 1).times(qtyMultiplier);
	  item.quantity = thisQuantity.toFixed(QUANTITY_PRICISION);
	  item.quantityInDisplayUnit = (0, _big2.default)(item.bomRatio || 0).times(qtyMultiplier).toFixed(QUANTITY_PRICISION);
	  item.qtyFulfilled = thisQuantity.times(fulfillPercentage).toFixed(QUANTITY_PRICISION);
	  item.qtyFulfilledInDisplayUnit = thisQuantity.times(item.unitRatio || 1).times(fulfillPercentage).toFixed(QUANTITY_PRICISION);
	  if (Array.isArray(item.children) && item.children.length) {
	    var calculator = calculateMaterialQuantity.bind(null, thisQuantity, fulfillPercentage);
	    item.children = item.children.map(calculator);
	  }
	  return item;
	};
	
	var patchPOMaterialListingInfo = function patchPOMaterialListingInfo(item, entities) {
	  var listing = entities[item.listingId] || {};
	  item.nameOfListing = listing.name;
	  item.ean13 = listing.ean13;
	  item.listingBarcode = listing.listingBarcode;
	  item.listingQuantity = (0, _big2.default)(listing.quantity || 0).toFixed(QUANTITY_PRICISION);
	  item.listingQtyReservedForProductionOrder = (0, _big2.default)(listing.qtyReservedForProductionOrder || 0).toFixed(QUANTITY_PRICISION);
	  if (Array.isArray(item.children) && item.children.length) {
	    item.children = item.children.map(function (i) {
	      return patchPOMaterialListingInfo(i, entities);
	    });
	  }
	  return item;
	};
	
	var patchPOMaterialQuantity = function patchPOMaterialQuantity(item, fulfillPercentage) {
	  if (!item.unitRatio) item.unitRatio = 1;
	  if (!item.bomRatio) item.bomRatio = 0;
	  if (!item.quantity) item.quantity = 0;
	  if (!item.quantityInDisplayUnit) item.quantityInDisplayUnit = (0, _big2.default)(item.quantity).div(item.unitRatio).toFixed(QUANTITY_PRICISION);
	  if (!item.qtyFulfilled) item.qtyFulfilled = (0, _big2.default)(item.quantity).times(fulfillPercentage).toFixed(QUANTITY_PRICISION);
	  if (!item.qtyFulfilledInDisplayUnit) item.qtyFulfilledInDisplayUnit = (0, _big2.default)(item.quantityInDisplayUnit).times(fulfillPercentage).toFixed(QUANTITY_PRICISION);
	  if (Array.isArray(item.children) && item.children.length) {
	    item.children = item.children.map(function (i) {
	      return patchPOMaterialQuantity(i, fulfillPercentage);
	    });
	  }
	  return item;
	};
	
	var patchBomMaterial = function patchBomMaterial(item, uomGroups) {
	  // get ratio and base unit
	  var displayUnitId = item.displayUnitId;
	
	  if (!displayUnitId) item.ratio = 1;else {
	    (0, _lodash.forEach)(uomGroups, function (group, unitGroupId) {
	      var units = group.units;
	
	      var found = (0, _lodash.find)(units, ['id', displayUnitId]);
	      if (found) {
	        item.ratio = found.ratio;
	        item.unitGroupId = found.unitGroupId;
	
	        var _partition = (0, _lodash.partition)(group.units || [], 'isBaseUnit'),
	            _partition2 = _slicedToArray(_partition, 2),
	            baseUnit = _partition2[0],
	            normalUnit = _partition2[1]; // eslint-disable-line  no-unused-vars
	
	
	        if (baseUnit.length) {
	          // PO need base unit
	          item.baseUnit = baseUnit[0].name;
	          item.baseUnitId = baseUnit[0].id;
	        }
	      }
	    });
	    if (!item.ratio) {
	      item.ratio = 1;
	      console.warn('Cannot find unit group for BOM item:', item);
	    }
	  }
	
	  item.bomRatio = item.quantityInDisplayUnit || 0;
	  item.unitRatio = item.ratio || 1;
	
	  // item.quantity = 0;
	  // item.quantityInDisplayUnit = 0;
	  // item.qtyFulfilled = 0;
	  // item.qtyFulfilledInDisplayUnit = 0;
	
	  // transform display name: BOM -> PO
	  item.displayUnit = item.displayUnitName;
	
	  // transform name: BOM -> PO
	  item.name = item.nameOfMaterial;
	
	  // transform ean13: BOM -> PO
	  item.ean13 = item.materialEan13;
	
	  // transform listingBarcode
	  item.listingBarcode = item.materialListingBarcode;
	
	  // transform bomType: BOM -> PO
	  item.bomType = item.materialBomType;
	
	  // no need to process sub materials if need to track item quantity
	  if (item.trackQuantity) {
	    item.children = [];
	  }
	
	  if (Array.isArray(item.children) && item.children.length) {
	    item.children = item.children.map(function (i) {
	      return patchBomMaterial(i, uomGroups);
	    });
	  }
	
	  return item;
	};
	
	var processRawItem = function processRawItem(item) {
	  if (!item.quantity) item.quantity = 0;
	  if (!item.quantityInDisplayUnit) item.qtyFulfilledInDisplayUnit = 0;
	  if (!item.qtyFulfilledInDisplayUnit) item.qtyFulfilledInDisplayUnit = 0;
	  if (!item.qtyFulfilled) item.qtyFulfilled = 0;
	  if (!item.ratio) item.ratio = 1;
	  var fulfillPercentage = item.quantity > 0 ? (0, _big2.default)(item.qtyFulfilled).div(item.quantity) : (0, _big2.default)(0);
	  if (fulfillPercentage.gt((0, _big2.default)(1))) fulfillPercentage = (0, _big2.default)(1);
	  if (Array.isArray(item.productionOrderItemMaterials) && item.productionOrderItemMaterials.length) {
	    item.productionOrderItemMaterials = (0, _arrayToTree2.default)(item.productionOrderItemMaterials, {
	      parentProperty: 'parentUuid',
	      customID: 'uuid'
	    });
	    item.productionOrderItemMaterials = item.productionOrderItemMaterials.map(function (i) {
	      return patchPOMaterialQuantity(i, fulfillPercentage);
	    });
	  }
	  return item;
	};
	
	var patchPOItemListingInfo = function patchPOItemListingInfo(item, entities) {
	  var listing = entities[item.listingId] || {};
	  item.nameOfListing = listing.name;
	  item.name = listing.name;
	  item.ean13 = listing.ean13;
	  item.listingBarcode = listing.listingBarcode;
	  item.imageUrl = listing.imageUrl;
	  item.unitGroupId = listing.unitGroupId;
	  item.listingQuantity = (0, _big2.default)(listing.quantity).toFixed(4);
	  item.listingQtyReservedForProductionOrder = (0, _big2.default)(listing.qtyReservedForProductionOrder).toFixed(4);
	  item.ratio = item.displayUnitRatio;
	  if (Array.isArray(item.productionOrderItemMaterials) && item.productionOrderItemMaterials.length) {
	    item.productionOrderItemMaterials = item.productionOrderItemMaterials.map(function (m) {
	      return patchPOMaterialListingInfo(m, entities);
	    });
	  }
	  return item;
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_REQUEST, function (state, action) {
	  var id = action.id,
	      storeId = action.storeId;
	
	  return _extends({}, state, { storeId: storeId, isLoading: false, isCreating: !id, id: id });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_SUCCESS, function (state, action) {
	  var data = (0, _lodash.cloneDeep)(action.data);
	  var _data$productionOrder = data.productionOrderItems,
	      productionOrderItems = _data$productionOrder === undefined ? [] : _data$productionOrder;
	
	  productionOrderItems = productionOrderItems.map(processRawItem);
	  return _extends({}, state, {
	    productionOrderItems: (0, _lodash.cloneDeep)(productionOrderItems),
	    initialProductionOrderItems: (0, _lodash.cloneDeep)(productionOrderItems),
	    initialValues: data,
	    typeId: data.typeId,
	    isLoading: false
	  });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.OPEN_PRODUCTION_ORDER_OVERVIEW_FAILURE, function (state, action) {
	  var errors = state.errors;
	
	  errors.loadProductionOrder = action.error;
	  return _extends({}, state, { isLoading: false, errors: errors });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CLOSE_PRODUCTION_ORDER_OVERVIEW, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.DISCARD_PRODUCTION_ORDER_OVERVIEW, function (state) {
	  var initialValues = state.initialValues,
	      listings = state.listings;
	
	
	  var productionOrderItems = (0, _lodash.cloneDeep)(initialValues.productionOrderItems);
	  productionOrderItems.forEach(function (item) {
	    var listing = listings[item.listingId] || {};
	    item.name = listing.name;
	    item.ean13 = listing.ean13;
	    item.listingBarcode = listing.listingBarcode;
	    item.imageUrl = listing.imageUrl;
	    item.unitGroupId = listing.unitGroupId;
	    item.listingQuantity = (0, _big2.default)(listing.quantity).toFixed(QUANTITY_PRICISION);
	    item.listingQtyReservedForProductionOrder = (0, _big2.default)(listing.qtyReservedForProductionOrder).toFixed(QUANTITY_PRICISION);
	  });
	  return _extends({}, state, { productionOrderItems: productionOrderItems, editMode: false });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_REQUEST, function (state) {
	  return _extends({}, state, { isSubmitting: true });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_SUCCESS, function (state, action) {
	  var data = action.data;
	  var _data$productionOrder2 = data.productionOrderItems,
	      productionOrderItems = _data$productionOrder2 === undefined ? [] : _data$productionOrder2;
	
	  productionOrderItems = productionOrderItems.map(processRawItem).map(function (i) {
	    return patchPOItemListingInfo(i, state.listings);
	  });
	  return _extends({}, state, {
	    isSubmitting: false,
	    editMode: false,
	    productionOrderItems: (0, _lodash.cloneDeep)(productionOrderItems),
	    initialProductionOrderItems: (0, _lodash.cloneDeep)(productionOrderItems),
	    initialValues: data
	  });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.SUBMIT_PRODUCTION_ORDER_OVERVIEW_FAILURE, function (state) {
	  return _extends({}, state, { isSubmitting: false, editMode: false });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CLOSE_ISSUBMITING_STATE, function (state) {
	  return _extends({}, state, { isSubmitting: false });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_REQUEST, function (state) {
	  return _extends({}, state, { isLoadingListing: true });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_SUCCESS, function (state, action) {
	  var data = action.data;
	
	  var entities = {};
	  data.forEach(function (d) {
	    return entities[d.id] = d;
	  });
	  var _state$productionOrde = state.productionOrderItems,
	      productionOrderItems = _state$productionOrde === undefined ? [] : _state$productionOrde;
	
	  productionOrderItems = productionOrderItems.map(function (i) {
	    return patchPOItemListingInfo(i, entities);
	  });
	  return _extends({}, state, { isLoadingListing: false, productionOrderItems: productionOrderItems, listings: entities });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_LISTINGS_FOR_PRODUCTION_ORDER_FAILURE, function (state, action) {
	  var errors = state.errors;
	
	  if (errors.hasOwnProperty('loadListing')) errors.loadListing.push(action.error);else errors.loadListing = [action.error];
	  return _extends({}, state, { isLoadingListing: false, errors: errors });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_REQUEST, function (state) {
	  return _extends({}, state, { isLoadingBom: true });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_BOM_FOR_PRODUCTION_ORDER_ITEM_SUCCESS, function (state, action) {
	  var data = action.data;
	  var billOfMaterials = state.billOfMaterials;
	
	  Object.keys(data).forEach(function (listingId) {
	    var itsBom = data[listingId];
	    itsBom = patchBomUuid(itsBom);
	    billOfMaterials[listingId] = turnBomToChildren(itsBom);
	  });
	  return _extends({}, state, { billOfMaterials: billOfMaterials, isLoadingBom: false });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_BOM_OF_PRODUCTION_ORDER_ITEM_FAILURE, function (state, action) {
	  var errors = state.errors;
	
	  if (errors.hasOwnProperty('loadBom')) errors.loadBom.push(action.error);else errors.loadBom = [action.error];
	  return _extends({}, state, { isLoadingBom: false });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_REQUEST, function (state) {
	  return _extends({}, state, { isLoadingUom: true });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_SUCCESS, function (state, action) {
	  var data = action.data;
	  var productionOrderItems = state.productionOrderItems;
	
	  var entities = {};
	  data.forEach(function (d) {
	    return entities[d.id] = d;
	  });
	  productionOrderItems.forEach(function (item) {
	    if (!item.unitGroupId || !entities[item.unitGroupId]) {
	      item.units = [];
	      item.unitMap = {};
	      item.ratio = 1;
	    } else {
	      item.units = entities[item.unitGroupId].units;
	      item.unitMap = {};
	      item.units.forEach(function (u) {
	        var id = u.id;
	
	        item.unitMap[id] = u;
	      });
	      item.ratio = item.unitMap[item.displayUnitId].ratio;
	    }
	  });
	  return _extends({}, state, { uomGroups: entities, isLoadingUom: false, productionOrderItems: productionOrderItems.slice() });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.LOAD_ALL_UOM_FOR_PRODUCTION_ORDER_FAILURE, function (state, action) {
	  var errors = state.errors;
	
	  if (errors.hasOwnProperty('loadUom')) errors.loadUom.push(action.error);else errors.loadBom = [action.error];
	  return _extends({}, state, { isLoadingUom: false, errors: errors });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.ENABLE_PRODUCTION_ORDER_EDITMODE, function (state, action) {
	  return _extends({}, state, { editMode: action.mode });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CHANGE_PRODUCTION_ORDER_TYPE, function (state, action) {
	  return _extends({}, state, { typeId: action.value });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CHANGE_PRODUCTION_ORDER_PLANNED_QUANTITY, function (state, action) {
	  var index = action.index,
	      value = action.value;
	  var productionOrderItems = state.productionOrderItems;
	
	  productionOrderItems[index].quantityInDisplayUnit = (0, _lodash.isNumber)(value) ? Math.floor(value * 10000) / 10000 : value;
	  productionOrderItems[index] = calculateItemQuantity(productionOrderItems[index]);
	  return _extends({}, state, { productionOrderItems: productionOrderItems.slice() });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CHANGE_PRODUCTION_ORDER_PROCESSED_QUANTITIY, function (state, action) {
	  var index = action.index,
	      value = action.value;
	  var productionOrderItems = state.productionOrderItems;
	
	  productionOrderItems[index].qtyFulfilledInDisplayUnit = (0, _lodash.isNumber)(value) ? Math.floor(value * 10000) / 10000 : value;
	  productionOrderItems[index] = calculateItemQuantity(productionOrderItems[index]);
	  return _extends({}, state, { productionOrderItems: productionOrderItems.slice() });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.CHANGE_PRODUCTION_ORDER_UOM, function (state, action) {
	  var index = action.index,
	      value = action.value;
	  var productionOrderItems = state.productionOrderItems;
	
	  productionOrderItems[index].displayUnitId = value.id;
	  productionOrderItems[index].displayUnit = value.name;
	  productionOrderItems[index].ratio = value.ratio;
	  productionOrderItems[index] = calculateItemQuantity(productionOrderItems[index]);
	  return _extends({}, state, { productionOrderItems: productionOrderItems.slice() });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.REMOVE_PRODUCTION_ORDER_LISTING_ITEM, function (state, action) {
	  var index = action.index;
	  var productionOrderItems = state.productionOrderItems;
	
	  productionOrderItems.splice(index, 1);
	  return _extends({}, state, { productionOrderItems: productionOrderItems.slice() });
	}), _defineProperty(_actionHandlers, _productionOrderItem.actionTypes.ADD_PRODUCTION_ORDER_LISTING_ITEM, function (state, action) {
	  var data = action.data;
	  var uomGroups = state.uomGroups;
	  var productionOrderItems = state.productionOrderItems;
	
	
	  data.forEach(function (listing) {
	    var newItem = {
	      name: listing.name,
	      imageUrl: listing.imageUrl,
	      listingId: listing.id,
	      ean13: listing.ean13,
	      quantity: 0,
	      quantityInDisplayUnit: 0,
	      qtyFulfilledInDisplayUnit: 0,
	      qtyFulfilled: 0,
	      trackQuantity: listing.hasOwnProperty('trackQuantity') ? listing.trackQuantity : 1,
	      listingBarcode: listing.listingBarcode,
	      listingQuantity: (0, _big2.default)(listing.quantity || 0).toFixed(QUANTITY_PRICISION),
	      listingQtyReservedForProductionOrder: (0, _big2.default)(listing.qtyReservedForProductionOrder || 0).toFixed(QUANTITY_PRICISION)
	    };
	
	    if (listing.unitGroupId) {
	      newItem.hasUnitGroup = true;
	      if (uomGroups[listing.unitGroupId]) {
	        newItem.units = uomGroups[listing.unitGroupId].units || [];
	        newItem.unitMap = {};
	        newItem.units.forEach(function (u) {
	          var id = u.id;
	
	          newItem.unitMap[id] = u;
	        });
	        var baseUnit = newItem.units.filter(function (u) {
	          return u.isBaseUnit;
	        });
	        if (baseUnit.length) baseUnit = baseUnit[0];else baseUnit = {};
	        newItem.baseUnitId = baseUnit.id;
	        newItem.baseUnit = baseUnit.name;
	        newItem.displayUnitId = baseUnit.id;
	        newItem.displayUnit = baseUnit.name;
	      }
	    }
	    newItem.ratio = 1;
	    if (newItem.trackQuantity) {
	      newItem.productionOrderItemMaterials = [];
	    } else {
	      newItem.productionOrderItemMaterials = state.billOfMaterials[listing.id] || [];
	      if (Array.isArray(newItem.productionOrderItemMaterials) && newItem.productionOrderItemMaterials.length) {
	        newItem.productionOrderItemMaterials = newItem.productionOrderItemMaterials.map(function (i) {
	          return patchBomMaterial(i, uomGroups);
	        });
	      }
	    }
	    productionOrderItems.push(calculateItemQuantity(newItem));
	  });
	
	  return _extends({}, state, { productionOrderItems: productionOrderItems.slice() });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(14);
	
	var _stationOverview = __webpack_require__(310);
	
	var actions = _interopRequireWildcard(_stationOverview);
	
	var _departmentSelection = __webpack_require__(118);
	
	var _kitchenDepartmentSelection = __webpack_require__(150);
	
	var _statusSelection = __webpack_require__(225);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  initialValues: {},
	  name: '',
	  need_aggregation: false,
	  aggregation_minutes: 10,
	  station_priorities: [],
	  matchCriteria: [],
	  //pending
	  show_in_progress: false,
	  display_view: 1
	};
	
	var defaultPriorities = [{
	  "id": "defalut1",
	  "name": "Critical",
	  "minutes": 3,
	  "color": "#f1735c"
	}, {
	  "id": "default2",
	  "name": "High",
	  "minutes": 3,
	  "color": "#3db3bf"
	}, {
	  "id": "defalut3",
	  "name": "Low",
	  "minutes": 3,
	  "color": "#adcf67"
	}];
	
	var patitionDepart = function patitionDepart(departments, match_group_number) {
	  var matched = [],
	      others = [];
	  departments.forEach(function (d) {
	    if (d.match_group_number === match_group_number) {
	      matched.push(d);
	    } else {
	      others.push(d);
	    }
	  });
	  return [matched, others];
	};
	
	var criteriaBuilder = function criteriaBuilder() {
	  var departments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var kitchenDepartments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var match_group_number = 1,
	      criterias = [];
	
	  while (departments.length || kitchenDepartments.length) {
	    var _patitionDepart = patitionDepart(departments, match_group_number),
	        _patitionDepart2 = _slicedToArray(_patitionDepart, 2),
	        matchedDepartments = _patitionDepart2[0],
	        otherDepartments = _patitionDepart2[1];
	
	    var _patitionDepart3 = patitionDepart(kitchenDepartments, match_group_number),
	        _patitionDepart4 = _slicedToArray(_patitionDepart3, 2),
	        matchedKitchDepart = _patitionDepart4[0],
	        otherKitchenDepartments = _patitionDepart4[1];
	
	    var first = matchedKitchDepart[0] || matchedDepartments[0];
	    if (first) {
	      var key = 'station_kitchen_department_statuses' in first ? 'station_kitchen_department_statuses' : 'station_department_statuses';
	      var status = first[key];
	      criterias.push({
	        match_group_number: match_group_number,
	        departments: matchedDepartments,
	        kitchenDepartments: matchedKitchDepart,
	        status: status
	      });
	    }
	    departments = otherDepartments;
	    kitchenDepartments = otherKitchenDepartments;
	  }
	
	  return criterias;
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.SHOW_STATION_OVERVIEW, function (state, action) {
	  var station = action.station;
	  var name = station.name,
	      need_aggregation = station.need_aggregation,
	      aggregation_minutes = station.aggregation_minutes,
	      station_departments = station.station_departments,
	      station_kitchen_departments = station.station_kitchen_departments,
	      station_priorities = station.station_priorities;
	
	  var matchCriteria = criteriaBuilder(station_departments, station_kitchen_departments);
	
	  if (!station_priorities || !station_priorities.length) {
	    station_priorities = defaultPriorities;
	  }
	
	  return Object.assign({}, state, {
	    initialValues: station,
	    name: name || '',
	    need_aggregation: need_aggregation,
	    aggregation_minutes: aggregation_minutes || 10,
	    station_priorities: station_priorities,
	    matchCriteria: matchCriteria
	  });
	}), _defineProperty(_actionHandlers, actions.ADD_MATCHING_CRITERIA, function (state) {
	  var matchCriteria = state.matchCriteria;
	
	  var numbers = matchCriteria.map(function (match) {
	    return match.match_group_number;
	  }).sort(function (a, b) {
	    return a - b;
	  });
	  var nextNumber = numbers.length ? numbers[numbers.length - 1] + 1 : 1;
	  matchCriteria.push({ match_group_number: nextNumber, departments: [], status: [], show_premature_items: false });
	  return Object.assign({}, state, { matchCriteria: matchCriteria });
	}), _defineProperty(_actionHandlers, actions.CHANE_STATION_NAME, function (state, action) {
	  return Object.assign({}, state, { name: action.value });
	}), _defineProperty(_actionHandlers, actions.CHANGE_SHOW_IN_PROGRESS_STATE, function (state, action) {
	  return Object.assign({}, state, { show_in_progress: action.value });
	}), _defineProperty(_actionHandlers, actions.SELECT_DISPLAY_VIEW, function (state, action) {
	  return Object.assign({}, state, { display_view: action.view });
	}), _defineProperty(_actionHandlers, actions.CHANGE_PRIORITY, function (state, action) {
	  var _action$priority = action.priority,
	      id = _action$priority.id,
	      minutes = _action$priority.minutes;
	  var station_priorities = state.station_priorities;
	
	  var prev = station_priorities.map(function (m, i) {
	    return m.id === id ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	  if (prev && prev.length) {
	    station_priorities[prev[0]].minutes = minutes;
	    return Object.assign({}, state, station_priorities);
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.TOGGLE_AGGREGATION, function (state, action) {
	  return Object.assign({}, state, { need_aggregation: action.value });
	}), _defineProperty(_actionHandlers, actions.CHANGE_AGGREGATION_TIME, function (state, action) {
	  return Object.assign({}, state, { aggregation_minutes: action.value });
	}), _defineProperty(_actionHandlers, actions.CHANGE_MATCHING_CRITERIA, function (state, action) {
	  var number = action.number,
	      departments = action.departments,
	      status = action.status,
	      showPrematureItems = action.showPrematureItems,
	      kitchenDepartments = action.kitchenDepartments;
	  var matchCriteria = state.matchCriteria;
	
	  var prev = matchCriteria.map(function (m, i) {
	    return m.match_group_number === number ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	  if (prev && prev.length) {
	    if (departments !== undefined) {
	      matchCriteria[prev[0]].departments = (0, _lodash.unionBy)(departments, 'department_id');
	    }
	    if (kitchenDepartments !== undefined) {
	      matchCriteria[prev[0]].kitchenDepartments = (0, _lodash.unionBy)(kitchenDepartments, 'kitchen_department_id');
	    }
	    if (status !== undefined) matchCriteria[prev[0]].status = status;
	    if (showPrematureItems !== undefined) matchCriteria[prev[0]].show_premature_items = showPrematureItems;
	    return Object.assign({}, state, { matchCriteria: matchCriteria });
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actions.SUBMIT_STATION_OVERVIEW_SUCCESS, function (state, action) {
	  var station = action.station;
	
	  return Object.assign({}, state, { initialValues: station });
	}), _defineProperty(_actionHandlers, _departmentSelection.SAVE_DEPARTMENT_SELECTION, function (state, action) {
	  var selected = action.selected,
	      params = action.params;
	
	  if (params.opener !== 'settings-kds') return state;
	  var number = params.number;
	  var matchCriteria = state.matchCriteria;
	
	  var prev = matchCriteria.map(function (m, i) {
	    return m.match_group_number === number ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	  if (prev && prev.length) {
	    matchCriteria[prev[0]].departments = (0, _lodash.unionBy)(matchCriteria[prev[0]].departments, selected, 'department_id');
	    return Object.assign({}, state, { matchCriteria: matchCriteria });
	  }
	  return state;
	}), _defineProperty(_actionHandlers, _kitchenDepartmentSelection.SAVE_KITCHEN_DEPARTMENT_SELECTION, function (state, action) {
	  var selected = action.selected,
	      params = action.params;
	
	  if (params.opener !== 'settings-kds') return state;
	  var number = params.number;
	  var matchCriteria = state.matchCriteria;
	
	  var prev = matchCriteria.map(function (m, i) {
	    return m.match_group_number === number ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	  if (prev && prev.length) {
	    matchCriteria[prev[0]].kitchenDepartments = (0, _lodash.unionBy)(matchCriteria[prev[0]].kitchenDepartments, selected, 'kitchen_department_id');
	    return Object.assign({}, state, { matchCriteria: matchCriteria });
	  }
	  return state;
	}), _defineProperty(_actionHandlers, _statusSelection.SAVE_STATUS_SELECTION, function (state, action) {
	  var selected = action.selected,
	      params = action.params;
	  var number = params.number;
	  var matchCriteria = state.matchCriteria;
	
	  var prev = matchCriteria.map(function (m, i) {
	    return m.match_group_number === number ? i : null;
	  }).filter(function (i) {
	    return i !== null;
	  });
	  if (prev && prev.length) {
	    matchCriteria[prev[0]].status = selected;
	    return Object.assign({}, state, { matchCriteria: matchCriteria });
	  }
	  return state;
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _statusSelection = __webpack_require__(225);
	
	var actions = _interopRequireWildcard(_statusSelection);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  isOpen: false,
	  params: {},
	  all: [],
	  selected: [],
	  input: {
	    value: '',
	    failure: false,
	    success: false
	  }
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.OPEN_STATUS_SELECTION, function (state, action) {
	  var all = action.all,
	      selected = action.selected,
	      params = action.params;
	
	  return Object.assign({}, state, { all: all, selected: selected, isOpen: true, params: params });
	}), _defineProperty(_actionHandlers, actions.CLOSE_STATUS_SELECTION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.SAVE_STATUS_SELECTION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.TOGGLE_STATUS, function (state, action) {
	  var item = action.item,
	      checked = action.checked;
	  var selected = state.selected;
	
	  if (checked) {
	    selected.push(item);
	  } else {
	    selected = selected.filter(function (i) {
	      return i.line_item_status_id !== item.line_item_status_id;
	    });
	  }
	  return Object.assign({}, state, { selected: selected });
	}), _defineProperty(_actionHandlers, actions.CHANGE_STATUS_INPUT, function (state, action) {
	  var input = state.input;
	
	  input.value = action.value;
	  return Object.assign({}, state, { input: input });
	}), _defineProperty(_actionHandlers, actions.ADD_STATUS_REQUEST, function (state) {
	  var input = state.input;
	
	  input = Object.assign({}, input, { failure: false, success: false });
	  return Object.assign({}, state, { input: input });
	}), _defineProperty(_actionHandlers, actions.ADD_STATUS_SUCCESS, function (state, action) {
	  var data = action.data;
	  var all = state.all,
	      input = state.input;
	
	  all.push({ line_item_status_name: data.status, line_item_status_id: data.id });
	  input = Object.assign({}, input, { failure: false, success: true });
	  return Object.assign({}, state, { all: all, input: input });
	}), _defineProperty(_actionHandlers, actions.ADD_STATUS_FAILURE, function (state) {
	  var input = state.input;
	
	  input = Object.assign({}, input, { failure: true, success: false });
	  return Object.assign({}, state, { input: input });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _tableSizeSegmentation = __webpack_require__(462);
	
	var actions = _interopRequireWildcard(_tableSizeSegmentation);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  editMode: false,
	  items: [],
	  enableDailyRestart: false,
	  initialValues: {},
	  storeId: '',
	  isCreating: false,
	  isLoading: false,
	  loadingError: '',
	  isSubmitting: false,
	  isRefreshing: false,
	  isLinking: false,
	  isModalOpen: false,
	  updatedAt: '',
	  linkSuccess: false,
	  linkError: false
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.CHANGE_TABLE_SIZE_SEGMENTATION_EDIT_MODE, function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { editMode: value });
	}), _defineProperty(_actionHandlers, actions.CHANGE_TYPE_NAME, function (state, action) {
	  var value = action.value,
	      index = action.index;
	  var items = state.items;
	
	  items[index].label = value;
	  return Object.assign({}, state, { items: items.slice() });
	}), _defineProperty(_actionHandlers, actions.CHANGE_TABLE_SIZE, function (state, action) {
	  var value = action.value,
	      index = action.index;
	  var items = state.items;
	
	  items[index].minimumPartySize = value;
	  var prev = value;
	  for (var i = index + 1; i < items.length; i++) {
	    if (items[i].minimumPartySize <= prev) {
	      items[i].minimumPartySize = prev + 1;
	      prev = prev + 1;
	    } else {
	      prev = items[i].minimumPartySize;
	    }
	  }
	  return Object.assign({}, state, { items: items.slice() });
	}), _defineProperty(_actionHandlers, actions.CHANGE_RESTART_ENABLE, function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { enableDailyRestart: value });
	}), _defineProperty(_actionHandlers, actions.ADD_TABLE_TYPE, function (state) {
	  var items = state.items;
	
	  items.push({ label: '', minimumPartySize: 0 });
	  return Object.assign({}, state, { items: items.slice() });
	}), _defineProperty(_actionHandlers, actions.REMOVE_TABLE_TYPE, function (state, action) {
	  var index = action.index;
	  var items = state.items;
	
	  items.splice(index, 1);
	  return Object.assign({}, state, { items: items.slice() });
	}), _defineProperty(_actionHandlers, actions.REFRESH_TABLE_SIZING_NOW_REQUEST, function (state, action) {
	  return Object.assign({}, state, { isRefreshing: true });
	}), _defineProperty(_actionHandlers, actions.REFRESH_TABLE_SIZING_NOW_SUCCESS, function (state) {
	  return Object.assign({}, state, { isRefreshing: false });
	}), _defineProperty(_actionHandlers, actions.REFRESH_TABLE_SIZING_NOW_FAILURE, function (state) {
	  return Object.assign({}, state, { isRefreshing: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_TABLE_SIZE_SEGMENTATION_REQUEST, function (state) {
	  return Object.assign({}, state, { isSubmitting: true });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_TABLE_SIZE_SEGMENTATION_SUCCESS, function (state) {
	  return Object.assign({}, state, { isSubmitting: false, editMode: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_TABLE_SIZE_SEGMENTATION_FAILURE, function (state) {
	  return Object.assign({}, state, { isSubmitting: false, editMode: false });
	}), _defineProperty(_actionHandlers, actions.OPEN_TABLE_SIZE_SEGMENTATION_REQUEST, function (state, action) {
	  return Object.assign({}, state, { isLoading: true });
	}), _defineProperty(_actionHandlers, actions.OPEN_TABLE_SIZE_SEGMENTATION_SUCCESS, function (state, action) {
	  var data = action.data,
	      isCreating = action.isCreating,
	      storeId = action.storeId;
	
	  var items = [];
	  var updatedAt = '';
	  var enableDailyRestart = false;
	  if (!isCreating) {
	    items = data.partySizeSegmentItems.slice();
	    items.sort(function (a, b) {
	      return a.minimumPartySize - b.minimumPartySize;
	    });
	    enableDailyRestart = data.dailyCountRestart;
	    updatedAt = data.updatedAt;
	  }
	  return Object.assign({}, state, {
	    storeId: storeId,
	    initialValues: data,
	    items: items,
	    enableDailyRestart: enableDailyRestart,
	    updatedAt: updatedAt,
	    isCreating: isCreating ? true : false,
	    editMode: isCreating ? true : false,
	    isLoading: false
	  });
	}), _defineProperty(_actionHandlers, actions.OPEN_TABLE_SIZE_SEGMENTATION_FAILURE, function (state, action) {
	  var error = action.error,
	      storeId = action.storeId;
	
	  return Object.assign({}, state, { isLoading: false, loadingError: error.message, storeId: storeId });
	}), _defineProperty(_actionHandlers, actions.CLOSE_TABLE_SIZE_SEGMENTATION, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.OPEN_LINK_UP_QUEUE_DISPLAY_MODAL, function (state) {
	  return Object.assign({}, state, { isModalOpen: true });
	}), _defineProperty(_actionHandlers, actions.CLOSE_LINK_UP_QUEUE_DISPLAY_MODAL, function (state) {
	  return Object.assign({}, state, { isModalOpen: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_LINK_UP_QUEUE_DISPLAY_REQUEST, function (state, action) {
	  return Object.assign({}, state, { isLinking: true, linkSuccess: false, linkError: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_LINK_UP_QUEUE_DISPLAY_SUCCESS, function (state, action) {
	  return Object.assign({}, state, { isLinking: false, linkSuccess: true });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_LINK_UP_QUEUE_DISPLAY_FAILURE, function (state, action) {
	  return Object.assign({}, state, { isLinking: false, linkError: true });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _uomGroupOverview = __webpack_require__(463);
	
	var actions = _interopRequireWildcard(_uomGroupOverview);
	
	var _lodash = __webpack_require__(14);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  editMode: false,
	  initialValues: {},
	  storeId: '',
	  isCreating: false,
	  isLoading: false,
	  isSubmitting: false,
	  groupName: '',
	  units: [],
	  referenceUnit: {
	    name: '',
	    ratio: 1,
	    unitGroupId: undefined,
	    isBaseUnit: true
	  }
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.OPEN_WORKFLOW_OVERVIEW_REQUEST, function (state, action) {
	  var unitGroupId = action.unitGroupId,
	      storeId = action.storeId;
	
	  if (!unitGroupId) {
	    return Object.assign({}, state, { isCreating: true, editMode: true, storeId: storeId });
	  } else {
	    return Object.assign({}, state, { isLoading: true, storeId: storeId, unitGroupId: unitGroupId });
	  }
	}), _defineProperty(_actionHandlers, actions.OPEN_WORKFLOW_OVERVIEW_SUCCESS, function (state, action) {
	  var data = action.data;
	
	  var loaded = {};
	  loaded.isLoading = false;
	  loaded.initialValues = data;
	  loaded.groupName = data.name;
	  var units = data.units || [];
	  var ref = units.filter(function (u) {
	    return u.isBaseUnit === true;
	  });
	  if (ref.length) {
	    ref = ref[0];
	    if (ref.ratio) ref.ratio = parseFloat(ref.ratio);
	    loaded.referenceUnit = ref;
	  }
	  var normal = units.filter(function (u) {
	    return !u.isBaseUnit;
	  });
	  if (normal.length) {
	    normal.forEach(function (u) {
	      return u.ratio = parseFloat(u.ratio);
	    });
	    loaded.units = (0, _lodash.uniqBy)(normal, 'id');
	  }
	  return Object.assign({}, state, loaded);
	}), _defineProperty(_actionHandlers, actions.OPEN_WORKFLOW_OVERVIEW_FAILURE, function (state, action) {
	  return Object.assign({}, state, { isLoading: false });
	}), _defineProperty(_actionHandlers, actions.CLOSE_WORKFLOW_OVERVIEW, function () {
	  return initialState;
	}), _defineProperty(_actionHandlers, actions.ENABLE_UOM_OVERVIEW_EDITMODE, function (state) {
	  return Object.assign({}, state, { editMode: true });
	}), _defineProperty(_actionHandlers, actions.CHANGE_UOM_GROUP_NAME, function (state, action) {
	  var value = action.value;
	
	  return Object.assign({}, state, { groupName: value });
	}), _defineProperty(_actionHandlers, actions.CHANGE_UOM_UNIT_NAME, function (state, action) {
	  var value = action.value,
	      index = action.index;
	
	  if (index !== undefined) {
	    var units = state.units;
	
	    units[index].name = value;
	    return Object.assign({}, state, { units: units });
	  } else {
	    var referenceUnit = state.referenceUnit;
	
	    referenceUnit.name = value;
	    return Object.assign({}, state, { referenceUnit: referenceUnit });
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_UOM_UNIT_RATIO, function (state, action) {
	  var value = action.value,
	      index = action.index;
	
	  if (index !== undefined) {
	    var units = state.units;
	
	    units[index].ratio = value;
	    return Object.assign({}, state, { units: units });
	  } else {
	    var referenceUnit = state.referenceUnit;
	
	    referenceUnit.ratio = value;
	    return Object.assign({}, state, { referenceUnit: referenceUnit });
	  }
	}), _defineProperty(_actionHandlers, actions.ADD_UOM_UNIT, function (state, action) {
	  var units = state.units.slice();
	  units.push({ name: '', ratio: 1 });
	  return Object.assign({}, state, { units: units });
	}), _defineProperty(_actionHandlers, actions.REMOVE_UOM_UNIT, function (state, action) {
	  var index = action.index;
	
	  var units = state.units.slice();
	  units.splice(index, 1);
	  return Object.assign({}, state, { units: units });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UOM_GROUP_REQUEST, function (state) {
	  return Object.assign({}, state, { isSubmitting: true });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UOM_GROUP_SUCCESS, function (state) {
	  return Object.assign({}, state, { isSubmitting: false, editMode: false });
	}), _defineProperty(_actionHandlers, actions.SUBMIT_UOM_GROUP_FAILURE, function (state) {
	  return Object.assign({}, state, { isSubmitting: false, editMode: false });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _lodash = __webpack_require__(14);
	
	var _workflowOverview = __webpack_require__(464);
	
	var actions = _interopRequireWildcard(_workflowOverview);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  initialValues: null,
	  title: '',
	  steps: [],
	  isCreating: true
	};
	
	function linksToList(trans) {
	  var links = {};
	  var all = {};
	  var froms = [];
	  var tos = [];
	  trans.forEach(function (_ref) {
	    var from_status = _ref.from_status,
	        to_status = _ref.to_status;
	
	    from_status = from_status || {};
	    to_status = to_status || {};
	    froms.push(from_status);
	    tos.push(to_status);
	    links[from_status.id] = to_status.id;
	    all[from_status.id] = from_status;
	    all[to_status.id] = to_status;
	  });
	  var start = (0, _lodash.differenceBy)((0, _lodash.unionBy)(froms, tos, 'id'), tos, 'id');
	  if (start.length) {
	    var from = start[0].id;
	    var list = [];
	    list.push(start[0]);
	    var to = links[from];
	    while (to !== undefined) {
	      list.push(all[to]);
	      to = links[to];
	    }
	    return list;
	  } else {
	    return [];
	  }
	}
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.SHOW_WORKFLOW_OVERVIEW, function (state, action) {
	  var initialValues = action.initialValues,
	      isCreating = action.isCreating;
	
	  if (isCreating) {
	    return initialState;
	  } else {
	    var steps = [];
	    var workflow_statuses = initialValues.workflow_statuses;
	
	    if (workflow_statuses && workflow_statuses.length) {
	      steps = linksToList(workflow_statuses);
	      steps.forEach(function (s) {
	        s.value = s.status;
	        s.label = s.status;
	      });
	    }
	    return Object.assign({}, state, { initialValues: initialValues, title: initialValues.name, steps: steps, isCreating: isCreating });
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_WORKFLOW_TITLE, function (state, action) {
	  return Object.assign({}, state, { title: action.value });
	}), _defineProperty(_actionHandlers, actions.ADD_WORKFLOW_NEXT_STEP, function (state, action) {
	  var steps = state.steps;
	
	  steps.push(undefined);
	  return Object.assign({}, state, { steps: steps });
	}), _defineProperty(_actionHandlers, actions.SELECT_WORKFLOW_STEP_STATUS, function (state, action) {
	  var stepNumber = action.stepNumber,
	      lineItemStatus = action.lineItemStatus;
	  var steps = state.steps;
	
	  if (!steps.length) {
	    steps.push(lineItemStatus);
	  } else {
	    if (!lineItemStatus) {
	      steps.splice(stepNumber, 1);
	    } else {
	      steps[stepNumber] = lineItemStatus;
	    }
	  }
	  return Object.assign({}, state, { steps: steps });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.importerReducer = importerReducer;
	
	var _inventoryActions = __webpack_require__(105);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = [];
	
	function importerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case _inventoryVarianceActions.INVENTORY_VARIANCE_IMPORT_INIT:
	      return [].concat(_toConsumableArray(state));
	
	    case _inventoryActions.REQUEST_VALIATATED:
	      return Object.assign({}, action.data, { upload_url: action.upload_url ? action.upload_url : "" });
	
	    case _inventoryActions.GET_IMPORTER_STATUS:
	      return action.data;
	
	    case _inventoryActions.REQUEST_UPLOAD_IMAGES:
	      return action.data;
	
	    case _inventoryActions.WAIT_SERVER_UPLOAD_IMAGES:
	      return Object.assign({}, action.data, { status: _inventoryActions.WAIT_SERVER_UPLOAD_IMAGES });
	
	    case _inventoryActions.UPLOADING_IMAGES:
	      return Object.assign({}, action.data, { status: _inventoryActions.UPLOADING_IMAGES });
	
	    case _inventoryActions.FINISH_UPLOAD_IMAGES:
	      return Object.assign({}, { status: _inventoryActions.FINISH_UPLOAD_IMAGES, id: action.id });
	
	    case _inventoryActions.ERROR_UPLOAD_IMAGES:
	      return Object.assign({}, action.data, { status: _inventoryActions.ERROR_UPLOAD_IMAGES });
	    default:
	      return state;
	  }
	}

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _humps = __webpack_require__(44);
	
	var _reduxHelper = __webpack_require__(30);
	
	var _inventoryVarianceActions = __webpack_require__(119);
	
	var actionTypes = _interopRequireWildcard(_inventoryVarianceActions);
	
	var _constants = __webpack_require__(26);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MODE = _constants.INVENTORY_VARIANCE.MODE,
	    TYPE = _constants.INVENTORY_VARIANCE.TYPE,
	    TAB = _constants.INVENTORY_VARIANCE.TAB;
	
	
	var initialState = {
	  mode: MODE.VIEW,
	  tab: TAB.OVERVIEW,
	  type: TYPE.OPENING,
	  currentStore: {},
	  currentPage: 0, // start from 1
	  totalPages: 0,
	  perPage: 20,
	  totalEntries: 0,
	  varianceCostTotal: (0, _big2.default)(0),
	  activeItems: [],
	  errors: {},
	  entities: {},
	  iv: {
	    id: null,
	    typeId: TAB.OPENING,
	    name: '',
	    effectiveDate: null,
	    remarks: '',
	    items: []
	  }
	};
	
	var activeFilter = function activeFilter() {
	  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var entities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return ids.filter(function (id) {
	    return entities[id] && !entities[id]._destroy;
	  });
	};
	
	var calTotalPagesInfo = function calTotalPagesInfo(state) {
	  var _state$iv$items = state.iv.items,
	      items = _state$iv$items === undefined ? [] : _state$iv$items,
	      _state$entities = state.entities,
	      entities = _state$entities === undefined ? {} : _state$entities,
	      currentPage = state.currentPage,
	      perPage = state.perPage;
	
	  var activeIds = activeFilter(items, entities);
	  var totalEntries = activeIds.length;
	  var totalPages = Math.ceil(totalEntries / perPage);
	  var newCurrentPage = currentPage;
	  if (currentPage === 0 && totalPages > 0) {
	    newCurrentPage = 1;
	  } else if (currentPage > totalPages) {
	    newCurrentPage = totalPages;
	  }
	  var currentIdx = (newCurrentPage - 1) * perPage;
	  var activeItems = activeIds.slice(currentIdx, currentIdx + perPage).map(function (id) {
	    return entities[id];
	  });
	  var varianceCostTotal = activeIds.reduce(function (sum, id) {
	    var item = entities[id] || {};
	    return state.type == TYPE.OPENING ? sum.add(item.totalCost || 0) : sum.add(item.varianceCost || 0);
	  }, (0, _big2.default)(0));
	  return _extends({}, state, {
	    totalEntries: totalEntries,
	    totalPages: totalPages,
	    perPage: perPage,
	    currentPage: newCurrentPage,
	    varianceCostTotal: varianceCostTotal,
	    activeItems: activeItems
	  });
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_INIT, function (state, _ref) {
	  var _ref$payload = _ref.payload,
	      payload = _ref$payload === undefined ? {} : _ref$payload;
	
	  return _extends({}, initialState, payload);
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_SET_FIELDS, function (state, _ref2) {
	  var _ref2$payload = _ref2.payload,
	      payload = _ref2$payload === undefined ? {} : _ref2$payload;
	
	  return _extends({}, state, payload);
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_ADD_LISTINGS, function (state, _ref3) {
	  var _ref3$payload = _ref3.payload,
	      payload = _ref3$payload === undefined ? [] : _ref3$payload;
	
	  if (payload.length > 0) {
	    var entities = _extends({}, state.entities);
	    var items = state.iv.items.slice();
	    var mappedPayload = payload.map(function (listing) {
	      return (0, _humps.camelizeKeys)(listing);
	    }).map(function (listing) {
	      listing.listingId = listing.id;
	      listing.id = null;
	      listing.productName = listing.name;
	      listing.qtyBefore = (0, _big2.default)(listing.quantity || 0);
	      listing.actualQty = (0, _big2.default)(listing.quantity || 0);
	      listing.quantityInDisplayUnit = (0, _big2.default)(listing.quantity || 0);
	      listing.varianceQty = (0, _big2.default)(0);
	      listing.varianceQtyInDisplayUnit = (0, _big2.default)(0);
	      listing.costBefore = (0, _big2.default)(listing.cost || 0);
	      listing.cost = (0, _big2.default)(listing.cost || 0);
	      listing.costInDisplayUnit = (0, _big2.default)(listing.cost || 0);
	      listing.varianceCost = (0, _big2.default)(0);
	      listing.totalCost = listing.quantityInDisplayUnit.times(listing.costInDisplayUnit);
	      listing.errors = [];
	      listing._destroy = false;
	      listing._modified = false;
	      listing.serialNumbers = (listing.serialNumbers || []).map(function (v) {
	        return typeof v === 'string' ? v : v.number;
	      });
	      listing.listingReferenceCodes = (listing.listingReferenceCodes || []).map(function (v) {
	        return typeof v === 'string' ? v : v.code;
	      });
	      listing.remark = "";
	      // listing.displayUnitId    = listing.baseUnit ? listing.baseUnit.id : null;
	      listing.displayUnitId = null;
	      return listing;
	    });
	    mappedPayload.forEach(function (listing) {
	      var listingId = listing.listingId;
	
	      if (entities[listingId]) {
	        entities[listingId] = _extends({}, entities[listingId]);
	        entities[listingId]._destroy = false;
	      } else {
	        entities[listingId] = listing;
	        items.push(listing.listingId);
	      }
	    });
	    var iv = _extends({}, state.iv, {
	      items: items
	    });
	    return calTotalPagesInfo(_extends({}, state, { iv: iv, entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_LOAD_LISTINGS, function (state, _ref4) {
	  var _ref4$payload = _ref4.payload,
	      payload = _ref4$payload === undefined ? [] : _ref4$payload;
	
	  if (payload.length > 0) {
	    var type = state.type,
	        _state$errors = state.errors,
	        errors = _state$errors === undefined ? {} : _state$errors;
	
	    var entities = _extends({}, state.entities);
	    var isVarQty = type === TYPE.VARIANCE_QTY_ADJ;
	    var isVarCost = type === TYPE.COST_ADJ;
	    var items = state.iv.items.slice();
	    var mappedPayload = payload.map(function (listing) {
	      return (0, _humps.camelizeKeys)(listing);
	    }).map(function (listing) {
	      listing.qtyBefore = (0, _big2.default)(listing.qtyBefore || 0);
	      listing.actualQty = (0, _big2.default)(listing.actualQty || 0);
	      listing.quantityInDisplayUnit = (0, _big2.default)(listing.quantityInDisplayUnit || 0);
	      listing.varianceQty = isVarQty ? (0, _big2.default)(listing.varianceQty) : (0, _big2.default)(listing.quantityInDisplayUnit).minus(listing.qtyBefore);
	      listing.varianceQtyInDisplayUnit = isVarQty ? (0, _big2.default)(listing.varianceQtyInDisplayUnit) : (0, _big2.default)(listing.quantityInDisplayUnit).minus(listing.qtyBefore);
	      listing.costBefore = (0, _big2.default)(listing.costBefore || 0);
	      listing.cost = (0, _big2.default)(listing.cost || 0);
	      listing.costInDisplayUnit = (0, _big2.default)(listing.costInDisplayUnit || 0);
	      listing.varianceCost = isVarCost ? (0, _big2.default)(listing.costInDisplayUnit).minus(listing.costBefore).times(listing.qtyBefore) : (0, _big2.default)(listing.varianceQtyInDisplayUnit).times(listing.costInDisplayUnit);
	      listing.totalCost = listing.quantityInDisplayUnit.times(listing.costInDisplayUnit);
	      listing.errors = errors[listing.id] || [];
	      listing._destroy = false;
	      listing._modified = false;
	      listing.serialNumbers = (listing.serialNumbers || []).map(function (v) {
	        return typeof v === 'string' ? v : v.number;
	      });
	      listing.listingReferenceCodes = (listing.listingReferenceCodes || []).map(function (v) {
	        return typeof v === 'string' ? v : v.code;
	      });
	      return listing;
	    });
	    mappedPayload.forEach(function (listing) {
	      var listingId = listing.listingId;
	
	      if (entities[listingId]) {
	        entities[listingId] = _extends({}, entities[listingId]);
	        entities[listingId]._destroy = false;
	      } else {
	        entities[listingId] = listing;
	        items.push(listing.listingId);
	      }
	    });
	    var iv = _extends({}, state.iv, {
	      items: items
	    });
	    return calTotalPagesInfo(_extends({}, state, { iv: iv, entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_REMOVE_LISTINGS, function (state, _ref5) {
	  var _ref5$payload = _ref5.payload,
	      payload = _ref5$payload === undefined ? [] : _ref5$payload;
	
	  if (payload.length > 0) {
	    var entities = _extends({}, state.entities);
	    var items = state.iv.items.slice();
	    payload.forEach(function (listingId) {
	      if (entities[listingId]) {
	        entities[listingId] = _extends({}, entities[listingId]);
	        entities[listingId]._destroy = true;
	      }
	    });
	    var iv = _extends({}, state.iv, {
	      items: items
	    });
	    return calTotalPagesInfo(_extends({}, state, { iv: iv, entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_ACTUAL_QTY, function (state, _ref6) {
	  var _ref6$payload = _ref6.payload,
	      payload = _ref6$payload === undefined ? {} : _ref6$payload;
	  var listingId = payload.listingId,
	      value = payload.value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var _entities$listingId = entities[listingId],
	        qtyBefore = _entities$listingId.qtyBefore,
	        actualQty = _entities$listingId.actualQty,
	        varianceQty = _entities$listingId.varianceQty,
	        varianceQtyInDisplayUnit = _entities$listingId.varianceQtyInDisplayUnit,
	        costBefore = _entities$listingId.costBefore,
	        cost = _entities$listingId.cost,
	        varianceCost = _entities$listingId.varianceCost,
	        totalCost = _entities$listingId.totalCost,
	        quantityInDisplayUnit = _entities$listingId.quantityInDisplayUnit,
	        costInDisplayUnit = _entities$listingId.costInDisplayUnit;
	
	    quantityInDisplayUnit = (0, _big2.default)(value || 0);
	    varianceQty = (0, _big2.default)(quantityInDisplayUnit).minus(qtyBefore);
	    varianceQtyInDisplayUnit = (0, _big2.default)(quantityInDisplayUnit).minus(qtyBefore);
	    varianceCost = (0, _big2.default)(varianceQtyInDisplayUnit).times(costInDisplayUnit);
	    totalCost = (0, _big2.default)(quantityInDisplayUnit).times(costInDisplayUnit);
	    entities[listingId] = _extends({}, entities[listingId], {
	      qtyBefore: qtyBefore, actualQty: actualQty, varianceQty: varianceQty, varianceQtyInDisplayUnit: varianceQtyInDisplayUnit,
	      costBefore: costBefore, cost: cost, varianceCost: varianceCost, totalCost: totalCost, quantityInDisplayUnit: quantityInDisplayUnit, costInDisplayUnit: costInDisplayUnit,
	      _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_REMARK, function (state, _ref7) {
	  var _ref7$payload = _ref7.payload,
	      payload = _ref7$payload === undefined ? {} : _ref7$payload;
	  var listingId = payload.listingId,
	      value = payload.value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var remark = entities[listingId].remark;
	
	    remark = value;
	    entities[listingId] = _extends({}, entities[listingId], { remark: remark, _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_UNIT, function (state, _ref8) {
	  var _ref8$payload = _ref8.payload,
	      payload = _ref8$payload === undefined ? {} : _ref8$payload;
	  var listingId = payload.listingId,
	      value = payload.value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var _entities$listingId2 = entities[listingId],
	        qtyBefore = _entities$listingId2.qtyBefore,
	        varianceQtyInDisplayUnit = _entities$listingId2.varianceQtyInDisplayUnit,
	        displayUnitId = _entities$listingId2.displayUnitId,
	        unitGroup = _entities$listingId2.unitGroup,
	        costBefore = _entities$listingId2.costBefore,
	        varianceCost = _entities$listingId2.varianceCost,
	        totalCost = _entities$listingId2.totalCost,
	        quantityInDisplayUnit = _entities$listingId2.quantityInDisplayUnit,
	        costInDisplayUnit = _entities$listingId2.costInDisplayUnit;
	
	    var currentUnitRatio = unitGroup.find(function (r) {
	      return r.id === value.value;
	    }).ratio;
	    var beforeUnitRatio = unitGroup.find(function (r) {
	      return r.id === displayUnitId;
	    }).ratio;
	    displayUnitId = value.value;
	    qtyBefore = (0, _big2.default)(qtyBefore).times(beforeUnitRatio).div(currentUnitRatio);
	    costBefore = (0, _big2.default)(costBefore).div(beforeUnitRatio).times(currentUnitRatio);
	    costInDisplayUnit = (0, _big2.default)(costInDisplayUnit).div(beforeUnitRatio).times(currentUnitRatio);
	    varianceQtyInDisplayUnit = (0, _big2.default)(quantityInDisplayUnit).minus(qtyBefore);
	    varianceCost = (0, _big2.default)(varianceQtyInDisplayUnit).times(costInDisplayUnit);
	    totalCost = (0, _big2.default)(quantityInDisplayUnit).times(costInDisplayUnit);
	    entities[listingId] = _extends({}, entities[listingId], {
	      qtyBefore: qtyBefore, varianceQtyInDisplayUnit: varianceQtyInDisplayUnit, displayUnitId: displayUnitId, unitGroup: unitGroup,
	      costBefore: costBefore, varianceCost: varianceCost, totalCost: totalCost, quantityInDisplayUnit: quantityInDisplayUnit, costInDisplayUnit: costInDisplayUnit, _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_VARIANCE_QTY, function (state, _ref9) {
	  var _ref9$payload = _ref9.payload,
	      payload = _ref9$payload === undefined ? {} : _ref9$payload;
	  var listingId = payload.listingId,
	      value = payload.value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var _entities$listingId3 = entities[listingId],
	        qtyBefore = _entities$listingId3.qtyBefore,
	        actualQty = _entities$listingId3.actualQty,
	        varianceQty = _entities$listingId3.varianceQty,
	        varianceQtyInDisplayUnit = _entities$listingId3.varianceQtyInDisplayUnit,
	        costBefore = _entities$listingId3.costBefore,
	        cost = _entities$listingId3.cost,
	        varianceCost = _entities$listingId3.varianceCost,
	        totalCost = _entities$listingId3.totalCost,
	        quantityInDisplayUnit = _entities$listingId3.quantityInDisplayUnit,
	        costInDisplayUnit = _entities$listingId3.costInDisplayUnit;
	
	    varianceQty = (0, _big2.default)(value || 0);
	    varianceQtyInDisplayUnit = (0, _big2.default)(value || 0);
	    quantityInDisplayUnit = (0, _big2.default)(qtyBefore).plus(varianceQtyInDisplayUnit);
	    varianceCost = (0, _big2.default)(varianceQtyInDisplayUnit).times(costInDisplayUnit);
	    totalCost = (0, _big2.default)(quantityInDisplayUnit).times(costInDisplayUnit);
	    entities[listingId] = _extends({}, entities[listingId], {
	      qtyBefore: qtyBefore, actualQty: actualQty, varianceQty: varianceQty, varianceQtyInDisplayUnit: varianceQtyInDisplayUnit,
	      costBefore: costBefore, cost: cost, varianceCost: varianceCost, totalCost: totalCost, quantityInDisplayUnit: quantityInDisplayUnit, costInDisplayUnit: costInDisplayUnit,
	      _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_COST, function (state, _ref10) {
	  var _ref10$payload = _ref10.payload,
	      payload = _ref10$payload === undefined ? {} : _ref10$payload;
	  var listingId = payload.listingId,
	      value = payload.value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var _entities$listingId4 = entities[listingId],
	        qtyBefore = _entities$listingId4.qtyBefore,
	        actualQty = _entities$listingId4.actualQty,
	        varianceQty = _entities$listingId4.varianceQty,
	        varianceQtyInDisplayUnit = _entities$listingId4.varianceQtyInDisplayUnit,
	        costBefore = _entities$listingId4.costBefore,
	        cost = _entities$listingId4.cost,
	        varianceCost = _entities$listingId4.varianceCost,
	        totalCost = _entities$listingId4.totalCost,
	        quantityInDisplayUnit = _entities$listingId4.quantityInDisplayUnit,
	        costInDisplayUnit = _entities$listingId4.costInDisplayUnit;
	
	    cost = (0, _big2.default)(value || 0);
	    costInDisplayUnit = (0, _big2.default)(value || 0);
	    varianceCost = (0, _big2.default)(costInDisplayUnit).minus(costBefore).times(qtyBefore);
	    totalCost = (0, _big2.default)(qtyBefore).times(costInDisplayUnit);
	    entities[listingId] = _extends({}, entities[listingId], {
	      qtyBefore: qtyBefore, actualQty: actualQty, varianceQty: varianceQty, varianceQtyInDisplayUnit: varianceQtyInDisplayUnit,
	      costBefore: costBefore, cost: cost, varianceCost: varianceCost, totalCost: totalCost, quantityInDisplayUnit: quantityInDisplayUnit, costInDisplayUnit: costInDisplayUnit,
	      _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_SERIAL_NUMBERS, function (state, _ref11) {
	  var _ref11$payload = _ref11.payload,
	      payload = _ref11$payload === undefined ? {} : _ref11$payload;
	  var listingId = payload.listingId,
	      _payload$value = payload.value,
	      value = _payload$value === undefined ? [] : _payload$value;
	
	  if (state.entities[listingId]) {
	    var entities = _extends({}, state.entities);
	    var _entities$listingId5 = entities[listingId],
	        qtyBefore = _entities$listingId5.qtyBefore,
	        actualQty = _entities$listingId5.actualQty,
	        varianceQty = _entities$listingId5.varianceQty,
	        varianceQtyInDisplayUnit = _entities$listingId5.varianceQtyInDisplayUnit,
	        costBefore = _entities$listingId5.costBefore,
	        cost = _entities$listingId5.cost,
	        varianceCost = _entities$listingId5.varianceCost,
	        totalCost = _entities$listingId5.totalCost,
	        quantityInDisplayUnit = _entities$listingId5.quantityInDisplayUnit,
	        costInDisplayUnit = _entities$listingId5.costInDisplayUnit;
	
	    var serialNumbers = value;
	    actualQty = (0, _big2.default)(value.length || 0);
	    quantityInDisplayUnit = (0, _big2.default)(value.length || 0);
	    varianceQty = (0, _big2.default)(quantityInDisplayUnit).minus(qtyBefore);
	    varianceQtyInDisplayUnit = (0, _big2.default)(quantityInDisplayUnit).minus(qtyBefore);
	    varianceCost = (0, _big2.default)(varianceQtyInDisplayUnit).times(costInDisplayUnit);
	    totalCost = (0, _big2.default)(quantityInDisplayUnit).times(costInDisplayUnit);
	    entities[listingId] = _extends({}, entities[listingId], {
	      qtyBefore: qtyBefore, actualQty: actualQty, varianceQty: varianceQty, varianceQtyInDisplayUnit: varianceQtyInDisplayUnit,
	      costBefore: costBefore, cost: cost, varianceCost: varianceCost, totalCost: totalCost, quantityInDisplayUnit: quantityInDisplayUnit, costInDisplayUnit: costInDisplayUnit,
	      serialNumbers: serialNumbers,
	      _modified: true
	    });
	    return calTotalPagesInfo(_extends({}, state, { entities: entities }));
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_IV_FIELD, function (state, _ref12) {
	  var _ref12$payload = _ref12.payload,
	      payload = _ref12$payload === undefined ? {} : _ref12$payload;
	  var field = payload.field,
	      value = payload.value;
	
	  var iv = _extends({}, state.iv, _defineProperty({}, field, value));
	  return _extends({}, state, { iv: iv });
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_LISTING_GO_TO_PAGE, function (state, _ref13) {
	  var _ref13$payload = _ref13.payload,
	      payload = _ref13$payload === undefined ? {} : _ref13$payload;
	  var page = payload.page;
	
	  var currentPage = page ? page : 0;
	  return calTotalPagesInfo(_extends({}, state, { currentPage: currentPage }));
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_LOAD_ITEM, function (state, _ref14) {
	  var _ref14$payload = _ref14.payload,
	      payload = _ref14$payload === undefined ? {} : _ref14$payload;
	
	  var data = (0, _humps.camelizeKeys)(payload).inventoryVariance;
	
	  var _data$typeId = data.typeId,
	      type = _data$typeId === undefined ? TYPE.OPENING : _data$typeId,
	      _data$humanizeValidat = data.humanizeValidationErrors,
	      errors = _data$humanizeValidat === undefined ? {} : _data$humanizeValidat,
	      iv = _objectWithoutProperties(data, ['typeId', 'humanizeValidationErrors']);
	
	  iv.items = [];
	  return _extends({}, state, { type: type, iv: iv, errors: errors });
	}), _defineProperty(_actionHandlers, actionTypes.INVENTORY_VARIANCE_UPDATE_ITEM, function (state, _ref15) {
	  var _ref15$payload = _ref15.payload,
	      payload = _ref15$payload === undefined ? {} : _ref15$payload;
	
	  var data = (0, _humps.camelizeKeys)(payload).inventoryVariance;
	
	  var _data$typeId2 = data.typeId,
	      type = _data$typeId2 === undefined ? TYPE.OPENING : _data$typeId2,
	      _data$humanizeValidat2 = data.humanizeValidationErrors,
	      errors = _data$humanizeValidat2 === undefined ? {} : _data$humanizeValidat2,
	      newIv = _objectWithoutProperties(data, ['typeId', 'humanizeValidationErrors']);
	
	  var iv = Object.assign({}, state.iv, newIv);
	  return _extends({}, state, { type: type, iv: iv, errors: errors });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _lodash = __webpack_require__(14);
	
	var _reduxHelper = __webpack_require__(30);
	
	var _formatHelper = __webpack_require__(35);
	
	var _roundHelper = __webpack_require__(816);
	
	var _index = __webpack_require__(41);
	
	var actions = _interopRequireWildcard(_index);
	
	var _constants = __webpack_require__(26);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var initialState = {
	  type: null,
	  mode: null,
	  currentTab: null,
	  multiStore: false,
	  currentStore: null,
	  orderNumber: null,
	  totalDp: constants.DECIMAL_POINTS_FOUR_DP,
	  totalRoundType: constants.ROUNDING_TYPE_NORMAL,
	  listingDp: constants.DECIMAL_POINTS_FOUR_DP,
	  listingRoundType: constants.ROUNDING_TYPE_NORMAL,
	  quantityDp: constants.QUANTITY_DECIMAL_POINTS_FOUR_DP,
	  order: {
	    lineItems: [],
	    totalItems: (0, _big2.default)(0),
	    subtotal: (0, _big2.default)(0),
	    tax: (0, _big2.default)(0),
	    taxError: (0, _big2.default)(0),
	    discountTotal: (0, _big2.default)(0),
	    serviceFee: (0, _big2.default)(0),
	    tips: (0, _big2.default)(0),
	    charge: (0, _big2.default)(0),
	    rounding: (0, _big2.default)(0),
	    total: (0, _big2.default)(0),
	    paidTotal: (0, _big2.default)(0),
	    refundTotal: (0, _big2.default)(0),
	    amountLefted: (0, _big2.default)(0),
	    roundingId: undefined,
	    saleTransactions: [],
	    refundTransactions: []
	  },
	  history: [],
	  isLoadingHistory: false,
	  deliveryOrders: []
	};
	
	function initLineItemNumber() {
	  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var ret = Object.assign({}, item);
	  ['quantity', 'unitQuantity', 'qtyFulfilled', 'qtyFulfilledInDisplayUnit', 'qtyRefunded', 'qtyRefundedInDisplayUnit', 'price', 'unitPrice', 'roundingAmount', 'total'].forEach(function (key) {
	    ret[key] = (0, _big2.default)(ret[key] || 0);
	  });
	  return ret;
	}
	
	function patchBaseUnit() {
	  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var unitGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var unitGroup = unitGroups[item.unitGroupId];
	  if (unitGroup) {
	    var allowedUnits = unitGroup.units.map(function (unitId) {
	      return units[unitId];
	    });
	    var itemBaseUnit = allowedUnits.find(function (unit) {
	      return unit.isBaseUnit;
	    });
	    // const itemDefaultUnit = allowedUnits.find(unit => unit.id === item.defaultOrderUnitId); // Design fault, don't use this now
	    var itemUnit = allowedUnits.find(function (unit) {
	      return unit.id === item.unitId;
	    }) || itemBaseUnit;
	    var baseUnitId = void 0,
	        baseUnit = void 0,
	        unitId = void 0,
	        unit = void 0,
	        unitRatio = void 0,
	        unitPrice = void 0,
	        displayUnitId = void 0;
	    if (itemBaseUnit) {
	      var id = itemBaseUnit.id,
	          name = itemBaseUnit.name,
	          ratio = itemBaseUnit.ratio;
	
	      baseUnitId = id;
	      baseUnit = name;
	      unitRatio = (0, _big2.default)(ratio);
	    }
	    if (itemUnit) {
	      var _id = itemUnit.id,
	          _name = itemUnit.name,
	          _ratio = itemUnit.ratio;
	
	      unitId = _id;
	      displayUnitId = _id;
	      unit = _name;
	      unitRatio = (0, _big2.default)(_ratio);
	      unitPrice = (0, _big2.default)(item.price).times(unitRatio);
	    }
	    return Object.assign({}, item, { baseUnitId: baseUnitId, baseUnit: baseUnit, unitId: unitId, displayUnitId: displayUnitId, unit: unit, unitRatio: unitRatio, unitPrice: unitPrice });
	  }
	  return item;
	}
	
	function calculateUnitPriceAndLineItemTotal(item, options) {
	  var listingDp = options.listingDp,
	      listingRoundType = options.listingRoundType,
	      quantityDp = options.quantityDp;
	  var price = item.price,
	      unitPrice = item.unitPrice,
	      unitRatio = item.unitRatio,
	      quantity = item.quantity,
	      unitQuantity = item.unitQuantity,
	      roundingAmount = item.roundingAmount,
	      total = item.total,
	      qtyFulfilled = item.qtyFulfilled,
	      qtyFulfilledInDisplayUnit = item.qtyFulfilledInDisplayUnit,
	      qtyRefunded = item.qtyRefunded,
	      qtyRefundedInDisplayUnit = item.qtyRefundedInDisplayUnit,
	      quantityAllowDecimal = item.quantityAllowDecimal,
	      discountEntries = item.discountEntries;
	
	  unitQuantity = (0, _roundHelper.roundAsBig)(unitQuantity || 0, quantityAllowDecimal ? quantityDp : 0);
	  quantity = (0, _roundHelper.roundAsBig)(unitQuantity.times(unitRatio || 1), quantityAllowDecimal ? quantityDp : 0);
	  unitPrice = (0, _roundHelper.roundAsBig)((0, _big2.default)(price || 0).times(unitRatio || 1));
	  total = (0, _roundHelper.roundAsBig)(unitQuantity.times(unitPrice), listingDp, listingRoundType);
	  var subtotal = (0, _roundHelper.roundAsBig)(unitQuantity.times(unitPrice), listingDp, listingRoundType);
	  if (discountEntries[0]) {
	    discountEntries[0].amount = discountEntries[0].discountAmount || total.times(discountEntries[0].discountPercentage).toFixed(4);
	    total = total.minus(discountEntries[0].amount);
	  }
	  roundingAmount = total.minus(quantity.times(price)), qtyFulfilledInDisplayUnit = (0, _roundHelper.roundAsBig)((0, _big2.default)(qtyFulfilledInDisplayUnit), quantityAllowDecimal ? quantityDp : 0);
	  qtyRefundedInDisplayUnit = (0, _roundHelper.roundAsBig)((0, _big2.default)(qtyRefunded).div(unitRatio || 1), quantityAllowDecimal ? quantityDp : 0);
	  return Object.assign({}, item, {
	    price: price,
	    unitPrice: unitPrice,
	    unitRatio: unitRatio,
	    quantity: quantity,
	    unitQuantity: unitQuantity,
	    roundingAmount: roundingAmount,
	    total: total,
	    subtotal: subtotal,
	    qtyFulfilled: qtyFulfilled,
	    qtyFulfilledInDisplayUnit: qtyFulfilledInDisplayUnit,
	    qtyRefunded: qtyRefunded,
	    qtyRefundedInDisplayUnit: qtyRefundedInDisplayUnit,
	    quantityAllowDecimal: quantityAllowDecimal
	  });
	}
	
	function calculateOrderTotal(state) {
	  var order = Object.assign({}, state.order);
	  var totalDp = state.totalDp,
	      totalRoundType = state.totalRoundType,
	      listingDp = state.listingDp,
	      listingRoundType = state.listingRoundType;
	
	  var totalItems = (order.lineItems || []).reduce(function (sum, item) {
	    return sum.add(item.unitId ? 1 : item.quantity);
	  }, (0, _big2.default)(0));
	  var subtotal = (order.lineItems || []).reduce(function (sum, item) {
	    return sum.add((0, _roundHelper.roundAsBig)(Number(item.subtotal), listingDp, listingRoundType));
	  }, (0, _big2.default)(0));
	  var discountTotal = (order.lineItems || []).reduce(function (sum, item) {
	    if (item.discountEntries[0]) {
	      sum = sum.add((0, _roundHelper.roundAsBig)(Number(item.discountEntries[0].amount)));
	    }
	    return sum;
	  }, (0, _big2.default)(0));
	  var taxError = (0, _big2.default)(order.initialIncludedInPriceTaxError || '0');
	  var tax = (0, _big2.default)(order.tax || '0');
	  var serviceFee = (0, _big2.default)(order.serviceFee || '0');
	  var bill = subtotal.add(tax).minus(discountTotal).add(serviceFee);
	  var tips = (0, _big2.default)(order.tips || '0');
	  var total = (0, _roundHelper.roundAsBig)(bill, totalDp, totalRoundType).add(tips).add(taxError);
	  var rounding = total.minus(bill).minus(tips).minus(taxError);
	  var paidTotal = (0, _big2.default)(order.paidTotal || '0'); // Already deduct refund total
	  var refundTotal = (0, _big2.default)(order.refundTotal || '0');
	  var amountLefted = total.minus(paidTotal);
	
	  order.totalItems = totalItems;
	  order.subtotal = subtotal;
	  order.tax = tax;
	  order.taxError = taxError;
	  order.discountTotal = discountTotal;
	  order.serviceFee = serviceFee;
	  order.tips = tips;
	  order.charge = bill;
	  order.rounding = rounding;
	  order.total = total;
	  order.paidTotal = paidTotal;
	  order.refundTotal = refundTotal;
	  order.amountLefted = amountLefted;
	  return Object.assign({}, state, { order: order });
	}
	
	function calculateAllFields(state) {
	  var order = Object.assign({}, state.order);
	  var lineItems = order.lineItems.map(function (item) {
	    return calculateUnitPriceAndLineItemTotal(item, state);
	  });
	  order.lineItems = lineItems;
	  var newState = Object.assign({}, state, { order: order });
	  return calculateOrderTotal(newState);
	}
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.INIT_INVOICE_STATE, function (state, _ref) {
	  var data = _ref.data;
	
	  return Object.assign({}, initialState, data);
	}), _defineProperty(_actionHandlers, actions.SET_INVOICE_STATE, function (state, _ref2) {
	  var data = _ref2.data;
	
	  return Object.assign({}, state, data);
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_TAB, function (state, _ref3) {
	  var data = _ref3.data;
	
	  return Object.assign({}, state, { currentTab: data });
	}), _defineProperty(_actionHandlers, actions.ADD_LISTINGS_TO_INVOICE, function (state, _ref4) {
	  var _ref4$data = _ref4.data,
	      data = _ref4$data === undefined ? [] : _ref4$data;
	  var _state$unitGroups = state.unitGroups,
	      unitGroups = _state$unitGroups === undefined ? {} : _state$unitGroups,
	      _state$units = state.units,
	      units = _state$units === undefined ? {} : _state$units;
	
	  var order = Object.assign({}, state.order);
	  var lineItems = (order.lineItems || []).slice(0);
	  var addingLineItems = Array.isArray(data) ? data : [data];
	  if (addingLineItems.length > 0) {
	    addingLineItems.forEach(function (item) {
	      var targetIdx = (0, _lodash.findIndex)(lineItems, function (lineItem) {
	        return lineItem.purchasableId === item.id;
	      });
	      if (targetIdx >= 0) {
	        var target = Object.assign({}, lineItems[targetIdx]);
	        target.unitQuantity = target.unitQuantity.add(1);
	        if (target.unitQuantity.lt(target.qtyFulfilledInDisplayUnit)) {
	          target.unitQuantity = (0, _big2.default)(target.qtyFulfilledInDisplayUnit);
	        }
	        target = calculateUnitPriceAndLineItemTotal(target, state);
	        lineItems[targetIdx] = target;
	      } else {
	        item.purchasableType = constants.PURCHASABLE_TYPE_LISTING;
	        item.purchasableId = item.id;
	        item.id = null;
	        item.label = item.name;
	        item.quantity = item.unitQuantity = 0;
	        item.unitPrice = item.price;
	        item.unitRatio = (0, _big2.default)(1);
	        item.discountEntries = [];
	        item.roundingAmount = (0, _big2.default)(0);
	        delete item.name;
	        item = patchBaseUnit(initLineItemNumber(item), unitGroups, units);
	        item.unitQuantity = (0, _big2.default)(1);
	        item = calculateUnitPriceAndLineItemTotal(item, state);
	        lineItems.push(item);
	      }
	    });
	    order.lineItems = lineItems;
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.REMOVE_LISTINGS_FROM_INVOICE, function (state, _ref5) {
	  var _ref5$data = _ref5.data,
	      data = _ref5$data === undefined ? [] : _ref5$data;
	
	  var order = Object.assign({}, state.order);
	  var lineItems = order.lineItems || [];
	  var newLineItems = lineItems.filter(function (item, i) {
	    return data.indexOf(i) < 0;
	  });
	  if (lineItems.length !== newLineItems) {
	    order.lineItems = newLineItems;
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_FIELD, function (state, _ref6) {
	  var _ref6$data = _ref6.data,
	      data = _ref6$data === undefined ? {} : _ref6$data;
	  var field = data.field,
	      value = data.value;
	
	  var order = Object.assign({}, state.order);
	  if (field) {
	    order[field] = value;
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_FIELDS, function (state, _ref7) {
	  var _ref7$data = _ref7.data,
	      data = _ref7$data === undefined ? {} : _ref7$data;
	
	  if (Object.keys(data).length > 0) {
	    var order = Object.assign({}, state.order);
	    for (var field in data) {
	      if (field === 'billingAddressInfo' || field === 'shippingAddressInfo') {
	        if (!order.billingAddressInfo && !order.shippingAddressInfo) {
	          order.billingAddressInfo = order.shippingAddressInfo = data[field];
	          order.billToId = order.shipToId = (data[field] || {}).id || null;
	        }
	        order[field] = data[field];
	        var b = order.billingAddressInfo || {};
	        var s = order.shippingAddressInfo || {};
	        order.customerId = b.id || s.id || null;
	        order.customerName = b.name || s.name || null;
	        order.customerPhone = b.phone || s.phone || null;
	        order.customerEmail = b.email || s.email || null;
	      }
	      order[field] = data[field];
	    }
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_LISTING_QUANTITY, function (state, _ref8) {
	  var _ref8$data = _ref8.data,
	      data = _ref8$data === undefined ? {} : _ref8$data;
	  var index = data.index,
	      value = data.value;
	
	  var order = Object.assign({}, state.order);
	  var lineItems = (order.lineItems || []).slice(0);
	  if (lineItems[index]) {
	    var item = Object.assign({}, lineItems[index]);
	    item.unitQuantity = (0, _big2.default)(value || 0);
	    if (item.unitQuantity.lt(item.qtyFulfilledInDisplayUnit)) {
	      item.unitQuantity = (0, _big2.default)(item.qtyFulfilledInDisplayUnit);
	    }
	    item = calculateUnitPriceAndLineItemTotal(item, state);
	    lineItems[index] = item;
	    order.lineItems = lineItems;
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_LISTING_UNIT, function (state, _ref9) {
	  var _ref9$data = _ref9.data,
	      data = _ref9$data === undefined ? {} : _ref9$data;
	  var index = data.index,
	      value = data.value;
	  var units = state.units;
	
	  var unit = units[value];
	  var order = Object.assign({}, state.order);
	  var lineItems = order.lineItems = (order.lineItems || []).slice(0);
	  if (unit && lineItems[index]) {
	    var item = Object.assign({}, lineItems[index]);
	    var unitId = unit.id,
	        unitName = unit.name,
	        unitRatio = unit.ratio;
	
	    item.unitRatio = (0, _big2.default)(unitRatio);
	    item.unitId = unitId;
	    item.displayUnitId = unitId;
	    item.unit = unitName;
	    item = calculateUnitPriceAndLineItemTotal(item, state);
	    lineItems[index] = item;
	    order.lineItems = lineItems;
	    return Object.assign({}, state, { order: order });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_DISCOUNT, function (state, _ref10) {
	  var _ref10$data = _ref10.data,
	      data = _ref10$data === undefined ? {} : _ref10$data;
	  var index = data.index,
	      discount = data.discount;
	
	  var order = state.order;
	  var lineItems = order.lineItems;
	  var item = lineItems[index];
	  if (!item) {
	    return state;
	  }
	  if (discount) {
	    var initDiscount = {};
	    initDiscount.discountId = discount.id;
	    initDiscount.discountAmount = discount.amount;
	    initDiscount.discountPercentage = discount.percentage;
	    item.discountEntries[0] = initDiscount;
	  } else {
	    item.discountEntries = [];
	  }
	  item = calculateUnitPriceAndLineItemTotal(item, state);
	  lineItems[index] = item;
	  order.lineItems = lineItems;
	  return Object.assign({}, state, { order: order });
	}), _defineProperty(_actionHandlers, actions.CHANGE_INVOICE_LISTING_UNIT_PRICE, function (state, _ref11) {
	  var _ref11$data = _ref11.data,
	      data = _ref11$data === undefined ? {} : _ref11$data;
	  var index = data.index,
	      value = data.value;
	
	  var order = Object.assign({}, state.order);
	  var lineItems = (order.lineItems || []).slice(0);
	  if (lineItems[index]) {
	    var item = Object.assign({}, lineItems[index]);
	    item.unitPrice = (0, _big2.default)(value || 0);
	    item.price = (0, _roundHelper.roundAsBig)((0, _big2.default)(item.unitPrice).div(item.unitRatio || 1), 2);
	    item = calculateUnitPriceAndLineItemTotal(item, state);
	    lineItems[index] = item;
	    order.lineItems = lineItems;
	    return calculateOrderTotal(Object.assign({}, state, { order: order }));
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.CALCULATE_INVOICE_ORDER_TOTAL, function (state) {
	  return calculateOrderTotal(state);
	}), _defineProperty(_actionHandlers, actions.LOAD_INVOICE_TO_FORM, function (state, _ref12) {
	  var _ref12$data = _ref12.data,
	      data = _ref12$data === undefined ? {} : _ref12$data;
	  var _state$currentStore = state.currentStore,
	      currentStore = _state$currentStore === undefined ? {} : _state$currentStore,
	      listingDp = state.listingDp,
	      listingRoundType = state.listingRoundType;
	  var timezone = currentStore.timezone;
	
	  var _Object$assign = Object.assign({}, data),
	      _Object$assign$listin = _Object$assign.listingLineItems,
	      listingLineItems = _Object$assign$listin === undefined ? [] : _Object$assign$listin,
	      roundingLineItem = _Object$assign.roundingLineItem,
	      subtotal = _Object$assign.subtotal,
	      initialTax = _Object$assign.initialTax,
	      discountTotal = _Object$assign.discountTotal,
	      initialServiceFee = _Object$assign.initialServiceFee,
	      initialTips = _Object$assign.initialTips,
	      initialRounding = _Object$assign.initialRounding,
	      initialTotal = _Object$assign.initialTotal,
	      paidTotal = _Object$assign.paidTotal,
	      amountLefted = _Object$assign.amountLefted,
	      _Object$assign$saleTr = _Object$assign.saleTransactions,
	      saleTransactions = _Object$assign$saleTr === undefined ? [] : _Object$assign$saleTr,
	      _Object$assign$refund = _Object$assign.refundTransactions,
	      refundTransactions = _Object$assign$refund === undefined ? [] : _Object$assign$refund,
	      order = _objectWithoutProperties(_Object$assign, ['listingLineItems', 'roundingLineItem', 'subtotal', 'initialTax', 'discountTotal', 'initialServiceFee', 'initialTips', 'initialRounding', 'initialTotal', 'paidTotal', 'amountLefted', 'saleTransactions', 'refundTransactions']);
	
	  order.effectiveCreatedAt = (0, _formatHelper.dateTz)(order.effectiveCreatedAt, timezone);
	  order.lineItems = listingLineItems.map(function (item) {
	    var ret = Object.assign({}, item);
	    ret.price = (0, _big2.default)(ret.price);
	    ret.quantity = (0, _big2.default)(ret.quantity);
	    ret.unitQuantity = (0, _big2.default)(ret.unitQuantity || ret.quantity); // Old data may have null
	    ret.roundingAmount = (0, _big2.default)(ret.roundingAmount);
	    ret.total = (0, _roundHelper.roundAsBig)((0, _big2.default)(ret.price).times(ret.quantity), listingDp, listingRoundType);
	    if (ret.discountEntries[0]) {
	      ret.total = ret.total.minus(ret.discountEntries[0].amount);
	    }
	    ret.qtyFulfilled = (0, _big2.default)(ret.qtyFulfilled);
	    ret.qtyFulfilledInDisplayUnit = (0, _big2.default)(ret.qtyFulfilledInDisplayUnit || ret.qtyFulfilled); // Old data may have null
	    ret.qtyRefunded = (0, _big2.default)(ret.qtyRefunded);
	    ret.qtyRefundedInDisplayUnit = (0, _big2.default)(ret.qtyRefundedInDisplayUnit || ret.qtyRefunded); // Old data may have null
	    // quantityAllowDecimal, unitRatio, unitPrice is not given by default
	    ret.quantityAllowDecimal = ret.quantityAllowDecimal == null ? true : ret.quantityAllowDecimal;
	    if (ret.unitId == null || ret.unitQuantity.eq(0)) {
	      ret.unitRatio = (0, _big2.default)(1);
	      ret.unitPrice = ret.price;
	    } else {
	      ret.unitRatio = (0, _big2.default)(ret.quantity).div(ret.unitQuantity);
	      ret.unitPrice = ret.price.times(ret.unitRatio);
	    }
	    return ret;
	  }).sort(function (a, b) {
	    var aCode = a.lineItemCode;
	    var bCode = b.lineItemCode;
	    return aCode === bCode ? 0 : aCode > bCode ? 1 : -1;
	  });
	  order.subtotal = subtotal || 0;
	  order.tax = initialTax || 0;
	  order.discountTotal = discountTotal || 0;
	  order.serviceFee = initialServiceFee || 0;
	  order.tips = initialTips || 0;
	  order.roundingId = (roundingLineItem || {}).id;
	  order.rounding = initialRounding || 0;
	  order.total = initialTotal || 0;
	  order.paidTotal = paidTotal || 0;
	  order.amountLefted = amountLefted || 0;
	  order.saleTransactions = saleTransactions.map(function (t) {
	    t.amount = (0, _big2.default)(t.amount || 0);
	    t.changeAmount = (0, _big2.default)(t.changeAmount || 0);
	    t.actualPaymentAmount = (0, _big2.default)(t.actualPaymentAmount || 0);
	    t.amountLefted = (0, _big2.default)(t.amountLefted || 0);
	    return t;
	  });
	  order.refundTransactions = refundTransactions.map(function (t) {
	    t.amount = (0, _big2.default)(t.amount || 0);
	    t.changeAmount = (0, _big2.default)(t.changeAmount || 0);
	    t.actualPaymentAmount = (0, _big2.default)(t.actualPaymentAmount || 0);
	    t.amountLefted = (0, _big2.default)(t.amountLefted || 0);
	    return t;
	  });
	  var newState = Object.assign({}, state, { order: order });
	  return calculateOrderTotal(newState);
	}), _defineProperty(_actionHandlers, actions.PATCH_INVOICE_LISTING_MISSING_INFO, function (state, _ref13) {
	  var _ref13$data = _ref13.data,
	      data = _ref13$data === undefined ? [] : _ref13$data;
	
	  var order = Object.assign({}, state.order);
	  var lineItems = (order.lineItems || []).map(function (item) {
	    var ret = Object.assign({}, item);
	    var match = data.find(function (i) {
	      return i.id === item.purchasableId;
	    });
	    if (match) {
	      ret.description = match.description;
	      ret.upc = match.upc || match.upc_e;
	      ret.ean13 = match.ean13;
	      ret.listingBarcode = match.listingBarcode;
	      ret.unitGroupId = match.unitGroupId;
	      ret.defaultOrderUnitId = match.defaultOrderUnitId;
	      ret.quantityAllowDecimal = match.quantityAllowDecimal;
	      return ret;
	    } else {
	      return item;
	    }
	  });
	  order.lineItems = lineItems;
	  return Object.assign({}, state, { order: order });
	}), _defineProperty(_actionHandlers, actions.PATCH_INVOICE_LISTING_UNIT_GROUP, function (state, _ref14) {
	  var _ref14$data = _ref14.data,
	      data = _ref14$data === undefined ? {} : _ref14$data;
	  var _data$unitGroups = data.unitGroups,
	      unitGroups = _data$unitGroups === undefined ? {} : _data$unitGroups,
	      _data$units = data.units,
	      units = _data$units === undefined ? {} : _data$units;
	
	  var newState = Object.assign({}, state);
	  newState.unitGroups = Object.assign({}, state.unitGroups, unitGroups);
	  newState.units = Object.assign({}, state.units, units);
	  var order = Object.assign({}, state.order);
	  order.lineItems = order.lineItems.map(function (item) {
	    return patchBaseUnit(item, newState.unitGroups, newState.units);
	  });
	  newState.order = order;
	  return calculateAllFields(newState);
	}), _defineProperty(_actionHandlers, actions.LOAD_INVOICE_HISTORY_REQUEST, function (state) {
	  return _extends({}, state, { isLoadingHistory: true });
	}), _defineProperty(_actionHandlers, actions.LOAD_INVOICE_HISTORY_SUCCESS, function (state, _ref15) {
	  var _ref15$data = _ref15.data,
	      data = _ref15$data === undefined ? [] : _ref15$data;
	
	  return _extends({}, state, { history: data, isLoadingHistory: false });
	}), _defineProperty(_actionHandlers, actions.LOAD_INVOICE_HISTORY_FAILURE, function (state) {
	  return _extends({}, state, { isLoadingHistory: false });
	}), _defineProperty(_actionHandlers, actions.LOAD_INVOICE_DELIVERY_ORDER_SUCCESS, function (state, _ref16) {
	  var _ref16$payload = _ref16.payload,
	      payload = _ref16$payload === undefined ? {} : _ref16$payload;
	  var _payload$deliveryOrde = payload.deliveryOrders,
	      deliveryOrders = _payload$deliveryOrde === undefined ? [] : _payload$deliveryOrde;
	
	  return _extends({}, state, { deliveryOrders: deliveryOrders });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = entityReducer;
	
	var _forEach = __webpack_require__(139);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _kdsActions = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  stations: null
	};
	
	function entityReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _kdsActions.SET_STATIONS:
	      {
	        state.stations = state.stations || {};
	        var newStations = {};
	
	        (0, _forEach2.default)(action.data.stations, function (station) {
	          var key = station.id;
	
	          newStations[key] = Object.assign({}, state.stations[key], station);
	        });
	
	        return Object.assign({}, state, { stations: newStations });
	      }
	
	    case _kdsActions.UPDATE_STATION:
	      {
	        var id = action.id,
	            data = action.data;
	
	        var targetStation = state.stations[id];
	
	        if (targetStation) {
	          var newStation = Object.assign({}, targetStation, data);
	          var _newStations = Object.assign({}, state.stations, _defineProperty({}, id, newStation));
	
	          return Object.assign({}, state, { stations: _newStations });
	        } else {
	          return state;
	        }
	      }
	
	    case _kdsActions.REMOVE_STATION:
	      {
	        var _id = action.id;
	        var stations = state.stations;
	
	        if (stations.hasOwnProperty(_id)) delete stations[_id];
	        return Object.assign({}, state, { stations: stations });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = kdsStatusReducer;
	
	var _kdsActions = __webpack_require__(182);
	
	var initialState = {
	  page: 1,
	  count: 25,
	  totalCount: 0,
	  totalPages: 1,
	  filters: [],
	  loading: false
	};
	
	function kdsStatusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _kdsActions.SET_STATIONS_STATUS:
	      return Object.assign({}, state, action.data);
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listingsReducer = listingsReducer;
	
	var _without = __webpack_require__(398);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _unionBy = __webpack_require__(397);
	
	var _unionBy2 = _interopRequireDefault(_unionBy);
	
	var _inventoryActions = __webpack_require__(105);
	
	var _storeActions = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	function listingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // LIST
	    case _inventoryActions.SET_LISTINGS:
	      return action.data;
	
	    case _inventoryActions.REMOVE_LISTING:
	      return (0, _without2.default)(action.data, action.id);
	
	    // ITEM
	    case _inventoryActions.SET_LISTING:
	      return (0, _unionBy2.default)(state, [action.data], 'id');
	
	    case _storeActions.SWITCH_STORE:
	      return [];
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = listingStatusReducer;
	
	var _inventoryActions = __webpack_require__(105);
	
	var initialState = {
	  page: 1,
	  count: 25,
	  totalCount: 0,
	  totalPages: 1,
	  filters: [],
	  loading: false
	};
	
	function listingStatusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _inventoryActions.SET_LISTINGS_STATUS:
	      return Object.assign({}, state, action.data);
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(5);
	
	var _productionOrderIndex = __webpack_require__(1006);
	
	var _productionOrderIndex2 = _interopRequireDefault(_productionOrderIndex);
	
	var _inventoryVarianceIndex = __webpack_require__(1005);
	
	var _inventoryVarianceIndex2 = _interopRequireDefault(_inventoryVarianceIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formsReducer = (0, _redux.combineReducers)({
	  productionOrderIndex: _productionOrderIndex2.default,
	  inventoryVarianceIndex: _inventoryVarianceIndex2.default
	});
	
	exports.default = formsReducer;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _inventoryVarianceIndex = __webpack_require__(465);
	
	var _reduxHelper = __webpack_require__(30);
	
	var _constants = __webpack_require__(26);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TYPE = _constants.INVENTORY_VARIANCE.TYPE;
	
	
	var initialState = {
	  isLoading: true,
	  totalEntries: 0,
	  currentPage: 1,
	  rowsPerPage: 25,
	  totalPages: 1,
	  filters: [],
	  storeId: 0,
	  data: [],
	  type: TYPE.OPENING
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_REQUEST, function (state, action) {
	  var storeId = action.storeId;
	
	  return _extends({}, state, { storeId: storeId, isLoading: true });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_SUCCESS, function (state, action) {
	  return _extends({}, state, action, { isLoading: false });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.LOAD_INVENTORY_VARIANCE_INDEX_FAILURE, function (state) {
	  return _extends({}, state, { isLoading: false });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_ROWS_PER_PAGE, function (state, action) {
	  return _extends({}, state, { rowsPerPage: action.value });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_PAGE_NUMBER, function (state, action) {
	  return _extends({}, state, { currentPage: action.value });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.CHANGE_INVENTORY_VARIANCE_INDEX_FILTERS, function (state, action) {
	  return _extends({}, state, { filters: action.filters });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.CHANGE_INVENTORY_VARIANCE_TYPE, function (state, action) {
	  state.modification = state.modification + 1;
	  return Object.assign({}, state, { type: action.ivType });
	}), _defineProperty(_actionHandlers, _inventoryVarianceIndex.actionTypes.CLEAR_IV_TYPE, function (state, action) {
	  var type = action.initType;
	  return Object.assign({}, state, { type: type });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _productionOrderIndex = __webpack_require__(466);
	
	var _reduxHelper = __webpack_require__(30);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  isLoading: true,
	  totalEntries: 0,
	  currentPage: 1,
	  rowsPerPage: 25,
	  totalPages: 1,
	  filters: [],
	  storeId: 0,
	  data: []
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.LOAD_PRODUCTION_ORDER_INDEX_REQUEST, function (state, action) {
	  var storeId = action.storeId;
	
	  return _extends({}, state, { storeId: storeId, isLoading: true });
	}), _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.LOAD_PRODUCTION_ORDER_INDEX_SUCCESS, function (state, action) {
	  return _extends({}, state, action, { isLoading: false });
	}), _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.LOAD_PRODUCTION_ORDER_INDEX_FAILURE, function (state) {
	  return _extends({}, state, { isLoading: false });
	}), _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_ROWS_PER_PAGE, function (state, action) {
	  return _extends({}, state, { rowsPerPage: action.value });
	}), _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_PAGE_NUMBER, function (state, action) {
	  return _extends({}, state, { currentPage: action.value });
	}), _defineProperty(_actionHandlers, _productionOrderIndex.actionTypes.CHANGE_PRODUCTION_ORDER_INDEX_FILTERS, function (state, action) {
	  return _extends({}, state, { filters: action.filters });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pathReducer;
	
	var _baseActions = __webpack_require__(34);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {};
	
	function pathReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _baseActions.SET_PATH_STATE:
	      {
	        var currentState = void 0;
	        try {
	          currentState = state[action.path][action.stateName];
	        } catch (e) {
	          console.warn('state', action.path, action.stateName, 'not exist yet, set to null.');
	          currentState = null;
	        }
	
	        var newState = _defineProperty({}, action.path, Object.assign({}, state[action.path], _defineProperty({}, action.stateName, action.callback ? action.callback(currentState, action.result) : action.result)));
	        if (action.meta) {
	          newState[action.path][action.stateName + '_meta'] = action.meta;
	        }
	
	        return Object.assign({}, state, newState);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxHelper = __webpack_require__(30);
	
	var _promoCodeActions = __webpack_require__(152);
	
	var actionTypes = _interopRequireWildcard(_promoCodeActions);
	
	var _constants = __webpack_require__(26);
	
	var _promoCodeHelper = __webpack_require__(479);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MODE = _constants.PROMO_CODE.MODE,
	    TAB = _constants.PROMO_CODE.TAB;
	
	
	var initialState = {
	  mode: MODE.VIEW,
	  storeId: null,
	  promoCodeId: null,
	  tab: TAB.OVERVIEW,
	  coupon: (0, _promoCodeHelper.transformPromoCode)(),
	  promoCodes: [],
	  errMsg: null
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actionTypes.MODE_CHANGE, function (state, _ref) {
	  var payload = _ref.payload;
	  return _extends({}, state, { promoCodes: [], coupon: {} }, payload);
	}), _defineProperty(_actionHandlers, actionTypes.UPDATE_PROMO_CODE_ITEM_FIELD, function (state, _ref2) {
	  var _ref2$payload = _ref2.payload,
	      payload = _ref2$payload === undefined ? {} : _ref2$payload;
	  var field = payload.field,
	      value = payload.value;
	
	  if (field) {
	    var coupon = _extends({}, state.coupon);
	    coupon[field] = value;
	    return _extends({}, state, { coupon: coupon });
	  }
	  return state;
	}), _defineProperty(_actionHandlers, actionTypes.LOAD_PROMO_CODE_LIST_SUCCESS, function (state, _ref3) {
	  var payload = _ref3.payload;
	  return _extends({}, state, payload);
	}), _defineProperty(_actionHandlers, actionTypes.LOAD_PROMO_CODE_ITEM_SUCCESS, function (state, _ref4) {
	  var promoCode = _ref4.promoCode;
	  return _extends({}, state, { coupon: (0, _promoCodeHelper.transformPromoCode)(promoCode)
	  });
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = savedFiltersReducer;
	
	var _merge = __webpack_require__(287);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _savedFiltersActions = __webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function savedFiltersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var newState = void 0;
	  switch (action.type) {
	    case _savedFiltersActions.SAVE_FILTER:
	      newState = (0, _merge2.default)({}, state, action.data);
	      return newState;
	
	    case _savedFiltersActions.REMOVE_SAVED_FILTER:
	      delete state[action.data.group][action.data.name];
	      newState = Object.assign({}, state);
	      return newState;
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = storeReducer;
	
	var _unionBy = __webpack_require__(397);
	
	var _unionBy2 = _interopRequireDefault(_unionBy);
	
	var _find = __webpack_require__(98);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _map = __webpack_require__(24);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(287);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _storeActions = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	function storeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _storeActions.SET_STORES:
	      {
	        var mergedStore = (0, _map2.default)(state, function (store) {
	          var matchedStore = (0, _find2.default)(action.stores, { id: store.id });
	          if (matchedStore) {
	            Object.assign(store, matchedStore);
	          }
	          return store;
	        });
	
	        return (0, _unionBy2.default)(mergedStore, action.stores, 'id');
	      }
	
	    case _storeActions.UPDATE_STORE:
	      {
	        var targetStore = (0, _find2.default)(state, { id: action.id });
	        if (targetStore) {
	          (0, _merge2.default)(targetStore, action.data);
	        } else {
	          state.push(Object.assign(action.data, { id: action.id }));
	        }
	
	        return state.slice();
	      }
	
	    case _storeActions.CLEAR_STORE:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = storeSuppliersReducer;
	
	var _supplierActions = __webpack_require__(468);
	
	var _merge = __webpack_require__(287);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function storeSuppliersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _supplierActions.SET_SUPPLIERS:
	      {
	        var newState = (0, _merge2.default)({}, state);
	        newState[action.data.storeId] = action.data.supplierIds;
	        return newState;
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionHandlers;
	
	var _big = __webpack_require__(43);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _reduxHelper = __webpack_require__(30);
	
	var _tableActions = __webpack_require__(469);
	
	var actions = _interopRequireWildcard(_tableActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  storeId: null,
	  defaultTableTurnTime: null
	};
	
	var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, actions.INIT_SETTINGS_BUSINESS_TABLE, function (state, _ref) {
	  var data = _ref.data;
	
	  var _ref2 = data || {},
	      storeId = _ref2.storeId;
	
	  if (storeId) {
	    return Object.assign({}, state, { storeId: storeId });
	  } else {
	    return state;
	  }
	}), _defineProperty(_actionHandlers, actions.UPDATE_SETTINGS_BUSINESS_TABLE_FIELD, function (state, _ref3) {
	  var data = _ref3.data;
	
	  var _ref4 = data || {},
	      field = _ref4.field,
	      value = _ref4.value;
	
	  if (field) {
	    var v = value;
	    var numberFields = ['defaultTableTurnTime'];
	    if (numberFields.indexOf(field) >= 0 && v != null) {
	      v = (0, _big2.default)(v);
	    }
	    return Object.assign({}, state, _defineProperty({}, field, v));
	  } else {
	    return state;
	  }
	}), _actionHandlers);
	
	exports.default = (0, _reduxHelper.createReducer)(initialState, actionHandlers);

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = userReducer;
	
	var _userActions = __webpack_require__(470);
	
	var initialState = null;
	
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _userActions.LOGIN_SUCCESS:
	      return action.user;
	
	    case _userActions.LOGIN_FAILURE:
	      return null;
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _voucherActions = __webpack_require__(59);
	
	var initialState = {
	  criteria: {
	    totalCount: 0,
	    totalPages: 0,
	    page: 0,
	    perPage: 25
	  },
	  currentCoupons: [],
	  fetchingData: true
	};
	
	function voucherCouponReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case _voucherActions.SET_VOUCHER_COUPONS:
	      return Object.assign({}, state, action.data, { fetchingData: false });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = voucherCouponReducer;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = voucherReducer;
	
	var _voucherActions = __webpack_require__(59);
	
	var _remove = __webpack_require__(394);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _values = __webpack_require__(99);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  criteria: {
	    totalCount: 0,
	    totalPages: 0,
	    page: 0,
	    count: 25,
	    filters: []
	  },
	  currentVouchers: [],
	  products: [],
	  fetchingData: true
	};
	
	function voucherReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	
	  switch (action.type) {
	
	    // VOUCHERS
	    case _voucherActions.SET_VOUCHERS:
	      return Object.assign({}, state, action.data, { fetchingData: false });
	
	    case _voucherActions.REMOVE_ASSOCIATED_PRODUCTS:
	      state.products = (0, _remove2.default)((0, _values2.default)(state.products), function (p) {
	        return p.product_id !== action.id;
	      });
	      return Object.assign({}, state);
	
	    case _voucherActions.SET_ASSOCIATED_PRODUCTS:
	
	      return Object.assign({}, state, action.data, { fetchingData: false });
	
	    case _voucherActions.REMOVE_VOUCHER:
	
	      (0, _remove2.default)(state.currentVouchers, function (id) {
	        return Number(id) === Number(action.id);
	      });
	
	      state.criteria.totalCount -= 1;
	      state.criteria.totalPages = Math.ceil(state.criteria.totalCount / state.criteria.count);
	
	      return Object.assign({}, state);
	
	    // VOUCHER'S FILTER
	    case _voucherActions.SET_VOUCHERS_FILTERS:
	      return Object.assign({}, state, {
	        criteria: _extends({}, state.criteria, {
	          filters: action.data.slice()
	        })
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var upcE = __webpack_require__(1017);
	
	module.exports = function (code, upce) {
	  var retval = {
	    format: null,
	    real: null,
	    valid: false,
	    expanded: null
	
	    // Input must be a number or a string.
	  };if (typeof code === 'number') code = String(code);
	  if (typeof code !== 'string') return retval;
	
	  // String must have all digits.
	  if (!/^\d+$/.test(code)) return retval;
	
	  // Stting must have lengtsh of either 8, 12, 13, or 14.
	  var digits = code.split('');
	  switch (digits.length) {
	    case 8:
	      if (upce) {
	        retval.format = 'UPC-E';
	        retval.real = 'UPC-E';
	      } else {
	        retval.format = 'GTIN-8';
	        retval.real = 'GTIN-8';
	      }
	      break;
	    case 12:
	      retval.format = 'GTIN-12';
	      break;
	    case 13:
	      retval.format = 'GTIN-13';
	      break;
	    case 14:
	      retval.format = 'GTIN-14';
	      break;
	    default:
	      return retval;
	  }
	
	  if (retval.format === 'UPC-E') {
	    return processUPCE(digits, retval);
	  }
	
	  if (retval.format !== 'GTIN-8') {
	    retval.real = determineReal(digits, retval.format);
	  }
	
	  padDigits(digits);
	  retval.valid = validateChecksum(digits);
	
	  return retval;
	};
	
	function processUPCE(digits, retval) {
	  var validUPCE = upcE.validate(digits);
	  retval.expanded = upcE.expand(digits);
	  if (!validUPCE) return retval;
	
	  // Now, validate the UPC-A checksum.
	  var expandedDigits = retval.expanded.split('');
	  padDigits(expandedDigits);
	  retval.valid = validateChecksum(expandedDigits);
	  return retval;
	}
	
	function determineReal(digits, format) {
	  var code = digits.join('');
	  if (/^0{1,6}\d{8}$/.test(code)) return 'GTIN-8';
	  if (/^0{1,2}\d{12}$/.test(code)) return 'GTIN-12';
	  if (/^0{1}\d{13}$/.test(code)) return 'GTIN-13';
	  return format;
	}
	
	function padDigits(digits) {
	  var zeroes = 14 - digits.length;
	  for (var i = 0; i < zeroes; i++) {
	    digits.unshift('0');
	  }
	}
	
	function validateChecksum(digits) {
	  var check = digits.pop();
	  var newNumbers = digits.map(function (num, idx) {
	    return num * (idx % 2 === 0 ? 3 : 1);
	  });
	  var sum = newNumbers.reduce(function (prev, cur) {
	    return prev + cur;
	  });
	  return check === String((10 - sum % 10) % 10);
	}

/***/ },
/* 1017 */
/***/ function(module, exports) {

	'use strict';
	
	exports.validate = function (_digits) {
	  // Clone tha array for our use.
	  var digits = _digits.slice(0);
	
	  var numberSystem = digits.shift();
	  // Pop the check digit. We won't be using it.
	  digits.pop();
	
	  // UPC-E needs to use the 0 or 1 number system.
	  if (numberSystem !== '0' && numberSystem !== '1') return false;
	  // We can expand this number.
	  return true;
	};
	
	exports.expand = function (digits) {
	  var numberSystem = digits.shift();
	  var checkDigit = digits.pop();
	  var lastDigit = +digits.pop();
	  var expanded;
	
	  switch (lastDigit) {
	    case 0:
	    case 1:
	    case 2:
	      expanded = digits.slice(0, 2).join('') + lastDigit + '0000' + digits.slice(2, 5).join('');
	      break;
	    case 3:
	    case 4:
	      expanded = digits.slice(0, lastDigit).join('') + '00000' + digits.slice(lastDigit, 5).join('');
	      break;
	    case 5:
	    case 6:
	    case 7:
	    case 8:
	    case 9:
	      expanded = digits.join('') + '0000' + lastDigit;
	      break;
	  }
	
	  return numberSystem + expanded + checkDigit;
	};

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1220);
	
	__webpack_require__(1019);
	
	__webpack_require__(1022);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1019 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1020 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1021 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1028);
	module.exports = __webpack_require__(68).RegExp.escape;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var isArray = __webpack_require__(244);
	var SPECIES = __webpack_require__(22)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(16);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(80);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(127);
	var gOPS = __webpack_require__(248);
	var pIE = __webpack_require__(193);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1027 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3);
	var $re = __webpack_require__(1027)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(500) });
	
	__webpack_require__(110)('copyWithin');


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $every = __webpack_require__(77)(4);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { fill: __webpack_require__(329) });
	
	__webpack_require__(110)('fill');


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $filter = __webpack_require__(77)(2);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(77)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(110)(KEY);


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(77)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(110)(KEY);


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $forEach = __webpack_require__(77)(0);
	var STRICT = __webpack_require__(70)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(69);
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var call = __webpack_require__(511);
	var isArrayIter = __webpack_require__(337);
	var toLength = __webpack_require__(23);
	var createProperty = __webpack_require__(331);
	var getIterFn = __webpack_require__(353);
	
	$export($export.S + $export.F * !__webpack_require__(246)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $indexOf = __webpack_require__(241)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(70)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(244) });


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(63);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(192) != Object || !__webpack_require__(70)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(63);
	var toInteger = __webpack_require__(71);
	var toLength = __webpack_require__(23);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(70)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $map = __webpack_require__(77)(1);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var createProperty = __webpack_require__(331);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(16)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(502);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(502);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var html = __webpack_require__(335);
	var cof = __webpack_require__(67);
	var toAbsoluteIndex = __webpack_require__(131);
	var toLength = __webpack_require__(23);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(16)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $some = __webpack_require__(77)(3);
	
	$export($export.P + $export.F * !__webpack_require__(70)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(36);
	var fails = __webpack_require__(16);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(70)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(130)('Array');


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3);
	var toISOString = __webpack_require__(1024);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var toPrimitive = __webpack_require__(80);
	
	$export($export.P + $export.F * __webpack_require__(16)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(22)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(53)(proto, TO_PRIMITIVE, __webpack_require__(1025));


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(54)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', { bind: __webpack_require__(503) });


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(62);
	var HAS_INSTANCE = __webpack_require__(22)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(28).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(27) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3);
	var log1p = __webpack_require__(514);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3);
	var sign = __webpack_require__(341);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3);
	var $expm1 = __webpack_require__(340);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { fround: __webpack_require__(513) });


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(16)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(514) });


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { sign: __webpack_require__(341) });


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(340);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(16)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(340);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var has = __webpack_require__(60);
	var cof = __webpack_require__(67);
	var inheritIfRequired = __webpack_require__(336);
	var toPrimitive = __webpack_require__(80);
	var fails = __webpack_require__(16);
	var gOPN = __webpack_require__(126).f;
	var gOPD = __webpack_require__(61).f;
	var dP = __webpack_require__(28).f;
	var $trim = __webpack_require__(159).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(125)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(27) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(54)(global, NUMBER, $Number);
	}


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(3);
	var _isFinite = __webpack_require__(15).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(510) });


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3);
	var isInteger = __webpack_require__(510);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(522);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(523);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toInteger = __webpack_require__(71);
	var aNumberValue = __webpack_require__(499);
	var repeat = __webpack_require__(348);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(16)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $fails = __webpack_require__(16);
	var aNumberValue = __webpack_require__(499);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(516) });


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(125) });


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperties: __webpack_require__(517) });


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(112).onFreeze;
	
	__webpack_require__(79)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(63);
	var $getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	__webpack_require__(79)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(79)('getOwnPropertyNames', function () {
	  return __webpack_require__(518).f;
	});


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(36);
	var $getPrototypeOf = __webpack_require__(62);
	
	__webpack_require__(79)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(79)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(79)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(79)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { is: __webpack_require__(526) });


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(36);
	var $keys = __webpack_require__(127);
	
	__webpack_require__(79)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(112).onFreeze;
	
	__webpack_require__(79)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(112).onFreeze;
	
	__webpack_require__(79)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(345).set });


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(156);
	var test = {};
	test[__webpack_require__(22)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(54)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(522);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(523);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(111);
	var global = __webpack_require__(15);
	var ctx = __webpack_require__(69);
	var classof = __webpack_require__(156);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(18);
	var aFunction = __webpack_require__(49);
	var anInstance = __webpack_require__(123);
	var forOf = __webpack_require__(124);
	var speciesConstructor = __webpack_require__(194);
	var task = __webpack_require__(350).set;
	var microtask = __webpack_require__(342)();
	var newPromiseCapabilityModule = __webpack_require__(343);
	var perform = __webpack_require__(524);
	var userAgent = __webpack_require__(255);
	var promiseResolve = __webpack_require__(525);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(22)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(129)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(158)($Promise, PROMISE);
	__webpack_require__(130)(PROMISE);
	Wrapper = __webpack_require__(68)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(246)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(49);
	var anObject = __webpack_require__(11);
	var rApply = (__webpack_require__(15).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(16)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3);
	var create = __webpack_require__(125);
	var aFunction = __webpack_require__(49);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(16);
	var bind = __webpack_require__(503);
	var rConstruct = (__webpack_require__(15).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(28);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(80);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(16)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3);
	var gOPD = __webpack_require__(61).f;
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(338)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(61);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3);
	var getProto = __webpack_require__(62);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(62);
	var has = __webpack_require__(60);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(11);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(521) });


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3);
	var setProto = __webpack_require__(345);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(28);
	var gOPD = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(62);
	var has = __webpack_require__(60);
	var $export = __webpack_require__(3);
	var createDesc = __webpack_require__(128);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var inheritIfRequired = __webpack_require__(336);
	var dP = __webpack_require__(28).f;
	var gOPN = __webpack_require__(126).f;
	var isRegExp = __webpack_require__(245);
	var $flags = __webpack_require__(191);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(27) && (!CORRECT_NEW || __webpack_require__(16)(function () {
	  re2[__webpack_require__(22)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(54)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(130)('RegExp');


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(23);
	var advanceStringIndex = __webpack_require__(328);
	var regExpExec = __webpack_require__(249);
	
	// @@match logic
	__webpack_require__(243)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toObject = __webpack_require__(36);
	var toLength = __webpack_require__(23);
	var toInteger = __webpack_require__(71);
	var advanceStringIndex = __webpack_require__(328);
	var regExpExec = __webpack_require__(249);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(243)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return ch;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return ch;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return ch;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var sameValue = __webpack_require__(526);
	var regExpExec = __webpack_require__(249);
	
	// @@search logic
	__webpack_require__(243)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(245);
	var anObject = __webpack_require__(11);
	var speciesConstructor = __webpack_require__(194);
	var advanceStringIndex = __webpack_require__(328);
	var toLength = __webpack_require__(23);
	var callRegExpExec = __webpack_require__(249);
	var regexpExec = __webpack_require__(344);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	
	// eslint-disable-next-line no-empty
	var SUPPORTS_Y = !!(function () { try { return new RegExp('x', 'y'); } catch (e) {} })();
	
	// @@split logic
	__webpack_require__(243)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                    (rx.multiline ? 'm' : '') +
	                    (rx.unicode ? 'u' : '') +
	                    (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? 0xffffffff : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(532);
	var anObject = __webpack_require__(11);
	var $flags = __webpack_require__(191);
	var DESCRIPTORS = __webpack_require__(27);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(54)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(16)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(55)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(55)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(55)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(55)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(253)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(23);
	var context = __webpack_require__(347);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(334)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(55)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(55)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(55)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(131);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3);
	var context = __webpack_require__(347);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(334)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(55)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(253)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(339)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(55)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(63);
	var toLength = __webpack_require__(23);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(348)
	});


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(55)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(23);
	var context = __webpack_require__(347);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(334)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(55)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(55)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(55)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(159)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(15);
	var has = __webpack_require__(60);
	var DESCRIPTORS = __webpack_require__(27);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(54);
	var META = __webpack_require__(112).KEY;
	var $fails = __webpack_require__(16);
	var shared = __webpack_require__(252);
	var setToStringTag = __webpack_require__(158);
	var uid = __webpack_require__(132);
	var wks = __webpack_require__(22);
	var wksExt = __webpack_require__(529);
	var wksDefine = __webpack_require__(352);
	var enumKeys = __webpack_require__(1026);
	var isArray = __webpack_require__(244);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var toIObject = __webpack_require__(63);
	var toPrimitive = __webpack_require__(80);
	var createDesc = __webpack_require__(128);
	var _create = __webpack_require__(125);
	var gOPNExt = __webpack_require__(518);
	var $GOPD = __webpack_require__(61);
	var $DP = __webpack_require__(28);
	var $keys = __webpack_require__(127);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(126).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(193).f = $propertyIsEnumerable;
	  __webpack_require__(248).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(111)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(53)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $typed = __webpack_require__(254);
	var buffer = __webpack_require__(351);
	var anObject = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(131);
	var toLength = __webpack_require__(23);
	var isObject = __webpack_require__(18);
	var ArrayBuffer = __webpack_require__(15).ArrayBuffer;
	var speciesConstructor = __webpack_require__(194);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(16)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(130)(ARRAY_BUFFER);


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(254).ABV, {
	  DataView: __webpack_require__(351).DataView
	});


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(506);
	var validate = __webpack_require__(160);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(242)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(507);
	var toObject = __webpack_require__(36);
	var toLength = __webpack_require__(23);
	var aFunction = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(330);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(110)('flatMap');


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(507);
	var toObject = __webpack_require__(36);
	var toLength = __webpack_require__(23);
	var toInteger = __webpack_require__(71);
	var arraySpeciesCreate = __webpack_require__(330);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(110)('flatten');


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3);
	var $includes = __webpack_require__(241)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(110)('includes');


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3);
	var microtask = __webpack_require__(342)();
	var process = __webpack_require__(15).process;
	var isNode = __webpack_require__(67)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3);
	var cof = __webpack_require__(67);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.G, { global: __webpack_require__(15) });


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(250)('Map');


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(251)('Map');


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(505)('Map') });


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var scale = __webpack_require__(515);
	var fround = __webpack_require__(513);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { scale: __webpack_require__(515) });


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(28);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(247), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(28);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(247), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $entries = __webpack_require__(520)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3);
	var ownKeys = __webpack_require__(521);
	var toIObject = __webpack_require__(63);
	var gOPD = __webpack_require__(61);
	var createProperty = __webpack_require__(331);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var toPrimitive = __webpack_require__(80);
	var getPrototypeOf = __webpack_require__(62);
	var getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(247), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(36);
	var toPrimitive = __webpack_require__(80);
	var getPrototypeOf = __webpack_require__(62);
	var getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(247), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $values = __webpack_require__(520)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3);
	var global = __webpack_require__(15);
	var core = __webpack_require__(68);
	var microtask = __webpack_require__(342)();
	var OBSERVABLE = __webpack_require__(22)('observable');
	var aFunction = __webpack_require__(49);
	var anObject = __webpack_require__(11);
	var anInstance = __webpack_require__(123);
	var redefineAll = __webpack_require__(129);
	var hide = __webpack_require__(53);
	var forOf = __webpack_require__(124);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(130)('Observable');


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(3);
	var core = __webpack_require__(68);
	var global = __webpack_require__(15);
	var speciesConstructor = __webpack_require__(194);
	var promiseResolve = __webpack_require__(525);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(3);
	var newPromiseCapability = __webpack_require__(343);
	var perform = __webpack_require__(524);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(533);
	var from = __webpack_require__(501);
	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(62);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(62);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(62);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(95);
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(49);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(250)('Set');


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(251)('Set');


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(505)('Set') });


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(253)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3);
	var defined = __webpack_require__(78);
	var toLength = __webpack_require__(23);
	var isRegExp = __webpack_require__(245);
	var getFlags = __webpack_require__(191);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(338)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(527);
	var userAgent = __webpack_require__(255);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(527);
	var userAgent = __webpack_require__(255);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(159)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(159)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(352)('asyncIterator');


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(352)('observable');


/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', { global: __webpack_require__(15) });


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(250)('WeakMap');


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(251)('WeakMap');


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(250)('WeakSet');


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(251)('WeakSet');


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(354);
	var getKeys = __webpack_require__(127);
	var redefine = __webpack_require__(54);
	var global = __webpack_require__(15);
	var hide = __webpack_require__(53);
	var Iterators = __webpack_require__(157);
	var wks = __webpack_require__(22);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $task = __webpack_require__(350);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(15);
	var $export = __webpack_require__(3);
	var userAgent = __webpack_require__(255);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1148);
	__webpack_require__(1087);
	__webpack_require__(1089);
	__webpack_require__(1088);
	__webpack_require__(1091);
	__webpack_require__(1093);
	__webpack_require__(1098);
	__webpack_require__(1092);
	__webpack_require__(1090);
	__webpack_require__(1100);
	__webpack_require__(1099);
	__webpack_require__(1095);
	__webpack_require__(1096);
	__webpack_require__(1094);
	__webpack_require__(1086);
	__webpack_require__(1097);
	__webpack_require__(1101);
	__webpack_require__(1102);
	__webpack_require__(1054);
	__webpack_require__(1056);
	__webpack_require__(1055);
	__webpack_require__(1104);
	__webpack_require__(1103);
	__webpack_require__(1074);
	__webpack_require__(1084);
	__webpack_require__(1085);
	__webpack_require__(1075);
	__webpack_require__(1076);
	__webpack_require__(1077);
	__webpack_require__(1078);
	__webpack_require__(1079);
	__webpack_require__(1080);
	__webpack_require__(1081);
	__webpack_require__(1082);
	__webpack_require__(1083);
	__webpack_require__(1057);
	__webpack_require__(1058);
	__webpack_require__(1059);
	__webpack_require__(1060);
	__webpack_require__(1061);
	__webpack_require__(1062);
	__webpack_require__(1063);
	__webpack_require__(1064);
	__webpack_require__(1065);
	__webpack_require__(1066);
	__webpack_require__(1067);
	__webpack_require__(1068);
	__webpack_require__(1069);
	__webpack_require__(1070);
	__webpack_require__(1071);
	__webpack_require__(1072);
	__webpack_require__(1073);
	__webpack_require__(1135);
	__webpack_require__(1140);
	__webpack_require__(1147);
	__webpack_require__(1138);
	__webpack_require__(1130);
	__webpack_require__(1131);
	__webpack_require__(1136);
	__webpack_require__(1141);
	__webpack_require__(1143);
	__webpack_require__(1126);
	__webpack_require__(1127);
	__webpack_require__(1128);
	__webpack_require__(1129);
	__webpack_require__(1132);
	__webpack_require__(1133);
	__webpack_require__(1134);
	__webpack_require__(1137);
	__webpack_require__(1139);
	__webpack_require__(1142);
	__webpack_require__(1144);
	__webpack_require__(1145);
	__webpack_require__(1146);
	__webpack_require__(1049);
	__webpack_require__(1051);
	__webpack_require__(1050);
	__webpack_require__(1053);
	__webpack_require__(1052);
	__webpack_require__(1038);
	__webpack_require__(1036);
	__webpack_require__(1042);
	__webpack_require__(1039);
	__webpack_require__(1045);
	__webpack_require__(1047);
	__webpack_require__(1035);
	__webpack_require__(1041);
	__webpack_require__(1032);
	__webpack_require__(1046);
	__webpack_require__(1030);
	__webpack_require__(1044);
	__webpack_require__(1043);
	__webpack_require__(1037);
	__webpack_require__(1040);
	__webpack_require__(1029);
	__webpack_require__(1031);
	__webpack_require__(1034);
	__webpack_require__(1033);
	__webpack_require__(1048);
	__webpack_require__(354);
	__webpack_require__(1120);
	__webpack_require__(531);
	__webpack_require__(1125);
	__webpack_require__(532);
	__webpack_require__(1121);
	__webpack_require__(1122);
	__webpack_require__(1123);
	__webpack_require__(1124);
	__webpack_require__(1105);
	__webpack_require__(530);
	__webpack_require__(533);
	__webpack_require__(534);
	__webpack_require__(1160);
	__webpack_require__(1149);
	__webpack_require__(1150);
	__webpack_require__(1155);
	__webpack_require__(1158);
	__webpack_require__(1159);
	__webpack_require__(1153);
	__webpack_require__(1156);
	__webpack_require__(1154);
	__webpack_require__(1157);
	__webpack_require__(1151);
	__webpack_require__(1152);
	__webpack_require__(1106);
	__webpack_require__(1107);
	__webpack_require__(1108);
	__webpack_require__(1109);
	__webpack_require__(1110);
	__webpack_require__(1113);
	__webpack_require__(1111);
	__webpack_require__(1112);
	__webpack_require__(1114);
	__webpack_require__(1115);
	__webpack_require__(1116);
	__webpack_require__(1117);
	__webpack_require__(1119);
	__webpack_require__(1118);
	__webpack_require__(1163);
	__webpack_require__(1161);
	__webpack_require__(1162);
	__webpack_require__(1204);
	__webpack_require__(1207);
	__webpack_require__(1206);
	__webpack_require__(1208);
	__webpack_require__(1209);
	__webpack_require__(1205);
	__webpack_require__(1210);
	__webpack_require__(1211);
	__webpack_require__(1185);
	__webpack_require__(1188);
	__webpack_require__(1184);
	__webpack_require__(1182);
	__webpack_require__(1183);
	__webpack_require__(1186);
	__webpack_require__(1187);
	__webpack_require__(1169);
	__webpack_require__(1203);
	__webpack_require__(1168);
	__webpack_require__(1202);
	__webpack_require__(1214);
	__webpack_require__(1216);
	__webpack_require__(1167);
	__webpack_require__(1201);
	__webpack_require__(1213);
	__webpack_require__(1215);
	__webpack_require__(1166);
	__webpack_require__(1212);
	__webpack_require__(1165);
	__webpack_require__(1170);
	__webpack_require__(1171);
	__webpack_require__(1172);
	__webpack_require__(1173);
	__webpack_require__(1174);
	__webpack_require__(1176);
	__webpack_require__(1175);
	__webpack_require__(1177);
	__webpack_require__(1178);
	__webpack_require__(1179);
	__webpack_require__(1181);
	__webpack_require__(1180);
	__webpack_require__(1190);
	__webpack_require__(1191);
	__webpack_require__(1192);
	__webpack_require__(1193);
	__webpack_require__(1195);
	__webpack_require__(1194);
	__webpack_require__(1197);
	__webpack_require__(1196);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1200);
	__webpack_require__(1164);
	__webpack_require__(1189);
	__webpack_require__(1219);
	__webpack_require__(1218);
	__webpack_require__(1217);
	module.exports = __webpack_require__(68);


/***/ },
/* 1221 */
/***/ function(module, exports) {

	module.exports = [
	  {
	    code: 'AED',
	    symbol: 'د.إ.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'AFN',
	    symbol: '؋',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'ALL',
	    symbol: 'Lek',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'AMD',
	    symbol: '֏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'ANG',
	    symbol: 'ƒ',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'AOA',
	    symbol: 'Kz',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'ARS',
	    symbol: '$',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'AUD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'AWG',
	    symbol: 'ƒ',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'AZN',
	    symbol: '₼',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BAM',
	    symbol: 'КМ',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BBD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'BDT',
	    symbol: '৳',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 0
	  },
	  {
	    code: 'BGN',
	    symbol: 'лв.',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BHD',
	    symbol: 'د.ب.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 3
	  },
	  {
	    code: 'BIF',
	    symbol: 'FBu',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'BMD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'BND',
	    symbol: '$',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'BOB',
	    symbol: 'Bs',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BRL',
	    symbol: 'R$',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BSD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'BTC',
	    symbol: 'Ƀ',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'BTN',
	    symbol: 'Nu.',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 1
	  },
	  {
	    code: 'BWP',
	    symbol: 'P',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'BYR',
	    symbol: 'р.',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'BZD',
	    symbol: 'BZ$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CAD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CDF',
	    symbol: 'FC',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CHF',
	    symbol: 'CHF',
	    thousandsSeparator: '\'',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'CLP',
	    symbol: '$',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'CNY',
	    symbol: '¥',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'COP',
	    symbol: '$',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'CRC',
	    symbol: '₡',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CUC',
	    symbol: 'CUC',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CUP',
	    symbol: '$MN',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CVE',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'CZK',
	    symbol: 'Kč',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'DJF',
	    symbol: 'Fdj',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'DKK',
	    symbol: 'kr.',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'DOP',
	    symbol: 'RD$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'DZD',
	    symbol: 'د.ج.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'EGP',
	    symbol: 'ج.م.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'ERN',
	    symbol: 'Nfk',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'ETB',
	    symbol: 'ETB',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'EUR',
	    symbol: '€',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'FJD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	    {
	    code: 'FKP',
	    symbol: '£',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GBP',
	    symbol: '£',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GEL',
	    symbol: 'Lari',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'GHS',
	    symbol: '₵',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GIP',
	    symbol: '£',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GMD',
	    symbol: 'D',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GNF',
	    symbol: 'FG',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'GTQ',
	    symbol: 'Q',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'GYD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'HKD',
	    symbol: 'HK$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'HNL',
	    symbol: 'L.',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'HRK',
	    symbol: 'kn',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'HTG',
	    symbol: 'G',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'HUF',
	    symbol: 'Ft',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'IDR',
	    symbol: 'Rp',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'ILS',
	    symbol: '₪',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'INR',
	    symbol: '₹',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'IQD',
	    symbol: 'د.ع.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'IRR',
	    symbol: '﷼',
	    thousandsSeparator: ',',
	    decimalSeparator: '/',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'ISK',
	    symbol: 'kr.',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 0
	  },
	  {
	    code: 'JMD',
	    symbol: 'J$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'JOD',
	    symbol: 'د.ا.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 3
	  },
	  {
	    code: 'JPY',
	    symbol: '¥',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'KES',
	    symbol: 'S',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'KGS',
	    symbol: 'сом',
	    thousandsSeparator: ' ',
	    decimalSeparator: '-',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'KHR',
	    symbol: '៛',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'KMF',
	    symbol: 'CF',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'KPW',
	    symbol: '₩',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'KRW',
	    symbol: '₩',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'KWD',
	    symbol: 'د.ك.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 3
	  },
	  {
	    code: 'KYD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'KZT',
	    symbol: '₸',
	    thousandsSeparator: ' ',
	    decimalSeparator: '-',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'LAK',
	    symbol: '₭',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'LBP',
	    symbol: 'ل.ل.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'LKR',
	    symbol: '₨',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 0
	  },
	  {
	    code: 'LRD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'LSL',
	    symbol: 'M',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'LYD',
	    symbol: 'د.ل.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 3
	  },
	  {
	    code: 'MAD',
	    symbol: 'د.م.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'MDL',
	    symbol: 'lei',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'MGA',
	    symbol: 'Ar',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'MKD',
	    symbol: 'ден.',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'MMK',
	    symbol: 'K',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MNT',
	    symbol: '₮',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MOP',
	    symbol: 'MOP$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MRO',
	    symbol: 'UM',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MTL',
	    symbol: '₤',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MUR',
	    symbol: '₨',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MVR',
	    symbol: 'MVR',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 1
	  },
	  {
	    code: 'MWK',
	    symbol: 'MK',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MXN',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MYR',
	    symbol: 'RM',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'MZN',
	    symbol: 'MT',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'NAD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'NGN',
	    symbol: '₦',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'NIO',
	    symbol: 'C$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'NOK',
	    symbol: 'kr',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'NPR',
	    symbol: '₨',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'NZD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'OMR',
	    symbol: '﷼',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 3
	  },
	  {
	    code: 'PAB',
	    symbol: 'B/.',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'PEN',
	    symbol: 'S/.',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'PGK',
	    symbol: 'K',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'PHP',
	    symbol: '₱',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'PKR',
	    symbol: '₨',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'PLN',
	    symbol: 'zł',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'PYG',
	    symbol: '₲',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'QAR',
	    symbol: '﷼',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'RON',
	    symbol: 'lei',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'RSD',
	    symbol: 'Дин.',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'RUB',
	    symbol: '₽',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'RWF',
	    symbol: 'RWF',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'SAR',
	    symbol: '﷼',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'SBD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SCR',
	    symbol: '₨',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SDD',
	    symbol: 'LSd',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SDG',
	    symbol: '£‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SEK',
	    symbol: 'kr',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'SGD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SHP',
	    symbol: '£',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SLL',
	    symbol: 'Le',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SOS',
	    symbol: 'S',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SRD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'STD',
	    symbol: 'Db',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SVC',
	    symbol: '₡',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'SYP',
	    symbol: '£',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'SZL',
	    symbol: 'E',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'THB',
	    symbol: '฿',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'TJS',
	    symbol: 'TJS',
	    thousandsSeparator: ' ',
	    decimalSeparator: ';',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'TMT',
	    symbol: 'm',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'TND',
	    symbol: 'د.ت.‏',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 3
	  },
	  {
	    code: 'TOP',
	    symbol: 'T$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'TRY',
	    symbol: 'TL',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'TTD',
	    symbol: 'TT$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'TVD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'TWD',
	    symbol: 'NT$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'TZS',
	    symbol: 'TSh',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'UAH',
	    symbol: '₴',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'UGX',
	    symbol: 'USh',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'USD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'UYU',
	    symbol: '$U',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'UZS',
	    symbol: 'сўм',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'VEB',
	    symbol: 'Bs.',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'VEF',
	    symbol: 'Bs. F.',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'VND',
	    symbol: '₫',
	    thousandsSeparator: '.',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 1
	  },
	  {
	    code: 'VUV',
	    symbol: 'VT',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 0
	  },
	  {
	    code: 'WST',
	    symbol: 'WS$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'XAF',
	    symbol: 'F',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'XCD',
	    symbol: '$',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'XOF',
	    symbol: 'F',
	    thousandsSeparator: ' ',
	    decimalSeparator: ',',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'XPF',
	    symbol: 'F',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  },
	  {
	    code: 'YER',
	    symbol: '﷼',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'ZAR',
	    symbol: 'R',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    decimalDigits: 2
	  },
	  {
	    code: 'ZMW',
	    symbol: 'ZK',
	    thousandsSeparator: ',',
	    decimalSeparator: '.',
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    decimalDigits: 2
	  }
	]


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	var currencies = __webpack_require__(1221)
	var accounting = __webpack_require__(757)
	/*
	  This polyfill intends to emulate the Array.prototy.find() method
	  for browsers who don't support it yet.
	*/
	if (!Array.prototype.find) {
	  Array.prototype.find = function(predicate) {
	    if (this === null) {
	      throw new TypeError('Array.prototype.find called on null or undefined');
	    }
	    if (typeof predicate !== 'function') {
	      throw new TypeError('predicate must be a function');
	    }
	    var list = Object(this);
	    var length = list.length >>> 0;
	    var thisArg = arguments[1];
	    var value;
	
	    for (var i = 0; i < length; i++) {
	      value = list[i];
	      if (predicate.call(thisArg, value, i, list)) {
	        return value;
	      }
	    }
	    return undefined;
	  };
	}
	
	exports.defaultCurrency = {
	  symbol: '',
	  thousandsSeparator: ',',
	  decimalSeparator: '.',
	  symbolOnLeft: true,
	  spaceBetweenAmountAndSymbol: false,
	  decimalDigits: 2
	}
	
	exports.currencies = currencies
	
	var formatMapping = [
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%s%v',
	      neg: '-%s%v',
	      zero: '%s%v'
	    }
	  },
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%s %v',
	      neg: '-%s %v',
	      zero: '%s %v'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%v%s',
	      neg: '-%v%s',
	      zero: '%v%s'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%v %s',
	      neg: '-%v %s',
	      zero: '%v %s'
	    }
	  }
	]
	
	exports.format = function (value, options) {
	  var currency = findCurrency(options.code) || exports.defaultCurrency
	
	  var symbolOnLeft = currency.symbolOnLeft
	  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol
	
	  var format = formatMapping.find(function(f) {
	    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
	  }).format
	
	  return accounting.formatMoney(value, {
	    symbol: isUndefined(options.symbol)
	              ? currency.symbol
	              : options.symbol,
	
	    decimal: isUndefined(options.decimal)
	              ? currency.decimalSeparator
	              : options.decimal,
	
	    thousand: isUndefined(options.thousand)
	              ? currency.thousandsSeparator
	              : options.thousand,
	
	    precision: typeof options.precision === 'number'
	              ? options.precision
	              : currency.decimalDigits,
	
	    format: ['string', 'object'].indexOf(typeof options.format) > -1
	              ? options.format
	              : format
	  })
	}
	
	function findCurrency (currencyCode) {
	  return currencies.find(function (c) { return c.code === currencyCode })
	}
	
	exports.findCurrency = findCurrency
	
	function isUndefined (val) {
	  return typeof val === 'undefined'
	}


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? 'a'  : 'p',
	          tt:   H < 12 ? 'am' : 'pm',
	          T:    H < 12 ? 'A'  : 'P',
	          TT:   H < 12 ? 'AM' : 'PM',
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occurred and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ },
/* 1224 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 1225 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 1226 */
/***/ function(module, exports) {

	/*!
	Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	(function(window){'use strict';
	  /* jshint loopfunc: true, noempty: false*/
	  // http://www.w3.org/TR/dom/#element
	
	  function createDocumentFragment() {
	    return document.createDocumentFragment();
	  }
	
	  function createElement(nodeName) {
	    return document.createElement(nodeName);
	  }
	
	  function enoughArguments(length, name) {
	    if (!length) throw new Error(
	      'Failed to construct ' +
	        name +
	      ': 1 argument required, but only 0 present.'
	    );
	  }
	
	  function mutationMacro(nodes) {
	    if (nodes.length === 1) {
	      return textNodeIfString(nodes[0]);
	    }
	    for (var
	      fragment = createDocumentFragment(),
	      list = slice.call(nodes),
	      i = 0; i < nodes.length; i++
	    ) {
	      fragment.appendChild(textNodeIfString(list[i]));
	    }
	    return fragment;
	  }
	
	  function textNodeIfString(node) {
	    return typeof node === 'string' ? document.createTextNode(node) : node;
	  }
	
	  for(var
	    head,
	    property,
	    TemporaryPrototype,
	    TemporaryTokenList,
	    wrapVerifyToken,
	    document = window.document,
	    hOP = Object.prototype.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (object, property, descriptor) {
	      if (hOP.call(descriptor, 'value')) {
	        object[property] = descriptor.value;
	      } else {
	        if (hOP.call(descriptor, 'get'))
	          object.__defineGetter__(property, descriptor.get);
	        if (hOP.call(descriptor, 'set'))
	          object.__defineSetter__(property, descriptor.set);
	      }
	      return object;
	    },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    // http://www.w3.org/TR/domcore/#domtokenlist
	    verifyToken = function (token) {
	      if (!token) {
	        throw 'SyntaxError';
	      } else if (spaces.test(token)) {
	        throw 'InvalidCharacterError';
	      }
	      return token;
	    },
	    DOMTokenList = function (node) {
	      var
	        noClassName = typeof node.className === 'undefined',
	        className = noClassName ?
	          (node.getAttribute('class') || '') : node.className,
	        isSVG = noClassName || typeof className === 'object',
	        value = (isSVG ?
	          (noClassName ? className : className.baseVal) :
	          className
	        ).replace(trim, '')
	      ;
	      if (value.length) {
	        properties.push.apply(
	          this,
	          value.split(spaces)
	        );
	      }
	      this._isSVG = isSVG;
	      this._ = node;
	    },
	    classListDescriptor = {
	      get: function get() {
	        return new DOMTokenList(this);
	      },
	      set: function(){}
	    },
	    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
	    trim = /^\s+|\s+$/g,
	    spaces = /\s+/,
	    SPACE = '\x20',
	    CLASS_LIST = 'classList',
	    toggle = function toggle(token, force) {
	      if (this.contains(token)) {
	        if (!force) {
	          // force is not true (either false or omitted)
	          this.remove(token);
	        }
	      } else if(force === undefined || force) {
	        force = true;
	        this.add(token);
	      }
	      return !!force;
	    },
	    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
	    Node = window.Node,
	    NodePrototype = (Node || Element).prototype,
	    CharacterData = window.CharacterData || Node,
	    CharacterDataPrototype = CharacterData && CharacterData.prototype,
	    DocumentType = window.DocumentType,
	    DocumentTypePrototype = DocumentType && DocumentType.prototype,
	    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
	    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
	    selectRemove = HTMLSelectElement.prototype.remove,
	    ShadowRoot = window.ShadowRoot,
	    SVGElement = window.SVGElement,
	    // normalizes multiple ids as CSS query
	    idSpaceFinder = / /g,
	    idSpaceReplacer = '\\ ',
	    createQueryMethod = function (methodName) {
	      var createArray = methodName === 'querySelectorAll';
	      return function (css) {
	        var a, i, id, query, nl, selectors, node = this.parentNode;
	        if (node) {
	          for (
	            id = this.getAttribute('id') || uid,
	            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
	            selectors = css.split(','),
	            i = 0; i < selectors.length; i++
	          ) {
	            selectors[i] = '#' + query + ' ' + selectors[i];
	          }
	          css = selectors.join(',');
	        }
	        if (id === uid) this.setAttribute('id', id);
	        nl = (node || this)[methodName](css);
	        if (id === uid) this.removeAttribute('id');
	        // return a list
	        if (createArray) {
	          i = nl.length;
	          a = new Array(i);
	          while (i--) a[i] = nl[i];
	        }
	        // return node or null
	        else {
	          a = nl;
	        }
	        return a;
	      };
	    },
	    addQueryAndAll = function (where) {
	      if (!('query' in where)) {
	        where.query = ElementPrototype.query;
	      }
	      if (!('queryAll' in where)) {
	        where.queryAll = ElementPrototype.queryAll;
	      }
	    },
	    properties = [
	      'matches', (
	        ElementPrototype.matchesSelector ||
	        ElementPrototype.webkitMatchesSelector ||
	        ElementPrototype.khtmlMatchesSelector ||
	        ElementPrototype.mozMatchesSelector ||
	        ElementPrototype.msMatchesSelector ||
	        ElementPrototype.oMatchesSelector ||
	        function matches(selector) {
	          var parentNode = this.parentNode;
	          return !!parentNode && -1 < indexOf.call(
	            parentNode.querySelectorAll(selector),
	            this
	          );
	        }
	      ),
	      'closest', function closest(selector) {
	        var parentNode = this, matches;
	        while (
	          // document has no .matches
	          (matches = parentNode && parentNode.matches) &&
	          !parentNode.matches(selector)
	        ) {
	          parentNode = parentNode.parentNode;
	        }
	        return matches ? parentNode : null;
	      },
	      'prepend', function prepend() {
	        var firstChild = this.firstChild,
	            node = mutationMacro(arguments);
	        if (firstChild) {
	          this.insertBefore(node, firstChild);
	        } else {
	          this.appendChild(node);
	        }
	      },
	      'append', function append() {
	        this.appendChild(mutationMacro(arguments));
	      },
	      'before', function before() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.insertBefore(
	            mutationMacro(arguments), this
	          );
	        }
	      },
	      'after', function after() {
	        var parentNode = this.parentNode,
	            nextSibling = this.nextSibling,
	            node = mutationMacro(arguments);
	        if (parentNode) {
	          if (nextSibling) {
	            parentNode.insertBefore(node, nextSibling);
	          } else {
	            parentNode.appendChild(node);
	          }
	        }
	      },
	      // WARNING - DEPRECATED - use .replaceWith() instead
	      'replace', function replace() {
	        this.replaceWith.apply(this, arguments);
	      },
	      'replaceWith', function replaceWith() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.replaceChild(
	            mutationMacro(arguments),
	            this
	          );
	        }
	      },
	      'remove', function remove() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.removeChild(this);
	        }
	      },
	      'query', createQueryMethod('querySelector'),
	      'queryAll', createQueryMethod('querySelectorAll')
	    ],
	    slice = properties.slice,
	    i = properties.length; i; i -= 2
	  ) {
	    property = properties[i - 2];
	    if (!(property in ElementPrototype)) {
	      ElementPrototype[property] = properties[i - 1];
	    }
	    if (property === 'remove') {
	      // see https://github.com/WebReflection/dom4/issues/19
	      HTMLSelectElement.prototype[property] = function () {
	        return 0 < arguments.length ?
	          selectRemove.apply(this, arguments) :
	          ElementPrototype.remove.call(this);
	      };
	    }
	    // see https://github.com/WebReflection/dom4/issues/18
	    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
	      if (CharacterData && !(property in CharacterDataPrototype)) {
	        CharacterDataPrototype[property] = properties[i - 1];
	      }
	      if (DocumentType && !(property in DocumentTypePrototype)) {
	        DocumentTypePrototype[property] = properties[i - 1];
	      }
	    }
	    // see https://github.com/WebReflection/dom4/pull/26
	    if (/^(?:append|prepend)$/.test(property)) {
	      if (DocumentFragmentPrototype) {
	        if (!(property in DocumentFragmentPrototype)) {
	          DocumentFragmentPrototype[property] = properties[i - 1];
	        }
	      } else {
	        try {
	          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
	        } catch(o_O) {}
	      }
	    }
	  }
	
	  // bring query and queryAll to the document too
	  addQueryAndAll(document);
	
	  // brings query and queryAll to fragments as well
	  if (DocumentFragmentPrototype) {
	    addQueryAndAll(DocumentFragmentPrototype);
	  } else {
	    try {
	      addQueryAndAll(createDocumentFragment().constructor.prototype);
	    } catch(o_O) {}
	  }
	
	  // bring query and queryAll to the ShadowRoot too
	  if (ShadowRoot) {
	    addQueryAndAll(ShadowRoot.prototype);
	  }
	
	  // most likely an IE9 only issue
	  // see https://github.com/WebReflection/dom4/issues/6
	  if (!createElement('a').matches('a')) {
	    ElementPrototype[property] = function(matches){
	      return function (selector) {
	        return matches.call(
	          this.parentNode ?
	            this :
	            createDocumentFragment().appendChild(this),
	          selector
	        );
	      };
	    }(ElementPrototype[property]);
	  }
	
	  // used to fix both old webkit and SVG
	  DOMTokenList.prototype = {
	    length: 0,
	    add: function add() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(!this.contains(token)) {
	          properties.push.call(this, property);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    contains: (function(indexOf){
	      return function contains(token) {
	        i = indexOf.call(this, property = verifyToken(token));
	        return -1 < i;
	      };
	    }([].indexOf || function (token) {
	      i = this.length;
	      while(i-- && this[i] !== token){}
	      return i;
	    })),
	    item: function item(i) {
	      return this[i] || null;
	    },
	    remove: function remove() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(this.contains(token)) {
	          properties.splice.call(this, i, 1);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    toggle: toggle,
	    toString: function toString() {
	      return properties.join.call(this, SPACE);
	    }
	  };
	
	  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
	    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
	  }
	
	  // http://www.w3.org/TR/dom/#domtokenlist
	  // iOS 5.1 has completely screwed this property
	  // classList in ElementPrototype is false
	  // but it's actually there as getter
	  if (!(CLASS_LIST in document.documentElement)) {
	    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
	  } else {
	    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
	    // trying to detect and fix that in here
	    TemporaryTokenList = createElement('div')[CLASS_LIST];
	    TemporaryTokenList.add('a', 'b', 'a');
	    if ('a\x20b' != TemporaryTokenList) {
	      // no other way to reach original methods in iOS 5.1
	      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
	      if (!('add' in TemporaryPrototype)) {
	        // ASHA double fails in here
	        TemporaryPrototype = window.TemporaryTokenList.prototype;
	      }
	      wrapVerifyToken = function (original) {
	        return function () {
	          var i = 0;
	          while (i < arguments.length) {
	            original.call(this, arguments[i++]);
	          }
	        };
	      };
	      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
	      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
	      // toggle is broken too ^_^ ... let's fix it
	      TemporaryPrototype.toggle = toggle;
	    }
	  }
	
	  if (!('contains' in NodePrototype)) {
	    defineProperty(NodePrototype, 'contains', {
	      value: function (el) {
	        while (el && el !== this) el = el.parentNode;
	        return this === el;
	      }
	    });
	  }
	
	  if (!('head' in document)) {
	    defineProperty(document, 'head', {
	      get: function () {
	        return head || (
	          head = document.getElementsByTagName('head')[0]
	        );
	      }
	    });
	  }
	
	  // requestAnimationFrame partial polyfill
	  (function () {
	    for (var
	      raf,
	      rAF = window.requestAnimationFrame,
	      cAF = window.cancelAnimationFrame,
	      prefixes = ['o', 'ms', 'moz', 'webkit'],
	      i = prefixes.length;
	      !cAF && i--;
	    ) {
	      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
	      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
	            window[prefixes[i] + 'CancelRequestAnimationFrame'];
	    }
	    if (!cAF) {
	      // some FF apparently implemented rAF but no cAF 
	      if (rAF) {
	        raf = rAF;
	        rAF = function (callback) {
	          var goOn = true;
	          raf(function () {
	            if (goOn) callback.apply(this, arguments);
	          });
	          return function () {
	            goOn = false;
	          };
	        };
	        cAF = function (id) {
	          id();
	        };
	      } else {
	        rAF = function (callback) {
	          return setTimeout(callback, 15, 15);
	        };
	        cAF = function (id) {
	          clearTimeout(id);
	        };
	      }
	    }
	    window.requestAnimationFrame = rAF;
	    window.cancelAnimationFrame = cAF;
	  }());
	
	  // http://www.w3.org/TR/dom/#customevent
	  try{new window.CustomEvent('?');}catch(o_O){
	    window.CustomEvent = function(
	      eventName,
	      defaultInitDict
	    ){
	
	      // the infamous substitute
	      function CustomEvent(type, eventInitDict) {
	        /*jshint eqnull:true */
	        var event = document.createEvent(eventName);
	        if (typeof type != 'string') {
	          throw new Error('An event name must be provided');
	        }
	        if (eventName == 'Event') {
	          event.initCustomEvent = initCustomEvent;
	        }
	        if (eventInitDict == null) {
	          eventInitDict = defaultInitDict;
	        }
	        event.initCustomEvent(
	          type,
	          eventInitDict.bubbles,
	          eventInitDict.cancelable,
	          eventInitDict.detail
	        );
	        return event;
	      }
	
	      // attached at runtime
	      function initCustomEvent(
	        type, bubbles, cancelable, detail
	      ) {
	        /*jshint validthis:true*/
	        this.initEvent(type, bubbles, cancelable);
	        this.detail = detail;
	      }
	
	      // that's it
	      return CustomEvent;
	    }(
	      // is this IE9 or IE10 ?
	      // where CustomEvent is there
	      // but not usable as construtor ?
	      window.CustomEvent ?
	        // use the CustomEvent interface in such case
	        'CustomEvent' : 'Event',
	        // otherwise the common compatible one
	      {
	        bubbles: false,
	        cancelable: false,
	        detail: null
	      }
	    );
	  }
	
	  // window.Event as constructor
	  try { new Event('_'); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($Event) {
	      function Event(type, init) {
	        enoughArguments(arguments.length, 'Event');
	        var out = document.createEvent('Event');
	        if (!init) init = {};
	        out.initEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable
	        );
	        return out;
	      }
	      Event.prototype = $Event.prototype;
	      return Event;
	    }(window.Event || function Event() {}));
	    defineProperty(window, 'Event', {value: o_O});
	    // Android 4 gotcha
	    if (Event !== o_O) Event = o_O;
	  }
	
	  // window.KeyboardEvent as constructor
	  try { new KeyboardEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($KeyboardEvent) {
	      // code inspired by https://gist.github.com/termi/4654819
	      var
	        initType = 0,
	        defaults = {
	          char: '',
	          key: '',
	          location: 0,
	          ctrlKey: false,
	          shiftKey: false,
	          altKey: false,
	          metaKey: false,
	          altGraphKey: false,
	          repeat: false,
	          locale: navigator.language,
	          detail: 0,
	          bubbles: false,
	          cancelable: false,
	          keyCode: 0,
	          charCode: 0,
	          which: 0
	        },
	        eventType
	      ;
	      try {
	        var e = document.createEvent('KeyboardEvent');
	        e.initKeyboardEvent(
	          'keyup', false, false, window, '+', 3,
	          true, false, true, false, false
	        );
	        initType = (
	          (e.keyIdentifier || e.key) == '+' &&
	          (e.keyLocation || e.location) == 3
	        ) && (
	          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
	        ) || 9;
	      } catch(o_O) {}
	      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';
	
	      function getModifier(init) {
	        for (var
	          out = [],
	          keys = [
	            'ctrlKey',
	            'Control',
	            'shiftKey',
	            'Shift',
	            'altKey',
	            'Alt',
	            'metaKey',
	            'Meta',
	            'altGraphKey',
	            'AltGraph'
	          ],
	          i = 0; i < keys.length; i += 2
	        ) {
	          if (init[keys[i]])
	            out.push(keys[i + 1]);
	        }
	        return out.join(' ');
	      }
	
	      function withDefaults(target, source) {
	        for (var key in source) {
	          if (
	            source.hasOwnProperty(key) &&
	            !source.hasOwnProperty.call(target, key)
	          ) target[key] = source[key];
	        }
	        return target;
	      }
	
	      function withInitValues(key, out, init) {
	        try {
	          out[key] = init[key];
	        } catch(o_O) {}
	      }
	
	      function KeyboardEvent(type, init) {
	        enoughArguments(arguments.length, 'KeyboardEvent');
	        init = withDefaults(init || {}, defaults);
	        var
	          out = document.createEvent(eventType),
	          ctrlKey = init.ctrlKey,
	          shiftKey = init.shiftKey,
	          altKey = init.altKey,
	          metaKey = init.metaKey,
	          altGraphKey = init.altGraphKey,
	          modifiers = initType > 3 ? getModifier(init) : null,
	          key = String(init.key),
	          chr = String(init.char),
	          location = init.location,
	          keyCode = init.keyCode || (
	            (init.keyCode = key) &&
	            key.charCodeAt(0)
	          ) || 0,
	          charCode = init.charCode || (
	            (init.charCode = chr) &&
	            chr.charCodeAt(0)
	          ) || 0,
	          bubbles = init.bubbles,
	          cancelable = init.cancelable,
	          repeat = init.repeat,
	          locale = init.locale,
	          view = init.view || window,
	          args
	        ;
	        if (!init.which) init.which = init.keyCode;
	        if ('initKeyEvent' in out) {
	          out.initKeyEvent(
	            type, bubbles, cancelable, view,
	            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
	          );
	        } else if (0 < initType && 'initKeyboardEvent' in out) {
	          args = [type, bubbles, cancelable, view];
	          switch (initType) {
	            case 1:
	              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
	              break;
	            case 2:
	              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
	              break;
	            case 3:
	              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
	              break;
	            case 4:
	              args.push(key, location, modifiers, repeat, locale);
	              break;
	            default:
	              args.push(char, key, location, modifiers, repeat, locale);
	          }
	          out.initKeyboardEvent.apply(out, args);
	        } else {
	          out.initEvent(type, bubbles, cancelable);
	        }
	        for (key in out) {
	          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
	            withInitValues(key, out, init);
	          }
	        }
	        return out;
	      }
	      KeyboardEvent.prototype = $KeyboardEvent.prototype;
	      return KeyboardEvent;
	    }(window.KeyboardEvent || function KeyboardEvent() {}));
	    defineProperty(window, 'KeyboardEvent', {value: o_O});
	    // Android 4 gotcha
	    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
	  }
	
	  // window.MouseEvent as constructor
	  try { new MouseEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($MouseEvent) {
	      function MouseEvent(type, init) {
	        enoughArguments(arguments.length, 'MouseEvent');
	        var out = document.createEvent('MouseEvent');
	        if (!init) init = {};
	        out.initMouseEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable,
	          init.view || window,
	          init.detail || 1,
	          init.screenX || 0,
	          init.screenY || 0,
	          init.clientX || 0,
	          init.clientY || 0,
	          !!init.ctrlKey,
	          !!init.altKey,
	          !!init.shiftKey,
	          !!init.metaKey,
	          init.button || 0,
	          init.relatedTarget || null
	        );
	        return out;
	      }
	      MouseEvent.prototype = $MouseEvent.prototype;
	      return MouseEvent;
	    }(window.MouseEvent || function MouseEvent() {}));
	    defineProperty(window, 'MouseEvent', {value: o_O});
	    // Android 4 gotcha
	    if (MouseEvent !== o_O) MouseEvent = o_O;
	  }
	
	}(window));(function (global){'use strict';
	
	  // a WeakMap fallback for DOM nodes only used as key
	  var DOMMap = global.WeakMap || (function () {
	
	    var
	      counter = 0,
	      dispatched = false,
	      drop = false,
	      value
	    ;
	
	    function dispatch(key, ce, shouldDrop) {
	      drop = shouldDrop;
	      dispatched = false;
	      value = undefined;
	      key.dispatchEvent(ce);
	    }
	
	    function Handler(value) {
	      this.value = value;
	    }
	
	    Handler.prototype.handleEvent = function handleEvent(e) {
	      dispatched = true;
	      if (drop) {
	        e.currentTarget.removeEventListener(e.type, this, false);
	      } else {
	        value = this.value;
	      }
	    };
	
	    function DOMMap() {
	      counter++;  // make id clashing highly improbable
	      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
	    }
	
	    DOMMap.prototype = {
	      'constructor': DOMMap,
	      'delete': function del(key) {
	        return dispatch(key, this.__ce__, true), dispatched;
	      },
	      'get': function get(key) {
	        dispatch(key, this.__ce__, false);
	        var v = value;
	        value = undefined;
	        return v;
	      },
	      'has': function has(key) {
	        return dispatch(key, this.__ce__, false), dispatched;
	      },
	      'set': function set(key, value) {
	        dispatch(key, this.__ce__, true);
	        key.addEventListener(this.__ce__.type, new Handler(value), false);
	        return this;
	      },
	    };
	
	    return DOMMap;
	
	  }());
	
	  function Dict() {}
	  Dict.prototype = (Object.create || Object)(null);
	
	  // https://dom.spec.whatwg.org/#interface-eventtarget
	
	  function createEventListener(type, callback, options) {
	    function eventListener(e) {
	      if (eventListener.once) {
	        e.currentTarget.removeEventListener(
	          e.type,
	          callback,
	          eventListener
	        );
	        eventListener.removed = true;
	      }
	      if (eventListener.passive) {
	        e.preventDefault = createEventListener.preventDefault;
	      }
	      if (typeof eventListener.callback === 'function') {
	        /* jshint validthis: true */
	        eventListener.callback.call(this, e);
	      } else if (eventListener.callback) {
	        eventListener.callback.handleEvent(e);
	      }
	      if (eventListener.passive) {
	        delete e.preventDefault;
	      }
	    }
	    eventListener.type = type;
	    eventListener.callback = callback;
	    eventListener.capture = !!options.capture;
	    eventListener.passive = !!options.passive;
	    eventListener.once = !!options.once;
	    // currently pointless but specs say to use it, so ...
	    eventListener.removed = false;
	    return eventListener;
	  }
	
	  createEventListener.preventDefault = function preventDefault() {};
	
	  var
	    Event = global.CustomEvent,
	    hOP = Object.prototype.hasOwnProperty,
	    dE = global.dispatchEvent,
	    aEL = global.addEventListener,
	    rEL = global.removeEventListener,
	    counter = 0,
	    increment = function () { counter++; },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    getListenerKey = function (options) {
	      return ''.concat(
	        options.capture ? '1' : '0',
	        options.passive ? '1' : '0',
	        options.once ? '1' : '0'
	      );
	    },
	    augment, proto
	  ;
	
	  try {
	    aEL('_', increment, {once: true});
	    dE(new Event('_'));
	    dE(new Event('_'));
	    rEL('_', increment, {once: true});
	  } catch(o_O) {}
	
	  if (counter !== 1) {
	    (function () {
	      var dm = new DOMMap();
	      function createAEL(aEL) {
	        return function addEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key = getListenerKey(options),
	              i, tmp, wrap
	            ;
	            if (!info) dm.set(this, (info = new Dict()));
	            if (!(type in info)) info[type] = {
	              handler: [],
	              wrap: []
	            };
	            tmp = info[type];
	            i = indexOf.call(tmp.handler, handler);
	            if (i < 0) {
	              i = tmp.handler.push(handler) - 1;
	              tmp.wrap[i] = (wrap = new Dict());
	            } else {
	              wrap = tmp.wrap[i];
	            }
	            if (!(key in wrap)) {
	              wrap[key] = createEventListener(type, handler, options);
	              aEL.call(this, type, wrap[key], wrap[key].capture);
	            }
	          } else {
	            aEL.call(this, type, handler, options);
	          }
	        };
	      }
	      function createREL(rEL) {
	        return function removeEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key, i, tmp, wrap
	            ;
	            if (info && (type in info)) {
	              tmp = info[type];
	              i = indexOf.call(tmp.handler, handler);
	              if (-1 < i) {
	                key = getListenerKey(options);
	                wrap = tmp.wrap[i];
	                if (key in wrap) {
	                  rEL.call(this, type, wrap[key], wrap[key].capture);
	                  delete wrap[key];
	                  // return if there are other wraps
	                  for (key in wrap) return;
	                  // otherwise remove all the things
	                  tmp.handler.splice(i, 1);
	                  tmp.wrap.splice(i, 1);
	                  // if there are no other handlers
	                  if (tmp.handler.length === 0)
	                    // drop the info[type] entirely
	                    delete info[type];
	                }
	              }
	            }
	          } else {
	            rEL.call(this, type, handler, options);
	          }
	        };
	      }
	
	      augment = function (Constructor) {
	        if (!Constructor) return;
	        var proto = Constructor.prototype;
	        proto.addEventListener = createAEL(proto.addEventListener);
	        proto.removeEventListener = createREL(proto.removeEventListener);
	      };
	
	      if (global.EventTarget) {
	        augment(EventTarget);
	      } else {
	        augment(global.Text);
	        augment(global.Element || global.HTMLElement);
	        augment(global.HTMLDocument);
	        augment(global.Window || {prototype:global});
	        augment(global.XMLHttpRequest);
	      }
	
	    }());
	  }
	
	}(self));

/***/ },
/* 1227 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1229 */
113,
/* 1230 */
113,
/* 1231 */
113,
/* 1232 */
113,
/* 1233 */
113,
/* 1234 */
113,
/* 1235 */
113,
/* 1236 */
113,
/* 1237 */
113,
/* 1238 */
113,
/* 1239 */
113,
/* 1240 */
113,
/* 1241 */
113,
/* 1242 */
113,
/* 1243 */
113,
/* 1244 */
113,
/* 1245 */
113,
/* 1246 */
113,
/* 1247 */
113,
/* 1248 */
113,
/* 1249 */
113,
/* 1250 */
113,
/* 1251 */
113,
/* 1252 */
113,
/* 1253 */
113,
/* 1254 */
113,
/* 1255 */
113,
/* 1256 */
113,
/* 1257 */
113,
/* 1258 */
113,
/* 1259 */
113,
/* 1260 */
113,
/* 1261 */
113,
/* 1262 */
113,
/* 1263 */
113,
/* 1264 */
113,
/* 1265 */
113,
/* 1266 */
113,
/* 1267 */
113,
/* 1268 */
113,
/* 1269 */
113,
/* 1270 */
113,
/* 1271 */
113,
/* 1272 */
113,
/* 1273 */
113,
/* 1274 */
113,
/* 1275 */
113,
/* 1276 */
113,
/* 1277 */
113,
/* 1278 */
113,
/* 1279 */
113,
/* 1280 */
113,
/* 1281 */
113,
/* 1282 */
113,
/* 1283 */
113,
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 1285 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1285);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1295);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createArrayFromMixed = __webpack_require__(1288);
	var getMarkupWrap = __webpack_require__(1290);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1291 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1292 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1292);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1294 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1294);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1296 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aaeb1a0639850eb167bc1d0ede9d38a8.png";

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a0951b4cbddb5d11b6fb1511deb6f67.csv";

/***/ },
/* 1299 */
1297,
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13fb7755ead4829cf214b927739a88f5.png";

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8dd92c17116f6b5aaaaed632235b441.csv";

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9e54eaa7a7a94cb80735f8abb7e9934.csv";

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcebf947814e1aab12c489851ff2f66f.csv";

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "474c34cdd5018a0cb5a32b121cf449be.csv";

/***/ },
/* 1305 */
1297,
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f394c5f69163e10ae13fa3bf42335064.csv";

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60088697dc90cb6fb1fb61fa14df3ab8.png";

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3aafa126814f90c4e88f8f1bf4536d27.png";

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4233843eabe25c15471c10787ce5c019.png";

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(1);
	
	var CustomFilterContainer = React.createClass({
	  displayName: "CustomFilterContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "placeholderText": ""
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customFilterComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", null);
	    }
	
	    return React.createElement(that.props.customFilterComponent, {
	      changeFilter: this.props.changeFilter,
	      results: this.props.results,
	      currentResults: this.props.currentResults,
	      placeholderText: this.props.placeholderText });
	  }
	});
	
	module.exports = CustomFilterContainer;


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(1);
	
	var CustomPaginationContainer = React.createClass({
	  displayName: "CustomPaginationContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "maxPage": 0,
	      "nextText": "",
	      "previousText": "",
	      "currentPage": 0,
	      "customPagerComponent": {}
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customPagerComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", null);
	    }
	
	    return React.createElement(that.props.customPagerComponent, { maxPage: this.props.maxPage, nextText: this.props.nextText, previousText: this.props.previousText, currentPage: this.props.currentPage, setPage: this.props.setPage, previous: this.props.previous, next: this.props.next });
	  }
	});
	
	module.exports = CustomPaginationContainer;


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   Griddle - Simple Grid Component for React
	   https://github.com/DynamicTyped/Griddle
	   Copyright (c) 2014 Ryan Lanciaux | DynamicTyped
	
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(1);
	
	var CustomRowComponentContainer = React.createClass({
	  displayName: "CustomRowComponentContainer",
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "data": [],
	      "metadataColumns": [],
	      "className": "",
	      "customComponent": {},
	      "globalData": {}
	    };
	  },
	  render: function render() {
	    var that = this;
	
	    if (typeof that.props.customComponent !== 'function') {
	      console.log("Couldn't find valid template.");
	      return React.createElement("div", { className: this.props.className });
	    }
	
	    var nodes = this.props.data.map(function (row, index) {
	      return React.createElement(that.props.customComponent, { data: row, metadataColumns: that.props.metadataColumns, key: index, globalData: that.props.globalData });
	    });
	
	    var footer = this.props.showPager && this.props.pagingContent;
	    return React.createElement("div", { className: this.props.className, style: this.props.style }, nodes);
	  }
	});
	
	module.exports = CustomRowComponentContainer;


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(1);
	
	var GridFilter = React.createClass({
	    displayName: "GridFilter",
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "placeholderText": ""
	        };
	    },
	    handleChange: function handleChange(event) {
	        this.props.changeFilter(event.target.value);
	    },
	    render: function render() {
	        return React.createElement("div", { className: "filter-container" }, React.createElement("input", { type: "text", name: "filter", placeholder: this.props.placeholderText, className: "form-control", onChange: this.handleChange }));
	    }
	});
	
	module.exports = GridFilter;


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	"use strict";
	
	var React = __webpack_require__(1);
	
	var GridNoData = React.createClass({
	    displayName: "GridNoData",
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "noDataMessage": "No Data"
	        };
	    },
	    render: function render() {
	        var that = this;
	
	        return React.createElement("div", null, this.props.noDataMessage);
	    }
	});
	
	module.exports = GridNoData;


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(264);
	
	//needs props maxPage, currentPage, nextFunction, prevFunction
	var GridPagination = React.createClass({
	    displayName: 'GridPagination',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "maxPage": 0,
	            "nextText": "",
	            "previousText": "",
	            "currentPage": 0,
	            "useGriddleStyles": true,
	            "nextClassName": "griddle-next",
	            "previousClassName": "griddle-previous",
	            "nextIconComponent": null,
	            "previousIconComponent": null
	        };
	    },
	    pageChange: function pageChange(event) {
	        this.props.setPage(parseInt(event.target.value, 10) - 1);
	    },
	    render: function render() {
	        var previous = "";
	        var next = "";
	
	        if (this.props.currentPage > 0) {
	            previous = React.createElement('button', { type: 'button', onClick: this.props.previous, style: this.props.useGriddleStyles ? { "color": "#222", border: "none", background: "none", margin: "0 0 0 10px" } : null }, this.props.previousIconComponent, this.props.previousText);
	        }
	
	        if (this.props.currentPage !== this.props.maxPage - 1) {
	            next = React.createElement('button', { type: 'button', onClick: this.props.next, style: this.props.useGriddleStyles ? { "color": "#222", border: "none", background: "none", margin: "0 10px 0 0" } : null }, this.props.nextText, this.props.nextIconComponent);
	        }
	
	        var leftStyle = null;
	        var middleStyle = null;
	        var rightStyle = null;
	
	        if (this.props.useGriddleStyles === true) {
	            var baseStyle = {
	                "float": "left",
	                minHeight: "1px",
	                marginTop: "5px"
	            };
	
	            rightStyle = assign({ textAlign: "right", width: "34%" }, baseStyle);
	            middleStyle = assign({ textAlign: "center", width: "33%" }, baseStyle);
	            leftStyle = assign({ width: "33%" }, baseStyle);
	        }
	
	        var options = [];
	
	        for (var i = 1; i <= this.props.maxPage; i++) {
	            options.push(React.createElement('option', { value: i, key: i }, i));
	        }
	
	        return React.createElement('div', { style: this.props.useGriddleStyles ? { minHeight: "35px" } : null }, React.createElement('div', { className: this.props.previousClassName, style: leftStyle }, previous), React.createElement('div', { className: 'griddle-page', style: middleStyle }, React.createElement('select', { value: this.props.currentPage + 1, onChange: this.pageChange }, options), ' / ', this.props.maxPage), React.createElement('div', { className: this.props.nextClassName, style: rightStyle }, next));
	    }
	});
	
	module.exports = GridPagination;


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(1);
	var ColumnProperties = __webpack_require__(197);
	var deep = __webpack_require__(541);
	var isFunction = __webpack_require__(267);
	var fromPairs = __webpack_require__(1429);
	var assign = __webpack_require__(264);
	var defaults = __webpack_require__(1423);
	var toPairs = __webpack_require__(1449);
	var without = __webpack_require__(582);
	
	var GridRow = React.createClass({
	  displayName: 'GridRow',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "isChildRow": false,
	      "showChildren": false,
	      "data": {},
	      "columnSettings": null,
	      "rowSettings": null,
	      "hasChildren": false,
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "onRowClick": null,
	      "multipleSelectionSettings": null
	    };
	  },
	  handleClick: function handleClick(e) {
	    if (this.props.onRowClick !== null && isFunction(this.props.onRowClick)) {
	      this.props.onRowClick(this, e);
	    } else if (this.props.hasChildren) {
	      this.props.toggleChildren();
	    }
	  },
	  handleSelectionChange: function handleSelectionChange(e) {
	    //hack to get around warning that's not super useful in this case
	    return;
	  },
	  handleSelectClick: function handleSelectClick(e) {
	    if (this.props.multipleSelectionSettings.isMultipleSelection) {
	      if (e.target.type === "checkbox") {
	        this.props.multipleSelectionSettings.toggleSelectRow(this.props.data, this.refs.selected.checked);
	      } else {
	        this.props.multipleSelectionSettings.toggleSelectRow(this.props.data, !this.refs.selected.checked);
	      }
	    }
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridRow: The columnSettings prop is null and it shouldn't be");
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    this.verifyProps();
	    var that = this;
	    var columnStyles = null;
	
	    if (this.props.useGriddleStyles) {
	      columnStyles = {
	        margin: "0px",
	        padding: that.props.paddingHeight + "px 5px " + that.props.paddingHeight + "px 5px",
	        height: that.props.rowHeight ? this.props.rowHeight - that.props.paddingHeight * 2 + "px" : null,
	        backgroundColor: "#FFF",
	        borderTopColor: "#DDD",
	        color: "#222"
	      };
	    }
	
	    var columns = this.props.columnSettings.getColumns();
	
	    // make sure that all the columns we need have default empty values
	    // otherwise they will get clipped
	    var defaultValues = fromPairs(columns, []);
	
	    // creates a 'view' on top the data so we will not alter the original data but will allow us to add default values to missing columns
	    var dataView = assign({}, this.props.data);
	
	    defaults(dataView, defaultValues);
	    var data = toPairs(deep.pick(dataView, without(columns, 'children')));
	    var nodes = data.map(function (col, index) {
	      var returnValue = null;
	      var meta = _this.props.columnSettings.getColumnMetadataByName(col[0]);
	
	      //todo: Make this not as ridiculous looking
	      var firstColAppend = index === 0 && _this.props.hasChildren && _this.props.showChildren === false && _this.props.useGriddleIcons ? React.createElement('span', { style: _this.props.useGriddleStyles ? { fontSize: "10px", marginRight: "5px" } : null }, _this.props.parentRowCollapsedComponent) : index === 0 && _this.props.hasChildren && _this.props.showChildren && _this.props.useGriddleIcons ? React.createElement('span', { style: _this.props.useGriddleStyles ? { fontSize: "10px" } : null }, _this.props.parentRowExpandedComponent) : "";
	
	      if (index === 0 && _this.props.isChildRow && _this.props.useGriddleStyles) {
	        columnStyles = assign(columnStyles, { paddingLeft: 10 });
	      }
	
	      if (_this.props.columnSettings.hasColumnMetadata() && typeof meta !== 'undefined' && meta !== null) {
	        if (typeof meta.customComponent !== 'undefined' && meta.customComponent !== null) {
	          var customComponent = React.createElement(meta.customComponent, { data: col[1], rowData: dataView, metadata: meta });
	          returnValue = React.createElement('td', { onClick: _this.handleClick, className: meta.cssClassName, key: index, style: columnStyles }, customComponent);
	        } else {
	          returnValue = React.createElement('td', { onClick: _this.handleClick, className: meta.cssClassName, key: index, style: columnStyles }, firstColAppend, col[1]);
	        }
	      }
	
	      return returnValue || React.createElement('td', { onClick: _this.handleClick, key: index, style: columnStyles }, firstColAppend, col[1]);
	    });
	
	    if (nodes && this.props.multipleSelectionSettings && this.props.multipleSelectionSettings.isMultipleSelection) {
	      var selectedRowIds = this.props.multipleSelectionSettings.getSelectedRowIds();
	
	      nodes.unshift(React.createElement('td', { key: 'selection', style: columnStyles }, React.createElement('input', {
	        type: 'checkbox',
	        checked: this.props.multipleSelectionSettings.getIsRowChecked(dataView),
	        onChange: this.handleSelectionChange,
	        ref: 'selected' })));
	    }
	
	    //Get the row from the row settings.
	    var className = that.props.rowSettings && that.props.rowSettings.getBodyRowMetadataClass(that.props.data) || "standard-row";
	
	    if (that.props.isChildRow) {
	      className = "child-row";
	    } else if (that.props.hasChildren) {
	      className = that.props.showChildren ? this.props.parentRowExpandedClassName : this.props.parentRowCollapsedClassName;
	    }
	    return React.createElement('tr', { onClick: this.props.multipleSelectionSettings && this.props.multipleSelectionSettings.isMultipleSelection ? this.handleSelectClick : null, className: className }, nodes);
	  }
	});
	
	module.exports = GridRow;


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(1);
	var includes = __webpack_require__(1430);
	var without = __webpack_require__(582);
	var find = __webpack_require__(368);
	
	var GridSettings = React.createClass({
	    displayName: 'GridSettings',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columns": [],
	            "columnMetadata": [],
	            "selectedColumns": [],
	            "settingsText": "",
	            "maxRowsText": "",
	            "resultsPerPage": 0,
	            "enableToggleCustom": false,
	            "useCustomComponent": false,
	            "useGriddleStyles": true,
	            "toggleCustomComponent": function toggleCustomComponent() {}
	        };
	    },
	    setPageSize: function setPageSize(event) {
	        var value = parseInt(event.target.value, 10);
	        this.props.setPageSize(value);
	    },
	    handleChange: function handleChange(event) {
	        var columnName = event.target.dataset ? event.target.dataset.name : event.target.getAttribute('data-name');
	        if (event.target.checked === true && includes(this.props.selectedColumns, columnName) === false) {
	            this.props.selectedColumns.push(columnName);
	            this.props.setColumns(this.props.selectedColumns);
	        } else {
	            /* redraw with the selected columns minus the one just unchecked */
	            this.props.setColumns(without(this.props.selectedColumns, columnName));
	        }
	    },
	    render: function render() {
	        var that = this;
	
	        var nodes = [];
	        //don't show column selector if we're on a custom component
	        if (that.props.useCustomComponent === false) {
	            nodes = this.props.columns.map(function (col, index) {
	                var checked = includes(that.props.selectedColumns, col);
	                //check column metadata -- if this one is locked make it disabled and don't put an onChange event
	                var meta = find(that.props.columnMetadata, { columnName: col });
	                var displayName = col;
	
	                if (typeof meta !== "undefined" && typeof meta.displayName !== "undefined" && meta.displayName != null) {
	                    displayName = meta.displayName;
	                }
	
	                if (typeof meta !== "undefined" && meta != null && meta.locked) {
	                    return React.createElement('div', { className: 'column checkbox' }, React.createElement('label', null, React.createElement('input', { type: 'checkbox', disabled: true, name: 'check', checked: checked, 'data-name': col }), displayName));
	                } else if (typeof meta !== "undefined" && meta != null && typeof meta.visible !== "undefined" && meta.visible === false) {
	                    return null;
	                }
	                return React.createElement('div', { className: 'griddle-column-selection checkbox', key: col, style: that.props.useGriddleStyles ? { "float": "left", width: "20%" } : null }, React.createElement('label', null, React.createElement('input', { type: 'checkbox', name: 'check', onChange: that.handleChange, checked: checked, 'data-name': col }), displayName));
	            });
	        }
	
	        var toggleCustom = that.props.enableToggleCustom ? React.createElement('div', { className: 'form-group' }, React.createElement('label', { htmlFor: 'maxRows' }, React.createElement('input', { type: 'checkbox', checked: this.props.useCustomComponent, onChange: this.props.toggleCustomComponent }), ' ', this.props.enableCustomFormatText)) : "";
	
	        var setPageSize = this.props.showSetPageSize ? React.createElement('div', null, React.createElement('label', { htmlFor: 'maxRows' }, this.props.maxRowsText, ':', React.createElement('select', { onChange: this.setPageSize, value: this.props.resultsPerPage }, React.createElement('option', { value: '5' }, '5'), React.createElement('option', { value: '10' }, '10'), React.createElement('option', { value: '25' }, '25'), React.createElement('option', { value: '50' }, '50'), React.createElement('option', { value: '100' }, '100')))) : "";
	
	        return React.createElement('div', { className: 'griddle-settings', style: this.props.useGriddleStyles ? { backgroundColor: "#FFF", border: "1px solid #DDD", color: "#222", padding: "10px", marginBottom: "10px" } : null }, React.createElement('h6', null, this.props.settingsText), React.createElement('div', { className: 'griddle-columns', style: this.props.useGriddleStyles ? { clear: "both", display: "table", width: "100%", borderBottom: "1px solid #EDEDED", marginBottom: "10px" } : null }, nodes), setPageSize, toggleCustom);
	    }
	});
	
	module.exports = GridSettings;


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	/*
	   See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	*/
	'use strict';
	
	var React = __webpack_require__(1);
	var GridTitle = __webpack_require__(1319);
	var GridRowContainer = __webpack_require__(542);
	var ColumnProperties = __webpack_require__(197);
	var RowProperties = __webpack_require__(543);
	
	var GridTable = React.createClass({
	  displayName: 'GridTable',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      "data": [],
	      "columnSettings": null,
	      "rowSettings": null,
	      "sortSettings": null,
	      "multipleSelectionSettings": null,
	      "className": "",
	      "enableInfiniteScroll": false,
	      "nextPage": null,
	      "hasMorePages": false,
	      "useFixedHeader": false,
	      "useFixedLayout": true,
	      "paddingHeight": null,
	      "rowHeight": null,
	      "filterByColumn": null,
	      "infiniteScrollLoadTreshold": null,
	      "bodyHeight": null,
	      "useGriddleStyles": true,
	      "useGriddleIcons": true,
	      "isSubGriddle": false,
	      "parentRowCollapsedClassName": "parent-row",
	      "parentRowExpandedClassName": "parent-row expanded",
	      "parentRowCollapsedComponent": "▶",
	      "parentRowExpandedComponent": "▼",
	      "externalLoadingComponent": null,
	      "externalIsLoading": false,
	      "onRowClick": null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      scrollTop: 0,
	      scrollHeight: this.props.bodyHeight,
	      clientHeight: this.props.bodyHeight
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    // After the initial render, see if we need to load additional pages.
	    this.gridScroll();
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // After the subsequent renders, see if we need to load additional pages.
	    this.gridScroll();
	  },
	  gridScroll: function gridScroll() {
	    if (this.props.enableInfiniteScroll && !this.props.externalIsLoading) {
	      // If the scroll height is greater than the current amount of rows displayed, update the page.
	      var scrollable = this.refs.scrollable;
	      var scrollTop = scrollable.scrollTop;
	      var scrollHeight = scrollable.scrollHeight;
	      var clientHeight = scrollable.clientHeight;
	
	      // If the scroll position changed and the difference is greater than a row height
	      if (this.props.rowHeight !== null && this.state.scrollTop !== scrollTop && Math.abs(this.state.scrollTop - scrollTop) >= this.getAdjustedRowHeight()) {
	        var newState = {
	          scrollTop: scrollTop,
	          scrollHeight: scrollHeight,
	          clientHeight: clientHeight
	        };
	
	        // Set the state to the new state
	        this.setState(newState);
	      }
	
	      // Determine the diff by subtracting the amount scrolled by the total height, taking into consideratoin
	      // the spacer's height.
	      var scrollHeightDiff = scrollHeight - (scrollTop + clientHeight) - this.props.infiniteScrollLoadTreshold;
	
	      // Make sure that we load results a little before reaching the bottom.
	      var compareHeight = scrollHeightDiff * 0.6;
	
	      if (compareHeight <= this.props.infiniteScrollLoadTreshold) {
	        this.props.nextPage();
	      }
	    }
	  },
	  verifyProps: function verifyProps() {
	    if (this.props.columnSettings === null) {
	      console.error("gridTable: The columnSettings prop is null and it shouldn't be");
	    }
	    if (this.props.rowSettings === null) {
	      console.error("gridTable: The rowSettings prop is null and it shouldn't be");
	    }
	  },
	  getAdjustedRowHeight: function getAdjustedRowHeight() {
	    return this.props.rowHeight + this.props.paddingHeight * 2; // account for padding.
	  },
	  getNodeContent: function getNodeContent() {
	    this.verifyProps();
	    var that = this;
	
	    //figure out if we need to wrap the group in one tbody or many
	    var anyHasChildren = false;
	
	    // If the data is still being loaded, don't build the nodes unless this is an infinite scroll table.
	    if (!this.props.externalIsLoading || this.props.enableInfiniteScroll) {
	      var nodeData = that.props.data;
	      var aboveSpacerRow = null;
	      var belowSpacerRow = null;
	      var usingDefault = false;
	
	      // If we have a row height specified, only render what's going to be visible.
	      if (this.props.enableInfiniteScroll && this.props.rowHeight !== null && this.refs.scrollable !== undefined) {
	        var adjustedHeight = that.getAdjustedRowHeight();
	        var visibleRecordCount = Math.ceil(that.state.clientHeight / adjustedHeight);
	
	        // Inspired by : http://jsfiddle.net/vjeux/KbWJ2/9/
	        var displayStart = Math.max(0, Math.floor(that.state.scrollTop / adjustedHeight) - visibleRecordCount * 0.25);
	        var displayEnd = Math.min(displayStart + visibleRecordCount * 1.25, this.props.data.length - 1);
	
	        // Split the amount of nodes.
	        nodeData = nodeData.slice(displayStart, displayEnd + 1);
	
	        // Set the above and below nodes.
	        var aboveSpacerRowStyle = { height: displayStart * adjustedHeight + "px" };
	        aboveSpacerRow = React.createElement('tr', { key: 'above-' + aboveSpacerRowStyle.height, style: aboveSpacerRowStyle });
	        var belowSpacerRowStyle = { height: (this.props.data.length - displayEnd) * adjustedHeight + "px" };
	        belowSpacerRow = React.createElement('tr', { key: 'below-' + belowSpacerRowStyle.height, style: belowSpacerRowStyle });
	      }
	
	      var nodes = nodeData.map(function (row, index) {
	        var hasChildren = typeof row["children"] !== "undefined" && row["children"].length > 0;
	        var uniqueId = that.props.rowSettings.getRowKey(row, index);
	
	        //at least one item in the group has children.
	        if (hasChildren) {
	          anyHasChildren = hasChildren;
	        }
	
	        return React.createElement(GridRowContainer, {
	          useGriddleStyles: that.props.useGriddleStyles,
	          isSubGriddle: that.props.isSubGriddle,
	          parentRowExpandedClassName: that.props.parentRowExpandedClassName,
	          parentRowCollapsedClassName: that.props.parentRowCollapsedClassName,
	          parentRowExpandedComponent: that.props.parentRowExpandedComponent,
	          parentRowCollapsedComponent: that.props.parentRowCollapsedComponent,
	          data: row,
	          key: uniqueId + '-container',
	          uniqueId: uniqueId,
	          columnSettings: that.props.columnSettings,
	          rowSettings: that.props.rowSettings,
	          paddingHeight: that.props.paddingHeight,
	          multipleSelectionSettings: that.props.multipleSelectionSettings,
	          rowHeight: that.props.rowHeight,
	          hasChildren: hasChildren,
	          tableClassName: that.props.className,
	          onRowClick: that.props.onRowClick
	        });
	      });
	
	      // no data section
	      if (this.props.showNoData) {
	        var colSpan = this.props.columnSettings.getVisibleColumnCount();
	        nodes.push(React.createElement('tr', { key: 'no-data-section' }, React.createElement('td', { colSpan: colSpan }, this.props.noDataSection)));
	      }
	
	      // Add the spacer rows for nodes we're not rendering.
	      if (aboveSpacerRow) {
	        nodes.unshift(aboveSpacerRow);
	      }
	      if (belowSpacerRow) {
	        nodes.push(belowSpacerRow);
	      }
	
	      // Send back the nodes.
	      return {
	        nodes: nodes,
	        anyHasChildren: anyHasChildren
	      };
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var that = this;
	    var nodes = [];
	
	    // for if we need to wrap the group in one tbody or many
	    var anyHasChildren = false;
	
	    // Grab the nodes to render
	    var nodeContent = this.getNodeContent();
	    if (nodeContent) {
	      nodes = nodeContent.nodes;
	      anyHasChildren = nodeContent.anyHasChildren;
	    }
	
	    var gridStyle = null;
	    var loadingContent = null;
	    var tableStyle = {
	      width: "100%"
	    };
	
	    if (this.props.useFixedLayout) {
	      tableStyle.tableLayout = "fixed";
	    }
	
	    if (this.props.enableInfiniteScroll) {
	      // If we're enabling infinite scrolling, we'll want to include the max height of the grid body + allow scrolling.
	      gridStyle = {
	        "position": "relative",
	        "overflowY": "scroll",
	        "height": this.props.bodyHeight + "px",
	        "width": "100%"
	      };
	    }
	
	    // If we're currently loading, populate the loading content
	    if (this.props.externalIsLoading) {
	      var defaultLoadingStyle = null;
	      var defaultColSpan = null;
	
	      if (this.props.useGriddleStyles) {
	        defaultLoadingStyle = {
	          textAlign: "center",
	          paddingBottom: "40px"
	        };
	
	        defaultColSpan = this.props.columnSettings.getVisibleColumnCount();
	      }
	
	      var loadingComponent = this.props.externalLoadingComponent ? React.createElement(this.props.externalLoadingComponent, null) : React.createElement('div', null, 'Loading...');
	
	      loadingContent = React.createElement('tbody', null, React.createElement('tr', null, React.createElement('td', { style: defaultLoadingStyle, colSpan: defaultColSpan }, loadingComponent)));
	    }
	
	    //construct the table heading component
	    var tableHeading = this.props.showTableHeading ? React.createElement(GridTitle, { useGriddleStyles: this.props.useGriddleStyles, useGriddleIcons: this.props.useGriddleIcons,
	      sortSettings: this.props.sortSettings,
	      multipleSelectionSettings: this.props.multipleSelectionSettings,
	      columnSettings: this.props.columnSettings,
	      filterByColumn: this.props.filterByColumn,
	      rowSettings: this.props.rowSettings }) : undefined;
	
	    //check to see if any of the rows have children... if they don't wrap everything in a tbody so the browser doesn't auto do this
	    if (!anyHasChildren) {
	      nodes = React.createElement('tbody', null, nodes);
	    }
	
	    var pagingContent = React.createElement('tbody', null);
	    if (this.props.showPager) {
	      var pagingStyles = this.props.useGriddleStyles ? {
	        padding: "0px",
	        backgroundColor: "#EDEDED",
	        border: "0px",
	        color: "#222",
	        height: this.props.showNoData ? "20px" : null
	      } : null;
	      pagingContent = React.createElement('tbody', null, React.createElement('tr', null, React.createElement('td', { colSpan: this.props.multipleSelectionSettings.isMultipleSelection ? this.props.columnSettings.getVisibleColumnCount() + 1 : this.props.columnSettings.getVisibleColumnCount(), style: pagingStyles, className: 'footer-container' }, !this.props.showNoData ? this.props.pagingContent : null)));
	    }
	
	    // If we have a fixed header, split into two tables.
	    if (this.props.useFixedHeader) {
	      if (this.props.useGriddleStyles) {
	        tableStyle.tableLayout = "fixed";
	      }
	
	      return React.createElement('div', null, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, tableHeading), React.createElement('div', { ref: 'scrollable', onScroll: this.gridScroll, style: gridStyle }, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, nodes, loadingContent, pagingContent)));
	    }
	
	    return React.createElement('div', { ref: 'scrollable', onScroll: this.gridScroll, style: gridStyle }, React.createElement('table', { className: this.props.className, style: this.props.useGriddleStyles && tableStyle || null }, tableHeading, nodes, loadingContent, pagingContent));
	  }
	});
	
	module.exports = GridTable;


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 See License / Disclaimer https://raw.githubusercontent.com/DynamicTyped/Griddle/master/LICENSE
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }return target;
	};
	
	var React = __webpack_require__(1);
	var ColumnProperties = __webpack_require__(197);
	var assign = __webpack_require__(264);
	
	var DefaultHeaderComponent = React.createClass({
	    displayName: 'DefaultHeaderComponent',
	
	    render: function render() {
	        return React.createElement('span', null, this.props.displayName);
	    }
	});
	
	var GridTitle = React.createClass({
	    displayName: 'GridTitle',
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            "columnSettings": null,
	            "filterByColumn": function filterByColumn() {},
	            "rowSettings": null,
	            "sortSettings": null,
	            "multipleSelectionSettings": null,
	            "headerStyle": null,
	            "useGriddleStyles": true,
	            "useGriddleIcons": true,
	            "headerStyles": {}
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this.verifyProps();
	    },
	    sort: function sort(column) {
	        var that = this;
	        return function (event) {
	            that.props.sortSettings.changeSort(column);
	        };
	    },
	    toggleSelectAll: function toggleSelectAll(event) {
	        this.props.multipleSelectionSettings.toggleSelectAll();
	    },
	    handleSelectionChange: function handleSelectionChange(event) {
	        //hack to get around warning message that's not helpful in this case
	        return;
	    },
	    verifyProps: function verifyProps() {
	        if (this.props.columnSettings === null) {
	            console.error("gridTitle: The columnSettings prop is null and it shouldn't be");
	        }
	
	        if (this.props.sortSettings === null) {
	            console.error("gridTitle: The sortSettings prop is null and it shouldn't be");
	        }
	    },
	    render: function render() {
	        this.verifyProps();
	        var that = this;
	        var titleStyles = {};
	
	        var nodes = this.props.columnSettings.getColumns().map(function (col, index) {
	            var defaultTitleStyles = {};
	            var columnSort = "";
	            var columnIsSortable = that.props.columnSettings.getMetadataColumnProperty(col, "sortable", true);
	            var sortComponent = columnIsSortable ? that.props.sortSettings.sortDefaultComponent : null;
	
	            if (that.props.sortSettings.sortColumn == col && that.props.sortSettings.sortDirection === 'asc') {
	                columnSort = that.props.sortSettings.sortAscendingClassName;
	                sortComponent = that.props.useGriddleIcons && that.props.sortSettings.sortAscendingComponent;
	            } else if (that.props.sortSettings.sortColumn == col && that.props.sortSettings.sortDirection === 'desc') {
	                columnSort += that.props.sortSettings.sortDescendingClassName;
	                sortComponent = that.props.useGriddleIcons && that.props.sortSettings.sortDescendingComponent;
	            }
	
	            var meta = that.props.columnSettings.getColumnMetadataByName(col);
	            var displayName = that.props.columnSettings.getMetadataColumnProperty(col, "displayName", col);
	            var HeaderComponent = that.props.columnSettings.getMetadataColumnProperty(col, "customHeaderComponent", DefaultHeaderComponent);
	            var headerProps = that.props.columnSettings.getMetadataColumnProperty(col, "customHeaderComponentProps", {});
	
	            columnSort = meta == null ? columnSort : (columnSort && columnSort + " " || columnSort) + that.props.columnSettings.getMetadataColumnProperty(col, "cssClassName", "");
	
	            if (that.props.useGriddleStyles) {
	                defaultTitleStyles = {
	                    backgroundColor: "#EDEDEF",
	                    border: "0px",
	                    borderBottom: "1px solid #DDD",
	                    color: "#222",
	                    padding: "5px",
	                    cursor: columnIsSortable ? "pointer" : "default"
	                };
	            }
	            titleStyles = meta && meta.titleStyles ? assign({}, defaultTitleStyles, meta.titleStyles) : assign({}, defaultTitleStyles);
	            return React.createElement('th', { onClick: columnIsSortable ? that.sort(col) : null, 'data-title': col, className: columnSort, key: col,
	                style: titleStyles }, React.createElement(HeaderComponent, _extends({ columnName: col, displayName: displayName,
	                filterByColumn: that.props.filterByColumn }, headerProps)), sortComponent);
	        });
	
	        if (nodes && this.props.multipleSelectionSettings.isMultipleSelection) {
	            nodes.unshift(React.createElement('th', { key: 'selection', onClick: this.toggleSelectAll, style: titleStyles }, React.createElement('input', { type: 'checkbox',
	                checked: this.props.multipleSelectionSettings.getIsSelectAllChecked(),
	                onChange: this.handleSelectionChange })));
	        }
	
	        //Get the row from the row settings.
	        var className = that.props.rowSettings && that.props.rowSettings.getHeaderRowMetadataClass() || null;
	
	        return React.createElement('thead', null, React.createElement('tr', {
	            className: className,
	            style: this.props.headerStyles }, nodes));
	    }
	});
	
	module.exports = GridTitle;


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(81);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1384),
	    hashDelete = __webpack_require__(1385),
	    hashGet = __webpack_require__(1386),
	    hashHas = __webpack_require__(1387),
	    hashSet = __webpack_require__(1388);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(81);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1323 */
[1789, 135, 81],
/* 1324 */
[1792, 135, 81],
/* 1325 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(553);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 1327 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 1328 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1329 */
[1793, 163, 97],
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(163),
	    keysIn = __webpack_require__(371);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    arrayEach = __webpack_require__(546),
	    assignValue = __webpack_require__(258),
	    baseAssign = __webpack_require__(1329),
	    baseAssignIn = __webpack_require__(1330),
	    cloneBuffer = __webpack_require__(1361),
	    copyArray = __webpack_require__(1368),
	    copySymbols = __webpack_require__(1369),
	    copySymbolsIn = __webpack_require__(1370),
	    getAllKeys = __webpack_require__(563),
	    getAllKeysIn = __webpack_require__(564),
	    getTag = __webpack_require__(164),
	    initCloneArray = __webpack_require__(1389),
	    initCloneByTag = __webpack_require__(1390),
	    initCloneObject = __webpack_require__(1391),
	    isArray = __webpack_require__(38),
	    isBuffer = __webpack_require__(266),
	    isMap = __webpack_require__(1433),
	    isObject = __webpack_require__(83),
	    isSet = __webpack_require__(1436),
	    keys = __webpack_require__(97);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1333 */
[1795, 360],
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1374);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1335 */
[1796, 1334, 97],
/* 1336 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    equalArrays = __webpack_require__(560),
	    equalByTag = __webpack_require__(1378),
	    equalObjects = __webpack_require__(1379),
	    getTag = __webpack_require__(164),
	    isArray = __webpack_require__(38),
	    isBuffer = __webpack_require__(266),
	    isTypedArray = __webpack_require__(370);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(164),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    baseIsEqual = __webpack_require__(554);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1341 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(267),
	    isMasked = __webpack_require__(1394),
	    isObject = __webpack_require__(83),
	    toSource = __webpack_require__(572);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(164),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isLength = __webpack_require__(369),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83),
	    isPrototype = __webpack_require__(202),
	    nativeKeysIn = __webpack_require__(1407);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1340),
	    getMatchData = __webpack_require__(1380),
	    matchesStrictComparable = __webpack_require__(568);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(554),
	    get = __webpack_require__(575),
	    hasIn = __webpack_require__(576),
	    isKey = __webpack_require__(366),
	    isStrictComparable = __webpack_require__(566),
	    matchesStrictComparable = __webpack_require__(568),
	    toKey = __webpack_require__(165);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(1349),
	    hasIn = __webpack_require__(576);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(260),
	    baseSet = __webpack_require__(1352),
	    castPath = __webpack_require__(162);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 1350 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(260);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(258),
	    castPath = __webpack_require__(162),
	    isIndex = __webpack_require__(262),
	    isObject = __webpack_require__(83),
	    toKey = __webpack_require__(165);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1422),
	    defineProperty = __webpack_require__(559),
	    identity = __webpack_require__(204);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1354 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1355 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(133);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161),
	    arrayMap = __webpack_require__(133),
	    isArray = __webpack_require__(38),
	    isSymbol = __webpack_require__(205);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(162),
	    last = __webpack_require__(1439),
	    parent = __webpack_require__(1409),
	    toKey = __webpack_require__(165);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 1359 */
[1798, 133],
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(204);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(81);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(362);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1363 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1364 */
[1800, 161],
/* 1365 */
[1801, 362],
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(205);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1366);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1368 */
625,
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(163),
	    getSymbols = __webpack_require__(364);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(163),
	    getSymbolsIn = __webpack_require__(565);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(81);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(199),
	    isIterateeCall = __webpack_require__(365);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1373 */
[1802, 82],
/* 1374 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(198),
	    isArrayLike = __webpack_require__(82),
	    keys = __webpack_require__(97);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(1356),
	    getTag = __webpack_require__(164),
	    mapToArray = __webpack_require__(567),
	    setToPairs = __webpack_require__(1413);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(1435);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161),
	    Uint8Array = __webpack_require__(545),
	    eq = __webpack_require__(203),
	    equalArrays = __webpack_require__(560),
	    mapToArray = __webpack_require__(567),
	    setToArray = __webpack_require__(1412);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(563);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(566),
	    keys = __webpack_require__(97);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1382 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(162),
	    isArguments = __webpack_require__(265),
	    isArray = __webpack_require__(38),
	    isIndex = __webpack_require__(262),
	    isLength = __webpack_require__(369),
	    toKey = __webpack_require__(165);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(263);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1385 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(263);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(263);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(263);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1389 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(362),
	    cloneDataView = __webpack_require__(1362),
	    cloneRegExp = __webpack_require__(1363),
	    cloneSymbol = __webpack_require__(1364),
	    cloneTypedArray = __webpack_require__(1365);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1332),
	    getPrototype = __webpack_require__(363),
	    isPrototype = __webpack_require__(202);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161),
	    isArguments = __webpack_require__(265),
	    isArray = __webpack_require__(38);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1393 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1371);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1395 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(259);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(259);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(259);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(259);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1321),
	    ListCache = __webpack_require__(257),
	    Map = __webpack_require__(356);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(261);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(261);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(261);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(261);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1440);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(569);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1407 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1408 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(260),
	    baseSlice = __webpack_require__(200);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 1410 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1411 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1412 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1413 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ },
/* 1414 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(257);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1416 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1417 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1418 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(257),
	    Map = __webpack_require__(356),
	    MapCache = __webpack_require__(357);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1420 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1405);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1422 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(199),
	    eq = __webpack_require__(203),
	    isIterateeCall = __webpack_require__(365),
	    keysIn = __webpack_require__(371);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(550),
	    baseFlatten = __webpack_require__(361),
	    baseRest = __webpack_require__(199),
	    isArrayLikeObject = __webpack_require__(577);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(200),
	    toInteger = __webpack_require__(206);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.drop([1, 2, 3]);
	 * // => [2, 3]
	 *
	 * _.drop([1, 2, 3], 2);
	 * // => [3]
	 *
	 * _.drop([1, 2, 3], 5);
	 * // => []
	 *
	 * _.drop([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function drop(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = drop;


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(200),
	    toInteger = __webpack_require__(206);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(551),
	    baseIteratee = __webpack_require__(198),
	    toInteger = __webpack_require__(206);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(361);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 1429 */
/***/ function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(553),
	    isArrayLike = __webpack_require__(82),
	    isString = __webpack_require__(1437),
	    toInteger = __webpack_require__(206),
	    values = __webpack_require__(1451);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(200);
	
	/**
	 * Gets all but the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.initial([1, 2, 3]);
	 * // => [1, 2]
	 */
	function initial(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 0, -1) : [];
	}
	
	module.exports = initial;


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(555),
	    getTag = __webpack_require__(164),
	    isArguments = __webpack_require__(265),
	    isArray = __webpack_require__(38),
	    isArrayLike = __webpack_require__(82),
	    isBuffer = __webpack_require__(266),
	    isPrototype = __webpack_require__(202),
	    isTypedArray = __webpack_require__(370);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1339),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(367);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 1434 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    getPrototype = __webpack_require__(363),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1343),
	    baseUnary = __webpack_require__(201),
	    nodeUtil = __webpack_require__(367);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isArray = __webpack_require__(38),
	    isObjectLike = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 1438 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 1439 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(357);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(133),
	    baseClone = __webpack_require__(1331),
	    baseUnset = __webpack_require__(1358),
	    castPath = __webpack_require__(162),
	    copyObject = __webpack_require__(163),
	    customOmitClone = __webpack_require__(1377),
	    flatRest = __webpack_require__(561),
	    getAllKeysIn = __webpack_require__(564);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(557),
	    isArray = __webpack_require__(38);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1348),
	    flatRest = __webpack_require__(561);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(361),
	    baseOrderBy = __webpack_require__(557),
	    baseRest = __webpack_require__(199),
	    isIterateeCall = __webpack_require__(365);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1445 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(200),
	    toInteger = __webpack_require__(206);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1448);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83),
	    isSymbol = __webpack_require__(205);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(1376),
	    keys = __webpack_require__(97);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(581);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1359),
	    keys = __webpack_require__(97);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 1452 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(166);
	
	var _PathUtils = __webpack_require__(136);
	
	var _ExecutionEnvironment = __webpack_require__(268);
	
	var _DOMUtils = __webpack_require__(372);
	
	var _DOMStateStorage = __webpack_require__(583);
	
	var _createDOMHistory = __webpack_require__(584);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(166);
	
	var _PathUtils = __webpack_require__(136);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(85);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(136);
	
	var _Actions = __webpack_require__(166);
	
	var _createHistory = __webpack_require__(586);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1777);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1457 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1458 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			var _OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = _OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					return (document.cookie = [
						key, '=', value,
						attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
						attributes.path    && '; path=' + attributes.path,
						attributes.domain  && '; domain=' + attributes.domain,
						attributes.secure ? '; secure' : ''
					].join(''));
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var name = parts[0].replace(rdecode, decodeURIComponent);
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.get = api.set = api;
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 1460 */
/***/ function(module, exports) {

	module.exports = {"version":"2016d","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0","America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0","America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0","America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0","America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|zzz MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5","America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|zzz PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|zzz EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp0 1Vb0 3dB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|zzz AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|zzz MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|zzz AWST CAST|0 -80 -b0|012121|-2q00 1DjS0 T90 40P0 KL0|10","Antarctica/Davis|zzz DAVT DAVT|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|zzz PMT DDUT|0 -a0 -a0|0102|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT zzz MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|zzz MAWT MAWT|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|zzz ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40","Antarctica/Rothera|zzz ROTT|0 30|01|gOo0|130","Antarctica/Syowa|zzz SYOT|0 -30|01|-vs00|20","Antarctica/Troll|zzz UTC CEST|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|zzz VOST|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT ANAT ANAT ANAST ANAST ANAST ANAT|-bN.U -c0 -d0 -e0 -d0 -c0 -b0|01232414141414141414141561414141414141414141414141414141414141561|-1PcbN.U eUnN.U 23CL0 1db0 1cN0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT ASHT ASHT ASHST ASHST TMT TMT|-3R.w -40 -50 -60 -50 -40 -50|012323232323232323232324156|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 ba0 xC0|41e4","Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT BAKT BAKT BAKST BAKST AZST AZT AZT AZST|-3j.o -30 -40 -50 -40 -40 -30 -40 -50|01232323232323232323232456578787878787878787878787878787878787878787|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 10K0 c30 1cM0 1cI0 8wu0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT FRUT FRUT FRUST FRUST KGT KGST KGT|-4W.o -50 -60 -70 -60 -50 -60 -60|01232323232323232323232456565656565656565656565656567|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11c0 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 T8u|87e4","Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT YAKT YAKT YAKST YAKST YAKT IRKT|-7x.Q -80 -90 -a0 -90 -a0 -80|0123232323232323232323241232323232323232323232323232323232323232562|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT IST IHST IST LKT LKT|-5j.w -5u -60 -6u -6u -60|01231451|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4","Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT DUST DUST DUSST DUSST TJT|-4z.c -50 -60 -70 -60 -50|0123232323232323232323245|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 14N0|76e4","Asia/Gaza|EET EET EEST IST IDT|-20 -30 -30 -20 -30|010101010102020202020202020202023434343434343434343434343430202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|18e5","Asia/Hebron|EET EET EEST IST IDT|-20 -30 -30 -20 -30|01010101010202020202020202020202343434343434343434343434343020202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|25e4","Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT IRKT IRKT IRKST IRKST IRKT|-6V.5 -70 -80 -90 -80 -90|012323232323232323232324123232323232323232323232323232323232323252|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST TRST TRT|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1df0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e6","Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT PETT PETT PETST PETST|-ay.A -b0 -c0 -d0 -c0|01232323232323232323232412323232323232323232323232323232323232412|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|18e4","Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT YAKT YAKT YAKST YAKST VLAT VLAST VLAT YAKT|-92.d -80 -90 -a0 -90 -a0 -b0 -b0 -a0|01232323232323232323232412323232323232323232323232565656565656565782|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT KRAT KRAT KRAST KRAST KRAT|-6b.q -60 -70 -80 -70 -80|012323232323232323232324123232323232323232323232323232323232323252|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4","Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4","Asia/Magadan|LMT MAGT MAGT MAGST MAGST MAGT|-a3.c -a0 -b0 -c0 -b0 -c0|0123232323232323232323241232323232323232323232323232323232323232512|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT KRAT KRAT KRAST KRAST NOVST NOVT NOVT|-5M.M -60 -70 -80 -70 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232325672|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0 8Hz0|55e4","Asia/Novosibirsk|LMT NOVT NOVT NOVST NOVST|-5v.E -60 -70 -80 -70|0123232323232323232323241232341414141414141414141414141414141414121|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|15e5","Asia/Omsk|LMT OMST OMST OMSST OMSST OMST|-4R.u -50 -60 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232323252|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT JCST JST SAKT SAKST SAKST SAKT|-9u.M -90 -90 -b0 -c0 -b0 -a0|01234343434343434343434356343434343435656565656565656565656565656363|-2AGVu.M 1iaMu.M je00 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o10 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT SAMT SAMT SAMST TAST UZST UZT|-4r.R -40 -50 -60 -60 -60 -50|01234323232323232323232356|-1Pc4r.R eUor.R 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11x0 bf0|36e4","Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5","Asia/Srednekolymsk|LMT MAGT MAGT MAGST MAGST MAGT SRET|-ae.Q -a0 -b0 -c0 -b0 -c0 -b0|012323232323232323232324123232323232323232323232323232323232323256|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT TAST TAST TASST TASST UZST UZT|-4B.b -50 -60 -70 -60 -60 -50|01232323232323232323232456|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11y0 bf0|23e5","Asia/Tbilisi|TBMT TBIT TBIT TBIST TBIST GEST GET GET GEST|-2X.b -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565787878787878787878567|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 3y0 19f0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cM0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT YAKT YAKT MAGST MAGT MAGST MAGT MAGT VLAT VLAT|-9w.S -80 -90 -c0 -b0 -b0 -a0 -c0 -b0 -a0|0123434343434343434343456434343434343434343434343434343434343434789|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT VLAT VLAT VLAST VLAST VLAT|-8L.v -90 -a0 -b0 -a0 -b0|012323232323232323232324123232323232323232323232323232323232323252|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT YAKT YAKT YAKST YAKST YAKT|-8C.W -80 -90 -a0 -90 -a0|012323232323232323232324123232323232323232323232323232323232323252|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT SVET SVET SVEST SVEST YEKT YEKST YEKT|-42.x -3J.5 -40 -50 -60 -50 -50 -60 -60|0123434343434343434343435267676767676767676767676767676767676767686|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT YERT YERT YERST YERST AMST AMT AMT AMST|-2W -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565657878787878787878787878787878787|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1am0 2r0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fb0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|GST|20|0||30","Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|GMT+1|10|0|","Etc/GMT+10|GMT+10|a0|0|","Etc/GMT+11|GMT+11|b0|0|","Etc/GMT+12|GMT+12|c0|0|","Etc/GMT+2|GMT+2|20|0|","Etc/GMT+3|GMT+3|30|0|","Etc/GMT+4|GMT+4|40|0|","Etc/GMT+5|GMT+5|50|0|","Etc/GMT+6|GMT+6|60|0|","Etc/GMT+7|GMT+7|70|0|","Etc/GMT+8|GMT+8|80|0|","Etc/GMT+9|GMT+9|90|0|","Etc/GMT-1|GMT-1|-10|0|","Etc/GMT-10|GMT-10|-a0|0|","Etc/GMT-11|GMT-11|-b0|0|","Etc/GMT-12|GMT-12|-c0|0|","Etc/GMT-13|GMT-13|-d0|0|","Etc/GMT-14|GMT-14|-e0|0|","Etc/GMT-2|GMT-2|-20|0|","Etc/GMT-3|GMT-3|-30|0|","Etc/GMT-4|GMT-4|-40|0|","Etc/GMT-5|GMT-5|-50|0|","Etc/GMT-6|GMT-6|-60|0|","Etc/GMT-7|GMT-7|-70|0|","Etc/GMT-8|GMT-8|-80|0|","Etc/GMT-9|GMT-9|-90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET FET|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WNi.M qHai.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 1cM0 1cM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1cp0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST FET|-1O -20 -30 -20 -10 -40 -30 -30|012343432525252525252525252616161616161616161616161616161616161616172|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cK0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hy0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK MSM EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c20 imv.j 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 16K0 1iO0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1C10 Lz0 1zd0 On0 1C10 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT SAMT SAMT KUYT KUYST MSD MSK EEST SAMST SAMST|-3k.k -30 -40 -40 -50 -40 -30 -30 -50 -40|012343434343434343435656712828282828282828282828282828282828282912|-22WNk.k qHak.k bcn0 1Qqo0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cN0 8o0 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|12e5","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WNd.A qHad.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT TSAT STAT STAT VOLT VOLST VOLST VOLT MSD MSK MSK|-2V.E -30 -30 -40 -40 -50 -40 -30 -40 -30 -40|0123454545454545454676767489898989898989898989898989898989898989a9|-21IqV.E cLXV.E cEM0 1gqn0 Lco0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Christmas|CXT|-70|0||21e2","Indian/Cocos|CCT|-6u|0||596","Indian/Kerguelen|zzz TFT|0 -50|01|-MG00|130","Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|CHUT|-a0|0||49e3","Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Funafuti|TVT|-c0|0||45e2","Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3","Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2","Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|PWT|-90|0||21e3","Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56","Pacific/Pohnpei|PONT|-b0|0||34e3","Pacific/Port_Moresby|PGT|-a0|0||25e4","Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4","Pacific/Tarawa|GILT|-c0|0||29e3","Pacific/Tongatapu|TOT TOT TOST|-ck -d0 -e0|01212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0|75e3","Pacific/Wake|WAKT|-c0|0||16e3","Pacific/Wallis|WFT|-c0|0||94","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Singapore|Singapore","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(86);
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(1585);
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input, compressionOptions) {
	    return pako.deflateRaw(input, {
	        level : compressionOptions.level || -1 // default compression
	    });
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(377);
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(380);
	JSZip.prototype.load = __webpack_require__(1465);
	JSZip.support = __webpack_require__(207);
	JSZip.defaults = __webpack_require__(591);
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = __webpack_require__(1462);
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = __webpack_require__(378);
	module.exports = JSZip;


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var base64 = __webpack_require__(377);
	var ZipEntries = __webpack_require__(1470);
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            unixPermissions : input.unixPermissions,
	            dosPermissions : input.dosPermissions,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(594);
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	var support = __webpack_require__(207);
	var nodeBuffer = __webpack_require__(379);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(593);
	var NodeBufferReader = __webpack_require__(1466);
	var Uint8ArrayReader = __webpack_require__(594);
	var utils = __webpack_require__(86);
	var sig = __webpack_require__(592);
	var ZipEntry = __webpack_require__(1471);
	var support = __webpack_require__(207);
	var jszipProto = __webpack_require__(380);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = true;
	            try {
	                this.reader.setIndex(0);
	                this.checkSignature(sig.LOCAL_FILE_HEADER);
	                isGarbage = false;
	            } catch (e) {}
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip : can't find end of central directory");
	            }
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(593);
	var utils = __webpack_require__(86);
	var CompressedObject = __webpack_require__(589);
	var jszipProto = __webpack_require__(380);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileName.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _util = __webpack_require__(1783);
	
	var _lruCache = __webpack_require__(1473);
	
	var _lruCache2 = _interopRequireDefault(_lruCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WHITESPACE_X = /\s+/g;
	
	function vaccuum(string) {
	  return string.replace(WHITESPACE_X, '');
	}
	
	function hash(object) {
	  return vaccuum((0, _util.inspect)(object, {
	    depth: Infinity,
	    showHidden: true
	  }));
	}
	
	var cache = (0, _lruCache2.default)(100);
	
	function validate(anArrayOfKeys) {
	  var moduleOutputPrefix = '[keykey]';
	
	  if (!Array.isArray(anArrayOfKeys)) {
	    throw new TypeError(moduleOutputPrefix + ' Must call with an array.');
	  }
	}
	
	function reduce(anArrayOfKeys, each) {
	  var subObject = {};
	  anArrayOfKeys.forEach(each.bind(each, subObject, anArrayOfKeys));
	  return subObject;
	}
	
	function set(anArrayOfKeys) {
	  var key = hash(anArrayOfKeys);
	  return cache.set(key, anArrayOfKeys);
	}
	
	function create(anArrayOfKeys, bypassCache) {
	  validate(anArrayOfKeys);
	
	  var creation = reduce(anArrayOfKeys, function (result, _, key) {
	    result[key] = key;
	  });
	
	  !bypassCache && set(creation);
	  return creation;
	}
	
	function get(anArrayOfKeys) {
	  return cache.get(hash(anArrayOfKeys)) || create(anArrayOfKeys);
	}
	
	function isUndef(o) {
	  return typeof o === 'undefined';
	}
	
	function isBool(o) {
	  return typeof o === 'boolean';
	}
	
	function last(a) {
	  return a[a.length - 1];
	}
	
	function notUndefOrBool(o) {
	  return !isUndef(o) && !isBool(o);
	}
	
	function KeyKey(anArrayOfKeys, bypassCache) {
	  // Allow non-array input while maintaining cache decision-point
	  if (notUndefOrBool(bypassCache)) {
	    anArrayOfKeys = [].slice.call(arguments);
	    var lastKey = last(anArrayOfKeys);
	    if (isBool(lastKey)) {
	      bypassCache = lastKey;
	      anArrayOfKeys.pop();
	    } else {
	      bypassCache = false;
	    }
	  }
	
	  return bypassCache ? create(anArrayOfKeys, bypassCache) : get(anArrayOfKeys);
	}
	
	module.exports = KeyKey;
	
	module.exports.reset = function () {
	  return cache.reset();
	};
	
	module.exports.resetCache = module.exports.reset;
	
	module.exports.cacheKeys = function () {
	  return cache.keys();
	};
	
	module.exports.cacheValues = function () {
	  return cache.values();
	};

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = LRUCache
	
	// This will be a proper iterable 'Map' in engines that support it,
	// or a fakey-fake PseudoMap in older versions.
	var Map = __webpack_require__(1598)
	
	function naiveLength () { return 1 }
	
	function LRUCache (options) {
	  if (!(this instanceof LRUCache))
	    return new LRUCache(options)
	
	  if (typeof options === 'number')
	    options = { max: options }
	
	  if (!options)
	    options = {}
	
	  this._max = options.max
	  // Kind of weird to have a default max of Infinity, but oh well.
	  if (!this._max || !(typeof this._max === "number") || this._max <= 0 )
	    this._max = Infinity
	
	  this._lengthCalculator = options.length || naiveLength
	  if (typeof this._lengthCalculator !== "function")
	    this._lengthCalculator = naiveLength
	
	  this._allowStale = options.stale || false
	  this._maxAge = options.maxAge || null
	  this._dispose = options.dispose
	  this.reset()
	}
	
	// resize the cache when the max changes.
	Object.defineProperty(LRUCache.prototype, "max",
	  { set : function (mL) {
	      if (!mL || !(typeof mL === "number") || mL <= 0 ) mL = Infinity
	      this._max = mL
	      if (this._length > this._max) trim(this)
	    }
	  , get : function () { return this._max }
	  , enumerable : true
	  })
	
	// resize the cache when the lengthCalculator changes.
	Object.defineProperty(LRUCache.prototype, "lengthCalculator",
	  { set : function (lC) {
	      if (typeof lC !== "function") {
	        this._lengthCalculator = naiveLength
	        this._length = this._lruList.size
	        this._cache.forEach(function (value, key) {
	          value.length = 1
	        })
	      } else {
	        this._lengthCalculator = lC
	        this._length = 0
	        this._cache.forEach(function (value, key) {
	          value.length = this._lengthCalculator(value.value, key)
	          this._length += value.length
	        }, this)
	      }
	
	      if (this._length > this._max) trim(this)
	    }
	  , get : function () { return this._lengthCalculator }
	  , enumerable : true
	  })
	
	Object.defineProperty(LRUCache.prototype, "length",
	  { get : function () { return this._length }
	  , enumerable : true
	  })
	
	Object.defineProperty(LRUCache.prototype, "itemCount",
	  { get : function () { return this._lruList.size }
	  , enumerable : true
	  })
	
	function reverseKeys (map) {
	  // keys live in lruList map in insertion order.
	  // we want them in reverse insertion order.
	  // flip the list of keys.
	  var itemCount = map.size
	  var keys = new Array(itemCount)
	  var i = itemCount
	  map.forEach(function (value, key) {
	    keys[--i] = key
	  })
	
	  return keys
	}
	
	LRUCache.prototype.rforEach = function (fn, thisp) {
	  thisp = thisp || this
	  this._lruList.forEach(function (hit) {
	    forEachStep(this, fn, hit, thisp)
	  }, this)
	}
	
	function forEachStep (self, fn, hit, thisp) {
	  if (isStale(self, hit)) {
	    del(self, hit)
	    if (!self._allowStale) {
	      hit = undefined
	    }
	  }
	  if (hit) {
	    fn.call(thisp, hit.value, hit.key, self)
	  }
	}
	
	
	LRUCache.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	
	  var keys = reverseKeys(this._lruList)
	  for (var k = 0; k < keys.length; k++) {
	    var hit = this._lruList.get(keys[k])
	    forEachStep(this, fn, hit, thisp)
	  }
	}
	
	LRUCache.prototype.keys = function () {
	  return reverseKeys(this._lruList).map(function (k) {
	    return this._lruList.get(k).key
	  }, this)
	}
	
	LRUCache.prototype.values = function () {
	  return reverseKeys(this._lruList).map(function (k) {
	    return this._lruList.get(k).value
	  }, this)
	}
	
	LRUCache.prototype.reset = function () {
	  if (this._dispose && this._cache) {
	    this._cache.forEach(function (entry, key) {
	      this._dispose(key, entry.value)
	    }, this)
	  }
	
	  this._cache = new Map() // hash of items by key
	  this._lruList = new Map() // list of items in order of use recency
	  this._mru = 0 // most recently used
	  this._lru = 0 // least recently used
	  this._length = 0 // number of items in the list
	}
	
	LRUCache.prototype.dump = function () {
	  var arr = []
	  var i = 0
	  var size = this._lruList.size
	  return reverseKeys(this._lruList).map(function (k) {
	    var hit = this._lruList.get(k)
	    if (!isStale(this, hit)) {
	      return {
	        k: hit.key,
	        v: hit.value,
	        e: hit.now + (hit.maxAge || 0)
	      }
	    }
	  }, this).filter(function (h) {
	    return h
	  })
	}
	
	LRUCache.prototype.dumpLru = function () {
	  return this._lruList
	}
	
	LRUCache.prototype.set = function (key, value, maxAge) {
	  maxAge = maxAge || this._maxAge
	
	  var now = maxAge ? Date.now() : 0
	  var len = this._lengthCalculator(value, key)
	
	  if (this._cache.has(key)) {
	    if (len > this._max) {
	      del(this, this._cache.get(key))
	      return false
	    }
	
	    var item = this._cache.get(key)
	
	    // dispose of the old one before overwriting
	    if (this._dispose)
	      this._dispose(key, item.value)
	
	    item.now = now
	    item.maxAge = maxAge
	    item.value = value
	    this._length += (len - item.length)
	    item.length = len
	    this.get(key)
	
	    if (this._length > this._max)
	      trim(this)
	
	    return true
	  }
	
	  var hit = new Entry(key, value, this._mru, len, now, maxAge)
	  incMru(this)
	
	  // oversized objects fall out of cache automatically.
	  if (hit.length > this._max) {
	    if (this._dispose) this._dispose(key, value)
	    return false
	  }
	
	  this._length += hit.length
	  this._cache.set(key, hit)
	  this._lruList.set(hit.lu, hit)
	
	  if (this._length > this._max)
	    trim(this)
	
	  return true
	}
	
	LRUCache.prototype.has = function (key) {
	  if (!this._cache.has(key)) return false
	  var hit = this._cache.get(key)
	  if (isStale(this, hit)) {
	    return false
	  }
	  return true
	}
	
	LRUCache.prototype.get = function (key) {
	  return get(this, key, true)
	}
	
	LRUCache.prototype.peek = function (key) {
	  return get(this, key, false)
	}
	
	LRUCache.prototype.pop = function () {
	  var hit = this._lruList.get(this._lru)
	  del(this, hit)
	  return hit || null
	}
	
	LRUCache.prototype.del = function (key) {
	  del(this, this._cache.get(key))
	}
	
	LRUCache.prototype.load = function (arr) {
	  //reset the cache
	  this.reset();
	
	  var now = Date.now()
	  // A previous serialized cache has the most recent items first
	  for (var l = arr.length - 1; l >= 0; l--) {
	    var hit = arr[l]
	    var expiresAt = hit.e || 0
	    if (expiresAt === 0) {
	      // the item was created without expiration in a non aged cache
	      this.set(hit.k, hit.v)
	    } else {
	      var maxAge = expiresAt - now
	      // dont add already expired items
	      if (maxAge > 0) {
	        this.set(hit.k, hit.v, maxAge)
	      }
	    }
	  }
	}
	
	function get (self, key, doUse) {
	  var hit = self._cache.get(key)
	  if (hit) {
	    if (isStale(self, hit)) {
	      del(self, hit)
	      if (!self._allowStale) hit = undefined
	    } else {
	      if (doUse) use(self, hit)
	    }
	    if (hit) hit = hit.value
	  }
	  return hit
	}
	
	function isStale(self, hit) {
	  if (!hit || (!hit.maxAge && !self._maxAge)) return false
	  var stale = false;
	  var diff = Date.now() - hit.now
	  if (hit.maxAge) {
	    stale = diff > hit.maxAge
	  } else {
	    stale = self._maxAge && (diff > self._maxAge)
	  }
	  return stale;
	}
	
	function use (self, hit) {
	  shiftLU(self, hit)
	  hit.lu = self._mru
	  incMru(self)
	  self._lruList.set(hit.lu, hit)
	}
	
	function trim (self) {
	  if (self._length > self._max) {
	    var keys = reverseKeys(self._lruList)
	    for (var k = keys.length - 1; self._length > self._max; k--) {
	      // We know that we're about to delete this one, and also
	      // what the next least recently used key will be, so just
	      // go ahead and set it now.
	      self._lru = keys[k - 1]
	      del(self, self._lruList.get(keys[k]))
	    }
	  }
	}
	
	function shiftLU (self, hit) {
	  self._lruList.delete(hit.lu)
	  if (hit.lu === self._lru)
	    self._lru = reverseKeys(self._lruList).pop()
	}
	
	function del (self, hit) {
	  if (hit) {
	    if (self._dispose) self._dispose(hit.key, hit.value)
	    self._length -= hit.length
	    self._cache.delete(hit.key)
	    shiftLU(self, hit)
	  }
	}
	
	// classy, since V8 prefers predictable objects.
	function Entry (key, value, lu, length, now, maxAge) {
	  this.key = key
	  this.value = value
	  this.lu = lu
	  this.length = length
	  this.now = now
	  if (maxAge) this.maxAge = maxAge
	}
	
	
	// Incrementers and decrementers that loop at MAX_SAFE_INTEGER
	// only relevant for the lu, lru, and mru counters, since they
	// get touched a lot and can get very large. Also, since they
	// only go upwards, and the sets will tend to be much smaller than
	// the max, we can very well assume that a very small number comes
	// after a very large number, rather than before it.
	var maxSafeInt = Number.MAX_SAFE_INTEGER || 9007199254740991
	function intInc (number) {
	  return (number === maxSafeInt) ? 0 : number + 1
	}
	function incMru (self) {
	  do {
	    self._mru = intInc(self._mru)
	  } while (self._lruList.has(self._mru))
	}


/***/ },
/* 1474 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(1476),
	    keys = __webpack_require__(383);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1476 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var keys = __webpack_require__(383);
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = baseEach;


/***/ },
/* 1478 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(595),
	    isIterateeCall = __webpack_require__(1481),
	    restParam = __webpack_require__(1484);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1480 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 1481 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(1478),
	    isArguments = __webpack_require__(381),
	    keysIn = __webpack_require__(1483);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(381),
	    isArray = __webpack_require__(382);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 1484 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(278);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Creates an hash object.
	 *
	 * @private
	 * @constructor
	 * @returns {Object} Returns the new hash object.
	 */
	function Hash() {}
	
	// Avoid inheriting from `Object.prototype` when possible.
	Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	module.exports = Hash;


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(138);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 1487 */
[1792, 275, 138],
/* 1488 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 1489 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 1490 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1491 */
/***/ function(module, exports) {

	/**
	 * Creates a new array concatenating `array` with `other`.
	 *
	 * @private
	 * @param {Array} array The first array to concatenate.
	 * @param {Array} other The second array to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 */
	function arrayConcat(array, other) {
	  var index = -1,
	      length = array.length,
	      othIndex = -1,
	      othLength = other.length,
	      result = Array(length + othLength);
	
	  while (++index < length) {
	    result[index] = array[index];
	  }
	  while (++othIndex < othLength) {
	    result[index++] = other[othIndex];
	  }
	  return result;
	}
	
	module.exports = arrayConcat;


/***/ },
/* 1492 */
359,
/* 1493 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1494 */
[1793, 388, 141],
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(636);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the array-like object.
	 */
	function baseCastFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = baseCastFunction;


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 1497 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(615),
	    keysIn = __webpack_require__(286);
	
	/**
	 * The base implementation of `_.forIn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return object == null ? object : baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 1499 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(271),
	    equalArrays = __webpack_require__(627),
	    equalByTag = __webpack_require__(1534),
	    equalObjects = __webpack_require__(1535),
	    getTag = __webpack_require__(628),
	    isArray = __webpack_require__(32),
	    isHostObject = __webpack_require__(276),
	    isTypedArray = __webpack_require__(392);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      stack || (stack = new Stack);
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(271),
	    baseIsEqual = __webpack_require__(387);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack,
	          result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;
	
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1502 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(1486),
	    iteratorToArray = __webpack_require__(1548);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1501),
	    getMatchData = __webpack_require__(1537);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value &&
	        (value !== undefined || (key in Object(object)));
	    };
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(387),
	    get = __webpack_require__(635),
	    hasIn = __webpack_require__(1564);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(605),
	    baseClone = __webpack_require__(611),
	    copyArray = __webpack_require__(625),
	    isArguments = __webpack_require__(283),
	    isArray = __webpack_require__(32),
	    isArrayLikeObject = __webpack_require__(211),
	    isFunction = __webpack_require__(212),
	    isObject = __webpack_require__(51),
	    isPlainObject = __webpack_require__(285),
	    isTypedArray = __webpack_require__(392),
	    toPlainObject = __webpack_require__(1579);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, !customizer);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, !customizer);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  stack['delete'](srcValue);
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168),
	    baseIteratee = __webpack_require__(72),
	    baseMap = __webpack_require__(619),
	    baseSortBy = __webpack_require__(1513),
	    compareMultiple = __webpack_require__(1528);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : Array(1), baseIteratee);
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(1498);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key) {
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(616);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(386),
	    isIndex = __webpack_require__(210),
	    isKey = __webpack_require__(277),
	    last = __webpack_require__(393),
	    parent = __webpack_require__(633);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (lastIndex == length || index != previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      }
	      else if (!isKey(index, array)) {
	        var path = baseCastPath(index),
	            object = parent(array, path);
	
	        if (object != null) {
	          delete object[last(path)];
	        }
	      }
	      else {
	        delete array[index];
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ },
/* 1511 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 1512 */
200,
/* 1513 */
1354,
/* 1514 */
1355,
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(168);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the new array of key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 1516 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(600),
	    arrayIncludes = __webpack_require__(603),
	    arrayIncludesWith = __webpack_require__(604),
	    cacheHas = __webpack_require__(623),
	    createSet = __webpack_require__(1533),
	    setToArray = __webpack_require__(390);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 1518 */
[1798, 168],
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(169);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the set cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var map = this.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    hash[value] = HASH_UNDEFINED;
	  }
	  else {
	    map.set(value, HASH_UNDEFINED);
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 1520 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 1521 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(1488),
	    arrayReduce = __webpack_require__(272),
	    mapToArray = __webpack_require__(632);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map) {
	  return arrayReduce(mapToArray(map), addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 1523 */
1363,
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(1489),
	    arrayReduce = __webpack_require__(272),
	    setToArray = __webpack_require__(390);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set) {
	  return arrayReduce(setToArray(set), addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 1525 */
[1800, 384],
/* 1526 */
[1801, 624],
/* 1527 */
/***/ function(module, exports) {

	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsNull = value === null,
	        valIsUndef = value === undefined,
	        valIsReflexive = value === value;
	
	    var othIsNull = other === null,
	        othIsUndef = other === undefined,
	        othIsReflexive = other === other;
	
	    if ((value > other && !othIsNull) || !valIsReflexive ||
	        (valIsNull && !othIsUndef && othIsReflexive) ||
	        (valIsUndef && othIsReflexive)) {
	      return 1;
	    }
	    if ((value < other && !valIsNull) || !othIsReflexive ||
	        (othIsNull && !valIsUndef && valIsReflexive) ||
	        (othIsUndef && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1527);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(606);
	
	/**
	 * This function is like `copyObject` except that it accepts a function to
	 * customize copied values.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObjectWith(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObjectWith;


/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(388),
	    getSymbols = __webpack_require__(1538);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1531 */
[1802, 170],
/* 1532 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(599),
	    noop = __webpack_require__(1572);
	
	/**
	 * Creates a set of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(384),
	    Uint8Array = __webpack_require__(601),
	    equalArrays = __webpack_require__(627),
	    mapToArray = __webpack_require__(632),
	    setToArray = __webpack_require__(390);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask | UNORDERED_COMPARE_FLAG, stack.set(object, other));
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(617),
	    keys = __webpack_require__(141);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(622);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1547),
	    toPairs = __webpack_require__(1578);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = toPairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1538 */
/***/ function(module, exports) {

	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = getOwnPropertySymbols || function() {
	  return [];
	};
	
	module.exports = getSymbols;


/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(386),
	    isArguments = __webpack_require__(283),
	    isArray = __webpack_require__(32),
	    isIndex = __webpack_require__(210),
	    isKey = __webpack_require__(277),
	    isLength = __webpack_require__(284),
	    isString = __webpack_require__(391),
	    last = __webpack_require__(393),
	    parent = __webpack_require__(633);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  if (object == null) {
	    return false;
	  }
	  var result = hasFunc(object, path);
	  if (!result && !isKey(path)) {
	    path = baseCastPath(path);
	    object = parent(object, path);
	    if (object != null) {
	      path = last(path);
	      result = hasFunc(object, path);
	    }
	  }
	  var length = object ? object.length : undefined;
	  return result || (
	    !!length && isLength(length) && isIndex(path, length) &&
	    (isArray(object) || isString(object) || isArguments(object))
	  );
	}
	
	module.exports = hasPath;


/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	var hashHas = __webpack_require__(629);
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(hash, key) {
	  return hashHas(hash, key) && delete hash[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(278);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(hash, key) {
	  if (nativeCreate) {
	    var result = hash[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(278);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function hashSet(hash, key, value) {
	  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	}
	
	module.exports = hashSet;


/***/ },
/* 1543 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 1544 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(624),
	    cloneMap = __webpack_require__(1522),
	    cloneRegExp = __webpack_require__(1523),
	    cloneSet = __webpack_require__(1524),
	    cloneSymbol = __webpack_require__(1525),
	    cloneTypedArray = __webpack_require__(1526);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1496),
	    isPrototype = __webpack_require__(389);
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototypeOf(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1547 */
[1803, 51],
/* 1548 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1485),
	    Map = __webpack_require__(167);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': Map ? new Map : [],
	    'string': new Hash
	  };
	}
	
	module.exports = mapClear;


/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(167),
	    assocDelete = __webpack_require__(607),
	    hashDelete = __webpack_require__(1540),
	    isKeyable = __webpack_require__(169);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapDelete(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	}
	
	module.exports = mapDelete;


/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(167),
	    assocGet = __webpack_require__(608),
	    hashGet = __webpack_require__(1541),
	    isKeyable = __webpack_require__(169);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapGet(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.get(key) : assocGet(data.map, key);
	}
	
	module.exports = mapGet;


/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(167),
	    assocHas = __webpack_require__(609),
	    hashHas = __webpack_require__(629),
	    isKeyable = __webpack_require__(169);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapHas(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.has(key) : assocHas(data.map, key);
	}
	
	module.exports = mapHas;


/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(167),
	    assocSet = __webpack_require__(610),
	    hashSet = __webpack_require__(1542),
	    isKeyable = __webpack_require__(169);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache object.
	 */
	function mapSet(key, value) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	  } else if (Map) {
	    data.map.set(key, value);
	  } else {
	    assocSet(data.map, key, value);
	  }
	  return this;
	}
	
	module.exports = mapSet;


/***/ },
/* 1554 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = { 'array': [], 'map': null };
	}
	
	module.exports = stackClear;


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	var assocDelete = __webpack_require__(607);
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocDelete(array, key) : data.map['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	var assocGet = __webpack_require__(608);
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocGet(array, key) : data.map.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	var assocHas = __webpack_require__(609);
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocHas(array, key) : data.map.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(598),
	    assocSet = __webpack_require__(610);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache object.
	 */
	function stackSet(key, value) {
	  var data = this.__data__,
	      array = data.array;
	
	  if (array) {
	    if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	      assocSet(array, key, value);
	    } else {
	      data.array = null;
	      data.map = new MapCache(array);
	    }
	  }
	  var map = data.map;
	  if (map) {
	    map.set(key, value);
	  }
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1559 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  if (!(string && reHasComplexSymbol.test(string))) {
	    return string.length;
	  }
	  var result = reComplexSymbol.lastIndex = 0;
	  while (reComplexSymbol.test(string)) {
	    result++;
	  }
	  return result;
	}
	
	module.exports = stringSize;


/***/ },
/* 1560 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return string.match(reComplexSymbol);
	}
	
	module.exports = stringToArray;


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(396);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	function stringToPath(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = stringToPath;


/***/ },
/* 1562 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	var baseFind = __webpack_require__(614),
	    baseForOwn = __webpack_require__(274),
	    baseIteratee = __webpack_require__(72);
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFind(object, baseIteratee(predicate, 3), baseForOwn, true);
	}
	
	module.exports = findKey;


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1499),
	    hasPath = __webpack_require__(1539);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b.c');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b', 'c']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var constant = __webpack_require__(1562),
	    root = __webpack_require__(138);
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = (freeModule && freeModule.exports === freeExports)
	  ? freeExports
	  : undefined;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? constant(false) : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(387);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are **not** supported.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(212),
	    isHostObject = __webpack_require__(276),
	    isObjectLike = __webpack_require__(140);
	
	/** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(funcToString.call(value));
	  }
	  return isObjectLike(value) &&
	    (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	function isRegExp(value) {
	  return isObject(value) && objectToString.call(value) == regexpTag;
	}
	
	module.exports = isRegExp;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(140);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(274),
	    baseIteratee = __webpack_require__(72);
	
	/**
	 * Creates an object with the same keys as `object` and values generated by
	 * running each own enumerable property of `object` through `iteratee`. The
	 * iteratee is invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(620),
	    createAssigner = __webpack_require__(626);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined` merging is handled by the
	 * method instead. The `customizer` is invoked with seven arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 1572 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(72),
	    basePickBy = __webpack_require__(1508);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  return object == null ? {} : basePickBy(object, baseIteratee(predicate));
	}
	
	module.exports = pickBy;


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(622),
	    basePropertyDeep = __webpack_require__(1509),
	    isKey = __webpack_require__(277);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(602),
	    baseFilter = __webpack_require__(613),
	    baseIteratee = __webpack_require__(72),
	    isArray = __webpack_require__(32);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseIteratee(predicate, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(209),
	    baseOrderBy = __webpack_require__(1507),
	    isIterateeCall = __webpack_require__(631),
	    rest = __webpack_require__(142);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[]|Object|Object[]|string|string[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by, specified individually or in arrays.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, function(o) { return o.user; });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	 *
	 * _.sortBy(users, 'user', function(o) {
	 *   return Math.floor(o.age / 10);
	 * });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	var sortBy = rest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees.length = 1;
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(212),
	    isObject = __webpack_require__(51);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3);
	 * // => 3
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3');
	 * // => 3
	 */
	function toNumber(value) {
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(1515),
	    keys = __webpack_require__(141);
	
	/**
	 * Creates an array of own enumerable key-value pairs for `object` which
	 * can be consumed by `_.fromPairs`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	function toPairs(object) {
	  return baseToPairs(object, keys(object));
	}
	
	module.exports = toPairs;


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(388),
	    keysIn = __webpack_require__(286);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(51),
	    isRegExp = __webpack_require__(1568),
	    stringSize = __webpack_require__(1559),
	    stringToArray = __webpack_require__(1560),
	    toInteger = __webpack_require__(395),
	    toString = __webpack_require__(396);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options=({})] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? toString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (reHasComplexSymbol.test(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? strSymbols.slice(0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(separator, end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.4
	//! author : Tim Wood
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(143)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.5.4",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1582 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EntitySchema = (function () {
	  function EntitySchema(key) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('A string non-empty key is required');
	    }
	
	    this._key = key;
	
	    var idAttribute = options.idAttribute || 'id';
	    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
	      return x[idAttribute];
	    };
	    this._idAttribute = idAttribute;
	  }
	
	  EntitySchema.prototype.getKey = function getKey() {
	    return this._key;
	  };
	
	  EntitySchema.prototype.getId = function getId(entity) {
	    return this._getId(entity);
	  };
	
	  EntitySchema.prototype.getIdAttribute = function getIdAttribute() {
	    return this._idAttribute;
	  };
	
	  EntitySchema.prototype.define = function define(nestedSchema) {
	    for (var key in nestedSchema) {
	      if (nestedSchema.hasOwnProperty(key)) {
	        this[key] = nestedSchema[key];
	      }
	    }
	  };
	
	  return EntitySchema;
	})();
	
	exports['default'] = EntitySchema;
	module.exports = exports['default'];

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashIsObject = __webpack_require__(51);
	
	var _lodashIsObject2 = _interopRequireDefault(_lodashIsObject);
	
	var _UnionSchema = __webpack_require__(639);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	var ArraySchema = (function () {
	  function ArraySchema(itemSchema) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, ArraySchema);
	
	    if (!_lodashIsObject2['default'](itemSchema)) {
	      throw new Error('ArraySchema requires item schema to be an object.');
	    }
	
	    if (options.schemaAttribute) {
	      var schemaAttribute = options.schemaAttribute;
	      this._itemSchema = new _UnionSchema2['default'](itemSchema, { schemaAttribute: schemaAttribute });
	    } else {
	      this._itemSchema = itemSchema;
	    }
	  }
	
	  ArraySchema.prototype.getItemSchema = function getItemSchema() {
	    return this._itemSchema;
	  };
	
	  return ArraySchema;
	})();
	
	exports['default'] = ArraySchema;
	module.exports = exports['default'];

/***/ },
/* 1584 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(115).assign;
	
	var deflate   = __webpack_require__(1586);
	var inflate   = __webpack_require__(1587);
	var constants = __webpack_require__(642);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(1588);
	var utils        = __webpack_require__(115);
	var strings      = __webpack_require__(640);
	var msg          = __webpack_require__(401);
	var ZStream      = __webpack_require__(644);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(1591);
	var utils        = __webpack_require__(115);
	var strings      = __webpack_require__(640);
	var c            = __webpack_require__(642);
	var msg          = __webpack_require__(401);
	var ZStream      = __webpack_require__(644);
	var GZheader     = __webpack_require__(1589);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	  var dict;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      // Convert data if needed
	      if (typeof dictionary === 'string') {
	        dict = strings.string2buf(dictionary);
	      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
	        dict = new Uint8Array(dictionary);
	      } else {
	        dict = dictionary;
	      }
	
	      status = zlib_inflate.inflateSetDictionary(this.strm, dict);
	
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(115);
	var trees   = __webpack_require__(1593);
	var adler32 = __webpack_require__(641);
	var crc32   = __webpack_require__(643);
	var msg     = __webpack_require__(401);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 1589 */
/***/ function(module, exports) {

	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ },
/* 1590 */
/***/ function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(115);
	var adler32       = __webpack_require__(641);
	var crc32         = __webpack_require__(643);
	var inflate_fast  = __webpack_require__(1590);
	var inflate_table = __webpack_require__(1592);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(115);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(115);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*@license
		Papa Parse
		v4.5.0
		https://github.com/mholt/PapaParse
		License: MIT
	*/
	(function(root, factory)
	{
		/* globals define */
		if (true)
		{
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof module === 'object' && typeof exports !== 'undefined')
		{
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		}
		else
		{
			// Browser globals (root is window)
			root.Papa = factory();
		}
	}(this, function()
	{
		'use strict';
	
		var global = (function() {
			// alternative method, similar to `Function('return this')()`
			// but without using `eval` (which is disabled when
			// using Content Security Policy).
	
			if (typeof self !== 'undefined') { return self; }
			if (typeof window !== 'undefined') { return window; }
			if (typeof global !== 'undefined') { return global; }
	
			// When running tests none of the above have been defined
			return {};
		})();
	
	
		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = '\ufeff';
		Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously
		Papa.NODE_STREAM_INPUT = 1;
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
		Papa.ReadableStreamStreamer = ReadableStreamStreamer;
		Papa.DuplexStreamStreamer = DuplexStreamStreamer;
	
		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];
	
				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
									&& $(this).attr('type').toLowerCase() === 'file'
									&& global.FileReader;
	
					if (!supported || !this.files || this.files.length === 0)
						return true;	// continue to next input element
	
					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile();	// begin parsing
				return this;		// maintains chainability
	
	
				function parseNextFile()
				{
					if (queue.length === 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);
	
						if (typeof returned === 'object')
						{
							if (returned.action === 'abort')
							{
								error('AbortError', f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action === 'skip')
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}
	
				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			};
		}
	
	
		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function() {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
	
	
	
		function CsvToJson(_input, _config)
		{
			_config = _config || {};
			var dynamicTyping = _config.dynamicTyping || false;
			if (isFunction(dynamicTyping)) {
				_config.dynamicTypingFunction = dynamicTyping;
				// Will be filled on first row call
				dynamicTyping = {};
			}
			_config.dynamicTyping = dynamicTyping;
	
			_config.transform = isFunction(_config.transform) ? _config.transform : false;
	
			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (_input === Papa.NODE_STREAM_INPUT)
			{
				// create a node Duplex stream for use
				// with .pipe
				streamer = new DuplexStreamStreamer(_config);
				return streamer.getStream();
			}
			else if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
			{
				streamer = new ReadableStreamStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
	
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** whether to write headers */
			var _writeHeader = true;
	
			/** delimiting character */
			var _delimiter = ',';
	
			/** newline character(s) */
			var _newline = '\r\n';
	
			/** quote character */
			var _quoteChar = '"';
	
			unpackConfig();
	
			var quoteCharRegex = new RegExp(_quoteChar, 'g');
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields =  _input.meta && _input.meta.fields;
	
					if (!_input.fields)
						_input.fields =  _input.data[0] instanceof Array
							? _input.fields
							: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw 'exception: Unable to serialize unrecognized input';
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length === 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
	
				if (typeof _config.quoteChar === 'string')
					_quoteChar = _config.quoteChar;
	
				if (typeof _config.header === 'boolean')
					_writeHeader = _config.header;
			}
	
	
			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = '';
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader && _writeHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === 'undefined' || str === null)
					return '';
	
				if (str.constructor === Date)
					return JSON.stringify(str).slice(1, 25);
	
				str = str.toString().replace(quoteCharRegex, _quoteChar + _quoteChar);
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) === ' '
								|| str.charAt(str.length - 1) === ' ';
	
				return needsQuotes ? _quoteChar + str + _quoteChar : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._finished = false;
			this._completed = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = '';
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function(chunk, isFakeChunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = '';
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
	
				if (this._handle.paused() || this._handle.aborted())
					return;
	
				var lastIndex = results.meta.cursor;
	
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data)
					this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
	
				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk) && !isFakeChunk)
				{
					this._config.chunk(results, this._handle);
					if (this._handle.paused() || this._handle.aborted())
						return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (!this._completed && finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) {
					this._config.complete(this._completeResults, this._input);
					this._completed = true;
				}
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();
	
				return results;
			};
	
			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}
	
	
		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}
	
			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};
	
			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
	
				if (this._config.withCredentials)
				{
					xhr.withCredentials = this._config.withCredentials;
				}
	
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open('GET', this._input, !IS_WORKER);
				// Headers can only be set when once the request state is OPENED
				if (this._config.downloadRequestHeaders)
				{
					var headers = this._config.downloadRequestHeaders;
	
					for (var headerName in headers)
					{
						xhr.setRequestHeader(headerName, headers[headerName]);
					}
				}
	
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader('Range', 'bytes=' + this._start + '-' + end);
					xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status === 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			};
	
			this._chunkLoaded = function()
			{
				if (xhr.readyState !== 4)
					return;
	
				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			};
	
			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(new Error(errorText));
			};
	
			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader('Content-Range');
				if (contentRange === null) { // no content range, then finish!
					return -1;
				}
				return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
	
		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105
	
			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox
	
				this._nextChunk();	// Starts streaming
			};
	
			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			};
	
			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			};
	
			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			};
	
			this._chunkError = function()
			{
				this._sendError(reader.error);
			};
	
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
	
		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var remaining;
			this.stream = function(s)
			{
				remaining = s;
				return this._nextChunk();
			};
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			};
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
	
		function ReadableStreamStreamer(config)
		{
			config = config || {};
	
			ChunkStreamer.call(this, config);
	
			var queue = [];
			var parseOnData = true;
			var streamHasEnded = false;
	
			this.pause = function()
			{
				ChunkStreamer.prototype.pause.apply(this, arguments);
				this._input.pause();
			};
	
			this.resume = function()
			{
				ChunkStreamer.prototype.resume.apply(this, arguments);
				this._input.resume();
			};
	
			this.stream = function(stream)
			{
				this._input = stream;
	
				this._input.on('data', this._streamData);
				this._input.on('end', this._streamEnd);
				this._input.on('error', this._streamError);
			};
	
			this._checkIsFinished = function()
			{
				if (streamHasEnded && queue.length === 1) {
					this._finished = true;
				}
			};
	
			this._nextChunk = function()
			{
				this._checkIsFinished();
				if (queue.length)
				{
					this.parseChunk(queue.shift());
				}
				else
				{
					parseOnData = true;
				}
			};
	
			this._streamData = bindFunction(function(chunk)
			{
				try
				{
					queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));
	
					if (parseOnData)
					{
						parseOnData = false;
						this._checkIsFinished();
						this.parseChunk(queue.shift());
					}
				}
				catch (error)
				{
					this._streamError(error);
				}
			}, this);
	
			this._streamError = bindFunction(function(error)
			{
				this._streamCleanUp();
				this._sendError(error);
			}, this);
	
			this._streamEnd = bindFunction(function()
			{
				this._streamCleanUp();
				streamHasEnded = true;
				this._streamData('');
			}, this);
	
			this._streamCleanUp = bindFunction(function()
			{
				this._input.removeListener('data', this._streamData);
				this._input.removeListener('end', this._streamEnd);
				this._input.removeListener('error', this._streamError);
			}, this);
		}
		ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;
	
	
		function DuplexStreamStreamer(_config) {
			var Duplex = __webpack_require__(219).Duplex;
			var config = copy(_config);
			var parseOnWrite = true;
			var writeStreamHasFinished = false;
			var parseCallbackQueue = [];
			var stream = null;
	
			this._onCsvData = function(results)
			{
				var data = results.data;
				for (var i = 0; i < data.length; i++) {
					if (!stream.push(data[i]) && !this._handle.paused()) {
						// the writeable consumer buffer has filled up
						// so we need to pause until more items
						// can be processed
						this._handle.pause();
					}
				}
			};
	
			this._onCsvComplete = function()
			{
				// node will finish the read stream when
				// null is pushed
				stream.push(null);
			};
	
			config.step = bindFunction(this._onCsvData, this);
			config.complete = bindFunction(this._onCsvComplete, this);
			ChunkStreamer.call(this, config);
	
			this._nextChunk = function()
			{
				if (writeStreamHasFinished && parseCallbackQueue.length === 1) {
					this._finished = true;
				}
				if (parseCallbackQueue.length) {
					parseCallbackQueue.shift()();
				} else {
					parseOnWrite = true;
				}
			};
	
			this._addToParseQueue = function(chunk, callback)
			{
				// add to queue so that we can indicate
				// completion via callback
				// node will automatically pause the incoming stream
				// when too many items have been added without their
				// callback being invoked
				parseCallbackQueue.push(bindFunction(function() {
					this.parseChunk(typeof chunk === 'string' ? chunk : chunk.toString(config.encoding));
					if (isFunction(callback)) {
						return callback();
					}
				}, this));
				if (parseOnWrite) {
					parseOnWrite = false;
					this._nextChunk();
				}
			};
	
			this._onRead = function()
			{
				if (this._handle.paused()) {
					// the writeable consumer can handle more data
					// so resume the chunk parsing
					this._handle.resume();
				}
			};
	
			this._onWrite = function(chunk, encoding, callback)
			{
				this._addToParseQueue(chunk, callback);
			};
	
			this._onWriteComplete = function()
			{
				writeStreamHasFinished = true;
				// have to write empty string
				// so parser knows its done
				this._addToParseQueue('');
			};
	
			this.getStream = function()
			{
				return stream;
			};
			stream = new Duplex({
				readableObjectMode: true,
				decodeStrings: false,
				read: bindFunction(this._onRead, this),
				write: bindFunction(this._onWrite, this)
			});
			stream.once('finish', bindFunction(this._onWriteComplete, this));
		}
		DuplexStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		DuplexStreamStreamer.prototype.constructor = DuplexStreamStreamer;
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
			var ISO_DATE = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _rowCounter = 0;	// Number of rows that have been parsed so far
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;	// Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length === 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines, _config.comments);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
				else if(isFunction(_config.delimiter))
				{
					_config.delimiter = _config.delimiter(input);
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.paused = function()
			{
				return _paused;
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input, true);
			};
	
			this.aborted = function()
			{
				return _aborted;
			};
	
			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = '';
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Papa.DefaultDelimiter + '\'');
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length === 1 && _results.data[i][0] === '')
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTypingAndTransformation();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length === 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
					{
						var header = _results.data[i][j];
	
						if (_config.trimHeaders) {
							header = header.trim();
						}
	
						_fields.push(header);
					}
				_results.data.splice(0, 1);
			}
	
			function shouldApplyDynamicTyping(field) {
				// Cache function values to avoid calling it for each row
				if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
					_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
				}
				return (_config.dynamicTyping[field] || _config.dynamicTyping) === true;
			}
	
			function parseDynamic(field, value)
			{
				if (shouldApplyDynamicTyping(field))
				{
					if (value === 'true' || value === 'TRUE')
						return true;
					else if (value === 'false' || value === 'FALSE')
						return false;
					else if (FLOAT.test(value))
						return parseFloat(value);
					else if (ISO_DATE.test(value))
						return new Date(value);
					else
						return (value === '' ? null : value);
				}
				return value;
			}
	
			function applyHeaderAndDynamicTypingAndTransformation()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping && !_config.transform))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = _config.header ? {} : [];
	
					var j;
					for (j = 0; j < _results.data[i].length; j++)
					{
						var field = j;
						var value = _results.data[i][j];
	
						if (_config.header)
							field = j >= _fields.length ? '__parsed_extra' : _fields[j];
	
						if (_config.transform)
							value = _config.transform(value,field);
	
						value = parseDynamic(field, value);
	
						if (field === '__parsed_extra')
						{
							row[field] = row[field] || [];
							row[field].push(value);
						}
						else
							row[field] = value;
					}
	
					_results.data[i] = row;
	
					if (_config.header)
					{
						if (j > _fields.length)
							addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
						else if (j < _fields.length)
							addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
	
				_rowCounter += _results.data.length;
				return _results;
			}
	
			function guessDelimiter(input, newline, skipEmptyLines, comments)
			{
				var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						comments: comments,
						delimiter: delim,
						newline: newline,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
							emptyLinesCount++;
							continue;
						}
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0)
						avgFieldCount /= (preview.data.length - emptyLinesCount);
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				};
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024 * 1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				var n = input.split('\n');
	
				var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);
	
				if (r.length === 1 || nAppearsFirst)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] === '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
			var quoteChar;
			/** Allows for no quoteChar by setting quoteChar to undefined in config */
			if (config.quoteChar === undefined) {
				quoteChar = '"';
			} else {
				quoteChar = config.quoteChar;
			}
			var escapeChar = quoteChar;
			if (config.escapeChar !== undefined) {
				escapeChar = config.escapeChar;
			}
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ',';
	
			// Comment character must be valid
			if (comments === delim)
				throw 'Comment character same as delimiter';
			else if (comments === true)
				comments = '#';
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline !== '\n' && newline !== '\r' && newline !== '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw 'Input must be a string';
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = isFunction(step);
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;
	
				if (!input)
					return returnable();
	
				if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) === comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
				var quoteCharRegex = new RegExp(escapeChar.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&') + quoteChar, 'g');
				var quoteSearch;
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] === quoteChar)
					{
						// Start our search for the closing quote where the cursor is
						quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							quoteSearch = input.indexOf(quoteChar, quoteSearch + 1);
	
							//No other quotes are found - no other delimiters
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: 'Quotes',
										code: 'MissingQuotes',
										message: 'Quoted field unterminated',
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							// Closing quote at EOF
							if (quoteSearch === inputLen - 1)
							{
								var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							// If the quote character is the escape character, then check if the next character is the escape character
							if (quoteChar === escapeChar &&  input[quoteSearch + 1] === escapeChar)
							{
								quoteSearch++;
								continue;
							}
	
							// If the quote character is not the escape character, then check if the previous character was the escape character
							if (quoteChar !== escapeChar && quoteSearch !== 0 && input[quoteSearch - 1] === escapeChar)
							{
								continue;
							}
	
							var spacesBetweenQuoteAndDelimiter = extraSpaces(nextDelim);
	
							// Closing quote followed by delimiter or 'unnecessary steps + delimiter'
							if (input[quoteSearch + 1 + spacesBetweenQuoteAndDelimiter] === delim)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								cursor = quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							var spacesBetweenQuoteAndNewLine = extraSpaces(nextNewline);
	
							// Closing quote followed by newline or 'unnecessary spaces + newLine'
							if (input.substr(quoteSearch + 1 + spacesBetweenQuoteAndNewLine, newlineLen) === newline)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								saveRow(quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
	
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
	
	
							// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
							errors.push({
								type: 'Quotes',
								code: 'InvalidQuotes',
								message: 'Trailing quote on quoted field is malformed',
								row: data.length,	// row has yet to be inserted
								index: cursor
							});
	
							quoteSearch++;
							continue;
	
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline === -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
	             * checks if there are extra spaces after closing quote and given index without any text
	             * if Yes, returns the number of spaces
	             */
				function extraSpaces(index) {
					var spaceLength = 0;
					if (index !== -1) {
						var textBetweenClosingQuoteAndIndex = input.substring(quoteSearch + 1, index);
						if (textBetweenClosingQuoteAndIndex && textBetweenClosingQuoteAndIndex.trim() === '') {
							spaceLength = textBetweenClosingQuoteAndIndex.length;
						}
					}
					return spaceLength;
				}
	
				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [];
					errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append 'papaworker' to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw 'Not implemented.';
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object' || obj === null)
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	
		return Papa;
	}));


/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Pikaday
	 *
	 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
	 */
	
	(function (root, factory)
	{
	    'use strict';
	
	    var moment;
	    if (true) {
	        // CommonJS module
	        // Load moment.js as an optional dependency
	        try { moment = __webpack_require__(143); } catch (e) {}
	        module.exports = factory(moment);
	    } else if (typeof define === 'function' && define.amd) {
	        // AMD. Register as an anonymous module.
	        define(function (req)
	        {
	            // Load moment.js as an optional dependency
	            var id = 'moment';
	            try { moment = req(id); } catch (e) {}
	            return factory(moment);
	        });
	    } else {
	        root.Pikaday = factory(root.moment);
	    }
	}(this, function (moment)
	{
	    'use strict';
	
	    /**
	     * feature detection and helper functions
	     */
	    var hasMoment = typeof moment === 'function',
	
	    hasEventListeners = !!window.addEventListener,
	
	    document = window.document,
	
	    sto = window.setTimeout,
	
	    addEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.addEventListener(e, callback, !!capture);
	        } else {
	            el.attachEvent('on' + e, callback);
	        }
	    },
	
	    removeEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.removeEventListener(e, callback, !!capture);
	        } else {
	            el.detachEvent('on' + e, callback);
	        }
	    },
	
	    fireEvent = function(el, eventName, data)
	    {
	        var ev;
	
	        if (document.createEvent) {
	            ev = document.createEvent('HTMLEvents');
	            ev.initEvent(eventName, true, false);
	            ev = extend(ev, data);
	            el.dispatchEvent(ev);
	        } else if (document.createEventObject) {
	            ev = document.createEventObject();
	            ev = extend(ev, data);
	            el.fireEvent('on' + eventName, ev);
	        }
	    },
	
	    trim = function(str)
	    {
	        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
	    },
	
	    hasClass = function(el, cn)
	    {
	        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
	    },
	
	    addClass = function(el, cn)
	    {
	        if (!hasClass(el, cn)) {
	            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
	        }
	    },
	
	    removeClass = function(el, cn)
	    {
	        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
	    },
	
	    isArray = function(obj)
	    {
	        return (/Array/).test(Object.prototype.toString.call(obj));
	    },
	
	    isDate = function(obj)
	    {
	        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
	    },
	
	    isWeekend = function(date)
	    {
	        var day = date.getDay();
	        return day === 0 || day === 6;
	    },
	
	    isLeapYear = function(year)
	    {
	        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    },
	
	    getDaysInMonth = function(year, month)
	    {
	        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	    },
	
	    setToStartOfDay = function(date)
	    {
	        if (isDate(date)) date.setHours(0,0,0,0);
	    },
	
	    compareDates = function(a,b)
	    {
	        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
	        return a.getTime() === b.getTime();
	    },
	
	    extend = function(to, from, overwrite)
	    {
	        var prop, hasProp;
	        for (prop in from) {
	            hasProp = to[prop] !== undefined;
	            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
	                if (isDate(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = new Date(from[prop].getTime());
	                    }
	                }
	                else if (isArray(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = from[prop].slice(0);
	                    }
	                } else {
	                    to[prop] = extend({}, from[prop], overwrite);
	                }
	            } else if (overwrite || !hasProp) {
	                to[prop] = from[prop];
	            }
	        }
	        return to;
	    },
	
	    adjustCalendar = function(calendar) {
	        if (calendar.month < 0) {
	            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
	            calendar.month += 12;
	        }
	        if (calendar.month > 11) {
	            calendar.year += Math.floor(Math.abs(calendar.month)/12);
	            calendar.month -= 12;
	        }
	        return calendar;
	    },
	
	    /**
	     * defaults and localisation
	     */
	    defaults = {
	
	        // bind the picker to a form field
	        field: null,
	
	        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
	        bound: undefined,
	
	        // position of the datepicker, relative to the field (default to bottom & left)
	        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
	        position: 'bottom left',
	
	        // automatically fit in the viewport even if it means repositioning from the position option
	        reposition: true,
	
	        // the default output format for `.toString()` and `field` value
	        format: 'YYYY-MM-DD',
	
	        // the initial date to view when first opened
	        defaultDate: null,
	
	        // make the `defaultDate` the initial selected value
	        setDefaultDate: false,
	
	        // first day of week (0: Sunday, 1: Monday etc)
	        firstDay: 0,
	
	        // the minimum/earliest date that can be selected
	        minDate: null,
	        // the maximum/latest date that can be selected
	        maxDate: null,
	
	        // number of years either side, or array of upper/lower range
	        yearRange: 10,
	
	        // show week numbers at head of row
	        showWeekNumber: false,
	
	        // used internally (don't config outside)
	        minYear: 0,
	        maxYear: 9999,
	        minMonth: undefined,
	        maxMonth: undefined,
	
	        startRange: null,
	        endRange: null,
	
	        isRTL: false,
	
	        // Additional text to append to the year in the calendar title
	        yearSuffix: '',
	
	        // Render the month after year in the calendar title
	        showMonthAfterYear: false,
	
	        // how many months are visible
	        numberOfMonths: 1,
	
	        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
	        // only used for the first display or when a selected date is not visible
	        mainCalendar: 'left',
	
	        // Specify a DOM element to render the calendar in
	        container: undefined,
	
	        // internationalization
	        i18n: {
	            previousMonth : 'Previous Month',
	            nextMonth     : 'Next Month',
	            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
	            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
	        },
	
	        // Theme Classname
	        theme: null,
	
	        // callback function
	        onSelect: null,
	        onOpen: null,
	        onClose: null,
	        onDraw: null
	    },
	
	
	    /**
	     * templating functions to abstract HTML rendering
	     */
	    renderDayName = function(opts, day, abbr)
	    {
	        day += opts.firstDay;
	        while (day >= 7) {
	            day -= 7;
	        }
	        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
	    },
	
	    renderDay = function(opts)
	    {
	        if (opts.isEmpty) {
	            return '<td class="is-empty"></td>';
	        }
	        var arr = [];
	        if (opts.isDisabled) {
	            arr.push('is-disabled');
	        }
	        if (opts.isToday) {
	            arr.push('is-today');
	        }
	        if (opts.isSelected) {
	            arr.push('is-selected');
	        }
	        if (opts.isInRange) {
	            arr.push('is-inrange');
	        }
	        if (opts.isStartRange) {
	            arr.push('is-startrange');
	        }
	        if (opts.isEndRange) {
	            arr.push('is-endrange');
	        }
	        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '">' +
	                 '<button class="pika-button pika-day" type="button" ' +
	                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
	                        opts.day +
	                 '</button>' +
	               '</td>';
	    },
	
	    renderWeek = function (d, m, y) {
	        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
	        var onejan = new Date(y, 0, 1),
	            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
	        return '<td class="pika-week">' + weekNum + '</td>';
	    },
	
	    renderRow = function(days, isRTL)
	    {
	        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
	    },
	
	    renderBody = function(rows)
	    {
	        return '<tbody>' + rows.join('') + '</tbody>';
	    },
	
	    renderHead = function(opts)
	    {
	        var i, arr = [];
	        if (opts.showWeekNumber) {
	            arr.push('<th></th>');
	        }
	        for (i = 0; i < 7; i++) {
	            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
	        }
	        return '<thead>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</thead>';
	    },
	
	    renderTitle = function(instance, c, year, month, refYear)
	    {
	        var i, j, arr,
	            opts = instance._o,
	            isMinYear = year === opts.minYear,
	            isMaxYear = year === opts.maxYear,
	            html = '<div class="pika-title">',
	            monthHtml,
	            yearHtml,
	            prev = true,
	            next = true;
	
	        for (arr = [], i = 0; i < 12; i++) {
	            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
	                (i === month ? ' selected': '') +
	                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled' : '') + '>' +
	                opts.i18n.months[i] + '</option>');
	        }
	        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';
	
	        if (isArray(opts.yearRange)) {
	            i = opts.yearRange[0];
	            j = opts.yearRange[1] + 1;
	        } else {
	            i = year - opts.yearRange;
	            j = 1 + year + opts.yearRange;
	        }
	
	        for (arr = []; i < j && i <= opts.maxYear; i++) {
	            if (i >= opts.minYear) {
	                arr.push('<option value="' + i + '"' + (i === year ? ' selected': '') + '>' + (i) + '</option>');
	            }
	        }
	        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';
	
	        if (opts.showMonthAfterYear) {
	            html += yearHtml + monthHtml;
	        } else {
	            html += monthHtml + yearHtml;
	        }
	
	        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
	            prev = false;
	        }
	
	        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
	            next = false;
	        }
	
	        if (c === 0) {
	            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
	        }
	        if (c === (instance._o.numberOfMonths - 1) ) {
	            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
	        }
	
	        return html += '</div>';
	    },
	
	    renderTable = function(opts, data)
	    {
	        return '<table cellpadding="0" cellspacing="0" class="pika-table">' + renderHead(opts) + renderBody(data) + '</table>';
	    },
	
	
	    /**
	     * Pikaday constructor
	     */
	    Pikaday = function(options)
	    {
	        var self = this,
	            opts = self.config(options);
	
	        self._onMouseDown = function(e)
	        {
	            if (!self._v) {
	                return;
	            }
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	
	            if (!hasClass(target, 'is-disabled')) {
	                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty')) {
	                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
	                    if (opts.bound) {
	                        sto(function() {
	                            self.hide();
	                            if (opts.field) {
	                                opts.field.blur();
	                            }
	                        }, 100);
	                    }
	                }
	                else if (hasClass(target, 'pika-prev')) {
	                    self.prevMonth();
	                }
	                else if (hasClass(target, 'pika-next')) {
	                    self.nextMonth();
	                }
	            }
	            if (!hasClass(target, 'pika-select')) {
	                // if this is touch event prevent mouse events emulation
	                if (e.preventDefault) {
	                    e.preventDefault();
	                } else {
	                    e.returnValue = false;
	                    return false;
	                }
	            } else {
	                self._c = true;
	            }
	        };
	
	        self._onChange = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	            if (hasClass(target, 'pika-select-month')) {
	                self.gotoMonth(target.value);
	            }
	            else if (hasClass(target, 'pika-select-year')) {
	                self.gotoYear(target.value);
	            }
	        };
	
	        self._onInputChange = function(e)
	        {
	            var date;
	
	            if (e.firedBy === self) {
	                return;
	            }
	            if (hasMoment) {
	                date = moment(opts.field.value, opts.format);
	                date = (date && date.isValid()) ? date.toDate() : null;
	            }
	            else {
	                date = new Date(Date.parse(opts.field.value));
	            }
	            if (isDate(date)) {
	              self.setDate(date);
	            }
	            if (!self._v) {
	                self.show();
	            }
	        };
	
	        self._onInputFocus = function()
	        {
	            self.show();
	        };
	
	        self._onInputClick = function()
	        {
	            self.show();
	        };
	
	        self._onInputBlur = function()
	        {
	            // IE allows pika div to gain focus; catch blur the input field
	            var pEl = document.activeElement;
	            do {
	                if (hasClass(pEl, 'pika-single')) {
	                    return;
	                }
	            }
	            while ((pEl = pEl.parentNode));
	
	            if (!self._c) {
	                self._b = sto(function() {
	                    self.hide();
	                }, 50);
	            }
	            self._c = false;
	        };
	
	        self._onClick = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement,
	                pEl = target;
	            if (!target) {
	                return;
	            }
	            if (!hasEventListeners && hasClass(target, 'pika-select')) {
	                if (!target.onchange) {
	                    target.setAttribute('onchange', 'return;');
	                    addEvent(target, 'change', self._onChange);
	                }
	            }
	            do {
	                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
	                    return;
	                }
	            }
	            while ((pEl = pEl.parentNode));
	            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
	                self.hide();
	            }
	        };
	
	        self.el = document.createElement('div');
	        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');
	
	        addEvent(self.el, 'mousedown', self._onMouseDown, true);
	        addEvent(self.el, 'touchend', self._onMouseDown, true);
	        addEvent(self.el, 'change', self._onChange);
	
	        if (opts.field) {
	            if (opts.container) {
	                opts.container.appendChild(self.el);
	            } else if (opts.bound) {
	                document.body.appendChild(self.el);
	            } else {
	                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
	            }
	            addEvent(opts.field, 'change', self._onInputChange);
	
	            if (!opts.defaultDate) {
	                if (hasMoment && opts.field.value) {
	                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
	                } else {
	                    opts.defaultDate = new Date(Date.parse(opts.field.value));
	                }
	                opts.setDefaultDate = true;
	            }
	        }
	
	        var defDate = opts.defaultDate;
	
	        if (isDate(defDate)) {
	            if (opts.setDefaultDate) {
	                self.setDate(defDate, true);
	            } else {
	                self.gotoDate(defDate);
	            }
	        } else {
	            self.gotoDate(new Date());
	        }
	
	        if (opts.bound) {
	            this.hide();
	            self.el.className += ' is-bound';
	            addEvent(opts.trigger, 'click', self._onInputClick);
	            addEvent(opts.trigger, 'focus', self._onInputFocus);
	            addEvent(opts.trigger, 'blur', self._onInputBlur);
	        } else {
	            this.show();
	        }
	    };
	
	
	    /**
	     * public Pikaday API
	     */
	    Pikaday.prototype = {
	
	
	        /**
	         * configure functionality
	         */
	        config: function(options)
	        {
	            if (!this._o) {
	                this._o = extend({}, defaults, true);
	            }
	
	            var opts = extend(this._o, options, true);
	
	            opts.isRTL = !!opts.isRTL;
	
	            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;
	
	            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;
	
	            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);
	
	            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;
	
	            opts.disableWeekends = !!opts.disableWeekends;
	
	            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;
	
	            var nom = parseInt(opts.numberOfMonths, 10) || 1;
	            opts.numberOfMonths = nom > 4 ? 4 : nom;
	
	            if (!isDate(opts.minDate)) {
	                opts.minDate = false;
	            }
	            if (!isDate(opts.maxDate)) {
	                opts.maxDate = false;
	            }
	            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
	                opts.maxDate = opts.minDate = false;
	            }
	            if (opts.minDate) {
	                this.setMinDate(opts.minDate);
	            }
	            if (opts.maxDate) {
	                this.setMaxDate(opts.maxDate);
	            }
	
	            if (isArray(opts.yearRange)) {
	                var fallback = new Date().getFullYear() - 10;
	                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
	                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
	            } else {
	                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
	                if (opts.yearRange > 100) {
	                    opts.yearRange = 100;
	                }
	            }
	
	            return opts;
	        },
	
	        /**
	         * return a formatted string of the current selection (using Moment.js if available)
	         */
	        toString: function(format)
	        {
	            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
	        },
	
	        /**
	         * return a Moment.js object of the current selection (if available)
	         */
	        getMoment: function()
	        {
	            return hasMoment ? moment(this._d) : null;
	        },
	
	        /**
	         * set the current selection from a Moment.js object (if available)
	         */
	        setMoment: function(date, preventOnSelect)
	        {
	            if (hasMoment && moment.isMoment(date)) {
	                this.setDate(date.toDate(), preventOnSelect);
	            }
	        },
	
	        /**
	         * return a Date object of the current selection
	         */
	        getDate: function()
	        {
	            return isDate(this._d) ? new Date(this._d.getTime()) : null;
	        },
	
	        /**
	         * set the current selection
	         */
	        setDate: function(date, preventOnSelect)
	        {
	            if (!date) {
	                this._d = null;
	
	                if (this._o.field) {
	                    this._o.field.value = '';
	                    fireEvent(this._o.field, 'change', { firedBy: this });
	                }
	
	                return this.draw();
	            }
	            if (typeof date === 'string') {
	                date = new Date(Date.parse(date));
	            }
	            if (!isDate(date)) {
	                return;
	            }
	
	            var min = this._o.minDate,
	                max = this._o.maxDate;
	
	            if (isDate(min) && date < min) {
	                date = min;
	            } else if (isDate(max) && date > max) {
	                date = max;
	            }
	
	            this._d = new Date(date.getTime());
	            setToStartOfDay(this._d);
	            this.gotoDate(this._d);
	
	            if (this._o.field) {
	                this._o.field.value = this.toString();
	                fireEvent(this._o.field, 'change', { firedBy: this });
	            }
	            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
	                this._o.onSelect.call(this, this.getDate());
	            }
	        },
	
	        /**
	         * change view to a specific date
	         */
	        gotoDate: function(date)
	        {
	            var newCalendar = true;
	
	            if (!isDate(date)) {
	                return;
	            }
	
	            if (this.calendars) {
	                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
	                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
	                    visibleDate = date.getTime();
	                // get the end of the month
	                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
	                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
	                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
	            }
	
	            if (newCalendar) {
	                this.calendars = [{
	                    month: date.getMonth(),
	                    year: date.getFullYear()
	                }];
	                if (this._o.mainCalendar === 'right') {
	                    this.calendars[0].month += 1 - this._o.numberOfMonths;
	                }
	            }
	
	            this.adjustCalendars();
	        },
	
	        adjustCalendars: function() {
	            this.calendars[0] = adjustCalendar(this.calendars[0]);
	            for (var c = 1; c < this._o.numberOfMonths; c++) {
	                this.calendars[c] = adjustCalendar({
	                    month: this.calendars[0].month + c,
	                    year: this.calendars[0].year
	                });
	            }
	            this.draw();
	        },
	
	        gotoToday: function()
	        {
	            this.gotoDate(new Date());
	        },
	
	        /**
	         * change view to a specific month (zero-index, e.g. 0: January)
	         */
	        gotoMonth: function(month)
	        {
	            if (!isNaN(month)) {
	                this.calendars[0].month = parseInt(month, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        nextMonth: function()
	        {
	            this.calendars[0].month++;
	            this.adjustCalendars();
	        },
	
	        prevMonth: function()
	        {
	            this.calendars[0].month--;
	            this.adjustCalendars();
	        },
	
	        /**
	         * change view to a specific full year (e.g. "2012")
	         */
	        gotoYear: function(year)
	        {
	            if (!isNaN(year)) {
	                this.calendars[0].year = parseInt(year, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        /**
	         * change the minDate
	         */
	        setMinDate: function(value)
	        {
	            setToStartOfDay(value);
	            this._o.minDate = value;
	            this._o.minYear  = value.getFullYear();
	            this._o.minMonth = value.getMonth();
	            this.draw();
	        },
	
	        /**
	         * change the maxDate
	         */
	        setMaxDate: function(value)
	        {
	            setToStartOfDay(value);
	            this._o.maxDate = value;
	            this._o.maxYear = value.getFullYear();
	            this._o.maxMonth = value.getMonth();
	            this.draw();
	        },
	
	        setStartRange: function(value)
	        {
	            this._o.startRange = value;
	        },
	
	        setEndRange: function(value)
	        {
	            this._o.endRange = value;
	        },
	
	        /**
	         * refresh the HTML
	         */
	        draw: function(force)
	        {
	            if (!this._v && !force) {
	                return;
	            }
	            var opts = this._o,
	                minYear = opts.minYear,
	                maxYear = opts.maxYear,
	                minMonth = opts.minMonth,
	                maxMonth = opts.maxMonth,
	                html = '';
	
	            if (this._y <= minYear) {
	                this._y = minYear;
	                if (!isNaN(minMonth) && this._m < minMonth) {
	                    this._m = minMonth;
	                }
	            }
	            if (this._y >= maxYear) {
	                this._y = maxYear;
	                if (!isNaN(maxMonth) && this._m > maxMonth) {
	                    this._m = maxMonth;
	                }
	            }
	
	            for (var c = 0; c < opts.numberOfMonths; c++) {
	                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year) + this.render(this.calendars[c].year, this.calendars[c].month) + '</div>';
	            }
	
	            this.el.innerHTML = html;
	
	            if (opts.bound) {
	                if(opts.field.type !== 'hidden') {
	                    sto(function() {
	                        opts.trigger.focus();
	                    }, 1);
	                }
	            }
	
	            if (typeof this._o.onDraw === 'function') {
	                var self = this;
	                sto(function() {
	                    self._o.onDraw.call(self);
	                }, 0);
	            }
	        },
	
	        adjustPosition: function()
	        {
	            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;
	
	            if (this._o.container) return;
	
	            this.el.style.position = 'absolute';
	
	            field = this._o.trigger;
	            pEl = field;
	            width = this.el.offsetWidth;
	            height = this.el.offsetHeight;
	            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
	
	            if (typeof field.getBoundingClientRect === 'function') {
	                clientRect = field.getBoundingClientRect();
	                left = clientRect.left + window.pageXOffset;
	                top = clientRect.bottom + window.pageYOffset;
	            } else {
	                left = pEl.offsetLeft;
	                top  = pEl.offsetTop + pEl.offsetHeight;
	                while((pEl = pEl.offsetParent)) {
	                    left += pEl.offsetLeft;
	                    top  += pEl.offsetTop;
	                }
	            }
	
	            // default position is bottom & left
	            if ((this._o.reposition && left + width > viewportWidth) ||
	                (
	                    this._o.position.indexOf('right') > -1 &&
	                    left - width + field.offsetWidth > 0
	                )
	            ) {
	                left = left - width + field.offsetWidth;
	            }
	            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
	                (
	                    this._o.position.indexOf('top') > -1 &&
	                    top - height - field.offsetHeight > 0
	                )
	            ) {
	                top = top - height - field.offsetHeight;
	            }
	
	            this.el.style.left = left + 'px';
	            this.el.style.top = top + 'px';
	        },
	
	        /**
	         * render HTML for a particular month
	         */
	        render: function(year, month)
	        {
	            var opts   = this._o,
	                now    = new Date(),
	                days   = getDaysInMonth(year, month),
	                before = new Date(year, month, 1).getDay(),
	                data   = [],
	                row    = [];
	            setToStartOfDay(now);
	            if (opts.firstDay > 0) {
	                before -= opts.firstDay;
	                if (before < 0) {
	                    before += 7;
	                }
	            }
	            var cells = days + before,
	                after = cells;
	            while(after > 7) {
	                after -= 7;
	            }
	            cells += 7 - after;
	            for (var i = 0, r = 0; i < cells; i++)
	            {
	                var day = new Date(year, month, 1 + (i - before)),
	                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
	                    isToday = compareDates(day, now),
	                    isEmpty = i < before || i >= (days + before),
	                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
	                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
	                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
	                    isDisabled = (opts.minDate && day < opts.minDate) ||
	                                 (opts.maxDate && day > opts.maxDate) ||
	                                 (opts.disableWeekends && isWeekend(day)) ||
	                                 (opts.disableDayFn && opts.disableDayFn(day)),
	                    dayConfig = {
	                        day: 1 + (i - before),
	                        month: month,
	                        year: year,
	                        isSelected: isSelected,
	                        isToday: isToday,
	                        isDisabled: isDisabled,
	                        isEmpty: isEmpty,
	                        isStartRange: isStartRange,
	                        isEndRange: isEndRange,
	                        isInRange: isInRange
	                    };
	
	                row.push(renderDay(dayConfig));
	
	                if (++r === 7) {
	                    if (opts.showWeekNumber) {
	                        row.unshift(renderWeek(i - before, month, year));
	                    }
	                    data.push(renderRow(row, opts.isRTL));
	                    row = [];
	                    r = 0;
	                }
	            }
	            return renderTable(opts, data);
	        },
	
	        isVisible: function()
	        {
	            return this._v;
	        },
	
	        show: function()
	        {
	            if (!this._v) {
	                removeClass(this.el, 'is-hidden');
	                this._v = true;
	                this.draw();
	                if (this._o.bound) {
	                    addEvent(document, 'click', this._onClick);
	                    this.adjustPosition();
	                }
	                if (typeof this._o.onOpen === 'function') {
	                    this._o.onOpen.call(this);
	                }
	            }
	        },
	
	        hide: function()
	        {
	            var v = this._v;
	            if (v !== false) {
	                if (this._o.bound) {
	                    removeEvent(document, 'click', this._onClick);
	                }
	                this.el.style.position = 'static'; // reset
	                this.el.style.left = 'auto';
	                this.el.style.top = 'auto';
	                addClass(this.el, 'is-hidden');
	                this._v = false;
	                if (v !== undefined && typeof this._o.onClose === 'function') {
	                    this._o.onClose.call(this);
	                }
	            }
	        },
	
	        /**
	         * GAME OVER
	         */
	        destroy: function()
	        {
	            this.hide();
	            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
	            removeEvent(this.el, 'touchend', this._onMouseDown, true);
	            removeEvent(this.el, 'change', this._onChange);
	            if (this._o.field) {
	                removeEvent(this._o.field, 'change', this._onInputChange);
	                if (this._o.bound) {
	                    removeEvent(this._o.trigger, 'click', this._onInputClick);
	                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
	                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
	                }
	            }
	            if (this.el.parentNode) {
	                this.el.parentNode.removeChild(this.el);
	            }
	        }
	
	    };
	
	    return Pikaday;
	
	}));


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.6
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthOddness = reference.width % 2 === popper.width % 2;
	  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
	  var verticalToInteger = !shouldRound ? noRound : Math.round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var ReactPropTypesSecret = __webpack_require__(645);
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error) : void 0;
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '') : void 0;
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {if (process.env.npm_package_name === 'pseudomap' &&
	    process.env.npm_lifecycle_script === 'test')
	  process.env.TEST_PSEUDOMAP = 'true'
	
	if (typeof Map === 'function' && !process.env.TEST_PSEUDOMAP) {
	  module.exports = Map
	} else {
	  module.exports = __webpack_require__(1599)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1599 */
/***/ function(module, exports) {

	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	module.exports = PseudoMap
	
	function PseudoMap (set) {
	  if (!(this instanceof PseudoMap)) // whyyyyyyy
	    throw new TypeError("Constructor PseudoMap requires 'new'")
	
	  this.clear()
	
	  if (set) {
	    if ((set instanceof PseudoMap) ||
	        (typeof Map === 'function' && set instanceof Map))
	      set.forEach(function (value, key) {
	        this.set(key, value)
	      }, this)
	    else if (Array.isArray(set))
	      set.forEach(function (kv) {
	        this.set(kv[0], kv[1])
	      }, this)
	    else
	      throw new TypeError('invalid argument')
	  }
	}
	
	PseudoMap.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this
	  Object.keys(this._data).forEach(function (k) {
	    if (k !== 'size')
	      fn.call(thisp, this._data[k].value, this._data[k].key)
	  }, this)
	}
	
	PseudoMap.prototype.has = function (k) {
	  return !!find(this._data, k)
	}
	
	PseudoMap.prototype.get = function (k) {
	  var res = find(this._data, k)
	  return res && res.value
	}
	
	PseudoMap.prototype.set = function (k, v) {
	  set(this._data, k, v)
	}
	
	PseudoMap.prototype.delete = function (k) {
	  var res = find(this._data, k)
	  if (res) {
	    delete this._data[res._index]
	    this._data.size--
	  }
	}
	
	PseudoMap.prototype.clear = function () {
	  var data = Object.create(null)
	  data.size = 0
	
	  Object.defineProperty(this, '_data', {
	    value: data,
	    enumerable: false,
	    configurable: true,
	    writable: false
	  })
	}
	
	Object.defineProperty(PseudoMap.prototype, 'size', {
	  get: function () {
	    return this._data.size
	  },
	  set: function (n) {},
	  enumerable: true,
	  configurable: true
	})
	
	PseudoMap.prototype.values =
	PseudoMap.prototype.keys =
	PseudoMap.prototype.entries = function () {
	  throw new Error('iterators are not implemented in this version')
	}
	
	// Either identical, or both NaN
	function same (a, b) {
	  return a === b || a !== a && b !== b
	}
	
	function Entry (k, v, i) {
	  this.key = k
	  this.value = v
	  this._index = i
	}
	
	function find (data, k) {
	  for (var i = 0, s = '_' + k, key = s;
	       hasOwnProperty.call(data, key);
	       key = s + i++) {
	    if (same(data[key].key, k))
	      return data[key]
	  }
	}
	
	function set (data, k, v) {
	  for (var i = 0, s = '_' + k, key = s;
	       hasOwnProperty.call(data, key);
	       key = s + i++) {
	    if (same(data[key].key, k)) {
	      data[key].value = v
	      return
	    }
	  }
	  data.size++
	  data[key] = new Entry(k, v, key)
	}


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stringify = __webpack_require__(1602);
	var Parse = __webpack_require__(1601);
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Utils = __webpack_require__(646);
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000,
	    strictNullHandling: false,
	    plainObjects: false,
	    allowPrototypes: false,
	    allowDots: false
	};
	
	internals.parseValues = function (str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	
	            if (options.strictNullHandling) {
	                obj[Utils.decode(part)] = null;
	            }
	        } else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty.call(obj, key)) {
	                obj[key] = [].concat(obj[key]).concat(val);
	            } else {
	                obj[key] = val;
	            }
	        }
	    }
	
	    return obj;
	};
	
	internals.parseObject = function (chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index) &&
	            root !== cleanRoot &&
	            String(index) === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	internals.parseKeys = function (givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^\.\[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1])) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            if (!options.allowPrototypes) {
	                continue;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	
	    if (
	        str === '' ||
	        str === null ||
	        typeof str === 'undefined'
	    ) {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj, options);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Utils = __webpack_require__(646);
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix) {
	            return prefix;
	        }
	    },
	    strictNullHandling: false,
	    skipNulls: false,
	    encode: true
	};
	
	internals.stringify = function (object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (Utils.isBuffer(obj)) {
	        obj = String(obj);
	    } else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encode ? Utils.encode(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
	        if (encode) {
	            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
	        }
	        return [prefix + '=' + obj];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
	        } else {
	            values = values.concat(internals.stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var objKeys;
	    var filter;
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        objKeys = filter = options.filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1727);

/***/ },
/* 1604 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var focusNode = __webpack_require__(539);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(216);
	var ExecutionEnvironment = __webpack_require__(50);
	var FallbackCompositionState = __webpack_require__(1612);
	var SyntheticCompositionEvent = __webpack_require__(1648);
	var SyntheticInputEvent = __webpack_require__(1651);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(647);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(74);
	
	var camelizeStyleName = __webpack_require__(1286);
	var dangerousStyleValue = __webpack_require__(1657);
	var hyphenateStyleName = __webpack_require__(1293);
	var memoizeStringOnly = __webpack_require__(1296);
	var warning = __webpack_require__(13);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(215);
	var EventPropagators = __webpack_require__(216);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(87);
	var SyntheticEvent = __webpack_require__(100);
	
	var getEventTarget = __webpack_require__(414);
	var isEventSupported = __webpack_require__(415);
	var isTextInputElement = __webpack_require__(666);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var DOMLazyTree = __webpack_require__(171);
	var ExecutionEnvironment = __webpack_require__(50);
	
	var createNodesFromMarkup = __webpack_require__(1289);
	var emptyFunction = __webpack_require__(56);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1610 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticMouseEvent = __webpack_require__(290);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(144);
	
	var getTextContentAccessor = __webpack_require__(663);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(172);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(173);
	
	var instantiateReactComponent = __webpack_require__(665);
	var KeyEscapeUtils = __webpack_require__(406);
	var shouldUpdateReactComponent = __webpack_require__(416);
	var traverseAllChildren = __webpack_require__(668);
	var warning = __webpack_require__(13);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(424);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(402);
	var ReactDOMIDOperations = __webpack_require__(1621);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var React = __webpack_require__(101);
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactCurrentOwner = __webpack_require__(102);
	var ReactErrorUtils = __webpack_require__(409);
	var ReactInstanceMap = __webpack_require__(217);
	var ReactInstrumentation = __webpack_require__(74);
	var ReactNodeTypes = __webpack_require__(658);
	var ReactReconciler = __webpack_require__(173);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(196);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(256);
	var shouldUpdateReactComponent = __webpack_require__(416);
	var warning = __webpack_require__(13);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var AutoFocusUtils = __webpack_require__(1605);
	var CSSPropertyOperations = __webpack_require__(1607);
	var DOMLazyTree = __webpack_require__(171);
	var DOMNamespaces = __webpack_require__(403);
	var DOMProperty = __webpack_require__(172);
	var DOMPropertyOperations = __webpack_require__(649);
	var EventPluginHub = __webpack_require__(215);
	var EventPluginRegistry = __webpack_require__(404);
	var ReactBrowserEventEmitter = __webpack_require__(289);
	var ReactDOMComponentFlags = __webpack_require__(651);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMInput = __webpack_require__(1622);
	var ReactDOMOption = __webpack_require__(1623);
	var ReactDOMSelect = __webpack_require__(652);
	var ReactDOMTextarea = __webpack_require__(1626);
	var ReactInstrumentation = __webpack_require__(74);
	var ReactMultiChild = __webpack_require__(1635);
	var ReactServerRenderingTransaction = __webpack_require__(1640);
	
	var emptyFunction = __webpack_require__(56);
	var escapeTextContentForBrowser = __webpack_require__(292);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(415);
	var shallowEqual = __webpack_require__(256);
	var validateDOMNesting = __webpack_require__(417);
	var warning = __webpack_require__(13);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(417);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var DOMLazyTree = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1620 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(402);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var DOMPropertyOperations = __webpack_require__(649);
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(87);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var React = __webpack_require__(101);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMSelect = __webpack_require__(652);
	
	var warning = __webpack_require__(13);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var getNodeForCharacterOffset = __webpack_require__(1662);
	var getTextContentAccessor = __webpack_require__(663);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var DOMChildrenOperations = __webpack_require__(402);
	var DOMLazyTree = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var escapeTextContentForBrowser = __webpack_require__(292);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(417);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20),
	    _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(407);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(87);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactUpdates = __webpack_require__(87);
	var Transaction = __webpack_require__(291);
	
	var emptyFunction = __webpack_require__(56);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1604);
	var BeforeInputEventPlugin = __webpack_require__(1606);
	var ChangeEventPlugin = __webpack_require__(1608);
	var DefaultEventPluginOrder = __webpack_require__(1610);
	var EnterLeaveEventPlugin = __webpack_require__(1611);
	var HTMLDOMPropertyConfig = __webpack_require__(1613);
	var ReactComponentBrowserEnvironment = __webpack_require__(1615);
	var ReactDOMComponent = __webpack_require__(1617);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMEmptyComponent = __webpack_require__(1619);
	var ReactDOMTreeTraversal = __webpack_require__(1627);
	var ReactDOMTextComponent = __webpack_require__(1625);
	var ReactDefaultBatchingStrategy = __webpack_require__(1628);
	var ReactEventListener = __webpack_require__(1632);
	var ReactInjection = __webpack_require__(1633);
	var ReactReconcileTransaction = __webpack_require__(1638);
	var SVGDOMPropertyConfig = __webpack_require__(1643);
	var SelectEventPlugin = __webpack_require__(1644);
	var SimpleEventPlugin = __webpack_require__(1645);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1630 */
690,
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(215);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventListener = __webpack_require__(538);
	var ExecutionEnvironment = __webpack_require__(50);
	var PooledClass = __webpack_require__(144);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(87);
	
	var getEventTarget = __webpack_require__(414);
	var getUnboundedScrollPosition = __webpack_require__(1291);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(172);
	var EventPluginHub = __webpack_require__(215);
	var EventPluginUtils = __webpack_require__(405);
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactEmptyComponent = __webpack_require__(653);
	var ReactBrowserEventEmitter = __webpack_require__(289);
	var ReactHostComponent = __webpack_require__(655);
	var ReactUpdates = __webpack_require__(87);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1656);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactInstanceMap = __webpack_require__(217);
	var ReactInstrumentation = __webpack_require__(74);
	
	var ReactCurrentOwner = __webpack_require__(102);
	var ReactReconciler = __webpack_require__(173);
	var ReactChildReconciler = __webpack_require__(1614);
	
	var emptyFunction = __webpack_require__(56);
	var flattenChildren = __webpack_require__(1659);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1637 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(648);
	var PooledClass = __webpack_require__(144);
	var ReactBrowserEventEmitter = __webpack_require__(289);
	var ReactInputSelection = __webpack_require__(656);
	var ReactInstrumentation = __webpack_require__(74);
	var Transaction = __webpack_require__(291);
	var ReactUpdateQueue = __webpack_require__(410);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1636);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(144);
	var Transaction = __webpack_require__(291);
	var ReactInstrumentation = __webpack_require__(74);
	var ReactServerUpdateQueue = __webpack_require__(1641);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(410);
	
	var warning = __webpack_require__(13);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1642 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.0';

/***/ },
/* 1643 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(216);
	var ExecutionEnvironment = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInputSelection = __webpack_require__(656);
	var SyntheticEvent = __webpack_require__(100);
	
	var getActiveElement = __webpack_require__(540);
	var isTextInputElement = __webpack_require__(666);
	var shallowEqual = __webpack_require__(256);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var EventListener = __webpack_require__(538);
	var EventPropagators = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticAnimationEvent = __webpack_require__(1646);
	var SyntheticClipboardEvent = __webpack_require__(1647);
	var SyntheticEvent = __webpack_require__(100);
	var SyntheticFocusEvent = __webpack_require__(1650);
	var SyntheticKeyboardEvent = __webpack_require__(1652);
	var SyntheticMouseEvent = __webpack_require__(290);
	var SyntheticDragEvent = __webpack_require__(1649);
	var SyntheticTouchEvent = __webpack_require__(1653);
	var SyntheticTransitionEvent = __webpack_require__(1654);
	var SyntheticUIEvent = __webpack_require__(218);
	var SyntheticWheelEvent = __webpack_require__(1655);
	
	var emptyFunction = __webpack_require__(56);
	var getEventCharCode = __webpack_require__(412);
	var invariant = __webpack_require__(10);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(290);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(218);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(218);
	
	var getEventCharCode = __webpack_require__(412);
	var getEventKey = __webpack_require__(1660);
	var getEventModifierState = __webpack_require__(413);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(218);
	
	var getEventModifierState = __webpack_require__(413);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(100);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(290);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1656 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(647);
	var warning = __webpack_require__(13);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(102);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstanceMap = __webpack_require__(217);
	
	var getHostComponentFromComposite = __webpack_require__(662);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(406);
	var traverseAllChildren = __webpack_require__(668);
	var warning = __webpack_require__(13);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(424);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(412);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1661 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1662 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(292);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(657);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1667);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(56);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var ReactPropTypesSecret = __webpack_require__(1668);
	var checkPropTypes = __webpack_require__(1665);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1668 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1671);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1670 */
[1806, 1672],
/* 1671 */
[1807, 1670],
/* 1672 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(355);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1673);


/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var ExecutionEnvironment = __webpack_require__(1228);
	var ModalPortal = React.createFactory(__webpack_require__(1676));
	var ariaAppHider = __webpack_require__(1677);
	var elementClass = __webpack_require__(1227);
	var renderSubtreeIntoContainer = __webpack_require__(39).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(596);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	var Modal = React.createClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired,
	    style: React.PropTypes.shape({
	      content: React.PropTypes.object,
	      overlay: React.PropTypes.object
	    }),
	    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    closeTimeoutMS: React.PropTypes.number,
	    ariaHideApp: React.PropTypes.bool,
	    shouldCloseOnOverlayClick: React.PropTypes.bool
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = 'ReactModalPortal';
	    AppElement.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    AppElement.removeChild(this.node);
	    elementClass(document.body).remove('ReactModal__Body--open');
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen) {
	      elementClass(document.body).add('ReactModal__Body--open');
	    } else {
	      elementClass(document.body).remove('ReactModal__Body--open');
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return React.DOM.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var div = React.DOM.div;
	var focusManager = __webpack_require__(1678);
	var scopeTab = __webpack_require__(1679);
	var Assign = __webpack_require__(596);
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: {
	    base: 'ReactModal__Overlay',
	    afterOpen: 'ReactModal__Overlay--after-open',
	    beforeClose: 'ReactModal__Overlay--before-close'
	  },
	  content: {
	    base: 'ReactModal__Content',
	    afterOpen: 'ReactModal__Content--after-open',
	    beforeClose: 'ReactModal__Content--before-close'
	  }
	};
	
	var ModalPortal = module.exports = React.createClass({
	
	  displayName: 'ModalPortal',
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  open: function() {
	    focusManager.setupScopedFocus(this.node);
	    focusManager.markForFocusLater();
	    this.setState({isOpen: true}, function() {
	      this.setState({afterOpen: true});
	
	      if (this.props.isOpen && this.props.onAfterOpen) {
	        this.props.onAfterOpen();
	      }
	    }.bind(this));
	  },
	
	  close: function() {
	    if (!this.ownerHandlesClose())
	      return;
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    this.refs.content.focus();
	  },
	
	  closeWithTimeout: function() {
	    this.setState({beforeClose: true}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      afterOpen: false,
	      beforeClose: false
	    }, this.afterClose);
	  },
	
	  afterClose: function() {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayClick: function(event) {
	    var node = event.target
	
	    while (node) {
	      if (node === this.refs.content) return
	      node = node.parentNode
	    }
	
	    if (this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.props.isOpen && !this.state.beforeClose;
	  },
	
	  buildClassName: function(which, additional) {
	    var className = CLASS_NAMES[which].base;
	    if (this.state.afterOpen)
	      className += ' '+CLASS_NAMES[which].afterOpen;
	    if (this.state.beforeClose)
	      className += ' '+CLASS_NAMES[which].beforeClose;
	    return additional ? className + ' ' + additional : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 1677 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(669);
	var modalElement = null;
	var focusLaterElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation 
	    // is that the document.body gets focus, and then we focus our element right 
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElement = document.activeElement;
	};
	
	exports.returnFocus = function() {
	  try {
	    focusLaterElement.focus();
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
	  }
	  focusLaterElement = null;
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};
	
	


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(669);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(1584);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pikaday = undefined;
	if ('undefined' !== typeof window) {
	    Pikaday = __webpack_require__(1595);
	}
	
	var ReactPikadayComponent = (function (_React$Component) {
	    _inherits(ReactPikadayComponent, _React$Component);
	
	    function ReactPikadayComponent() {
	        _classCallCheck(this, ReactPikadayComponent);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(ReactPikadayComponent).apply(this, arguments));
	    }
	
	    _createClass(ReactPikadayComponent, [{
	        key: '_getValueLink',
	
	        // see Pikaday options at https://github.com/dbushell/Pikaday#configuration
	        // except `onSelect` and `field`
	        value: function _getValueLink(props) {
	            return props.valueLink || {
	                value: props.value,
	                requestChange: props.onChange
	            };
	        }
	    }, {
	        key: '_setDateIfChanged',
	        value: function _setDateIfChanged(newDate, prevDate) {
	            var newTime = newDate ? newDate.getTime() : null;
	            var prevTime = prevDate ? prevDate.getTime() : null;
	
	            if (newTime !== prevTime) {
	                if (isNaN(newTime)) {
	                    // workaround for pikaday not clearing value when date set to false
	                    var el = _reactDom2.default.findDOMNode(this.refs.pikaday);
	                    el.value = '';
	                }
	                this._picker.setDate(newDate, true); // not trigger onSelect
	            }
	        }
	    }, {
	        key: '_setupPikaday',
	        value: function _setupPikaday() {
	            var el = _reactDom2.default.findDOMNode(this.refs.pikaday);
	
	            var _getValueLink2 = this._getValueLink(this.props);
	
	            var requestChange = _getValueLink2.requestChange;
	            var _props = this.props;
	            var value = _props.value;
	            var onChange = _props.onChange;
	            var valueLink = _props.valueLink;
	
	            var pikadayOptions = _objectWithoutProperties(_props, ['value', 'onChange', 'valueLink']);
	
	            var options = (0, _objectAssign2.default)({}, pikadayOptions, {
	                field: el,
	                onSelect: requestChange
	            });
	
	            this._picker = new Pikaday(options);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _getValueLink3 = this._getValueLink(this.props);
	
	            var value = _getValueLink3.value;
	
	            this._setupPikaday();
	
	            this._setDateIfChanged(value);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var newDate = this._getValueLink(nextProps).value;
	            var lastDate = this._getValueLink(this.props).value;
	
	            this._setDateIfChanged(newDate, lastDate);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            // update if container is set
	            if (!prevProps.container && this.props.container) {
	                var newDate = this._getValueLink(this.props).value;
	                var lastDate = this._getValueLink(prevProps).value;
	                this._picker.destroy();
	                this._setupPikaday();
	                this._setDateIfChanged(newDate, lastDate);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props;
	            var className = _props2.className;
	            var disabled = _props2.disabled;
	            var placeholder = _props2.placeholder;
	            var readOnly = _props2.readOnly;
	            var style = _props2.style;
	
	            return _react2.default.createElement('input', {
	                type: 'text',
	                ref: 'pikaday',
	                className: className,
	                style: style,
	                placeholder: placeholder,
	                disabled: disabled,
	                readOnly: readOnly
	            });
	        }
	    }]);
	
	    return ReactPikadayComponent;
	})(_react2.default.Component);
	
	ReactPikadayComponent.propTypes = {
	    value: _react.PropTypes.instanceOf(Date),
	    onChange: _react.PropTypes.func,
	    valueLink: _react.PropTypes.shape({
	        value: _react.PropTypes.instanceOf(Date),
	        requestChange: _react.PropTypes.func.isRequired
	    }) };
	exports.default = ReactPikadayComponent;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(294);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Arrow;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(294);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manager = function (_Component) {
	  _inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return (0, _react.createElement)(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	
	  return Manager;
	}(_react.Component);
	
	Manager.childContextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Manager.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	exports.default = Manager;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(294);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popper = __webpack_require__(1596);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popper = function (_Component) {
	  _inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	      // If Popper isn't instantiated, hide the popperElement
	      // to avoid flash of unstyled content
	
	      if (!data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      var _data$offsets$popper = data.offsets.popper,
	          top = _data$offsets$popper.top,
	          left = _data$offsets$popper.left,
	          position = _data$offsets$popper.position;
	
	
	      return _extends({
	        position: position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	
	      if (lastProps.children !== this.props.children) {
	        this._popper.scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	
	      if (this._arrowNode) {
	        modifiers.arrow = {
	          element: this._arrowNode
	        };
	      }
	
	      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // schedule an update to make sure everything gets positioned correctly
	      // after being instantiated
	      this._popper.scheduleUpdate();
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperRef = function popperRef(node) {
	        _this2._node = node;
	        if (node) {
	          _this2._createPopper();
	        } else {
	          _this2._destroyPopper();
	        }
	        if (typeof innerRef === 'function') {
	          innerRef(node);
	        }
	      };
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var _popperProps;
	
	        var popperProps = (_popperProps = {
	          ref: popperRef,
	          style: popperStyle
	        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);
	
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: function scheduleUpdate() {
	            // _createPopper will scheduleUpdate,
	            // so calling this before this._popper exists
	            // can be a noop.
	            _this2._popper && _this2._popper.scheduleUpdate();
	          }
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = popperRef;
	      } else {
	        componentProps.innerRef = popperRef;
	      }
	
	      return (0, _react.createElement)(component, componentProps, children);
	    }
	  }]);
	
	  return Popper;
	}(_react.Component);
	
	Popper.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Popper.childContextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	Popper.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  placement: _propTypes2.default.oneOf(_popper2.default.placements),
	  eventsEnabled: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	exports.default = Popper;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(294);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	
	Target.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Target;

/***/ },
/* 1685 */
[1806, 1686],
/* 1686 */
1672,
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(675);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(673);
	
	var _warning = __webpack_require__(418);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  storeSubscription: _PropTypes.subscriptionShape
	};
	Provider.displayName = 'Provider';

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(671);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1695);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1689);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1690);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1691);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1692);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(5);
	
	var _wrapMapToProps = __webpack_require__(672);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(672);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(674);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1693);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(418);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1694 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1695 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1696 */
[1806, 1697],
/* 1697 */
1672,
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(676);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(677);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(585);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(269);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(421);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	var _RouterContext = __webpack_require__(295);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _RouterUtils = __webpack_require__(678);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(295);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(419);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(295);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1453);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(680);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(174);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(419);
	
	var _makeStateWithLocation = __webpack_require__(681);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(174);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(585);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(680);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(174);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(166);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(679);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(421);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _RouterUtils = __webpack_require__(678);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(419);
	
	var _makeStateWithLocation = __webpack_require__(681);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(174);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(269);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(421);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(45);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(375);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(297);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(683);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(684);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function reduce(obj) {
		var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		return Object.keys(obj).reduce(function (props, key) {
			var value = obj[key];
			if (value !== undefined) props[key] = value;
			return props;
		}, props);
	}
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (asyncProps) {
						return _react2.default.createElement(
							_Creatable2.default,
							_this2.props,
							function (creatableProps) {
								return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
									onInputChange: function onInputChange(input) {
										creatableProps.onInputChange(input);
										return asyncProps.onInputChange(input);
									},
									ref: function ref(_ref) {
										_this2.select = _ref;
										creatableProps.ref(_ref);
										asyncProps.ref(_ref);
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	;
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(298);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'blockEvent',
			value: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	;
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = arrowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(175);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = clearRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};

/***/ },
/* 1723 */
[1806, 1724],
/* 1724 */
1672,
/* 1725 */
[1805, 177],
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(650);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	if (false) {
	  var ReactPerf;
	  var ReactTestUtils;
	
	  exports.getReactPerf = function () {
	    if (!ReactPerf) {
	      ReactPerf = require('react-dom/lib/ReactPerf');
	    }
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    if (!ReactTestUtils) {
	      ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	    }
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(101);
	var propTypesFactory = __webpack_require__(214);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var ReactTransitionGroup = __webpack_require__(1737);
	var ReactCSSTransitionGroupChild = __webpack_require__(1728);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: PropTypes.bool,
	  transitionEnter: PropTypes.bool,
	  transitionLeave: PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(101);
	var ReactAddonsDOMDependencies = __webpack_require__(1726);
	
	var propTypesFactory = __webpack_require__(214);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var CSSCore = __webpack_require__(1284);
	var ReactTransitionEvents = __webpack_require__(1736);
	
	var onlyChild = __webpack_require__(692);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroupChild, _React$Component);
	
	  function ReactCSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._isMounted = false, _this.transition = function (animationType, finishCallback, userSpecifiedDelay) {
	      var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(_this);
	
	      if (!node) {
	        if (finishCallback) {
	          finishCallback();
	        }
	        return;
	      }
	
	      var className = _this.props.name[animationType] || _this.props.name + '-' + animationType;
	      var activeClassName = _this.props.name[animationType + 'Active'] || className + '-active';
	      var timeout = null;
	
	      var endListener = function (e) {
	        if (e && e.target !== node) {
	          return;
	        }
	
	        clearTimeout(timeout);
	
	        CSSCore.removeClass(node, className);
	        CSSCore.removeClass(node, activeClassName);
	
	        ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	        // Usually this optional callback is used for informing an owner of
	        // a leave animation and telling it to remove the child.
	        if (finishCallback) {
	          finishCallback();
	        }
	      };
	
	      CSSCore.addClass(node, className);
	
	      // Need to do this to actually trigger a transition.
	      _this.queueClassAndNode(activeClassName, node);
	
	      // If the user specified a timeout delay.
	      if (userSpecifiedDelay) {
	        // Clean-up the animation after the specified delay
	        timeout = setTimeout(endListener, userSpecifiedDelay);
	        _this.transitionTimeouts.push(timeout);
	      } else {
	        // DEPRECATED: this listener will be removed in a future version of react
	        ReactTransitionEvents.addEndEventListener(node, endListener);
	      }
	    }, _this.queueClassAndNode = function (className, node) {
	      _this.classNameAndNodeQueue.push({
	        className: className,
	        node: node
	      });
	
	      if (!_this.timeout) {
	        _this.timeout = setTimeout(_this.flushClassNameAndNodeQueue, TICK);
	      }
	    }, _this.flushClassNameAndNodeQueue = function () {
	      if (_this._isMounted) {
	        _this.classNameAndNodeQueue.forEach(function (obj) {
	          CSSCore.addClass(obj.node, obj.className);
	        });
	      }
	      _this.classNameAndNodeQueue.length = 0;
	      _this.timeout = null;
	    }, _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.render = function render() {
	    return onlyChild(this.props.children);
	  };
	
	  return ReactCSSTransitionGroupChild;
	}(React.Component);
	
	ReactCSSTransitionGroupChild.propTypes = {
	  name: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
	    enter: PropTypes.string,
	    leave: PropTypes.string,
	    active: PropTypes.string
	  }), PropTypes.shape({
	    enter: PropTypes.string,
	    enterActive: PropTypes.string,
	    leave: PropTypes.string,
	    leaveActive: PropTypes.string,
	    appear: PropTypes.string,
	    appearActive: PropTypes.string
	  })]).isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: PropTypes.bool,
	  enter: PropTypes.bool,
	  leave: PropTypes.bool,
	  appearTimeout: PropTypes.number,
	  enterTimeout: PropTypes.number,
	  leaveTimeout: PropTypes.number
	};
	
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1725);
	var ReactElement = __webpack_require__(176);
	
	var emptyFunction = __webpack_require__(56);
	var traverseAllChildren = __webpack_require__(693);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(177),
	    _assign = __webpack_require__(178);
	
	var ReactComponent = __webpack_require__(423);
	var ReactElement = __webpack_require__(176);
	var ReactPropTypeLocationNames = __webpack_require__(1732);
	var ReactNoopUpdateQueue = __webpack_require__(425);
	
	var emptyObject = __webpack_require__(196);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(13);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(176);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(176),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(214);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	var ReactComponent = __webpack_require__(423);
	var ReactNoopUpdateQueue = __webpack_require__(425);
	
	var emptyObject = __webpack_require__(196);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(1739);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(50);
	
	var getVendorPrefixedEventName = __webpack_require__(664);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(178);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(101);
	var ReactTransitionChildMapping = __webpack_require__(1735);
	
	var propTypesFactory = __webpack_require__(214);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var emptyFunction = __webpack_require__(56);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: PropTypes.any,
	  childFactory: PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 1738 */
1642,
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(689);
	var traverseAllChildren = __webpack_require__(693);
	var warning = __webpack_require__(13);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(424);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1740 */
1661,
/* 1741 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(376);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(299);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(705);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(1746);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(427);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(695);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(694);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(426);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(1745);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(702);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(React),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(694);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(700);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(705);
	
	var _deepEqual = __webpack_require__(355);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(695);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(701);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(299);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(1758);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(1753);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(1742);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(1752);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(699);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(1764);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(1765);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.fields = (0, _readFields2.default)(props, {}, {}, _this.asyncValidate, isReactNative);
	        var submitPassback = _this.props.submitPassback;
	
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props;
	        var fields = _props.fields;
	        var form = _props.form;
	        var initialize = _props.initialize;
	        var initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props;
	        var alwaysAsyncValidate = _props2.alwaysAsyncValidate;
	        var asyncValidate = _props2.asyncValidate;
	        var dispatch = _props2.dispatch;
	        var fields = _props2.fields;
	        var form = _props2.form;
	        var startAsyncValidation = _props2.startAsyncValidation;
	        var stopAsyncValidation = _props2.stopAsyncValidation;
	        var validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var _ret = function () {
	            var values = (0, _getValues2.default)(fields, form);
	            if (name) {
	              values[name] = value;
	            }
	            var syncErrors = validate(values, _this2.props);
	            var allPristine = _this2.fields._meta.allPristine;
	
	            var initialized = form._initialized;
	
	            // if blur validating, only run async validate if sync validation passes
	            // and submitting (not blur validation) or form is dirty or form was never initialized
	            // unless alwaysAsyncValidate is true
	            var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	            if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	              return {
	                v: (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(values, dispatch, _this2.props);
	                }, startAsyncValidation, stopAsyncValidation, name)
	              };
	            }
	          }();
	
	          if (typeof _ret === "object") return _ret.v;
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props;
	        var onSubmit = _props3.onSubmit;
	        var fields = _props3.fields;
	        var form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref;
	
	        var allFields = this.fields;
	        var _props4 = this.props;
	        var addArrayValue = _props4.addArrayValue;
	        var asyncBlurFields = _props4.asyncBlurFields;
	        var autofill = _props4.autofill;
	        var blur = _props4.blur;
	        var change = _props4.change;
	        var destroy = _props4.destroy;
	        var focus = _props4.focus;
	        var fields = _props4.fields;
	        var form = _props4.form;
	        var initialValues = _props4.initialValues;
	        var initialize = _props4.initialize;
	        var onSubmit = _props4.onSubmit;
	        var propNamespace = _props4.propNamespace;
	        var reset = _props4.reset;
	        var removeArrayValue = _props4.removeArrayValue;
	        var returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise;
	        var startAsyncValidation = _props4.startAsyncValidation;
	        var startSubmit = _props4.startSubmit;
	        var stopAsyncValidation = _props4.stopAsyncValidation;
	        var stopSubmit = _props4.stopSubmit;
	        var submitFailed = _props4.submitFailed;
	        var swapArrayValues = _props4.swapArrayValues;
	        var touch = _props4.touch;
	        var untouch = _props4.untouch;
	        var validate = _props4.validate;
	
	        var passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta;
	        var allPristine = _allFields$_meta.allPristine;
	        var allValid = _allFields$_meta.allValid;
	        var errors = _allFields$_meta.errors;
	        var formError = _allFields$_meta.formError;
	        var values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref = {}, _ref[propNamespace] = props, _ref) : props;
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: PropTypes.bool,
	      asyncBlurFields: PropTypes.arrayOf(PropTypes.string),
	      asyncValidate: PropTypes.func,
	      dispatch: PropTypes.func.isRequired,
	      fields: PropTypes.arrayOf(PropTypes.string).isRequired,
	      form: PropTypes.object,
	      initialValues: PropTypes.any,
	      onSubmit: PropTypes.func,
	      onSubmitSuccess: PropTypes.func,
	      onSubmitFail: PropTypes.func,
	      overwriteOnInitialValuesChange: PropTypes.bool.isRequired,
	      propNamespace: PropTypes.string,
	      readonly: PropTypes.bool,
	      returnRejectedSubmitPromise: PropTypes.bool,
	      submitPassback: PropTypes.func.isRequired,
	      validate: PropTypes.func,
	
	      // actions:
	      addArrayValue: PropTypes.func.isRequired,
	      autofill: PropTypes.func.isRequired,
	      blur: PropTypes.func.isRequired,
	      change: PropTypes.func.isRequired,
	      destroy: PropTypes.func.isRequired,
	      focus: PropTypes.func.isRequired,
	      initialize: PropTypes.func.isRequired,
	      removeArrayValue: PropTypes.func.isRequired,
	      reset: PropTypes.func.isRequired,
	      startAsyncValidation: PropTypes.func.isRequired,
	      startSubmit: PropTypes.func.isRequired,
	      stopAsyncValidation: PropTypes.func.isRequired,
	      stopSubmit: PropTypes.func.isRequired,
	      submitFailed: PropTypes.func.isRequired,
	      swapArrayValues: PropTypes.func.isRequired,
	      touch: PropTypes.func.isRequired,
	      untouch: PropTypes.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ },
/* 1745 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createPropTypes = function createPropTypes(_ref) {
	  var _ref$PropTypes = _ref.PropTypes;
	  var any = _ref$PropTypes.any;
	  var bool = _ref$PropTypes.bool;
	  var string = _ref$PropTypes.string;
	  var func = _ref$PropTypes.func;
	  var object = _ref$PropTypes.object;
	  return {
	    // State:
	    active: string, // currently active field
	    asyncValidating: bool.isRequired, // true if async validation is running
	    autofilled: bool, // true if set programmatically by autofill
	    dirty: bool.isRequired, // true if any values are different from initialValues
	    error: any, // form-wide error from '_error' key in validation result
	    errors: object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: object.isRequired, // the map of fields
	    formKey: any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: bool.isRequired, // true if there are any validation errors
	    pristine: bool.isRequired, // true if the values are the same as initialValues
	    submitting: bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: bool.isRequired, // true if there are no validation errors
	    values: object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: func.isRequired, // function to trigger async validation
	    destroyForm: func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: func.isRequired, // function to submit the form
	    initializeForm: func.isRequired, // action to initialize form data
	    resetForm: func.isRequired, // action to reset the form data to previously initialized values
	    touch: func.isRequired, // action to mark fields as touched
	    touchAll: func.isRequired, // action to mark ALL fields as touched
	    untouch: func.isRequired, // action to mark fields as untouched
	    untouchAll: func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(1747);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(375);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _noGetters = __webpack_require__(1674);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(700);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(1744);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	    var PropTypes = React.PropTypes;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	        var _props = this.props;
	        var reduxMountPoint = _props.reduxMountPoint;
	        var destroyOnUnmount = _props.destroyOnUnmount;
	        var form = _props.form;
	        var getFormState = _props.getFormState;
	        var touchOnBlur = _props.touchOnBlur;
	        var touchOnChange = _props.touchOnChange;
	
	        var passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: PropTypes.bool,
	      reduxMountPoint: PropTypes.string,
	      form: PropTypes.string.isRequired,
	      formKey: PropTypes.string,
	      getFormState: PropTypes.func,
	      touchOnBlur: PropTypes.bool,
	      touchOnChange: PropTypes.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(697);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(697);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(696);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ },
/* 1751 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(699);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(376);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(299);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch;
	  var fields = props.fields;
	  var onSubmitSuccess = props.onSubmitSuccess;
	  var onSubmitFail = props.onSubmitFail;
	  var startSubmit = props.startSubmit;
	  var stopSubmit = props.stopSubmit;
	  var submitFailed = props.submitFailed;
	  var returnRejectedSubmitPromise = props.returnRejectedSubmitPromise;
	  var touch = props.touch;
	  var validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(179);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined ? {} : {
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	  var overwriteValues = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      (function () {
	        // is array notation
	        if (closeIndex < 0) {
	          throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	        }
	        var key = path.substring(0, openIndex);
	        var srcArray = src[key];
	        var destArray = result[key];
	        var rest = path.substring(closeIndex + 1);
	        if (Array.isArray(srcArray)) {
	          if (rest.length) {
	            // need to keep recursing
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	            });
	          } else {
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	            });
	          }
	        } else {
	          result[key] = [];
	        }
	      })();
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ },
/* 1755 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  }
	  return true;
	}

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(179);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var _ret = function () {
	        var array = state && state[field.key] || [];
	        var previousArray = previousState && previousState[field.key] || [];
	        var nestedField = extractKey(field.nestedPath);
	
	        return {
	          v: array.map(function (nestedState, i) {
	            nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	            return nestedState;
	          })
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && state[field.key] || {};
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(1748);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(1749);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(696);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(1750);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(1751);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(1762);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(704);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(1763);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(703);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return(
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length <= 8 || arguments[8] === undefined ? function () {
	    return null;
	  } : arguments[8];
	  var prefix = arguments.length <= 9 || arguments[9] === undefined ? '' : arguments[9];
	  var asyncBlurFields = props.asyncBlurFields;
	  var autofill = props.autofill;
	  var blur = props.blur;
	  var change = props.change;
	  var focus = props.focus;
	  var form = props.form;
	  var initialValues = props.initialValues;
	  var readonly = props.readonly;
	  var addArrayValue = props.addArrayValue;
	  var removeArrayValue = props.removeArrayValue;
	  var swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = fieldName.substring(0, openIndex);
	      var rest = getSuffix(fieldName, closeIndex);
	      var stateArray = state && state[key] || [];
	      var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	      var subfields = props.fields.reduce(function (accumulator, field) {
	        if (field.indexOf(fullPrefix) === 0) {
	          accumulator.push(field);
	        }
	        return accumulator;
	      }, []).map(function (field) {
	        return getSuffix(field, prefix.length + closeIndex);
	      });
	      var addMethods = function addMethods(dest) {
	        Object.defineProperty(dest, 'addField', {
	          value: function value(_value, index) {
	            return addArrayValue(pathToHere + key, _value, index, subfields);
	          }
	        });
	        Object.defineProperty(dest, 'removeField', {
	          value: function value(index) {
	            return removeArrayValue(pathToHere + key, index);
	          }
	        });
	        Object.defineProperty(dest, 'swapFields', {
	          value: function value(indexA, indexB) {
	            return swapArrayValues(pathToHere + key, indexA, indexB);
	          }
	        });
	        return dest;
	      };
	      if (!fields[key] || fields[key].length !== stateArray.length) {
	        fields[key] = fields[key] ? [].concat(fields[key]) : [];
	        addMethods(fields[key]);
	      }
	      var fieldArray = fields[key];
	      var changed = false;
	      stateArray.forEach(function (fieldState, index) {
	        if (rest && !fieldArray[index]) {
	          fieldArray[index] = {};
	          changed = true;
	        }
	        var dest = rest ? fieldArray[index] : {};
	        var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	        var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	        var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	        if (!rest && fieldArray[index] !== result) {
	          // if nothing after [] in field name, assign directly to array
	          fieldArray[index] = result;
	          changed = true;
	        }
	      });
	      if (fieldArray.length > stateArray.length) {
	        // remove extra items that aren't in state array
	        fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	      }
	      return {
	        v: changed ? addMethods([].concat(fieldArray)) : fieldArray
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var nextPrefix = prefix + _key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var defaultFieldState = {
	    initial: field.value,
	    value: field.value
	  };
	
	  var fieldState = (fieldName ? state[fieldName] : state) || defaultFieldState;
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(1757);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(706);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(701);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(1759);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields;
	  var form = props.form;
	  var validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ },
/* 1759 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = path.substring(0, openIndex);
	      if (!Array.isArray(fields[key])) {
	        return {
	          v: without(fields, key)
	        };
	      }
	      var rest = path.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      if (rest) {
	        var _ret2 = function () {
	          var _extends2;
	
	          var copy = [];
	          fields[key].forEach(function (item, index) {
	            var result = removeField(item, rest);
	            if (Object.keys(result).length) {
	              copy[index] = result;
	            }
	          });
	          return {
	            v: {
	              v: copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key)
	            }
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return {
	        v: without(fields, key)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(179);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(179);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _ret = function () {
	        var copy = (state || []).map(function (stateItem, index) {
	          return setErrors(stateItem, errors[index], destKey);
	        });
	        errors.forEach(function (errorItem, index) {
	          return copy[index] = setErrors(copy[index], errorItem, destKey);
	        });
	        return {
	          v: copy
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(376);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(1755);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(299);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(703);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(5);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if (mapDispatchToProps.length > 1) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ },
/* 1765 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if (mapStateToProps.length > 1) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(1482);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var _bufferActions = __webpack_require__(1767);
	
	var _bufferActions2 = _interopRequireDefault(_bufferActions);
	
	var _constants = __webpack_require__(300);
	
	module.exports = function autoRehydrate() {
	  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var rehydrationReducer = createRehydrationReducer(reducer);
	
	      // buffer actions
	      var store = next(rehydrationReducer, initialState, enhancer);
	      var dispatch = _bufferActions2['default'](onBufferEnd)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: dispatch
	      });
	    };
	  };
	
	  function onBufferEnd(err, queue) {
	    if (err) console.error(err);
	    if (config.log) console.log('redux-persist/autoRehydrate action buffer released', queue);
	  }
	
	  function createRehydrationReducer(reducer) {
	    return function (state, action) {
	      if (action.type !== _constants.REHYDRATE) return reducer(state, action);else {
	        var _ret = (function () {
	          var inboundState = action.payload;
	          var reducedState = reducer(state, action);
	          var newState = _extends({}, reducedState);
	
	          Object.keys(inboundState).forEach(function (key) {
	            // if reducer modifies substate, skip auto rehydration
	            if (state[key] !== reducedState[key]) {
	              if (config.log) console.log('redux-persist/autoRehydrate sub state for key "%s" modified, skipping autoRehydrate', key);
	              newState[key] = reducedState[key];
	              return;
	            }
	
	            // otherwise take the inboundState
	            if (checkIfPlain(inboundState[key], reducedState[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
	            else newState[key] = inboundState[key]; // hard set
	
	            if (config.log) console.log('redux-persist/autoRehydrate key: %s, rehydrated to:', key, newState[key]);
	          });
	          return {
	            v: newState
	          };
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	      }
	    };
	  }
	};
	
	function checkIfPlain(a, b) {
	  // isPlainObject + duck type not immutable
	  if (typeof a !== 'object' || typeof b !== 'object') return false;
	  if (typeof a.mergeDeep === 'function' || typeof b.mergeDeep === 'function') return false;
	  if (!_lodashIsplainobject2['default'](a) || !_lodashIsplainobject2['default'](b)) return false;
	  return true;
	}

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(300);
	
	module.exports = function bufferActions(cb) {
	  var active = true;
	  var queue = [];
	
	  return function (next) {
	    return function (action) {
	      if (!active) return next(action);
	      if (action.type === constants.REHYDRATE) {
	        active = false;
	        var result = next(action);
	        queue.forEach(function (queuedAction) {
	          return next(queuedAction);
	        });
	        cb(null, queue);
	        return result;
	      }
	      queue.push(action);
	    };
	  };
	};

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = persistStore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashForeach = __webpack_require__(597);
	
	var _lodashForeach2 = _interopRequireDefault(_lodashForeach);
	
	var _constants = __webpack_require__(300);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _defaultsAsyncLocalStorage = __webpack_require__(428);
	
	var _defaultsAsyncLocalStorage2 = _interopRequireDefault(_defaultsAsyncLocalStorage);
	
	var _getStoredState = __webpack_require__(707);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var genericSetImmediate = typeof setImmediate === 'undefined' ? global.setImmediate : setImmediate;
	
	function persistStore(store, config, onComplete) {
	  if (config === undefined) config = {};
	
	  // defaults
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var serialize = config.serialize || defaultSerialize;
	  var deserialize = config.deserialize || defaultDeserialize;
	  var transforms = config.transforms || [];
	  var storage = config.storage || _defaultsAsyncLocalStorage2['default']('local');
	  var debounce = config.debounce || false;
	  var shouldRestore = !config.skipRestore;
	
	  // initialize values
	  var timeIterator = null;
	  var lastState = store.getState();
	  var purgeMode = false;
	  var storesToProcess = [];
	
	  // restore
	  if (shouldRestore) {
	    genericSetImmediate(function () {
	      _getStoredState2['default'](_extends({}, config, { purgeMode: purgeMode }), function (err, restoredState) {
	        if (err && ("production") !== 'production') console.warn('Error in getStoredState', err);
	        store.dispatch(rehydrateAction(restoredState));
	        onComplete && onComplete(null, restoredState);
	      });
	    });
	  } else onComplete && genericSetImmediate(onComplete);
	
	  // store
	  store.subscribe(function () {
	    if (timeIterator !== null) clearInterval(timeIterator);
	
	    var state = store.getState();
	    _lodashForeach2['default'](state, function (subState, key) {
	      if (whitelistBlacklistCheck(key)) return;
	      if (lastState[key] === state[key]) return;
	      if (storesToProcess.indexOf(key) !== -1) return;
	      storesToProcess.push(key);
	    });
	
	    // time iterator (read: debounce)
	    timeIterator = setInterval(function () {
	      if (storesToProcess.length === 0) {
	        clearInterval(timeIterator);
	        return;
	      }
	
	      var key = createStorageKey(storesToProcess[0]);
	      var endState = transforms.reduce(function (subState, transformer) {
	        return transformer['in'](subState);
	      }, state[storesToProcess[0]]);
	      if (typeof endState !== 'undefined') storage.setItem(key, serialize(endState), warnIfSetError(key));
	      storesToProcess.shift();
	    }, debounce);
	
	    lastState = state;
	  });
	
	  function whitelistBlacklistCheck(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return true;
	    if (blacklist.indexOf(key) !== -1) return true;
	    return false;
	  }
	
	  function adhocRehydrate(serialized, cb) {
	    var state = null;
	
	    try {
	      var data = deserialize(serialized);
	      state = transforms.reduceRight(function (interState, transformer) {
	        return transformer.out(interState);
	      }, data);
	    } catch (err) {
	      if (false) console.warn('Error rehydrating data:', serialized, err);
	    }
	
	    store.dispatch(rehydrateAction(state));
	    cb && cb(null, state);
	  }
	
	  function purge(keys) {
	    purgeMode = keys;
	    _lodashForeach2['default'](keys, function (key) {
	      storage.removeItem(createStorageKey(key), warnIfRemoveError(key));
	    });
	  }
	
	  function purgeAll() {
	    purgeMode = '*';
	    storage.getAllKeys(function (err, allKeys) {
	      if (err && ("production") !== 'production') {
	        console.warn('Error in storage.getAllKeys');
	      }
	      purge(allKeys.filter(function (key) {
	        return key.indexOf(_constants2['default'].keyPrefix) === 0;
	      }).map(function (key) {
	        return key.slice(_constants2['default'].keyPrefix.length);
	      }));
	    });
	  }
	
	  // return `persistor`
	  return {
	    rehydrate: adhocRehydrate,
	    purge: purge,
	    purgeAll: purgeAll
	  };
	}
	
	function warnIfRemoveError(key) {
	  return function removeError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}
	
	function warnIfSetError(key) {
	  return function setError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}
	
	function createStorageKey(key) {
	  return _constants2['default'].keyPrefix + key;
	}
	
	function rehydrateAction(data) {
	  return {
	    type: _constants2['default'].REHYDRATE,
	    payload: data
	  };
	}
	
	function defaultSerialize(data) {
	  return JSON.stringify(data);
	}
	
	function defaultDeserialize(serial) {
	  return JSON.parse(serial);
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(302).setImmediate, (function() { return this; }())))

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(709);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1770 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(710);
	
	var _isPlainObject = __webpack_require__(285);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(711);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(146)


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(712)


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(713);
	exports.Stream = __webpack_require__(219);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(431);
	exports.Duplex = __webpack_require__(146);
	exports.Transform = __webpack_require__(430);
	exports.PassThrough = __webpack_require__(712);
	if (!process.browser && process.env.READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(219);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(430)


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(431)


/***/ },
/* 1777 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.4 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.Tether = factory();
	  }
	}(this, function() {
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TetherBase = undefined;
	if (typeof TetherBase === 'undefined') {
	  TetherBase = { modules: [] };
	}
	
	var zeroElement = null;
	
	// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
	// if the element lies within a nested document (<frame> or <iframe>-like).
	function getActualBoundingClientRect(node) {
	  var boundingRect = node.getBoundingClientRect();
	
	  // The original object returned by getBoundingClientRect is immutable, so we clone it
	  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
	  var rect = {};
	  for (var k in boundingRect) {
	    rect[k] = boundingRect[k];
	  }
	
	  if (node.ownerDocument !== document) {
	    var _frameElement = node.ownerDocument.defaultView.frameElement;
	    if (_frameElement) {
	      var frameRect = getActualBoundingClientRect(_frameElement);
	      rect.top += frameRect.top;
	      rect.bottom += frameRect.top;
	      rect.left += frameRect.left;
	      rect.right += frameRect.left;
	    }
	  }
	
	  return rect;
	}
	
	function getScrollParents(el) {
	  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = getComputedStyle(el) || {};
	  var position = computedStyle.position;
	  var parents = [];
	
	  if (position === 'fixed') {
	    return [el];
	  }
	
	  var parent = el;
	  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
	    var style = undefined;
	    try {
	      style = getComputedStyle(parent);
	    } catch (err) {}
	
	    if (typeof style === 'undefined' || style === null) {
	      parents.push(parent);
	      return parents;
	    }
	
	    var _style = style;
	    var overflow = _style.overflow;
	    var overflowX = _style.overflowX;
	    var overflowY = _style.overflowY;
	
	    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
	        parents.push(parent);
	      }
	    }
	  }
	
	  parents.push(el.ownerDocument.body);
	
	  // If the node is within a frame, account for the parent window scroll
	  if (el.ownerDocument !== document) {
	    parents.push(el.ownerDocument.defaultView);
	  }
	
	  return parents;
	}
	
	var uniqueId = (function () {
	  var id = 0;
	  return function () {
	    return ++id;
	  };
	})();
	
	var zeroPosCache = {};
	var getOrigin = function getOrigin() {
	  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
	  // jitter as the user scrolls that messes with our ability to detect if two positions
	  // are equivilant or not.  We place an element at the top left of the page that will
	  // get the same jitter, so we can cancel the two out.
	  var node = zeroElement;
	  if (!node || !document.body.contains(node)) {
	    node = document.createElement('div');
	    node.setAttribute('data-tether-id', uniqueId());
	    extend(node.style, {
	      top: 0,
	      left: 0,
	      position: 'absolute'
	    });
	
	    document.body.appendChild(node);
	
	    zeroElement = node;
	  }
	
	  var id = node.getAttribute('data-tether-id');
	  if (typeof zeroPosCache[id] === 'undefined') {
	    zeroPosCache[id] = getActualBoundingClientRect(node);
	
	    // Clear the cache when this position call is done
	    defer(function () {
	      delete zeroPosCache[id];
	    });
	  }
	
	  return zeroPosCache[id];
	};
	
	function removeUtilElements() {
	  if (zeroElement) {
	    document.body.removeChild(zeroElement);
	  }
	  zeroElement = null;
	};
	
	function getBounds(el) {
	  var doc = undefined;
	  if (el === document) {
	    doc = document;
	    el = document.documentElement;
	  } else {
	    doc = el.ownerDocument;
	  }
	
	  var docEl = doc.documentElement;
	
	  var box = getActualBoundingClientRect(el);
	
	  var origin = getOrigin();
	
	  box.top -= origin.top;
	  box.left -= origin.left;
	
	  if (typeof box.width === 'undefined') {
	    box.width = document.body.scrollWidth - box.left - box.right;
	  }
	  if (typeof box.height === 'undefined') {
	    box.height = document.body.scrollHeight - box.top - box.bottom;
	  }
	
	  box.top = box.top - docEl.clientTop;
	  box.left = box.left - docEl.clientLeft;
	  box.right = doc.body.clientWidth - box.width - box.left;
	  box.bottom = doc.body.clientHeight - box.height - box.top;
	
	  return box;
	}
	
	function getOffsetParent(el) {
	  return el.offsetParent || document.documentElement;
	}
	
	var _scrollBarSize = null;
	function getScrollBarSize() {
	  if (_scrollBarSize) {
	    return _scrollBarSize;
	  }
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  extend(outer.style, {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    pointerEvents: 'none',
	    visibility: 'hidden',
	    width: '200px',
	    height: '150px',
	    overflow: 'hidden'
	  });
	
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	
	  var widthContained = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var widthScroll = inner.offsetWidth;
	
	  if (widthContained === widthScroll) {
	    widthScroll = outer.clientWidth;
	  }
	
	  document.body.removeChild(outer);
	
	  var width = widthContained - widthScroll;
	
	  _scrollBarSize = { width: width, height: width };
	  return _scrollBarSize;
	}
	
	function extend() {
	  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var args = [];
	
	  Array.prototype.push.apply(args, arguments);
	
	  args.slice(1).forEach(function (obj) {
	    if (obj) {
	      for (var key in obj) {
	        if (({}).hasOwnProperty.call(obj, key)) {
	          out[key] = obj[key];
	        }
	      }
	    }
	  });
	
	  return out;
	}
	
	function removeClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.remove(cls);
	      }
	    });
	  } else {
	    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
	    var className = getClassName(el).replace(regex, ' ');
	    setClassName(el, className);
	  }
	}
	
	function addClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.add(cls);
	      }
	    });
	  } else {
	    removeClass(el, name);
	    var cls = getClassName(el) + (' ' + name);
	    setClassName(el, cls);
	  }
	}
	
	function hasClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    return el.classList.contains(name);
	  }
	  var className = getClassName(el);
	  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
	}
	
	function getClassName(el) {
	  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
	  // completely separately SVGAnimatedString base classes
	  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
	    return el.className.baseVal;
	  }
	  return el.className;
	}
	
	function setClassName(el, className) {
	  el.setAttribute('class', className);
	}
	
	function updateClasses(el, add, all) {
	  // Of the set of 'all' classes, we need the 'add' classes, and only the
	  // 'add' classes to be set.
	  all.forEach(function (cls) {
	    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
	      removeClass(el, cls);
	    }
	  });
	
	  add.forEach(function (cls) {
	    if (!hasClass(el, cls)) {
	      addClass(el, cls);
	    }
	  });
	}
	
	var deferred = [];
	
	var defer = function defer(fn) {
	  deferred.push(fn);
	};
	
	var flush = function flush() {
	  var fn = undefined;
	  while (fn = deferred.pop()) {
	    fn();
	  }
	};
	
	var Evented = (function () {
	  function Evented() {
	    _classCallCheck(this, Evented);
	  }
	
	  _createClass(Evented, [{
	    key: 'on',
	    value: function on(event, handler, ctx) {
	      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	      if (typeof this.bindings === 'undefined') {
	        this.bindings = {};
	      }
	      if (typeof this.bindings[event] === 'undefined') {
	        this.bindings[event] = [];
	      }
	      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
	    }
	  }, {
	    key: 'once',
	    value: function once(event, handler, ctx) {
	      this.on(event, handler, ctx, true);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, handler) {
	      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
	        return;
	      }
	
	      if (typeof handler === 'undefined') {
	        delete this.bindings[event];
	      } else {
	        var i = 0;
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
	        var i = 0;
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        while (i < this.bindings[event].length) {
	          var _bindings$event$i = this.bindings[event][i];
	          var handler = _bindings$event$i.handler;
	          var ctx = _bindings$event$i.ctx;
	          var once = _bindings$event$i.once;
	
	          var context = ctx;
	          if (typeof context === 'undefined') {
	            context = this;
	          }
	
	          handler.apply(context, args);
	
	          if (once) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }]);
	
	  return Evented;
	})();
	
	TetherBase.Utils = {
	  getActualBoundingClientRect: getActualBoundingClientRect,
	  getScrollParents: getScrollParents,
	  getBounds: getBounds,
	  getOffsetParent: getOffsetParent,
	  extend: extend,
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  updateClasses: updateClasses,
	  defer: defer,
	  flush: flush,
	  uniqueId: uniqueId,
	  Evented: Evented,
	  getScrollBarSize: getScrollBarSize,
	  removeUtilElements: removeUtilElements
	};
	/* globals TetherBase, performance */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof TetherBase === 'undefined') {
	  throw new Error('You must include the utils.js file before tether.js');
	}
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getScrollParents = _TetherBase$Utils.getScrollParents;
	var getBounds = _TetherBase$Utils.getBounds;
	var getOffsetParent = _TetherBase$Utils.getOffsetParent;
	var extend = _TetherBase$Utils.extend;
	var addClass = _TetherBase$Utils.addClass;
	var removeClass = _TetherBase$Utils.removeClass;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	var flush = _TetherBase$Utils.flush;
	var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
	var removeUtilElements = _TetherBase$Utils.removeUtilElements;
	
	function within(a, b) {
	  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	  return a + diff >= b && b >= a - diff;
	}
	
	var transformKey = (function () {
	  if (typeof document === 'undefined') {
	    return '';
	  }
	  var el = document.createElement('div');
	
	  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
	  for (var i = 0; i < transforms.length; ++i) {
	    var key = transforms[i];
	    if (el.style[key] !== undefined) {
	      return key;
	    }
	  }
	})();
	
	var tethers = [];
	
	var position = function position() {
	  tethers.forEach(function (tether) {
	    tether.position(false);
	  });
	  flush();
	};
	
	function now() {
	  if (typeof performance === 'object' && typeof performance.now === 'function') {
	    return performance.now();
	  }
	  return +new Date();
	}
	
	(function () {
	  var lastCall = null;
	  var lastDuration = null;
	  var pendingTimeout = null;
	
	  var tick = function tick() {
	    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
	      // We voluntarily throttle ourselves if we can't manage 60fps
	      lastDuration = Math.min(lastDuration - 16, 250);
	
	      // Just in case this is the last event, remember to position just once more
	      pendingTimeout = setTimeout(tick, 250);
	      return;
	    }
	
	    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
	      // Some browsers call events a little too frequently, refuse to run more than is reasonable
	      return;
	    }
	
	    if (pendingTimeout != null) {
	      clearTimeout(pendingTimeout);
	      pendingTimeout = null;
	    }
	
	    lastCall = now();
	    position();
	    lastDuration = now() - lastCall;
	  };
	
	  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
	    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
	      window.addEventListener(event, tick);
	    });
	  }
	})();
	
	var MIRROR_LR = {
	  center: 'center',
	  left: 'right',
	  right: 'left'
	};
	
	var MIRROR_TB = {
	  middle: 'middle',
	  top: 'bottom',
	  bottom: 'top'
	};
	
	var OFFSET_MAP = {
	  top: 0,
	  left: 0,
	  middle: '50%',
	  center: '50%',
	  bottom: '100%',
	  right: '100%'
	};
	
	var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (left === 'auto') {
	    left = MIRROR_LR[relativeToAttachment.left];
	  }
	
	  if (top === 'auto') {
	    top = MIRROR_TB[relativeToAttachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	var attachmentToOffset = function attachmentToOffset(attachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
	    left = OFFSET_MAP[attachment.left];
	  }
	
	  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
	    top = OFFSET_MAP[attachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	function addOffset() {
	  var out = { top: 0, left: 0 };
	
	  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
	    offsets[_key] = arguments[_key];
	  }
	
	  offsets.forEach(function (_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (typeof top === 'string') {
	      top = parseFloat(top, 10);
	    }
	    if (typeof left === 'string') {
	      left = parseFloat(left, 10);
	    }
	
	    out.top += top;
	    out.left += left;
	  });
	
	  return out;
	}
	
	function offsetToPx(offset, size) {
	  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
	    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
	  }
	  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
	    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
	  }
	
	  return offset;
	}
	
	var parseOffset = function parseOffset(value) {
	  var _value$split = value.split(' ');
	
	  var _value$split2 = _slicedToArray(_value$split, 2);
	
	  var top = _value$split2[0];
	  var left = _value$split2[1];
	
	  return { top: top, left: left };
	};
	var parseAttachment = parseOffset;
	
	var TetherClass = (function (_Evented) {
	  _inherits(TetherClass, _Evented);
	
	  function TetherClass(options) {
	    var _this = this;
	
	    _classCallCheck(this, TetherClass);
	
	    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
	    this.position = this.position.bind(this);
	
	    tethers.push(this);
	
	    this.history = [];
	
	    this.setOptions(options, false);
	
	    TetherBase.modules.forEach(function (module) {
	      if (typeof module.initialize !== 'undefined') {
	        module.initialize.call(_this);
	      }
	    });
	
	    this.position();
	  }
	
	  _createClass(TetherClass, [{
	    key: 'getClass',
	    value: function getClass() {
	      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	      var classes = this.options.classes;
	
	      if (typeof classes !== 'undefined' && classes[key]) {
	        return this.options.classes[key];
	      } else if (this.options.classPrefix) {
	        return this.options.classPrefix + '-' + key;
	      } else {
	        return key;
	      }
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _this2 = this;
	
	      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var defaults = {
	        offset: '0 0',
	        targetOffset: '0 0',
	        targetAttachment: 'auto auto',
	        classPrefix: 'tether'
	      };
	
	      this.options = extend(defaults, options);
	
	      var _options = this.options;
	      var element = _options.element;
	      var target = _options.target;
	      var targetModifier = _options.targetModifier;
	
	      this.element = element;
	      this.target = target;
	      this.targetModifier = targetModifier;
	
	      if (this.target === 'viewport') {
	        this.target = document.body;
	        this.targetModifier = 'visible';
	      } else if (this.target === 'scroll-handle') {
	        this.target = document.body;
	        this.targetModifier = 'scroll-handle';
	      }
	
	      ['element', 'target'].forEach(function (key) {
	        if (typeof _this2[key] === 'undefined') {
	          throw new Error('Tether Error: Both element and target must be defined');
	        }
	
	        if (typeof _this2[key].jquery !== 'undefined') {
	          _this2[key] = _this2[key][0];
	        } else if (typeof _this2[key] === 'string') {
	          _this2[key] = document.querySelector(_this2[key]);
	        }
	      });
	
	      addClass(this.element, this.getClass('element'));
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('target'));
	      }
	
	      if (!this.options.attachment) {
	        throw new Error('Tether Error: You must provide an attachment');
	      }
	
	      this.targetAttachment = parseAttachment(this.options.targetAttachment);
	      this.attachment = parseAttachment(this.options.attachment);
	      this.offset = parseOffset(this.options.offset);
	      this.targetOffset = parseOffset(this.options.targetOffset);
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.disable();
	      }
	
	      if (this.targetModifier === 'scroll-handle') {
	        this.scrollParents = [this.target];
	      } else {
	        this.scrollParents = getScrollParents(this.target);
	      }
	
	      if (!(this.options.enabled === false)) {
	        this.enable(pos);
	      }
	    }
	  }, {
	    key: 'getTargetBounds',
	    value: function getTargetBounds() {
	      if (typeof this.targetModifier !== 'undefined') {
	        if (this.targetModifier === 'visible') {
	          if (this.target === document.body) {
	            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
	          } else {
	            var bounds = getBounds(this.target);
	
	            var out = {
	              height: bounds.height,
	              width: bounds.width,
	              top: bounds.top,
	              left: bounds.left
	            };
	
	            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
	            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
	            out.height = Math.min(innerHeight, out.height);
	            out.height -= 2;
	
	            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
	            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
	            out.width = Math.min(innerWidth, out.width);
	            out.width -= 2;
	
	            if (out.top < pageYOffset) {
	              out.top = pageYOffset;
	            }
	            if (out.left < pageXOffset) {
	              out.left = pageXOffset;
	            }
	
	            return out;
	          }
	        } else if (this.targetModifier === 'scroll-handle') {
	          var bounds = undefined;
	          var target = this.target;
	          if (target === document.body) {
	            target = document.documentElement;
	
	            bounds = {
	              left: pageXOffset,
	              top: pageYOffset,
	              height: innerHeight,
	              width: innerWidth
	            };
	          } else {
	            bounds = getBounds(target);
	          }
	
	          var style = getComputedStyle(target);
	
	          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;
	
	          var scrollBottom = 0;
	          if (hasBottomScroll) {
	            scrollBottom = 15;
	          }
	
	          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
	
	          var out = {
	            width: 15,
	            height: height * 0.975 * (height / target.scrollHeight),
	            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
	          };
	
	          var fitAdj = 0;
	          if (height < 408 && this.target === document.body) {
	            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
	          }
	
	          if (this.target !== document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
	          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
	
	          if (this.target === document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          return out;
	        }
	      } else {
	        return getBounds(this.target);
	      }
	    }
	  }, {
	    key: 'clearCache',
	    value: function clearCache() {
	      this._cache = {};
	    }
	  }, {
	    key: 'cache',
	    value: function cache(k, getter) {
	      // More than one module will often need the same DOM info, so
	      // we keep a cache which is cleared on each position call
	      if (typeof this._cache === 'undefined') {
	        this._cache = {};
	      }
	
	      if (typeof this._cache[k] === 'undefined') {
	        this._cache[k] = getter.call(this);
	      }
	
	      return this._cache[k];
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var _this3 = this;
	
	      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('enabled'));
	      }
	      addClass(this.element, this.getClass('enabled'));
	      this.enabled = true;
	
	      this.scrollParents.forEach(function (parent) {
	        if (parent !== _this3.target.ownerDocument) {
	          parent.addEventListener('scroll', _this3.position);
	        }
	      });
	
	      if (pos) {
	        this.position();
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _this4 = this;
	
	      removeClass(this.target, this.getClass('enabled'));
	      removeClass(this.element, this.getClass('enabled'));
	      this.enabled = false;
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.scrollParents.forEach(function (parent) {
	          parent.removeEventListener('scroll', _this4.position);
	        });
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this5 = this;
	
	      this.disable();
	
	      tethers.forEach(function (tether, i) {
	        if (tether === _this5) {
	          tethers.splice(i, 1);
	        }
	      });
	
	      // Remove any elements we were using for convenience from the DOM
	      if (tethers.length === 0) {
	        removeUtilElements();
	      }
	    }
	  }, {
	    key: 'updateAttachClasses',
	    value: function updateAttachClasses(elementAttach, targetAttach) {
	      var _this6 = this;
	
	      elementAttach = elementAttach || this.attachment;
	      targetAttach = targetAttach || this.targetAttachment;
	      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	
	      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
	        // updateAttachClasses can be called more than once in a position call, so
	        // we need to clean up after ourselves such that when the last defer gets
	        // ran it doesn't add any extra classes from previous calls.
	        this._addAttachClasses.splice(0, this._addAttachClasses.length);
	      }
	
	      if (typeof this._addAttachClasses === 'undefined') {
	        this._addAttachClasses = [];
	      }
	      var add = this._addAttachClasses;
	
	      if (elementAttach.top) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
	      }
	      if (elementAttach.left) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
	      }
	      if (targetAttach.top) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
	      }
	      if (targetAttach.left) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
	      }
	
	      var all = [];
	      sides.forEach(function (side) {
	        all.push(_this6.getClass('element-attached') + '-' + side);
	        all.push(_this6.getClass('target-attached') + '-' + side);
	      });
	
	      defer(function () {
	        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
	          return;
	        }
	
	        updateClasses(_this6.element, _this6._addAttachClasses, all);
	        if (!(_this6.options.addTargetClasses === false)) {
	          updateClasses(_this6.target, _this6._addAttachClasses, all);
	        }
	
	        delete _this6._addAttachClasses;
	      });
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      var _this7 = this;
	
	      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
	      // tethers (in which case call Tether.Utils.flush yourself when you're done)
	
	      if (!this.enabled) {
	        return;
	      }
	
	      this.clearCache();
	
	      // Turn 'auto' attachments into the appropriate corner or edge
	      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
	
	      this.updateAttachClasses(this.attachment, targetAttachment);
	
	      var elementPos = this.cache('element-bounds', function () {
	        return getBounds(_this7.element);
	      });
	
	      var width = elementPos.width;
	      var height = elementPos.height;
	
	      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	        var _lastSize = this.lastSize;
	
	        // We cache the height and width to make it possible to position elements that are
	        // getting hidden.
	        width = _lastSize.width;
	        height = _lastSize.height;
	      } else {
	        this.lastSize = { width: width, height: height };
	      }
	
	      var targetPos = this.cache('target-bounds', function () {
	        return _this7.getTargetBounds();
	      });
	      var targetSize = targetPos;
	
	      // Get an actual px offset from the attachment
	      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
	      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
	
	      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
	      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
	
	      // Add the manually provided offset
	      offset = addOffset(offset, manualOffset);
	      targetOffset = addOffset(targetOffset, manualTargetOffset);
	
	      // It's now our goal to make (element position + offset) == (target position + target offset)
	      var left = targetPos.left + targetOffset.left - offset.left;
	      var top = targetPos.top + targetOffset.top - offset.top;
	
	      for (var i = 0; i < TetherBase.modules.length; ++i) {
	        var _module2 = TetherBase.modules[i];
	        var ret = _module2.position.call(this, {
	          left: left,
	          top: top,
	          targetAttachment: targetAttachment,
	          targetPos: targetPos,
	          elementPos: elementPos,
	          offset: offset,
	          targetOffset: targetOffset,
	          manualOffset: manualOffset,
	          manualTargetOffset: manualTargetOffset,
	          scrollbarSize: scrollbarSize,
	          attachment: this.attachment
	        });
	
	        if (ret === false) {
	          return false;
	        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
	          continue;
	        } else {
	          top = ret.top;
	          left = ret.left;
	        }
	      }
	
	      // We describe the position three different ways to give the optimizer
	      // a chance to decide the best possible way to position the element
	      // with the fewest repaints.
	      var next = {
	        // It's position relative to the page (absolute positioning when
	        // the element is a child of the body)
	        page: {
	          top: top,
	          left: left
	        },
	
	        // It's position relative to the viewport (fixed positioning)
	        viewport: {
	          top: top - pageYOffset,
	          bottom: pageYOffset - top - height + innerHeight,
	          left: left - pageXOffset,
	          right: pageXOffset - left - width + innerWidth
	        }
	      };
	
	      var doc = this.target.ownerDocument;
	      var win = doc.defaultView;
	
	      var scrollbarSize = undefined;
	      if (win.innerHeight > doc.documentElement.clientHeight) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.bottom -= scrollbarSize.height;
	      }
	
	      if (win.innerWidth > doc.documentElement.clientWidth) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.right -= scrollbarSize.width;
	      }
	
	      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
	        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
	        next.page.bottom = doc.body.scrollHeight - top - height;
	        next.page.right = doc.body.scrollWidth - left - width;
	      }
	
	      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
	        (function () {
	          var offsetParent = _this7.cache('target-offsetparent', function () {
	            return getOffsetParent(_this7.target);
	          });
	          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
	            return getBounds(offsetParent);
	          });
	          var offsetParentStyle = getComputedStyle(offsetParent);
	          var offsetParentSize = offsetPosition;
	
	          var offsetBorder = {};
	          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
	          });
	
	          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
	          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
	
	          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
	            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
	              // We're within the visible part of the target's scroll parent
	              var scrollTop = offsetParent.scrollTop;
	              var scrollLeft = offsetParent.scrollLeft;
	
	              // It's position relative to the target's offset parent (absolute positioning when
	              // the element is moved to be a child of the target's offset parent).
	              next.offset = {
	                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
	                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
	              };
	            }
	          }
	        })();
	      }
	
	      // We could also travel up the DOM and try each containing context, rather than only
	      // looking at the body, but we're gonna get diminishing returns.
	
	      this.move(next);
	
	      this.history.unshift(next);
	
	      if (this.history.length > 3) {
	        this.history.pop();
	      }
	
	      if (flushChanges) {
	        flush();
	      }
	
	      return true;
	    }
	
	    // THE ISSUE
	  }, {
	    key: 'move',
	    value: function move(pos) {
	      var _this8 = this;
	
	      if (!(typeof this.element.parentNode !== 'undefined')) {
	        return;
	      }
	
	      var same = {};
	
	      for (var type in pos) {
	        same[type] = {};
	
	        for (var key in pos[type]) {
	          var found = false;
	
	          for (var i = 0; i < this.history.length; ++i) {
	            var point = this.history[i];
	            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
	              found = true;
	              break;
	            }
	          }
	
	          if (!found) {
	            same[type][key] = true;
	          }
	        }
	      }
	
	      var css = { top: '', left: '', right: '', bottom: '' };
	
	      var transcribe = function transcribe(_same, _pos) {
	        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
	        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
	        if (gpu !== false) {
	          var yPos = undefined,
	              xPos = undefined;
	          if (_same.top) {
	            css.top = 0;
	            yPos = _pos.top;
	          } else {
	            css.bottom = 0;
	            yPos = -_pos.bottom;
	          }
	
	          if (_same.left) {
	            css.left = 0;
	            xPos = _pos.left;
	          } else {
	            css.right = 0;
	            xPos = -_pos.right;
	          }
	
	          if (window.matchMedia) {
	            // HubSpot/tether#207
	            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
	            if (!retina) {
	              xPos = Math.round(xPos);
	              yPos = Math.round(yPos);
	            }
	          }
	
	          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';
	
	          if (transformKey !== 'msTransform') {
	            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
	            // but IE9 doesn't support 3d transforms and will choke.
	            css[transformKey] += " translateZ(0)";
	          }
	        } else {
	          if (_same.top) {
	            css.top = _pos.top + 'px';
	          } else {
	            css.bottom = _pos.bottom + 'px';
	          }
	
	          if (_same.left) {
	            css.left = _pos.left + 'px';
	          } else {
	            css.right = _pos.right + 'px';
	          }
	        }
	      };
	
	      var moved = false;
	      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
	        css.position = 'absolute';
	        transcribe(same.page, pos.page);
	      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
	        css.position = 'fixed';
	        transcribe(same.viewport, pos.viewport);
	      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
	        (function () {
	          css.position = 'absolute';
	          var offsetParent = _this8.cache('target-offsetparent', function () {
	            return getOffsetParent(_this8.target);
	          });
	
	          if (getOffsetParent(_this8.element) !== offsetParent) {
	            defer(function () {
	              _this8.element.parentNode.removeChild(_this8.element);
	              offsetParent.appendChild(_this8.element);
	            });
	          }
	
	          transcribe(same.offset, pos.offset);
	          moved = true;
	        })();
	      } else {
	        css.position = 'absolute';
	        transcribe({ top: true, left: true }, pos.page);
	      }
	
	      if (!moved) {
	        if (this.options.bodyElement) {
	          if (this.element.parentNode !== this.options.bodyElement) {
	            this.options.bodyElement.appendChild(this.element);
	          }
	        } else {
	          var isFullscreenElement = function isFullscreenElement(e) {
	            var d = e.ownerDocument;
	            var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
	            return fe === e;
	          };
	
	          var offsetParentIsBody = true;
	
	          var currentNode = this.element.parentNode;
	          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY' && !isFullscreenElement(currentNode)) {
	            if (getComputedStyle(currentNode).position !== 'static') {
	              offsetParentIsBody = false;
	              break;
	            }
	
	            currentNode = currentNode.parentNode;
	          }
	
	          if (!offsetParentIsBody) {
	            this.element.parentNode.removeChild(this.element);
	            this.element.ownerDocument.body.appendChild(this.element);
	          }
	        }
	      }
	
	      // Any css change will trigger a repaint, so let's avoid one if nothing changed
	      var writeCSS = {};
	      var write = false;
	      for (var key in css) {
	        var val = css[key];
	        var elVal = this.element.style[key];
	
	        if (elVal !== val) {
	          write = true;
	          writeCSS[key] = val;
	        }
	      }
	
	      if (write) {
	        defer(function () {
	          extend(_this8.element.style, writeCSS);
	          _this8.trigger('repositioned');
	        });
	      }
	    }
	  }]);
	
	  return TetherClass;
	})(Evented);
	
	TetherClass.modules = [];
	
	TetherBase.position = position;
	
	var Tether = extend(TetherClass, TetherBase);
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var extend = _TetherBase$Utils.extend;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
	
	function getBoundingRect(tether, to) {
	  if (to === 'scrollParent') {
	    to = tether.scrollParents[0];
	  } else if (to === 'window') {
	    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
	  }
	
	  if (to === document) {
	    to = to.documentElement;
	  }
	
	  if (typeof to.nodeType !== 'undefined') {
	    (function () {
	      var node = to;
	      var size = getBounds(to);
	      var pos = size;
	      var style = getComputedStyle(to);
	
	      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];
	
	      // Account any parent Frames scroll offset
	      if (node.ownerDocument !== document) {
	        var win = node.ownerDocument.defaultView;
	        to[0] += win.pageXOffset;
	        to[1] += win.pageYOffset;
	        to[2] += win.pageXOffset;
	        to[3] += win.pageYOffset;
	      }
	
	      BOUNDS_FORMAT.forEach(function (side, i) {
	        side = side[0].toUpperCase() + side.substr(1);
	        if (side === 'Top' || side === 'Left') {
	          to[i] += parseFloat(style['border' + side + 'Width']);
	        } else {
	          to[i] -= parseFloat(style['border' + side + 'Width']);
	        }
	      });
	    })();
	  }
	
	  return to;
	}
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	    var targetAttachment = _ref.targetAttachment;
	
	    if (!this.options.constraints) {
	      return true;
	    }
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	      var _lastSize = this.lastSize;
	
	      // Handle the item getting hidden as a result of our positioning without glitching
	      // the classes in and out
	      width = _lastSize.width;
	      height = _lastSize.height;
	    }
	
	    var targetSize = this.cache('target-bounds', function () {
	      return _this.getTargetBounds();
	    });
	
	    var targetHeight = targetSize.height;
	    var targetWidth = targetSize.width;
	
	    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];
	
	    this.options.constraints.forEach(function (constraint) {
	      var outOfBoundsClass = constraint.outOfBoundsClass;
	      var pinnedClass = constraint.pinnedClass;
	
	      if (outOfBoundsClass) {
	        allClasses.push(outOfBoundsClass);
	      }
	      if (pinnedClass) {
	        allClasses.push(pinnedClass);
	      }
	    });
	
	    allClasses.forEach(function (cls) {
	      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
	        allClasses.push(cls + '-' + side);
	      });
	    });
	
	    var addClasses = [];
	
	    var tAttachment = extend({}, targetAttachment);
	    var eAttachment = extend({}, this.attachment);
	
	    this.options.constraints.forEach(function (constraint) {
	      var to = constraint.to;
	      var attachment = constraint.attachment;
	      var pin = constraint.pin;
	
	      if (typeof attachment === 'undefined') {
	        attachment = '';
	      }
	
	      var changeAttachX = undefined,
	          changeAttachY = undefined;
	      if (attachment.indexOf(' ') >= 0) {
	        var _attachment$split = attachment.split(' ');
	
	        var _attachment$split2 = _slicedToArray(_attachment$split, 2);
	
	        changeAttachY = _attachment$split2[0];
	        changeAttachX = _attachment$split2[1];
	      } else {
	        changeAttachX = changeAttachY = attachment;
	      }
	
	      var bounds = getBoundingRect(_this, to);
	
	      if (changeAttachY === 'target' || changeAttachY === 'both') {
	        if (top < bounds[1] && tAttachment.top === 'top') {
	          top += targetHeight;
	          tAttachment.top = 'bottom';
	        }
	
	        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	          top -= targetHeight;
	          tAttachment.top = 'top';
	        }
	      }
	
	      if (changeAttachY === 'together') {
	        if (tAttachment.top === 'top') {
	          if (eAttachment.top === 'bottom' && top < bounds[1]) {
	            top += targetHeight;
	            tAttachment.top = 'bottom';
	
	            top += height;
	            eAttachment.top = 'top';
	          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
	            top -= height - targetHeight;
	            tAttachment.top = 'bottom';
	
	            eAttachment.top = 'bottom';
	          }
	        }
	
	        if (tAttachment.top === 'bottom') {
	          if (eAttachment.top === 'top' && top + height > bounds[3]) {
	            top -= targetHeight;
	            tAttachment.top = 'top';
	
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
	            top += height - targetHeight;
	            tAttachment.top = 'top';
	
	            eAttachment.top = 'top';
	          }
	        }
	
	        if (tAttachment.top === 'middle') {
	          if (top + height > bounds[3] && eAttachment.top === 'top') {
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
	            top += height;
	            eAttachment.top = 'top';
	          }
	        }
	      }
	
	      if (changeAttachX === 'target' || changeAttachX === 'both') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          left += targetWidth;
	          tAttachment.left = 'right';
	        }
	
	        if (left + width > bounds[2] && tAttachment.left === 'right') {
	          left -= targetWidth;
	          tAttachment.left = 'left';
	        }
	      }
	
	      if (changeAttachX === 'together') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          if (eAttachment.left === 'right') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'left') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left -= width;
	            eAttachment.left = 'right';
	          }
	        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
	          if (eAttachment.left === 'left') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'right') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left += width;
	            eAttachment.left = 'left';
	          }
	        } else if (tAttachment.left === 'center') {
	          if (left + width > bounds[2] && eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (left < bounds[0] && eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          }
	        }
	      }
	
	      if (changeAttachY === 'element' || changeAttachY === 'both') {
	        if (top < bounds[1] && eAttachment.top === 'bottom') {
	          top += height;
	          eAttachment.top = 'top';
	        }
	
	        if (top + height > bounds[3] && eAttachment.top === 'top') {
	          top -= height;
	          eAttachment.top = 'bottom';
	        }
	      }
	
	      if (changeAttachX === 'element' || changeAttachX === 'both') {
	        if (left < bounds[0]) {
	          if (eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'center') {
	            left += width / 2;
	            eAttachment.left = 'left';
	          }
	        }
	
	        if (left + width > bounds[2]) {
	          if (eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'center') {
	            left -= width / 2;
	            eAttachment.left = 'right';
	          }
	        }
	      }
	
	      if (typeof pin === 'string') {
	        pin = pin.split(',').map(function (p) {
	          return p.trim();
	        });
	      } else if (pin === true) {
	        pin = ['top', 'left', 'right', 'bottom'];
	      }
	
	      pin = pin || [];
	
	      var pinned = [];
	      var oob = [];
	
	      if (top < bounds[1]) {
	        if (pin.indexOf('top') >= 0) {
	          top = bounds[1];
	          pinned.push('top');
	        } else {
	          oob.push('top');
	        }
	      }
	
	      if (top + height > bounds[3]) {
	        if (pin.indexOf('bottom') >= 0) {
	          top = bounds[3] - height;
	          pinned.push('bottom');
	        } else {
	          oob.push('bottom');
	        }
	      }
	
	      if (left < bounds[0]) {
	        if (pin.indexOf('left') >= 0) {
	          left = bounds[0];
	          pinned.push('left');
	        } else {
	          oob.push('left');
	        }
	      }
	
	      if (left + width > bounds[2]) {
	        if (pin.indexOf('right') >= 0) {
	          left = bounds[2] - width;
	          pinned.push('right');
	        } else {
	          oob.push('right');
	        }
	      }
	
	      if (pinned.length) {
	        (function () {
	          var pinnedClass = undefined;
	          if (typeof _this.options.pinnedClass !== 'undefined') {
	            pinnedClass = _this.options.pinnedClass;
	          } else {
	            pinnedClass = _this.getClass('pinned');
	          }
	
	          addClasses.push(pinnedClass);
	          pinned.forEach(function (side) {
	            addClasses.push(pinnedClass + '-' + side);
	          });
	        })();
	      }
	
	      if (oob.length) {
	        (function () {
	          var oobClass = undefined;
	          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
	            oobClass = _this.options.outOfBoundsClass;
	          } else {
	            oobClass = _this.getClass('out-of-bounds');
	          }
	
	          addClasses.push(oobClass);
	          oob.forEach(function (side) {
	            addClasses.push(oobClass + '-' + side);
	          });
	        })();
	      }
	
	      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
	        eAttachment.left = tAttachment.left = false;
	      }
	      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
	        eAttachment.top = tAttachment.top = false;
	      }
	
	      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
	        _this.updateAttachClasses(eAttachment, tAttachment);
	        _this.trigger('update', {
	          attachment: eAttachment,
	          targetAttachment: tAttachment
	        });
	      }
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return { top: top, left: left };
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    var targetPos = this.getTargetBounds();
	
	    var bottom = top + height;
	    var right = left + width;
	
	    var abutted = [];
	    if (top <= targetPos.bottom && bottom >= targetPos.top) {
	      ['left', 'right'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === left || targetPosSide === right) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    if (left <= targetPos.right && right >= targetPos.left) {
	      ['top', 'bottom'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === top || targetPosSide === bottom) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    var allClasses = [];
	    var addClasses = [];
	
	    var sides = ['left', 'top', 'right', 'bottom'];
	    allClasses.push(this.getClass('abutted'));
	    sides.forEach(function (side) {
	      allClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    if (abutted.length) {
	      addClasses.push(this.getClass('abutted'));
	    }
	
	    abutted.forEach(function (side) {
	      addClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return true;
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (!this.options.shift) {
	      return;
	    }
	
	    var shift = this.options.shift;
	    if (typeof this.options.shift === 'function') {
	      shift = this.options.shift.call(this, { top: top, left: left });
	    }
	
	    var shiftTop = undefined,
	        shiftLeft = undefined;
	    if (typeof shift === 'string') {
	      shift = shift.split(' ');
	      shift[1] = shift[1] || shift[0];
	
	      var _shift = shift;
	
	      var _shift2 = _slicedToArray(_shift, 2);
	
	      shiftTop = _shift2[0];
	      shiftLeft = _shift2[1];
	
	      shiftTop = parseFloat(shiftTop, 10);
	      shiftLeft = parseFloat(shiftLeft, 10);
	    } else {
	      shiftTop = shift.top;
	      shiftLeft = shift.left;
	    }
	
	    top += shiftTop;
	    left += shiftLeft;
	
	    return { top: top, left: left };
	  }
	});
	return Tether;
	
	}));


/***/ },
/* 1779 */
73,
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1781);

/***/ },
/* 1781 */
/***/ function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	module.exports = function flattenTree(root, key) {
	  var flatten = [_extends({}, root)];
	  delete flatten[0][key];
	
	  if (root[key] && root[key].length > 0) {
	    return flatten.concat(root[key].map(function (child) {
	      return flattenTree(child, key);
	    }).reduce(function (a, b) {
	      return a.concat(b);
	    }, []));
	  }
	
	  return flatten;
	};

/***/ },
/* 1782 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
	  function getOwnPropertyDescriptors(obj) {
	    var keys = Object.keys(obj);
	    var descriptors = {};
	    for (var i = 0; i < keys.length; i++) {
	      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	    }
	    return descriptors;
	  };
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  if (typeof process !== 'undefined' && process.noDeprecation === true) {
	    return fn;
	  }
	
	  // Allow for deprecating things in the process of starting up.
	  if (typeof process === 'undefined') {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1782);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(137);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
	
	exports.promisify = function promisify(original) {
	  if (typeof original !== 'function')
	    throw new TypeError('The "original" argument must be of type Function');
	
	  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	    var fn = original[kCustomPromisifiedSymbol];
	    if (typeof fn !== 'function') {
	      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	    }
	    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	      value: fn, enumerable: false, writable: false, configurable: true
	    });
	    return fn;
	  }
	
	  function fn() {
	    var promiseResolve, promiseReject;
	    var promise = new Promise(function (resolve, reject) {
	      promiseResolve = resolve;
	      promiseReject = reject;
	    });
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	    args.push(function (err, value) {
	      if (err) {
	        promiseReject(err);
	      } else {
	        promiseResolve(value);
	      }
	    });
	
	    try {
	      original.apply(this, args);
	    } catch (err) {
	      promiseReject(err);
	    }
	
	    return promise;
	  }
	
	  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	
	  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	    value: fn, enumerable: false, writable: false, configurable: true
	  });
	  return Object.defineProperties(
	    fn,
	    getOwnPropertyDescriptors(original)
	  );
	}
	
	exports.promisify.custom = kCustomPromisifiedSymbol
	
	function callbackifyOnRejected(reason, cb) {
	  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
	  // Because `null` is a special error value in callbacks which means "no error
	  // occurred", we error-wrap so the callback consumer can distinguish between
	  // "the promise rejected with null" or "the promise fulfilled with undefined".
	  if (!reason) {
	    var newReason = new Error('Promise was rejected with a falsy value');
	    newReason.reason = reason;
	    reason = newReason;
	  }
	  return cb(reason);
	}
	
	function callbackify(original) {
	  if (typeof original !== 'function') {
	    throw new TypeError('The "original" argument must be of type Function');
	  }
	
	  // We DO NOT return the promise as it gives the user a false sense that
	  // the promise is actually somehow related to the callback's execution
	  // and that the callback throwing will reject the promise.
	  function callbackified() {
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	
	    var maybeCb = args.pop();
	    if (typeof maybeCb !== 'function') {
	      throw new TypeError('The last argument must be of type Function');
	    }
	    var self = this;
	    var cb = function() {
	      return maybeCb.apply(self, arguments);
	    };
	    // In true node style we process the callback on `nextTick` with all the
	    // implications (stack, `uncaughtException`, `async_hooks`)
	    original.apply(this, args)
	      .then(function(ret) { process.nextTick(cb, null, ret) },
	            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
	  }
	
	  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	  Object.defineProperties(callbackified,
	                          getOwnPropertyDescriptors(original));
	  return callbackified;
	}
	exports.callbackify = callbackify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 1784 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return _rnds;
	  };
	}
	
	module.exports = rng;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1785 */
85,
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1787 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyObject = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseForOwn = __webpack_require__(__webpack_module_template_argument_0__),
	    createBaseEach = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseFor = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Uint8Array = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var cloneArrayBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.f780a2777100e12af6e2.js
 **/